webpackJsonp([0],{

/***/ "../node_modules/core-js/fn/array/find.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.array.find.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.find;

/***/ }),

/***/ "../node_modules/core-js/fn/array/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.array.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Array.includes;

/***/ }),

/***/ "../node_modules/core-js/fn/object/assign.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.object.assign.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.assign;

/***/ }),

/***/ "../node_modules/core-js/fn/object/entries.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.entries.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.entries;

/***/ }),

/***/ "../node_modules/core-js/fn/object/values.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es7.object.values.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").Object.values;

/***/ }),

/***/ "../node_modules/core-js/fn/string/includes.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/core-js/modules/es6.string.includes.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_core.js").String.includes;

/***/ }),

/***/ "../node_modules/core-js/modules/_a-function.js":
/***/ (function(module, exports) {



module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_add-to-unscopables.js":
/***/ (function(module, exports, __webpack_require__) {



// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("../node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_an-object.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-includes.js":
/***/ (function(module, exports, __webpack_require__) {



// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var toAbsoluteIndex = __webpack_require__("../node_modules/core-js/modules/_to-absolute-index.js");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    }
    return !IS_INCLUDES && -1;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-methods.js":
/***/ (function(module, exports, __webpack_require__) {



// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var toLength = __webpack_require__("../node_modules/core-js/modules/_to-length.js");
var asc = __webpack_require__("../node_modules/core-js/modules/_array-species-create.js");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (; length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res; // map
        else if (res) switch (TYPE) {
          case 3:
            return true;
          // some
          case 5:
            return val;
          // find
          case 6:
            return index;
          // findIndex
          case 2:
            result.push(val);
          // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-constructor.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var isArray = __webpack_require__("../node_modules/core-js/modules/_is-array.js");
var SPECIES = __webpack_require__("../node_modules/core-js/modules/_wks.js")('species');
module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  }
  return C === undefined ? Array : C;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_array-species-create.js":
/***/ (function(module, exports, __webpack_require__) {



// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("../node_modules/core-js/modules/_array-species-constructor.js");
module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_cof.js":
/***/ (function(module, exports) {



var toString = {}.toString;
module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_core.js":
/***/ (function(module, exports) {



var core = module.exports = {
  version: '2.6.12'
};
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_ctx.js":
/***/ (function(module, exports, __webpack_require__) {



// optional / simple context binding
var aFunction = __webpack_require__("../node_modules/core-js/modules/_a-function.js");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function /* ...args */
  () {
    return fn.apply(that, arguments);
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_defined.js":
/***/ (function(module, exports) {



// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_descriptors.js":
/***/ (function(module, exports, __webpack_require__) {



// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty({}, 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_dom-create.js":
/***/ (function(module, exports, __webpack_require__) {



var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var document = __webpack_require__("../node_modules/core-js/modules/_global.js").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),

/***/ "../node_modules/core-js/modules/_enum-bug-keys.js":
/***/ (function(module, exports) {



// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),

/***/ "../node_modules/core-js/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var redefine = __webpack_require__("../node_modules/core-js/modules/_redefine.js");
var ctx = __webpack_require__("../node_modules/core-js/modules/_ctx.js");
var PROTOTYPE = 'prototype';
var _$export = function $export(type, name, source) {
  var IS_FORCED = type & _$export.F;
  var IS_GLOBAL = type & _$export.G;
  var IS_STATIC = type & _$export.S;
  var IS_PROTO = type & _$export.P;
  var IS_BIND = type & _$export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & _$export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
_$export.F = 1; // forced
_$export.G = 2; // global
_$export.S = 4; // static
_$export.P = 8; // proto
_$export.B = 16; // bind
_$export.W = 32; // wrap
_$export.U = 64; // safe
_$export.R = 128; // real proto method for `library`
module.exports = _$export;

/***/ }),

/***/ "../node_modules/core-js/modules/_fails-is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) {/* empty */}
  }
  return true;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_fails.js":
/***/ (function(module, exports) {



module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),

/***/ "../node_modules/core-js/modules/_function-to-string.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__("../node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);

/***/ }),

/***/ "../node_modules/core-js/modules/_global.js":
/***/ (function(module, exports) {



// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),

/***/ "../node_modules/core-js/modules/_has.js":
/***/ (function(module, exports) {



var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_hide.js":
/***/ (function(module, exports, __webpack_require__) {



var dP = __webpack_require__("../node_modules/core-js/modules/_object-dp.js");
var createDesc = __webpack_require__("../node_modules/core-js/modules/_property-desc.js");
module.exports = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_ie8-dom-define.js":
/***/ (function(module, exports, __webpack_require__) {



module.exports = !__webpack_require__("../node_modules/core-js/modules/_descriptors.js") && !__webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  return Object.defineProperty(__webpack_require__("../node_modules/core-js/modules/_dom-create.js")('div'), 'a', {
    get: function get() {
      return 7;
    }
  }).a != 7;
});

/***/ }),

/***/ "../node_modules/core-js/modules/_iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-array.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.2 IsArray(argument)
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-object.js":
/***/ (function(module, exports) {



module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),

/***/ "../node_modules/core-js/modules/_is-regexp.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
var cof = __webpack_require__("../node_modules/core-js/modules/_cof.js");
var MATCH = __webpack_require__("../node_modules/core-js/modules/_wks.js")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

/***/ }),

/***/ "../node_modules/core-js/modules/_library.js":
/***/ (function(module, exports) {



module.exports = false;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-assign.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var gOPS = __webpack_require__("../node_modules/core-js/modules/_object-gops.js");
var pIE = __webpack_require__("../node_modules/core-js/modules/_object-pie.js");
var toObject = __webpack_require__("../node_modules/core-js/modules/_to-object.js");
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("../node_modules/core-js/modules/_fails.js")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  }
  return T;
} : $assign;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-dp.js":
/***/ (function(module, exports, __webpack_require__) {



var anObject = __webpack_require__("../node_modules/core-js/modules/_an-object.js");
var IE8_DOM_DEFINE = __webpack_require__("../node_modules/core-js/modules/_ie8-dom-define.js");
var toPrimitive = __webpack_require__("../node_modules/core-js/modules/_to-primitive.js");
var dP = Object.defineProperty;
exports.f = __webpack_require__("../node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-gops.js":
/***/ (function(module, exports) {



exports.f = Object.getOwnPropertySymbols;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys-internal.js":
/***/ (function(module, exports, __webpack_require__) {



var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var arrayIndexOf = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(false);
var IE_PROTO = __webpack_require__("../node_modules/core-js/modules/_shared-key.js")('IE_PROTO');
module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-keys.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("../node_modules/core-js/modules/_object-keys-internal.js");
var enumBugKeys = __webpack_require__("../node_modules/core-js/modules/_enum-bug-keys.js");
module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_object-pie.js":
/***/ (function(module, exports) {



exports.f = {}.propertyIsEnumerable;

/***/ }),

/***/ "../node_modules/core-js/modules/_object-to-array.js":
/***/ (function(module, exports, __webpack_require__) {



var DESCRIPTORS = __webpack_require__("../node_modules/core-js/modules/_descriptors.js");
var getKeys = __webpack_require__("../node_modules/core-js/modules/_object-keys.js");
var toIObject = __webpack_require__("../node_modules/core-js/modules/_to-iobject.js");
var isEnum = __webpack_require__("../node_modules/core-js/modules/_object-pie.js").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_property-desc.js":
/***/ (function(module, exports) {



module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),

/***/ "../node_modules/core-js/modules/_redefine.js":
/***/ (function(module, exports, __webpack_require__) {



var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var hide = __webpack_require__("../node_modules/core-js/modules/_hide.js");
var has = __webpack_require__("../node_modules/core-js/modules/_has.js");
var SRC = __webpack_require__("../node_modules/core-js/modules/_uid.js")('src');
var $toString = __webpack_require__("../node_modules/core-js/modules/_function-to-string.js");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);
__webpack_require__("../node_modules/core-js/modules/_core.js").inspectSource = function (it) {
  return $toString.call(it);
};
(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),

/***/ "../node_modules/core-js/modules/_shared-key.js":
/***/ (function(module, exports, __webpack_require__) {



var shared = __webpack_require__("../node_modules/core-js/modules/_shared.js")('keys');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_shared.js":
/***/ (function(module, exports, __webpack_require__) {



var core = __webpack_require__("../node_modules/core-js/modules/_core.js");
var global = __webpack_require__("../node_modules/core-js/modules/_global.js");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("../node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});

/***/ }),

/***/ "../node_modules/core-js/modules/_string-context.js":
/***/ (function(module, exports, __webpack_require__) {



// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("../node_modules/core-js/modules/_is-regexp.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-absolute-index.js":
/***/ (function(module, exports, __webpack_require__) {



var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-integer.js":
/***/ (function(module, exports) {



// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-iobject.js":
/***/ (function(module, exports, __webpack_require__) {



// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("../node_modules/core-js/modules/_iobject.js");
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-length.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.15 ToLength
var toInteger = __webpack_require__("../node_modules/core-js/modules/_to-integer.js");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.13 ToObject(argument)
var defined = __webpack_require__("../node_modules/core-js/modules/_defined.js");
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_to-primitive.js":
/***/ (function(module, exports, __webpack_require__) {



// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("../node_modules/core-js/modules/_is-object.js");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),

/***/ "../node_modules/core-js/modules/_uid.js":
/***/ (function(module, exports) {



var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),

/***/ "../node_modules/core-js/modules/_wks.js":
/***/ (function(module, exports, __webpack_require__) {



var store = __webpack_require__("../node_modules/core-js/modules/_shared.js")('wks');
var uid = __webpack_require__("../node_modules/core-js/modules/_uid.js");
var Symbol = __webpack_require__("../node_modules/core-js/modules/_global.js").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';
var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};
$exports.store = store;

/***/ }),

/***/ "../node_modules/core-js/modules/es6.array.find.js":
/***/ (function(module, exports, __webpack_require__) {



// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $find = __webpack_require__("../node_modules/core-js/modules/_array-methods.js")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () {
  forced = false;
});
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")(KEY);

/***/ }),

/***/ "../node_modules/core-js/modules/es6.object.assign.js":
/***/ (function(module, exports, __webpack_require__) {



// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
$export($export.S + $export.F, 'Object', {
  assign: __webpack_require__("../node_modules/core-js/modules/_object-assign.js")
});

/***/ }),

/***/ "../node_modules/core-js/modules/es6.string.includes.js":
/***/ (function(module, exports, __webpack_require__) {

// 21.1.3.7 String.prototype.includes(searchString, position = 0)


var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var context = __webpack_require__("../node_modules/core-js/modules/_string-context.js");
var INCLUDES = 'includes';
$export($export.P + $export.F * __webpack_require__("../node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.array.includes.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $includes = __webpack_require__("../node_modules/core-js/modules/_array-includes.js")(true);
$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("../node_modules/core-js/modules/_add-to-unscopables.js")('includes');

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.entries.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $entries = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(true);
$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

/***/ }),

/***/ "../node_modules/core-js/modules/es7.object.values.js":
/***/ (function(module, exports, __webpack_require__) {



// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("../node_modules/core-js/modules/_export.js");
var $values = __webpack_require__("../node_modules/core-js/modules/_object-to-array.js")(false);
$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

/***/ }),

/***/ "../node_modules/escape-html/index.js":
/***/ (function(module, exports) {

/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */



/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Module exports.
 * @public
 */

module.exports = escapeHtml;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;';
        break;
      case 38: // &
        escape = '&amp;';
        break;
      case 39: // '
        escape = '&#39;';
        break;
      case 60: // <
        escape = '&lt;';
        break;
      case 62: // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index
    ? html + str.substring(lastIndex, index)
    : html;
}



/***/ }),

/***/ "../node_modules/lodash/lodash.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.23';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);

      // Prevent prototype pollution, see: https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
      var index = -1,
          length = path.length;

      if (!length) {
        return true;
      }

      var isRootPrimitive = object == null || (typeof object !== 'object' && typeof object !== 'function');

      while (++index < length) {
        var key = path[index];

        // skip non-string keys (e.g., Symbols, numbers)
        if (typeof key !== 'string') {
          continue;
        }

        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
          return false;
        }

        // Block "constructor.prototype" chains
        if (key === 'constructor' &&
            (index + 1) < length &&
            typeof path[index + 1] === 'string' &&
            path[index + 1] === 'prototype') {

          // Allow ONLY when the path starts at a primitive root, e.g., _.unset(0, 'constructor.prototype.a')
          if (isRootPrimitive && index === 0) {
            continue;
          }

          return false;
        }
      }

      var obj = parent(object, path);
      return obj == null || delete obj[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/global.js"), __webpack_require__("../node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "../node_modules/node-uuid/uuid.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_RESULT__;//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

/*global window, require, define */
(function(_window) {
  

  // Unique ID creation requires a high quality random # generator.  We feature
  // detect to determine the best RNG source, normalizing to a function that
  // returns 128-bits of randomness, since that's what's usually required
  var _rng, _mathRNG, _nodeRNG, _whatwgRNG, _previousRoot;

  function setupBrowser() {
    // Allow for MSIE11 msCrypto
    var _crypto = _window.crypto || _window.msCrypto;

    if (!_rng && _crypto && _crypto.getRandomValues) {
      // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
      //
      // Moderately fast, high quality
      try {
        var _rnds8 = new Uint8Array(16);
        _whatwgRNG = _rng = function whatwgRNG() {
          _crypto.getRandomValues(_rnds8);
          return _rnds8;
        };
        _rng();
      } catch(e) {}
    }

    if (!_rng) {
      // Math.random()-based (RNG)
      //
      // If all else fails, use Math.random().  It's fast, but is of unspecified
      // quality.
      var  _rnds = new Array(16);
      _mathRNG = _rng = function() {
        for (var i = 0, r; i < 16; i++) {
          if ((i & 0x03) === 0) { r = Math.random() * 0x100000000; }
          _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }

        return _rnds;
      };
      if ('undefined' !== typeof console && console.warn) {
        console.warn("[SECURITY] node-uuid: crypto not usable, falling back to insecure Math.random()");
      }
    }
  }

  function setupNode() {
    // Node.js crypto-based RNG - http://nodejs.org/docs/v0.6.2/api/crypto.html
    //
    // Moderately fast, high quality
    if (true) {
      try {
        var _rb = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"crypto\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).randomBytes;
        _nodeRNG = _rng = _rb && function() {return _rb(16);};
        _rng();
      } catch(e) {}
    }
  }

  if (_window) {
    setupBrowser();
  } else {
    setupNode();
  }

  // Buffer class to use
  var BufferClass = ('function' === typeof Buffer) ? Buffer : Array;

  // Maps for number <-> hex string conversion
  var _byteToHex = [];
  var _hexToByte = {};
  for (var i = 0; i < 256; i++) {
    _byteToHex[i] = (i + 0x100).toString(16).substr(1);
    _hexToByte[_byteToHex[i]] = i;
  }

  // **`parse()` - Parse a UUID into it's component bytes**
  function parse(s, buf, offset) {
    var i = (buf && offset) || 0, ii = 0;

    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
      if (ii < 16) { // Don't overflow!
        buf[i + ii++] = _hexToByte[oct];
      }
    });

    // Zero out remaining bytes if string was short
    while (ii < 16) {
      buf[i + ii++] = 0;
    }

    return buf;
  }

  // **`unparse()` - Convert UUID byte array (ala parse()) into a string**
  function unparse(buf, offset) {
    var i = offset || 0, bth = _byteToHex;
    return  bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] + '-' +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]] +
            bth[buf[i++]] + bth[buf[i++]];
  }

  // **`v1()` - Generate time-based UUID**
  //
  // Inspired by https://github.com/LiosK/UUID.js
  // and http://docs.python.org/library/uuid.html

  // random #'s we need to init node and clockseq
  var _seedBytes = _rng();

  // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
  var _nodeId = [
    _seedBytes[0] | 0x01,
    _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
  ];

  // Per 4.2.2, randomize (14 bit) clockseq
  var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

  // Previous uuid creation time
  var _lastMSecs = 0, _lastNSecs = 0;

  // See https://github.com/broofa/node-uuid for API details
  function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];

    options = options || {};

    var clockseq = (options.clockseq != null) ? options.clockseq : _clockseq;

    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = (options.msecs != null) ? options.msecs : new Date().getTime();

    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = (options.nsecs != null) ? options.nsecs : _lastNSecs + 1;

    // Time since last uuid creation (in msecs)
    var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq == null) {
      clockseq = clockseq + 1 & 0x3fff;
    }

    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs == null) {
      nsecs = 0;
    }

    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) {
      throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    }

    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq;

    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;

    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;

    // `time_mid`
    var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;

    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;

    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;

    // `clock_seq_low`
    b[i++] = clockseq & 0xff;

    // `node`
    var node = options.node || _nodeId;
    for (var n = 0; n < 6; n++) {
      b[i + n] = node[n];
    }

    return buf ? buf : unparse(b);
  }

  // **`v4()` - Generate random UUID**

  // See https://github.com/broofa/node-uuid for API details
  function v4(options, buf, offset) {
    // Deprecated - 'format' argument, as supported in v1.2
    var i = buf && offset || 0;

    if (typeof(options) === 'string') {
      buf = (options === 'binary') ? new BufferClass(16) : null;
      options = null;
    }
    options = options || {};

    var rnds = options.random || (options.rng || _rng)();

    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = (rnds[6] & 0x0f) | 0x40;
    rnds[8] = (rnds[8] & 0x3f) | 0x80;

    // Copy bytes to buffer, if provided
    if (buf) {
      for (var ii = 0; ii < 16; ii++) {
        buf[i + ii] = rnds[ii];
      }
    }

    return buf || unparse(rnds);
  }

  // Export public API
  var uuid = v4;
  uuid.v1 = v1;
  uuid.v4 = v4;
  uuid.parse = parse;
  uuid.unparse = unparse;
  uuid.BufferClass = BufferClass;
  uuid._rng = _rng;
  uuid._mathRNG = _mathRNG;
  uuid._nodeRNG = _nodeRNG;
  uuid._whatwgRNG = _whatwgRNG;

  if (('undefined' !== typeof module) && module.exports) {
    // Publish as node.js module
    module.exports = uuid;
  } else if (true) {
    // Publish as AMD module
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {return uuid;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


  } else {
    // Publish as global (in browsers)
    _previousRoot = _window.uuid;

    // **`noConflict()` - (browser only) to reset global 'uuid' var**
    uuid.noConflict = function() {
      _window.uuid = _previousRoot;
      return uuid;
    };

    _window.uuid = uuid;
  }
})('undefined' !== typeof window ? window : null);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/guest-upgrade/occupation/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"occupationDropDown\" class=\"dropdown confidential occupation clearfix inputField\"\n     floating-label-dropdown content>\n    <select xo-dropdown name=\"occupation\" id=\"occupation\" ng-model=\"user.occupation\"\n            ng-options=\"occupation as name for (occupation, name) in occupations\"\n            aria-labelledby=\"occupationLabel\" ng-required=\"true\" aria-required=\"true\" required>\n        <option value=\"\">{{ content('signup.occupationLabel') }}</option>\n    </select>\n    <label for=\"occupation\" id=\"occupationLabel\">{{ content('signup.occupationLabel') }}</label>\n</div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/login-button/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"loginSection\" content class=\"loginRedirect\">\n    <div class=\"row-fluid\">\n        <div class=\"span13 verticallyCentered baslLoginLabelContainer\">\n            <b>{{content('largeScreenPayment.guestSignUpDesc')}}</b>\n        </div>\n        <div class=\"span11 alignRight baslLoginButtonContainer\">\n            <a class=\"btn full\" ng-click=\"logWebviewLoginClickWrapper(); redirect()\" href=\"\">{{content('login.login')}}</a>\n        </div>\n    </div>\n</div>\n\n<div id=\"loginDivider\">\n      <span class=\"textInDivider\">\n        &nbsp{{content('login.orLowercase')}}&nbsp\n      </span>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addCard/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"multistepAddCard\" id=\"multistepAddCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n\n            <!-- BillingAgreement flows need to display description passed by merchant in cart -->\n            <xo-ba-message-banner ng-if=\"billingAgreementMerchantMsg\" token=\"token\"></xo-ba-message-banner>\n\n            <xo-login-button ng-if=\"showLogin\" redirect=\"redirect\"></xo-login-button>\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupaddcard.errorMessage\"></xo-message>\n            <xo-xoon-header token=\"token\" flags=\"multistepSignupModel.flags\" user=\"multistepSignupModel.onboard.user\" mode=\"mode\" fi-mode=\"fiMode\"></xo-xoon-header>\n\n            <form id=\"multistepAddCardForm\" name=\"multistepAddCardForm\" class=\"multistepSignupForm\"\n                  ng-submit=\"multistepAddCardForm.$valid && onSubmit()\" ng-class=\"{'validated': validated}\"\n                  novalidate form-error-detect>\n\n                <xo-country-list token=\"token\" show-mask=\"showMask\"></xo-country-list>\n                <div ng-class=\"{'showMask': showMask}\" disable-form=\"showMask\">\n                    <xo-credit-card\n                        token=\"token\"\n                        card=\"multistepSignupModel.onboard.card\"\n                        user=\"multistepSignupModel.onboard.user\"\n                        name-below=\"true\"\n                        set-buyer-fx-flag=\"setBuyerFxFlag\">\n                    </xo-credit-card>\n\n                    <div ng-if=\"isInstallmentsVisible()\" class=\"installment\">\n                        <a ng-if=\"!multistepSignupModel.selectedInstallmentData.preventChange\" focus-when=\"multistepSignupModel.selectedInstallmentData\" id=\"paymentMethod\" ui-sref=\"checkout.multistepsignup.multistepsignupaddcard.sidebar.installmentOptions\" class=\"getInstallments installmentsDropDown btn btn-secondary\" scroll-top=\"scroll-top\">\n                            <span ng-if=\"multistepSignupModel.selectedInstallmentData\">\n                                {{multistepSignupModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{multistepSignupModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                            </span>\n                            <span ng-if=\"!multistepSignupModel.selectedInstallmentData\">\n                                {{content('paymentMethod.changeInstallmentLongLink')}}\n                            </span>\n                        </a>\n                        <a ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\"\n                           class=\"getInstallments btn btn-secondary\" disabled>\n                            <span ng-if=\"multistepSignupModel.selectedInstallmentData\">\n                                {{multistepSignupModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{multistepSignupModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                            </span>\n                        </a>\n                        <div ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\" class=\"installmentHelper\">\n                            <a href=\"#\" id=\"installmentHelp\" alt=\"{{ content('common.altHelp') }}\" class=\"verifyHelp\">\n                            </a>\n                        </div>\n                        <xo-tooltip ng-if=\"multistepSignupModel.selectedInstallmentData.preventChange\" trigger=\"#installmentHelp\">\n                            <div class=\"tip tipDesc emailToolTip\">\n                                {{ content('paymentMethod.installmentPreselectedHelp') }}\n                            </div>\n                        </xo-tooltip>\n                    </div>\n\n                    <input ng-if=\"isInstallmentsVisible() && !multistepSignupModel.selectedInstallmentData\"\n                           type=\"text\"\n                           name=\"installments\"\n                           id=\"installments\"\n                           ng-model=\"multistepSignupModel.selectedInstallmentData.installment_option_selected.term\"\n                           value=\"\"\n                           class=\"hiddenInput ng-pristine\"\n                           required/>\n\n                    <xo-name-input user=\"multistepSignupModel.onboard.user\"></xo-name-input>\n\n                    <xo-inline-currency-conversion\n                        card=\"multistepSignupModel.onboard.card\"\n                        token=\"token\"\n                        treatment=\"multistepSignupModel.flags.buyerFxTreatment\"\n                        ng-if=\"multistepSignupModel.flags.hasBuyerFxPrePlanData && multistepSignupModel.flags.buyerFxTreatment\">\n                    </xo-inline-currency-conversion>\n\n                    <div id=\"billingAddress\">\n                        <div class=\"inputField confidential zip\" ng-if=\"componentsFlag.zipCode\" floating-label>\n\n                            <input type=\"text\"\n                                   name=\"zip\"\n                                   id=\"zip\"\n                                   ng-model=\"formattedValues.postalCode\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   data-error-key=\"common.valueInvalid\"\n                                   ng-blur=\"prefill(false)\"\n                                   xo-error-tooltip\n                                   maxlength=\"9\"\n                                   ng-change=\"zipMasking(formattedValues.postalCode)\"\n                                   required/>\n                            <label for=\"zip\" id=\"zipLabel\" >{{ content('common.cep') }}</label>\n                        </div>\n\n\n                        <div ng-if=\"componentsFlag.billingAddressLabel\">\n                            <label class=\"labelHeight\">{{ content('addressBook.billingAddress') }}</label>\n                        </div>\n\n                        <div ng-if=\"multistepSignupModel.flags.billingAddress.addrPrefilled || locale.country!=='BR'\">\n                            <xo-add-address address=\"multistepSignupModel.onboard.billing_address\" hide-cep=\"true\" country=\"locale.country\"></xo-add-address>\n                        </div>\n                    </div>\n\n                    <xo-phone-input phone=\"multistepSignupModel.onboard.phone\" countryCode=\"locale.country\"></xo-phone-input>\n\n                    <div class=\"row-fluid checkbox shipToBillingContainer\" ng-if=\"multistepSignupModel.flags.allowEditShipping\">\n                        <input ng-model=\"multistepSignupModel.flags.shipToBilling\" type=\"checkbox\" name=\"shipToBilling\" id=\"shipToBilling\"\n                               class=\"shipToBilling\"/>\n                        <label class=\"noBottom\" for=\"shipToBilling\"\n                               ng-bind-html=\"htmlContent('largeScreenPayment.shipTo')\"></label>\n                    </div>\n\n                    <div ng-if=\"componentsFlag.shippingAddress\">\n                        <div id=\"shippingAddress\" class=\"billingAddressPadding\" ng-if=\"!multistepSignupModel.flags.shipToBilling\">\n                            <label class=\"labelHeight\">{{ content('shipping.shippingTitle') }}</label>\n\n                            <xo-name-input user=\"multistepSignupModel.onboard.shipping_address\"></xo-name-input>\n\n                            <span feature=\"changeShippingCountry\">\n                                <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                                    <select xo-dropdown name=\"country\" ng-model=\"multistepSignupModel.onboard.shipping_address.country\" id=\"country\"\n                                            aria-labelledby=\"countryLabel\" ng-change=\"changeCountry()\" xo-error-tooltip required>\n                                            <option ng-repeat=\"country in multistepSignupModel.countries\" value=\"{{country.code}}\" ng-selected=\"multistepSignupModel.onboard.shipping_address.country === country.code\">{{country.name}}</option>\n                                    </select>\n                                    <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n                                </div>\n                            </span>\n\n                            <xo-add-address address=\"multistepSignupModel.onboard.shipping_address\" hide-cep=\"true\" hide-name=\"true\" is-shipping=\"true\" token=\"token\"\n                                            country=\"multistepSignupModel.onboard.shipping_address.country\"></xo-add-address>\n                        </div>\n                    </div>\n\n                    <div id=\"shippingMethod\" ng-if=\"multistepSignupModel.wps_flow && multistepSignupModel.merchant_has_snt_profile\">\n                        <xo-guest-select-shipping-method token=\"token\"\n                                                         show-shipping =\"showShippingAddress\"\n                                                 billing-address=\"multistepSignupModel.onboard.billing_address\"\n                                                 shipping-address=\"multistepSignupModel.onboard.shipping_address\"\n                                                 is-shipping-same-as-billing=\"multistepSignupModel.flags.shipToBilling\"\n                                                 button-params=\"buttonParams\"\n                                                 flags = \"multistepSignupModel.flags\"></xo-guest-select-shipping-method>\n                    </div>\n\n                    <div class=\"buttons visible\">\n                        <!--<a id=\"backButton\" class=\"btn btn-secondary half\"\n                           ng-click=\"backState($event)\">\n                            {{ content('common.back') }}\n                        </a>-->\n\n                        <input\n                            track-submit\n                            id=\"addCardSubmit\"\n                            type=\"submit\"\n                            value=\"{{ content(submitButtonKey, { currency: selectedCurrency }) }}\"\n                            class=\"btn half signupFlowSubmit\"\n                            ng-click=\"validated=true && positionToErrorField()\"/>\n                    </div>\n                </div>\n            </form>\n            <div ui-view></div>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addShipping/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"multiStepAddShipping\" id=\"multiStepAddShipping\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupaddshipping.errorMessage\"></xo-message>\n            <h1 class=\"alpha\">{{content('shipping.shippingTitle')}}</h1>\n\n            <form id=\"addShippingForm\" name=\"addShippingForm\" class=\"multistepSignupForm\" ng-submit=\"addShippingForm.$valid && onSubmit()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                <div id=\"shippingAddress\">\n                    <span feature=\"changeShippingCountry\">\n                        <div class=\"dropdown confidential country clearfix\">\n                            <label for=\"country\" id=\"countryLabel\" class=\"accessAid\">{{content('common.country')}}</label>\n                            <select xo-dropdown name=\"country\" ng-model=\"multistepSignupModel.onboard.shipping_address.country\" id=\"country\"\n                                    aria-labelledby=\"countryLabel\" ng-change=\"changeCountry()\" xo-error-tooltip required>\n                                    <option ng-repeat=\"country in multistepSignupModel.countries\" value=\"{{country.code}}\" ng-selected=\"multistepSignupModel.onboard.shipping_address.country === country.code\">{{country.name}}</option>\n                            </select>\n                        </div>\n                    </span>\n\n                    <xo-name-input user=\"multistepSignupModel.onboard.shipping_address\"></xo-name-input>\n                    <div ng-if=\"!multistepSignupModel.onboard.shippingCountryChanged\"\n                         class=\"inputField confidential zip\" floating-label>\n\n                        <input type=\"text\"\n                               name=\"zip\"\n                               id=\"zip\"\n                               ng-model=\"formattedValues.postalCode\"\n                               value=\"\"\n                               autocapitalize=\"off\"\n                               aria-required=\"true\"\n                               autocomplete=\"off\"\n                               placeholder=\"{{ content('common.cep') }}\"\n                               data-error-key=\"common.valueInvalid\"\n                               ng-blur=\"prefillDone ? prefill(false):prefill(true)\"\n                               xo-error-tooltip\n                               maxlength=\"9\"\n                               ng-change=\"zipMasking(formattedValues.postalCode)\"\n                               required/>\n                        <label for=\"zip\" id=\"zipLabel\">{{content('common.cep')}}</label>\n                    </div>\n\n                    <div ng-if=\"multistepSignupModel.flags.shippingAddress.addrPrefilled || multistepSignupModel.onboard.shipping_address.country!=='BR'\">\n                        <xo-add-address address=\"multistepSignupModel.onboard.shipping_address\" hide-cep=\"true\" hide-name=\"true\" is-shipping=\"true\" token=\"token\"\n                                        country=\"multistepSignupModel.onboard.shipping_address.country\"></xo-add-address>\n                    </div>\n                </div>\n\n                <div class=\"buttons\">\n                    <a id=\"backButton\" class=\"btn btn-secondary half\" ng-click=\"backState($event)\">\n                        {{content('common.back')}}\n                    </a>\n\n                    <input track-submit id=\"addShippingSubmit\" type=\"submit\" value=\"{{ content( 'common.continueLabel' ) }}\" class=\"btn half signupFlowSubmit\"\n                           ng-click=\"validate() && positionToErrorField()\" />\n                </div>\n            </form>\n\n            <div ui-view></div>\n\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\"\n                            text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"multiStepAddressNormalization\" id=\"multiStepAddressNormalization\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-address-normalization token=\"token\" address=\"address\" hide-back-button=\"false\" done-fn=\"doneFn\"></xo-address-normalization>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/createAccount/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"multiStepCreateAccount\" id=\"multiStepCreateAccount\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-message message=\"multistepSignupModel.pageError.multistepsignupcreateaccount.errorMessage\"></xo-message>\n            <h1 class=\"alpha\">{{content('largeScreenAccountCreation.title')}}</h1>\n\n            <form id=\"createAccountForm\" name=\"createAccountForm\" class=\"multistepSignupForm\" ng-submit=\"createAccountForm.$valid && onContinue()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                <div class=\"signupFieldsContainer\" id=\"signupContainer\">\n\n                    <div class=\"signupFieldGroup\">\n\n                        <div ng-class=\"{'fullSignup': fullSignup}\">\n                            <xo-email-input user=\"multistepSignupModel.onboard.user\"></xo-email-input>\n\n                            <xo-password-input user=\"multistepSignupModel.onboard.user\"></xo-password-input>\n\n                            <div ng-if=\"componentsFlag.dobDropDown\">\n                                <xo-dob-input user=\"multistepSignupModel.onboard.user\"></xo-dob-input>\n                            </div>\n\n                            <div class=\"rowPadding\">\n                                <xo-national-id-input country=\"{{locale.country}}\" user=\"multistepSignupModel.onboard.user\"></xo-national-id-input>\n                            </div>\n\n                            <div class=\"row-fluid checkbox legal rowPadding\" feature=\"econsent\">\n                                <div id=\"legalAgreeToolTip\" ng-show=\"showTooltip\">\n                                    <div class=\"errorTooltip legalAgreeCBToolTip\">{{content('largeScreenAccountCreation.agrementError')}}</div>\n                                </div>\n                                <input ng-model=\"multistepSignupModel.onboard.agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" ng-change=\"legalAgreeToolTip()\" required/>\n                                <label class=\"noBottom\" for=\"agree\" ng-bind-html=\"htmlContent('signupTerms.signupC', {country:locale.country, lang:locale.lang})\"></label>\n                            </div>\n\n                            <p class=\"billingTxt secondary row-fluid rowPadding legal\" ng-if=\"billingAgrementContentInfo.contentKey\">\n                                <span id=\"{{billingAgrementContentInfo.idSelector}}\" data-ng-bind-html=\"htmlContent(billingAgrementContentInfo.contentKey, billingAgrementContentInfo.data)\"></span>\n                            </p>\n\n                        </div>\n\n                    </div>\n\n                </div>\n\n                <div class=\"buttons\">\n                    <a id=\"backButton\" class=\"btn btn-secondary half\" ng-click=\"backState($event)\">\n                        {{content('common.back')}}\n                    </a>\n\n                    <input track-submit id=\"signupSubmit\" type=\"submit\" value=\"{{ content( submitButtonKey ) }}\" class=\"btn half signupFlowSubmit\"\n                           ng-click=\"validate() &&  positionToErrorField()\" />\n                </div>\n            </form>\n        </div>\n        <div class=\"span10\" ng-if=\"!createAccountDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\"\n                            text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n        <div class=\"span10\" ng-if=\"createAccountDesignExp\">\n            <xo-value-props type=\"review\" title=\"{{content(createAccountDesignExp.propHeader)}}\"\n                            text-content=\"{{createAccountDesignExp.propText}}\"\n                            image-url=\"{{createAccountDesignExp.propImage}}\"></xo-value-props>\n        </div>\n    </div>\n</section>\n\n<xo-3ds on-complete-3ds-handler=\"onComplete3DSHandler\" token=\"token\" data=\"multistepSignupModel.resolve_3ds_data\"\n        ng-if=\"multistepSignupModel.is3ds\"></xo-3ds>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view></div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"props {{type}}\" content>\n    <div class=\"prop-img\"></div>\n    <h2 class=\"vprop-header\">{{ title }}</h2>\n    <p ng-if=\"textContent\" ng-bind-html=\"htmlContent(textContent)\"></p>\n    <p ng-if=\"!textContent\" ng-bind-html=\"text\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html":
/***/ (function(module, exports) {

module.exports = "<a ng-show=\"isIFrame\" href=\"{{redirectURL}}\" id=\"closeButton\" target=\"_parent\" role=\"button\" ng-click=\"closeFrame($event)\">{{ content('base.closePayPalCheckoutLabel') }}</a>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html":
/***/ (function(module, exports) {

module.exports = "<button ng-show=\"isIFrame\" title=\"{{content('footer.escHatch')}}\" class='btn escapeHatch' ng-click=\"closeFrame()\"><span class=\"accessAid\">{{content('footer.escHatch')}}</span></button>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/generic-message/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"genericMessage\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{content(titleKey)}}\n        </div>\n        <div class=\"message\" ng-if=\"contentKey\">\n            {{content(contentKey)}}\n        </div>\n        <div class=\"returnButton\" ng-if=\"enableSuccessReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{returnButtonLabel}}\" ng-click=\"goToMerchant()\" ng-disabled=\"disableReturnToMerchantButton\"/>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"message.msgs || message.msgKeys\">\n    <div id=\"notifications\" role=\"alert\" aria-live=\"assertive\" content >\n        <div id=\"pageLevelErrors\" ng-class=\"[{'extendedMsg': isgreyheader}, 'msg-' + message.type, 'msgPage']\">\n            <span class=\"icon\"></span>\n            <ul role=\"presentation\">\n                <li ng-repeat=\"msg in message.msgs track by $index\">\n                    <span data-ng-bind-html=\"msg\" data-test-id=\"message\"></span>\n                </li>\n                <li ng-repeat=\"keys in message.msgKeys track by $index\" ng-if=\"message.msgKeys\">\n                    <div data-ng-bind-html=\"htmlContent(keys, message.compileWith)\" data-test-id=\"message\"></div>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner-button/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"spinnerBtn\" content>\n    <button track-submit={{track}} ng-click=\"submit()\" class=\"btn full\">\n        <div ng-show=\"isProcessing\" ng-class=\"{processing: isProcessing}\" class=\"spinner\"></div>\n        <div ng-hide=\"isProcessing\" class=\"text\" ng-bind-html=\"htmlContent(buttonText)\"></div>\n    </button>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"loading\" id=\"spinner\" class=\"spinner\">\n    <div class=\"spinWrap\">\n        <p class=\"spinnerImage\" />\n        <p class=\"loader\" />\n        <p id=\"spinner-message\" tabIndex=\"0\" role=\"alert\" class=\"loadingMessage\">\n            {{ message }}\n        </p>\n        <p id=\"spinner-submessage\" tabIndex=\"0\" role=\"alert\" class=\"loadingSubHeading\" ng-if=\"subMessage\">\n            {{ subMessage }}\n        </p>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/3ds/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"light-box-3ds\" class=\"light-box-3ds\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <a class=\"close\" ng-click=\"close3DSFrame()\" href=\"#\" ng-if=\"closable\">&nbsp;</a>\n                    <p class=\"light-box-header\">\n                        {{ content('threeDS.iFrameTitle') }}\n                    </p>\n                    <iframe id=\"threeDSFrame\" name=\"threeDSFrame\" src=\"\" class=\"light-box-iframe\"></iframe>\n                </div>\n\n                <div class=\"logo\"></div>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-bank/bank-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"bankFields\" content>\n\n    <div class=\"bban\" ng-if = \"!showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterBBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadIBAN')}}</a>\n        </p>\n\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"bankAccountNumber\" name=\"bankAccountNumber\" type=\"text\" value=\"\" ng-model=\"bank.bank_account_number\" placeholder=\"{{content('DEMemberGuest.accountPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"10\" aria-required=\"true\"\n                   xo-validation='{\n                \"validator\": \"validBankAccount\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-key=\"scripts.validNumber\" xo-error-tooltip />\n            <label for=\"bankAccountNumber\">\n                {{content('DEMemberGuest.account')}}\n            </label>\n        </div>\n\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"blz\" name=\"blz\" type=\"text\" value=\"\" ng-model=\"bank.bank_routing_number\" placeholder=\"{{content('DEMemberGuest.sortPlaceholder')}}\" autocomplete=\"off\" pattern=\"[0-9]*\" maxlength=\"8\" aria-required=\"true\"  xo-validation='{\n                \"validator\": \"validRouting\",\n                \"required\":  \"{{showIBAN}}\"\n            }' data-error-key=\"scripts.validNumber\" xo-error-tooltip />\n            <label for=\"blz\">\n                {{content('DEMemberGuest.sort')}}\n            </label>\n        </div>\n    </div>\n    <div class=\"iban\" ng-if=\"showIBAN\">\n        <p class=\"entryToggleLinks\">{{content('bank.enterIBAN')}}\n            <a class=\"toggle rightLink\" href ng-click=\"toggleIBAN()\">{{content('bank.insteadBBAN')}}</a>\n        </p>\n        <div class=\"inputField restricted\" floating-label>\n            <input id=\"ibanNumber\" name=\"ibanNumber\" type=\"text\" value=\"\" placeholder=\"{{content('bank.IBANPlaceholder')}}\" autocomplete=\"off\" maxlength=\"42\" aria-required=\"true\" ng-model=\"bank.iban_number\" data-error-key=\"scripts.validIBAN\" ng-change=\"onibanKeyup()\" xo-error-tooltip />\n            <label for=\"ibanNumber\">\n                {{content('bank.iban')}}\n            </label>\n        </div>\n    </div>\n\n\n    <div id=\"ccBlock\" ng-if=\"isCurrencyConversionValid\">\n        <div>\n            <span>{{content('currencyOptions.ppConversionRate')}}</span>\n            <span>{{exchangeSpreadFormatStr}}</span>\n        </div>\n        <div class=\"date\">\n            <span>{{content('currencyOptions.textConversionDate')}}</span>\n            <span>{{fxDate}}</span>\n        </div>\n        <div ng-if=\"showTotalAmount\">\n            <span ng-bind-html=\"htmlContent('currencyOptions.estimatedTotal')\"></span>\n            <span><b>{{targetFormatStr}}</b></span>\n        </div>\n        <div ng-if=\"!showTotalAmount\" ng-bind-html=\"htmlContent('currencyOptions.merchantCurrencyRate', {currency: sourceCurrencyCode})\"></div>\n    </div>\n\n\n    <div id=\"dobBank\" class=\"dobbank mb10\">\n        <fieldset>\n            <legend class=\"fieldLegend\" for=\"dob\">{{content('DEMemberGuest.dob')}}</legend>\n\n            <div class=\"dropdown fidobDay\">\n                <select xo-dropdown name=\"dobDay\" ng-model=\"user.dob_day\" id=\"dobDay\" aria-label=\"{{content('applyForBml.bmlApplyDay')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyDD')}}</option>\n                    <option ng-repeat=\"day in days\" value=\"{{day}}\" ng-selected=\"user.dob_day==='{{day}}'\">{{day}}</option>\n                </select>\n            </div>\n\n\n            <div class=\"dropdown fidobMonth\">\n                <select xo-dropdown name=\"dobMonth\" ng-model=\"user.dob_month\" id=\"dobMonth\" aria-label=\"{{content('applyForBml.bmlApplyMonth')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyMM')}}</option>\n                    <option ng-repeat=\"month in months\" value=\"{{month}}\" ng-selected=\"user.dob_month==='{{month}}'\">{{month}}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear\">\n                <select xo-dropdown name=\"dobYear\" ng-model=\"user.dob_year\" id=\"dobYear\" aria-label=\"{{content('applyForBml.bmlApplyYear')}}\" aria-required=\"true\" required>\n                    <option value=\"\">{{content('applyForBml.bmlApplyYYYY')}}</option>\n                    <option ng-repeat=\"year in years\" value=\"{{year}}\" ng-selected=\"user.dob_year==='{{year}}'\">{{year}}</option>\n                </select>\n            </div>\n\n        </fieldset>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addCep/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n<h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n<form id=\"cepForm\" name=\"cepForm\" class=\"asideView addressForm\" content novalidate>\n    <div class=\"trayInner container\">\n        <xo-zipcode id=\"zipcode\" country=\"{{country}}\" address=\"address\" zip-label=\"{{content('common.cep')}}\"\n                    zip-error-key=\"common.valueInvalid\"></xo-zipcode>\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\"\n                   value=\"{{ content('common.continueLabel') }}\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n        </div>\n    </div>\n</form>\n\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addbilling/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"billing\" modal-box=\"address\" modal-cancel=\"cancelFn()\">\n    <xo-aside-header back-url=\"^.addCard\" heading=\"asideHeader.addBillingAddress\" ng-if=\"sidebar\"></xo-aside-header>\n\n    <h1 class=\"gamma addBillingTitle\" ng-if=\"!sidebar\">{{ content('addBillingAddress.title') }}</h1>\n\n    <form id=\"billingAddressForm\" name=\"billingAddressForm\" class=\"asideView addressForm\" content form-autofocus novalidate>\n        <div class=\"trayInner container\">\n            <div class=\"clearfix\">\n                <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n            </div>\n\n            <div class=\"buttons clearfix\">\n                <a ng-hide=\"sidebar\" id=\"backButton\" ui-sref=\"^.addCard\" class=\"btn btn-secondary\" role=\"button\">{{ content('common.back') }}</a>\n                <input ng-if=\"country==='BR' && !prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"prefill()\" />\n                <input track-submit ng-if=\"country!=='BR' || prefilled\" type=\"submit\" id=\"proceedButton\" value=\"{{ content('common.save') }}\" class=\"btn\" ng-class=\"{full:sidebar}\" validate-submit=\"onSubmit()\" />\n            </div>\n        </div>\n    </form>\n</div>\n<div ui-view></div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addcard/template.html":
/***/ (function(module, exports) {

module.exports = "\n<div content modal-box=\"!!sidebar\" modal-cancel=\"cancelFn()\" xo-tray-height>\n    <xo-aside-header back-url=\"{{backUri}}\" heading=\"asideHeader.addCard\" ng-if=\"sidebar && !checkoutSession.plccOffer && !cardmodel.card.isExisting()\"></xo-aside-header>\n    <div class=\"header noButtons\" ng-if=\"manageCardFlow\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content('asideHeader.updateCard', {type: cardmodel.card.name, number: cardmodel.card.lastDigits}) }}</h1>\n        <a link-button ui-sref=\"checkout.review.sidebar.wallet\" class=\"backArrow goTray\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n    </div>\n    <xo-aside-header back-url=\"^.selectCard\" heading='asideHeader.selectCard' ng-if=\"sidebar && checkoutSession.plccOffer\"></xo-aside-header>\n    <xo-message message=\"message\" ng-if=\"!sidebar\"></xo-message>\n    <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n        {{ content('memberReview.welcomeBack', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout(auth)\">{{ content('memberReview.notYou')}}</a>\n                </span>\n    </p>\n    <h1 class=\"gamma\" ng-if=\"pagetitle\">{{ pagetitle }}</h1>\n\n    <div ng-class=\"{true: 'sidebar'}[asideContent]\" xo-tray-height>\n        <form id=\"creditCardForm\" name=\"creditCardForm\" class=\"addCard asideView asideContent\" content form-autofocus novalidate>\n            <div class=\"trayInner container\">\n                <xo-message message=\"message\" ng-if=\"sidebar\"></xo-message>\n                <xo-message id=\"billingAddressUpdatedMsg\" ng-if=\"billingaddressupdated.value\" message=\"billingaddressupdated\"></xo-message>\n                <xo-name-input user=\"cardmodel.user\" country=\"{{country}}\"></xo-name-input>\n\n                <xo-credit-card token=\"token\" card=\"cardmodel.card\" user=\"cardmodel.user\"\n                                selected-promotion-card-type=\"selectedPromotionCardType\"\n                                card-type-changed=\"cardTypeChanged\" promotion=\"promotion\"\n                                manage-card-flow=\"manageCardFlow\"></xo-credit-card>\n\n                <div ng-if=\"flag('fields.address')\" id=\"billingAddress\" class=\"billingAddress confidential\">\n                    <div class=\"dropdown billingAddress nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown default=\"{{content('addCard.addNewBillingAddress')}}\" ng-model=\"cardmodel.address\"\n                                ng-change=\"gotoBilling(cardmodel.address)\"\n                                ng-options=\"address.full_address for address in billingAddresses.addresses\"\n                                name=\"billingAddress\" id=\"billingAddressDropdown\" required>\n                        </select>\n                        <label for=\"billingAddressDropdown\" class=\"billingAddressLabel\">\n                            {{ content(\"addressBook.billingAddress\") }}\n                        </label>\n                        <a href=\"\" link-button ng-click=\"gotoBilling()\" class=\"addNewBillingAddress\" aria-label=\"{{ content('addCard.addNewBillingAddress') }}\">{{ content(\"addressBook.add\") }}</a>\n                    </div>\n                </div>\n\n                <div ng-if=\"flag('fields.phone')\">\n                    <div class=\"otpVerification\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></div>\n                    <xo-phone-input token=\"token\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n                </div>\n\n                <div class=\"addressLabel\">\n                    <a href=\"\" link-button ng-click=\"gotoBilling()\">{{ content(\"addCard.addNewBillingAddress\") }}</a>\n                </div>\n\n                <div ng-if=\"showplcc\">\n                    <div class=\"plccAgree checkbox\">\n                        <input type=\"checkbox\" checked=\"true\" name=\"plccAgree\" id=\"plccAgree\" />\n                        <label class=\"noBottom\" for=\"plccAgree\">{{content('addCard.plccPreferMethod', { merchant: promotion.name})}}</label>\n                    </div>\n                    <div class=\"legal\">{{content('addCard.plccLegal', { merchant: promotion.name})}}</div>\n                </div>\n\n\n                <input track-submit=\"{{cardmodel.card.isExisting() ? 'update_cc' : 'add_cc' }}\" type=\"submit\" value=\"{{ content(buttonText()) }}\" id=\"proceedButton\" class=\"btn full\" validate-submit=\"onSubmit()\" />\n            </div>\n        </form>\n    </div>\n\n    <div ui-view></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/creditcard-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"creditCardInput\" content>\n    <!-- These two hidden fields are added to avoid autofill issue by chome for password and login field -->\n    <input style=\"display:none\">\n    <input type=\"password\" style=\"display:none\">\n\n    <div class=\"cardIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showAcceptedCardLogos()\">\n        <div class=\"icons\" ng-repeat = \"cardType in cardTypes.allowed\"><div class = \"cardIcon {{cardType}}\"></div></div>\n        <div ng-if=\"showScanCardExperiment\" class=\"icons\"><div class=\"secureIcon lockIcon\"></div></div>\n    </div>\n\n    <div class=\"debitAndCreditIconsGroup\" ng-if=\"!debitCardFlow && !manageCardFlow && showMXCardLogos()\">\n        <p id=\"mxCardTitle\" class=\"cardIconTitle\">{{content('creditcard.cardIconTitle')}} </p>\n        <div class=\"cardIconsSection\">\n            <p class=\"creditIconLabel\" ng-if=\"showLabels\">{{content('creditcard.creditIconLabel')}}</p>\n            <div class=\"mxCardIconGroup\">\n                <div class=\"icons\" ng-repeat=\"cardType in cardTypes.allowed\">\n                    <div class=\"cardIcon {{cardType}}\"></div>\n                </div>\n            </div>\n            <div ng-if=\"showScanCardExperiment\" class=\"icons\"><div class=\"secureIcon lockIcon\"></div></div>\n            <br>\n            <p class=\"debitIconLabel\" ng-if=\"showLabels\">{{content('creditcard.debitIconLabel')}}</p>\n            <div class=\"icons\"\n                 ng-repeat=\"cardType in mxDebitCards\">\n                <div class=\"debitcardIcon {{cardType}}\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isPlcc\" class=\"plccCardNumberTitle\" >{{content('addCard.plccAddCard', { merchant: promotion.name})}}</div>\n\n    <div class=\"dropdown cardType confidential nullable inputField\" ng-if=\"!manageCardFlow && showDropDown()\"\n         floating-label-dropdown>\n        <select xo-dropdown name=\"cardType\" ng-model=\"card.type\" ng-change=\"changeType()\" ng-required=\"true\"\n                ng-options=\"cardType as content('cardTypes.' + cardType) for cardType in cardTypes.allowed track by cardType\"\n                track-focus-and-blur=\"cardType\"\n                id=\"cardType\" aria-labelledby=\"cardTypeLabel\" data-show-card-type=\"false\">\n            <option value=\"\" selected>{{ content('creditcard.typeLabel') }}</option>\n        </select>\n        <label for=\"cardType\" id=\"cardTypeLabel\">{{ content('creditcard.typeLabel') }}</label>\n    </div>\n\n    <div ng-if=\"!manageCardFlow\" class=\"inputField confidential cardNumber creditCardField\" floating-label directionality>\n        <input type=\"tel\" ui-validate=\"{luhn: 'cardLuhnValid($value)', len: 'cardLengthValid($value)', prodType: 'cardProductValid($value)'}\"\n                ui-validate-watch=\"'card.type'\"\n                ng-model=\"card.number\"\n                name=\"cardNumber\"\n                id=\"cc\"\n                value=\"\"\n                ng-change=\"changeCardNumber(false)\"\n                js-onchange=\"checkCardForDccCall\"\n                ng-blur=\"focusAndBlurHandler($event)\"\n                ng-focus=\"focusAndBlurHandler($event)\"\n                maxlength=\"{{maxLength()}}\"\n                data-number=\"{{unformattedCardNumber}}\"\n                autocapitalize=\"off\"\n                data-country=\"{{ locale.country }}\"\n                autocomplete=\"off\"\n                ng-pattern=\"/.*/\"\n                pattern=\"[0-9]*\"\n                scroll-to-top\n                track-focus-and-blur=\"cardNumber\"\n                data-error-key=\"{{debitCardFlow ? 'validation.validDebitCard' : 'validation.validCreditCard'}}\" xo-error-tooltip />\n\n        <xo-tooltip trigger=\"#cc\" ng-if=\"allowedCardsTooltip\" show-event=\"keyup\">\n            <div class=\"tip tipDesc tipCreditCard\" ng-if=\"!showUnsupportedCardMessage\">\n                {{ !debitCardFlow ? content('creditcard.acceptableCards') : content('creditcard.acceptDebitCardOnly') }}\n                <span class=\"acceptedCards\" ng-if=\"!debitCardFlow\">\n                    {{supportedCardNamesCommaSeparated}}\n                </span>\n            </div>\n            <div class=\"tip tipDesc tipCreditCard\" ng-if=\"showUnsupportedCardMessage\">\n                {{ !debitCardFlow ? content('creditcard.supportedAndUnsupportedCardType', {supportedCardNames: supportedCardNamesCommaSeparated, unsupportedCardNames: unsupportedCardNamesCommaSeparated}) : content('creditcard.acceptDebitCardOnly') }}\n            </div>\n        </xo-tooltip>\n\n        <label ng-if=\"showScanCardExperiment\"  for=\"cc\" class=\"focus\">\n            {{content('creditcard.scanCardNumber')}}\n        </label>\n        <label ng-if=\"!showScanCardExperiment\" for=\"cc\" class=\"focus\">\n            {{ !debitCardFlow ? content('creditcard.cardNumber') : content('creditcard.debitCardNumber') }}\n        </label>\n\n        <span ng-if=\"card.type\" class=\"creditCard {{card.type}} {{card.subType}}\" aria-label=\"{{card.type}}\" id=\"creditCard\" role=\"img\"></span>\n    </div>\n\n    <!-- Issue no and start date for maestro cards -->\n    <div id=\"cardIssueInfo\" data-cardspecific=\"true\" class=\"fieldGroup clearfix\" ng-if=\"flag('fields.issue')\">\n\n        <div class=\"startDate inputField invisiField half confidential\">\n            <label class=\"starts nolap\" for=\"startmonth\">{{ content('creditcard.startDate') }}</label>\n\n            <div class=\"dropdown startmonth expmonth nullable\">\n                <select xo-dropdown ng-model=\"card.start_month\" id=\"startmonth\" name=\"startmonth\"\n                        ng-required=\"true\" ng-options=\"month for month in months\">\n                    <option value=\"\">{{ content('creditcard.monthPlaceholder') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown startyear expyear nullable\">\n                <select xo-dropdown ng-model=\"card.start_year\" id=\"startyear\" name=\"startyear\"\n                        ng-required=\"true\" ng-options=\"year for year in startYears\">\n                    <option value=\"\">{{ content('creditcard.yearPlaceholder') }}</option>\n                </select>\n            </div>\n        </div>\n\n        <div class=\"issueNo inputField half last-child confidential last-child\">\n            <input id=\"issueNo\" name=\"issueNo\" placeholder=\"{{content('creditcard.issueNoLabel')}}\" type=\"text\" ng-model=\"card.issue_number\" autocapitalize=\"off\" autocomplete=\"off\" maxlength=\"2\" ng-pattern=\"/^[0-9]+$/\" pattern=\"[0-9]*\"/>\n\n            <xo-tooltip trigger=\"#issueNo\">\n                <div class=\"tip tipDesc tipIssueNo\">\n                    {{ content('creditcard.issueNoLabelToolTip') }}\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n\n    <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"expiryShown() || cvvShown()\">\n        <xo-card-expiry ng-if=\"expiryShown()\" expiry-month=\"card.expiry_month\" expiry-year=\"card.expiry_year\"></xo-card-expiry>\n        <xo-cvv ng-if=\"cvvShown()\" card=\"card\" show-label=\"true\"></xo-cvv>\n    </div>\n\n    <!-- DOB fields for Country specific cards -->\n    <xo-dob-card-input ng-if=\"flag('fields.dob')\" user=\"user\"></xo-dob-card-input>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/selectcard/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"selectCardType\">\n\t<xo-aside-header hdrtype='tall' heading='asideHeader.selectCard' sub-head='asideHeader.fundingInstrumentsSubHead' back-url=\"checkout.review.sidebar.wallet\"></xo-aside-header>\n\n\t<div class=\"asideContent fundingCards\" id=\"selectFundingType\" content>\n\t\t<div class=\"allCards\">\n\t\t\t<ul class=\"allFundingInstrumentsList clearfix\">\n\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('cc')\">\n\t\t\t\t\t\t<span class=\"fsIcon\"></span>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">Debit or Credit Card</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"fundingsource fs-item\">\n\t\t\t\t\t<a class=\"source\" role=\"button\" ng-click=\"selectCardType('plcc')\">\n\t\t\t\t\t\t<img class=\"plccIcon\" ng-src=\"{{promotion.logoUrl}}\"/>\n\t\t\t\t\t\t<p class=\"fsdetails\">\n\t\t\t\t\t\t\t<span class=\"name\">{{content('addCard.plccAddCard', { merchant: promotion.name})}}</span>\n\t\t\t\t\t\t\t<span class=\"secondary\">{{content('addCard.plccSelectIncentive')}}</span>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<span class=\"forwardIcon\"/>\n\t\t\t\t\t</a>\n\t\t\t\t</li>\n\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<div ui-view></div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/installment-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"aside installmentOptions\" ng-class=\"{true: 'signupflow'}[!auth.logged_in]\" >\n    <div class=\"cardInfo\" ng-if=\"cardInfo\">\n        <span class=\"ccard {{cardInfo.card_type}}\" id=\"creditCard\" role=\"img\" aria-label=\"{{cardInfo.name}}\"></span> {{cardInfo.name}} x-{{cardInfo.last4}}&nbsp;<span class=\"installmentText\" ng-if=\"installments\">{{content('installments.upto')}}&nbsp;{{installments.length}}x</span>\n    </div>\n    <ul class=\"asideContent items\" ng-if=\"installments\">\n        <li class=\"installment\" ng-repeat=\"installment in installments\" ng-click=\"onSelect($index)\" track-submit>\n            <div class=\"term\">\n                <span>{{installment.term}}x {{content('installments.of')}}&nbsp;</span>\n            </div>\n            <div class=\"display\">\n                <span>{{installment.monthly_payment.formatted_value}}</span>\n                <div class=\"confidential total\">\n                    <span>{{content('installments.total')}}: {{installment.total}}</span>\n                    <span class=\"save\" ng-if=\"installment.discount_amount\">\n                        {{content('installments.save')}} {{installment.discount_amount.formatted_value}}\n                    </span>\n                </div>\n            </div>\n\n        </li>\n    </ul>\n</div>"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-add-card/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addCard\" id=\"addCard\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <ui-view></ui-view>\n        </div>\n\n        <div class=\"span10\">\n            <xo-value-props type=\"addCard\" title=\"{{content('memberReview.propHead')}}\" text-content=\"memberReview.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-checkout/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"outerWrapper\" ng-class=\"[locale.metadata.directionality, locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'', guestAuthFlow ? 'authflow' : '']\" id=\"outerWrapper\">\n    <xo-merchant-header token=\"token\" ng-if=\"!guestAuthFlow\"></xo-merchant-header>\n    <div id=\"wrapper\" class=\"clearfix\">\n        <main id=\"main\" tabindex=\"-1\">\n            <xo-header token=\"token\" is-unbranded=\"isUnbranded\" unbranded-title=\"unbrandedTitle\"\n                       unbranded-sub-title=\"unbrandedSubTitle\" language-switch=\"languageSwitchHeader\" ng-if=\"!guestAuthFlow\"></xo-header>\n            <div id=\"contents\">\n                <div ui-view></div>\n            </div>\n        </main>\n        <xo-spinner></xo-spinner>\n    </div>\n    <xo-footer token=\"token\" language-switch=\"languageSwitchFooter\" ng-if=\"!guestAuthFlow\"></xo-footer>\n    <xo-gdpr-cookie-banner ng-if=\"isGdprValid()\"></xo-gdpr-cookie-banner>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-generic-message/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-generic-message token=token></xo-generic-message>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-guest/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"guestWithSignup\" id=\"guestWithSignup\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-onboard-payment token=\"token\" mode=\"mode\" is-unbranded=\"isUnbranded\"\n                                payment-method=\"paymentMethod\"\n                                single-step-model=\"singleStepModel\" button-params=\"buttonParams\"></xo-onboard-payment>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props  ng-if=\"!isUnbranded\" type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n            <xo-value-props  ng-if=\"isUnbranded\" type=\"review\" title=\"{{content('guestVerify.unbrandedPropHead')}}\" text-content=\"guestVerify.unbrandedPropVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-pay-upon-invoice/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"payUponInvoice\" id=\"payUponInvoice\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-pay-upon-invoice token=\"token\" is-unbranded=\"isUnbranded\"></xo-pay-upon-invoice>\n        </div>\n\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-sidebar-installment-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"aside\" id=\"installmentOptions\" xo-tray-height>\n    <xo-aside-header close-url=\"{{backUri}}\" heading='asideHeader.installmentsPanel'></xo-aside-header>\n    <div class=\"installmentOptions asideContent container\">\n       <xo-installment-options token=\"token\" done-fn=\"onComplete\" card-number=\"cardInfo.number\"></xo-installment-options>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-sidebar/template.html":
/***/ (function(module, exports) {

module.exports = "<aside class=\"sidebar\" id=\"tray\" ng-click=\"onPageClick($event)\">\n    <div ui-view></div>\n</aside>\n\n<span class=\"trayViewMask\" ng-click=\"close()\"></span>\n"

/***/ }),

/***/ "../node_modules/noop-loader/index.js!./pages/xo-signup/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"fullSignup\" id=\"fullSignup\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14\">\n            <xo-onboard-payment token=\"token\" mode=\"mode\" single-step-model=\"singleStepModel\" button-params=\"buttonParams\"></xo-onboard-payment>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"review\" title=\"{{content('guestVerify.propHead')}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n        </div>\n    </div>\n    <div ui-view></div>\n</section>\n"

/***/ }),

/***/ "../node_modules/paypal-sdk-constants/dist/paypal-sdk-constants.js":
/***/ (function(module, exports, __webpack_require__) {



!function (root, factory) {
   true ? module.exports = factory() : "function" == typeof define && define.amd ? define("ppsdkconstants", [], factory) : "object" == typeof exports ? exports.ppsdkconstants = factory() : root.ppsdkconstants = factory();
}("undefined" != typeof self ? self : void 0, function () {
  return function (modules) {
    var installedModules = {};
    function __webpack_require__(moduleId) {
      if (installedModules[moduleId]) return installedModules[moduleId].exports;
      var module = installedModules[moduleId] = {
        i: moduleId,
        l: !1,
        exports: {}
      };
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      module.l = !0;
      return module.exports;
    }
    __webpack_require__.m = modules;
    __webpack_require__.c = installedModules;
    __webpack_require__.d = function (exports, name, getter) {
      __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
        configurable: !1,
        enumerable: !0,
        get: getter
      });
    };
    __webpack_require__.n = function (module) {
      var getter = module && module.__esModule ? function () {
        return module["default"];
      } : function () {
        return module;
      };
      __webpack_require__.d(getter, "a", getter);
      return getter;
    };
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    __webpack_require__.p = "";
    return __webpack_require__(__webpack_require__.s = "./src/index.js");
  }({
    "./src/index.js": function _src_indexJs(module, __webpack_exports__, __webpack_require__) {
      

      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: !0
      });
      var _COUNTRY_LANGS,
        COUNTRY = {
          AD: "AD",
          AE: "AE",
          AG: "AG",
          AI: "AI",
          AL: "AL",
          AM: "AM",
          AN: "AN",
          AO: "AO",
          AR: "AR",
          AT: "AT",
          AU: "AU",
          AW: "AW",
          AZ: "AZ",
          BA: "BA",
          BB: "BB",
          BE: "BE",
          BF: "BF",
          BG: "BG",
          BH: "BH",
          BI: "BI",
          BJ: "BJ",
          BM: "BM",
          BN: "BN",
          BO: "BO",
          BR: "BR",
          BS: "BS",
          BT: "BT",
          BW: "BW",
          BY: "BY",
          BZ: "BZ",
          CA: "CA",
          CD: "CD",
          CG: "CG",
          CH: "CH",
          CI: "CI",
          CK: "CK",
          CL: "CL",
          CM: "CM",
          CN: "CN",
          CO: "CO",
          CR: "CR",
          CV: "CV",
          CY: "CY",
          CZ: "CZ",
          DE: "DE",
          DJ: "DJ",
          DK: "DK",
          DM: "DM",
          DO: "DO",
          DZ: "DZ",
          EC: "EC",
          EE: "EE",
          EG: "EG",
          ER: "ER",
          ES: "ES",
          ET: "ET",
          FI: "FI",
          FJ: "FJ",
          FK: "FK",
          FM: "FM",
          FO: "FO",
          FR: "FR",
          GA: "GA",
          GB: "GB",
          GD: "GD",
          GE: "GE",
          GF: "GF",
          GI: "GI",
          GL: "GL",
          GM: "GM",
          GN: "GN",
          GP: "GP",
          GR: "GR",
          GT: "GT",
          GW: "GW",
          GY: "GY",
          HK: "HK",
          HN: "HN",
          HR: "HR",
          HU: "HU",
          ID: "ID",
          IE: "IE",
          IL: "IL",
          IN: "IN",
          IS: "IS",
          IT: "IT",
          JM: "JM",
          JO: "JO",
          JP: "JP",
          KE: "KE",
          KG: "KG",
          KH: "KH",
          KI: "KI",
          KM: "KM",
          KN: "KN",
          KR: "KR",
          KW: "KW",
          KY: "KY",
          KZ: "KZ",
          LA: "LA",
          LC: "LC",
          LI: "LI",
          LK: "LK",
          LS: "LS",
          LT: "LT",
          LU: "LU",
          LV: "LV",
          MA: "MA",
          MC: "MC",
          MD: "MD",
          ME: "ME",
          MG: "MG",
          MH: "MH",
          MK: "MK",
          ML: "ML",
          MN: "MN",
          MQ: "MQ",
          MR: "MR",
          MS: "MS",
          MT: "MT",
          MU: "MU",
          MV: "MV",
          MW: "MW",
          MX: "MX",
          MY: "MY",
          MZ: "MZ",
          NA: "NA",
          NC: "NC",
          NE: "NE",
          NF: "NF",
          NG: "NG",
          NI: "NI",
          NL: "NL",
          NO: "NO",
          NP: "NP",
          NR: "NR",
          NU: "NU",
          NZ: "NZ",
          OM: "OM",
          PA: "PA",
          PE: "PE",
          PF: "PF",
          PG: "PG",
          PH: "PH",
          PL: "PL",
          PM: "PM",
          PN: "PN",
          PT: "PT",
          PW: "PW",
          PY: "PY",
          QA: "QA",
          RE: "RE",
          RO: "RO",
          RS: "RS",
          RU: "RU",
          RW: "RW",
          SA: "SA",
          SB: "SB",
          SC: "SC",
          SE: "SE",
          SG: "SG",
          SH: "SH",
          SI: "SI",
          SJ: "SJ",
          SK: "SK",
          SL: "SL",
          SM: "SM",
          SN: "SN",
          SO: "SO",
          SR: "SR",
          ST: "ST",
          SV: "SV",
          SZ: "SZ",
          TC: "TC",
          TD: "TD",
          TG: "TG",
          TH: "TH",
          TJ: "TJ",
          TM: "TM",
          TN: "TN",
          TO: "TO",
          TR: "TR",
          TT: "TT",
          TV: "TV",
          TW: "TW",
          TZ: "TZ",
          UA: "UA",
          UG: "UG",
          US: "US",
          UY: "UY",
          VA: "VA",
          VC: "VC",
          VE: "VE",
          VG: "VG",
          VN: "VN",
          VU: "VU",
          WF: "WF",
          WS: "WS",
          YE: "YE",
          YT: "YT",
          ZA: "ZA",
          ZM: "ZM",
          ZW: "ZW"
        },
        LANG = {
          AR: "ar",
          CS: "cs",
          DA: "da",
          DE: "de",
          EL: "el",
          EN: "en",
          ES: "es",
          FI: "fi",
          FR: "fr",
          HE: "he",
          HU: "hu",
          ID: "id",
          IT: "it",
          JA: "ja",
          KO: "ko",
          NL: "nl",
          NO: "no",
          PL: "pl",
          PT: "pt",
          RU: "ru",
          SK: "sk",
          SV: "sv",
          TH: "th",
          TR: "tr",
          ZH: "zh"
        },
        COUNTRY_LANGS = ((_COUNTRY_LANGS = {})[COUNTRY.AD] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR], _COUNTRY_LANGS[COUNTRY.AG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AL] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.AM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AN] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AO] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AR] = [LANG.ES, LANG.EN], _COUNTRY_LANGS[COUNTRY.AT] = [LANG.DE, LANG.EN], _COUNTRY_LANGS[COUNTRY.AU] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.AW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.AZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BA] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BB] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BE] = [LANG.EN, LANG.NL, LANG.FR], _COUNTRY_LANGS[COUNTRY.BF] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BG] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BH] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BI] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BJ] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BN] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BO] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BR] = [LANG.PT, LANG.EN], _COUNTRY_LANGS[COUNTRY.BS] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BT] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.BY] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.BZ] = [LANG.EN, LANG.ES, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CA] = [LANG.EN, LANG.FR], _COUNTRY_LANGS[COUNTRY.CD] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CH] = [LANG.DE, LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.CI] = [LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.CK] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CL] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CM] = [LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.CN] = [LANG.ZH], _COUNTRY_LANGS[COUNTRY.CO] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CR] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CV] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.CY] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.CZ] = [LANG.CS, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.DE] = [LANG.DE, LANG.EN], _COUNTRY_LANGS[COUNTRY.DJ] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.DK] = [LANG.DA, LANG.EN], _COUNTRY_LANGS[COUNTRY.DM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.DO] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.DZ] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.EC] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.EE] = [LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.EG] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ER] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ES] = [LANG.ES, LANG.EN], _COUNTRY_LANGS[COUNTRY.ET] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FI] = [LANG.FI, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FJ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FK] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FM] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.FO] = [LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.FR] = [LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.GA] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GB] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.GD] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GF] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GL] = [LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GN] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GP] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GR] = [LANG.EL, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GT] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.GY] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.HK] = [LANG.EN, LANG.ZH], _COUNTRY_LANGS[COUNTRY.HN] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.HR] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.HU] = [LANG.HU, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ID] = [LANG.ID, LANG.EN], _COUNTRY_LANGS[COUNTRY.IE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.IL] = [LANG.HE, LANG.EN], _COUNTRY_LANGS[COUNTRY.IN] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.IS] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.IT] = [LANG.IT, LANG.EN], _COUNTRY_LANGS[COUNTRY.JM] = [LANG.EN, LANG.ES, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.JO] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.JP] = [LANG.JA, LANG.EN], _COUNTRY_LANGS[COUNTRY.KE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KH] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.KI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KM] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KN] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KR] = [LANG.KO, LANG.EN], _COUNTRY_LANGS[COUNTRY.KW] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KY] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.KZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LA] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.LC] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LK] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.LS] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LT] = [LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LU] = [LANG.EN, LANG.DE, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.LV] = [LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MA] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MC] = [LANG.FR, LANG.EN], _COUNTRY_LANGS[COUNTRY.MD] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.ME] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MH] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MK] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.ML] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MN] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MQ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MR] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MS] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MT] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MU] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MV] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.MX] = [LANG.ES, LANG.EN], _COUNTRY_LANGS[COUNTRY.MY] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.MZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NA] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NC] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NE] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NF] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NG] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.NI] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NL] = [LANG.NL, LANG.EN], _COUNTRY_LANGS[COUNTRY.NO] = [LANG.NO, LANG.EN], _COUNTRY_LANGS[COUNTRY.NP] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.NR] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NU] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.NZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.OM] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PA] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PE] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PF] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PH] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.PL] = [LANG.PL, LANG.EN], _COUNTRY_LANGS[COUNTRY.PM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PN] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PT] = [LANG.PT, LANG.EN], _COUNTRY_LANGS[COUNTRY.PW] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.PY] = [LANG.ES, LANG.EN], _COUNTRY_LANGS[COUNTRY.QA] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR], _COUNTRY_LANGS[COUNTRY.RE] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.RO] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.RS] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.RU] = [LANG.RU, LANG.EN], _COUNTRY_LANGS[COUNTRY.RW] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SA] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SB] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SC] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SE] = [LANG.SV, LANG.EN], _COUNTRY_LANGS[COUNTRY.SG] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.SH] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SI] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SJ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SK] = [LANG.SK, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SL] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SN] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SO] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SR] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ST] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SV] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.SZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TC] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TD] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TG] = [LANG.FR, LANG.EN, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TH] = [LANG.TH, LANG.EN], _COUNTRY_LANGS[COUNTRY.TJ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TN] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TO] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.TR] = [LANG.TR, LANG.EN], _COUNTRY_LANGS[COUNTRY.TT] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TV] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.TW] = [LANG.ZH, LANG.EN], _COUNTRY_LANGS[COUNTRY.TZ] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.UA] = [LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.UG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.US] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.UY] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VA] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VC] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VE] = [LANG.ES, LANG.EN, LANG.FR, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VG] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.VN] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.VU] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.WF] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.WS] = [LANG.EN], _COUNTRY_LANGS[COUNTRY.YE] = [LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.YT] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ZA] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ZM] = [LANG.EN, LANG.FR, LANG.ES, LANG.ZH], _COUNTRY_LANGS[COUNTRY.ZW] = [LANG.EN], _COUNTRY_LANGS),
        SDK_SETTINGS = {
          CLIENT_TOKEN: "data-client-token",
          PARTNER_ATTRIBUTION_ID: "data-partner-attribution-id",
          STAGE_HOST: "data-stage-host",
          API_STAGE_HOST: "data-api-stage-host"
        },
        SDK_QUERY_KEYS = {
          COMPONENTS: "components",
          ENV: "env",
          DEBUG: "debug",
          CACHEBUST: "cachebust",
          CLIENT_ID: "client-id",
          MERCHANT_ID: "merchant-id",
          LOCALE: "locale",
          CURRENCY: "currency",
          INTENT: "intent",
          COMMIT: "commit",
          VAULT: "vault",
          BUYER_COUNTRY: "buyer-country",
          DISABLE_FUNDING: "disable-funding",
          DISABLE_CARD: "disable-card",
          LOCALE_COUNTRY: "locale-country",
          LOCALE_LANG: "locale-lang",
          ORDER_CURRENCY: "order-currency",
          ORDER_INTENT: "order-intent",
          ORDER_COMMIT: "order-commit",
          ORDER_VAULT: "order-vault"
        },
        COMPONENTS = {
          BUTTONS: "buttons",
          HOSTED_FIELDS: "hosted-fields"
        },
        DEBUG = {
          TRUE: !0,
          FALSE: !1
        },
        QUERY_BOOL = {
          TRUE: "true",
          FALSE: "false"
        },
        ENV = {
          LOCAL: "local",
          STAGE: "stage",
          SANDBOX: "sandbox",
          PRODUCTION: "production",
          TEST: "test"
        },
        FPTI_KEY = {
          FEED: "feed_name",
          STATE: "state_name",
          TRANSITION: "transition_name",
          BUTTON_TYPE: "button_type",
          SESSION_UID: "page_session_id",
          BUTTON_SESSION_UID: "button_session_id",
          TOKEN: "token",
          CONTEXT_ID: "context_id",
          CONTEXT_TYPE: "context_type",
          REFERER: "referer_url",
          PAY_ID: "pay_id",
          SELLER_ID: "seller_id",
          CLIENT_ID: "client_id",
          DATA_SOURCE: "serverside_data_source",
          BUTTON_SOURCE: "button_source",
          ERROR_CODE: "ext_error_code",
          ERROR_DESC: "ext_error_desc",
          PAGE_LOAD_TIME: "page_load_time",
          EXPERIMENT_NAME: "pxp_exp_id",
          TREATMENT_NAME: "pxp_trtmnt_id",
          TRANSITION_TIME: "transition_time",
          FUNDING_LIST: "eligible_payment_methods",
          FUNDING_COUNT: "eligible_payment_count",
          CHOSEN_FUNDING: "selected_payment_method",
          BUTTON_LAYOUT: "button_layout",
          VERSION: "checkoutjs_version",
          LOCALE: "locale",
          BUYER_COUNTRY: "buyer_cntry",
          INTEGRATION_IDENTIFIER: "integration_identifier",
          PARTNER_ATTRIBUTION_ID: "bn_code",
          SDK_NAME: "sdk_name",
          SDK_VERSION: "sdk_version",
          USER_AGENT: "user_agent",
          USER_ACTION: "user_action",
          CONTEXT_CORRID: "context_correlation_id"
        },
        FPTI_USER_ACTION = {
          COMMIT: "commit",
          CONTINUE: "continue"
        },
        FPTI_DATA_SOURCE = {
          PAYMENTS_SDK: "checkout"
        },
        FPTI_FEED = {
          PAYMENTS_SDK: "payments_sdk"
        },
        FPTI_SDK_NAME = {
          PAYMENTS_SDK: "payments_sdk"
        },
        INTENT = {
          CAPTURE: "capture",
          AUTHORIZE: "authorize",
          ORDER: "order"
        },
        COMMIT = {
          TRUE: !0,
          FALSE: !1
        },
        VAULT = {
          TRUE: !0,
          FALSE: !1
        },
        CURRENCY = {
          AUD: "AUD",
          BRL: "BRL",
          CAD: "CAD",
          CZK: "CZK",
          DKK: "DKK",
          EUR: "EUR",
          HKD: "HKD",
          HUF: "HUF",
          INR: "INR",
          ILS: "ILS",
          JPY: "JPY",
          MYR: "MYR",
          MXN: "MXN",
          TWD: "TWD",
          NZD: "NZD",
          NOK: "NOK",
          PHP: "PHP",
          PLN: "PLN",
          GBP: "GBP",
          RUB: "RUB",
          SGD: "SGD",
          SEK: "SEK",
          CHF: "CHF",
          THB: "THB",
          USD: "USD"
        },
        PLATFORM = {
          DESKTOP: "desktop",
          MOBILE: "mobile"
        },
        FUNDING = {
          PAYPAL: "paypal",
          VENMO: "venmo",
          CREDIT: "credit",
          CARD: "card",
          IDEAL: "ideal",
          SEPA: "sepa",
          BANCONTACT: "bancontact",
          GIROPAY: "giropay",
          SOFORT: "sofort",
          EPS: "eps",
          MYBANK: "mybank",
          P24: "p24",
          ZIMPLER: "zimpler",
          WECHATPAY: "wechatpay"
        },
        CARD = {
          VISA: "visa",
          MASTERCARD: "mastercard",
          AMEX: "amex",
          DISCOVER: "discover",
          HIPER: "hiper",
          ELO: "elo",
          JCB: "jcb",
          CUP: "cup"
        },
        DEFAULT_COUNTRY = COUNTRY.US,
        DEFAULT_CURRENCY = CURRENCY.USD,
        DEFAULT_INTENT = INTENT.CAPTURE,
        DEFAULT_COMMIT = COMMIT.TRUE,
        DEFAULT_VAULT = VAULT.FALSE,
        DEFAULT_COMPONENTS = COMPONENTS.BUTTONS,
        DEFAULT_DEBUG = DEBUG.FALSE;
      __webpack_require__.d(__webpack_exports__, "COUNTRY", function () {
        return COUNTRY;
      });
      __webpack_require__.d(__webpack_exports__, "LANG", function () {
        return LANG;
      });
      __webpack_require__.d(__webpack_exports__, "COUNTRY_LANGS", function () {
        return COUNTRY_LANGS;
      });
      __webpack_require__.d(__webpack_exports__, "SDK_PATH", function () {
        return "/sdk/js";
      });
      __webpack_require__.d(__webpack_exports__, "SDK_SETTINGS", function () {
        return SDK_SETTINGS;
      });
      __webpack_require__.d(__webpack_exports__, "SDK_QUERY_KEYS", function () {
        return SDK_QUERY_KEYS;
      });
      __webpack_require__.d(__webpack_exports__, "COMPONENTS", function () {
        return COMPONENTS;
      });
      __webpack_require__.d(__webpack_exports__, "DEBUG", function () {
        return DEBUG;
      });
      __webpack_require__.d(__webpack_exports__, "QUERY_BOOL", function () {
        return QUERY_BOOL;
      });
      __webpack_require__.d(__webpack_exports__, "ENV", function () {
        return ENV;
      });
      __webpack_require__.d(__webpack_exports__, "FPTI_KEY", function () {
        return FPTI_KEY;
      });
      __webpack_require__.d(__webpack_exports__, "FPTI_USER_ACTION", function () {
        return FPTI_USER_ACTION;
      });
      __webpack_require__.d(__webpack_exports__, "FPTI_DATA_SOURCE", function () {
        return FPTI_DATA_SOURCE;
      });
      __webpack_require__.d(__webpack_exports__, "FPTI_FEED", function () {
        return FPTI_FEED;
      });
      __webpack_require__.d(__webpack_exports__, "FPTI_SDK_NAME", function () {
        return FPTI_SDK_NAME;
      });
      __webpack_require__.d(__webpack_exports__, "INTENT", function () {
        return INTENT;
      });
      __webpack_require__.d(__webpack_exports__, "COMMIT", function () {
        return COMMIT;
      });
      __webpack_require__.d(__webpack_exports__, "VAULT", function () {
        return VAULT;
      });
      __webpack_require__.d(__webpack_exports__, "CURRENCY", function () {
        return CURRENCY;
      });
      __webpack_require__.d(__webpack_exports__, "PLATFORM", function () {
        return PLATFORM;
      });
      __webpack_require__.d(__webpack_exports__, "FUNDING", function () {
        return FUNDING;
      });
      __webpack_require__.d(__webpack_exports__, "CARD", function () {
        return CARD;
      });
      __webpack_require__.d(__webpack_exports__, "DEFAULT_COUNTRY", function () {
        return DEFAULT_COUNTRY;
      });
      __webpack_require__.d(__webpack_exports__, "DEFAULT_CURRENCY", function () {
        return DEFAULT_CURRENCY;
      });
      __webpack_require__.d(__webpack_exports__, "DEFAULT_INTENT", function () {
        return DEFAULT_INTENT;
      });
      __webpack_require__.d(__webpack_exports__, "DEFAULT_COMMIT", function () {
        return DEFAULT_COMMIT;
      });
      __webpack_require__.d(__webpack_exports__, "DEFAULT_VAULT", function () {
        return DEFAULT_VAULT;
      });
      __webpack_require__.d(__webpack_exports__, "DEFAULT_COMPONENTS", function () {
        return DEFAULT_COMPONENTS;
      });
      __webpack_require__.d(__webpack_exports__, "DEFAULT_DEBUG", function () {
        return DEFAULT_DEBUG;
      });
    }
  });
});

/***/ }),

/***/ "../node_modules/paypal-sdk-constants/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* @flow */

// $FlowFixMe
module.exports = __webpack_require__("../node_modules/paypal-sdk-constants/dist/paypal-sdk-constants.js"); // eslint-disable-line import/no-commonjs



/***/ }),

/***/ "../node_modules/sanitize-caja/index.js":
/***/ (function(module, exports, __webpack_require__) {

var html_sanitize = __webpack_require__("../node_modules/sanitize-caja/sanitizer-bundle.js");

module.exports = function(_) {
    if (!_) return '';
    return html_sanitize(_, cleanUrl, cleanId);
};

// https://bugzilla.mozilla.org/show_bug.cgi?id=255107
function cleanUrl(url) {
    
    if (/^https?/.test(url.getScheme())) return url.toString();
    if (/^mailto?/.test(url.getScheme())) return url.toString();
    if ('data' == url.getScheme() && /^image/.test(url.getPath())) {
        return url.toString();
    }
}

function cleanId(id) { return id; }



/***/ }),

/***/ "../node_modules/sanitize-caja/sanitizer-bundle.js":
/***/ (function(module, exports, __webpack_require__) {


// Copyright (C) 2010 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview
 * Implements RFC 3986 for parsing/formatting URIs.
 *
 * @author mikesamuel@gmail.com
 * \@provides URI
 * \@overrides window
 */

var URI = (function () {

/**
 * creates a uri from the string form.  The parser is relaxed, so special
 * characters that aren't escaped but don't cause ambiguities will not cause
 * parse failures.
 *
 * @return {URI|null}
 */
function parse(uriStr) {
  var m = ('' + uriStr).match(URI_RE_);
  if (!m) { return null; }
  return new URI(
      nullIfAbsent(m[1]),
      nullIfAbsent(m[2]),
      nullIfAbsent(m[3]),
      nullIfAbsent(m[4]),
      nullIfAbsent(m[5]),
      nullIfAbsent(m[6]),
      nullIfAbsent(m[7]));
}


/**
 * creates a uri from the given parts.
 *
 * @param scheme {string} an unencoded scheme such as "http" or null
 * @param credentials {string} unencoded user credentials or null
 * @param domain {string} an unencoded domain name or null
 * @param port {number} a port number in [1, 32768].
 *    -1 indicates no port, as does null.
 * @param path {string} an unencoded path
 * @param query {Array.<string>|string|null} a list of unencoded cgi
 *   parameters where even values are keys and odds the corresponding values
 *   or an unencoded query.
 * @param fragment {string} an unencoded fragment without the "#" or null.
 * @return {URI}
 */
function create(scheme, credentials, domain, port, path, query, fragment) {
  var uri = new URI(
      encodeIfExists2(scheme, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_),
      encodeIfExists2(
          credentials, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_),
      encodeIfExists(domain),
      port > 0 ? port.toString() : null,
      encodeIfExists2(path, URI_DISALLOWED_IN_PATH_),
      null,
      encodeIfExists(fragment));
  if (query) {
    if ('string' === typeof query) {
      uri.setRawQuery(query.replace(/[^?&=0-9A-Za-z_\-~.%]/g, encodeOne));
    } else {
      uri.setAllParameters(query);
    }
  }
  return uri;
}
function encodeIfExists(unescapedPart) {
  if ('string' == typeof unescapedPart) {
    return encodeURIComponent(unescapedPart);
  }
  return null;
};
/**
 * if unescapedPart is non null, then escapes any characters in it that aren't
 * valid characters in a url and also escapes any special characters that
 * appear in extra.
 *
 * @param unescapedPart {string}
 * @param extra {RegExp} a character set of characters in [\01-\177].
 * @return {string|null} null iff unescapedPart == null.
 */
function encodeIfExists2(unescapedPart, extra) {
  if ('string' == typeof unescapedPart) {
    return encodeURI(unescapedPart).replace(extra, encodeOne);
  }
  return null;
};
/** converts a character in [\01-\177] to its url encoded equivalent. */
function encodeOne(ch) {
  var n = ch.charCodeAt(0);
  return '%' + '0123456789ABCDEF'.charAt((n >> 4) & 0xf) +
      '0123456789ABCDEF'.charAt(n & 0xf);
}

/**
 * {@updoc
 *  $ normPath('foo/./bar')
 *  # 'foo/bar'
 *  $ normPath('./foo')
 *  # 'foo'
 *  $ normPath('foo/.')
 *  # 'foo'
 *  $ normPath('foo//bar')
 *  # 'foo/bar'
 * }
 */
function normPath(path) {
  return path.replace(/(^|\/)\.(?:\/|$)/g, '$1').replace(/\/{2,}/g, '/');
}

var PARENT_DIRECTORY_HANDLER = new RegExp(
    ''
    // A path break
    + '(/|^)'
    // followed by a non .. path element
    // (cannot be . because normPath is used prior to this RegExp)
    + '(?:[^./][^/]*|\\.{2,}(?:[^./][^/]*)|\\.{3,}[^/]*)'
    // followed by .. followed by a path break.
    + '/\\.\\.(?:/|$)');

var PARENT_DIRECTORY_HANDLER_RE = new RegExp(PARENT_DIRECTORY_HANDLER);

var EXTRA_PARENT_PATHS_RE = /^(?:\.\.\/)*(?:\.\.$)?/;

/**
 * Normalizes its input path and collapses all . and .. sequences except for
 * .. sequences that would take it above the root of the current parent
 * directory.
 * {@updoc
 *  $ collapse_dots('foo/../bar')
 *  # 'bar'
 *  $ collapse_dots('foo/./bar')
 *  # 'foo/bar'
 *  $ collapse_dots('foo/../bar/./../../baz')
 *  # 'baz'
 *  $ collapse_dots('../foo')
 *  # '../foo'
 *  $ collapse_dots('../foo').replace(EXTRA_PARENT_PATHS_RE, '')
 *  # 'foo'
 * }
 */
function collapse_dots(path) {
  if (path === null) { return null; }
  var p = normPath(path);
  // Only /../ left to flatten
  var r = PARENT_DIRECTORY_HANDLER_RE;
  // We replace with $1 which matches a / before the .. because this
  // guarantees that:
  // (1) we have at most 1 / between the adjacent place,
  // (2) always have a slash if there is a preceding path section, and
  // (3) we never turn a relative path into an absolute path.
  for (var q; (q = p.replace(r, '$1')) != p; p = q) {};
  return p;
}

/**
 * resolves a relative url string to a base uri.
 * @return {URI}
 */
function resolve(baseUri, relativeUri) {
  // there are several kinds of relative urls:
  // 1. //foo - replaces everything from the domain on.  foo is a domain name
  // 2. foo - replaces the last part of the path, the whole query and fragment
  // 3. /foo - replaces the the path, the query and fragment
  // 4. ?foo - replace the query and fragment
  // 5. #foo - replace the fragment only

  var absoluteUri = baseUri.clone();
  // we satisfy these conditions by looking for the first part of relativeUri
  // that is not blank and applying defaults to the rest

  var overridden = relativeUri.hasScheme();

  if (overridden) {
    absoluteUri.setRawScheme(relativeUri.getRawScheme());
  } else {
    overridden = relativeUri.hasCredentials();
  }

  if (overridden) {
    absoluteUri.setRawCredentials(relativeUri.getRawCredentials());
  } else {
    overridden = relativeUri.hasDomain();
  }

  if (overridden) {
    absoluteUri.setRawDomain(relativeUri.getRawDomain());
  } else {
    overridden = relativeUri.hasPort();
  }

  var rawPath = relativeUri.getRawPath();
  var simplifiedPath = collapse_dots(rawPath);
  if (overridden) {
    absoluteUri.setPort(relativeUri.getPort());
    simplifiedPath = simplifiedPath
        && simplifiedPath.replace(EXTRA_PARENT_PATHS_RE, '');
  } else {
    overridden = !!rawPath;
    if (overridden) {
      // resolve path properly
      if (simplifiedPath.charCodeAt(0) !== 0x2f /* / */) {  // path is relative
        var absRawPath = collapse_dots(absoluteUri.getRawPath() || '')
            .replace(EXTRA_PARENT_PATHS_RE, '');
        var slash = absRawPath.lastIndexOf('/') + 1;
        simplifiedPath = collapse_dots(
            (slash ? absRawPath.substring(0, slash) : '')
            + collapse_dots(rawPath))
            .replace(EXTRA_PARENT_PATHS_RE, '');
      }
    } else {
      simplifiedPath = simplifiedPath
          && simplifiedPath.replace(EXTRA_PARENT_PATHS_RE, '');
      if (simplifiedPath !== rawPath) {
        absoluteUri.setRawPath(simplifiedPath);
      }
    }
  }

  if (overridden) {
    absoluteUri.setRawPath(simplifiedPath);
  } else {
    overridden = relativeUri.hasQuery();
  }

  if (overridden) {
    absoluteUri.setRawQuery(relativeUri.getRawQuery());
  } else {
    overridden = relativeUri.hasFragment();
  }

  if (overridden) {
    absoluteUri.setRawFragment(relativeUri.getRawFragment());
  }

  return absoluteUri;
}

/**
 * a mutable URI.
 *
 * This class contains setters and getters for the parts of the URI.
 * The <tt>getXYZ</tt>/<tt>setXYZ</tt> methods return the decoded part -- so
 * <code>uri.parse('/foo%20bar').getPath()</code> will return the decoded path,
 * <tt>/foo bar</tt>.
 *
 * <p>The raw versions of fields are available too.
 * <code>uri.parse('/foo%20bar').getRawPath()</code> will return the raw path,
 * <tt>/foo%20bar</tt>.  Use the raw setters with care, since
 * <code>URI::toString</code> is not guaranteed to return a valid url if a
 * raw setter was used.
 *
 * <p>All setters return <tt>this</tt> and so may be chained, a la
 * <code>uri.parse('/foo').setFragment('part').toString()</code>.
 *
 * <p>You should not use this constructor directly -- please prefer the factory
 * functions {@link uri.parse}, {@link uri.create}, {@link uri.resolve}
 * instead.</p>
 *
 * <p>The parameters are all raw (assumed to be properly escaped) parts, and
 * any (but not all) may be null.  Undefined is not allowed.</p>
 *
 * @constructor
 */
function URI(
    rawScheme,
    rawCredentials, rawDomain, port,
    rawPath, rawQuery, rawFragment) {
  this.scheme_ = rawScheme;
  this.credentials_ = rawCredentials;
  this.domain_ = rawDomain;
  this.port_ = port;
  this.path_ = rawPath;
  this.query_ = rawQuery;
  this.fragment_ = rawFragment;
  /**
   * @type {Array|null}
   */
  this.paramCache_ = null;
}

/** returns the string form of the url. */
URI.prototype.toString = function () {
  var out = [];
  if (null !== this.scheme_) { out.push(this.scheme_, ':'); }
  if (null !== this.domain_) {
    out.push('//');
    if (null !== this.credentials_) { out.push(this.credentials_, '@'); }
    out.push(this.domain_);
    if (null !== this.port_) { out.push(':', this.port_.toString()); }
  }
  if (null !== this.path_) { out.push(this.path_); }
  if (null !== this.query_) { out.push('?', this.query_); }
  if (null !== this.fragment_) { out.push('#', this.fragment_); }
  return out.join('');
};

URI.prototype.clone = function () {
  return new URI(this.scheme_, this.credentials_, this.domain_, this.port_,
                 this.path_, this.query_, this.fragment_);
};

URI.prototype.getScheme = function () {
  // HTML5 spec does not require the scheme to be lowercased but
  // all common browsers except Safari lowercase the scheme.
  return this.scheme_ && decodeURIComponent(this.scheme_).toLowerCase();
};
URI.prototype.getRawScheme = function () {
  return this.scheme_;
};
URI.prototype.setScheme = function (newScheme) {
  this.scheme_ = encodeIfExists2(
      newScheme, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_);
  return this;
};
URI.prototype.setRawScheme = function (newScheme) {
  this.scheme_ = newScheme ? newScheme : null;
  return this;
};
URI.prototype.hasScheme = function () {
  return null !== this.scheme_;
};


URI.prototype.getCredentials = function () {
  return this.credentials_ && decodeURIComponent(this.credentials_);
};
URI.prototype.getRawCredentials = function () {
  return this.credentials_;
};
URI.prototype.setCredentials = function (newCredentials) {
  this.credentials_ = encodeIfExists2(
      newCredentials, URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_);

  return this;
};
URI.prototype.setRawCredentials = function (newCredentials) {
  this.credentials_ = newCredentials ? newCredentials : null;
  return this;
};
URI.prototype.hasCredentials = function () {
  return null !== this.credentials_;
};


URI.prototype.getDomain = function () {
  return this.domain_ && decodeURIComponent(this.domain_);
};
URI.prototype.getRawDomain = function () {
  return this.domain_;
};
URI.prototype.setDomain = function (newDomain) {
  return this.setRawDomain(newDomain && encodeURIComponent(newDomain));
};
URI.prototype.setRawDomain = function (newDomain) {
  this.domain_ = newDomain ? newDomain : null;
  // Maintain the invariant that paths must start with a slash when the URI
  // is not path-relative.
  return this.setRawPath(this.path_);
};
URI.prototype.hasDomain = function () {
  return null !== this.domain_;
};


URI.prototype.getPort = function () {
  return this.port_ && decodeURIComponent(this.port_);
};
URI.prototype.setPort = function (newPort) {
  if (newPort) {
    newPort = Number(newPort);
    if (newPort !== (newPort & 0xffff)) {
      throw new Error('Bad port number ' + newPort);
    }
    this.port_ = '' + newPort;
  } else {
    this.port_ = null;
  }
  return this;
};
URI.prototype.hasPort = function () {
  return null !== this.port_;
};


URI.prototype.getPath = function () {
  return this.path_ && decodeURIComponent(this.path_);
};
URI.prototype.getRawPath = function () {
  return this.path_;
};
URI.prototype.setPath = function (newPath) {
  return this.setRawPath(encodeIfExists2(newPath, URI_DISALLOWED_IN_PATH_));
};
URI.prototype.setRawPath = function (newPath) {
  if (newPath) {
    newPath = String(newPath);
    this.path_ = 
      // Paths must start with '/' unless this is a path-relative URL.
      (!this.domain_ || /^\//.test(newPath)) ? newPath : '/' + newPath;
  } else {
    this.path_ = null;
  }
  return this;
};
URI.prototype.hasPath = function () {
  return null !== this.path_;
};


URI.prototype.getQuery = function () {
  // From http://www.w3.org/Addressing/URL/4_URI_Recommentations.html
  // Within the query string, the plus sign is reserved as shorthand notation
  // for a space.
  return this.query_ && decodeURIComponent(this.query_).replace(/\+/g, ' ');
};
URI.prototype.getRawQuery = function () {
  return this.query_;
};
URI.prototype.setQuery = function (newQuery) {
  this.paramCache_ = null;
  this.query_ = encodeIfExists(newQuery);
  return this;
};
URI.prototype.setRawQuery = function (newQuery) {
  this.paramCache_ = null;
  this.query_ = newQuery ? newQuery : null;
  return this;
};
URI.prototype.hasQuery = function () {
  return null !== this.query_;
};

/**
 * sets the query given a list of strings of the form
 * [ key0, value0, key1, value1, ... ].
 *
 * <p><code>uri.setAllParameters(['a', 'b', 'c', 'd']).getQuery()</code>
 * will yield <code>'a=b&c=d'</code>.
 */
URI.prototype.setAllParameters = function (params) {
  if (typeof params === 'object') {
    if (!(params instanceof Array)
        && (params instanceof Object
            || Object.prototype.toString.call(params) !== '[object Array]')) {
      var newParams = [];
      var i = -1;
      for (var k in params) {
        var v = params[k];
        if ('string' === typeof v) {
          newParams[++i] = k;
          newParams[++i] = v;
        }
      }
      params = newParams;
    }
  }
  this.paramCache_ = null;
  var queryBuf = [];
  var separator = '';
  for (var j = 0; j < params.length;) {
    var k = params[j++];
    var v = params[j++];
    queryBuf.push(separator, encodeURIComponent(k.toString()));
    separator = '&';
    if (v) {
      queryBuf.push('=', encodeURIComponent(v.toString()));
    }
  }
  this.query_ = queryBuf.join('');
  return this;
};
URI.prototype.checkParameterCache_ = function () {
  if (!this.paramCache_) {
    var q = this.query_;
    if (!q) {
      this.paramCache_ = [];
    } else {
      var cgiParams = q.split(/[&\?]/);
      var out = [];
      var k = -1;
      for (var i = 0; i < cgiParams.length; ++i) {
        var m = cgiParams[i].match(/^([^=]*)(?:=(.*))?$/);
        // From http://www.w3.org/Addressing/URL/4_URI_Recommentations.html
        // Within the query string, the plus sign is reserved as shorthand
        // notation for a space.
        out[++k] = decodeURIComponent(m[1]).replace(/\+/g, ' ');
        out[++k] = decodeURIComponent(m[2] || '').replace(/\+/g, ' ');
      }
      this.paramCache_ = out;
    }
  }
};
/**
 * sets the values of the named cgi parameters.
 *
 * <p>So, <code>uri.parse('foo?a=b&c=d&e=f').setParameterValues('c', ['new'])
 * </code> yields <tt>foo?a=b&c=new&e=f</tt>.</p>
 *
 * @param key {string}
 * @param values {Array.<string>} the new values.  If values is a single string
 *   then it will be treated as the sole value.
 */
URI.prototype.setParameterValues = function (key, values) {
  // be nice and avoid subtle bugs where [] operator on string performs charAt
  // on some browsers and crashes on IE
  if (typeof values === 'string') {
    values = [ values ];
  }

  this.checkParameterCache_();
  var newValueIndex = 0;
  var pc = this.paramCache_;
  var params = [];
  for (var i = 0, k = 0; i < pc.length; i += 2) {
    if (key === pc[i]) {
      if (newValueIndex < values.length) {
        params.push(key, values[newValueIndex++]);
      }
    } else {
      params.push(pc[i], pc[i + 1]);
    }
  }
  while (newValueIndex < values.length) {
    params.push(key, values[newValueIndex++]);
  }
  this.setAllParameters(params);
  return this;
};
URI.prototype.removeParameter = function (key) {
  return this.setParameterValues(key, []);
};
/**
 * returns the parameters specified in the query part of the uri as a list of
 * keys and values like [ key0, value0, key1, value1, ... ].
 *
 * @return {Array.<string>}
 */
URI.prototype.getAllParameters = function () {
  this.checkParameterCache_();
  return this.paramCache_.slice(0, this.paramCache_.length);
};
/**
 * returns the value<b>s</b> for a given cgi parameter as a list of decoded
 * query parameter values.
 * @return {Array.<string>}
 */
URI.prototype.getParameterValues = function (paramNameUnescaped) {
  this.checkParameterCache_();
  var values = [];
  for (var i = 0; i < this.paramCache_.length; i += 2) {
    if (paramNameUnescaped === this.paramCache_[i]) {
      values.push(this.paramCache_[i + 1]);
    }
  }
  return values;
};
/**
 * returns a map of cgi parameter names to (non-empty) lists of values.
 * @return {Object.<string,Array.<string>>}
 */
URI.prototype.getParameterMap = function (paramNameUnescaped) {
  this.checkParameterCache_();
  var paramMap = {};
  for (var i = 0; i < this.paramCache_.length; i += 2) {
    var key = this.paramCache_[i++],
      value = this.paramCache_[i++];
    if (!(key in paramMap)) {
      paramMap[key] = [value];
    } else {
      paramMap[key].push(value);
    }
  }
  return paramMap;
};
/**
 * returns the first value for a given cgi parameter or null if the given
 * parameter name does not appear in the query string.
 * If the given parameter name does appear, but has no '<tt>=</tt>' following
 * it, then the empty string will be returned.
 * @return {string|null}
 */
URI.prototype.getParameterValue = function (paramNameUnescaped) {
  this.checkParameterCache_();
  for (var i = 0; i < this.paramCache_.length; i += 2) {
    if (paramNameUnescaped === this.paramCache_[i]) {
      return this.paramCache_[i + 1];
    }
  }
  return null;
};

URI.prototype.getFragment = function () {
  return this.fragment_ && decodeURIComponent(this.fragment_);
};
URI.prototype.getRawFragment = function () {
  return this.fragment_;
};
URI.prototype.setFragment = function (newFragment) {
  this.fragment_ = newFragment ? encodeURIComponent(newFragment) : null;
  return this;
};
URI.prototype.setRawFragment = function (newFragment) {
  this.fragment_ = newFragment ? newFragment : null;
  return this;
};
URI.prototype.hasFragment = function () {
  return null !== this.fragment_;
};

function nullIfAbsent(matchPart) {
  return ('string' == typeof matchPart) && (matchPart.length > 0)
         ? matchPart
         : null;
}




/**
 * a regular expression for breaking a URI into its component parts.
 *
 * <p>http://www.gbiv.com/protocols/uri/rfc/rfc3986.html#RFC2234 says
 * As the "first-match-wins" algorithm is identical to the "greedy"
 * disambiguation method used by POSIX regular expressions, it is natural and
 * commonplace to use a regular expression for parsing the potential five
 * components of a URI reference.
 *
 * <p>The following line is the regular expression for breaking-down a
 * well-formed URI reference into its components.
 *
 * <pre>
 * ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
 *  12            3  4          5       6  7        8 9
 * </pre>
 *
 * <p>The numbers in the second line above are only to assist readability; they
 * indicate the reference points for each subexpression (i.e., each paired
 * parenthesis). We refer to the value matched for subexpression <n> as $<n>.
 * For example, matching the above expression to
 * <pre>
 *     http://www.ics.uci.edu/pub/ietf/uri/#Related
 * </pre>
 * results in the following subexpression matches:
 * <pre>
 *    $1 = http:
 *    $2 = http
 *    $3 = //www.ics.uci.edu
 *    $4 = www.ics.uci.edu
 *    $5 = /pub/ietf/uri/
 *    $6 = <undefined>
 *    $7 = <undefined>
 *    $8 = #Related
 *    $9 = Related
 * </pre>
 * where <undefined> indicates that the component is not present, as is the
 * case for the query component in the above example. Therefore, we can
 * determine the value of the five components as
 * <pre>
 *    scheme    = $2
 *    authority = $4
 *    path      = $5
 *    query     = $7
 *    fragment  = $9
 * </pre>
 *
 * <p>msamuel: I have modified the regular expression slightly to expose the
 * credentials, domain, and port separately from the authority.
 * The modified version yields
 * <pre>
 *    $1 = http              scheme
 *    $2 = <undefined>       credentials -\
 *    $3 = www.ics.uci.edu   domain       | authority
 *    $4 = <undefined>       port        -/
 *    $5 = /pub/ietf/uri/    path
 *    $6 = <undefined>       query without ?
 *    $7 = Related           fragment without #
 * </pre>
 */
var URI_RE_ = new RegExp(
      "^" +
      "(?:" +
        "([^:/?#]+)" +         // scheme
      ":)?" +
      "(?://" +
        "(?:([^/?#]*)@)?" +    // credentials
        "([^/?#:@]*)" +        // domain
        "(?::([0-9]+))?" +     // port
      ")?" +
      "([^?#]+)?" +            // path
      "(?:\\?([^#]*))?" +      // query
      "(?:#(.*))?" +           // fragment
      "$"
      );

var URI_DISALLOWED_IN_SCHEME_OR_CREDENTIALS_ = /[#\/\?@]/g;
var URI_DISALLOWED_IN_PATH_ = /[\#\?]/g;

URI.parse = parse;
URI.create = create;
URI.resolve = resolve;
URI.collapse_dots = collapse_dots;  // Visible for testing.

// lightweight string-based api for loadModuleMaker
URI.utils = {
  mimeTypeOf: function (uri) {
    var uriObj = parse(uri);
    if (/\.html$/.test(uriObj.getPath())) {
      return 'text/html';
    } else {
      return 'application/javascript';
    }
  },
  resolve: function (base, uri) {
    if (base) {
      return resolve(parse(base), parse(uri)).toString();
    } else {
      return '' + uri;
    }
  }
};


return URI;
})();

// Copyright Google Inc.
// Licensed under the Apache Licence Version 2.0
// Autogenerated at Mon Feb 25 13:05:42 EST 2013
// @overrides window
// @provides html4
var html4 = {};
html4.atype = {
  'NONE': 0,
  'URI': 1,
  'URI_FRAGMENT': 11,
  'SCRIPT': 2,
  'STYLE': 3,
  'HTML': 12,
  'ID': 4,
  'IDREF': 5,
  'IDREFS': 6,
  'GLOBAL_NAME': 7,
  'LOCAL_NAME': 8,
  'CLASSES': 9,
  'FRAME_TARGET': 10,
  'MEDIA_QUERY': 13
};
html4[ 'atype' ] = html4.atype;
html4.ATTRIBS = {
  '*::class': 9,
  '*::dir': 0,
  '*::draggable': 0,
  '*::hidden': 0,
  '*::id': 4,
  '*::inert': 0,
  '*::itemprop': 0,
  '*::itemref': 6,
  '*::itemscope': 0,
  '*::lang': 0,
  '*::onblur': 2,
  '*::onchange': 2,
  '*::onclick': 2,
  '*::ondblclick': 2,
  '*::onfocus': 2,
  '*::onkeydown': 2,
  '*::onkeypress': 2,
  '*::onkeyup': 2,
  '*::onload': 2,
  '*::onmousedown': 2,
  '*::onmousemove': 2,
  '*::onmouseout': 2,
  '*::onmouseover': 2,
  '*::onmouseup': 2,
  '*::onreset': 2,
  '*::onscroll': 2,
  '*::onselect': 2,
  '*::onsubmit': 2,
  '*::onunload': 2,
  '*::spellcheck': 0,
  '*::style': 3,
  '*::title': 0,
  '*::translate': 0,
  'a::accesskey': 0,
  'a::coords': 0,
  'a::href': 1,
  'a::hreflang': 0,
  'a::name': 7,
  'a::onblur': 2,
  'a::onfocus': 2,
  'a::shape': 0,
  'a::tabindex': 0,
  'a::target': 10,
  'a::type': 0,
  'area::accesskey': 0,
  'area::alt': 0,
  'area::coords': 0,
  'area::href': 1,
  'area::nohref': 0,
  'area::onblur': 2,
  'area::onfocus': 2,
  'area::shape': 0,
  'area::tabindex': 0,
  'area::target': 10,
  'audio::controls': 0,
  'audio::loop': 0,
  'audio::mediagroup': 5,
  'audio::muted': 0,
  'audio::preload': 0,
  'bdo::dir': 0,
  'blockquote::cite': 1,
  'br::clear': 0,
  'button::accesskey': 0,
  'button::disabled': 0,
  'button::name': 8,
  'button::onblur': 2,
  'button::onfocus': 2,
  'button::tabindex': 0,
  'button::type': 0,
  'button::value': 0,
  'canvas::height': 0,
  'canvas::width': 0,
  'caption::align': 0,
  'col::align': 0,
  'col::char': 0,
  'col::charoff': 0,
  'col::span': 0,
  'col::valign': 0,
  'col::width': 0,
  'colgroup::align': 0,
  'colgroup::char': 0,
  'colgroup::charoff': 0,
  'colgroup::span': 0,
  'colgroup::valign': 0,
  'colgroup::width': 0,
  'command::checked': 0,
  'command::command': 5,
  'command::disabled': 0,
  'command::icon': 1,
  'command::label': 0,
  'command::radiogroup': 0,
  'command::type': 0,
  'data::value': 0,
  'del::cite': 1,
  'del::datetime': 0,
  'details::open': 0,
  'dir::compact': 0,
  'div::align': 0,
  'dl::compact': 0,
  'fieldset::disabled': 0,
  'font::color': 0,
  'font::face': 0,
  'font::size': 0,
  'form::accept': 0,
  'form::action': 1,
  'form::autocomplete': 0,
  'form::enctype': 0,
  'form::method': 0,
  'form::name': 7,
  'form::novalidate': 0,
  'form::onreset': 2,
  'form::onsubmit': 2,
  'form::target': 10,
  'h1::align': 0,
  'h2::align': 0,
  'h3::align': 0,
  'h4::align': 0,
  'h5::align': 0,
  'h6::align': 0,
  'hr::align': 0,
  'hr::noshade': 0,
  'hr::size': 0,
  'hr::width': 0,
  'iframe::align': 0,
  'iframe::frameborder': 0,
  'iframe::height': 0,
  'iframe::marginheight': 0,
  'iframe::marginwidth': 0,
  'iframe::width': 0,
  'img::align': 0,
  'img::alt': 0,
  'img::border': 0,
  'img::height': 0,
  'img::hspace': 0,
  'img::ismap': 0,
  'img::name': 7,
  'img::src': 1,
  'img::usemap': 11,
  'img::vspace': 0,
  'img::width': 0,
  'input::accept': 0,
  'input::accesskey': 0,
  'input::align': 0,
  'input::alt': 0,
  'input::autocomplete': 0,
  'input::checked': 0,
  'input::disabled': 0,
  'input::inputmode': 0,
  'input::ismap': 0,
  'input::list': 5,
  'input::max': 0,
  'input::maxlength': 0,
  'input::min': 0,
  'input::multiple': 0,
  'input::name': 8,
  'input::onblur': 2,
  'input::onchange': 2,
  'input::onfocus': 2,
  'input::onselect': 2,
  'input::placeholder': 0,
  'input::readonly': 0,
  'input::required': 0,
  'input::size': 0,
  'input::src': 1,
  'input::step': 0,
  'input::tabindex': 0,
  'input::type': 0,
  'input::usemap': 11,
  'input::value': 0,
  'ins::cite': 1,
  'ins::datetime': 0,
  'label::accesskey': 0,
  'label::for': 5,
  'label::onblur': 2,
  'label::onfocus': 2,
  'legend::accesskey': 0,
  'legend::align': 0,
  'li::type': 0,
  'li::value': 0,
  'map::name': 7,
  'menu::compact': 0,
  'menu::label': 0,
  'menu::type': 0,
  'meter::high': 0,
  'meter::low': 0,
  'meter::max': 0,
  'meter::min': 0,
  'meter::value': 0,
  'ol::compact': 0,
  'ol::reversed': 0,
  'ol::start': 0,
  'ol::type': 0,
  'optgroup::disabled': 0,
  'optgroup::label': 0,
  'option::disabled': 0,
  'option::label': 0,
  'option::selected': 0,
  'option::value': 0,
  'output::for': 6,
  'output::name': 8,
  'p::align': 0,
  'pre::width': 0,
  'progress::max': 0,
  'progress::min': 0,
  'progress::value': 0,
  'q::cite': 1,
  'select::autocomplete': 0,
  'select::disabled': 0,
  'select::multiple': 0,
  'select::name': 8,
  'select::onblur': 2,
  'select::onchange': 2,
  'select::onfocus': 2,
  'select::required': 0,
  'select::size': 0,
  'select::tabindex': 0,
  'source::type': 0,
  'table::align': 0,
  'table::bgcolor': 0,
  'table::border': 0,
  'table::cellpadding': 0,
  'table::cellspacing': 0,
  'table::frame': 0,
  'table::rules': 0,
  'table::summary': 0,
  'table::width': 0,
  'tbody::align': 0,
  'tbody::char': 0,
  'tbody::charoff': 0,
  'tbody::valign': 0,
  'td::abbr': 0,
  'td::align': 0,
  'td::axis': 0,
  'td::bgcolor': 0,
  'td::char': 0,
  'td::charoff': 0,
  'td::colspan': 0,
  'td::headers': 6,
  'td::height': 0,
  'td::nowrap': 0,
  'td::rowspan': 0,
  'td::scope': 0,
  'td::valign': 0,
  'td::width': 0,
  'textarea::accesskey': 0,
  'textarea::autocomplete': 0,
  'textarea::cols': 0,
  'textarea::disabled': 0,
  'textarea::inputmode': 0,
  'textarea::name': 8,
  'textarea::onblur': 2,
  'textarea::onchange': 2,
  'textarea::onfocus': 2,
  'textarea::onselect': 2,
  'textarea::placeholder': 0,
  'textarea::readonly': 0,
  'textarea::required': 0,
  'textarea::rows': 0,
  'textarea::tabindex': 0,
  'textarea::wrap': 0,
  'tfoot::align': 0,
  'tfoot::char': 0,
  'tfoot::charoff': 0,
  'tfoot::valign': 0,
  'th::abbr': 0,
  'th::align': 0,
  'th::axis': 0,
  'th::bgcolor': 0,
  'th::char': 0,
  'th::charoff': 0,
  'th::colspan': 0,
  'th::headers': 6,
  'th::height': 0,
  'th::nowrap': 0,
  'th::rowspan': 0,
  'th::scope': 0,
  'th::valign': 0,
  'th::width': 0,
  'thead::align': 0,
  'thead::char': 0,
  'thead::charoff': 0,
  'thead::valign': 0,
  'tr::align': 0,
  'tr::bgcolor': 0,
  'tr::char': 0,
  'tr::charoff': 0,
  'tr::valign': 0,
  'track::default': 0,
  'track::kind': 0,
  'track::label': 0,
  'track::srclang': 0,
  'ul::compact': 0,
  'ul::type': 0,
  'video::controls': 0,
  'video::height': 0,
  'video::loop': 0,
  'video::mediagroup': 5,
  'video::muted': 0,
  'video::poster': 1,
  'video::preload': 0,
  'video::width': 0
};
html4[ 'ATTRIBS' ] = html4.ATTRIBS;
html4.eflags = {
  'OPTIONAL_ENDTAG': 1,
  'EMPTY': 2,
  'CDATA': 4,
  'RCDATA': 8,
  'UNSAFE': 16,
  'FOLDABLE': 32,
  'SCRIPT': 64,
  'STYLE': 128,
  'VIRTUALIZED': 256
};
html4[ 'eflags' ] = html4.eflags;
// these are bitmasks of the eflags above.
html4.ELEMENTS = {
  'a': 0,
  'abbr': 0,
  'acronym': 0,
  'address': 0,
  'applet': 272,
  'area': 2,
  'article': 0,
  'aside': 0,
  'audio': 0,
  'b': 0,
  'base': 274,
  'basefont': 274,
  'bdi': 0,
  'bdo': 0,
  'big': 0,
  'blockquote': 0,
  'body': 305,
  'br': 2,
  'button': 0,
  'canvas': 0,
  'caption': 0,
  'center': 0,
  'cite': 0,
  'code': 0,
  'col': 2,
  'colgroup': 1,
  'command': 2,
  'data': 0,
  'datalist': 0,
  'dd': 1,
  'del': 0,
  'details': 0,
  'dfn': 0,
  'dialog': 272,
  'dir': 0,
  'div': 0,
  'dl': 0,
  'dt': 1,
  'em': 0,
  'fieldset': 0,
  'figcaption': 0,
  'figure': 0,
  'font': 0,
  'footer': 0,
  'form': 0,
  'frame': 274,
  'frameset': 272,
  'h1': 0,
  'h2': 0,
  'h3': 0,
  'h4': 0,
  'h5': 0,
  'h6': 0,
  'head': 305,
  'header': 0,
  'hgroup': 0,
  'hr': 2,
  'html': 305,
  'i': 0,
  'iframe': 16,
  'img': 2,
  'input': 2,
  'ins': 0,
  'isindex': 274,
  'kbd': 0,
  'keygen': 274,
  'label': 0,
  'legend': 0,
  'li': 1,
  'link': 274,
  'map': 0,
  'mark': 0,
  'menu': 0,
  'meta': 274,
  'meter': 0,
  'nav': 0,
  'nobr': 0,
  'noembed': 276,
  'noframes': 276,
  'noscript': 276,
  'object': 272,
  'ol': 0,
  'optgroup': 0,
  'option': 1,
  'output': 0,
  'p': 1,
  'param': 274,
  'pre': 0,
  'progress': 0,
  'q': 0,
  's': 0,
  'samp': 0,
  'script': 84,
  'section': 0,
  'select': 0,
  'small': 0,
  'source': 2,
  'span': 0,
  'strike': 0,
  'strong': 0,
  'style': 148,
  'sub': 0,
  'summary': 0,
  'sup': 0,
  'table': 0,
  'tbody': 1,
  'td': 1,
  'textarea': 8,
  'tfoot': 1,
  'th': 1,
  'thead': 1,
  'time': 0,
  'title': 280,
  'tr': 1,
  'track': 2,
  'tt': 0,
  'u': 0,
  'ul': 0,
  'var': 0,
  'video': 0,
  'wbr': 2
};
html4[ 'ELEMENTS' ] = html4.ELEMENTS;
html4.ELEMENT_DOM_INTERFACES = {
  'a': 'HTMLAnchorElement',
  'abbr': 'HTMLElement',
  'acronym': 'HTMLElement',
  'address': 'HTMLElement',
  'applet': 'HTMLAppletElement',
  'area': 'HTMLAreaElement',
  'article': 'HTMLElement',
  'aside': 'HTMLElement',
  'audio': 'HTMLAudioElement',
  'b': 'HTMLElement',
  'base': 'HTMLBaseElement',
  'basefont': 'HTMLBaseFontElement',
  'bdi': 'HTMLElement',
  'bdo': 'HTMLElement',
  'big': 'HTMLElement',
  'blockquote': 'HTMLQuoteElement',
  'body': 'HTMLBodyElement',
  'br': 'HTMLBRElement',
  'button': 'HTMLButtonElement',
  'canvas': 'HTMLCanvasElement',
  'caption': 'HTMLTableCaptionElement',
  'center': 'HTMLElement',
  'cite': 'HTMLElement',
  'code': 'HTMLElement',
  'col': 'HTMLTableColElement',
  'colgroup': 'HTMLTableColElement',
  'command': 'HTMLCommandElement',
  'data': 'HTMLElement',
  'datalist': 'HTMLDataListElement',
  'dd': 'HTMLElement',
  'del': 'HTMLModElement',
  'details': 'HTMLDetailsElement',
  'dfn': 'HTMLElement',
  'dialog': 'HTMLDialogElement',
  'dir': 'HTMLDirectoryElement',
  'div': 'HTMLDivElement',
  'dl': 'HTMLDListElement',
  'dt': 'HTMLElement',
  'em': 'HTMLElement',
  'fieldset': 'HTMLFieldSetElement',
  'figcaption': 'HTMLElement',
  'figure': 'HTMLElement',
  'font': 'HTMLFontElement',
  'footer': 'HTMLElement',
  'form': 'HTMLFormElement',
  'frame': 'HTMLFrameElement',
  'frameset': 'HTMLFrameSetElement',
  'h1': 'HTMLHeadingElement',
  'h2': 'HTMLHeadingElement',
  'h3': 'HTMLHeadingElement',
  'h4': 'HTMLHeadingElement',
  'h5': 'HTMLHeadingElement',
  'h6': 'HTMLHeadingElement',
  'head': 'HTMLHeadElement',
  'header': 'HTMLElement',
  'hgroup': 'HTMLElement',
  'hr': 'HTMLHRElement',
  'html': 'HTMLHtmlElement',
  'i': 'HTMLElement',
  'iframe': 'HTMLIFrameElement',
  'img': 'HTMLImageElement',
  'input': 'HTMLInputElement',
  'ins': 'HTMLModElement',
  'isindex': 'HTMLUnknownElement',
  'kbd': 'HTMLElement',
  'keygen': 'HTMLKeygenElement',
  'label': 'HTMLLabelElement',
  'legend': 'HTMLLegendElement',
  'li': 'HTMLLIElement',
  'link': 'HTMLLinkElement',
  'map': 'HTMLMapElement',
  'mark': 'HTMLElement',
  'menu': 'HTMLMenuElement',
  'meta': 'HTMLMetaElement',
  'meter': 'HTMLMeterElement',
  'nav': 'HTMLElement',
  'nobr': 'HTMLElement',
  'noembed': 'HTMLElement',
  'noframes': 'HTMLElement',
  'noscript': 'HTMLElement',
  'object': 'HTMLObjectElement',
  'ol': 'HTMLOListElement',
  'optgroup': 'HTMLOptGroupElement',
  'option': 'HTMLOptionElement',
  'output': 'HTMLOutputElement',
  'p': 'HTMLParagraphElement',
  'param': 'HTMLParamElement',
  'pre': 'HTMLPreElement',
  'progress': 'HTMLProgressElement',
  'q': 'HTMLQuoteElement',
  's': 'HTMLElement',
  'samp': 'HTMLElement',
  'script': 'HTMLScriptElement',
  'section': 'HTMLElement',
  'select': 'HTMLSelectElement',
  'small': 'HTMLElement',
  'source': 'HTMLSourceElement',
  'span': 'HTMLSpanElement',
  'strike': 'HTMLElement',
  'strong': 'HTMLElement',
  'style': 'HTMLStyleElement',
  'sub': 'HTMLElement',
  'summary': 'HTMLElement',
  'sup': 'HTMLElement',
  'table': 'HTMLTableElement',
  'tbody': 'HTMLTableSectionElement',
  'td': 'HTMLTableDataCellElement',
  'textarea': 'HTMLTextAreaElement',
  'tfoot': 'HTMLTableSectionElement',
  'th': 'HTMLTableHeaderCellElement',
  'thead': 'HTMLTableSectionElement',
  'time': 'HTMLTimeElement',
  'title': 'HTMLTitleElement',
  'tr': 'HTMLTableRowElement',
  'track': 'HTMLTrackElement',
  'tt': 'HTMLElement',
  'u': 'HTMLElement',
  'ul': 'HTMLUListElement',
  'var': 'HTMLElement',
  'video': 'HTMLVideoElement',
  'wbr': 'HTMLElement'
};
html4[ 'ELEMENT_DOM_INTERFACES' ] = html4.ELEMENT_DOM_INTERFACES;
html4.ueffects = {
  'NOT_LOADED': 0,
  'SAME_DOCUMENT': 1,
  'NEW_DOCUMENT': 2
};
html4[ 'ueffects' ] = html4.ueffects;
html4.URIEFFECTS = {
  'a::href': 2,
  'area::href': 2,
  'blockquote::cite': 0,
  'command::icon': 1,
  'del::cite': 0,
  'form::action': 2,
  'img::src': 1,
  'input::src': 1,
  'ins::cite': 0,
  'q::cite': 0,
  'video::poster': 1
};
html4[ 'URIEFFECTS' ] = html4.URIEFFECTS;
html4.ltypes = {
  'UNSANDBOXED': 2,
  'SANDBOXED': 1,
  'DATA': 0
};
html4[ 'ltypes' ] = html4.ltypes;
html4.LOADERTYPES = {
  'a::href': 2,
  'area::href': 2,
  'blockquote::cite': 2,
  'command::icon': 1,
  'del::cite': 2,
  'form::action': 2,
  'img::src': 1,
  'input::src': 1,
  'ins::cite': 2,
  'q::cite': 2,
  'video::poster': 1
};
html4[ 'LOADERTYPES' ] = html4.LOADERTYPES;

// Copyright (C) 2006 Google Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * @fileoverview
 * An HTML sanitizer that can satisfy a variety of security policies.
 *
 * <p>
 * The HTML sanitizer is built around a SAX parser and HTML element and
 * attributes schemas.
 *
 * If the cssparser is loaded, inline styles are sanitized using the
 * css property and value schemas.  Else they are remove during
 * sanitization.
 *
 * If it exists, uses parseCssDeclarations, sanitizeCssProperty,  cssSchema
 *
 * @author mikesamuel@gmail.com
 * @author jasvir@gmail.com
 * \@requires html4, URI
 * \@overrides window
 * \@provides html, html_sanitize
 */

// The Turkish i seems to be a non-issue, but abort in case it is.
if ('I'.toLowerCase() !== 'i') { throw 'I/i problem'; }

/**
 * \@namespace
 */
var html = (function(html4) {

  // For closure compiler
  var parseCssDeclarations, sanitizeCssProperty, cssSchema;
  if ('undefined' !== typeof window) {
    parseCssDeclarations = window['parseCssDeclarations'];
    sanitizeCssProperty = window['sanitizeCssProperty'];
    cssSchema = window['cssSchema'];
  }

  // The keys of this object must be 'quoted' or JSCompiler will mangle them!
  // This is a partial list -- lookupEntity() uses the host browser's parser
  // (when available) to implement full entity lookup.
  // Note that entities are in general case-sensitive; the uppercase ones are
  // explicitly defined by HTML5 (presumably as compatibility).
  var ENTITIES = {
    'lt': '<',
    'LT': '<',
    'gt': '>',
    'GT': '>',
    'amp': '&',
    'AMP': '&',
    'quot': '"',
    'apos': '\'',
    'nbsp': '\u00A0'
  };

  // Patterns for types of entity/character reference names.
  var decimalEscapeRe = /^#(\d+)$/;
  var hexEscapeRe = /^#x([0-9A-Fa-f]+)$/;
  // contains every entity per http://www.w3.org/TR/2011/WD-html5-20110113/named-character-references.html
  var safeEntityNameRe = /^[A-Za-z][A-za-z0-9]+$/;
  // Used as a hook to invoke the browser's entity parsing. <textarea> is used
  // because its content is parsed for entities but not tags.
  // TODO(kpreid): This retrieval is a kludge and leads to silent loss of
  // functionality if the document isn't available.
  var entityLookupElement =
      ('undefined' !== typeof window && window['document'])
          ? window['document'].createElement('textarea') : null;
  /**
   * Decodes an HTML entity.
   *
   * {\@updoc
   * $ lookupEntity('lt')
   * # '<'
   * $ lookupEntity('GT')
   * # '>'
   * $ lookupEntity('amp')
   * # '&'
   * $ lookupEntity('nbsp')
   * # '\xA0'
   * $ lookupEntity('apos')
   * # "'"
   * $ lookupEntity('quot')
   * # '"'
   * $ lookupEntity('#xa')
   * # '\n'
   * $ lookupEntity('#10')
   * # '\n'
   * $ lookupEntity('#x0a')
   * # '\n'
   * $ lookupEntity('#010')
   * # '\n'
   * $ lookupEntity('#x00A')
   * # '\n'
   * $ lookupEntity('Pi')      // Known failure
   * # '\u03A0'
   * $ lookupEntity('pi')      // Known failure
   * # '\u03C0'
   * }
   *
   * @param {string} name the content between the '&' and the ';'.
   * @return {string} a single unicode code-point as a string.
   */
  function lookupEntity(name) {
    // TODO: entity lookup as specified by HTML5 actually depends on the
    // presence of the ";".
    if (ENTITIES.hasOwnProperty(name)) { return ENTITIES[name]; }
    var m = name.match(decimalEscapeRe);
    if (m) {
      return String.fromCharCode(parseInt(m[1], 10));
    } else if (!!(m = name.match(hexEscapeRe))) {
      return String.fromCharCode(parseInt(m[1], 16));
    } else if (entityLookupElement && safeEntityNameRe.test(name)) {
      entityLookupElement.innerHTML = '&' + name + ';';
      var text = entityLookupElement.textContent;
      ENTITIES[name] = text;
      return text;
    } else {
      return '&' + name + ';';
    }
  }

  function decodeOneEntity(_, name) {
    return lookupEntity(name);
  }

  var nulRe = /\0/g;
  function stripNULs(s) {
    return s.replace(nulRe, '');
  }

  var ENTITY_RE_1 = /&(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/g;
  var ENTITY_RE_2 = /^(#[0-9]+|#[xX][0-9A-Fa-f]+|\w+);/;
  /**
   * The plain text of a chunk of HTML CDATA which possibly containing.
   *
   * {\@updoc
   * $ unescapeEntities('')
   * # ''
   * $ unescapeEntities('hello World!')
   * # 'hello World!'
   * $ unescapeEntities('1 &lt; 2 &amp;&AMP; 4 &gt; 3&#10;')
   * # '1 < 2 && 4 > 3\n'
   * $ unescapeEntities('&lt;&lt <- unfinished entity&gt;')
   * # '<&lt <- unfinished entity>'
   * $ unescapeEntities('/foo?bar=baz&copy=true')  // & often unescaped in URLS
   * # '/foo?bar=baz&copy=true'
   * $ unescapeEntities('pi=&pi;&#x3c0;, Pi=&Pi;\u03A0') // FIXME: known failure
   * # 'pi=\u03C0\u03c0, Pi=\u03A0\u03A0'
   * }
   *
   * @param {string} s a chunk of HTML CDATA.  It must not start or end inside
   *     an HTML entity.
   */
  function unescapeEntities(s) {
    return s.replace(ENTITY_RE_1, decodeOneEntity);
  }

  var ampRe = /&/g;
  var looseAmpRe = /&([^a-z#]|#(?:[^0-9x]|x(?:[^0-9a-f]|$)|$)|$)/gi;
  var ltRe = /[<]/g;
  var gtRe = />/g;
  var quotRe = /\"/g;

  /**
   * Escapes HTML special characters in attribute values.
   *
   * {\@updoc
   * $ escapeAttrib('')
   * # ''
   * $ escapeAttrib('"<<&==&>>"')  // Do not just escape the first occurrence.
   * # '&#34;&lt;&lt;&amp;&#61;&#61;&amp;&gt;&gt;&#34;'
   * $ escapeAttrib('Hello <World>!')
   * # 'Hello &lt;World&gt;!'
   * }
   */
  function escapeAttrib(s) {
    return ('' + s).replace(ampRe, '&amp;').replace(ltRe, '&lt;')
        .replace(gtRe, '&gt;').replace(quotRe, '&#34;');
  }

  /**
   * Escape entities in RCDATA that can be escaped without changing the meaning.
   * {\@updoc
   * $ normalizeRCData('1 < 2 &&amp; 3 > 4 &amp;& 5 &lt; 7&8')
   * # '1 &lt; 2 &amp;&amp; 3 &gt; 4 &amp;&amp; 5 &lt; 7&amp;8'
   * }
   */
  function normalizeRCData(rcdata) {
    return rcdata
        .replace(looseAmpRe, '&amp;$1')
        .replace(ltRe, '&lt;')
        .replace(gtRe, '&gt;');
  }

  // TODO(felix8a): validate sanitizer regexs against the HTML5 grammar at
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/syntax.html
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html
  // http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html

  // We initially split input so that potentially meaningful characters
  // like '<' and '>' are separate tokens, using a fast dumb process that
  // ignores quoting.  Then we walk that token stream, and when we see a
  // '<' that's the start of a tag, we use ATTR_RE to extract tag
  // attributes from the next token.  That token will never have a '>'
  // character.  However, it might have an unbalanced quote character, and
  // when we see that, we combine additional tokens to balance the quote.

  var ATTR_RE = new RegExp(
    '^\\s*' +
    '([-.:\\w]+)' +             // 1 = Attribute name
    '(?:' + (
      '\\s*(=)\\s*' +           // 2 = Is there a value?
      '(' + (                   // 3 = Attribute value
        // TODO(felix8a): maybe use backref to match quotes
        '(\")[^\"]*(\"|$)' +    // 4, 5 = Double-quoted string
        '|' +
        '(\')[^\']*(\'|$)' +    // 6, 7 = Single-quoted string
        '|' +
        // Positive lookahead to prevent interpretation of
        // <foo a= b=c> as <foo a='b=c'>
        // TODO(felix8a): might be able to drop this case
        '(?=[a-z][-\\w]*\\s*=)' +
        '|' +
        // Unquoted value that isn't an attribute name
        // (since we didn't match the positive lookahead above)
        '[^\"\'\\s]*' ) +
      ')' ) +
    ')?',
    'i');

  // false on IE<=8, true on most other browsers
  var splitWillCapture = ('a,b'.split(/(,)/).length === 3);

  // bitmask for tags with special parsing, like <script> and <textarea>
  var EFLAGS_TEXT = html4.eflags['CDATA'] | html4.eflags['RCDATA'];

  /**
   * Given a SAX-like event handler, produce a function that feeds those
   * events and a parameter to the event handler.
   *
   * The event handler has the form:{@code
   * {
   *   // Name is an upper-case HTML tag name.  Attribs is an array of
   *   // alternating upper-case attribute names, and attribute values.  The
   *   // attribs array is reused by the parser.  Param is the value passed to
   *   // the saxParser.
   *   startTag: function (name, attribs, param) { ... },
   *   endTag:   function (name, param) { ... },
   *   pcdata:   function (text, param) { ... },
   *   rcdata:   function (text, param) { ... },
   *   cdata:    function (text, param) { ... },
   *   startDoc: function (param) { ... },
   *   endDoc:   function (param) { ... }
   * }}
   *
   * @param {Object} handler a record containing event handlers.
   * @return {function(string, Object)} A function that takes a chunk of HTML
   *     and a parameter.  The parameter is passed on to the handler methods.
   */
  function makeSaxParser(handler) {
    // Accept quoted or unquoted keys (Closure compat)
    var hcopy = {
      cdata: handler.cdata || handler['cdata'],
      comment: handler.comment || handler['comment'],
      endDoc: handler.endDoc || handler['endDoc'],
      endTag: handler.endTag || handler['endTag'],
      pcdata: handler.pcdata || handler['pcdata'],
      rcdata: handler.rcdata || handler['rcdata'],
      startDoc: handler.startDoc || handler['startDoc'],
      startTag: handler.startTag || handler['startTag']
    };
    return function(htmlText, param) {
      return parse(htmlText, hcopy, param);
    };
  }

  // Parsing strategy is to split input into parts that might be lexically
  // meaningful (every ">" becomes a separate part), and then recombine
  // parts if we discover they're in a different context.

  // TODO(felix8a): Significant performance regressions from -legacy,
  // tested on
  //    Chrome 18.0
  //    Firefox 11.0
  //    IE 6, 7, 8, 9
  //    Opera 11.61
  //    Safari 5.1.3
  // Many of these are unusual patterns that are linearly slower and still
  // pretty fast (eg 1ms to 5ms), so not necessarily worth fixing.

  // TODO(felix8a): "<script> && && && ... <\/script>" is slower on all
  // browsers.  The hotspot is htmlSplit.

  // TODO(felix8a): "<p title='>>>>...'><\/p>" is slower on all browsers.
  // This is partly htmlSplit, but the hotspot is parseTagAndAttrs.

  // TODO(felix8a): "<a><\/a><a><\/a>..." is slower on IE9.
  // "<a>1<\/a><a>1<\/a>..." is faster, "<a><\/a>2<a><\/a>2..." is faster.

  // TODO(felix8a): "<p<p<p..." is slower on IE[6-8]

  var continuationMarker = {};
  function parse(htmlText, handler, param) {
    var m, p, tagName;
    var parts = htmlSplit(htmlText);
    var state = {
      noMoreGT: false,
      noMoreEndComments: false
    };
    parseCPS(handler, parts, 0, state, param);
  }

  function continuationMaker(h, parts, initial, state, param) {
    return function () {
      parseCPS(h, parts, initial, state, param);
    };
  }

  function parseCPS(h, parts, initial, state, param) {
    try {
      if (h.startDoc && initial == 0) { h.startDoc(param); }
      var m, p, tagName;
      for (var pos = initial, end = parts.length; pos < end;) {
        var current = parts[pos++];
        var next = parts[pos];
        switch (current) {
        case '&':
          if (ENTITY_RE_2.test(next)) {
            if (h.pcdata) {
              h.pcdata('&' + next, param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
            pos++;
          } else {
            if (h.pcdata) { h.pcdata("&amp;", param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '<\/':
          if (m = /^([-\w:]+)[^\'\"]*/.exec(next)) {
            if (m[0].length === next.length && parts[pos + 1] === '>') {
              // fast case, no attribute parsing needed
              pos += 2;
              tagName = m[1].toLowerCase();
              if (h.endTag) {
                h.endTag(tagName, param, continuationMarker,
                  continuationMaker(h, parts, pos, state, param));
              }
            } else {
              // slow case, need to parse attributes
              // TODO(felix8a): do we really care about misparsing this?
              pos = parseEndTag(
                parts, pos, h, param, continuationMarker, state);
            }
          } else {
            if (h.pcdata) {
              h.pcdata('&lt;/', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '<':
          if (m = /^([-\w:]+)\s*\/?/.exec(next)) {
            if (m[0].length === next.length && parts[pos + 1] === '>') {
              // fast case, no attribute parsing needed
              pos += 2;
              tagName = m[1].toLowerCase();
              if (h.startTag) {
                h.startTag(tagName, [], param, continuationMarker,
                  continuationMaker(h, parts, pos, state, param));
              }
              // tags like <script> and <textarea> have special parsing
              var eflags = html4.ELEMENTS[tagName];
              if (eflags & EFLAGS_TEXT) {
                var tag = { name: tagName, next: pos, eflags: eflags };
                pos = parseText(
                  parts, tag, h, param, continuationMarker, state);
              }
            } else {
              // slow case, need to parse attributes
              pos = parseStartTag(
                parts, pos, h, param, continuationMarker, state);
            }
          } else {
            if (h.pcdata) {
              h.pcdata('&lt;', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '<\!--':
          // The pathological case is n copies of '<\!--' without '-->', and
          // repeated failure to find '-->' is quadratic.  We avoid that by
          // remembering when search for '-->' fails.
          if (!state.noMoreEndComments) {
            // A comment <\!--x--> is split into three tokens:
            //   '<\!--', 'x--', '>'
            // We want to find the next '>' token that has a preceding '--'.
            // pos is at the 'x--'.
            for (p = pos + 1; p < end; p++) {
              if (parts[p] === '>' && /--$/.test(parts[p - 1])) { break; }
            }
            if (p < end) {
              if (h.comment) {
                var comment = parts.slice(pos, p).join('');
                h.comment(
                  comment.substr(0, comment.length - 2), param,
                  continuationMarker,
                  continuationMaker(h, parts, p + 1, state, param));
              }
              pos = p + 1;
            } else {
              state.noMoreEndComments = true;
            }
          }
          if (state.noMoreEndComments) {
            if (h.pcdata) {
              h.pcdata('&lt;!--', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '<\!':
          if (!/^\w/.test(next)) {
            if (h.pcdata) {
              h.pcdata('&lt;!', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          } else {
            // similar to noMoreEndComment logic
            if (!state.noMoreGT) {
              for (p = pos + 1; p < end; p++) {
                if (parts[p] === '>') { break; }
              }
              if (p < end) {
                pos = p + 1;
              } else {
                state.noMoreGT = true;
              }
            }
            if (state.noMoreGT) {
              if (h.pcdata) {
                h.pcdata('&lt;!', param, continuationMarker,
                  continuationMaker(h, parts, pos, state, param));
              }
            }
          }
          break;
        case '<?':
          // similar to noMoreEndComment logic
          if (!state.noMoreGT) {
            for (p = pos + 1; p < end; p++) {
              if (parts[p] === '>') { break; }
            }
            if (p < end) {
              pos = p + 1;
            } else {
              state.noMoreGT = true;
            }
          }
          if (state.noMoreGT) {
            if (h.pcdata) {
              h.pcdata('&lt;?', param, continuationMarker,
                continuationMaker(h, parts, pos, state, param));
            }
          }
          break;
        case '>':
          if (h.pcdata) {
            h.pcdata("&gt;", param, continuationMarker,
              continuationMaker(h, parts, pos, state, param));
          }
          break;
        case '':
          break;
        default:
          if (h.pcdata) {
            h.pcdata(current, param, continuationMarker,
              continuationMaker(h, parts, pos, state, param));
          }
          break;
        }
      }
      if (h.endDoc) { h.endDoc(param); }
    } catch (e) {
      if (e !== continuationMarker) { throw e; }
    }
  }

  // Split str into parts for the html parser.
  function htmlSplit(str) {
    // can't hoist this out of the function because of the re.exec loop.
    var re = /(<\/|<\!--|<[!?]|[&<>])/g;
    str += '';
    if (splitWillCapture) {
      return str.split(re);
    } else {
      var parts = [];
      var lastPos = 0;
      var m;
      while ((m = re.exec(str)) !== null) {
        parts.push(str.substring(lastPos, m.index));
        parts.push(m[0]);
        lastPos = m.index + m[0].length;
      }
      parts.push(str.substring(lastPos));
      return parts;
    }
  }

  function parseEndTag(parts, pos, h, param, continuationMarker, state) {
    var tag = parseTagAndAttrs(parts, pos);
    // drop unclosed tags
    if (!tag) { return parts.length; }
    if (h.endTag) {
      h.endTag(tag.name, param, continuationMarker,
        continuationMaker(h, parts, pos, state, param));
    }
    return tag.next;
  }

  function parseStartTag(parts, pos, h, param, continuationMarker, state) {
    var tag = parseTagAndAttrs(parts, pos);
    // drop unclosed tags
    if (!tag) { return parts.length; }
    if (h.startTag) {
      h.startTag(tag.name, tag.attrs, param, continuationMarker,
        continuationMaker(h, parts, tag.next, state, param));
    }
    // tags like <script> and <textarea> have special parsing
    if (tag.eflags & EFLAGS_TEXT) {
      return parseText(parts, tag, h, param, continuationMarker, state);
    } else {
      return tag.next;
    }
  }

  var endTagRe = {};

  // Tags like <script> and <textarea> are flagged as CDATA or RCDATA,
  // which means everything is text until we see the correct closing tag.
  function parseText(parts, tag, h, param, continuationMarker, state) {
    var end = parts.length;
    if (!endTagRe.hasOwnProperty(tag.name)) {
      endTagRe[tag.name] = new RegExp('^' + tag.name + '(?:[\\s\\/]|$)', 'i');
    }
    var re = endTagRe[tag.name];
    var first = tag.next;
    var p = tag.next + 1;
    for (; p < end; p++) {
      if (parts[p - 1] === '<\/' && re.test(parts[p])) { break; }
    }
    if (p < end) { p -= 1; }
    var buf = parts.slice(first, p).join('');
    if (tag.eflags & html4.eflags['CDATA']) {
      if (h.cdata) {
        h.cdata(buf, param, continuationMarker,
          continuationMaker(h, parts, p, state, param));
      }
    } else if (tag.eflags & html4.eflags['RCDATA']) {
      if (h.rcdata) {
        h.rcdata(normalizeRCData(buf), param, continuationMarker,
          continuationMaker(h, parts, p, state, param));
      }
    } else {
      throw new Error('bug');
    }
    return p;
  }

  // at this point, parts[pos-1] is either "<" or "<\/".
  function parseTagAndAttrs(parts, pos) {
    var m = /^([-\w:]+)/.exec(parts[pos]);
    var tag = {};
    tag.name = m[1].toLowerCase();
    tag.eflags = html4.ELEMENTS[tag.name];
    var buf = parts[pos].substr(m[0].length);
    // Find the next '>'.  We optimistically assume this '>' is not in a
    // quoted context, and further down we fix things up if it turns out to
    // be quoted.
    var p = pos + 1;
    var end = parts.length;
    for (; p < end; p++) {
      if (parts[p] === '>') { break; }
      buf += parts[p];
    }
    if (end <= p) { return void 0; }
    var attrs = [];
    while (buf !== '') {
      m = ATTR_RE.exec(buf);
      if (!m) {
        // No attribute found: skip garbage
        buf = buf.replace(/^[\s\S][^a-z\s]*/, '');

      } else if ((m[4] && !m[5]) || (m[6] && !m[7])) {
        // Unterminated quote: slurp to the next unquoted '>'
        var quote = m[4] || m[6];
        var sawQuote = false;
        var abuf = [buf, parts[p++]];
        for (; p < end; p++) {
          if (sawQuote) {
            if (parts[p] === '>') { break; }
          } else if (0 <= parts[p].indexOf(quote)) {
            sawQuote = true;
          }
          abuf.push(parts[p]);
        }
        // Slurp failed: lose the garbage
        if (end <= p) { break; }
        // Otherwise retry attribute parsing
        buf = abuf.join('');
        continue;

      } else {
        // We have an attribute
        var aName = m[1].toLowerCase();
        var aValue = m[2] ? decodeValue(m[3]) : '';
        attrs.push(aName, aValue);
        buf = buf.substr(m[0].length);
      }
    }
    tag.attrs = attrs;
    tag.next = p + 1;
    return tag;
  }

  function decodeValue(v) {
    var q = v.charCodeAt(0);
    if (q === 0x22 || q === 0x27) { // " or '
      v = v.substr(1, v.length - 2);
    }
    return unescapeEntities(stripNULs(v));
  }

  /**
   * Returns a function that strips unsafe tags and attributes from html.
   * @param {function(string, Array.<string>): ?Array.<string>} tagPolicy
   *     A function that takes (tagName, attribs[]), where tagName is a key in
   *     html4.ELEMENTS and attribs is an array of alternating attribute names
   *     and values.  It should return a record (as follows), or null to delete
   *     the element.  It's okay for tagPolicy to modify the attribs array,
   *     but the same array is reused, so it should not be held between calls.
   *     Record keys:
   *        attribs: (required) Sanitized attributes array.
   *        tagName: Replacement tag name.
   * @return {function(string, Array)} A function that sanitizes a string of
   *     HTML and appends result strings to the second argument, an array.
   */
  function makeHtmlSanitizer(tagPolicy) {
    var stack;
    var ignoring;
    var emit = function (text, out) {
      if (!ignoring) { out.push(text); }
    };
    return makeSaxParser({
      'startDoc': function(_) {
        stack = [];
        ignoring = false;
      },
      'startTag': function(tagNameOrig, attribs, out) {
        if (ignoring) { return; }
        if (!html4.ELEMENTS.hasOwnProperty(tagNameOrig)) { return; }
        var eflagsOrig = html4.ELEMENTS[tagNameOrig];
        if (eflagsOrig & html4.eflags['FOLDABLE']) {
          return;
        }

        var decision = tagPolicy(tagNameOrig, attribs);
        if (!decision) {
          ignoring = !(eflagsOrig & html4.eflags['EMPTY']);
          return;
        } else if (typeof decision !== 'object') {
          throw new Error('tagPolicy did not return object (old API?)');
        }
        if ('attribs' in decision) {
          attribs = decision['attribs'];
        } else {
          throw new Error('tagPolicy gave no attribs');
        }
        var eflagsRep;
        var tagNameRep;
        if ('tagName' in decision) {
          tagNameRep = decision['tagName'];
          eflagsRep = html4.ELEMENTS[tagNameRep];
        } else {
          tagNameRep = tagNameOrig;
          eflagsRep = eflagsOrig;
        }
        // TODO(mikesamuel): relying on tagPolicy not to insert unsafe
        // attribute names.

        // If this is an optional-end-tag element and either this element or its
        // previous like sibling was rewritten, then insert a close tag to
        // preserve structure.
        if (eflagsOrig & html4.eflags['OPTIONAL_ENDTAG']) {
          var onStack = stack[stack.length - 1];
          if (onStack && onStack.orig === tagNameOrig &&
              (onStack.rep !== tagNameRep || tagNameOrig !== tagNameRep)) {
                out.push('<\/', onStack.rep, '>');
          }
        }

        if (!(eflagsOrig & html4.eflags['EMPTY'])) {
          stack.push({orig: tagNameOrig, rep: tagNameRep});
        }

        out.push('<', tagNameRep);
        for (var i = 0, n = attribs.length; i < n; i += 2) {
          var attribName = attribs[i],
              value = attribs[i + 1];
          if (value !== null && value !== void 0) {
            out.push(' ', attribName, '="', escapeAttrib(value), '"');
          }
        }
        out.push('>');

        if ((eflagsOrig & html4.eflags['EMPTY'])
            && !(eflagsRep & html4.eflags['EMPTY'])) {
          // replacement is non-empty, synthesize end tag
          out.push('<\/', tagNameRep, '>');
        }
      },
      'endTag': function(tagName, out) {
        if (ignoring) {
          ignoring = false;
          return;
        }
        if (!html4.ELEMENTS.hasOwnProperty(tagName)) { return; }
        var eflags = html4.ELEMENTS[tagName];
        if (!(eflags & (html4.eflags['EMPTY'] | html4.eflags['FOLDABLE']))) {
          var index;
          if (eflags & html4.eflags['OPTIONAL_ENDTAG']) {
            for (index = stack.length; --index >= 0;) {
              var stackElOrigTag = stack[index].orig;
              if (stackElOrigTag === tagName) { break; }
              if (!(html4.ELEMENTS[stackElOrigTag] &
                    html4.eflags['OPTIONAL_ENDTAG'])) {
                // Don't pop non optional end tags looking for a match.
                return;
              }
            }
          } else {
            for (index = stack.length; --index >= 0;) {
              if (stack[index].orig === tagName) { break; }
            }
          }
          if (index < 0) { return; }  // Not opened.
          for (var i = stack.length; --i > index;) {
            var stackElRepTag = stack[i].rep;
            if (!(html4.ELEMENTS[stackElRepTag] &
                  html4.eflags['OPTIONAL_ENDTAG'])) {
              out.push('<\/', stackElRepTag, '>');
            }
          }
          if (index < stack.length) {
            tagName = stack[index].rep;
          }
          stack.length = index;
          out.push('<\/', tagName, '>');
        }
      },
      'pcdata': emit,
      'rcdata': emit,
      'cdata': emit,
      'endDoc': function(out) {
        for (; stack.length; stack.length--) {
          out.push('<\/', stack[stack.length - 1].rep, '>');
        }
      }
    });
  }

  var ALLOWED_URI_SCHEMES = /^(?:https?|mailto|data)$/i;

  function safeUri(uri, effect, ltype, hints, naiveUriRewriter) {
    if (!naiveUriRewriter) { return null; }
    try {
      var parsed = URI.parse('' + uri);
      if (parsed) {
        if (!parsed.hasScheme() ||
            ALLOWED_URI_SCHEMES.test(parsed.getScheme())) {
          var safe = naiveUriRewriter(parsed, effect, ltype, hints);
          return safe ? safe.toString() : null;
        }
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  function log(logger, tagName, attribName, oldValue, newValue) {
    if (!attribName) {
      logger(tagName + " removed", {
        change: "removed",
        tagName: tagName
      });
    }
    if (oldValue !== newValue) {
      var changed = "changed";
      if (oldValue && !newValue) {
        changed = "removed";
      } else if (!oldValue && newValue)  {
        changed = "added";
      }
      logger(tagName + "." + attribName + " " + changed, {
        change: changed,
        tagName: tagName,
        attribName: attribName,
        oldValue: oldValue,
        newValue: newValue
      });
    }
  }

  function lookupAttribute(map, tagName, attribName) {
    var attribKey;
    attribKey = tagName + '::' + attribName;
    if (map.hasOwnProperty(attribKey)) {
      return map[attribKey];
    }
    attribKey = '*::' + attribName;
    if (map.hasOwnProperty(attribKey)) {
      return map[attribKey];
    }
    return void 0;
  }
  function getAttributeType(tagName, attribName) {
    return lookupAttribute(html4.ATTRIBS, tagName, attribName);
  }
  function getLoaderType(tagName, attribName) {
    return lookupAttribute(html4.LOADERTYPES, tagName, attribName);
  }
  function getUriEffect(tagName, attribName) {
    return lookupAttribute(html4.URIEFFECTS, tagName, attribName);
  }

  /**
   * Sanitizes attributes on an HTML tag.
   * @param {string} tagName An HTML tag name in lowercase.
   * @param {Array.<?string>} attribs An array of alternating names and values.
   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
   *     apply to URI attributes; it can return a new string value, or null to
   *     delete the attribute.  If unspecified, URI attributes are deleted.
   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
   *     to attributes containing HTML names, element IDs, and space-separated
   *     lists of classes; it can return a new string value, or null to delete
   *     the attribute.  If unspecified, these attributes are kept unchanged.
   * @return {Array.<?string>} The sanitized attributes as a list of alternating
   *     names and values, where a null value means to omit the attribute.
   */
  function sanitizeAttribs(tagName, attribs,
    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
    // TODO(felix8a): it's obnoxious that domado duplicates much of this
    // TODO(felix8a): maybe consistently enforce constraints like target=
    for (var i = 0; i < attribs.length; i += 2) {
      var attribName = attribs[i];
      var value = attribs[i + 1];
      var oldValue = value;
      var atype = null, attribKey;
      if ((attribKey = tagName + '::' + attribName,
           html4.ATTRIBS.hasOwnProperty(attribKey)) ||
          (attribKey = '*::' + attribName,
           html4.ATTRIBS.hasOwnProperty(attribKey))) {
        atype = html4.ATTRIBS[attribKey];
      }
      if (atype !== null) {
        switch (atype) {
          case html4.atype['NONE']: break;
          case html4.atype['SCRIPT']:
            value = null;
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          case html4.atype['STYLE']:
            if ('undefined' === typeof parseCssDeclarations) {
              value = null;
              if (opt_logger) {
                log(opt_logger, tagName, attribName, oldValue, value);
	      }
              break;
            }
            var sanitizedDeclarations = [];
            parseCssDeclarations(
                value,
                {
                  declaration: function (property, tokens) {
                    var normProp = property.toLowerCase();
                    var schema = cssSchema[normProp];
                    if (!schema) {
                      return;
                    }
                    sanitizeCssProperty(
                        normProp, schema, tokens,
                        opt_naiveUriRewriter
                        ? function (url) {
                            return safeUri(
                                url, html4.ueffects.SAME_DOCUMENT,
                                html4.ltypes.SANDBOXED,
                                {
                                  "TYPE": "CSS",
                                  "CSS_PROP": normProp
                                }, opt_naiveUriRewriter);
                          }
                        : null);
                    sanitizedDeclarations.push(property + ': ' + tokens.join(' '));
                  }
                });
            value = sanitizedDeclarations.length > 0 ?
              sanitizedDeclarations.join(' ; ') : null;
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          case html4.atype['ID']:
          case html4.atype['IDREF']:
          case html4.atype['IDREFS']:
          case html4.atype['GLOBAL_NAME']:
          case html4.atype['LOCAL_NAME']:
          case html4.atype['CLASSES']:
            value = opt_nmTokenPolicy ? opt_nmTokenPolicy(value) : value;
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          case html4.atype['URI']:
            value = safeUri(value,
              getUriEffect(tagName, attribName),
              getLoaderType(tagName, attribName),
              {
                "TYPE": "MARKUP",
                "XML_ATTR": attribName,
                "XML_TAG": tagName
              }, opt_naiveUriRewriter);
              if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          case html4.atype['URI_FRAGMENT']:
            if (value && '#' === value.charAt(0)) {
              value = value.substring(1);  // remove the leading '#'
              value = opt_nmTokenPolicy ? opt_nmTokenPolicy(value) : value;
              if (value !== null && value !== void 0) {
                value = '#' + value;  // restore the leading '#'
              }
            } else {
              value = null;
            }
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
          default:
            value = null;
            if (opt_logger) {
              log(opt_logger, tagName, attribName, oldValue, value);
            }
            break;
        }
      } else {
        value = null;
        if (opt_logger) {
          log(opt_logger, tagName, attribName, oldValue, value);
        }
      }
      attribs[i + 1] = value;
    }
    return attribs;
  }

  /**
   * Creates a tag policy that omits all tags marked UNSAFE in html4-defs.js
   * and applies the default attribute sanitizer with the supplied policy for
   * URI attributes and NMTOKEN attributes.
   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
   *     apply to URI attributes.  If not given, URI attributes are deleted.
   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
   *     to attributes containing HTML names, element IDs, and space-separated
   *     lists of classes.  If not given, such attributes are left unchanged.
   * @return {function(string, Array.<?string>)} A tagPolicy suitable for
   *     passing to html.sanitize.
   */
  function makeTagPolicy(
    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
    return function(tagName, attribs) {
      if (!(html4.ELEMENTS[tagName] & html4.eflags['UNSAFE'])) {
        return {
          'attribs': sanitizeAttribs(tagName, attribs,
            opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger)
        };
      } else {
        if (opt_logger) {
          log(opt_logger, tagName, undefined, undefined, undefined);
        }
      }
    };
  }

  /**
   * Sanitizes HTML tags and attributes according to a given policy.
   * @param {string} inputHtml The HTML to sanitize.
   * @param {function(string, Array.<?string>)} tagPolicy A function that
   *     decides which tags to accept and sanitizes their attributes (see
   *     makeHtmlSanitizer above for details).
   * @return {string} The sanitized HTML.
   */
  function sanitizeWithPolicy(inputHtml, tagPolicy) {
    var outputArray = [];
    makeHtmlSanitizer(tagPolicy)(inputHtml, outputArray);
    return outputArray.join('');
  }

  /**
   * Strips unsafe tags and attributes from HTML.
   * @param {string} inputHtml The HTML to sanitize.
   * @param {?function(?string): ?string} opt_naiveUriRewriter A transform to
   *     apply to URI attributes.  If not given, URI attributes are deleted.
   * @param {function(?string): ?string} opt_nmTokenPolicy A transform to apply
   *     to attributes containing HTML names, element IDs, and space-separated
   *     lists of classes.  If not given, such attributes are left unchanged.
   */
  function sanitize(inputHtml,
    opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger) {
    var tagPolicy = makeTagPolicy(
      opt_naiveUriRewriter, opt_nmTokenPolicy, opt_logger);
    return sanitizeWithPolicy(inputHtml, tagPolicy);
  }

  // Export both quoted and unquoted names for Closure linkage.
  var html = {};
  html.escapeAttrib = html['escapeAttrib'] = escapeAttrib;
  html.makeHtmlSanitizer = html['makeHtmlSanitizer'] = makeHtmlSanitizer;
  html.makeSaxParser = html['makeSaxParser'] = makeSaxParser;
  html.makeTagPolicy = html['makeTagPolicy'] = makeTagPolicy;
  html.normalizeRCData = html['normalizeRCData'] = normalizeRCData;
  html.sanitize = html['sanitize'] = sanitize;
  html.sanitizeAttribs = html['sanitizeAttribs'] = sanitizeAttribs;
  html.sanitizeWithPolicy = html['sanitizeWithPolicy'] = sanitizeWithPolicy;
  html.unescapeEntities = html['unescapeEntities'] = unescapeEntities;
  return html;
})(html4);

var html_sanitize = html['sanitize'];

// Loosen restrictions of Caja's
// html-sanitizer to allow for styling
html4.ATTRIBS['*::style'] = 0;
html4.ELEMENTS['style'] = 0;
html4.ATTRIBS['a::target'] = 0;
html4.ELEMENTS['video'] = 0;
html4.ATTRIBS['video::src'] = 0;
html4.ATTRIBS['video::poster'] = 0;
html4.ATTRIBS['video::controls'] = 0;
html4.ELEMENTS['audio'] = 0;
html4.ATTRIBS['audio::src'] = 0;
html4.ATTRIBS['video::autoplay'] = 0;
html4.ATTRIBS['video::controls'] = 0;

if (true) {
    module.exports = html_sanitize;
}



/***/ }),

/***/ "../node_modules/squid/dist/core/api.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Api = void 0;
exports.$getLatestCorrelationID = $getLatestCorrelationID;
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");
var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");
var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");
var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");
var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");
var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");
var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
 API
 ---

 This layer is responsible for handling api requests. It has a number of responsibilities:

 - Caching responses
 - Transparently returning data that has been preloaded into the initial page response
 - Instrumentation
 - Batching multiple api calls into a single http request
 - Handling multiple types of responses and dispatching to the correct handlers
 - Emitting loading events for all http calls
 */

_config.$meta.headers = _config.$meta.headers || {};
_config.$meta.headers['x-cookies'] = typeof _config.$meta.headers['x-cookies'] !== 'object' ? JSON.parse(_config.$meta.headers['x-cookies'] || '{}') : _config.$meta.headers['x-cookies'];

// Are we in 'cookies disabled' mode? (Do we need to keep a local store of cookies)
function cookiesEnabled() {
  return _util.$util.cookiesEnabled() && window.location.hostname.indexOf('.paypal.com') > -1;
}

// Cache for api responses, when cache: true
var cache = {};
var standardHeaders = {};
var latestCorrelationID = _config.$meta.correlationId;

// Window load promise
var windowLoad = _util.$util.memoize(function () {
  return _promise.$promise.resolver(function (resolve) {
    if (document.readyState === 'complete') {
      resolve();
    } else {
      window.addEventListener('load', resolve);
    }
  });
});

// Buffer for batch requests made within the same frame
var batchQueue = {};

// Backwards compat
window.pre = {};

// Transient cache resolvers
var transientCache = {};

// Transient cache resolvers
var transientCacheResolvers = {};

// Metabuilder
var metaBuilder;

// Add to transientCache
window.preload = function (method, url, data, name) {
  if (name) {
    window.pre[name] = {
      method: method,
      uri: url,
      res: data
    };
  }
  var key = method + ":" + url;
  var resolvers = transientCacheResolvers[key] || [];
  transientCache[key] = data;
  while (resolvers.length) {
    resolvers.pop().call();
  }
};

// Preload complete
var preloadComplete = false;
window.preloadComplete = function () {
  preloadComplete = true;
  Object.keys(transientCacheResolvers).forEach(function (key) {
    var resolvers = transientCacheResolvers[key] || [];
    while (resolvers.length) {
      resolvers.pop().call();
    }
  });
};
_logger.$logger.info(cookiesEnabled() ? 'cookies_enabled' : 'cookies_disabled');
var $Api = exports.$Api = _class.$Class.extend('$Api', {
  // Cache any GET responses indefinitely
  cache: false,
  // Http timeout for all requests
  timeout: 45000,
  // Default number of attempts on aborted requests and 500 server errors
  getAttempts: 3,
  postAttempts: 1,
  // POST on a resource with an action name myapi.action('foo') -> POST /my/api/foo
  action: function action(_action, options) {
    options.action = _action;
    return this.post(options);
  },
  // GET on a resource myapi.retrieve() -> GET /my/api
  retrieve: function retrieve(options) {
    options.method = 'get';
    return this.call(options);
  },
  // POST on a resource myapi.retrieve() -> POST /my/api
  post: function post(options) {
    options.method = 'post';
    return this.call(options);
  },
  // Generic handler for calling an api and dispatching requests to the right place
  call: function call(options) {
    var self = this;

    // Set up request options and params. `options` is an object which should contain everything
    // the request needs to run and handle the response

    options.api = this;
    options.uri = this.getURI(options.model, options.action);
    options.params = options.params || {};
    options.cache = options.cache || self.cache && options.method === 'get';
    options.name = this.buildAPIName(options);
    options.meta = this.buildMeta();
    options.transientError = options.transientError || false;
    options.cacheKey = _util.$util.buildURL(options.uri, options.params);
    _logger.$logger.info(options.name + '_call', {
      name: options.name,
      method: options.method,
      uri: options.uri
    });
    if (!options.silent) {
      _event.$event.emit('loading');
    }

    // Decide where to get the response
    return _promise.$promise.first([
    // If caching is enabled and we have the data in local cache, use the cache
    function () {
      if (options.cache && cache[options.cacheKey]) {
        return cache[options.cacheKey];
      }
    },
    // Otherwise if we have transient cache data for this api, we can use that
    function () {
      return _promise.$promise.providing(self.hasTransientCacheData(options), function () {
        // The reason we use self.attemptRequest here is so any errors in the cached response
        // can trigger the retry code path, as if it were a regular request
        return self.attemptRequest(options);
      });
    },
    // If we're in batch mode, queue up a batch request
    function () {
      if (options.batch) {
        return self.batchRequest(options);
      }
    },
    // Otherwise attempt a regular http request (at this point an http call is guaranteed)
    function () {
      return self.attemptRequest(options);
    }])["finally"](function () {
      if (!options.silent) {
        _event.$event.emit('loaded');
      }
    }).then(function (res) {
      // Cache the response if we need to
      if (options.cache) {
        cache[options.cacheKey] = res;
      }

      // Handle the response
      return self.handleResponse(res.data, options);
    }, function (err) {
      // $BatchShortCircuit will be thrown if:
      //
      // 1. batch api call B depends on api call A, but-
      // 2. api call A fails
      //
      // In which case we end up in a situation where had it been a regular chain of events,
      // api B would never have been called in the first place.
      //
      // One possibility here is to return $unresolved, which prevents the promise from ever
      // resolving, but this has the potential to cause a lot of difficulty debugging and strange
      // corner cases.
      //
      // Instead we opt to simply reject the promise, and not call any of the response handlers

      if (err instanceof _error.$BatchShortCircuit) {
        return _promise.$promise.reject(err);
      }

      // Otherwise, handle the error normally
      return self.handleErrorResponse(err, options);
    });
  },
  // Set up a batch request for processing in the next frame
  batchRequest: function batchRequest(options) {
    // Batch Requests are an optimization layer on top of regular api calls. The purpose of this
    // layer is to combine multiple atomic api calls into a single http request, without forcing
    // developers to create large orchestration layers on the client/server with cross-cutting concerns.
    //
    // This layer will queue up multiple requests made in the same frame whenever batch-mode is enabled,
    // attach them all to an http call to /api/batch/:name, then on the response it will dispatch each
    // individual api call to the correct handler.
    //
    // The way this is implemented is to place each response in the transient api cache, then to yield
    // control to the regular api request handler, which will handle instrumentation and retries

    // For quick dev-time feedback...
    _util.$util.assert(options.batch.name, 'Must define a "name" for batch request: ' + options.batch);
    _util.$util.assert(options.batch.id, 'Must define a "id" for batch request: ' + options.batch);
    var name = options.batch.name;
    var id = options.batch.id;

    // Add the batch request options to the batchQueue for processing on the next frame
    var batch = batchQueue[name] = batchQueue[name] || {};
    batch[id] = options;

    // Fire off a batch request. This will be debounced: calls in the same frame will be combined to one
    return this.buildBatchRequest(name).then(function (results) {
      // We get back a mapping of id->response, so we now extract the response for our api
      // call. If we have no response, we can assume the call was never made, and short circuit.
      return results[id].then(function (result) {
        return result || _promise.$promise.reject(new _error.$BatchShortCircuit());
      });
    });
  },
  // Process all of the accumulated batch api requests
  buildBatchRequest: _promise.$promise.debounce(function (name) {
    var self = this;
    var batch = batchQueue[name];
    var batchIds = _class.$Class.keys(batch);
    var batchData = {};
    var headers = {};
    delete batchQueue[name];

    // If we have just a single request, we can short-circuit and just hit that api

    if (batchIds.length === 1) {
      var batchId = batchIds[0];
      var opts = batch[batchId];
      var results = {};
      results[batchId] = opts.api.attemptRequest(opts);
      return results;
    }

    // Build the request to send to the server side. This is an mapping of id->request, each containing
    // the method, uri, data, and dependencies for each api.
    //
    // Specifying a dependency for an api essentially means the back-end will only
    // call api-B if api-A returns ack=success. Otherwise there will be no response for api B.

    _util.$util.forEach(batch, function (options, id) {
      batchData[id] = {
        method: options.method,
        uri: options.api.getURI(options.model, options.action, true),
        data: options.data,
        params: options.params,
        dependencies: options.batch.dependencies
      };
      _util.$util.extend(headers, options.headers);
    });

    // Unfortunate circular dependency... $Api depends on another api.
    //
    // $batchApi is subject to all of the same rules regarding retries, so if for some reason the server
    // does not respond the first time, our batch request can still get through.

    return $batchApi.action(name, {
      // eslint-disable-line no-use-before-define
      data: batchData,
      headers: headers
    }).then(function (res) {
      // The final response will be a mapping of id->response-promise.
      //
      // However, we do not treat this data as our final response. Instead, we simply use it to
      // prime our transient cache, then proceed to jump to our regular request handler. This will
      // take care of retries and instrumentation as if this were a regular request.
      //
      // Note that a retry for $batchApi is different to a retry for an individual api. If
      // an *individual* api call fails, we do not want to re-do the entire batch call; instead we
      // can just retry the individual api call.

      return self.handleBatchResponse(batch, res.data);
    });
  }),
  // Process the responses for all of the batch requests we sent to the server
  handleBatchResponse: function handleBatchResponse(batch, data) {
    var self = this;
    var promises = {};

    // Loop over each individual api response contained in the batch response, and process the result

    _util.$util.forEach(batch, function (options, id) {
      // Store each response promise so we can check and wait for api dependencies

      promises[id] = _promise.$promise.run(function () {
        // Check if all of the dependencies are present for our individual api call. To do this
        // we must wait until the dependent api call is entirely complete, including any retries.

        var depsPresent = _promise.$promise.every(options.batch.dependencies || [], function (depName) {
          if (!batch[depName]) {
            _logger.$logger.info('missing_batch_dependency', {
              dependency: depName,
              available: Object.keys(batch).join('|')
            });
          }
          return !batch[depName] || promises[depName].then(function (dependency) {
            return dependency && dependency.data && dependency.data.ack === 'success';
          });
        });

        // If our dependencies are present, we can continue, otherwise we are not interested in
        // the result of the individual api call - if its dependency is not present, it will not be.

        return _promise.$promise.providing(depsPresent, function () {
          // If there is data returned for the individual call, add it to the transient cache

          return _promise.$promise.providing(data[id], function (result) {
            var uri = options.api.getURI(options.model, options.action);
            uri = _util.$util.buildURL(uri, options.params);
            self.addTransientCacheData(options.method, uri, result);
          }).then(function () {
            // Regardless of whether or not there is data, we can now attempt the request.
            // This will either get the data from the transient cache, or make an http call,
            // and handle any retries that need to be made.

            return options.api.attemptRequest(options);
          });
        });
      });
    });
    return promises;
  },
  // Handle the request and any retries, using either the transient cache or http calls
  attemptRequest: function attemptRequest(options) {
    var self = this;
    var attempts = 1;
    if (_config.$config.enableCheckoutRetries) {
      // ui:enableCheckoutRetries=true
      attempts = options.method === 'get' ? this.getAttempts : this.postAttempts;
    }

    // We allow a certain number of attempts/retries for each api call
    return _promise.$promise.attempt(attempts, function (remaining) {
      // Query the transient cache
      return self.getTransientCacheResponse(options).then(function (res) {
        // If we can get a response from the transient cache, then use it
        if (res) {
          return res;
        }

        // Otherwise resort to making an http call
        return self.getHttpResponse(options);
      })['catch'](function (res) {
        // If our request was aborted without even a status code, force a single retry
        if ((!res || !res.status) && attempts === 1) {
          _logger.$logger.warn('api_retry_aborted', {
            method: options.method,
            uri: options.uri
          });
          return self.getHttpResponse(options);
        }
        return _promise.$promise.reject(res);
      })['catch'](function (res) {
        // If our request was 401 denied (probably due to a CSRF error), force a single retry
        if (res.status === 401) {
          _logger.$logger.warn('api_retry_401', {
            method: options.method,
            uri: options.uri
          });
          return self.getHttpResponse(options);
        }
        return _promise.$promise.reject(res);
      })['catch'](function (res) {
        // Set the correct response and ack for 401
        if (res.status === 401) {
          return {
            data: {
              ack: 'permission_denied'
            }
          };
        }

        // Setup to throw a TOO_MANY_REQUESTS contingency for 429 response from ratelimiter (velocityserv)
        if (res.status === 429) {
          return {
            data: {
              ack: 'contingency',
              contingency: 'TOO_MANY_REQUESTS'
            }
          };
        }

        // If we have any remaining retries, log and reject
        if (remaining) {
          _logger.$logger.warn('api_retry', {
            method: options.method,
            uri: options.uri
          });
          return _promise.$promise.reject(res);
        }

        // Otherwise reject the request with the appropriate error

        // We got ack=error in the response
        if (res && res.data && res.data.ack === 'error') {
          return _promise.$promise.reject(new _error.$ApiError('api_error', {
            // eslint-disable-line no-reserved-keys
            name: options.name,
            method: options.method,
            uri: options.uri,
            stack: res.data.stack,
            "transient": options.transientError
          }));
        }

        // We got a response error status
        else if (res && res.status) {
          return _promise.$promise.reject(new _error.$ApiError('response_status_' + res.status, {
            // eslint-disable-line no-reserved-keys
            uri: options.uri,
            "transient": options.transientError
          }));
        } else if (res && res.error) {
          return _promise.$promise.reject(new _error.$ApiError('request_' + res.error, {
            // eslint-disable-line no-reserved-keys
            uri: options.uri,
            "transient": options.transientError
          }));
        }

        // The request was aborted
        else {
          return _promise.$promise.reject(new _error.$ApiError('request_aborted', {
            // eslint-disable-line no-reserved-keys
            uri: options.uri,
            "transient": options.transientError
          }));
        }
      });
    });
  },
  // Get an api response via http
  getHttpResponse: function getHttpResponse(options) {
    var self = this;
    var startTime = _util.$util.now();
    var request = this.http(options);
    return request['finally'](function () {
      // Calculate the end-to-end duration of the request from the client's perspective
      options.duration = _util.$util.now() - startTime;
    })["catch"](function (res) {
      // Turn responses with an ack into a 'success' so it makes it to the standard handlers
      if (res && res.status && res.data && res.data.ack && res.data.ack !== 'error') {
        return res;
      }
      return _promise.$promise.reject(res);
    }).then(function (res) {
      self.saveResponseState(res);
      var loggerPayload = {
        name: options.name,
        method: options.method,
        uri: options.uri,
        server: res.data.server,
        time: options.duration,
        duration: options.duration,
        corrid: res && res.headers('Paypal-Debug-Id')
      };

      // In certain browsers we can match up this api call to the performance data from the browser
      if (window.performance && window.performance.getEntries) {
        _util.$util.forEach(window.performance.getEntries(), function (resource) {
          if (resource.name && resource.name.indexOf(options.uri) > -1) {
            _util.$util.extend(loggerPayload, resource);
          }
        });
      }
      _logger.$logger.info('api_response', loggerPayload);
      if (res && res.status) {
        _logger.$logger.info('http_response_' + res.status);
      }
      return res;
    }, function (res) {
      self.saveResponseState(res);
      if (res && res.status) {
        _logger.$logger.info('http_response_' + res.status, {
          corrid: res.headers('Paypal-Debug-Id'),
          referenceId: res.headers('X-Reference-Header') || undefined // To not serialize this data if not present
        });
      }
      return _promise.$promise.reject(res);
    });
  },
  setTransientCache: function setTransientCache(data) {
    throw new Error('NotImplemented');
  },
  // Get an individual api response from the transient cache, as an object
  getTransientCacheData: function getTransientCacheData(options, pop) {
    if (!_config.$config.enablePreload) {
      return _promise.$promise.resolve();
    }
    var preMethod = options.method.toLowerCase();
    var preUri = _util.$util.buildURL(options.uri, options.params);
    var key = preMethod + ":" + preUri;
    return _promise.$promise.resolver(function (resolve) {
      function res() {
        var data = transientCache[key];
        if (pop) {
          delete transientCache[key];
        }
        resolve(data);
      }
      if (transientCache[key] || document.readyState === 'complete' || preloadComplete) {
        return res();
      }
      transientCacheResolvers[key] = transientCacheResolvers[key] || [];
      transientCacheResolvers[key].push(res);
      windowLoad().then(res);
    });
  },
  // Check if the transient cache has the data for a particular api
  hasTransientCacheData: function hasTransientCacheData(options) {
    return this.getTransientCacheData(options, false).then(function (data) {
      return Boolean(data);
    });
  },
  // Add data to the transient cache
  addTransientCacheData: function addTransientCacheData(method, uri, data) {
    var key = method + ":" + uri;
    transientCache[key] = data;
  },
  // Get an individual api response from transient cache, as a res promise with the correct status code
  getTransientCacheResponse: function getTransientCacheResponse(options) {
    return this.getTransientCacheData(options, true).then(function (data) {
      // Preload data does not come with a response code, so massage it into a response promise
      if (data) {
        if (data.ack === 'error') {
          return _promise.$promise.reject({
            status: 500,
            data: data
          });
        } else if (data.ack === 'permission_denied') {
          return _promise.$promise.reject({
            status: 401,
            data: data
          });
        } else if (data.ack === 'contingency' || data.ack === 'validation_error') {
          return {
            status: 400,
            data: data
          };
        } else {
          return {
            status: 200,
            data: data
          };
        }
      }

      // Log a cache miss if we are currently in the first-page load
      else if (options.method === 'get' && !_loader.$loader.firstLoad() && !options.silent) {
        _logger.$logger.info('preload_cache_miss', {
          uri: options.uri
        });
      }
    });
  },
  getHeaders: function getHeaders(options) {
    if (!_config.$meta.headers['x-csrf-jwt'] && !_config.$meta.csrfJwt) {
      _logger.$logger.warn('missing_csrf_jwt');
    }
    var headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'x-csrf-jwt': _config.$meta.headers['x-csrf-jwt'] || _config.$meta.csrfJwt
    };
    _util.$util.extend(headers, standardHeaders);
    if (window.xprops && window.xprops.clientMetadataID) {
      headers['paypal-client-metadata-id'] = window.xprops.clientMetadataID;
    } else if (_util.$util.param('client-metadata-id')) {
      headers['paypal-client-metadata-id'] = _util.$util.param('client-metadata-id');
    }
    if (!cookiesEnabled()) {
      headers['x-cookies'] = JSON.stringify(_config.$meta.headers['x-cookies']);
    }
    if (options.headers) {
      _util.$util.extend(headers, options.headers);
    }
    return headers;
  },
  http: function http(options) {
    return this.httpJQuery(options);
  },
  /*
   // Raw http call
  httpAngular: function(options) {
       let request = {
          method: options.method,
          url: options.uri,
          data: {
              data: options.data,
              meta: options.meta
          },
          headers: this.getHeaders(options),
          params: options.params,
          requestType: 'json',
          responseType: 'json',
          timeout: this.timeout
      };
       if (options.method === 'get' && options.meta && Object.keys(options.meta).length) {
          request.params.meta = JSON.stringify(options.meta);
      }
       return $http(request);
  },
   */

  httpJQuery: function httpJQuery(options) {
    var request = {
      method: options.method,
      data: options.method === 'get' ? options.params : JSON.stringify({
        data: options.data,
        meta: options.meta || {}
      }),
      headers: this.getHeaders(options),
      timeout: this.timeout
    };
    if (options.method === 'post') {
      request.headers['Content-Type'] = 'application/json;charset=UTF-8';
    } else if (options.method === 'get') {
      request.data.meta = JSON.stringify(options.meta);
    }
    return _promise.$promise.resolver(function (resolve, reject) {
      function getRes(res, data) {
        return {
          status: res.status,
          data: data,
          headers: function headers(name) {
            return res.getResponseHeader(name);
          }
        };
      }
      request.success = function (data, status, res) {
        return resolve(getRes(res, data));
      };
      request.error = function (res) {
        if (res && res.status) {
          if (res.status >= 400) {
            return reject(getRes(res, res.responseJSON));
          } else {
            return resolve(getRes(res, res.responseJSON));
          }
        }
        return reject({
          status: 0,
          headers: _util.$util.noop,
          error: res && res.statusText
        });
      };
      _jquery["default"].ajax(options.uri, request);
    });
  },
  // Save cookies and jwt-csrf token from the response
  saveResponseState: function saveResponseState(res) {
    if (res.headers('x-csrf-jwt')) {
      _config.$meta.headers['x-csrf-jwt'] = res.headers('x-csrf-jwt');
      _config.$meta.csrfJwt = res.headers('x-csrf-jwt');
      _config.$meta.headers['x-csrf-jwt-hash'] = res.headers('x-csrf-jwt-hash');
    }
    if (res.headers('X-cookies')) {
      _config.$meta.headers['x-cookies-hash'] = res.headers('x-cookies-hash');

      // Extend local cookie jar of encrypted-cookie-name->encrypted-cookie-value with any new cookies
      _util.$util.extend(_config.$meta.headers['x-cookies'], JSON.parse(res.headers('X-cookies') || '{}'));
    }
    latestCorrelationID = res.headers('Paypal-Debug-Id') || latestCorrelationID;
  },
  // Dispatch the response to the correct handlers
  handleResponse: function handleResponse(res, options) {
    var loggerName = 'ui_' + options.name;
    var loggerPayload = {
      name: options.name,
      method: options.method,
      uri: options.uri,
      time: options.duration,
      duration: options.duration
    };

    // Here we dispatch the response to the correct handler based on the ack.
    //
    // ack=success     -> options.success()
    // ack=error       -> options.error()
    // ack=validation  -> options.validation()
    // ack=contingency -> options.contingencies[contingency]()
    //
    // Why do this rather than just rejecting the promise with a custom error?
    //
    // a) Angular promises have no `.catchType()`, so this saves us a lot of `instanceof` checks
    // b) Angular promises have no `.done()`, so callers can not assert that they have handled
    //    every error they want to. This is exacerbated by the fact that there is no single thread
    //    of execution on the front-end a la node, so we can't just call `.done()` at the very end :(
    //
    // This way, if somebody passes a handler, it will be called. Otherwise, an error will be thrown
    // and the global error handler will be invoked. The api responses are also given as promises.

    var resultModel = options.resultModel || options.model;

    /* jshint maxcomplexity: 17 */
    return _promise.$promise.call(function () {
      // If we are given a `resultModel`, we always extend it with `res.data`, no matter the ack

      if (res.data && resultModel) {
        if (resultModel.populate) {
          resultModel.populate(res.data);
        } else {
          _util.$util.extend(resultModel, res.data);
        }
      }
      if (res && res.ack === 'success' && resultModel && resultModel.fetchChildren) {
        return _promise.$promise.resolve(resultModel.fetchChildren()).then(function (children) {
          return _util.$util.extend(resultModel, children);
        });
      }
    }).then(function () {
      // eslint-disable-line max-statements

      // Handle each ack type, throw errors accordingly

      if (res.ack === 'success') {
        _logger.$logger.info(loggerName + '_success', loggerPayload);
        if (options.success) {
          if (options.success instanceof Function) {
            return options.success(res.data);
          }
          return options.success;
        }
        return res;
      }
      if (options.failSilently) {
        return;
      }
      if (res.ack === 'contingency') {
        _logger.$logger.info(loggerName + '_contingency', _util.$util.extend(loggerPayload, {
          contingency: res.contingency
        }));
        if (!res.contingency) {
          throw new _error.$ApiError('expected_contingency_name', {
            api: options.name
          });
        }
        var contingency = new _error.$Contingency(res.contingency, {
          // eslint-disable-line no-reserved-keys
          "transient": options.transientError
        });
        if (resultModel) {
          resultModel.errorData = res.errorData || {};
        }
        var handler = options.contingencies && (options.contingencies[contingency.message] || options.contingencies['DEFAULT']);
        _util.$util.extend(contingency, res.errorData);
        if (handler) {
          if (handler instanceof Function) {
            return handler(contingency.message, contingency);
          }
          return handler;
        }
        throw contingency;
      } else if (res.ack === 'validation') {
        _logger.$logger.info(loggerName + '_validation', _util.$util.extend(loggerPayload, {
          validation: res.validation
        }));
        if (options.validation) {
          return options.validation(res.validation);
        }
        throw new _error.$ApiError('validation', {
          // eslint-disable-line no-reserved-keys
          "transient": options.transientError
        });
      } else if (res.ack === 'permission_denied') {
        _logger.$logger.info(loggerName + '_denied', loggerPayload);
        var properties = {
          "transient": options.transientError
        };
        if (res.reason) {
          properties.reason = res.reason;
        }
        throw new _error.$Forbidden(options.uri + ': forbidden', properties);
      } else {
        _logger.$logger.info(loggerName + '_noack', loggerPayload);
        throw new _error.$ApiError('noack', {
          // eslint-disable-line no-reserved-keys
          "transient": options.transientError
        });
      }
    });
  },
  // Handle http error responses (ack=error or unhandled errors)
  handleErrorResponse: function handleErrorResponse(err, options) {
    return _promise.$promise.run(function () {
      // If the caller provides an error handler, let them handle it
      if (options.error) {
        return options.error(err);
      }

      // Otherwise we throw the error. Please not that this is NOT just rejecting the promise,
      // this will always end up in the global error handler due to how angular promises work.
      throw err;
    });
  },
  // Build the uri for the api call
  getURI: function getURI(model, action, relative) {
    var self = this;

    // build the uri as a seriest of segments
    var uri = [];
    uri.push(this.uri.replace(/\/:[\w\.]+\?/g, function (key) {
      // Add any *optional* dynamic keys from the model (/foo/:bar? -> /foo/{{model.bar}})

      key = key.slice(2);
      key = key.substring(0, key.length - 1);
      var component = model.get ? model.get(key) : model[key];
      if (!component) {
        return '';
      }
      return '/' + component;
    }).replace(/:[\w\.]+/g, function (key) {
      // Add any dynamic keys from the model (/foo/:bar -> /foo/{{model.bar}})

      key = key.slice(1);
      var component = model.get ? model.get(key) : model[key];
      if (!component) {
        throw new Error('Property "' + key + '" not found in model for: ' + self.uri);
      }
      return component;
    }));

    // Add the action, if provided (`foo.action('bar', {...})` -> /api/foo/bar
    if (action) {
      uri.push(action);
    }

    // Add the extension (e.g. for doing a GET on a .json resource)
    if (this.ext) {
      uri[uri.length - 1] += '.' + this.ext;
    }

    // Join the uri segments and strip any extra slashes
    uri = '/' + uri.join('/').replace(/\/{2,}/g, '/').replace(/^\//, '');

    // Add on the base uri, e.g. /webapps/hermes
    if (!relative) {
      uri = (this.baseURI || _config.$config.urls.baseUrl) + uri;
    }
    return uri;
  },
  // Attach meta data provided by the parent app
  buildMeta: function buildMeta() {
    if (metaBuilder) {
      return metaBuilder();
    }
  },
  // Build the name of the api for logging. /api/foo/bar -> api_foo_bar
  buildAPIName: function buildAPIName(options) {
    var self = this;
    var apiName = self.uri.replace(/^\/+/, '').
    // Remove leading '/'
    replace(/\//g, '_').
    // Replace remaining '/' with '_'
    replace(/\?(.*)/, '').
    // Remove everything after '?'
    replace(/[^a-zA-Z0-9_]/g, '');
    apiName = options.action ? apiName + '_' + options.action : apiName;
    apiName = apiName.charAt(0) === '_' ? apiName.slice(1) : apiName;
    return apiName;
  }
});
$Api.reopenClass({
  clearCache: function clearCache() {
    cache = {};
  }
});
$Api.registerMetaBuilder = function (builder) {
  metaBuilder = builder;
};
$Api.addHeader = function (name, value) {
  standardHeaders[name] = value;
};
var $batchApi = new $Api({
  uri: '/api/batch',
  postAttempts: 3
});
function $getLatestCorrelationID() {
  return latestCorrelationID;
}
angular.value("$Api", $Api);
angular.value("$getLatestCorrelationID", $getLatestCorrelationID);
_logger.$logger;
_event.$event;
_class.$Class;
_util.$util;
_promise.$promise;
_config.$config;
_config.$meta;
_error.$Contingency;
_error.$Forbidden;
_error.$ApiError;
_error.$BatchShortCircuit;
_loader.$loader;

/***/ }),

/***/ "../node_modules/squid/dist/core/class.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.$Class = void 0;
/*
 Class
 -----

 A class pattern, adding sugar on top of javascript prototypes

 ### Basic Usage

 let MyClass = Class.extend({
 foo: 'bar';
 });

 myInstance = new MyClass({
 hello: 'world'
 });

 console.log(myInstance.foo, myInstance.hello)

 In this example, `foo` becomes a property on `MyClass`'s prototype,
 and `hello` becomes a property on `myInstance`.

 ### Default Object Methods

 - `init()`: Called after the object is first instantiated, with all properties available

 - `get(<path>, <default>)`: Get an object an arbitrary number of levels deep, or return a default

 e.g. `myInstance.get('foo.bar.baz', 'some_default');`

 Default return value is undefined

 - `set(<path>, <value>)`: Set an object an arbitrary number of levels deep

 e.g. `myInstance.set('foo.bar.baz', 'some_value');`

 Error is thrown if no object is found to set the value on

 - `setProperties(<object>)`: Set all the properties from an object onto your object

 e.g. `myInstance.setProperties({foo: 'bar', hello: 'world'})`

 Can not be used with nested properties

 - `forEach(<callback>)`: Loop through the object and call callback(<key>, <value>) for each key/val pair

 */

// Object Create
// -------------
//
// Shim for Object.create, if it is not supported by our browser
//
// let myPrototype = {foo: 'bar'}
// let myObject = create(myPrototype)

// Create an empty anonymous constructor with no side effects, for re-use later
var EmptyConstructor = function EmptyConstructor() {}; // eslint-disable-line no-empty-function

var create = Object.create || function create(obj) {
  // Set a temporary prototype
  EmptyConstructor.prototype = obj;

  // Create an object using our temporary constructor/prototype
  var instance = new EmptyConstructor();

  // Reset the prototype for next time
  EmptyConstructor.prototype = null;

  // Return our new object, created without side effects
  return instance;
};
function _extend(obj, source) {
  if (!source) {
    return obj;
  }
  for (var key in source) {
    if (source.hasOwnProperty(key)) {
      obj[key] = source[key];
    }
  }
  return obj;
}

// Is Object
// ---------
//
// Check of a let is an object or not
//
// isobject({}) -> true
// isobject('foo') -> false

function isobject(obj) {
  return obj && typeof obj === 'object' && obj instanceof Object;
}

// Transpose properties
// -------------------------------------------------------------------
//
// Transpose properties from a list of objects onto a recipient object
//
// let recipient = {};
// transpose(recipient, [{a: 1, b: 2}, {c: 3}])
// recipient -> {a: 1, b: 2, c:3}

function transpose(recipient, args) {
  // Loop through all args
  for (var i = 0; i < args.length; i++) {
    var ob = args[i];

    // Ignore anything that is not an object
    if (!isobject(ob)) {
      continue;
    }

    // Loop through all keys in our object
    for (var key in ob) {
      // Ignore any prototypal properties
      if (!ob.hasOwnProperty(key)) {
        continue;
      }
      var item = ob[key];

      // Give the function a name
      if (item instanceof Function) {
        item.__name__ = key;
      }
      recipient[key] = item;
    }
  }
}

// Construct a Class
// -----------------
//
// This is the primary constructor for all $Class objects

function construct() {
  // eslint-disable-line no-unused-vars

  // Call any custom constructor;
  if (this.construct) {
    var ob = this.construct.apply(this, arguments);

    // If we get a new object back, return that to the user
    if (isobject(ob)) {
      return ob;
    }
  }

  // Load any provided properties directly onto the object
  transpose(this, arguments);

  // Initialize the object
  if (this.init) {
    this.init();
  }
}

// Reopen an object
// ----------------
//
// Add properties to the constructor's prototype
//
//     let Animal = $Class.extend();
//
//     Animal.reopen({
//       type: 'animal',
//     });
//
//     let cat = new Animal;
//     console.log(cat.type);
function reopen() {
  // Add some more properies to our prototype
  transpose(this.prototype, arguments);
  return this;
}

// Reopen a class
// --------------
//
// Add properties to the constructor. These will propogate through future extends
//
//     let Animal = $Class.extend();
//
//     Animal.reopenClass({
//       fromCache: function(id) {
//         return cache[id] || new this({id: id});
//       }
//     }
//
//     let cat = Animal.fromCache('cat_54');

function reopenClass() {
  // Add some more properies to our class
  transpose(this, arguments);

  // Add to __classmethods__
  transpose(this.__classmethods__, arguments);
  return this;
}
function isChild(Cls) {
  return Cls && Cls.prototype instanceof this;
}

// Generate a new class
// --------------------
//
// Generate a new constructor, with the specified name, and attach all static and prototypal methods

var id = 0;
function extend(name) {
  // eslint-disable-line max-statements
  var Cls;
  var className;
  var args;
  var argsLength;
  var startIndex;

  // Accept an optional class name
  if (typeof name === 'string') {
    // Guard against javascript injection
    if (!name.match(/^[\w$][\w\d]*$/)) {
      throw new Error('Class name can not include special characters: ' + name);
    }

    // Use the provided name and slice out the first argument
    className = name;
    argsLength = arguments.length && arguments.length - 1;
    startIndex = 1;
  } else {
    // Otherwise default to the parent name, or 'Object' if generating our first class
    className = this.name || 'Object';
    argsLength = arguments.length;
    startIndex = 0;
  }
  args = new Array(argsLength);
  for (var i = startIndex; i < arguments.length; i++) {
    args[i - startIndex] = arguments[i];
  }

  // Dynamically create our constructor with a custom name
  Cls = function Cls() {
    return construct.apply(this, arguments);
  };
  Object.defineProperty(Cls, 'name', {
    value: className,
    writable: false
  });

  // Store the class name for future reference
  Cls.__name__ = className;

  // Set up a classmethods object. These will be inherited through subsequent extend() calls
  Cls.__classmethods__ = {
    extend: extend,
    reopen: reopen,
    reopenClass: reopenClass,
    isChild: isChild
  };
  id += 1;
  Cls.id = id;

  // If we're being called on an existing class, e.g. Class.extend(), we should inherit from that class
  if (this && this !== window) {
    // Inherit everything from superclass prototype
    Cls.prototype = create(this.prototype);

    // Re-set the constructor, which is overwritten by create
    Cls.prototype.constructor = Cls;

    // Add a reference to the superclass prototype for super method calls
    Cls.prototype._super = this.prototype;

    // Inherit any class methods from the superclass
    _extend(Cls.__classmethods__, this.__classmethods__);
  }

  // Add the class methods to our existing class
  _extend(Cls, Cls.__classmethods__);

  // Load any provided properties onto the constructor's prototype
  transpose(Cls.prototype, args);

  // Temporary: allow access from console/debugger
  if (className.indexOf('$') === 0) {
    window[className] = Cls;
  } else {
    window['$' + className] = Cls;
  }
  return Cls;
}

// Multi-layer get
// ---------------
//
// Recursively gets a deep path from an object, returning a default value if any level is not found
//
// let obj = {bar: {baz: 1}}
// get(obj, 'bar.baz', 'default') -> 1
// get(obj, 'aaa.bbb', 'default') -> default

function _get(item, path, def) {
  if (!path) {
    return def;
  }
  path = path.split('.');

  // Loop through each section of our key path
  for (var i = 0; i < path.length; i++) {
    // If we have an object, we can get the key
    if (isobject(item)) {
      item = item[path[i]];
      // Otherwise, we should return the default (undefined if not provided)
    } else {
      return def;
    }
  }

  // If our final result is undefined, we should return the default
  return item === undefined ? def : item;
}

// Multi-layer set
// ---------------
//
// Recursively sets a deep path from an object
//
// let obj = {bar: {baz: 1}}
// set(obj, 'bar.baz', 2)
// obj.bar.baz -> 1

function _set(item, path, value) {
  path = path.split('.');

  // Loop through each section of our key path except the last
  for (var i = 0; i < path.length - 1; i++) {
    // Get the next item down
    item = item[path[i]];

    // If we have an object, we're good
    if (isobject(item)) {
      continue;
      // Otherwise, there's nothing to set our key on
    } else {
      throw new Error(path[i - 1] + '.' + path[i] + ' is not an object');
    }
  }

  // Do the set on the retrieved object with our value
  item[path[path.length - 1]] = value;
}

// Loop through object
// -------------------
//
// Loop an object and apply a function for each key/value
//
// let ob = {a: 1, b: 2, c: 3}
// each(ob, console.log) -> a 1  b 2  c 3

function each(ob, callback) {
  for (var key in ob) {
    if (ob.hasOwnProperty(key)) {
      callback.call(ob, key, ob[key]);
    }
  }
}

// Gey keys of object
// ------------------
//
// Shim for Object.keys if it does not already exist
//
// let ob = {a: 1, b: 2, c: 3}
// keys(ob) -> ['a', 'b', 'c']

function _keys(ob) {
  if (Object.keys) {
    return Object.keys(ob);
  }
  var result = [];
  for (var key in ob) {
    if (ob.hasOwnProperty(key)) {
      result.push(key);
    }
  }
  return result;
}

// Create a base class that can be inherited from
// ----------------------------------------------
//
// This is the public interface to the Class module.
// All classes with extend from Class and be provided with a set of base convenience methods.

var $Class = exports.$Class = extend('Class', {
  init: function init() {
    // Empty init class, so calls to _super can be safely made
  },
  get: function get(path, def) {
    return _get(this, path, def);
  },
  set: function set(path, value) {
    _set(this, path, value);
  },
  setProperties: function setProperties() {
    transpose(this, arguments);
  },
  forEach: function forEach(callback) {
    each(this, callback);
  },
  keys: function keys() {
    return _keys(this);
  }
});
$Class.get = _get;
$Class.set = _set;
$Class.keys = _keys;
angular.value("$Class", $Class);

/***/ }),

/***/ "../node_modules/squid/dist/core/config.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.$meta = exports.$cookies = exports.$config = void 0;
var $meta = exports.$meta = window.meta || {};
var $cookies = exports.$cookies = window.cookies || {};
var $config = exports.$config = window.config || {};
angular.value("$meta", $meta);
angular.value("$cookies", $cookies);
angular.value("$config", $config);

/***/ }),

/***/ "../node_modules/squid/dist/core/dom.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$dom = void 0;
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");
var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");
var $dom = exports.$dom = {
  elementReady: function elementReady(id) {
    return _promise.$promise.resolver(function (resolve, reject) {
      if (document.getElementById(id)) {
        return resolve();
      }
      var interval = setInterval(function () {
        if (document.getElementById(id)) {
          clearInterval(interval);
          return resolve();
        }
      }, 10);
      setTimeout(60000, reject);
    });
  },
  loadScript: function loadScript(name, src, timeout, attributes) {
    if (attributes === void 0) {
      attributes = {};
    }
    return _promise.$promise.resolver(function (resolve, reject) {
      var script = document.createElement('script');
      var loadTimeout;
      function clearScriptLoadTimeout() {
        if (loadTimeout) {
          clearTimeout(loadTimeout);
          loadTimeout = undefined;
        }
      }
      script.onload = function () {
        clearScriptLoadTimeout();
        setTimeout(resolve, 10);
      };

      // For Internet explorer 8 support
      script.onreadystatechange = function () {
        if (this.readyState === 'complete' || this.readyState === 'loaded') {
          clearScriptLoadTimeout();
          setTimeout(resolve, 10);
        }
      };
      script.onerror = function (event) {
        _logger.$logger.info('script_error', {
          script: src
        });
        return reject(new Error(name + '_loading_error'));
      };
      if (timeout) {
        loadTimeout = setTimeout(function () {
          _logger.$logger.info('script_load_timedout', {
            script: src
          });
          return reject(new Error(name + '_loading_timed_out'));
        }, timeout);
      }
      script.setAttribute('src', src);
      for (var _i = 0, _Object$keys = Object.keys(attributes); _i < _Object$keys.length; _i++) {
        var attribute = _Object$keys[_i];
        script.setAttribute(attribute, attributes[attribute]);
      }
      document.body.appendChild(script);
    });
  },
  cssReady: function cssReady(id) {
    var el = document.getElementById(id);
    return _promise.$promise.resolver(function (resolve, reject) {
      var timeout;
      var interval;
      function check() {
        _util.$util.forEach(document.styleSheets, function (stylesheet) {
          if (stylesheet.href === el.href) {
            clearInterval(interval);
            clearTimeout(timeout);
            resolve();
          }
        });
      }
      timeout = setTimeout(function () {
        clearInterval(interval);
        reject();
        throw new Error('css_loading_timed_out');
      }, 30000);
      interval = setInterval(check, 20);
      check();
    });
  }
};
angular.value("$dom", $dom);
_logger.$logger;
_promise.$promise;
_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShortCircuit = exports.$Forbidden = exports.$FallbackError = exports.$Error = exports.$Contingency = exports.$BatchShortCircuit = exports.$ApiError = void 0;
var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");
var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");
var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");
_util.$util.monkeyPatch(window, 'onerror', function (_ref, original) {
  var message = _ref[0],
    file = _ref[1],
    line = _ref[2],
    col = _ref[3],
    err = _ref[4];
  original();
  _event.$event.emit('$windowError', {
    message: message && (message.stack || message).toString(),
    file: file && file.toString(),
    line: line && line.toString(),
    col: col && col.toString(),
    stack: err && (err.stack || err).toString()
  });
});
var $Error = exports.$Error = _class.$Class.extend.call(Error, '$Error', {
  construct: function construct(err, properties) {
    if (err instanceof Error) {
      err = err.message;
    }
    if (properties) {
      _util.$util.extend(this, properties);
    }
    this.payload = properties;
    this.message = err;
  }
});
var $Contingency = exports.$Contingency = $Error.extend('$Contingency', {
  handle: function handle(handlers) {
    var handler = handlers[this.message] || handlers['DEFAULT'];
    if (handler) {
      var result = handler.call(this, this.message, this);
      if (typeof result !== 'undefined') {
        return result;
      }
      return true;
    }
  }
});
var $Forbidden = exports.$Forbidden = $Error.extend('$Forbidden');
var $ApiError = exports.$ApiError = $Error.extend('$ApiError');
var $FallbackError = exports.$FallbackError = $Error.extend('$FallbackError', {
  init: function init() {
    this.reason = this.reason || '';
    this.product = this.product || '';
    this.entryPoint = this.entryPoint || '';
  }
});

/**
 * $ShortCircuit should be thrown if you want to bypass the remainder of a promise chain, and you've already
 * done error handling for the rejection. It should be handled with a no-op in app's $exceptionHandler
 */
var $ShortCircuit = exports.$ShortCircuit = $Error.extend('$ShortCircuit');

// TO-BE-DEPRECATED: Use $ShortCircuit instead
var $BatchShortCircuit = exports.$BatchShortCircuit = $ShortCircuit;
angular.value("$Error", $Error);
angular.value("$Contingency", $Contingency);
angular.value("$Forbidden", $Forbidden);
angular.value("$ApiError", $ApiError);
angular.value("$FallbackError", $FallbackError);
angular.value("$ShortCircuit", $ShortCircuit);
angular.value("$BatchShortCircuit", $BatchShortCircuit);
_event.$event;
_class.$Class;
_util.$util;

/***/ }),

/***/ "../node_modules/squid/dist/core/event.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$event = void 0;
var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var handlers = {};
var customEventEmitter;
var $event = exports.$event = {
  use: function use(eventEmitter) {
    customEventEmitter = eventEmitter;
    for (var _i = 0, _Object$keys = Object.keys(handlers); _i < _Object$keys.length; _i++) {
      var eventName = _Object$keys[_i];
      if (handlers[eventName]) {
        for (var _iterator = _createForOfIteratorHelperLoose(handlers[eventName]), _step; !(_step = _iterator()).done;) {
          var handler = _step.value;
          customEventEmitter.on(eventName, handler);
        }
      }
    }
  },
  on: function on(eventName, method) {
    if (customEventEmitter) {
      return customEventEmitter.on(eventName, method);
    }
    handlers[eventName] = handlers[eventName] || [];
    handlers[eventName].push(method);
    var cancelled = false;
    function cancel() {
      if (!cancelled) {
        handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
        cancelled = true;
      }
    }
    cancel.cancel = cancel;
    return cancel;
  },
  once: function once(eventName, method) {
    if (customEventEmitter) {
      return customEventEmitter.once(eventName, method);
    }
    var listener = $event.on(eventName, function () {
      listener.cancel();
      return method.apply(this, arguments);
    });
    return listener;
  },
  emit: function emit(eventName) {
    if (customEventEmitter) {
      var _customEventEmitter;
      return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
    }
    var event = {
      preventDefault: function preventDefault() {
        event.defaultPrevented = true;
      }
    };
    if (handlers[eventName]) {
      for (var _iterator2 = _createForOfIteratorHelperLoose(Array.prototype.slice.apply(handlers[eventName])), _step2; !(_step2 = _iterator2()).done;) {
        var handler = _step2.value;
        handler.apply(this, [event].concat(Array.prototype.slice.call(arguments)));
      }
    }
    return event;
  },
  broadcast: function broadcast(eventName) {
    if (customEventEmitter) {
      var _customEventEmitter2;
      return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
    }
    return $event.emit.apply($event, arguments);
  },
  refCount: function refCount($scope, start, stop) {
    return _promise.$promise.resolver(function (resolve) {
      var count = 0;
      var cancelStartListener = $scope.$on(start, function (event, data) {
        count += 1;
      });
      var cancelStopListener = $scope.$on(stop, function (event, data) {
        setTimeout(function () {
          count -= 1;
          res(); // eslint-disable-line no-use-before-define
        }, 50);
      });
      function res() {
        if (!count) {
          if (cancelStartListener && cancelStopListener) {
            cancelStartListener();
            cancelStopListener();
          }
          return resolve();
        }
      }
      setTimeout(res, 50);
    });
  },
  compose: function compose(start, end, startAll, endAll, debounce) {
    if (debounce === void 0) {
      debounce = 0;
    }
    var count = 0;
    var active = false;
    $event.on(start, function () {
      if (!count) {
        setTimeout(function () {
          if (count && !active) {
            active = true;
            $event.emit(startAll);
          }
        }, debounce);
      }
      count += 1;
    });
    $event.on(end, function () {
      setTimeout(function () {
        count -= 1;
        if (!count && active) {
          active = false;
          $event.emit(endAll);
        }
      }, 0);
    });
    return {
      getCount: function getCount() {
        return count;
      },
      isActive: function isActive() {
        return Boolean(count);
      },
      reset: function reset() {
        count = 0;
      }
    };
  }
};
angular.value("$event", $event);
_promise.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/core/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _api = __webpack_require__("../node_modules/squid/dist/core/api.js");
Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _api[key]) return;
  exports[key] = _api[key];
});
var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");
Object.keys(_class).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _class[key]) return;
  exports[key] = _class[key];
});
var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");
Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _config[key]) return;
  exports[key] = _config[key];
});
var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");
Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _error[key]) return;
  exports[key] = _error[key];
});
var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");
Object.keys(_event).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _event[key]) return;
  exports[key] = _event[key];
});
var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");
Object.keys(_integration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _integration[key]) return;
  exports[key] = _integration[key];
});
var _model = __webpack_require__("../node_modules/squid/dist/core/model.js");
Object.keys(_model).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _model[key]) return;
  exports[key] = _model[key];
});
var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");
Object.keys(_promise).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _promise[key]) return;
  exports[key] = _promise[key];
});
var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");
Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _util[key]) return;
  exports[key] = _util[key];
});
var _loader = __webpack_require__("../node_modules/squid/dist/core/loader.js");
Object.keys(_loader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _loader[key]) return;
  exports[key] = _loader[key];
});
var _dom = __webpack_require__("../node_modules/squid/dist/core/dom.js");
Object.keys(_dom).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dom[key]) return;
  exports[key] = _dom[key];
});

/***/ }),

/***/ "../node_modules/squid/dist/core/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$integration = exports.$DEFAULT = exports.$CONTEXT = void 0;
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var $DEFAULT = exports.$DEFAULT = 'DEFAULT';
var $CONTEXT = exports.$CONTEXT = {
  // Full page checkout
  FULLPAGE: 'FULLPAGE',
  // Checkout in popup
  POPUP: 'POPUP',
  // Checkout in lightbox (iframe)
  LIGHTBOX: 'LIGHTBOX',
  // Web view
  WEBVIEW: 'WEBVIEW',
  // Native checkout
  NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};
var $integration = exports.$integration = {
  flow: $DEFAULT,
  init: function init(flow, config) {
    this.config = config || {};
    if (flow) {
      this.setFlow(flow);
    }
    this.setContext(this.getContext());
  },
  getContext: function getContext() {
    if (this.isIFrame()) {
      return $CONTEXT.LIGHTBOX;
    } else if (this.isPopup()) {
      return $CONTEXT.POPUP;
    } else {
      return $CONTEXT.FULLPAGE;
    }
  },
  isPopup: function isPopup() {
    return Boolean(window.opener);
  },
  isIFrame: function isIFrame() {
    return window.top !== window.self;
  },
  setContext: function setContext(context) {
    _logger.$logger.info("integration_context_" + context);
    this.context = context;
  },
  setFlow: function setFlow(flow) {
    _logger.$logger.info("integration_flow_" + flow);
    this.flow = flow;
  },
  is: function is(context, flow) {
    return this.isContext(context) && this.isFlow(flow);
  },
  isContext: function isContext(context) {
    return this.context === context;
  },
  isFlow: function isFlow(flow) {
    return this.flow === flow;
  },
  getConfig: function getConfig(key) {
    this.context = this.getContext();
    if (!this.config) {
      return;
    }
    if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(this.flow) && this.config[this.context][this.flow].hasOwnProperty(key)) {
      return this.config[this.context][this.flow][key];
    }
    if (this.config.hasOwnProperty(this.context) && this.config[this.context].hasOwnProperty(key)) {
      return this.config[this.context][key];
    }
    if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(this.flow) && this.config[$DEFAULT][this.flow].hasOwnProperty(key)) {
      return this.config[$DEFAULT][this.flow][key];
    }
    if (this.config.hasOwnProperty($DEFAULT) && this.config[$DEFAULT].hasOwnProperty(key)) {
      return this.config[$DEFAULT][key];
    }
  },
  error: function error(message) {
    return new Error("Integration error: " + this.context + " / " + this.flow + " :: " + message);
  }
};
angular.value("$DEFAULT", $DEFAULT);
angular.value("$CONTEXT", $CONTEXT);
angular.value("$integration", $integration);
_logger.$logger;

/***/ }),

/***/ "../node_modules/squid/dist/core/loader.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$loader = void 0;
var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");
var _firstLoad = false;
var loader = _event.$event.compose('loading', 'loaded', 'startLoad', 'allLoaded', 100);
var $loader = exports.$loader = {
  isLoading: function isLoading() {
    return Boolean(loader.getCount());
  },
  firstLoad: function firstLoad() {
    return _firstLoad;
  },
  reset: function reset() {
    loader.reset();
  }
};
_event.$event.on('allLoaded', function () {
  _firstLoad = true;
});
angular.value("$loader", $loader);
_event.$event;

/***/ }),

/***/ "../node_modules/squid/dist/core/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Model = void 0;
var _class = __webpack_require__("../node_modules/squid/dist/core/class.js");
var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");
var _promise = __webpack_require__("../node_modules/squid/dist/core/promise.js");
var $Model = exports.$Model = _class.$Class.extend('$Model', {
  init: function init() {
    if (this.keys().length) {
      this.onPopulate();
    }
    if (this.id) {
      var _cache = this.constructor._modelCache = this.constructor._modelCache || {};
      _cache[this.id] = this;
    }
    this.meta = {
      populated: false
    };
  },
  /**
   * Add the passed in properties to this Model.
   * Sets the meta.populated to true. This flag
   * can be used later to determine if the model is populated.
   * Calls onPopulate() in the end.
   */
  populate: function populate() {
    this.meta.populated = true;
    this.setProperties.apply(this, arguments);
    delete this.meta.invalidated;
    this.onPopulate();
    return this;
  },
  fetchChildren: function fetchChildren() {
    return _promise.$promise.resolve();
  },
  /**
   * Override this method, to execute any logic after model is populated.
   */
  onPopulate: function onPopulate() {// eslint-disable-line no-empty-function
  },
  /**
   * Override this method, to execute any logic after model is invalidated.
   */
  onInvalidate: function onInvalidate() {// eslint-disable-line no-empty-function
  },
  /**
   * Override this method to return a Mock instance. Must return a promise which resolves to model.
   */
  fetchMock: function fetchMock() {// eslint-disable-line no-empty-function
  },
  /**
   * Retrieves the model.
   *
   * If model is already populated just returns a promise which resolves to `this`
   * If there is a retriever for this model, then return the retreiver.
   * Else calls the api to retrieve the model.
   *
   * @param options
   * @returns {*}
   */
  retrieve: function retrieve(options) {
    var self = this;
    options = options || {};
    if (self.meta.populated) {
      if (options.success) {
        return _promise.$promise.resolve(options.success(self));
      }
      return _promise.$promise.resolve(this);
    }
    if (this.retriever) {
      return this.retriever;
    }
    if (!this.api) {
      throw new Error('Tried to populate a model with no api');
    }
    options.model = this;
    this.retriever = this.api.retrieve(options).then(function (res) {
      return self;
    })['finally'](function () {
      delete self.retriever;
    });
    return this.retriever;
  },
  /**
   * Calls a post on the api to save this model. Takes options as parameters.
   * options will passed down to api.post.
   *
   * @param options
   * @returns {*|HttpPromise}
   */
  save: function save(options) {
    options = options || {};
    options.model = this;
    options.data = options.data || this.serialize();
    return this.api.post(options);
  },
  /**
   * Calls Api.action to perform any action on the model.
   *
   * Takes action name and optional 'options' object as parameters.
   *
   * Ex: $CheckoutSession.actions('create', [options])
   *
   * @param action
   * @param options
   * @returns {*}
   */
  action: function action(_action, options) {
    options = options || {};
    options.model = this;
    return this.api.action(_action, options);
  },
  /**
   * Use this method to force a api call to get the data.
   *
   * @param options
   * @returns {*}
   */
  reload: function reload(options) {
    this.meta.populated = false;
    return this.retrieve(options);
  },
  stringify: function stringify() {
    return JSON.stringify(this, 2);
  },
  log: function log() {
    console.log(this.stringify());
  },
  serialize: function serialize() {// eslint-disable-line no-empty-function
  },
  /**
   * Invalidate the current model. Sets the meta.populated to false and sets meta.invalidated to true.
   */
  invalidate: function invalidate() {
    this.meta.populated = false;
    this.meta.invalidated = true;
    this.onInvalidate();
  },
  /**
   * Creates a new Class with properties from `child`. Then assigns `this` as parent to the new Class.
   *
   * @param Cls
   * @param child
   * @returns {*}
   */
  child: function child(Cls, _child) {
    if (!_child) {
      return;
    }
    return Cls.create(_child.id || this.id, {
      parent: this
    }).populate(_child);
  },
  /**
   *
   * @param Cls
   * @param children
   * @returns {*}
   */
  children: function children(Cls, _children) {
    var self = this;
    if (!_children) {
      return _children;
    }
    return _util.$util.map(_children, function (child) {
      return self.child(Cls, child);
    });
  }
});
var cache = {};
$Model.reopenClass({
  instance: function instance(id) {
    var modelCache = cache[this.id] = cache[this.id] || {};
    var instance = modelCache[id || 0] || this.create.apply(this, arguments);
    return instance;
  },
  retrieveInstance: function retrieveInstance() {
    return this.instance.apply(this, arguments).retrieve();
  },
  create: function create(id) {
    var modelCache = cache[this.id] = cache[this.id] || {};
    var instance = modelCache[id || 0] = new this({
      // eslint-disable-line new-cap
      id: id || 0
    });
    instance.setProperties.apply(instance, Array.prototype.slice.call(arguments, 1));
    return instance;
  },
  fetch: function fetch() {
    console.warn('Model.fetch is deprecated, please use Model.instance');
    return this.instance.apply(this, arguments);
  },
  clearCache: function clearCache() {
    cache = {};
  },
  /**
   * should invalidate all models where the invalidationKey is found truthy
   *
   * invalidationKey: key of type string to look for in a model
   * example: $Model.bulkInvalidate('invalidateOnLogout');
   */
  bulkInvalidate: function bulkInvalidate(invalidationKey) {
    if (!invalidationKey) {
      return;
    }
    _util.$util.forEach(cache, function (modelCache, key) {
      _util.$util.forEach(modelCache, function (modelInstance, instanceId) {
        if (modelInstance[invalidationKey]) {
          modelInstance.invalidate();
        }
      });
    });
  }
});
angular.value("$Model", $Model);
_class.$Class;
_util.$util;
_promise.$promise;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/core/promise.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$promise = $promise;
var _util = __webpack_require__("../node_modules/squid/dist/core/util.js");
var _error = __webpack_require__("../node_modules/squid/dist/core/error.js");
var Promise = window.Promise;
function $promise(obj) {
  return Promise.resolve(obj);
}
_util.$util.extend($promise, {
  use: function use(CustomPromise) {
    Promise = CustomPromise;
    if (!window.Promise) {
      window.Promise = CustomPromise;
    }
  },
  resolver: function resolver(method) {
    return new Promise(method);
  },
  resolve: function resolve(value) {
    return Promise.resolve(value);
  },
  reject: function reject(value) {
    return Promise.reject(value);
  },
  run: function run(method) {
    return Promise.resolve().then(method);
  },
  call: function call(method) {
    return Promise.resolve().then(method);
  },
  sequential: function sequential(methods) {
    var prom = Promise.resolve();
    _util.$util.forEach(methods, function (method) {
      prom = prom.then(method);
    });
    return prom;
  },
  sleep: function sleep(time) {
    return new Promise(function (resolve) {
      setTimeout(resolve, time);
    });
  },
  map: function map(items, method) {
    var promises;
    if (items instanceof Array) {
      promises = [];
    } else if (items instanceof Object) {
      promises = {};
    } else {
      return Promise.resolve();
    }
    return this.all(_util.$util.map(items, function (item, key) {
      promises[key] = Promise.resolve(item).then(function (result) {
        return method(result, key, promises);
      });
      return promises[key];
    }));
  },
  all: function all(items) {
    if (items instanceof Array) {
      return Promise.all(items);
    } else if (items instanceof Object) {
      return this.hash(items);
    }
    return Promise.resolve([]);
  },
  hash: function hash(obj) {
    var results = {};
    return Promise.all(_util.$util.map(obj, function (item, key) {
      return Promise.resolve(item).then(function (result) {
        results[key] = result;
      });
    })).then(function () {
      return results;
    });
  },
  extend: function extend(obj, hash) {
    return this.hash(hash || {}).then(function (data) {
      _util.$util.extend(obj, data);
    });
  },
  attempt: function attempt(attempts, method) {
    attempts -= 1;
    return Promise.resolve().then(function () {
      return method(attempts);
    })['catch'](function (err) {
      if (attempts) {
        return $promise.attempt(attempts, method);
      }
      return Promise.reject(err);
    });
  },
  debounce: function debounce(method, time) {
    var timeout;
    var resolvers = {};
    return function () {
      var self = this;
      var args = arguments;
      var key = JSON.stringify(args);
      resolvers[key] = resolvers[key] || [];
      return new Promise(function (resolve) {
        resolvers[key].push(resolve);
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          var result = method.apply(self, args);
          _util.$util.forEach(resolvers[key], function (resolver) {
            resolver(result);
          });
          delete resolvers[key];
        }, time);
      });
    };
  },
  every: function every(collection, handler) {
    return this.map(collection, function (item) {
      return handler(item);
    }).then(function (results) {
      return _util.$util.every(results);
    });
  },
  providing: function providing(condition, handler) {
    return Promise.resolve(condition).then(function (result) {
      if (result) {
        return handler(result);
      }
    });
  },
  until: function until(condition, pollTime, timeout, alwaysResolve) {
    return new Promise(function (resolve, reject) {
      if (condition()) {
        return resolve();
      }
      var interval = setInterval(function () {
        if (condition()) {
          clearInterval(interval);
          return resolve();
        }
      }, pollTime);
      if (timeout) {
        setTimeout(function () {
          clearInterval(interval);
          return alwaysResolve ? resolve() : reject();
        }, timeout);
      }
    });
  },
  first: function first(handlers) {
    var prom = $promise.resolve();
    var result;
    _util.$util.forEach(handlers, function (handler) {
      prom = prom.then(function () {
        return result || handler();
      }).then(function (handlerResult) {
        result = handlerResult;
        return result;
      });
    });
    return prom;
  },
  shortCircuit: function shortCircuit() {
    return $promise.reject(new _error.$ShortCircuit());
  }
});
angular.value("$promise", $promise);
_util.$util;
_error.$ShortCircuit;

/***/ }),

/***/ "../node_modules/squid/dist/core/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$dispatch = $dispatch;
exports.$experiment = $experiment;
exports.$getRedirectUrl = $getRedirectUrl;
exports.isUnsafeRedirect = exports.$util = exports.$unresolved = void 0;
var _event = __webpack_require__("../node_modules/squid/dist/core/event.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");
var _integration = __webpack_require__("../node_modules/squid/dist/core/integration.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var redirected = false;
var paramCache = {};
var blacklist = ['password', 'pr_password'];
var blacklistRegex = new RegExp("(" + blacklist.join('|') + ")=([^&]*)", 'g');
var sanitizeUrlForLogging = function sanitizeUrlForLogging(inputUrl) {
  return inputUrl.replace(blacklistRegex, function (match, key, value) {
    return key + "=**";
  });
};
var isUnsafeRedirect = exports.isUnsafeRedirect = function isUnsafeRedirect(url) {
  return url.toLowerCase().replace(/\s/g, '').indexOf('javascript:') !== -1;
}; // eslint-disable-line no-script-url

var $util = exports.$util = {
  forEach: function forEach(collection, method) {
    if (collection instanceof Array) {
      for (var i = 0; i < collection.length; i++) {
        method(collection[i], i);
      }
    } else if (collection instanceof Object) {
      for (var key in collection) {
        if (collection.hasOwnProperty(key)) {
          method(collection[key], key);
        }
      }
    }
  },
  idleTimeout: function idleTimeout(time) {
    setTimeout(function () {
      _logger.$logger.info('page_idle');
      $util.reload();
    }, time);
  },
  reload: function reload() {
    _logger.$logger.info('reload');
    _event.$event.emit('loading');
    location.reload();
  },
  /**
   * replace:
   * Insert URL params provided and reload the window
   * This does not find the param if it already exists in the URL. It will add it again
   * @param params {Object} param - Params to add as URL params
   */
  replace: function replace(params) {
    if (params) {
      // Note: This won't replace the
      var url = $util.buildURL(location.href.split('#')[0], params);
      url = "" + url + window.location.hash;
      _logger.$logger.info('replace', {
        url: url
      });
      _event.$event.emit('loading');
      location.replace(url);
    } else {
      $util.reload();
    }
  },
  /**
  * redirect:
  * Redirects user to the given Url with options for different redirect behaviours
  * @param params {String} url - redirect url
  * @param params {Object} options - Optional param can have flags effecting behaviour of redirect
  */
  redirect: function redirect(url, options) {
    // optional flag to allow an iframe to Bust out of iframe mode by setting window.top.location = window.location.href
    var frameBust = options && options.frameBust;

    // Optional flag for url to not show up in browsing history. Handles back button scenario from CAPE to HERMES
    var replace = options && options.replace;
    if (isUnsafeRedirect(url)) {
      // eslint-disable-line
      _logger.$logger.error('unsafe_redirect_url', {
        url: url
      });
      throw new Error('Unsafe redirect url: ' + url);
    }
    _logger.$logger.info('redirect', {
      url: sanitizeUrlForLogging(url)
    });
    _event.$event.on('$stateChangeStart', function (event) {
      if (_angular.$rootScope.allowStateChangeAfterRedirect) {
        // at this point flow redirected buyer to return url. The return url did not display any page.
        // So, the review page/xoon sign up page with spinner(processing) will not be cleared giving impression that PayPal is still processing
        // At this time, we redirect buyer to a generic message page indicating that PayPal's processing is finished
        _logger.$logger.info('allow_state_change_after_redirect');
        _event.$event.emit('loaded');
        return;
      }
      _logger.$logger.info('state_change_after_redirect');
      event.preventDefault();
    });
    function redir() {
      if (redirected) {
        _logger.$logger.info('redirected');
        return;
      }
      _logger.$logger.info('redir', {
        url: sanitizeUrlForLogging(url)
      });
      window.onunload = window.onbeforeunload = function () {}; // eslint-disable-line no-empty-function

      if (_integration.$integration.getConfig('REDIRECT_TOP') !== false || frameBust) {
        if (replace) {
          _logger.$logger.info('windowLocationReplace', {
            redirecTop: _integration.$integration.getConfig('REDIRECT_TOP'),
            frameBust: frameBust
          });
          window.top.location.replace(url);
        } else {
          _logger.$logger.info('windowTopLocation', {
            redirecTop: _integration.$integration.getConfig('REDIRECT_TOP'),
            frameBust: frameBust
          });
          window.top.location = url;
        }
      } else if (replace) {
        _logger.$logger.info('windowLocationReplace');
        window.location.replace(url);
      } else {
        _logger.$logger.info('windowLocation');
        window.location = url;
      }
      redirected = true;
    }
    _event.$event.emit('loading');
    _logger.$logger.flush().then(redir);
    setTimeout(redir, 500);
    _logger.$logger.done();
  },
  cookiesEnabled: function cookiesEnabled() {
    var cookiesEnabled;
    document.cookie = '_cookiecheck=1';
    cookiesEnabled = Boolean(document.cookie.indexOf('_cookiecheck') > -1);
    document.cookie = '_cookiecheck=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = '_cookiecheck; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    return cookiesEnabled;
  },
  storageEnabled: function storageEnabled(api) {
    try {
      window[api].setItem('__feature_test__', '0');
      window[api].removeItem('__feature_test__');
      return true;
    } catch (e) {
      return false;
    }
  },
  sessionStorageEnabled: function sessionStorageEnabled() {
    return this.storageEnabled('sessionStorage');
  },
  localStorageEnabled: function localStorageEnabled() {
    return this.storageEnabled('localStorage');
  },
  params: function params(string) {
    if (typeof string !== 'string') {
      string = this.queryString().slice(1);
    }
    var params = {};
    if (!string) {
      return params;
    }
    if (paramCache[string]) {
      return $util.extend({}, paramCache[string]);
    }
    $util.forEach(string.split('&'), function (pair) {
      pair = pair.split('=');
      if (pair[0]) {
        params[decodeURIComponent(pair[0])] = pair[1] && decodeURIComponent(pair[1]);
      }
    });
    paramCache[string] = params;
    return params;
  },
  queryString: function queryString() {
    if (window.location.search) {
      return window.location.search;
    } else {
      var string = window.location.href;
      var idx = string.indexOf('&');
      var rIdx = string.lastIndexOf('#');
      if (idx) {
        return '?' + string.substring(idx, rIdx >= 0 ? rIdx : string.length);
      }
    }
    return '';
  },
  queryStringSplice: function queryStringSplice(qs, insert, remove) {
    if (qs.indexOf('?') === 0) {
      qs = qs.slice(1);
    }
    var params = $util.extend(this.params(qs), insert);
    $util.forEach(remove, function (key) {
      delete params[key];
    });
    return '?' + this.paramToQueryString(params);
  },
  extend: function extend(obj, source) {
    if (!source) {
      return obj;
    }
    for (var key in source) {
      if (source.hasOwnProperty(key)) {
        obj[key] = source[key];
      }
    }
    return obj;
  },
  paramToQueryString: function paramToQueryString(params) {
    return this.filter(this.map(Object.keys(params).sort(), function (key) {
      if (!params[key]) {
        return;
      }
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    })).join('&');
  },
  param: function $param(name) {
    return this.params()[name];
  },
  hashParam: function hashParam(name) {
    return this.params(window.location.hash.slice(1))[name];
  },
  base64Decode: function base64Decode(encodedString) {
    return encodedString && window.atob(encodedString); // eslint-disable-line block-scoped-var,no-undef
  },
  base64Encode: function base64Encode(decodedString) {
    return decodedString && window.btoa(decodedString); // eslint-disable-line block-scoped-var,no-undef
  },
  /*
   * decodeAndParse :
   * 1 - Base64Decode
   * 2 - URI Decode
   * 3 - Split string into a nvp object
   * return obj
   */
  decodeAndParse: function decodeAndParse(encodedString) {
    if (encodedString) {
      return this.params(decodeURIComponent(this.base64Decode(encodedString)));
    }
  },
  assert: function $assert(value, message, payload) {
    if (!value) {
      throw new Error(message, payload || {});
    }
  },
  map: function $map(array, method) {
    array = array || [];
    var results;
    if (array instanceof Array) {
      results = [];
      $util.forEach(array, function () {
        results.push(method.apply(this, arguments));
      });
      return results;
    } else if (array instanceof Object) {
      results = {};
      $util.forEach(array, function (val, key) {
        results[key] = method.apply(this, arguments);
      });
      return results;
    } else {
      throw new Error('$util.map expects array or object');
    }
  },
  filter: function $filter(array, method) {
    method = method || Boolean;
    var results = [];
    $util.forEach(array, function (item) {
      if (method.apply(this, arguments)) {
        results.push(item);
      }
    });
    return results;
  },
  /**
   * Deprecated.
   *
   * If you have an array, use Array#find()
   * If you have an object, use the lodash or underscore .find() method
   *
   * @deprecated
   */
  find: function $find(array, method) {
    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
      _angular.$log.warn('deprecated_method: squid.$util.find() is deprecated, use Array#find, which we have polyfilled, or _.find() for Objects instead.');
    }
    if (!array) {
      return;
    }
    for (var i = 0; i < array.length; i++) {
      if (method(array[i])) {
        return array[i];
      }
    }
  },
  findIndex: function $find(array, method) {
    if (!array) {
      return;
    }
    for (var i = 0; i < array.length; i++) {
      if (method(array[i])) {
        return i;
      }
    }
  },
  range: function range(start, end) {
    if (!end) {
      end = start;
      start = 0;
    }
    var result = [];
    for (var i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  },
  pad: function $pad(string, n, _char) {
    n = n || 0;
    _char = _char || '0';
    var padding = Array(n + 1).join(_char.toString());
    return (padding + string).slice(-n);
  },
  /**
   * Deprecated.
   *
   * If you have an array, use Array#some() -- NOTE: Unlike Array#some(),
   * the return value of $util.some() isn't always a Boolean. It's return value
   * is whatever the passed callback returns. If you are using $util.some to
   * find an object in an array then you need to use $util.find instead of Array#some().
   * Ex:
   *      1. const preferredCard = $util.some(cardsArray, cards => card.isPreferred && card);
   *          preferredCard will be the preferred card object or undefined if there isn't a
   *          preferred card.
   *      2. const hasPreferred = cardsArray.some(cards => card.isPreferred && card);
   *          Taking the code from #1 and simply swapping out $util.some for Array#some()
   *          will result in a different return value, in this case the Boolean true if
   *          there is a preferred card, otherwise false. In this case, instead of using
   *          Array#some() you should use $util.find() (Array#find() isn't supported in IE9)
   *          as seen below:
   *         const preferredCard = $util.find(cardsArray, card => card.isPreferred);
   *
   * If you have an object, use the lodash or underscore .some() method
   *
   * @deprecated
   */
  some: function $some(array, method) {
    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
      _angular.$log.warn("deprecated_method: squid.$util.some() is deprecated, use Array#some (use $util.find() if you are using\n                        $util.some() to return someting other than a boolean) or lodash/underscore.some() instead.");
    }
    var result;
    $util.forEach(array, function (item, key) {
      if (!result) {
        result = method(item, key);
      }
    });
    return result;
  },
  /**
   * Deprecated.
   *
   * If you have an array, use Array#every()
   * If you have an object, use the lodash or underscore .every() method
   *
   * @deprecated
   */
  every: function $every(array, method) {
    if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
      _angular.$log.warn('deprecated_method: squid.$util.every() is deprecated, use Array#every, which we have polyfilled, or _.every() for Objects instead.');
    }
    method = method || Boolean;
    var result = true;
    $util.forEach(array, function (item) {
      if (!method(item)) {
        result = false;
      }
    });
    return result;
  },
  reduce: function $reduce(array, method, intial) {
    $util.forEach(array, function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      intial = method.apply(void 0, [intial].concat(args));
    });
    return intial;
  },
  isPopup: function isPopup() {
    return _integration.$integration.isPopup();
  },
  isIFrame: function isIFrame() {
    return _integration.$integration.isIFrame();
  },
  buildURL: function buildURL(url, params) {
    /*
     * Do NOT add a check for anchor cause this function is also used for building XO success / cancel urls.
     * These urls are defined by the merchants and can also contain urls like "abc.com#merchantanchor" and merchants
     * expect (!) the following outcome: abc.com#merchantanchor?paypalparam=2
     */
    this.assert(url, 'buildURL :: expected url');
    var paramKeys = Object.keys(params || {});
    if (JSON.stringify(params) === '{}') {
      return url;
    }
    if (!paramKeys.length) {
      return url;
    }
    if (url.indexOf('?') === -1) {
      url += '?';
    } else {
      url += '&';
    }
    url += this.paramToQueryString(params);
    return url;
  },
  paypalURL: function paypalURL(url, params) {
    url = 'https://' + (_config.$meta.stage ? _config.$meta.stage : window.location.host) + url;
    return this.buildURL(url, params);
  },
  override: function override(obj, methodName, handler) {
    var existing = obj[methodName];
    obj[methodName] = function () {
      if (existing) {
        try {
          existing.apply(obj, arguments);
        } catch (err) {
          _logger.$logger.error(methodName + 'event_error', {
            error: err.toString
          });
        }
      }
      return handler.apply(obj, arguments);
    };
  },
  result: function result(method) {
    return method();
  },
  memoize: function memoize(method) {
    function memoized() {
      var key = JSON.stringify(arguments, function (_, value) {
        switch (typeof value) {
          case 'function':
            throw new Error('Cannot memoize functional arguments');
          case 'undefined':
            return 'undefined';
          default:
            return value;
        }
      });
      if (!memoized.cache.hasOwnProperty(key)) {
        memoized.cache[key] = method.apply(this, arguments);
      }
      return memoized.cache[key];
    }
    memoized.cache = {};
    memoized.flush = function () {
      memoized.cache = {};
    };
    return memoized;
  },
  now: function now() {
    return window.enablePerformance ? parseInt(window.performance.now(), 10) : Date.now();
  },
  bindObject: function bindObject(obj, self) {
    return $util.map(obj, function (method) {
      return method.bind(self);
    });
  },
  hashStr: function hashStr(str) {
    var hash = 0;
    var i;
    var chr;
    var len;
    if (str.length === 0) {
      return hash;
    }
    for (i = 0, len = str.length; i < len; i++) {
      chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise, no-extra-parens
      // Convert to 32bit integer
      hash |= 0; // eslint-disable-line no-bitwise
    }
    return Math.abs(hash);
  },
  hash: function hash() {
    return this.hashStr(Math.random());
  },
  popup: function popup(name, url, options, callback) {
    callback = $util.once(callback);
    var win = window.open(url, name, $util.map(Object.keys(options), function (key) {
      return key + "=" + options[key];
    }).join(', '));
    var interval;
    function checkWindowClosed() {
      if (win.closed) {
        clearInterval(interval);
        callback();
      }
    }
    interval = setInterval(checkWindowClosed, 50);
    setTimeout(checkWindowClosed);
    try {
      var close = win.close;
      win.close = function () {
        close.apply(this, arguments);
        checkWindowClosed();
      };
    } catch (err) {
      // pass
    }
    return win;
  },
  unique: function unique(collection) {
    return collection.filter(function (value, index, self) {
      return self.indexOf(value) === index;
    });
  },
  monkeyPatch: function monkeyPatch(mod, prop, method) {
    var original = mod[prop];
    mod[prop] = function () {
      var _arguments = arguments,
        _this = this;
      return method.call(this, arguments, function (self, args) {
        if (original) {
          return original.apply(self || _this, args || _arguments);
        }
      });
    };
  },
  once: function once(method) {
    var called = false;
    return function () {
      if (!called) {
        called = true;
        return method.apply(this, arguments);
      }
    };
  },
  camelToDasherize: function camelToDasherize(string) {
    return string.replace(/([A-Z])/g, function (g) {
      return '-' + g.toLowerCase();
    });
  },
  camelToCapsUnderscore: function camelToCapsUnderscore(string) {
    return string.replace(/([a-z][A-Z])/g, function (g) {
      return g[0] + '_' + g[1];
    }).toUpperCase();
  },
  dasherizeToCamel: function dasherizeToCamel(string) {
    return string.replace(/-([a-z])/g, function (g) {
      return g[1].toUpperCase();
    });
  },
  parentWindow: function parentWindow() {
    if (window.opener) {
      return window.opener;
    } else if (window.parent !== window) {
      return window.parent;
    }
  },
  hasRTL: function hasRTL(str) {
    return new RegExp("[\u0590-\u07BF]").test(str);
  },
  noop: function noop() {// eslint-disable-line no-empty-function
  },
  /**
   * @function isObject - tests to see if a passed argument is an Object. Returns `false`
   *      for anything that is 'object-like' but not an actual Object (Array, Set, Map, ect)
   *      as well as for `null` and `Object.create(null)`
   * @param {*} o
   * @returns {boolean}
   */
  isObject: function isObject(o) {
    var oAsString = Object.prototype.toString.call(o);
    return o instanceof Object && oAsString === '[object Object]';
  },
  /**
   * @function debounce
   * @param {function} callback
   * @param {number} time
   * @returns {function}
   */
  debounce: function debounce(callback, time) {
    var timeout;
    return function () {
      var _this2 = this;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var functionCall = function functionCall() {
        return callback.apply(_this2, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(functionCall, time);
    };
  },
  /**
   * @function getProperty
   * @param {object} obj
   * @param {string} propString
   * @param {string} splitOn
   * @returns {*}
   *
   * Ex:
   *  const obj = {
   *      a: {
   *          b: {
   *              c: 'property c'
   *          },
   *          'key.with.periods': 10
   *      }
   *  };
   *  const c = $util.getProperty(obj, 'a.b.c'); // c === 'property c'
   *  const f = $util.getProperty(obj, 'a.b.c.d.e.f'); // f === undefined
   *  const fDefault = $util.getProperty(
   *      obj,
   *      'a.b.c.d.e.f',
   *      { default: 'default value for f' }
   *  ); // f === 'default value for f'
   *  const n = $util.getProperty(obj, 'a,b,key.with.periods', { splitOn: ',' }); // n === 10
   */
  getProperty: function getProperty(obj, path, options) {
    if (path === void 0) {
      path = '';
    }
    if (options === void 0) {
      options = {};
    }
    var _options = options,
      _options$splitOn = _options.splitOn,
      splitOn = _options$splitOn === void 0 ? '.' : _options$splitOn,
      defaultValue = _options["default"];
    if (!this.isObject(obj) || typeof path !== 'string' || typeof splitOn !== 'string') {
      return;
    }
    var pathArray = path.split(splitOn);
    var prop = obj[pathArray.shift()];
    while (prop && pathArray.length && this.isObject(prop)) {
      prop = prop[pathArray.shift()];
    }
    return pathArray.length || prop === undefined ? defaultValue : prop;
  }
};
var $unresolved = exports.$unresolved = {
  then: $util.noop,
  'catch': $util.noop
};
function $getRedirectUrl(product, params) {
  var url = '';
  var urlParams = $util.params();
  if (_config.$config.deploy.isLocal() || _config.$config.deploy.isStage()) {
    url = _config.$config.urls.dispatch && _config.$config.urls.dispatch[product] || '';
  }
  url += _config.$config.urls.fallbackUrl[product];
  $util.extend(urlParams, params || {});

  // cmd is a reserved slingshot param
  if (urlParams.cmd) {
    delete urlParams.cmd;
  }
  return $util.buildURL(url, urlParams);
}
function $dispatch(product, params, stateChange) {
  $util.assert(product, 'expected product');
  _logger.$logger.log('info', 'dispatch', {
    product: product
  });
  _event.$event.emit('loading');
  var url = '';
  url = $getRedirectUrl(product, params);

  // fire an event for xo-tracking to listen to and do fpti logging
  if (stateChange) {
    _event.$event.emit('page_loaded', stateChange.fromState, stateChange.toState);
  }
  return $util.redirect(url);
}
function $experiment(name, sample, id, loggerPayload) {
  var throttle = $util.hashStr(name + '_' + id) % 100;
  var group;
  if ($util.param(name) === 'true') {
    group = 'test_forced';
  } else if ($util.param(name) === 'false') {
    group = 'control_forced';
  } else if (throttle < sample) {
    group = 'test';
  } else if (sample >= 50 || sample <= throttle && throttle < sample * 2) {
    // eslint-disable-line no-extra-parens
    group = 'control';
  } else {
    group = 'throttle';
  }
  _logger.$logger.info('fpti_pxp_check', {
    from: 'PXP_CHECK',
    to: 'process_pxp_check',
    pxp_exp_id: name,
    pxp_trtmnt_id: group
  });
  _logger.$logger.info(name + '_' + group, loggerPayload || {});
  if (group === 'test' || group === 'test_forced') {
    return true;
  } else if (group === 'control') {
    return false;
  }
}
angular.value("isUnsafeRedirect", isUnsafeRedirect);
angular.value("$util", $util);
angular.value("$unresolved", $unresolved);
angular.value("$getRedirectUrl", $getRedirectUrl);
angular.value("$dispatch", $dispatch);
angular.value("$experiment", $experiment);
_event.$event;
_logger.$logger;
_config.$config;
_config.$meta;
_integration.$integration;
_angular.$log;
_angular.$rootScope;

/***/ }),

/***/ "../node_modules/squid/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _ng = __webpack_require__("../node_modules/squid/dist/ng/index.js");
Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ng[key]) return;
  exports[key] = _ng[key];
});
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _core[key]) return;
  exports[key] = _core[key];
});
var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");
Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _locale[key]) return;
  exports[key] = _locale[key];
});
var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");
Object.keys(_paypal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _paypal[key]) return;
  exports[key] = _paypal[key];
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/currency.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatCurrency = formatCurrency;
exports.getCurrencySymbol = void 0;
exports.roundingAndSeparators = roundingAndSeparators;
exports.truncateCurrencyConversionString = void 0;
var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");
// everything to do with currency formatting

// quick Griffin reference on currency format:
// ¤ : Currency Symbol = $
// # : Amount = 186432.431
// C : Currency Code = USD

var ALL_NON_BREAKING_SPACE = new RegExp('\xa0+', 'g');
var CODE_IN_FRONT = new RegExp('^([^¤#]*)(C[\\s]*)(.*)$'); // matching groups: (any negative symbol)(code)(the rest)
var ENDS_IN_WHITESPACE = new RegExp('\s$');
var THOUSANDS_SPLITTER = /\B(?=(\d{3})+(?!\d))/g; // eslint-disable-line fasec/no-unsafe-regex
var HUNDREDS_SPLITTER = /(\d)(?=(\d\d)+\d$)/g; // eslint-disable-line fasec/no-unsafe-regex

// This seems to be the only currency / locale specific exception in Griffin
var STYLE_EXCEPTION = {
  'tr TR TRY': '# ¤;-# ¤'
};
var AmountOnlyStyle = '#;-#'; // A currency style for number only. $9USD -> 9.00

// Griffin exceptions for separators at hundreds- xx,xx,xxx format
var HUNDREDS_SEPARATOR_EXCEPTION = ['IN', 'BT', 'MV', 'NP'];
var isObject = function isObject(param) {
  return Object.prototype.toString.call(param) === '[object Object]';
};

// Griffin "fuzzy logic"
// apparently if the symbol is at least "66% similar" to the code, ignore it
function maybeIgnoreSymbol(style, symbol, code) {
  // THIS IS NOT COMMUTATIVE
  function fuzzyMatch(code, symbol) {
    // eslint-disable-line no-shadow
    if (code === symbol) {
      return 100;
    } else {
      var codeParts = code.split('');
      var symbolParts = symbol.split('');
      var equivalency = codeParts.reduce(function (equiv, codePart) {
        var symbolPos = symbolParts.indexOf(codePart);
        if (symbolPos !== -1) {
          symbolParts.splice(symbolPos, 1);
          return equiv + 1;
        }
        return equiv;
      }, 0);
      var weight = equivalency / codeParts.length;
      return weight * 100;
    }
  }
  var ignoreSymbol = symbol.length > 1 && fuzzyMatch(code, symbol) >= 66;
  return ignoreSymbol ? style.replace(/¤\s*/g, '') : style;
}

// deal with rounding due to truncation (Griffin rounds up) as well as dot/comma symbols
// and thousand separators
function roundingAndSeparators(amountString, _ref, _ref2) {
  var lang = _ref.lang,
    country = _ref.country;
  var decimalPlaces = _ref2.decimalPlaces,
    dot = _ref2.dot,
    comma = _ref2.comma;
  var value = parseFloat(amountString);
  var truncate = decimalPlaces === 0;
  var amountParts = truncate && !isNaN(value) ? Math.round(value).toString().split('.') : amountString.split('.');
  var exception = HUNDREDS_SEPARATOR_EXCEPTION.indexOf(country) > -1; // special exceptions
  var wholeString = exception ? amountParts[0].replace(HUNDREDS_SPLITTER, '$1,') : amountParts[0].replace(THOUSANDS_SPLITTER, comma);
  var decimalString = amountParts[1] || '00';
  return truncate ? wholeString : "" + wholeString + dot + decimalString;
}

// this is an agreement with UED for visual consistency - the currency code, if displayed, is always on the right
function forceCodeToRight(style) {
  var parts = CODE_IN_FRONT.exec(style) || [];
  var endsWithWhitespace = ENDS_IN_WHITESPACE.test(style);
  var newStyle = style;

  // if CODE_IN_FRONT regex matches, array indexes -
  // [1] negative symbol plus whitespace, if any,
  // [2] the "C" plus any whitespace,
  // [3] whatever is after "C"
  if (parts.length === 4) {
    newStyle = parts[1] + parts[3] + (endsWithWhitespace ? 'C' : ' C');
  }
  return newStyle;
}

// deal with
// 1. exceptions for specific locales
// 2. positive and negative styles
// 3. griffin fuzzy logic
// 4. UED consistency logic
function getFinalStyle(styleString, _ref3, _ref4) {
  if (styleString === void 0) {
    styleString = ';';
  }
  var lang = _ref3.lang,
    country = _ref3.country;
  var value = _ref4.value,
    _ref4$symbol = _ref4.symbol,
    symbol = _ref4$symbol === void 0 ? '' : _ref4$symbol,
    code = _ref4.code;
  var exception = STYLE_EXCEPTION[[lang, country, code].join(' ')]; // special exceptions
  var currencyStyle = exception || styleString;
  var _currencyStyle$split = currencyStyle.split(';'),
    positiveStyle = _currencyStyle$split[0],
    negativeStyle = _currencyStyle$split[1]; // the style is separated by postive and negative notation via a ;
  var baseStyle = value < 0 ? negativeStyle || '-¤# C' : positiveStyle || '¤# C';
  var griffinStyle = exception ? baseStyle : maybeIgnoreSymbol(baseStyle, symbol, code); // don't apply fuzzy logic on exceptions

  return forceCodeToRight(griffinStyle);
}

// take the style and the formatted amount (rounded / truncated / thousands separator / decimal separator)
// and produce the final result.
//
// wrapCodeInSpan - wraps the currency code in a span.currencyCode for styling purposes
function applyCurrencyStyle(finalStyle, amountFormatted, _ref5) {
  var symbol = _ref5.symbol,
    code = _ref5.code,
    _ref5$wrapCodeInSpan = _ref5.wrapCodeInSpan,
    wrapCodeInSpan = _ref5$wrapCodeInSpan === void 0 ? false : _ref5$wrapCodeInSpan;
  // the style will take care of negative symbol (see getFinalStyle function above)
  var absoluteAmountFormatted = amountFormatted.replace('-', '');

  // parallel operation is safer than serial replace
  return finalStyle.split('').map(function (_char) {
    switch (_char) {
      case 'C':
        return wrapCodeInSpan ? '<span class="currencyCode">' + code + '</span>' : code;
      case '¤':
        return symbol;
      case '#':
        return absoluteAmountFormatted;
      default:
        return _char;
    }
  }).join('').replace(ALL_NON_BREAKING_SPACE, ' ');
}

/**
 * @function formatCurrency
 * @param {string|number} amount Amount can be a string or a number
 * @param {string} code
 * @param {boolean} wrapCodeInSpan
 * @param {string} [style=SymbolISOCurrency]
 * @returns {string} formatted currency string
 */
function formatCurrency(amount, code, wrapCodeInSpan, style) {
  if (style === void 0) {
    style = 'SymbolISOCurrency';
  }
  if (isObject(amount) || typeof amount === 'undefined' || amount === null) {
    return;
  }
  var _ref6 = _locale.$locale.metadata || {},
    _ref6$number = _ref6.number,
    numberConfig = _ref6$number === void 0 ? {} : _ref6$number,
    _ref6$currency = _ref6.currency,
    currencyConfig = _ref6$currency === void 0 ? {} : _ref6$currency;
  var _currencyConfig$digit = currencyConfig.digits,
    digits = _currencyConfig$digit === void 0 ? {} : _currencyConfig$digit,
    _currencyConfig$style = currencyConfig.styles,
    styles = _currencyConfig$style === void 0 ? {} : _currencyConfig$style,
    _currencyConfig$suppo = currencyConfig.supportedSymbols,
    currencySymbols = _currencyConfig$suppo === void 0 ? {} : _currencyConfig$suppo;
  var value = parseFloat(amount);
  styles.AmountOnlyStyle = AmountOnlyStyle;
  var dot = numberConfig.DECIMAL_SEP === undefined ? '.' : numberConfig.DECIMAL_SEP;
  var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
  var amountFormatted = roundingAndSeparators(amount.toString(), _locale.$locale, {
    decimalPlaces: digits[code],
    dot: dot,
    comma: comma
  });
  if (code) {
    var symbol = currencySymbols[code];
    var finalStyle = getFinalStyle(styles[style], _locale.$locale, {
      value: value,
      symbol: symbol,
      code: code
    });
    return applyCurrencyStyle(finalStyle, amountFormatted, {
      symbol: symbol,
      code: code,
      wrapCodeInSpan: wrapCodeInSpan
    });
  }
  return amountFormatted; // HTML?
}

/**
 * @function truncateCurrencyConversionString
 * @description Takes a fullString, amount, and amountForex and truncates
 *      the number in the full string to number of digits in amountForex.
 *      This function is used to format the PayPal currency conversion
 *      rate that is displayed to the user (e.g. '1 CAD = $0.7459 USD')
 *      e.g. inputs of:
 *          fullString = '$0.745994235 USD'
 *          amount = '0.745994235'
 *          amountForex = '0.7459'
 *      results in an output of '$0.7459 USD'
 * @param {object} Contains keys 'fullString', 'amount', and 'amountForex'
 * @returns {string}
 */
var truncateCurrencyConversionString = exports.truncateCurrencyConversionString = function truncateCurrencyConversionString(_temp) {
  var _ref7 = _temp === void 0 ? {} : _temp,
    fullString = _ref7.fullString,
    amount = _ref7.amount,
    amountForex = _ref7.amountForex;
  var allArgsAreStrings = [fullString, amount, amountForex].every(function (s) {
    return typeof s === 'string';
  });
  if (!allArgsAreStrings) {
    return fullString || '';
  }

  // Some countries, e.g. France, use commas instead of decimals
  var target = amountForex.includes(',') ? amount.replace('.', ',') : amount;
  return fullString.replace(target, amountForex);
};

/**
 * @description takes a currency code and
 *  returns either a code or a symbol based
 *  on our currency mapping.
 *  eg: USD -> $ , RUB -> RUB
 *
 * @param {*} code
 * @returns {string}
 */
var getCurrencySymbol = exports.getCurrencySymbol = function getCurrencySymbol(code) {
  var _ref8 = _locale.$locale.metadata || {},
    _ref8$currency = _ref8.currency,
    currency = _ref8$currency === void 0 ? {
      supportedSymbols: {}
    } : _ref8$currency;
  return currency.supportedSymbols[code];
};
_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/feature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$feature = $feature;
exports.$featureCountries = $featureCountries;
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");
function $feature(prop, def, country) {
  var features = _core.$config.features || {};
  country = country || _locale.$locale.country;
  // 1. Check the feature is present in country
  var result = _core.$Class.get(features[country], prop);
  if (result !== undefined) {
    return result;
  }
  // 2. Check the feature is present in feature group

  Object.keys(_core.$config.regions).some(function (region) {
    if (_core.$config.regions[region].indexOf(country) !== -1) {
      result = _core.$Class.get(features[region], prop);
      return result !== undefined;
    }
    return false;
  });
  if (result !== undefined) {
    return result;
  }
  // 3. Check the feature is present in default group
  result = _core.$Class.get(features.DEFAULT, prop);
  if (result !== undefined) {
    return result;
  }
  return def;
}

// Build a list of all countries in our feature list and regions
// populate countries with out REGION names in the list
var allCountries = _core.$Class.keys(_core.$config.features || {}).filter(function (country) {
  return country !== 'DEFAULT' && !(_core.$config.regions && _core.$config.regions.hasOwnProperty(country));
});

// populate all the region countries in to allcountries
_core.$util.forEach(_core.$config.regions, function (countries, region) {
  _core.$util.forEach(countries, function (country) {
    if (allCountries.indexOf(country) === -1) {
      allCountries.push(country);
    }
  });
});
function $featureCountries(prop) {
  // Find the countries with a certain feature enabled
  return allCountries.filter(function (country) {
    return $feature(prop, false, country);
  });
}
angular.value("$feature", $feature);
angular.value("$featureCountries", $featureCountries);
_core.$config;
_core.$Class;
_core.$util;
_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");
Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _locale[key]) return;
  exports[key] = _locale[key];
});
var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");
Object.keys(_currency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _currency[key]) return;
  exports[key] = _currency[key];
});
var _feature = __webpack_require__("../node_modules/squid/dist/locale/feature.js");
Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _feature[key]) return;
  exports[key] = _feature[key];
});
var _name = __webpack_require__("../node_modules/squid/dist/locale/name.js");
Object.keys(_name).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _name[key]) return;
  exports[key] = _name[key];
});
var _quantity = __webpack_require__("../node_modules/squid/dist/locale/quantity.js");
Object.keys(_quantity).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _quantity[key]) return;
  exports[key] = _quantity[key];
});

/***/ }),

/***/ "../node_modules/squid/dist/locale/locale.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MetadataModel = exports.$LocaleModel = exports.$ContentModel = void 0;
exports.$contentVersion = $contentVersion;
exports.$flushContent = $flushContent;
exports.$localeHelper = exports.$locale = void 0;
exports.$renderContent = $renderContent;
exports.Content = Content;
exports.sanitize = sanitize;
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
var _paypal = __webpack_require__("../node_modules/squid/dist/paypal/index.js");
/* eslint-disable no-use-before-define */

function sanitize(html) {
  return html && html.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\//g, '&#x2F;');
}
var JSONStringify = JSON.stringify;
JSON.stringify = function (item) {
  if (item instanceof Content) {
    return item.toString();
  }
  return JSONStringify.apply(this, arguments);
};
function Content(key, props) {
  this.key = key;
  this.props = props;
}
Content.cache = {};
Content.get = function (key, props) {
  if (!key) {
    return '';
  }
  props = props || {};
  var cacheKey = $locale.country + "_" + $locale.lang + "_" + key + "_" + JSONStringify.call(JSON, props);
  var cacheVal = Content.cache[cacheKey];
  if (cacheVal !== undefined) {
    return cacheVal;
  }
  cacheVal = Content.cache[cacheKey] = new Content(key, props);
  return cacheVal;
};
Content.prototype.toString = Content.prototype.valueOf = function () {
  if (this.string) {
    return this.string;
  }
  this.string = this.render(false);
  return this.string;
};
Content.prototype.toSafeString = function () {
  if (this.safeString) {
    return this.safeString;
  }
  this.safeString = this.render(true);
  return this.safeString;
};
Content.prototype.render = function (safe) {
  var _this = this;
  if (!this.key) {
    return '';
  }
  var value = contentCache[$locale.country] && contentCache[$locale.country][$locale.lang];
  var keys = this.key.split('.');
  for (var i = 0; i < keys.length; i++) {
    if (value) {
      value = value[keys[i]];
    } else {
      break;
    }
  }
  if (!value) {
    return '';
  }
  return value.replace(/\{\w+\}/g, function (prop) {
    prop = prop.slice(1, prop.length - 1);
    if (prop === 'country') {
      return $locale.country;
    }
    if (prop === 'lang') {
      return $locale.lang;
    }
    if (!_this.props[prop]) {
      if (!_core.$loader.isLoading()) {
        _logger.$logger.warn('missing_content_prop', {
          key: _this.key,
          prop: prop
        }, {
          unique: true
        });
      }
      return '';
    }
    var propStr = _this.props[prop].toString();
    if (safe) {
      return sanitize(propStr);
    }
    return propStr;
  });
};
var contentCache = {};
var currentVersion;
window.addContent = function (country, lang, content, version) {
  var countryCache = contentCache[country] = contentCache[country] || {};
  countryCache[lang] = content;
  currentVersion = version;
};
var metadataCache = {};
window.addMetadata = function (country, lang, metadata, metadataVersion) {
  if (metadataVersion === void 0) {
    metadataVersion = 'default';
  }
  var countryCache = metadataCache[country] = metadataCache[country] || {};
  countryCache[lang] = countryCache[lang] || {};
  countryCache[lang][metadataVersion] = metadata;
};
function $contentVersion() {
  return currentVersion || '';
}
var PP_SPECIAL_COUNTRIES_ISO_CODES = {
  C2: 'CN'
};
var $ContentModel = exports.$ContentModel = _core.$Model.extend('$ContentModel', {
  api: new _core.$Api({
    baseURI: _core.$meta.staticUrl,
    uri: '/locales/:countryCode/:lang',
    ext: 'js',
    retrieve: function retrieve(options) {
      var self = this;
      var model = options.model;
      var uri = self.getURI(model);
      return _core.$promise.resolve().then(function () {
        if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
          _logger.$logger.info('cached_content');
          return contentCache[model.countryCode][model.lang];
        }
        _logger.$logger.info('retrieve_content', {
          uri: uri
        });
        _core.$event.emit('loading');
        return _core.$promise.attempt(3, function () {
          return _core.$dom.loadScript('content', uri, 10000).then(function () {
            if (contentCache[model.countryCode] && contentCache[model.countryCode][model.lang]) {
              _logger.$logger.info('content_retrieved');
              return contentCache[model.countryCode][model.lang];
            }
            throw new Error('content_not_available');
          });
        })['catch'](function (err) {
          throw err;
        })['finally'](function () {
          _core.$event.emit('loaded');
        });
      }).then(function (content) {
        model.setProperties(content);
        return content;
      });
    }
  }),
  change: function change(country, lang) {
    if (country === this.countryCode && lang === this.lang) {
      return _core.$promise.resolve(this);
    }
    this.countryCode = country;
    this.lang = lang;
    return this.reload().then(function () {
      _core.$event.broadcast('contentChange');
    });
  }
});
var $MetadataModel = exports.$MetadataModel = _core.$Model.extend('$MetadataModel', {
  api: new _core.$Api({
    baseURI: _core.$meta.staticUrl,
    uri: '/metadata/:country/:lang/:version?/metadata',
    ext: 'js',
    retrieve: function retrieve(options) {
      var self = this;
      var model = options.model;
      var uri = self.getURI(model);
      return _core.$promise.resolve().then(function () {
        var metadataVersion = model.version || 'default';
        if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
          _logger.$logger.info('cached_metadata');
          return metadataCache[model.country][model.lang][metadataVersion];
        }
        _logger.$logger.info('retrieve_metadata', {
          uri: uri
        });
        _core.$event.emit('loading');
        return _core.$promise.attempt(3, function () {
          return _core.$dom.loadScript('metadata', uri, 10000).then(function () {
            if (metadataCache[model.country] && metadataCache[model.country][model.lang] && metadataCache[model.country][model.lang][metadataVersion]) {
              _logger.$logger.info('metadata_retrieved', {
                uri: uri
              });
              return metadataCache[model.country][model.lang][metadataVersion];
            }

            // Retry if not found in cache
            _logger.$logger.info('metadata_not_available', {
              uri: uri
            });
            return _core.$promise.reject(new Error('metadata_not_available'));
          });
        })['catch'](function (err) {
          throw err;
        })['finally'](function () {
          _core.$event.emit('loaded');
        });
      }).then(function (metadata) {
        model.setProperties(metadata);
        return metadata;
      });
    }
  }),
  setVersion: function setVersion(country, lang) {
    var _this2 = this;
    var versionPxpName = _core.$config.features[country] && _core.$config.features[country].metadataVersionName;
    if (versionPxpName && _core.$config.metadataPxpExperiments[versionPxpName]) {
      var pxp = (0, _paypal.$pxp)(_core.$config.metadataPxpExperiments[versionPxpName].experimentName, {
        'ctx.COUNTRY': country,
        'ctx.LANGUAGE': lang
      }, _core.$config.metadataPxpExperiments[versionPxpName].experimentTreatmentName);
      return pxp.then(function (treatment) {
        if (treatment) {
          _this2.version = versionPxpName;
          _logger.$logger.info('metadata_version_set', {
            country: country,
            lang: lang,
            version: versionPxpName
          });
        } else {
          delete _this2.version;
        }
      })["catch"](function () {
        delete _this2.version;
      })["finally"](function () {
        return _core.$promise.resolve();
      });
    } else {
      delete this.version;
      return _core.$promise.resolve();
    }
  },
  change: function change(country, lang) {
    var _this3 = this;
    this.country = country;
    this.lang = lang;
    return this.setVersion(country, lang).then(function () {
      return _this3.reload().then(function () {
        if (!_this3.noBroadcast) {
          _core.$event.broadcast('metadataChange');
        }
      });
    });
  },
  choose: function choose(country, lang, override) {
    if (country && (!this.chosenCountry || override !== false)) {
      this.chosenCountry = country;
    }
    if (lang && (!this.chosenLang || override !== false)) {
      this.chosenLang = lang;
    }
    country = this.chosenCountry || this.country;
    lang = this.chosenLang;
    if (_core.$config.supportedCountries) {
      if (!_core.$config.supportedCountries[country]) {
        country = this.country;
      }
      if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
        lang = _core.$config.supportedCountries[country][0];
      }
    }
    if (!lang) {
      lang = this.lang;
    }
    return this.change(country, lang);
  },
  normalizeAddressFields: function normalizeAddressFields(content) {
    var CONTENT_MAPPING = {
      line1Label: 'streetAddress',
      line2Label: 'streetAddress2',
      cityLabel: 'city',
      stateLabel: 'state',
      postcodeLabel: 'postalCode'
    };

    // Loop over all layout props, if they don't exist in Griffin, get them from xo-content
    for (var prop in CONTENT_MAPPING) {
      if (this.addressEntry && this.addressEntry.strings[prop]) {
        this.addressEntry.strings[prop] = this.addressEntry.strings[prop] || content.get('common.' + CONTENT_MAPPING[prop]);
      }
    }
  }
});
function mapLanguage(lang) {
  var unselectableLanguages = _core.$config.unselectableLanguages || [];
  if (unselectableLanguages.indexOf(lang) !== -1) {
    if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
      return 'en';
    }
  }
  var unsupportedLanguages = _core.$config.unsupportedLanguages || [];
  if (unsupportedLanguages.indexOf(lang) !== -1) {
    if (!(_core.$meta.corp && _core.$config.betaLanguages && _core.$config.betaLanguages.indexOf(lang) !== -1)) {
      var s = lang + '_locale_not_supported';
      throw new Error(s);
    }
  }
  return lang;
}
var $LocaleModel = exports.$LocaleModel = _core.$Model.extend('LocaleModel', {
  api: new _core.$Api({
    uri: '/api/locale'
  }),
  init: function init() {
    this._super.init.apply(this);
    this.content = $ContentModel.instance();
    this.metadata = $MetadataModel.instance();
  },
  retrieve: function retrieve() {
    var self = this;
    return this._super.retrieve.apply(this, arguments).then(function (result) {
      self.lang = mapLanguage(self.lang);
      return _core.$promise.all([self.content.change(self.country, self.lang), self.metadata.change(self.country, self.lang)]).then(function () {
        // TODO: This at build time... or make sure griffin metadata is complete
        self.metadata.normalizeAddressFields(self.content);
        return result;
      });
    });
  },
  change: function change(country, lang) {
    var self = this;
    lang = mapLanguage(lang);
    if (country === this.country && lang === this.lang) {
      return _core.$promise.resolve(this);
    }
    _logger.$logger.info('locale_change', {
      country: country,
      lang: lang
    });
    this.country = country;
    this.lang = lang;
    return _core.$promise.all([this.content.change(country, lang), this.metadata.change(country, lang)]).then(function (loadedData) {
      // TODO: This at build time... or make sure griffin metadata is complete
      self.metadata.normalizeAddressFields(self.content);
      _core.$event.broadcast('localeChange'); // broadcast only when data has all been loaded
      return loadedData;
    });
  },
  choose: function choose(country, lang, override) {
    if (country && (!this.chosenCountry || override !== false)) {
      this.chosenCountry = country;
    }
    if (lang && (!this.chosenLang || override !== false)) {
      this.chosenLang = lang;
    }
    country = this.chosenCountry || this.country;
    lang = this.chosenLang;
    if (!_core.$config.supportedCountries[country]) {
      country = this.country;
    }
    if (_core.$config.supportedCountries[country].indexOf(lang) === -1) {
      lang = _core.$config.supportedCountries[country][0];
    }
    if (!lang) {
      lang = this.lang;
    }
    return this.change(country, lang);
  },
  chooseCountry: function chooseCountry(country) {
    return this.choose(country, null);
  },
  chooseLang: function chooseLang(lang) {
    return this.choose(null, lang);
  },
  getLocaleCode: function getLocaleCode() {
    return this.lang + '_' + this.country;
  },
  getCountryCodeISO: function getCountryCodeISO() {
    return PP_SPECIAL_COUNTRIES_ISO_CODES[this.country] || this.country;
  }
});
var $locale = exports.$locale = $LocaleModel.instance();
function $renderContent(key, props) {
  return Content.get(key, props);
}
function $flushContent() {
  contentCache = {};
  Content.cache = {};
  $locale.content = $ContentModel.create();
  $locale.metadata = $MetadataModel.create();
  metadataCache = {};
}
var $localeHelper = exports.$localeHelper = {
  /**
   *
   * @param locale - Ex: en_US
   * @returns {{country: *, dialect}}
   */
  normalizeLocale: function normalizeLocale(locale) {
    if (!locale) {
      return {};
    }
    locale = locale.replace('-', '_');
    var country;
    var language;
    if (locale.match(/^\w{2}_\w{2}$/)) {
      locale = locale.split('_');
      language = locale[0];
      country = locale[1];
    } else {
      language = locale;
    }
    return {
      country: country,
      language: language
    };
  }
};
angular.value("sanitize", sanitize);
angular.value("Content", Content);
angular.value("$contentVersion", $contentVersion);
angular.value("$ContentModel", $ContentModel);
angular.value("$MetadataModel", $MetadataModel);
angular.value("$LocaleModel", $LocaleModel);
angular.value("$locale", $locale);
angular.value("$renderContent", $renderContent);
angular.value("$flushContent", $flushContent);
angular.value("$localeHelper", $localeHelper);
_logger.$logger;
_core.$event;
_core.$Model;
_core.$Api;
_core.$meta;
_core.$promise;
_core.$config;
_core.$loader;
_core.$dom;
_paypal.$pxp;

/***/ }),

/***/ "../node_modules/squid/dist/locale/name.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatNameInformal = formatNameInformal;
var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");
// Mapping of Griffin fields to name fields that should be used
var SUBSTITUTED_FIELDS = {
  givenName: 'first_name',
  surname: 'last_name'
};

// Taken from griffin-paypal: test if a string is Latin
function isLatin(str) {
  if (!str) {
    return true;
  }
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 0x24F) {
      return false;
    }
  }
  return true;
}

/**
 * Formats name into informal format based on Griffin metadata
 * @param  {Object} name The name to be formatted, containing first_name and last_name properties
 * @return {String}      The formatted string, or null if data is missing
 */
function formatNameInformal(name) {
  var layoutMetadata = _locale.$locale.metadata.nameInformal;
  var layout = null;
  if (!layoutMetadata) {
    return name.first_name || null; // Default to first name if metadata not loaded
  }

  // According to Griffin, if the name is all Latin and there is a Latin formatting variant, use that one
  if (layoutMetadata['latinLayout'] && isLatin(name.first_name) && isLatin(name.last_name)) {
    layout = layoutMetadata['latinLayout'];
  } else {
    layout = layoutMetadata['layout'];
  }

  // Map griffin layout parts to the name passed in. If it requires a value not passed in name, returns null early
  var formattedName = [];
  for (var i = 0; i < layout.length; i++) {
    var namePart = layout[i];
    if (name[SUBSTITUTED_FIELDS[namePart['$']]]) {
      formattedName.push(name[SUBSTITUTED_FIELDS[namePart['$']]]);
    } else if (namePart['$'] === 'separator') {
      formattedName.push(namePart._);
    }
  }
  return formattedName.join('');
}
_locale.$locale;

/***/ }),

/***/ "../node_modules/squid/dist/locale/quantity.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatQuantity = formatQuantity;
var _locale = __webpack_require__("../node_modules/squid/dist/locale/locale.js");
var _currency = __webpack_require__("../node_modules/squid/dist/locale/currency.js");
// format a quantity to add a thousand separator based on a locality
function formatQuantity(quantity) {
  var _ref = _locale.$locale.metadata || {},
    _ref$number = _ref.number,
    numberConfig = _ref$number === void 0 ? {} : _ref$number;
  var dot = '';
  var comma = numberConfig.GROUP_SEP === undefined ? ',' : numberConfig.GROUP_SEP;
  return (0, _currency.roundingAndSeparators)(quantity.toString(), _locale.$locale, {
    decimalPlaces: 0,
    dot: dot,
    comma: comma
  });
}
_locale.$locale;
_currency.roundingAndSeparators;

/***/ }),

/***/ "../node_modules/squid/dist/module.js":
/***/ (function(module, exports) {



module.exports = angular.module;

/***/ }),

/***/ "../node_modules/squid/dist/ng/component.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$Component = void 0;
exports.$populate = $populate;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");
var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");
(0, _directive.$registerDirective)('prevent-default', function () {
  return {
    restrict: 'A',
    link: function link($scope, $element, $attrs) {
      $element.on('click', function (event) {
        event.preventDefault();
      });
    }
  };
});
(0, _directive.$registerDirective)('stop-propagation', function () {
  return {
    restrict: 'A',
    link: function link($scope, $element, $attrs) {
      $element.on('click keydown keypress keyup', function (event) {
        event.stopPropagation();
      });
    }
  };
});
(0, _directive.$registerDirective)('validate-submit', function () {
  return {
    link: function link($scope, $element, $attrs) {
      var $form = $element.closest('form');
      var form = $scope[$form.prop('name')];
      var formID_element = $attrs.form; // take the form attribute from submit button
      var formID_linked = $element[0] // take the id from the linked form element
      && $element[0].form && $element[0].form.id;
      var isLinkedForm = formID_element && formID_element === formID_linked; // Checking for confirmation. May not be required. Presence should be good enough.

      if (isLinkedForm) {
        $form = angular.element(document.getElementById(formID_linked));
        var scope = $form.scope(); // Linked forms should mantain form scope

        form = scope[$form.prop('name')];
      }
      $element.on('click', function (event) {
        event.preventDefault();
        $form.addClass('validated');
        $scope.validated = true;
        form.$setSubmitted();
        if (form.$valid) {
          try {
            $scope.$eval($attrs.validateSubmit);
          } catch (err) {
            _angular.$injector.get('$exceptionHandler')(err);
          }
        } else {
          $form.find('.ng-invalid:first').focus();
        }
      });
    }
  };
});
function assertModelsRetrievedOrEmpty(items) {
  if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
    angular.forEach(items, function (item, name) {
      if (item instanceof _core.$Model) {
        if (item.meta.populated) {
          throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
        }
      }
    });
  }
}
function setUpComponentRoute($scope, $Component, angular) {
  var componentRoute = $scope.componentRoute;
  componentRoute.scope = $scope;
  componentRoute.scope["goto"] = function (route) {
    componentRoute["goto"](route);
  };
  var parentRoute = componentRoute.parent;
  if (parentRoute) {
    var parentScope = parentRoute.scope;
    var parentDirective = parentRoute.getDirective();
    var childSpec = componentRoute.childSpec;
    if (childSpec.config) {
      if (parentDirective instanceof $Component) {
        parentScope.viewConfig = childSpec.config.call(parentScope);
      } else {
        throw new Error("In order to use config() for child routes,\n                    " + parentRoute.getDirectiveTag() + " must be instance of new\n                    style $Component");
      }
    }
    if (childSpec.props) {
      if (parentDirective instanceof $Component) {
        angular.extend($scope, childSpec.props.call(parentScope));
      } else {
        throw new Error("In order to use props() for child routes,\n                    " + parentRoute.getDirectiveTag() + " must be instance of new\n                    style $Component");
      }
    }
  }
}
var $Component = exports.$Component = _core.$Class.extend('$Component', {
  onPopulate: angular.noop,
  init: function init() {
    var _arguments = arguments,
      _this = this;
    this.validate();
    this.name = _core.$util.dasherizeToCamel(this.tag);
    var wrapperType = this.wrapperType === 'span' ? 'span' : 'div';
    this.template = "<" + wrapperType + " class=\"" + this.tag + "-wrapper\" ng-if=\"populated && display\">" + this.template + "</" + wrapperType + ">";
    this.scope = this.scope || {};
    this.resolve = this.resolve || {};
    this.props = this.props || {};
    this.rootEvents = this.rootEvents || {};
    this.actions = this.actions || {};
    this.lifecycle = this.lifecycle || {};
    this.lifecycle.enter = this.lifecycle.enter || angular.noop;
    this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
    this.lifecycle.exit = this.lifecycle.exit || angular.noop;
    this.lifecycle.populate = this.lifecycle.populate || angular.noop;
    if (this.scope && Object.keys(this.scope).length) {
      if (this.props && Object.keys(this.props).length) {
        throw new Error('Can not defined scope and props on the same component');
      }
      this.scope.componentRoute = '=';
      this.scope["export"] = '@';
      this.props = _core.$util.map(this.scope, function (type, key) {
        return {
          type: {
            '=': 'var',
            '@': 'str'
          }[type],
          required: false
        };
      });
    } else {
      this.props.componentRoute = {
        type: 'var',
        required: false
      };
      this.props["export"] = {
        type: 'str',
        required: false
      };
      var isRequired = function isRequired(_temp) {
        var _ref = _temp === void 0 ? {} : _temp,
          required = _ref.required,
          optional = _ref.optional;
        return [true, 'true'].indexOf(required) > -1 || [false, 'false'].indexOf(optional) > -1;
      };
      this.scope = _core.$util.map(this.props, function (spec, key) {
        return {
          "var": isRequired(spec) ? '=' : '=?',
          str: isRequired(spec) ? '@' : '@?'
        }[spec.type || 'var'];
      });
    }
    var originalController = this.controller || angular.noop;
    this.controller = ['$scope', '$element', function ($scope, $element) {
      $scope.$element = $element;
      $scope.$on('$destroy', function () {
        if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
          delete $scope.componentRoute.parent.scope.viewConfig;
        }
        _this.lifecycle.exit.call($scope);
      });
      $scope.props = {};
      if ($scope.componentRoute) {
        setUpComponentRoute($scope, $Component, angular);
      }
      angular.forEach(_this.props, function (type, key) {
        var prop = _this.props[key];
        var required = prop.required !== false;
        var def;
        if (prop["default"] instanceof Function) {
          def = _core.$util.memoize(prop["default"].bind($scope));
        } else {
          def = function def() {
            return prop["default"];
          };
        }
        var UNDEFINED = {
          "var": undefined,
          str: ''
        }[prop.type];
        Object.defineProperty($scope.props, key, {
          get: function get() {
            var val = $scope[key];
            if (val === UNDEFINED) {
              if (required) {
                throw new Error("Prop required for component :: " + _this.tag + " :: " + key);
              }
              return def();
            }
            return val;
          },
          set: function set() {
            throw new Error("Prop is immutable :: " + _this.tag + " :: " + key);
          }
        });
      });
      $scope.fields = {};
      $scope.actions = _core.$util.bindObject(_this.actions, $scope);
      Object.keys(_this.rootEvents).forEach(function (eventName) {
        var cancel = _core.$event.on(eventName, function (event) {
          _this.rootEvents[eventName].apply($scope, _arguments);
        });
        $scope.$on('$destroy', cancel);
      });
      $scope.display = true;
      $scope.reload = function () {
        if (!$scope.populated) {
          throw new Error('Can not reload unpopulated component');
        }
        $scope.display = false;
        setTimeout(function () {
          $scope.display = true;
        });
      };
      $scope.componentScope = $scope;
      if ($scope.props["export"] && $scope.$parent.componentScope) {
        $scope.exports = angular.extend({}, _this.exports || {}, {
          reload: $scope.reload
        });
        Object.defineProperty($scope.$parent.componentScope, $scope.props["export"], {
          get: function get() {
            return $scope.exports;
          },
          configurable: true
        });
      }
      $scope._enablePopulateEvents = true;
      _angular.$injector.invoke(originalController, _this, {
        $scope: $scope,
        $element: $element
      });
      _this.lifecycle.enter.call($scope);
      $scope._enablePopulateEvents = false;
      var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
        if (toState === $scope.props.componentRoute) {
          _this.lifecycle.reenter.call($scope);
        }
      });
      $scope.$on('$destroy', cancelReEnterEvent);
      return _core.$promise.sequential([function () {
        $scope.$emit('_populating');
      }, function () {
        return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {
          if (angular.isObject(resolver)) {
            $scope[name] = resolver;
            return resolver;
          }
          return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
            assertModelsRetrievedOrEmpty(data);
            return _core.$promise.hash(data).then(function (resolvedData) {
              $scope[name] = resolvedData;
              return resolvedData;
            });
          });
        });
      }, function () {
        $scope.populated = true;
        $scope.$emit('_populated');
        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
          $scope.$on('populated', function (populatedEvent) {
            populatedEvent.stopPropagation();
          });
          $scope.$emit('populated');
          _this.onPopulate.call($scope);
          _this.lifecycle.populate.call($scope);
        });
      }]);
    }];
  },
  validate: function validate() {
    if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
      return;
    }
    var componentName = this.constructor.name;
    if (!this.tag) {
      throw new Error(componentName + " :: expected property 'tag'");
    }
    if (!this.tag.match(/^[a-z0-9-]+$/)) {
      throw new Error(componentName + " :: tag should contain only lowercase alphanumeric characters and dashes");
    }
    if (!this.template) {
      throw new Error(componentName + " :: expected property 'template'");
    }
    if (this.resolve) {
      angular.forEach(this.resolve, function (resolver, name) {
        if (!(resolver instanceof Function)) {
          throw new Error(componentName + " :: expected 'resolve." + name + "' to be a function");
        }
      });
    }
    if (this.props) {
      angular.forEach(this.props, function (prop, name) {
        if (!(prop instanceof Object)) {
          throw new Error(componentName + " :: expected 'props." + name + "' to be a function");
        }
        if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
          throw new Error(componentName + " :: expected 'props." + name + ".type' to be one of var, str");
        }
        if (prop["default"] && prop.required) {
          throw new Error(componentName + " :: unnecessary 'props." + name + ".default', since prop is required");
        }
        if (prop["default"] && prop["default"] instanceof Object && !(prop["default"] instanceof Function)) {
          throw new Error(componentName + " :: expected 'props." + name + ".default' to be a primitive or a function - please do not pass mutable objects");
        }
      });
    }
    if (this.actions) {
      angular.forEach(this.actions, function (action, name) {
        if (!(action instanceof Function)) {
          throw new Error(componentName + " :: expected 'actions." + name + "' to be a function");
        }
      });
    }
    if (this.lifecycle) {
      Object.keys(this.lifecycle).forEach(function (name) {
        if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
          throw new Error(componentName + " :: unexpected 'lifecycle." + name + "'");
        }
      });
    }
  }
});
$Component.reopenClass({
  extend: function extend() {
    var SubClass = _core.$Class.extend.apply(this, arguments);
    var spec = new SubClass();
    angular.module().directive(spec.name, function () {
      return spec;
    });
    return SubClass;
  },
  render: function render(scope) {
    _core.$event.emit('$resetState');
    var $scope = _angular.$rootScope.$new();
    angular.extend($scope, scope);
    var attrs = Object.keys(scope).map(function (key) {
      return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
    }.bind(this)).join(' ');
    var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
    var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';
    console.log('RENDER', html, scope);
    var element = (0, _angular.$compile)(html)($scope);

    // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
    angular.element(document.body).append(element);
    afterEach(_core.$util.once(function () {
      $scope.$destroy();
      cleanRootScope();
      element.remove();
    }));
    setTimeout.flush();
    element.isolateScope = function () {
      throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
    };
    element.updateProps = function (props) {
      angular.extend($scope, props);
      $scope.$digest();
      setTimeout.flush();
    };
    return element;
  }
});
function autoConvertDirectiveToComponent(_ref2, original) {
  var name = _ref2[0],
    factory = _ref2[1];
  if (!angular.isFunction(factory)) {
    return original();
  }
  var tag = _core.$util.camelToDasherize(name);
  var spec = _angular.$injector.invoke(factory);
  if (spec.controller) {
    var originalController = spec.controller;
    spec.controller = ['$scope', '$element', function ($scope, $element) {
      $scope._enablePopulateEvents = true;
      var result = _angular.$injector.invoke(originalController, this, {
        $scope: $scope,
        $element: $element
      });
      $scope._enablePopulateEvents = false;
      return result;
    }];
  }
  if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
    return original(this, [name, function () {
      return spec;
    }]);
  }
  if (spec.componentize) {
    $Component.extend("$" + name + "Component", spec, {
      tag: tag
    });
    return this;
  }
  return original(this, [name, function () {
    return spec;
  }]);
}
_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);

// $populate needs to go away

function $populate($scope, instances) {
  $scope.$on = $scope.$on || angular.noop;
  $scope.$emit = $scope.$emit || angular.noop;
  var _enablePopulateEvents = $scope._enablePopulateEvents;
  if (_enablePopulateEvents) {
    _core.$event.refCount($scope, '_populating', '_populated').then(function () {
      $scope.$emit('populated');
    });
  }
  $scope.$on('populated', function (populatedEvent) {
    populatedEvent.stopPropagation();
  });
  if (_enablePopulateEvents) {
    $scope.$emit('_populating');
  }
  return _core.$promise.all(_core.$util.map(instances, function (instance, name) {
    var promise;
    if (instance.then) {
      promise = instance;
    } else {
      promise = instance.retrieve();
      $scope[name] = instance;
    }
    return promise.then(function (result) {
      $scope[name] = result;
      return result;
    });
  })).then(function (result) {
    if (_enablePopulateEvents) {
      $scope.$emit('_populated');
    }
    return result;
  });
}
angular.value("$Component", $Component);
angular.value("$populate", $populate);
_angular.$rootScope;
_angular.$compile;
_angular.$injector;
_angular.$compileProvider;
_core.$Class;
_core.$Model;
_core.$util;
_core.$promise;
_core.$config;
_core.$event;
_ng.$cleanRootScope;
_directive.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/squid/dist/ng/core.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
_core.$event.use({
  on: function on() {
    return _angular.$rootScope.$on.apply(_angular.$rootScope, arguments);
  },
  once: function once(name, handler) {
    var cancel = _core.$event.on(name, function () {
      cancel();
      handler.apply(this, arguments);
    }, true);
    return cancel;
  },
  emit: function emit() {
    return _angular.$rootScope.$emit.apply(_angular.$rootScope, arguments);
  },
  broadcast: function broadcast() {
    return _angular.$rootScope.$broadcast.apply(_angular.$rootScope, arguments);
  }
});
_core.$promise.use(_angular.$q);
_angular.$q;
_angular.$rootScope;
_core.$event;
_core.$promise;

/***/ }),

/***/ "../node_modules/squid/dist/ng/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$registerDirective = $registerDirective;
var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function $registerDirective(tag, definition) {
  var directiveName = tag.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  return _angular["default"].module().directive(directiveName, definition);
}
_angular["default"].value("$registerDirective", $registerDirective);

/***/ }),

/***/ "../node_modules/squid/dist/ng/events.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
angular.module().run(function () {
  _core.$event.on('$stateChangeStart', function (event) {
    _core.$event.emit('loading');
    _core.$event.emit('loaded');
  });
  var startLoadTime = 0;
  var currentState = 'checkout_init';
  function currentStateName() {
    return _uiRouter.$state.current.name && _uiRouter.$state.current.name.replace(/\./g, '_');
  }
  _core.$event.on('startLoad', function () {
    if (startLoadTime) {
      startLoadTime = _core.$util.now();
    } else if (window.enablePerformance && window.performance.timing.connectEnd && window.performance.timing.navigationStart) {
      var performance = window.performance;
      var timing = window.performance.timing || {};
      var now = performance.now();
      startLoadTime = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
    }
  });
  _core.$event.on('allLoaded', function () {
    var newState = currentStateName();
    if (!newState) {
      return;
    }
    if (currentState === newState) {
      _core.$event.emit('page_reloaded', currentState);
    } else {
      var duration;
      if (startLoadTime) {
        duration = _core.$util.now() - startLoadTime;
      }
      var payload = {
        start: currentState,
        end: newState,
        time: duration,
        duration: duration
      };
      _core.$event.emit('$transition', {
        from: currentState,
        toState: _uiRouter.$state.current,
        duration: duration
      });
      _logger.$logger.info('transition', payload);
      _logger.$logger.info('transition_' + currentState + '_to_' + newState, payload);
      _core.$event.emit('page_loaded', currentState, newState);
      _logger.$logger.flush();
      currentState = newState;
    }
  });
  _core.$event.emit('loading');
  var cancel = _core.$event.on('$stateChangeSuccess', function () {
    if (_uiRouter.$state.current.template) {
      cancel();
      setTimeout(function () {
        _core.$event.emit('loaded');
      }, 50);
    }
  });
});
_uiRouter.$state;
_logger.$logger;
_core.$event;
_core.$util;

/***/ }),

/***/ "../node_modules/squid/dist/ng/feature.js":
/***/ (function(module, exports, __webpack_require__) {



var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");
var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
(0, _directive.$registerDirective)('feature', function () {
  return {
    restrict: 'A',
    transclude: true,
    scope: {},
    template: '<span ng-if="enabled()" ng-transclude></span>',
    link: function link($scope, element, attr) {
      $scope.enabled = function () {
        return (0, _locale.$feature)(attr.feature) || _core.$integration.getConfig(attr.feature);
      };
    }
  };
});
(0, _directive.$registerDirective)('unless-feature', function () {
  return {
    restrict: 'A',
    transclude: true,
    scope: {},
    template: '<span ng-if="!enabled()" ng-transclude></span>',
    link: function link($scope, element, attr) {
      $scope.enabled = function () {
        return (0, _locale.$feature)(attr.unlessFeature) || _core.$integration.getConfig(attr.unlessFeature);
      };
    }
  };
});
_directive.$registerDirective;
_locale.$feature;
_core.$integration;

/***/ }),

/***/ "../node_modules/squid/dist/ng/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _core = __webpack_require__("../node_modules/squid/dist/ng/core.js");
Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _core[key]) return;
  exports[key] = _core[key];
});
var _route = __webpack_require__("../node_modules/squid/dist/ng/route.js");
Object.keys(_route).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _route[key]) return;
  exports[key] = _route[key];
});
var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");
Object.keys(_component).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _component[key]) return;
  exports[key] = _component[key];
});
var _feature = __webpack_require__("../node_modules/squid/dist/ng/feature.js");
Object.keys(_feature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _feature[key]) return;
  exports[key] = _feature[key];
});
var _locale = __webpack_require__("../node_modules/squid/dist/ng/locale.js");
Object.keys(_locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _locale[key]) return;
  exports[key] = _locale[key];
});
var _module = __webpack_require__("../node_modules/squid/dist/ng/module.js");
Object.keys(_module).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _module[key]) return;
  exports[key] = _module[key];
});
var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");
Object.keys(_ng).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ng[key]) return;
  exports[key] = _ng[key];
});
var _directive = __webpack_require__("../node_modules/squid/dist/ng/directive.js");
Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _directive[key]) return;
  exports[key] = _directive[key];
});
var _events = __webpack_require__("../node_modules/squid/dist/ng/events.js");
Object.keys(_events).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _events[key]) return;
  exports[key] = _events[key];
});
var _pxp = __webpack_require__("../node_modules/squid/dist/ng/pxp.js");
Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pxp[key]) return;
  exports[key] = _pxp[key];
});
var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");
Object.keys(_lazyLoadRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _lazyLoadRoutes[key]) return;
  exports[key] = _lazyLoadRoutes[key];
});

/***/ }),

/***/ "../node_modules/squid/dist/ng/lazyLoadRoutes.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.lazyLoadRoute = exports.initRoute = exports.findRelativeState = void 0;
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");
var getHash = function getHash(url) {
  if (!url || !~url.indexOf('#')) {
    // eslint-disable-line no-bitwise
    return;
  }
  url = url.split('#');
  return url[url.length - 1];
};

/**
 *
 * get parent state, e.g "checkout.sidebar.addCard" -> "checkout.sidebar"
 */
var getParentState = function getParentState(path) {
  return _uiRouter.$state.get(path.slice(0, path.lastIndexOf('.')));
};

/**
 * Find route by slug
 * path - full path of the current route, e.g "checkout.payWithSelection"
 * slug - path of the route that we want to search, e.g "payWithSelection"
 */
var getRoute = function getRoute(path, slug) {
  var route = getParentState(path);
  if (!route) {
    return;
  }
  var children = route.children;
  if (children) {
    return children.find(function (child) {
      return child.slug === slug;
    });
  }
};

/**
 * Lazy load children routes in the background
 */
var lazyLoadChildren = function lazyLoadChildren(children) {
  if (children) {
    _logger.$logger.info('lazy_loading_route_load_children');
    children.forEach(function (child) {
      if (child.lazyRoute) {
        // request to download js chunk (dynamic import)
        child.lazyRoute();
      }
    });
  }
};

/**
 * Dynamically load route and initialize / register it
 * @param {Object} routeObj - route object from Route definition, e.g
 *  {
 *      name: '$PayWithSelection',
 *      slug: 'payWithSelection',
 *      lazyRouter: () => import('pages/payWithSelection/route)
 *  }
 *
 * @param {Route} parent - parent of the passed routeObj
 * @param {String} fullRoutePath - full path of the route, e.g "checkout.payWithselection"
 */
var initRoute = exports.initRoute = function initRoute(routeObj, parent, fullRoutePath) {
  if (!routeObj) {
    return;
  }
  var name = routeObj.name,
    slug = routeObj.slug,
    attributes = routeObj.attributes,
    lazyRoute = routeObj.lazyRoute;
  _logger.$logger.info('lazy_loading_route_init', {
    name: name,
    slug: slug,
    fullRoutePath: fullRoutePath
  });
  return lazyRoute().then(function (route) {
    if (!route) {
      return;
    }
    if (typeof route === 'object') {
      route = route[name];
    }
    var childRoute = new route({
      //eslint-disable-line
      parent: parent || getParentState(fullRoutePath),
      childSpec: _core.$util.extend(routeObj, {
        route: route
      }),
      childAttributes: attributes
    });
    childRoute.register();
    return childRoute;
  });
};

/**
 * Promisify all lazy routes
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes
 *      1. Go through each possible route, e.g 'checkout', 'checkout.sidebar', 'checkout.sidebar.addCardFlow', 'checkout.sidebar.addCardFlow.addCard'
 *      2. Check if each exists / already registered
 *      3. if route is not registered -> find that route and return promise
 * @param {String} targetState full path of the target route
 * Returns an array of promisified functions
 */
var findAndPromisifyRoutes = function findAndPromisifyRoutes(targetState) {
  var splittedTargetState = targetState.split('.');
  var states = splittedTargetState.slice(1);
  var routes = [];
  var path = splittedTargetState[0];
  states.forEach(function (state) {
    path += "." + state;
    var fullRoutePath = path;
    if (!_uiRouter.$state.get(path)) {
      routes.push(function (parent) {
        var route = getRoute(fullRoutePath, state);
        return initRoute(route, parent, fullRoutePath);
      });
    }
  });
  return routes;
};

/**
 * Checks if it's a relative path (having `.` or `^`)
 * @param {String} stateName - path of the state, e.g `.mychildRoute`
 */
var isRelative = function isRelative(stateName) {
  return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
};

/**
 * finds a full path of the relative state name
 * examples:
 * '^' - will go to a parent state
 * '^.sibling' - will go to a sibling state
 * '.child.grandchild' - will go to grandchild state
 * @param {String / Object} stateOrName - state to find, e.g `^.selectFi`
 * Returns full path name of the state, e.g `^.selectFi` -> `checkout.selectFi`
 */
var findRelativeState = exports.findRelativeState = function findRelativeState(stateOrName) {
  if (!stateOrName) {
    return;
  }
  var base = _uiRouter.$state.current;
  var rel = stateOrName.split('.');
  var current = base;
  var i = 0;
  for (; i < rel.length; i++) {
    if (rel[i] === '' && i === 0) {
      current = base;
      continue;
    }
    if (rel[i] === '^') {
      if (!current.parent) {
        throw new Error('lazy-loading: path \'' + stateOrName + '\' not valid for state \'' + base.name + '\'');
      }
      current = current.parent;
      continue;
    }
    break;
  }
  rel = rel.slice(i).join('.');
  return current.name + (current.name && rel ? '.' : '') + rel;
};

/**
 * Lazy load route and redirect if successfull or reject if route was not found
 * Note: routes will be loading sequentialy for now to load parent routes first if they are lazy as well.
 * Example:
 *      targetState = 'checkout.sidebar.addCardFlow.addCard'
 *      Lets say 'addCard', 'addCardFlow' and 'addCard' are lazy routes and represent separate js chunk
 *      We have to load each js chunk in order one by one to be able to register them and attach to corresponding parents.
 * @param {String} targetState - route path, e.g 'checkout.payWithSelection'
 * @param {Object} targetParams - params which route may need
 * @param {Boolean} shouldChangeState - if state should be changed after route is loaded
 */
var lazyLoadRoute = exports.lazyLoadRoute = function lazyLoadRoute(targetState, targetParams, shouldChangeState) {
  if (targetParams === void 0) {
    targetParams = {};
  }
  if (shouldChangeState === void 0) {
    shouldChangeState = true;
  }
  if (!targetState) {
    return _core.$promise.reject(new Error('lazy_loading_target_state_is_empty'));
  }
  _logger.$logger.info('lazy_loading_route', {
    targetState: targetState,
    targetParams: targetParams
  });
  if (isRelative(targetState)) {
    targetState = findRelativeState(targetState, _uiRouter.$state.current);
  }
  _core.$event.emit('loading');
  var routes = findAndPromisifyRoutes(targetState);
  return _core.$promise.sequential(routes).then(function (result) {
    if (_uiRouter.$state.get(targetState)) {
      if (result) {
        lazyLoadChildren(result.children);
      }
      _logger.$logger.info('lazy_loading_route_state_change', {
        targetState: targetState,
        targetParams: targetParams
      });
      if (!shouldChangeState) {
        return _core.$promise.resolve();
      }
      return _uiRouter.$state.go(targetState, targetParams)["catch"](function (err) {
        if (err.message === 'transition prevented' || err.message === 'transition superseded') {
          return _core.$promise.resolve();
        }
        return _core.$promise.reject(err);
      });
    } else {
      return _core.$promise.reject(new Error('lazy_loading_state_was_not_loaded'));
    }
  })["catch"](function (error) {
    // in case of exceptions, spinner must dissapear, because for each 'loading' event
    // that's sent in the beginning of the function must be corresponding 'loaded' event
    // otherwise, there will be infinite spinner

    _logger.$logger.info('lazy_loading_route_error', {
      targetState: targetState,
      targetParams: targetParams,
      errorMessage: error && error.message,
      errorStack: error && error.stack
    });
    return _core.$promise.reject(error);
  })["finally"](function () {
    _core.$event.emit('loaded');
  });
};

/**
 * mostly needed for use cases when user types route manually
 */
window.addEventListener('hashchange', function (event) {
  if (_config.$meta.codeSplitting) {
    var fromHash = getHash(event.oldURL);
    var toHash = getHash(event.newURL || window.location.hash);

    // skip lazy loading in case hash is undefined or empty
    // example -> <a href="#" ng-click="openModal()">OpenModal</a>
    // in that case `toHash` will be empty
    if (!toHash) {
      return;
    }
    var getHashQueryParams = function getHashQueryParams(path) {
      var splittedPath = path.split('?');
      // e.g #/checkout/genericError?code=ERROR_CODE -> code=ERROR_CODE
      var hashParams = splittedPath.length > 1 && splittedPath[1];
      if (hashParams) {
        // e.g code=ERROR_CODE -> { code: ERROR_CODE }
        return _core.$util.params(hashParams);
      }
    };
    // e.g #/checkout/review -> checkout.review
    var path = toHash.slice(1).replace(/\//g, '.');
    var hashQueryParams = getHashQueryParams(path);
    if (hashQueryParams) {
      // e.g checkout.genericError?code=ERROR_CODE -> checkout.genericError
      path = path.split('?')[0];
    }
    if (_uiRouter.$state.get(path)) {
      return;
    }
    _logger.$logger.info('hashchange_lazy_loading', {
      from: fromHash,
      to: toHash
    });
    lazyLoadRoute(path, hashQueryParams)["catch"](function () {
      _logger.$logger.info('hashchange_lazy_loading_error', {
        from: fromHash,
        to: toHash,
        params: hashQueryParams
      });
    });
  }
});
_uiRouter.$state;
_logger.$logger;
_core.$util;
_core.$promise;
_core.$event;
_config.$meta;

/***/ }),

/***/ "../node_modules/squid/dist/ng/locale.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");
(0, _angular.$registerDirective)('content', function () {
  return {
    restrict: 'A',
    link: function link($scope, element, attributes) {
      $scope.content = $scope.htmlContent = function (key, props) {
        if (attributes.content) {
          key = attributes.content + '.' + key;
        }
        var content = _locale.Content.get(key, props);
        if (content.toString()) {
          return content;
        } else {
          return;
        }
      };
    }
  };
});
(0, _angular.$registerDirective)('bind-html-compile', function () {
  return {
    restrict: 'A',
    link: function link($scope, $element, $attrs) {
      $scope.$watch(function () {
        return $scope.$eval($attrs.bindHtmlCompile);
      }, function (value) {
        $element.html(value && value.toString());
        (0, _angular.$compile)($element.contents())($scope);
      });
    }
  };
});
(0, _angular.$registerDirective)('format-currency', function () {
  return {
    restrict: 'E',
    template: '<span ng-bind-html="amount_formatted" class="ltrOverride"></span>',
    scope: {
      amount: '=?',
      symbol: '=?',
      code: '=?',
      currencyStyle: '@?'
    },
    controller: ['$scope', function ($scope) {
      function format() {
        $scope.amount_formatted = _angular.$sce.trustAsHtml((0, _locale.formatCurrency)($scope.amount, $scope.code, true, $scope.currencyStyle));
      }
      $scope.$on('$destroy', _core.$event.on('localeChange', format));
      $scope.$watch('amount', function (newValue, oldValue) {
        if (newValue !== oldValue && _locale.$locale.country) {
          format();
        }
      });
      if (_locale.$locale.country) {
        format();
      }
    }] // controller
  }; // return
}); // registerDirective

(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
angular.module().value('$sanitize', function (val) {
  if (val instanceof _locale.Content) {
    return val.toSafeString();
  }
  return (0, _locale.sanitize)(val);
});
_angular.$sce;
_angular.$registerDirective;
_angular.$compile;
_core.$event;
_locale.formatCurrency;
_locale.sanitize;
_locale.Content;
_locale.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/squid/dist/ng", "../node_modules/squid/dist/ng/locale.js"))

/***/ }),

/***/ "../node_modules/squid/dist/ng/module.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.module = void 0;
var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _module = exports.module = _angular["default"].module;

/***/ }),

/***/ "../node_modules/squid/dist/ng/ng.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$angularInvoke = $angularInvoke;
exports.$cleanRootScope = $cleanRootScope;
exports.$once = $once;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
function $angularInvoke(method) {
  try {
    return method();
  } catch (err) {
    _angular.$injector.get('$exceptionHandler')(err);
  }
}
function $once(name, handler) {
  var cancel = _core.$event.on(name, function () {
    cancel();
    handler.apply(this, arguments);
  }, true);
}
function $cleanRootScope(rootScope) {
  var keys = Object.keys(rootScope);
  var autoCleanupEventHandlers = [];
  var eventHandlers = [];
  var eventCancelers = [];
  _core.$util.monkeyPatch(rootScope, '$on', function (_ref, original) {
    var name = _ref[0],
      handler = _ref[1],
      once = _ref[2];
    var cancel = original();
    var $state;
    try {
      $state = _angular.$injector.get('$state');
    } catch (err) {
      // pass
    }
    if (name === '$destroy' || !$state || !$state.current || !$state.current.name || $state.current.name === 'default') {
      autoCleanupEventHandlers.push(cancel);
      return function autoCleanedUpCancel() {}; // eslint-disable-line no-empty-function
    }
    if (once) {
      eventCancelers.push(cancel);
      return cancel;
    }

    // Let ng-router do its thing
    if (handler.toString().indexOf('updateView') !== -1) {
      return cancel;
    }
    var stack;
    try {
      throw new Error('$rootScope.$on');
    } catch (err) {
      stack = err.stack;
    }
    var reference = {
      name: name,
      handler: handler.toString(),
      stack: stack
    };
    eventHandlers.push(reference);
    return function () {
      cancel();
      eventHandlers.splice(eventHandlers.indexOf(reference), 1);
    };
  });
  return function () {
    _core.$event.emit('$destroy');
    autoCleanupEventHandlers.forEach(function (canceler) {
      return canceler();
    });
    autoCleanupEventHandlers = [];
    Object.keys(rootScope).forEach(function (key) {
      if (keys.indexOf(key) === -1) {
        delete rootScope[key];
      }
    });
    if (eventHandlers.length) {
      throw new Error('$rootScope event handlers not cleaned up:\n\n' + eventHandlers.map(function (eventHandler) {
        return eventHandler.name + "\n\n" + eventHandler.handler + "\n\n" + eventHandler.stack;
      }).join('\n\n'));
    }
    eventCancelers.forEach(function (cancel) {
      return cancel();
    });
  };
}
angular.value("$angularInvoke", $angularInvoke);
angular.value("$once", $once);
angular.value("$cleanRootScope", $cleanRootScope);
_angular.$injector;
_core.$util;
_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
_core.$event.on('pxp_res', function (event, pxpRes) {
  _uiRouter.$state.current.trackingData = _uiRouter.$state.current.trackingData || {};
  _uiRouter.$state.current.trackingData.pxpData = _uiRouter.$state.current.trackingData.pxpData || [];
  _uiRouter.$state.current.trackingData.pxpData.push(pxpRes);
});
_uiRouter.$state;
_core.$event;

/***/ }),

/***/ "../node_modules/squid/dist/ng/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Route = exports.$ComponentRoute = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");
var _component = __webpack_require__("../node_modules/squid/dist/ng/component.js");
var _ng = __webpack_require__("../node_modules/squid/dist/ng/ng.js");
var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");
var _lazyLoadRoutes = __webpack_require__("../node_modules/squid/dist/ng/lazyLoadRoutes.js");
var $Route = exports.$Route = _core.$Class.extend('$ComponentRoute', {
  childSpec: {},
  init: function init() {
    var _this = this;
    this.validate();
    this.url = '/' + (this.path || this.name);
    if (this.query) {
      this.url += '?' + this.query.join('&');
    }
    this.hasResolver = Boolean(this.resolve);
    var controller = this.controller = ['$scope', function ($scope) {
      $scope.route = _this;
      if ($scope.componentScope) {
        delete $scope.componentScope.view;
      }
    }];
    if (this.get('resolve.action')) {
      this.controller = ['$scope', 'action', function ($scope, action) {
        _angular.$injector.invoke(controller, this, {
          $scope: $scope
        });
        if (action) {
          if (!action.newState) {
            _angular.$location.replace();
          }
          if (angular.isObject(action) && action.to) {
            _uiRouter.$state.go(action.to, action.params);
          } else {
            _uiRouter.$state.go(action);
          }
        }
      }];
    }
  },
  validate: function validate() {
    if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
      return;
    }
    var routeName = this.constructor.name;
    if (!this.name && !this.path) {
      throw new Error(routeName + " :: expected property 'path'");
    }
    if (this.url) {
      _logger.$logger.warn(routeName + " :: unexpected property 'url' :: " + this.url);
    }
    if (this.query && !(this.query instanceof Array)) {
      throw new Error(routeName + " :: expected property 'query' to be array of query params");
    }
    if (this.controller) {
      // throw new Error(`${routeName} :: unexpected property 'controller'`);
    }
    if (this.resolve) {
      if (this.resolve.action && !(this.resolve.action instanceof Function)) {
        throw new Error(routeName + " :: expected property 'resolve.action' to be a function");
      }
      Object.keys(this.resolve).forEach(function (name) {
        if (name === 'data') {
          _logger.$logger.warn(routeName + " :: unexpected resolver :: " + name);
        } else if (name !== 'action') {
          throw new Error(routeName + " :: unexpected resolver :: " + name);
        }
      });
    }
    if (this.template) {
      throw new Error(routeName + " :: unexpected property 'template'");
    }
    if (!this.directive && !this.resolve && !this.resolve.action) {
      throw new Error(routeName + " :: expected property 'directive'");
    }
    if (this.directive && angular.isString(this.directive) && !this.getDirective()) {
      throw new Error(routeName + " :: unknown directive '" + this.directive + "'");
    }
    if (this.directive && !angular.isString(this.directive) && !_component.$Component.isChild(this.directive)) {
      throw new Error(routeName + " :: expected directive to be subclass of $Component");
    }
    if (this.children) {
      this.children.forEach(function (childSpec) {
        if (!childSpec.route && !childSpec.name) {
          throw new Error(routeName + " :: child expected property 'route'");
        }
        var ChildRoute = childSpec.route;
        var childName = childSpec.name || ChildRoute.name;

        // skip loading route as it won't be available to validate
        if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
          return;
        }
        if (!ChildRoute && childSpec.name) {
          try {
            ChildRoute = _angular.$injector.get(childSpec.name);
          } catch (err) {
            throw new Error(routeName + " :: could not find child route '" + childName + "'");
          }
        }
        if (!$Route.isChild(ChildRoute)) {
          throw new Error(routeName + " :: " + childName + " :: expected child to be instance of $Route");
        }
      });
    }
  },
  "goto": function goto(route) {
    return _uiRouter.$state.go(route.replace('this.', this.absolutePath + "."));
  },
  getDirective: function getDirective() {
    return _angular.$injector.get(_core.$util.dasherizeToCamel(this.getDirectiveTag() + "Directive"))[0];
  },
  getDirectiveTag: function getDirectiveTag() {
    return angular.isString(this.directive) ? this.directive : this.directive.prototype.tag;
  },
  bootstrap: function bootstrap(defaultState, middleware) {
    var _this2 = this;
    return (0, _ng.$angularInvoke)(function () {
      // only bootstrap if not bootstrapped already
      var element = angular.element(document.body);
      if (!element.injector()) {
        angular.bootstrap(element, ['app']);
      }
      return _this2.load(defaultState, middleware);
    });
  },
  load: function load(defaultState, middleware) {
    defaultState = defaultState || this.defaultState;
    middleware = middleware || this.middleware;
    _logger.$logger.info('bootstrap_route', {
      route: this.path || this.name
    });
    var logStateNotFoundAndThrow = function logStateNotFoundAndThrow(_ref) {
      var unfoundState = _ref.unfoundState,
        fromState = _ref.fromState,
        fromParams = _ref.fromParams,
        _ref$logName = _ref.logName,
        logName = _ref$logName === void 0 ? '' : _ref$logName;
      _logger.$logger.error("state_not_found" + logName, {
        name: unfoundState.to,
        from: fromState.name,
        fromParams: fromParams,
        hash: window.location.hash
      });
      throw new Error("state_not_found" + logName + ": " + unfoundState.to);
    };
    (0, _ng.$once)('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
      if (!_config.$meta.codeSplitting) {
        event.preventDefault();
        logStateNotFoundAndThrow({
          unfoundState: unfoundState,
          fromState: fromState,
          fromParams: fromParams
        });
      }
    });

    // for code splitting this event handler will be triggered every single time user tries to load lazy route
    // so we need to have it being listening more than once
    _core.$event.on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
      if (_config.$meta.codeSplitting) {
        event.preventDefault();
        // if route was not found - lazy load it or throw state_not_found if it was not found
        (0, _lazyLoadRoutes.lazyLoadRoute)(unfoundState.to, unfoundState.toParams)["catch"](function () {
          logStateNotFoundAndThrow({
            unfoundState: unfoundState,
            fromState: fromState,
            fromParams: fromParams,
            logName: '_lazy_loading'
          });
        });
      }
    });
    this.register();
    _uiRouter.$urlRouterProvider.otherwise(function () {
      return _logger.$logger.info('otherwise_after_bootstrap', {
        hash: window.location.hash
      });
    });
    this.runMiddleware(middleware).then(function () {
      var targetState;
      var targetParams;
      if (window.location.hash && window.location.hash.indexOf('#/') === 0) {
        targetState = window.location.hash.slice(2).split('?')[0].replace(/^\/+/, '').replace(/\/+$/, '').replace(/\//g, '.');
        targetParams = _core.$util.params(window.location.hash.slice(2).split('?')[1] || '');
      }
      _logger.$logger.info('initializing_route', {
        target: targetState,
        defaultState: defaultState,
        hash: window.location.hash
      });
      _angular.$location.replace();

      /**
       * load default state in case target state was not found
       * e.g checkout.landing - is the default state in Hermes
       */
      var loadDefaultState = function loadDefaultState() {
        if (_uiRouter.$state.get(defaultState)) {
          _logger.$logger.info('default_state', {
            stateName: defaultState
          });
          return _uiRouter.$state.go(defaultState)["catch"](function (err) {
            if (err.message === 'transition prevented') {
              _logger.$logger.warn('transition_prevented', {
                targetState: defaultState
              });
              return _core.$promise.resolve();
            }
            return _core.$promise.reject(err);
          });
        }
        throw new Error('Default state not found: ' + defaultState);
      };
      if (targetState) {
        var logUnknownState = function logUnknownState(logName) {
          if (logName === void 0) {
            logName = '';
          }
          _logger.$logger.info("unknown_state" + logName, {
            stateName: targetState
          });
        };
        if (_uiRouter.$state.get(targetState)) {
          _logger.$logger.info('existing_state', {
            stateName: targetState
          });
          return _uiRouter.$state.go(targetState, targetParams)["catch"](function (err) {
            // lib/js/security.js event listener handles auth required state changes
            // and cancels transitions if user not authenticated
            if (err.message === 'transition prevented') {
              _logger.$logger.warn('transition_prevented', {
                targetState: targetState
              });
              return _core.$promise.resolve();
            }
            return _core.$promise.reject(err);
          });
        } else if (_config.$meta.codeSplitting) {
          // try to lazy load route and catch / handle redirect errors
          // 1. If route was not found -> log and try to load default state
          // 2. If route was found but redirect throws an error -> reject
          return (0, _lazyLoadRoutes.lazyLoadRoute)(targetState, targetParams)["catch"](function (err) {
            if (err.message === 'lazy_loading_state_was_not_loaded') {
              logUnknownState('_lazy_loading');
              return loadDefaultState();
            } else {
              return _core.$promise.reject(err);
            }
          });
        } else {
          logUnknownState();
        }
      }
      return loadDefaultState();
    })["catch"](function (err) {
      return _angular.$injector.get('$exceptionHandler')(err);
    });
  },
  runMiddleware: function runMiddleware(middleware) {
    _logger.$logger.info('middleware', {
      priority: _core.$util.map(middleware, function (method) {
        return method.name;
      }).join('|')
    });
    var promise = _core.$promise.resolve();
    angular.forEach(middleware, function (method) {
      promise = promise.then(function () {
        if (method.name) {
          _logger.$logger.info('middleware_' + method.name);
        }
        return method();
      });
    });
    return promise;
  },
  register: function register() {
    var _this3 = this;
    this.template = this.constructTemplate(this.childAttributes || {});
    this.absolutePath = this.path || this.name;
    if (this.parent) {
      this.absolutePath = this.parent.absolutePath + '.' + this.absolutePath;
    }
    if (!_uiRouter.$state.get(this.absolutePath)) {
      _uiRouter.$stateProvider.state(this.absolutePath, this);
    }
    angular.forEach(this.children, function (childSpec) {
      // skip registering child if it's supposed to be lazy loaded
      if (_config.$meta.codeSplitting && childSpec.lazyRoute) {
        return;
      }
      var ChildRoute = childSpec.route || _angular.$injector.get(childSpec.name);
      var childRoute = new ChildRoute({
        parent: _this3,
        childSpec: childSpec,
        childAttributes: childSpec.attributes
      });
      childRoute.register();
    });
  },
  /**
   * Constructs the template string for this route. If route.directive = 'xo-add-bank', then the template will be
   * '<xo-add-bank/>'.
   * If attributes are specified, they will be passed to directive. Ex: <xo-add-bank attrname = "attrvalue"/>
   *
   * @param attributes - A map of name value pairs - {name: value}.
   * @returns {string}
   */
  constructTemplate: function constructTemplate(attributes) {
    var self = this;
    if (!self.directive) {
      return;
    }
    attributes['component-route'] = 'route';
    if (this.parent) {
      attributes["export"] = 'view';
    }
    var tag = this.getDirectiveTag();
    var paramString = '';
    angular.forEach(attributes, function (value, key) {
      paramString += ' ' + key + '="' + value + '"';
    });
    return "<div " + tag + " " + paramString + "></div>";
  }
});
if (!_uiRouter.$state.get('default')) {
  _uiRouter.$stateProvider.state('default', {
    auth: false
  });
}
$Route.reopenClass({
  render: function render(props) {
    _core.$event.emit('$resetState');
    _core.$loader.reset();
    _uiRouter.$state.go('default');
    setTimeout.flush();
    var $scope = angular.extend(_angular.$rootScope.$new(), props);
    var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
    var element = (0, _angular.$compile)('<div id="app"><ui-view></ui-view></div>')($scope);
    afterEach(_core.$util.once(function () {
      $scope.$destroy();
      cleanRootScope();
      _core.$loader.reset();
      angular.element(document.getElementById('app')).remove();
    }));
    var route = new this({
      // Pass child attributes to simulate a route receiving scope variables from the parent
      childAttributes: _core.$util.reduce(props, function (result, val, key) {
        result[_core.$util.camelToDasherize(key)] = key;
        return result;
      }, {})
    });
    route.bootstrap(route.defaultState || route.path || route.name);
    setTimeout.flush();
    element.isolateScope = function () {
      throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
    };

    // attaching to the document so DOM Api works in karma flow tests (e.g document.getElementById('myId'))
    angular.element(document.body).append(element);
    return element;
  },
  assertActive: function assertActive() {
    var isState = _uiRouter.$state.current instanceof this;
    if (!isState) {
      throw new Error("Current state should be \"" + (this.prototype.path || this.prototype.name) + "\", found \"" + _uiRouter.$state.current.name + "\"");
    }
  }
});
function getPageTitle(stateName) {
  var state = _uiRouter.$state.get(stateName);
  if (!state) {
    return;
  }
  if (state.titleContent) {
    return _locale.$locale.content.get(state.titleContent);
  }
}
function changePageTitle() {
  document.documentElement.setAttribute('lang', _locale.$locale.lang);
  if (!_uiRouter.$state.current || !_uiRouter.$state.current.name) {
    return;
  }
  var fullStateTitle = [];
  _uiRouter.$state.current.name.split('.').reduce(function (a, b) {
    var stateName = [a, b].filter(Boolean).join('.');
    var stateTitle = getPageTitle(stateName);
    if (stateTitle) {
      fullStateTitle.push(stateTitle);
    }
    return stateName;
  }, null);
  document.title = _core.$util.unique(fullStateTitle).join(' - ');
}
_core.$event.on('$stateChangeSuccess', changePageTitle);
_core.$event.on('contentChange', changePageTitle);
var $ComponentRoute = exports.$ComponentRoute = $Route;
angular.value("$Route", $Route);
angular.value("$ComponentRoute", $ComponentRoute);
_angular.$rootScope;
_angular.$location;
_angular.$injector;
_angular.$compile;
_uiRouter.$state;
_uiRouter.$stateProvider;
_uiRouter.$urlRouterProvider;
_logger.$logger;
_core.$config;
_core.$Class;
_core.$util;
_core.$promise;
_core.$event;
_core.$loader;
_locale.$locale;
_component.$Component;
_ng.$cleanRootScope;
_ng.$angularInvoke;
_ng.$once;
_config.$meta;
_lazyLoadRoutes.lazyLoadRoute;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/config.js":
/***/ (function(module, exports, __webpack_require__) {



var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");
_core.$config.deploy = _core.$config.deploy || _env.$env;
_core.$config;
_env.$env;

/***/ }),

/***/ "../node_modules/squid/dist/paypal/env.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.$env = void 0;
var $env = exports.$env = {
  isLocal: function isLocal() {
    return window.location.hostname === 'localhost' || window.location.hostname === 'localhost.paypal.com';
  },
  isStage: function isStage() {
    return Boolean(window.location.hostname.match(/^.*\.qa\.paypal\.com$/));
  },
  isSandbox: function isSandbox() {
    return Boolean(window.location.hostname.match(/^.*\.sandbox\.paypal\.com$/));
  },
  isLive: function isLive() {
    return window.location.hostname === 'www.paypal.com';
  },
  isTest: function isTest() {
    return false;
  }
};
angular.value("$env", $env);

/***/ }),

/***/ "../node_modules/squid/dist/paypal/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _env = __webpack_require__("../node_modules/squid/dist/paypal/env.js");
Object.keys(_env).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _env[key]) return;
  exports[key] = _env[key];
});
var _config = __webpack_require__("../node_modules/squid/dist/paypal/config.js");
Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _config[key]) return;
  exports[key] = _config[key];
});
var _pxp = __webpack_require__("../node_modules/squid/dist/paypal/pxp.js");
Object.keys(_pxp).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pxp[key]) return;
  exports[key] = _pxp[key];
});

/***/ }),

/***/ "../node_modules/squid/dist/paypal/pxp.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PXPModel = void 0;
exports.$elmo = $elmo;
exports.$getPxpTreatments = $getPxpTreatments;
exports.$pxp = $pxp;
exports.$pxpFactors = $pxpFactors;
exports.$pxpMatch = $pxpMatch;
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _core = __webpack_require__("../node_modules/squid/dist/core/index.js");
var _locale = __webpack_require__("../node_modules/squid/dist/locale/index.js");
var $PXPModel = exports.$PXPModel = _core.$Model.extend({
  api: new _core.$Api({
    uri: '/api/pxp/:pagename'
  })
});
function logPxp(pxpRes, params, logPayload) {
  var exp_name = [];
  var xe = [];
  var xt = [];
  var isElmoExperiment = params.isElmoExperiment;
  angular.forEach(pxpRes.treatments, function (treatment) {
    _logger.$logger.info('treatment_' + treatment.treatment_name, angular.extend({
      experiment: pxpRes.pagename,
      treatment: treatment.treatment_name,
      experiment_id: treatment.experiment_id,
      treatment_id: treatment.treatment_id,
      loc_country: _locale.$locale.country,
      loc_lang: _locale.$locale.lang,
      exp_source: isElmoExperiment ? 'elmo' : 'pxp'
    }, params, logPayload));
    exp_name.push(treatment.treatment_name);
    xe.push(treatment.experiment_id);
    xt.push(treatment.treatment_id);
  });
  _logger.$logger.info('pxp_' + pxpRes.pagename, angular.extend({
    pxp_exp_id: xe.join('|'),
    pxp_trtmnt_id: xt.join('|'),
    treatments: exp_name.join('|'),
    loc_country: _locale.$locale.country,
    loc_lang: _locale.$locale.lang,
    exp_source: isElmoExperiment ? 'elmo' : 'pxp'
  }, params, logPayload));
  _logger.$logger.info('fpti_pxp_check', {
    from: 'PXP_CHECK',
    to: 'process_pxp_check',
    pxp_exp_id: xe.join(','),
    pxp_trtmnt_id: xt.join(','),
    exp_source: isElmoExperiment ? 'elmo' : 'pxp'
  });
  _core.$event.emit('pxp_res', pxpRes);
}
function $getPxpTreatments(id, params, logPayload, forceApiCall, silent, isElmoExperiment) {
  if (forceApiCall === void 0) {
    forceApiCall = false;
  }
  if (silent === void 0) {
    silent = false;
  }
  if (isElmoExperiment === void 0) {
    isElmoExperiment = false;
  }
  return _core.$promise.run(function () {
    if (isElmoExperiment) {
      Object.assign(params, {
        isElmoExperiment: isElmoExperiment
      });
    }
    var pxp = $PXPModel.instance(_core.$util.buildURL(id, params), {
      pagename: id
    });
    var forceTreatments = _core.$util.param('pxp_' + id) || _core.$util.param('elmo_' + id);
    if (forceTreatments) {
      var treatments = forceTreatments.split(',').filter(Boolean);
      pxp.treatments = treatments.map(function (treatment_name) {
        return {
          treatment_name: treatment_name
        };
      });
      return pxp;
    }
    if (forceApiCall) {
      pxp.cached = false;
      return pxp.reload({
        params: params,
        silent: silent
      });
    }
    return pxp.retrieve({
      params: params,
      silent: silent,
      // Ignore all errors from this api, by passing transientError as true
      // Pxps are not critical calls, so they should fail silently without fallbacks (page reload / showing error page)
      transientError: true
    });
  }).then(function (pxp) {
    if (!pxp.cached) {
      logPxp(pxp, params, logPayload);
    }
    pxp.cached = true;
    return pxp;
  });
}
function $pxp(id, params, pattern, forceApiCall, silent, isElmoExperiment) {
  if (forceApiCall === void 0) {
    forceApiCall = false;
  }
  if (silent === void 0) {
    silent = false;
  }
  if (isElmoExperiment === void 0) {
    isElmoExperiment = false;
  }
  if (!pattern) {
    pattern = params;
    params = {};
  }
  pattern = new RegExp('^' + pattern + '$');
  return exports.$getPxpTreatments(id, params, null, forceApiCall, silent, isElmoExperiment).then(function (experimentResponse) {
    var result;
    (experimentResponse.treatments || []).some(function (treatment) {
      if (!pattern.test(treatment.treatment_name)) {
        return false;
      }
      result = {
        treatment_name: treatment.treatment_name,
        factors: treatment.factors
      };
      return true;
    });
    return result;
  });
}
function $pxpMatch(id, params, patterns, logPayload) {
  if (!patterns) {
    patterns = params;
    params = {};
  }
  return exports.$getPxpTreatments(id, params, logPayload).then(function (pxpResponse) {
    var result = {};
    angular.forEach(patterns, function (pattern, name) {
      pattern = new RegExp('^' + pattern + '$');
      result[name] = false;
      (pxpResponse.treatments || []).some(function (treatment) {
        if (!pattern.test(treatment.treatment_name)) {
          return false;
        }
        result[name] = true;
        return true;
      });
    });
    return result;
  });
}
function $pxpFactors(id, params, pattern) {
  params.factors = 'true';
  return $pxp(id, params, pattern).then(function (pxpResponse) {
    var result;
    if (pxpResponse && pxpResponse.factors) {
      result = {
        treatment_name: pxpResponse.treatment_name
      };
      var pxpFactors = pxpResponse.factors;
      var length = pxpFactors.length;
      for (var i = 0; i < length; i++) {
        result[pxpFactors[i].name] = pxpFactors[i].value;
      }
    }
    return result;
  });
}
function $elmo(id, params, pattern, forceApiCall, silent) {
  if (forceApiCall === void 0) {
    forceApiCall = false;
  }
  if (silent === void 0) {
    silent = true;
  }
  var isElmoExperiment = true;
  return $pxp(id, params, pattern, forceApiCall, silent, isElmoExperiment);
}
window.$pxp = $pxp;
window.$elmo = $elmo;
angular.value("$PXPModel", $PXPModel);
angular.value("$getPxpTreatments", $getPxpTreatments);
angular.value("$pxp", $pxp);
angular.value("$pxpMatch", $pxpMatch);
angular.value("$pxpFactors", $pxpFactors);
angular.value("$elmo", $elmo);
_logger.$logger;
_core.$Model;
_core.$Api;
_core.$util;
_core.$promise;
_core.$event;
_locale.$locale;

/***/ }),

/***/ "../node_modules/ul-inline/dist/inject.js":
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
(function() {

!function(a,b){a.PAYPAL=a.PAYPAL||{},a.PAYPAL.unifiedLogin=b()}(this,function(){function a(a,b){var c,d={src:a,height:b.height||239,style:"width: 100%;",name:b.name||"injectedUl",frameborder:0,scrolling:b.scrolling||"no",title:b.title||"PayPal",sandbox:"allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"},e=document.createElement("iframe");b.hide&&(d.style=d.style+"display: none;");for(c in d)e.setAttribute(c,d[c]);return e}function b(a,b,c){var d,e=a||window.location.origin||window.location.protocol+"//"+window.location.host,f=e+(c||"/signin/inject/"),g=b?"?":"",h=0;if(!b)return f;for(d in b)h>0&&(g+="&"),g=g+d+"="+encodeURIComponent(b[d]),h+=1;return f+g}function c(a){var b,c="";try{if(a.source.name!==q.name)return}catch(d){return}if(b=g(a.origin),!f(b))throw new Error("PostMessage iframe domain ("+b+"), must be a *.paypal.com domain");if(c=a&&a.data,"string"==typeof c)try{c=JSON.parse(c)}catch(h){throw new Error("Invalid JSON string sent to onPostMessage handler: "+c)}c.data&&"resize"===c.data.event?e(q,c.data.heightInPx):c.data&&"htmlRendered"===c.data.event?x=!0:!w&&p?p(c):w&&v.push(c)}function d(a){a&&"resize"===a.event?e(s,a.heightInPx):r(a)}function e(a,b){a.setAttribute("height",b)}function f(a){var b=/\.paypal\.com$/gi;return b.test(a)}function g(a){if(a){var b=/^https?:\/\/(.*\.paypal\.com)(:[0-9]+)?$/gi,c=b.exec(a);return c&&c[1]}}function h(){var a;if(p){for(a=0;a<v.length;a++)p(v[a]);v=[],w=!1}}function i(c){var d,e,h,i,k;if(!c||!c.targetElement)throw h="targetElement",new Error("The "+h+" option is required");if(c.origin&&(i=g(c.origin),!f(i)))throw new Error('All values for the "origin" setting must match *.paypal.com');for(u=c.config||{},e=b(c.origin,c.queryParams,c.iframePathname),k=c.xhrRequest&&c.xhrRequest===!0,d=k||c.preLoadedSource?a("about:blank",u):a(e,u),t=c.targetElement;c.targetElement.hasChildNodes();)c.targetElement.removeChild(c.targetElement.lastChild);return c.targetElement.appendChild(d),"directMessageIframe"===c.iframeType?(s=d,r=c.onPostMessage):(q=d,p=c.onPostMessage,j()),k?n(e,function(a){a&&o(d,a)}):c.preLoadedSource&&o(d,c.preLoadedSource),w=p?!1:!0,{iframe:d,onPostMessageCallback:p}}function j(){window.addEventListener?window.addEventListener("message",c,!1):window.attachEvent("onmessage",c)}function k(a){p=a,h()}function l(){t.parentNode&&t.parentNode.removeChild(t)}function m(b){var c,d,e,f,g="about:blank";if(!x)return void setTimeout(function(){m(b)},50);for(b.onPostMessage&&k(b.onPostMessage),u.hide=!1,c=a(g,u);b.targetElement.hasChildNodes();)b.targetElement.removeChild(b.targetElement.lastChild);b.targetElement.appendChild(c),d=q.contentWindow.document,e=d.documentElement.outerHTML,f=c.contentWindow.document,f.open(),f.write(e),f.close(),l(),q=c,t=b.targetElement}function n(a,b){var c;window.XMLHttpRequest?c=new XMLHttpRequest:window.ActiveXObject&&(c=new ActiveXObject("Microsoft.XMLHTTP")),c&&(c.onreadystatechange=function(){4==c.readyState&&200==c.status&&b(c.responseText)},c.open("GET",a,!0),c.send())}function o(a,b){a.contentWindow.inlineUlContents=b,a.src='javascript:window["inlineUlContents"]'}var p,q,r,s,t,u,v=[],w=!1,x=!1;return{inject:i,copyPasteIframe:m,removeTargetElement:l,messageDispatcher:c,nonPostMessageDispatcher:d}});

}.call(window));

/***/ }),

/***/ "../node_modules/xo-address-components/src/add-address/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddAddressComponent = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/dropdown-multiline/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");
var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");
__webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js");
__webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-address-components/src/add-address/template.html"));
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $xoAddAddressComponent = exports.$xoAddAddressComponent = _squid.$Component.extend('$xoAddAddressComponent', {
  tag: 'xo-add-address',
  template: _template["default"],
  props: {
    address: {
      type: 'var',
      required: false
    },
    isShipping: {
      type: 'var',
      required: false
    },
    isResidential: {
      type: 'var',
      required: false
    },
    country: {
      type: 'var',
      required: false
    },
    metadata: {
      type: 'str',
      required: false
    },
    hideButtonHandler: {
      type: 'var',
      required: false
    },
    hideCep: {
      type: 'var',
      required: false
    },
    hideAddPreferred: {
      type: 'var',
      required: false
    },
    hideName: {
      type: 'var',
      required: false
    },
    triggerLineOneBlur: {
      type: 'var',
      required: false
    },
    triggerZipCodeBlur: {
      type: 'var',
      required: false
    },
    triggerResidentialZipCodeBlur: {
      type: 'var',
      required: false
    },
    residentialErrorContent: {
      type: 'var',
      required: false
    },
    triggerZipCodeKeyPress: {
      type: 'var',
      required: false
    },
    renderBillingAddCheckbox: {
      type: 'var',
      required: false
    }
  },
  controller: ['$scope', '$populate', '$CheckoutAppDataModel', '$ShippingRuleSummaryModel', '$CheckoutPayeeModel', '$CheckoutCartModel', function ($scope, $populate, $CheckoutAppDataModel, $ShippingRuleSummaryModel, $CheckoutPayeeModel, $CheckoutCartModel) {
    // eslint-disable-line max-statements

    $scope.token = _angular.$rootScope.token;
    if ($scope.token) {
      $populate($scope, {
        checkoutCart: $CheckoutCartModel.instance($scope.token).retrieve(),
        checkoutAppData: $CheckoutAppDataModel.instance($scope.token).retrieve(),
        checkoutPayee: $CheckoutPayeeModel.instance($scope.token).retrieve()
      }).then(function () {
        // Snt Flow check
        if ($scope.checkoutAppData.is_snt_supported()) {
          if (_squid.$config.readRulesSummaryFromAppData === true || _squid.$config.readRulesSummaryFromAppData === 'true') {
            _logger.$logger.info('setting_snt_or_callback_flow_for_snt_from_app_data');
            $scope.snt_or_callback_flow = $scope.checkoutAppData.is_snt_enabled();
          } else {
            $populate($scope, {
              profileRulesSummary: $ShippingRuleSummaryModel.instance($scope.token).retrieve({
                params: {
                  merchant_id: $scope.checkoutPayee.merchant.id,
                  currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
                }
              })
            }).then(function () {
              // Variable to determine the county is optional or required for GB SNT and CALLBACK flows.
              // with out being the county required, shipping methods won't populate.
              // JIRA ID : PPPLMER-71514
              _logger.$logger.info('setting_snt_or_callback_flow_for_snt');
              $scope.snt_or_callback_flow = !!($scope.profileRulesSummary && $scope.profileRulesSummary.isSnTEnabled);
            });
          }
        } else if ($scope.checkoutCart.instantUpdateIntegration) {
          _logger.$logger.info('setting_snt_or_callback_flow_for_callback');
          $scope.snt_or_callback_flow = true;
        }
      });
    }
    var sortStates;
    var country = $scope.country || $scope.address && $scope.address.country;
    $scope.country = country;
    $scope.locale = _squid.$locale;
    $scope.metadata = _squid.$MetadataModel.create();

    // If the user changes their shipping/billing address country, fetch that metadata (if needed) and re-render.
    $scope.$watch('country', function () {
      $scope.metadata.choose($scope.country, $scope.locale.lang);
      onCountryChange();
    });
    function onCountryChange() {
      sortStates = (0, _squid.$feature)('sortStatesForAddress', false, $scope.country);
      if (sortStates) {
        getSortedStateList();
      }
    }
    onCountryChange();

    // If the user changes languagle toggle, fetch that metadata (if needed) and re-render.
    $scope.$on('contentChange', function () {
      $scope.metadata.choose($scope.country, $scope.locale.lang);
    });

    /**
     * Prefix to use for `id`, `name`, and `for` attributes. This is needed because Xoon will sometimes display both billing
     * and shipping address forms on the same page and without a prefix there will be duplicte `id`s and `name`s on the page.
     */
    $scope.attrPrefix = $scope.isShipping ? 'shipping' : 'billing';
    if ($scope.isResidential) {
      $scope.attrPrefix = 'residential';
    }
    $scope.$watch('address.state', function () {
      _angular.$rootScope.$emit($scope.attrPrefix + "AddressStateChange", $scope.address);
    });
    $scope.normalizeCountry = function (countryCode) {
      return (0, _squid.$feature)('AddressFormat', countryCode, countryCode) || countryCode;
    };
    $scope.isAddPreferred = (0, _squid.$feature)('preferredShipping', false, $scope.country) && $scope.isShipping;
    $scope.isAddressLookupEnabled = (0, _squid.$feature)('addressLookup', false, $scope.country);
    $scope.isShowLookupFields = $scope.isAddressLookupEnabled;
    if ($scope.isShowLookupFields) {
      // Show the Address Lookup Fields only when the hideButtonHandler function is passed by the caller.
      if ($scope.hideButtonHandler) {
        $scope.hideButtonHandler(true);
      } else {
        $scope.isShowLookupFields = false;
      }
    }
    function getSortedStateList() {
      var states = _squid.$locale.content.get(sortStates, {});
      var statesList = [];
      angular.forEach(states, function (key, value) {
        statesList.push({
          code: value,
          sname: key
        });
      });
      statesList.sort(function (a, b) {
        return a.sname.localeCompare(b.sname);
      });
      $scope.sortedStatesList = statesList;
    }
    $scope.formatZip = function () {
      var unformatted = $scope.address.postal_code && $scope.address.postal_code.replace(/[^0-9]/gi, '');
      var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3)]].map(function (x) {
        return x[1] && x[0] + x[1] || '';
      }).join('');
      $scope.address.postal_code = formatted;
    };
    function getAddress(address) {
      var COMMA = ', ';
      var SPACE = ' ';
      var line1;
      var line2;
      function prefix(str, prefixStr) {
        if (str) {
          return (prefixStr ? prefixStr : '') + str;
        }
        return '';
      }
      if (!address.deliveryAddresses || angular.isArray(address.deliveryAddresses) && address.deliveryAddresses.length === 0) {
        // if deliveryAddresses is not an array or is empty
        // line would be empty, hence return to caller.
        return;
      }
      var array = address.deliveryAddresses;
      if (array.length > 1) {
        // populate line2 from the last element
        line2 = array.pop();
      }
      line1 = array.join(COMMA);
      var displayLine1 = line1 + prefix(line2, COMMA);
      var displayLine2 = prefix(address.city) + prefix(address.state, COMMA) + prefix(address.postal_code, SPACE);
      var displayLine3 = prefix(address.country);
      return {
        line1: line1,
        line2: line2,
        city: address.city,
        state: address.state,
        postal_code: address.postal_code,
        country: address.country,
        displayLine1: displayLine1,
        displayLine2: displayLine2,
        displayLine3: displayLine3,
        dropDownAddress: displayLine1 + prefix(displayLine2, ' \\n ') + prefix(displayLine3, ' \\n ')
      };
    }
    function populateAddressFormFields(address) {
      $scope.address.line1 = address.line1;
      $scope.address.line2 = address.line2;
      $scope.address.city = address.city;
      $scope.address.state = address.state;
      $scope.address.postal_code = address.postal_code;
      $scope.address.neighborhood = address.neighborhood;
    }

    /**
     * Show error message and display the full-address fields
     */
    function populateErrorMessage() {
      var messages = [];
      messages.push($scope.locale.content.get('addressBook.lookupError'));
      $scope.lookupFailureMessage = {
        msgs: messages,
        type: 'warning'
      };
      $scope.isShowLookupFields = false;
      $scope.isLookupFailure = true;
    }
    function processLookupResult(list) {
      if (list.length > 1) {
        // Show drop-down list of all addresses
        $scope.isLookupSuccess = true;
        $scope.isShowLookupDropDown = true;
        $scope.lookupAddressList = list.map(function (addr) {
          return getAddress(addr);
        });
      } else if (list.length === 1) {
        // Show single address component
        $scope.isLookupSuccess = true;
        $scope.isShowLookupDropDown = false;
        var address = getAddress(list[0]);
        $scope.singleAddress = address;
        populateAddressFormFields(address);
      } else {
        populateErrorMessage();
      }
    }
    if ($scope.address) {
      $scope.lastPrefilledZip = $scope.address.postal_code;
    }
    $scope.prefill = function () {
      var cepPattern = /^(\d{5}-\d{3}|\d{5}|\d{8})$/;
      var first_name;
      var last_name;
      if ($scope.lastPrefilledZip === $scope.address.postal_code || !cepPattern.test($scope.address.postal_code)) {
        return;
      }
      if ($scope.isShipping) {
        first_name = $scope.address.first_name;
        last_name = $scope.address.last_name;
      }
      $scope.prefillAddress = new _index.$PrefillAddressModel({
        id: $scope.token,
        address: {
          country: $scope.address.country,
          postal_code: $scope.address.postal_code
        }
      });
      return $scope.prefillAddress.save({
        data: $scope.prefillAddress,
        success: function success(result) {
          if (result) {
            populateAddressFormFields(result);
            $scope.lastPrefilledZip = $scope.address.postal_code;
            if ($scope.isShipping) {
              $scope.address.first_name = first_name;
              $scope.address.last_name = last_name;
            }
          }
        }
      });
    };
    $scope.findAddress = function () {
      $scope.lookupAddress = _index.$PrefillAddressModel.create($scope.token, {
        address: {
          country: $scope.address.country,
          postal_code: $scope.address.postal_code,
          house_number: $scope.address.house_number,
          building_name: $scope.address.building_name
        }
      });
      if (document.querySelector('#lookupZip.ng-invalid')) {
        document.querySelector('#addressLookupFields').classList.add('validated');
      } else {
        $scope.isLookupProcessing = true;
        $scope.lookupAddress.save({
          data: $scope.lookupAddress,
          silent: true,
          success: function success(result) {
            processLookupResult(result);
            $scope.hideButtonHandler(false);
          },
          contingencies: {
            INTERNAL_ERROR: populateErrorMessage
          }
        });
      }
    };
    $scope.changeAddressDropDown = function () {
      populateAddressFormFields($scope.address.selectedAddress);
    };
    $scope.showFullAddress = function () {
      $scope.isShowLookupFields = false;
      $scope.hideButtonHandler(false);
    };

    /**
     * Pass an array of group names to retrieve the list of states
     * e.g. ['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies']
     */
    var stateNamesInGroup = [];
    $scope.retrieveStateNamesInGroup = function (groups) {
      if (stateNamesInGroup.length) {
        // Angular keeps watching for this method as its used in ng-model, hence return cached data.
        return stateNamesInGroup;
      }
      var content = _squid.$locale.content;
      angular.forEach(groups, function (group) {
        var groupName = content.common[group];
        var statesList = content[group];
        angular.forEach(statesList, function (value, key) {
          stateNamesInGroup.push({
            key: key,
            value: value,
            group: groupName
          });
        });
      });
      return stateNamesInGroup;
    };
    $scope.zipCodeBlur = function () {
      if ($scope.triggerZipCodeBlur) {
        _angular.$rootScope.$emit('zip_code_blur');
      }
      if ($scope.triggerResidentialZipCodeBlur) {
        _angular.$rootScope.$emit('zip_code_blur_residential');
      }
    };
    $scope.lineOneBlur = function () {
      if ($scope.triggerLineOneBlur) {
        _angular.$rootScope.$emit('line_1_blur');
      }
      if ($scope.isResidential) {
        $scope.clearResidentialError();
      }
    };
    $scope.lineOneChange = function () {
      if ($scope.isResidential) {
        $scope.clearResidentialError();
      }
    };
    $scope.zipCodeKeyPress = function (event) {
      if ($scope.triggerZipCodeKeyPress) {
        _angular.$rootScope.$emit('zip_code_keypress', {
          event: event
        });
      }
    };
    $scope.residentialError = '';
    $scope.setResidentialError = function () {
      // @TODO: adapt to xo-content or error-tooltip (currently doesnt update the data-error-key with new content)
      $scope.residentialError = $scope.residentialErrorContent;
      document.getElementById('residentialLine1').classList.add('backendError');
      document.getElementById('residentialError').classList.add('visibleResidentialError');
    };
    $scope.clearResidentialError = function () {
      // Clear Residential error
      if ($scope.residentialError.length > 0) {
        document.getElementById('residentialError').classList.remove('visibleResidentialError');
        document.getElementById('residentialLine1').classList.remove('backendError');
        $scope.residentialError = '';
      }
    };
  }],
  lifecycle: {
    populate: function populate() {
      if (this.props.residentialErrorContent) {
        this.setResidentialError();
      }
    }
  }
});
angular.value("$xoAddAddressComponent", $xoAddAddressComponent);
_angular.$rootScope;
_squid.$Component;
_squid.$config;
_squid.$feature;
_squid.$locale;
_squid.$MetadataModel;
_index.$PrefillAddressModel;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-address-components/src/add-address/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"addressForm\" class=\"addressForm\" content ng-class=\"country\">\n    <xo-name-input user=\"address\" country=\"{{country}}\" ng-if=\"isShipping && !hideName\" attr-prefix=\"attrPrefix\"></xo-name-input>\n    <div ng-switch=\"normalizeCountry(country)\" class=\"addressGroup clearfix\">\n        <div ng-switch-when=\"BR\">\n            <xo-zipcode id=\"zipcode\" prefix-attrs-with=\"{{attrPrefix}}\" attr-prefix=\"attrPrefix\" country=\"BR\" address=\"address\"\n                zip-label=\"{{content('common.cep')}}\" zip-error-key=\"common.valueInvalid\" done-fn=\"prefill\" ng-if=\"!hideCep\"></xo-zipcode>\n\n            <div id=\"addressFields\" prefix-attrs-with=\"{{attrPrefix}}\">\n                <div class=\"streetName clearfix\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" ng-blur=\"lineOneBlur()\" ng-keypress=\"lineOneChange()\" value=\"\"\n                            maxlength=\"60\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip required prefix-attrs-with=\"{{attrPrefix}}\"/>\n                        <div ng-if=\"isResidential\" id=\"residentialError\" class=\"errorTooltip errorTooltipRuleSpecific ng-binding ng-scope\">\n                                {{ residentialError }}\n                        </div>    \n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.streetAddress') }}\n                        </label>\n                    </div>\n                    <div class=\"inputField streetNumber\" floating-label>\n                        <input type=\"text\" name=\"streetNumber\" id=\"streetNumber\" ng-pattern=\"/^(?=.*[0-9])([a-zA-Z0-9]+)$/\"\n                            ng-model=\"address.streetNumber\" value=\"\" maxlength=\"6\" ariaRequired=\"true\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                        <label for=\"streetNumber\" id=\"streetNumberLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.streetNumber') }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\"\n                        maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential neighborhood\" floating-label>\n                    <input type=\"text\" name=\"neighborhood\" id=\"neighborhood\" ng-model=\"address.neighborhood\"\n                        value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\" ariaRequired=\"true\"\n                        data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"neighborhood\" id=\"neighborhoodLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.neighborhood') }}\n                    </label>\n                </div>\n                <div class=\"inputField confidential clearfix\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip required />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.onlyCity') }}</label>\n                    </div>\n                    <div class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-options=\"state.code as state.sname for state in sortedStatesList\"\n                            ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"true\"\n                            data-test-id=\"BR:addressProvince\" prefix-attrs-with=\"{{attrPrefix}}\" required >\n                            <option value=\"\">{{ content('common.otherState') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.otherState') }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div ng-switch-when=\"GB\">\n            <!-- start: Show all the fields for Add Address if isShowLookupFields is false -->\n            <div ng-if=\"!isShowLookupFields\">\n                <div ng-if=\"isAddressLookupEnabled\">\n                    <div ng-if=\"isShipping\" class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                    </div>\n                    <div ng-show=\"isLookupFailure\" class=\"lookupFailureMsg\">\n                        <xo-message message=\"lookupFailureMessage\"></xo-message>\n                    </div>\n                </div>\n                <div class=\"inputField confidential line1\" floating-label>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" ng-blur=\"lineOneBlur()\" ng-keypress=\"lineOneChange()\" value=\"\" maxlength=\"50\"\n                        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" \n                        data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                        <div ng-if=\"isResidential\" id=\"residentialError\" class=\"errorTooltip errorTooltipRuleSpecific ng-binding ng-scope\">\n                            {{ residentialError }}\n                        </div>\n                    <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress') }}</label>\n                </div>\n                <div class=\"inputField confidential line2\" floating-label>\n                    <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\"\n                        autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.streetAddress2') }}</label>\n                </div>\n                <div class=\"inputField confidential city\" floating-label>\n                    <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.onlyCity') }}</label>\n                </div>\n                <div class=\"stateZip clearfix\">\n                    <div class=\"dropdown confidential state inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"state\" ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\"\n                                aria-required=\"true\" prefix-attrs-with=\"{{attrPrefix}}\" ng-required=\"snt_or_callback_flow\"\n                                ng-options=\"c.key as c.value group by c.group for c in retrieveStateNamesInGroup(['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies'])\">\n                                <option value=\"\">{{ snt_or_callback_flow ? content('common.county') : content('common.countyOptional') }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ snt_or_callback_flow ? content('common.county') : content('common.countyOptional') }}</label>\n                    </div>\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" ng-blur=\"zipCodeBlur()\"  ng-keypress=\"zipCodeKeyPress()\"\n                            autocomplete=\"off\" data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                        \"country\": \"GB\"\n                                    }\n                                }'\n                            xo-error-tooltip required />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ content('common.zip') }}</label>\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show all the fields -->\n            <!-- start: Show only the address lookup fields -->\n            <div ng-if=\"isShowLookupFields\" id=\"addressLookup\" class=\"addressLookup\" prefix-attrs-with=\"{{attrPrefix}}\">\n                <div ng-hide=\"isLookupSuccess\" id=\"addressLookupFields\" prefix-attrs-with=\"{{attrPrefix}}\"> <!-- class=\"validated\" -->\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addBillingAddress.lookupTitle') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">{{ content('addressBook.enterFullAddress') }}</a>\n                    </div>\n                    <div class=\"fieldGroup\">\n                        <div class=\"inputField confidential lookupZip\">\n                            <input type=\"text\" name=\"lookupZip\" id=\"lookupZip\" ng-model=\"address.postal_code\" value=\"\"\n                                autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                                data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                xo-validation='{\n                                    \"validator\": \"validZip\",\n                                    \"options\": {\n                                    \"country\": \"GB\"\n                                    }\n                                }'\n                                ng-disabled=\"isLookupProcessing\" xo-error-tooltip required />\n                            <label for=\"lookupZip\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                                {{ content('common.zip') }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"inputField confidential houseNo\" floating-label>\n                        <input type=\"text\" id=\"houseNo\" name=\"houseNo\" ng-model=\"address.house_number\"\n                            value=\"\" maxlength=\"50\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            autocapitalize=\"off\" aria-required=\"false\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" xo-error-tooltip\n                            ng-disabled=\"isLookupProcessing\" />\n                        <label for=\"houseNo\" id=\"houseNoLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.houseBldgNo') }}\n                        </label>\n                    </div>\n                    <div class=\"inputField confidential buildingName\" floating-label>\n                        <input type=\"text\" id=\"buildingName\" ng-model=\"address.building_name\"\n                            value=\"\" maxlength=\"50\" autocapitalize=\"off\" autocomplete=\"off\"\n                            data-error-key=\"common.valueInvalid\" name=\"buildingName\"\n                            ng-disabled=\"isLookupProcessing\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"buildingName\" id=\"buildingNameLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ content('common.houseBldgName') }}\n                        </label>\n                    </div>\n                    <button track-submit ng-click=\"findAddress()\" id=\"findAddressButton\" class=\"btn full continue\"\n                            ng-class=\"{processing: isLookupProcessing}\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        <div ng-show=\"isLookupProcessing\" class=\"spinner\">\n                            <p class=\"loader\" ></p>\n                        </div>\n                        <div ng-hide=\"isLookupProcessing\" class=\"text\">{{ content('addressBook.findAddress') }}</div>\n                    </button>\n                </div>\n                <div ng-show=\"isLookupSuccess\">\n                    <div class=\"lookupHeading\">\n                        <span class=\"lookupTitle\">{{ content('addressBook.address') }}</span>\n                        <a class=\"editAddress\" ng-click=\"showFullAddress()\">\n                            {{ content('common.change') }}\n                        </a>\n                    </div>\n                    <div ng-if=\"isShowLookupDropDown\" id=\"lookedupDropDown\"\n                        class=\"dropdown confidential clearfix\" prefix-attrs-with=\"{{attrPrefix}}\">\n\n                        <select xo-dropdown-multiline ng-model=\"address.selectedAddress\"\n                                ng-change=\"changeAddressDropDown()\" prefix-attrs-with=\"{{attrPrefix}}\"\n                                id=\"addressDropDown\" ng-required=\"isShowLookupDropDown\">\n                            <option value=\"\" selected=\"selected\">\n                                {{ content('addressBook.selectYourAddress', { count: lookupAddressList.length}) }}\n                            </option>\n                            <option ng-repeat=\"addr in lookupAddressList track by $index\" value=\"{{$index}}\">\n                                {{ addr.dropDownAddress }}\n                            </option>\n                        </select>\n                    </div>\n                    <div ng-hide=\"isShowLookupDropDown\" class=\"singleAddress\">\n                        {{ singleAddress.displayLine1 }}<br/>\n                        {{ singleAddress.displayLine2 }}<br/>\n                        {{ singleAddress.displayLine3 }}\n                    </div>\n                </div>\n            </div>\n            <!-- end: Show only the address lookup fields -->\n        </div>\n        <!-- GB end -->\n        <!-- IE begin -->\n        <div ng-switch-when=\"IE\">\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout track by $index\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" ng-blur=\"lineOneBlur()\" ng-keypress=\"lineOneChange()\" value=\"\" maxlength=\"50\"\n                            autocapitalize=\"off\" aria-required=\"{{layoutItem.required}}\" autocomplete=\"off\" \n                            data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <div ng-if=\"isResidential\" id=\"residentialError\" class=\"errorTooltip errorTooltipRuleSpecific ng-binding ng-scope\">\n                            {{ residentialError }}\n                        </div>    \n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line1Label || metadata.addressEntry.strings[country].line1Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" ng-model=\"address.line2\" value=\"\" prefix-attrs-with=\"{{attrPrefix}}\"\n                            xo-error-tooltip maxlength=\"50\" aria-required=\"{{layoutItem.required}}\" ng-required=\"{{layoutItem.required}}\"\n                            autocapitalize=\"off\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\" />\n                        <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line2Label || metadata.addressEntry.strings[country].line2Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"{{layoutItem.required}}\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].cityLabel || metadata.addressEntry.strings[country].cityLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList\"\n                        class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown prefix-attrs-with=\"{{attrPrefix}}\"\n                            ng-options=\"state.$id as state.$id for state in (locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\"\n                            ng-model=\"address.state\" id=\"state\" aria-labelledby=\"stateLabel\" aria-required=\"{{layoutItem.required}}\" ng-required=\"{{layoutItem.required}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateList }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                    <!-- state input field is not marked as required as OAS is currently not validating state field for empty value or for any regex check -->\n                    <div ng-if=\"!(locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\" class=\"inputField confidential state\"\n                        floating-label>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\"\n                            autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                </div>\n                <!-- postalcode input field is not marked as required as OAS is currently not validating state field for empty value or for any regex check -->\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <div class=\"inputField confidential postalCode\" floating-label>\n                        <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" ng-blur=\"zipCodeBlur()\"\n                            ng-keypress=\"zipCodeKeyPress()\" value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                            data-error-key=\"validation.validZipCode\" maxlength=\"{{layoutItem.maxLength}}\" xo-error-tooltip prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"postalCode\" id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].postcodeLabel || metadata.addressEntry.strings[country].postcodeLabel }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <!-- IE end -->\n\n        <div ng-switch-default>\n            <!-- Griffin metadata DOES exist for this country -->\n            <div ng-if=\"metadata.addressEntry.layout\" ng-repeat=\"layoutItem in metadata.addressEntry.layout track by $index\">\n                <div ng-if=\"layoutItem.$ === 'line1'\">\n                    <div class=\"inputField confidential line1\" floating-label directionality>\n                        <input type=\"text\" name=\"line1\" id=\"line1\" ng-model=\"address.line1\" ng-blur=\"lineOneBlur()\" ng-keypress=\"lineOneChange()\" value=\"\" maxlength=\"50\"\n                            track-focus-and-blur=\"line1\"\n                            autocapitalize=\"off\" aria-required=\"{{layoutItem.required}}\" autocomplete=\"off\" \n                            data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <div ng-if=\"isResidential\" id=\"residentialError\" class=\"errorTooltip errorTooltipRuleSpecific ng-binding ng-scope\">\n                                {{ residentialError }}\n                        </div>\n                        <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line1Label || metadata.addressEntry.strings[country].line1Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'line2'\">\n                    <div class=\"inputField confidential line2\" floating-label directionality>\n                        <input type=\"text\" name=\"line2\" id=\"line2\" aria-required=\"{{layoutItem.required}}\" ng-model=\"address.line2\" value=\"\" maxlength=\"50\"\n                            track-focus-and-blur=\"line2\"\n                            xo-error-tooltip autocapitalize=\"off\" autocomplete=\"off\" ng-required=\"{{layoutItem.required}}\" data-error-key=\"common.valueInvalid\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"line2\" id=\"line2Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].line2Label || metadata.addressEntry.strings[country].line2Label }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'city'\">\n                    <div class=\"inputField confidential city\" floating-label directionality>\n                        <input type=\"text\" name=\"city\" id=\"city\" maxLength=\"100\" ng-model=\"address.city\" value=\"\"\n                            track-focus-and-blur=\"city\"\n                            autocapitalize=\"off\" aria-required=\"{{layoutItem.required}}\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                            xo-error-tooltip ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].cityLabel || metadata.addressEntry.strings[country].cityLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'state'\">\n                    <div ng-if=\"locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList\"\n                        class=\"dropdown confidential state nullable inputField\" floating-label-dropdown>\n                        <select name=\"state\" xo-dropdown ng-options=\"state.$id.toUpperCase() as state.$elt for state in (locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\"\n                            track-focus-and-blur=\"state\"\n                            ng-model=\"address.state\" id=\"state\" aria-required=\"{{layoutItem.required}}\" ng-required=\"{{layoutItem.required}}\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            <option value=\"\">{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}</option>\n                        </select>\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                    <!-- state input field is not marked as required as OAS is currently not validating state field for empty value or for any regex check -->\n                    <div ng-if=\"!(locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateList || metadata.addressEntry.strings[country].stateList)\" class=\"inputField confidential state\"\n                        floating-label directionality>\n                        <input type=\"text\" name=\"state\" id=\"state\" ng-model=\"address.state\" value=\"\" autocapitalize=\"off\"\n                            track-focus-and-blur=\"state\"\n                            aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                        <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                            {{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].stateLabel || metadata.addressEntry.strings[country].stateLabel }}\n                        </label>\n                    </div>\n                </div>\n                <div ng-if=\"layoutItem.$ === 'postcode'\">\n                    <xo-zipcode id=\"zipcode\" zip-entry=\"layoutItem\" country=\"{{country}}\"\n                                max-length=\"layoutItem.maxLength\" address=\"address\" attr-prefix=\"attrPrefix\"\n                                done-fn=\"zipCodeBlur\" prefix-attrs-with=\"{{attrPrefix}}\" aria-required=\"{{layoutItem.required}}\"\n                                key-press-fn=\"zipCodeKeyPress\" zip-required=\"layoutItem.required\"\n                                zip-label=\"{{ locale.metadata.addressEntry.strings[country] && locale.metadata.addressEntry.strings[country].postcodeLabel || metadata.addressEntry.strings[country].postcodeLabel }}\"\n                                zip-error-key=\"validation.validZipCode\"></xo-zipcode>\n                </div>\n            </div>\n            <!-- Griffin metadata DOES NOT exist for this country -->\n            <div ng-if=\"!metadata.addressEntry.layout\">\n                <div class=\"inputField confidential line1\" floating-label directionality>\n                    <input type=\"text\" name=\"line1\" id=\"line1\" data-test-id=\"addrSt\" ng-model=\"address.line1\" ng-blur=\"lineOneBlur()\"\n                        value=\"\" maxlength=\"50\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\"\n                        track-focus-and-blur=\"line1\"\n                        data-error-key=\"common.valueInvalid\"\n                        xo-error-tooltip required prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <div ng-if=\"isResidential\" id=\"residentialError\" class=\"errorTooltip errorTooltipRuleSpecific ng-binding ng-scope\">\n                            {{ residentialError }}\n                    </div>    \n                    <label for=\"line1\" id=\"line1Label\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.stAddress') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential city\" floating-label directionality>\n                    <input type=\"text\" name=\"city\" id=\"city\"data-test-id=\"addrCity\" maxLength=\"100\" ng-model=\"address.city\"\n                        track-focus-and-blur=\"city\"\n                        value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" data-error-key=\"common.valueInvalid\"\n                        prefix-attrs-with=\"{{attrPrefix}}\" xo-error-tooltip required />\n                    <label for=\"city\" id=\"cityLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.otherCity') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential state\" floating-label directionality>\n                    <input type=\"text\" name=\"state\" id=\"state\" data-test-id=\"addrState\" ng-model=\"address.state\"\n                        track-focus-and-blur=\"state\"\n                        value=\"\" autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" prefix-attrs-with=\"{{attrPrefix}}\" />\n                    <label for=\"state\" id=\"stateLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.optionalState') }}\n                    </label>\n                </div>\n\n                <div class=\"inputField confidential postalCode\" floating-label directionality>\n                    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" data-test-id=\"addrZipcode\" ng-model=\"address.postal_code\"\n                        track-focus-and-blur=\"postalCode\"\n                        value=\"\"  ng-blur=\"zipCodeBlur()\" ng-keypress=\"zipCodeKeyPress()\" autocapitalize=\"off\" aria-required=\"true\"\n                        autocomplete=\"off\" data-error-key=\"validation.validZipCode\" prefix-attrs-with=\"{{attrPrefix}}\"/>\n                    <label for=\"postalCode\" id=\"zipLabel\" prefix-attrs-with=\"{{attrPrefix}}\">\n                        {{ content('common.optionalPostalCode') }}\n                    </label>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"isAddPreferred && !hideAddPreferred\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\" ng-model=\"address.preferred_address\" name=\"addPreferred\" id=\"addPreferred\" />\n        <label for=\"addPreferred\">{{ content('memberReview.makePreferredShipping') }}</label>\n    </div>\n\n    <div ng-if=\"renderBillingAddCheckbox\" class=\"addPreferredShipping sCheckbox checkbox\">\n        <input type=\"checkbox\"  ng-model=\"address.isBA\" name=\"isBA\" id=\"addVenmoBA\" />\n        <label for=\"addVenmoBA\">{{ content('memberReview.useShippingAsBilling') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAddressDisplayComponent = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-address-components/src/address-display/template.html"));
__webpack_require__("../node_modules/xo-address-components/src/address-display/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $xoAddressDisplayComponent = exports.$xoAddressDisplayComponent = _squid.$Component.extend('$xoAddressDisplayComponent', {
  tag: 'xo-address-display',
  template: _template["default"],
  props: {
    address: {
      type: 'var',
      required: false
    },
    showPreferred: {
      type: 'str',
      required: false
    },
    countryCode: {
      type: 'var',
      required: false
    },
    displayFormattedAddr: {
      type: 'var',
      required: false
    }
  },
  actions: {
    formatAddress: function formatAddress(address) {
      var COMMA = ', ';
      var SPACE = ' ';
      function prefix(str, prefixStr) {
        if (str) {
          return (prefixStr ? prefixStr : '') + str;
        }
        return '';
      }
      var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
      var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
      var displayLine3 = address.country ? prefix(address.country) : '';
      return {
        displayLine1: displayLine1,
        displayLine2: displayLine2,
        displayLine3: displayLine3
      };
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this = this;
      var address = this.props.address || {};
      var countryCode = typeof this.props.countryCode === 'undefined' ? address.country || address.country_code : this.props.countryCode;
      this.isPreferred = this.props.showPreferred && address.preferred_address && (0, _squid.$feature)('preferredShipping', false, countryCode);
      if (this.props.displayFormattedAddr) {
        this.formattedAddr = this.actions.formatAddress(address);
        this.$watchCollection('props.address', function (newVal) {
          _this.formattedAddr = _this.actions.formatAddress(newVal);
        });
      }
    }
  }
});
angular.value("$xoAddressDisplayComponent", $xoAddressDisplayComponent);
_squid.$Component;
_squid.$feature;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-display/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"adr\" ng-class=[props.countryCode] content>\n    <div ng-if=\"props.address.full_address && !props.displayFormattedAddr\" class=\"confidential\">\n        <span class=\"full-address\" directionality-text=\"props.address.full_address\" data-test-id=\"fullAddress\">{{props.address.full_address}}</span>\n        <span class=\"country adr-break\">{{content('countryList.'+props.address.country)}}</span>\n    </div>\n\n    <div ng-if=\"props.displayFormattedAddr\" class=\"shippingAddress\">\n        {{formattedAddr.displayLine1}}<br/>\n        {{formattedAddr.displayLine2}}<br/>\n        {{formattedAddr.displayLine3}}\n    </div>\n\n    <div ng-if=\"isPreferred\" class=\"preferred\">\n        <span>\n            {{content('shippingAddress.preferred')}}\n        </span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/address/index.js");
__webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js");
__webpack_require__("../node_modules/xo-tray-height/dist/directive.js");
__webpack_require__("../node_modules/xo-address-components/src/address-normalization/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-address-components/src/address-normalization/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('xoAddressNormalization', function () {
  return {
    template: _template["default"],
    scope: {
      id: '=?',
      address: '=?',
      doneFn: '=?',
      sidebar: '=?',
      hideBackButton: '=?'
    },
    controller: ['$scope', function ($scope) {
      _squid.$util.assert($scope.address, 'Original Address cannot be empty');
      $scope.showNormalization = false;
      var normalize = (0, _squid.$feature)('addressNormalization', false, $scope.address.country);
      if (!normalize) {
        $scope.doneFn($scope.address, false);
        return;
      }
      var userEnteredAddress;
      var addrFormat = (0, _squid.$feature)('FormatAddressForNormalization', $scope.address.country, $scope.address.country);
      $scope.addressSelected = 'normalizedAddress';
      $scope.transitionName = 'address_normalization_normalizedAddress';

      // Brazil specific format
      if (addrFormat === 'AddressBR') {
        userEnteredAddress = angular.fromJson(angular.toJson($scope.address));
        userEnteredAddress.line1 = $scope.address.line1 + '  ' + $scope.address.streetNumber;
        userEnteredAddress.line2 = $scope.address.neighborhood;
      }
      $scope.servAddress = userEnteredAddress ? userEnteredAddress : $scope.address;
      $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
      $scope.addressNormalization = new _index.$AddressNormalizationModel({
        id: $scope.id,
        address: $scope.servAddress
      });
      function centerLightBox() {
        var element = $('#lbox');
        if (!element.length) {
          return;
        }
        var windowElement = $(window);
        var lboxContainerElem = $('#lboxContainer');
        element.css('top', Math.max(0, (windowElement.height() - element.outerHeight()) / 2) + 'px');
        element.css('width', '65%');
        var computedLeft = (windowElement.width() - element.outerWidth()) / 2;
        var leftBound = lboxContainerElem.offset().left + lboxContainerElem.width() * 0.1;
        var elementLeft = computedLeft < leftBound ? leftBound : computedLeft;
        if (computedLeft < leftBound) {
          element.css('width', lboxContainerElem.width() * 0.8);
        }
        element.css('left', Math.max(0, elementLeft) + 'px');
        return element;
      }
      function trinityResponseCallback() {
        $scope.showNormalization = true;

        // default behavior of $timeout with no 2nd param is to wait for dom to finish rendering before executing callback
        (0, _angular.$timeout)(function () {
          centerLightBox();
          $(window).resize(centerLightBox);
        });
      }
      $scope.addressNormalization.save({
        data: $scope.addressNormalization,
        contingencies: {
          VALIDATION_ERROR: function VALIDATION_ERROR() {
            trinityResponseCallback();
            $scope.transitionName = 'address_normalization_enteredAddress';
            return;
          }
        },
        success: function success(result) {
          trinityResponseCallback();
          if (result === false) {
            // trinity doesn't find any match
            $scope.transitionName = 'address_normalization_enteredAddress';
            return;
          }
          $scope.normalizedAddress = result;
          $scope.normalizedAddress.normalization_status = 'NORMALIZED';
          if (addrFormat === 'AddressBR') {
            $scope.normalizedAddress.line1 = $scope.normalizedAddress.streetName + '  ' + $scope.normalizedAddress.streetNumber;
            $scope.normalizedAddress.line2 = $scope.normalizedAddress.neighborhood;
          }

          // if the two addresses equal, no need to show the panel
          if ($scope.isEqual($scope.normalizedAddress, $scope.servAddress)) {
            if ($scope.servAddress.preferred_address) {
              $scope.normalizedAddress.preferred_address = true;
            }
            if (addrFormat === 'AddressBR' && $scope.address.line2) {
              $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
            }
            $scope.callback($scope.normalizedAddress, false);
          } else if (addrFormat === 'AddressBR' && $scope.address.line2) {
            $scope.normalizedAddress.line1 = $scope.normalizedAddress.line1 + '  ' + $scope.address.line2;
          }
        },
        error: trinityResponseCallback
      });

      // make space and case insensitive. sub empty vals for undefined.
      function desensitizedAddress(addr) {
        for (var key in addr) {
          var val = addr[key];
          if (addr.hasOwnProperty(key)) {
            if (val && val.length) {
              addr[key] = val.trim().toLowerCase();
            } else {
              addr[key] = undefined;
            }
          }
        }
        return addr;
      }

      // check if the two address are the same
      $scope.isEqual = function (address1, address2) {
        var addressOne = desensitizedAddress(JSON.parse(JSON.stringify(address1)));
        var addressTwo = desensitizedAddress(JSON.parse(JSON.stringify(address2)));
        if (!addressOne || !addressTwo) {
          return false;
        }
        return addressOne.line1 === addressTwo.line1 && addressOne.line2 === addressTwo.line2 && addressOne.city === addressTwo.city && addressOne.state === addressTwo.state && addressOne.postal_code === addressTwo.postal_code && addressOne.country === addressTwo.country;
      };

      // Australia displays address line2 first
      $scope.isLine2First = function () {
        return $scope.address.country === 'AU';
      };
      $scope.onBack = function () {
        $scope.callback($scope.address, true);
      };
      $scope.selection = function (value) {
        $scope.transitionName = 'address_normalization_' + value;
      };
      $scope.onContinue = function () {
        $scope.addressSelected = this.addressNormalizationForm.addressSelected;
        if ($scope.addressSelected && $scope.addressSelected.$modelValue === 'normalizedAddress') {
          if ($scope.servAddress.preferred_address) {
            $scope.normalizedAddress.preferred_address = true;
          }
          $scope.callback($scope.normalizedAddress, false);
        } else {
          $scope.servAddress.normalization_status = 'UNNORMALIZED_USER_PREFERRED';
          if (addrFormat === 'AddressBR' && $scope.address.line2) {
            $scope.servAddress.line1 = $scope.servAddress.line1 + ' ' + $scope.address.line2;
          }
          $scope.callback($scope.servAddress, false);
        }
      };
      $scope.callback = function (address, isBack) {
        $scope.doneFn(address, isBack);
      };
    }]
  };
});
_angular.$timeout;
_squid.$feature;
_squid.$util;
_index.$AddressNormalizationModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$AddressNormalizationRoute = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-address-components/src/address-normalization/directive.js");
var $AddressNormalizationRoute = exports.$AddressNormalizationRoute = _squid.$ComponentRoute.extend('AddressNormalizationRoute', {
  name: 'addressNormalization',
  titleContent: 'addressNormalization.addressmatch',
  directive: 'xo-address-normalization',
  trackingData: {
    fptiState: 'address_normalization',
    buzname: {
      'fullpage': {
        'pagename': '%::address_normalization',
        'pagename2': '%::address_normalization:member:hermes:',
        'version': 'member:%:'
      }
    }
  },
  loginRequired: true,
  children: []
});
angular.value("$AddressNormalizationRoute", $AddressNormalizationRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-address-components/src/address-normalization/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"showNormalization\" content id=\"addressNormalization\" xo-tray-height>\n    <xo-aside-header heading='asideHeader.selectNormalizedAddress' hidex='true' ng-if=\"sidebar\"></xo-aside-header>\n    <div class=\"asideContent\">\n        <form method=\"post\" class=\"formSmall asideView container\" novalidate=\"novalidate\" name=\"addressNormalizationForm\">\n            <div ng-if=\"normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.title') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.intro') }}</p>\n                <div class=\"normalizedAdrSection radio\">\n                    <p class=\"theta\" data-ng-bind-html=\"htmlContent('addressNormalization.addressmatch')\"></p>\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" id=\"defaultAddress\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"normalizedAddress\" ng-click=\"selection('normalizedAddress')\" class=\"addrRadio span2\" checked=\"true\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\">\n                                <div ng-if=\"normalizedAddress.line2\">{{normalizedAddress.line1}}, {{normalizedAddress.line2}},</div>\n                                <div ng-if=\"!normalizedAddress.line2\">{{normalizedAddress.line1}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{normalizedAddress.city}}</span>, <span class=\"state\">{{normalizedAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{normalizedAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n                <div class=\"enteredAddrSection radio subContainer\">\n                    <p class=\"addressNormalizationIntro\" data-ng-bind-html=\"htmlContent('addressNormalization.addressenter')\"></p>\n\n                    <label class=\"noBottom narrow addrLabel row-fluid\">\n                        <input type=\"radio\" ng-model=\"addressSelected\" name=\"addressSelected\" value=\"enteredAddress\" ng-click=\"selection('enteredAddress')\" class=\"addrRadio span2\">\n                        <div class=\"adr span20\">\n                            <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                                <div ng-if=\"servAddress.line2\">{{servAddress.line2}}, </div>{{servAddress.line1}},\n                            </div>\n                            <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                                <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}},</div>\n                                <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}},</div>\n                            </div>\n                            <div class=\"confidential\">\n                                <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                                <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                            </div>\n                        </div>\n                    </label>\n                </div>\n            </div>\n            <div ng-if=\"!normalizedAddress\">\n                <h2 class=\"gamma\">{{ content('addressNormalization.noaddressmatchTitle') }}</h2>\n                <p class=\"theta\">{{ content('addressNormalization.noaddressmatchMsg') }}</p>\n                <input type=\"hidden\" name=\"addressdisplay\" value=\"enteredAddress\">\n                <div class=\"enteredAddrSection subContainer\">\n                    <p class=\"theta\">{{ content('addressNormalization.addressyouenter') }}</p>\n                    <div class=\"adr\">\n                        <div class=\"confidential streets street-address\" ng-show=\"isLine2First()\">\n                            {{servAddress.line2}} {{servAddress.line1}},\n                        </div>\n                        <div class=\"confidential streets street-address\" ng-hide=\"isLine2First()\">\n                            <div ng-if=\"address.line2\">{{servAddress.line1}}, {{address.line2}}, {{servAddress.line2}}</div>\n                            <div ng-if=\"!address.line2\">{{servAddress.line1}}, {{servAddress.line2}}</div>\n                        </div>\n                        <div class=\"confidential\">\n                            <span class=\"locality\">{{servAddress.city}}</span>, <span class=\"state\">{{servAddress.state}}</span>\n                            <span class=\"postal-code adr-break\">{{servAddress.postal_code}},&nbsp;{{content('countryList.'+servAddress.country)}}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"buttons\" ng-if=\"!hideBackButton\">\n                <input id=\"back\" type=\"submit\" value=\"{{ content('common.back') }}\" class=\"btn firstHalf btn-secondary\" ng-click=\"onBack()\" >\n                <input track-submit=\"{{transitionName}}\" id=\"continue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn secondHalf\" ng-click=\"onContinue()\">\n            </div>\n            <div class=\"buttons\" ng-if=\"hideBackButton\">\n                <input track-submit=\"{{transitionName}}\" id=\"fullContinue\" type=\"submit\" value=\"{{ content('common.continueLabel') }}\" class=\"btn\" ng-click=\"onContinue()\">\n            </div>\n        </form>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-beaver/dist/level.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module('beaver.level', []).factory('$logLevel', function () {
  return {
    INFO: 'info',
    DEBUG: 'debug',
    ERROR: 'error',
    WARN: 'warn',
    ALERT: 'alert'
  };
}).factory('$consoleLogLevel', function () {
  return {
    info: 'info',
    debug: 'debug',
    error: 'error',
    warn: 'warn',
    alert: 'info'
  };
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/level.js"))

/***/ }),

/***/ "../node_modules/xo-beaver/dist/logger.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _level = __webpack_require__("../node_modules/xo-beaver/dist/level.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable angular/di */

(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().factory('$Logger', function ($window, $q, $interval, $timeout, $log, $injector) {
  var logger = {};
  var HERMES_DEV_COOKIE = 'hermesdev';
  _angular["default"].forEach(_level.$logLevel, function (level) {
    logger[level] = function (event, payload, settings) {
      return this.log(level, event, payload, settings);
    };
  });
  var hostname = $window.location && $window.location.hostname || '';
  var uniqueEvents = [];
  _angular["default"].extend(logger, {
    autoLog: [_level.$logLevel.WARNING, _level.$logLevel.ERROR],
    flushInterval: 10 * 60 * 1000,
    heartbeatInterval: 5000,
    sizeLimit: 500,
    debounceInterval: 10,
    uri: '/api/log',
    rootTxnUri: '/api/log/crt',
    hearbeatMaxThreshold: 50,
    deploy: {
      isLocal: function isLocal() {
        return hostname === 'localhost' || hostname === 'localhost.paypal.com';
      },
      isStage: function isStage() {
        return Boolean(hostname.match(/^.*\.qa\.paypal\.com$/));
      },
      isLive: function isLive() {
        return hostname === 'www.paypal.com';
      }
    },
    init: function init() {
      var self = this;
      this.buffer = [];
      var previousBeforeUnloadHandler = $window.onbeforeunload;
      $window.onbeforeunload = function (event) {
        if (self.isDone) {
          return;
        }
        self.info('window_beforeunload');
        if (previousBeforeUnloadHandler) {
          return previousBeforeUnloadHandler.apply(this, arguments);
        }
      };
      var previousUnloadHandler = $window.onunload;
      $window.onunload = function (event) {
        if (self.isDone) {
          return;
        }
        self.info('window_unload');
        self._flush();
        self.done();
        if (previousUnloadHandler) {
          return previousUnloadHandler.apply(this, arguments);
        }
      };
      this.heartbeat();
      this.daemon();
    },
    heartbeat: function heartbeat() {
      var self = this;
      if (!window.enablePerformance) {
        return;
      }
      function timestamp() {
        var perf = window.performance;
        return parseInt(perf.now() - (perf.timing.connectEnd - perf.timing.navigationStart), 10);
      }
      var howBusy = {
        lastSampledTime: timestamp(),
        lastLag: 0,
        maxLag: 0,
        dampendedLag: 0
      };
      var count = 0;
      $interval(function () {
        if (!self.buffer.length || self.buffer[self.buffer.length - 1].event !== 'heartbeat') {
          count = 0;
        }
        if (!self.buffer.length || count > self.hearbeatMaxThreshold) {
          return;
        }
        count += 1;
        var payload = {
          count: count
        };
        var now = timestamp();
        howBusy.lastLag = now - howBusy.lastSampledTime - self.heartbeatInterval;
        howBusy.maxLag = howBusy.lastLag > howBusy.maxLag ? howBusy.lastLag : howBusy.maxLag;
        howBusy.dampendedLag = (howBusy.lastLag + howBusy.dampendedLag * 2) / 3;
        howBusy.lastSampledTime = now;
        payload.lastLag = howBusy.lastLag.toFixed(4);
        payload.maxLag = howBusy.maxLag.toFixed(4);
        payload.dampendedLag = howBusy.dampendedLag.toFixed(4);
        payload.lastSampledTime = howBusy.lastSampledTime.toFixed(4);
        if (howBusy.lastLag > 10000) {
          self.info('toobusy', {}, {
            noConsole: true,
            unique: true
          });
        }
        self.info('heartbeat', payload, {
          noConsole: true
        });
      }, this.heartbeatInterval);
    },
    done: function done() {
      this.flush(true);
      this.isDone = true;
    },
    addPerformanceData: function addPerformanceData(payload) {
      if (window.enablePerformance) {
        var performance = window.performance;
        var timing = window.performance.timing || {};
        var now = performance.now();
        if (window.clientStartTime && _angular["default"].isUndefined(payload.client_elapsed)) {
          payload.client_elapsed = parseInt(now - window.clientStartTime, 10);
        }
        if (timing.connectEnd && timing.navigationStart && _angular["default"].isUndefined(payload.req_elapsed)) {
          payload.req_elapsed = parseInt(now - (timing.connectEnd - timing.navigationStart), 10);
        }
      }
    },
    addLocaleData: function addLocaleData(payload) {
      var context = {};
      try {
        context = $injector.get('$metaBuilder').buildContext();
      } catch (err) {
        return; // Continue without adding locale data
      }
      if (context.locale && context.locale.country) {
        payload.site_cntry = context.locale.country;
      }
    },
    /* jslint maxcomplexity: false */
    log: function log(level, event, payload, settings) {
      var self = this;
      payload = payload || {};
      if (_angular["default"].isArray(payload) || !_angular["default"].isObject(payload)) {
        payload = {
          payload: payload
        };
      }
      settings = settings || {};
      if (settings.unique) {
        var hash = event + ':' + _angular["default"].toJson(payload);
        if (uniqueEvents.indexOf(hash) > -1) {
          return self;
        }
        uniqueEvents.push(hash);
      }
      payload.pageID = window.meta && window.meta.pageID;
      this.addPerformanceData(payload);
      this.addLocaleData(payload);
      self.print(level, event, payload, settings);
      if (this.buffer.length >= this.sizeLimit) {
        if (this.buffer.length === this.sizeLimit) {
          return self.enqueue('warn', 'logger_max_buffer_length');
        }
        return self;
      }
      return self.enqueue(level, event, payload, settings);
    },
    getTimestamp: function getTimestamp() {
      var now = Date.now();
      return window.logOffset ? window.logOffset + now : now;
    },
    enqueue: function enqueue(level, event, payload, settings) {
      payload = payload || {};
      settings = settings || {};
      var data = {
        level: level,
        event: event,
        timestamp: this.getTimestamp(),
        payload: payload
      };
      this.buffer.push(data);

      // If the log level is classified as autolog, then flush the data
      if (this.autoLog.indexOf(level) > -1) {
        this.flush();
      }
      return this;
    },
    shouldPrintLogsToConsole: function shouldPrintLogsToConsole(settings) {
      if (settings.noConsole) {
        return false;
      }
      if (window.meta && window.meta.corp) {
        return true;
      }
      if (this.deploy.isLocal() || this.deploy.isStage()) {
        return true;
      }
      var cookies = window.cookies || {};
      if (cookies[HERMES_DEV_COOKIE] && cookies[HERMES_DEV_COOKIE] === '1') {
        return true;
      }
      return false;
    },
    print: function print(level, event, payload, settings) {
      if (!this.shouldPrintLogsToConsole(settings)) {
        return;
      }
      var args = [event];
      if (payload) {
        args.push(payload);
        if (payload.stack || payload.error || payload.warning) {
          args.push('\n\n', payload.stack || payload.error || payload.warning);
        }
      }
      $log[_level.$consoleLogLevel[level] || 'info'].apply($log, args);
    },
    flush: function flush(immediate) {
      var self = this;
      if (!this.buffer.length) {
        return $q.when();
      }
      if (immediate) {
        return $q.when(this._flush());
      }
      if (self.debouncer_timeout) {
        $timeout.cancel(self.debouncer_timeout);
      }
      self.debouncer_timeout = $timeout(function () {
        var resolver = self.debouncer_resolver;
        delete self.debouncer_promise;
        delete self.debouncer_resolver;
        delete self.debouncer_timeout;
        self._flush().then(function () {
          resolver();
        });
      }, this.debounceInterval);
      self.debouncer_promise = self.debouncer_promise || $q(function (resolver) {
        self.debouncer_resolver = resolver;
      });
      return self.debouncer_promise;
    },
    _flush: function _flush() {
      var self = this;
      if (!self.buffer.length) {
        return $q.when();
      }
      var meta = {};
      try {
        meta = $injector.get('$metaBuilder').build();
      } catch (err) {
        // @TODO - Log error
      }
      var req = this.ajax('post', $window.meta.logURL || $window.config.urls.baseUrl + this.uri, {
        data: {
          events: self.buffer
        },
        meta: meta
      });
      self.buffer = [];
      return req;
    },
    ajax: function ajax(method, url, json) {
      return $q(function (resolve) {
        var XRequest = window.XMLHttpRequest || ActiveXObject; // eslint-disable-line no-undef, block-scoped-var
        var req = new XRequest('MSXML2.XMLHTTP.3.0');
        var logAppName = $window.meta.logAppName;
        req.open(method.toUpperCase(), url);
        req.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        req.setRequestHeader('Content-type', 'application/json');
        if (logAppName) {
          req.setRequestHeader('x-app-name', logAppName);
        }
        req.onreadystatechange = function () {
          if (req.readyState > 3) {
            resolve();
          }
        };
        req.send(_angular["default"].toJson(json).replace(/&/g, '%26')); // eslint-disable-line angular/ng_json_functions
      });
    },
    daemon: function daemon() {
      this.stop();
      var self = this;
      this.timer = $interval(function () {
        self.flush();
      }, this.flushInterval);
    },
    stop: function stop() {
      if (this.timer) {
        $interval.cancel(this.timer);
      }
    },
    createCalRootTxn: function createCalRootTxn(data, txnName) {
      if (data !== null && _angular["default"].isObject(data)) {
        var rootTxnData = {
          'data': {},
          'transactionName': ''
        };
        var url = "" + $window.config.urls.baseUrl + this.rootTxnUri;
        if (_angular["default"].isString(txnName)) {
          rootTxnData.transactionName = txnName;
        }
        Object.assign(rootTxnData.data, data);
        this.ajax('post', url, rootTxnData);
      }
    }
  });
  function Logger(val) {
    _angular["default"].extend(this, val);
    this.init();
  }
  Logger.prototype = logger;
  Logger.prototype.constructor = Logger;
  return Logger;
}).factory('$logger', ['$Logger', function ($Logger) {
  return new $Logger();
}]).run(['$logger', function ($logger) {
  _angular["default"].forEach(window.beaconQueue, function (payload) {
    $logger.log(payload.level, payload.event, payload);
  });
  window.beacon = function (level, events, payload) {
    _angular["default"].forEach(events, function (event) {
      $logger.log(level, event, payload);
    });
  };
}]);
_level.$logLevel;
_level.$consoleLogLevel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-beaver/dist", "../node_modules/xo-beaver/dist/logger.js"))

/***/ }),

/***/ "../node_modules/xo-device-info/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().factory('$DeviceInfo', function ($window) {
  var userAgent = $window.navigator.userAgent;
  var standalone = $window.navigator.standalone;
  var DEVICE_PATTERN = /iPod|iPhone|iPad|Android|BlackBerry|BB10|Palm|CriOS|IEMobile|Windows Phone OS|webOS|Symbian|silk|Kindle|Opera Mini|mobile/i;
  var TABLET_PATTERN = /ip(a|ro)d|silk|xoom|playbook|tablet|kindle|Nexus 7|GT-P10|SC-01C|SHW-M180S|SM-T320|SGH-T849|SCH-I800|SHW-M180L|SPH-P100|SGH-I987|zt180|HTC( Flyer|_Flyer)|Sprint ATP51|ViewPad7|pandigital(sprnova|nova)|Ideos S7|Dell Streak 7|Advent Vega|A101IT|A70BHT|MID7015|Next2|nook|FOLIO|MB511.*RUTEM|Mac OS.*Silk/i;
  var IOS_PATTERN = /iP(hone|od|ad)/i;
  function getIntegrationContext(integrationKey) {
    // additonal context sent via partners in regards to integration
    var integrationContext = _squid.$meta.integrationCTX || {};
    return integrationContext[integrationKey];
  }

  // Supports iOS and Android. Updated / more accurate method of detecting webviews
  function isWebView(logEnabled, ua) {
    if (logEnabled === void 0) {
      logEnabled = true;
    }
    if (ua === void 0) {
      ua = userAgent;
    }
    var ios = /iphone|ipod|ipad/i.test(ua);
    var android = /Android/i.test(ua);
    if (ios) {
      // Unfortunately no perfectly reliable way, this will detect some 3rd party browsers as ui webview
      // Major browsers: chrome, safari, firefox, uc browser, puffin, are detected reliably.
      var ios_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
      if (!standalone && ios_uiwebview && !isSafariViewController()) {
        // uiwebview
        logWebView('iOS');
        return true;
      }
    } else if (android) {
      // not iOS, Android platform handling
      // Whitelist for x-requested-with header values for web view detection
      var allowedXRequestedWithRegexMap = {
        ajax: /XMLHttpRequest/i,
        baiduBrowser: /com.baidu.browser.inter/i,
        operaMini: /com.opera.mini.native/i,
        maxthon: /com.mx.browser/i,
        litterPenguinBrowser: /com.explore.web.browser/i
      };
      var xRequestedWithHeaderVal = _squid.$meta.requestHeaders['x-requested-with'];
      if (xRequestedWithHeaderVal) {
        // check if x-requested-with header val is in whitelist
        for (var key in allowedXRequestedWithRegexMap) {
          if (allowedXRequestedWithRegexMap.hasOwnProperty(key)) {
            if (allowedXRequestedWithRegexMap[key].test(xRequestedWithHeaderVal)) {
              return false;
            }
          }
        }
        logWebView('Android');
        return true;
      }
    }
    return false;
    function logWebView(device) {
      if (!logEnabled) {
        return;
      }
      // cal log
      _logger.$logger.info("WebView :: " + device);
    }
  }

  /**
   * Check if the given the user-agent string is belongs to a device.
   */
  function isDevice() {
    if (_angular["default"].isString(userAgent)) {
      return DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent);
    }
    return false;
  }

  /**
   * Check if the given the user-agent string is belongs to a tablet.
   */
  function isTablet() {
    if (_angular["default"].isString(userAgent)) {
      return TABLET_PATTERN.test(userAgent);
    }
    return false;
  }

  /**
   * Check if the given the user-agent string is belongs to a mobile
   */
  function isMobile() {
    return isDevice(userAgent) && !isTablet(userAgent);
  }

  /**
   * Get the mobile platform value given the user-agent string.
   */
  function getDevicePlatform() {
    if (_angular["default"].isString(userAgent)) {
      var matched = userAgent.match(/iPod|iPhone|iPad|Android|BlackBerry|Windows Phone OS|webOS|Symbian|mobile/g);
      if (matched && matched.length > 0) {
        return matched[0];
      }
    }
  }

  /**
   * Check if the give user agent is from an app.
   */
  function isApp(uaString) {
    userAgent = uaString || userAgent;
    if (DEVICE_PATTERN.test(userAgent) || TABLET_PATTERN.test(userAgent)) {
      if (getDevicePlatform(userAgent) === 'Android') {
        return /Version\/\d.\d/i.test(userAgent);
      }
      return /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|PLAYSTATION|iPadApp/i.test(userAgent);
    }
    return false;
  }
  function isSafariViewController() {
    if (getIntegrationContext('brainTreeIntegration') === 'SFVC') {
      return true;
    }
    if (_angular["default"].isString(userAgent)) {
      var ios = /iphone|ipod|ipad/i.test(userAgent);
      return ios && $window.indexedDB && isApp();
    } else {
      return false;
    }
  }

  /**
   * Get the device capabilities
   */
  function getCapabilities() {
    var capabilities = {};
    var device = DEVICE_PATTERN.test(userAgent);
    var tablet = TABLET_PATTERN.test(userAgent);
    var app = isApp(userAgent);
    if (_angular["default"].isString(userAgent)) {
      capabilities.isWireless = device || tablet;
      capabilities.isTablet = tablet;
      capabilities.isMobile = device && !tablet;
      capabilities.isDesktop = !device;
      capabilities.isApp = app;
    }
    return capabilities;
  }

  /**
   * Get various AppIntegrationType
   */
  function getAppIntegrationType() {
    var app_int_type;
    if (isDevice()) {
      if (isApp()) {
        if (isSafariViewController()) {
          app_int_type = 'SFVC';
        } else {
          app_int_type = 'WebView';
        }
      } else {
        app_int_type = 'Browser';
      }
    }
    return app_int_type;
  }
  function isSafariiOSBrowserView(ua) {
    if (ua === void 0) {
      ua = userAgent;
    }
    var ios = IOS_PATTERN.test(ua);
    var safari = /safari/i.test(ua);
    var isIOSApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
    var isChromeOnIOS = /(.*?CriOS)/i.test(ua);
    var isFirefoxOnIOS = /(.*?FxiOS)/i.test(ua);
    var isSafariBrowserOnly = safari && !isChromeOnIOS && !isFirefoxOnIOS;
    return ios && !standalone && isSafariBrowserOnly && !isIOSApp;
  }
  function getiOSVersion(ua) {
    if (ua === void 0) {
      ua = userAgent;
    }
    var ios = IOS_PATTERN.test(ua);
    if (ios) {
      var version = ua.match(/OS (\d+)_(\d+)/);
      return [parseInt(version[1], 10), parseInt(version[2], 10)];
    }
    return false;
  }
  return {
    isDevice: isDevice,
    isTablet: isTablet,
    isMobile: isMobile,
    isApp: isApp,
    isSafariViewController: isSafariViewController,
    getCapabilities: getCapabilities,
    getAppIntegrationType: getAppIntegrationType,
    isWebView: isWebView,
    isSafariiOSBrowserView: isSafariiOSBrowserView,
    getiOSVersion: getiOSVersion
  };
});
_squid.$meta;
_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-device-info/dist", "../node_modules/xo-device-info/dist/index.js"))

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/dob-input/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('dobValidation', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attr, ctrl) {
      // init scope vars
      // age - above 18 yrs
      // validDate - months <= 12 and day <= 31 or based on month
      scope.isValidDate = true;
      scope.isValidAge = true;
      scope.isValid = false;
      scope.dobToolTip = 'hide';
      function isValidDate(year, month, day) {
        // dates like 02/31 33/33 should return false
        var date = new Date(year, month, day);
        var fullYear = date.getFullYear();
        var dateMonth = date.getMonth();
        var dateDay = date.getDate();

        // If birth year is in the future or before 1900, dob is invalid
        var now = new Date();
        if (fullYear > now.getFullYear() || fullYear < 1900) {
          return false;
        }
        if (fullYear === parseInt(year, 10) && dateMonth === parseInt(month, 10) && dateDay === parseInt(day, 10)) {
          return true;
        }
        return false;
      }
      function isOfLegalAge(birthDate) {
        // user should be of exact 18 years of age or older
        var tempDate = new Date(birthDate.getFullYear() + 18, birthDate.getMonth(), birthDate.getDate());
        return tempDate <= new Date().setHours(0, 0, 0, 0);
      }

      /**
       * Parses input value to set corresponding day, month, year values for scope
       * @param {String} inputVal - the value to be parsed
       */
      function parseDob(inputVal) {
        var day;
        var month;
        var year;
        var sep = scope.dateSeparator();
        var partsArr = inputVal.split(sep);
        var first = partsArr[0];
        var sec = partsArr[1];
        var third = partsArr[2];
        if (scope.dateFormat() === 'DMY') {
          day = first;
          month = sec;
          year = third;
        } else if (scope.dateFormat() === 'YMD') {
          year = first;
          month = sec;
          day = third;
        } else {
          month = first;
          day = sec;
          year = third;
        }

        // Validate only on entering the last digit of the dob
        var dayLen = ('' + day).length;
        var monLen = ('' + month).length;
        var yrLen = ('' + year).length;
        var validDay = dayLen === 1 || dayLen === 2;
        var validMon = monLen === 1 || monLen === 2;
        var validYr = yrLen === 4;
        var requirement = validDay && validMon && validYr;
        if (requirement) {
          scope.isValidDate = isValidDate(year, month - 1, day);
          scope.isValidAge = isOfLegalAge(new Date(year, month - 1, day));
          scope.isValid = scope.isValidDate && scope.isValidAge;
          scope.dobToolTip = scope.isValid ? 'hide' : 'show';
          scope.user.dob_day = day;
          scope.user.dob_month = month;
          scope.user.dob_year = year;
        } else {
          scope.isValid = false;
        }
        ctrl.$setValidity('dobText', scope.isValid);
        return inputVal;
      }

      /**
       * Validates the inputted DOB value
       * @param {string} ngModelValue - the to-be mutated input value
       * onComplete for mask listener - called when user copy/pastes DOB into the field
       */
      scope.dobValidator = function dobValidator(ngModelValue) {
        var input = element;
        var dateMask = scope.dateMask();
        input.mask(dateMask, {
          translation: {
            'Z': {
              pattern: /[0-9]/,
              optional: true
            },
            '0': {
              pattern: /[0-9]/,
              optional: false
            }
          },
          onComplete: function onComplete(val) {
            ngModelValue = val;
            return parseDob(ngModelValue);
          }
        });
        return parseDob(ngModelValue);
      };
      scope.dobTester = function dobTester(val) {
        return parseDob(val);
      };
      ctrl.$parsers.push(scope.dobValidator);
    }
  };
}).directive('xoDobInput', function () {
  return {
    template: _template["default"],
    restrict: 'E',
    scope: {
      user: '=?'
    },
    controller: ['$scope', function ($scope) {
      // To support additional date separators, simply add separator to getDateSeparators function
      var DateManager = {
        dateSeparator: undefined,
        dateFormat: undefined,
        griffinDateEntry: undefined,
        _init_: function _init_() {
          this.griffinDateEntry = _squid.$locale.metadata.dateEntry;
          this.dateSeparator = this.getDateSeparator(this.griffinDateEntry);
          this.dateFormat = undefined;
          this.dateFormat = this.getDateFormat();
          this.dateRegex = this.getDateRegex();
          // dob validator depends on dateFormat function in $scope, so context is bound.
          $scope.dateFormat = this.getDateFormat.bind(this);
          $scope.dateSeparator = this.getDateSeparator.bind(this, this.griffinDateEntry);
          $scope.dateMask = this.getDateMask.bind(this, this.dateSeparator);
          this.getDobNumericCheck();
        },
        getDateFormat: function getDateFormat() {
          // cache date format value, must be unset on init
          if (this.dateFormat) {
            return this.dateFormat;
          }
          var griffinDateFormat = _squid.$locale.metadata.dateFormat.toUpperCase();
          var dateFormatComponents = griffinDateFormat.split(this.dateSeparator);

          // Trim the white space in griffin dateFormat
          // Eg: SK dateFormat is MM. DD. YYYY - here we need to strip spaces
          dateFormatComponents = dateFormatComponents.map(function (str) {
            return str.trim();
          });
          var dIdx = dateFormatComponents.indexOf('DD'),
            mIdx = dateFormatComponents.indexOf('MM');
          var formatComponentMap = this.getFormatComponentIdxMappings();
          if (formatComponentMap['DMY'].day === dIdx && formatComponentMap['DMY'].month === mIdx) {
            return 'DMY';
          } else if (formatComponentMap['MDY'].day === dIdx && formatComponentMap['MDY'].month === mIdx) {
            return 'MDY';
          }
          return 'YMD';
        },
        setDobTextPlaceHolder: function setDobTextPlaceHolder() {
          $scope.dobTextPlaceholder = this.griffinDateEntry.toUpperCase();
        },
        dobTextKeyupHandler: function dobTextKeyupHandler(event) {
          this.updateDobBindings(true);
        },
        getDobNumericCheck: function getDobNumericCheck() {
          return (0, _squid.$elmo)('xo_xoon_numeric_keypad_expirydob', {
            'ctx.COUNTRY': _squid.$locale.country
          }, 'xo_xoon_numeric_keypad_expirydob_test').then(function (result) {
            if (result) {
              $scope.dobTextInputType = 'tel';
            }
          });
        },
        /**
         * Absolutely makes sure that dob input doesn't contain bad characters.
         * Called on any chatacter input AND on locale change.
         */
        updateDobBindings: function updateDobBindings(change) {
          var cleanedDob = ($scope.dob.value || '').replace(this.dateRegex, '');
          $scope.dob.value = cleanedDob;

          // This way, our dob value is always formatted correctly.
          if (change) {
            $scope.dob.value = $('#dobText').val();
          }
        },
        // Dynamically construct regex to only include date separator supported by country and nondigits
        getDateRegex: function getDateRegex() {
          var escapedRegexChars = ['.', '$', '^', '{', '[', '(', '|', ')', '*', '+', '?', '\\'];
          var sep = this.dateSeparator;
          var assembledRegex = '[^0-9' + (escapedRegexChars.indexOf(sep) !== -1 ? '\\' + sep : sep) + ']';
          return new RegExp(assembledRegex, 'gi');
        },
        getDateMask: function getDateMask(dateSeparator) {
          var dateFormat = this.dateFormat;
          if (dateFormat === 'DMY' || dateFormat === 'MDY') {
            return '0Z' + dateSeparator + '0Z' + dateSeparator + '0000';
          }
          return '0000' + dateSeparator + '0Z' + dateSeparator + '0Z';
        },
        getDateSeparator: function getDateSeparator(dateEntry) {
          var ret = '';
          this.getDateSeparators().forEach(function (ele, iter) {
            // eslint-disable-line
            if (dateEntry.indexOf(ele) !== -1) {
              ret = ele;
            }
          });
          return ret;
        },
        // To add any additional date separators, simply add them to the returned array.
        getDateSeparators: function getDateSeparators() {
          return ['-', '.', '/'];
        },
        // Handles changes in date component order or date separator change.
        updateDateInputForFormat: function updateDateInputForFormat(oldFormat, newFormat, oldSeparator) {
          var curDateVal = $scope.dob.value || '';

          // Clear dob input if date is incomplete so user can see updated placeholder
          if (curDateVal.length < 8) {
            $scope.dob.value = '';
            return;
          }
          var formatComponentIdxMappings = this.getFormatComponentIdxMappings(),
            oldFormatIdxMapping = formatComponentIdxMappings[oldFormat],
            newFormatIdxMapping = formatComponentIdxMappings[newFormat];
          var oldDateComponents = curDateVal.split(oldSeparator),
            newDateComponents = ['', '', ''];
          newDateComponents[newFormatIdxMapping.day] = oldDateComponents[oldFormatIdxMapping.day];
          newDateComponents[newFormatIdxMapping.month] = oldDateComponents[oldFormatIdxMapping.month];
          newDateComponents[newFormatIdxMapping.year] = oldDateComponents[oldFormatIdxMapping.year];
          $scope.dob.value = newDateComponents.join(this.dateSeparator);
        },
        getFormatComponentIdxMappings: function getFormatComponentIdxMappings() {
          return {
            'DMY': {
              'day': 0,
              'month': 1,
              'year': 2
            },
            'MDY': {
              'day': 1,
              'month': 0,
              'year': 2
            },
            'YMD': {
              'day': 2,
              'month': 1,
              'year': 0
            }
          };
        },
        prefillFetchedDob: function prefillFetchedDob() {
          if ($scope.user && $scope.user.dob_day && $scope.user.dob_month && $scope.user.dob_year) {
            if (!$scope.dob) {
              $scope.dob = {};
            }
            if (this.dateFormat === 'DMY') {
              $scope.dob.value = $scope.user.dob_day + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_year;
            } else if (this.dateFormat === 'YMD') {
              $scope.dob.value = $scope.user.dob_year + this.dateSeparator + $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day;
            } else {
              $scope.dob.value = $scope.user.dob_month + this.dateSeparator + $scope.user.dob_day + this.dateSeparator + $scope.user.dob_year;
            }
          } else {
            $scope.dob = {
              value: ''
            };
          }
        }
      };
      DateManager._init_();
      DateManager.setDobTextPlaceHolder();
      DateManager.prefillFetchedDob();
      $scope.onDobTextKeyup = function (event) {
        DateManager.dobTextKeyupHandler(event);
      };
      $scope.$on('localeChange', function () {
        var oldDateFormat = DateManager.dateFormat;
        var oldSeparator = DateManager.dateSeparator;
        DateManager._init_();
        DateManager.updateDateInputForFormat(oldDateFormat, DateManager.dateFormat, oldSeparator);
        DateManager.updateDobBindings(false);
        DateManager.setDobTextPlaceHolder();
      });
    }]
  };
});
_squid.$locale;
_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/dob-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"dobComp\" class=\"dobbank\" ng-class=\"{dobTXT: dobInputType()==='TXT'}\" content>\n    <div class=\"dobField full inputField last-child\" floating-label directionality>\n        <input ng-model=\"dob.value\"\n               name=\"dobText\"\n               id=\"dobText\"\n               value=\"\"\n               maxlength=\"10\"\n               autocapitalize=\"off\"\n               aria-required=\"true\"\n               autocomplete=\"off\"\n               placeholder=\"{{ dobTextPlaceholder }}\"\n               xo-error-tooltip\n               dob-validation\n               ng-keyup=\"onDobTextKeyup($event)\"\n               aria-describedby=\"dobHelp\"\n               type=\"{{ dobTextInputType }}\"\n               required />\n        <div ng-class=\"dobToolTip\">\n            <xo-tooltip trigger=\"#dobText\" show-event=\"keyup\" ng-class=\"dobToolTip\" id=\"dobToolTip\">\n                <div class=\"tip tipDesc dobToolTip\">\n                  <p class=\"tipInfoText restriction active\" ng-if=\"!isValidDate\">{{ content('scripts.validDate') }}</p>\n                  <p class=\"tipInfoText restriction active\" ng-if=\"isValidDate && !isValidAge\">{{ content('scripts.legalAge') }}</p>\n                </div>\n            </xo-tooltip>\n        </div>\n        <span id=\"dobHelp\" class=\"accessAid\">{{ dobTextPlaceholder }}</span>\n        <label id=\"dobLabel\" for=\"dobText\">{{ content('signup.accountCreationGuest.dobLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/gender-type/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/gender-type/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/gender-type/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('$xoGenderType', {
  tag: 'xo-gender-type',
  template: _template["default"],
  props: {
    user: {
      type: 'var',
      required: false
    }
  }
});
_index.$Component;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/gender-type/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/gender-type/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <div id=\"genderTypeContainer\" class=\"dropdown gender confidential halfInputElement inputField last-child\"\n         floating-label-dropdown directionality>\n        <select ng-model=\"user.gendertype\" name=\"gender\" xo-dropdown id=\"gender\"\n                aria-required=\"true\" ng-required=\"true\">\n            <option value=\"\">{{ content('common.genderLabel') }}</option>\n            <option value=\"MALE\">{{ content('common.genderMale') }}</option>\n            <option value=\"FEMALE\">{{ content('common.genderFemale') }}</option>\n        </select>\n        <label for=\"gender\" id=\"genderLabel\">{{ content('common.genderLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/inventory-soldout/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");
__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/inventory-soldout/template.html"));
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoSoldoutPageDirective', {
  tag: 'xo-soldout-page',
  template: _template["default"],
  auth: false,
  actions: {
    continueShoppingHandler: function continueShoppingHandler() {
      _util.$ReturnToMerchant.goTo(decodeURIComponent(_uiRouter.$state.params.soldOutUrl), true);
    }
  },
  lifecycle: {
    enter: function enter() {
      this.locale = _squid.$locale;
      angular.element('.paypalHeader').css('display', 'none');
      angular.element('#defaultCancelLink').css('display', 'none');
      _logger.$logger.info('checkout_fpti', {
        landing_page: 'sold_out',
        int_error_code: '0',
        int_error_description: 'cart item sold out'
      });
    },
    populate: function populate() {
      this.item_name = decodeURIComponent(_uiRouter.$state.params.items);
    }
  }
});
_squid.$Component;
_squid.$locale;
_util.$ReturnToMerchant;
_uiRouter.$state;
_logger.$logger;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/inventory-soldout/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoSoldOutPageRoute = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _directive = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/inventory-soldout/directive.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $xoSoldOutPageRoute = exports.$xoSoldOutPageRoute = _squid.$ComponentRoute.extend('$xoSoldOutPageRoute', {
  path: 'soldout',
  directive: _directive["default"],
  titleContent: 'soldout.title',
  query: ['items', 'soldOutUrl'],
  auth: false,
  trackingData: {
    fptiState: 'soldout',
    templateName: 'soldout.dust',
    pageGoal: 'soldout page',
    buzname: {
      'fullpage': {
        'pagename': '%::fullpage-soldout',
        'pagename2': '%::fullpage-soldout:member:hermes:',
        'version': 'member:%:'
      }
      // More page qualifiers come here...
    }
  },
  children: []
});
angular.value("$xoSoldOutPageRoute", $xoSoldOutPageRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-form-components/src/inventory-soldout/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"soldOut\" content>\n    <div id=\"soldouticon\">\n        <div class=\"left_section\"> </div>\n\n        <div class=\"text_lines\">\n            <span id=\"text\">{{content ('soldout.icon')}}</span>\n        </div>\n\n        <div id=\"rightSection\">\n            <span class=\"shape-right\">   </span>\n        </div>\n    </div>\n\n    <div class=\"soldOutMessage\" ng-bind-html=\"htmlContent('soldout.message', {item: item_name})\">\n    </div>\n    <div>\n        <input id= \"Continue-Shopping\" class=\"btn full confirmButton continueButton\" type=\"button\" value=\"{{content ('soldout.continueShoppingButton')}}\" ng-click=\"actions.continueShoppingHandler()\"/>\n\n    </div>\n\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.VALID_DIRECTION = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/language-options/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var VALID_DIRECTION = exports.VALID_DIRECTION = ['top', 'bottom'];
var isValidDirection = function isValidDirection(n) {
  return VALID_DIRECTION.includes(n);
};
angular.module().directive('xoLanguageOptions', function () {
  return {
    template: _template["default"],
    scope: {
      direction: '@?'
    },
    controller: ['$scope', function ($scope) {
      $scope.direction = isValidDirection($scope.direction) ? $scope.direction : 'bottom';
      $scope.showLanguages = false;
      function setLanguageVars() {
        $scope.localeModel = _squid.$locale;
        $scope.currentLanguage = $scope.localeModel.lang;
        $scope.currentCountry = $scope.localeModel.country;
        $scope.languageList = $scope.localeModel.metadata.languageLabel;
        $scope.supportedLanguages = _squid.$config.supportedCountries[$scope.currentCountry];
        $scope.hasMultipleLanguages = $scope.supportedLanguages && $scope.supportedLanguages.length > 1 ? true : false;
      }
      $scope.selectLanguage = function (language) {
        $scope.currentLanguage = language;
        _squid.$locale.chooseLang(language);
      };
      $scope.toggle = function ($event) {
        if ($event) {
          $event.preventDefault();
        }
        $scope.showLanguages = !$scope.showLanguages;
      };
      setLanguageVars();

      // Reset locale properties for languageToggle
      $scope.$on('localeChange', function () {
        setLanguageVars();
      });

      // "clickBody" is an artifical event broadcast by the xo-checkout component (essentially document.click)
      $scope.$on('clickBody', function ($event, target) {
        if ($(target).parents('.languageToggleDisplay div').length === 0) {
          $scope.showLanguages = false;
          $scope.$apply();
        }
      });
    }]
  };
});
_squid.$config;
_squid.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/language-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"languageToggleDisplay\" content feature=\"languageToggle\" ng-if=\"hasMultipleLanguages\">\n    <div>\n        <a id=\"clickLanguageToggle\" lang=\"{{ currentLanguage }}\" aria-expanded=\"{{showLanguages}}\" aria-label=\"{{ content('languages.label', {language: languageList[currentLanguage]}) }}\" ng-click=\"toggle()\" select-button focus-when=\"!showLanguages\" focused-once-before><span class=\"displayText\">{{languageList[currentLanguage]}}</span><span class=\"changeLanguage\" ng-class=\"{expand:showLanguages}\"></span></a>\n    </div>\n    <div id=\"langDropdownBlock\" ng-show=\"showLanguages\" class=\"{{ direction }}\">\n        <div class=\"arrow\"></div>\n        <div ng-click=\"toggle()\">\n            <ul aria-labelledby=\"clickLanguageToggle\" select-box=\"showLanguages && supportedLanguages\" select-cancel=\"toggle()\">\n                <li role=\"presentation\" ng-repeat=\"lang in supportedLanguages track by $index\" lang=\"{{ lang }}\">\n                    <a track-link=\"language_change\" class=\"submit\" ng-click=\"selectLanguage(lang)\" link-button select-option=\"lang == currentLanguage\" focus-when=\"showLanguages && lang == currentLanguage\">{{languageList[lang]}}</a>\n                </li>\n            </ul>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/name-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/name-input/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoNameInput', {
  tag: 'xo-name-input',
  template: _template["default"],
  props: {
    attrPrefix: {
      required: false,
      type: 'var'
    },
    country: {
      required: false,
      type: 'str'
    },
    user: {
      required: false,
      type: 'var'
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.locale = _squid.$locale;
      this.metadata = _squid.$MetadataModel.create();
      var handleCountryChange = function handleCountryChange() {
        _this.metadata.choose(_this.country || _squid.$locale.country, _squid.$locale.lang);
      };
      this.$watch('country', handleCountryChange);
    }
  }
});
_squid.$Component;
_squid.$locale;
_squid.$MetadataModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/name-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fieldGroup name clearfix\" ng-class=\"country || locale.country\" content>\n    <div ng-if=\"metadata.nameEntry.layout\" ng-repeat=\"layoutItem in metadata.nameEntry.layout track by $index\">\n        <!-- First name -->\n        <div ng-if=\"layoutItem.$ === 'givenName'\">\n            <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" data-test-id=\"first-name-container\" floating-label disable-autoblur directionality>\n                <input ng-model=\"user.first_name\"\n                        id=\"firstName\"\n                        name=\"firstName\"\n                        prefix-attrs-with=\"{{attrPrefix}}\"\n                        value=\"\"\n                        pattern=\"(?!^\\d+$)^.+$\"\n                        autocapitalize=\"off\"\n                        aria-required=\"false\"\n                        autocomplete=\"off\"\n                        maxlength=\"100\"\n                        xo-error-tooltip\n                        track-focus-and-blur=\"firstName\"\n                        ng-required=\"{{layoutItem.required}}\"\n                        data-test-id=\"user.first_name\" />\n                <label for=\"firstName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                    {{content('common.firstName')}}\n                </label>\n            </div>\n        </div>\n\n        <!-- Last name -->\n        <div ng-if=\"layoutItem.$ === 'surname'\">\n            <div class=\"inputField half confidential\" ng-class=\"{'last-child': $last}\" data-test-id=\"last-name-container\" floating-label directionality>\n                <input ng-model=\"user.last_name\"\n                        id=\"lastName\"\n                        name=\"lastName\"\n                        prefix-attrs-with=\"{{attrPrefix}}\"\n                        value=\"\"\n                        pattern=\"(?!^\\d+$)^.+$\"\n                        autocapitalize=\"off\"\n                        aria-required=\"false\"\n                        autocomplete=\"off\"\n                        maxlength=\"100\"\n                        xo-error-tooltip\n                        track-focus-and-blur=\"lastName\"\n                        ng-required=\"{{layoutItem.required}}\"\n                        data-test-id=\"user.last_name\" />\n                <label for=\"lastName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                    {{content('common.lastName')}}\n                </label>\n            </div>\n        </div>\n    </div>\n\n    <div ng-if=\"!metadata.nameEntry.layout\">\n        <!-- First name -->\n        <div class=\"inputField half confidential\" floating-label disable-autoblur directionality>\n            <input ng-model=\"user.first_name\"\n                    id=\"firstName\"\n                    name=\"firstName\"\n                    prefix-attrs-with=\"{{attrPrefix}}\"\n                    value=\"\"\n                    pattern=\"(?!^\\d+$)^.+$\"\n                    autocapitalize=\"off\"\n                    aria-required=\"false\"\n                    autocomplete=\"off\"\n                    maxlength=\"100\"\n                    xo-error-tooltip\n                    ng-required=\"true\"\n                    track-focus-and-blur=\"firstName\"\n                    data-test-id=\"user.first_name\" />\n            <label for=\"firstName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                {{content('common.firstName')}}\n            </label>\n        </div>\n\n        <!-- Last name -->\n        <div class=\"inputField half confidential last-child\" floating-label directionality>\n            <input ng-model=\"user.last_name\"\n                    id=\"lastName\"\n                    name=\"lastName\"\n                    prefix-attrs-with=\"{{attrPrefix}}\"\n                    value=\"\"\n                    pattern=\"(?!^\\d+$)^.+$\"\n                    autocapitalize=\"off\"\n                    aria-required=\"false\"\n                    autocomplete=\"off\"\n                    maxlength=\"100\"\n                    xo-error-tooltip\n                    ng-required=\"true\"\n                    track-focus-and-blur=\"lastName\"\n                    data-test-id=\"user.last_name\" />\n            <label for=\"lastName\" prefix-attrs-with=\"{{attrPrefix}}\">\n                {{content('common.lastName')}}\n            </label>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/national-id-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/national-id-input/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
angular.module().directive('brIdValidations', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attr, ctrl) {
      scope.cpfValidator = function cpfValidator(ngModelValue) {
        var value = ngModelValue.replace(/[^0-9]/gi, '');
        var len = value.length;
        if (len !== 11) {
          ctrl.$setValidity('nationalId', false);
          return ngModelValue;
        }
        var x = value.match(/\b(\d)\1+\b/);
        if (x) {
          ctrl.$setValidity('nationalId', false);
          return ngModelValue;
        }
        var v1 = 0;
        var v2 = 0;
        var dv1;
        var dv2;
        var i;
        var j;
        for (i = 0, j = 10; i < 9, j > 1; i++, j--) {
          // eslint-disable-line no-sequences
          v1 += j * +value[i];
        }
        v1 = v1 % 11;
        dv1 = 11 - v1 < 10 ? 11 - v1 : 0;
        for (i = 0, j = 11; i < 9, j > 2; i++, j--) {
          // eslint-disable-line no-sequences
          v2 += j * +value[i];
        }
        v2 += dv1 * 2;
        v2 = v2 % 11;
        dv2 = 11 - v2 < 10 ? 11 - v2 : 0;
        scope.isValid = dv1 === parseInt(value[9], 10) && dv2 === parseInt(value[10], 10);
        ctrl.$setValidity('nationalId', scope.isValid);
        return ngModelValue;
      };
      ctrl.$parsers.push(scope.cpfValidator);
    }
  };
}).directive('sgIdValidations', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attr, ctrl) {
      scope.nricFinValidator = function nricFinValidator(ngModelValue) {
        var idType = scope.$parent.nationalIdModel.nationalId.type;
        if (idType === 'NATIONAL_ID') {
          scope.isValid = false;

          // Valid if first char is "S", "T", "F" or "G" and the rest 7 are digits followed by a letter.
          if (ngModelValue.match(/^[SFTG]\d{7}[A-Z]$/)) {
            scope.isValid = true;
          }
        } else {
          scope.isValid = true;
        }
        ctrl.$setValidity('nationalId', scope.isValid);
        return ngModelValue;
      };
      ctrl.$parsers.push(scope.nricFinValidator);
    }
  };
}).directive('ruIdValidations', function () {
  return {
    require: 'ngModel',
    link: function link(scope, element, attr, ctrl) {
      function validateSNILSChunk(sum, checksum) {
        if (sum < 100 && sum === checksum) {
          return true;
        } else if ((sum === 100 || sum === 101) && checksum === 0) {
          return true;
        } else if (sum > 101) {
          var remainder = sum % 101;
          return validateSNILSChunk(remainder, checksum);
        }
        return false;
      }
      function validateSNILS(value) {
        if (value.length === 11) {
          if (Number(value) > 1001998) {
            var snilsNumber = value.substring(0, 9);
            var checksum = Number(value.substring(9));
            var sum = 0;
            var multiplier = 1;
            for (var i = snilsNumber.length - 1; i >= 0; i--) {
              sum = sum + Number(snilsNumber.charAt(i)) * multiplier;
              multiplier++;
            }
            return validateSNILSChunk(sum, checksum);
          }
          return true;
        }
        return false;
      }
      function validateINNChecksum(value, factor, valueLength, match) {
        var n;
        var sumn = 0;
        for (var i = 0; i < valueLength; i++) {
          sumn = sumn + Number(value[i]) * Number(factor[i]);
        }
        n = sumn % 11;
        n = n === 10 ? 0 : n;
        if (n !== Number(match)) {
          return false;
        }
        return true;
      }
      function validateINN(value) {
        if (value.length === 12) {
          var factor = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8];
          if (!validateINNChecksum(value, factor, value.length - 2, value[10])) {
            return false;
          }
          factor.unshift(3);
          if (!validateINNChecksum(value, factor, value.length - 1, value[11])) {
            return false;
          }
          return true;
        }
        return false;
      }
      function validateOMS(value) {
        if (value.length >= 11 && value.length <= 16) {
          return true;
        }
        return false;
      }
      scope.idValidator = function idValidator(ngModelValue) {
        var value = ngModelValue.replace(/[^0-9]/gi, '');
        var secondaryType = scope.nationalIdModel.secondaryIdType;
        if (secondaryType === 'SNILS') {
          scope.isValid = validateSNILS(value);
        } else if (secondaryType === 'INN') {
          scope.isValid = validateINN(value);
        } else if (secondaryType === 'OMS') {
          scope.isValid = validateOMS(value);
        }
        ctrl.$setValidity('secondaryId', scope.isValid);
        return ngModelValue;
      };
      ctrl.$parsers.push(scope.idValidator);
    }
  };
}).directive('xoNationalIdInput', function () {
  return {
    template: _template["default"],
    scope: {
      user: '=?',
      country: '@?'
    },
    link: function link(scope, element, attr) {
      var passportMask = '0000000000';
      element.on('keyup', function (event) {
        if (scope.user.countryOfResidence === 'RU') {
          $('#nationalId').mask(passportMask, {
            'translation': {
              0: {
                pattern: /[0-9]/
              }
            }
          });
        } else {
          $('#nationalId').unmask(passportMask);
        }
      });
    },
    controller: ['$scope', '$NationalIdModel', function ($scope, $NationalIdModel) {
      $scope.nationalIdModel = $NationalIdModel.instance(_angular.$rootScope.token);
      $scope.checkoutCart = _index.$CheckoutCartModel.instance(_angular.$rootScope.token);
      $scope.user = $scope.user || {};
      $scope.user.countryOfResidence = $scope.user.countryOfResidence || $scope.country;
      $scope.formattedValues = {};
      $scope.showNationalIdFields = false;
      if ($scope.checkoutCart.payer && $scope.checkoutCart.payer.tax_id) {
        $scope.nationalIdModel.nationalId.value = $scope.checkoutCart.payer.tax_id;
      }
      $scope.countryChanged = function () {
        if ($scope.user.countryOfResidence === 'RU') {
          $scope.showNationalIdFields = true;
          $scope.minLengthNatId = 10;
          $scope.maxLengthNatId = 10;
        } else {
          $scope.showNationalIdFields = false;
          $scope.minLengthNatId = 6;
          $scope.maxLengthNatId = 15;
        }
      };
      $scope.cpfMasking = function (newValue) {
        if (newValue) {
          var unformatted = newValue.replace(/[^0-9]/gi, '');
          var formatted = [['', unformatted.slice(0, 3)], ['.', unformatted.slice(3, 6)], ['.', unformatted.slice(6, 9)], ['-', unformatted.slice(9)]].map(function (x) {
            return x[1] && x[0] + x[1] || '';
          }).join('');
          $scope.formattedValues.nationalId = formatted;
          $scope.nationalIdModel.nationalId.value = unformatted;
        } else {
          $scope.nationalIdModel.nationalId.value = '';
        }
      };
      $scope.secondaryIdFormatting = function () {
        var $el = $('#idValue');
        if ($scope.nationalIdModel.secondaryIdType === 'SNILS' && $el.length > 0) {
          var unformatted = $el.val().replace(/[^0-9]/gi, '');
          var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3, 6)], ['-', unformatted.slice(6, 9)], [' ', unformatted.slice(9)]].map(function (x) {
            return x[1] && x[0] + x[1] || '';
          }).join('');
          $scope.nationalIdModel.secondaryIdValue = formatted;
        }
      };
      $scope.secondaryIdChange = function () {
        var currentSecondaryId = $scope.secondaryIds[$scope.nationalIdModel.secondaryIdType];
        $scope.nationalIdModel.secondaryIdValue = '';
        $scope.maxLength = currentSecondaryId.length;
        $scope.minLength = currentSecondaryId.minlength ? currentSecondaryId.minlength : currentSecondaryId.length;
        $scope.maskCharLength = currentSecondaryId.maskCharLength ? currentSecondaryId.maskCharLength : 0;
      };
      $scope.sgIdChange = function () {
        $scope.nationalIdModel.nationalId.value = '';
      };
      function setLocalizedNatIDLabels() {
        $scope.nationalIds = {
          'PASSPORT': {
            name: 'PASSPORT_NUMBER',
            value: _squid.$locale.content.addTaxId.passport
          }
        };

        // National ID is not shown for South Korea
        if (_squid.$locale.country !== 'KR') {
          $scope.nationalIds.NATID = {
            name: 'NATIONAL_ID',
            value: _squid.$locale.content.addTaxId.natid
          };
        }

        // ID type change from “Driver’s License” to “TEMPORARY_NATIONAL_ID” for HK only,
        // other countries show "Driver’s License" in th national ID drop down
        if (_squid.$locale.country === 'HK' && (0, _squid.$feature)('driverLicenseToTempNationalID', false, _squid.$locale.country)) {
          $scope.nationalIds.TNID = {
            name: 'TEMPORARY_NATIONAL_ID',
            value: _squid.$locale.content.addTaxId.tnid
          };
        } else {
          $scope.nationalIds.DL = {
            name: 'DRIVERS_LICENSE',
            value: _squid.$locale.content.addTaxId.dl
          };
        }
      }
      function setLocalizedRUContent() {
        $scope.countries = _squid.$locale.metadata.territory;
        $scope.secondaryIds = {
          'INN': {
            name: 'INN',
            value: _squid.$locale.content.addTaxId.INN,
            length: 12
          },
          'SNILS': {
            name: 'SNILS',
            value: _squid.$locale.content.addTaxId.SNILS,
            length: 14,
            maskCharLength: 3
          }
        };
      }
      if (_squid.$locale.country === 'BR') {
        $scope.nationalIdModel.nationalId.type = 'TAX_ID';
        $scope.nationalIdModel.nationalId.subType = 'CPF';
        $scope.cpfMasking($scope.nationalIdModel.nationalId.value);
      } else if ($scope.country === 'RU') {
        setLocalizedRUContent();
        $scope.nationalIdModel.nationalId.type = 'PASSPORT';
        $scope.nationalIdModel.nationalId.subType = '';
        $scope.user.nativeName = $scope.user.nativeName || {};
        if (!$scope.nationalIdModel.secondaryIdType) {
          $scope.nationalIdModel.secondaryIdType = $scope.secondaryIds.INN.name;
        }
        $scope.secondaryIdChange();
        $scope.countryChanged();
      } else if ($scope.country === 'KR') {
        $scope.nationalIds = {
          'PASSPORT': {
            name: 'PASSPORT_NUMBER',
            value: _squid.$locale.content.addTaxId.passport
          },
          'DL': {
            name: 'DRIVERS_LICENSE',
            value: _squid.$locale.content.addTaxId.dl
          }
        };
        $scope.nationalIdModel.nationalId.type = 'PASSPORT_NUMBER';
        $scope.nationalIdModel.nationalId.subType = '';
      } else {
        // Default behaviour - set to 3pl countries
        setLocalizedNatIDLabels();
        $scope.nationalIdModel.nationalId.type = 'NATIONAL_ID';
        $scope.nationalIdModel.nationalId.subType = '';
      }
      $scope.$on('contentChange', function () {
        setLocalizedNatIDLabels();
        if ($scope.country === 'RU') {
          setLocalizedRUContent();
        }
      });
    }]
  };
}).factory('$NationalIdModel', function () {
  return _squid.$Model.extend('NationalIdModel', {
    init: function init() {
      this._super.init.apply(this);
      this.nationalId = this.nationalId || {};
    },
    serialize: function serialize() {
      return this.nationalId;
    }
  });
});
_angular.$rootScope;
_squid.$feature;
_squid.$locale;
_squid.$Model;
_index.$CheckoutCartModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-form-components/src/national-id-input", "../node_modules/xo-form-components/src/national-id-input/directive.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/national-id-input/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"nationalIdFields\" class=\"clearfix\" content>\n    <div class=\"bankField restricted\">\n        <div ng-switch=\"country\">\n            <div ng-switch-when=\"SG\">\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            ng-change=\"sgIdChange()\"\n                            aria-required=\"true\">\n                        <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           valid-letters=\"data.validLetters\"\n                           sg-id-validations\n                           required/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n            </div>\n\n            <div ng-switch-when=\"BR\">\n\n                <div class=\"inputField confidential nationalId\" floating-label directionality>\n                    <input ng-model=\"formattedValues.nationalId\"\n                           name=\"nationalId\"\n                           id=\"nationalId\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"true\"\n                           autocomplete=\"off\"\n                           xo-error-tooltip\n                           br-id-validations\n                           maxlength=\"14\"\n                           ng-change=\"cpfMasking(formattedValues.nationalId)\"\n                           required/>\n                    <label for=\"nationalId\">{{content('addTaxId.cpf')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"KR\">\n\n                <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                    <select xo-dropdown name=\"idType\"\n                            ng-model=\"nationalIdModel.nationalId.type\"\n                            id=\"idType\"\n                            aria-required=\"false\">\n                        <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                    </select>\n                    <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                </div>\n\n                <div class=\"inputField nationalIDValue\" floating-label directionality>\n                    <input ng-model=\"nationalIdModel.nationalId.value\"\n                           name=\"idValue\"\n                           id=\"idValue\"\n                           class=\"additionalIDBox\"\n                           value=\"\"\n                           autocapitalize=\"off\"\n                           aria-required=\"false\"\n                           autocomplete=\"off\"/>\n                    <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                </div>\n\n            </div>\n\n            <div ng-switch-when=\"RU\">\n\n                <div class=\"nationalId\">\n                    <div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown>\n                        <select xo-dropdown name=\"country\" ng-model=\"user.countryOfResidence\" id=\"country\"\n                                        aria-labelledby=\"countryLabel\" ng-change=\"countryChanged()\" xo-error-tooltip required>\n                            <option ng-repeat=\"country in countries track by $index\" value=\"{{country.code}}\" ng-selected=\"user.countryOfResidence === country.code\">{{country.name}}</option>\n                        </select>\n                        <label for=\"country\" id=\"countryLabel\">{{content('common.country')}}</label>\n                    </div>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <xo-name-input user=\"user.nativeName\"></xo-name-input>\n\n                        <div class=\"inputField confidential full\" floating-label directionality>\n                            <input ng-model=\"user.nativeName.middle_name\"\n                                   name=\"middleName\"\n                                   id=\"middleName\"\n                                   value=\"\"\n                                   autocapitalize=\"off\"\n                                   aria-required=\"true\"\n                                   autocomplete=\"off\"\n                                   required />\n                            <label for=\"middleName\" id=\"middleNameLabel\">{{content('common.middleName')}}</label>\n                        </div>\n                    </div>\n\n                    <div class=\"inputField full\" floating-label directionality>\n                        <input ng-model=\"nationalIdModel.nationalId.value\"\n                                name=\"nationalId\"\n                                id=\"nationalId\"\n                                value=\"\"\n                                autocapitalize=\"off\"\n                                aria-required=\"true\"\n                                autocomplete=\"off\"\n                                minlength=\"{{minLengthNatId}}\"\n                                maxlength=\"{{maxLengthNatId}}\"\n                                placeholder=\"{{user.countryOfResidence === 'RU' && content('addTaxId.passportRU') || content('addTaxId.passportEN')}}\"\n                                xo-validation='{\"validator\": \"validRUPassport\"}'\n                                xo-error-tooltip\n                                required />\n\n                        <label for=\"nationalId\">{{content('addTaxId.passport')}}</label>\n                    </div>\n\n                    <xo-dob-input user=\"user\"></xo-dob-input>\n\n                    <div ng-if=\"showNationalIdFields\">\n                        <legend class=\"fieldLegend\" for=\"additionalId\">{{content('addTaxId.additionalInfo')}}\n                            <div class=\"additionalIdHelper\">\n                                <a href=\"#\" id=\"verifyHelpAdditionalId\" alt=\"Why do we need this\" class=\"verifyHelp\"></a>\n                            </div>\n                            <div class=\"lineSpacing\">\n                                <xo-tooltip trigger=\"#verifyHelpAdditionalId\">\n                                    <div class=\"tip tipDesc\">\n                                        {{content('addTaxId.additionalInfoNote')}}\n                                    </div>\n                                </xo-tooltip>\n                            </div>\n                        </legend>\n\n                        <div id=\"additionalId\">\n                            <div class=\"dropdown inputField\" floating-label-dropdown>\n                                <select xo-dropdown name=\"idType\"\n                                        ng-model=\"nationalIdModel.secondaryIdType\"\n                                        id=\"idType\"\n                                        aria-label=\"{{ content('signup.accountCreationGuest.dobDay') }}\"\n                                        ng-change=\"secondaryIdChange()\"\n                                        aria-required=\"true\">\n                                    <option ng-repeat=\"items in secondaryIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.secondaryIdType === '{{items.name}}'\">{{items.value}}</option>\n                                </select>\n                                <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n                            </div>\n\n                            <div class=\"inputField\" floating-label directionality>\n                                <input ng-model=\"nationalIdModel.secondaryIdValue\"\n                                       name=\"idValue\"\n                                       id=\"idValue\"\n                                       value=\"\"\n                                       maxlength=\"{{maxLength}}\"\n                                       minlength=\"{{minLength}}\"\n                                       autocapitalize=\"off\"\n                                       aria-required=\"true\"\n                                       autocomplete=\"off\"\n                                       placeholder=\"{{(maxLength - maskCharLength)}} {{content('addTaxId.digits')}}\"\n                                       required\n                                       ru-id-validations\n                                       ng-change=\"secondaryIdFormatting()\"/>\n                                <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div ng-switch-default>\n              <div class=\"dropdown nationalID fidobDay inputField\" floating-label-dropdown>\n                  <select xo-dropdown name=\"idType\"\n                          ng-model=\"nationalIdModel.nationalId.type\"\n                          id=\"idType\"\n                          aria-required=\"true\">\n                      <option ng-repeat=\"items in nationalIds track by $index\" value=\"{{items.name}}\" ng-selected=\"nationalIdModel.nationalId.type === '{{items.name}}'\">{{items.value}}</option>\n                  </select>\n                  <label for=\"idType\">{{content('signupAccountCreation.idType')}}</label>\n              </div>\n\n              <div class=\"inputField nationalIDValue\" floating-label directionality>\n                  <input ng-model=\"nationalIdModel.nationalId.value\"\n                         name=\"idValue\"\n                         id=\"idValue\"\n                         class=\"additionalIDBox\"\n                         value=\"\"\n                         autocapitalize=\"off\"\n                         aria-required=\"true\"\n                         autocomplete=\"off\"\n                         required/>\n                  <label for=\"idValue\">{{content('signupAccountCreation.idNumber')}}</label>\n              </div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
__webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");
__webpack_require__("../node_modules/xo-title/dist/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/phone/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('xoAddPhone', function () {
  return {
    template: _template["default"],
    scope: {},
    controller: ['$scope', function ($scope) {
      $scope.showPhoneDisclosure = (0, _squid.$featureCountries)('showPhoneDisclosure').indexOf(_squid.$locale.country) > -1;
      $scope.phoneConsent = (0, _squid.$feature)('phoneConsent');
      $scope.consentContentKey = $scope.phoneConsent ? 'addPhone.phoneConsent' : 'addPhone.phoneDisclosure';
      $scope.errorMessage = {
        msgKeys: ['addPhone.addPhoneNumberConsent'],
        type: 'info'
      };
      $scope.userInfo = _index3.$UserInfoModel.instance(_angular.$rootScope.token);
      $scope.phone = {};
      var CONTENT_KEY = {
        INVALID_PHONE_NUMBER: 'validPhone'
      };
      var CONTENT_MAPPING = {
        numberError: CONTENT_KEY.INVALID_PHONE_NUMBER,
        typeError: CONTENT_KEY.INVALID_PHONE_NUMBER
      };
      var populateErrorMessage = function populateErrorMessage(name) {
        var contentKey = CONTENT_MAPPING[name];
        var msg = contentKey ? _squid.$locale.content.get('scripts.' + contentKey) : 'unresolved content for login error ' + name;
        $scope.errorMessage = {
          msgs: [msg],
          type: 'error'
        };
      };
      var validationErrorHandler = {
        numberError: populateErrorMessage,
        typeError: populateErrorMessage
      };
      (0, _squid.$populate)($scope, {
        auth: _auth.$AuthModel.instance()
      }).then(function () {
        $scope.logout = function () {
          _logger.$logger.info('not_you_logout');
          $scope.auth.action('logout').then(function () {
            _uiRouter.$state.go('checkout.login');
          });
        };
        $scope.showNotYou = $scope.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp' && $scope.logout;
        $scope.onSubmit = function () {
          if ($scope.phoneConsent) {
            $scope.phone.consent = {
              agreed: true,
              contentId: _squid.$locale.country + ':' + _squid.$locale.lang + ':' + $scope.consentContentKey + ':' + (0, _squid.$contentVersion)()
            };
          }
          $scope.userInfo.action('addPhone', {
            data: $scope.phone,
            success: function success(data) {
              return _index2.$CheckoutSessionModel.instance(_angular.$rootScope.token).action('create', {
                success: function success() {
                  _uiRouter.$state.go('checkout.review');
                }
              });
            },
            contingencies: {
              NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
                _angular.$location.path('/checkout/addCard');
              },
              EXPIRED_CREDIT_CARD: function EXPIRED_CREDIT_CARD() {
                _angular.$location.path('/checkout/updateCard');
              }
            },
            validation: function validation(data) {
              angular.forEach(data, function (value, key) {
                validationErrorHandler[key](key);
              });
            }
          });
        };
      });
    }]
  };
});
_angular.$rootScope;
_angular.$location;
_squid.$feature;
_squid.$locale;
_squid.$populate;
_squid.$util;
_squid.$featureCountries;
_squid.$contentVersion;
_uiRouter.$state;
_logger.$logger;
_auth.$AuthModel;
_index2.$CheckoutSessionModel;
_index3.$UserInfoModel;

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/lib/territoriesByCode.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  return {
    'AC': {
      'status': 'reserved',
      'phoneCountryCode': '247',
      'showCountryCodeList': false
    },
    'AD': {
      'status': 'assigned',
      'phoneCountryCode': '376',
      'showCountryCodeList': false
    },
    'AE': {
      'status': 'assigned',
      'phoneCountryCode': '971',
      'showCountryCodeList': false
    },
    'AF': {
      'status': 'assigned',
      'phoneCountryCode': '93',
      'showCountryCodeList': false
    },
    'AG': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'AI': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'AL': {
      'status': 'assigned',
      'phoneCountryCode': '355',
      'showCountryCodeList': false
    },
    'AM': {
      'status': 'assigned',
      'phoneCountryCode': '374',
      'showCountryCodeList': false
    },
    'AN': {
      'status': 'assigned',
      'phoneCountryCode': '599',
      'showCountryCodeList': false
    },
    'AO': {
      'status': 'assigned',
      'phoneCountryCode': '244',
      'showCountryCodeList': false
    },
    'AQ': {
      'status': 'assigned',
      'phoneCountryCode': '672',
      'showCountryCodeList': false
    },
    'AR': {
      'status': 'assigned',
      'phoneCountryCode': '54',
      'showCountryCodeList': false
    },
    'AS': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'AT': {
      'status': 'assigned',
      'phoneCountryCode': '43',
      'showCountryCodeList': true
    },
    'AU': {
      'status': 'assigned',
      'phoneCountryCode': '61',
      'showCountryCodeList': true
    },
    'AW': {
      'status': 'assigned',
      'phoneCountryCode': '297',
      'showCountryCodeList': false
    },
    'AZ': {
      'status': 'assigned',
      'phoneCountryCode': '994',
      'showCountryCodeList': false
    },
    'BA': {
      'status': 'assigned',
      'phoneCountryCode': '387',
      'showCountryCodeList': false
    },
    'BB': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'BD': {
      'status': 'assigned',
      'phoneCountryCode': '880',
      'showCountryCodeList': false
    },
    'BE': {
      'status': 'assigned',
      'phoneCountryCode': '32',
      'showCountryCodeList': true
    },
    'BF': {
      'status': 'assigned',
      'phoneCountryCode': '226',
      'showCountryCodeList': false
    },
    'BG': {
      'status': 'assigned',
      'phoneCountryCode': '359',
      'showCountryCodeList': false
    },
    'BH': {
      'status': 'assigned',
      'phoneCountryCode': '973',
      'showCountryCodeList': false
    },
    'BI': {
      'status': 'assigned',
      'phoneCountryCode': '257',
      'showCountryCodeList': false
    },
    'BJ': {
      'status': 'assigned',
      'phoneCountryCode': '229',
      'showCountryCodeList': false
    },
    'BL': {
      'status': 'assigned',
      'phoneCountryCode': '590',
      'showCountryCodeList': false
    },
    'BM': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'BN': {
      'status': 'assigned',
      'phoneCountryCode': '673',
      'showCountryCodeList': false
    },
    'BO': {
      'status': 'assigned',
      'phoneCountryCode': '591',
      'showCountryCodeList': false
    },
    'BQ': {
      'status': 'assigned',
      'phoneCountryCode': '599',
      'showCountryCodeList': false
    },
    'BR': {
      'status': 'assigned',
      'phoneCountryCode': '55',
      'showCountryCodeList': false
    },
    'BS': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'BT': {
      'status': 'assigned',
      'phoneCountryCode': '975',
      'showCountryCodeList': false
    },
    'BV': {
      'status': 'assigned'
    },
    'BW': {
      'status': 'assigned',
      'phoneCountryCode': '267',
      'showCountryCodeList': false
    },
    'BY': {
      'status': 'assigned',
      'phoneCountryCode': '375',
      'showCountryCodeList': false
    },
    'BZ': {
      'status': 'assigned',
      'phoneCountryCode': '501',
      'showCountryCodeList': false
    },
    'C2': {
      'status': 'assigned',
      'phoneCountryCode': '86',
      'showCountryCodeList': false
    },
    'CA': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'CC': {
      'status': 'assigned',
      'phoneCountryCode': '61',
      'showCountryCodeList': false
    },
    'CD': {
      'status': 'assigned',
      'phoneCountryCode': '243',
      'showCountryCodeList': false
    },
    'CF': {
      'status': 'assigned',
      'phoneCountryCode': '236',
      'showCountryCodeList': false
    },
    'CG': {
      'status': 'assigned',
      'phoneCountryCode': '242',
      'showCountryCodeList': false
    },
    'CH': {
      'status': 'assigned',
      'phoneCountryCode': '41',
      'showCountryCodeList': true
    },
    'CI': {
      'status': 'assigned',
      'phoneCountryCode': '225',
      'showCountryCodeList': false
    },
    'CK': {
      'status': 'assigned',
      'phoneCountryCode': '682',
      'showCountryCodeList': false
    },
    'CL': {
      'status': 'assigned',
      'phoneCountryCode': '56',
      'showCountryCodeList': false
    },
    'CM': {
      'status': 'assigned',
      'phoneCountryCode': '237',
      'showCountryCodeList': false
    },
    'CN': {
      'status': 'assigned',
      'phoneCountryCode': '86',
      'showCountryCodeList': false
    },
    'CO': {
      'status': 'assigned',
      'phoneCountryCode': '57',
      'showCountryCodeList': false
    },
    'CR': {
      'status': 'assigned',
      'phoneCountryCode': '506',
      'showCountryCodeList': false
    },
    'CU': {
      'status': 'assigned',
      'phoneCountryCode': '53',
      'showCountryCodeList': false
    },
    'CV': {
      'status': 'assigned',
      'phoneCountryCode': '238',
      'showCountryCodeList': false
    },
    'CW': {
      'status': 'assigned',
      'phoneCountryCode': '599',
      'showCountryCodeList': false
    },
    'CX': {
      'status': 'assigned',
      'phoneCountryCode': '61',
      'showCountryCodeList': false
    },
    'CY': {
      'status': 'assigned',
      'phoneCountryCode': '357',
      'showCountryCodeList': false
    },
    'CZ': {
      'status': 'assigned',
      'phoneCountryCode': '420',
      'showCountryCodeList': false
    },
    'DE': {
      'status': 'assigned',
      'phoneCountryCode': '49',
      'showCountryCodeList': false
    },
    'DJ': {
      'status': 'assigned',
      'phoneCountryCode': '253',
      'showCountryCodeList': false
    },
    'DK': {
      'status': 'assigned',
      'phoneCountryCode': '45',
      'showCountryCodeList': true
    },
    'DM': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'DO': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'DZ': {
      'status': 'assigned',
      'phoneCountryCode': '213',
      'showCountryCodeList': false
    },
    'EC': {
      'status': 'assigned',
      'phoneCountryCode': '593',
      'showCountryCodeList': false
    },
    'EE': {
      'status': 'assigned',
      'phoneCountryCode': '372',
      'showCountryCodeList': false
    },
    'EG': {
      'status': 'assigned',
      'phoneCountryCode': '20',
      'showCountryCodeList': false
    },
    'EH': {
      'status': 'assigned',
      'phoneCountryCode': '212',
      'showCountryCodeList': false
    },
    'ER': {
      'status': 'assigned',
      'phoneCountryCode': '291',
      'showCountryCodeList': false
    },
    'ES': {
      'status': 'assigned',
      'phoneCountryCode': '34',
      'showCountryCodeList': false
    },
    'ET': {
      'status': 'assigned',
      'phoneCountryCode': '251',
      'showCountryCodeList': false
    },
    'FI': {
      'status': 'assigned',
      'phoneCountryCode': '358',
      'showCountryCodeList': false
    },
    'FJ': {
      'status': 'assigned',
      'phoneCountryCode': '679',
      'showCountryCodeList': false
    },
    'FK': {
      'status': 'assigned',
      'phoneCountryCode': '500',
      'showCountryCodeList': false
    },
    'FM': {
      'status': 'assigned',
      'phoneCountryCode': '691',
      'showCountryCodeList': false
    },
    'FO': {
      'status': 'assigned',
      'phoneCountryCode': '298',
      'showCountryCodeList': false
    },
    'FR': {
      'status': 'assigned',
      'phoneCountryCode': '33',
      'showCountryCodeList': false
    },
    'GA': {
      'status': 'assigned',
      'phoneCountryCode': '241',
      'showCountryCodeList': false
    },
    'GB': {
      'status': 'assigned',
      'phoneCountryCode': '44',
      'showCountryCodeList': false
    },
    'GD': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'GE': {
      'status': 'assigned',
      'phoneCountryCode': '995',
      'showCountryCodeList': false
    },
    'GF': {
      'status': 'assigned',
      'phoneCountryCode': '594',
      'showCountryCodeList': false
    },
    'GG': {
      'status': 'assigned',
      'phoneCountryCode': '44',
      'showCountryCodeList': false
    },
    'GH': {
      'status': 'assigned',
      'phoneCountryCode': '233',
      'showCountryCodeList': false
    },
    'GI': {
      'status': 'assigned',
      'phoneCountryCode': '350',
      'showCountryCodeList': false
    },
    'GL': {
      'status': 'assigned',
      'phoneCountryCode': '299',
      'showCountryCodeList': false
    },
    'GM': {
      'status': 'assigned',
      'phoneCountryCode': '220',
      'showCountryCodeList': false
    },
    'GN': {
      'status': 'assigned',
      'phoneCountryCode': '224',
      'showCountryCodeList': false
    },
    'GP': {
      'status': 'assigned',
      'phoneCountryCode': '590',
      'showCountryCodeList': false
    },
    'GQ': {
      'status': 'assigned',
      'phoneCountryCode': '240',
      'showCountryCodeList': false
    },
    'GR': {
      'status': 'assigned',
      'phoneCountryCode': '30',
      'showCountryCodeList': false
    },
    'GS': {
      'status': 'assigned',
      'phoneCountryCode': '500',
      'showCountryCodeList': false
    },
    'GT': {
      'status': 'assigned',
      'phoneCountryCode': '502',
      'showCountryCodeList': false
    },
    'GU': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'GW': {
      'status': 'assigned',
      'phoneCountryCode': '245',
      'showCountryCodeList': false
    },
    'GY': {
      'status': 'assigned',
      'phoneCountryCode': '592',
      'showCountryCodeList': false
    },
    'HK': {
      'status': 'assigned',
      'phoneCountryCode': '852',
      'showCountryCodeList': true
    },
    'HM': {
      'status': 'assigned'
    },
    'HN': {
      'status': 'assigned',
      'phoneCountryCode': '504',
      'showCountryCodeList': false
    },
    'HR': {
      'status': 'assigned',
      'phoneCountryCode': '385',
      'showCountryCodeList': false
    },
    'HT': {
      'status': 'assigned',
      'phoneCountryCode': '509',
      'showCountryCodeList': false
    },
    'HU': {
      'status': 'assigned',
      'phoneCountryCode': '36',
      'showCountryCodeList': false
    },
    'ID': {
      'status': 'assigned',
      'phoneCountryCode': '62',
      'showCountryCodeList': false
    },
    'IE': {
      'status': 'assigned',
      'phoneCountryCode': '353',
      'showCountryCodeList': false
    },
    'IL': {
      'status': 'assigned',
      'phoneCountryCode': '972',
      'showCountryCodeList': false
    },
    'IM': {
      'status': 'assigned',
      'phoneCountryCode': '44',
      'showCountryCodeList': false
    },
    'IN': {
      'status': 'assigned',
      'phoneCountryCode': '91',
      'showCountryCodeList': false
    },
    'IO': {
      'status': 'assigned',
      'phoneCountryCode': '246',
      'showCountryCodeList': false
    },
    'IQ': {
      'status': 'assigned',
      'phoneCountryCode': '964',
      'showCountryCodeList': false
    },
    'IR': {
      'status': 'assigned',
      'phoneCountryCode': '98',
      'showCountryCodeList': false
    },
    'IS': {
      'status': 'assigned',
      'phoneCountryCode': '354',
      'showCountryCodeList': false
    },
    'IT': {
      'status': 'assigned',
      'phoneCountryCode': '39',
      'showCountryCodeList': false
    },
    'JE': {
      'status': 'assigned',
      'phoneCountryCode': '44',
      'showCountryCodeList': false
    },
    'JM': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'JO': {
      'status': 'assigned',
      'phoneCountryCode': '962',
      'showCountryCodeList': false
    },
    'JP': {
      'status': 'assigned',
      'phoneCountryCode': '81',
      'showCountryCodeList': false
    },
    'KE': {
      'status': 'assigned',
      'phoneCountryCode': '254',
      'showCountryCodeList': false
    },
    'KG': {
      'status': 'assigned',
      'phoneCountryCode': '996',
      'showCountryCodeList': false
    },
    'KH': {
      'status': 'assigned',
      'phoneCountryCode': '855',
      'showCountryCodeList': false
    },
    'KI': {
      'status': 'assigned',
      'phoneCountryCode': '686',
      'showCountryCodeList': false
    },
    'KM': {
      'status': 'assigned',
      'phoneCountryCode': '269',
      'showCountryCodeList': false
    },
    'KN': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'KP': {
      'status': 'assigned',
      'phoneCountryCode': '850',
      'showCountryCodeList': false
    },
    'KR': {
      'status': 'assigned',
      'phoneCountryCode': '82',
      'showCountryCodeList': false
    },
    'KW': {
      'status': 'assigned',
      'phoneCountryCode': '965',
      'showCountryCodeList': false
    },
    'KY': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'KZ': {
      'status': 'assigned',
      'phoneCountryCode': '7',
      'showCountryCodeList': false
    },
    'LA': {
      'status': 'assigned',
      'phoneCountryCode': '856',
      'showCountryCodeList': true
    },
    'LB': {
      'status': 'assigned',
      'phoneCountryCode': '961',
      'showCountryCodeList': false
    },
    'LC': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'LI': {
      'status': 'assigned',
      'phoneCountryCode': '423',
      'showCountryCodeList': false
    },
    'LK': {
      'status': 'assigned',
      'phoneCountryCode': '94',
      'showCountryCodeList': false
    },
    'LR': {
      'status': 'assigned',
      'phoneCountryCode': '231',
      'showCountryCodeList': false
    },
    'LS': {
      'status': 'assigned',
      'phoneCountryCode': '266',
      'showCountryCodeList': false
    },
    'LT': {
      'status': 'assigned',
      'phoneCountryCode': '370',
      'showCountryCodeList': false
    },
    'LU': {
      'status': 'assigned',
      'phoneCountryCode': '352',
      'showCountryCodeList': false
    },
    'LV': {
      'status': 'assigned',
      'phoneCountryCode': '371',
      'showCountryCodeList': false
    },
    'LY': {
      'status': 'assigned',
      'phoneCountryCode': '218',
      'showCountryCodeList': false
    },
    'MA': {
      'status': 'assigned',
      'phoneCountryCode': '212',
      'showCountryCodeList': false
    },
    'MC': {
      'status': 'assigned',
      'phoneCountryCode': '377',
      'showCountryCodeList': false
    },
    'MD': {
      'status': 'assigned',
      'phoneCountryCode': '373',
      'showCountryCodeList': false
    },
    'ME': {
      'status': 'assigned',
      'phoneCountryCode': '382',
      'showCountryCodeList': false
    },
    'MF': {
      'status': 'assigned',
      'phoneCountryCode': '590',
      'showCountryCodeList': false
    },
    'MG': {
      'status': 'assigned',
      'phoneCountryCode': '261',
      'showCountryCodeList': false
    },
    'MH': {
      'status': 'assigned',
      'phoneCountryCode': '692',
      'showCountryCodeList': false
    },
    'MK': {
      'status': 'assigned',
      'phoneCountryCode': '389',
      'showCountryCodeList': false
    },
    'ML': {
      'status': 'assigned',
      'phoneCountryCode': '223',
      'showCountryCodeList': false
    },
    'MM': {
      'status': 'assigned',
      'phoneCountryCode': '95',
      'showCountryCodeList': false
    },
    'MN': {
      'status': 'assigned',
      'phoneCountryCode': '976',
      'showCountryCodeList': false
    },
    'MO': {
      'status': 'assigned',
      'phoneCountryCode': '853',
      'showCountryCodeList': false
    },
    'MP': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'MQ': {
      'status': 'assigned',
      'phoneCountryCode': '596',
      'showCountryCodeList': false
    },
    'MR': {
      'status': 'assigned',
      'phoneCountryCode': '222',
      'showCountryCodeList': false
    },
    'MS': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'MT': {
      'status': 'assigned',
      'phoneCountryCode': '356',
      'showCountryCodeList': false
    },
    'MU': {
      'status': 'assigned',
      'phoneCountryCode': '230',
      'showCountryCodeList': false
    },
    'MV': {
      'status': 'assigned',
      'phoneCountryCode': '960',
      'showCountryCodeList': false
    },
    'MW': {
      'status': 'assigned',
      'phoneCountryCode': '265',
      'showCountryCodeList': false
    },
    'MX': {
      'status': 'assigned',
      'phoneCountryCode': '52',
      'showCountryCodeList': false
    },
    'MY': {
      'status': 'assigned',
      'phoneCountryCode': '60',
      'showCountryCodeList': false
    },
    'MZ': {
      'status': 'assigned',
      'phoneCountryCode': '258',
      'showCountryCodeList': false
    },
    'NA': {
      'status': 'assigned',
      'phoneCountryCode': '264',
      'showCountryCodeList': false
    },
    'NC': {
      'status': 'assigned',
      'phoneCountryCode': '687',
      'showCountryCodeList': false
    },
    'NE': {
      'status': 'assigned',
      'phoneCountryCode': '227',
      'showCountryCodeList': false
    },
    'NF': {
      'status': 'assigned',
      'phoneCountryCode': '672',
      'showCountryCodeList': false
    },
    'NG': {
      'status': 'assigned',
      'phoneCountryCode': '234',
      'showCountryCodeList': false
    },
    'NI': {
      'status': 'assigned',
      'phoneCountryCode': '505',
      'showCountryCodeList': false
    },
    'NL': {
      'status': 'assigned',
      'phoneCountryCode': '31',
      'showCountryCodeList': true
    },
    'NO': {
      'status': 'assigned',
      'phoneCountryCode': '47',
      'showCountryCodeList': true
    },
    'NP': {
      'status': 'assigned',
      'phoneCountryCode': '977',
      'showCountryCodeList': false
    },
    'NR': {
      'status': 'assigned',
      'phoneCountryCode': '674',
      'showCountryCodeList': false
    },
    'NU': {
      'status': 'assigned',
      'phoneCountryCode': '683',
      'showCountryCodeList': false
    },
    'NZ': {
      'status': 'assigned',
      'phoneCountryCode': '64',
      'showCountryCodeList': false
    },
    'OM': {
      'status': 'assigned',
      'phoneCountryCode': '968',
      'showCountryCodeList': false
    },
    'PA': {
      'status': 'assigned',
      'phoneCountryCode': '507',
      'showCountryCodeList': false
    },
    'PE': {
      'status': 'assigned',
      'phoneCountryCode': '51',
      'showCountryCodeList': false
    },
    'PF': {
      'status': 'assigned',
      'phoneCountryCode': '689',
      'showCountryCodeList': false
    },
    'PG': {
      'status': 'assigned',
      'phoneCountryCode': '675',
      'showCountryCodeList': false
    },
    'PH': {
      'status': 'assigned',
      'phoneCountryCode': '63',
      'showCountryCodeList': false
    },
    'PK': {
      'status': 'assigned',
      'phoneCountryCode': '92',
      'showCountryCodeList': false
    },
    'PL': {
      'status': 'assigned',
      'phoneCountryCode': '48',
      'showCountryCodeList': true
    },
    'PM': {
      'status': 'assigned',
      'phoneCountryCode': '508',
      'showCountryCodeList': false
    },
    'PN': {
      'status': 'assigned',
      'phoneCountryCode': '870',
      'showCountryCodeList': false
    },
    'PR': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'PS': {
      'status': 'assigned',
      'phoneCountryCode': '970',
      'showCountryCodeList': false
    },
    'PT': {
      'status': 'assigned',
      'phoneCountryCode': '351',
      'showCountryCodeList': false
    },
    'PW': {
      'status': 'assigned',
      'phoneCountryCode': '680',
      'showCountryCodeList': false
    },
    'PY': {
      'status': 'assigned',
      'phoneCountryCode': '595',
      'showCountryCodeList': false
    },
    'QA': {
      'status': 'assigned',
      'phoneCountryCode': '974',
      'showCountryCodeList': false
    },
    'RE': {
      'status': 'assigned',
      'phoneCountryCode': '262',
      'showCountryCodeList': false
    },
    'RO': {
      'status': 'assigned',
      'phoneCountryCode': '40',
      'showCountryCodeList': false
    },
    'RS': {
      'status': 'assigned',
      'phoneCountryCode': '381',
      'showCountryCodeList': false
    },
    'RU': {
      'status': 'assigned',
      'phoneCountryCode': '7',
      'showCountryCodeList': false
    },
    'RW': {
      'status': 'assigned',
      'phoneCountryCode': '250',
      'showCountryCodeList': false
    },
    'SA': {
      'status': 'assigned',
      'phoneCountryCode': '966',
      'showCountryCodeList': false
    },
    'SB': {
      'status': 'assigned',
      'phoneCountryCode': '677',
      'showCountryCodeList': false
    },
    'SC': {
      'status': 'assigned',
      'phoneCountryCode': '248',
      'showCountryCodeList': false
    },
    'SD': {
      'status': 'assigned',
      'phoneCountryCode': '249',
      'showCountryCodeList': false
    },
    'SE': {
      'status': 'assigned',
      'phoneCountryCode': '46',
      'showCountryCodeList': true
    },
    'SG': {
      'status': 'assigned',
      'phoneCountryCode': '65',
      'showCountryCodeList': true
    },
    'SH': {
      'status': 'assigned',
      'phoneCountryCode': '290',
      'showCountryCodeList': false
    },
    'SI': {
      'status': 'assigned',
      'phoneCountryCode': '386',
      'showCountryCodeList': false
    },
    'SJ': {
      'status': 'assigned',
      'phoneCountryCode': '47',
      'showCountryCodeList': false
    },
    'SK': {
      'status': 'assigned',
      'phoneCountryCode': '421',
      'showCountryCodeList': false
    },
    'SL': {
      'status': 'assigned',
      'phoneCountryCode': '232',
      'showCountryCodeList': false
    },
    'SM': {
      'status': 'assigned',
      'phoneCountryCode': '378',
      'showCountryCodeList': false
    },
    'SN': {
      'status': 'assigned',
      'phoneCountryCode': '221',
      'showCountryCodeList': false
    },
    'SO': {
      'status': 'assigned',
      'phoneCountryCode': '252',
      'showCountryCodeList': false
    },
    'SR': {
      'status': 'assigned',
      'phoneCountryCode': '597',
      'showCountryCodeList': false
    },
    'SS': {
      'status': 'assigned',
      'phoneCountryCode': '211',
      'showCountryCodeList': false
    },
    'ST': {
      'status': 'assigned',
      'phoneCountryCode': '239',
      'showCountryCodeList': false
    },
    'SV': {
      'status': 'assigned',
      'phoneCountryCode': '503',
      'showCountryCodeList': false
    },
    'SX': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'SY': {
      'status': 'assigned',
      'phoneCountryCode': '963',
      'showCountryCodeList': false
    },
    'SZ': {
      'status': 'assigned',
      'phoneCountryCode': '268',
      'showCountryCodeList': false
    },
    'TC': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'TD': {
      'status': 'assigned',
      'phoneCountryCode': '235',
      'showCountryCodeList': false
    },
    'TF': {
      'status': 'assigned',
      'phoneCountryCode': '262',
      'showCountryCodeList': false
    },
    'TG': {
      'status': 'assigned',
      'phoneCountryCode': '228',
      'showCountryCodeList': false
    },
    'TH': {
      'status': 'assigned',
      'phoneCountryCode': '66',
      'showCountryCodeList': false
    },
    'TJ': {
      'status': 'assigned',
      'phoneCountryCode': '992',
      'showCountryCodeList': false
    },
    'TK': {
      'status': 'assigned',
      'phoneCountryCode': '690',
      'showCountryCodeList': false
    },
    'TL': {
      'status': 'assigned',
      'phoneCountryCode': '670',
      'showCountryCodeList': false
    },
    'TM': {
      'status': 'assigned',
      'phoneCountryCode': '993',
      'showCountryCodeList': false
    },
    'TN': {
      'status': 'assigned',
      'phoneCountryCode': '216',
      'showCountryCodeList': false
    },
    'TO': {
      'status': 'assigned',
      'phoneCountryCode': '676',
      'showCountryCodeList': false
    },
    'TR': {
      'status': 'assigned',
      'phoneCountryCode': '90',
      'showCountryCodeList': true
    },
    'TT': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'TV': {
      'status': 'assigned',
      'phoneCountryCode': '688',
      'showCountryCodeList': false
    },
    'TW': {
      'status': 'assigned',
      'phoneCountryCode': '886',
      'showCountryCodeList': true
    },
    'TZ': {
      'status': 'assigned',
      'phoneCountryCode': '255',
      'showCountryCodeList': false
    },
    'UA': {
      'status': 'assigned',
      'phoneCountryCode': '380',
      'showCountryCodeList': false
    },
    'UG': {
      'status': 'assigned',
      'phoneCountryCode': '256',
      'showCountryCodeList': false
    },
    'UM': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'US': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false,
      'hideInOtherCountries': true
    },
    'UY': {
      'status': 'assigned',
      'phoneCountryCode': '598',
      'showCountryCodeList': false
    },
    'UZ': {
      'status': 'assigned',
      'phoneCountryCode': '998',
      'showCountryCodeList': false
    },
    'VA': {
      'status': 'assigned',
      'phoneCountryCode': '39',
      'showCountryCodeList': false
    },
    'VC': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'VE': {
      'status': 'assigned',
      'phoneCountryCode': '58',
      'showCountryCodeList': false
    },
    'VG': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'VI': {
      'status': 'assigned',
      'phoneCountryCode': '1',
      'showCountryCodeList': false
    },
    'VN': {
      'status': 'assigned',
      'phoneCountryCode': '84',
      'showCountryCodeList': false
    },
    'VU': {
      'status': 'assigned',
      'phoneCountryCode': '678',
      'showCountryCodeList': false
    },
    'WF': {
      'status': 'assigned',
      'phoneCountryCode': '681',
      'showCountryCodeList': false
    },
    'WS': {
      'status': 'assigned',
      'phoneCountryCode': '685',
      'showCountryCodeList': false
    },
    'YE': {
      'status': 'assigned',
      'phoneCountryCode': '967',
      'showCountryCodeList': false
    },
    'YT': {
      'status': 'assigned',
      'phoneCountryCode': '262',
      'showCountryCodeList': false
    },
    'ZA': {
      'status': 'assigned',
      'phoneCountryCode': '27',
      'showCountryCodeList': false
    },
    'ZM': {
      'status': 'assigned',
      'phoneCountryCode': '260',
      'showCountryCodeList': false
    },
    'ZW': {
      'status': 'assigned',
      'phoneCountryCode': '263',
      'showCountryCodeList': false
    }
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/template.html"));
__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoPhoneInput', {
  tag: 'xo-phone-input',
  template: _template["default"],
  props: {
    phone: {
      type: 'var',
      reqiured: false
    },
    showPhoneType: {
      type: 'var',
      optional: true,
      "default": true
    },
    hideWork: {
      type: 'var',
      optional: true,
      "default": false
    },
    token: {
      type: 'var',
      optional: true
    },
    exclude: {
      type: 'var',
      optional: true
    },
    hidePhoneType: {
      type: 'var',
      optional: true,
      "default": false
    },
    country: {
      type: 'var',
      optional: true
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      var getTreatment = function getTreatment() {
        if ((0, _squid.$feature)('showNewPhoneDesign', false, _squid.$locale.country)) {
          return true;
        }
        var throttle;
        if (_squid.$config['newPhoneDesignThrottle']) {
          throttle = _squid.$config['newPhoneDesignThrottle']['DEFAULT'];
          if (_squid.$config['newPhoneDesignThrottle'][_squid.$locale.country] >= 0) {
            throttle = _squid.$config['newPhoneDesignThrottle'][_squid.$locale.country];
          }
        }
        var id = _squid.$locale.country + _angular.$rootScope.token;
        return throttle !== undefined && (0, _squid.$experiment)('new_phone_design_exp', throttle, id, {}) ? true : false;
      };
      this.treatment = getTreatment();
      this.$watch('showPhoneType', function () {
        _this.hidePhoneType = _this.showPhoneType === false;
      }, true);
    }
  }
});
_angular.$rootScope;
_squid.$Component;
_squid.$locale;
_squid.$experiment;
_squid.$config;
_squid.$feature;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInput/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-phone-input-a ng-if=\"!treatment\" token=\"token\" phone=\"phone\"\n                  show-phone-type=\"showPhoneType\" exclude=\"exclude\" country=\"country\"></xo-phone-input-a>\n<xo-phone-input-b ng-if=\"treatment\" phone=\"phone\" hide-phone-type=\"hidePhoneType\" show-phone-type=\"showPhoneType\"\n                  hide-work=\"hideWork\"></xo-phone-input-b>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");
var _territoriesByCode = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/phone/lib/territoriesByCode.js"));
__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputA/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('xoPhoneInputA', function () {
  return {
    template: _template["default"],
    scope: {
      phone: '=?',
      showPhoneType: '=?',
      exclude: '@?',
      country: '=?'
    },
    link: function link(scope, element, attr, controller) {
      element.on('keyup', function (event) {
        element.find('.telephone').mask(scope.mask, {
          'translation': {
            0: {
              pattern: /[0-9]/
            }
          }
        });
      });
    },
    controller: ['$scope', function ($scope) {
      $scope.locale = _squid.$locale;
      $scope.IntDialingCodes = _territoriesByCode["default"];
      $scope.defaultCountryPhoneCode = _territoriesByCode["default"][_squid.$locale.country];
      $scope.showPhoneType = (0, _squid.$feature)('phoneType', true, $scope.country) && $scope.showPhoneType !== false;

      // dont display countries that are tagged with hideInOtherCountries flag in territoriesByCode.js.
      // if localeCountry and dropdown country are same ignore hideInOtherCountries and display the countrycode.
      $scope.hideCountry = function (dropdownCountry, hideInOtherCountries) {
        return _squid.$locale.country !== dropdownCountry && hideInOtherCountries;
      };
      $scope.phone = $scope.phone || {};
      $scope.phone.phoneType = $scope.phone.phoneType || 'Mobile';
      $scope.phone.IntDialingCountryCode = $scope.defaultCountryPhoneCode.phoneCountryCode;
      angular.extend($scope.phone, {
        phoneCountryCode: _squid.$locale.country
      });
      function getPhoneMask(phoneType, phoneEntry) {
        var defaultMask = '0000000000000000';
        var masks = phoneEntry && phoneEntry.masks;
        var mobileMask = masks && masks.MOBILE ? masks.MOBILE : defaultMask;
        var fixedLineMask = masks && masks.FIXED_LINE ? masks.FIXED_LINE : defaultMask;
        return phoneType === 'Mobile' ? mobileMask : fixedLineMask;
      }
      function getPhonePattern(phoneEntry) {
        var defaultPattern = '^[0-9]+$';
        var patterns = phoneEntry && phoneEntry.patterns;
        // less stric regex validation in place for now, just use general regex to match mobile AND fixed-line formats
        // for now we use less strict regex validation because we are not ready for this more strict validation

        if (patterns) {
          return patterns.GENERAL ? patterns.GENERAL : defaultPattern;
        }
        return defaultPattern;

        // more strict regex validaiton based on phone type is found commented below
        // var ret;
        // switch ($scope.phone.phoneType) {
        //     case 'Mobile':
        //         ret = patterns.MOBILE;
        //         break;
        //     case 'Home':
        //     case 'Work':
        //         ret = patterns.FIXED_LINE;
        //         break;
        //     default:
        //         ret = patterns.GENERAL;
        //         break;
        // }
        // return ret ? ret : defaultPattern;
      }
      function populatePhoneMetadata() {
        if (!$scope.metadata || $scope.metadata.country !== _squid.$locale.metadata.country) {
          $scope.metadata = angular.copy(_squid.$locale.metadata);
        }
        var phoneEntry = $scope.metadata.phoneEntry;
        $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
        $scope.pattern = getPhonePattern(phoneEntry);
      }
      populatePhoneMetadata();

      // Reset the phone number mask from according to the phone type
      $scope.phoneTypeChanged = function () {
        $scope.mask = getPhoneMask($scope.phone.phoneType, $scope.metadata.phoneEntry);
        $scope.pattern = getPhonePattern($scope.metadata.phoneEntry);
        $('.telephone').mask($scope.mask);
      };
      $scope.$watch('phone.phoneCountryCode', function (newValue) {
        $scope.phone.IntDialingCountryCode = _territoriesByCode["default"][newValue].phoneCountryCode;
      });
      $scope.$on('localeChange', function () {
        $scope.defaultCountryPhoneCode = _territoriesByCode["default"][_squid.$locale.country];
        $scope.phone.phoneCountryCode = _squid.$locale.country;
        if (!$scope.metadata || $scope.metadata.country !== _squid.$locale.metadata.country) {
          populatePhoneMetadata();
          $('.telephone').mask($scope.mask);
        }
      });
      $scope.$watch('country', function (newVal) {
        if (newVal) {
          $scope.defaultCountryPhoneCode = _territoriesByCode["default"][$scope.country];
          $scope.phone.phoneCountryCode = $scope.country;
          if (!$scope.metadata || $scope.metadata.country !== $scope.country) {
            $scope.metadata = _squid.$MetadataModel.create();
            $scope.metadata.choose($scope.country, _squid.$locale.lang).then(function () {
              var phoneEntry = $scope.metadata.phoneEntry;
              $scope.mask = getPhoneMask($scope.phone.phoneType, phoneEntry);
              $scope.pattern = getPhonePattern(phoneEntry);
              $('.telephone').mask($scope.mask);
            });
          }
        }
      });
      $scope.showWork = $scope.exclude === 'WORK';
    }]
  };
});
_squid.$feature;
_squid.$locale;
_squid.$MetadataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputA/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid fieldGroup clearfix\" ng-class=\"{countryCodeSelect: defaultCountryPhoneCode.showCountryCodeList === true}\" content>\n    <div id=\"phoneTypeContainer\" class=\"phoneTypeContainer dropdown confidential inputField half\" ng-cloak\n         ng-if=\"showPhoneType === true\" ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl'}\"\n         floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneType\" name=\"phoneType\" id=\"phoneType\" ng-change=\"phoneTypeChanged()\" xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!showWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n    <div id=\"phoneCodeContainer\" class=\"phoneCodeContainer dropdown confidential half last-child inputField\" ng-cloak\n         ng-if=\"defaultCountryPhoneCode.showCountryCodeList\" floating-label-dropdown>\n        <select xo-dropdown ng-model=\"phone.phoneCountryCode\" name=\"phoneCountryCode\" id=\"phoneCountryCode\" aria-required=\"true\" xo-error-tooltip required>\n            <option ng-repeat=\"(key, value) in IntDialingCodes track by $index\" value=\"{{key}}\" ng-if=\"!hideCountry(key, value.hideInOtherCountries)\" ng-selected=\"phone.phoneCountryCode === key\">{{value.phoneCountryCode}} ({{key}})</option>\n        </select>\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n    <div class=\"inputField confidential last-child\"\n         ng-class=\"{'half': showPhoneType || defaultCountryPhoneCode.showCountryCodeList, 'telephoneField': showPhoneType,\n         'telephoneFieldFull': !showPhoneType, 'rtlPhoneField': locale.metadata.directionality === 'rtl',\n         singleLineMobile: !showPhoneType && !defaultCountryPhoneCode.showCountryCodeList}\" floating-label directionality >\n\n        <input id=\"telephone\"\n               class=\"telephone\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               country-code=\"phone.phoneCountryCode\"\n               phone-pattern=\"{{pattern}}\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               required\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\">{{content('common.phone')}}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/template.html"));
__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInputB/styles.less");
__webpack_require__("../node_modules/xo-jquery-mask-plugin/dist/jquery.mask.min.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MOBILE = 'Mobile';
var KEYS = {
  ENTER: 13,
  UP: 38,
  DOWN: 40,
  TAB: 9,
  ESC: 27,
  A: 65,
  Z: 90,
  SPACE: 32
};
var query = '';
var queryTimer = null;
var _default = exports["default"] = _squid.$Component.extend('$xoPhoneInputB', {
  tag: 'xo-phone-input-b',
  template: _template["default"],
  props: {
    phone: {
      type: 'var',
      required: false
    },
    hidePhoneType: {
      type: 'var',
      required: false
    },
    hideWork: {
      type: 'var',
      required: false,
      "default": false
    }
  },
  actions: {
    // return the phonePattern
    getPhonePattern: function getPhonePattern(phoneEntry) {
      var DEFAULT_PATTERN = '^[0-9]+$';
      var patterns = phoneEntry && phoneEntry.patterns;
      // less strict regex validation in place for now, just use general regex to match mobile AND fixed-line
      // formats
      // for now we use less strict regex validation because we are not ready for this more strict validation

      return patterns && patterns.GENERAL ? patterns.GENERAL : DEFAULT_PATTERN;
    },
    // return phoneMask based on phone Type
    getPhoneMask: function getPhoneMask(phoneType, phoneEntry) {
      var DEFAULT_MASK = '0000000000000000';
      var masks = phoneEntry && phoneEntry.masks;
      if (phoneType === MOBILE) {
        return masks && masks.MOBILE ? masks.MOBILE : DEFAULT_MASK;
      } else {
        return masks && masks.FIXED_LINE ? masks.FIXED_LINE : DEFAULT_MASK;
      }
    },
    // set the phone number mask and pattern
    updatePhoneMaskAndPattern: function updatePhoneMaskAndPattern() {
      // We need this check because in safari '13.1.3 iPhone XS' we see 'undefined is not an object'
      // error when country.x=CN and locale.x=en_CN in line 78 - this.metadata.localization.country
      if (this.metadata && this.metadata.localization) {
        var country = this.metadata.localization.country;
        // If phoneCountry does not match the country the metadata is from then
        // we set phoneEntry to a falsey value so the default pattern and mask are
        // used for the phone input.
        var phoneEntry = this.phoneCountry === country && this.metadata.phoneEntry;
        _logger.$logger.info("metadata_country_for_phone_mask_" + country);
        this.mask = this.actions.getPhoneMask(this.phone.phoneType, phoneEntry);
        this.pattern = this.actions.getPhonePattern(phoneEntry);
        this.actions.applyMaskOnPhoneInput();
      }
    },
    getPhoneDialingCode: function getPhoneDialingCode(territory, state) {
      var overrides = this.metadata.regionalOverrides;
      if (state && overrides && overrides.hasOwnProperty(state) && overrides[state].props.internationalDialingCode) {
        return overrides[state].props.internationalDialingCode;
      }
      return territory.internationalDialingCode;
    },
    // fetch the passed country's international dialing code
    updateDialingCodeAndCountry: function updateDialingCodeAndCountry(territory, state) {
      if (territory === void 0) {
        territory = {};
      }
      this.phoneCountry = territory.code;
      this.phone.phoneCountry = territory.code;
      this.phone.IntDialingCountryCode = this.actions.getPhoneDialingCode(territory, state);
      (0, _jquery["default"])('.fixedCode').text('+' + this.phone.IntDialingCountryCode);
    },
    /* if user chooses a different dialing code -
     -. fetch the new country's metadata
     -. update phone Country and dialing code
     -. update the phone number mask and pattern (no explicit call as it happens when metadata updates)
     -. close the dropdown if open
     */
    updatePhoneFieldMetadata: function updatePhoneFieldMetadata(territory, state) {
      if (territory === void 0) {
        territory = {};
      }
      // create a local copy of metadata (only happens on initial load)
      if (!this.metadata) {
        this.metadata = _squid.$MetadataModel.instance(0, {
          'noBroadcast': true
        });
      }
      this.metadata.choose(territory.code);
      this.actions.updateDialingCodeAndCountry(territory, state);
      // Whenever metadata is updated that is promise returns then the metadata listener will update the mask
      // and pattern so not calling it here. Moving on...

      // close the dropdown if open
      if (this.listVisible) {
        this.actions.collapseListAndFocusOnParent();
      }
      _logger.$logger.info('phone_country_code_updated', {
        territory: territory.code
      });
    },
    getTerritoryDataFromMetadata: function getTerritoryDataFromMetadata(country) {
      return _squid.$util.find(this.dialingCodeList, function (_ref) {
        var code = _ref.code;
        return code === country;
      });
    },
    // set the stage on first load or on locale change
    init: function init(country) {
      this.hidePhoneType = this.hidePhoneType || (0, _squid.$feature)('hidePhoneType', false, country);
      this.showDialingCodeContainer = (0, _squid.$feature)('showDialingCodeContainer', false, country);
      this.listVisible = false;

      // default the phone type to Mobile if not specified
      // Note: this.phone is not optional
      this.phone = this.phone || {};
      this.phone.phoneType = this.phone.phoneType || 'Mobile';

      // populate the dialing code list/options
      var _$locale$metadata = _squid.$locale.metadata,
        _$locale$metadata$ter = _$locale$metadata.territory,
        territory = _$locale$metadata$ter === void 0 ? [] : _$locale$metadata$ter,
        _$locale$metadata$add = _$locale$metadata.additionalDialingCodes,
        additionalDialingCodes = _$locale$metadata$add === void 0 ? [] : _$locale$metadata$add;
      var _$config$dialingCodeB = _squid.$config.dialingCodeBlacklist,
        dialingCodeBlacklist = _$config$dialingCodeB === void 0 ? [] : _$config$dialingCodeB;

      // Merge dialing codes from supported countries with dialing codes from
      // assigned countries and then filtering countries that are blacklisted
      this.dialingCodeList = territory.concat(additionalDialingCodes).filter(function (_ref2) {
        var code = _ref2.code;
        return !dialingCodeBlacklist.includes(code);
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      var territoryData = this.actions.getTerritoryDataFromMetadata(this.phone.phoneCountry || country);
      this.actions.updatePhoneFieldMetadata(territoryData);
    },
    // helper to show the options list and focus on the selected phone country option
    expandList: function expandList() {
      (0, _jquery["default"])('.country-list').show();
      this.listVisible = true;
      (0, _jquery["default"])('.country-list .country.selected').focus();
    },
    // helper to collapse the options
    collapseList: function collapseList() {
      this.listVisible = false;
      (0, _jquery["default"])('.country-list').hide();
    },
    // helper to collapse the options and xfer focus back to the parent dropdown
    collapseListAndFocusOnParent: function collapseListAndFocusOnParent() {
      this.actions.collapseList();
      (0, _jquery["default"])('#dialingCodeContainer div.selected-flag').focus();
    },
    // helper to toggle the dropdown list
    toggleList: function toggleList() {
      if (this.listVisible) {
        this.actions.collapseListAndFocusOnParent();
      } else {
        this.actions.expandList();
      }
    },
    // remove highlighting from other list items and highlight the given item
    highlightListItem: function highlightListItem(listItem) {
      (0, _jquery["default"])('li.country').removeClass('highlight');
      listItem.addClass('highlight');
      listItem.focus();
    },
    // select the given item and update the phone field metadata
    selectListItem: function selectListItem(listItem) {
      var country = listItem.attr('data-country-code');
      var territory = this.actions.getTerritoryDataFromMetadata(country);
      this.actions.updatePhoneFieldMetadata(territory);
    },
    // find the first list item whose name starts with the query string
    searchForCountry: function searchForCountry(queryString) {
      for (var i = 0; i < this.dialingCodeList.length; i++) {
        if (this.actions.startsWith(this.dialingCodeList[i].name, queryString)) {
          var listItem = (0, _jquery["default"])('.country-list').find('[data-country-code="' + this.dialingCodeList[i].code + '"]');
          // update highlighting and scroll

          this.actions.highlightListItem(listItem);
          break;
        }
      }
    },
    // check if (uppercase) string a starts with string b
    startsWith: function startsWith(a, b) {
      return a.substr(0, b.length).toUpperCase() === b;
    },
    // When Switching between double Byte -> Single Byte character
    // angular model is not properly updated by jquery-mask (PPPLMER-52127)
    // re-update the model with entered value.
    updateAngularModel: function updateAngularModel() {
      if (this.phone.ispreFill) {
        // We set the flag to false once the prefill is completed.
        // This helps to update angular model properly upon next keyUp()
        this.phone.ispreFill = false;
      } else {
        this.phone.telephone = this.$element.find('.telephone').val();
      }
    },
    // format the phone number
    applyMaskOnPhoneInput: function applyMaskOnPhoneInput() {
      // If `this.mask` is `undefined` and we try to mask this field
      // jQuery mask will throw a type error when it tries to access
      // `mask.length` during a for loop.
      if (!this.mask) {
        return;
      }
      this.actions.updateAngularModel();
      this.$element.find('.telephone').mask(this.mask, {
        'translation': {
          0: {
            pattern: /[0-9]/
          }
        }
      });
    },
    // highlight the event target
    handleListMouseover: function handleListMouseover($event) {
      this.actions.highlightListItem((0, _jquery["default"])($event.target));
    },
    // expand the list when down arrow is pressed
    handleKeyboardInputForDropdown: function handleKeyboardInputForDropdown($event) {
      var key = $event.which;
      if (key === KEYS.DOWN || key === KEYS.UP || key === KEYS.SPACE) {
        $event.stopPropagation();
        $event.preventDefault();
        this.actions.expandList();
      } else {
        this.actions.collapseList();
      }
    },
    /*
     navigating list using the keyboard
     up, down, esc, enter and letter keys
     */
    handleKeyboardInputForList: function handleKeyboardInputForList($event) {
      var $listItems = (0, _jquery["default"])('li.country');
      var key = $event.which;
      var $selected = (0, _jquery["default"])($event.target);
      var $current;
      $event.stopPropagation();
      $event.preventDefault();

      // if user types in an input, focus on the first country starting with that query
      // upper case letters (since keyup/keydown only return upper case letters)
      if (key >= KEYS.A && key <= KEYS.Z) {
        if (queryTimer) {
          _angular.$timeout.cancel(queryTimer);
        }
        query += String.fromCharCode(key);
        this.actions.searchForCountry(query);
        queryTimer = (0, _angular.$timeout)(function () {
          query = '';
        }, 1e3);
        return;
      }

      // ignore other keys
      if (key !== KEYS.DOWN && key !== KEYS.UP && key !== KEYS.ENTER && key !== KEYS.ESC) {
        return;
      }

      // select the the new phone country when user hits enter
      if (key === KEYS.ENTER) {
        this.actions.selectListItem($selected);
        return;
      }

      // close the list if escape is pressed
      if (key === KEYS.ESC) {
        this.actions.collapseListAndFocusOnParent();
        return;
      }

      // highlight the next/prev element when arrow key is pressed
      if (key === KEYS.DOWN)
        // Down key
        {
          if (!$selected.length || $selected.is(':last-child')) {
            $current = $listItems.eq(0);
          } else {
            $current = $selected.next();
          }
        }

      // Up key
      if (key === KEYS.UP) {
        if (!$selected.length || $selected.is(':first-child')) {
          $current = $listItems.last();
        } else {
          $current = $selected.prev();
        }
      }
      this.actions.highlightListItem($current);
    }
  },
  lifecycle: {
    enter: function enter() {
      this.actions.init(_squid.$locale.country);
    },
    populate: function populate() {
      var _this = this;
      this.$on('localeChange', function () {
        _this.actions.init(_squid.$locale.country);
      });

      // update the phone mask and pattern when metadata is changed
      this.$watch('metadata', function () {
        _this.actions.updatePhoneMaskAndPattern();
      }, true);

      // update the mask when .telephone val changes either programatically or via user action
      this.$watch('this.phone.telephone', function (newVal) {
        if (newVal) {
          _this.$element.find('.telephone').val(newVal).trigger('input');
        }
      }, true);
      var addressChangeEvent = _angular.$rootScope.$on('billingAddressStateChange', function (e, address) {
        var territory = _this.actions.getTerritoryDataFromMetadata(_this.metadata.country);
        _this.actions.updatePhoneFieldMetadata(territory, address.state);
      });
      this.$on('$destroy', addressChangeEvent);

      // hide the dropdown list if a click occurs anywhere else on the page
      (0, _jquery["default"])('*').on('click', function (event) {
        if (!(0, _jquery["default"])('#dialingCodeContainer div.selected-flag').is((0, _jquery["default"])(event.target))) {
          _this.actions.collapseList();
        }
      });
    }
  }
});
_angular.$rootScope;
_angular.$timeout;
_squid.$Component;
_squid.$locale;
_squid.$feature;
_squid.$util;
_squid.$MetadataModel;
_squid.$config;
_logger.$logger;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/phoneInputB/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid fieldGroup clearfix\" content>\n    <div ng-if=\"hidePhoneType !== true\"\n         id=\"phoneTypeContainer\"\n         class=\"phoneTypeContainer dropdown confidential inputField half\"\n         ng-class=\"{'rtlPhoneType': locale.metadata.directionality === 'rtl', 'dialCodeVisible': showDialingCodeContainer}\"\n         ng-cloak\n         floating-label-dropdown >\n\n        <select xo-dropdown\n                ng-model=\"phone.phoneType\"\n                name=\"phoneType\"\n                id=\"phoneType\"\n                ng-change=\"actions.updatePhoneMaskAndPattern()\"\n                track-focus-and-blur=\"phoneType\"\n                xo-error-tooltip>\n            <option value=\"Mobile\" selected=\"\">{{content('common.mobile')}}</option>\n            <option value=\"Home\">{{content('common.home')}}</option>\n            <option ng-if=\"!hideWork\" value=\"Work\">{{content('common.work')}}</option>\n        </select>\n\n        <label for=\"phoneType\" id=\"phoneTypeLabel\">{{content('common.phoneType')}}</label>\n    </div>\n\n\n    <div ng-if=\"showDialingCodeContainer\"\n         id=\"dialingCodeContainer\"\n         class=\"dialingCodeContainer dropdown confidential half last-child inputField intl-tel-input\"\n         ng-cloak\n         floating-label-dropdown>\n\n        <div class=\"flag-dropdown\">\n            <div tabindex=\"0\"\n                 class=\"selected-flag\"\n                 title=\"{{ phoneCountry + ' +'+this.phone.IntDialingCountryCode }}\"\n                 ng-keydown=\"actions.handleKeyboardInputForDropdown($event)\"\n                 ng-click=\"actions.toggleList()\">\n                <div class=\"iti-flag {{ phoneCountry | lowercase }}\" style=\"pointer-events: none\"></div>\n                <div class=\"arrow\" style=\"pointer-events: none\"></div>\n            </div>\n\n            <ul class=\"country-list hide\">\n                <li ng-repeat=\"(key, value) in dialingCodeList track by $index\"\n                    tabindex=\"-1\"\n                    class=\"country\"\n                    data-country-code=\"{{ value.code }}\"\n                    ng-class=\"{'selected': value.code === phoneCountry}\"\n                    ng-click=\"actions.updatePhoneFieldMetadata(value)\"\n                    ng-keydown=\"actions.handleKeyboardInputForList($event)\"\n                    ng-mouseover=\"actions.handleListMouseover($event)\">\n\n                    <div class=\"flag\" style=\"pointer-events: none\">\n                        <div class=\"iti-flag {{ value.code | lowercase }}\"/>\n                    </div>\n\n                    <span class=\"country-name\" style=\"pointer-events: none\">{{ value.name }}</span>\n\n                    <span class=\"dial-code\" style=\"pointer-events: none\">+{{ value.internationalDialingCode }}</span>\n                </li>\n            </ul>\n        </div>\n\n        <label for=\"phoneCountryCode\" id=\"phoneCodeLabel\" class=\"focus accessAid\">{{content('common.phoneCountryCode')}}</label>\n    </div>\n\n\n    <div id=\"phoneNumberContainer\"\n         class=\"inputField confidential last-child phoneNumber\"\n         ng-class=\"{'half': !hidePhoneType,\n            'telephoneField': !hidePhoneType,\n            'telephoneFieldFull': hidePhoneType,\n            'rtlPhoneField': locale.metadata.directionality === 'rtl',\n            'dialCodeVisible': showDialingCodeContainer,\n            'singleLineMobile' : hidePhoneType}\"\n         floating-label\n         directionality >\n\n        <span class=\"fixedCode ltrOverride\" id=\"countryTelephoneCode\">+{{ phone.IntDialingCountryCode }}</span>\n        <input id=\"telephone\"\n               class=\"telephone\"\n               ng-class=\"{'digit1' : phone.IntDialingCountryCode.length === 1, 'digit2' : phone.IntDialingCountryCode.length === 2, 'digit3' : phone.IntDialingCountryCode.length === 3, 'digit4' : phone.IntDialingCountryCode.length === 4 }\"\n               type=\"tel\"\n               ng-model=\"phone.telephone\"\n               name=\"telephone\"\n               value=\"\"\n               data-mask=\"{{mask}}\"\n               ng-change=\"actions.applyMaskOnPhoneInput()\"\n               autocapitalize=\"off\"\n               autocomplete=\"off\"\n               aria-required=\"true\"\n               aria-labelledby=\"telephoneLabel countryTelephoneCode\"\n               country-code=\"phone.phoneCountryCode\"\n               xo-validation='{\"validator\": \"validPhone\"}'\n               data-error-key=\"validation.validPhone\"\n               maxlength=\"{{mask.length}}\"\n               ng-keyup=\"actions.applyMaskOnPhoneInput()\"\n               required\n               track-focus-and-blur=\"phone\"\n               xo-error-tooltip />\n        <label for=\"telephone\" class=\"focus\" id=\"telephoneLabel\">{{content('common.phone')}}</label>\n    </div>\n\n\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/phone/template.html":
/***/ (function(module, exports) {

module.exports = "<section class=\"addPhone\" id=\"addPhone\" content>\n    <div class=\"row-fluid\">\n        <div class=\"span14 trayInner\">\n            <xo-message message=\"errorMessage\"></xo-message>\n            <p class=\"userEmail\" id=\"reviewUserInfo\" ng-if=\"showNotYou\">\n                {{ content('creditcard.hi', {userName: auth.first_name ? auth.first_name : auth.email}) }}\n                <span>\n                    <a track-link=\"login_with_diff_user\" href=\"\" ng-click=\"logout()\">{{ content('memberReview.notYou')}}</a>\n                </span>\n            </p>\n            <xo-title title-txt=\"{{content('addPhone.addPhoneNumber')}}\"></xo-title>\n            <form name=\"addPhoneForm\" class=\"proceed\" content autocomplete=\"off\" ng-submit=\"addPhoneForm.$valid && onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n                <xo-phone-input phone=\"phone\"></xo-phone-input>\n                <p class=\"disclaimer\" id=\"phoneDisclosure\" ng-if=\"showPhoneDisclosure\">\n                    <span data-ng-bind-html=\"htmlContent(consentContentKey)\"></span>\n                </p>\n                <input track-submit type=\"submit\" value=\"{{showPhoneDisclosure ? content('addPhone.agreeContinue') : content('common.continueLabel') }}\" class=\"btn full\" ng-click=\"validated=true\" />\n            </form>\n        </div>\n        <div class=\"span10\">\n            <xo-value-props type=\"login\" title=\"{{content('login.propHead')}}\" text-content=\"login.propVal\"></xo-value-props>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/place-of-birth/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/place-of-birth/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('$xoPlaceOfBirth', {
  tag: 'xo-place-of-birth',
  template: _template["default"],
  props: {
    user: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this = this;
      this.populateCountryList = function () {
        var guestBlockedCountries = _index.$config.guestBlockedCountries || [];
        _this.metadata = _angular["default"].copy(_index.$locale.metadata);
        var placeOfBirth = {};
        _this.countriesList = _this.metadata.territory.filter(function (c) {
          if (c.code === _index.$locale.country) {
            placeOfBirth = c;
          }
          return !(guestBlockedCountries.indexOf(c.code) > -1);
        });
        // set the default select option in the place of birth dropdown
        _this.selectedPlaceOfBirth = placeOfBirth;
        _this.user.placeofbirth = placeOfBirth.code;
      };
      this.populateCountryList();
      this.$on('metadataChange', this.populateCountryList);
    }
  },
  actions: {
    updatePlaceOfBirth: function updatePlaceOfBirth(country_code) {
      this.user.placeofbirth = country_code;
    }
  }
});
_index.$Component;
_index.$locale;
_index.$config;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/place-of-birth/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"dropdown confidential country clearfix inputField\" floating-label-dropdown content>\n    <select xo-dropdown name=\"placeofbirth\" dropdown-text-bind-var=\"selectedPlaceOfBirth.name\"\n            ng-model=\"selectedPlaceOfBirth\"\n            ng-options=\"country.name for country in countriesList track by country.code\"\n            id=\"placeofbirth\"\n            ng-change=\"actions.updatePlaceOfBirth(selectedPlaceOfBirth.code)\"\n            xo-error-tooltip required>\n    </select>\n    <label for=\"placeofbirth\" id=\"placeofbirthlabel\">{{ content('common.placeOfBirth') }}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-country/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/template.html"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoSelectShippingCountry', {
  tag: 'xo-select-shipping-country',
  template: _template["default"],
  props: {
    shippingAddress: {
      type: 'var',
      required: false
    },
    disableChangeShippingCountry: {
      type: 'var',
      required: false
    }
  },
  actions: {
    // Return the country list, with the selected address country at the top
    getList: function getList(address) {
      var defaultCountryCode = address && address.country || _squid.$locale.country;
      var countryList = _squid.$locale.metadata.territory;
      var isDefaultCountry = function isDefaultCountry(country) {
        return country.code === defaultCountryCode;
      };
      var defaultCountry = _squid.$util.find(countryList, isDefaultCountry);
      var res = countryList.filter(function (country) {
        return !isDefaultCountry(country);
      });
      res.unshift(defaultCountry);
      return res;
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.countryList = this.actions.getList(this.props.shippingAddress);
      this.$on('metadataChange', function () {
        _this.countryList = _this.actions.getList(_this.props.shippingAddress);
      });
    }
  }
});
_squid.$Component;
_squid.$locale;
_squid.$util;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/select-shipping-country/template.html":
/***/ (function(module, exports) {

module.exports = "<span id=\"selectShippingCountry\" feature=\"changeShippingCountry\">\n    <div class=\"dropdown confidential country clearfix inputField\"\n         ng-class=\"{'disabled': props.disableChangeShippingCountry}\" content floating-label-dropdown>\n        <select xo-dropdown name=\"country\" ng-model=\"props.shippingAddress.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"country\" xo-error-tooltip required ng-disabled=\"props.disableChangeShippingCountry\">\n        </select>\n        <label for=\"country\" id=\"countryLabel\">{{ content('common.country') }}</label>\n    </div>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
var _utilFunctions = __webpack_require__("../node_modules/xo-form-components/src/travel-rule/utilFunctions.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/travel-rule/template.html"));
__webpack_require__("../node_modules/xo-form-components/src/travel-rule/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// This component probably shouldn't be in xo-form-components, as xo-address-components depends on xo-form-components
// If below is included, the tests will error due to duplicate xo-form-components being loaded.
// import 'xo-address-components/src/add-address/directive';
var _default = exports["default"] = _index.$Component.extend('xoTravelRule', {
  tag: 'xo-travel-rule',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    finish: {
      type: 'var',
      required: false
    },
    onUserInfoSuccess: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutSession: _index2.$CheckoutSessionModel.instance(this.token).retrieve()
      };
    }
  },
  actions: {
    submit: function submit() {
      var _this = this;
      var data = {};
      if (this.needPayerGovtId) {
        var chosenIdDetails = this.idTypes.find((0, _utilFunctions.findChosenId)(this.idData.type));

        // Scrub the formatting when invoking the backend services.
        var unformatted = (this.idData.value || '').replace(/[^0-9a-zA-Z]+/g, '');
        data.newDocId = {
          type: chosenIdDetails.idType,
          subType: chosenIdDetails.idSubtype,
          issuerCountry: this.idData.country,
          issuer: chosenIdDetails.idIssuer,
          value: unformatted,
          collectionPoint: 'UNKNOWN',
          placeOfIssue: this.idData.country
        };
      }
      if (this.needPayerAddress) {
        var address = this.address;
        data.newAddress = {
          address1: address.line1,
          address2: address.line2,
          city: address.city,
          state: address.state,
          zip: address.postal_code,
          iso_country: 'US'
        };
      }
      var onUserInfoSuccess = this.onUserInfoSuccess || function () {
        var checkoutCart = _index2.$CheckoutCartModel.instance(_this.token);
        return _this.models.checkoutSession.action('create', {
          data: {
            baToken: checkoutCart.billing && checkoutCart.billing.ba_token
          },
          success: function success() {
            // Clear the errors if create checkout session was successful
            _this.models.checkoutSession.errorData = undefined;
            _this.finish();
          }
        });
      };
      this.userInfo.action('governmentId-address', {
        data: data,
        success: onUserInfoSuccess,
        validation: function validation(validationData) {
          var $field = _this.$element.find('#data');
          $field.addClass('backendError');
          $field.attr('aria-invalid', true);
          $field.focus();
        }
      });
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this2 = this;
      var country = _index.$locale.getCountryCodeISO();
      this.country = country;
      this.address = {
        country: country
      };
      this.countryList = _index.$locale.metadata.territory;
      this.idTypes = (0, _utilFunctions.getIdTypes)(_index.$locale.content);
      this.idData = (0, _utilFunctions.getIdData)();
      this.idTypeChanged = function () {
        _this2.idData.country = 'US';
      };
      var checkoutSession = _index2.$CheckoutSessionModel.instance(this.token);
      var payerDetailsTypes = checkoutSession.get('errorData.resolution.data', []);
      if (payerDetailsTypes.includes('GOVERNMENT_ID')) {
        this.needPayerGovtId = true;
      }
      if (payerDetailsTypes.includes('STREET_ADDRESS')) {
        this.needPayerAddress = true;
      }
      this.userInfo = _index3.$UserInfoModel.instance(this.token);
    }
  }
});
_index.$Component;
_index.$locale;
_index2.$CheckoutSessionModel;
_index2.$CheckoutCartModel;
_index3.$UserInfoModel;
_utilFunctions.findChosenId;
_utilFunctions.getIdData;
_utilFunctions.getIdTypes;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/template.html":
/***/ (function(module, exports) {

module.exports = "<form id=\"travelRuleForm\" name=\"travelRuleForm\" class=\"travelRuleForm\" content novalidate>\n    <div class=\"trayInner trayInnerDefault\">\n        <h3 class=\"gamma noHead\">{{ content('travelRule.travelRule') }}</h3>\n        <p>{{ content('travelRule.note') }}</p>\n\n        <div ng-if=\"needPayerGovtId\" class=\"govtId\">\n            <div class=\"dropdown idType inputField\" floating-label-dropdown>\n                <select xo-dropdown\n                        name=\"idType\"\n                        ng-model=\"idData.type\"\n                        id=\"idType\"\n                        ng-change=\"idTypeChanged()\"\n                        aria-required=\"true\">\n                    <option ng-repeat=\"item in idTypes track by $index\" value=\"{{item.name}}\" ng-selected=\"idData.type === '{{item.name}}'\">{{item.value}}</option>\n                </select>\n                <label for=\"idType\">{{content('travelRule.idType')}}</label>\n            </div>\n            <div></div>\n            <div class=\"inputField confidential\"\n                ng-switch on=\"idData.type\">\n                <div class=\"animate-switch\" ng-switch-when=\"SSN\">\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.ssnPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"TaxID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.taxIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.taxIdPlaceholder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"EmployerID\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.employerIdDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.employerIdPlaceHolder') }}\"/>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"Passport\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.passportDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.passportPlaceholder') }}\"/>\n                    <div class=\"dropdown confidential country clearfix inputField\" content floating-label-dropdown>\n                        <select xo-dropdown name=\"passportCountry\" ng-model=\"idData.country\" ng-options=\"country.code as country.name for country in countryList\" id=\"passportCountry\" aria-labelledby=\"countryLabel\" xo-error-tooltip required>\n                        </select>\n                    </div>\n                </div>\n                <div class=\"animate-switch\" ng-switch-when=\"AlienNumber\">\n                    <label for=\"data\" class=\"nolap\">{{ content('travelRule.aNumberDesc') }}</label>\n                    <input id=\"data\" name=\"data\" maxlength=\"14\" ng-model=\"idData.value\"\n                       xo-error-tooltip required placeholder=\"{{ content('travelRule.aNumberPlaceholder') }}\"/>\n                </div>\n            </div>\n        </div>\n\n        <div ng-if=\"needPayerAddress\" class=\"address\">\n            <p>{{ content('travelRule.pleaseEnterStreetAddress') }}</p>\n            <xo-add-address country=\"country\" address=\"address\" token=\"token\"></xo-add-address>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit type=\"submit\" id=\"proceedButton\" value=\"{{ content('travelRule.payButton') }}\" class=\"btn full btn-large\" validate-submit=\"actions.submit()\" />\n        </div>\n    </div>\n</form>\n"

/***/ }),

/***/ "../node_modules/xo-form-components/src/travel-rule/utilFunctions.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.getIdTypes = exports.getIdData = exports.findChosenId = void 0;
var findChosenId = exports.findChosenId = function findChosenId(id) {
  return function (_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      name = _ref.name;
    return name === id;
  };
};
var getIdTypes = exports.getIdTypes = function getIdTypes(content) {
  return [{
    name: 'SSN',
    value: content.get('travelRule.ssnDropdownLabel'),
    idType: 'TAX_ID',
    idSubtype: 'SSN',
    idIssuer: 'US_SSN'
  }, {
    name: 'TaxID',
    value: content.get('travelRule.taxIdDropdownLabel'),
    idType: 'TAX_ID',
    idSubtype: 'ITIN',
    idIssuer: 'US_ITIN'
  }, {
    name: 'EmployerID',
    value: content.get('travelRule.employerIdDropdownLabel'),
    idType: 'TAX_ID',
    idSubtype: 'TIN',
    idIssuer: 'US_TIN'
  }, {
    name: 'Passport',
    value: content.get('travelRule.passportDropdownLabel'),
    idType: 'PASSPORT',
    idIssuer: 'PASSPORT'
  }, {
    name: 'AlienNumber',
    value: content.get('travelRule.aNumberDropdownLabel'),
    idType: 'IMMGT_ID',
    idIssuer: 'IMMIGRATION'
  }];
};
var getIdData = exports.getIdData = function getIdData() {
  return {
    type: 'SSN',
    value: '',
    country: 'US'
  };
};

/***/ }),

/***/ "../node_modules/xo-form-components/src/zipcode/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-form-components/src/zipcode/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoZipcode', {
  tag: 'xo-zipcode',
  template: _template["default"],
  props: {
    address: {
      reqiured: false,
      type: 'var'
    },
    attrPrefix: {
      required: false,
      type: 'var'
    },
    country: {
      required: false,
      type: 'str'
    },
    doneFn: {
      required: false,
      type: 'var'
    },
    keyPressFn: {
      required: false,
      type: 'var'
    },
    maxLength: {
      required: false,
      type: 'var'
    },
    postalCodeLabel: {
      required: false,
      type: 'var'
    },
    zipEntry: {
      required: false,
      type: 'var'
    },
    zipErrorKey: {
      required: false,
      type: 'str'
    },
    zipLabel: {
      required: false,
      type: 'str'
    },
    zipRequired: {
      reqiured: false,
      type: 'var'
    }
  },
  lifecycle: {
    enter: function enter() {
      this.formatRegex = undefined;
      this.inputParams = (0, _squid.$feature)('zipcodeInputParams', undefined, this.country);
      if (this.inputParams) {
        this.minLength = this.inputParams.minLength;
        this.maxLength = this.inputParams.maxLength;
        if (this.inputParams.formatPattern) {
          this.formatRegex = new RegExp(this.inputParams.formatPattern, 'g');
        }
      }
      this.formatZipWithDash = function (zipcode, index) {
        if (zipcode.length > index) {
          zipcode = zipcode.slice(0, index) + "-" + zipcode.slice(index);
        }
        return zipcode;
      };
    }
  },
  actions: {
    changeZip: function changeZip(zipcode) {
      if (zipcode) {
        if (this.formatRegex) {
          zipcode = zipcode.replace(this.formatRegex, '');
        }
        if (this.inputParams && this.inputParams.formatZip) {
          zipcode = this.formatZipWithDash(zipcode, this.inputParams.minLength);
        }
        this.address.postal_code = zipcode;
      }
    },
    doneFunction: function doneFunction() {
      if (this.doneFn) {
        this.doneFn();
      }
    },
    keyPressHandler: function keyPressHandler(event) {
      if (this.keyPressFn) {
        this.keyPressFn(event);
      }
    }
  }
});
_squid.$Component;
_squid.$feature;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-form-components/src/zipcode/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"zipField\" data-test-id=\"zipField\" class=\"inputField confidential postalCode\" prefix-attrs-with=\"{{attrPrefix}}\" floating-label directionality content>\n    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"address.postal_code\" data-test-id=\"address.postal_code\"\n        track-focus-and-blur=\"postalCode\"\n        autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" ng-change=\"actions.changeZip(address.postal_code)\" xo-validation='{\"validator\": \"validZip\"}'\n        minlength=\"{{minLength}}\" maxlength=\"{{maxLength}}\" ng-blur=\"actions.doneFunction()\" ng-keypress=\"actions.keyPressHandler($event)\"\n        data-error-key=\"{{zipErrorKey}}\" xo-error-tooltip ng-required=\"{{zipRequired}}\" prefix-attrs-with=\"{{attrPrefix}}\"/>\n    <label for=\"postalCode\" id=\"postalCodeLabel\" data-test-id=\"postalCodeLabel\" prefix-attrs-with=\"{{attrPrefix}}\">{{ zipLabel }}</label>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/continue-3ds-redirect/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/continue-3ds-redirect/template.html"));
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _shippingChangeFeature = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/shippingChangeFeature.js");
var _guestFactory = __webpack_require__("../node_modules/xo-guest-components/src/lib/guestFactory.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _shippingOptionsFeature = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/shippingOptionsFeature.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoContinue3DSRedirectComponent', {
  tag: 'xo-continue-threeds-redirect',
  template: _template["default"],
  props: {
    mode: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve({
          id: _angular.$rootScope.token
        }),
        checkoutSession: _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve({
          id: _angular.$rootScope.token
        }),
        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve({
          id: _angular.$rootScope.token
        }),
        checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve({
          id: _angular.$rootScope.token
        }),
        checkoutInputData: _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).retrieve({
          id: _angular.$rootScope.token
        })
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      this.token = _angular.$rootScope.token;
      this.locale = _squid.$locale;
      this.mode = _angular.$rootScope.mode;
      this.launchCurrencyConversionLightbox = false;
      this.launchTravelRuleLightbox = false;
      this.flags = {
        shipToBilling: true,
        allowEditShipping: true,
        showSingleAddress: false,
        showShippingLabel: true,
        cupDetected: false,
        hideShippingAddress: false,
        allowPayWithSnT: false,
        allowSnTCall: true,
        instantUpdateShippingRegionSupported: true,
        showRedirectWarningPrompt: false,
        titleSubtitlePxpTreatment: false,
        showCartChanged: false,
        whiteListedIndiaMerchant: false,
        mode: _angular.$rootScope.mode,
        returnFromANW: false
      };
      this.onboard = new _index3.$OnboardModel({
        user: _index3.$OnboardUserModel.instance(this.token, {
          country: _squid.$locale.country,
          countryOfResidence: _squid.$locale.country,
          nationality: _squid.$locale.country
        }),
        card: new _index2.$CardModel(),
        bank: new _index2.$BankModel(),
        fiMode: 'card',
        billing_address: _index2.$BillingAddressModel.create(this.token, {
          country: _squid.$locale.country
        }),
        shipping_address: _index4.$ShippingAddressModel.create(this.token, {
          country: _squid.$locale.country
        }),
        phone: new _index3.$OnboardPhoneModel(),
        shipping_address_validation: false,
        billing_address_present: false,
        poma_flow: false,
        residential_address_present: false
      });
      this.singleStepModel = {};
      this.singleStepModel.onboard = this.onboard;
      this.singleStepModel.flags = this.flags;
      this.guestFactory = (0, _guestFactory.$GuestFactory)({
        scope: this
      });
    },
    populate: function populate() {
      var _this = this;
      this.flags.wpsFlow = this.models.checkoutAppData.is_wps_flow();
      this.flags.wpsInterstitialEligible = true;
      this.flags.buyerMode = this.mode;
      this.flags.allowEditShipping = this.models.checkoutAppData.get('flags.allow_change_shipping', false);
      this.shippingOptionsFeature = (0, _shippingOptionsFeature.buildShippingOptionsFeature)(this.token);
      if (this.shippingOptionsFeature.hasShippingOptions()) {
        this.flags.showCartChanged();
      }
      this.shippingChangeFeature = (0, _shippingChangeFeature.createShippingChangeFeature)({
        orderID: this.token,
        checkoutAppData: this.models.checkoutAppData,
        checkoutCart: this.models.checkoutCart,
        flags: this.flags,
        callback: function callback() {
          return _this.shippingOptionsFeature.checkForShippingOptions();
        }
      });
      _logger.$logger.info('checkout_fpti', {
        from: 'xoon_process_3ds_redirect_continued',
        to: 'prepare_xoon_process_3ds_redirect_continued'
      });
      _logger.$logger.info('XOON_PROCESS3DSREDIRECT_CONTINUED');

      /**
       * Once after complete3DS success in full page redirection with bank page
       * need to continue the process by calling `onComplete3DSHandler` to proceed
       * clear3DSContigency and authorize
       */
      return this.guestFactory.onComplete3DSHandler('success');
    }
  }
});
_angular.$rootScope;
_squid.$Component;
_squid.$locale;
_logger.$logger;
_checkout.$CheckoutSessionModel;
_checkout.$CheckoutAppDataModel;
_checkout.$CheckoutCartModel;
_checkout.$CheckoutPayeeModel;
_index.$CheckoutInputDataModel;
_shippingChangeFeature.createShippingChangeFeature;
_guestFactory.$GuestFactory;
_index2.$BankModel;
_index2.$BillingAddressModel;
_index2.$CardModel;
_index3.$OnboardModel;
_index3.$OnboardPhoneModel;
_index3.$OnboardUserModel;
_index4.$ShippingAddressModel;
_shippingOptionsFeature.buildShippingOptionsFeature;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/continue-3ds-redirect/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Continue3DSRedirectRoute = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-guest-components/src/continue-3ds-redirect/directive.js");
var $Continue3DSRedirectRoute = exports.$Continue3DSRedirectRoute = _squid.$ComponentRoute.extend('$Continue3DSRedirectRoute', {
  path: 'continue3DSRedirect',
  directive: 'xo-continue-threeds-redirect',
  trackingData: {},
  children: []
});
angular.value("$Continue3DSRedirectRoute", $Continue3DSRedirectRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/continue-3ds-redirect/template.html":
/***/ (function(module, exports) {

module.exports = "<div mode=\"mode\"></div>"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/fraudnet/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.FRAUD_NET_FIELD_LIST = void 0;
var FRAUD_NET_FIELD_LIST = exports.FRAUD_NET_FIELD_LIST = [
// FI fields
{
  id: 'cvv',
  min: 3
}, {
  id: 'expiry_value',
  min: 7
}, {
  id: 'cc',
  min: 8
},
// Contact information
{
  id: 'email',
  min: 13
}, {
  id: 'firstName',
  min: 5
}, {
  id: 'lastName',
  min: 5
}, {
  id: 'telephone',
  min: 10
},
// Billing Address fields
{
  id: 'billingCity',
  min: 5
}, {
  id: 'billingLine1',
  min: 5
}, {
  id: 'billingLine2',
  min: 2
}, {
  id: 'billingPostalCode',
  min: 5
},
// Shipping Address fields
{
  id: 'shippingFirstName',
  min: 5
}, {
  id: 'shippingLastName',
  min: 5
}, {
  id: 'shippingCity',
  min: 5
}, {
  id: 'shippingLine1',
  min: 5
}, {
  id: 'shippingLine2',
  min: 2
}, {
  id: 'shippingPostalCode',
  min: 5
},
// Signup field
{
  id: 'password',
  min: 8
}];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/fraudnet/fn.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
__webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/fraudnet/constants.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().factory('$fn', ['$populate', '$rootScope', '$window', '$logger', '$config', '$util', '$meta', '$q', function ($populate, $rootScope, $window, $logger, $config, $util, $meta, $q) {
  var fncls = 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99';
  var options = {
    fnSessionId: getFnCorrId(),
    sourceId: 'XOONBOARDINGNODEWEB',
    allowsCustomEvent: typeof CustomEvent !== 'undefined' && _angular["default"].isFunction(CustomEvent),
    fnUrl: $config.urls.fraudnetUrl,
    typingSpeed: {
      delegate: true,
      fields: _constants.FRAUD_NET_FIELD_LIST,
      type: 'XOONBOARDINGNODEWEB'
    },
    passive: true
  };

  // Fraudnet initialization logging
  $logger.info('FN_Initialised', {
    allowsCustomEvent: options.allowsCustomEvent,
    fnSessionId: options.fnSessionId
  });

  // Get the unique id to pass to fraudnet - EC/WPS/BA token
  function getFnCorrId() {
    var fnCorrId = $rootScope.token || $meta.token;
    if ($window.xprops && $window.xprops.clientMetadataID) {
      $logger.info('fraudNetId_found_in_rootscope_xprops', {
        fraudNetId: $window.xprops.clientMetadataID
      });
      fnCorrId = $window.xprops.clientMetadataID;
    } else if ($util.param('client-metadata-id')) {
      $logger.info('fraudNetId_found_in_rootscope_param', {
        fraudNetId: $util.param('client-metadata-id')
      });
      fnCorrId = $util.param('client-metadata-id');
    }

    // Make sure returned value is always EC/WPS token and not BA or PAYID
    // REASON: In the backend while making FI or OAS call we use req.token
    // as CMID (client-metadata-id header) which should exactly match the
    // fnCorrId we return here. If there is no matching then there is no
    // data for risk to do any analysis
    return fnCorrId;
  }

  // Call injectConfig before calling injectScript function
  function _injectScript(fnUrl) {
    var script = document.createElement('script');
    script.id = 'js-sync';
    script.src = fnUrl;
    document.body.appendChild(script);
  }
  function _injectConfig(configOptions) {
    var script = document.getElementById('fconfig');
    var fnetConfiguration = {
      f: configOptions.fnSessionId,
      s: configOptions.sourceId,
      cb: 'fnCallback'
    };
    if (script) {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    }
    script = document.createElement('script');
    script.id = 'fconfig';
    script.type = 'application/json';
    script.setAttribute('data-testid', "cmid-" + configOptions.fnSessionId);
    script.setAttribute('fncls', fncls);
    if (configOptions.typingSpeed) {
      fnetConfiguration.ts = configOptions.typingSpeed;
    }
    script.text = JSON.stringify(fnetConfiguration);
    document.body.appendChild(script);
  }

  /*
   * trigger - this function will call injectConfig and injectScript
   * functions which actually load fraudnet required scripts
   */
  function trigger(scope) {
    var fnLoaded = !!$rootScope.fnLoaded;
    if (fnLoaded || !(0, _squid.$feature)('enableFraudnet')) {
      return false;
    }
    if (options.fnUrl) {
      $window.fnCallback = function () {
        if (scope) {
          scope.$emit('fnCallback');
        }
      };
      _injectConfig(options);
      _injectScript(options.fnUrl);
      $rootScope.fnLoaded = true;
      return true;
    }
    return false;
  }
  return {
    trigger: trigger
  };
}]);
_squid.$feature;
_constants.FRAUD_NET_FIELD_LIST;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/fraudnet", "../node_modules/xo-guest-components/src/fraudnet/fn.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-authnode/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _mayfly = __webpack_require__("../node_modules/xo-models/src/mayfly/index.js");
var _shippingChangeFeature = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/shippingChangeFeature.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest-authnode/template.html"));
var _guestFactory = __webpack_require__("../node_modules/xo-guest-components/src/lib/guestFactory.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");
var _index5 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _shippingOptionsFeature = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/shippingOptionsFeature.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoGuestAuthNodeComponent', {
  tag: 'xo-guest-authnode',
  template: _template["default"],
  resolve: {
    models: function models() {
      return {
        auth: _index2.$AuthModel.instance(_angular.$rootScope.token).retrieve(),
        payee: _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve(),
        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(),
        checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve(),
        checkoutInputData: _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).retrieve()
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      this.token = _angular.$rootScope.token;
      this.locale = _squid.$locale;
      this.mode = 'guest';
      this.launchCurrencyConversionLightbox = false;
      this.launchTravelRuleLightbox = false;
      this.flags = {
        shipToBilling: true,
        allowEditShipping: true,
        showSingleAddress: false,
        showShippingLabel: true,
        cupDetected: false,
        hideShippingAddress: false,
        allowPayWithSnT: false,
        allowSnTCall: true,
        instantUpdateShippingRegionSupported: true,
        showRedirectWarningPrompt: false,
        titleSubtitlePxpTreatment: false,
        showCartChanged: false,
        whiteListedIndiaMerchant: false,
        mode: 'guest',
        returnFromANW: true
      };
      this.onboard = new _index4.$OnboardModel({
        user: _index4.$OnboardUserModel.instance(this.token, {
          country: _squid.$locale.country,
          countryOfResidence: _squid.$locale.country,
          nationality: _squid.$locale.country
        }),
        card: new _index3.$CardModel(),
        bank: new _index3.$BankModel(),
        fiMode: 'card',
        billing_address: _index3.$BillingAddressModel.create(this.token, {
          country: _squid.$locale.country
        }),
        shipping_address: _index5.$ShippingAddressModel.create(this.token, {
          country: _squid.$locale.country
        }),
        phone: new _index4.$OnboardPhoneModel(),
        shipping_address_validation: false,
        billing_address_present: false,
        residential_address_present: false,
        poma_flow: false
      });
      this.guestFactory = (0, _guestFactory.$GuestFactory)({
        scope: this
      });
    },
    populate: function populate() {
      var _this = this;
      var self = this;
      this.flags.wpsFlow = this.models.checkoutAppData.is_wps_flow();
      this.flags.allowEditShipping = this.models.checkoutAppData.get('flags.allow_change_shipping', false);
      this.shippingOptionsFeature = (0, _shippingOptionsFeature.buildShippingOptionsFeature)(this.token);
      if (this.shippingOptionsFeature.hasShippingOptions()) {
        this.flags.showCartChanged();
      }
      this.shippingChangeFeature = (0, _shippingChangeFeature.createShippingChangeFeature)({
        orderID: this.token,
        checkoutAppData: this.models.checkoutAppData,
        checkoutCart: this.models.checkoutCart,
        flags: this.flags,
        callback: function callback() {
          return _this.shippingOptionsFeature.checkForShippingOptions();
        }
      });
      var mayfly = _mayfly.$MayflyModel.instance(_angular.$rootScope.token);

      // After Returning from ANW:
      // 1. Retrieve data from mayfly
      // 2. Login to STS and fetch upgraded access_token and auth_state
      // 3. Post Re-Planning call to PAPS for further transaction processing.
      mayfly.action('retrieve', {
        success: function success(response) {
          _logger.$logger.info('mayfly_retrieve', {
            status: response.success
          });
          if (response.success) {
            var authModel = _index2.$AuthModel.instance(_angular.$rootScope.token);
            self.onboard.cc_login_account_number = response.cc_login_account_number;
            self.onboard.email_login_account_number = response.email_login_account_number;
            self.onboard.fiMode = response.fimode;
            self.onboard.user.email = response.user_email;
            self.onboard.card.type = response.cardType;
            self.onboard.card.currencyConvData = response.cardCurrencyConvData;
            self.onboard.card.ppconversion = response.ppconversion;
            self.onboard.billing_address.country = response.billingCountry;
            return _angular.$q.when().then(function () {
              var loginData = {
                user: {
                  account_number: self.models.auth.buyer_id,
                  email: response.user_email,
                  access_token: self.models.auth.access_token
                },
                auth_service_type: 'sts',
                authflow_nonce: true,
                client: {
                  skip_oauth: false,
                  skip_consent: true
                }
              };
              _logger.$logger.info('guest_authflow_sts_nonce_login');
              return authModel.action('login', {
                data: loginData,
                success: function success() {
                  _logger.$logger.info('guest_authflow_sts_nonce_login_success');
                  return _this.guestFactory.createXO();
                },
                error: function error(err) {
                  _logger.$logger.info('guest_authflow_sts_nonce_login_failed', err);
                  return _uiRouter.$state.go(_guestFactory.ROUTE.GENERIC_ERROR, {
                    code: _guestFactory.ERROR_CODE.PAYMENT_PROCESS_ERROR
                  });
                }
              })["catch"](function (err) {
                _logger.$logger.info('guest_authflow_sts_nonce_login_failed', err);
                return _uiRouter.$state.go(_guestFactory.ROUTE.GENERIC_ERROR, {
                  code: _guestFactory.ERROR_CODE.PAYMENT_PROCESS_ERROR
                });
              });
            });
          } else {
            _logger.$logger.info('guest_authflow_mayfly_retrieval_failed');
            return _uiRouter.$state.go(_guestFactory.ROUTE.GENERIC_ERROR, {
              code: _guestFactory.ERROR_CODE.PAYMENT_PROCESS_ERROR
            });
          }
        },
        contingencies: {
          DEFAULT: self.guestFactory.showGenericError(_guestFactory.ERROR_CODE.TRANSACTION_REFUSED)
        },
        error: function error(err) {
          _logger.$logger.info('guest_authflow_mayfly_retrieval_failed', err);
          return _uiRouter.$state.go(_guestFactory.ROUTE.GENERIC_ERROR, {
            code: _guestFactory.ERROR_CODE.PAYMENT_PROCESS_ERROR
          });
        }
      });
    }
  }
});
_angular.$q;
_angular.$rootScope;
_uiRouter.$state;
_squid.$Component;
_squid.$locale;
_logger.$logger;
_checkout.$CheckoutAppDataModel;
_checkout.$CheckoutCartModel;
_checkout.$CheckoutPayeeModel;
_index.$CheckoutInputDataModel;
_index2.$AuthModel;
_mayfly.$MayflyModel;
_shippingChangeFeature.createShippingChangeFeature;
_guestFactory.$GuestFactory;
_guestFactory.ERROR_CODE;
_guestFactory.ROUTE;
_index3.$BankModel;
_index3.$BillingAddressModel;
_index3.$CardModel;
_index4.$OnboardModel;
_index4.$OnboardPhoneModel;
_index4.$OnboardUserModel;
_index5.$ShippingAddressModel;
_shippingOptionsFeature.buildShippingOptionsFeature;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-authnode/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GuestAuthNodeRoute = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest-authnode/directive.js");
var $GuestAuthNodeRoute = exports.$GuestAuthNodeRoute = _squid.$ComponentRoute.extend('$GuestAuthNodeRoute', {
  path: 'guestauthnode',
  directive: 'xo-guest-authnode',
  trackingData: {},
  children: []
});
angular.value("$GuestAuthNodeRoute", $GuestAuthNodeRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-authnode/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-3ds on-complete-3ds-handler=\"guestFactory.onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" closable=\"false\" ng-if=\"launch3DSResolver\"></xo-3ds>\n<xo-currency-conversion-lightbox token=\"token\" done-fn=\"guestFactory.onCompleteDCC\" pre-plan-treatment=\"flags.buyerFxTreatment\" ng-if=\"launchCurrencyConversionLightbox\"></xo-currency-conversion-lightbox>\n<xo-travel-rule-lightbox token=\"token\" ng-if=\"launchTravelRuleLightbox\" done-fn=\"guestFactory.onTravelRuleSuccess\"></xo-travel-rule-lightbox>\n<xo-cart-changed\n    ng-if=\"flags.showCartChanged\"\n    token=\"token\"\n    disable-change-shipping-country=\"disableChangeShippingCountry\"\n    shipping-address=\"onboard.shipping_address\"\n    formatted-shipping-address=\"formattedShippingAddress\"\n    ixo-model=\"ixoModel\"\n    show-form=\"shippingChangeFeature.showForm\"\n    message=\"shippingChangeFeature.message\"\n    on-shipping-change=\"shippingChangeFeature.handleOnShippingChange\"\n    on-continue=\"shippingChangeFeature.showOrResolveInterstitial\"\n></xo-cart-changed>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-existing-member-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest-existing-member-interstitial/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoGuestExistingMemberInterstitial', {
  tag: 'xo-guest-existing-member-interstitial',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    parentModel: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.locale = _squid.$locale;
      this.flags = this.props.parentModel.flags;
      var treatmentStr = this.props.parentModel.ulMeta.trmt;
      this.treatmentVersion = treatmentStr.substr(-2) || 'V1';
      if (!this.flags) {
        // Flags from the parent Model (Guest/directive.js) is required here to display this
        // interstitial page. Though it would be very rare and this check is added just to be extra safety...
        // if the flag is missing (null / undefined) for any reason then we will show generic error page with code
        // PAYMENT_ALREADY_DONE, as payment is already completed.
        _logger.$logger.info('WPS_existing_member_interstitial_render_error');
        return _uiRouter.$state.go('checkout.genericError', {
          code: 'PAYMENT_ALREADY_DONE'
        });
      }
      this.flags.launchUlIframe = false;

      // Wait for the component to be populated and the template to be rendered
      // and then set `interstitialOpen` to `true`, which will add the class 'upsellOpen'
      // to the interstitial and trigger the transition to slide it onto the screen
      this.$on('populated', function () {
        _this.interstitialOpen = true;
      });
    },
    populate: function populate() {
      var _this2 = this;
      this.getcontentKey = function () {
        return "common.skipLogin" + _this2.treatmentVersion;
      };
      _logger.$logger.info('checkout_fpti', {
        from: 'guest_existing_member_interstitial_flow',
        to: 'prepare_guest_existing_member_interstitial'
      });
    }
  },
  actions: {
    onSubmit: function onSubmit() {
      _logger.$logger.info('checkout_fpti', {
        from: 'guest_existing_member_interstitial_flow',
        to: 'process_guest_existing_member_interstitial'
      });
      var interstitial = angular.element(document.getElementById('guestExistingMemberInterstitial'));
      this.interstitialOpen = false;
      interstitial.remove();
      this.flags.launchUlIframe = true;
    }
  }
});
_squid.$Component;
_squid.$locale;
_logger.$logger;
_uiRouter.$state;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-existing-member-interstitial/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-existing-member-interstitial/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-guest-existing-member-interstitial.route', ['squid', 'xo-guest-existing-member-interstitial.directive']).factory('$GuestExistingMemberInterstitialRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GuestExistingMemberInterstitialRoute', {
      name: 'guestExistingMemberInterstitial',
      directive: 'xo-guest-existing-member-interstitial',
      trackingData: {
        fptiState: 'guest_xo_existing_member_interstitial',
        trackStateExit: false,
        pageQualifier: 'guest',
        buzname: {
          'guest': {
            'pagename': '%::fullpage-guest-existing-member-interstitial',
            'pagename2': '%::fullpage-guest:member:hermes:',
            'version': 'guest:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: []
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/guest-existing-member-interstitial", "../node_modules/xo-guest-components/src/guest-existing-member-interstitial/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-existing-member-interstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"guestExistingMemberInterstitial\" id=\"guestExistingMemberInterstitial\" ng-class=\"{mobile: isDevice, upsellOpen: interstitialOpen}\" content>\n    <div class=\"upsellMask\"></div>\n    <div class=\"upsellWrapper\" >\n        <div class=\"profile\"></div>\n        <div class=\"upsellScrollWrapper\">\n            <div class=\"upsellContainer\">\n                <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n                <div>\n                    <div class=\"mainTitle\"><div>{{content('guestUpgrade.existingMemberInterstitialTitle')}}</div></div>\n                    <div class=\"cart_image\"></div>\n                    <div class=\"intro-content\">{{content('guestUpgrade.existingMemberInterstitialSubTitle')}}</div>\n                </div>\n                <form id=\"upgradeInterstitialForm\" name=\"upgradeInterstitialForm\" ng-submit=\"actions.onSubmit()\">\n                    <input track-submit=\"xoon_wps_interstitial_submit\" id=\"wpsInterstitialSubmit\" type=\"submit\" ng-click=\"validated=true\"\n                           value=\"{{ content(getcontentKey()) }}\" class=\"btn full\" />\n\n                    <div class=\"intro-content\">\n                        <a aria-hidden=\"false\" class=\"notNow\" id=\"notNow\"\n                           track-link=\"guest_existing_member_interstitial_not_now\"\n                           ui-sref=\"checkout.done\" role=\"button\">{{content('common.notNowGoToReceipt')}}</a>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");
var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/template.html"));
__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/signup/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoGuestUpgradeInterstitial', {
  tag: 'xo-guest-upgrade-interstitial',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    parentModel: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.locale = _squid.$locale;
      this.flags = this.props.parentModel.flags;
      this.userAgreementLink = this.props.parentModel.userAgreementLink;
      if (!this.flags) {
        _logger.$logger.info('WPS_interstitial_render_error');
        return _uiRouter.$state.go('checkout.genericError', {
          code: 'PAYMENT_ALREADY_DONE'
        });
      }
      this.flags.wpsInterstitial = true;
      this.flags.showMobileEmailSection = true;
      this.onboard = this.props.parentModel.onboard;

      // If US, then show new e-sign compliance experience
      // Submit button text changes and return to merchant msg above button
      // with user action 'continue'
      if (this.locale.country === 'US') {
        this.showNewSignupComplianceExp = true;
      }

      // Wait for the component to be populated and the template to be rendered
      // and then set `interstitialOpen` to `true`, which will add the class 'upsellOpen'
      // to the interstitial and trigger the transition to slide it onto the screen
      this.$on('populated', function () {
        _this.interstitialOpen = true;
      });
    }
  },
  actions: {
    onSubmit: function onSubmit() {
      this.upgrade = new _index.$GuestUpgradeModel();
      this.upgrade.billing_address = this.onboard.billing_address;
      this.upgrade.user = this.onboard.user;
      this.upgrade.payerId = this.onboard.payerId;
      this.upgrade.transaction = this.onboard.transaction;
      this.upgrade.phone = this.onboard.phone;
      this.upgrade.marketing_optin = this.onboard.marketingOptin;
      this.upgrade.nationalIdModel = _directive.$NationalIdModel.instance(this.props.token);
      this.upgrade.experienceChannel = 'HERMES';
      // Set Legal Agreements that will be sent to OAS
      this.upgrade.legal_agreements = this.onboard.legal_agreements;

      // Close the interstitial after submit so it is not shown underneath the spinner mask.
      this.interstitialOpen = false;
      return this.upgrade.save({
        data: this.upgrade.serialize(),
        success: function success() {
          _angular.$rootScope.mode = 'signup';
          _logger.$logger.info('WPS_guest_upgrade_success');
          return _uiRouter.$state.go('checkout.done');
        },
        error: function error() {
          _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_ERROR');
          return _uiRouter.$state.go('checkout.done', {
            code: 'NO_UPGRADE'
          });
        },
        contingencies: {
          DOB_INVALID: function DOB_INVALID() {
            _logger.$logger.info('WPS_guest_upgrade_failed_DOB_INVALID');
            return _uiRouter.$state.go('checkout.done', {
              code: 'NO_UPGRADE'
            });
          },
          NATID_INVALID: function NATID_INVALID() {
            _logger.$logger.info('WPS_guest_upgrade_failed_NATID_INVALID');
            return _uiRouter.$state.go('checkout.done', {
              code: 'NO_UPGRADE'
            });
          },
          DEFAULT: function DEFAULT() {
            _logger.$logger.info('WPS_guest_upgrade_failed_Unknown_contingency');
            return _uiRouter.$state.go('checkout.done', {
              code: 'NO_UPGRADE'
            });
          }
        },
        validation: function validation() {
          _logger.$logger.info('WPS_guest_upgrade_failed_SERVICE_VALIDATION_ERROR');
          return _uiRouter.$state.go('checkout.done', {
            code: 'NO_UPGRADE'
          });
        }
      });
    }
  }
});
_angular.$rootScope;
_squid.$Component;
_squid.$locale;
_index.$GuestUpgradeModel;
_directive.$NationalIdModel;
_logger.$logger;
_uiRouter.$state;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-guest-upgrade-interstitial.route', ['squid', 'xo-guest-upgrade-interstitial.directive']).factory('$GuestUpgradeInterstitialRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GuestUpgradeInterstitialRoute', {
      name: 'guestUpgradeInterstitial',
      directive: 'xo-guest-upgrade-interstitial',
      trackingData: {
        fptiState: 'guest_xo_upgrade_interstitial',
        trackStateExit: false,
        pageQualifier: 'guest',
        buzname: {
          'guest': {
            'pagename': '%::fullpage-guest-upgrade-interstitial',
            'pagename2': '%::fullpage-guest:member:hermes:',
            'version': 'guest:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: []
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/guest-upgrade-interstitial", "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade-interstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"guestUpgradeInterstitial\" ng-class=\"{mobile: isDevice, upsellOpen: interstitialOpen}\" content>\n    <div class=\"upsellMask\"></div>\n    <div class=\"upsellWrapper\" >\n        <div class=\"profile\">&nbsp;</div>\n        <div class=\"upsellScrollWrapper\">\n            <div class=\"upsellContainer\">\n                <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n\n                <div>\n                    <div class=\"mainTitle\">\n                        <div>{{content('signup.paymentSuccessTitle')}}</div>\n                        <div>{{content('signup.createAccountToday')}}</div>\n                    </div>\n\n                    <div class=\"intro-content\">{{ content('signup.createAccountDetails') }}</div>\n                </div>\n\n                <div class=\"emailHelper\" >\n                    <span class=\"email\">{{onboard.user.email}}</span>\n                    <span>\n                        <a id=\"emailHelp\"\n                           class=\"verifyHelp\"\n                           aria-label=\"{{ content('login.kmliTooltipTitle') }}\"\n                           href=\"javascript:void(0)\">\n                        </a>\n                    </span>\n\n                    <xo-tooltip trigger=\"#emailHelp\" >\n                        <div id=\"emailToolTipText\" class=\"tip tipDesc emailToolTip\">\n                            {{ content('signup.emailHelper') }}\n                        </div>\n                    </xo-tooltip>\n                </div>\n\n                <form id=\"upgradeInterstitialForm\" name=\"upgradeInterstitialForm\" class=\"upgradeInterstitialForm\"\n                      ng-submit=\"upgradeInterstitialForm.$valid && actions.onSubmit()\" ng-class=\"{true: 'validated'}[validated]\"  novalidate>\n\n                    <xo-signup-options flags=\"flags\" onboard=\"onboard\" guest-upgrade=\"true\" user-agreement-link=\"userAgreementLink\" use-user-agreement-custom-link=\"flags.isGatherActiveConsentEnabled\"></xo-signup-options>\n\n                    <input track-submit=\"xoon_wps_interstitial_submit\" id=\"wpsInterstitialSubmit\" type=\"submit\" ng-click=\"validated=true\"\n                           value=\"{{ content(showNewSignupComplianceExp ? 'common.agreeAndCreateAccount' : 'common.agreeAndContinue') }}\" class=\"btn full\" />\n\n                    <div class=\"intro-content\">\n                        <a aria-hidden=\"false\" class=\"notNow\" id=\"notNow\"\n                           track-link=\"guest_upgrade_interstitial_not_now\"\n                           ui-sref=\"checkout.done\" role=\"button\">\n                            {{content('common.notNow')}}\n                        </a>\n\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");
var _index2 = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _util = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/template.html"));
var _index3 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");
var _mapper = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/lib/mapper.js"));
__webpack_require__("../node_modules/xo-form-components/src/place-of-birth/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/gender-type/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/phone/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/occupation/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/nationality/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/phone-confirmation-interstitial/directive.js");
var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");
__webpack_require__("../node_modules/xo-page-components/src/footer/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/spinner/directive.js");
__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js");
__webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/passwordInput/directive.js");
__webpack_require__("../node_modules/xo-address-components/src/address-normalization/directive.js");
var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");
var _helper = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/lib/helper.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index2.$Component.extend('xoGuestUpgrade', {
  tag: 'xo-guest-upgrade',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      var options = {
        params: {
          data: _index2.$util.param('data')
        }
      };
      return {
        preloadedData: _index4.$GuestUpgradeModel.instance().retrieve(options)["catch"](function (err) {
          _logger.$logger.info('guest_upgrade_load_unknown_contingency', {
            'int_error_description': err
          });
        })
      };
    },
    phoneConfirmationExp: function phoneConfirmationExp() {
      var _this = this;
      return (0, _index2.$elmo)('xo_xoon_phone_confirmation', {
        'ctx.COUNTRY': _index2.$locale.country
      }, '(Trmt_xo_xoon_phone_confirmation)(.*)').then(function (result) {
        if (result) {
          _logger.$logger.info('phoneConfirmationExp_Treatment');
          _this.flags.isphoneConfirmationExpTreatment = true;
        }
      });
    }
  },
  lifecycle: {
    enter: function enter() {
      this.upgradeFromEmail = _index2.$util.param('data').length === 15 || _index2.$util.param('data').length === 16;
      this.flags = {
        singlePassword: false,
        launchUlIframe: false,
        phoneConfirmed: false,
        showPhoneConfirmationPopup: false,
        isphoneConfirmationExpTreatment: false
      };
      this.locale = _index2.$locale;
      this.returnToMerchantTimerMsg = '';
      this.valueTitle = (0, _index2.$renderContent)('guestVerify.propHead');
      this.valueText = (0, _index2.$renderContent)('guestVerify.propVal');
      this.footerStyle = 'fullFooter';
      this.isGdprValid = _gdprCookieBanner.isGdprValid;

      // Do not show cancel URL if experience is set to minibrowser
      if (!_angular.$rootScope.miniBrowser) {
        this.cancelUrl = _index2.$util.param('cancel_url');
      } else {
        // Change the message of the overlay on the site that launched this flow.
        _index.$ReturnToMerchant.postToMerchant({
          secureWindowmsg: _index2.$locale.content.get('signup.overlayMsg')
        });
      }
      var modelSchema = {
        user: new _index4.$OnboardUserModel({
          country: _index2.$locale.country,
          nationality: _index2.$locale.country
        }),
        phone: new _index4.$OnboardPhoneModel(),
        billing_address: _index3.$BillingAddressModel.create(null, {
          country: _index2.$locale.country
        })
      };
      this.onboard = new _index4.$GuestUpgradeModel(modelSchema);
      this.fpti = {
        trackSuccess: function trackSuccess() {
          this.track(':success');
        },
        trackError: function trackError(err) {
          this.track(':error', err);
        },
        track: function track(suffix, err) {
          var error;
          if (err) {
            error = {
              type: 'pageError',
              msg: err.message
            };
          }
          _uiRouter.$state.current.trackingData.buzname.guestupgrade.pagename2 += suffix;
          _fpti.$fpti.setupDataString(_uiRouter.$state.current, error);
        }
      };
      this.currentYear = new Date().getFullYear().toString();
      this.validMonths = _index2.$util.map(_index2.$util.range(1, 13), function (num) {
        return ('0' + num).substr(-2);
      });
    },
    populate: function populate() {
      var _this2 = this;
      var preloadedData = this.models.preloadedData;

      // Don't proceed if there is no preloaded data fetched from get upgrade call
      if (!preloadedData || !preloadedData.billing_address) {
        _logger.$logger.info('GUEST_UPGRADE_LOAD_ERROR');
        return _uiRouter.$state.go('guestupgrade.genericError', {
          code: 'GUEST_UPGRADE_ERROR'
        });
      }

      // Block signup / guest upgrade for countries
      // Thailand: user onboarding is blocked due to compliance
      // Australia: blocked onboarding due to CRS compliance feature is not implemented in legacy application(xoonboarding)
      if ((0, _index2.$feature)('blockSignup', false, preloadedData.get('billing_address.country'))) {
        _logger.$logger.info(preloadedData.billing_address.country + "_COUNTRY_GUEST_UPGRADE_BLOCKED_FOR_EBAY");
        return _uiRouter.$state.go('guestupgrade.genericError', {
          code: 'GUEST_UPGRADE_ERROR'
        });
      }
      var isGDPRCountry = _helper.signupLib.getIsGDPRCountry(this.locale.country);

      // Market Opt-in display and checked by default is based on config settings
      this.showMarketingOptin = _helper.signupLib.getMarketingOptinShowHide(this.locale.country, isGDPRCountry);

      // If not showing a checkbox for marketing opt-in, set the flag to null as per GDPR team requirement
      if (!this.showMarketingOptin) {
        this.onboard.marketing_optin = null;
      } else {
        // DO THIS ONLY IF the marketing opt-in checkbox is displayed to users
        // Is marketing opt-in checkbox checked by default
        this.onboard.marketing_optin = _helper.signupLib.getMarketingOptinIsChecked(this.locale.country, isGDPRCountry);
        // Marketing opt-in text next to checkbox
        this.marketingOptinContentKey = _helper.signupLib.getMarketingOptinContentKey(this.locale.country, isGDPRCountry);
        this.MarketingCheckboxFirst = _helper.signupLib.getIsMarketingCheckboxFirst(this.locale.country, isGDPRCountry);
      }
      var getContentIdentifier = function getContentIdentifier() {
        return [_index2.$locale.country, _index2.$locale.lang, (0, _index2.$contentVersion)(), 'signupTerms.easySignupTCPA'].join(':');
      };
      var getFiMode = function getFiMode() {
        var _ref = preloadedData && preloadedData.fi_details || {},
          _ref$bank_accounts = _ref.bank_accounts,
          bank_accounts = _ref$bank_accounts === void 0 ? [] : _ref$bank_accounts;
        return bank_accounts.length > 0 ? 'bank' : '';
      };
      this.onboard.eConsentTermsContent = _helper.signupLib.getSignupTermsContentKey(this.locale.country, isGDPRCountry, getFiMode());
      if (preloadedData.guestUpgradeNewAppRedirect === true) {
        var redirectUrl = window.location.href.replace('xoonboarding', 'prox');
        _logger.$logger.info('guest_upgrade_new_app_redirect', {
          redirectUrl: redirectUrl,
          transactionId: preloadedData.transaction
        });
        return _index2.$util.redirect(redirectUrl);
      }
      this.onboard.payerId = preloadedData.payerId;
      this.onboard.billing_address.populate(_mapper["default"].getFormattedAddress(preloadedData.billing_address));
      this.onboard.user.populate(preloadedData.user);
      this.specialFields = _mapper["default"].getSpecialFieldsFor(preloadedData.user.country);
      this.onboard.contentIdentifier = getContentIdentifier();
      this.hasDialingCodeOverride = _util.hasDialingCodeOverride;
      if (this.upgradeFromEmail) {
        // Email based gxo flow

        this.onboard.card = preloadedData.card;
        this.onboard.receiptId = preloadedData.receiptId;
        this.onboard.transaction = preloadedData.transaction;
        this.onboard.experienceIdentifier = 'proxemailupgrade';
      } else {
        // Ad based gxo flow

        // Check if return_url and cancel_url are present and if the session has timed out
        if (!_index2.$util.param('cancel_url') || !_index2.$util.param('return_url') || !preloadedData.email || !preloadedData.payerId || !preloadedData.transaction) {
          this.fpti.trackError(new Error('malformed payload'));
          _uiRouter.$state.go('guestupgrade.genericError', {
            code: 'GUEST_UPGRADE_SESSION_ERROR'
          });
          return;
        }
        _mapper["default"].pxpMapper(this, _index2.$pxpMatch, preloadedData);
        this.onboard.transaction = preloadedData.transaction;
        this.onboard.experienceIdentifier = 'proxupgrade';
        _logger.$logger.info('guest_upgrade_ui_fields', {
          special_fields: this.specialFields,
          txn_id: preloadedData.transaction
        });
        if (this.specialFields.address) {
          this.uponNormalization = function (normalizedAddress) {
            _this2.showAddressNormalizationLightbox = false;

            // Update the new address
            _this2.onboard.billing_address = _index3.$BillingAddressModel.create(null, normalizedAddress, {
              id: '0',
              normalization_status: normalizedAddress.normalization_status
            });
            _this2.upgrade();
          };
        }
      }
      var showSuccessPage = function showSuccessPage() {
        // This changes the footer wapper ID and appropriate css classes gets applied
        _this2.footerStyle = 'confirmationFooter';
        if (!_this2.upgradeFromEmail) {
          var timer;
          _this2.successUrl = _index2.$util.buildURL(_index2.$util.param('return_url'), {
            status: 'success'
          });
          _this2.fpti.trackSuccess();
          _index.$ReturnToMerchant.postToMerchant(_this2.successUrl);
          var timerExecutor = function timerExecutor() {
            // eslint-disable-line no-inner-declarations
            // We wait for 5 secs on live and 10 secs on stage/local(helpful for automation)
            var waitTime = _index2.$config.deploy.isLive() ? 20 : 10;
            var updateMsg = function updateMsg() {
              _this2.returnToMerchantTimerMsg = (0, _index2.$renderContent)('signup.returnTimerMsg', {
                waitTime: waitTime
              });
            };
            _this2.stopTimerAndRedirect = function () {
              if (angular.isDefined(timer)) {
                _angular.$interval.cancel(timer);
                timer = undefined;
              }
              _index.$ReturnToMerchant.goTo(_this2.successUrl);
            };
            updateMsg();
            // When this.onboard becomes null, the success page is shown.
            _this2.onboard = null;
            return function () {
              waitTime -= 1;
              updateMsg();
              if (waitTime === 0) {
                return _this2.stopTimerAndRedirect();
              }
            };
          };
          timer = (0, _angular.$interval)(timerExecutor(), 1000);
        } else {
          // When this.onboard becomes null, the success page is shown.
          _this2.onboard = null;
        }
      };
      var handleUIValidation = function handleUIValidation(errorData, displayGenericMessage) {
        var element = _mapper["default"].errorMapper(errorData);
        if (element) {
          var $fields = $(element);
          $fields.addClass('backendError');
        }
        if (displayGenericMessage) {
          _this2.pageErrorMsg = {
            msgs: [_this2.locale.content.genericError.incontextGenericPageError],
            type: 'error'
          };
        }
      };
      var getContent = function getContent(errorKey) {
        var errorText;
        var msg = _index2.$locale.content.get(errorKey);
        errorText = {
          msgs: [msg],
          type: 'error'
        };
        return errorText;
      };
      this.upgrade = function () {
        var data = _this2.upgradeFromEmail ? _this2.onboard.serializeEmailFlow() : _this2.onboard.serialize();
        _this2.onboard.save({
          data: data,
          success: showSuccessPage,
          contingencies: {
            DOB_INVALID: function DOB_INVALID(err, message) {
              handleUIValidation(err);
              _this2.pageErrorMsg = {
                msgs: [_this2.locale.content.validation.validDOB],
                type: 'error'
              };
            },
            PHONE_INVALID: function PHONE_INVALID(err, message) {
              handleUIValidation(err);
              _this2.pageErrorMsg = {
                msgs: [_this2.locale.content.validation.validPhone],
                type: 'error'
              };
            },
            NATID_INVALID: function NATID_INVALID(err, message) {
              handleUIValidation(err);
              _this2.pageErrorMsg = {
                msgs: [_this2.locale.content.validation.validNationalId],
                type: 'error'
              };
            },
            ADDRESS_LINEONE_INVALID: function ADDRESS_LINEONE_INVALID(err, message) {
              handleUIValidation(err, true);
            },
            ADDRESS_CITY_INVALID: function ADDRESS_CITY_INVALID(err, message) {
              handleUIValidation(err, true);
            },
            ADDRESS_STATE_INVALID: function ADDRESS_STATE_INVALID(err, message) {
              handleUIValidation(err, true);
            },
            ADDRESS_POSTAL_CODE_INVALID: function ADDRESS_POSTAL_CODE_INVALID(err, message) {
              handleUIValidation(err, true);
            },
            PASSWORD_INVALID: function PASSWORD_INVALID(err, message) {
              handleUIValidation(err, true);
            },
            FI_INVALID: function FI_INVALID(err, message) {
              handleUIValidation(err);
            },
            INVALID_FIRST_NAME: function INVALID_FIRST_NAME(err, message) {
              handleUIValidation(err);
              _this2.validationErrMsg = '';
              _this2.pageErrorMsg = getContent('bank.errorInvalidFirstName');
              _logger.$logger.info('guest_upgrade_JP_first_name_contingency', {
                'int_error_description': message,
                'contingency_name': err
              });
            },
            INVALID_LAST_NAME: function INVALID_LAST_NAME(err, message) {
              handleUIValidation(err);
              _this2.validationErrMsg = '';
              _this2.pageErrorMsg = getContent('bank.errorInvalidLastName');
              _logger.$logger.info('guest_upgrade_JP_last_name_contingency', {
                'int_error_description': message,
                'contingency_name': err
              });
            },
            INVALID_NAME: function INVALID_NAME(err, message) {
              $('#firstName').addClass('backendError');
              $('#lastName').addClass('backendError');
              _this2.pageErrorMsg = getContent('bank.errorInvalidFirstName');
              _this2.validationErrMsg = getContent('bank.errorInvalidLastName');
              _logger.$logger.info('guest_upgrade_JP_first_and_last_name_contingency', {
                'int_error_description': message,
                'contingency_name': err
              });
            },
            DEFAULT: function DEFAULT(name, contingency) {
              _logger.$logger.info('guest_upgrade_contingency', {
                'int_error_description': contingency && contingency.message,
                'contingency_name': name
              });
            }
          }
        })["catch"](function (err) {
          _this2.fpti.trackError(err);
          _logger.$logger.error('guest_upgrade_error', {
            error: err
          });
          if (_index2.$util.param('return_url')) {
            var url = _index2.$util.buildURL(_index2.$util.param('return_url'), {
              status: 'fail'
            });
            _this2.cancelUrl = url;
            _index.$ReturnToMerchant.postToMerchant({
              cancelUrl: url
            });
          }
        });
      };
    }
  },
  actions: {
    onSubmit: function onSubmit() {
      if (this.specialFields.nationalId) {
        this.onboard.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
      }

      // SCA - Strong Customer Authentication
      // 2fa - 2 factor authentication
      // phoneConfirmation - we send a 6 digit otp to user's mobile number to authenticate
      // the user before signup (it does not apply to guest flows)
      if (this.flags.isphoneConfirmationExpTreatment && !this.flags.phoneConfirmed) {
        this.flags.showPhoneConfirmationPopup = true;
        return;
      }
      if (this.specialFields.address) {
        this.showAddressNormalizationLightbox = true;
        return;
      }
      this.upgrade();
    },
    formatExpiry: function formatExpiry(event) {
      var key = event.keyCode || event.charCode;
      var $el = $(event.target);
      var val = $el.val().replace(/[^0-9\/]/gi, '');
      var strokes = val.length;

      // Ignore delete keys
      if (key === 8 || key === 46) {
        return;
      }

      // after two characters add a slash char
      if (strokes === 2) {
        val += '/';
      }
      this.expiryDate = val;
      $el.mask('99/99');
    },
    validate: function validate(expiryDate) {
      if (!expiryDate) {
        return;
      }
      var month, year, unformatted;
      var isValid = false;
      unformatted = expiryDate.replace(/[^0-9]/gi, '');
      if (unformatted.length > 3) {
        month = unformatted.substring(0, 2);
        year = this.currentYear.substring(0, 2) + unformatted.substring(2, 4);
        isValid = this.validMonths.indexOf(month) > -1 && year >= this.currentYear;
        if (isValid) {
          var expDate = new Date(year, parseInt(month, 10) - 1);
          var today = new Date();
          isValid = expDate > today;
        }
      }
      return isValid;
    },
    onPhoneConfirmationClose: function onPhoneConfirmationClose() {
      this.flags.showPhoneConfirmationPopup = false;
    },
    onPhoneConfirmationSuccess: function onPhoneConfirmationSuccess() {
      this.flags.phoneConfirmed = true;
      this.flags.showPhoneConfirmationPopup = false;

      // We cannot call onboardAccount here. If we do, then we
      // are going to skip other checks like address_normalization
      // that lives in onSubmit
      this.actions.onSubmit();
    }
  }
});
_index.$ReturnToMerchant;
_index2.$Component;
_index2.$contentVersion;
_index2.$locale;
_index2.$util;
_index2.$config;
_index2.$pxpMatch;
_index2.$renderContent;
_index2.$elmo;
_index2.$feature;
_angular.$rootScope;
_angular.$interval;
_util.hasDialingCodeOverride;
_index3.$BillingAddressModel;
_uiRouter.$state;
_logger.$logger;
_directive.$NationalIdModel;
_index4.$OnboardUserModel;
_index4.$OnboardPhoneModel;
_index4.$GuestUpgradeModel;
_fpti.$fpti;
_gdprCookieBanner.isGdprValid;
_helper.signupLib;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/lib/mapper.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  var FIELD_SETS = {
    // eslint-disable-line no-reserved-keys
    "default": [],
    set1: ['dob', 'nationality'],
    set2: ['dob', 'nationality', 'marketing'],
    set3: ['address', 'dob', 'marketing'],
    set4: ['dob', 'nationality', 'occupation', 'marketing'],
    set5: ['dob', 'nationality', 'nationalId'],
    set6: ['dob', 'gender', 'placeOfBirth', 'nationality', 'nationalId'],
    set7: ['dob', 'nationality', 'nationalId', 'marketing'],
    set8: ['dob', 'nationality', 'name']
  };
  var FIELDS = {
    US: FIELD_SETS["default"],
    IN: FIELD_SETS.set2,
    IL: FIELD_SETS.set7,
    AT: FIELD_SETS.set2,
    BE: FIELD_SETS.set2,
    DK: FIELD_SETS.set2,
    NO: FIELD_SETS.set2,
    PL: FIELD_SETS.set2,
    SE: FIELD_SETS.set2,
    AU: FIELD_SETS.set3,
    CA: FIELD_SETS.set4,
    SG: FIELD_SETS.set5,
    MY: FIELD_SETS.set2,
    KR: FIELD_SETS.set5,
    NZ: FIELD_SETS.set5,
    ID: FIELD_SETS.set5,
    TH: FIELD_SETS.set5,
    FR: FIELD_SETS.set2,
    DE: FIELD_SETS.set2,
    IT: FIELD_SETS.set2,
    ES: FIELD_SETS.set2,
    GB: FIELD_SETS.set2,
    NL: FIELD_SETS.set2,
    CH: FIELD_SETS.set7,
    TR: FIELD_SETS.set1,
    CZ: FIELD_SETS.set2,
    FI: FIELD_SETS.set2,
    EE: FIELD_SETS.set2,
    LV: FIELD_SETS.set2,
    HR: FIELD_SETS.set7,
    UA: FIELD_SETS.set1,
    PT: FIELD_SETS.set2,
    IE: FIELD_SETS.set2,
    HU: FIELD_SETS.set2,
    GR: FIELD_SETS.set2,
    SK: FIELD_SETS.set2,
    BA: FIELD_SETS.set1,
    BG: FIELD_SETS.set2,
    CY: FIELD_SETS.set2,
    HK: FIELD_SETS.set6,
    LT: FIELD_SETS.set2,
    LU: FIELD_SETS.set2,
    MT: FIELD_SETS.set2,
    PH: FIELD_SETS.set5,
    RO: FIELD_SETS.set2,
    SI: FIELD_SETS.set2,
    TW: FIELD_SETS.set1,
    AE: FIELD_SETS.set5,
    AL: FIELD_SETS.set1,
    AM: FIELD_SETS.set1,
    AZ: FIELD_SETS.set1,
    BH: FIELD_SETS.set5,
    BN: FIELD_SETS.set1,
    BY: FIELD_SETS.set1,
    EG: FIELD_SETS.set1,
    FO: FIELD_SETS.set5,
    GE: FIELD_SETS.set5,
    NG: FIELD_SETS.set1,
    OM: FIELD_SETS.set5,
    QA: FIELD_SETS.set5,
    RE: FIELD_SETS.set1,
    RS: FIELD_SETS.set5,
    SA: FIELD_SETS.set5,
    VA: FIELD_SETS.set1,
    ZA: FIELD_SETS.set5,
    ZM: FIELD_SETS.set1,
    LK: FIELD_SETS.set1,
    FM: FIELD_SETS.set1,
    MN: FIELD_SETS.set1,
    MV: FIELD_SETS.set1,
    VN: FIELD_SETS.set5,
    MK: FIELD_SETS.set1,
    GI: FIELD_SETS.set1,
    MQ: FIELD_SETS.set1,
    GP: FIELD_SETS.set1,
    MU: FIELD_SETS.set5,
    MD: FIELD_SETS.set5,
    IS: FIELD_SETS.set7,
    GL: FIELD_SETS.set5,
    KZ: FIELD_SETS.set5,
    KW: FIELD_SETS.set5,
    BT: FIELD_SETS.set1,
    KH: FIELD_SETS.set1,
    LA: FIELD_SETS.set1,
    NP: FIELD_SETS.set1,
    TO: FIELD_SETS.set1,
    WS: FIELD_SETS.set1,
    AO: FIELD_SETS.set1,
    BF: FIELD_SETS.set1,
    BI: FIELD_SETS.set1,
    BJ: FIELD_SETS.set1,
    CD: FIELD_SETS.set1,
    CG: FIELD_SETS.set1,
    CI: FIELD_SETS.set1,
    CK: FIELD_SETS.set1,
    CM: FIELD_SETS.set1,
    CV: FIELD_SETS.set1,
    DJ: FIELD_SETS.set1,
    ER: FIELD_SETS.set1,
    ET: FIELD_SETS.set1,
    FJ: FIELD_SETS.set1,
    GA: FIELD_SETS.set1,
    GF: FIELD_SETS.set1,
    GM: FIELD_SETS.set1,
    GN: FIELD_SETS.set1,
    GW: FIELD_SETS.set1,
    KG: FIELD_SETS.set1,
    KI: FIELD_SETS.set1,
    KM: FIELD_SETS.set1,
    LI: FIELD_SETS.set2,
    ME: FIELD_SETS.set1,
    MG: FIELD_SETS.set1,
    MH: FIELD_SETS.set1,
    ML: FIELD_SETS.set1,
    MR: FIELD_SETS.set1,
    MS: FIELD_SETS.set1,
    MW: FIELD_SETS.set1,
    NA: FIELD_SETS.set1,
    NC: FIELD_SETS.set1,
    NE: FIELD_SETS.set1,
    NF: FIELD_SETS.set1,
    NR: FIELD_SETS.set1,
    NU: FIELD_SETS.set1,
    PF: FIELD_SETS.set1,
    SZ: FIELD_SETS.set1,
    TD: FIELD_SETS.set1,
    TG: FIELD_SETS.set1,
    TJ: FIELD_SETS.set1,
    TM: FIELD_SETS.set1,
    TV: FIELD_SETS.set1,
    TZ: FIELD_SETS.set1,
    UG: FIELD_SETS.set5,
    VU: FIELD_SETS.set1,
    WF: FIELD_SETS.set1,
    YT: FIELD_SETS.set1,
    ZW: FIELD_SETS.set1,
    DZ: FIELD_SETS.set1,
    JO: FIELD_SETS.set5,
    MA: FIELD_SETS.set5,
    TN: FIELD_SETS.set1,
    YE: FIELD_SETS.set1,
    AD: FIELD_SETS.set5,
    BW: FIELD_SETS.set5,
    KE: FIELD_SETS.set5,
    LS: FIELD_SETS.set5,
    MC: FIELD_SETS.set5,
    MZ: FIELD_SETS.set5,
    SN: FIELD_SETS.set5,
    PG: FIELD_SETS.set1,
    PM: FIELD_SETS.set1,
    PN: FIELD_SETS.set1,
    PY: FIELD_SETS.set1,
    RW: FIELD_SETS.set1,
    SB: FIELD_SETS.set1,
    SC: FIELD_SETS.set1,
    SH: FIELD_SETS.set1,
    SJ: FIELD_SETS.set1,
    SL: FIELD_SETS.set1,
    SM: FIELD_SETS.set1,
    SO: FIELD_SETS.set1,
    ST: FIELD_SETS.set1,
    PW: FIELD_SETS.set1,
    AG: FIELD_SETS.set1,
    AN: FIELD_SETS.set1,
    AW: FIELD_SETS.set1,
    BB: FIELD_SETS.set1,
    BO: FIELD_SETS.set1,
    BZ: FIELD_SETS.set1,
    DM: FIELD_SETS.set1,
    FK: FIELD_SETS.set1,
    GD: FIELD_SETS.set1,
    GY: FIELD_SETS.set1,
    KN: FIELD_SETS.set1,
    LC: FIELD_SETS.set1,
    SR: FIELD_SETS.set1,
    TC: FIELD_SETS.set1,
    TT: FIELD_SETS.set1,
    VC: FIELD_SETS.set1,
    VG: FIELD_SETS.set1,
    AI: FIELD_SETS.set1,
    MX: FIELD_SETS.set1,
    AR: FIELD_SETS.set5,
    BM: FIELD_SETS.set5,
    BS: FIELD_SETS.set5,
    CL: FIELD_SETS.set5,
    CO: FIELD_SETS.set5,
    CR: FIELD_SETS.set5,
    DO: FIELD_SETS.set5,
    EC: FIELD_SETS.set5,
    GT: FIELD_SETS.set5,
    HN: FIELD_SETS.set5,
    JM: FIELD_SETS.set5,
    JP: FIELD_SETS.set8,
    KY: FIELD_SETS.set5,
    NI: FIELD_SETS.set5,
    PA: FIELD_SETS.set5,
    PE: FIELD_SETS.set5,
    SV: FIELD_SETS.set5,
    UY: FIELD_SETS.set5,
    VE: FIELD_SETS.set5,
    C2: FIELD_SETS.set1
  };

  // converts ['a', 'b'] to {a:true, b:true}
  function arrayToObject(array) {
    var obj = {};
    array.forEach(function (key) {
      obj[key] = true;
    });
    return obj;
  }
  return {
    getSpecialFieldsFor: function getSpecialFieldsFor(country) {
      return arrayToObject(FIELDS[country] || FIELDS.US);
    },
    getFormattedAddress: function getFormattedAddress(address) {
      if (address.country === 'AU') {
        var AUStateCodeMap = {
          australiancapitalterritory: 'ACT',
          newsouthwales: 'NSW',
          northernterritory: 'NT',
          queensland: 'QLD',
          southaustralia: 'SA',
          tasmania: 'TAS',
          victoria: 'VIC',
          westernaustralia: 'WA'
        };
        address.state = AUStateCodeMap[address.state.replace(/\s/g, '').toLowerCase()] || address.state;
      }
      return address;
    },
    errorMapper: function errorMapper(errorData) {
      var errorMap = {
        DOB_INVALID: {
          field: '#dobText'
        },
        PHONE_INVALID: {
          field: '#telephone'
        },
        NATID_INVALID: {
          field: '#idValue'
        },
        FI_INVALID: {
          field: '#expiry_value, #cvv'
        },
        ADDRESS_LINEONE_INVALID: {
          field: '#billingLine1'
        },
        ADDRESS_CITY_INVALID: {
          field: '#billingCity'
        },
        ADDRESS_STATE_INVALID: {
          field: '#billingState'
        },
        ADDRESS_POSTAL_CODE_INVALID: {
          field: '#billingPostalCode'
        },
        PASSWORD_INVALID: {
          field: '#password, #confirmPassword'
        },
        INVALID_FIRST_NAME: {
          field: '#firstName'
        },
        INVALID_LAST_NAME: {
          field: '#lastName'
        }
      };
      return errorMap[errorData].field;
    },
    pxpMapper: function pxpMapper($scope, $pxpMatch, preloadedData) {
      var patterns = {
        proxSignupTitleTreatment: 'prox_signup_title_treatment'
      };
      var logPayload = {
        txn_id: preloadedData.transaction
      };
      if ($scope.locale.metadata.country === 'US' && $scope.locale.metadata.lang === 'en') {
        $pxpMatch('prox_signup_title', {}, patterns, logPayload).then(function (result) {
          if (result && result.proxSignupTitleTreatment) {
            $scope.pageTitle = $scope.locale.content.signup.eBayTitle;
          } else {
            $scope.pageTitle = $scope.locale.content.signup.title;
          }
        });
      }
    }
  };
}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/occupation/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _factory = __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/occupation/factory.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/guest-upgrade/occupation/template.html"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {
  return angular.module('xo-guest-upgrade.occupation', ['squid', 'xo-error-tooltip.directive']).directive('xoOccupation', [function () {
    return {
      template: template,
      scope: {
        user: '=?'
      },
      controller: ['$scope', '$locale', function ($scope, $locale) {
        $scope.locale = $locale;
        _factory.$OccupationFactory.occupationExp().then(function (_ref) {
          var enabled = _ref.enabled;
          $scope.occupations = enabled ? $locale.content.signup.occupations : $locale.content.signup.occupationList;
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_factory.$OccupationFactory;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/occupation/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
angular.module().factory('$OccupationFactory', function () {
  // Experiment that controls if user should see old or new list of occupations
  var occupationExp = function occupationExp() {
    return (0, _squid.$elmo)('xo_xoon_occupation_list', {
      'ctx.COUNTRY': _squid.$locale.country
    }, 'Trmt_xo_xoon_occupation_list_1').then(function (result) {
      return {
        enabled: Boolean(result && result.treatment_name)
      };
    });
  };
  return {
    occupationExp: occupationExp
  };
});
_squid.$elmo;
_squid.$locale;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/guest-upgrade/occupation", "../node_modules/xo-guest-components/src/guest-upgrade/occupation/factory.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest-upgrade/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"outerWrapper\" ng-class=\"[locale.metadata.directionality, locale.country, locale.lang, miniBrowser?'minibrowser':'', isApp?'mobileApp':'']\" id=\"outerWrapper\">\n    <header>\n        <div id=\"header\" class=\"merchantHeader clearfix\">\n            <div class=\"headerWrapper\"></div>\n        </div>\n    </header>\n    <div id=\"wrapper\" class=\"clearfix\" ng-class=\"{confirmationPage: !onboard}\">\n        <div id=\"main\">\n            <div class=\"row-fluid paypalHeaderWrapper\">\n                <div class=\"clearfix paypalHeader\" ng-class=\"{span14: onboard, spanConfirmation: !onboard}\">\n                    <div id=\"paypalLogo\" class=\"logo\">\n                        <span class=\"accessAid\">{{content('signup.paypal')}}</span>\n                    </div>\n                </div>\n            </div>\n            <div content ui-view id=\"contents\">\n                <section class=\"guestUpgrade\" id=\"guestUpgrade\">\n                    <div class=\"row-fluid\">\n                        <div ng-if=\"!onboard\">\n                            <div class=\"tick\">\n                                <div id=\"circle\"></div>\n                                <h1 id=\"successTitle\" class=\"alpha successTitle\">{{content('signup.successTitle')}}</h1>\n                            </div>\n\n                            <p id=\"successText1\">{{content('signup.successText1')}} {{content('signup.successText2')}}</p>\n                            <p id=\"successText3\" ng-bind-html=\"htmlContent('signup.successText3')\"></p>\n                            <p ng-if=\"successUrl\" id=\"returnToEbay\" class=\"returnToMerchant\">{{content('signup.returnToEbayMsg')}}</p>\n\n                            <a ng-if=\"successUrl\" id=\"returnToEbayBtn\" track-link=\"success_redirect_return_to_merchant\" href=\"{{successUrl}}\" ng-click=\"stopTimerAndRedirect($event)\" role=\"button\" class=\"ng-binding btn btnGrey\">\n                                {{content('signup.backToEbay')}}\n                            </a>\n                        </div>\n                        <div ng-if=\"onboard\" class=\"span14\">\n                            <div>\n                                <xo-message message=\"pageErrorMsg\"></xo-message>\n                                <xo-message message=\"validationErrMsg\"></xo-message>\n\n                                <form id=\"guestUpgradeForm\" name=\"guestUpgradeForm\" class=\"guestUpgradeForm singlePagePaymentForm\" ng-submit=\"guestUpgradeForm.$valid && actions.onSubmit()\" ng-class=\"{'validated': validated}\" novalidate>\n\n                                    <div class=\"titlePadding\">\n                                        <h1 class=\"alpha\">{{ content(upgradeFromEmail ? 'guestUpgrade.emailFlowTitle' : 'signup.title') }}</h1>\n                                        <p>{{pageSubTitle}}</p>\n                                    </div>\n\n                                    <div id=\"upgradeFromEmail\" ng-if=\"upgradeFromEmail\" class=\"confidential\">\n                                        <div class=\"fieldGroup clearfix\">\n                                            <div id=\"personalInfo\" class=\"inputField half\">\n                                                <p class=\"contactInfoFont\"><b>{{content('guestUpgrade.contactInfo')}}</b></p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.first_name}} {{onboard.user.last_name}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.email}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.user.phone}}</p>\n                                            </div>\n                                            <div id=\"personalBillingAddress\" class=\"inputField half last-child\">\n                                                <p class=\"contactInfoFont\"><b>{{content('guestUpgrade.billingAddress')}}</b></p>\n                                                <p class=\"contactInfoFont\">{{onboard.billing_address.line1}}</p>\n                                                <p class=\"contactInfoFont\">{{onboard.billing_address.city}}, {{onboard.billing_address.state}} {{onboard.billing_address.postal_code}}</p>\n                                            </div>\n                                        </div>\n\n                                        <p class=\"contactInfoFont fullsignup-link\" ng-bind-html=\"htmlContent('guestUpgrade.fullSignupLink', {country: locale.country})\"></p>\n\n                                        <div class=\"fieldGroup confirmCard\">\n                                            <p>{{content('guestUpgrade.confirmCard')}} {{onboard.card.brand}} x-{{onboard.card.lastFour}}</p>\n\n                                            <div class=\"inputField half expirationField\" floating-label>\n                                                <input ng-model=\"onboard.card.expiry_month\"\n                                                       name=\"expiry_value\"\n                                                       id=\"expiry_value\"\n                                                       value=\"\"\n                                                       maxlength=\"5\"\n                                                       autocapitalize=\"off\"\n                                                       autocomplete=\"off\"\n                                                       ui-validate=\"'actions.validate($value)'\"\n                                                       ng-keyup=\"actions.formatExpiry($event)\"\n                                                       required />\n\n                                                <label for=\"expiry_value\" class=\"focus\">{{content('creditcard.expiresPlaceholder')}}</label>\n                                            </div>\n\n                                            <div class=\"inputField cvvField half last-child cvvSecurityCode\" floating-label>\n                                                <input type=\"tel\"\n                                                       id=\"cvv\"\n                                                       name=\"cvv\"\n                                                       ng-model=\"onboard.card.security_code\"\n                                                       ng-pattern=\"/^[0-9]{1,4}$/\"\n                                                       ng-minlength=\"3\"\n                                                       ng-maxlength=\"4\"\n                                                       required/>\n\n                                                <label for=\"cvv\" class=\"focus\">{{content('creditcard.cscLabel')}}</label>\n\n                                                <span id=\"securityCode\" class=\"creditCard\" role=\"img\"></span>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <xo-email-input flags=\"flags\" ng-if=\"!upgradeFromEmail\" user=\"onboard.user\" disabled=\"true\"></xo-email-input>\n                                    <xo-password-input user=\"onboard.user\" single-password=\"flags.singlePassword\"></xo-password-input>\n\n                                    <!--As per the UI design, DOB and Gender needs to be side by side -->\n                                    <div class=\"dualInputElements clearfix\">\n                                        <span ng-class=\"{'halfInputElement': specialFields.gender}\" ng-if=\"specialFields.dob\">\n                                            <xo-dob-input user=\"onboard.user\" id=\"dob\"></xo-dob-input>\n                                        </span>\n                                        <!--gender is enabled only for HK-->\n                                        <span ng-if=\"specialFields.gender\">\n                                            <xo-gender-type user=\"onboard.user\" id=\"gender\"></xo-gender-type>\n                                        </span>\n                                    </div>\n                                    <!--first_name and last_name is enabled only for JP-->\n                                    <xo-name-input ng-if=\"specialFields.name\" user=\"onboard.user\"></xo-name-input>\n                                    <!--placeOfBirth -->\n                                    <xo-place-of-birth ng-if=\"specialFields.placeOfBirth\" user=\"onboard.user\" id=\"placeofbirth\"></xo-place-of-birth>\n\n                                    <xo-nationality ng-if=\"specialFields.nationality\" user=\"onboard.user\"></xo-nationality>\n                                    <xo-phone-input ng-if=\"!hasDialingCodeOverride()\" phone=\"onboard.phone\" optional=\"false\" countryCode=\"locale.country\"></xo-phone-input>\n                                    <p ng-if=\"phoneConfirmationExp && phoneConfirmationExp.isPhoneConfirmationEnabled\">\n                                        {{ content('2faPhoneConfirmation.phoneFieldMessage') }}\n                                        </p>\n                                    <xo-occupation ng-if=\"specialFields.occupation\" user=\"onboard.user\"></xo-occupation>\n\n                                    <xo-national-id-input ng-if=\"specialFields.nationalId\" country=\"{{locale.country}}\" user=\"onboard.user\"></xo-national-id-input>\n\n                                    <div ng-if=\"specialFields.address\" id=\"billingAddress\">\n                                        <xo-add-address address=\"onboard.billing_address\" country=\"locale.country\"></xo-add-address>\n                                    </div>\n\n                                    <xo-phone-input ng-if=\"hasDialingCodeOverride()\" phone=\"onboard.phone\" optional=\"false\" countryCode=\"locale.country\"></xo-phone-input>\n                                    <p ng-if=\"phoneConfirmationExp && phoneConfirmationExp.isPhoneConfirmationEnabled\">\n                                        {{ content('2faPhoneConfirmation.phoneFieldMessage') }}\n                                    </p>\n\n                                    <div ng-if=\"showMarketingOptin && MarketingCheckboxFirst\" class=\"row-fluid checkbox legal marketing margin-bottom\">\n                                        <input ng-model=\"onboard.marketing_optin\" type=\"checkbox\" name=\"marketing_optin\" id=\"marketing_optin\" ng-checked=\"onboard.marketing_optin\"/>\n                                        <label class=\"noBottom\" id=\"marketingOptinText\" for=\"marketing_optin\" ng-bind-html=\"htmlContent(marketingOptinContentKey, { country: locale.country, lang: locale.lang })\"></label>\n                                    </div>\n\n                                    <div class=\"row-fluid inputField checkbox legal ltrOverride\">\n                                        <div id=\"errorSignupAgree\" ng-show=\"guestUpgradeForm.agree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('signup.agrementError') }}</div>\n\n                                        <input ng-model=\"agree\" type=\"checkbox\" name=\"agree\" id=\"agree\" required aria-describedby=\"errorSignupAgree\"/>\n                                        <label class=\"noBottom signupTerms bgImgOnSpan\" for=\"agree\" aria-describedby=\"errorSignupAgree\">\n                                            <span class=\"bgImg\">&nbsp;</span>\n                                            <span id=\"consentTerms\" ng-bind-html=\"htmlContent(onboard.eConsentTermsContent, { country: locale.country, lang: locale.lang })\"></span>\n                                        </label>\n                                    </div> \n                                \n                                    <div ng-if=\"locale.country != 'JP'\" class=\"terms\" feature=\"signupTerms\">\n                                        <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisoryB',{country:locale.country})\"></p>\n                                    </div>\n\n                                    <div ng-if=\"showMarketingOptin && !MarketingCheckboxFirst\" class=\"row-fluid checkbox legal marketing\">\n                                        <input ng-model=\"onboard.marketing_optin\" type=\"checkbox\" name=\"marketing_optin\" id=\"marketing_optin\" ng-checked=\"onboard.marketing_optin\"/>\n                                        <label class=\"noBottom\" id=\"marketingOptinText\" for=\"marketing_optin\" ng-bind-html=\"htmlContent(marketingOptinContentKey, { country: locale.country, lang: locale.lang })\"></label>\n                                    </div>\n\n                                    <div class=\"buttons\">\n                                        <input track-submit id=\"guestUpgradeSubmit\" type=\"submit\" value=\"{{ content('signup.agreeAndCreateAcc')}}\" class=\"btn\"\n                                               ng-click=\"validated=true\" />\n                                    </div>\n                                </form>\n                            </div>\n                        </div>\n\n                        <div ng-if=\"onboard\" class=\"span10\">\n                            <xo-value-props type=\"review\" title=\"{{valueTitle}}\" text-content=\"guestVerify.propVal\"></xo-value-props>\n                        </div>\n                    </div>\n                </section>\n                <xo-modal ng-if=\"showAddressNormalizationLightbox && specialFields.address\" show=\"true\">\n                    <xo-address-normalization token=\"token\" address=\"onboard.billing_address\" hide-back-button=\"true\" done-fn=\"uponNormalization\"></xo-address-normalization>\n                </xo-modal>\n            </div>\n        </div>\n        <xo-spinner></xo-spinner>\n    </div>\n    <div ng-attr-id=\"{{footerStyle}}\">\n        <xo-footer merchant=\"{{content('signup.ebay')}}\" cancel=\"{{cancelUrl}}\"></xo-footer>\n    </div>\n    <xo-gdpr-cookie-banner ng-if=\"isGdprValid()\"></xo-gdpr-cookie-banner>\n</div>\n\n<xo-modal\n    ng-if=\"flags.showPhoneConfirmationPopup\"\n    show=\"true\"\n    show-close-button=\"true\"\n    enable-close-on-escape=\"true\"\n    enable-mobile-interstitial=\"true\"\n    on-close=\"actions.onPhoneConfirmationClose\"\n    override-default-container=\"true\"\n>\n    <xo-phone-confirmation-interstitial\n        phone-details=\"onboard.phone\"\n        on-phone-confirmation-success=\"actions.onPhoneConfirmationSuccess\"\n    />\n</xo-modal>\n\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/cartChanged/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/cartChanged/template.html"));
var errorHandlerHelper = _interopRequireWildcard(__webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js"));
__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/header/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");
var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");
var _xoShippingOptions = __webpack_require__("../node_modules/xo-shipping-options/src/index.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoCartChanged', {
  tag: 'xo-cart-changed',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    shippingAddress: {
      type: 'var',
      required: true
    },
    disableChangeShippingCountry: {
      type: 'var',
      required: false
    },
    checkForShippingOptions: {
      type: 'var',
      required: true
    },
    shippingOptions: {
      type: 'var',
      required: true
    },
    selectedShippingOption: {
      type: 'var',
      required: true
    },
    onShippingOptionSelect: {
      type: 'var',
      required: true
    },
    onShippingChange: {
      type: 'var',
      required: true
    },
    onContinue: {
      type: 'var',
      required: true
    },
    message: {
      type: 'var',
      required: false
    },
    showForm: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutAppData: _checkout.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
        checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
        checkoutCart: _checkout.$CheckoutCartModel.instance(this.props.token).retrieve()
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.callOnShippingChange = this.showForm;
      var isCallbackInterstitial = window.xprops && window.xprops.onShippingChange;
      var initialMessage = !isCallbackInterstitial && this.shippingOptions && this.shippingOptions.length ? (0, _squid.$renderContent)('shipping.orderChoiceLabel') : this.message;
      var changeMessage = function changeMessage(message) {
        _this.computedMessage = message;
      };
      changeMessage(initialMessage);

      // Turn on the call-callback flag if a new option is selected
      this.wrappedOnShippingOptionSelect = function (option, userSelected) {
        if (option === void 0) {
          option = {};
        }
        if (option) {
          return _this.onShippingOptionSelect(option, userSelected).then(function () {
            if (isCallbackInterstitial) {
              var newMessage = (0, _squid.$renderContent)('shippingCallback.updated', {
                amount: _this.models.checkoutCart.get('purchase.amounts.total.amount_formatted_currency')
              });
              changeMessage(newMessage);
            }
            if (userSelected && window.xprops && window.xprops.onShippingChange) {
              return _this.onShippingChange();
            }
          });
        }
      };
      this.errorMessage = '';

      // If the interstitial is submitted with the form open, call the callback
      this.openForm = function () {
        changeMessage((0, _squid.$renderContent)('shippingAddress.label'));
        _this.callOnShippingChange = true;
        _this.showForm = true;
      };
      this.closeForm = function () {
        changeMessage(initialMessage);
        _this.showForm = false;
      };
      document.querySelector('body').style.overflow = 'hidden';
    },
    exit: function exit() {
      document.querySelector('body').style.overflow = '';
    },
    populate: function populate() {
      var _this2 = this;
      this.checkForShippingOptions();
      this.cartOptions = {
        showTotal: true,
        showContainer: false
      };
      this.updateShippingAddress = function () {
        return _this2.models.checkoutSession.shipping.action('update', {
          data: _this2.shippingAddress.serialize(),
          resultModel: _this2.models.checkoutSession,
          validation: function validation(errorData, message) {
            errorHandlerHelper.errorHandler(message, errorData.fields, function () {}, null, '#cartChangedForm');
            _this2.errorMessage = {
              msgs: [(0, _squid.$renderContent)('shippingAddress.errorInfo')],
              type: 'error'
            };
            return _squid.$promise.reject();
          }
        });
      };
      this.merchant = this.models.checkoutAppData.getMerchantDisplayName();
      var getFormattedAddress = function getFormattedAddress() {
        var fullName = _this2.models.checkoutSession.shipping.name;
        var fullAddress = _this2.models.checkoutSession.shipping.full_address_multiline;
        return [fullName].concat(fullAddress).join('<br/>');
      };
      this.formattedAddress = _angular.$sce.trustAsHtml(getFormattedAddress());
      (0, _angular.$timeout)(function () {
        _this2.modalOpen = true;
      });
    }
  },
  actions: {
    updateShippingOrContinue: function updateShippingOrContinue(event) {
      if (event) {
        event.preventDefault();
      }
      if (this.callOnShippingChange) {
        this.callOnShippingChange = false;
        return this.updateShippingAddress().then(this.onShippingChange);
      }
      return this.onContinue();
    },
    returnToMerchant: function returnToMerchant() {
      return (0, _util.goTo)(this.models.checkoutAppData.urls.cancel_url, true);
    }
  }
});
_squid.$Component;
_squid.$renderContent;
_angular.$timeout;
_angular.$sce;
_checkout.$CheckoutAppDataModel;
_checkout.$CheckoutSessionModel;
_checkout.$CheckoutCartModel;
_squid.$promise;
_util.goTo;
_xoShippingOptions.$xoShippingOptions; // eslint-disable-line no-unused-vars;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/cartChanged/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"cartChangedInterstitial\" class=\"interstitialModal\">\n    <div class=\"cartChanged\" ng-class=\"{modalClose: !modalOpen, modalOpen: modalOpen}\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper modalWrapperAnimation\" modal-box focus-when=\"modalOpen\">\n\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n\t\t\t\t<header class=\"interstitialHeader\">\n                    <xo-header token=\"token\"></xo-header>\n                </header>\n                <div class=\"interstitialWrapper\">\n                    <section class=\"interstitialBody\">\n                        <h2 class=\"beta\" id=\"pageTitle\">{{computedMessage}}</h2>\n                        <address class=\"bodyAddress\" ng-if=\"!showForm\">\n                            <div class=\"interstitialShippingOptions\">\n                                <xo-shipping-options\n                                    token=\"token\"\n                                    on-select=\"wrappedOnShippingOptionSelect\"\n                                    selected-method=\"selectedShippingOption\"\n                                    on-click-edit=\"openForm\"\n                                    methods=\"shippingOptions\">\n                                </xo-shipping-options>\n                            </div>\n                        </address>\n                        <form id=\"cartChangedForm\" class=\"bodyForm\" ng-submit=\"actions.updateShippingOrContinue($event)\" ng-if=\"showForm\">\n                            <xo-message message=\"errorMessage\"></xo-message>\n                            <xo-select-shipping-country token=\"token\" shipping-address=\"shippingAddress\"\n                                                    disable-change-shipping-country=\"disableChangeShippingCountry\"></xo-select-shipping-country>\n                            <xo-add-address address=\"shippingAddress\" is-shipping=\"true\" token=\"token\" country=\"shippingAddress.country\"></xo-add-address>\n                            <a class=\"edits changeShipping\" ng-click=\"closeForm()\" role=\"button\" tabindex=\"0\">\n                                {{content('shipping.orderChoiceLabel')}}\n                            </a>\n                        </form>\n                    </section>\n                    <footer class=\"interstitialFooter\">\n                        <button type=\"submit\" class=\"btn\" ng-click=\"actions.updateShippingOrContinue()\">{{content('common.continuetext')}}</button>\n                        <p id=\"defaultCancelLink\" class=\"footerLink cancelUrl\">\n                            <a track-link=\"cancel_and_return_to_merchant\" href=\"\" ng-click=\"actions.returnToMerchant()\" role=\"button\">\n                               <span ng-bind-html=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n                            </a>\n                        </p>\n                    </footer>\n                </div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/constants/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.channelType = exports.availablePaymentExp = exports.SUBSCRIPTION_SUBMIT_BUTTON_KEY = exports.SUBMIT_BUTTON_TEXT_KEY_MAP = exports.SHIPPING_TYPE_MAPPING = exports.SHIPPING_TYPE_LABEL_MAPPING = exports.RTR_AMOUNT = void 0;
var submitButtonGuestTextKeyMap = {
  commit: 'common.payLabel',
  notCommit: 'common.continueLabel',
  commitInCurrency: 'common.payInCurrencyLabel',
  notCommitInCurrency: 'common.continueInCurrencyLabel'
};
var submitButtonSignupTextKeyMap = {
  commit: 'common.createAccountAndPayNow',
  notCommit: 'common.agreeAndCreateAccount'
};
var submitButtonSubscriptionSignupTextKeyMap = {
  commit: 'wpsSubscription.guest.createAccountAndSubscribe.button.text',
  notCommit: 'wpsSubscription.guest.createAccountAndSubscribe.button.text'
};
var submitButtonSubscriptionGuestTextKeyMap = {
  commit: 'memberReview.agreeAndSubscribeLabel',
  notCommit: 'memberReview.agreeAndSubscribeLabel'
};

// Reference Transaction button text for Singapore PSA (compliance)
var submitButtonRTSignupSGKeyMap = {
  commit: 'common.payNowAndCreateAccount',
  notCommit: 'common.continueAndCreateAccount'
};

// Subscriptions button text for Singapore PSA (compliance)
var submitButtonSubscriptionSignupSGKeyMap = {
  commit: 'common.payNowAndSubscribe',
  notCommit: 'common.continueAndCreateAccount'
};
var submitButtonSubscriptionGuestSGKeyMap = {
  commit: 'common.confirmAndSubscribe',
  notCommit: 'common.confirmAndContinue'
};
var SUBSCRIPTION_SUBMIT_BUTTON_KEY = exports.SUBSCRIPTION_SUBMIT_BUTTON_KEY = {
  signup: {
    US: submitButtonSubscriptionSignupTextKeyMap,
    ROW: submitButtonSubscriptionSignupTextKeyMap,
    SG: submitButtonSubscriptionSignupSGKeyMap
  },
  pomaSignup: {
    US: submitButtonSubscriptionSignupTextKeyMap,
    ROW: submitButtonSubscriptionSignupTextKeyMap
  },
  guest: {
    US: submitButtonSubscriptionGuestTextKeyMap,
    ROW: submitButtonSubscriptionGuestTextKeyMap,
    SG: submitButtonSubscriptionGuestSGKeyMap
  }
};
var SUBMIT_BUTTON_TEXT_KEY_MAP = exports.SUBMIT_BUTTON_TEXT_KEY_MAP = {
  signup: {
    US: submitButtonSignupTextKeyMap,
    ROW: {
      commit: 'common.agreeAndPay',
      notCommit: 'common.agreeAndContinue'
    },
    SG: submitButtonRTSignupSGKeyMap
  },
  pomaSignup: {
    US: submitButtonSignupTextKeyMap,
    ROW: {
      commit: 'common.agreeAndPayNowPoma',
      notCommit: 'common.agreeAndContinue'
    }
  },
  guest: {
    US: submitButtonGuestTextKeyMap,
    ROW: submitButtonGuestTextKeyMap,
    SG: submitButtonGuestTextKeyMap
  }
};

// This is remittance transfer rule max amount for invoicing transactions
var RTR_AMOUNT = exports.RTR_AMOUNT = 15;

// Shipping Options Label mapping for content
var SHIPPING_TYPE_LABEL_MAPPING = exports.SHIPPING_TYPE_LABEL_MAPPING = {
  PICKUP: {
    PICKUP_IN_STORE: 'shipping.pickupInStore',
    STORE_PICKUP: 'shipping.storePickup',
    PICKUP_OPTION: 'shipping.pickupOption',
    COLLECTION: 'shipping.collection',
    EXPRESS_PICKUP: 'shipping.expressPickup',
    CLICK_COLLECT: 'shipping.clickCollect',
    SHIP_TO_STORE: 'shipping.shipToStore',
    COLLECT_PLUS: 'shipping.collectPlus',
    PICKUP_FROM_STORE: 'shipping.pickupFromStore',
    FREE_NEXT_DAY_STORE_DELIVERY: 'shipping.freeNextDayStoreDelivery',
    BUY_AND_COLLECT: 'shipping.buyAndCollect',
    SHIP_TO_LOCKER: 'shipping.shipToLocker'
  },
  SHIPPING: {
    SHIP_TO_HOME: 'shipping.shipToHome',
    OVERNIGHT: 'shipping.overnightShipping',
    // testing multiple methods ....
    TWO_THREE_DAYS: 'shipping.twoThreeDaysShipping' // testing multiple methods ....
  }
};

// Shipping Type content mapping
var SHIPPING_TYPE_MAPPING = exports.SHIPPING_TYPE_MAPPING = {
  SHIPPING: 'shipping.shipHome',
  PICKUP: 'shipping.shipStore'
};

// 3DS - FPR
var availablePaymentExp = exports.availablePaymentExp = {
  REDIRECT: 'REDIRECT',
  IFRAME: 'IFRAME'
};
var channelType = exports.channelType = {
  MOBILE_APP: 'MOBILE_APP',
  WEB: 'WEB'
};

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/constants/errorHandlerConstants.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.validationErrorMap = exports.errorElementMap = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var loginRedirectUrl = (0, _squid.$getRedirectUrl)('hermes', {
  hermesLoginRedirect: 'xoon'
});

/* Please do not remove the double encoding component 'encodeURIComponent' */
var doubleEncodeUrl = function doubleEncodeUrl(url) {
  return encodeURIComponent(encodeURIComponent(url));
};
var loginPageUrl = doubleEncodeUrl((0, _squid.$getRedirectUrl)('hermes', {}));
var landingPageUrl = doubleEncodeUrl(_index.$util.buildURL(_index.$config.urls.fallbackUrl && _index.$config.urls.fallbackUrl['hermes'] || '/webapps/hermes', _index.$util.params()));
var authflowRedirectUrl = (0, _squid.$getRedirectUrl)('authflow', {});
authflowRedirectUrl = authflowRedirectUrl + "&loginUrl=" + loginPageUrl + "&redirectUri=" + landingPageUrl;

// TODO: should we have fields in a different constant
var errorElementMap = exports.errorElementMap = {
  INVALID_FIRST_NAME: {
    fields: [{
      field: 'user.first_name'
    }]
  },
  INVALID_LAST_NAME: {
    fields: [{
      field: 'user.last_name'
    }]
  },
  INVALID_PHONE_TYPE: {
    fields: [{
      field: 'phone.phoneType'
    }]
  },
  INVALID_PHONE_NUMBER: {
    fields: [{
      field: 'phone.telephone'
    }]
  },
  INVALID_CITY_STATE_ZIPCODE: {
    fields: [{
      field: 'address.city'
    }, {
      field: 'address.state'
    }, {
      field: 'zipCode'
    }]
  },
  INVALID_LINE1: {
    fields: [{
      field: 'address.line1'
    }]
  },
  INVALID_CITY: {
    fields: [{
      field: 'address.city'
    }]
  },
  INVALID_STATE: {
    fields: [{
      field: 'address.state'
    }]
  },
  INVALID_ZIPCODE: {
    fields: [{
      field: 'PostalCode'
    }, {
      field: 'address.postal_code'
    }],
    name: 'billing'
  },
  INVALID_NATIONAL_ID_TYPE: {
    element: '#nationalIdFields',
    fields: [{
      field: 'type'
    }],
    model: 'nationalIdModel.nationalId.'
  },
  INVALID_NATIONAL_ID: {
    element: '#nationalIdFields',
    fields: [{
      field: 'Value'
    }],
    name: 'id'
  },
  INVALID_SECONDARY_ID_TYPE: {
    element: '#nationalIdFields',
    fields: [{
      field: 'secondaryIdType'
    }],
    model: 'nationalIdModel.'
  },
  INVALID_SECONDARY_ID: {
    element: '#nationalIdFields',
    fields: [{
      field: 'secondaryIdValue'
    }],
    model: 'nationalIdModel.'
  },
  INVALID_BILLING_ADDRESS: {
    element: '#billingAddress',
    name: 'billing'
  },
  INVALID_SHIPPING_ADDRESS: {
    element: '#shippingAddress',
    name: 'shipping'
  },
  INVALID_EXPIRATION_DATE: {
    pageError: {
      contentKey: 'creditcard.errorExpiredCard'
    }
  },
  PASSWORD_TOO_LONG: {
    element: '#signupContainer',
    model: 'user.',
    fields: [{
      field: 'password'
    }, {
      field: 'confirmPassword'
    }]
  },
  PASSWORD_CONTAINS_FORBIDDEN_WORDS: {
    element: '#signupContainer',
    model: 'user.',
    fields: [{
      field: 'password'
    }, {
      field: 'confirmPassword'
    }]
  },
  PASSWORD_HAS_ILLEGAL_CHARACTERS: {
    element: '#signupContainer',
    model: 'user.',
    fields: [{
      field: 'password'
    }, {
      field: 'confirmPassword'
    }]
  },
  ACCOUNT_ALREADY_EXISTS: {
    fields: [{
      field: 'user.email'
    }],
    pageError: {
      contentKey: 'login.userMayHaveAccount',
      guestcontentKey: 'login.userMayHaveAccountGuest'
    },
    compileMessageWith: {
      href: loginRedirectUrl
    },
    scrollToTop: true
  },
  ACCOUNT_ALREADY_EXISTS_AUTHFLOW_REDIRECT: {
    fields: [{
      field: 'user.email'
    }],
    pageError: {
      contentKey: 'login.userMayHaveAccountRecovery'
    },
    compileMessageWith: {
      href: authflowRedirectUrl
    },
    scrollToTop: true
  },
  INVALID_EMAIL_ID: {
    fields: [{
      field: 'user.email'
    }]
  },
  DOB_INVALID: {
    element: '#dob, #dobBank',
    name: 'dob',
    fields: [{
      field: 'Day'
    }, {
      field: 'Month'
    }, {
      field: 'Year'
    }, {
      field: 'Text'
    }]
  },
  REJECT_REFUSED: {
    pageError: {
      contentKey: 'creditcard.errorInstrumentRefused'
    }
  },
  INVALID_INSTRUMENT_ID: {
    pageError: {
      contentKey: 'creditcard.errorInvalidData'
    }
  },
  ADDRESS_MISMATCH: {
    pageError: {
      contentKey: 'creditcard.errorInstrumentBillingAddressNotMatch'
    }
  },
  CHECK_DIGITS_REJECTED: {
    pageError: {
      contentKey: 'creditcard.errorCheckDigits'
    }
  },
  OAS_GENERIC_ERROR: {
    pageError: {
      contentKey: 'genericError.genericError'
    },
    scrollToTop: true
  },
  BIN_BLOCKED_OR_CARD_NOT_ALLOWED: {
    pageError: {
      contentKey: 'creditcard.complianceDecline'
    }
  },
  INVALID_CARD_OR_TYPE: {
    pageError: {
      contentKey: 'creditcard.errorInvalidCCNumberOrType_global'
    }
  },
  INVALID_SECURITY_CODE: {
    fields: [{
      field: 'card.security_code'
    }],
    pageError: {
      contentKey: 'creditcard.errorCheckDigitsNotPresent'
    }
  },
  COUNTRY_NOT_SUPPORTED: {
    pageError: {
      contentKey: 'creditcard.complianceDecline'
    }
  },
  CARD_GENERIC_ERROR: {
    pageError: {
      contentKey: 'creditcard.errorGeneral'
    }
  },
  BANK_GENERIC_ERROR: {
    pageError: {
      contentKey: 'bank.errorGeneral'
    }
  }
};

// TODO: this block needs to be depricated. looks like this is valid for a
// old service call which is killed already
var validationErrorMap = exports.validationErrorMap = {
  INVALID_ROUTING_NUMBER: {
    contentKey: 'bank.invalidRoutingNumber'
  },
  INVALID_ACCOUNT: {
    contentKey: 'creditcard.errorInvalidData'
  },
  ISSUER_DENIED: {
    contentKey: 'creditcard.errorIssuerDenied'
  },
  ISSUER_REJECTED: {
    contentKey: 'creditcard.errorIssuerReject'
  },
  REJECT_REFUSED: {
    contentKey: 'creditcard.errorInstrumentRefused'
  },
  INVALID_INSTRUMENT_ID: {
    contentKey: 'creditcard.errorInvalidData'
  }
};
_squid.$getRedirectUrl;
_index.$config;
_index.$util;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/constants/pxpExperimentConstants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports["default"] = void 0;
var singlepassword = {
  singlepassword_test: 'xoon_single_password_test'
};
var xoon_optional_signup_content_change = {
  GB: {
    subTitle: 'common.createPayPalPropTest1',
    yesCreateAccount: 'common.yesCreateAccount'
  }
};
var xoon_forced_signup_buyer_protection_content = {
  xoon_forced_signup_buyer_protection_content_treatment_a: {
    titleLine1: 'common.getSecurityAndProtectionLine1',
    titleLine2: 'common.getSecurityAndProtectionLine2',
    subTitle: 'common.getSecurityAndProtectionLineSubTitle'
  },
  xoon_forced_signup_buyer_protection_content_treatment_b: {
    titleLine1: 'common.getCashbackLine1',
    titleLine2: '',
    subTitle: 'common.getCashbackLineSubTitle'
  }
};
var _default = exports["default"] = {
  test: {
    singlepassword: singlepassword,
    xoon_optional_signup_content_change: xoon_optional_signup_content_change,
    xoon_forced_signup_buyer_protection_content: xoon_forced_signup_buyer_protection_content
  }
};
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/countryList/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/countryList/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('xoCountryList', {
  tag: 'xo-country-list',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    showMask: {
      type: 'var',
      required: false
    },
    // mode is not present in multistep, so it is set as not required
    mode: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve(),
        payee: _index2.$CheckoutPayeeModel.instance(this.token).retrieve(),
        checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.token).retrieve(),
        checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve()
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      // Default to 'signup' as multistep will not pass mode prop
      this.mode = this.mode || 'signup';
      this.skipMerchantLocale = true;
    },
    populate: function populate() {
      var _this = this;
      var proxSignUpFlow = this.models.checkoutInputData.isEbayTxn();
      this.contentKey = 'common.complianceRestricted';
      this.merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country');
      this.merchantComplianceRestricted = (0, _index.$feature)('merchantComplianceRestricted', false, this.merchantCountry);
      this.fallbackOnUnsupportedCountry = function (selectedCountry) {
        if (!(0, _index.$feature)('guest', false, selectedCountry) || (0, _index.$feature)('guestFallback', false, selectedCountry)) {
          throw new _index.$FallbackError({
            reason: 'other_country_selected_for_guest',
            product: 'ux'
          });
        }
      };
      this.fallbackOnUnsupportedCountry(_index.$locale.country);
      this.isMerchantCountrySameAsSelectedCountry = function (merchantCountry, selectedCountry) {
        var countriesWithMultipleCodes = {
          CN: ['CN', 'C2'],
          C2: ['CN', 'C2']
        };
        var merchantCountryList = countriesWithMultipleCodes[merchantCountry] || [merchantCountry];
        return merchantCountryList.indexOf(selectedCountry) > -1;
      };

      /**
       * This function will determine the country list will be shown to user:
       * 1. Get supported country list from griffin
       * 2. Filter out blocked countries configured in our app's config file
       * 3. Add default 'Country' option to the list if needed: ie. for merchant compliance restricted case
       */
      this.populateSupportedCountries = function () {
        _this.metadata = _angular["default"].copy(_index.$locale.metadata) || {};
        var _this$metadata$territ = _this.metadata.territory,
          territory = _this$metadata$territ === void 0 ? [] : _this$metadata$territ;
        var countries = proxSignUpFlow ? _index.$config.proxSupportedCountries : _index.$config.guestBlockedCountries || [];
        _this.supportedCountries = territory.filter(function (c) {
          if (c.code === _index.$locale.country) {
            _this.selectedCountryObj = c;
          }
          var inCountires = countries.includes(c.code);

          // When not in the prox signup flow we need to return the negated
          // inCountires since it is checking blocked countries, not allowed countries
          return proxSignUpFlow ? inCountires : !inCountires;
        });
        if (!proxSignUpFlow) {
          if (_this.merchantComplianceRestricted && _this.isMerchantCountrySameAsSelectedCountry(_this.merchantCountry, _this.selectedCountryObj.code)) {
            var defaultOption = {
              code: '',
              name: _index.$locale.content.common.country
            };
            _this.supportedCountries.push(defaultOption);
            _this.selectedCountryObj = defaultOption;
          }
          if (_this.merchantComplianceRestricted && _this.isMerchantCountrySameAsSelectedCountry(_this.merchantCountry, _index.$locale.country)) {
            _this.showMask = true;
          }
        }
      };
      this.populateSupportedCountries();

      // TODO: to be removed - currently locale change and metadata change is not in sync which need to be fixed.
      this.$on('metadataChange', function () {
        _this.populateSupportedCountries();
      });

      /*
       * merchants can block international PayPal accounts using the merchant setting Block payments from users
       * who have non-merchant country PayPal accounts, if resolved country is not merchant country, default to merchant country
       * and disable the country list
       */
      this.blockNonDomesticPayer = this.models.checkoutAppData.get('flags.block_non_domestic_payer') && (0, _index.$feature)('blockNonDomesticPayer', false, this.merchantCountry);
      this.disableCountryList = this.blockNonDomesticPayer || this.models.checkoutCart.isWalletTokenization();
      if (this.disableCountryList && this.merchantCountry !== _index.$locale.country) {
        _logger.$logger.info('merchant block_non_domestic_payer', {
          merchantCountry: this.merchantCountry,
          resolvedCountry: _index.$locale.country
        });
        this.actions.countryChanged(this.merchantCountry);
      }
    }
  },
  actions: {
    countryChanged: function countryChanged(selectedCountry) {
      var _this2 = this;
      var stateName = this.mode === 'signup' ? 'signup' : 'guest_xo';
      _logger.$logger.info('country_updated', {
        'to': selectedCountry,
        'from': _index.$locale.country
      });
      _logger.$logger.info('checkout_fpti', {
        from: stateName,
        to: 'prep_change_cntry',
        billing_country: _index.$locale.country,
        billing_country_changed: selectedCountry
      });
      this.selectedCountry = selectedCountry;
      this.fallbackOnUnsupportedCountry(selectedCountry);
      if (this.merchantComplianceRestricted) {
        this.showMask = false;
        this.showMessage = false;
        this.ariaDescribedBy = '';
        if (!selectedCountry) {
          this.showMask = true;
          return;
        } else if (this.isMerchantCountrySameAsSelectedCountry(this.merchantCountry, selectedCountry)) {
          if (this.merchantCountry === 'CN' || this.merchantCountry === 'C2') {
            this.contentKey = 'common.complianceCNRestricted';
          }
          this.showMask = true;
          this.showMessage = true;
          this.ariaDescribedBy = 'errorSignupAgree';
          return;
        }
      }
      var resolveLang = function resolveLang() {
        // merchat_locale will be set to the value sent in `LOCALECODE` set ec param.
        // sample value for LOCALECODE are en_US, fr_FR, etc...
        var merchantLocale = _this2.models.checkoutAppData.get('merchant.merchant_locale');
        merchantLocale = merchantLocale && _index.$localeHelper.normalizeLocale(merchantLocale).language;
        merchantLocale = merchantLocale && merchantLocale.toLowerCase();
        _logger.$logger.info("merchantLocale_from_appData_" + merchantLocale);
        // skipMerchantLocale will be true only incase of test treatment.
        if (_this2.skipMerchantLocale) {
          _logger.$logger.info("skipMerchantLocale_" + _this2.skipMerchantLocale);
          // set merchantLocale to undefined, so that defaultCountryLang takes priority.
          merchantLocale = undefined;
        }
        var supportedLocales = _index.$config.supportedCountries;
        var defaultLanguageException = _index.$config.defaultLanguageException;
        var defaultExceptionLang = defaultLanguageException[selectedCountry];
        var defaultCountryLang = supportedLocales[selectedCountry] && supportedLocales[selectedCountry][0];
        _logger.$logger.info("defaultCountryLang_" + defaultCountryLang);
        _logger.$logger.info("defaultExceptionLang_" + defaultExceptionLang);
        var selectedLang = defaultExceptionLang || defaultCountryLang;
        var resolvedLang = merchantLocale && supportedLocales[selectedCountry] && supportedLocales[selectedCountry].indexOf(merchantLocale) !== -1 ? merchantLocale : selectedLang;
        return resolvedLang;
      };
      if (_index.$locale.country !== this.selectedCountry) {
        // Make known the country has changed
        // Used in xoon to re-issue EPM call
        _index.$event.broadcast('countryChange');

        // Perform Language Resolution only when the country is changed, as below code does not consider locale.x merchant parameter
        _index.$locale.choose(this.selectedCountry, resolveLang(selectedCountry)).then(function () {
          _uiRouter.$state.go('checkout.landing');
        });
      }
    }
  }
});
_index.$Component;
_index.$FallbackError;
_index.$config;
_index.$event;
_index.$feature;
_index.$locale;
_index.$localeHelper;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutPayeeModel;
_index2.$CheckoutCartModel;
_index3.$CheckoutInputDataModel;
_logger.$logger;
_uiRouter.$state;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/countryList/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"countryList\" class=\"countryList dropdown confidential inputField\" ng-class=\"{'validated': showMessage}\"\n     ng-cloak content floating-label-dropdown>\n    <div id=\"blockNonDomesticPayer\" ng-if=\"blockNonDomesticPayer\" class=\"infoMsg errorMsgRuleSpecific\">\n        <span class=\"infoIcon\"></span>\n        <span>{{content('billing.blockNonDomesticPayer', {countryCode: selectedCountryObj.code})}}</span>\n    </div>\n    <div ng-class=\"{'showMask': disableCountryList}\">\n        <select xo-dropdown compliance-validation dropdown-text-bind-var=\"selectedCountryObj.name\"\n                ng-model=\"selectedCountryObj\" name=\"countryName\" id=\"countrySelector\"\n                ng-required=\"true\" ng-disabled=\"disableCountryList\"\n                ng-attr-aria-describedby=\"{{ariaDescribedBy}}\"\n                track-focus-and-blur=\"country\"\n                ng-options=\"country.name for country in supportedCountries track by country.code\"\n                ng-change=\"actions.countryChanged(selectedCountryObj.code)\">\n        </select>\n        <label for=\"countrySelector\" id=\"countryListLabel\">{{content('country.country')}}</label>\n    </div>\n\n    <div id=\"errorSignupAgree\" ng-if=\"showMessage\" class=\"errorMsg errorMsgRuleSpecific\">\n        {{content(contentKey, {merchantCountry: selectedCountryObj.name})}}\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-options/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/template.html"));
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/constants.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoCurrencyConversionLightbox', {
  tag: 'xo-currency-conversion-lightbox',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    doneFn: {
      type: 'var',
      required: false
    },
    prePlanTreatment: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
        checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.openModal = function () {
        _logger.$logger.info('OPENING_CURRENCY_CONVERSION_LIGHTBOX', {
          isBuyerFx: Boolean(_this.prePlanTreatment)
        });
        _this.modalOpen = true;
      };
      this.updateConversionSelection = function (selection) {
        _this.models.ppconversion = selection;
        _this.setSelectedCurrency(selection);
      };
      this.isBuyerFXTreatment2 = (this.prePlanTreatment || '').includes('treatment_2');
      this.isNotBuyerFXTreatment = !(this.prePlanTreatment || '').includes('treatment');

      // This function is used to set the this.currency property which
      // is used for the `Pay in {currency}` label for the Buyer FX flow
      this.setSelectedCurrency = function (currencySelection) {
        if (_this.isBuyerFXTreatment2) {
          _this.currency = currencySelection === 'PAYPAL' ? _this.fromCurrencyCode : _this.toCurrencyCode;
        }
      };
    },
    populate: function populate() {
      var _this2 = this;
      // Set default conversion choice to 'PAYPAL'
      this.models.ppconversion = 'PAYPAL';

      // Get conversion currency codes
      var conversion = this.models.checkoutSession.get('plan.conversion', {});
      this.fromCurrencyCode = conversion.from_code;
      this.toCurrencyCode = conversion.to_code;
      this.conversionSpread = conversion.spread;

      // We don't want to log Buyer FX information to FPTI
      // for countries not included in the PXP
      if (this.prePlanTreatment) {
        /**
         * FPTI event #5 for Buyer FX guest experience
         * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
         * Buyer FX logging requires some extra information beyond what
         * we log for the PILOT/ROW/EMEA DCC experience
         */
        _logger.$logger.info('checkout_fpti', {
          from: 'CURRENCY_CONVERSION',
          to: 'prepare_currency_conversion_post_plan',
          conversion_type: 'PAYPAL',
          // Default selection
          is_conversion_shown: 1,
          currency_conversion_from_curr: this.fromCurrencyCode,
          currency_conversion_to_curr: this.toCurrencyCode,
          currency_conversion_spread: this.conversionSpread
        });
      }

      // Set content for Buyer FX (prePlanTreatment)
      this.setSelectedCurrency('PAYPAL');
      this.continueButton = "common.pay" + (this.isBuyerFXTreatment2 ? 'InCurrency' : '') + "Label";
      this.buyerFxHeader = this.prePlanTreatment === 'xo_xoon_dcc_popup_content_treatment_1' ? 'currencyOptions.bfxConversionHeaderRateInterstitial' : 'currencyOptions.bfxConversionHeaderCurrency';

      /**
       * Invoicing RegE compliance message has to be shown if Remittance Transfer Rule (RTR) applies.
       * It applies for US payers paying non US merchants an amount greater than $15 USD or the
       * equivalent in a foreign currency.
       */
      var isInvoicingFlow = this.models.checkoutAppData.get('flags.is_invoice_flow') === true;
      var amount = this.models.checkoutSession.get('plan.sources.0.amount.amount');
      var isRTRAmount = Number(amount) > _constants.RTR_AMOUNT;
      if (isInvoicingFlow) {
        var isUSBuyer = _squid.$locale.country === 'US';
        this.merchant = this.models.checkoutAppData.get('merchant');
        this.showInvoicingRegEMsg = isUSBuyer && isRTRAmount && _squid.$util.getProperty(this.merchant, 'merchant_country') !== 'US';

        // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
        // then we need the value of merchantDisplayName to be 'the merchant' as it is the middle of sentence
        // in currencyOptions.invoicingRegEMsg displayed in template
        this.nonEmptyMerchantDisplayName = this.models.checkoutAppData.getMerchantDisplayName({
          nonEmptyReturnValue: true
        });
      }
      /**
       * End Reg-E logic
       */

      this.closeModal = function (event) {
        if (event && event.preventDefault) {
          event.preventDefault();
        }
        _this2.modalOpen = false;

        // Hook css transition completion event 'transitionend'
        // to call onComplete function, guarentees best timing
        var containerEl = document.getElementById('conversionContainer');
        var onComplete = _squid.$util.once(function () {
          _logger.$logger.info('close_currency_conversion_lightbox');
          return _this2.props.doneFn();
        });
        containerEl.addEventListener('transitionend', onComplete);

        // If the browser doesn't support `transitionend` event callback
        // then we call onComplete after 350ms as fallback
        (0, _angular.$timeout)(onComplete, 350);
      };

      /**
       * FPTI event 7 for Buyer FX DCC - POST-PLAN
       * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
       */
      this.logFinalSelectionToFPTI = function () {
        _logger.$logger.info('checkout_fpti', {
          from: 'CURRENCY_CONVERSION',
          to: 'finalize_currency_conversion',
          currency_conversion_selected: _this2.models.ppconversion,
          currency_conversion_from_curr: _this2.fromCurrencyCode,
          currency_conversion_to_curr: _this2.toCurrencyCode,
          currency_conversion_spread: _this2.conversionSpread
        });
      };
    }
  },
  actions: {
    onSubmit: function onSubmit() {
      var _this3 = this;
      if (!this.models.ppconversion) {
        _logger.$logger.info('CURRENCY_CONVERSION_SUBMITTED_WITHOUT_SELECTION');
        this.message = {
          msgKeys: ['currencyOptions.noneSelected'],
          type: 'error'
        };
        return;
      }

      /*
       * This check cuts off flow to the 'updateConversion' service call
       * when the user has selected 'PAYPAL' for conversion. This is done
       * because the conversion is already set to 'PAYPAL' on the plan so
       * we do not need to make a patch call to update the conversion selection.
       */
      if (this.models.ppconversion === 'PAYPAL') {
        // We don't want to log Buyer FX information to FPTI
        // for countries not incldued in the PXP
        if (this.prePlanTreatment) {
          this.logFinalSelectionToFPTI();
        }
        this.closeModal({
          complete: true
        });
        return;
      }

      /**
       * If conversion is not 'PAYPAL' then we need to patch the cart to set the
       * conversion type to vendor.
       */
      var data = {
        conversionType: this.models.ppconversion,
        planId: this.models.checkoutSession.get('plan.id')
      };
      if (data.planId) {
        var setErrorMessage = function setErrorMessage() {
          _logger.$logger.info('POST_PLAN_CONVERSION_ERROR');
          _this3.message = {
            msgKeys: ['genericError.genericError'],
            type: 'error'
          };
        };
        this.models.checkoutSession.fundingOptions.action('updateConversion', {
          data: data,
          success: function success() {
            // We don't want to log Buyer FX information to FPTI
            // for countries not incldued in the PXP
            if (_this3.prePlanTreatment) {
              _this3.logFinalSelectionToFPTI();
            }
            _this3.closeModal({
              complete: true
            });
          },
          error: setErrorMessage,
          contingency: setErrorMessage
        });
      }
    }
  }
});
_index.$CheckoutSessionModel;
_index.$CheckoutAppDataModel;
_squid.$Component;
_squid.$locale;
_squid.$util;
_logger.$logger;
_angular.$timeout;
_constants.RTR_AMOUNT;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"conversionSection\">\n    <div class=\"conversion\"\n        id=\"conversionContainer\"\n        ng-class=\"{modalClose: !modalOpen, modalOpen: modalOpen}\">\n\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper modalWrapperAnimation\"\n            focus-when=\"modalOpen\"\n            modal-box>\n\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <xo-message message=\"message\"></xo-message>\n\n                <form method=\"post\"\n                    class=\"curr_conv asideProceed formSmall\"\n                    novalidate=\"novalidate\"\n                    ng-submit=\"actions.onSubmit()\"\n                    content>\n\n                    <xo-currency-conversion-lightbox-options\n                        token=\"token\"\n                        update-conversion-selection=\"updateConversionSelection\"\n                        open-modal=\"openModal\"\n                        is-buyer-fx-pxp=\"prePlanTreatment\"\n                        ng-if=\"isNotBuyerFXTreatment\">\n                    </xo-currency-conversion-lightbox-options>\n\n                    <div ng-if=\"!isNotBuyerFXTreatment\">\n                        <h2 class=\"buyer-fx-interstitial-header\">{{ content(buyerFxHeader) }}</h2>\n                        <xo-currency-conversion-options\n                            token=\"token\"\n                            treatment=\"prePlanTreatment\"\n                            update-conversion-selection=\"updateConversionSelection\"\n                            open-modal=\"openModal\">\n                        </xo-currency-conversion-options>\n                    </div>\n\n                    <div class=\"invRegE\" ng-if=\"showInvoicingRegEMsg\">\n                        {{\n                            content(\n                                'currencyOptions.invoicingRegEMsg',\n                                {\n                                    merchantName: nonEmptyMerchantDisplayName,\n                                    amountInInvoiceCurrency: merchantTotal\n                                }\n                            )\n                        }}\n                    </div>\n\n                    <div class=\"buttons\">\n                        <input\n                            id=\"proceedButton\"\n                            type=\"submit\"\n                            value=\"{{ content(continueButton, { currency: currency }) }}\"\n                            class=\"btn full\">\n                    </div>\n\n                </form>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/inlineCurrencyConversion/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/inlineCurrencyConversion/template.html"));
__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-options/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoInlineCurrencyConversion', {
  tag: 'xo-inline-currency-conversion',
  template: _template["default"],
  props: {
    card: {
      type: 'var',
      required: false
    },
    token: {
      type: 'var',
      required: false
    },
    treatment: {
      type: 'var',
      required: false
    },
    showInvoicingRegEMsg: {
      type: 'var',
      required: false
    },
    nonEmptyMerchantDisplayName: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    populate: function populate() {
      var isRate = (this.treatment || '').includes('treatment_1');
      var headerType = isRate ? 'RateInline' : 'Currency';
      this.conversionTitle = "currencyOptions.bfxConversionHeader" + headerType;
    }
  }
});
_squid.$Component;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/inlineCurrencyConversion/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"currency-conversion-container\" content>\n    <h2 class=\"sectionTitle currency-conversion-title\"\n        data-test-id=\"inline-conversion-header\">\n        {{ content(conversionTitle) }}\n    </h2>\n\n    <xo-currency-conversion-options\n        card=\"card\"\n        token=\"token\"\n        treatment=\"treatment\"\n        show-invoicing-reg-e-msg=\"showInvoicingRegEMsg\"\n        non-empty-merchant-display-name=\"nonEmptyMerchantDisplayName\"\n        is-pre-plan=\"true\">\n    </xo-currency-conversion-options>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/contentUtils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getVendorRateLabel = exports.getPPRateLabel = exports.getDccVendorTotal = exports.getDccVendorExchange = exports.getDccTitle = exports.getDccPPTotal = exports.getDccPPRate = exports.getDccPPExchange = exports.getCurrencyTo = exports.getCurrencyFrom = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
/* eslint-disable no-arrow-condition, no-confusing-arrow */

var getDccTitle = exports.getDccTitle = function getDccTitle(isCountryUS) {
  return isCountryUS ? 'currencyOptions.dccTitleTreatment2' : 'currencyOptions.dccTitle';
};
var getPPRateLabel = exports.getPPRateLabel = function getPPRateLabel(isCountryUS) {
  return isCountryUS ? 'currencyOptions.dccPPDescTreatment1' : 'currencyOptions.dccPPDesc';
};
var getVendorRateLabel = exports.getVendorRateLabel = function getVendorRateLabel(isCountryUS) {
  return isCountryUS ? 'currencyOptions.dccVendorDescTreatment1' : 'currencyOptions.dccVendorDesc';
};
var getDccPPRate = exports.getDccPPRate = function getDccPPRate(isCountryUS, isEMEA3PLCountry) {
  return isCountryUS ? 'currencyOptions.dccPPRateTreatment1' : "currencyOptions.dccPPRate" + (isEMEA3PLCountry ? '3PL' : '');
};
var getDccVendorTotal = exports.getDccVendorTotal = function getDccVendorTotal(isCountryUS) {
  return isCountryUS ? 'currencyOptions.dccVendorTotalTreatment1' : 'currencyOptions.dccVendorTotal';
};
var getDccPPTotal = exports.getDccPPTotal = function getDccPPTotal(isCountryUS) {
  return isCountryUS ? 'currencyOptions.dccPPTotalTreatment1' : 'currencyOptions.dccPPTotal';
};
var getDccPPExchange = exports.getDccPPExchange = function getDccPPExchange(isCountryUS) {
  return isCountryUS ? 'currencyOptions.dccPPExchangeTreatment1' : 'currencyOptions.dccPPExchange';
};
var getDccVendorExchange = exports.getDccVendorExchange = function getDccVendorExchange(isCountryUS) {
  return isCountryUS ? 'currencyOptions.dccVendorExchangeTreatment1' : 'currencyOptions.dccVendorExchange';
};
var getCurrencyTo = exports.getCurrencyTo = function getCurrencyTo(isCountryUS, conversion) {
  if (isCountryUS) {
    return conversion.to_amount_forex;
  }
  return (0, _squid.truncateCurrencyConversionString)({
    fullString: conversion.to,
    amount: conversion.to_amount,
    amountForex: conversion.to_amount_forex
  });
};
var getCurrencyFrom = exports.getCurrencyFrom = function getCurrencyFrom(isCountryUS, conversion) {
  if (isCountryUS) {
    return '1';
  }
  return (0, _squid.truncateCurrencyConversionString)({
    fullString: conversion.from,
    amount: conversion.from_amount,
    amountForex: conversion.from_amount_forex
  });
};
_squid.truncateCurrencyConversionString;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _contentUtils = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/contentUtils.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoCurrencyConversionLightboxOptions', {
  tag: 'xo-currency-conversion-lightbox-options',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    openModal: {
      type: 'var',
      required: false
    },
    updateConversionSelection: {
      type: 'var',
      required: false
    },
    isBuyerFxPxp: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve(),
        checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
      };
    }
  },
  lifecycle: {
    populate: function populate() {
      // Set conversion information
      this.conversionOptions = _squid.$config.currencyConversion.options;
      this.models.ppconversion = this.conversionOptions.PAYPAL;
      this.conversion = this.models.checkoutSession.get('plan.conversion');
      this.paypalConversionTotal = this.models.checkoutSession.get('plan.sources.0.amount.amount_formatted_currency');
      var unformattedAmount = this.models.checkoutCart.get('purchase.amounts.total.amount');
      var merchantCurrencyCode = this.models.checkoutCart.get('purchase.amounts.total.currency_code');
      this.merchantTotal = (0, _squid.formatCurrency)(unformattedAmount, merchantCurrencyCode, false);
      var isEMEA3PLCountry = _squid.$util.getProperty(_squid.$locale.metadata, 'localization.isEMEA3PLCountry', {
        "default": false
      });

      // Content for non Buyer FX phase 2 is different for the US.
      // The US uses content from Buyer FX phase 1 as the control.
      var isCountryUS = _squid.$locale.country === 'US';

      // Get content keys
      this.dccTitle = (0, _contentUtils.getDccTitle)(isCountryUS);
      this.ppRateLabel = (0, _contentUtils.getPPRateLabel)(isCountryUS);
      this.dccPPRate = (0, _contentUtils.getDccPPRate)(isCountryUS, isEMEA3PLCountry);
      this.vendorRateLabel = (0, _contentUtils.getVendorRateLabel)(isCountryUS);
      this.dccPPTotal = (0, _contentUtils.getDccPPTotal)(isCountryUS);
      this.dccPPExchange = (0, _contentUtils.getDccPPExchange)(isCountryUS);
      this.dccPPExchangeOptions = {
        buyerCurrency: this.conversion.from_code,
        currencyFrom: (0, _contentUtils.getCurrencyFrom)(isCountryUS, this.conversion),
        currencyTo: (0, _contentUtils.getCurrencyTo)(isCountryUS, this.conversion),
        sellerCurrency: this.conversion.to_code
      };
      this.dccVendorExchange = (0, _contentUtils.getDccVendorExchange)(isCountryUS);

      // LATAM countries have unique disclosure requirements for vendor option
      this.dccVendorTotal = (0, _contentUtils.getDccVendorTotal)(isCountryUS);

      // Open the interstitial
      this.openModal();
    }
  },
  actions: {
    onConversionOptionChange: function onConversionOptionChange() {
      // For post-plan conversion we need to update the chosen conversion
      // selection in the guest currency conversion interstitial component
      this.updateConversionSelection(this.models.ppconversion);

      // We don't want to log Buyer FX information to FPTI
      // for countries not incldued in the PXP
      if (this.isBuyerFxPxp) {
        /**
         * FPTI event #4 & #6 for Buyer FX guest experience
         * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
         */
        _logger.$logger.info('checkout_fpti', {
          from: 'CURRENCY_CONVERSION',
          to: 'changed_currency_conversion_post_plan',
          currency_conversion_selected: this.models.ppconversion,
          currency_conversion_from_curr: this.conversion.from_code,
          currency_conversion_to_curr: this.conversion.to_code,
          currency_conversion_spread: this.conversion.spread
        });
      }
    }
  }
});
_squid.$Component;
_squid.$locale;
_squid.formatCurrency;
_squid.$util;
_squid.$config;
_index.$CheckoutSessionModel;
_index.$CheckoutCartModel;
_logger.$logger;
_contentUtils.getDccTitle;
_contentUtils.getPPRateLabel;
_contentUtils.getVendorRateLabel;
_contentUtils.getDccPPRate;
_contentUtils.getDccVendorTotal;
_contentUtils.getDccPPTotal;
_contentUtils.getDccPPExchange;
_contentUtils.getDccVendorExchange;
_contentUtils.getCurrencyTo;
_contentUtils.getCurrencyFrom;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/postPlanInterstitialOptions/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <h1 class=\"alpha\" data-test-id=\"conversion-title\">{{ content(dccTitle) }}</h1>\n\n    <ul class=\"conversionOptions\">\n        <p class=\"merchantPrice\"\n            ng-bind-html=\"htmlContent('currencyOptions.merchPrice', {transactionTotal: merchantTotal})\">\n        </p>\n        <li class=\"conversionOption\">\n            <div class=\"radioButton\">\n                <input\n                    type=\"radio\"\n                    ng-model=\"models.ppconversion\"\n                    name=\"ppconversion\"\n                    id=\"conversionPayPal\"\n                    ng-change=\"actions.onConversionOptionChange()\"\n                    value=\"{{conversionOptions.PAYPAL}}\"/>\n                <label\n                    for=\"conversionPayPal\"\n                    data-test-id=\"conversion-paypal-label\">\n                    {{ content(ppRateLabel, { buyerCurrency: conversion.from_code }) }}\n                </label>\n            </div>\n            <ul data-test-id=\"conversion-paypal-disclaimers\">\n                <li class=\"dccDetails\"\n                    ng-bind-html=\"htmlContent(dccPPExchange, dccPPExchangeOptions)\">\n                </li>\n                <li class=\"conversionDate\" ng-if=\"isPrePlanVal\">\n                    {{ content('currencyOptions.conversionDate', {date: conversion.date}) }}\n                </li>\n                <li class=\"spread\"\n                    ng-bind-html=\"htmlContent(dccPPRate, {rate: conversion.spread})\">\n                </li>\n                <li class=\"ppConversionTotal\"\n                    ng-bind-html=\"htmlContent(dccPPTotal, {total: paypalConversionTotal})\">\n                </li>\n            </ul>\n        </li>\n        <li class=\"conversionOption\">\n            <div class=\"radioButton\">\n                <input\n                    type=\"radio\"\n                    ng-model=\"models.ppconversion\"\n                    name=\"ppconversion\"\n                    id=\"conversionVendor\"\n                    ng-change=\"actions.onConversionOptionChange()\"\n                    value=\"{{conversionOptions.VENDOR}}\"/>\n                <label\n                    for=\"conversionVendor\"\n                    data-test-id=\"conversion-vendor-label\">\n                    {{ content(vendorRateLabel, { sellerCurrency: conversion.to_code }) }}\n                </label>\n            </div>\n            <ul data-test-id=\"conversion-vendor-disclaimers\">\n                <li class=\"dccDetails\"\n                    ng-if=\"!showLATAMDisclosure\"\n                    ng-bind-html=\"htmlContent(dccVendorExchange)\">\n                </li>\n                <li class=\"dccDetails\" ng-if=\"showLATAMDisclosure\">\n                    <b>{{ content('currencyOptions.exchangeRate') }}</b> {{ content('currencyOptions.dccVendorRateNonVisa') }}\n                </li>\n                <li class=\"ppConversionTotal\" ng-bind-html=\"htmlContent(dccVendorTotal)\"></li>\n            </ul>\n        </li>\n        <li class=\"nonVisaDCCTaxDisclosureLATAM\" ng-if=\"showLATAMDisclosure\">\n            {{ content('currencyOptions.dccCommonRateNonVisa') }}\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/currencyConversion/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.logBuyerFxFptiEvent7 = exports.logBuyerFxFptiEvent3 = exports.logBuyerFxFpti = exports.isConversionChangeableForCardType = exports.getForcedVendorCards = exports.getForcedPayPalCards = void 0;
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var getFromCode = function getFromCode() {
  return _squid.$util.getProperty(_squid.$locale, 'metadata.currency.code');
};
var getToCode = function getToCode(purchase) {
  return _squid.$util.getProperty(purchase, 'amounts.total.currency_code');
};
var getForcedCards = function getForcedCards(type) {
  return _squid.$util.getProperty(_squid.$config, "currencyConversion.cards.forced" + type, {
    "default": []
  });
};
var getForcedPayPalCards = exports.getForcedPayPalCards = function getForcedPayPalCards() {
  return getForcedCards('PayPal');
};
var getForcedVendorCards = exports.getForcedVendorCards = function getForcedVendorCards() {
  return getForcedCards('Vendor');
};
var isConversionChangeableForCardType = exports.isConversionChangeableForCardType = function isConversionChangeableForCardType(type) {
  return ![].concat(getForcedPayPalCards(), getForcedVendorCards()).includes(type);
};

/**
 * FPTI event #3 for Buyer FX guest experience
 * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
 */
var logBuyerFxFptiEvent3 = exports.logBuyerFxFptiEvent3 = function logBuyerFxFptiEvent3(purchase) {
  _logger.$logger.info('checkout_fpti', {
    from: 'CURRENCY_CONVERSION',
    to: 'prepare_currency_conversion_post_plan',
    conversion_type: 'VENDOR',
    is_conversion_shown: 0,
    // 0 b/c we won't be showing conversion options
    currency_conversion_from_curr: getFromCode(),
    currency_conversion_to_curr: getToCode(purchase),
    currency_conversion_spread: 'N/A',
    locale: _squid.$locale.country
  });
};

/**
 * FPTI event 7 for Buyer FX DCC - PRE-PLAN MULTISTEP
 * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
 */
var logBuyerFxFptiEvent7 = exports.logBuyerFxFptiEvent7 = function logBuyerFxFptiEvent7(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$card = _ref.card,
    card = _ref$card === void 0 ? {} : _ref$card,
    isConversionChangeable = _ref.isConversionChangeable,
    isSignup = _ref.isSignup,
    hasPrePlanData = _ref.hasPrePlanData,
    purchase = _ref.purchase;
  var _card$currencyConvDat = card.currencyConvData,
    _card$currencyConvDat2 = _card$currencyConvDat === void 0 ? {} : _card$currencyConvDat,
    from_code = _card$currencyConvDat2.from_code,
    to_code = _card$currencyConvDat2.to_code,
    spread = _card$currencyConvDat2.spread,
    type = card.type;

  /**
   * We initially set the selection to `card.ppconversion`, which is the choice
   * the user selected when they were shown the conversion options. There are
   * two scenarios we need to adjust for, which are handled by the conditional
   * statement below.
   */
  var selection = card.ppconversion;

  /**
   * Adjustment scenario 1
   * Conversion is changeable, mode is `signup` and we don't have pre-plan data
   * In this case we force the vendor rate and forgo the conversion fee so that
   * there is as little friction as possible for a user that is in the process of
   * signing up.
   */
  if (isConversionChangeable && isSignup && !hasPrePlanData) {
    selection = 'VENDOR';

    /**
     * Adjustment scenario 2
     * If conversion is not changeable we need to check if the card type should be
     * forced to the PayPal conversion rate. If not, use vendor
     */
  } else if (!isConversionChangeable) {
    selection = getForcedPayPalCards().includes(type) ? 'PAYPAL' : 'VENDOR';
  }
  _logger.$logger.info('checkout_fpti', {
    from: 'CURRENCY_CONVERSION',
    to: 'finalize_currency_conversion',
    currency_conversion_selected: selection,
    currency_conversion_from_curr: from_code || getFromCode(),
    currency_conversion_to_curr: to_code || getToCode(purchase),
    currency_conversion_spread: spread || 'N/A'
  });
};
var logBuyerFxFpti = exports.logBuyerFxFpti = function logBuyerFxFpti(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    hasPrePlanData = _ref2.hasPrePlanData,
    isSignup = _ref2.isSignup,
    _ref2$card = _ref2.card,
    card = _ref2$card === void 0 ? {} : _ref2$card,
    purchase = _ref2.purchase;
  var type = card.type;
  var isConversionChangeable = isConversionChangeableForCardType(type);

  /**
   * If we don't have pre-plan data because the pre-plan API failed or becuse
   * the user is seeing the control and not one of the treatments and
   * the mode is signup and the card the chageable then we need to log event
   * 3 here. This is because for signup use cases the user won't see the
   * post-plan interstitial which is where event 3 is logged when the pre-plan
   * API fails or when the user is seeing the control experience for the guest
   * use case.
   */
  if (!hasPrePlanData && isSignup && isConversionChangeable) {
    logBuyerFxFptiEvent3(purchase);
  }
  if (isSignup || hasPrePlanData || !isConversionChangeable) {
    logBuyerFxFptiEvent7({
      card: card,
      isConversionChangeable: isConversionChangeable,
      isSignup: isSignup,
      hasPrePlanData: hasPrePlanData,
      purchase: purchase
    });
  }
};
_logger.$logger;
_squid.$config;
_squid.$locale;
_squid.$util;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _ul = __webpack_require__("../node_modules/xo-login-components/src/unified-login/ul.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _subscription = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");
var _index5 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");
var _index6 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var _index7 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _index8 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _index9 = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");
var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");
var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");
var _util2 = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");
var errorHandlerHelper = _interopRequireWildcard(__webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js"));
var _shippingChangeFeature = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/shippingChangeFeature.js");
var _pageProps = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/pageProps.js");
var _util3 = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/util.js");
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/constants.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/template.html"));
var _index0 = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");
var _address = __webpack_require__("../node_modules/xo-models/src/address/index.js");
var _index1 = __webpack_require__("../node_modules/xo-models/src/consent/index.js");
var _helper = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/lib/helper.js");
var _xoShippingOptions = __webpack_require__("../node_modules/xo-shipping-options/src/index.js");
var _shippingOptionsFeature = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/shippingOptionsFeature.js");
__webpack_require__("../node_modules/xo-guest-components/src/phone-confirmation-interstitial/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/currencyConversionInterstitial/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/inlineCurrencyConversion/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/countryList/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/passwordInput/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/sepa/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/cartChanged/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/travelRuleLightbox/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/tesla-add-bank/directive.js");
__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");
__webpack_require__("../node_modules/xo-address-components/src/address-normalization/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/select-shipping-country/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/3ds/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/ul-iframe/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/three-ds/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/ba-message-banner/directive.js");
var _guestFactory = __webpack_require__("../node_modules/xo-guest-components/src/lib/guestFactory.js");
__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var _default = exports["default"] = _index.$Component.extend('xoOnboardPayment', {
  tag: 'xo-onboard-payment',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    mode: {
      type: 'var',
      required: false
    },
    isUnbranded: {
      type: 'var',
      required: false
    },
    paymentMethod: {
      type: 'var',
      required: false
    },
    singleStepModel: {
      type: 'var',
      required: false
    },
    buttonParams: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        payee: _index2.$CheckoutPayeeModel.instance(this.props.token).retrieve(),
        checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
        checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve(),
        checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve()
      };
    },
    shippingRule: function shippingRule(resolvers) {
      var _this = this;
      return resolvers.models.then(function (models) {
        if (models.checkoutAppData.is_snt_supported()) {
          return {
            profileRulesSummary: _index4.$ShippingRuleSummaryModel.instance(_this.token).retrieve({
              params: {
                merchant_id: models.payee.merchant.id,
                currency_code: models.checkoutCart.purchase.amounts.total.currency_code
              }
            })
          };
        }
      });
    },
    merchantPreferences: function merchantPreferences(resolvers) {
      return resolvers.models.then(function (models) {
        return {
          model: _index0.$MerchantPreferenceModel.instance(models.payee.merchant.id).retrieve()
        };
      });
    },
    isRestRpMigratedFlow: function isRestRpMigratedFlow(resolvers) {
      var _this2 = this;
      return resolvers.models.then(function (models) {
        if (models.checkoutCart.isSubscriptionsV1()) {
          return _subscription.$SubscriptionsV1Model.instance(models.checkoutCart.getBaToken()).retrieve().then(function (subscriptionV1Data) {
            var billingAgreementCart = subscriptionV1Data && subscriptionV1Data.billingAgreementCart;
            _this2.flags.isRestRpMigratedFlow = billingAgreementCart && billingAgreementCart.client_configuration && billingAgreementCart.client_configuration.api === 'RECURRING_PAYMENTS_V1' || false;
          });
        }
      });
    },
    indiaWhitelistPxp: function indiaWhitelistPxp(resolvers) {
      var _this3 = this;
      return resolvers.models.then(function (models) {
        // show address less on-boarding experience only for EC IN whitelisted merchants.
        var eligible = !models.checkoutAppData.is_wps_flow() && !models.checkoutInputData.isEbayTxn() && !models.checkoutAppData.isInvoiceFlow() && !models.checkoutAppData.is_wps_subscription_flow() && !models.checkoutAppData.isWpsAutobillingFlow() && !models.checkoutAppData.is_wps_installmentplan_flow() && !models.checkoutCart.isWalletTokenization();
        if (_index.$locale.country === 'IN' && eligible) {
          var _ref = models.payee || {},
            _ref$merchant = _ref.merchant,
            _ref$merchant2 = _ref$merchant === void 0 ? {} : _ref$merchant,
            id = _ref$merchant2.id;
          return (0, _squid.$elmo)('xo_xoon_addressless_in_whitelist', {
            'uid': id
          }, '(xo_xoon_addressless_in_whitelist_)(.*)').then(function (result) {
            if (result && result.treatment_name.includes('xo_xoon_addressless_in_whitelist_test')) {
              // Hide Billing Address and DOB fields when merchant is whitelisted
              _this3.flags.whiteListedIndiaMerchant = true;
              _logger.$logger.info('test_whitelisted_india_merchant');
            } else {
              return (0, _squid.$elmo)('xo_xoon_addressless_in_ramp', {
                'ctx.MID': id
              }, '(xo_xoon_addressless_in_ramp_)(.*)').then(function (rampResult) {
                if (rampResult && rampResult.treatment_name.includes('xo_xoon_addressless_in_ramp_test')) {
                  // Hide Billing Address and DOB fields when merchant is whitelisted
                  _this3.flags.whiteListedIndiaMerchant = true;
                  _logger.$logger.info('test_ramped_india_merchant');
                }
              });
            }
          });
        }
      });
    },
    bypassAuthExperience: function bypassAuthExperience(resolvers) {
      var _this4 = this;
      if (this.mode === 'guest' || this.mode === 'guestonly') {
        return resolvers.models.then(function (models) {
          var country = ['US', 'CB', 'GB'];
          var mode = _this4.mode;
          var flow = models.checkoutAppData.is_wps_flow() ? 'wps' : 'ec';
          if (country.includes(_index.$locale.country)) {
            _this4.flags.bypass_address_verification = true;
            _logger.$logger.info(flow + "_" + mode + "_bypass_address_verification");
          }
        });
      }
    },
    phoneConfirmationExp: function phoneConfirmationExp() {
      var _this5 = this;
      // TODO: Having the complete string Trmt_xo_xoon_phone_confirmation
      // for regex check, as we saw a bug where skip_avs treatment
      // was returned to this elmo call. need to debug why this happened
      // How to reproduce - ramp down phone_confirmation elmo to 0% Trmt
      // and try hitting US forced signup multiple times on private window
      return (0, _squid.$elmo)('xo_xoon_phone_confirmation', {
        'ctx.COUNTRY': _index.$locale.country
      }, '(Trmt_xo_xoon_phone_confirmation)(.*)').then(function (result) {
        if (result) {
          _logger.$logger.info('phoneConfirmationExp_Treatment');
          _this5.flags.isphoneConfirmationExpTreatment = true;
        }
      });
    },
    residentialAddressExp: function residentialAddressExp() {
      var _this6 = this;
      return (0, _squid.$elmo)('xo_xoon_residential_address', {
        'ctx.COUNTRY': _index.$locale.country
      }, 'Trmt_FEATURE_RESIDENTIAL_ADDRESS_LEGACY').then(function (result) {
        if (result) {
          var enabledTreatment = Boolean(result && result.treatment_name);
          _logger.$logger.info('checkout_fpti', {
            'residential_address_treatment': String(enabledTreatment)
          });
          _this6.residentialAddress.hasResidentialAddress = enabledTreatment;
          _this6.onboard.residential_address_present = enabledTreatment;
        }
      });
    },
    suppressBankFundedGuestPaymentsExp: function suppressBankFundedGuestPaymentsExp() {
      var _this7 = this;
      return (0, _squid.$elmo)('xo_xoon_suppress_bank_payments', {
        'ctx.COUNTRY': _index.$locale.country
      }, 'Trmt_feature_suppress_bank_payments_legacy').then(function (result) {
        if (result) {
          _logger.$logger.info('suppressBankFundedGuestPayments_Treatment');
          _this7.flags.suppressBankFundedGuestPayments = true;
        }
      });
    },
    gatherActiveConsentExp: function gatherActiveConsentExp() {
      var _this8 = this;
      var setUserAgreementLinkAndVersion = function setUserAgreementLinkAndVersion(consentModel) {
        _this8.userAgreementLink = consentModel.getActiveUrl();
        _this8.userAgreement = {
          majorVersion: consentModel.getMajorVersion(),
          minorVersion: consentModel.getMinorVersion()
        };
      };
      return _helper.signupLib.getGatherActiveConsentExp(_index.$locale.country).then(function (elmoResult) {
        if (elmoResult) {
          return _index1.$UserAgreementConsentModel.instance(_this8.token).retrieve(_helper.signupLib.getNoticeAndConsentUserAgreementParameters()).then(function (consentData) {
            if (consentData) {
              _this8.flags.isGatherActiveConsentEnabled = true;
              setUserAgreementLinkAndVersion(consentData);
              _logger.$logger.info('gatherActiveConsentData_fetched', {
                url: consentData.getActiveUrl(),
                majorVersion: consentData.getMajorVersion(),
                minorVersion: consentData.getMinorVersion()
              });
            }
          })["catch"](function (err) {
            _logger.$logger.error('gatherActiveConsent_error', err);
          });
        }
      });
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this9 = this;
      this.locale = _index.$locale;
      this.currentState = _uiRouter.$state.current.name;
      this.ulMeta = {
        mkey: '',
        trmt: ''
      };
      this.flags = {
        shipToBilling: true,
        allowEditShipping: true,
        showSingleAddress: false,
        showShippingLabel: true,
        cupDetected: false,
        hideShippingAddress: false,
        allowPayWithSnT: false,
        allowSnTCall: true,
        instantUpdateShippingRegionSupported: true,
        showRedirectWarningPrompt: false,
        titleSubtitlePxpTreatment: false,
        showCartChanged: false,
        whiteListedIndiaMerchant: false,
        upopDetected: false,
        bypass_address_verification: false,
        bypass_authorization: false,
        shippingAddressPresentFromCart: false,
        billingAddressPresentFromCart: false,
        launchUlIframe: false,
        phoneConfirmed: false,
        showPhoneConfirmationPopup: false,
        isphoneConfirmationExpTreatment: false,
        isRestRpMigratedFlow: false,
        isGatherActiveConsentEnabled: false,
        suppressBankFundedGuestPayments: false
      };
      // Defaulting userAgreementLink/ userAgreement major and minor versions.
      // So that default values always present when page loads / billing
      // country changes.
      this.userAgreementLink = '/webapps/mpp/ua/useragreement-full';
      this.userAgreement = {
        majorVersion: '3',
        minorVersion: '2'
      };
      this.guestFactory = (0, _guestFactory.$GuestFactory)({
        scope: this
      });
      this.sepa = {
        sepaGuestAgree: false,
        sepaAgree: false,
        show: false
      };
      this.residentialAddress = {
        hasResidentialAddress: false,
        residentialAddressShowPopup: false,
        residentialAddressFieldErrors: false,
        residentialAddressFieldErrorValue: undefined,
        // sync until submitted edit button
        residentialAddressSyncBillingAddress: true
      };

      // set the OTP for addCard based on country feature
      this.needOTPForAddCard = (0, _index.$feature)('needOTPForAddCard');

      // If US, then show new e-sign compliance experience
      // Submit button text changes and show return to merchant msg above button
      // with user action 'continue'
      if (this.locale.country === 'US') {
        this.showNewSignupComplianceExp = true;
      }
      var app_int_type = _index8.$DeviceInfo.isWebView() ? 'WebView' : _index8.$DeviceInfo.getAppIntegrationType();

      // fpti log for app integration type
      _logger.$logger.info('checkout_fpti', {
        app_int_type: app_int_type
      });
      _logger.$logger.info('checkout_fpti', {
        page: 'main:ec:hermes::fullpage-billing:guest:hermes:'
      });

      // set the china upop flag on event heard
      // based on upop detected
      this.$watch('onboard.card.isUpop', function (newVal) {
        _this9.flags.upopDetected = newVal;
      });

      // set the cup flag on event heard
      // based on card type selected
      this.$watch('onboard.card.type', function (newVal) {
        _this9.flags.cupDetected = newVal === 'CUP';
      });
      $(document).on('click', '#pomaLegalterms a', function () {
        _angular.$rootScope.$broadcast('trackInput', {
          currentRoute: _uiRouter.$state.current,
          page: 'main:ec:hermes::fullpage-billing:guest:aries:',
          transition: $(_this9).text().replace(/\s/g, '_')
        });
      });

      // This is needed in Sepa directive
      this.sectionElement = '#singlePagePayment';
      this.countries = function () {
        return _index.$locale.content.countryList;
      };
      var triggerPageDesignFPTILog = function triggerPageDesignFPTILog() {
        var pageContext = 'Full-context';
        if (_angular.$rootScope.miniBrowser) {
          pageContext = 'In-context';
        }
        _logger.$logger.info('checkout_fpti', {
          'design': pageContext
        });
      };
      // Log Initial Page Design

      triggerPageDesignFPTILog();
      // Trigger Design FPTI Log on Page Design Change
      _angular.$rootScope.$watch('miniBrowser', triggerPageDesignFPTILog);
      var getPresetPaymentMethod = function getPresetPaymentMethod() {
        var paymentMethod = _this9.paymentMethod && _this9.paymentMethod.toLowerCase();
        if (!paymentMethod || paymentMethod !== 'bank' && paymentMethod !== 'card') {
          return;
        }
        return paymentMethod === 'bank' ? 'bank' : 'card';
      };
      var getFundingSource = function getFundingSource() {
        var fundingSource;
        if (_index.$config.deploy.isLocal() || _index.$config.deploy.isStage()) {
          // Both query param (fundingSource) and post message(window.xprops.fundingSource) are present
          // in SPB(Smart Payment Button) integration. but post message(window.xprops.fundingSource)
          // will not be availabe in local testing, so passing query param in the url mimics
          // the same.
          fundingSource = _index.$util.param('fundingSource');
        }
        if (window.xprops && window.xprops.fundingSource) {
          fundingSource = window.xprops.fundingSource;
        }
        return fundingSource;
      };
      this.showFISwitchTab = function () {
        // If the experience is tesla-add-bank, then show the FI toggle.
        if (_this9.teslaAddBankEXP) {
          return true;
        }

        // When bank payments are suppressed, show bank and card options
        if (_this9.flags.suppressBankFundedGuestPayments) {
          return true;
        }
        var fundingSource = getFundingSource();

        // `sepa` is being passed for paymentSDK SPB integrations.
        // `elv` is passed from checkoutjs V4 version.
        var isSepa = ['elv', 'sepa'].indexOf(fundingSource) > -1;
        if (getPresetPaymentMethod() || isSepa) {
          return false;
        }
        return (0, _index.$feature)('fiSwitchTab', false, _index.$locale.country);
      };
      this.getDefaultFIMode = function () {
        var presetPayMentMethod = getPresetPaymentMethod();
        if (presetPayMentMethod) {
          return presetPayMentMethod;
        }

        // Check to see if it's Tesla Add Bank experience. If so,
        // The default FI will depend on the treatments A,B or control

        if (_this9.teslaAddBankEXP) {
          return _this9.teslaFIDefault;
        }
        if (_index.$locale.country === 'DE') {
          var fundingSource = getFundingSource();
          var allowRevisedEpmCallJson = _index.$config.allowRevisedEpmCall;
          var allowSpb = allowRevisedEpmCallJson[_index.$locale.country] || allowRevisedEpmCallJson['DEFAULT'];

          // defaulting to card tab for SPB(Smart Payment Button) integration whenever post message
          // passing 'card' for DE.
          if (allowSpb && fundingSource === 'card') {
            return 'card';
          }
          // Default tab for branded DE transaction is Bank
          return 'bank';
        }
        return 'card';
      };
      this.onboard = new _index5.$OnboardModel({
        user: _index5.$OnboardUserModel.instance(this.token, {
          country: _index.$locale.country,
          countryOfResidence: _index.$locale.country,
          nationality: _index.$locale.country
        }),
        card: new _index6.$CardModel(),
        bank: new _index6.$BankModel(),
        fiMode: this.getDefaultFIMode(),
        billing_address: _index6.$BillingAddressModel.create(this.token, {
          country: _index.$locale.country
        }),
        shipping_address: _index2.$ShippingAddressModel.create(this.token, {
          country: _index.$locale.country
        }),
        phone: new _index5.$OnboardPhoneModel(),
        shipping_address_validation: false,
        billing_address_present: false,
        poma_flow: false,
        residential_address: _address.$ResidentialAddressModel.create(this.token, {
          country: _index.$locale.country
        }),
        residential_address_present: false
      });
      this.onboard.card.ppconversion = 'PAYPAL';
      this.getSelectedCurrencyCode = function (selection) {
        var _this9$onboard$card$c = _this9.onboard.card.currencyConvData,
          _this9$onboard$card$c2 = _this9$onboard$card$c === void 0 ? {} : _this9$onboard$card$c,
          from_code = _this9$onboard$card$c2.from_code,
          to_code = _this9$onboard$card$c2.to_code;
        _this9.selectedCurrency = selection === 'PAYPAL' ? from_code : to_code;
      };
      this.$watch('onboard.card.ppconversion', function (newVal) {
        _logger.$logger.info("conversion_selection_changed_to_" + newVal);
        _this9.getSelectedCurrencyCode(newVal);
      });
      this.setBuyerFxFlag = function (_ref2) {
        var treatment = _ref2.treatment,
          hasBuyerFxPrePlanData = _ref2.hasBuyerFxPrePlanData;
        if (treatment) {
          _this9.flags.buyerFxTreatment = treatment;
        }
        _this9.flags.hasBuyerFxPrePlanData = hasBuyerFxPrePlanData;
      };

      // Display the Error message if errorKey is passed in the URL.
      // This use case is for when user return from ANW and in guest-authnode an error is thrown.
      // user will be redirected to guest page with the error key.
      if (_uiRouter.$state.params.error) {
        var errorKey = _uiRouter.$state.params.error;
        var msgs = [];
        if (errorKey.split('.')[0] === 'threeDS') {
          var params = {
            type: _uiRouter.$state.params.cType,
            number: _uiRouter.$state.params.cNumber
          };
          msgs = errorHandlerHelper.get3dsPageWarning(params, errorKey);
        } else {
          msgs = errorHandlerHelper.getPageError(errorKey);
        }
        this.errorMessage = {
          msgs: msgs,
          type: _uiRouter.$state.params.type || 'error'
        };
      }
    },
    populate: function populate() {
      var _this0 = this;
      this.flags.guestWPSMessage18Plus = this.flags.wpsInterstitialEligible && (0, _index.$feature)('guestWPSMessage18Plus', false, _index.$locale.country);
      var checkTeslaEligbility = function checkTeslaEligbility() {
        _this0.teslaAddBankEXP = _index.$locale.country === 'JP';
        // If it's teslaAddBankEXP treatment is successful, then change the default FI based on treatment returned.
        if (_this0.teslaAddBankEXP) {
          _this0.teslaFIDefault = 'bank';
          _this0.onboard.fiMode = _this0.teslaFIDefault;
        }
      };
      checkTeslaEligbility();
      if (this.flags.suppressBankFundedGuestPayments) {
        this.onboard.fiMode = 'card';
      }
      this.getToggleKeys = (0, _pageProps.getFItoggleContentKeys)(this.teslaAddBankEXP, this.teslaFIDefault);

      // We show JP-add bank experience only when the following conditions meet:
      // A) If ELMO passes. If ELMO fails, we don't even show the toggle.
      // B) If the flow is a bank flow.

      this.showTeslaAddBankFlow = function () {
        return _this0.teslaAddBankEXP && _this0.onboard.fiMode === 'bank';
      };

      // Shipping Options/BOPIS
      this.shippingOptionsFeature = (0, _shippingOptionsFeature.buildShippingOptionsFeature)(this.token);
      if (this.shippingOptionsFeature.hasShippingOptions()) {
        this.flags.showCartChanged();
      }

      // Needed to show custom description sent by merchant in Billing Agreement flow
      this.billingAgreementMerchantMsg = this.models.checkoutCart.getBillingDescription();

      // Log to FPTI to indicate the page has been rendered
      _logger.$logger.info('checkout_fpti', {
        from: this.mode === 'guest' ? 'GUEST_XO' : 'SIGNUP',
        to: "prepare_" + (this.mode === 'guest' ? 'guest_xo' : 'signup')
      });
      _logger.$logger.info('config_to_read_from_app_data', {
        readRulesSummaryFromAppData: _index.$config.readRulesSummaryFromAppData,
        readMerchantPreferencesFromAppData: _index.$config.readMerchantPreferencesFromAppData
      });
      if (!_index.$config.readRulesSummaryFromAppData) {
        if (this.shippingRule && this.shippingRule.profileRulesSummary) {
          this.flags.wps_SnT_flow = this.shippingRule.profileRulesSummary.isSnTEnabled;
        }
      } else {
        this.flags.wps_SnT_flow = this.models.checkoutAppData.is_snt_enabled();
      }
      // pre-fill user first name and last name.
      // override happens at handlePrefillShippingAndBillingAddress if merchant passing
      // shipping address during cart creation.
      this.onboard.user.first_name = this.models.checkoutCart.get('payer.first_name');
      this.onboard.user.last_name = this.models.checkoutCart.get('payer.last_name');
      var setAllowShipToBilling = function setAllowShipToBilling(allow) {
        // Toggle checkbox
        _this0.flags.disallowShipToBilling = !allow;
        // Show/Hide shipping address section
        _this0.flags.shipToBilling = allow;
      };
      var checkProcessorDecline = function checkProcessorDecline() {
        var processorDeclined = _this0.models.checkoutAppData.get('flags.processor_declined');
        if (processorDeclined) {
          _this0.errorMessage = {
            msgs: [(0, _squid.$renderContent)('payment.processorDeclineMemberNoFIGeneric')],
            type: 'warning'
          };
        }
      };
      var checkLatinumRedirect = function checkLatinumRedirect() {
        if (_squid.$meta.query && _squid.$meta.query.latinumRedirect) {
          _this0.topErrorMessage = {
            msgs: [(0, _squid.$renderContent)('login.latinumNotUsed', {
              alternativeFunding: _squid.$meta.query.latinumRedirect
            })],
            type: 'info'
          };
        }
      };
      var setChangeShippingCountryAlertMsg = function setChangeShippingCountryAlertMsg() {
        var countryName = (0, _squid.$renderContent)('shippingCountry.' + _this0.merchantCountry);
        var infoMessage = (0, _squid.$renderContent)('largeScreenPayment.blockNonDomesticShippingAlert', {
          shippingCountry: countryName
        });
        _this0.changeShippingCountryAlert = {
          msgs: [infoMessage],
          type: 'info'
        };
      };

      // pre-populate shipping and billing address
      var updateShippingAndBillingAddress = function updateShippingAndBillingAddress(shippingAddress, billingAddress) {
        // Detect invalid length country codes in which case we invalidate the country code.
        // A default value of $locale.country will subsequently be picked up for invalidated country codes in the model creation.
        if (shippingAddress && shippingAddress.country_code && shippingAddress.country_code.length !== 2) {
          shippingAddress.country_code = undefined;
        }
        if (billingAddress && billingAddress.country_code && billingAddress.country_code.length !== 2) {
          billingAddress.country_code = undefined;
        }

        // NOTE: this function modifies params.state value to uppercase
        (0, _util3.sanitizeStateFields)(shippingAddress, billingAddress);

        // pre-fill billing address with shipping address
        _this0.onboard.shipping_address = _index2.$ShippingAddressModel.create(_this0.token, {
          country: shippingAddress.country_code || _index.$locale.country
        }, shippingAddress);

        // pre-fill provided billing address
        _this0.onboard.billing_address = _index6.$BillingAddressModel.create(_this0.token, {
          country: billingAddress.country_code || _index.$locale.country
        }, billingAddress);
      };

      // handle billing and shipping address prefill scenarios
      var handlePrefillShippingAndBillingAddress = function handlePrefillShippingAndBillingAddress(allowPrefillShippingAddress, prefilledAddress, prefilledBillingAddress) {
        // if users already had performed planning/post on xo session. Don't prefill the address
        // due to security concerns.
        // buyer_set_in_session attribute indicates that post on xo session/planning has been invoked
        var supplementary_data = _this0.models.checkoutCart.supplementary;
        if (supplementary_data && supplementary_data.buyer_set_in_session) {
          return;
        }
        // if both shipping and billing addresses are provided
        if (allowPrefillShippingAddress && prefilledAddress && prefilledBillingAddress) {
          updateShippingAndBillingAddress(prefilledAddress, prefilledBillingAddress);

          // uncheck ship to billing checkbox
          _this0.flags.shipToBilling = false;
        } else if (allowPrefillShippingAddress && prefilledAddress) {
          // if only shipping address is provided

          // pre-fill user first name and last name
          _this0.onboard.user.first_name = prefilledAddress.first_name;
          _this0.onboard.user.last_name = prefilledAddress.last_name;
          updateShippingAndBillingAddress(prefilledAddress, prefilledAddress);
          if (!_this0.flags.allowEditShipping) {
            _this0.flags.shipToBilling = false;
          }
        } else if (prefilledBillingAddress) {
          // if only billing address is provided
          updateShippingAndBillingAddress(prefilledBillingAddress, prefilledBillingAddress);
        }
      };

      // remove this upon oas ramp completion
      this.onboard.testParams = {
        oas: _index.$util.param('oas'),
        cardCandidate: _index.$util.param('cardCandidate')
      };
      this.$on('localeChange', function () {
        _this0.onboard.fiMode = _this0.getDefaultFIMode();
        _this0.onboard.billing_address.country = _index.$locale.country;
        _this0.onboard.user.country = _index.$locale.country;
        _this0.onboard.user.nationality = _index.$locale.country;
        _this0.onboard.user.countryOfResidence = _index.$locale.country;
        _this0.setBackButtonForWebview();
        if (_this0.flags.disableChangeShippingCountry) {
          if (_this0.flags.allowEditShipping) {
            setAllowShipToBilling(_index.$locale.country === _this0.merchantCountry);
          }
        } else {
          _this0.onboard.shipping_address.country = _index.$locale.country;
        }
      });
      this.$on('contentChange', function () {
        if (_this0.flags.disableChangeShippingCountry) {
          setChangeShippingCountryAlertMsg();
        }
      });
      this.$on('signupClickedTimerStarted', function (event, time) {
        _this0.signupClickedStartTime = time;
      });
      this.hasDialingCodeOverride = _util2.hasDialingCodeOverride;
      this.showContactInfo = function () {
        return _this0.hasDialingCodeOverride() || _this0.flags.allowChoice;
      };
      this.displayEmailInContactInfo = function () {
        if (!(0, _util2.hasDialingCodeOverride)()) {
          return true;
        }
        var showingEmailInSignup = !_this0.flags.allowChoice;
        if (!showingEmailInSignup) {
          return true;
        }
        return false;
      };
      this.redirect = function () {
        _logger.$logger.info('basl_throttle_test_login');
        (0, _squid.$dispatch)('hermes', {
          hermesLoginRedirect: 'xoon',
          token: _this0.token,
          'locale.x': _index.$locale.lang + '_' + _index.$locale.country,
          'country.x': _index.$locale.country
        });
      };
      this.$watch('flags.shipToBilling', function (shipToBilling) {
        if (!shipToBilling && _this0.flags.allowEditShipping) {
          $.each(_this0.onboard.billing_address, function (key, val) {
            if (angular.isString(_this0.onboard.billing_address[key]) && !_this0.onboard.shipping_address[key]) {
              _this0.onboard.shipping_address[key] = val;
            }
          });
          _this0.onboard.shipping_address.first_name = _this0.onboard.shipping_address.first_name || _this0.onboard.user.first_name;
          _this0.onboard.shipping_address.last_name = _this0.onboard.shipping_address.last_name || _this0.onboard.user.last_name;
        }
      });

      // Format address to display when store pick is selected
      var formatAddress = function formatAddress(address) {
        var COMMA = ', ';
        var SPACE = ' ';
        function prefix(str, prefixStr) {
          if (str) {
            return (prefixStr ? prefixStr : '') + str;
          }
          return '';
        }
        var displayLine1 = (address.line1 ? address.line1 : '') + (address.line2 ? prefix(address.line2, COMMA) : '');
        var displayLine2 = (address.city ? prefix(address.city) : '') + (address.state ? prefix(address.state, COMMA) : '') + (address.postal_code ? prefix(address.postal_code, SPACE) : '');
        var displayLine3 = address.country ? prefix(address.country) : '';
        return {
          displayLine1: displayLine1,
          displayLine2: displayLine2,
          displayLine3: displayLine3
        };
      };
      var storePickUpSelected = _angular.$rootScope.$on('store_pick_up_selected', function (event) {
        var addressType = _this0.flags.shipToBilling ? 'billing_address' : 'shipping_address';
        _this0.shippingAddress = formatAddress(_this0.onboard[addressType]);
      });
      this.$on('$destroy', storePickUpSelected);
      var showErrorFields = _angular.$rootScope.$on('showErrorFields', function (event) {
        _this0.toggleAddressFieldsValidation(true);
      });
      this.$on('$destroy', showErrorFields);
      var hideErrorFields = _angular.$rootScope.$on('hideErrorFields', function (event) {
        _this0.toggleAddressFieldsValidation(false);
      });
      this.$on('$destroy', hideErrorFields);

      // useraction flag
      var useraction = this.models.checkoutAppData.useraction();
      this.flags.commit = useraction && useraction.toLowerCase() === 'commit';
      _logger.$logger.info('checkout_fpti', {
        billing_page_button_text: this.flags.commit ? 'paynow_y' : 'paynow_n'
      });
      this.flags.wpsFlow = this.models.checkoutAppData.is_wps_flow();

      // show shipping address based on merchant passed in parameter
      this.showShippingAddress = Boolean(!this.models.checkoutAppData.flags.hide_shipping_address && this.models.checkoutAppData.flags.shipping_address_required);
      this.isInstantUpdateFlow = this.models.checkoutCart.instantUpdateIntegration;
      if (this.isInstantUpdateFlow) {
        this.trackSntReq = {};
      }

      // flags.allowEditShipping = false, skip saving shipping address validation otherwise don't skip.
      this.flags.allowEditShipping = this.models.checkoutAppData.get('flags.allow_change_shipping', false);

      // Prefill email from cart
      this.onboard.user.email = this.models.checkoutCart.get('payer.email');

      // Prefill birth_date from cart(/v2/checkout/orders api can send birth date while creating the token)
      // according to PPAAS v2/checkout/orders api, regex for birth_date is always "yyyy-mm-dd"
      // PPAAS url for v2/checkout/orders: https://ppaas/api/3719176155269081#apiReference
      var payerBirthDate = this.models.checkoutCart.get('payer.birth_date');
      if (payerBirthDate) {
        var _payerBirthDate$split = payerBirthDate.split('-'),
          year = _payerBirthDate$split[0],
          month = _payerBirthDate$split[1],
          day = _payerBirthDate$split[2];
        this.onboard.user.dob_day = day;
        this.onboard.user.dob_month = month;
        this.onboard.user.dob_year = year;
      }
      this.upopConfirmButtonTextKey = (0, _pageProps.upopConfirmButtonTextKey)(this.flags);

      // *** NOTE:
      // PXP was initially intended to be used with login button, but we've opted to use back button
      // page name and treatments still have login in the name though.
      this.flags.backButtonWebview = false;
      this.setBackButtonForWebview = function () {
        if (_index8.$DeviceInfo.isWebView(false)) {
          var floatThrottle = parseFloat((0, _index.$feature)('webviewBackButtonThrottle', 0, _index.$locale.country));
          if (isNaN(floatThrottle)) {
            return;
          }
          _this0.flags.backButtonWebview = !!(floatThrottle && (0, _squid.$experiment)('webview_backbutton_throttle', floatThrottle, _angular.$rootScope.token, {}));
          if (_this0.flags.backButtonWebview) {
            _logger.$logger.info('BACK_BUTTON_SHOWN_FOR_WEBVIEW');
          }
        }
      };
      this.setBackButtonForWebview();
      this.landingAbTestCheck = function () {
        /**
         * Show the login button on xoon when:
         * - hermes redirects to xoon in xo-landing-router
         **/
        return !!(_squid.$meta.query && _squid.$meta.query.abTestThrottle === 'xoon');
      };

      /**
       * This function takes in an International number: e.g +491721232312 and returns national number (1721232312)
       * @param {string} formattedPhone
       * @param {string} IntDialingCountryCode
       * @return {string}
       */
      this.getFormattedNationalNumber = function (formattedPhone, IntDialingCountryCode) {
        if (!formattedPhone || !IntDialingCountryCode) {
          return;
        }

        // Generate clean number by removing empty spaces.
        var cleanPhoneNumber = formattedPhone.replace(/\s/g, '');
        var dailingCode = IntDialingCountryCode[0] === '+' ? IntDialingCountryCode : "+" + IntDialingCountryCode;
        return cleanPhoneNumber.split(dailingCode)[1];
      };
      var purchasePhoneFields = this.models.checkoutCart.get('purchase.phone_fields');
      var billingPhoneFields = this.models.checkoutCart.get('billing.phone_fields');
      var payerPhoneFields = this.models.checkoutCart.get('payer.normalizedPhoneNumber.phone_fields');

      // Get merchant passed shipping address from either purchase plan or billing agreement plan
      var prefilledAddress = this.models.checkoutCart.get('purchase.shipping_address') || this.models.checkoutCart.get('billing.shipping_address');
      var purchaseTelephoneCountryPresent = !!(purchasePhoneFields && purchasePhoneFields.hasOwnProperty('telephone_country'));
      var billingTelephoneCountryPresent = !!(billingPhoneFields && billingPhoneFields.hasOwnProperty('telephone_country'));
      var payerTelephoneCountryPresent = !!(payerPhoneFields && payerPhoneFields.hasOwnProperty('telephone_country'));
      var prefilledNumber = purchaseTelephoneCountryPresent && purchasePhoneFields || billingTelephoneCountryPresent && billingPhoneFields || payerTelephoneCountryPresent && payerPhoneFields;
      var useInternationalFormatting = (0, _index.$feature)('useInternationalFormatting', false, _index.$locale.country);
      if (prefilledNumber && prefilledNumber.telephone_country === _index.$locale.country) {
        // If UseInternationalFormatting is enabled, we use griffin's international Number
        // Formatting instead of national formatting. This can be found in feature in config.json
        if (useInternationalFormatting) {
          this.onboard.phone.telephone = this.getFormattedNationalNumber(prefilledNumber.formatted_phone_number_international, this.onboard.phone.IntDialingCountryCode);
        } else {
          this.onboard.phone.telephone = prefilledNumber.formatted_phone_number;
        }
        this.onboard.phone.ispreFill = true;
      }
      var allowPrefillShippingAddress = !!prefilledAddress;
      var prefilledBillingAddress = this.models.checkoutCart.get('billing_address');

      // variable to indicate whether billing/shipping address is from cart or not.
      this.flags.shippingAddressPresentFromCart = !!prefilledAddress;
      this.flags.billingAddressPresentFromCart = !!prefilledBillingAddress;
      this.merchantCountry = this.models.checkoutAppData.get('merchant.merchant_country', 'US');

      // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
      // then we need the value of merchantDisplayName to be 'the merchant' as it is the middle of sentence
      // in content keys used in template
      this.nonEmptyMerchantDisplayName = this.models.checkoutAppData.getMerchantDisplayName({
        nonEmptyReturnValue: true
      });
      if ((0, _index.$feature)('supportBlockNonDomesticShipping', false, this.merchantCountry)) {
        this.flags.disableChangeShippingCountry = this.models.checkoutAppData.get('flags.block_non_domestic_shipping', false);
        if (this.flags.disableChangeShippingCountry) {
          _logger.$logger.info('onboard_block_non_domestic_shipping', {
            block_non_domestic_shipping: this.flags.disableChangeShippingCountry,
            allow_change_shipping: this.flags.allowEditShipping,
            setec_shipping_country_code: prefilledAddress && prefilledAddress.country_code
          });
          if (!this.flags.allowEditShipping && prefilledAddress && prefilledAddress.country_code !== this.merchantCountry && prefilledAddress.country_code !== '') {
            _uiRouter.$state.go(_guestFactory.ROUTE.GENERIC_ERROR, {
              code: _guestFactory.ERROR_CODE.BLOCK_NON_DOMESTIC_SHIPPING
            });
          }
          if (prefilledAddress && prefilledAddress.country_code !== this.merchantCountry) {
            allowPrefillShippingAddress = false;
          }
          setChangeShippingCountryAlertMsg();
          this.onboard.shipping_address.country = this.merchantCountry;

          // Show shipping address section if user locale is different from merchant country
          if (this.flags.allowEditShipping && _index.$locale.country !== this.merchantCountry) {
            setAllowShipToBilling(false);
          }
        }
      }

      /**
       * Handle Card-Type based Installments e.g. Brazil is card_type based installments,
       * so fetch the installments during page load.
       */
      var handleCardTypeBasedInstallments = function handleCardTypeBasedInstallments() {
        _this0.$watch('singlePagePaymentForm.$valid', function (newVal, oldVal) {
          var cardModel = _this0.onboard.card;
          if (newVal && newVal.luhn && newVal.luhn[0].$name === 'cardNumber') {
            cardModel.valid = false;
          } else {
            cardModel.valid = true;
          }
        });
        _this0.$watch(_this0.onboard.card.type, function (newValue, oldValue) {
          // Sanitize the values
          newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;
          var cardNetwork;
          if (newValue && _this0.installments && _this0.installments.length > 0) {
            _this0.installments.some(function cardCheck(card, index, array) {
              if (card.cardInfo && card.cardInfo.card_type && card.cardInfo.card_type.toLowerCase() === newValue) {
                // Card Network Found
                cardNetwork = card;
                return true;
              }
              return false;
            });
            if (cardNetwork && cardNetwork.installment_options && cardNetwork.installment_options.length > 0) {
              // Card network && installments found
              if (cardNetwork.installment_options.length === 1) {
                _this0.singleStepModel.selectedInstallmentData = {
                  installment_option_selected: cardNetwork.installment_options[0],
                  preventChange: true
                };
              }
              _this0.singleStepModel.allowInstallments = true;
            } else {
              // Card network does not exists Or No installment found
              _this0.singleStepModel.allowInstallments = false;
            }
          } else {
            _this0.singleStepModel.allowInstallments = false;
          }
        });
        var installments = _index2.$InstallmentOptionsModel.instance(_this0.token);
        installments.save({
          data: {
            payee: _this0.models.payee,
            checkoutCart: _this0.models.checkoutCart,
            checkoutAppData: _this0.models.checkoutAppData
          },
          success: function success(result) {
            _this0.installments = result.installments;
          }
        });
      };

      /**
       * Handle Issuer based Installments e.g. Mexico is issuer_based (bank) installments, so fetch the
       * installments after user enters card number
       */
      var handleIssuerBasedInstallments = function handleIssuerBasedInstallments() {
        _this0.cardNumberChanged = function (unformattedCardNumber) {
          if (unformattedCardNumber && unformattedCardNumber !== _this0.prevCardNumber) {
            // Make sure the Installments server is hit only once for a cardNumber
            _this0.prevCardNumber = unformattedCardNumber;
            var installments = _index2.$InstallmentOptionsModel.instance(_this0.token);
            installments.save({
              silent: true,
              data: {
                payee: _this0.models.payee,
                checkoutCart: _this0.models.checkoutCart,
                checkoutAppData: _this0.models.checkoutAppData,
                cc: unformattedCardNumber
              },
              success: function success(result) {
                _this0.installments = result;
                if (result.installment_options && result.installment_options.length > 0) {
                  _this0.issuerBasedInstallmentsRetrieved = true;

                  // reset the previously selected installment
                  _this0.singleStepModel.selectedInstallmentData = undefined;
                  if (result.installment_options.length === 1) {
                    _this0.singleStepModel.selectedInstallmentData = {
                      installment_option_selected: result.installment_options[0],
                      preventChange: true
                    };
                  }
                  _this0.singleStepModel.allowInstallments = true;
                } else {
                  _this0.singleStepModel.allowInstallments = false;
                }
              }
            });
          }
        };
      };

      // Lookup installments only when amount is greater than zero.
      // for ex: Billing Agreements can create with amount=zero.
      // Installments have been deprecated for AS1/AS2 flows
      if ((0, _index.$feature)('installments', false, _index.$locale.country) && this.models.checkoutCart.get('purchase.amounts.total.amount', 0) > 0 && this.models.checkoutCart.payment_action === 'sale') {
        if ((0, _index.$feature)('issuerBasedInstallments', false, _index.$locale.country)) {
          // e.g. Mexico is issuer_based (bank) installments, so fetch the installments after user enters card number
          handleIssuerBasedInstallments();
        } else {
          // e.g. Brazil is card_type based installments, so fetch the installments during page load.
          handleCardTypeBasedInstallments();
        }
      }
      this.isInstallmentsVisible = function () {
        if (!_this0.singleStepModel) {
          return false;
        }
        _this0.singleStepModel.onboard = _this0.onboard;
        var model = _this0.onboard;
        var hasConditionMet = _this0.singleStepModel.allowInstallments && model.card.number && (model.card.valid || _this0.issuerBasedInstallmentsRetrieved);
        var isBilling = _this0.models.checkoutCart.isBilling();
        return !isBilling && hasConditionMet;
      };
      checkProcessorDecline();
      checkLatinumRedirect();
      handlePrefillShippingAndBillingAddress(allowPrefillShippingAddress, prefilledAddress, prefilledBillingAddress);
      this.onboard.payment_experience_initiator = this.models.checkoutAppData.get('flags.payment_experience_initiator');
      this.isApac = function () {
        return _index.$config.apacCountries && _index.$config.apacCountries.indexOf(_this0.locale.country) > -1;
      };
      this.$on('MORSDisplayed', function (event, args) {
        _this0.MORSDisplayed = args;
      });
      this.$on('MORSNotDisplayed', function (event, args) {
        _this0.MORSDisplayed = {};
      });
      this.shippingChangeFeature = (0, _shippingChangeFeature.createShippingChangeFeature)({
        orderID: this.token,
        checkoutAppData: this.models.checkoutAppData,
        checkoutCart: this.models.checkoutCart,
        flags: this.flags,
        callback: function callback() {
          return _this0.shippingOptionsFeature.checkForShippingOptions();
        }
      });
      var mapValidationErrors = function mapValidationErrors(err) {
        var fields = err && err.fields || [];
        fields.forEach(function (fieldError) {
          if (fieldError && fieldError.property) {
            fieldError.field = fieldError.property;
          }
        });
        return {
          fields: fields
        };
      };
      var mapAddCardErrors = function mapAddCardErrors(field) {
        switch (field) {
          case 'cvv':
            return {
              fields: [{
                field: 'security_code'
              }]
            };
          case 'billing_address':
            if (_this0.$element.find('[ng-model="address.line2"]').val().length) {
              return {
                fields: [{
                  field: 'address.line1'
                }, {
                  field: 'address.line2'
                }, {
                  field: 'address.postal_code'
                }]
              };
            }
            return {
              fields: [{
                field: 'address.line1'
              }, {
                field: 'address.postal_code'
              }]
            };
          default:
            return;
        }
      };

      // TODO: clean up this code as most of filifecycleserv error handler is in
      // lib/errorHandlerHelper, and we should get rid of $fiErrorUtil
      // From my understanding following function is related to older service call
      this.handleFIContingencies = function (data, fundingInstrument) {
        // data is an object which has error with key 0
        // standardize data's data structure to group invalid fields together and handle all cases
        if (data && data[0]) {
          var contentBundle = 'addCardFIErrors';
          var errorData = mapAddCardErrors(data[0].field);
          switch (data[0].field) {
            case 'billing_address':
              _this0.errorMessage = _util.$fiErrorUtil.addPageErrors(data, contentBundle, _this0.props, 'VALIDATION_ERROR_BILLING_ADDRESS');
              _util.$fiErrorUtil.addFieldErrors(errorData, _this0.$element);
              break;
            case 'cvv':
              _this0.errorMessage = _util.$fiErrorUtil.addPageErrors(data, contentBundle, _this0.props, 'VALIDATION_ERROR_CVV');
              _util.$fiErrorUtil.addFieldErrors(errorData, _this0.$element, 'card.');
              break;
            default:
              _this0.errorMessage = _util.$fiErrorUtil.addPageErrors(data, fundingInstrument);
              break;
          }
        }
        if (!_this0.errorMessage) {
          _this0.errorMessage = {
            msgs: [_index.$locale.content.get(fundingInstrument + '.errorGeneral')],
            type: 'error'
          };
        }
        errorHandlerHelper.scrollToElement();
      };
      this.handleAddFIContingencies = function (data, fundingInstrument, action) {
        if (action === 'signup') {
          _this0.guestFactory.handleCardContingencySignup(data);
        } else {
          _this0.handleFIContingencies(data, fundingInstrument);
        }
      };
      this.handleResidentialAddressError = function (status, addressType) {
        if (status === 'INVALID') {
          _this0.residentialAddress.residentialAddressFieldErrorValue = 'INVALID';
        } else if (addressType === 'P') {
          // P : PO_BOX
          _this0.residentialAddress.residentialAddressFieldErrorValue = 'PO_BOX';
        } else if (addressType === 'R') {
          // R: RR_BOX
          _this0.residentialAddress.residentialAddressFieldErrorValue = 'RR_BOX';
        }
        // Error flag for watch
        _this0.residentialAddress.residentialAddressFieldErrors = true;
        _this0.residentialAddress.residentialAddressShowPopup = true;
      };
      var getContentIdentifier = function getContentIdentifier(tcpaIdentifier) {
        return _index.$locale.country + ':' + _index.$locale.lang + ':' + (0, _squid.$contentVersion)() + ':' + tcpaIdentifier;
      };

      /*
       * onBoardAccount and functions calling onBoardAccount
       */
      this.onBoardAccount = function () {
        // remove the page level errors
        _this0.errorMessage = '';

        // Reset flag to handle any error in 3ds 2.0 modal window
        _this0.showThreedsPopup = false;

        // creating this variable shipping_address_validation for back-end whether to validate
        // the shipping address or not.
        // shipping address validation required only when shipping address is different than Billing Address
        // shipToBilling flag will be false when user tries to expand the shipping address in Billing Page
        // By default shipToBilling is true, so when shipping address is shown and Billing Address
        // is not present for whitelisted india merchants, shipping address needs to be validated.
        _this0.onboard.shipping_address_validation = _this0.flags.allowEditShipping && (!_this0.flags.shipToBilling || _this0.flags.whiteListedIndiaMerchant);
        // billing_address_present passed to the back end to skip / perform billing address validation
        // billing_address_present will be false only for whitelisted merchant from INs.
        _this0.onboard.billing_address_present = !_this0.flags.whiteListedIndiaMerchant;
        _this0.onboard.billing_address.country = _index.$locale.country;
        _this0.onboard.skipInitiateAuth = true;
        _this0.onboard.poma_flow = _this0.flags.poma_flow;
        _this0.onboard.content_identifier = getContentIdentifier(_this0.flags.tcpa_identifier);
        _this0.onboard.prox_flow = _this0.models.checkoutInputData.isEbayTxn();

        // merchantCountry, merchantPreferences, and isUnbranded are needed to check for guest eligibility
        var _this0$merchantPrefer = _this0.merchantPreferences,
          _this0$merchantPrefer2 = _this0$merchantPrefer === void 0 ? {} : _this0$merchantPrefer,
          merchant_preferences = _this0$merchantPrefer2.model;
        _this0.onboard.flow_eligibility_data = {
          is_unbranded: _this0.isUnbranded,
          merchant_preferences: merchant_preferences,
          merchant_country: _this0.merchantCountry
        };

        // Bypass auth experiment
        if (_this0.flags.mode === 'guest' || _this0.flags.mode === 'guestonly') {
          _this0.onboard.bypass_address_verification = _this0.flags.bypass_address_verification;
          _this0.onboard.bypass_authorization = _this0.flags.bypass_authorization;
        }

        // Set `legal_agreements` with the data related to User Agreement to be sent to OAS
        _this0.onboard.legal_agreements = [_helper.signupLib.getUserLegalAgreementPayload(_this0.userAgreement.majorVersion, _this0.userAgreement.minorVersion)];

        // POMA should go in Singup rails, because poma usecase is passwordless member
        var action = _this0.flags.poma_flow || _this0.flags.mode === 'signup' ? 'signup' : 'guest';
        var setErrorMessage = function setErrorMessage(errMsg) {
          _this0.errorMessage = {
            msgs: errorHandlerHelper.getPageError(errMsg),
            type: 'error'
          };
        };
        if (['GF', 'GP', 'MQ', 'YT', 'RE'].includes(_index.$locale.country)) {
          (0, _util3.frenchDomCountryChange)(_this0.onboard);
        }
        return _this0.onboard.action(action, {
          data: _this0.onboard.serialize(),
          success: function success(result) {
            _this0.threedsData = (0, _util3.getThreedsDataForAddFi)(result && result.fiConfirmationDetails);
            return _angular.$q.when().then(function () {
              /*
                  If we're in an in-context flow, the parent button
                  iframe may need the access token to continue running
                  and execute the payment (e.g. in 3rd party cookies
                  disabled mode)
                   We reload the auth model, since after the user is
                  onboarded this model is not updated, then pass the
                  access token up. The token will only be passed if
                  we're on the same-domain as the parent button.
              */

              if (window.xprops && window.xprops.onAuth) {
                if (result && result.accessToken) {
                  _logger.$logger.info('spb_onauth_from_onboard_call');
                  return window.xprops.onAuth({
                    accessToken: result.accessToken
                  });
                } else {
                  // TODO: this can be removed once we're sure `result.accessToken`
                  // is always populated
                  _logger.$logger.info('spb_onauth_from_auth_reload');
                  var auth = _index7.$AuthModel.instance();
                  return auth.reload().then(function () {
                    window.xprops.onAuth({
                      accessToken: auth.access_token
                    });
                  });
                }
              }
            }).then(function () {
              if (_this0.flags.poma_flow) {
                var locale_code = _index.$locale.lang + '_' + _index.$locale.country;
                var locale_country = _index.$locale.country;
                return _ul.$ul.optInToOneTouch(_this0.token, locale_country, locale_code).then(function (success) {
                  _logger.$logger.info('UL_SUCCESSFULLY_DROPPED_RT_IN_COOKIE');
                }, function (err) {
                  // eslint-disable-line handle-callback-err
                  _logger.$logger.info('UL_FAILED_DROPPED_RT_IN_COOKIE');
                });
              }
            }).then(function () {
              if (_this0.models.checkoutCart.isWalletTokenization()) {
                _logger.$logger.info("REDIRECT_" + _this0.subject + "_WALLET_TOKENIZATION");
                (0, _squid.$dispatch)('hermes', {
                  token: _this0.token,
                  'locale.x': _index.$locale.lang + "_" + _index.$locale.country,
                  'country.x': _index.$locale.country
                });
              } else {
                // fire conversion url for MORS offer in the sign up section, ad_id = 202002
                if (_this0.MORSDisplayed && _this0.MORSDisplayed.placementId === '202002') {
                  _index9.$fireMORSBeacon.fireBeacon(_this0.MORSDisplayed.clickURL);
                }
                if (_this0.onboard.card && _this0.onboard.fundingId && _this0.needOTPForAddCard && _this0.flags.cupDetected && _this0.flags.upopDetected) {
                  _this0.onboard.card.id = _this0.onboard.fundingId;
                  _this0.launchUpopScreen = true;
                } else if (_this0.threedsData && _this0.threedsData.referenceId && _this0.onboard.fundingId) {
                  _this0.threedsData.initThreedsData = {
                    bypassConfirmationProcess: _this0.threedsData.bypassConfirmationProcess,
                    confirmationMethod: _this0.threedsData.confirmationMethod,
                    cvv: _this0.onboard.get('card.security_code'),
                    fundingId: _this0.onboard.fundingId,
                    referenceId: _this0.threedsData.referenceId
                  };
                  _this0.showThreedsPopup = true;
                } else {
                  // Fetch OTP Challenge and store in Mayfly. If no OTP challenge then Customer is
                  // not eligible for UL Otp. It is a Fire and forget call.
                  _this0.isCustomerEligibleForOtpUpsell = _this0.guestFactory.checkCustomerEligibleForOtpUpsell();
                  // Create Checkout-Session
                  return _this0.guestFactory.createXO();
                }
              }
            });
          },
          contingencies: {
            INVALID_RESOURCE_ID: _this0.guestFactory.showGenericError(_guestFactory.ERROR_CODE.EXPIRED_SESSION),
            TRANSACTION_REFUSED: _this0.guestFactory.showGenericError(_guestFactory.ERROR_CODE.TRANSACTION_REFUSED),
            RESIDENTIAL_ADDRESS_VALIDATION_ERROR: function RESIDENTIAL_ADDRESS_VALIDATION_ERROR(result, err) {
              var status = err.status,
                address_type = err.address_type;
              _this0.handleResidentialAddressError(status, address_type);
            },
            CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
              setErrorMessage('creditcard.linkedCardToAddNewCard');
            },
            BANK_LINKED_TO_FULL_ACCOUNT: function BANK_LINKED_TO_FULL_ACCOUNT() {
              setErrorMessage('bank.linkedBankError');
            },
            BANK_PAYMENTS_BLOCKED: function BANK_PAYMENTS_BLOCKED() {
              _logger.$logger.info('bank_payments_blocked_contingency');
              _this0.errorMessage = {
                msgs: errorHandlerHelper.getPageError('pageLevelError.cannotUseBank'),
                type: 'error'
              };
            },
            EXISTING_ACCOUNT_RESTRICTED: function EXISTING_ACCOUNT_RESTRICTED() {
              setErrorMessage('creditcard.riskDisallowed');
            },
            TOO_MANY_REQUESTS: function TOO_MANY_REQUESTS() {
              setErrorMessage('genericError.genericError');
            },
            VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, data) {
              _this0.errorMessage = _util.$fiErrorUtil.addPageErrors(data, _this0.locale, 'bank');
              _util.$fiErrorUtil.addFieldErrors(data, _this0.sectionElement);
            },
            ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(result, err) {
              _this0.handleAddFIContingencies(err, 'creditcard', action);
            },
            ADD_BANK_CONTINGENCY: function ADD_BANK_CONTINGENCY(result, err) {
              _this0.handleAddFIContingencies(err, 'bank', action);
            },
            RISK_DISALLOWED: function RISK_DISALLOWED() {
              setErrorMessage('creditcard.riskDisallowed');
            },
            COUNTRY_NOT_SUPPORTED: function COUNTRY_NOT_SUPPORTED() {
              setErrorMessage('creditcard.complianceDecline');
            },
            VALIDATION_ERROR: function VALIDATION_ERROR(message, errorData) {
              if (errorData === void 0) {
                errorData = {};
              }
              var _errorData = errorData,
                _errorData$ = _errorData[0],
                _errorData$2 = _errorData$ === void 0 ? {} : _errorData$,
                errorCode = _errorData$2.code;
              var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, _this0.actions.positionToErrorField, '');
              var errorType = errorHandlerHelper.getErrorType(errorCode, _this0.mode, '');
              if (errorMsgs && errorMsgs.length > 0) {
                _this0.errorMessage = {
                  msgs: errorMsgs,
                  type: errorType
                };
              }
            }
          },
          validation: function validation(res) {
            // should catch any primary check failures like schema validations etc
            _util.$fiErrorUtil.addFieldErrors(mapValidationErrors(res), _this0.sectionElement);
          }
        });
      };
      this.onUpopSuccess = function () {
        _this0.launchUpopScreen = false;
        return _this0.guestFactory.createXO();
      };
      this.onUpopCancel = function (errorData) {
        _this0.launchUpopScreen = false;
        if (_this0.flags.mode === 'signup') {
          // If signup user closes the OTP popup window(or some error in flow)
          // then call create checkout session, and this will intern redirect
          // to hermes with NEED_AUTHENTICATED_CARD contingency
          return _this0.guestFactory.createXO();
        } else if (errorData) {
          // If guest user closes the OTP popup window(or some error in flow)
          // then show a page level error to the user
          // There is no redirect to hermes in guest case
          if (errorData && errorData.errorCodes && errorData.errorCodes[0] === 'RESTRICTED_CARD') {
            // Custom error messaging for RESTRICTED_CARD errorCode.
            // RESTRICTED_CARD_GUEST content key is applicable for both Guest & Signup flows.
            errorData.errorCodes[0] = 'RESTRICTED_CARD_GUEST';
          }

          // prop for last 4 digits of card in error message
          var prop = {
            number: _this0.onboard.card.last4()
          };
          _this0.errorMessage = _util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error');
        }
      };
      this.uponNormalization = function (normalizedAddress, isBack) {
        _this0.showAddressNormalizationLightbox = false;
        var newBilling = _index6.$BillingAddressModel.create(_this0.token, normalizedAddress, {
          id: '0'
        });
        _this0.onboard.billing_address = newBilling;
        if (_this0.flags.shipToBilling) {
          _this0.onboard.shipping_address.first_name = _this0.onboard.user.first_name;
          _this0.onboard.shipping_address.last_name = _this0.onboard.user.last_name;
        }
        return _this0.onBoardAccount();
      };
      this.toggleAddressFieldsValidation = function (toggle) {
        if (_this0.flags.shipToBilling) {
          _this0.billingAddressValidated = toggle;
        } else {
          _this0.shippingAddressValidated = toggle;
        }
      };

      /*
       * Update Phone Number to remove '-' from actual Number.
       * Input: 123-4567-890 Output: 1234567890.
       */
      this.updatePhoneOnSubmit = function () {
        if (_this0.onboard.phone.telephone) {
          _this0.onboard.phone.telephone = _this0.$element.find('.telephone').cleanVal();
        }
      };

      /*
       * Before submit the transaction, need to update shipping address if this.flags.shipToBilling is set
       * Also update city/state/zip value if the city/state/zip element is not present for the selected country
       * TODO: should enhance this function to compare the address entry from metadata based on country,
       *       the tricky part is need to consider to load metadata separately for billing and shipping
       *       if their country is different
       */
      this.updateAddressOnSubmit = function () {
        var billingState = $('#billingAddress #state')[0] || $('#billingAddress #billingState')[0];
        var shippingState = $('#shippingAddress #state')[0] || $('#shippingAddress #shippingState')[0];
        var billingCity = $('#billingAddress #city')[0] || $('#billingAddress #billingCity')[0];
        var shippingCity = $('#shippingAddress #city')[0] || $('#shippingAddress #shippingCity')[0];
        var billingZip = $('#billingAddress #postalCode')[0] || $('#billingAddress #billingPostalCode')[0];
        var shippingZip = $('#shippingAddress #postalCode')[0] || $('#shippingAddress #shippingPostalCode')[0];
        var billingLine1 = $('#billingAddress #line1')[0] || $('#billingAddress #billingLine1')[0];
        var billingLine2 = $('#billingAddress #line2')[0] || $('#billingAddress #billingLine2')[0];

        // Before submit the onboarding request, we need to make sure billing address country code is user selected country
        _this0.onboard.billing_address.country = _index.$locale.country;
        if (!billingCity) {
          delete _this0.onboard.billing_address.city;
        }
        if (!billingState) {
          delete _this0.onboard.billing_address.state;
        }
        if (!billingZip) {
          delete _this0.onboard.billing_address.postal_code;
        }
        if (!billingLine1) {
          delete _this0.onboard.billing_address.line1;
        }
        if (!billingLine2) {
          delete _this0.onboard.billing_address.line2;
        }
        // skip populating shipping address fields for india whitelisted Merchants.
        if (_this0.flags.shipToBilling && !_this0.flags.whiteListedIndiaMerchant) {
          _this0.onboard.shipping_address = _index2.$ShippingAddressModel.create(_this0.token, _this0.onboard.billing_address, {
            first_name: _this0.onboard.user.first_name,
            last_name: _this0.onboard.user.last_name
          });
        } else {
          _this0.onboard.shipping_address.first_name = _this0.onboard.shipping_address.first_name || _this0.onboard.user.first_name;
          _this0.onboard.shipping_address.last_name = _this0.onboard.shipping_address.last_name || _this0.onboard.user.last_name;
          if (!shippingState) {
            delete _this0.onboard.shipping_address.state;
          }
          if (!shippingCity) {
            delete _this0.onboard.shipping_address.city;
          }
          if (!shippingZip) {
            delete _this0.onboard.shipping_address.postal_code;
          }

          // Shipping / Billing Address Difference Detection
          _this0.addrDiffDetected = compareShippingBillingAddrs(_this0.onboard.shipping_address, _this0.onboard.billing_address);
          if (_this0.addrDiffDetected) {
            var addrDiff = {
              is_ship_addr_diff: 1,
              page: 'main:ec:hermes::fullpage-billing:guest:hermes:'
            };
            _angular.$rootScope.$broadcast('addrDiff', addrDiff);
          }
        }
      };

      // This function just logs 'Non-DE' IBAN when user submits the form.
      this.logNonDEIBAN = function (iban_value) {
        if (iban_value && iban_value.slice(0, 2) !== 'DE') {
          _logger.$logger.info("non_DE_IBAN_number_submitted_" + iban_value);
        }
      };

      // Case insensitively compare all string properties of shipping and billing address to detect difference.
      // This method is designed to work with any country with any set of address input fields.
      var compareShippingBillingAddrs = function compareShippingBillingAddrs(shipping_addr, billing_addr) {
        var diffDetected = false;
        for (var prop in shipping_addr) {
          if (shipping_addr.hasOwnProperty(prop) && billing_addr.hasOwnProperty(prop)) {
            if (angular.isString(shipping_addr[prop]) && angular.isString(billing_addr[prop])) {
              if (shipping_addr[prop].toUpperCase() !== billing_addr[prop].toUpperCase()) {
                // Special handling for postal code
                if (prop === 'postal_code') {
                  diffDetected = checkZip(shipping_addr[prop], billing_addr[prop]);
                } else {
                  diffDetected = true;
                }
              }
            }
          }
        }

        // Special case zip check to ignore differences in zipcode format
        function checkZip(zip1, zip2) {
          var longerZip = zip1.length > zip2.length ? zip1 : zip2;
          var shorterZip = longerZip === zip1 ? zip2 : zip1;
          if (longerZip.indexOf(shorterZip) > -1) {
            return false;
          }
          return true;
        }
        return diffDetected;
      };
      var enableSnT = function enableSnT() {
        if (_this0.flags.wps_SnT_flow && !_this0.flags.allowSnTCall) {
          // SnT should be allowed if there is an contingency during OnBoard.
          _this0.flags.allowSnTCall = true;
        }
      };
      var handleAllLoadedForSnT = _angular.$rootScope.$on('allLoaded', enableSnT);
      this.$on('$destroy', handleAllLoadedForSnT);
      this.flags.show_sepa_overlay = this.isUnbranded && this.onboard.fiMode === 'bank';
      _logger.$logger.info('checkout_fpti', {
        is_sepaOverlay: this.flags.show_sepa_overlay ? '1' : '0'
      });
      _logger.$logger.info('sepa_overlay', {
        type: this.onboard.fiMode,
        sepa_overlay: this.flags.show_sepa_overlay,
        lang: _index.$locale.lang,
        unbrandedFlag: this.isUnbranded
      });

      // will be called upon change in flags.mode and flags.poma_flow - opt-in or opt-out
      // and when pre-plan currency conversion API returns conversion data
      var setSubmitButtonText = function setSubmitButtonText() {
        _this0.submitButtonText = (0, _pageProps.submitButtonTextKey)(_this0.flags, _this0.showNewSignupComplianceExp, _this0.flags.hasBuyerFxPrePlanData, _this0.models);
      };
      var updateMerchantReturnUrlDisplay = function updateMerchantReturnUrlDisplay() {
        _this0.showReturnToMerchantUrl = !_this0.models.checkoutCart.isSubscriptionsV1();
      };
      this.$watch('flags.mode', function () {
        setSubmitButtonText();
        updateMerchantReturnUrlDisplay();
      });
      this.$watch('flags.poma_flow', function () {
        setSubmitButtonText();
        updateMerchantReturnUrlDisplay();
      });
      this.$watch('onboard.card.currencyConvData', function () {
        _this0.getSelectedCurrencyCode(_this0.onboard.card.ppconversion);
        setSubmitButtonText();
        updateMerchantReturnUrlDisplay();
      });
      this.openAndContinueSepaOverlay = function () {
        if (_this0.flags.show_sepa_overlay && !_this0.sepa.sepaGuestAgree) {
          _this0.sepa.show = true;
          return true;
        } else {
          return false;
        }
      };

      // If its invoicing flow with Remittance transfer rule (RTR), then a dislaimer content has to be shown to the payer.
      // It applies for US payers paying non US merchants of greater than $15 USD or equivalent.
      var handleInvoicingRegE = function handleInvoicingRegE(currConvData) {
        var isInvoicingFlow = _this0.models.checkoutAppData.get('flags.is_invoice_flow') === true;
        if (isInvoicingFlow) {
          var merchantCountry = _this0.models.checkoutAppData.get('merchant.merchant_country');
          var payerCountry = _this0.locale.country;
          var isRTRAmount;
          if (currConvData) {
            var _currConvData$payment = currConvData.payment_amt,
              _currConvData$payment2 = _currConvData$payment === void 0 ? {} : _currConvData$payment,
              value = _currConvData$payment2.value,
              currency_code = _currConvData$payment2.currency_code;
            if (value && currency_code) {
              isRTRAmount = Number(value) > _constants.RTR_AMOUNT;
              _this0.amountInPayerCurrency = (0, _squid.formatCurrency)(value, currency_code);
              _this0.hasCurrConversion = true;
            }
          } else {
            _this0.hasCurrConversion = false;
            var _ref3 = _this0.models.checkoutCart.get('purchase.amounts.total') || {},
              amount = _ref3.amount,
              _currency_code = _ref3.currency_code;
            isRTRAmount = Number(amount) > _constants.RTR_AMOUNT && _currency_code === 'USD';
          }
          _this0.showInvoicingRegEMsg = isRTRAmount && merchantCountry !== 'US' && payerCountry === 'US';
          var _ref4 = _this0.models.checkoutCart.get('purchase.amounts.total') || {},
            amount_formatted_currency = _ref4.amount_formatted_currency;
          _this0.amountInInvCurrency = amount_formatted_currency;

          // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
          // then we need the value of merchantDisplayName to be 'the merchant' as it is the middle of sentence
          // in content keys used in template
          _this0.nonEmptyMerchantDisplayName = _this0.models.checkoutAppData.getMerchantDisplayName({
            nonEmptyReturnValue: true
          });
        }
      };
      var setInvoicingRegEDetails = function setInvoicingRegEDetails(cardType) {
        if (cardType !== undefined && cardType !== 'VISA') {
          handleInvoicingRegE();
        } else {
          _this0.showInvoicingRegEMsg = false;
        }
      };
      this.$watch('onboard.card.type', setInvoicingRegEDetails);
      var setInvoicingRegEDetailsWithConversion = function setInvoicingRegEDetailsWithConversion(currConvData) {
        if (currConvData !== undefined) {
          handleInvoicingRegE(currConvData);
        } else {
          _this0.showInvoicingRegEMsg = false;
        }
      };
      this.$watch('onboard.card.currencyConvData', setInvoicingRegEDetailsWithConversion);
      var initPaymentRequest = function initPaymentRequest(PaymentRequest) {
        var networks = ['amex', 'diners', 'discover', 'jcb', 'mastercard', 'unionpay', 'visa', 'mir'];
        var types = ['debit', 'credit', 'prepaid'];
        // supportedInstruments includes Android Pay and credit cards.
        var supportedInstruments = [{
          supportedMethods: 'basic-card',
          data: {
            supportedNetworks: networks,
            supportedTypes: types
          }
        }];
        var details = {
          total: {
            label: 'Pay with PayPal',
            amount: {
              currency: 'USD',
              value: '10.00'
            }
          }
        };
        var options = {
          requestPayerName: true,
          requestPayerPhone: true,
          requestPayerEmail: true
        };
        return new PaymentRequest(supportedInstruments, details, options);
      };

      // GPayment Request API to measure impact.
      var logGPayMethods = function logGPayMethods() {
        if (angular.isFunction(window.PaymentRequest)) {
          try {
            var request = initPaymentRequest(window.PaymentRequest);
            if (request.canMakePayment) {
              request.canMakePayment().then(function (result) {
                if (result) {
                  _logger.$logger.info('gpayment_api_can_make_payment');
                } else {
                  _logger.$logger.info('gpayment_api_cannot_make_payment');
                }
              })["catch"](function (err) {
                _logger.$logger.info('gpayment_api_unhandled_error', err);
              });
            } else {
              _logger.$logger.info('gpayment_api_browser_cannot_make_payment');
            }
          } catch (e) {
            // Could happening due to support for modifiers not being present (< chrome v62)
            _logger.$logger.info('gpayment_api_exception_init_gpay', e);
          }
        } else {
          _logger.$logger.info('gpayment_api_browser_not_supported');
        }
      };
      logGPayMethods();

      // To get paymentExperience for 3DS confirmation
      var paymentExperiencePxp = function paymentExperiencePxp() {
        _this0.guestFactory.checkPaymentExperienceTreatment();
      };
      paymentExperiencePxp();
    } // populate
  },
  actions: {
    toggleFIMode: function toggleFIMode(event, mode) {
      var isTesla = this.teslaAddBankEXP ? 'tesla_' : '';

      // Log to FPTI with event name and mode.

      _logger.$logger.info('checkout_fpti', {
        from: this.mode === 'guest' ? 'GUEST_XO' : 'SIGNUP',
        to: "prepare_" + isTesla + mode
      });
      _logger.$logger.info('FI_TOGGLE_CHANGED_TO', mode);
      event.preventDefault();
      this.onboard.fiMode = mode;
      if (mode === 'bank' && this.flags.suppressBankFundedGuestPayments) {
        _logger.$logger.info('bank_tab_blocked_by_elmo');
        this.errorMessage = {
          msgs: errorHandlerHelper.getPageError('pageLevelError.cannotUseBank'),
          type: 'error'
        };
      } else {
        this.errorMessage = '';
      }
    },
    goBack: function goBack(event) {
      (0, _squid.$dispatch)('hermes', {
        redirectToHermes: true,
        token: this.token
      });
    },
    // Enable user to edit shipping address
    editShippingAddress: function editShippingAddress() {
      this.flags.showSingleAddress = false;
      this.flags.allowEditShipping = true;
      this.flags.disallowShipToBilling = true;
      this.flags.shipToBilling = false;
      this.flags.hideShippingAddress = false;
      _angular.$rootScope.$emit('change_in_shipping_address');
    },
    logWebviewBackButtonClick: function logWebviewBackButtonClick() {
      if (this.flags.backButtonWebview) {
        _logger.$logger.info('BACK_BUTTON_FOR_WEBVIEW_CLICKED');
      }
    },
    updatePageLevelErrorMessage: function updatePageLevelErrorMessage(msgs, type) {
      if (msgs === void 0) {
        msgs = [];
      }
      if (type === void 0) {
        type = 'error';
      }
      this.errorMessage = {
        msgs: msgs,
        type: type
      };
    },
    handleCtaClick: function handleCtaClick(isValid) {
      if (this.onboard.fiMode === 'bank' && this.flags.suppressBankFundedGuestPayments) {
        _logger.$logger.info('bank_submit_blocked_by_elmo');
        this.errorMessage = {
          msgs: errorHandlerHelper.getPageError('pageLevelError.cannotUseBank'),
          type: 'error'
        };
        return;
      }

      // Log to help debug the conversion gap between lite & xoon
      var transitionName = !isValid ? 'process_invalid_billing_page_submission' : 'process_billing_page';
      _logger.$logger.info('checkout_fpti', {
        from: 'BILLING',
        to: transitionName
      }).flush(true);
      this.actions.positionToErrorField();
    },
    onSubmit: function onSubmit() {
      if (this.onboard.fiMode === 'bank' && this.flags.suppressBankFundedGuestPayments) {
        _logger.$logger.info('bank_submit_blocked_by_elmo');
        this.errorMessage = {
          msgs: errorHandlerHelper.getPageError('pageLevelError.cannotUseBank'),
          type: 'error'
        };
        return;
      }

      // SCA - Strong Customer Authentication
      // 2fa - 2 factor authentication
      // phoneConfirmation - we send a 6 digit otp to user's mobile number to authenticate
      // the user before signup (it does not apply to guest flows)
      if (this.flags.mode === 'signup' && this.flags.isphoneConfirmationExpTreatment && !this.flags.phoneConfirmed) {
        this.flags.showPhoneConfirmationPopup = true;
        return;
      }

      // Remove backendError class upon submit on all fields
      // This is necessary to clear backend error on fields like first name
      // and last name, that is not having frontend validation
      $(this.sectionElement + " .backendError").removeAttr('aria-invalid').removeClass('backendError');

      // Added logging for non-DE IBAN numbers: US1022248
      this.logNonDEIBAN($(this.sectionElement + " #ibanNumber").val());

      // Added a condition check for pxp experimentation for Sepa Overlay US755520
      if (this.openAndContinueSepaOverlay()) {
        return;
      }
      if (this.isInstantUpdateFlow) {
        var currentShippingAddress = this.flags.shipToBilling ? this.onboard.billing_address : this.onboard.shipping_address;
        if ((0, _util2.hasAddressChanged)(this.trackSntReq.address, currentShippingAddress)) {
          _logger.$logger.info('address_changed_trigger_snt');
          _angular.$rootScope.$emit('submission_triggered');
          return;
        }
        if (!this.flags.instantUpdateShippingRegionSupported) {
          _logger.$logger.info(this.flags.mode + "_submit_not_allowed_instant_update_shipping_region_unsupported");
          return;
        }
      }
      if (this.flags.wps_SnT_flow || this.isInstantUpdateFlow) {
        /**
         * During submit , if SnT is triggered , do not allow Pay .
         */
        if (!this.flags.allowPayWithSnT) {
          _logger.$logger.info(this.flags.mode + "_submit_not_allowed_without_SnT_completion");
          return;
        }
        // Any SnT Call triggered when xoon updates the address for checkout should not be allowed.
        this.flags.allowSnTCall = false;
      }
      _logger.$logger.info(this.flags.mode + '_submit', {
        type: this.onboard.fiMode === 'bank' ? 'BANK' : this.onboard.card.type,
        country: _index.$locale.country,
        lang: _index.$locale.lang
      }).flush();
      if (this.flags.nationalIdFlag) {
        this.onboard.nationalIdModel = _directive.$NationalIdModel.instance(_angular.$rootScope.token);
      }
      if (this.flags.mode !== 'signup') {
        delete this.onboard.user.password;
      }
      this.updateAddressOnSubmit();
      this.updatePhoneOnSubmit();

      // CUP OTP popup
      if (this.needOTPForAddCard && this.flags.cupDetected && !this.flags.upopDetected) {
        this.flags.allowSnTCall = true;
        // CUP Secure card is not supported in our flow
        return this.handleFIContingencies({}, 'creditcard');
      }
      var merchantPassedShipping = this.models.checkoutCart.get('purchase.shipping_address') || this.models.checkoutCart.get('billing.shipping_address');
      _logger.$logger.info('address_normalization', {
        from: 'checkout_guest',
        to: 'prepare_address_normalization',
        shipping_cnty: this.onboard.shipping_address.country,
        is_ship_addr_diff: this.addrDiffDetected,
        is_billing_present: this.models.checkoutCart.billing_address ? true : false,
        is_shipping_present: merchantPassedShipping ? true : false
      });
      if ((0, _index.$feature)('addressNormalization')) {
        this.showAddressNormalizationLightbox = true;
      } else {
        // Making sure incontext shipping methods are populated
        if (this.shippingOptionsFeature.hasShippingOptions() && !this.shippingOptionsFeature.selectedShippingOption) {
          this.errorMessage = {
            type: 'error',
            msgKeys: ['shipping.bopisErrorMessage']
          };
          return;
        }
        return this.onBoardAccount();
      }
    },
    positionToErrorField: function positionToErrorField() {
      var _this1 = this;
      var errorFields = $('.backendError:visible, input:visible.ng-invalid, select:visible.ng-invalid');
      var firstErrorField = errorFields && errorFields.length && errorFields[0];

      // Sets the styling for validation on singlePagePaymentForm
      this.validated = true;

      // AB testing - fixes the revious bug of marking the email and password
      // as required when the user selects the 'yes' button for the first time
      this.flags.ignoreValidationTheFirstTime = false;
      if (firstErrorField) {
        firstErrorField.focus();
      } else {
        errorHandlerHelper.scrollToElement();
      }
      $('.backendError:visible').on('blur', function (event) {
        $(_this1).removeClass('backendError');
      });
      if ($('#installments').length) {
        $('#paymentMethod').addClass('ng-invalid');
      } else {
        $('#paymentMethod').removeClass('ng-invalid');
      }
      return true;
    },
    onThreedsModalClose: function onThreedsModalClose() {
      this.showThreedsPopup = false;
      _logger.$logger.info("3DS_V2_MODAL_WINDOW_CLOSED_" + this.threedsData.integrationType);
      if (this.threedsData.integrationType === 'ADD_CARD') {
        this.guestFactory.onThreedsCompleteAddFi('CLOSE');
      } else {
        this.guestFactory.onThreedsCompleteTransaction('CLOSE');
      }
    },
    onPhoneConfirmationClose: function onPhoneConfirmationClose() {
      this.flags.showPhoneConfirmationPopup = false;
    },
    onPhoneConfirmationSuccess: function onPhoneConfirmationSuccess() {
      this.flags.phoneConfirmed = true;
      this.flags.showPhoneConfirmationPopup = false;

      // We cannot call onboardAccount here. If we do, then we
      // are going to skip other checks like address_normalization
      // that lives in onSubmit
      this.actions.onSubmit();
    }
  }
});
_angular.$q;
_angular.$rootScope;
_ul.$ul;
_squid.$contentVersion;
_squid.$experiment;
_squid.$renderContent;
_squid.$dispatch;
_squid.$meta;
_squid.formatCurrency;
_squid.$elmo;
_index.$Component;
_index.$config;
_index.$feature;
_index.$locale;
_index.$util;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutPayeeModel;
_index2.$CheckoutCartModel;
_index2.$ShippingAddressModel;
_index2.$InstallmentOptionsModel;
_subscription.$SubscriptionsV1Model;
_index3.$CheckoutInputDataModel;
_index4.$ShippingRuleSummaryModel;
_index5.$OnboardModel;
_index5.$OnboardUserModel;
_index5.$OnboardPhoneModel;
_index6.$BankModel;
_index6.$CardModel;
_index6.$BillingAddressModel;
_index7.$AuthModel;
_logger.$logger;
_uiRouter.$state;
_index8.$DeviceInfo;
_index9.$fireMORSBeacon;
_directive.$NationalIdModel;
_util.$fiErrorUtil;
_util2.hasAddressChanged;
_util2.hasDialingCodeOverride;
_shippingChangeFeature.createShippingChangeFeature;
_pageProps.upopConfirmButtonTextKey;
_pageProps.submitButtonTextKey;
_pageProps.getFItoggleContentKeys;
_util3.sanitizeStateFields;
_util3.getThreedsDataForAddFi;
_util3.frenchDomCountryChange;
_constants.RTR_AMOUNT;
_index0.$MerchantPreferenceModel;
_address.$ResidentialAddressModel;
_index1.$UserAgreementConsentModel;
_helper.signupLib;
_xoShippingOptions.$xoShippingOptions; // eslint-disable-line no-unused-vars;

_shippingOptionsFeature.buildShippingOptionsFeature;
_guestFactory.$GuestFactory;
_guestFactory.ERROR_CODE;
_guestFactory.ROUTE;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/emailInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-validation/dist/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoEmailInput', {
  tag: 'xo-email-input',
  template: _template["default"],
  props: {
    user: {
      type: 'var',
      required: false
    },
    disabled: {
      type: 'var',
      required: false
    },
    hideHelper: {
      type: 'var',
      // flow: Optional string, if "signup" then use the Signup tooltip
      required: false
    },
    flags: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.flags = this.flags ? this.flags : {};
      var setEmailToolTip = function setEmailToolTip() {
        _this.emailToolTip = _this.flags.mode === 'signup' ? 'common.emailHelper' : 'common.emailTooltipGuest';
      };
      this.$watch('flags.mode', setEmailToolTip);
    }
  }
});
_squid.$Component;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/emailInput/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/emailInput/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"inputField emailField confidential\" content floating-label directionality>\n    <input ng-model=\"user.email\" id=\"email\" name=\"email\" type=\"email\" value=\"\" autocapitalize=\"off\"\n           aria-required=\"false\" xo-validation='{ \"validator\": \"validEmail\" }' autocomplete=\"off\"\n           track-focus-and-blur=\"email\"\n           data-error-key='email.invalid'\n           ng-disabled=\"disabled\" xo-error-tooltip required />\n    <div class=\"emailHelper\" ng-if=\"!hideHelper\">\n        <button id=\"verifyHelp\"\n           class=\"verifyHelp\"\n           aria-label=\"{{ content('email.whyTooltip') }}\"\n           >\n        </button>\n    </div>\n    <label for=\"email\">\n        {{ content('index.EmailLabel') }}\n    </label>\n    <xo-tooltip trigger=\"#verifyHelp\" ng-if=\"!hideHelper\">\n        <div id=\"emailToolTipText\" class=\"tip tipDesc emailToolTip\">\n            <span ng-bind-html=\"htmlContent(emailToolTip)\">\n            </span>\n        </div>\n    </xo-tooltip>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.scrollToElement = exports.getPageError = exports.getErrorType = exports.get3dsPageWarning = exports.errorHandler = exports.addFieldError = void 0;
var _errorHandlerConstants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/errorHandlerConstants.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var SECTION_ELEMENT = '#singlePagePayment';
var scrollToElement = exports.scrollToElement = function scrollToElement(fieldName) {
  var element = $("[name=" + fieldName + "]");
  var notifications = $('#notifications');
  var logo = $('#paypalLogo');
  if (element.length) {
    element.focus();
  } else {
    var focusDiv = notifications.length ? notifications : logo;

    // Focus notifications div or logo div
    // This triggers scroll to notifications or logo from
    // hideSpinner() function
    focusDiv.attr('tabindex', '-1').focus();
  }
};
var getPageError = exports.getPageError = function getPageError(contentKey, compileMessageWith) {
  var messages = [];
  var msg;
  if (compileMessageWith) {
    msg = (0, _squid.$renderContent)(contentKey, compileMessageWith);
  } else {
    msg = _squid.$locale.content.get(contentKey);
  }
  messages.push(msg);
  scrollToElement();
  return messages;
};
var get3dsPageWarning = exports.get3dsPageWarning = function get3dsPageWarning(resolve3DS, contentKey) {
  var messages = [];
  var cardType = resolve3DS.type;
  var cardLast4 = resolve3DS.number;
  messages.push((0, _squid.$renderContent)(contentKey, {
    cardType: cardType,
    last4: cardLast4
  }));
  scrollToElement();
  return messages;
};
var addFieldError = exports.addFieldError = function addFieldError(errorData, sectionElement) {
  if (sectionElement === void 0) {
    sectionElement = SECTION_ELEMENT;
  }
  (errorData.fields || []).forEach(function (field) {
    var $field = $(sectionElement).find("[ng-model=\"" + field + "\"]");
    $field.addClass('backendError');
  });
};
var getErrorType = exports.getErrorType = function getErrorType(errorCode, mode, treatment) {
  if (errorCode === 'ACCOUNT_ALREADY_EXISTS' && mode !== 'signup' && treatment) {
    return 'info';
  }
  return 'error';
};

/**
 * Highlight the Error Fields by ng-model
 * @param errorData
 * @param element
 * @param modelPrefix
 */
var addFieldErrors = function addFieldErrors(errorData, element, modelPrefix) {
  if (errorData.fields && errorData.fields.length) {
    errorData.fields.forEach(function (field) {
      var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');
      $field.addClass('backendError');
      $field.attr('aria-invalid', true);
    });
  }
  $(element).find('.backendError:first').focus();
};

/**
 * Highlight the Error Fields by element name
 * @param errorData
 * @param element
 * @param modelPrefix
 */
var addFieldErrorsByName = function addFieldErrorsByName(errorData, element, modelPrefix) {
  if (errorData.fields && errorData.fields.length) {
    errorData.fields.forEach(function (field) {
      var fieldName;
      if (modelPrefix && field.field && field.field.length > 0) {
        // Add prefix with CamelCase of field name
        fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
      } else {
        fieldName = field.field;
      }
      var $field = $(element).find('[name="' + fieldName + '"]');
      $field.addClass('backendError');
      $field.attr('aria-invalid', true);
    });
  }
  $(element).find('.backendError:first').focus();
};
var errorHandler = exports.errorHandler = function errorHandler(message, errorData, positionToErrorField, mode, sectionElement) {
  if (sectionElement === void 0) {
    sectionElement = SECTION_ELEMENT;
  }
  var messages = [];
  var prefix = mode === 'guest' ? 'guest' : '';

  // TODO: this block does same thing as next block, need to depricate this
  // Next block has better features and stable on live
  if (errorData && errorData.message === 'VALIDATION_ERROR') {
    angular.forEach(errorData.errorCodes, function (errCode) {
      var validationPageError = _errorHandlerConstants.validationErrorMap[errCode];
      if (validationPageError) {
        messages = getPageError(validationPageError.contentKey);
        _logger.$logger.info('HANDLED_VALIDATION_ERROR', errCode);
      } else {
        // There are multiple services that can throw generic VALIDATION_ERROR.
        // We have chosen to use genericError for the time being since we can't pinpoint the error class.
        messages = getPageError('genericError.genericError');
        _logger.$logger.info('UNHANDLED_VALIDATION_ERROR', errCode);
      }
    });
  }
  var scrollToTop = false;
  angular.forEach(errorData, function (err) {
    // TODO: need to break if case nesting
    if (err) {
      var errElMap = _errorHandlerConstants.errorElementMap[err] || _errorHandlerConstants.errorElementMap[err.errorCode] || _errorHandlerConstants.errorElementMap[err.code];
      if (errElMap) {
        var element = sectionElement + (errElMap.element ? ' ' + errElMap.element : '');
        if (errElMap.name) {
          // Highlight the Error Fields by name
          addFieldErrorsByName(errElMap.fields && errElMap || err.details || err, element, errElMap.name);
        } else {
          // Highlight the Error Fields by ng-model
          addFieldErrors(errElMap.fields && errElMap || err.details || err, element, errElMap.model);
        }
        if (errElMap.pageError) {
          // If guest specific content key (guestcontentKey) is not found, then pickup generic content key
          var contentKey = errElMap.pageError[prefix + "contentKey"] || errElMap.pageError.contentKey;
          messages = getPageError(contentKey, errElMap.compileMessageWith);
          scrollToTop = errElMap.scrollToTop ? true : false;
        }
      } else {
        addFieldError(err);
      }
    }
  });
  if (!scrollToTop) {
    positionToErrorField();
  }
  return messages;
};
_errorHandlerConstants.errorElementMap;
_errorHandlerConstants.validationErrorMap;
_squid.$renderContent;
_squid.$locale;
_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/pageProps.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.upopConfirmButtonTextKey = exports.submitButtonTextKey = exports.getFItoggleContentKeys = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/constants.js");
var _constants2 = __webpack_require__("../node_modules/xo-guest-components/src/guest/tesla-add-bank/constants.js");
var upopConfirmButtonTextKey = exports.upopConfirmButtonTextKey = function upopConfirmButtonTextKey(flags) {
  if (flags.wpsFlow) {
    return 'confirmUpop.confirmAndContinue';
  } else if (flags.commit) {
    return 'confirmUpop.confirmAndPay';
  }
  return 'confirmUpop.confirmAndContinueToMerch';
};
var getCommitOrContinueText = function getCommitOrContinueText(flags, mode, showSignupCompliance, hasConversion, models) {
  var showCurrency = mode === 'guest' && (flags.buyerFxTreatment || '').includes('treatment_2') && hasConversion;
  var isRecurringPayment = models.checkoutCart.isRecurringPayment();
  var isWpsSubscription = models.checkoutAppData.is_wps_subscription_flow() || models.checkoutCart.isSubscriptionsV1();
  var isWpsInstallmentPlan = models.checkoutAppData.is_wps_installmentplan_flow();
  var isWpsAutobilling = models.checkoutAppData.isWpsAutobillingFlow();
  var isSubscription = isWpsSubscription || isWpsInstallmentPlan || isWpsAutobilling || isRecurringPayment;
  var isPaymentServiceAct = (0, _index.$feature)('paymentServiceAct', false, _index.$locale.country) && (models.checkoutCart.isBilling() || isSubscription);
  var commitType = flags.commit ? "commit" + (showCurrency ? 'InCurrency' : '') : "notCommit" + (showCurrency ? 'InCurrency' : '');
  var group = showSignupCompliance ? 'US' : 'ROW';
  if (isPaymentServiceAct) {
    group = 'SG';
  }
  return isSubscription ? _constants.SUBSCRIPTION_SUBMIT_BUTTON_KEY[mode][group][commitType] : _constants.SUBMIT_BUTTON_TEXT_KEY_MAP[mode][group][commitType];
};
var submitButtonTextKey = exports.submitButtonTextKey = function submitButtonTextKey(flags, showSignupCompliance, hasConversion, models) {
  var mode = flags.mode === 'signup' ? 'signup' : 'guest';
  if (flags.showPomaUi) {
    mode = flags.poma_flow ? 'pomaSignup' : 'guest';
  }
  return getCommitOrContinueText(flags, mode, showSignupCompliance, hasConversion, models);
};

// Returns keys depending on the specific flow. (e.g, Tesla add bank)
var getFItoggleContentKeys = exports.getFItoggleContentKeys = function getFItoggleContentKeys(teslaAddBank, teslaFIDefault) {
  if (!teslaAddBank) {
    return _constants2.DEFAULT_TOGGLE_FI;
  }

  // Treatment A - 'bank' selected as default.
  if (teslaAddBank && teslaFIDefault === 'bank') {
    return _constants2.TESLA_TOGGLE_FI_BANK;
  }

  // Treatment B - 'card' selected as default.
  return _constants2.TESLA_TOGGLE_FI_CARD;
};
_index.$feature;
_index.$locale;
_constants.SUBMIT_BUTTON_TEXT_KEY_MAP;
_constants.SUBSCRIPTION_SUBMIT_BUTTON_KEY;
_constants2.DEFAULT_TOGGLE_FI;
_constants2.TESLA_TOGGLE_FI_BANK;
_constants2.TESLA_TOGGLE_FI_CARD;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/shippingChangeFeature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.createShippingChangeFeature = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _factory = __webpack_require__("../node_modules/xo-shipping-change/src/factory.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var promiseNoop = function promiseNoop() {
  return (0, _squid.$promise)();
};
var createShippingChangeFeature = exports.createShippingChangeFeature = function createShippingChangeFeature(_ref) {
  var orderID = _ref.orderID,
    checkoutCart = _ref.checkoutCart,
    checkoutAppData = _ref.checkoutAppData,
    flags = _ref.flags,
    _ref$callback = _ref.callback,
    callback = _ref$callback === void 0 ? promiseNoop : _ref$callback;
  var feature = {
    message: '',
    showForm: false,
    interstitialResolver: null,
    showCartChanged: function showCartChanged() {},
    showOrResolveInterstitial: function showOrResolveInterstitial() {},
    handleOnShippingChange: function handleOnShippingChange() {}
  };
  feature.showCartChanged = function () {
    flags.showCartChanged = true;
  };
  feature.showOrResolveInterstitial = function (cartHasChanged, rejected) {
    if (rejected) {
      feature.message = (0, _squid.$renderContent)('shippingMethod.shippingRegionUnsupported', {
        merchant: checkoutAppData.getMerchantDisplayName()
      });
      feature.showForm = true;
      return callback().then(function () {
        return feature.showCartChanged();
      });
    }
    if (cartHasChanged) {
      feature.message = (0, _squid.$renderContent)('shippingCallback.updated', {
        amount: checkoutCart.get('purchase.amounts.total.amount_formatted_currency')
      });
      feature.showForm = false;
      return callback().then(function () {
        return feature.showCartChanged();
      });
    }
    feature.interstitialResolver();
  };
  feature.handleOnShippingChange = function () {
    if (!window.xprops || !window.xprops.onShippingChange) {
      return (0, _squid.$promise)();
    }
    var loadingMsg = _squid.$locale.content.get('shippingCallback.loading');
    _squid.$event.emit('loading');
    _squid.$event.emit('loadingMessage', loadingMsg);
    flags.showCartChanged = false;
    var checkoutSession = _index.$CheckoutSessionModel.instance(orderID);
    var shippingChangeFactory = (0, _factory.$ShippingChangeFactory)({
      orderID: orderID,
      checkoutAppData: checkoutAppData,
      checkoutCart: checkoutCart,
      appName: 'xoon'
    });
    return shippingChangeFactory.getPayload(checkoutSession.get('shipping')).then(function (payload) {
      _logger.$logger.info('shipping_change_payload_recieved', payload);
      return shippingChangeFactory.callOnShippingChange(payload);
    }).then(function (_ref2) {
      var cartHasChanged = _ref2.cartHasChanged,
        rejected = _ref2.rejected;
      _logger.$logger.info('shipping_change_called', {
        cartHasChanged: cartHasChanged,
        rejected: rejected
      });
      _squid.$event.emit('loaded');

      /**
       * There's currently a pending promise that's
       * waiting on a successful response from the interstitial
       * in order to continue.
       */
      if (feature.interstitialResolver) {
        return feature.showOrResolveInterstitial(cartHasChanged, rejected);
      }
      return _squid.$promise.resolver(function (resolve) {
        feature.interstitialResolver = resolve;
        return feature.showOrResolveInterstitial(cartHasChanged, rejected);
      });
    })["catch"](function (err) {
      _squid.$event.emit('loaded');
      _logger.$logger.error('shipping_change_error', err);
      return _uiRouter.$state.go('checkout.genericError', {
        code: 'DEFAULT'
      });
    });
  };
  return feature;
};
_squid.$promise;
_squid.$renderContent;
_squid.$locale;
_squid.$event;
_uiRouter.$state;
_index.$CheckoutSessionModel;
_factory.$ShippingChangeFactory;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/shippingOptionsFeature.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.buildShippingOptionsFeature = void 0;
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _xoShippingOptions = __webpack_require__("../node_modules/xo-shipping-options/src/index.js");
var buildShippingOptionsFeature = exports.buildShippingOptionsFeature = function buildShippingOptionsFeature(token) {
  var checkoutCart = _index.$CheckoutCartModel.instance(token);
  var selectOption = function selectOption(option) {
    if (!option) {
      return;
    }
    return (0, _xoShippingOptions.selectShippingOption)(token, option).then(function () {
      checkoutCart.invalidate();
      checkoutCart.api.cache = false;
      return checkoutCart.reload().then(function () {
        return option;
      });
    });
  };
  var checkForOptions = function checkForOptions() {
    var shippingOptions = [];
    var selectedShippingOption = null;
    return (0, _xoShippingOptions.getShippingOptions)(token).then(function (options) {
      shippingOptions = options;
    }).then(function () {
      return (0, _xoShippingOptions.getSelectedShippingOption)(token);
    }).then(function (selectedOption) {
      selectedShippingOption = selectedOption;
    }).then(function () {
      return {
        options: shippingOptions,
        selectedOption: selectedShippingOption
      };
    });
  };
  var feature = {
    shippingOptions: [],
    selectedShippingOption: null,
    hasShippingOptions: function hasShippingOptions() {
      return Boolean(feature.shippingOptions && feature.shippingOptions.length);
    },
    selectShippingOption: function selectShippingOption(option, userSelected) {
      if (option) {
        return selectOption(option, userSelected).then(function (shippingOption) {
          feature.selectedShippingOption = shippingOption;
        });
      }
    },
    checkForShippingOptions: function checkForShippingOptions() {
      return checkForOptions().then(function (_ref) {
        var options = _ref.options,
          selectedOption = _ref.selectedOption;
        feature.shippingOptions = options;
        feature.selectedShippingOption = selectedOption;
      });
    }
  };
  feature.checkForShippingOptions();
  return feature;
};
_index.$CheckoutCartModel;
_xoShippingOptions.getShippingOptions;
_xoShippingOptions.selectShippingOption;
_xoShippingOptions.getSelectedShippingOption;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.sanitizeStateFields = exports.getThreedsDataForAddFi = exports.get3DSDataForSwitch = exports.frenchDomCountryChange = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
// There are two ways to prefill state related info.
// NVP and REST integration. For NVP the shippingAddress.state || billingAddress.state is capitalized before landing here
// REST does not do any capitalization.

// In order to make prefilling consistent across all integrations, we convert them to uppercase!
var sanitizeStateFields = exports.sanitizeStateFields = function sanitizeStateFields(shippingAddress, billingAddress) {
  if (shippingAddress && shippingAddress.state) {
    shippingAddress.state = shippingAddress.state.toUpperCase();
  }
  if (billingAddress && billingAddress.state) {
    billingAddress.state = billingAddress.state.toUpperCase();
  }
};
var isBillingFlow = function isBillingFlow(scope) {
  return scope.models.checkoutCart.isBilling() || scope.models.checkoutCart.isSubscriptionsV1() || scope.models.checkoutAppData.is_wps_subscription_flow() || scope.models.checkoutAppData.isWpsAutobillingFlow() || scope.models.checkoutAppData.is_wps_installmentplan_flow();
};
var get3DSDataForSwitch = exports.get3DSDataForSwitch = function get3DSDataForSwitch(checkoutSession, scope) {
  var threeDSResolutionData = checkoutSession.get('threeDSResolutionData');
  var _ref = threeDSResolutionData.resolutions || [],
    resolutions = _ref[0];
  var _ref2 = resolutions || {},
    _ref2$funding_instrum = _ref2.funding_instrument_details,
    _ref2$funding_instrum2 = _ref2$funding_instrum === void 0 ? {} : _ref2$funding_instrum,
    _ref2$funding_instrum3 = _ref2$funding_instrum2.payment_card,
    payment_card = _ref2$funding_instrum3 === void 0 ? {} : _ref2$funding_instrum3,
    _ref2$funding_instrum4 = _ref2$funding_instrum2.three_ds_contingency_context,
    three_ds_contingency_context = _ref2$funding_instrum4 === void 0 ? {} : _ref2$funding_instrum4;

  // This will remain empty object until planning returns n/w logo in the 3DS contingency data.
  var networkLogo = {};
  var creditCardId = payment_card.id; // ex: CC-XUBYA6TH5RJ2G
  /**
   * In cases where currencyConversion was done prior to 3DS flow, if VENDOR option was selected,
   * then fundingOptions.plan.sources exists in checkoutSession and contains the correct amount.
   * if PAYPAL option was selected, then we can use the original plan.sources object.
   */
  var plans = checkoutSession.get('fundingOptions.plan.sources', null) || checkoutSession.get('plan.sources', null);
  var plan = plans && plans.filter(function (e) {
    return e.instrument_id === creditCardId;
  })[0].amount || null;
  var jwtInfo = {
    jwtIssuer: three_ds_contingency_context.auth_specification.issuer,
    jwtOrgUnitId: three_ds_contingency_context.auth_specification.org_unit_id,
    jwtDuration: three_ds_contingency_context.auth_specification.validity_duration
  };
  var threeDSContingencySource = three_ds_contingency_context.source,
    threeDSContingencyReason = three_ds_contingency_context.reason;
  var bank_identification_number = payment_card.bank_identification_number,
    billing_address = payment_card.billing_address,
    number_encrypted = payment_card.number_encrypted,
    card_product_class = payment_card.card_product_class,
    expire_month = payment_card.expire_month,
    expire_year = payment_card.expire_year,
    currency_code = payment_card.currency_code;
  var amount = isBillingFlow(scope) ? {
    currencyCode: currency_code,
    currencyValue: '0.00'
  } : {
    currencyCode: plan && plan.currency_code,
    currencyValue: plan && plan.amount
  };
  return {
    cardBin: bank_identification_number,
    // Needed for JWT
    ddcUrl: three_ds_contingency_context.device_data_collection_url,
    cardBrandProcessed: three_ds_contingency_context.card_brand_processed,
    authenticationProvider: three_ds_contingency_context.authentication_provider,
    jwtInfo: jwtInfo,
    // Needed for JWT
    referenceId: three_ds_contingency_context.reference_id,
    integrationType: 'TRANSACTION',
    billing_address: billing_address,
    number_encrypted: number_encrypted,
    card_product_class: card_product_class,
    expire_month: expire_month,
    expire_year: expire_year,
    amount: amount,
    networkLogo: networkLogo,
    initThreedsData: {
      referenceId: three_ds_contingency_context.reference_id,
      billing_address: billing_address,
      number_encrypted: number_encrypted,
      card_product_class: card_product_class,
      expire_month: expire_month,
      expire_year: expire_year,
      amount: amount,
      threeDSContingencySource: threeDSContingencySource,
      threeDSContingencyReason: threeDSContingencyReason,
      creditCardId: creditCardId
    }
  };
};
var getThreedsDataForAddFi = exports.getThreedsDataForAddFi = function getThreedsDataForAddFi(fiConfirmationDetails) {
  if (!fiConfirmationDetails) {
    return null;
  }
  var threeDSConfirmationDetails = fiConfirmationDetails.three_ds_confirmation_details;
  if (threeDSConfirmationDetails && threeDSConfirmationDetails.three_ds_required_during_add_card) {
    var supplementalData = threeDSConfirmationDetails.supplemental_data_details || {};
    return {
      // Decides the type of integration for threeDS calls
      // ADD_CARD - fi apis
      // TRANSACTION - switch apis
      integrationType: 'ADD_CARD',
      bypassConfirmationProcess: fiConfirmationDetails.bypassConfirmationProcess,
      cardBin: supplementalData.bank_identification_number,
      confirmationMethod: fiConfirmationDetails.confirmation_method,
      ddcUrl: supplementalData.device_data_collection_url,
      cardBrandProcessed: supplementalData.card_brand_processed,
      authenticationProvider: supplementalData.mpi_vendor_3ds,
      jwtInfo: {
        jwtIssuer: supplementalData.jwt_issuer,
        jwtOrgUnitId: supplementalData.jwt_org_unit_id,
        jwtDuration: supplementalData.jwt_duration
      },
      referenceId: threeDSConfirmationDetails.reference_id,
      networkLogo: supplementalData.network_logo
    };
  }
  return null;
};

/**
 * @description uses $locale metadata to retrieve territory name
 * @param {String} countryCode eg: "GP"
 * @returns {String} Territory name. Example GP: Guadaloupe
 */

var getTerritoryNameFromCountryCode = function getTerritoryNameFromCountryCode(countryCode) {
  return _squid.$locale.metadata.territory.filter(function (countryObj) {
    return countryObj.code === countryCode;
  })[0].name;
};

/**
 * @description: changes the user's country to France(FR) for the French DOM regions
 * which are the french overseas territories. The previous country code will be set as state
 * previously retrieving the territory name. And the billing/residential country is set to France
 *
 * @param {*} onboard: this.onboard, containing addresses and user data
 */
var frenchDomCountryChange = exports.frenchDomCountryChange = function frenchDomCountryChange(onboard) {
  // 1. User legal country
  onboard.user.country = 'FR';
  onboard.user.countryOfResidence = 'FR';

  // 2. Billing Address
  onboard.billing_address.state = getTerritoryNameFromCountryCode(onboard.billing_address.country);
  onboard.billing_address.country = 'FR';

  // 3. Shipping Address
  onboard.shipping_address.state = getTerritoryNameFromCountryCode(onboard.shipping_address.country);
  onboard.shipping_address.country = 'FR';

  // 4. Residential Address (compared values must match)
  if (onboard.residential_address_present) {
    onboard.residential_address.state = getTerritoryNameFromCountryCode(onboard.residential_address.country);
    onboard.residential_address.country = 'FR';
  }
};
_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/nationality/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/nationality/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/nationality/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoNationality', {
  tag: 'xo-nationality',
  template: _template["default"],
  props: {
    user: {
      type: 'var',
      required: true
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      var bindLocalizedCountries = function bindLocalizedCountries() {
        var guestBlockedCountries = _squid.$config.guestBlockedCountries || [];
        _this.metadata = angular.copy(_squid.$locale.metadata);
        _this.countries = _this.metadata.territory.filter(function (c) {
          // don't show the blocked countries in the dropdown
          return !(guestBlockedCountries.indexOf(c.code) > -1);
        });
      };
      bindLocalizedCountries();
      this.$on('metadataChange', bindLocalizedCountries);
    }
  }
});
_squid.$Component;
_squid.$locale;
_squid.$config;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/nationality/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/nationality/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"nationalityDropDown\" class=\"dropdown confidential nationality clearfix inputField\"\n     floating-label-dropdown content>\n    <select xo-dropdown id=\"nationality\"\n            name=\"nationality\"\n            ng-model=\"user.nationality\"\n            ng-options=\"countryList.code as countryList.name for countryList in countries | filter: {country: '!others'} | filter: {country: '!change'}\"\n            aria-labelledby=\"nationalityLabel\"\n            xo-error-tooltip\n            required>\n    </select>\n    <label id=\"nationalityLabel\" for=\"nationality\">{{ content('country.nationality') }}</label>\n</div>"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _index5 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _contentKeys = __webpack_require__("../node_modules/xo-guest-components/src/lib/contentKeys.js");
var _pxpExperimentConstants = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/constants/pxpExperimentConstants.js"));
__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/guest/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/signup/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/marketingOffers/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('xoOnboardOptions', {
  tag: 'xo-onboard-options',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    flags: {
      type: 'var',
      required: false
    },
    mode: {
      type: 'var',
      required: false
    },
    onboard: {
      type: 'var',
      required: false
    },
    singlePagePaymentForm: {
      type: 'var',
      required: false
    },
    validated: {
      type: 'var',
      required: false
    },
    sepa: {
      type: 'var',
      required: false
    },
    merchant: {
      type: 'var',
      required: false
    },
    isUnbranded: {
      type: 'var',
      required: false
    },
    residentialAddress: {
      type: 'var',
      required: false
    },
    useUserAgreementCustomLink: {
      type: 'var',
      required: false
    },
    userAgreementLink: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutInputData: _index2.$CheckoutInputDataModel.instance(this.token).retrieve(),
        payee: _index3.$CheckoutPayeeModel.instance(this.token).retrieve(),
        checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.token).retrieve(),
        checkoutCart: _index3.$CheckoutCartModel.instance(this.token).retrieve(),
        flowEligibility: _index3.$FlowEligibilityModel.instance(this.token).retrieve()
      };
    },
    populateFlags: function populateFlags(resolvers) {
      var _this = this;
      return resolvers.models.then(function (models) {
        // Saving various flow indicators in to flags for future use.
        // These flags can be reused in this file instead of referring it from models always
        var _ref = models.payee || {},
          _ref$merchant = _ref.merchant,
          _ref$merchant2 = _ref$merchant === void 0 ? {} : _ref$merchant,
          id = _ref$merchant2.id;

        // is_wps_flow indicator in checkoutAppData will be undefined for ebay flows
        // isEbaytxn() will be true only for prox flows.
        var flowFLags = {
          isWpsFlow: models.checkoutAppData.is_wps_flow(),
          isEcFlow: !models.checkoutAppData.is_wps_flow() && !models.checkoutInputData.isEbayTxn(),
          isInvoiceFlow: models.checkoutAppData.isInvoiceFlow(),
          isWpsSubscription: models.checkoutAppData.is_wps_subscription_flow(),
          isWpsAutobilling: models.checkoutAppData.isWpsAutobillingFlow(),
          isWpsInstallmentPlan: models.checkoutAppData.is_wps_installmentplan_flow(),
          tokenWalletization: models.checkoutCart.isWalletTokenization(),
          isRecurringPayment: models.checkoutCart.isRecurringPayment(),
          isSubscriptionsV1: models.checkoutCart.isSubscriptionsV1()
        };
        Object.assign(_this.flags, flowFLags);
        _this.flags.flowName = flowFLags.isEcFlow ? 'ec' : 'wps';
        if (_index.$config.readMerchantPreferencesFromAppData) {
          var merchantPreferencesFromAppData = models.checkoutAppData.merchant_preferences;
          _this.flags.merchantPreferencesFromAppData = merchantPreferencesFromAppData;
          _logger.$logger.info('merchant_preferences_set_from_appData');
          _this.flags.autoReturnEnabled = models.checkoutAppData.is_autoreturn_enabled();
          _this.flags.pdtEnabled = models.checkoutAppData.is_pdt_enabled();
          _this.flags.wpsAutoreturnPdtEnabled = _this.flags.autoReturnEnabledInAppData || _this.flags.pdtEnabledInAppData;
          return _angular.$q.when();
        } else {
          _logger.$logger.info('merchant_preferences_set_from_merchant_profile_settings');
          return _index4.$MerchantPreferenceModel.instance(id).retrieve().then(function (merchantPreferences) {
            _this.flags.merchantPreferences = merchantPreferences;
            _this.flags.autoReturnEnabled = merchantPreferences.autoReturn();
            _this.flags.pdtEnabled = merchantPreferences.pdtEnabled();
            _this.flags.wpsAutoreturnPdtEnabled = flowFLags.isWpsFlow && (_this.flags.autoReturnEnabled || _this.flags.pdtEnabled);
          });
        }
      });
    },
    experiments: function experiments() {
      return {
        marketingOfferTitleContentExp: (0, _index.$elmo)('xoon_forced_signup_buyer_protection_content', {
          'ctx.COUNTRY': _index.$locale.country
        }, '(xoon_forced_signup_buyer_protection_content_)(.*)'),
        noBalanceExp: (0, _index.$elmo)('xo_xoon_no_balance_agreement', {
          'ctx.COUNTRY': _index.$locale.country
        }, '(Trmt_xo_xoon_no_balance_agreement_)(.*)').then(function (result) {
          return Boolean(result && result.treatment_name);
        })
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      this.locale = _index.$locale;
    },
    populate: function populate() {
      var _this2 = this;
      this.contentKeys = {};
      this.isSignupBlocked = function (country) {
        // Block signup. Current countries:
        // Thailand: user onboarding is blocked due to compliance
        // Australia: blocked onboarding due to CRS compliance feature is not implemented in legacy application(xoonboarding)
        return (0, _index.$feature)('blockSignup', false, country);
      };
      this.showMarketingOffers = function () {
        return !_this2.flags.allowChoice && !_this2.models.checkoutCart.isWalletTokenization() && !_this2.flags.titleSubtitlePxpTreatment;
      };
      var setUnbrandedContent = function setUnbrandedContent() {
        _this2.onboardTitleLine1 = _this2.isUnbranded ? 'common.getBenefitsUnBrandedLine1' : 'common.getBenefitsLine1';
        _this2.subTitle = _this2.isUnbranded ? 'common.createPayPalUnBrandedProp' : 'common.createPayPalProp';
        _this2.paypalSubTitle = _this2.isUnbranded ? 'common.createPayPalUnBrandedSubTitle' : 'common.createPayPalSubTitle';
        _this2.guestSignup1 = _this2.isUnbranded ? 'common.yesCreateUnBrandedAccount' : 'common.yesCreateAccount';
        _this2.guestSignup2 = _this2.isUnbranded ? 'common.nothanksUnBranded' : 'common.nothanks';
      };
      setUnbrandedContent();
      var contentOpts = {
        cart: this.models.checkoutCart,
        appData: this.models.checkoutAppData,
        locale: this.locale,
        fiMode: this.onboard.fiMode,
        noBalance: this.experiments.noBalanceExp
      };
      this.billingAgreementContent = (0, _contentKeys.getBillingAgreementContentInfo)(contentOpts);

      /**
       * show WPS interstitial page, if
       * 1. its optional sign up flow and
       * 2. not multistep flow and not DE
       * 3. merchant pref not have pdt or auto return and
       * 4. one touch throttle is not control
       * 5. wps interstitial throttle return treatment experiment
       **/
      var checkWPSInterstitialEligibility = function checkWPSInterstitialEligibility() {
        if (!_this2.flags.isWpsFlow) {
          return;
        }
        if (_this2.flags.isWpsSubscription) {
          _logger.$logger.info('wps_interstitial_not_eligible_for_wps_subscription_flow');
          return;
        }
        if (_this2.flags.isWpsAutobilling) {
          _logger.$logger.info('wps_interstitial_not_eligible_for_autobilling_flow');
          return;
        }
        if (_this2.flags.isWpsInstallmentPlan) {
          _logger.$logger.info('wps_interstitial_not_eligible_for_wps_installmentplan_flow');
          return;
        }
        if (_this2.mode === 'signup') {
          _logger.$logger.info('wps_interstitial_not_eligible_force_signup');
          return;
        }
        if (_this2.flags.merchantPreferences || _this2.flags.merchantPreferencesFromAppData) {
          var autoReturnEnabled = (0, _index.$feature)('wpsMerchantAutoReturn', false) && _this2.flags.autoReturnEnabled;
          var pdtEnabled = (0, _index.$feature)('wpsMerchantPdt', false) && _this2.flags.pdtEnabled;
          _logger.$logger.info('config_to_read_from_app_data', {
            readMerchantPreferencesFromAppData: _index.$config.readMerchantPreferencesFromAppData
          });
          if (autoReturnEnabled) {
            _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_auto_return');
            return;
          }
          if (pdtEnabled) {
            _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_pdt_enabled');
            return;
          }
        }
        _logger.$logger.info('wps_interstitial_pxp_eligible_show_guestonly_and_wps_interstitial');
        _this2.flags.wpsInterstitialEligible = true;
        _this2.mode = 'guestonly';
      };
      var setEcPomaFlag = function setEcPomaFlag() {
        _logger.$logger.info('checkout_fpti', {
          is_poma: 1
        });
        _this2.flags.wpsInterstitialEligible = false;
        _this2.flags.showPomaUi = true;
      };
      var setOptionalSignupPromotionContent = function setOptionalSignupPromotionContent() {
        if (_this2.mode !== 'guest') {
          return;
        }

        // only for GB, different content for subtitle and create account description
        var treatmentContentKeys = _pxpExperimentConstants["default"].test['xoon_optional_signup_content_change'][_index.$locale.country];
        _this2.contentKeys = treatmentContentKeys ? treatmentContentKeys : {};
      };

      // This Marketing Header is set for IN guest experience users where the header title and subtitle are updated based on the PXP value.
      var setINMarketingOfferContent = function setINMarketingOfferContent() {
        if (_this2.mode !== 'signup' || _index.$locale.country !== 'IN') {
          return;
        }
        _this2.flags.marketingOfferTitleContentExp = false;
        _this2.marketingOfferTitleContentExpContentKeys = {};
        var marketingOfferTitleContentExp = _this2.experiments.marketingOfferTitleContentExp;
        if (marketingOfferTitleContentExp && marketingOfferTitleContentExp.treatment_name) {
          var treatmentContentKeys = _pxpExperimentConstants["default"].test['xoon_forced_signup_buyer_protection_content'][marketingOfferTitleContentExp.treatment_name];
          // Check whether the treatment key exists or is it a control. This will set the marketingOfferTitleContentExp variable as false so that the control text is rendered.

          if (treatmentContentKeys) {
            _this2.flags.marketingOfferTitleContentExp = true;
            _this2.marketingOfferTitleContentExpContentKeys = treatmentContentKeys ? treatmentContentKeys : {};
            _logger.$logger.info('xoon_forced_signup_buyer_protection_content', {
              message: marketingOfferTitleContentExp.treatment_name
            });
          }
        }
      };
      var setFlagsPostFlowEligibility = function setFlagsPostFlowEligibility() {
        var trackingModes = ['guest', 'guestonly'];
        _this2.flags.track_submit_transition = trackingModes.includes(_this2.mode) ? 'guest_xo' : 'signup';
        _logger.$logger.info("calling_setFlagsPostFlowEligibility_" + _index.$locale.country + "_" + _this2.mode);

        // Don't show interstitial experience(guest to member upgrade)
        // page for the below reasons.
        // 1. isphoneConfirmationExpTreatment = true for
        // PSD2 countries in the experiment xo_xoon_phone_confirmation.
        // NOTE: TH(thailand) is not part of the experiment, so isphoneConfirmationExpTreatment will be false.
        // 2. Block guest upgrade to member for TH country due to compliance requirements.
        if (!_this2.flags.isphoneConfirmationExpTreatment) {
          _logger.$logger.info('phoneConfirmationExp_Not_Treatment');
          // blockSignup feature flag is true only for TH country.
          // so other countries will be eligible for interstitial page.
          if (!_this2.isSignupBlocked(_index.$locale.country)) {
            _logger.$logger.info("SIGNUP_NOT_BLOCKED_IN_COUNTRY_" + _index.$locale.country);
            checkWPSInterstitialEligibility();
          }
        }
        setOptionalSignupPromotionContent();
        setINMarketingOfferContent();

        // POMA - Passwordless Onboarding of Member Accounts
        if (_this2.mode === 'guest' && _index.$locale.country === 'US' && !_index5.$DeviceInfo.isWebView() && !_this2.flags.isWpsFlow && !_this2.flags.isInvoiceFlow && !_this2.flags.isSubscriptionsV1 && _index.$config.isPomaEnabled) {
          setEcPomaFlag();
        }
        _this2.flags.mode = _this2.mode;
        _this2.flags.signupEnabled = _this2.mode !== 'guestonly';
        _this2.flags.allowChoice = _this2.mode !== 'signup';

        // Initialize showDisabledPasswordField to true.
        // NOTE: We use the if condition to check for undefined so the variable is assigned only once.
        // This method is called on every locale change, so we don't want it to be true on every change.
        // In future cases, signupSelected and guestSelected will set it accordingly.
        if (_this2.flags.showDisabledPasswordField === undefined) {
          _this2.flags.showDisabledPasswordField = true;
        }
      };
      setFlagsPostFlowEligibility();
    }
  },
  actions: {
    setBuyerModeFlags: function setBuyerModeFlags(newValue) {
      var contentOpts = {
        cart: this.models.checkoutCart,
        appData: this.models.checkoutAppData,
        locale: this.locale,
        fiMode: this.onboard.fiMode,
        noBalance: this.experiments.noBalanceExp
      };
      switch (newValue) {
        case 'guest':
        case 'guestonly':
          // show disabled password field for variant2
          this.flags.showDisabledPasswordField = true;
          _logger.$logger.info('Guest_Signup_No');
          this.flags.mode = newValue;
          this.flags.track_submit_transition = 'guest_xo';
          contentOpts.mode = newValue;
          break;
        case 'signup':
          // hide disabled password field
          this.flags.showDisabledPasswordField = false;
          this.flags.ignoreValidationTheFirstTime = true;
          _logger.$logger.info('Guest_Signup_Yes');
          this.flags.mode = newValue;
          this.flags.track_submit_transition = 'guest_optional_signup';
          contentOpts.mode = newValue;
          break;
        default:
        // Do Nothing
      }
      this.accountCreationSectionErrorMessage = '';
      $('.signupFieldsContainer .radioButton').removeClass('warning');
      this.billingAgreementContent = (0, _contentKeys.getBillingAgreementContentInfo)(contentOpts);
      _uiRouter.$state.current.trackingData.pageQualifier = newValue;
      return true;
    },
    triggerTimerForSignupClicked: function triggerTimerForSignupClicked() {
      if (window.performance) {
        _logger.$logger.info('sign up option clicked, start timer...', window.performance.now());
        this.$emit('signupClickedTimerStarted', window.performance.now());
      }
    },
    onCheckedSavedMyInfo: function onCheckedSavedMyInfo($event) {
      if ($event.target.checked) {
        // populating the legal terms key to send the TCPA details to OAS later during onboarding
        this.flags.tcpa_identifier = 'poma.legalTerms';
        this.flags.poma_flow = true;
        this.flags.track_submit_transition = 'poma_signup';
        $('.pomaFieldsContainer').addClass('focusBorder');
        $('.pomaFieldsContainer').addClass('active');
        _logger.$logger.info('POMA_CHECKBOX_SELECTED');
        if ($('#pomaSubmit').offset()) {
          window.scrollTo(0, this.$element.parent().find('#pomaSubmit').offset().top);
        }
      } else {
        this.flags.tcpa_identifier = undefined;
        this.flags.poma_flow = false;
        this.flags.track_submit_transition = 'guest_xo';
        $('.pomaFieldsContainer').removeClass('focusBorder');
        $('.pomaFieldsContainer').removeClass('active');
        _logger.$logger.info('POMA_CHECKBOX_DESELECTED');
      }
    }
  }
});
_index.$Component;
_index.$locale;
_index.$config;
_index.$feature;
_index.$elmo;
_angular.$q;
_index2.$CheckoutInputDataModel;
_index3.$CheckoutAppDataModel;
_index3.$CheckoutPayeeModel;
_index3.$CheckoutCartModel;
_index3.$FlowEligibilityModel;
_index4.$MerchantPreferenceModel;
_logger.$logger;
_uiRouter.$state;
_index5.$DeviceInfo;
_contentKeys.getBillingAgreementContentInfo;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/guest/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoGuestOptions', {
  tag: 'xo-guest-options',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    flags: {
      type: 'var',
      required: false
    },
    onboard: {
      type: 'var',
      required: false
    },
    singlePagePaymentForm: {
      type: 'var',
      required: false
    },
    validated: {
      type: 'var',
      required: false
    },
    sepa: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutAppData: _index.$CheckoutAppDataModel.instance(this.token).retrieve()
      };
    },
    showGuestDomesticUserAgreementExp: function showGuestDomesticUserAgreementExp(resolvers) {
      var _this = this;
      return resolvers.models.then(function (_ref) {
        var checkoutAppData = _ref.checkoutAppData;
        // Take the merchant country
        var merchantCountry = checkoutAppData.get('merchant.merchant_country');

        // As this is intended to be domestic only, checking the selected country
        if (merchantCountry !== _squid.$locale.country) {
          return;
        }
        return (0, _squid.$elmo)('xo_xoon_guest_domestic_user_agreement', {
          'ctx.COUNTRY': merchantCountry,
          'ctx.app_name': 'xoonboardingnodeweb'
        }, 'Trmt_xo_xoon_guest_domestic_user_agreement_1').then(function (result) {
          if (result) {
            _logger.$logger.info('guest_domestic_user_agreement_exp', {
              merchant_country: merchantCountry,
              buyer_country: _squid.$locale.country
            });
            _this.showGuestDomesticUserAgreement = true;
          }
        });
      });
    },
    showILPSL2GuestDisclaimer: function showILPSL2GuestDisclaimer() {
      var _this2 = this;
      if (_squid.$locale.country === 'IL') {
        return (0, _squid.$elmo)('xo_xoon_il_psl_article_2', {
          'ctx.country': _squid.$locale.country
        }, 'Trmt_xo_xoon_il_psl_article_2').then(function (result) {
          if (result) {
            _this2.ILPSL2Enabled = true;
          }
        });
      }
    }
  },
  lifecycle: {
    enter: function enter() {
      this.locale = _squid.$locale;
      this.showGuestAMLD4Terms = false;
      var _$config$AMLRuleCount = _squid.$config.AMLRuleCountries,
        AMLRuleCountries = _$config$AMLRuleCount === void 0 ? [] : _$config$AMLRuleCount;
      this.isAmlCountry = AMLRuleCountries.includes(_squid.$locale.country);
      this.showGuestDomesticUserAgreement = false;
      this.ILPSL2Enabled = false;
    },
    populate: function populate() {
      var _this3 = this;
      this.eConsentTermsContentValues = {
        country: _squid.$locale.country,
        lang: _squid.$locale.lang
      };
      var getAMLGuestTermsContentKey = function getAMLGuestTermsContentKey() {
        _this3.showGuestAMLD4Terms = true;
        return _this3.onboard.fiMode === 'bank' ? 'signupTerms.guestEconsentBankTermsAMLD4' : 'signupTerms.guestEconsentTermsAMLD4';
      };
      this.$watch('onboard.fiMode', function () {
        if (_this3.showGuestDomesticUserAgreement) {
          _this3.guestTermsKey = 'signupTerms.guestDomesticTerms';
          _this3.showGuestAMLD4Terms = false;
          return;
        }
        _this3.econsentKey = _this3.ILPSL2Enabled ||
        // @TODO: Remove this once exp is 100% ramped
        _squid.$locale.country !== 'IL' && _this3.isAmlCountry ? getAMLGuestTermsContentKey() : 'signupTerms.guest';
        _this3.guestTermsKey = 'signupTerms.guestTerms';
      });
    }
  },
  actions: {
    openSepa: function openSepa() {
      this.props.sepa.show = true;
    }
  }
});
_squid.$Component;
_squid.$config;
_squid.$elmo;
_squid.$locale;
_logger.$logger;
_index.$CheckoutAppDataModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/guest/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"guestOption\" content>\n    <div ng-if=\"flags.buyerMode === 'guest' || flags.mode === 'guestonly'\"\n         ng-class=\"{'signupFieldsContainer': !flags.signupEnabled, 'signupFields': flags.mode === 'guest'}\">\n        <div class=\"row-fluid inputField checkbox legal\" feature=\"econsentGuest\" ng-if=\"!showGuestAMLD4Terms\">\n            <div id=\"errorGuestAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.guestagree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"guestagree\" type=\"checkbox\" name=\"guestagree\" id=\"guestagree\" required aria-describedby=\"errorGuestAgree\"/>\n            <label class=\"noBottom\" for=\"guestagree\" ng-bind-html=\"htmlContent(econsentKey, eConsentTermsContentValues)\" aria-describedby=\"errorGuestAgree\"></label>\n        </div>\n        <div class=\"row-fluid legal\" feature=\"econsentGuest\" ng-if=\"showGuestAMLD4Terms\">\n            <p class=\"noBottom\" id=\"guestAmld4Terms\" ng-bind-html=\"htmlContent(econsentKey, eConsentTermsContentValues)\"></p>\n        </div>\n        <div class=\"row-fluid inputField checkbox legal\" feature=\"guestTerms\">\n            <div id=\"errorGuestTerms\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.guestTerms.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"guestTerms\" type=\"checkbox\" name=\"guestTerms\" id=\"guestTerms\" required aria-describedby=\"errorGuestTerms\"/>\n            <label class=\"noBottom\" for=\"guestTerms\" ng-bind-html=\"htmlContent(guestTermsKey, eConsentTermsContentValues)\" aria-describedby=\"errorGuestTerms\"></label>\n        </div>\n        <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"onboard.fiMode === 'bank' && !flags.show_sepa_overlay\">\n            <div id=\"errorSepaGuestAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.sepaGuestAgree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n            <input ng-model=\"sepa.sepaGuestAgree\" type=\"checkbox\" name=\"sepaGuestAgree\" id=\"sepaGuestAgree\" required aria-describedby=\"errorSepaGuestAgree\"/>\n            <label class=\"noBottom agreeSepaTerms\" for=\"sepaGuestAgree\"\n                   bind-html-compile=\"htmlContent('signupTerms.agreeSepaTermsV2')\"\n                   aria-describedby=\"errorSepaGuestAgree\"></label>\n        </div>\n        <div feature=\"guestECMessage18Plus\" ng-if=\"!flags.guestWPSMessage18Plus\">\n            <p id=\"legal18PlusMessageForOptionalGuest\" class=\"legal18PlusAcknowledgementMessageForOptionalGuest\">\n                {{content('common.legal18PlusAcknowledgement')}}\n            </p>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/lib/helper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.signupLib = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var getIsGDPRCountry = function getIsGDPRCountry(country) {
  if (country === void 0) {
    country = _squid.$locale.country;
  }
  // Refer to config.GDPR for countries list
  return _squid.$util.getProperty(_squid.$config, 'GDPR.countries', {
    "default": []
  }).indexOf(country) > -1;
};
var getMarketingOptinShowHide = function getMarketingOptinShowHide(country, isGDPRCountry) {
  if (country === void 0) {
    country = _squid.$locale.country;
  }
  if (isGDPRCountry) {
    return _squid.$util.getProperty(_squid.$config, 'GDPR.marketingOptinExcluded', {
      "default": []
    }).indexOf(country) === -1;
  }

  // GDPR config overrides all country specific config
  return (0, _squid.$feature)('marketingOptinMember', false, country);
};
var getMarketingOptinIsChecked = function getMarketingOptinIsChecked(country, isGDPRCountry) {
  if (country === void 0) {
    country = _squid.$locale.country;
  }
  // If GDPR country, then check for marketing opt-in
  // unchecked countries list in GDPR config object
  if (isGDPRCountry) {
    return _squid.$util.getProperty(_squid.$config, 'GDPR.marketingOptinUncheckedCountries', {
      "default": []
    }).indexOf(country) < 0;
  }

  // GDPR config overrides all country specific config
  return (0, _squid.$feature)('checkMarketingOptIn', false, country);
};
var getMarketingOptinContentKey = function getMarketingOptinContentKey(country, isGDPRCountry, isSelectAllMultipleTerms) {
  if (country === void 0) {
    country = _squid.$locale.country;
  }
  if (isSelectAllMultipleTerms === void 0) {
    isSelectAllMultipleTerms = false;
  }
  if (isGDPRCountry) {
    return 'signupTerms.GDPRAgreeMarketing';
  }
  if (isSelectAllMultipleTerms) {
    return 'signupTerms.multiTerms.agreeMarketing';
  }

  // GDPR config overrides all country specific config
  return 'signupTerms.agreeMarketing';
};
var getSignupTermsContentKey = function getSignupTermsContentKey(country, isGDPRCountry, fiMode, displayRightOfWithdrawal, useUserAgreementCustomLink, isSelectAllMultipleTerms) {
  if (country === void 0) {
    country = _squid.$locale.country;
  }
  if (useUserAgreementCustomLink === void 0) {
    useUserAgreementCustomLink = false;
  }
  if (isSelectAllMultipleTerms === void 0) {
    isSelectAllMultipleTerms = false;
  }
  var consentKey = 'signupTerms.signupC';

  // GDPR pxp treatment check
  if (isGDPRCountry) {
    consentKey = fiMode === 'bank' ? 'signupTerms.GDPRAgreeTermsBank' : 'signupTerms.GDPRAgreeTerms';
  }
  if (country === 'US') {
    consentKey = 'signupTerms.signupTCPA3';
  }
  if (displayRightOfWithdrawal) {
    consentKey = 'signupTerms.signupRightOfWithdrawal';
  }
  if (useUserAgreementCustomLink) {
    consentKey = consentKey + "_UALink";
  }
  if (isSelectAllMultipleTerms) {
    consentKey = 'signupTerms.multiTerms.signupC_UALink';
  }
  return consentKey;
};
var getIsMarketingCheckboxFirst = function getIsMarketingCheckboxFirst(country, isGDPRCountry) {
  if (country === void 0) {
    country = _squid.$locale.country;
  }
  if (isGDPRCountry) {
    return _squid.$util.getProperty(_squid.$config, 'GDPR.marketingCheckboxFirstThenAgreeTerms', {
      "default": []
    }).indexOf(country) > -1;
  }
  return false;
};

/**
 * @function getGatherActiveConsentExp
 * @description Returns the Gather Active Consent experiment: FEATURE_GATHER_ACTIVE_CONSENT
 */
var getGatherActiveConsentExp = function getGatherActiveConsentExp(country) {
  if (country === void 0) {
    country = _squid.$locale.country;
  }
  // Experiment to define if we should fetch the User Agreement from N&C API (Notice & Consent)
  // Experiment: FEATURE_GATHER_ACTIVE_CONSENT
  // Filters: Country + App Name, to fetch correct allocation
  // It's for multiple apps in the same experiment
  return (0, _squid.$elmo)('xo::gatheractiveconsent', {
    'ctx.COUNTRY': country,
    'ctx.app_name': 'xoonboardingnodeweb'
  }, 'Trmt_FEATURE_GATHER_ACTIVE_CONSENT');
};
var getNoticeAndConsentUserAgreementParameters = function getNoticeAndConsentUserAgreementParameters() {
  return {
    action: 'evalPolicy',
    params: {
      flow: 'ONBOARDING',
      policyType: 'UserLegalConsent'
    }
  };
};
var getUserLegalAgreementPayload = function getUserLegalAgreementPayload(majorVersion, minorVersion) {
  return {
    agreement_type: 'USER',
    major_version: majorVersion,
    minor_version: minorVersion
  };
};
var signupLib = exports.signupLib = {
  getIsGDPRCountry: getIsGDPRCountry,
  getMarketingOptinIsChecked: getMarketingOptinIsChecked,
  getMarketingOptinShowHide: getMarketingOptinShowHide,
  getMarketingOptinContentKey: getMarketingOptinContentKey,
  getSignupTermsContentKey: getSignupTermsContentKey,
  getIsMarketingCheckboxFirst: getIsMarketingCheckboxFirst,
  getNoticeAndConsentUserAgreementParameters: getNoticeAndConsentUserAgreementParameters,
  getGatherActiveConsentExp: getGatherActiveConsentExp,
  getUserLegalAgreementPayload: getUserLegalAgreementPayload
};
_squid.$util;
_squid.$locale;
_squid.$feature;
_squid.$config;
_squid.$elmo;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/signup/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.selectAllTermsAndPrivacyTermsExperiment = exports.rightOfWithdrawalExperiment = void 0;
var rightOfWithdrawalExperiment = exports.rightOfWithdrawalExperiment = {
  name: 'xo_xoon_right_of_withdrawal',
  treatment_1: 'Trmt_xo_xoon_right_of_withdrawal_1',
  treatment_2: 'Trmt_xo_xoon_right_of_withdrawal_2'
};
var selectAllTermsAndPrivacyTermsExperiment = exports.selectAllTermsAndPrivacyTermsExperiment = {
  name: 'xo_xoon_select_all_terms',
  treatment_1: 'Trmt_xo_xoon_select_all_terms'
};

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/signup/template.html"));
__webpack_require__("../node_modules/xo-form-components/src/place-of-birth/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/gender-type/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/primaryResidentialAddressField/directive.js");
var _helper = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/lib/helper.js");
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/onboardOptions/signup/constants.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('xoSignupOptions', {
  tag: 'xo-signup-options',
  template: _template["default"],
  props: {
    flags: {
      type: 'var',
      required: false
    },
    onboard: {
      type: 'var',
      required: false
    },
    locale: {
      type: 'var',
      required: false
    },
    singlePagePaymentForm: {
      type: 'var',
      required: false
    },
    validated: {
      type: 'var',
      required: false
    },
    sepa: {
      type: 'var',
      required: false
    },
    guestUpgrade: {
      type: 'var',
      required: false
    },
    isUnbranded: {
      type: 'var',
      required: false
    },
    residentialAddress: {
      type: 'var',
      required: false
    },
    useUserAgreementCustomLink: {
      type: 'var',
      required: false
    },
    userAgreementLink: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    experiments: function experiments() {
      return {
        // countries in the contextual rules
        // "GB,"FR","ES","IE","PL","CY","BG","BE","CZ","DK","EE","FI",
        // "GF","GI","GP","GR","HU","LV","LI","LT","LU","MT","MQ","PT",
        // "RE","RO","SM","SK","SI","SE","NO","AT","NL","IT","DE"
        nationalityThrottle: (0, _index.$elmo)('xo_xoonboarding_eu_nationality_throttle', {
          'ctx.COUNTRY': _index.$locale.country
        }, '(xo_xoonboarding_eu_nationality_throttle_)(.*)'),
        rightOfWithdrawalExp: (0, _index.$elmo)(_constants.rightOfWithdrawalExperiment.name, {
          'ctx.COUNTRY': _index.$locale.country
        }, '(Trmt_xo_xoon_right_of_withdrawal_)(.*)').then(function (result) {
          return result && result.treatment_name;
        }),
        selectAllAndPrivacyTermsExp: (0, _index.$elmo)(_constants.selectAllTermsAndPrivacyTermsExperiment.name, {
          'ctx.COUNTRY': _index.$locale.country
        }, _constants.selectAllTermsAndPrivacyTermsExperiment.treatment_1).then(function (result) {
          return result && result.treatment_name;
        })
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      this.locale = _index.$locale;
      this.flags.nationalIdFlag = _index.$config.nationalIdRequiredCountries && _index.$config.nationalIdRequiredCountries.indexOf(this.locale.country) > -1;
      this.isGenderFieldEnabled = (0, _index.$feature)('gender', false, this.locale.country);
      this.showNationalityField = (0, _index.$feature)('nationalityRequired', false, this.locale.country);
    },
    populate: function populate() {
      var _this = this;
      var isGDPRCountry = _helper.signupLib.getIsGDPRCountry(this.locale.country);

      // Market Opt-in display and checked by default is based on config settings
      this.showMarketingOptin = _helper.signupLib.getMarketingOptinShowHide(this.locale.country, isGDPRCountry);

      // By default, if we are not showing a checkbox for marketing opt-in
      // then, get all signup/POMA users opted-in for marketing emails
      // Setting the flag to null as per GDPR team requirement
      if (!this.showMarketingOptin) {
        this.onboard.marketingOptin = null;
      } else {
        // DO THIS ONLY IF the marketing opt-in checkbox is displayed to users
        // Is marketing opt-in checkbox checked by default
        this.onboard.marketingOptin = _helper.signupLib.getMarketingOptinIsChecked(this.locale.country, isGDPRCountry);
        // Marketing opt-in text next to checkbox
        this.marketingOptinContentKey = _helper.signupLib.getMarketingOptinContentKey(this.locale.country, isGDPRCountry, Boolean(this.experiments.selectAllAndPrivacyTermsExp));
        // Decision to display marketing checkbox before or after signup agree terms
        this.MarketingCheckboxFirst = _helper.signupLib.getIsMarketingCheckboxFirst(this.locale.country, isGDPRCountry);
      }
      var rightOfWithdrawalTreatment = this.experiments.rightOfWithdrawalExp;
      if (rightOfWithdrawalTreatment === _constants.rightOfWithdrawalExperiment.treatment_1) {
        this.onboard.rightOfWithdrawal = false;
        this.showRightOfWithdrawalCheckbox = true;
      } else {
        this.onboard.rightOfWithdrawal = null;
      }

      // Get Signup agree terms content and update the this.onboard object with they key
      var getSignupTermsContentKey = function getSignupTermsContentKey() {
        var displayRightOfWithdrawal = rightOfWithdrawalTreatment === _constants.rightOfWithdrawalExperiment.treatment_2;
        return _helper.signupLib.getSignupTermsContentKey(_this.locale.country, isGDPRCountry, _this.onboard.fiMode, displayRightOfWithdrawal, _this.useUserAgreementCustomLink, Boolean(_this.experiments.selectAllAndPrivacyTermsExp));
      };
      this.onboard.eConsentTermsContent = getSignupTermsContentKey();
      this.onboard.eConsentTermsContentValues = {
        country: this.locale.country,
        userAgreementLink: this.userAgreementLink,
        lang: this.locale.lang
      };

      // control treatment will be returned for the countries which are in the contextual rules and falls in to control,
      // for those don't show the national ID field.
      // Test treatment / undefined (In-case of the countries not in the contextual rules),
      // read "nationalityRequired" from config.json which by default determined in enter()
      var pxpTreatments = this.experiments.nationalityThrottle;
      if (pxpTreatments && pxpTreatments.treatment_name.indexOf('xo_xoonboarding_eu_nationality_throttle_control') > -1 && this.showNationalityField) {
        this.showNationalityField = false;
      }
      this.onboard.onboardTermsAgree = false;
      if (this.experiments.selectAllAndPrivacyTermsExp) {
        // Privacy Statements
        this.onboard.privacyStatementsTerms = false;
        this.showPrivacyStatementsTerms = true;
        this.privacyStatementLinksValues = {
          country: this.locale.country,
          lang: this.locale.lang
        };

        // Select All
        this.showSelectAll = true;
        this.calculateSelectAll = function () {
          this.selectAllFieldsValues = [this.onboard.onboardTermsAgree, this.onboard.marketingOptin, this.onboard.privacyStatementsTerms];
          this.allSelected = this.selectAllFieldsValues.every(function (val) {
            return val === true;
          });
        };
        this.setValuesForAllCheckboxes = function (newValue) {
          this.onboard.onboardTermsAgree = newValue;
          this.onboard.marketingOptin = newValue;
          this.onboard.privacyStatementsTerms = newValue;
        };
        this.affectedSelectAllFields = ['singlePagePaymentForm.agree', 'onboard.onboardTermsAgree', 'onboard.marketingOptin', 'onboard.privacyStatementsTerms'];
        this.affectedSelectAllFields.forEach(function (watchedField) {
          _this.$watch(watchedField, function () {
            _this.calculateSelectAll();
          });
        });

        // default call also for language
        this.calculateSelectAll();
      } else {
        this.showSelectAll = null;
        this.onboard.privacyStatementsTerms = null;
      }

      // TODO: Remove watch after GDPR ramp (may 25th, 2018), we will have
      // one signup terms text for both bank and card fi types
      // DE - based on FI mode, we need to change signup agree terms
      this.$watch('onboard.fiMode', function (newVal) {
        _this.onboard.eConsentTermsContent = getSignupTermsContentKey();
      });
    }
  },
  actions: {
    openSepa: function openSepa() {
      this.sepa.show = true;
    },
    selectAllKeyPress: function selectAllKeyPress(event) {
      var keyCode = event.which || event.keyCode;
      // For space or enter

      if (keyCode === 32 || keyCode === 13) {
        this.setValuesForAllCheckboxes(!this.allSelected);
      }
    },
    selectAllOnclick: function selectAllOnclick() {
      if (!this.showSelectAll) {
        return;
      }
      this.setValuesForAllCheckboxes(!this.allSelected);
    }
  }
});
_index.$Component;
_index.$locale;
_index.$elmo;
_index.$config;
_index.$feature;
_helper.signupLib;
_constants.rightOfWithdrawalExperiment;
_constants.selectAllTermsAndPrivacyTermsExperiment;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/signup/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"signupOptions\" content>\n    <div ng-if=\"flags.showDisabledPasswordField && flags.allowChoice && !guestUpgrade\" class=\"signupFields\">\n        <xo-password-input user=\"onboard.user\" is-disabled=\"true\"></xo-password-input>\n    </div>\n    <div class=\"signupFields\" ng-if=\"guestUpgrade || flags.mode === 'signup' || flags.buyerMode === 'signup'\"\n         ng-class=\"{'fullSignup': fullSignup || !flags.allowChoice, 'ignoreValidation': flags.ignoreValidationTheFirstTime }\">\n            <xo-email-input flow=\"signup\" flags=\"flags\" user=\"onboard.user\" ng-if=\"!flags.allowChoice\"></xo-email-input>\n            <xo-password-input class=\"highZindexTooltip\" user=\"onboard.user\"></xo-password-input>\n\n            <!--As per the UI design, DOB and Gender needs to be side by side for HK and others just DOB-->\n            <div class=\"dualInputElements clearfix\">\n                <span feature=\"dobRequired\" ng-class=\"{'halfInputElement': isGenderFieldEnabled}\" ng-if=\"onboard.fiMode === 'card' && !flags.whiteListedIndiaMerchant\">\n                    <xo-dob-input user=\"onboard.user\" id=\"dob\"></xo-dob-input>\n                </span>\n                <!--gender is enabled only for HK-->\n                <span feature=\"gender\">\n                    <xo-gender-type user=\"onboard.user\" id=\"gender\"></xo-gender-type>\n                </span>\n            </div>\n\n            <!--placeOfBirth is enabled only for HK-->\n            <span feature=\"placeOfBirth\">\n                <xo-place-of-birth user=\"onboard.user\" id=\"placeofbirth\"></xo-place-of-birth>\n            </span>\n\n            <span feature=\"collectOccupation\">\n                <xo-occupation user=\"onboard.user\"></xo-occupation>\n            </span>\n\n            <span ng-if=\"showNationalityField\">\n                <xo-nationality user=\"onboard.user\"></xo-nationality>\n            </span>\n\n            <span ng-if=\"flags.nationalIdFlag\">\n                <xo-national-id-input country=\"{{locale.country}}\" user=\"onboard.user\"></xo-national-id-input>\n            </span>\n\n            <xo-citizenship user=\"onboard.user\"></xo-citizenship>\n\n            <!--Residential Address based on Elmo hasResidentialAddress true-->\n            <div id=\"residentialAddressContainer\" ng-if=\"residentialAddress.hasResidentialAddress\">\n                <xo-primary-residential-address residential-address=\"residentialAddress\" onboard=\"onboard\" locale=\"locale\" flags=\"flags\"/>\n            </div>\n\n            <div class=\"row-fluid checkbox legal marketingOptin marketingOptinBeforeAgreeTerms\" ng-if=\"showMarketingOptin && MarketingCheckboxFirst\">\n                <input ng-model=\"onboard.marketingOptin\" type=\"checkbox\" name=\"marketingOptin\" id=\"marketingOptin\" ng-checked=\"onboard.marketingOptin\"/>\n                <label id=\"marketingOptinText\" class=\"noBottom marketingOptin\" for=\"marketingOptin\"\n                       ng-bind-html=\"htmlContent(marketingOptinContentKey, { country: locale.country, lang: locale.lang })\"></label>\n            </div>\n\n\n            <div ng-if=\"showSelectAll\" class=\"selectAllDiv\">\n                    {{ content('signupTerms.multiTerms.header')}}\n                <a ng-click=\"actions.selectAllOnclick()\" tabindex=\"0\" id=\"selectAllLink\" ng-keydown=\"actions.selectAllKeyPress($event)\">\n                    {{ content(allSelected ? 'signupTerms.unselectAll' : 'signupTerms.selectAll') }}\n                </a>\n            </div>\n            <div class=\"row-fluid inputField checkbox legal ltrOverride\" directionality feature=\"econsent\">\n                <div id=\"errorSignupAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.agree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">\n                    {{ content( !showSelectAll ? 'largeScreenAccountCreation.agrementError' : 'fieldLevelError.valueMissing') }}\n                </div>\n                <input\n                    ng-if=\"showSelectAll\"\n                    ng-model=\"onboard.onboardTermsAgree\"\n                    type=\"checkbox\"\n                    name=\"agree\"\n                    id=\"agree\"\n                    track-focus-and-blur=\"signupAgreeToTerms\"\n                    required\n                    aria-describedby=\"errorSignupAgree\"\n                />\n                <input\n                    ng-if=\"!showSelectAll\"\n                    ng-model=\"agree\"\n                    type=\"checkbox\"\n                    name=\"agree\"\n                    id=\"agree\"\n                    track-focus-and-blur=\"signupAgreeToTerms\"\n                    required\n                    aria-describedby=\"errorSignupAgree\"\n                />\n                <label class=\"noBottom signupTerms bgImgOnSpan\" for=\"agree\" aria-describedby=\"errorSignupAgree\">\n                    <span class=\"bgImg\">&nbsp;</span>\n                    <span id=\"consentTerms\" ng-class=\"{ selectAllTermsCenteredText: showSelectAll }\" ng-bind-html=\"htmlContent(onboard.eConsentTermsContent, onboard.eConsentTermsContentValues)\"></span>\n                </label>\n            </div>\n            <div class=\"terms\" feature=\"signupTerms\">\n                <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-if=\"flags.commit\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisory',{ country: locale.country })\"></p>\n                <p class=\"signupTerms\" id=\"consumerAdvisory\" ng-if=\"!flags.commit\" ng-bind-html=\"htmlContent('signupTerms.consumerAdvisoryB',{ country: locale.country })\"></p>\n            </div>\n\n            <div class=\"privacyStatements\" ng-if=\"showPrivacyStatementsTerms\">\n                <div class=\"row-fluid checkbox legal privacyStatementsTerms\">\n                    <div id=\"errorPrivacyStatementsTerms\"\n                        ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.privacyStatementsTerms.$error.required\"\n                        class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('fieldLevelError.valueMissing')\n                        }} </div>\n                    <input ng-model=\"onboard.privacyStatementsTerms\" type=\"checkbox\" name=\"privacyStatementsTerms\"\n                        id=\"privacyStatementsTerms\" ng-checked=\"onboard.privacyStatementsTerms\" required />\n                    <label id=\"privacyStatementsTermsText\" class=\"noBottom privacyStateaments\" for=\"privacyStatementsTerms\">\n                        <span ng-class=\"{ selectAllTermsCenteredText: showSelectAll }\" ng-bind-html=\"htmlContent('signupTerms.privacyStatement.header', privacyStatementLinksValues)\"></span>\n                        <ul class=\"privacyTermsList\">\n                            <li ng-bind-html=\"htmlContent('signupTerms.privacyStatement.personalData', privacyStatementLinksValues)\"></li>\n                            <li ng-bind-html=\"htmlContent('signupTerms.privacyStatement.purpose', privacyStatementLinksValues)\"></li>\n                            <li ng-bind-html=\"htmlContent('signupTerms.privacyStatement.retentionPeriod', privacyStatementLinksValues)\"></li>\n                        </ul>\n                    </label>\n                </div>\n            </div>\n            <div class=\"row-fluid inputField checkbox legal sepaTerms\" ng-if=\"onboard.fiMode === 'bank' && !flags.wpsInterstitial\">\n                <div id=\"errorSepaSignupAgree\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.sepaAgree.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.agrementError') }}</div>\n                <input ng-model=\"sepa.sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\" required aria-describedby=\"errorSepaSignupAgree\"/>\n                <label class=\"noBottom agreeSepaTerms\" for=\"sepaAgree\"\n                       bind-html-compile=\"htmlContent('signupTerms.agreeSepaTermsV2')\"\n                       aria-describedby=\"errorSepaSignupAgree\"></label>\n            </div>\n\n            <div class=\"row-fluid checkbox legal rightOfWithdrawal\" ng-if=\"showRightOfWithdrawalCheckbox\">\n                <div id=\"errorRightOfWithdrawal\" ng-show=\"!flags.ignoreValidationTheFirstTime && singlePagePaymentForm.rightOfWithdrawal.$error.required\" class=\"errorTooltip errorTooltipRuleSpecific\">{{ content('largeScreenAccountCreation.rightOfWithdrawalError') }}</div>\n                <input ng-model=\"onboard.rightOfWithdrawal\" type=\"checkbox\" name=\"rightOfWithdrawal\" id=\"rightOfWithdrawal\"\n                    ng-checked=\"onboard.rightOfWithdrawal\" required />\n                <label id=\"rightOfWithdrawalText\" class=\"noBottom rightOfWithdrawal\" for=\"rightOfWithdrawal\"\n                    ng-bind-html=\"htmlContent('rightOfWithdrawal.legalAgreement')\"></label>\n            </div>\n\n            <div class=\"row-fluid checkbox legal marketingOptin\" ng-if=\"showMarketingOptin && !MarketingCheckboxFirst\">\n                <input ng-model=\"onboard.marketingOptin\" type=\"checkbox\" name=\"marketingOptin\" id=\"marketingOptin\" ng-checked=\"onboard.marketingOptin\"/>\n                <label id=\"marketingOptinText\" class=\"noBottom marketingOptin\" for=\"marketingOptin\" ng-class=\"{ selectAllTermsCenteredText: showSelectAll }\"\n                       ng-bind-html=\"htmlContent(marketingOptinContentKey, { country: locale.country, lang: locale.lang })\"></label>\n            </div>\n        </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/onboardOptions/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"onboardOptions\" content>\n\n    <!-- signup/guest fieldset container open -->\n    <div ng-if=\"flags.signupEnabled && !flags.showPomaUi\" class=\"signupFieldsContainer\" id=\"signupContainer\">\n\n        <fieldset>\n\n            <legend ng-if=\"!flags.allowChoice && flags.titleSubtitlePxpTreatment && !flags.marketingOfferTitleContentExp\">\n                <h2 class=\"onboard-header alpha\" ng-bind-html=\"htmlContent('splitScreenExp.payPalAccountDetails')\"></h2>\n            </legend>\n\n            <div ng-if=\"flags.allowChoice\">\n\n                <legend ng-if=\"!contentKeys.title\">\n                    <h2 class=\"onboard-header alpha\">\n                        <p id=\"onboardTitleLine1\" class=\"onboardTitleLine1\">{{content(onboardTitleLine1)}}</p>\n                        <p class=\"onboardTitleLine2\">{{content('common.getBenefitsLine2')}}</p>\n                    </h2>\n                </legend>\n\n                <legend ng-if=\"contentKeys.title\">\n                    <h2 class=\"onboard-header alpha\">\n                        <p class=\"onboardTitleLine1\">{{content(contentKeys.title)}}</p>\n                    </h2>\n                </legend>\n\n                <p class=\"subTitle\" id=\"subTitle\" ng-if=\"!contentKeys.subTitle\" ng-bind-html=\"htmlContent(subTitle, {country: locale.country, lang: locale.lang})\"></p>\n                <p class=\"subTitle\" ng-if=\"contentKeys.subTitle\" ng-bind-html=\"htmlContent(contentKeys.subTitle, {country: locale.country, lang: locale.lang})\"></p>\n\n                <xo-message ng-if=\"validated && singlePagePaymentForm.guestSignup.$error.required\" id=\"guestSignupErrorMessage\"\n                            message=\"{ msgs: [content('largeScreenPayment.chooseAnOption')], type: 'warning' }\"></xo-message>\n\n                <p id =\"paypalSubTitle\" ng-bind-html=\"htmlContent(paypalSubTitle)\"></p>\n            </div>\n\n            <!-- we cannot merge all variable on ng-if into one showMarkingOffers variable -->\n            <!-- as change in any flag value after template is rendered, will not refect in template -->\n            <div ng-if=\"showMarketingOffers() && !flags.marketingOfferTitleContentExp\">\n                <legend>\n                    <xo-marketing-offers\n                        placement-code=\"'202002'\"\n                        token=\"token\"\n                        page-name=\"'HERMES_GUEST_CHECKOUT'\"\n                        title-txt-property=\"'common.createPayPalSubTitleSignup'\"\n                        subtitle-property=\"'common.buyerProtectionSignup'\"\n                        xo-title-class=\"onboard-header alpha\"\n                        xo-title-tag=\"h2\">\n                    </xo-marketing-offers>\n                </legend>\n            </div>\n\n            <div ng-if=\"showMarketingOffers() && flags.marketingOfferTitleContentExp\">\n                <legend ng-if=\"marketingOfferTitleContentExpContentKeys.titleLine1\">\n                    <h2 class=\"onboard-header alpha\">\n                        <p ng-if=\"marketingOfferTitleContentExpContentKeys.titleLine1\" class=\"onboardTitleLine1\">{{content(marketingOfferTitleContentExpContentKeys.titleLine1)}}</p>\n                        <p ng-if=\"marketingOfferTitleContentExpContentKeys.titleLine2\" class=\"onboardTitleLine2\">{{content(marketingOfferTitleContentExpContentKeys.titleLine2)}}</p>\n                    </h2>\n                </legend>\n                <p class=\"subTitle\" ng-if=\"marketingOfferTitleContentExpContentKeys.subTitle\" ng-bind-html=\"htmlContent(marketingOfferTitleContentExpContentKeys.subTitle, {country: locale.country, lang: locale.lang})\"></p>\n            </div>\n\n            <div ng-if=\"models.checkoutCart.isWalletTokenization()\">\n                <h2 class=\"onboard-header alpha\">{{content('signup.loginDetails')}}</h2>\n            </div>\n            <div class=\"signupFieldGroup\">\n\n                <div class=\"row-fluid radioButton\" ng-if=\"flags.allowChoice\"\n                     ng-class=\"{ 'warning': (validated && singlePagePaymentForm.guestSignup.$error.required) }\">\n                    <input track-input=\"Guest_Signup_Yes\" ng-model=\"flags.buyerMode\" type=\"radio\" name=\"guestSignup\" id=\"guestSignup1\"\n                           value=\"signup\" required tabindex=\"0\" aria-describedby=\"guestSignupErrorMessage\"\n                           ng-change=\"actions.setBuyerModeFlags(flags.buyerMode) && actions.triggerTimerForSignupClicked()\"\n                           ng-disabled=\"isSignupBlocked(locale.country)\" />\n\n                    <label class=\"noBottom\" for=\"guestSignup1\" ng-if=\"!contentKeys.yesCreateAccount\">{{ content(guestSignup1)}}</label>\n                    <label class=\"noBottom\" for=\"guestSignup1\" ng-if=\"contentKeys.yesCreateAccount\">{{ content(contentKeys.yesCreateAccount) }}</label>\n                </div>\n\n                <xo-signup-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\" flags=\"flags\" is-unbranded=\"isUnbranded\"\n                        onboard=\"onboard\" sepa=\"sepa\" residential-address=\"residentialAddress\" user-agreement-link=\"userAgreementLink\" use-user-agreement-custom-link=\"useUserAgreementCustomLink\"></xo-signup-options>\n\n            </div>\n\n            <div class=\"row-fluid radioButton\"\n                 ng-class=\"{ 'warning': (validated && singlePagePaymentForm.guestSignup.$error.required) }\" ng-if=\"flags.allowChoice\">\n                <input track-input=\"Guest_Signup_No\" ng-model=\"flags.buyerMode\" ng-change=\"actions.setBuyerModeFlags(flags.buyerMode)\" type=\"radio\" name=\"guestSignup\" id=\"guestSignup2\" value=\"guest\"\n                       required tabindex=\"0\" aria-describedby=\"guestSignupErrorMessage\" />\n                <label class=\"noBottom\" for=\"guestSignup2\">{{ content('common.noCreateAccount') || content(guestSignup2) }}</label>\n            </div>\n\n            <xo-guest-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\"  flags=\"flags\"\n                              onboard=\"onboard\" sepa=\"sepa\" token=\"token\"></xo-guest-options>\n\n        </fieldset>\n\n    </div>\n    <!-- signup/guest fieldset container closed -->\n\n    <div ng-if=\"mode === 'guestonly'\">\n        <xo-guest-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\"  flags=\"flags\"\n                          onboard=\"onboard\" sepa=\"sepa\" user-agreement-link=\"userAgreementLink\" token=\"token\"></xo-guest-options>\n    </div>\n\n    <div ng-if=\"flags.showPomaUi\" class=\"pomaFieldsContainer\" id=\"pomaContainer\">\n        <div class=\"pomaBgImg cardIcon VISA\">&nbsp;</div>\n        <div>\n            <h2 class=\"alpha\">{{content('poma.heading')}}</h2>\n            <div>\n                <p class=\"subTitle\">{{content('poma.para1')}}</p>\n                <p class=\"hfast noMarginBottom\">{{content('poma.para2')}}</p>\n                <ul class=\"hfast fastList\">\n                    <li>{{content('poma.para2Bullet1')}}</li>\n                    <li>{{content('poma.para2Bullet2')}}</li>\n                </ul>\n                <p class=\"subTitle\">{{content('poma.para3')}}</p>\n                <p class=\"subTitle\">{{content('poma.para4')}}</p>\n            </div>\n            <div class=\"checkbox saveMyInfoBox\">\n                <input\n                    track-input=\"POMA_CHECKBOX\"\n                    ng-model=\"saveMyInfo\"\n                    type=\"checkbox\"\n                    name=\"saveMyInfo\"\n                    id=\"saveMyInfo\"\n                    track-focus-and-blur=\"poma\"\n                    ng-click=\"actions.onCheckedSavedMyInfo($event)\"\n                />\n                <label for=\"saveMyInfo\">{{content('poma.saveMyInfoCheckBox')}}</label>\n            </div>\n            <div ng-if=\"saveMyInfo\">\n                <p class=\"legal\" id=\"pomaLegalterms\" ng-bind-html=\"htmlContent('poma.legalTerms', {country:locale.country, lang:locale.lang})\"></p>\n            </div>\n        </div>\n    </div>\n\n    <p class=\"billingTxt secondary legal\">\n        <span id=\"{{billingAgreementContent.idSelector}}\" data-ng-bind-html=\"htmlContent(billingAgreementContent.contentKey, billingAgreementContent.data)\"></span>\n    </p>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/passwordInput/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/passwordInput/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoPasswordInput', {
  tag: 'xo-password-input',
  template: _template["default"],
  props: {
    user: {
      type: 'var',
      required: false
    },
    singlePassword: {
      type: 'var',
      required: false
    },
    isDisabled: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.locale = _squid.$locale;
      this.passwordToolTip = 'show';
      this.passwordMismatch = 'hide';
      this.requirementLength = 'active';
      this.requirementNumberSymbol = 'active';

      // Set singlePassword as true by default
      // NOTE: PROX flow is still using two password fields
      this.singlePassword = this.singlePassword !== false;

      /*
          The next 2 methods serve to allow passwordValidate & confirmPasswordValidate directives
          to access + change the scope variables inside here as the scopes
          in these directives are different and do not inherit from here.
      */
      this.setScopeProp = function (prop, newVal) {
        _this[prop] = newVal;
      };
      this.getScopeProp = function (prop) {
        return _this[prop];
      };

      /*
       * single password case
       * flags and functions to enable single password hide and
       * show password feature
       */
      var enableSinglePassword = function enableSinglePassword() {
        _this.showRawPassword = false;
        _this.showPasswordTextToggleLink = false;
        _this.toggleShowRawPassword = function ($event) {
          var $passwordEl = (0, _jquery["default"])('#password');
          var valLength = $passwordEl.val().length;
          $event.preventDefault();
          _this.showRawPassword = !_this.showRawPassword;
          if (_this.showRawPassword) {
            $passwordEl.prop('type', 'text');
          } else {
            $passwordEl.prop('type', 'password');
          }

          // timeout is need to get this function running after
          // the onPasswordBlur function
          (0, _angular.$timeout)(function () {
            $passwordEl.focus();
            // firefox set the cursor to the end of the value text
            $passwordEl.get(0).setSelectionRange(valLength, valLength);
          });
        };
      };
      if (this.singlePassword) {
        enableSinglePassword();
      }
    }
  },
  actions: {
    // 'singlePassword' case - show the 'hide/show' password link
    onPasswordFocusBlur: function onPasswordFocusBlur($event, focused) {
      var passwordValLength = this.user.password && this.user.password.length;
      if (this.singlePassword) {
        if (focused) {
          this.showPasswordTextToggleLink = true;
          this.addRightSpaceToShowHideLink = (0, _jquery["default"])($event.target).hasClass('ng-invalid');
        } else {
          // if password value length is zero then it is false
          this.showPasswordTextToggleLink = passwordValLength ? true : false;
        }
      }
    }
  }
});
(0, _angular.$registerDirective)('password-validate', function () {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function link(scope, elem, attrs, controller) {
      var ngModel = controller;
      var passwordInputScope = scope.componentScope;
      ngModel.$setValidity('password', false);
      var fourSequence = function fourSequence(value) {
        value += " " + value.split('').reverse().join('');
        var sequences = '`1231234234534564567567867897890890-90-= ' +
        // row 1
        'qwerwertertyrtyutyuiyuiouiopiop[op[]p[]\\ ' +
        // row 2
        'asdfsdfgdfghfghjghjkhjkljkl;kl;\' ' +
        // row 3
        'zxcvxcvbcvbnvbnmbnm,nm,.m,./ ' +
        // row 4
        '~!@#!@#$@#$%#$%^$%^&%^&*^&*(&*()*()_()_+ ' +
        // shift + row 1
        'QWERWERTERTYRTYUTYUIYUIOUIOPIOP{OP{}P{}| ' +
        // shift + row 2
        'ASDFSDFGDFGHFGHJGHJKHJKLJKL:KL:" ' +
        // shift + row 3
        'ZXCVXCVBCVBNVBNMBNM<NM<>M<>?'; // shift + row 4

        var len = value.length;
        for (var i = 0; i < len - 3; i++) {
          if (sequences.indexOf(value.substr(i, 4)) > -1) {
            // if return value is false, then add the class
            passwordInputScope.setScopeProp('addRightSpaceToShowHideLink', true);
            return false;
          }
        }
        return true;
      };
      var containsDoubleByte = function containsDoubleByte(s) {
        var returnVal = /[^\u0000-\u00ff]/.test(s); // eslint-disable-line no-control-regex

        // if return value is false, then add the class
        passwordInputScope.setScopeProp('addRightSpaceToShowHideLink', !returnVal);
        return returnVal;
      };
      ngModel.$parsers.unshift(function (viewValue) {
        passwordInputScope.setScopeProp('requirementLength', viewValue.length >= 8 && viewValue.length <= 20 ? false : 'active');
        passwordInputScope.setScopeProp('requirementNumberSymbol', /\d/.test(viewValue) || /[\-!@#$%\^&*()_+|~=`{}\[\]:';'<>?,.\/\\]/.test(viewValue) ? false : 'active');
        passwordInputScope.setScopeProp('requirementInfoSec', false);
        if (scope.user.country === 'AU') {
          var lcViewVal = viewValue.toLowerCase();
          var firstName = scope.user && scope.user.first_name && scope.user.first_name.toLowerCase();
          var lastName = scope.user && scope.user.last_name && scope.user.last_name.toLowerCase();
          var dob = scope.user && scope.user.dob_day + "/" + scope.user.dob_month + "/" + scope.user.dob_year;
          if (lcViewVal.indexOf(firstName) > -1 || lcViewVal.indexOf(lastName) > -1 || lcViewVal.indexOf(dob) > -1) {
            passwordInputScope.setScopeProp('requirementInfoSec', 'active');
          }
        }
        passwordInputScope.setScopeProp('restrictionEmail', false);
        passwordInputScope.setScopeProp('restrictionFourRepeated', viewValue.length > 3 && /(.)\1{3}/.test(viewValue) ? 'active' : false);
        passwordInputScope.setScopeProp('restrictionNonValidCharacters', /[\x00-\x08\x0E-\x1F\x80-\xFF ]/.test(viewValue) ? 'active' : false); // eslint-disable-line no-control-regex
        passwordInputScope.setScopeProp('restrictionFourSequence', viewValue.length > 3 && !fourSequence(viewValue) ? 'active' : false);
        passwordInputScope.setScopeProp('restrictionDoubleByte', containsDoubleByte(viewValue) ? 'active' : false);
        var requirements = !(passwordInputScope.getScopeProp('requirementLength') || passwordInputScope.getScopeProp('requirementNumberSymbol') || passwordInputScope.getScopeProp('requirementInfoSec'));
        var restrictions = !(passwordInputScope.getScopeProp('restrictionEmail') || passwordInputScope.getScopeProp('restrictionFourRepeated') || passwordInputScope.getScopeProp('restrictionNonValidCharacters') || passwordInputScope.getScopeProp('restrictionFourSequence') || passwordInputScope.getScopeProp('restrictionDoubleByte'));
        var isValidPassword = requirements && restrictions;
        ngModel.$setValidity('password', isValidPassword);
        passwordInputScope.setScopeProp('passwordToolTip', isValidPassword ? 'hide' : 'show');

        // for singlePassword field with hide/show link, add hide/show link
        // right side spacing based on validity of field input
        passwordInputScope.setScopeProp('addRightSpaceToShowHideLink', !isValidPassword);
        return viewValue;
      });
    }
  };
});
(0, _angular.$registerDirective)('confirm-password-validate', function () {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function link(scope, elem, attrs, controller) {
      var ngModel = controller;
      var passwordInputScope = scope.componentScope;
      ngModel.$setValidity('confirmPassword', false);
      passwordInputScope.$watch('user.password', function (newValue) {
        var cPass = passwordInputScope.user.confirmPassword;
        if (cPass && cPass.length && cPass !== newValue) {
          ngModel.$setValidity('confirmPassword', false);
          passwordInputScope.setScopeProp('passwordMismatch', 'show');
        }
      });
      ngModel.$parsers.unshift(function (viewValue) {
        var passwordVal = passwordInputScope.user.password;
        passwordInputScope.setScopeProp('restrictionMatch', passwordVal && viewValue.length > 0 && passwordVal.indexOf(viewValue) === 0 && passwordVal === viewValue);
        ngModel.$setValidity('confirmPassword', passwordVal === viewValue);
        passwordInputScope.setScopeProp('passwordMismatch', passwordInputScope.getScopeProp('restrictionMatch') ? 'hide' : 'show');
        return viewValue;
      });
    }
  };
});
_squid.$Component;
_squid.$locale;
_angular.$timeout;
_angular.$registerDirective;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/passwordInput/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"fieldGroup passwords clearfix\" content>\n    <div ng-switch=\"isDisabled\" class=\"inputField passwordField confidential {{locale.metadata.directionality}}\"\n         ng-class=\"{ 'half': !singlePassword, 'full': singlePassword }\" floating-label>\n\n         <div ng-switch-when=\"true\">\n            <input id=\"password\" name=\"password\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n               maxlength=\"22\" value=\"\" ng-disabled=\"isDisabled\" />\n            <label for=\"password\">{{ content('common.password') }}</label>\n         </div>\n\n         <div ng-switch-default directionality>\n            <input\n                ng-model=\"user.password\"\n                ng-focus=\"actions.onPasswordFocusBlur($event, true)\"\n                ng-blur=\"actions.onPasswordFocusBlur($event, false)\"\n                id=\"password\"\n                name=\"password\"\n                type=\"password\"\n                autocapitalize=\"off\"\n                autocomplete=\"off\"\n                aria-required=\"true\"\n                aria-describedby=\"passwordToolTip\"\n                track-focus-and-blur=\"password\"\n                maxlength=\"22\"\n                value=\"\"\n                password-validate\n            />\n            <label for=\"password\">{{ content('common.password') }}</label>\n         </div>\n\n         <div ng-if=\"singlePassword && !isDisabled && showPasswordTextToggleLink\" ng-class=\"{ addRightSpace: addRightSpaceToShowHideLink }\" class=\"showHidePasswordLinks\" ng-switch=\"showRawPassword\">\n            <a href=\"#\" id=\"showPasswordLink\" ng-switch-when=\"false\" title=\"{{ content('password.showPassword') }}\" ng-mousedown=\"toggleShowRawPassword($event)\">{{ content('common.show') }}</a>\n            <a href=\"#\" id=\"hidePasswordLink\" ng-switch-when=\"true\" title=\"{{ content('password.hidePassword') }}\" ng-mousedown=\"toggleShowRawPassword($event)\">{{ content('common.hide') }}</a>\n        </div>\n\n        <div ng-class=\"passwordToolTip\">\n            <xo-tooltip trigger=\"#password\" show-event=\"keyup\" ng-class=\"passwordToolTip\" id=\"passwordToolTip\">\n                <div class=\"tip tipDesc passwordToolTip\">\n                    <ul class=\"tipInfoText\">\n                        <li class=\"requirement\" ng-class=\"requirementLength\">{{ content('scripts.requirementLength') }}</li>\n                        <li class=\"requirement\" ng-class=\"requirementNumberSymbol\">{{ content('scripts.requirementNumberSymbol') }}</li>\n                        <li class=\"requirement\" ng-class=\"requirementInfoSec\" feature=\"requirementInfoSec\">{{ content('scripts.informationSecurity') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionEmail\">{{ content('scripts.restrictionEmail') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionFourRepeated\">{{ content('scripts.restrictionFourRepeated') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionNonValidCharacters\">{{ content('scripts.restrictionNonValidCharacters') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionFourSequence\">{{ content('scripts.restrictionFourSequence') }}</li>\n                        <li class=\"restriction\" ng-class=\"restrictionDoubleByte\">{{ content('scripts.restrictionDoubleByte') }}</li>\n                    </ul>\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n    <div ng-if=\"!singlePassword\" ng-switch=\"isDisabled\"\n         class=\"inputField confirmPasswordField half last-child confidential\" floating-label>\n\n         <div ng-switch-when=\"true\">\n            <input id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n               maxlength=\"22\" value=\"\" ng-disabled=\"isDisabled\" />\n            <label for=\"confirmPassword\">{{ content('common.confirmPassword') }}</label>\n         </div>\n\n         <div ng-switch-default directionality>\n            <input ng-model=\"user.confirmPassword\" id=\"confirmPassword\" name=\"confirmPassword\" type=\"password\" autocapitalize=\"off\" autocomplete=\"off\"\n                aria-required=\"true\" maxlength=\"22\" value=\"\" confirm-password-validate />\n            <label for=\"confirmPassword\">{{ content('common.confirmPassword') }}</label>\n         </div>\n\n        <div ng-class=\"passwordMismatch\">\n            <xo-tooltip trigger=\"#confirmPassword\" show-event=\"keyup\" id=\"confirmPasswordToolTip\">\n                <div class=\"tip tipDesc confirmPasswordToolTip\">\n                    <ul class=\"tipInfoText\">\n                        <li class=\"restriction active\">{{ content('scripts.restrictionMatch') }}</li>\n                    </ul>\n                </div>\n            </xo-tooltip>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/primaryResidentialAddressField/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/primaryResidentialAddressField/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/primaryResidentialAddressField/template.html"));
__webpack_require__("../node_modules/xo-guest-components/src/guest/primaryResidentialAddressInterstitial/directive.js");
__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var debounceAddressTimer = null;
var _default = exports["default"] = _index.$Component.extend('xoPrimaryResidentialAddress', {
  tag: 'xo-primary-residential-address',
  template: _template["default"],
  props: {
    onboard: {
      type: 'var',
      required: true
    },
    locale: {
      type: 'var',
      required: false
    },
    residentialAddress: {
      type: 'var',
      required: true
    }
  },
  actions: {
    fixPlaceholder: function fixPlaceholder() {
      // @TODO check is dirty override
      // Workaround to hide placeholder without focus();
      (0, _angular.$timeout)(function () {
        var primaryResidentialAddress = $('#primaryResidentialAddress')[0];
        if (!primaryResidentialAddress) {
          return;
        }
        primaryResidentialAddress.classList.add('focused');
      }, 50);
    },
    closeModal: function closeModal() {
      var _this = this;
      // Restore residential_address, without modifications
      // only restore fields, keep model, to call serialize() from $ResidentialAddressModel

      this.syncFields.forEach(function (field) {
        _this.onboard.residential_address[field] = _this.preEditChanges[field];
      });

      // Hide modal
      this.residentialAddress.residentialAddressShowPopup = false;
    },
    setPreEditChanges: function setPreEditChanges() {
      // Save values to rollback if closing with X
      // Copy of current residential_address
      Object.assign(this.preEditChanges, this.onboard.residential_address);
    },
    openModal: function openModal() {
      this.actions.setPreEditChanges();
      // Show modal
      this.residentialAddress.residentialAddressShowPopup = true;
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this2 = this;
      this.preEditChanges = {};
      // Only shows when user added a line1/postal code
      this.showPrimaryResidentialInput = false;
      this.syncFields = ['line1', 'line2', 'city', 'state', 'postal_code'];
      var onFirstLoadSyncResidentialWithBilling = function onFirstLoadSyncResidentialWithBilling() {
        if (_this2.residentialAddress.residentialAddressSyncBillingAddress) {
          _this2.syncFields.forEach(function (field) {
            _this2.onboard.residential_address[field] = _this2.onboard.billing_address[field];
          });
        }
      };
      var getCurrentAddress = function getCurrentAddress() {
        var address = _this2.onboard.residential_address;
        var postal_code = address.postal_code || '';
        var line1 = address.line1 || '';
        var finalAddress = line1 + ", " + postal_code;
        _this2.showPrimaryResidentialInput = line1.length > 0 && postal_code.length > 0;
        return finalAddress;
      };
      var updatePrimaryResAddressPreview = function updatePrimaryResAddressPreview() {
        _this2.primaryResidentialAddressValue = getCurrentAddress();
      };
      var debounceAddressChange = function debounceAddressChange() {
        // reset timer on each key press
        if (debounceAddressTimer) {
          _angular.$timeout.cancel(debounceAddressTimer);
        }
        debounceAddressTimer = (0, _angular.$timeout)(function () {
          updatePrimaryResAddressPreview();
        }, 200);
      };
      var updateOnboardWithBillingAddress = function updateOnboardWithBillingAddress(field) {
        if (!_this2.residentialAddress.residentialAddressSyncBillingAddress) {
          return;
        }
        _this2.onboard.residential_address[field] = _this2.onboard.billing_address[field];
        if (field === 'line1' || field === 'postal_code') {
          debounceAddressChange();
        }
      };

      // Update preview on blur, not on every change
      var zipCodeBlur = _angular.$rootScope.$on('zip_code_blur_residential', updatePrimaryResAddressPreview);
      _angular.$rootScope.$on('$destroy', zipCodeBlur);
      var line1Blur = _angular.$rootScope.$on('line_1_blur', updatePrimaryResAddressPreview);
      _angular.$rootScope.$on('$destroy', line1Blur);
      this.$watch('residentialAddress.residentialAddressShowPopup', function () {
        updatePrimaryResAddressPreview();
      });
      this.syncFields.forEach(function (field) {
        _this2.$watch("onboard.billing_address." + field, function () {
          updateOnboardWithBillingAddress(field);
        });
      });
      this.$watch('residentialAddress.residentialAddressFieldErrors', function () {
        _this2.actions.setPreEditChanges();
      });
      updatePrimaryResAddressPreview();
      onFirstLoadSyncResidentialWithBilling();
    },
    exit: function exit() {
      if (debounceAddressTimer) {
        _angular.$timeout.cancel(debounceAddressTimer);
      }
    }
  }
});
_index.$Component;
_angular.$rootScope;
_angular.$timeout;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/primaryResidentialAddressField/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/primaryResidentialAddressField/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"primaryResidentialAddressContainer\" ng-if=\"showPrimaryResidentialInput\">\n        <div id=\"primaryResidentialAddressField\" class=\"editBtnFieldContainer clearfix inputField\" content>\n                <div class=\"inputField confidential primaryResidentialAddress\" floating-label>\n\n                        <input ng-init=\"actions.fixPlaceholder()\" type=\"text\" name=\"primaryResidentialAddress\"\n                                id=\"primaryResidentialAddress\" aria-labelledby=\"primaryResidentialAddressLabel\"\n                                value=\"{{primaryResidentialAddressValue}}\" maxlength=\"60\" autocapitalize=\"off\"\n                                autocomplete=\"off\" data-error-key=\"common.valueInvalid\" readonly=\"true\"\n                                prefix-attrs-with=\"{{attrPrefix}}\" />\n\n\n                        <label for=\"primaryResidentialAddress\" id=\"primaryResidentialAddressLabel\"\n                                prefix-attrs-with=\"{{attrPrefix}}\">\n                                {{ content('common.primaryResidentialAddress') }}\n                        </label>\n                </div>\n\n                <button type=\"button\" class=\"editBtn\" ng-click=\"actions.openModal()\"\n                        aria-label=\"{{ content('common.edit') + ' ' + content('common.primaryResidentialAddress') }}\">                \n                        {{ content('common.edit') }}\n                </button>\n        </div>\n</div>\n\n<xo-modal ng-if=\"residentialAddress.residentialAddressShowPopup\" show=\"true\" show-close-button=\"true\"\n        enable-close-on-escape=\"true\" enable-mobile-interstitial=\"true\" override-default-container=\"true\"\n        on-close=\"actions.closeModal\" id=\"primaryResidentialAddressModal\">\n        <xo-primary-residential-address-interstitial onboard=\"onboard\" locale=\"locale\"\n                residential-address=\"residentialAddress\" />\n</xo-modal>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/primaryResidentialAddressInterstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/primaryResidentialAddressInterstitial/template.html"));
__webpack_require__("../node_modules/xo-guest-components/src/guest/primaryResidentialAddressInterstitial/styles.less");
__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('xoPrimaryResidentialAddressInterstitial', {
  tag: 'xo-primary-residential-address-interstitial',
  template: _template["default"],
  props: {
    onboard: {
      type: 'var',
      required: true
    },
    residentialAddress: {
      type: 'var',
      required: true
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.locale = _index.$locale;
      this.validated = false;
      _logger.$logger.info('residential_address_interstitial_loaded');
      var errorsMap = {
        // PO BOX
        PO_BOX: _index.$locale.content.get('fieldLevelError.invalidPrimaryResidentialAddress.invalidPOBox'),
        // RR Box, only for Canada
        RR_BOX: _index.$locale.content.get('fieldLevelError.invalidPrimaryResidentialAddress.invalidRRBox')
      };
      var getErrorKey = function getErrorKey(contingencyErr) {
        return errorsMap[contingencyErr] || _index.$locale.content.get('common.valueInvalid');
      };
      var setCustomError = function setCustomError() {
        if (_this.residentialAddress.residentialAddressFieldErrors) {
          var err = _this.residentialAddress.residentialAddressFieldErrorValue;
          _logger.$logger.info("residential_address_interstitial_loaded_" + err);
          _this.residentialErrorContent = getErrorKey(err);
        } else {
          _this.residentialErrorContent = false;
        }
      };
      setCustomError();
      this.$watch('residentialAddress.residentialAddressFieldErrors', function () {
        setCustomError();
      });
    },
    populate: function populate() {}
  },
  actions: {
    hasResidentialAddressError: function hasResidentialAddressError() {
      return document.querySelector('.addressForm .visibleResidentialError') !== null;
    },
    onSave: function onSave() {
      this.residentialAddress.residentialAddressSyncBillingAddress = false;
      this.residentialAddress.residentialAddressShowPopup = false;
      this.residentialAddress.residentialAddressFieldErrors = false;
      this.residentialErrorContent = false;
      _logger.$logger.info('residential_address_interstitial_save');
    },
    onSubmit: function onSubmit() {
      if (!this.actions.hasResidentialAddressError()) {
        this.actions.onSave();
      }
    }
  }
});
_index.$Component;
_index.$locale;
_logger.$logger;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/primaryResidentialAddressInterstitial/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/primaryResidentialAddressInterstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"primaryResAddressInterstitialContainer\" content>\n        <div class=\"interstitialTitle\">\n                {{ content('common.primaryResidentialAddress') }}\n        </div>\n\n        <form id=\"residentialAddressForm\" name=\"residentialAddressForm\" class=\"\" ng-class=\"{'validated': validated}\"\n                ng-submit=\"residentialAddressForm.$valid && actions.onSubmit()\" novalidate>\n\n                <xo-add-address is-residential=\"true\" address=\"onboard.residential_address\" country=\"locale.country\"\n                        residential-error-content=\"residentialErrorContent\">\n                </xo-add-address>\n\n                <button type=\"submit\" class=\"btn full\" ng-click=\"validated = true\"\n                        id=\"{{!residentialAddress.residentialAddressFieldErrors ? 'residentialAdressSave' : 'residentialAdressSaveAndContinue'}}\">\n\n                        {{ !residentialAddress.residentialAddressFieldErrors ? content('buttons.save') :\n                        content('buttons.saveAndContinue')}}\n                </button>\n\n        </form>\n\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoRedirectingFromXoonWarning', {
  tag: 'xo-redirecting-from-xoon-warning',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: true
    },
    flags: {
      type: 'var',
      required: true
    },
    // mode is not present in multistep, so it is set as not required
    mode: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        auth: _index.$AuthModel.instance().retrieve()
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      // Default to 'signup' as multistep will not pass mode prop
      this.mode = this.mode || 'signup';
    },
    populate: function populate() {
      var $ccField = $('#cc');

      // Check the validity of fields read from config
      if (($ccField.val() || '').length > 0 && $ccField.hasClass('ng-valid')) {
        _logger.$logger.info('checkout_fpti', {
          from: this.mode === 'signup' ? 'signup' : 'guest_xo',
          to: 'prep_change_email'
        });
        this.showPrompt = true;
      } else {
        this.actions.redirectToHermes();
      }
    }
  },
  actions: {
    redirectToHermes: function redirectToHermes(isRedirectConfirmationShown) {
      var redirectLogType = isRedirectConfirmationShown ? 'with' : 'without';
      var transitionName = isRedirectConfirmationShown ? 'process_yes_change_email' : 'process_change_email';
      _logger.$logger.info("splitscreen_email_change_redirect_" + redirectLogType + "_modal_confirmation");
      _logger.$logger.info('checkout_fpti', {
        from: this.mode === 'signup' ? 'signup' : 'guest_xo',
        to: transitionName
      });

      // need this to get token in ".then" function of clearCookies call
      var that = this;

      // We need to clear loginEmail and rmuc cookies
      // to make sure UL treats this user as splitscreen eligible
      this.models.auth.clearCookies({
        loginEmail: true,
        rmuc: true
      }).then(function () {
        // Make sure to send locale and country as we need to carry this back
        // to hermes, if user changed these params in xoon
        (0, _squid.$dispatch)('hermes', {
          token: that.token,
          'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
          'country.x': _squid.$locale.country
        });
      });
    },
    triggerRedirect: function triggerRedirect($event) {
      if ($event) {
        $event.preventDefault();
      }
      this.actions.redirectToHermes(true);
    },
    closePopupModal: function closePopupModal($event) {
      // We need this as this function is called from xo-modal
      // as a callback function
      if ($event) {
        $event.preventDefault();
      }
      _logger.$logger.info('checkout_fpti', {
        from: this.mode === 'signup' ? 'signup' : 'guest_xo',
        to: 'process_no_change_email'
      });
      this.showPrompt = false;
      this.flags.showRedirectWarningPrompt = false;
    }
  }
});
_squid.$Component;
_squid.$locale;
_squid.$dispatch;
_logger.$logger;
_index.$AuthModel;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/redirectingFromXoonWarning/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-modal ng-if=\"showPrompt\"\n    show=\"showPrompt\" override-default-container=\"true\"\n    on-close=\"actions.closePopupModal\"\n    enable-close-on-escape=\"true\" content>\n    <div id=\"redirectPromptBox\">\n        <div class=\"informationContent\">\n            <h1 class=\"alpha\" ng-bind-html=\"htmlContent('splitScreenExp.areYouSure')\"></h1>\n            <p class=\"subTitle\" ng-bind-html=\"htmlContent('splitScreenExp.confirmEmailChange')\"></p>\n        </div>\n\n        <div class=\"promptActionLinks\">\n            <a class=\"first\" ng-click=\"actions.triggerRedirect($event)\" href=\"#\" ng-bind-html=\"htmlContent('splitScreenExp.yesChange')\"></a>\n            <a class=\"last\" ng-click=\"actions.closePopupModal($event)\" href=\"#\" ng-bind-html=\"htmlContent('splitScreenExp.noDontChange')\"></a>\n        </div>\n    </div>\n</xo-modal>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/select-shipping-method/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, console) {

exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var errorHandlerHelper = _interopRequireWildcard(__webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js"));
var _index2 = __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/template.html"));
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/shipping-method-dropdown/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/styles.less");
var _util = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * Created by aaramamurthy on 2/29/16.
 *
 * Component responsible to show shipping methods set by merchant to a buyer during guest checkout flow.
 */
var _default = exports["default"] = _index.$Component.extend('$xoGuestSelectShippingMethodDirective', {
  tag: 'xo-guest-select-shipping-method',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    billingAddress: {
      type: 'var',
      required: false
    },
    shippingAddress: {
      type: 'var',
      required: false
    },
    isShippingSameAsBilling: {
      type: 'var',
      required: false
    },
    showShipping: {
      type: 'var',
      required: false
    },
    buttonParams: {
      type: 'var',
      required: false
    },
    updatePageLevelErrorMessage: {
      type: 'var',
      required: false
    },
    flags: {
      type: 'var',
      required: false
    },
    trackSntReq: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
        checkoutCart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve(),
        checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      // Decides whether to show whole section
      this.showShippingMethodSection = true;

      // Decides whether to show merchant options
      this.showMerchantOptions = true;
      this.showZipCode = false;
      this.zipCode = '';

      // Decides whether to show different DropDown
      this.isShowShippingMethodsDropDown = false;
      this.noShippingMethodDropDown = true;

      // Decides whether to show pick up store Text
      this.isStorePickUp = false;
      this.billingCountryChangeWatchVariable = false;
      this.shippingCountryChangeWatchVariable = false;

      // Models
      this.currencyCode = '';
      this.selectedShippingCharge = '';

      // Initial charges
      this.charges = [{}];

      // No shipping charges
      this.noShippingChargesList = this.charges;

      // Hide the additional drop down that is rendered in iOS
      this.hideSelectDropdown = navigator.appVersion.indexOf('iPhone') !== -1;

      // Models mapped to guest scope component
      this.billingAddress = this.props.billingAddress;
      this.shippingAddress = this.props.shippingAddress;
      this.propsFlags = this.props.flags;
      this.isShippingSameAsBilling = this.props.isShippingSameAsBilling;
      this.showShipping = this.props.showShipping;
      this.trackSntReq = this.props.trackSntReq;

      // Decides on disable/enable of dropdown
      this.changeShippingMethod = 'changeShippingMethodDisabled';
      this.selectedShippingMethodText = 'disableShippingMethod';
      this.dropDownBackground = 'normalBackground';

      // Used for instant update feature
      this.callbackShippingOptions = [];
      this.fallbackShippingOptions = [];
      this.selectedMethod = {};
      this.callbackInsuranceOffered = false;
      this.defaultFallbackOptionIndex = 0;
      this.shippingMethodNotSelected = true;
      this.shipAndTaxError = false;
      this.override = false;
      this.noErrorOrOverride = true;
      this.triggerFetchShippingMethods = false;
      this.localeCountry = _index.$locale.country;
      this.trackZipCode = {
        prev: '',
        current: ''
      };
      this.trackState = {
        prev: '',
        current: ''
      };
      var populatePatchAmountDetails = function populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts) {
        var newTotal = _this.buttonCartAmounts.total;
        Object.keys(patchableAmountEntities).forEach(function (key) {
          var detail = patchableAmountEntities[key];
          if (!isNaN(detail.value)) {
            detail.value = Number(detail.value);
            amounts.details[key] = detail.value.toFixed(decimalDigits);
          } else {
            detail.value = 0;
          }
          var difference = detail.valueInCart ? detail.value - detail.valueInCart : detail.value;
          newTotal += difference;
        });
        amounts.total = newTotal.toFixed(decimalDigits);
        Object.keys(constantAmountEntities).forEach(function (key) {
          var detail = constantAmountEntities[key];
          if (detail.valueInCart !== undefined) {
            amounts.details[key] = detail.valueInCart.toFixed(decimalDigits);
          }
        });
        _logger.$logger.info('snt_populate_patch_amount_details', {
          patchableAmountEntities: patchableAmountEntities,
          constantAmountEntities: constantAmountEntities,
          amounts: amounts,
          decimalDigits: decimalDigits
        });
      };

      // Todo: Understand: Why are we modifying API response?
      var getExternalCallbackOptionsForPatch = function getExternalCallbackOptionsForPatch() {
        var externalCallbackOptions = _this.models.checkoutCart.getExternalCallbackOptions();
        if (_this.response.shipping_options_source === 'CALLBACK') {
          externalCallbackOptions.callback_shipping_options = _this.callbackShippingOptions;
          externalCallbackOptions.callback_insurance_option_offered = _this.callbackInsuranceOffered;
        } else if (_this.response.shipping_options_source === 'FALLBACK') {
          externalCallbackOptions.fallback_shipping_options = _this.fallbackShippingOptions;
        }
        _logger.$logger.info('snt_external_callback_options_for_patch', {
          externalCallbackOptions: externalCallbackOptions
        });
        return externalCallbackOptions;
      };

      // Generates the request body to be used for patch Cart
      var getPatchReqData = function getPatchReqData(shippingAmt, taxAmt, shipMethod, insuranceAmt) {
        // What will get patched?
        // 1. amount values in the cart,
        // 2. shipping method (only in case of non instant update flows)
        // 3. external_callback_options (only in case of instant update flows)

        var currencyDigits = _index.$locale.metadata && _index.$locale.metadata.currency && _index.$locale.metadata.currency.digits;
        var decimalDigits = currencyDigits && currencyDigits[_this.currencyCode];
        if (isNaN(decimalDigits)) {
          decimalDigits = 2;
        }
        var patchEntities = [];
        var amounts = {
          currency: _this.currencyCode,
          details: {
            subtotal: _this.buttonCartAmounts.subTotal.toFixed(decimalDigits)
          }
        };
        var patchableAmountEntities = {
          shipping: {
            value: shippingAmt,
            valueInCart: _this.buttonCartAmounts.shippingAmt
          },
          tax: {
            value: taxAmt,
            valueInCart: _this.buttonCartAmounts.taxAmt
          },
          insurance: {
            value: insuranceAmt,
            valueInCart: _this.buttonCartAmounts.insuranceAmt
          }
        };
        // amount details which are not affected by SnT response,
        // but still need to get included in the patch request if initially present
        var constantAmountEntities = {
          handling_fee: {
            valueInCart: _this.buttonCartAmounts.handlingAmt
          },
          shipping_discount: {
            valueInCart: _this.buttonCartAmounts.shippingDiscountAmt
          },
          discount: {
            valueInCart: _this.buttonCartAmounts.discount
          }
        };
        populatePatchAmountDetails(patchableAmountEntities, constantAmountEntities, decimalDigits, amounts);
        patchEntities.push({
          field: 'purchaseAmount',
          value: amounts
        });
        if (_this.isInstantUpdateFlow) {
          patchEntities.push({
            field: 'externalCallbackOptions',
            value: getExternalCallbackOptionsForPatch()
          });
        } else {
          var shippingMethod = '';
          if (shipMethod && _this.shippingMethods) {
            shippingMethod = _this.shippingMethods.getShippingMethodId(shipMethod);
          }
          patchEntities.push({
            field: 'shippingMethod',
            value: shippingMethod
          });
        }
        var patchRequest = {
          id: _this.token,
          patchEntities: patchEntities
        };
        _logger.$logger.info('snt_patch_request', {
          patchRequest: patchRequest
        });
        return patchRequest;
      };

      // Function which will update costs which were patched
      var updatePreviousCosts = function updatePreviousCosts() {
        _this.previousCosts = {};
        if (_this.models.checkoutCart.purchase.amounts.shipping) {
          _this.previousCosts.shippingAmount = Number(_this.models.checkoutCart.purchase.amounts.shipping.amount);
        }
        if (_this.models.checkoutCart.purchase.amounts.tax) {
          _this.previousCosts.taxAmount = Number(_this.models.checkoutCart.purchase.amounts.tax.amount);
        }
        _logger.$logger.info('snt_update_previous_costs', {
          previousCosts: _this.previousCosts
        });
      };

      // Responsible to patch the cart with shipping, tax (and insurance in case of instant update)
      var updateShippingTaxCharge = function updateShippingTaxCharge(shippingAmt, taxAmt, shipMethod, insurance) {
        _logger.$logger.info('snt_update_shipping_tax_charge', {
          shippingAmt: shippingAmt,
          taxAmt: taxAmt,
          shipMethod: shipMethod,
          decodeEntities: (0, _util.decodeEntities)(shipMethod),
          insurance: insurance
        });
        var patchReq = getPatchReqData(shippingAmt, taxAmt, (0, _util.decodeEntities)(shipMethod), insurance);
        _this.models.checkoutCart.action('patchCartData', {
          data: patchReq,
          batch: {
            name: 'patchCartData',
            id: 'checkoutCart'
          },
          success: function success(result) {
            _logger.$logger.info('snt_patch_cart_data_success');
            _this.checkoutSession = _index3.$CheckoutSessionModel.instance(_this.token);
            updatePreviousCosts();
          },
          contingencies: {
            DEFAULT: function DEFAULT(name, err) {
              _logger.$logger.info('snt_patch_cart_failure', {
                error: err
              });
              throw err;
            }
          }
        });
      };

      // Checks whether domestic shipping methods are supported for the country or not
      this.isDomesticShippingMethodsSupported = function () {
        var country = _this.isShippingSameAsBilling ? _this.billingAddress.country : _this.shippingAddress.country;
        var result;
        if (_this.isInstantUpdateFlow) {
          // for countries which have no state or zip code in their address templates, SnT must be called based on country change
          // which implies isDomesticShippingMethodsSupported would be false
          result = !(0, _index.$feature)('noZipCodeOrState', false, country);
        } else {
          result = (0, _index.$feature)('allowWPSDomesticShippingMethods', false, country);
        }
        _logger.$logger.info('snt_is_domestic_shipping_methods_supported', {
          result: result,
          isInstantUpdateFlow: _this.isInstantUpdateFlow
        });
        return result;
      };

      // Sets the zip code whenever user enters the postal code field.
      this.setZipCode = function (caller) {
        if (_this.isDomesticShippingMethodsSupported()) {
          _this.showZipCode = true;
          if (_this.isShippingSameAsBilling) {
            _this.zipCode = _this.billingAddress.postal_code;
          } else {
            _this.zipCode = _this.shippingAddress.postal_code;
          }
        } else {
          _this.showZipCode = false;
        }
        _logger.$logger.info('snt_set_zip_code', {
          isShippingSameAsBilling: _this.isShippingSameAsBilling,
          zipCode: _this.zipCode,
          showZipCode: _this.showZipCode,
          caller: caller
        });
      };

      // Checks whether there was a change in zip code
      var isZipCodeChange = function isZipCodeChange() {
        var result = _this.trackZipCode.prev !== _this.trackZipCode.current;
        _logger.$logger.info('snt_zip_code_changed', {
          previousZipCode: _this.trackZipCode.prev,
          currrentZipCode: _this.trackZipCode.current,
          result: result
        });
        return result;
      };

      // Checks whether there was a change in state
      var isStateChange = function isStateChange() {
        var result = _this.trackState.prev !== _this.trackState.current;
        _logger.$logger.info('snt_state_changed', {
          PreviousState: _this.trackState.prev,
          CurrentState: _this.trackState.current,
          result: result
        });
        return result;
      };

      // Checks whether there was a change in country
      // Todo: Understand: Won't billing address country will always be the same as locale country
      var isCountryChange = function isCountryChange() {
        _logger.$logger.info('snt_country_changed', {
          bc: _this.billingAddress && _this.billingAddress.country,
          lc: _this.localeCountry
        });
        if (_this.billingAddress.country && _this.localeCountry) {
          return _this.billingAddress.country !== _this.localeCountry;
        }
        // Todo: Understand: Why are we returning true by default
        return true;
      };

      // Util function to help safe convert a value to decimal
      var safeConvert = function safeConvert(value) {
        value = Number(value);
        _logger.$logger.info('snt_safe_convert', {
          value: value
        });
        if (isNaN(value)) {
          throw new Error(value + ' cannot be divided');
        }
        return value / 100;
      };

      // Checks whether shipping and tax response has tax in it
      // Todo: instead of returning a boolean why not returntax amount if there is any
      var responseHasTaxCharges = function responseHasTaxCharges() {
        _logger.$logger.info('snt_response_has_tax_charges', {
          charges: _this.response.charges
        });
        if (_this.response.charges.length === 0) {
          return false;
        }
        return !!_this.response.charges[0].tax;
      };

      // Checks whether shipping and tax response has shipping charges
      var responseHasShippingCharges = function responseHasShippingCharges() {
        _logger.$logger.info('snt_response_has_shipping_charges', {
          charges: _this.response.charges
        });
        if (_this.response.charges.length === 0) {
          return false;
        }
        return !!_this.response.charges[0].shipping_charge;
      };

      /*
       Checks whether patch cart is required or not .
       Use cases where this is called
       ------------------------------
       1. When user selects a shipping method from dropdown.
       2. User selects store pick Up , wants to change shipping address but shipping address fields are empty ,
       applicationShippingAmt will be passed as undefined to this function .
       */
      var isPatchCartRequired = function isPatchCartRequired(applicableShippingAmt, applicableTaxAmt) {
        var result = applicableShippingAmt !== _this.previousCosts.shippingAmount || applicableTaxAmt !== _this.previousCosts.taxAmount;
        _logger.$logger.info('snt_is_patch_card_required', {
          applicableShippingAmt: applicableShippingAmt,
          applicableTaxAmt: applicableTaxAmt,
          previousCosts: _this.previousCosts,
          result: result
        });
        return result;
      };
      var getTaxFromResponse = function getTaxFromResponse(charge) {
        // todo: Understand: is charge different from towhat is there in response since we want to get tax from
        // response!
        var responseCharge = charge || responseHasTaxCharges() && _this.response.charges[0];
        var result;
        if (responseCharge && responseCharge.tax) {
          // todo: Understand: Why the below condition
          if (!_this.buttonCartAmounts.shippingAmt && !_this.showShipping) {
            result = safeConvert(responseCharge.tax.item_tax.value);
          } else {
            result = safeConvert(responseCharge.tax.total_tax.value);
          }
        }
        _logger.$logger.info('snt_tax_from_response', {
          result: result,
          responseCharge: responseCharge
        });
        return result;
      };

      // Returns tax amount
      var getTax = function getTax(charge) {
        _logger.$logger.info('snt_get_tax', {
          isInstantUpdateFlow: _this.isInstantUpdateFlow,
          isBuyNow: _this.isBuyNow,
          buttonCartAmountsTaxAmt: _this.buttonCartAmounts.taxAmt
        });

        // todo: Understand: Why do we need isInstantUpdateFlow condition when getTaxFromResponse(charge); is
        // the default!?
        if (_this.isInstantUpdateFlow) {
          return getTaxFromResponse(charge);
        }
        if ((_this.isBuyNow || _this.isCartUpload) && _this.buttonCartAmounts.taxAmt >= 0) {
          return _this.buttonCartAmounts.taxAmt;
        }
        return getTaxFromResponse(charge);
      };

      // Disables the shipping method dropdown
      var disableDropDown = function disableDropDown() {
        _logger.$logger.info('snt_disable_dropdown');
        _this.isShowShippingMethodsDropDown = false;
        _this.noShippingMethodDropDown = true;
        _this.changeShippingMethod = 'changeShippingMethodDisabled';
        _this.dropDownBackground = 'normalBackground';
        _this.selectedShippingMethodText = 'disableShippingMethod';
        var span = $('#noShippingMethod > div > span > span > span');
        span.html(_index.$locale.content.get('shippingMethod.selectMethod'));
      };

      // Enable the shipping method dropdown
      var enableDropDown = function enableDropDown() {
        _logger.$logger.info('snt_enable_dropdown');
        _this.isShowShippingMethodsDropDown = true;
        _this.noShippingMethodDropDown = false;
        _this.shippingMethodNotSelected = true;
        _this.changeShippingMethod = 'changeShippingMethodEnabled';
        _this.dropDownBackground = 'normalBackground';
        _this.selectedShippingMethodText = 'enableShippingMethod';
      };

      // Enable store pick up to show shipping address
      var enableStorePickUp = function enableStorePickUp() {
        _logger.$logger.info('snt_enable_store_pickup');
        _this.propsFlags.hideShippingAddress = true;
        _this.propsFlags.showSingleAddress = true;
        _angular.$rootScope.$emit('store_pick_up_selected');
      };

      // Disable store pick Up
      var disableStorePickUp = function disableStorePickUp() {
        _logger.$logger.info('snt_disable_store_pickup');
        _this.propsFlags.hideShippingAddress = false;
        _this.propsFlags.showSingleAddress = false;
      };

      // Checks whether zip code is empty or not
      var isFormZipCodeEmpty = function isFormZipCodeEmpty() {
        // Todo: Understand: Is zipCodeField always present for non instant update flow?
        // Basically understand instant update flow
        var result;
        if (_this.isInstantUpdateFlow) {
          var zipCodeField = _this.isShippingSameAsBilling ? $('#billingAddress #postalCode')[0] || $('#billingAddress #billingPostalCode')[0] : $('#shippingAddress #postalCode')[0] || $('#shippingAddress #shippingPostalCode')[0];
          // The zip code field is not present for some countries.
          // isFormZipCodeEmpty() in that case returns false

          if (!zipCodeField) {
            _logger.$logger.info('snt_is_form_zip_code_empty_no_zip_field');
            return false;
          }
        }
        if (_this.isShippingSameAsBilling) {
          result = _this.billingAddress && !_this.billingAddress.postal_code;
        } else {
          result = _this.shippingAddress && !_this.shippingAddress.postal_code;
        }
        _logger.$logger.info('snt_is_form_zip_code_empty', {
          result: result,
          isShippingSameAsBilling: _this.isShippingSameAsBilling
        });
        return result;
      };

      // Checks whether line1 is emoty or not
      var isFormAddressLine1Empty = function isFormAddressLine1Empty() {
        var result;
        if (_this.isShippingSameAsBilling) {
          result = _this.billingAddress && !_this.billingAddress.line1;
        } else {
          result = _this.shippingAddress && !_this.shippingAddress.line1;
        }
        _logger.$logger.info('snt_is_form_address_line1_empty', {
          result: result
        });
        return result;
      };

      // Checks whether state is empty or not
      var isFormStateEmpty = function isFormStateEmpty() {
        var result;
        if (_this.isInstantUpdateFlow) {
          var stateField = _this.isShippingSameAsBilling ? $('#billingAddress #state')[0] || $('#billingAddress #billingState')[0] : $('#shippingAddress #state')[0] || $('#shippingAddress #shippingState')[0];
          // The state field is not present for some countries.
          // isFormStateEmpty() in that case returns false

          if (!stateField) {
            _logger.$logger.info('snt_is_form_state_empty_no_state');
            return false;
          }
        }
        if (_this.isShippingSameAsBilling) {
          result = _this.billingAddress && !_this.billingAddress.state;
        } else {
          result = _this.shippingAddress && !_this.shippingAddress.state;
        }
        _logger.$logger.info('snt_is_form_state_empty', {
          result: result,
          isShippingSameAsBilling: _this.isShippingSameAsBilling
        });
        return result;
      };

      // Returns the current zip code entered by the user
      var getCurrentZipCode = function getCurrentZipCode() {
        _logger.$logger.info('snt_get_current_zip_code', {
          isShippingSameAsBilling: _this.isShippingSameAsBilling,
          baPostalCode: _this.billingAddress.postal_code,
          saPostalCode: _this.shippingAddress.postal_code
        });
        if (_this.isShippingSameAsBilling) {
          if (_this.billingAddress.postal_code) {
            return _this.billingAddress.postal_code;
          }
        }

        // Todo: Understand should it be else if?
        if (_this.shippingAddress.postal_code) {
          return _this.shippingAddress.postal_code;
        }
      };

      // Returns current state selected by the user
      var getCurrentState = function getCurrentState() {
        _logger.$logger.info('snt_get_current_state', {
          isShippingSameAsBilling: _this.isShippingSameAsBilling,
          baPostalCode: _this.billingAddress.state,
          saPostalCode: _this.shippingAddress.state
        });
        if (_this.isShippingSameAsBilling) {
          if (_this.billingAddress.state) {
            return _this.billingAddress.state;
          }
        }
        if (_this.shippingAddress.state) {
          return _this.shippingAddress.state;
        }
      };
      var isValidPostalCodeElement = function isValidPostalCodeElement(element) {
        var isValidBillingPostalCodeElement = (element === 'billingPostalCode' || element === 'postalCode') && _this.isShippingSameAsBilling;
        var isValidShippingPostalCodeElement = (element === 'shippingPostalCode' || element === 'postalCode') && !_this.isShippingSameAsBilling;
        _logger.$logger.info('snt_is_valid_postal_code_element', {
          result: isValidBillingPostalCodeElement || isValidShippingPostalCodeElement
        });
        return isValidBillingPostalCodeElement || isValidShippingPostalCodeElement;
      };

      // Function which patches the cart with button parameters
      var patchCartWithButtonParams = function patchCartWithButtonParams() {
        _logger.$logger.info('snt_patch_cart_with_button_params', {
          buttonCartAmounts: _this.buttonCartAmounts
        });
        if (!_this.buttonCartAmounts) {
          // todo: Understand: No error?
          return;
        }
        var shippingAmt = _this.buttonCartAmounts.shippingAmt;
        var taxAmt = _this.buttonCartAmounts.taxAmt;
        if (isPatchCartRequired(shippingAmt, taxAmt)) {
          updateShippingTaxCharge(shippingAmt, taxAmt, 'DEFAULT');
        }
      };

      // Listener to fetch adapted shipping methods when locale changes
      // Todo: Cleanup: localeChange not required
      var localeChange = _angular.$rootScope.$on('localeChange', function (event) {
        _this.localeCountry = _index.$locale.country;
        if (!isCountryChange()) {
          _logger.$logger.info('snt_no_country_change');
          disableDropDown();
          _this.fetchShippingMethods();
        }
      });

      // Todo: cleanup: not needed
      _angular.$rootScope.$on('$destroy', localeChange);

      // Listener which is responsible to patch Cart with button params if shipping address fields are empty
      var changeInShippingAddress = _angular.$rootScope.$on('change_in_shipping_address', function (event) {
        _logger.$logger.info('snt_change_in_shipping_address');
        if (isFormZipCodeEmpty() || isFormStateEmpty()) {
          disableDropDown();
          _this.isStorePickUp = false;
          patchCartWithButtonParams();
        }
      });
      _angular.$rootScope.$on('$destroy', changeInShippingAddress);
      this.setAllowPayWithSnT = function (value) {
        _logger.$logger.info('snt_set_allow_pay_with_snt', {
          value: value
        });
        _this.propsFlags.allowPayWithSnT = value;
      };
      this.handleZipCodeBlur = function (event) {
        _logger.$logger.info('snt_handle_zip_code_blur', {
          allowSnTCall: _this.propsFlags.allowSnTCall
        });
        if (_this.propsFlags.allowSnTCall) {
          // if address is not a prefill and this.billingAddress and this.shippingAddress
          // has some values, that means some race condition is still holding the values in
          // the objects this.billingAddress, this.shippingAddress.
          // so cleanup billing and shipping zip/line1/state, dont trigger fetch shipping charges and patch later.

          // NOTE: Both watch variable can the true in a given transaction.
          // for ex: deselecting shippingsameasbilling checkout

          // shippingCountryChangeWatchVariable is set when shipping address country watch is
          // invoked.
          if (_this.shippingCountryChangeWatchVariable && !_this.propsFlags.shippingAddressPresentFromCart) {
            // clean up shipping zip/line1/state
            if (_this.shippingAddress) {
              _logger.$logger.info('not_a_shippingAddress_prefill_cleanup_state_zip_postalcode');
              delete _this.shippingAddress.postal_code;
              delete _this.shippingAddress.line1;
              delete _this.shippingAddress.state;
              _this.shippingCountryChangeWatchVariable = false;
            }
          }
          // billingCountryChangeWatchVariable is set when billing address country watch is
          // invoked.
          if (_this.billingCountryChangeWatchVariable && !_this.propsFlags.billingAddressPresentFromCart) {
            // clean up billing zip/line1/state
            if (_this.billingAddress) {
              _logger.$logger.info('not_a_billingAddress_prefill_cleanup_state_zip_postalcode');
              delete _this.billingAddress.postal_code;
              delete _this.billingAddress.line1;
              delete _this.billingAddress.state;
            }
          }
          if (!_this.showShipping) {
            disableDropDown();
            _this.fetchShippingMethods();
          } else if (!isFormZipCodeEmpty() && !isFormStateEmpty()) {
            _this.trackZipCode.current = getCurrentZipCode();
            _this.trackState.current = getCurrentState();
            if (isZipCodeChange() || isStateChange()) {
              if (_this.isDomesticShippingMethodsSupported()) {
                disableDropDown();
                _this.fetchShippingMethods();
              } else {
                _this.setAllowPayWithSnT(true);
              }
            } else {
              _this.setAllowPayWithSnT(true);
            }
          } else if (!isFormAddressLine1Empty() && (isFormZipCodeEmpty() || isFormStateEmpty())) {
            if (isFormZipCodeEmpty()) {
              _this.trackZipCode.prev = '';
            }
            if (isFormStateEmpty()) {
              _this.trackState.prev = '';
            }
            if (_this.isDomesticShippingMethodsSupported()) {
              _angular.$rootScope.$emit('showErrorFields');
              disableDropDown();
              _this.isStorePickUp = false;
              disableStorePickUp();
              patchCartWithButtonParams();
            }
          } else {
            _logger.$logger.info('snt_handle_zip_code_blur_default', {
              showZipCode: false
            });
            _this.showZipCode = false;
          }
        }
      };

      // Listener which is responsible to call shipping tax API to fetch shipping methods for the given address
      var zipCodeBlur = _angular.$rootScope.$on('zip_code_blur', this.handleZipCodeBlur);
      _angular.$rootScope.$on('$destroy', zipCodeBlur);
      var handleZipCodeKeyPress = function handleZipCodeKeyPress(event, args) {
        var zipCodeElement = args && args.event && args.event.target && args.event.target.id;
        _logger.$logger.info('snt_handle_zip_code_key_press', {
          zipCodeElement: zipCodeElement
        });
        _this.setAllowPayWithSnT(true);
        /* On keypress of zip code element in US / CA , SnT should be applied before Pay.
         For other countries , flag will be set when SnT Call is made during Page load .
         */
        if (zipCodeElement && isValidPostalCodeElement(zipCodeElement) && _this.isDomesticShippingMethodsSupported() && isZipCodeChange()) {
          _this.setAllowPayWithSnT(false);
        }
      };
      var zipCodeKeyPress = _angular.$rootScope.$on('zip_code_keypress', handleZipCodeKeyPress);
      _angular.$rootScope.$on('$destroy', zipCodeKeyPress);

      /*
       Watcher on the ship to Billing checkbox
       Use cases
       ---------
       1. User has selected a shipping method , unchecks the ship to my billing checkbox , if shipping address is empty
       we disable dropdown and patch cart with button params.
       2. User has selected a shipping method , unchecks the ship to my billing checkbox , if shipping address is not empty,
       we fetch shipping methods based on shipping address.
       3. User has selected a shipping method based on shipping address , checks the ship to my billing checkbox ,
       we fetch shipping methods based on billing address.
       */
      this.$watch('isShippingSameAsBilling', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          _logger.$logger.info('snt_shipping_same_as_billing_watch');
          disableDropDown();
          _this.trackZipCode = {
            prev: '',
            current: ''
          };
          _this.trackState = {
            prev: '',
            current: ''
          };
          _this.fetchShippingMethods();
          _this.isStorePickUp = false;
          _this.setZipCode('snt_shipping_same_as_billing_watch');
        }
      });

      /*
       For instant update flows, the SnT service call is triggered when there is a change in
       i. State
       ii. Zip code
       Changes to any other address fields will not trigger the SnT call.
       The address fields are again compared during submit. If they are found to be different, SnT is again called.
       */

      // Watcher for billing address postal code
      this.$watch('billingAddress.postal_code', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          _logger.$logger.info('snt_billing_address_postal_code_watch', {
            newVal: newVal,
            oldVal: oldVal
          });
          _this.shipAndTaxError = false;
          _this.setZipCode('snt_billing_address_postal_code_watch');
        }
      });

      // Watcher for shipping address postal code
      this.$watch('shippingAddress.postal_code', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          _logger.$logger.info('snt_billing_address_postal_code_watch', {
            newVal: newVal,
            oldVal: oldVal
          });
          _this.shipAndTaxError = false;
          _this.setZipCode('snt_billing_address_postal_code_watch');
        }
      });

      // Watchers for billing address state change
      this.$watch('billingAddress.state', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          _logger.$logger.info('snt_billing_address_state_watch', {
            newVal: newVal,
            oldVal: oldVal
          });
          if (_this.isShippingSameAsBilling && !isFormZipCodeEmpty() && _this.propsFlags.allowSnTCall) {
            if (!isFormStateEmpty()) {
              if (_this.isDomesticShippingMethodsSupported()) {
                disableDropDown();
                _this.fetchShippingMethods();
              }
            }
          }
        }
      });

      // Watchers for billing address country change
      this.$watch('billingAddress.country', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          _logger.$logger.info('snt_billing_address_country_watch', {
            newVal: newVal,
            oldVal: oldVal,
            isShippingSameAsBilling: _this.isShippingSameAsBilling,
            allowSnTCall: _this.propsFlags.allowSnTCall
          });
          if (_this.isShippingSameAsBilling && _this.propsFlags.allowSnTCall) {
            if (!_this.isInstantUpdateFlow || !_this.isDomesticShippingMethodsSupported()) {
              _logger.$logger.info('billingAddress_country_watch_trigger_shipping_methods');
              _angular.$rootScope.$emit('hideErrorFields');
              _this.billingCountryChangeWatchVariable = true;
              _this.triggerFetchShippingMethods = true;
            }
          }
        }
      });

      // Todo: Undertand: Why watch? just call a function when set true
      this.$watch('triggerFetchShippingMethods', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          _logger.$logger.info('snt_trigger_fetch_shipping_methods_watch', {
            newVal: newVal,
            oldVal: oldVal
          });
          if (newVal) {
            disableDropDown();
            _this.fetchShippingMethods();
          }
        }
      });

      // Watchers for shipping address country change
      this.$watch('shippingAddress.country', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          _logger.$logger.info('snt_shipping_address_country_watch', {
            newVal: newVal,
            oldVal: oldVal,
            isShippingSameAsBilling: _this.isShippingSameAsBilling,
            allowSnTCall: _this.propsFlags.allowSnTCall
          });
          if (!_this.isShippingSameAsBilling && _this.propsFlags.allowSnTCall) {
            if (!_this.isInstantUpdateFlow || !_this.isDomesticShippingMethodsSupported()) {
              _logger.$logger.info('shippingAddress_country_watch_trigger_shipping_methods');
              _this.shippingCountryChangeWatchVariable = true;
              disableDropDown();
              _this.fetchShippingMethods();
            }
          }
        }
      });

      // Watchers for shipping address state change
      this.$watch('shippingAddress.state', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          _logger.$logger.info('snt_shipping_address_state_watch', {
            newVal: newVal,
            oldVal: oldVal,
            isShippingSameAsBilling: _this.isShippingSameAsBilling,
            allowSnTCall: _this.propsFlags.allowSnTCall
          });
          if (!_this.isShippingSameAsBilling && !isFormZipCodeEmpty() && _this.propsFlags.allowSnTCall) {
            if (_this.isDomesticShippingMethodsSupported()) {
              disableDropDown();
              _this.fetchShippingMethods();
            }
          }
        }
      });

      // Function responsible to format each item to be shown in the dropdown
      var getShippingCharge = function getShippingCharge(charge, index) {
        var DASH = '--';
        var SPACE = ' ';
        function prefix(str, prefixStr) {
          if (str) {
            return (prefixStr ? prefixStr : '') + str;
          }
          return '';
        }
        var shippingMethod = charge.shipping_charge.shipping_method;
        var _ref = charge.shipping_charge || {},
          _ref$shipping_amount = _ref.shipping_amount,
          shipping_amount = _ref$shipping_amount === void 0 ? {} : _ref$shipping_amount;
        // TODO: shipping amount and insurance amount formatting code can be refactored
        // Format shipping amount if available
        var shippingCurrency = '';
        if (shipping_amount) {
          var amount = (parseInt(charge.shipping_charge.shipping_amount.value, 10) / 100).toFixed(2);
          var currencyCode = charge.shipping_charge.shipping_amount.currency_code;
          var formattedAmount = (0, _index.formatCurrency)(amount, currencyCode);
          shippingCurrency = prefix(SPACE + formattedAmount, SPACE + DASH);
        }
        var shippingDeliveryTime = charge.shipping_charge.delivery_time;
        var displayShippingMethod = (0, _util.decodeEntities)(shippingMethod);
        var displayShippingDeliveryTime = prefix(shippingDeliveryTime, ' \\n ');

        // Format insurance if available
        var insuranceCurrency = '';
        if (charge.shipping_charge.insurance_amount) {
          var insuranceAmount = (parseInt(charge.shipping_charge.insurance_amount.value, 10) / 100).toFixed(2);
          var insuranceCurrencyCode = charge.shipping_charge.insurance_amount.currency_code;
          var formattedInsuranceAmount = (0, _index.formatCurrency)(insuranceAmount, insuranceCurrencyCode);
          insuranceCurrency = "" + SPACE + formattedInsuranceAmount;
        }
        var result = {
          shippingCharge: charge,
          shippingMethod: displayShippingMethod,
          shippingCurrency: shippingCurrency,
          shippingDeliveryTime: displayShippingDeliveryTime,
          insuranceCurrency: insuranceCurrency,
          index: index
        };
        _logger.$logger.info('snt_get_shipping_charge', {
          result: result
        });
        return result;
      };

      // Function responsible to set default shipping method
      var setDefaultShippingMethod = function setDefaultShippingMethod() {
        _logger.$logger.info('snt_set_default_shipping_method');
        var span = $('#shippingMethodsDropDown > div > span > span > span');
        span.html(_index.$locale.content.get('shippingMethod.selectMethod'));
        _this.isStorePickUp = false;
        disableStorePickUp();
        _this.shippingChargesList = [{}];
      };

      // Populates the shipping method dropdown with shipping charges .
      var populateShippingCharges = function populateShippingCharges() {
        _logger.$logger.info('snt_populate_shipping_charges');
        setDefaultShippingMethod();
        if (_this.charges.length >= 1) {
          _this.shippingChargesList = _this.charges.map(getShippingCharge);
          _logger.$logger.info('snt_populate_shipping_charges_list', {
            shippingChargesList: _this.shippingChargesList
          });
          // lets enable the dropdown after the shipping charges list is populated.
          enableDropDown();
        } else {
          disableDropDown();
        }
      };

      // Checks whether selected shipping method is store pick up or not
      var isStorePickUpMethod = function isStorePickUpMethod(shipping_method_type) {
        var result = shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
        _logger.$logger.info('snt_is_store_pickup', {
          result: result
        });
        return result;
      };

      // Function called when user selects a shipping method from the dropdown
      this.selectShippingMethod = function (selectedShippingCharge) {
        _logger.$logger.info('snt_selected_shipping_method');
        _this.selectedMethod.index = selectedShippingCharge.index;
        _this.selectedShippingCharge = selectedShippingCharge;

        // PPPLMER-81698: Patch cart is not happening since no element being selected in the shipping method
        // select button in few edge cases. Due to which shipping charges are missing in the transactions.
        // adding debug log for such edge cases.
        _logger.$logger.info("snt_selected_shipping_charge_index_" + (selectedShippingCharge.index > -1 ? selectedShippingCharge.index : 'empty'));

        // deselect insurance checkbox
        _this.selectedShippingCharge.insuranceCheckboxChecked = false;
        _this.selectedShippingCharge.showInsuranceSelectCheckbox = false;
        var taxAmtApplied;
        var amountValue;
        var methodType;
        var insurance;
        var patchWithInsurance = false;
        if (_this.selectedShippingCharge && _this.selectedShippingCharge.shippingCharge && _this.selectedShippingCharge.shippingCharge.shipping_charge) {
          _logger.$logger.info('snt_selected_shipping_charge_present');
          var shippingCharge = _this.selectedShippingCharge.shippingCharge.shipping_charge;
          _this.propsFlags.allowEditShipping = true;
          _this.propsFlags.showSingleAddress = false;
          _this.isStorePickUp = false;
          if (isStorePickUpMethod(shippingCharge.shipping_method_type)) {
            _this.isStorePickUp = true;
            enableStorePickUp();
          }
          _this.shippingMethodNotSelected = false;
          methodType = shippingCharge.shipping_method_type;
          amountValue = safeConvert(shippingCharge.shipping_amount.value);
          taxAmtApplied = getTax(_this.selectedShippingCharge.shippingCharge);
          insurance = shippingCharge.insurance_amount && shippingCharge.insurance_amount.value;
          _logger.$logger.info('snt_selected_shipping_charge_insurance', {
            insurance: insurance
          });
          if (insurance) {
            insurance = safeConvert(insurance);
            /**
             *  Patch Insurance if
             *  1. offer_insurance_option=false and there is insurance amount in response;
             *  2. offer_insurance_option=true and there is an insurance amount in response,
             *     then user needs to select the apply insurance checkbox first
             */
            if (!shippingCharge.offer_insurance_option) {
              _logger.$logger.info('snt_selected_shipping_charge_dont_offer_insurance_option');
              patchWithInsurance = true;
            } else {
              _logger.$logger.info('snt_selected_shipping_charge_show_insurance_checkbox');
              _this.selectedShippingCharge.showInsuranceSelectCheckbox = true;
            }
          }
        } else {
          _logger.$logger.info('snt_no_selected_shipping_charge');
          _this.isStorePickUp = false;
          amountValue = _this.buttonCartAmounts.shippingAmt;
          taxAmtApplied = getTax();
          methodType = 'DEFAULT';
        }
        if (_this.isInstantUpdateFlow) {
          updateExternalCallbackOptions(_this.response.shipping_options_source, _this.selectedMethod.prevIndex, _this.selectedMethod.index);
          if (patchWithInsurance) {
            updateShippingTaxCharge(amountValue, taxAmtApplied, methodType, insurance);
          } else {
            updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
          }
        } else if (isPatchCartRequired(amountValue, taxAmtApplied)) {
          updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
        }
        _logger.$logger.info('snt_selected_shipping_method_final', {
          prevIndex: _this.selectedMethod.index,
          isInstantUpdateFlow: _this.isInstantUpdateFlow
        });
        _this.selectedMethod.prevIndex = _this.selectedMethod.index;
      };
      // Function called when user selects a optional insurance field in checkbox
      this.onInsuranceCheckboxChange = function (insuranceCheckboxChecked) {
        _this.selectedShippingCharge.insuranceCheckboxChecked = insuranceCheckboxChecked;
        var shippingCharge = _this.selectedShippingCharge.shippingCharge.shipping_charge;
        var insurance = safeConvert(shippingCharge.insurance_amount.value);
        var taxAmtApplied = getTax(_this.selectedShippingCharge.shippingCharge);
        var amountValue = safeConvert(shippingCharge.shipping_amount.value);
        var methodType = shippingCharge.shipping_method_type;
        _logger.$logger.info('snt_on_insurance_checkbox_change', {
          insuranceCheckboxChecked: insuranceCheckboxChecked,
          amountValue: amountValue,
          taxAmtApplied: taxAmtApplied,
          methodType: methodType,
          insurance: insurance
        });
        if (_this.selectedShippingCharge.insuranceCheckboxChecked === true) {
          // Patch the cart with insurance
          updateShippingTaxCharge(amountValue, taxAmtApplied, methodType, insurance);
        } else {
          // Patch the cart without insurance
          updateShippingTaxCharge(amountValue, taxAmtApplied, methodType);
        }
      };

      // Function responsible to populate Error fields
      var populateErrorFields = function populateErrorFields() {
        _logger.$logger.info('snt_populate_error_fields', {
          isShippingSameAsBilling: _this.isShippingSameAsBilling
        });
        disableDropDown();
        _this.showZipCode = false;
        if (_this.isShippingSameAsBilling) {
          _this.city = _this.billingAddress.city;
          _this.state = _this.billingAddress.state;
        } else {
          _this.city = _this.shippingAddress.city;
          _this.state = _this.shippingAddress.state;
        }
      };
      var populateCallbackShippingOptions = function populateCallbackShippingOptions() {
        _logger.$logger.info('snt_populate_callback_shipping_options', {
          charges: _this.charges
        });
        if (!_this.charges) {
          return;
        }
        _this.callbackShippingOptions = _this.charges.map(function (charge, index) {
          var shippingCharge = charge.shipping_charge;
          var taxCharge = charge.tax;
          var insurance = shippingCharge && shippingCharge.insurance_amount;
          var option = {};
          if (shippingCharge) {
            option.method = shippingCharge.shipping_method;
            option.amount = {
              value: safeConvert(shippingCharge.shipping_amount && shippingCharge.shipping_amount.value),
              currency: shippingCharge.shipping_amount && shippingCharge.shipping_amount.currency_code
            };
            option.is_default = shippingCharge.default_method;
            option.is_selected = false;
            if (insurance) {
              option.insurance = {
                value: safeConvert(insurance.value),
                currency: insurance.currency_code
              };
              _this.callbackInsuranceOffered = true;
            }
            if (taxCharge) {
              option.tax = {
                value: safeConvert(taxCharge.total_tax.value),
                currency: taxCharge.total_tax.currency_code
              };
            }
          }
          return option;
        });
        _logger.$logger.info('snt_populate_callback_shipping_options', {
          callbackShippingOptions: _this.callbackShippingOptions
        });
      };
      var updateExternalCallbackOptions = function updateExternalCallbackOptions(optionsSource, prevIndex, index) {
        if (optionsSource === 'CALLBACK' && _this.callbackShippingOptions) {
          if (!isNaN(prevIndex)) {
            _this.callbackShippingOptions[prevIndex].is_selected = false;
          }
          _this.callbackShippingOptions[index].is_selected = true;
        } else if (optionsSource === 'FALLBACK' && _this.fallbackShippingOptions) {
          if (!isNaN(prevIndex)) {
            _this.fallbackShippingOptions[prevIndex].is_selected = false;
          }
          _this.fallbackShippingOptions[index].is_selected = true;
        }
        _logger.$logger.info('snt_update_external_extcallback_options', {
          optionsSource: optionsSource,
          prevIndex: prevIndex,
          index: index,
          callbackShippingOptions: _this.callbackShippingOptions,
          fallbackShippingOptions: _this.fallbackShippingOptions
        });
      };

      // Find the charges of the default option and patch cart with corresponding values.
      var updateShippingTaxChargeWithDefaultOption = function updateShippingTaxChargeWithDefaultOption() {
        var shippingAmt;
        var taxAmt;
        var insuranceAmt;
        var methodType;
        // SnT service always returns FALLBACK response when no_shipping = 1

        if (_this.response.shipping_options_source === 'FALLBACK' && !isNaN(_this.defaultFallbackOptionIndex)) {
          var defaultOption = _this.fallbackShippingOptions[_this.defaultFallbackOptionIndex];
          if (defaultOption) {
            shippingAmt = defaultOption.amount && defaultOption.amount.value;
            taxAmt = defaultOption.tax && defaultOption.tax.value;
            insuranceAmt = defaultOption.insurance && defaultOption.insurance.value;
          }
        }
        _logger.$logger.info('snt_updateShippingTaxChargeWithDefaultOption', {
          shippingAmt: shippingAmt,
          taxAmt: taxAmt,
          methodType: methodType,
          insuranceAmt: insuranceAmt
        });
        // Todo: Understand: shouldnt this call be inside if
        updateShippingTaxCharge(shippingAmt, taxAmt, methodType, insuranceAmt);
      };

      /*  Function which is responsible to process shipping tax response
       Use cases
       ---------
       1. If shipping tax API returns error, show Error fields.
       2. (i) WPS: If response has shipping charges and shipping options are to be shown, populate the dropdown with charges else patch cart
       with shipping amount returned.
          (ii)Instant Update: If the shipping region is unsupported, display error message. Otherwise the above behavior applies.
       3. If no_shipping = 1
          (i) WPS:  If profile_override = true , apply shipping from button if it is not empty.
          (ii) Instant Update: Do not display the shipping options. Apply the default fallback(or callback) shipping option charges.
       4. Apply tax if applicable.
       */
      var processShippingAndTaxResponse = function processShippingAndTaxResponse() {
        _logger.$logger.info('snt_processShippingAndTaxResponse');
        var applicableShippingAmt = _this.buttonCartAmounts && _this.buttonCartAmounts.shippingAmt;

        // Set selected shipping charge as null to disallow form submit without selecting a shipping method.
        _this.selectedShippingCharge = null;

        // Handle error from service
        if (_this.shipAndTaxError) {
          populateErrorFields();
        }
        if (_this.isInstantUpdateFlow) {
          _logger.$logger.info('snt_is_instant_update_flow');
          if (!_this.response.shipping_region_supported) {
            _logger.$logger.info('snt_shipping_region_not_supported');
            _this.propsFlags.instantUpdateShippingRegionSupported = false;
            var msgsArray = errorHandlerHelper.getPageError('shippingMethod.shippingRegionUnsupported', {
              merchant: _this.nonEmptyMerchantDisplayName
            });

            // As updatePageLevelErrorMessage is an optional parameter we are
            // checking for the parameter before calling the function
            if (_this.updatePageLevelErrorMessage) {
              _this.updatePageLevelErrorMessage(msgsArray);
            }
            return;
          }
          if (_this.response.shipping_options_source === 'CALLBACK') {
            _logger.$logger.info('snt_shipping_options_source_is_callback');
            populateCallbackShippingOptions();
          }
          if (_this.showShipping) {
            _logger.$logger.info('snt_instant_update_show_shipping_is_true');
            // this.showShipping is true when merchant passes no_shipping parameter with value 0 or 2.
            // In this case, the shipping values from the SnT response is considered.
            if (responseHasShippingCharges()) {
              populateShippingCharges();
              patchCartWithButtonParams();
            }
          } else {
            // this.showShipping is false when merchant passes no_shipping parameter with value 1
            // In this case, shipping options aren't shown. The default fallback shipping option is considered.
            _logger.$logger.info('snt_show_shipping_is_not_true');
            _this.showShippingMethodSection = false;
            _this.propsFlags.showShippingLabel = false;
            updateShippingTaxChargeWithDefaultOption();
          }
          return;
        }
        // non instant update flow, no_shipping = 0
        else if (_this.showShipping) {
          _logger.$logger.info('snt_show_shipping_is_true');
          if (responseHasShippingCharges()) {
            if (_this.response.show_shipping_options) {
              _logger.$logger.info('snt_show_shipping_options_is_true');
              populateShippingCharges();
            } else {
              _logger.$logger.info('snt_show_shipping_options_is_not_true');
              // shippingCharges with out amount is returned in the charges array even shipping is not
              // configured in the profile for the merchant. so safe to check for null values before
              // accessing shipping_amount.
              var _ref2 = _this.response.charges[0].shipping_charge || {},
                _ref2$shipping_amount = _ref2.shipping_amount,
                _ref2$shipping_amount2 = _ref2$shipping_amount === void 0 ? {} : _ref2$shipping_amount,
                value = _ref2$shipping_amount2.value;
              // call safeConvert only when value is present

              if (value) {
                applicableShippingAmt = safeConvert(value);
              }
              _this.showShippingMethodSection = false;
              _this.propsFlags.showShippingLabel = false;
            }
          }
        }
        // not instant update flow, no_shipping = 1 , profile_override = true , shipping passed in button.
        else if (_this.response.profile_override_allowed) {
          _logger.$logger.info('snt_profile_override_allowed');
          // If shipping Amt is not empty , set applicable shipping amt for patch cart
          if (_this.buttonCartAmounts && _this.buttonCartAmounts.shippingAmt) {
            applicableShippingAmt = _this.buttonCartAmounts.shippingAmt;
            _this.showShippingMethodSection = false;
            _this.propsFlags.showShippingLabel = false;
          }
        }
        var applicableTaxAmt = getTax();

        // Patch if shipping amt or tax amount has changed
        if (isPatchCartRequired(applicableShippingAmt, applicableTaxAmt)) {
          updateShippingTaxCharge(applicableShippingAmt, applicableTaxAmt, 'DEFAULT');
        }
      };
      var clearFallbackOptionsSelectionFlags = function clearFallbackOptionsSelectionFlags() {
        _logger.$logger.info('snt_clearFallbackOptionsSelectionFlags', {
          fallbackShippingOptions: _this.fallbackShippingOptions
        });
        if (!_this.fallbackShippingOptions) {
          return;
        }
        for (var i = 0; i < _this.fallbackShippingOptions.length; i++) {
          _this.fallbackShippingOptions[i].is_selected = false;
        }
      };

      // Function which gets shipping and tax charges from the merchant profile.
      this.fetchShippingMethods = function () {
        _this.propsFlags.showShippingLabel = true;
        _this.propsFlags.instantUpdateShippingRegionSupported = true;
        _this.selectedMethod = {};
        _this.response = {};
        _this.callbackShippingOptions = [];
        _this.callbackInsuranceOffered = false;
        _this.showShippingMethodSection = true;
        _this.shippingChargesList = [{}];

        // Todo: Understand: What?
        _this.setAllowPayWithSnT(false);
        clearFallbackOptionsSelectionFlags();
        console.log('before setting SA with billing address');
        var shippingAddress = _this.billingAddress;
        if (!_this.isShippingSameAsBilling) {
          console.log('before setting SA with billing address when shipping same as billing');
          shippingAddress = _this.shippingAddress;
        }
        _this.trackZipCode.prev = shippingAddress.postal_code;
        _this.trackState.prev = shippingAddress.state;
        _this.dropDownBackground = 'processingBackground';
        _this.selectedShippingMethodText = 'disableShippingMethod';
        _this.changeShippingMethod = 'changeShippingMethodDisabled';
        var cartWeight, discount, cartHandling, currCode;
        if (_this.models.checkoutCart.cartWeight && _this.models.checkoutCart.cartWeight.value) {
          cartWeight = {
            value: Number(_this.models.checkoutCart.cartWeight.value).toFixed(2),
            unit: _this.models.checkoutCart.cartWeight.unit
          };
        }
        if (_this.models.checkoutCart.purchase.amounts.discount && _this.models.checkoutCart.purchase.amounts.discount.amount) {
          discount = Number(_this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2);
        }
        if (_this.models.checkoutCart.purchase.amounts.handling_fee && _this.models.checkoutCart.purchase.amounts.handling_fee.amount) {
          cartHandling = Number(_this.models.checkoutCart.purchase.amounts.handling_fee.amount).toFixed(2);
        }
        currCode = _this.models.checkoutCart.purchase.amounts.total.currency_code;
        var sntRequest = {
          currency_code: _this.currencyCode,
          cart_weight: cartWeight,
          cart_handling: {
            value: cartHandling,
            currency_code: currCode
          },
          discount: {
            value: discount,
            currency_code: currCode
          },
          item_list: _this.models.checkoutCart.purchase.items,
          tax_on_shipping_required: _this.showShipping,
          //   tax on shipping is not applicable when no_shipping is 1
          merchant_id: _this.models.checkoutPayee.merchant.id,
          locale: _index.$locale.lang + "_" + _index.$locale.country
        };
        _logger.$logger.info('snt_fetch_shipping_methods', {
          sntRequest: sntRequest,
          state: shippingAddress.state,
          postal_code: shippingAddress.postal_code
        });
        sntRequest.address = {
          line1: shippingAddress.line1,
          line2: shippingAddress.line2,
          city: shippingAddress.city,
          state: shippingAddress.state,
          postal_code: shippingAddress.postal_code,
          country_code: shippingAddress.country,
          id: _this.token
        };
        if (_this.isInstantUpdateFlow) {
          _this.trackSntReq.address = sntRequest.address;
          sntRequest.external_callback_options = _this.models.checkoutCart.getExternalCallbackOptions();
          // TODO: For EC flows, populate sntRequest.token as well.
        }
        _this.shippingMethods = new _index2.$ShippingMethodModel(sntRequest);
        _this.shippingMethods.save({
          data: _this.shippingMethods,
          contingencies: {
            VALIDATION_ERROR: function VALIDATION_ERROR(name, err) {
              _logger.$logger.info('snt_get_shipping_methods_VALIDATION_ERROR');
              _this.shipAndTaxError = true;
              if (!isFormZipCodeEmpty() || !isFormStateEmpty()) {
                _angular.$rootScope.$emit('showErrorFields');
              }
              populateErrorFields();
              patchCartWithButtonParams();
            },
            INTERNAL_SERVICE_ERROR: function INTERNAL_SERVICE_ERROR(name, err) {
              _logger.$logger.info('snt_get_shipping_methods_INTERNAL_SERVICE_ERROR');
              _this.shipAndTaxError = true;
              if (!isFormZipCodeEmpty() || !isFormStateEmpty()) {
                _angular.$rootScope.$emit('showErrorFields');
              }
              populateErrorFields();
              patchCartWithButtonParams();
            }
          },
          success: function success(result) {
            _logger.$logger.info('snt_get_shipping_methods_success');
            _this.response = result;
            _this.charges = result.charges;
            _this.triggerFetchShippingMethods = false;
            _this.setAllowPayWithSnT(true);
            processShippingAndTaxResponse();
          }
        });
      };
      _angular.$rootScope.$on('submission_triggered', function () {
        _logger.$logger.info('snt_submission_triggered');
        disableDropDown();
        _this.fetchShippingMethods();
      });
    },
    populate: function populate() {
      this.currencyCode = this.models.checkoutCart.purchase.amounts.total.currency_code;
      this.isInstantUpdateFlow = this.models.checkoutCart.instantUpdateIntegration;
      if (this.isInstantUpdateFlow) {
        this.fallbackShippingOptions = this.models.checkoutCart.getExternalCallbackOptions().fallback_shipping_options;
        if (this.fallbackShippingOptions) {
          this.defaultFallbackOptionIndex = _index.$util.findIndex(this.fallbackShippingOptions, function (option) {
            return option.is_default;
          });
        }
      }
      this.buttonCartAmounts = {
        shippingAmt: this.buttonParams.shipping ? Number(this.buttonParams.shipping.amount) : undefined,
        taxAmt: this.buttonParams.tax ? Number(this.buttonParams.tax.amount) : undefined,
        discount: this.models.checkoutCart.purchase.amounts.discount ? Number(this.models.checkoutCart.purchase.amounts.discount.amount) : undefined,
        subTotal: Number(this.models.checkoutCart.purchase.amounts.subtotal.amount),
        total: Number(this.buttonParams.total.amount)
      };
      var appDataFlags = this.models.checkoutAppData && this.models.checkoutAppData.flags;

      // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
      // then we need the value of merchantDisplayName to be 'the merchant' as it is the first word
      // in shippingMethod.shippingRegionUnsupported content key used below
      this.nonEmptyMerchantDisplayName = this.models.checkoutAppData.getMerchantDisplayName({
        nonEmptyReturnValue: true,
        isSentenceBeginning: true
      });
      this.isBuyNow = appDataFlags && appDataFlags.is_buy_now_flow;
      this.isCartUpload = appDataFlags && appDataFlags.is_cart_upload_flow;
      if (this.models.checkoutCart.cartWeight) {
        if (this.models.checkoutCart.cartWeight.value) {
          this.cartWeight = {
            value: Number(this.models.checkoutCart.cartWeight.value).toFixed(2),
            unit: this.models.checkoutCart.cartWeight.unit
          };
        }
      }
      if (this.models.checkoutCart.purchase.amounts.discount) {
        if (this.models.checkoutCart.purchase.amounts.discount.amount) {
          this.cartDiscount = {
            value: Number(this.models.checkoutCart.purchase.amounts.discount.amount).toFixed(2),
            currency_code: this.currencyCode
          };
        }
      }
      if (this.models.checkoutCart.purchase.amounts.handling_fee) {
        this.buttonCartAmounts.handlingAmt = Number(this.models.checkoutCart.purchase.amounts.handling_fee.amount);
      }
      if (this.models.checkoutCart.purchase.amounts.insurance) {
        this.buttonCartAmounts.insuranceAmt = Number(this.models.checkoutCart.purchase.amounts.insurance.amount);
      }
      if (this.models.checkoutCart.purchase.amounts.shipping_discount) {
        this.buttonCartAmounts.shippingDiscountAmt = Number(this.models.checkoutCart.purchase.amounts.shipping_discount.amount);
      }
      this.previousCosts = {
        shippingAmount: this.models.checkoutCart.purchase.amounts.shipping ? Number(this.models.checkoutCart.purchase.amounts.shipping.amount) : undefined,
        taxAmount: this.models.checkoutCart.purchase.amounts.tax ? Number(this.models.checkoutCart.purchase.amounts.tax.amount) : undefined
      };
      if (!this.isDomesticShippingMethodsSupported()) {
        this.triggerFetchShippingMethods = true;
      }
      _logger.$logger.info('snt_populate', {
        buttonCartAmounts: this.buttonCartAmounts,
        previousCosts: this.previousCosts
      });

      // trigger zipCodeBlur handler to fetch shipping methods in case of pre-filled address
      this.handleZipCodeBlur();
    }
  }
});
_angular.$rootScope;
_index.$Component;
_index.$locale;
_index.formatCurrency;
_index.$feature;
_index.$util;
_logger.$logger;
_index2.$ShippingMethodModel;
_index3.$CheckoutAppDataModel;
_index3.$CheckoutCartModel;
_index3.$CheckoutSessionModel;
_index3.$CheckoutPayeeModel;
_util.decodeEntities;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/select-shipping-method/shipping-method-dropdown/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * Created by aaramamurthy on 3/22/16.
 *
 * This is a dropdown multiline directive customised for shipping charges dropdown .
 * Existing multiline dropdown does not provide the functionality to have element based styling inside an dropdown item.
 * Existing multiline dropdown also shows an empty object in the dropdown if passed.
 * This directive populates the dropdown by making shipping amount as bold .
 * This directive populates the dropdown with items which is a valid object and has a value.
 */



!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/escape-html/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $, escapeHtml) {
  squid.module('xo-shipping-method-dropdown.directive', ['squid']).directive('xoShippingMethodDropDown', ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link($scope, $select, attrs, ngModel) {
        var isListVisible = false;
        var listCreated = false;
        $select = $($select);
        var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
        var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
        var $list;
        function updateCover() {
          $timeout(function () {
            var span = $span.find('span span');
            var escapedText = escapeHtml($select.find('[selected]').text());
            var text = escapedText.replace(/\\n/gi, '<br>').trim();
            var shippingAmount = text.substring(text.search('--'), text.search('<br>'));
            var boldText = text.replace(shippingAmount, shippingAmount.bold());
            boldText = boldText.replace('--', '-');
            span.html(boldText);
          }, 10);
        }
        function createList($options) {
          if ($options.length < 2) {
            return;
          }
          function getModel() {
            var modelName;
            var model;
            var subParts;
            if ($select.attr('ng-options')) {
              modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
            } else {
              var $option = $($select.find('[ng-repeat]')[0]);
              modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
            }

            // This is to handle cases like card.billingAddress
            if (modelName.indexOf('.') !== -1) {
              subParts = modelName.split('.');
              model = $scope;
              for (var i = 0; i < subParts.length; i++) {
                model = model[subParts[i]];
              }
            } else {
              // And this is to handle straightforward model names
              model = $scope[modelName];
            }
            return model;
          }
          function hideList(event) {
            $list.hide();
            $container.append($list);
            isListVisible = false;
            $container.removeClass('open');
          }
          function positionList() {
            $list.css('left', $container.offset().left + 'px');
            $list.css('top', $container.offset().top + $container.height() + 'px');
            $list.css('width', $container.width() + 'px');
          }
          function setFocusOnSelected() {
            var $selected = $select.find('[selected]');
            if ($selected.length) {
              var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');
              $item.focus();
            } else {
              $list.find('li')[0].focus();
            }
          }
          function showList() {
            $('body').append($list);
            $container.addClass('open');
            $list.show();
            positionList();
            isListVisible = true;
            setFocusOnSelected();
          }
          function processContainerKeypress(event) {
            var keyCode = event.keyCode;
            if (keyCode === 13 || keyCode === 40) {
              // enter or down arrow
              if (!isListVisible) {
                showList();
              } else {
                hideList();
                $container.focus();
              }
            } else if (keyCode === 27) {
              // escape
              if (isListVisible) {
                hideList();
                $container.focus();
              }
            }
          }
          if ($list) {
            $list.remove();
          }
          $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');
          Array.prototype.forEach.call($options, function (option) {
            var $option = $(option);
            var value = $option.attr('value');
            var text = option.innerHTML.replace(/\\n/gi, '<br>');
            var shippingAmount = text.substring(text.search('--'), text.search('<br>'));
            var boldText = text.replace(shippingAmount, shippingAmount.bold());
            boldText = boldText.replace('--', '- ');
            if (boldText.indexOf('content(') !== -1) {
              boldText = $scope.content(boldText.substring(boldText.indexOf('(\'') + 2, boldText.indexOf('\')')));
            }
            var html = '<li tabindex="0"';
            if (value !== $option.text()) {
              html = html + ' data-value="' + value + '"';
            }
            html = html + '>' + boldText + '</li>';
            if (value !== '') {
              $list.append($(html));
            }
          });
          $container.append($list);
          $list.hide();
          $($list.find('li')).click(function (event) {
            var $target = $(event.target);
            var value = $target.data('value');
            if ($target[0].nodeName.toLowerCase() !== 'li') {
              value = $target.parent().data('value');
            }
            if (typeof value !== 'undefined') {
              $select.find('option').removeAttr('selected');
              $select.find('option[value="' + value + '"]').attr('selected', 'selected');
              $select.find('option').removeProp('selected');
              $select.find('option[value="' + value + '"]').prop('selected', 'selected');
            } else {
              value = $target.html().replace(/\/<br\/>/gi, '\\n');
              $select.val(value);
            }
            if ($select.attr('ng-model')) {
              if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
                /* This parses the 'ng-options' directive and returns the options model.
                 For example: If you have: ng-options='opt as opt.label for opt in options'
                 Here it will parse this attribute and return 'options */
                var model = getModel();
                ngModel.$setViewValue(model[value]);
              } else {
                ngModel.$setViewValue(value);
              }
            }
            updateCover();
            hideList();
          });
          var $innerContainer = $container.find('.innerContainer');
          $container.click(function (event) {
            if (isListVisible) {
              hideList();
              $container.focus();
            } else {
              showList();
            }
          });
          $container.keydown(function (event) {
            processContainerKeypress(event);
          });
          $innerContainer.keydown(function (event) {
            processContainerKeypress(event);
          });
          $list.find('li').keydown(function (event) {
            var keyCode = event.keyCode;
            var $target = $(event.target);
            if (keyCode === 13) {
              // enter
              $target.click();
              event.stopPropagation();
            } else if (keyCode === 27) {
              // escape
              if (isListVisible) {
                hideList();
                $container.focus();
                event.stopPropagation();
              }
            } else if (keyCode === 40) {
              // down arrow
              if (!$target.is(':last-of-type')) {
                $target.next().focus();
                event.preventDefault();
                event.stopPropagation();
              }
            } else if (keyCode === 38) {
              // up arrow
              if (!$target.is(':first-of-type')) {
                $target.prev().focus();
              }
              event.preventDefault();
              event.stopPropagation();
            }
          });
          $(window).resize(function () {
            if (isListVisible) {
              positionList();
            }
          });
          $(window).bind('hashchange', function () {
            if (isListVisible) {
              hideList();
            }
          });
          $(document).click(function (event) {
            var $target = $(event.target);
            if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
              hideList();
            }
          });
          listCreated = true;
          updateCover();
        }
        function render() {
          var options = $select.find('option');
          if (!listCreated) {
            createList(options);
          }
        }
        $select.wrap($container);
        $container = $select.parent();

        // Change class names to enable styling of hover/focus states
        $select.bind('mouseenter focus', function () {
          $span.addClass('active');
        });

        // Change class names to enable styling of hover/focus states
        $select.bind('mouseleave blur', function () {
          $span.removeClass('active');
        });
        $select.after($span);
        $select.addClass('replaced');
        $select.attr('tabindex', '-1');
        if (attrs['default']) {
          var defaultOption = document.createElement('option');
          defaultOption.innerText = attrs['default'];
          $select.append(defaultOption);
        }
        if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
          $scope.$watch(attrs.ngModel, function () {
            render();
          });
        } else {
          $timeout(function () {
            $scope.$broadcast('pageRendered');
          }, 0);
        }
        $scope.$on('pageRendered', function () {
          render();
        });
      }
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/select-shipping-method/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/select-shipping-method/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"selectShippingMethod\" ng-if=\"showShippingMethodSection\" content>\n    <label class=\"shippingMethodTitle\">{{content('shipping.shippingMethodTitle')}}</label>\n\n    <div id=\"merchantOptions\" class=\"merchantOptionsStyle\">\n        <p class=\"guestMerchantOptions\" ng-show=\"showMerchantOptions\">\n            {{content('shippingMethod.guestMerchantOptions')}}\n        </p>\n\n        <p class=\"guestMerchantOptions\" ng-show=\"showZipCode\">\n            {{content('shippingMethod.zipCode')}}:\n        </p>\n\n        <p class=\"zipCodeOptions\" ng-show=\"showZipCode\">\n            {{zipCode}}\n        </p>\n\n        <p class=\"addressOptions\" ng-show=\"shipAndTaxError\">\n            [{{city}},{{state}} {{zipCode}}]\n        </p>\n\n    </div>\n\n    <div id=\"shippingMethodsDropDown\" ng-if=\"isShowShippingMethodsDropDown && !noShippingMethodDropDown\"\n         ng-class=\"[changeShippingMethod,dropDownBackground,selectedShippingMethodText]\" class=\"dropdown confidential clearfix\">\n\n        <select xo-shipping-method-drop-down ng-model=\"selectedShippingCharge\"\n                ng-change=\"selectShippingMethod(selectedShippingCharge)\"\n                id=\"shippingMethodDropDown\" name=\"shippingMethodDropDown\"\n                ng-required = \"shippingMethodNotSelected\" ng-hide=\"hideSelectDropdown\">\n\n\n            <option value=\"\" selected=\"selected\" class=\"selectedShippingMethod\" > {{ content('shippingMethod.selectMethod',\n                { count: shippingChargesList.length}) }}</option>\n\n            <option ng-repeat=\"charge in shippingChargesList\" value=\"{{$index}}\">\n                {{charge.shippingMethod}}{{charge.shippingCurrency}}{{charge.shippingDeliveryTime}}\n            </option>\n\n        </select>\n\n    </div>\n\n    <div class=\"row-fluid checkbox shippingMethodApplyInsuranceContainer\"\n         ng-if=\"selectedShippingCharge && selectedShippingCharge.showInsuranceSelectCheckbox\">\n\n        <input type=\"checkbox\" ng-model=\"selectedShippingCharge.insuranceCheckboxChecked\"\n               name=\"shippingMethodApplyInsurance\" id=\"shippingMethodApplyInsurance\"\n               ng-change=\"onInsuranceCheckboxChange(selectedShippingCharge.insuranceCheckboxChecked)\">\n        <label class=\"noBottom\" for=\"shippingMethodApplyInsurance\"\n               ng-bind-html=\"htmlContent('shippingMethod.addShippingInsurance',{amount: selectedShippingCharge.insuranceCurrency})\">\n        </label>\n\n    </div>\n\n    <div id=\"noShippingMethod\" ng-if=\"noShippingMethodDropDown\"\n         ng-class=\"[changeShippingMethod,selectedShippingMethodText]\" class=\"dropdown confidential clearfix\">\n\n        <select xo-dropdown-multiline id=\"noShippingMethodDropDown\">\n\n\n            <option value=\"\" selected=\"selected\" class=\"selectedShippingMethod\"> {{ content('shippingMethod.selectMethod',\n                { count: shippingChargesList.length}) }}</option>\n\n            <option ng-repeat=\"charge in noShippingChargesList track by $index\" value=\"{{$index}}\">\n\n            </option>\n\n        </select>\n\n    </div>\n\n    <div id=\"shippingMethodProcessing\" ng-show=\"isProcessing\">\n        <div class=\"spinner\">\n            <p class=\"loader\" ></p>\n        </div>\n    </div>\n\n    <div id=\"showPickUpStore\" class=\"pickUpStoreText\" ng-if=\"isStorePickUp\">\n        {{content('shippingMethod.storeLocationInfo')}}\n    </div>\n\n\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/sepa/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var errorHandlerHelper = _interopRequireWildcard(__webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js"));
var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");
var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/sepa/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var _default = exports["default"] = _squid.$Component.extend('xoGuestSepaLightbox', {
  tag: 'xo-guest-sepa-lightbox',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    address: {
      type: 'var',
      required: false
    },
    singlePagePaymentForm: {
      type: 'var',
      required: false
    },
    updatePageLevelErrorMessage: {
      type: 'var',
      required: false
    },
    validated: {
      type: 'var',
      required: false
    },
    sepa: {
      type: 'var',
      required: false
    },
    onboard: {
      type: 'var',
      required: false
    },
    sectionElement: {
      type: 'var',
      required: false
    },
    flags: {
      type: 'var',
      required: false
    },
    isUnbranded: {
      type: 'var',
      required: false
    },
    doneFn: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {},
    populate: function populate() {
      var _this = this;
      var openSepa = function openSepa() {
        var form = _this.singlePagePaymentForm;
        var formValid = true;
        var firstFailedElementName = determineFirstFailedElement();

        // Clear existing error messages
        _this.validated = true;
        _this.noErrorShowSepa = false;
        function determineFirstFailedElement() {
          var result;
          var sepaNotRequiredFields = ['sepaAgree', 'sepaGuestAgree', 'guestagree', 'agree'];
          for (var i in form) {
            if (form[i] && form[i].hasOwnProperty && form[i].hasOwnProperty('$valid') && sepaNotRequiredFields.indexOf(form[i].$name) === -1 &&
            // Dont check validity for fields we don't need for SEPA
            !form[i].$valid) {
              formValid = false;
              result = form[i].$name;
              break;
            }
          }
          return result;
        }
        // If form is valid then call validateBank Api and then open sepa

        if (formValid) {
          _this.addBankModel = new _index.$AddBankModel({
            user: _this.onboard.user,
            bank: _this.onboard.bank
          });
          _this.addBankModel.action('validate', {
            data: _this.addBankModel.getBankData(),
            resultModel: {},
            success: function success(data) {
              _this.addBankModel.creditorDetails = data.creditorDetails;
              _this.addBankModel.fiDetails = data.fiDetails;
              _this.noErrorShowSepa = true;
              (0, _angular.$timeout)(function () {
                window.scrollTo(0, 0);
              }, 100);
            },
            contingencies: {
              VALIDATE_BANK_CONTINGENCY: function VALIDATE_BANK_CONTINGENCY(name, data) {
                var pageLevelErrorObj = _util.$fiErrorUtil.addPageErrors(data, 'bank');
                _this.hideSepa();
                _this.updatePageLevelErrorMessage(pageLevelErrorObj.msgs, pageLevelErrorObj.type);
                _util.$fiErrorUtil.addFieldErrors(data, _this.sectionElement);
                firstFailedElementName = determineFirstFailedElement();
                errorHandlerHelper.scrollToElement(firstFailedElementName);
              }
            },
            validation: function validation(data) {
              var returnObj = {
                fields: []
              };
              _this.hideSepa();
              angular.forEach(data.fields || [], function (field) {
                returnObj.fields.push(field.property);
              });
              errorHandlerHelper.addFieldError(returnObj);
              firstFailedElementName = determineFirstFailedElement();
              errorHandlerHelper.scrollToElement(firstFailedElementName);
            }
          });
        } else {
          _this.hideSepa();
          errorHandlerHelper.scrollToElement(firstFailedElementName);
        }
      };
      this.hideSepa = function () {
        _this.noErrorShowSepa = false;
        _this.sepa.show = false;
      };

      // Added the sepa content change based on US755520
      var setSepaOverlayContent = function setSepaOverlayContent() {
        _this.sepaTitle = _this.isUnbranded && _this.flags.show_sepa_overlay ? 'DEMemberGuest.sepaTitleUnbranded' : 'DEMemberGuest.sepaTitle';
        _this.sepaAgreement = _this.isUnbranded && _this.flags.show_sepa_overlay ? 'DEMemberGuest.ddAgreementUnbrandedPara1' : 'DEMemberGuest.ddAgreementPara1';
        if (_this.flags.show_sepa_overlay) {
          if (_this.flags.isUnbranded && _this.flags.commit) {
            _this.sepaSubmit = 'common.acceptAndComplete';
          } else {
            _this.sepaSubmit = 'common.acceptAndContinue';
          }
        } else {
          _this.sepaSubmit = 'header.close';
        }
      };
      this.$watch('sepa.show', function (newVal, oldVal) {
        if (newVal) {
          openSepa();
        }
      });
      this.$watch('flags.show_sepa_overlay', function (newVal, oldVal) {
        if (newVal) {
          setSepaOverlayContent();
        }
      });
      setSepaOverlayContent();
    }
  },
  actions: {
    closeSepa: function closeSepa($event) {
      $event.preventDefault();
      this.hideSepa();
    },
    acceptSepa: function acceptSepa($event) {
      $event.preventDefault();
      this.hideSepa();
      this.sepa.sepaGuestAgree = true;
      this.sepa.sepaAgree = true;
      if (this.flags.show_sepa_overlay) {
        this.doneFn();
      }
    }
  }
});
_squid.$Component;
_util.$fiErrorUtil;
_index.$AddBankModel;
_angular.$timeout;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/sepa/template.html":
/***/ (function(module, exports) {

module.exports = "\n<div class=\"kmliUpsell upsellOpen sepa\" ng-if=\"noErrorShowSepa\">\n    <div class=\"upsellMask\"></div>\n\n    <div class=\"upsellWrapper\" simple-modal=\"modalActive\" modal-cancel=\"hideModal()\" content>\n        <div class=\"sepaContainer\">\n\n\n            <a href=\"#\" class=\"close\" ng-click=\"actions.closeSepa($event)\">close</a>\n\n            <h1 id=\"sepaTitle\" class=\"alpha\">{{ content(sepaTitle) }}</h1>\n\n            <p id=\"sepaAgreement\">{{ content(sepaAgreement) }}</p>\n\n            <div class=\"carrierinfo\">\n                <span><strong>{{ content('DEMemberGuest.accountCarrier') }}</strong></span>\n                <div><span>{{addBankModel.user.first_name}} {{addBankModel.user.last_name}}</span></div>\n                <div><span>{{address.line1}}</span></div>\n                <div><span ng-if=\"address.line2\">{{address.line2}}</span></div>\n                <div><span>{{address.postal_code}} {{address.city}}</span></div>\n            </div>\n\n            <div class=\"bankinfo\">\n                <p>\n                    <span class=\"col1\"> <strong>{{content('DEMemberGuest.IBAN')}} </strong></span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.piAccountNumber}}</span>\n                </p>\n\n                <p>\n                    <span class=\"col1\"> <strong> {{content('DEMemberGuest.bankName')}} </strong></span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.isssuerDetails.name}}</span>\n                </p>\n\n                <p>\n                    <span class=\"col1\"> <strong> {{content('DEMemberGuest.bic')}} </strong> </span><br/>\n                    <span class=\"col2\">{{addBankModel.fiDetails.piDetails.bic}}</span>\n                </p>\n            </div>\n\n            <input track-submit id=\"sepaSubmit\" type=\"submit\" value=\"{{ content(sepaSubmit) }}\"\n                   class=\"btn full\"\n                   ng-click=\"actions.acceptSepa($event)\" />\n\n            <div id=\"paypalLogo\" class=\"miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/sticky.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.setStickyInstrument = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
/**
 * Makes billing agreement financial instrument sticky if necessary
 *
 * @param {CheckoutSession} checkoutSession
 * @return {Promise}
 */
var setStickyInstrument = exports.setStickyInstrument = function setStickyInstrument(checkoutSession) {
  if (!checkoutSession) {
    throw new TypeError('missing checkoutSession');
  }
  if (checkoutSession.selectedFuturePaymentInstrument) {
    // session already has a sticky instrument
    _logger.$logger.info('no_setStickyFI_call_checkoutsession_already_has_sticky_fi');
    return _squid.$promise.resolve();
  }
  var stickyInstrument = checkoutSession.getSelectedStickyInstrument();

  // billing agreement is not supported for WPS and guest transactions
  // we dont do setStickyFI call in both WPS and guest transactions
  if (stickyInstrument) {
    _logger.$logger.info('calling_checkoutsession_setStickyFI_API');
    return checkoutSession.action('setStickyFI', {
      data: {
        instrument_id: stickyInstrument.instrument_id
      }
    });
  }
  _logger.$logger.info('no_setStickyFI_call_checkoutsession_has_no_selected_sticky_fi');
  return _squid.$promise.resolve();
};
_squid.$promise;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"singlePagePayment\" id=\"singlePagePayment\">\n\n    <!-- BillingAgreement flows need to display description passed by merchant in cart -->\n    <xo-ba-message-banner ng-if=\"billingAgreementMerchantMsg\" token=\"token\"></xo-ba-message-banner>\n\n    <xo-message message=\"topErrorMessage\"></xo-message>\n    <xo-login-button ng-if=\"landingAbTestCheck()\" redirect=\"redirect\"></xo-login-button>\n    <xo-message message=\"errorMessage\"></xo-message>\n\n    <xo-xoon-header token=\"token\" flags=\"flags\" user=\"onboard.user\" mode=\"mode\" fi-mode=\"onboard.fiMode\"></xo-xoon-header>\n\n    <form id=\"singlePagePaymentForm\" name=\"singlePagePaymentForm\" class=\"singlePagePaymentForm\" ng-submit=\"singlePagePaymentForm.$valid && actions.onSubmit()\" ng-class=\"{'validated': validated, 'APAC': isApac()}\" novalidate>\n\n        <xo-country-list is-unbranded=\"isUnbranded\" token=\"token\" show-mask=\"showMask\" mode=\"mode\"></xo-country-list>\n\n        <div ng-class=\"{'showMask': showMask}\" disable-form=\"showMask\">\n            <span ng-if=\"showFISwitchTab()\">\n                <ul class=\"form-tabs\" id=\"paymentTab\">\n                    <li ng-repeat=\"fi in getToggleKeys\" class=\"{{fi.type}} {{onboard.fiMode === fi.type ? 'active' : ''}}\" ui-sref-active=\"active\">\n                        <a ng-click=\"actions.toggleFIMode($event, fi.type)\" href=\"#\" class=\"{{fi.type}}Tab\">{{content(fi.label)}}</a>\n                    </li>\n                </ul>\n            </span>\n\n            <div ng-if=\"showTeslaAddBankFlow()\">\n                <xo-tesla-add-bank token=\"token\"></xo-tesla-add-bank>\n            </div>\n\n            <div ng-if=\"!showTeslaAddBankFlow()\">\n                <div ng-if=\"onboard.fiMode === 'card'\" id=\"cardFields\">\n                <xo-credit-card\n                    token=\"token\"\n                    card=\"onboard.card\"\n                    user=\"onboard.user\"\n                    name-below=\"true\"\n                    card-number-changed=\"cardNumberChanged\"\n                    set-buyer-fx-flag=\"setBuyerFxFlag\">\n                </xo-credit-card>\n\n                <div ng-if=\"isInstallmentsVisible()\" class=\"installment\">\n                    <a ng-if=\"!singleStepModel.selectedInstallmentData.preventChange\" id=\"paymentMethod\" ui-sref=\"{{currentState}}.sidebar.installmentOptions\" class=\"getInstallments installmentsDropDown btn btn-secondary\" scroll-to-top>\n                        <span ng-if=\"singleStepModel.selectedInstallmentData\">\n                            {{singleStepModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{singleStepModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                        </span>\n                        <span ng-if=\"!singleStepModel.selectedInstallmentData\">\n                            {{content('paymentMethod.changeInstallmentLongLink')}}\n                        </span>\n                    </a>\n                    <a ng-if=\"singleStepModel.selectedInstallmentData.preventChange\"\n                       class=\"getInstallments btn btn-secondary\" disabled>\n                        <span ng-if=\"singleStepModel.selectedInstallmentData\">\n                            {{singleStepModel.selectedInstallmentData.installment_option_selected.term}}X {{content('paymentMethod.of')}} {{singleStepModel.selectedInstallmentData.installment_option_selected.monthly_payment.formatted_value}}\n                        </span>\n                    </a>\n                    <div ng-if=\"singleStepModel.selectedInstallmentData.preventChange\" class=\"installmentHelper\">\n                        <a href=\"#\" id=\"installmentHelp\" aria-label=\"{{content('common.altHelp')}}\" class=\"verifyHelp\">\n                        </a>\n                    </div>\n                    <xo-tooltip ng-if=\"singleStepModel.selectedInstallmentData.preventChange\" trigger=\"#installmentHelp\">\n                        <div class=\"tip tipDesc emailToolTip\">\n                            {{content('paymentMethod.installmentPreselectedHelp')}}\n                        </div>\n                    </xo-tooltip>\n                </div>\n\n                <input ng-if=\"isInstallmentsVisible() && !singleStepModel.selectedInstallmentData\"\n                       type=\"text\"\n                       name=\"installments\"\n                       id=\"installments\"\n                       ng-model=\"singleStepModel.selectedInstallmentData.installment_option_selected.term\"\n                       value=\"\"\n                       class=\"hiddenInput ng-pristine\"\n                       required/>\n\n                <xo-name-input user=\"onboard.user\"></xo-name-input>\n\n                <xo-inline-currency-conversion\n                    card=\"onboard.card\"\n                    token=\"token\"\n                    treatment=\"flags.buyerFxTreatment\"\n                    show-invoicing-reg-e-msg=\"showInvoicingRegEMsg\"\n                    non-empty-merchant-display-name=\"nonEmptyMerchantDisplayName\"\n                    ng-if=\"flags.hasBuyerFxPrePlanData && flags.buyerFxTreatment\">\n                </xo-inline-currency-conversion>\n            </div>\n\n            <div ng-if=\"onboard.fiMode === 'bank'\" id=\"bankFields\">\n                <xo-name-input user=\"onboard.user\"></xo-name-input>\n                <xo-bank-input token=\"token\" bank=\"onboard.bank\" is-unbranded=\"isUnbranded\" user=\"onboard.user\"></xo-bank-input>\n            </div>\n\n            <div ng-if=\"!hasDialingCodeOverride() && !flags.allowChoice && !(flags.upopDetected && flags.cupDetected)\">\n                <xo-phone-input phone=\"onboard.phone\" countryCode=\"locale.country\"></xo-phone-input>\n                <p ng-if=\"flags.isphoneConfirmationExpTreatment\">\n                    {{ content('2faPhoneConfirmation.phoneFieldMessage') }}\n                </p>\n            </div>\n\n            <h2 class=\"billingLabel sectionTitle\" ng-if=\"!flags.whiteListedIndiaMerchant\">{{content('addressBook.billingAddress')}}</h2>\n            <div id=\"billingAddress\" ng-class=\"{'validated': billingAddressValidated}\" ng-if=\"!flags.whiteListedIndiaMerchant\">\n                <xo-add-address address=\"onboard.billing_address\" country=\"locale.country\" \n                trigger-line-one-blur=\"residentialAddress.hasResidentialAddress\"\n                trigger-residential-zip-code-blur=\"residentialAddress.hasResidentialAddress\"\n                trigger-zip-code-blur=\"(flags.wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\" \n                trigger-zip-code-key-press=\"(flags.wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\"></xo-add-address>\n            </div>\n        </div>\n\n\n            <div ng-if=\"!showTeslaAddBankFlow()\">\n            <div class=\"row-fluid checkbox shipToBillingContainer\" ng-if=\"flags.allowEditShipping && !flags.disallowShipToBilling && !flags.whiteListedIndiaMerchant\">\n                <input\n                    ng-model=\"flags.shipToBilling\"\n                    type=\"checkbox\"\n                    name=\"shipToBilling\"\n                    id=\"shipToBilling\"\n                    class=\"shipToBilling\"\n                    track-focus-and-blur=\"shipToBilling\"\n                />\n                <label class=\"noBottom\" for=\"shipToBilling\" ng-bind-html=\"htmlContent('largeScreenPayment.shipTo')\"></label>\n            </div>\n\n            <h2 ng-if=\"flags.showShippingLabel && (flags.wps_SnT_flow || isInstantUpdateFlow || hasShippingOptions())\" class=\"nolap shippingLabel sectionTitle\">{{content('shipping.shippingLabel')}}</h2>\n\n            <div id=\"showShippingAddress\" ng-if=\"flags.showSingleAddress\">\n                <div class=\"showShippingAddressHeading\">\n                    <span class=\"showShippingAddressTitle\">{{content('shipping.shippingTitle')}}</span>\n                    <a class=\"editShippingAddress\"\n                       ng-click=\"actions.editShippingAddress()\">{{content('common.change')}}</a>\n                </div>\n                <div class=\"shippingAddress\">\n                    {{shippingAddress.displayLine1}}<br/>\n                    {{shippingAddress.displayLine2}}<br/>\n                    {{shippingAddress.displayLine3}}\n                </div>\n            </div>\n\n            <div ng-if=\"(!flags.shipToBilling || flags.whiteListedIndiaMerchant) && flags.allowEditShipping\" ng-hide=\"(flags.wps_SnT_flow || isInstantUpdateFlow) && flags.hideShippingAddress\" id=\"shippingAddress\" ng-class=\"{'validated': shippingAddressValidated}\">\n\n                <h2 class=\"nolap shippingAddressLabel sectionTitle\">{{content('shipping.shippingTitle')}}</h2>\n\n                <xo-message message=\"changeShippingCountryAlert\"></xo-message>\n\n                <xo-select-shipping-country token=\"token\" shipping-address=\"onboard.shipping_address\"\n                                            disable-change-shipping-country=\"flags.disableChangeShippingCountry\"></xo-select-shipping-country>\n\n                <xo-add-address address=\"onboard.shipping_address\" is-shipping=\"true\" token=\"token\" country=\"onboard.shipping_address.country\" trigger-zip-code-blur=\"(flags.wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\" trigger-zip-code-key-press=\"(flags.wpsFlow && flags.wps_SnT_flow) || isInstantUpdateFlow\"></xo-add-address>\n\n            </div>\n\n            <div id=\"shippingMethod\" ng-if=\"flags.wps_SnT_flow || isInstantUpdateFlow || ixoModel.ixoShippingMethods\">\n                <xo-guest-select-shipping-method ng-if=\"!ixoModel.ixoShippingMethods\"\n                                                 token=\"token\"\n                                                 show-shipping =\"showShippingAddress\"\n                                                 billing-address=\"onboard.billing_address\"\n                                                 shipping-address=\"onboard.shipping_address\"\n                                                 track-snt-req=\"trackSntReq\"\n                                                 is-shipping-same-as-billing=\"flags.shipToBilling\"\n                                                 button-params=\"buttonParams\"\n                                                 update-page-level-error-message=\"actions.updatePageLevelErrorMessage\"\n                                                 flags = \"flags\"></xo-guest-select-shipping-method>\n                <xo-guest-simplified-select-shipping-methods\n                    ng-if=\"ixoModel.ixoShippingMethods\"\n                    token=\"token\"\n                    select-shipping-method=\"ixoModel.updateIxoSelectedShippingMethod\"\n                    shipping-methods=\"ixoModel.ixoShippingMethods\"\n                    selected-shipping-method=\"ixoModel.ixoSelectedShippingMethod\">\n                </xo-guest-simplified-select-shipping-methods>\n            </div>\n\n            <div ng-if=\"showContactInfo()\">\n                <h2 class=\"nolap billingLabel sectionTitle\">{{content('addPhone.contactInformation')}}</h2>\n                <p ng-if=\"(flags.upopDetected && flags.cupDetected)\" class=\"subTitle upopMobileNotify\" ng-bind-html=\"htmlContent('confirmUpop.debitInitOtp')\"></p>\n                <xo-phone-input phone=\"onboard.phone\" show-phone-type=\"!(flags.upopDetected && flags.cupDetected)\" countryCode=\"locale.country\"></xo-phone-input>\n                <p ng-if=\"flags.isphoneConfirmationExpTreatment\">\n                    {{ content('2faPhoneConfirmation.phoneFieldMessage') }}\n                </p>\n                <xo-email-input ng-if=\"displayEmailInContactInfo()\" class=\"emailInputContactSection\" flags=\"flags\" user=\"onboard.user\"></xo-email-input>\n            </div>\n\n            <div ng-if=\"flags.showPomaUi\" class=\"subTitle\">\n                <p id=\"legal18PlusPOMAMessage\">\n                    {{content('common.legal18PlusAcknowledgement')}}\n                </p>\n            </div>\n\n            <xo-onboard-options single-page-payment-form=\"singlePagePaymentForm\" validated=\"validated\" token=\"token\" flags=\"flags\" mode=\"mode\" is-unbranded=\"isUnbranded\"\n                onboard=\"onboard\" sepa=\"sepa\" residential-address=\"residentialAddress\" merchant=\"nonEmptyMerchantDisplayName\" user-agreement-link=\"userAgreementLink\" use-user-agreement-custom-link=\"flags.isGatherActiveConsentEnabled\"></xo-onboard-options>\n\n            <div ng-if=\"showInvoicingRegEMsg && !hasCurrConversion\" class=\"invRegE\">\n                {{ content('billingAgreement.invoicingRegEMsg', {merchantName: nonEmptyMerchantDisplayName, amountInInvCurrency: amountInInvCurrency}) }}\n            </div>\n\n            <div ng-if=\"flags.guestWPSMessage18Plus\" class=\"legal18PlusAcknowledgementMessageForWPSGuest\">\n                <p id=\"legal18PlusWPSMessage\">\n                    {{content('common.legal18PlusAcknowledgement')}}\n                </p>\n            </div>\n\n            <div class=\"buttons\">\n                <a id=\"backButton\" ng-if=\"flags.backButtonWebview\" href=\"#/checkout/login\" class=\"btn btn-secondary half\" ng-click=\"actions.logWebviewBackButtonClick(); actions.goBack($event)\">\n                    {{content('common.back')}}\n                </a>\n\n                <button\n                    type=\"submit\" class=\"btn\"\n                    track-input=\"{{flags.poma_flow ? (flags.commit ? 'Agree_Pay_Now' : 'Agree_Continue') : (flags.commit ? 'Pay_Now' : 'Continue')}}\"\n                    track-submit=\"{{flags.track_submit_transition}}\"\n                    id=\"{{flags.showPomaUi ? 'pomaSubmit' : 'guestSubmit'}}\"\n                    ng-bind-html=\"htmlContent(this.submitButtonText, { currency: selectedCurrency })\"\n                    ng-click=\"actions.handleCtaClick(singlePagePaymentForm.$valid)\"\n                    ng-class=\"{backButtonEnabled: flags.backButtonWebview}\">\n                </button>\n\n            </div>\n        </div>\n        </div>\n        </div>\n    </form>\n</div>\n\n<xo-modal ng-if=\"showAddressNormalizationLightbox\" show=\"true\">\n    <xo-address-normalization token=\"token\" address=\"onboard.billing_address\" hide-back-button=\"true\" done-fn=\"uponNormalization\"></xo-address-normalization>\n</xo-modal>\n\n<xo-guest-sepa-lightbox single-page-payment-form=\"singlePagePaymentForm\"\n    onboard=\"onboard\" section-element=\"sectionElement\" update-page-level-error-message=\"actions.updatePageLevelErrorMessage\" address=\"onboard.billing_address\" is-unbranded=\"isUnbranded\" flags=\"flags\"\n    validated=\"validated\" sepa=\"sepa\" done-fn=\"actions.onSubmit\"></xo-guest-sepa-lightbox>\n\n<!-- 3ds 1.0 -->\n<xo-3ds on-complete-3ds-handler=\"guestFactory.onComplete3DSHandler\" token=\"token\" data=\"resolve_3ds_data\" ng-if=\"launch3DSResolver\"></xo-3ds>\n\n<xo-ul-iframe on-complete=\"guestFactory.onCompleteULIframeHandler\" token=\"token\" mkey=\"ulMeta.mkey\" ng-if=\"flags.launchUlIframe\"></xo-ul-iframe>\n\n<!-- 3ds 2.0 -->\n<xo-modal\n    ng-if=\"showThreedsPopup\"\n    show=\"showThreedsPopup\"\n    enable-mobile-interstitial=\"true\"\n    show-close-button=\"true\"\n    on-close=\"actions.onThreedsModalClose\"\n    override-default-container=\"true\">\n    <xo-three-ds\n        token=\"token\"\n        reference-id=\"threedsData.referenceId\"\n        jwt-info=\"threedsData.jwtInfo\"\n        card-bin=\"threedsData.cardBin\"\n        network-logo=\"threedsData.networkLogo\"\n        ddc-url=\"threedsData.ddcUrl\"\n        authentication-provider=\"threedsData.authenticationProvider\"\n        card-brand-processed=\"threedsData.cardBrandProcessed\"\n        integration-type=\"threedsData.integrationType\"\n        init-threeds-data=\"threedsData.initThreedsData\"\n        on-complete=\"threedsData.integrationType === 'ADD_CARD' ? guestFactory.onThreedsCompleteAddFi : guestFactory.onThreedsCompleteTransaction\"\n        card-brand=\"onboard.card.type\">\n    </xo-three-ds>\n</xo-modal>\n\n<xo-confirm-upop token=\"token\" card-model=\"onboard.card\" phone=\"onboard.phone\" on-success=\"onUpopSuccess\" on-cancel=\"onUpopCancel\" on-init-error=\"onUpopCancel\" ng-if=\"launchUpopScreen\" button-text-key=\"upopConfirmButtonTextKey\"></xo-confirm-upop>\n<xo-currency-conversion-lightbox\n    token=\"token\"\n    done-fn=\"guestFactory.onCompleteDCC\"\n    pre-plan-treatment=\"flags.buyerFxTreatment\"\n    ng-if=\"launchCurrencyConversionLightbox\">\n</xo-currency-conversion-lightbox>\n<xo-travel-rule-lightbox token=\"token\" ng-if=\"launchTravelRuleLightbox\" done-fn=\"guestFactory.onTravelRuleSuccess\"></xo-travel-rule-lightbox>\n<xo-redirecting-from-xoon-warning token=\"token\" flags=\"flags\" mode=\"mode\" ng-if=\"flags.showRedirectWarningPrompt\"></xo-redirecting-from-xoon-warning>\n\n<xo-cart-changed\n    ng-if=\"flags.showCartChanged\"\n    token=\"token\"\n    disable-change-shipping-country=\"disableChangeShippingCountry\"\n    shipping-address=\"onboard.shipping_address\"\n    formatted-shipping-address=\"formattedShippingAddress\"\n    show-form=\"shippingChangeFeature.showForm\"\n    message=\"shippingChangeFeature.message\"\n    check-for-shipping-options=\"shippingOptionsFeature.checkForShippingOptions\"\n    selected-shipping-option=\"shippingOptionsFeature.selectedShippingOption\"\n    shipping-options=\"shippingOptionsFeature.shippingOptions\"\n    on-shipping-option-select=\"shippingOptionsFeature.selectShippingOption\"\n    on-shipping-change=\"shippingChangeFeature.handleOnShippingChange\"\n    on-continue=\"shippingChangeFeature.showOrResolveInterstitial\"\n></xo-cart-changed>\n\n<xo-modal\n    ng-if=\"flags.showPhoneConfirmationPopup\"\n    show=\"true\"\n    show-close-button=\"true\"\n    enable-close-on-escape=\"true\"\n    enable-mobile-interstitial=\"true\"\n    on-close=\"actions.onPhoneConfirmationClose\"\n    override-default-container=\"true\"\n>\n    <xo-phone-confirmation-interstitial\n        phone-details=\"onboard.phone\"\n        on-phone-confirmation-success=\"actions.onPhoneConfirmationSuccess\"\n    />\n</xo-modal>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/tesla-add-bank/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.TESLA_TOGGLE_FI_CARD = exports.TESLA_TOGGLE_FI_BANK = exports.DEFAULT_TOGGLE_FI = void 0;
// Default experience keys - For "DE" and other flows.
var DEFAULT_TOGGLE_FI = exports.DEFAULT_TOGGLE_FI = [{
  type: 'bank',
  label: 'bank.bank'
}, {
  type: 'card',
  label: 'bank.card'
}];

// Keys when "Bank" is selected as default.
var TESLA_TOGGLE_FI_BANK = exports.TESLA_TOGGLE_FI_BANK = [{
  type: 'bank',
  label: 'bank.bank'
}, {
  type: 'card',
  label: 'bank.cardWithoutCredit'
}];

// Keys when "Card" is selected as default.
var TESLA_TOGGLE_FI_CARD = exports.TESLA_TOGGLE_FI_CARD = [{
  type: 'card',
  label: 'bank.cardWithoutCredit'
}, {
  type: 'bank',
  label: 'bank.bank'
}];

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/tesla-add-bank/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/app/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/tesla-add-bank/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('xoTeslaAddBank', {
  tag: 'xo-tesla-add-bank',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        teslaFlowIdData: _index2.$TeslaFlowIdModel.instance(this.token).retrieve()
      };
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this = this;
      var setupRedirectUrl = function setupRedirectUrl() {
        var _ref = _this.models.teslaFlowIdData || {},
          teslaFlowID = _ref.encodedParam;
        _this.finalUrl = "" + window.location.origin + _index.$config.urls.teslaAddBankUrl + teslaFlowID + "&country.x=" + _index.$locale.country + "&locale.x=" + _index.$locale.lang + "_" + _index.$locale.country + "&tsrce=xoonboardingnodeweb";
        _logger.$logger.info('tesla_add_bank_final_url', _this.finalUrl);
      };
      setupRedirectUrl();
      this.$on('localeChange', function () {
        setupRedirectUrl();
      });
    }
  },
  actions: {
    onContinueClick: function onContinueClick($event) {
      // FPTI logging when clicked on continue.
      _logger.$logger.info('checkout_fpti', {
        from: 'SIGNUP',
        to: 'process_tesla_continue'
      });
      $event.preventDefault();
      _logger.$logger.info('tesla_add_bank_redirection_button_clicked');
      window.location.href = this.finalUrl;
    }
  }
});
_index.$Component;
_index.$locale;
_index.$config;
_index2.$TeslaFlowIdModel;
_logger.$logger;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/tesla-add-bank/template.html":
/***/ (function(module, exports) {

module.exports = "<div content>\n    <p class=\"subTitle ng-binding\">\n        {{content('bank.bankDescription')}}\n    </p>\n\n    <button class=\"btn\" id=\"teslaAddBankSubmit\" ng-click=\"actions.onContinueClick($event)\">{{content('common.continueLabel')}}</button>\n</div>"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/travelRuleLightbox/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/travelRuleLightbox/template.html"));
__webpack_require__("../node_modules/xo-form-components/src/travel-rule/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoTravelRuleLightbox', {
  tag: 'xo-travel-rule-lightbox',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    doneFn: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      // Open interstitial after element is rendered
      (0, _angular.$timeout)(function () {
        _this.modalOpen = true;
      });
    }
  }
});
_squid.$Component;
_angular.$timeout;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/travelRuleLightbox/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"travelRuleInterstitial\">\n    <div class=\"travelRule\" ng-class=\"{modalClose: !modalOpen, modalOpen: modalOpen}\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper modalWrapperAnimation\" modal-box focus-when=\"modalOpen\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <xo-message message=\"message\"></xo-message>\n                <xo-travel-rule token=\"token\" on-user-info-success=\"doneFn\"></xo-travel-rule>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"logo\"></div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.titleTreatmentKeyToContentKeyMapping = exports.titlePropsTreatmentKeyToContentKeyMapping = exports.indiaBillingProps = void 0;
var defaultSignupTitleContentKey = 'largeScreenPayment.signupTitle';
var defaultGuestTitleContentKey = 'largeScreenPayment.title';
var titleTreatmentKeyToContentKeyMapping = exports.titleTreatmentKeyToContentKeyMapping = {
  signup: defaultSignupTitleContentKey,
  guest: defaultGuestTitleContentKey,
  ebay: 'signupAccountCreation.heading',
  bank: 'largeScreenPayment.bankTitle',
  walletTokenization: 'common.createPayPalSubTitleSignup',
  xo_xoon_header_title_subtitle_global_control: defaultSignupTitleContentKey,
  xo_xoon_header_title_subtitle_global_throttle: defaultSignupTitleContentKey,
  xo_xoon_header_title_subtitle_global_test: 'splitScreenExp.signupOnboardTitle',
  xo_xoon_header_title_subtitle_IN_control: defaultSignupTitleContentKey,
  xo_xoon_header_title_subtitle_IN_treatment_a: 'header.titleSaferCheckout',
  xo_xoon_header_title_subtitle_IN_treatment_b: 'header.titleAddYourCard',
  xo_xoon_header_title_subtitle_IN_treatment_c: 'header.titleFreeAccount',
  indiaTitleBilling: 'header.titleBilling',
  indiaCrossBorderTitleBilling: 'signup.addACard',
  xo_xoon_jp_add_bank: 'header.titleTeslaBankOrCard',
  subscriptionV1Guest: 'subscriptions.guestHeader',
  indiaRtTitleBillingImmediate: 'header.indiaRtTitleBillingImmediate',
  indiaRtTitleBillingNonImmediate: 'header.indiaRtTitleBillingNonImmediate'
};
var defaultSignupTitlePropsContentKey = 'largeScreenPayment.titleProp';
var defaultGuestTitlePropsContentKey = defaultSignupTitlePropsContentKey;
var titlePropsTreatmentKeyToContentKeyMapping = exports.titlePropsTreatmentKeyToContentKeyMapping = {
  signup: defaultSignupTitlePropsContentKey,
  guest: defaultGuestTitlePropsContentKey,
  google: 'signup.androidPayTitleProp',
  samsung: 'signup.tokenizedWalletInfoTitleProp',
  walletTokenization: 'signup.androidPayTitleProp',
  xo_xoon_header_title_subtitle_global_control: defaultSignupTitlePropsContentKey,
  xo_xoon_header_title_subtitle_global_throttle: defaultSignupTitlePropsContentKey,
  xo_xoon_header_title_subtitle_global_test: 'common.buyerProtectionSignup',
  xo_xoon_header_title_subtitle_IN_control: defaultSignupTitlePropsContentKey,
  xo_xoon_header_title_subtitle_IN_treatment_a: 'header.subTitleCreateYourAccount',
  xo_xoon_header_title_subtitle_IN_treatment_b: 'header.subTitleSaveYourCard',
  xo_xoon_header_title_subtitle_IN_treatment_c: 'header.subTitleSaveYourCard',
  indiaTitleBilling: 'header.subTitleBilling'
};
var indiaBillingProps = exports.indiaBillingProps = {
  countryCode: 'IN',
  titleBilling: 'indiaTitleBilling',
  crossBorderTitleBilling: 'indiaCrossBorderTitleBilling',
  rtTitleBillingImmediate: 'indiaRtTitleBillingImmediate',
  rtTitleBillingNonImmediate: 'indiaRtTitleBillingNonImmediate'
};

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
__webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/template.html"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _lib = __webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/lib.js");
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/constants.js");
var _index = __webpack_require__("../node_modules/xo-models/src/app/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoXoonHeader', {
  tag: 'xo-xoon-header',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: true
    },
    flags: {
      type: 'var',
      required: true
    },
    user: {
      type: 'var',
      required: true
    },
    // This mode is carried from pages 'mode' setting
    // It is not flags.mode that changes upon radio button clicks
    // in optional signup flow
    mode: {
      type: 'var',
      required: true
    },
    fiMode: {
      type: 'var',
      required: true
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve(),
        checkoutInputData: _index3.$CheckoutInputDataModel.instance(this.token).retrieve(),
        tokenizedWalletInfoModel: _index.$TokenizedWalletInfoModel.instance(this.token).retrieve(),
        checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.token).retrieve()
      };
    },
    experiments: function experiments() {
      return {
        // we are running title and subTitle pxp only for signup flows
        titleSubtitleContentExp: this.props.mode === 'signup' ? (0, _squid.$elmo)('xo_xoon_header_title_subtitle', {
          'ctx.COUNTRY': _squid.$locale.country
        }, '(xo_xoon_header_title_subtitle_)(.*)') : null
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      this.locale = _squid.$locale;
      this.currentCountryName = _squid.$util.getProperty(this.locale, 'metadata.localization.countryName', {
        "default": this.locale.country
      });
    },
    populate: function populate() {
      var _this = this;
      var checkTeslaEligbility = function checkTeslaEligbility() {
        if (_this.locale.country === 'JP') {
          _this.teslaTreatmentFIType = 'xo_xoon_jp_add_bank';
          _this.teslaAddBankEXP = true;
        }
      };
      checkTeslaEligbility();
      var setTitleSubtitleContentAndFlags = function setTitleSubtitleContentAndFlags() {
        _this.subject = _this.models.tokenizedWalletInfoModel.getSubject(); // Samsung or Android

        var _ref = _this.experiments.titleSubtitleContentExp || {},
          titleSubtitleContentExpTreatment = _ref.treatment_name;

        // Add experiment check and default values (props.mode) on FLow Context keys
        var pageTitleFlowContextKey = (0, _lib.getPageTitleContextKey)(_this.models, _this.props.mode, _this.props.fiMode, _this.currentCountryName) || _this.teslaAddBankEXP && _this.teslaTreatmentFIType || titleSubtitleContentExpTreatment || _this.props.mode;
        var pageTitlePropsFlowContextKey = (0, _lib.getPageTitlePropsContextKey)(_this.models, _this.subject, _this.currentCountryName) || titleSubtitleContentExpTreatment || _this.props.mode;
        _this.merchant_name = _this.models.checkoutAppData.merchant.brand_name;
        // get the actual content key from constants file mapping
        _this.pageTitleContentKey = _constants.titleTreatmentKeyToContentKeyMapping[pageTitleFlowContextKey];
        _this.pageTitlePropsContentKey = _constants.titlePropsTreatmentKeyToContentKeyMapping[pageTitlePropsFlowContextKey];

        // When bank payments are suppressed, override "Pay with direct debit" to "Pay with debit or credit card"
        if (_this.props.flags.suppressBankFundedGuestPayments && _this.props.fiMode === 'bank') {
          _this.pageTitleContentKey = 'largeScreenPayment.title';
        }

        // if the treatment returned by pxp does not have words like 'control' and 'throttle'
        // then it is a test treatment, so lets set flags.titleSubtitleContentExpTreatment = true
        // This flag is used in onboardOptions template to decide display components
        if (titleSubtitleContentExpTreatment && !(titleSubtitleContentExpTreatment.indexOf('control') > -1 || titleSubtitleContentExpTreatment.indexOf('throttle') > -1)) {
          // Set flag to use in oboardingOptions template
          _this.props.flags.titleSubtitlePxpTreatment = true;
        }
      };
      var setInitialFlags = function setInitialFlags() {
        setTitleSubtitleContentAndFlags();
      };
      setInitialFlags();
    }
  },
  actions: {
    redirectWarningPromptInit: function redirectWarningPromptInit($event) {
      if ($event) {
        $event.preventDefault();
      }

      // Redirection will be triggered in redirectWarningPrompt directive
      // based on few conditions check
      this.flags.showRedirectWarningPrompt = true;
    }
  }
});
_squid.$Component;
_squid.$locale;
_squid.$util;
_squid.$elmo;
_lib.getPageTitleContextKey;
_lib.getPageTitlePropsContextKey;
_constants.titleTreatmentKeyToContentKeyMapping;
_constants.titlePropsTreatmentKeyToContentKeyMapping;
_index.$TokenizedWalletInfoModel;
_index2.$CheckoutCartModel;
_index2.$CheckoutAppDataModel;
_index3.$CheckoutInputDataModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/lib.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getPageTitlePropsContextKey = exports.getPageTitleContextKey = void 0;
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/constants.js");
var isIndiaInterBorderBilling = function isIndiaInterBorderBilling(models) {
  var isBilling = models.checkoutCart.isBilling();
  var isIndia = models.checkoutCart.isConsumerCountry(_constants.indiaBillingProps.countryCode);
  var isInterBorderMerchant = models.checkoutAppData.isMerchantCountry(_constants.indiaBillingProps.countryCode);
  return isBilling && isIndia && isInterBorderMerchant;
};
var isIndiaCrossBorderBilling = function isIndiaCrossBorderBilling(models) {
  var isBilling = models.checkoutCart.isBilling();
  var isIndia = models.checkoutCart.isConsumerCountry(_constants.indiaBillingProps.countryCode);
  var isCrossBorderMerchant = !models.checkoutAppData.isMerchantCountry(_constants.indiaBillingProps.countryCode);
  return isBilling && isIndia && isCrossBorderMerchant;
};

// Return keys for few specific flows that needs title override
// Please refer to ./constants.js file for default keys used in the flow
var getPageTitleContextKey = exports.getPageTitleContextKey = function getPageTitleContextKey(models, mode, fiMode, currentCountryName) {
  if (models.checkoutInputData.isEbayTxn()) {
    // prox signup flow title
    return 'ebay';
  } else if (mode === 'guest' && (models.checkoutCart.isSubscriptionsV1() || models.checkoutAppData.isWpsAutobillingFlow())) {
    return 'subscriptionV1Guest';
  } else if (fiMode === 'bank') {
    return 'bank';
  } else if (models.checkoutCart.isWalletTokenization()) {
    return 'walletTokenization';
  } else if (isIndiaInterBorderBilling(models)) {
    if (models.checkoutAppData.is_wps_flow() || models.checkoutCart.isRecurringPayment() || models.checkoutCart.isSubscriptionsV1()) {
      return _constants.indiaBillingProps.titleBilling;
    } else if (models.checkoutCart.isReferenceTransaction() && !models.checkoutCart.isChargePatternImmediateOrDeferred()) {
      return _constants.indiaBillingProps.rtTitleBillingNonImmediate;
    } else if (models.checkoutCart.isReferenceTransaction() && models.checkoutCart.isChargePatternImmediateOrDeferred()) {
      return _constants.indiaBillingProps.rtTitleBillingImmediate;
    }
  } else if (isIndiaCrossBorderBilling(models)) {
    if (models.checkoutCart.isReferenceTransaction()) {
      return _constants.indiaBillingProps.rtTitleBillingImmediate;
    } else {
      return _constants.indiaBillingProps.crossBorderTitleBilling;
    }
  }
  // We have an experiment that decides key for mode === 'signup'
};

// Return keys for few specific flows that needs title props or sub title override
// Please refer to ./constants.js file for default keys used in the flow
var getPageTitlePropsContextKey = exports.getPageTitlePropsContextKey = function getPageTitlePropsContextKey(models, subject, currentCountryName) {
  var WALLET_RESPONSE = ['google', 'Samsung'];
  if (models.checkoutCart.isWalletTokenization()) {
    _logger.$logger.info(subject + "_WALLET_TOKENIZATION");
    if (WALLET_RESPONSE.indexOf(subject) > -1) {
      return subject.toLowerCase();
    } else {
      // Oops something terrible happened! API response does't have our key. return default instead
      return 'walletTokenization';
    }
  }
  if (models.checkoutCart.isConsumerCountry(_constants.indiaBillingProps.countryCode) && models.checkoutCart.isBilling()) {
    return _constants.indiaBillingProps.titleBilling;
  }
};
_logger.$logger;
_constants.indiaBillingProps;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/guest/xoonHeader/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"headerBox\" content>\n    <h1 class=\"alpha\" id=\"pageTitle\" ng-bind-html=\"htmlContent(pageTitleContentKey, { merchant_name: merchant_name })\"></h1>\n    <p class=\"subTitle\" id=\"pageTitleProps\" ng-bind-html=\"htmlContent(pageTitlePropsContentKey, { subject: subject, countryName: currentCountryName })\"></p>\n\n    <xo-message ng-if=\"showEmailCheckInfoBox\" id=\"headerEmailCheckInfo\" message=\"emailCheckInfo\"></xo-message>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-guest-components/src/lib/contentKeys.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.getSusbcriptionsV1ContentKey = exports.getRPContentKey = exports.getKeySuffix = exports.getBillingAgreementContentInfo = exports.getBAContentKey = void 0;
/**
 * Returns the appropriate billing agreement key suffix
 * Return indiaCrossBorderWithoutCib if it is indiaCrossBorder transaction and the type is not cib
 * Or the indiaDomestic transaction and the flow is wps or RecurringPayments.
 * Return indiaDomesticRt if it indiaDomesticTransaction and the transaction type is ReferenceTransaction.
 * Return indiaRtCib if it is a indiaCrossBorder or IndiaDomestic Transaction and the transaction type is ReferenceTransaction.
 * If none of the case matches returns ${type}Sticky${indiaDomestic}${action}.
 *
 * @param {type} String
 * @param {indiaDomestic} Boolean
 * @param {indiaCrossBorder} Boolean
 * @param {action} String
 * @param {cart} a CheckoutCartModel instance
 * @return {String}
 */
var BILL_PAY_CONSENT = 'billPayConsent';
var getKeySuffix = exports.getKeySuffix = function getKeySuffix(type, buyerCountry, appData, action, cart) {
  var isIndianMerchant = appData.get('merchant.merchant_country', 'US') === 'IN';
  var indiaDomestic = buyerCountry === 'IN' && isIndianMerchant ? 'Domestic' : '';
  if (buyerCountry === 'IN') {
    if (!isIndianMerchant && type !== 'Cib') {
      return 'IndiaCrossBorderWithoutCib';
    } else if (type === 'Cib' && cart.isReferenceTransaction()) {
      return 'IndiaRtCib';
    } else if (isIndianMerchant && cart.isReferenceTransaction()) {
      return 'IndiaDomesticRt';
    }
  }
  return type + "Sticky" + indiaDomestic + action;
};

/**
 * Returns the appropriate billing agreement xo-content key.
 * (Usage: MIB, CIB, MISB, CISB and all merchant having a consent_code in their settings.)
 *   enterpriseAgreement.{CODE}NoFiStickyConsentSignup
 *   billingAgreement.signupAgreementCibStickyPay
 *   billingAgreement.signupAgreementCibStickyContinue
 *   billingAgreement.signupAgreementFiStickyPay
 *   billingAgreement.signupAgreementFiStickyContinue
 *   billingAgreement.signupAgreementIndiaCrossBorderWithoutCib
 *   billingAgreement.signupAgreementIndiaDomesticRt
 *   billingAgreement.signupAgreementIndiaRtCib
 * @param {cart} a CheckoutCartModel instance
 * @param {appData} a CheckoutAppDataModel instance
 * @return {String}
 */

var getBAContentKey = exports.getBAContentKey = function getBAContentKey(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    cart = _ref.cart,
    appData = _ref.appData,
    locale = _ref.locale,
    noBalance = _ref.noBalance;
  if (!cart.isSubscriptionsV1()) {
    var consentCode = cart.get('billing.consent_code');
    var isBillPayConsent = consentCode === BILL_PAY_CONSENT; // Validation for billpay model 3 flow

    if (consentCode) {
      return "enterpriseAgreement." + (isBillPayConsent ? 'billPayConsentMIBWithNoBalanceChoice' : consentCode + "NoFiStickyConsentSignup");
    }
  }
  if (noBalance) {
    return 'billingAgreement.noBalanceSignupAgreement';
  }
  var isCIB = cart.get('billing.type') === 'CHANNEL_INITIATED_BILLING';
  var type = isCIB ? 'Cib' : 'Fi'; // 'Fi' type applicable to both MIB and subscriptionsV1
  var useraction = appData.useraction();
  var action = useraction === 'commit' ? 'Pay' : 'Continue';
  var keySuffix = getKeySuffix(type, locale.country, appData, action, cart);
  return "billingAgreement.signupAgreement" + keySuffix;
};

/**
 * Returns the appropriate RP xo-content key.
 *
 *   billingAgreement.signupRpAgreementFiStickyPay
 *   billingAgreement.signupRpAgreementFiStickyContinue
 *
 * @param {appData} a CheckoutAppDataModel instance
 * @return {String}
 */
var getRPContentKey = exports.getRPContentKey = function getRPContentKey(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    appData = _ref2.appData,
    noBalance = _ref2.noBalance;
  if (noBalance) {
    return 'billingAgreement.noBalanceSignupAgreement';
  }
  var useraction = appData.useraction();
  var action = useraction === 'commit' ? 'Pay' : 'Continue';
  return "billingAgreement.signupRpAgreementFiSticky" + action;
};
var getSusbcriptionsV1ContentKey = exports.getSusbcriptionsV1ContentKey = function getSusbcriptionsV1ContentKey(_ref3) {
  var cart = _ref3.cart,
    appData = _ref3.appData,
    locale = _ref3.locale,
    mode = _ref3.mode,
    fiMode = _ref3.fiMode;
  var useraction = appData.useraction();
  if (locale.country === 'SG') {
    // Singapore Payment Service Act
    if (useraction === 'continue') {
      return 'billingAgreement.guestAgreementSubscriptionV1Continue';
    }
    return 'billingAgreement.guestAgreementSubscriptionsV1';
  }
  if (mode === 'guest') {
    if (fiMode === 'bank') {
      return 'billingAgreement.guestAgreementSubscriptionsV1Bank';
    }
    return 'billingAgreement.guestAgreementSubscriptionsV1';
  }

  // Using MIB BA text for subscription V1 signup flow
  return getBAContentKey({
    cart: cart,
    appData: appData,
    locale: locale
  });
};

/**
 * Determines and returns content key for billing agreement flow.
 * Takes care of MIB, CIB, RP, WPS Subscriptions, WPS InstallmentPlan, Subscriptions V1 (API integration).
 * WPS Susbcription and RP BA Text is same.
 *
 * @param cart
 * @param appData
 * @param locale
 * @return {object} containing contentKey and idSelector to be applied to span element displaying BA text
 */
var getBillingAgreementContentInfo = exports.getBillingAgreementContentInfo = function getBillingAgreementContentInfo(_temp3) {
  var _ref4 = _temp3 === void 0 ? {} : _temp3,
    cart = _ref4.cart,
    appData = _ref4.appData,
    locale = _ref4.locale,
    mode = _ref4.mode,
    fiMode = _ref4.fiMode,
    noBalance = _ref4.noBalance;
  var billPayIntegratorName = cart.get('partnerDetail.businessName');
  var showBAContent = cart.isBilling() && !cart.isWalletTokenization();
  var isWpsSubscription = appData.is_wps_subscription_flow();
  var isWpsAutobilling = appData.isWpsAutobillingFlow();
  var isSubscriptionsV1 = cart.isSubscriptionsV1();
  var isWpsInstallmentPlan = appData.is_wps_installmentplan_flow();
  var isRP = cart.get('billing.type') === 'RECURRING_PAYMENTS';
  var showBillingAgreementText = showBAContent && !isRP && !isWpsSubscription && !isWpsAutobilling && !isSubscriptionsV1 && !isWpsInstallmentPlan;
  var showRpAgreementText = showBAContent && (isRP || isWpsSubscription);
  var showInstallmentPlanText = showBAContent && isWpsInstallmentPlan;
  var showSubscriptionsV1AgreementText = showBAContent && isSubscriptionsV1 || isWpsAutobilling;
  var country = locale.country,
    lang = locale.lang;
  var merchantName = appData.getMerchantDisplayName({
    nonEmptyReturnValue: true
  });
  if (showBillingAgreementText) {
    return {
      contentKey: getBAContentKey({
        cart: cart,
        appData: appData,
        locale: locale,
        noBalance: noBalance
      }),
      idSelector: 'billingAgreement',
      data: {
        billPayIntegratorName: billPayIntegratorName,
        merchantName: merchantName,
        country: country,
        lang: lang
      }
    };
  } else if (showRpAgreementText) {
    return {
      contentKey: getRPContentKey({
        appData: appData,
        locale: locale,
        noBalance: noBalance
      }),
      idSelector: 'rpAgreement',
      data: {
        merchantName: merchantName,
        country: country,
        lang: lang
      }
    };
  } else if (showInstallmentPlanText) {
    return {
      contentKey: 'billingAgreement.signupAgreementInstallmentPlan',
      idSelector: 'installmentPlan',
      data: {
        merchantName: merchantName,
        country: country,
        lang: lang
      }
    };
  } else if (showSubscriptionsV1AgreementText) {
    return {
      contentKey: getSusbcriptionsV1ContentKey({
        cart: cart,
        appData: appData,
        locale: locale,
        mode: mode,
        fiMode: fiMode
      }),
      idSelector: 'subscriptionsV1Agreement',
      data: {
        merchantName: merchantName,
        country: country,
        lang: lang
      }
    };
  }
  return {};
};

/***/ }),

/***/ "../node_modules/xo-guest-components/src/lib/guestFactory.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$GuestFactory = $GuestFactory;
exports.ROUTE = exports.ERROR_CODE = void 0;
__webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/shoppingcart/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");
var _fiApis = __webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js");
var _mayfly = __webpack_require__("../node_modules/xo-models/src/mayfly/index.js");
var errorHandlerHelper = _interopRequireWildcard(__webpack_require__("../node_modules/xo-guest-components/src/guest/lib/errorHandlerHelper.js"));
var _util = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");
var _utils = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/utils.js");
var _sticky = __webpack_require__("../node_modules/xo-guest-components/src/guest/sticky.js");
var _util2 = __webpack_require__("../node_modules/xo-guest-components/src/guest/lib/util.js");
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/guest/constants/constants.js");
var _index5 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var ERROR_CODE = exports.ERROR_CODE = {
  EXPIRED_SESSION: 'EXPIRED_SESSION',
  PAYMENT_PROCESS_ERROR: 'PAYMENT_PROCESS_ERROR',
  TRANSACTION_REFUSED: 'TRANSACTION_REFUSED',
  BLOCK_NON_DOMESTIC_SHIPPING: 'BLOCK_NON_DOMESTIC_SHIPPING',
  TRANSACTION_LIMIT_EXCEEDED: 'TRANSACTION_LIMIT_EXCEEDED',
  PAYMENT_DENIED: 'PAYMENT_DENIED',
  PAYMENT_ALREADY_DONE: 'PAYMENT_ALREADY_DONE',
  DEFAULT: 'DEFAULT'
};
var ROUTE = exports.ROUTE = {
  GENERIC_ERROR: 'checkout.genericError',
  XO_GUEST: 'checkout.guest',
  XO_DONE: 'checkout.done',
  XO_END: 'checkout.end',
  XO_GUEST_UPGRADE_INTERSTITIAL: 'checkout.guest.guestUpgradeInterstitial',
  XO_GUEST_EXISTING_MEMBER_INTERSTITIAL: 'checkout.guest.guestExistingMemberInterstitial',
  XO_ADD_CARD_FLOW: 'checkout.pageAddCard.addCardFlow.addCard',
  XO_SOLDOUT: 'checkout.soldout'
};
var THREEDS_FAILURE_CODE = ['DECLINE', 'FAILURE'];
function $GuestFactory(_ref) {
  var scope = _ref.scope;
  var addMissingTokens = function addMissingTokens(urlQuery) {
    var payload = {
      'token': scope.token || _squid.$meta.token
    };
    if (_squid.$meta.baToken) {
      payload.ba_token = _squid.$meta.baToken;
    }
    return _squid.$util.queryStringSplice(urlQuery, payload);
  };
  var handleStepUpAuth = function handleStepUpAuth(step_up_context) {
    if (step_up_context && !angular.isObject(step_up_context)) {
      _logger.$logger.info('Guest_authflow_step_up', {
        context: step_up_context
      });
      var authChallengeNodeUrl = _squid.$config.urls.authChallengeNodeUrl;
      if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage() || _squid.$config.deploy.isTest()) {
        var hostname = _squid.$meta.stage || _angular.$window.location.hostname;
        authChallengeNodeUrl = authChallengeNodeUrl.replace('www.paypal.com', hostname);
      }
      authChallengeNodeUrl = _squid.$util.buildURL(authChallengeNodeUrl, {
        stepupContext: step_up_context,
        returnUri: _squid.$config.urls.baseUrl + addMissingTokens(_angular.$window.location.search) + '&atoSuccess=true',
        flowId: 'guestxo',
        flowContext: 'funding'
      });
      if (authChallengeNodeUrl) {
        _squid.$util.redirect(authChallengeNodeUrl);
      } else {
        _logger.$logger.info('Guest_authflow_no_auth_challenge_url');
        return showGenericError(ERROR_CODE.TRANSACTION_REFUSED);
      }
    } else {
      _logger.$logger.info('Guest_authflow_no_step_up_context');
      throw new _squid.$FallbackError({
        reason: 'step_up_auth_needed',
        product: 'ux'
      });
    }
  };
  var showGenericError = function showGenericError(code) {
    return function () {
      _uiRouter.$state.go(ROUTE.GENERIC_ERROR, {
        code: code
      });
    };
  };
  var handleCardContingencyGuest = function handleCardContingencyGuest() {
    var errorKey;
    if (scope.models.payee.isGambling()) {
      errorKey = 'creditcard.noEligibleFI';
    } else if (scope.onboard.billing_address.country === 'DE') {
      if (scope.onboard.fiMode === 'bank') {
        delete scope.onboard.bank;
        errorKey = 'creditcard.cannotUseBank';
        scope.onboard.fiMode = 'card';
      } else {
        errorKey = 'creditcard.cannotUseCard';
      }
    } else {
      errorKey = 'creditcard.errorInstrumentRefused';
    }
    if (scope.flags.returnFromANW) {
      _uiRouter.$state.go(ROUTE.XO_GUEST, {
        error: errorKey
      });
    } else {
      var msg = _squid.$locale.content.get(errorKey);
      scope.errorMessage = {
        msgs: [msg],
        type: 'error'
      };
      return _angular.$q.reject()["catch"](angular.noop);
    }
  };
  var patchCvv = function patchCvv(checkoutSession, mustPatchCvv) {
    if (mustPatchCvv === void 0) {
      mustPatchCvv = false;
    }
    // Performing a check if the card and CVV exists to determine whether or not we do a patchCVV
    var security_code = scope.onboard.get('card.security_code');
    var fundingOptions = checkoutSession.get('fundingOptions.instruments');
    var instrumentId = fundingOptions && fundingOptions.length > 0 ? fundingOptions[0].id : null;
    if (mustPatchCvv) {
      checkoutSession.set('cvvData', {
        id: scope.onboard.get('fundingId'),
        type: scope.onboard.get('card.type'),
        number: scope.onboard.get('card.number').replace(/[^\d]+/g, ''),
        security_code: security_code
      });
    } else if (checkoutSession.get('cvvData')) {
      _logger.$logger.info('paps_threw_cvv_contigency_patchCvv');
      checkoutSession.set('cvvData.security_code', security_code);
    } else if (security_code && instrumentId && (scope.onboard.bypass_address_verification || scope.onboard.bypass_authorization)) {
      if (scope.onboard.bypass_address_verification) {
        _logger.$logger.info('bypass_avs_patchCvv');
      }
      if (scope.onboard.bypass_authorization) {
        _logger.$logger.info('bypass_auth_patchCvv');
      }
      checkoutSession.set('cvvData', {
        security_code: security_code,
        id: instrumentId
      });
    }
    return _fiApis.$fiApis.patchCvv(checkoutSession);
  };
  var handleCardContingencySignup = function handleCardContingencySignup(errorData) {
    if (scope.models.checkoutInputData.isEbayTxn()) {
      (0, _squid.$dispatch)('prox', {
        action: 'login'
      });
    } else {
      // redirect to hermes and we will see add card page
      var fieldError = errorData && errorData[0] && errorData[0].field;
      var avsRetry = fieldError === 'billing_address';
      (0, _squid.$dispatch)('hermes', {
        redirectToHermes: true,
        addFIContingency: fieldError ? 'retry' : 'noretry',
        avsRetry: avsRetry,
        token: scope.token,
        'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
        'country.x': _squid.$locale.country
      });
    }
  };

  /**
   * To check the elmo treatment for the 3ds experience
   *
   * return {Boolean}
   */
  var checkPaymentExperienceTreatment = function checkPaymentExperienceTreatment() {
    // If the country is not enabled for paymentExperience elmo check, return without calling elmo
    if (!(0, _squid.$feature)('callElmoForPaymentExperience')) {
      parseQueryStringForExperience();
      return;
    }
    var merchant_id = scope.models.payee.get('merchant.id');
    var _$config$pxpExperimen = _squid.$config.pxpExperiments.IN.in_xoon_3DS_experience,
      resourceName = _$config$pxpExperimen.resourceName,
      pattern = _$config$pxpExperimen.testTreatmentName;
    var merchantCountryCode = scope.models.checkoutAppData.get('merchant.merchant_country');
    var params = {
      'filters.Country': _squid.$locale.country,
      'uid': merchant_id,
      'filters.MerchantCountry': merchantCountryCode
    };
    (0, _squid.$elmo)(resourceName, params, pattern).then(function (result) {
      if (result) {
        scope.isRedirectTreatment = true;
      }
    })["finally"](function () {
      parseQueryStringForExperience();
    });
  };

  /**
   * Parse the queryString
   * - set the required scopes for init3DS paymentExperience
   * - set return query while return to merchaant
   */
  var parseQueryStringForExperience = function parseQueryStringForExperience() {
    var searchParams = _squid.$util.params(_angular.$window.location.search.split('?')[1]);

    // Construct the url query string to return back after complete3DS to proceed with /continue3DSRedirect
    searchParams = Object.assign({}, searchParams, {
      hermes: '1',
      token: scope.token
    });

    // Remove unwanted query params from url
    // - cmd: as this will force the flow in newer onboarding experience
    delete searchParams.cmd;
    scope.process3dsReturnQueryParams = _squid.$util.paramToQueryString(searchParams);

    /**
     * Below is for Internal testing, it will override paymentExperience,
     * if init3DS response is not giving paymemtExperience
     * to override paymentExperience we can use threeDSexp in qqueryString with 'redirect' or 'iframe'
     */
    var searchParamThreeDSexp = searchParams['threeDSexp'];
    if (searchParamThreeDSexp === 'redirect' || searchParamThreeDSexp === 'iframe') {
      scope.isRedirectTreatment = searchParamThreeDSexp === 'redirect';
      _logger.$logger.info('checkout_fpti', {
        from: "3ds_exp_queryString_" + scope.isRedirectTreatment,
        to: "process_3ds_exp__queryString_" + scope.isRedirectTreatment
      });
    }
  };

  /**
   * Get paymentExperience from URL for experiemenation
   *
   * @return {Array}
   */
  var getPaymentExperience = function getPaymentExperience() {
    var supportedPaymentExperience;
    scope.paymentExperience = scope.isRedirectTreatment ? _constants.availablePaymentExp.REDIRECT : _constants.availablePaymentExp.IFRAME;
    scope.channelType = scope.isRedirectTreatment ? _constants.channelType.MOBILE_APP : _constants.channelType.WEB;
    supportedPaymentExperience = [scope.paymentExperience];

    // if the merchant integrated with incontext experience then we need to send 'IFRAME' as experience
    if (isPaymentExperienceForcedIframe() || isWPSGuestFlow()) {
      scope.overridePaymentExpAsIframe = true;
      _logger.$logger.info('checkout_fpti', {
        from: 'override_as_iframe',
        to: 'process_override_as_iframe'
      });
      scope.channelType = _constants.channelType.WEB;
      scope.isRedirectTreatment = false;
      supportedPaymentExperience = [_constants.availablePaymentExp.IFRAME];
    }
    return supportedPaymentExperience;
  };

  /**
   * Get Security code from cvvData
   */
  var getSecurityCode = function getSecurityCode() {
    if (scope.onboard.get('card.security_code')) {
      var security_code = scope.onboard.get('card.security_code');
      return security_code;
    }
  };

  /**
   * Validate the flow for forceing the paymentExperience to iframe
   */
  var isPaymentExperienceForcedIframe = function isPaymentExperienceForcedIframe() {
    return _angular.$rootScope.miniBrowser;
  };

  /**
   * Validate and return true if the  transaction is WPS and user mode is Guest
   */
  var isWPSGuestFlow = function isWPSGuestFlow() {
    return scope.flags.wpsFlow && scope.flags.mode !== 'signup';
  };
  var handleCardContingency = function handleCardContingency() {
    return scope.flags.mode === 'signup' ? handleCardContingencySignup() : handleCardContingencyGuest();
  };
  var show3DSLightbox = function show3DSLightbox(checkoutSession) {
    var cc_id = checkoutSession.get('resolve_3ds.ccId');
    var plans = checkoutSession.get('plan.sources', null);
    var plan = plans && plans.filter(function (e) {
      return e.instrument_id === cc_id;
    })[0].amount || null;
    scope.resolve_3ds_data = {
      cc_id: cc_id,
      flow_id: 'HERMES',
      merchant_id: scope.models.payee.get('merchant.id'),
      merchant_country_code: scope.models.checkoutAppData.get('merchant.merchant_country'),
      transaction_amount_currency: plan && plan.currency_code,
      transaction_amount_value: plan && plan.amount
    };
    if ((0, _squid.$feature)('appendIPGPayload')) {
      scope.resolve_3ds_data.card_verification_code = getSecurityCode();
      scope.resolve_3ds_data.paymentExperience = getPaymentExperience();
      scope.resolve_3ds_data.channelType = scope.channelType;
      scope.resolve_3ds_data.isRedirectTreatment = scope.isRedirectTreatment;
      scope.resolve_3ds_data.process3dsReturnQueryParams = scope.process3dsReturnQueryParams;
      scope.resolve_3ds_data.mode = scope.flags.mode;
      scope.resolve_3ds_data.overridePaymentExpAsIframe = scope.overridePaymentExpAsIframe;
    }
    scope.launch3DSResolver = true;
  };
  var getProductDetails = function getProductDetails() {
    // default to express checkout
    var productDetails = {
      productCode: 'EXPRESS_CHECKOUT',
      productFlow: 'HERMES'
    };
    var isWPSFlow = scope.models.checkoutAppData.is_wps_flow();
    var isPurchase = scope.models.checkoutCart.isPurchase();
    var isBilling = scope.models.checkoutCart.isBilling();
    var isWPSSubscriptionFlow = scope.models.checkoutAppData.is_wps_subscription_flow();
    var isWPSAutobillingFlow = scope.models.checkoutAppData.isWpsAutobillingFlow();
    var isWPSInstallmentsFlow = scope.models.checkoutAppData.is_wps_installmentplan_flow();
    var isSubscriptionsV1Flow = scope.models.checkoutCart.isSubscriptionsV1();
    var isRPFlow = isBilling && scope.models.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
    var setBillingProductFlow = function setBillingProductFlow() {
      if (isPurchase) {
        productDetails.productFlow = 'BUYER_APPROVAL_BILLING_AGREEMENT_WITH_PURCHASE';
      } else {
        productDetails.productFlow = 'BUYER_APPROVAL_SUBSCRIPTIONS_CREATE';
      }
    };
    if (isWPSSubscriptionFlow || isWPSInstallmentsFlow || isSubscriptionsV1Flow || isRPFlow || isWPSAutobillingFlow) {
      productDetails.productCode = 'BILLING_SUBSCRIPTIONS';
      setBillingProductFlow();
    } else if (isBilling) {
      productDetails.productCode = 'BILLING_AGREEMENTS';
      setBillingProductFlow();
    } else if (isWPSFlow) {
      productDetails.productCode = 'WEBSITE_PAYMENT_STANDARD';
    }
    return productDetails;
  };
  var show3DS2_0_Lightbox = function show3DS2_0_Lightbox(checkoutSession) {
    var merchant_category_code = scope.models.payee.get('merchant.merchant_category_code');
    scope.threedsData = (0, _util2.get3DSDataForSwitch)(checkoutSession, scope);
    scope.threedsData.initThreedsData.merchant_category_code = merchant_category_code;
    scope.threedsData.initThreedsData.productDetails = getProductDetails();
    scope.showThreedsPopup = true;
  };
  var inventoryOperation = function inventoryOperation(paymentStatus) {
    var cartHasInventory = scope.models.checkoutCart.get('cartHasInventory');
    if (!cartHasInventory) {
      return _angular.$q.when(); // not an inventory request proceed with existing flow
    }
    var inventoryModel = _index4.$InventoryModel.instance(scope.token);
    var inventoryItems = inventoryModel.getInventoryItems();
    var purchaseItems = scope.models.checkoutCart.get('purchaseUnits');
    var cartItems;
    if (purchaseItems && purchaseItems[0] && purchaseItems[0].item_list) {
      cartItems = purchaseItems[0].item_list.items;
    }
    paymentStatus = paymentStatus || 'success';
    if (!(cartItems && inventoryItems)) {
      return _angular.$q.when(); // don't need to call patchInventory if items not present
    }
    var inventoryPatchInput = {
      inventoryItems: inventoryItems,
      merchantId: scope.models.payee.get('merchant.id', ''),
      paymentStatus: paymentStatus
    };
    return inventoryModel.action('patchInventory', {
      data: inventoryPatchInput,
      success: function success(patchResponse) {
        if (patchResponse) {
          if (patchResponse.showSoldoutPage) {
            // show soldout page
            return {
              soldoutpage: true,
              items: patchResponse.soldoutItems,
              soldOutUrl: patchResponse.soldoutUrl
            };
          } else if (patchResponse.patchCart) {
            var purchase_unit = scope.models.checkoutCart.get('purchaseUnits')[0];
            purchase_unit.item_list.items = patchResponse.cartItems;
            var patchCartPayload = {
              id: scope.token,
              patchEntities: [{
                field: 'inventoryItems',
                value: purchase_unit.item_list.items
              }]
            };
            return scope.models.checkoutCart.action('patchCartData', {
              data: patchCartPayload
            });
          }
        } else {
          return;
        }
      }
    });
  };
  var handlePaymentContingencies = function handlePaymentContingencies(code) {
    return function () {
      inventoryOperation('failed');
      return _uiRouter.$state.go(ROUTE.GENERIC_ERROR, {
        code: code
      });
    };
  };
  var markCartCheckedout = function markCartCheckedout() {
    var shoppingCartModel = _index3.$ShoppingCartModel.instance(scope.token);
    return shoppingCartModel.action('cartCheckedOut', {
      success: function success() {
        _logger.$logger.info('cart checked out successfully');
      }
    });
  };

  /*
   * This function will determine final route of the transaction:
   * 1. return to merchant for all non WPS traffic
   * 2. go to checkout done page for WPS with not eligible interstitial traffic
   * 3. go to WPS interstitial for eligible(passes upgrade eligibility) WPS traffic
   */
  var finalRoute = function finalRoute() {
    var finishFlow = function finishFlow() {
      var isWpsFlow = scope.flags.wpsFlow;
      if (scope.flags.poma_flow) {
        _logger.$logger.info("LOGGING_OUT" + (isWpsFlow ? '_WPS' : '') + "_POMA_FLOW_FOR_CLEARING_COOKIES");

        // Logging out the user only for POMA before going to END state.
        // why are we logging out?
        // ACCESS_TOKEN dropped during passive login is 8hr expiration, due to which
        // user is not authenticated in subsequent transaction in hermes review page
        // while adding FI or Shipping Address.
        // so by logging out the user, removes all the cookies except RT from the
        // browser in which hermes does RT to AT exchange in the absence of AT and gets
        // the limited AccessToken.
        var auth = _index5.$AuthModel.instance();
        return auth.action('logout').then(function () {
          return _uiRouter.$state.go(isWpsFlow ? ROUTE.XO_DONE : ROUTE.XO_END);
        });
      }
      return _uiRouter.$state.go(isWpsFlow ? ROUTE.XO_DONE : ROUTE.XO_END);
    };
    if (scope.flags.wpsFlow) {
      scope.singleStepModel.onboard = scope.onboard;
      scope.singleStepModel.flags = scope.flags;
      if (scope.userAgreementLink) {
        scope.singleStepModel.userAgreementLink = scope.userAgreementLink;
      }
      // set signup/guest flag so done page
      // renders the proper content
      _angular.$rootScope.mode = scope.flags.mode;
      if (scope.flags.wpsInterstitialEligible) {
        if (scope.flags.buyerMode === 'signup') {
          return _uiRouter.$state.go(ROUTE.XO_DONE);
        }
        var logAndGoToDone = function logAndGoToDone(error) {
          return function () {
            _logger.$logger.info('checkout_fpti', {
              from: 'Create_account',
              to: 'wps_upgrade_interstitial_ineligible'
            });
            _logger.$logger.info("wps_interstitial_ineligible_" + error);
            return _uiRouter.$state.go(ROUTE.XO_DONE);
          };
        };
        if (scope.onboard.isEmailLinkedToFullAccount) {
          return scope.isCustomerEligibleForOtpUpsell.then(function (eligible) {
            // This block means the customer is in elmo - treatment, but he may or may not be eligible for
            // OTP upsell interstitial.
            if (eligible && scope.ulMeta['mkey'] && scope.ulMeta.trmt.length > 0) {
              _logger.$logger.info('wps_interstitial_eligible_for_otpUpsell');
              scope.singleStepModel.ulMeta = scope.ulMeta;
              return _uiRouter.$state.go(ROUTE.XO_GUEST_EXISTING_MEMBER_INTERSTITIAL);
            } else {
              _logger.$logger.info('checkout_fpti', {
                from: 'Create_account',
                to: 'wps_upgrade_interstitial_ineligible'
              });
              _logger.$logger.info('wps_interstitial_ineligible');
              return _uiRouter.$state.go(ROUTE.XO_DONE);
            }
          })["catch"](function () {
            _logger.$logger.info('checkout_fpti', {
              from: 'Create_account',
              to: 'wps_upgrade_interstitial_ineligible'
            });
            // This block means the customer is in elmo - control
            _logger.$logger.info('wps_interstitial_ineligible_EXISTING_MEMBER');
            return _uiRouter.$state.go(ROUTE.XO_DONE);
          });
        } else {
          return scope.onboard.action('upgradeValidate', {
            data: scope.onboard.serialize(),
            success: function success() {
              _logger.$logger.info('wps_upgrade_interstitial_eligible');
              _logger.$logger.info('checkout_fpti', {
                from: 'Create_account',
                to: 'wps_upgrade_interstitial_eligible'
              });
              return _uiRouter.$state.go(ROUTE.XO_GUEST_UPGRADE_INTERSTITIAL);
            },
            contingencies: {
              CC_LINKED: logAndGoToDone('CC_LINKED'),
              CC_LINKED_TO_FULL_ACCOUNT: logAndGoToDone('CC_LINKED_TO_FULL_ACCOUNT'),
              VALIDATION_ERROR: logAndGoToDone('VALIDATION_ERROR'),
              DEFAULT: logAndGoToDone('UHANDLED_CONTINGENCY')
            },
            validation: logAndGoToDone('SERVICE_VALIDATION_ERROR'),
            error: logAndGoToDone('SERVICE_ERROR')
          });
        }
      }
    }
    finishFlow();
  };
  var makePayment = function makePayment() {
    var checkoutSession = _index2.$CheckoutSessionModel.instance(scope.token);
    var wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
    return checkoutSession.action('createPayment', {
      data: {
        payer_id: checkoutSession.get('payer.id'),
        intent: scope.models.checkoutCart.payment_action,
        wa_type: wpsParams && wpsParams.wa_type,
        correlation_id: _squid.$meta.correlationId,
        merchant_id: scope.models.payee.get('merchant.id'),
        custom: scope.models.checkoutCart.get('purchase.custom'),
        invoice: scope.models.checkoutCart.get('purchase.invoice')
      },
      success: function success(result) {
        _angular.$rootScope.paymentComplete = true;
        scope.onboard.payerId = checkoutSession.payer && checkoutSession.payer.id;
        scope.onboard.transaction = result.transactionDetails && result.transactionDetails.id;
        if (_squid.$config.enableShoppingCartWPS && scope.models.checkoutAppData.flags.is_shopping_cart_flow) {
          markCartCheckedout();
        }
        return finalRoute();
      },
      contingencies: {
        TRANSACTION_REFUSED: handlePaymentContingencies(ERROR_CODE.TRANSACTION_REFUSED),
        INSTRUMENT_DECLINED: function INSTRUMENT_DECLINED() {
          inventoryOperation('failed');
          _uiRouter.$state.go(ROUTE.XO_ADD_CARD_FLOW, {
            mode: scope.flags.mode
          });
        },
        PAYEE_BLOCKED_TRANSACTION: handlePaymentContingencies(ERROR_CODE.PAYMENT_DENIED),
        DUPLICATE_TRANSACTION: handlePaymentContingencies(ERROR_CODE.PAYMENT_ALREADY_DONE),
        // This error needs the same handling as card decline in add card API call
        CC_PROCESSOR_DECLINED: handleCardContingency,
        DEFAULT: handlePaymentContingencies(ERROR_CODE.DEFAULT)
      },
      error: function error(err) {
        _logger.$logger.info('createPayment Failed due to service error', err);
        inventoryOperation('failed');
        return _uiRouter.$state.go(ROUTE.GENERIC_ERROR, {
          code: ERROR_CODE.DEFAULT
        });
      }
    });
  };
  var checkInventoryAndPay = function checkInventoryAndPay() {
    return inventoryOperation().then(function (result) {
      if (result && result.soldoutpage) {
        return _uiRouter.$state.go(ROUTE.XO_SOLDOUT, {
          items: encodeURIComponent(result.items),
          soldOutUrl: encodeURIComponent(result.soldOutUrl)
        });
      }
      return makePayment();
    });
  };
  var authorize = function authorize() {
    var checkoutSession = _index2.$CheckoutSessionModel.instance(scope.token);
    var checkoutAppData = scope.models.checkoutAppData;
    var checkoutCart = scope.models.checkoutCart;
    var doEcOnApprove = checkoutAppData.doec_on_approve();
    return checkoutSession.action('authorize', {
      success: function success() {
        var billingFlow = {
          isSubscriptionsV1: checkoutCart.isSubscriptionsV1(),
          isWpsSubscription: checkoutAppData.is_wps_subscription_flow(),
          isWpsAutobilling: checkoutAppData.isWpsAutobillingFlow(),
          isWpsInstallmentPlan: checkoutAppData.is_wps_installmentplan_flow()
        };
        if ((billingFlow.isWpsSubscription || billingFlow.isSubscriptionsV1 || billingFlow.isWpsInstallmentPlan || billingFlow.isWpsAutobilling) && !scope.flags.isRestRpMigratedFlow) {
          return (0, _util.redirectToSubscriptionFinalRoute)(scope.flags.mode, billingFlow);
        } else if (doEcOnApprove) {
          return checkInventoryAndPay();
        }
        return finalRoute();
      }
    });
  };
  var setStickyFIAndAuthorize = function setStickyFIAndAuthorize() {
    var checkoutSession = _index2.$CheckoutSessionModel.instance(scope.token);
    return _angular.$q.when((0, _sticky.setStickyInstrument)(checkoutSession))["catch"](function (err) {
      _logger.$logger.info('setStickyFI_Failed', err);
    })["finally"](authorize);
  };

  // Check for Dynamic Currency Conversion (DCC)
  var isDCCEligible = function isDCCEligible(checkoutSession) {
    var isGuest = scope.flags.mode !== 'signup';
    var hasCurrencyConversion = checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable');

    // Decides dcc currency conversion popup show/hide
    return isGuest && hasCurrencyConversion;
  };
  var continueWith3DSOrAuthorize = function continueWith3DSOrAuthorize() {
    var checkoutSession = _index2.$CheckoutSessionModel.instance(scope.token);
    if (checkoutSession.resolve_3ds) {
      return show3DSLightbox(checkoutSession);
    }
    if (checkoutSession.get('threeDSResolutionData')) {
      return show3DS2_0_Lightbox(checkoutSession);
    }
    _logger.$logger.info('Initiate_setStickyFI_call_and_authorize_call');
    return setStickyFIAndAuthorize();
  };
  var callOnShippingChangeAndContinue = function callOnShippingChangeAndContinue() {
    // We don't have a shipping address... just continue
    if (!scope.flags.allowEditShipping) {
      return _angular.$q.when().then(continueWith3DSOrAuthorize);
    }
    return scope.shippingChangeFeature.handleOnShippingChange().then(continueWith3DSOrAuthorize);
  };
  var postCheckoutSessionOperations = function postCheckoutSessionOperations(dccComplete) {
    var checkoutSession = _index2.$CheckoutSessionModel.instance(scope.token);

    /**
     * 1. Transaction is eligible for DCC - guest flow, plan has PayPal conversion,
     *    and conversion is changeable
     * 2. Function wasn't called by post plan interstitial form submission
     * 3. DCC has not been successfully called (scope.onboard.cart.currencyConvData will be `undefined`)
     *      - Beacuse it hasn't been called yet or because the prePlan API was called but it
     *        returned an error. In that case we want to try again with the postPlan API instead
     *        of forcing the user to abandon their cart.
     */
    if (isDCCEligible(checkoutSession) && !dccComplete && !scope.onboard.card.currencyConvData) {
      _logger.$logger.info('render_currency_conversion_lightbox');
      if (scope.flags.wpsInterstitialEligible) {
        _logger.$logger.info('wps_interstitial_render_dcc');
      }
      scope.launchCurrencyConversionLightbox = true;
      return;
    }
    var hasCallbackAPI = window.xprops && window.xprops.onShippingChange;
    if (scope.shippingOptionsFeature.hasShippingOptions() && !hasCallbackAPI) {
      scope.shippingChangeFeature.interstitialResolver = continueWith3DSOrAuthorize;
      scope.shippingChangeFeature.handleOnShippingChange = function () {
        return scope.shippingChangeFeature.showOrResolveInterstitial();
      };
      return scope.shippingChangeFeature.showOrResolveInterstitial(true);
    }
    return callOnShippingChangeAndContinue();
  };
  var routeToHermesOn3DSDeclineForSignUp = function routeToHermesOn3DSDeclineForSignUp() {
    // dispatch to hermesnodeweb up on 3DS authenticate decline.
    _logger.$logger.info('xoon_to_hermes_redirect_on_signup_3DS_Authentication_decline');
    (0, _squid.$dispatch)('hermes', {
      redirectToHermesOn3DSDecline: 'xoon',
      token: scope.token,
      'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
      'country.x': _squid.$locale.country
    });
  };
  var loadLatestCheckoutSessionForThreeds = function loadLatestCheckoutSessionForThreeds() {
    var latestCheckoutSession = _index2.$CheckoutSessionModel.instance(scope.token);
    // Recheck whether the 3DS V1/V2 contingencies are actually cleared or not from
    // latest checkout session.

    if (latestCheckoutSession.get('threeDSResolutionData')) {
      var threeDSResolutionData = latestCheckoutSession.get('threeDSResolutionData') || {};
      var _ref2 = threeDSResolutionData.resolutions || [],
        resolutions = _ref2[0];
      var _ref3 = resolutions || {},
        _ref3$funding_instrum = _ref3.funding_instrument_details,
        _ref3$funding_instrum2 = _ref3$funding_instrum === void 0 ? {} : _ref3$funding_instrum,
        _ref3$funding_instrum3 = _ref3$funding_instrum2.payment_card,
        payment_card = _ref3$funding_instrum3 === void 0 ? {} : _ref3$funding_instrum3;
      return {
        number: payment_card.number,
        type: payment_card.type,
        threedsPresent: true
      };
    } else if (latestCheckoutSession.resolve_3ds) {
      var resolveThreeds = latestCheckoutSession.resolve_3ds || {};
      return {
        number: resolveThreeds.number,
        type: resolveThreeds.type,
        threedsPresent: true
      };
    }
  };

  /**
   * call patchXO API to clear the 3DS contingency and then call authorize API.
   */
  var clear3DSContingency = function clear3DSContingency(onCompleteData) {
    var dataObj;
    var checkoutSession = _index2.$CheckoutSessionModel.instance(scope.token);
    if (checkoutSession.get('threeDSResolutionData')) {
      var threeDSResolutionData = checkoutSession.get('threeDSResolutionData') || {};
      var _ref4 = threeDSResolutionData.resolutions || [],
        resolutions = _ref4[0];
      var _ref5 = resolutions || {},
        _ref5$funding_instrum = _ref5.funding_instrument_details,
        _ref5$funding_instrum2 = _ref5$funding_instrum === void 0 ? {} : _ref5$funding_instrum,
        _ref5$funding_instrum3 = _ref5$funding_instrum2.payment_card,
        payment_card = _ref5$funding_instrum3 === void 0 ? {} : _ref5$funding_instrum3,
        _ref5$funding_instrum4 = _ref5$funding_instrum2.three_ds_contingency_context,
        three_ds_contingency_context = _ref5$funding_instrum4 === void 0 ? {} : _ref5$funding_instrum4;
      dataObj = {
        referenceId: three_ds_contingency_context.reference_id,
        ccId: payment_card.id,
        authId: onCompleteData.threeDSTransactionId
      };
    } else if (checkoutSession.resolve_3ds) {
      dataObj = {
        ccId: checkoutSession.resolve_3ds.ccId
      };
    }
    return checkoutSession.action('clear3DSContingency', {
      data: dataObj,
      success: function success() {
        // if loadLatestCheckoutSessionForThreeds returns undefined, that means its non 3ds flows
        // then defaulting type, number to undefined and threedsPresent to false
        var _ref6 = loadLatestCheckoutSessionForThreeds() || {},
          _ref6$type = _ref6.type,
          type = _ref6$type === void 0 ? undefined : _ref6$type,
          _ref6$number = _ref6.number,
          number = _ref6$number === void 0 ? undefined : _ref6$number,
          _ref6$threedsPresent = _ref6.threedsPresent,
          threedsPresent = _ref6$threedsPresent === void 0 ? false : _ref6$threedsPresent;

        // don't call authorize if the contingency is not cleared
        if (!threedsPresent) {
          _logger.$logger.info('Initiate_setStickyFI_call_and_authorize_call_after_resolve_3ds');
          return setStickyFIAndAuthorize();
        } else if (scope.flags.returnFromANW) {
          _uiRouter.$state.go(ROUTE.XO_GUEST, {
            error: 'threeDS.guestDeclineAfter3DSAccept',
            type: 'warning',
            cType: type,
            cNumber: number
          });
        } else {
          var msgs = errorHandlerHelper.get3dsPageWarning({
            type: type,
            number: number
          }, 'threeDS.guestDeclineAfter3DSAccept');
          scope.errorMessage = {
            msgs: msgs,
            type: 'warning'
          };
        }
      },
      contingencies: {
        // contingency may be "no cc" or any thing from clear3DSContingency(patch on xosession)
        // for "no cc" symphony throws NEED_CREDIT_CARD or NEED_CREDIT_CARD_OR_BANK_ACCOUNT
        DEFAULT: function DEFAULT(name, contingency) {
          var _ref7 = loadLatestCheckoutSessionForThreeds() || {},
            _ref7$type = _ref7.type,
            type = _ref7$type === void 0 ? undefined : _ref7$type,
            _ref7$number = _ref7.number,
            number = _ref7$number === void 0 ? undefined : _ref7$number;
          _logger.$logger.info('clear3DSContingency_contingency', {
            int_error_description: contingency && contingency.message,
            contingency_name: name
          });
          if (scope.flags.mode === 'signup') {
            // route to member review page upon patch xo throws contingency for signup
            routeToHermesOn3DSDeclineForSignUp();
          } else if (scope.flags.returnFromANW) {
            _uiRouter.$state.go(ROUTE.XO_GUEST, {
              error: 'threeDS.guestDeclineAfter3DSAccept',
              type: 'warning',
              cType: type,
              cNumber: number
            });
          } else {
            var msgs = errorHandlerHelper.get3dsPageWarning({
              type: type,
              number: number
            }, 'threeDS.guestDeclineAfter3DSAccept');
            scope.errorMessage = {
              msgs: msgs,
              type: 'warning'
            };
          }
        }
      }
    });
  };

  // onThreedsCompleteAddFi - onComplete callback for add fi/Signup route
  // status - SUCCESS/DECLINE/CLOSE
  // onCompleteData - is not used currently in addFI/Signup route
  var onThreedsCompleteAddFi = function onThreedsCompleteAddFi(status, onCompleteData) {
    scope.showThreedsPopup = false;
    // Any error or 3ds window closed case, redirect user to hermes
    if (THREEDS_FAILURE_CODE.indexOf(status) !== -1 || status === 'CLOSE') {
      routeToHermesOn3DSDeclineForSignUp();
    } else if (status === 'SUCCESS') {
      createXO(true);
    }
  };

  // onThreedsCompleteTransaction - onComplete callback for transaction/guest route
  // status - SUCCESS/DECLINE/CLOSE
  // onCompleteData is an object which contains status,
  // auth ID (which is need to pass in during clear 3ds contingency)
  var onThreedsCompleteTransaction = function onThreedsCompleteTransaction(status, onCompleteData) {
    scope.showThreedsPopup = false;
    var _ref8 = loadLatestCheckoutSessionForThreeds() || {},
      _ref8$type = _ref8.type,
      type = _ref8$type === void 0 ? undefined : _ref8$type,
      _ref8$number = _ref8.number,
      number = _ref8$number === void 0 ? undefined : _ref8$number;

    // might need to change the status values. may be DECLINE/SUCCESS/CLOSE
    // We do not handle status === CLOSE case explicitly, we just show guest page
    if (THREEDS_FAILURE_CODE.indexOf(status) !== -1) {
      // guest case
      scope.errorMessage = {
        msgs: errorHandlerHelper.get3dsPageWarning({
          type: type,
          number: number
        }, 'threeDS.guestDecline'),
        type: 'warning'
      };
    } else if (status === 'SUCCESS') {
      clear3DSContingency(onCompleteData);
    }
  };
  var onComplete3DSHandler = function onComplete3DSHandler(status) {
    scope.launch3DSResolver = false;
    var checkoutSession = _index2.$CheckoutSessionModel.instance(scope.token);
    if (status === 'decline') {
      // Flow should route to member review page for sign up case
      // up on receiving "decline" response from 3DS authenticate call
      if (scope.flags.mode === 'signup') {
        routeToHermesOn3DSDeclineForSignUp();
      } else if (scope.flags.returnFromANW) {
        // guest case
        _uiRouter.$state.go(ROUTE.XO_GUEST, {
          error: 'threeDS.guestDecline',
          type: 'warning',
          cType: checkoutSession.resolve_3ds.type,
          cNumber: checkoutSession.resolve_3ds.number
        });
      } else {
        var msgs = errorHandlerHelper.get3dsPageWarning(checkoutSession.resolve_3ds, 'threeDS.guestDecline');
        scope.errorMessage = {
          msgs: msgs,
          type: 'warning'
        };
      }
    } else if (status === 'close') {
      // Closing the 3DS page should route the flow to member review for sign up case
      // because the member account is created already.
      // Guest remains in the Billing page, no re-direction.
      if (scope.flags.mode === 'signup') {
        routeToHermesOn3DSDeclineForSignUp();
      }
    } else if (status === 'success') {
      // Up on Successful authenticate, perform Patch on XO session and authorise.
      clear3DSContingency();
    }
  };
  var createXO = function createXO(threedsStatus) {
    if (threedsStatus === void 0) {
      threedsStatus = false;
    }
    var checkoutSession = _index2.$CheckoutSessionModel.instance(scope.token);
    var checkoutSessionData = {
      baToken: scope.models.checkoutCart.get('billing.ba_token'),
      cc_login_account_number: scope.onboard.cc_login_account_number,
      email_login_account_number: scope.onboard.email_login_account_number,
      fraudnet_id: scope.models.checkoutCart.get('supplementary.risk_correlation_id')
    };

    // This is the id of the card that the user entered into the billing form.
    // This is used to ensure that the card that the user entered is used for payment.
    if (scope.onboard.fundingId) {
      _logger.$logger.info('adding_fundingId_to_create_session_payload');
      var paymentCard = {
        id: scope.onboard.fundingId
      };
      checkoutSessionData.funding_instruments = [{
        payment_card: paymentCard
      }];
    }

    // These parameter needs to send only for addcard 3DS 2.0 flows during planning
    // indicating that 3DS 2.0 contingency is already resolved.
    // So that symphony informs risk not to throw 3DS contingency.
    // This flags makes more sense for strict bins.
    if (threedsStatus) {
      _logger.$logger.info('populating_flags_for_risk');
      checkoutSessionData.preselected_fi = scope.onboard.fundingId;
      checkoutSessionData.threeds_resolved = true;
    }

    // Add shipping address if edit shipping is allowed. scope.flags.allowEditShipping flag used
    // to show "ship to Billing" checkbox
    if (scope.flags.allowEditShipping) {
      var shippingAddress = scope.onboard.shipping_address;
      shippingAddress.recipient_name = shippingAddress.first_name + ' ' + shippingAddress.last_name;
      checkoutSessionData.shipping_address = scope.onboard.shipping_address.serialize();
    }
    return checkoutSession.action('create', {
      data: checkoutSessionData,
      success: function success() {
        return _angular.$q.when().then(function () {
          if (scope.flags.buyerFxTreatment) {
            /**
             * Here we will log the following events to FPTI
             * Event 3 - During signup when the the pre-plan API failed and
             *      the card allows for the conversion seleciton to be changed
             * Event 7 - All cases expect for guest checkout when the pre-plan
             *      API fails and the card allows for conversion selection. We
             *      don't log event 7 here in that case because those users will
             *      see the post-plan interstitial which will log event 7 upon submission
             */
            (0, _utils.logBuyerFxFpti)({
              card: scope.onboard.card,
              hasPrePlanData: scope.flags.hasBuyerFxPrePlanData,
              isSignup: scope.flags.mode === 'signup',
              purchase: scope.models.checkoutCart.purchase
            });
          }

          /**
           * If checkoutSession has DCC enabled, then we do the 'updateConversion' call and upate to 'VENDOR' if:
           * 1. Pre-Plan (Buyer FX): if 'VENDOR' was selected as the option from the inline radio buttons.
           * 2. The user is going through the forced signup flow we need currency conversion and they didn't see the Buyer FX
           *    experience or the API for that experience failed. For signup we don't show the post-plan
           *    DCC interstitial since we want to minimize the number of fields the user has to fill
           *    out. Therefore we forgo the chance at earning the conversion fee and forece 'VENDOR'.
           */
          var conversionPayPalAndChangeable = checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable');
          var isSignupWithNoConversion = scope.flags.mode === 'signup' && !scope.onboard.card.currencyConvData;
          var conversionIsVendor = scope.onboard.card.ppconversion === 'VENDOR';
          if (conversionPayPalAndChangeable && (isSignupWithNoConversion || conversionIsVendor)) {
            return _index2.$FundingOptionsModel.instance(scope.token).action('updateConversion', {
              data: {
                conversionType: 'VENDOR',
                planId: checkoutSession.plan.id
              },
              resultModel: checkoutSession
            })["catch"](function (err) {
              return err;
            });
          }
        }).then(function () {
          // Performing a check if the card and CVV exists to determine whether or not we do a patchCVV
          return patchCvv(checkoutSession).then(function () {
            return postCheckoutSessionOperations(false);
          }, function (err) {
            _logger.$logger.error('patchCvv error', err);
          });
        });
      },
      contingencies: {
        VERIFY_USER_IDENTITY: function VERIFY_USER_IDENTITY(message, data) {
          _logger.$logger.info('create_checkout_session_contingency', {
            contingency: 'VERIFY_USER_IDENTITY'
          });
          // For step up contingency, we need to redirect user to ANW (AuthNodeWeb).
          // Before redirecting to ANW, we need to store some onboarding data in mayfly
          // and patch CVV in mayfly-nodisk.

          var mayflyData = JSON.stringify({
            user_email: scope.onboard.user.email,
            cc_login_account_number: scope.onboard.cc_login_account_number,
            email_login_account_number: scope.onboard.email_login_account_number,
            cardType: scope.onboard.card.type,
            cardCurrencyConvData: scope.onboard.card.currencyConvData,
            ppconversion: scope.onboard.card.ppconversion,
            fimode: scope.onboard.fiMode,
            billingCountry: scope.onboard.billing_address.country
          });
          var mayflyModel = _mayfly.$MayflyModel.instance(scope.token);
          mayflyModel.action('save', {
            data: {
              mData: mayflyData
            },
            contingencies: {
              DEFAULT: showGenericError(ERROR_CODE.TRANSACTION_REFUSED)
            },
            success: function success(response) {
              _logger.$logger.info('mayfly_save', {
                status: response.success
              });
              if (response.success) {
                var mustPatchCvv = true;
                patchCvv(checkoutSession, mustPatchCvv).then(function () {
                  return handleStepUpAuth(data.step_up_context);
                })["catch"](function (err) {
                  _logger.$logger.error('guest_authflow_patchCvv_error', err);
                  // As PAPS has already returned VERIFY_USER_IDENTITY for createCheckoutSession call
                  // so for all subsequent calls to PAPS we will get VERIFY_USER_IDENTITY contingency
                  // until this contingency is resolved.
                  // So we need to bypass it for guest authflow use case.
                  if (err.message === 'VERIFY_USER_IDENTITY') {
                    return handleStepUpAuth(data.step_up_context);
                  } else {
                    _logger.$logger.info('guest_authflow_generic_error_redirect');
                    return showGenericError(ERROR_CODE.TRANSACTION_REFUSED);
                  }
                });
              } else {
                return showGenericError(ERROR_CODE.TRANSACTION_REFUSED);
              }
            }
          });
        },
        TRANSACTION_REFUSED: showGenericError(ERROR_CODE.TRANSACTION_REFUSED),
        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS() {
          return scope.onboard.shipping_address.save({
            data: scope.onboard.shipping_address.serialize(),
            validation: function validation(message, errorData) {
              var errorMsgs = errorHandlerHelper.errorHandler(message, errorData, scope.actions.positionToErrorField);
              if (errorMsgs && errorMsgs.length > 0) {
                scope.errorMessage = {
                  msgs: errorMsgs,
                  type: 'error'
                };
              }
            }
          });
        },
        NEED_CREDIT_CARD_OR_BANK_ACCOUNT: function NEED_CREDIT_CARD_OR_BANK_ACCOUNT() {
          return handleCardContingency();
        },
        NEED_CREDIT_CARD: function NEED_CREDIT_CARD() {
          return handleCardContingency();
        },
        SENDING_LIMIT_EXCEEDED: function SENDING_LIMIT_EXCEEDED() {
          /* 1. Introducing config attribute sendingLimitNoFallback for certain countries right now
           only Japan, to go to generic error page in case of sending limit exceeded. this config
           will be removed once all countries have proper content available.
           2. Currently only guest mode will go to generic error page as signup mode need to handle
           SENDING_LIMIT_EXCEEDED AND TRANSACTION_LIMIT_EXCEEDED separately but we are not getting expected
           contingency from Symphony yet. Will remove scope.flags.mode === 'guest' condition once we are getting
           expected contingency back.
           */
          if ((0, _squid.$feature)('sendingLimitNoFallback') && scope.flags.mode === 'guest') {
            _uiRouter.$state.go(ROUTE.GENERIC_ERROR, {
              code: ERROR_CODE.TRANSACTION_LIMIT_EXCEEDED
            });
          } else {
            throw new _squid.$FallbackError({
              reason: 'sending_limit_exceeded',
              product: 'ux'
            });
          }
        },
        NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD() {
          // Contingency purpose - Show OTP confirmation popup
          // As we have already presented user with OTP popup with
          // init call after add card (flag - launchUpopScreen),
          // we need to redirect user to hermes at this point
          (0, _squid.$dispatch)('hermes', {
            token: scope.token,
            'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country,
            'country.x': _squid.$locale.country
          });
        },
        TRAVEL_RULE_ID_REQUIRED: function TRAVEL_RULE_ID_REQUIRED() {
          _logger.$logger.info('invoice_travel_rule_id_required');
          scope.launchTravelRuleLightbox = true;
        }
      }
    });
  };
  var onTravelRuleSuccess = function onTravelRuleSuccess() {
    // Close travel rule lightbox if it is open
    scope.launchTravelRuleLightbox = false;
    return createXO();
  };
  var onCompleteDCC = function onCompleteDCC() {
    scope.launchCurrencyConversionLightbox = false;
    return postCheckoutSessionOperations(true);
  };

  /*
     Function to fetch OTP challenges based on the customer eligibilty criteria,
     After fetching OTP, if storeInMayfly is not send in data then by default API would
     save OTP Document in Mayfly.
  */
  var retrieveAndStoreOTPChallenges = function retrieveAndStoreOTPChallenges() {
    _logger.$logger.info('Fetching_OTP_Challenges');
    return _angular.$q.when().then(function () {
      var otpData = {
        user: {
          email: scope.onboard.user.email
        },
        client: {
          response_type: 'challenge'
        }
      };
      var auth = _index5.$AuthModel.instance();
      return auth.action('otpChallenge', {
        data: otpData,
        success: function success(response) {
          _logger.$logger.info('otp_login_sts_fetch_challenge_success');
          return response;
        },
        contingencies: {
          DEFAULT: function DEFAULT(name) {
            _logger.$logger.info('otp_challenge_contingency', {
              'contingency_name': name
            });
            return _angular.$q.reject('UHANDLED_CONTINGENCY');
          }
        }
      })["catch"](function (err) {
        return _angular.$q.reject(err);
      });
    });
  };

  /* function to check if customer is eligible for WPS Upsell page - eligiblity criteria is as follows -
     1. Should be a WPS Transaction.
     2. should be WPS Interstitial Eligible.
     3. Customer entered email must linked to a full member account. (Existing Member Account).
     4. Merchant should not be blacklisted.
     5. Customer should be in treatment.
   */
  var isUlLandingEligible = function isUlLandingEligible() {
    if (!scope.flags.wpsFlow || !scope.flags.wpsInterstitialEligible || !scope.onboard.isEmailLinkedToFullAccount) {
      _logger.$logger.info('wps_otp_upsell_elmo_ineligible');
      return _angular.$q.reject(false);
    }
    _logger.$logger.info('wps_otp_upsell_merchant_eligible');
    return (0, _squid.$elmo)('xo_xoon_wps_upsell', {
      'ctx.COUNTRY': _squid.$locale.country
    }, '(xo_xoon_wps_upsell_treatment_)(.*)').then(function (trmt) {
      if (trmt && trmt.treatment_name) {
        // WPS Upsell treatment, v1, v2, v3
        var treatment_name = trmt.treatment_name;
        scope.ulMeta['trmt'] = treatment_name;
        _logger.$logger.info('wps_otp_upsell_treatment');
        return _angular.$q.resolve(true);
      } else {
        // WPS Upsell Control
        _logger.$logger.info('wps_otp_upsell_control');
        return _angular.$q.reject(false);
      }
    })["catch"](function (err) {
      // May be some elmo call failure, Treat this as control.
      _logger.$logger.info('ul_landing_elmo_failure', err);
      return _angular.$q.reject(false);
    });
  };

  /*
  Function to Check if customer is eligible for OTP upsell.
  1. Experiment eligiblity.
  2. Fetch OTP Document.
  3. Check if OTP document has SMS Challenge Type.
  */
  var checkCustomerEligibleForOtpUpsell = function checkCustomerEligibleForOtpUpsell() {
    return _angular.$q.when().then(function () {
      return isUlLandingEligible().then(function (eligible) {
        if (eligible) {
          return retrieveAndStoreOTPChallenges().then(function (result) {
            _logger.$logger.info('otp_login_success');
            var isSMSChallengePresent = result.isSMSChallengePresent,
              mKey = result.mKey;
            if (isSMSChallengePresent && mKey) {
              _logger.$logger.info('wps_otp_upsell_eligible');
              _logger.$logger.info('checkout_fpti', {
                otp_elg: 'SMS_CHALLENGE_AVAILABLE'
              });
              scope.ulMeta['mkey'] = mKey;
              return _angular.$q.resolve(true);
            } else if (isSMSChallengePresent && !mKey) {
              // Customer has OTP phone number, but the data could not be stored in Mayfly
              // so customer is not eligible for OTP Upsell Page.
              _logger.$logger.info('wps_otp_upsell_ineligible_no_mayfly');
              return _angular.$q.resolve(false);
            } else {
              // Customer does not have any SMS OTP challege available.
              _logger.$logger.info('wps_otp_upsell_ineligible');
              _logger.$logger.info('checkout_fpti', {
                otp_elg: 'NO_SMS_CHALLENGE'
              });
              return _angular.$q.resolve(false);
            }
          })["catch"](function (err) {
            _logger.$logger.info('otp_login_failure', err);
            return _angular.$q.resolve(false);
          });
        }
        return _angular.$q.resolve(false);
      })["catch"](function () {
        return _angular.$q.resolve(false);
      });
    });
  };
  var onCompleteULIframeHandler = function onCompleteULIframeHandler(status) {
    _logger.$logger.info('checkout_fpti', {
      from: 'otp_challenge',
      to: 'otp_challenge_complete',
      user_action: status
    });
    scope.flags.launchUlIframe = false;

    // Logging out the user only for OTP Flow and only when RT cookie is dropped, before going to Checkout.Done state.
    // Why are we logging out?
    // ACCESS_TOKEN (AT) and REFRESH_TOKEN (RT a.k.a One Touch Cookie) cookie dropped during Existing Member OTP Flow,
    // due to which user is not authenticated in subsequent transaction in hermes review page, So by logging out the
    // user, removes all the cookies except RT from the browser in which hermes does RT to AT exchange in the absence
    // of AT and gets the limited AccessToken.
    // How we know if UL dropped RT Cookie or not? - UL sends `LOGIN_SUCCESS` status in postmessage when RT cookie is dropped.
    if (status === 'LOGIN_SUCCESS') {
      _logger.$logger.info('LOGGING_OUT_WPS_UPSELL_OTP_FLOW_FOR_CLEARING_COOKIES');
      var auth = _index5.$AuthModel.instance();
      return auth.action('logout').then(function () {
        return _uiRouter.$state.go(ROUTE.XO_DONE);
      });
    } else {
      return _uiRouter.$state.go(ROUTE.XO_DONE);
    }
  };
  return {
    showGenericError: showGenericError,
    handleCardContingencySignup: handleCardContingencySignup,
    postCheckoutSessionOperations: postCheckoutSessionOperations,
    onComplete3DSHandler: onComplete3DSHandler,
    onTravelRuleSuccess: onTravelRuleSuccess,
    onCompleteDCC: onCompleteDCC,
    createXO: createXO,
    onThreedsCompleteAddFi: onThreedsCompleteAddFi,
    onThreedsCompleteTransaction: onThreedsCompleteTransaction,
    checkCustomerEligibleForOtpUpsell: checkCustomerEligibleForOtpUpsell,
    checkPaymentExperienceTreatment: checkPaymentExperienceTreatment,
    onCompleteULIframeHandler: onCompleteULIframeHandler
  };
}
angular.value("ERROR_CODE", ERROR_CODE);
angular.value("ROUTE", ROUTE);
angular.value("$GuestFactory", $GuestFactory);
_uiRouter.$state;
_angular.$q;
_angular.$rootScope;
_angular.$window;
_squid.$config;
_squid.$locale;
_squid.$util;
_squid.$FallbackError;
_squid.$feature;
_squid.$meta;
_squid.$dispatch;
_squid.$elmo;
_logger.$logger;
_index2.$CheckoutSessionModel;
_index2.$FundingOptionsModel;
_index3.$ShoppingCartModel;
_index4.$InventoryModel;
_fiApis.$fiApis;
_mayfly.$MayflyModel;
_util.redirectToSubscriptionFinalRoute;
_utils.logBuyerFxFpti;
_sticky.setStickyInstrument;
_util2.get3DSDataForSwitch;
_constants.availablePaymentExp;
_constants.channelType;
_index5.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.redirectToSubscriptionFinalRoute = exports.hasDialingCodeOverride = exports.hasAddressChanged = exports.decodeEntities = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var isString = function isString(value) {
  return typeof value === 'string';
}; // eslint-disable-line angular/typecheck-string

var areAddressFieldsEqual = function areAddressFieldsEqual(address1Field, address2Field) {
  if (address1Field === address2Field) {
    return true;
  }
  var fields = [address1Field, address2Field];
  if (fields.includes(undefined) && fields.includes('')) {
    return true;
  }
  if (isString(address1Field) && isString(address2Field)) {
    return address1Field.toUpperCase() === address2Field.toUpperCase();
  }
  return false;
};
var hasAddressChanged = exports.hasAddressChanged = function hasAddressChanged(address1, address2) {
  var addressFields = ['line1', 'line2', 'city', 'state', 'postal_code', 'country_code'];
  return addressFields.some(function (field) {
    return !areAddressFieldsEqual(address1[field], address2[field === 'country_code' ? 'country' : field]);
  });
};
var decodeEntities = exports.decodeEntities = function decodeEntities(input) {
  // A constant key that can be used to find the element
  var ENTITY_ELEM = '__xpc_entitydecoder__';

  // Create the element if this is the first time this is called
  if (!window[ENTITY_ELEM]) {
    window[ENTITY_ELEM] = document.createElement('p');
  }
  var converter = window[ENTITY_ELEM];
  converter.innerHTML = input;
  return converter.innerText || converter.text || converter.textContent;
};
var redirectToSubscriptionFinalRoute = exports.redirectToSubscriptionFinalRoute = function redirectToSubscriptionFinalRoute(mode, billingFlow) {
  if (mode === void 0) {
    mode = 'guest';
  }
  var protocol = _angular.$window.location.protocol + '//';
  var stageUrl = _squid.$meta.stage || _angular.$window.location.hostname;
  var wpsReturnUri;
  if (billingFlow.isWpsSubscription) {
    wpsReturnUri = _squid.$config.urls.wpsSubscriptionReturnUrl;
  } else if (billingFlow.isSubscriptionsV1) {
    wpsReturnUri = _squid.$config.urls.subscriptionsV1ReturnUrl;
  } else if (billingFlow.isWpsInstallmentPlan) {
    wpsReturnUri = _squid.$config.urls.wpsInstallmentPlanReturnUrl;
  } else if (billingFlow.isWpsAutobilling) {
    wpsReturnUri = _squid.$config.urls.wpsAutobillingReturnUrl;
  }
  var params = {
    token: _squid.$meta.token,
    sdkMeta: _squid.$meta.sdkMeta,
    mode: mode,
    // Read mfid from params in case buyer landed with 302 URL redirection,
    // and meta for internal redirects.
    mfid: _squid.$util.param('mfid') || _squid.$meta.mfid,
    'country.x': _squid.$locale.country,
    'locale.x': _squid.$locale.lang + "_" + _squid.$locale.country
  };
  var redirectUrl = _squid.$util.buildURL(protocol + stageUrl + wpsReturnUri, params);
  _squid.$util.redirect(redirectUrl);
};

/**
 * Certain regions (ie: Macau) live within territories
 * but have their own dialing codes. We need to shift the UX
 * to have the phone number after the province selection
 * https://engineering.paypalcorp.com/jira/browse/PPPLMER-48433
 */
var hasDialingCodeOverride = exports.hasDialingCodeOverride = function hasDialingCodeOverride() {
  var overrides = _squid.$locale.metadata.regionalOverrides;
  if (!overrides) {
    return false;
  }
  return Object.keys(overrides).map(function (key) {
    return overrides[key].props;
  }).some(function (override) {
    return override.hasOwnProperty('internationalDialingCode');
  });
};
_angular.$window;
_squid.$meta;
_squid.$util;
_squid.$locale;
_squid.$config;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/login-button/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/login-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template, opinionlab) {
  squid.module('xo-login-button.directive', ['squid']).directive('xoLoginButton', [function () {
    return {
      template: template,
      scope: {
        redirect: '=?'
      },
      controller: ['$scope', function ($scope) {}]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addCard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addCard/template.html"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js"), __webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/passwordInput/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/countryList/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/sepa/directive.js"),
// TODO: Check if its used
__webpack_require__("../node_modules/xo-guest-components/src/guest/select-shipping-method/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/xoonHeader/directive.js"), __webpack_require__("../node_modules/xo-models/src/onboard/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/login-button/directive.js"), __webpack_require__("../node_modules/xo-locale/dist/index.js"), __webpack_require__("../node_modules/xo-locale/dist/helper.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js"), __webpack_require__("../node_modules/xo-ui-components/src/ui-utils/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/ba-message-banner/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template, util) {
  return angular.module('xo-multistep-signup-add-card.directive', ['squid', 'xo-value-props.directive', 'xo-phone.phoneInput', 'xo-name-input.directive', 'xo-guest.emailInput', 'xo-guest.passwordInput', 'xo-guest.countryList', 'xo-onboard.sepa.directive',
  // TODO: Check if its used
  'xo-guest-select-shipping-method.directive', 'xo-xoon-header.directive', 'xomodel.onboard', 'xo-login-button.directive', 'locale.helper', 'xomodel.address', 'xomodel.checkout', 'xo-ui-utils.directive', 'xo-accessibility.directive', 'xo-ba-message-banner.directive']).directive('formErrorDetect', [function () {
    return function ($scope, el, attrs) {
      $scope.$watch(attrs.name + '.$error', function (newVal, oldVal) {
        var cardModel = $scope.multistepSignupModel.onboard.card;

        /*
        * Here we are making sure that both luhn and len validation
        * together marks the cardModel validity which in-tern handles
        * form submit and validity in front-end
        * Background:
        * card input element has luhn and len validation as part of
        * ui-validate util
        */
        if (newVal.luhn && newVal.luhn[0].$invalid || newVal.len && newVal.len[0].$invalid) {
          cardModel.valid = false;
        } else {
          cardModel.valid = true;
        }
      }, true);
    };
  }]).directive('xoMultistepSignupAddCard', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        parentCallbacks: '=?',
        multistepSignupModel: '=?',
        positionToErrorField: '=?',
        backState: '=?',
        backendError: '=?',
        clearBackendError: '=?',
        normalizeAddress: '=?',
        prefillAddressCommon: '=?',
        buttonParams: '=?'
      },
      link: function link($scope) {
        $scope.$watch(function () {
          return $scope.multistepSignupModel.onboard.card.number;
        }, function cardNumberChangeHandler(newValue, oldValue) {
          // Sanitize the values
          newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;
          oldValue = oldValue ? oldValue.replace(/ /g, '').toLowerCase() : null;
          if (newValue) {
            if (newValue !== oldValue) {
              if ($scope.multistepSignupModel.selectedInstallmentData && !$scope.multistepSignupModel.selectedInstallmentData.preventChange) {
                // Resetting selected installment data, if installment change is not explicitly prohibited.
                $scope.multistepSignupModel.selectedInstallmentData = undefined;
              }
            }
          }
        });
        $scope.$watch(function () {
          return $scope.multistepSignupModel.onboard.card.type;
        }, function cardTypeChangeHandler(newValue, oldValue) {
          // Sanitize the values
          newValue = newValue ? newValue.replace(/ /g, '').toLowerCase() : null;
          var eligibilityModel = $scope.multistepSignupModel.eligibilityModel;
          var cardNetwork;
          if (newValue && eligibilityModel && eligibilityModel.installments && eligibilityModel.installments.length > 0) {
            eligibilityModel.installments.some(function cardCheck(card, index, array) {
              if (card.cardInfo && card.cardInfo.card_type && card.cardInfo.card_type.toLowerCase() === newValue) {
                // Card Network Found
                cardNetwork = card;
                return true;
              }
              return false;
            });
            if (cardNetwork && cardNetwork.installment_options && cardNetwork.installment_options.length > 0) {
              // Card network && installments found
              if (cardNetwork.installment_options.length === 1) {
                $scope.multistepSignupModel.selectedInstallmentData = {
                  installment_option_selected: cardNetwork.installment_options[0],
                  preventChange: true
                };
              }
              $scope.multistepSignupModel.allowInstallments = true;
            } else {
              // Card network does not exists Or No installment found
              $scope.multistepSignupModel.allowInstallments = false;
            }
          } else {
            $scope.multistepSignupModel.allowInstallments = false;
          }
        });
        $scope.$on('$destroy', function () {
          $scope.clearBackendError('multistepsignupaddcard');
        });
        if ($scope.backendError) {
          $scope.backendError('multistepsignupaddcard');
        }
      },
      controller: ['$scope', '$rootScope', '$populate', '$state', '$util', '$locale', '$feature', '$q', '$CheckoutAppDataModel', '$ShippingRuleSummaryModel', '$CheckoutPayeeModel', '$CheckoutCartModel', '$BillingAddressModel', '$ShippingAddressModel', '$PrefillAddressModel', '$pxpFactors', '$config', '$dispatch', '$localeHelper', '$location', '$meta', function ($scope, $rootScope, $populate, $state, $util, $locale, $feature, $q, $CheckoutAppDataModel, $ShippingRuleSummaryModel, $CheckoutPayeeModel, $CheckoutCartModel, $BillingAddressModel, $ShippingAddressModel, $PrefillAddressModel, $pxpFactors, $config, $dispatch, $localeHelper, $location, $meta) {
        $scope.locale = $locale;
        $scope.formattedValues = {};
        $scope.mode = 'signup';
        $scope.fiMode = 'card';
        $scope.backUri = 'checkout.multistepsignup.multistepsignupaddcard';
        $scope.normalize = $feature('addressNormalization', false, $locale.country);
        $scope.componentsFlag = util.componentsMap($locale.country);
        $scope.$on('localeChange', function () {
          $scope.componentsFlag = util.componentsMap($locale.country);
          $scope.multistepSignupModel.onboard.billing_address.country = $locale.country;
          $scope.multistepSignupModel.onboard.shipping_address.country = $locale.country;
        });
        $scope.zipMasking = function (newValue) {
          if (newValue === void 0) {
            newValue = '';
          }
          $scope.formattedValues.postalCode = $locale.country === 'RU' ? newValue : util.maskingUtil.maskZip(newValue);
          $scope.multistepSignupModel.onboard.billing_address.postal_code = $scope.formattedValues.postalCode && $scope.formattedValues.postalCode.replace(/[^0-9]/gi, '');
        };
        function checkShippingRulesExist() {
          if ($scope.multistepSignupModel.wps_flow && $scope.multistepSignupModel.snt_supported_flow) {
            return $populate($scope, {
              shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
                params: {
                  merchant_id: $scope.payee.merchant.id,
                  currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
                }
              })
            }).then(function () {
              if ($scope.shippingRulesSummary.isSnTEnabled) {
                $scope.multistepSignupModel.merchant_has_snt_profile = true;
              }
            });
          } else {
            return $q.when();
          }
        }
        $scope.isInstallmentsVisible = function isInstallmentsVisible() {
          var model = $scope.multistepSignupModel;
          var hasConditionMet = model.allowInstallments && model.onboard.card.number && model.onboard.card.valid;
          var isBilling = $scope.checkoutCart.isBilling();
          return !isBilling && hasConditionMet;
        };
        if ($scope.multistepSignupModel.onboard.ue_billing_address) {
          $scope.multistepSignupModel.onboard.billing_address = $scope.multistepSignupModel.onboard.ue_billing_address;
          $scope.zipMasking($scope.multistepSignupModel.onboard.ue_billing_address.postal_code);
        }
        if ($locale.country === 'BR' && $scope.multistepSignupModel.onboard.billing_address) {
          $scope.multistepSignupModel.onboard.billing_address.postal_code = util.maskingUtil.maskZip($scope.multistepSignupModel.onboard.billing_address.postal_code);
        }
        $scope.setSelectedCurrency = function (selection) {
          var _$scope$multistepSign = $scope.multistepSignupModel.onboard.card.currencyConvData,
            _$scope$multistepSign2 = _$scope$multistepSign === void 0 ? {} : _$scope$multistepSign,
            from_code = _$scope$multistepSign2.from_code,
            to_code = _$scope$multistepSign2.to_code;
          $scope.selectedCurrency = selection === 'PAYPAL' ? from_code : to_code;
          _logger.$logger.info("CONVERSION_SELECTION_CHANGED_TO_" + selection);
        };
        $scope.setSubmitButtonKey = function () {
          var _$scope$multistepSign3 = $scope.multistepSignupModel.flags,
            hasData = _$scope$multistepSign3.hasBuyerFxPrePlanData,
            _$scope$multistepSign4 = _$scope$multistepSign3.buyerFxTreatment,
            treatment = _$scope$multistepSign4 === void 0 ? '' : _$scope$multistepSign4;
          var inCurrency = treatment.includes('treatment_2') && hasData;
          $scope.submitButtonKey = "common.continue" + (inCurrency ? 'InCurrency' : '') + "Label";
        };
        $scope.$watch('multistepSignupModel.onboard.card.ppconversion', function (selection) {
          $scope.setSelectedCurrency(selection);
          $scope.setSubmitButtonKey();
        });
        $scope.setBuyerFxFlag = function (_ref) {
          var treatment = _ref.treatment,
            hasBuyerFxPrePlanData = _ref.hasBuyerFxPrePlanData;
          if (treatment) {
            $scope.multistepSignupModel.flags.buyerFxTreatment = treatment;
          }
          if (hasBuyerFxPrePlanData) {
            $scope.setSelectedCurrency($scope.multistepSignupModel.onboard.card.ppconversion);
          }
          $scope.multistepSignupModel.flags.hasBuyerFxPrePlanData = hasBuyerFxPrePlanData;
          $scope.setSubmitButtonKey();
          _logger.$logger.info('SETTING_BUYER_FX_FLAG_IN_MULTISTEP_DIR', {
            treatment: treatment,
            hasBuyerFxPrePlanData: hasBuyerFxPrePlanData
          });
        };
        $scope.submitButtonKey = 'common.continueLabel';
        $populate($scope, {
          checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
          payee: $CheckoutPayeeModel.instance($scope.token),
          checkoutCart: $CheckoutCartModel.instance($scope.token)
        }).then(function () {
          // Needed to show custom description sent by merchant in Billing Agreement flow
          $scope.billingAgreementMerchantMsg = $scope.checkoutCart.getBillingDescription();

          // Log to FPTI to indicate the page has been rendered
          _logger.$logger.info('checkout_fpti', {
            from: 'CHECKOUT_MULTISTEPSIGNUP',
            to: 'prepare_checkout_multistepsignup'
          });
          $scope.multistepSignupModel.flags.allowEditShipping = $scope.checkoutAppData.get('flags.allow_change_shipping', false);
          $scope.multistepSignupModel.installmentDisabled = $scope.checkoutCart.isBilling();
          $scope.multistepSignupModel.wps_flow = $scope.checkoutAppData.is_wps_flow();
          $scope.multistepSignupModel.snt_supported_flow = $scope.checkoutAppData.is_snt_supported();
          $scope.showShippingAddress = Boolean(!$scope.checkoutAppData.flags.hide_shipping_address && $scope.checkoutAppData.flags.shipping_address_required);
          if ($config.readRulesSummaryFromAppData && $scope.multistepSignupModel.wps_flow && $scope.multistepSignupModel.snt_supported_flow) {
            if ($scope.checkoutAppData.is_snt_enabled()) {
              $scope.multistepSignupModel.merchant_has_snt_profile = true;
            }
          } else {
            checkShippingRulesExist();
          }
          $scope.prefill = function () {
            var postal_code = $scope.multistepSignupModel.onboard.billing_address.postal_code;
            $scope.prefillAddressCommon(postal_code, $scope.multistepSignupModel.onboard.billing_address, $scope.multistepSignupModel.onboard.user, $scope.multistepSignupModel.flags.billingAddress, false);
          };

          // Get merchant passed shipping address from either purchase plan or billing agreement plan
          var merchantSuppliedAddress = $scope.checkoutCart.get('purchase.shipping_address') || $scope.checkoutCart.get('billing.shipping_address');
          var merchantSuppliedNumber = $scope.checkoutCart.get('purchase.phone_fields') || $scope.checkoutCart.get('billing.phone_fields');
          if (merchantSuppliedAddress && !$scope.multistepSignupModel.onboard.ue_billing_address) {
            $scope.multistepSignupModel.onboard.billing_address = $BillingAddressModel.create($scope.token, {
              country: $locale.country
            }, merchantSuppliedAddress);
            $scope.prefill();
            $scope.zipMasking($scope.multistepSignupModel.onboard.billing_address.postal_code);
            $scope.multistepSignupModel.onboard.billing_address.postal_code = $scope.formattedValues.postalCode;
            $scope.multistepSignupModel.onboard.user.first_name = merchantSuppliedAddress.first_name;
            $scope.multistepSignupModel.onboard.user.last_name = merchantSuppliedAddress.last_name;
          }
          if (merchantSuppliedNumber && merchantSuppliedNumber.telephone_country === $locale.country) {
            $scope.multistepSignupModel.onboard.phone.telephone = merchantSuppliedNumber.normalized_phone_number;
          }
        });
        var basl_hermes_xoon_redirect = $util.param('hermesXoonRedirect') || $meta.query && $meta.query.hermesXoonRedirect;
        var basl_abtest_throttle = $util.param('abTestThrottle') || $meta.query && $meta.query.abTestThrottle;
        $scope.showLogin = basl_hermes_xoon_redirect || basl_abtest_throttle;
        $scope.redirect = function () {
          $dispatch('hermes', {
            hermesLoginRedirect: 'xoon',
            token: $scope.token,
            'locale.x': $locale.lang + '_' + $locale.country,
            'country.x': $locale.country
          });
        };
        $scope.uponNormalization = function (normalizedAddress, isBack) {
          if (isBack) {
            $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
          } else {
            $scope.normalize = false;
            $scope.multistepSignupModel.onboard.billing_address.setProperties(normalizedAddress);
            if ($scope.multistepSignupModel.flags.shipToBilling) {
              $location.path('/checkout/multistepsignup/multistepsignupcreateaccount').replace();
            } else {
              $location.path('/checkout/multistepsignup/multistepsignupaddshipping').replace();
            }
          }
        };
        $scope.changeCountry = function changeCountry() {
          if ($scope.multistepSignupModel.onboard.shipping_address.country && $scope.multistepSignupModel.onboard.shipping_address.country !== $locale.country) {
            $scope.multistepSignupModel.onboard.shippingCountryChanged = true;
            $rootScope.$broadcast('countryChange', $scope.multistepSignupModel.onboard.shipping_address.country);
          } else {
            $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
          }
        };
        $scope.onSubmit = function onSubmit() {
          // Backup user entered address
          $scope.multistepSignupModel.onboard.ue_billing_address = $BillingAddressModel.create($scope.token, {
            country: $locale.country
          }, $scope.multistepSignupModel.onboard.billing_address);
          if ($scope.componentsFlag.shippingAddress) {
            $scope.multistepSignupModel.onboard.ue_shipping_address = $ShippingAddressModel.create($scope.token, {
              country: $locale.country
            }, $scope.multistepSignupModel.onboard.shipping_address);
          }

          // Remove phone formatting
          $scope.multistepSignupModel.onboard.phone.telephone = $scope.multistepSignupModel.onboard.phone.telephone.replace(/[^0-9]/gi, '');
          if ($scope.normalize) {
            $scope.clearBackendError('multistepsignupaddcard');
            $scope.normalizeAddress($scope.multistepSignupModel.onboard.billing_address, $scope.uponNormalization);
          } else if ($scope.componentsFlag.shippingAddressPage) {
            if (!$scope.multistepSignupModel.flags.shipToBilling) {
              $state.go('checkout.multistepsignup.multistepsignupaddshipping');
            }
          } else {
            $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
          }
        };
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addCard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addCard/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-multistep-signup-add-card.route', ['squid', 'xo-multistep-signup-add-card.directive', 'hermes.page.xo-sidebar.route']).factory('$MultistepSignupAddCardRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('MultistepSignupAddCardRoute', {
      name: 'multistepsignupaddcard',
      directive: 'xo-multistep-signup-add-card',
      children: [{
        name: '$SidebarRoute',
        attributes: {
          'back-uri': 'backUri',
          'parent-model': 'multistepSignupModel'
        }
      }]
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/addCard", "../node_modules/xo-guest-components/src/multistep-signup/addCard/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addShipping/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addShipping/template.html"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template, util) {
  return angular.module('xo-multistep-signup-add-shipping.directive', ['squid', 'xo-value-props.directive']).directive('xoMultistepSignupAddShipping', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        parentCallbacks: '=?',
        multistepSignupModel: '=?',
        positionToErrorField: '=?',
        backState: '=?',
        backendError: '=?',
        clearBackendError: '=?',
        normalizeAddress: '=?',
        prefillAddressCommon: '=?'
      },
      link: function link($scope) {
        if ($scope.backendError) {
          $scope.backendError('multistepsignupaddshipping');
        }
        $scope.$on('$destroy', function () {
          $scope.clearBackendError('multistepsignupaddshipping');
        });
      },
      controller: ['$scope', '$rootScope', '$populate', '$state', '$util', '$locale', '$feature', '$ShippingAddressModel', '$CheckoutAppDataModel', '$CheckoutCartModel', '$pxpFactors', '$config', '$location', function ($scope, $rootScope, $populate, $state, $util, $locale, $feature, $ShippingAddressModel, $CheckoutAppDataModel, $CheckoutCartModel, $pxpFactors, $config, $location) {
        $scope.locale = $locale;
        $scope.validated = false;
        $scope.formattedValues = {};
        $scope.normalize = $feature('addressNormalization', false, $locale.country);
        $scope.prefillDone = false;
        if (!$scope.multistepSignupModel.onboard.shippingCountryChanged) {
          $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
        }
        $scope.zipMasking = function (newValue) {
          $scope.formattedValues.postalCode = util.maskingUtil.maskZip(newValue);
          $scope.multistepSignupModel.onboard.shipping_address.postal_code = $scope.formattedValues.postalCode.replace(/[^0-9]/gi, '');
        };
        if ($scope.multistepSignupModel.onboard.ue_shipping_address) {
          $scope.multistepSignupModel.onboard.shipping_address = $scope.multistepSignupModel.onboard.ue_shipping_address;
          $scope.zipMasking($scope.multistepSignupModel.onboard.ue_shipping_address.postal_code);
        }
        $scope.changeCountry = function changeCountry() {
          if ($scope.multistepSignupModel.onboard.shipping_address.country && $scope.multistepSignupModel.onboard.shipping_address.country !== $locale.country) {
            $scope.multistepSignupModel.onboard.shippingCountryChanged = true;
            $rootScope.$broadcast('countryChange', $scope.multistepSignupModel.onboard.shipping_address.country);
          } else {
            $scope.multistepSignupModel.onboard.shippingCountryChanged = false;
          }
        };
        $populate($scope, {
          checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
          checkoutCart: $CheckoutCartModel.instance($scope.token)
        }).then(function () {
          // To fix the back case where the '-' is not added to zip code
          if ($scope.multistepSignupModel.onboard.shipping_address) {
            $scope.multistepSignupModel.onboard.shipping_address.postal_code = util.maskingUtil.maskZip($scope.multistepSignupModel.onboard.shipping_address.postal_code);
          }
          $scope.prefill = function (override) {
            var postal_code = $scope.multistepSignupModel.onboard.shipping_address.postal_code;
            $scope.prefillAddressCommon(postal_code, $scope.multistepSignupModel.onboard.shipping_address, $scope.multistepSignupModel.onboard.shipping_address, $scope.multistepSignupModel.flags.shippingAddress, override);
            if (!$scope.prefillDone) {
              $scope.prefillDone = true;
            }
          };

          // Get merchant passed shipping address from either purchase plan or billing agreement plan
          var merchantSuppliedAddress = $scope.checkoutCart.get('purchase.shipping_address') || $scope.checkoutCart.get('billing.shipping_address');
          if (merchantSuppliedAddress && !$scope.multistepSignupModel.onboard.ue_shipping_address) {
            $scope.multistepSignupModel.onboard.shipping_address = $ShippingAddressModel.create($scope.token, {
              country: $locale.country
            }, merchantSuppliedAddress);
            $scope.prefill(true);
            $scope.zipMasking($scope.multistepSignupModel.onboard.shipping_address.postal_code);
            $scope.multistepSignupModel.onboard.shipping_address.postal_code = $scope.formattedValues.postalCode;
          }
        });
        $scope.uponNormalization = function (normalizedAddress, isBack) {
          if (isBack) {
            $location.path('/checkout/multistepsignup/multistepsignupaddshipping').replace();
          } else {
            $scope.normalize = false;
            $scope.multistepSignupModel.onboard.shipping_address.setProperties(normalizedAddress);
            $location.path('/checkout/multistepsignup/multistepsignupcreateaccount').replace();
          }
        };
        $scope.validate = function () {
          $scope.validated = true;
          return true;
        };
        $scope.onSubmit = function onSubmit() {
          // set recipient_name property
          var shippingAddress = $scope.multistepSignupModel.onboard.shipping_address;
          // TODO: in some locale, last_name can be displayed first, and space ' ' can be unnecessary.

          shippingAddress.recipient_name = shippingAddress.first_name + ' ' + shippingAddress.last_name;

          // backup user entered address
          $scope.multistepSignupModel.onboard.ue_shipping_address = $ShippingAddressModel.create($scope.token, {
            country: $locale.country
          }, shippingAddress);
          if ($scope.normalize) {
            $scope.clearBackendError('multistepsignupaddshipping');
            $scope.normalizeAddress(shippingAddress, $scope.uponNormalization);
          } else {
            $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
          }
        };
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addShipping/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addShipping/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-multistep-signup-add-shipping.route', ['squid', 'xo-multistep-signup-add-shipping.directive']).factory('$MultistepSignupAddShippingRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('MultistepSignupAddShippingRoute', {
      name: 'multistepsignupaddshipping',
      directive: 'xo-multistep-signup-add-shipping',
      children: [{
        name: '$AddressNormalizationRoute',
        attributes: {
          id: 'token',
          address: 'multistepSignupModel.onboard.shipping_address',
          'done-fn': 'uponNormalization'
        }
      }]
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/addShipping", "../node_modules/xo-guest-components/src/multistep-signup/addShipping/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/template.html"), __webpack_require__("./js/lib/index.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {
  return angular.module('xo-multistep-signup-address-normalization.directive', ['squid', 'xo-value-props.directive']).directive('xoMultistepSignupAddressNormalization', ['$rootScope', function ($rootScope) {
    return {
      template: template,
      scope: {
        id: '=?',
        address: '=?',
        doneFn: '=?'
      },
      controller: ['$scope', '$locale', '$config', function ($scope, $locale, $config) {}]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-multistep-signup-address-normalization.route', ['squid', 'xo-multistep-signup-address-normalization.directive']).factory('$MultistepSignupAddressNormalizationRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('MultistepSignupAddressNormalizationRoute', {
      name: 'multistepsignupaddressnormalization',
      directive: 'xo-multistep-signup-address-normalization',
      children: []
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/addressNormalization", "../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/apiCalls/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename, $) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _util = __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _utils = __webpack_require__("../node_modules/xo-guest-components/src/guest/currencyConversion/utils.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("../node_modules/xo-guest-components/src/lib/util.js"), __webpack_require__("../node_modules/xo-models/src/inventory/index.js"), __webpack_require__("../node_modules/xo-models/src/shoppingcart/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, util) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('xomultistepsignupapi', ['squid']).factory('$MultistepApiCalls', ['$MultistepSignupModel', '$CheckoutSessionModel', '$CheckoutAppDataModel', '$CheckoutPayeeModel', '$InventoryModel', '$ShoppingCartModel', '$CheckoutCartModel', '$rootScope', '$state', '$config', '$locale', '$NationalIdModel', '$location', '$dispatch', '$getRedirectUrl', '$renderContent', '$q', '$FundingOptionsModel', function ($MultistepSignupModel, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $InventoryModel, $ShoppingCartModel, $CheckoutCartModel, $rootScope, $state, $config, $locale, $NationalIdModel, $location, $dispatch, $getRedirectUrl, $renderContent, $q, $FundingOptionsModel) {
    function processFieldMap(errorCategory) {
      var fieldMap = util.contingencyMap(errorCategory.errorCode || errorCategory.code);
      if (fieldMap) {
        if (!fieldMap.fields && (errorCategory.fields || errorCategory.details && errorCategory.details.fields)) {
          // eslint-disable-line no-extra-parens
          errorCategory.fields = errorCategory.fields || errorCategory.details && errorCategory.details.fields;
          var fields = errorCategory.fields.map(function (value, index, array) {
            if (angular.isString(value)) {
              return {
                field: value
              };
            }
            return value;
          });
          fieldMap.fields = fields;
        }
      } else {
        _logger.$logger.info('signup_validation_error', {
          message: errorCategory.errorCode || errorCategory.code + ' not mapped'
        });
      }
      return fieldMap;
    }
    function redirectTohermesCC(path, $location, token) {
      // eslint-disable-line no-shadow
      var url;
      var protocol;
      var host;
      var port;
      protocol = $location.protocol() + '://';
      if ($location.host()) {
        host = $location.host();
      }
      if ($location.port()) {
        port = ':' + $location.port();
      }
      url = protocol + host + port + config.urls.fallbackUrl.hermes + '?token=' + token + path; // eslint-disable-line no-undef,block-scoped-var

      window.location = url;
    }
    function setStickyInstrument(checkoutSession) {
      // make billing agreement FI sticky for sign up

      var stickyInstrument = checkoutSession.selectedFuturePaymentInstrument ? undefined : checkoutSession.getSelectedStickyInstrument();
      if (stickyInstrument) {
        return checkoutSession.action('setStickyFI', {
          data: {
            instrument_id: stickyInstrument.instrument_id
          }
        });
      }
    }
    function showGenericError(code) {
      return function () {
        $state.go('checkout.genericError', {
          code: code
        });
      };
    }
    function markCartCheckedout(checkoutAppData) {
      var shoppingCartModel = $ShoppingCartModel.instance($rootScope.token);
      return shoppingCartModel.action('cartCheckedOut', {
        success: function success(result) {
          _logger.$logger.info('cart checked out successfully');
        }
      });
    }
    function handlePaymentContingencies(checkoutCart, payee, code) {
      return function () {
        inventoryOperation(checkoutCart, payee, 'failed');
        return $state.go('checkout.genericError', {
          code: code
        });
      };
    }
    function makePayment(checkoutSession, checkoutCart, checkoutAppData, payee) {
      return checkoutSession.action('createPayment', {
        'data': {
          payer_id: checkoutSession.payer && checkoutSession.payer.id,
          intent: checkoutCart.payment_action
        },
        success: function success(result) {
          $rootScope.paymentComplete = true;
          if ($config.enableShoppingCartWPS && checkoutAppData.flags.is_shopping_cart_flow) {
            markCartCheckedout(checkoutAppData);
          }
          return $state.go('checkout.done');
        },
        contingencies: {
          TRANSACTION_REFUSED: handlePaymentContingencies(checkoutCart, payee, 'TRANSACTION_REFUSED'),
          INSTRUMENT_DECLINED: function INSTRUMENT_DECLINED(err, message) {
            inventoryOperation(checkoutCart, payee, 'failed');
            _logger.$logger.info('INSTRUMENT_DECLINED_contingency', {
              name: err,
              message: message
            });
            redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
          },
          PAYEE_BLOCKED_TRANSACTION: handlePaymentContingencies(checkoutCart, payee, 'PAYMENT_DENIED'),
          DUPLICATE_TRANSACTION: handlePaymentContingencies(checkoutCart, payee, 'PAYMENT_ALREADY_DONE'),
          CC_PROCESSOR_DECLINED: function CC_PROCESSOR_DECLINED(err, message) {
            inventoryOperation(checkoutCart, payee, 'failed');
            // Log the error and redirect to hermes add card page
            _logger.$logger.info('CC_PROCESSOR_DECLINED_CONTINGENCY', {
              name: err,
              message: message
            });
            redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
          },
          DEFAULT: handlePaymentContingencies(checkoutCart, payee, 'DEFAULT')
        },
        error: function error(err) {
          _logger.$logger.info('createPayment Failed due to service error', err);
          inventoryOperation(checkoutCart, payee, 'failed');
          return $state.go('checkout.genericError', {
            code: 'DEFAULT'
          });
        }
      });
    }
    function authorizeSession(checkoutSession) {
      var multistepSignupModel = $MultistepSignupModel.instance();
      var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
      var payee = $CheckoutPayeeModel.instance($rootScope.token);
      var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
      if (checkoutSession.resolve_3ds) {
        var cc_id = checkoutSession.get('resolve_3ds.ccId');
        var plans = checkoutSession.get('plan.sources', null);
        var plan = plans && plans.filter(function (e) {
          return e.instrument_id === cc_id;
        })[0].amount || null;
        multistepSignupModel.resolve_3ds_data = {
          cc_id: cc_id,
          flow_id: 'HERMES',
          merchant_id: payee.get('merchant.id'),
          merchant_country_code: checkoutAppData.get('merchant.merchant_country'),
          transaction_amount_currency: plan && plan.currency_code,
          transaction_amount_value: plan && plan.amount
        };
        multistepSignupModel.is3ds = true;
        $state.go('checkout.multistepsignup.multistepsignupcreateaccount');
      } else {
        return $q.when(setStickyInstrument(checkoutSession))["catch"](function (err) {
          _logger.$logger.info('setStickyFI Failed', err);
        })["finally"](function () {
          return checkoutSession.action('authorize', {
            success: function success() {
              var billingFlow = {
                isSubscriptionsV1: checkoutCart.isSubscriptionsV1(),
                isWpsSubscription: checkoutAppData.is_wps_subscription_flow(),
                isWpsAutobilling: checkoutAppData.isWpsAutobillingFlow(),
                isWpsInstallmentPlan: checkoutAppData.is_wps_installmentplan_flow()
              };
              if (billingFlow.isWpsSubscription || billingFlow.isSubscriptionsV1 || billingFlow.isWpsInstallmentPlan || billingFlow.isWpsAutobilling) {
                return (0, _util.redirectToSubscriptionFinalRoute)(multistepSignupModel.flags.mode, billingFlow);
              } else if (checkoutAppData.doec_on_approve()) {
                return checkInventoryAndPay(checkoutSession, checkoutCart, payee, checkoutAppData);
              } else {
                $state.go('checkout.end');
              }
            }
          });
        });
      }
    }
    function inventoryOperation(checkoutCart, payee, paymentStatus) {
      var cartHasInventory = checkoutCart.get('cartHasInventory');
      if (cartHasInventory) {
        var inventoryModel = $InventoryModel.instance($rootScope.token);
        var inventoryItems = inventoryModel.getInventoryItems();
        var purchaseItems = checkoutCart.get('purchaseUnits');
        var cartItems,
          inventoryPatchInput = {};
        if (purchaseItems && purchaseItems[0] && purchaseItems[0].item_list) {
          cartItems = purchaseItems[0].item_list.items;
        }
        paymentStatus = paymentStatus ? paymentStatus : 'success';
        if (cartItems && inventoryItems) {
          inventoryPatchInput = {
            inventoryItems: inventoryItems,
            cartItems: cartItems,
            merchantId: payee.get('merchant.id', ''),
            paymentStatus: paymentStatus
          };
        } else {
          return $q.when(); // don't need to call patchInventory if items not present
        }
        return inventoryModel.action('patchInventory', {
          data: inventoryPatchInput,
          success: function success(patchResponse) {
            if (patchResponse) {
              if (patchResponse.showSoldoutPage) {
                // show soldout page
                return {
                  soldoutpage: true,
                  items: patchResponse.soldoutItems,
                  soldOutUrl: patchResponse.soldoutUrl
                };
              } else if (patchResponse.patchCart) {
                var purchase_unit = checkoutCart.get('purchaseUnits')[0];
                purchase_unit.item_list.items = patchResponse.cartItems;
                var patchCartPayload = {
                  id: $rootScope.token,
                  patchEntities: [{
                    field: 'inventoryItems',
                    value: purchase_unit.item_list.items
                  }]
                };
                return checkoutCart.action('patchCartData', {
                  data: patchCartPayload
                });
              }
            } else {
              return;
            }
          }
        });
      } else {
        return $q.when(); // not an inventory request proceed with existing flow
      }
    }
    function checkInventoryAndPay(checkoutSession, checkoutCart, payee, checkoutAppData) {
      return inventoryOperation(checkoutCart, payee).then(function (result) {
        if (result && result.soldoutpage) {
          return $state.go('checkout.soldout', {
            items: encodeURIComponent(result.items),
            soldOutUrl: encodeURIComponent(result.soldOutUrl)
          });
        }
        return makePayment(checkoutSession, checkoutCart, checkoutAppData, payee);
      });
    }
    function createSession() {
      var multistepSignupModel = $MultistepSignupModel.instance();
      var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
      var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
      return checkoutSession.action('create', {
        data: {
          fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
          baToken: checkoutCart.billing && checkoutCart.billing.ba_token
        },
        success: function success() {
          return $q.when().then(function () {
            if (!multistepSignupModel.flags.shipToBilling) {
              return multistepSignupModel.onboard.shipping_address.save({
                data: multistepSignupModel.onboard.shipping_address.serialize(),
                validation: function validation(message, err) {
                  // TODO need to handle
                }
              });
            }
          }).then(function () {
            var _ref = multistepSignupModel.flags || {},
              hasBuyerFxPrePlanData = _ref.hasBuyerFxPrePlanData,
              buyerFxTreatment = _ref.buyerFxTreatment;

            // If this purchase is a cross-border transaction that requires
            // currency conversion then `buyerFxTreatment` will be truthy
            if (buyerFxTreatment) {
              var _multistepSignupModel = multistepSignupModel.onboard,
                card = _multistepSignupModel.card,
                _multistepSignupModel2 = _multistepSignupModel.card,
                _multistepSignupModel3 = _multistepSignupModel2 === void 0 ? {} : _multistepSignupModel2,
                type = _multistepSignupModel3.type;
              var purchase = checkoutSession.purchase;
              var isConversionChangeable = (0, _utils.isConversionChangeableForCardType)(type);

              /**
               * If buyer fx pre-plan call failed and the card is changeable
               * then we haven't logged event 3 yet. Event 3 for changeable
               * cards is usually logged in xo-wallet-components creditcard-input
               * directive after a successful call to the pre-plan API.
               */
              if (!hasBuyerFxPrePlanData && isConversionChangeable) {
                /**
                 * FPTI event #3 for Buyer FX
                 * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
                 */
                (0, _utils.logBuyerFxFptiEvent3)(purchase);
              }

              /**
               * FPTI event 7 for Buyer FX
               * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
               */
              (0, _utils.logBuyerFxFptiEvent7)({
                card: card,
                hasPrePlanData: hasBuyerFxPrePlanData,
                isConversionChangeable: isConversionChangeable,
                isSignup: true,
                purchase: purchase
              });
            }
            if (checkoutSession.get('plan.conversion.paypal') && checkoutSession.get('plan.conversion.changeable') && multistepSignupModel.onboard.card.ppconversion === 'VENDOR') {
              return $FundingOptionsModel.instance($rootScope.token).action('updateConversion', {
                data: {
                  conversionType: 'VENDOR',
                  planId: checkoutSession.plan.id
                }
              })["catch"](function (err) {
                _logger.$logger.warn('ERROR_updateConversion to VENDOR failed', err);
              });
            }
          }).then(function () {
            return authorizeSession(checkoutSession);
          });
        },
        contingencies: {
          TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
          NEED_CREDIT_CARD: function NEED_CREDIT_CARD(err, message) {
            _logger.$logger.info('NEED_CREDIT_CARD_contingency', {
              name: err,
              message: message
            });
            redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
          }
        }
      });
    }
    var multiStepFunctions = {
      onboard: function onboard() {
        var pageError = {
          // eslint-disable-line no-reserved-keys
          multistepsignupaddcard: [],
          multistepsignupaddshipping: [],
          multistepsignupcreateaccount: [],
          "transient": true
        };
        var multistepSignupModel = $MultistepSignupModel.instance();
        multistepSignupModel.onboard.billing_address.country = $locale.country;
        multistepSignupModel.onboard.nationalIdModel = $NationalIdModel.instance($rootScope.token);
        return multistepSignupModel.onboard.action(multistepSignupModel.flags.mode, {
          data: multistepSignupModel.onboard.serialize(),
          success: createSession,
          contingencies: {
            TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
            TOO_MANY_REQUESTS: function TOO_MANY_REQUESTS() {
              var messages = [];
              messages.push($locale.content.get('genericError.genericError'));
              multistepSignupModel.pageError = pageError;
              pageError.multistepsignupaddcard.errorMessage = {
                msgs: messages,
                type: 'error'
              };
              $state.go('checkout.multistepsignup.multistepsignupaddcard');
            },
            ADD_KYC_FAILED: function ADD_KYC_FAILED() {
              redirectTohermesCC('#/checkout/addNationalId', $location, $rootScope.token);
            },
            CC_LINKED_TO_FULL_ACCOUNT: function CC_LINKED_TO_FULL_ACCOUNT() {
              var messages = [];
              messages.push($locale.content.get('creditcard.linkedCardToAddNewCard'));
              multistepSignupModel.pageError = pageError;
              pageError.multistepsignupaddcard.errorMessage = {
                msgs: messages,
                type: 'error'
              };
              $state.go('checkout.multistepsignup.multistepsignupaddcard');
            },
            ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(message, errorData) {
              // @TODO send to correct page in hermes
              // $dispatch('hermes');
              // auth model-> check if user logged in
              var addFIContingency = errorData && errorData[0] === 'VALIDATION_ERROR' ? 'retry' : 'noretry';
              $dispatch('hermes', {
                redirectToHermes: true,
                addFIContingency: addFIContingency,
                token: $rootScope.token,
                'locale.x': $locale.lang + '_' + $locale.country,
                'country.x': $locale.country
              });
            },
            ISSUER_DECLINE: function ISSUER_DECLINE(message, result) {
              // @TODO send to correct page in hermes
              // $dispatch('hermes');
              redirectTohermesCC('#checkout/pageAddCard/addCardFlow/addCard', $location, $rootScope.token);
            },
            VALIDATION_ERROR: function VALIDATION_ERROR(message, errors) {
              var messages = [];
              var compileVars = {
                loginRedirectUrl: $getRedirectUrl('hermes', {
                  hermesLoginRedirect: 'xoon'
                })
              };
              // Iterate over the errorData to support multiple error support

              Object.keys(errors).forEach(function (key, index, array) {
                var errorCategory = errors[key];
                // errorCategory sanity checks

                if (!errorCategory || angular.isString(errorCategory) || key === 'transient' || key === 'payload') {
                  return;
                }
                var fieldMap = processFieldMap(errorCategory);
                var msg;
                var compileMessageWith;
                if (fieldMap) {
                  if (fieldMap.pageError) {
                    compileMessageWith = fieldMap.compileMessageWith;
                    if (compileMessageWith) {
                      // substitute the actual value
                      // this is required as it is not good to have custom
                      // code inside library - lib/utils.js
                      $.each(compileMessageWith, function (objKey, val) {
                        var actualValue = compileVars[val];
                        if (actualValue) {
                          compileMessageWith[objKey] = actualValue;
                        }
                      });
                      msg = $renderContent(fieldMap.pageError.contentKey, compileMessageWith);
                    } else {
                      msg = $locale.content.get(fieldMap.pageError.contentKey);
                    }
                    messages.push(msg);
                  }
                  pageError[fieldMap.path].push(fieldMap);
                  if (messages.length > 0) {
                    pageError[fieldMap.path].errorMessage = {
                      msgs: messages,
                      type: 'error'
                    };
                  }
                }
              });
              multistepSignupModel.pageError = pageError;
              throw pageError;
            }
          },
          validation: function validation(res) {
            if (res && (res.field === 'secondaryId' || res.field === 'passport')) {
              // The validation error cannot be corrected at this point in onboarding
              redirectTohermesCC('#/checkout/addNationalId', $location, $rootScope.token);
            } else {
              _logger.$logger.info('signup_validation', {
                message: res
              });
            }
          }
        });
      },
      routeToHermesOn3DSDeclineForSignUp: function routeToHermesOn3DSDeclineForSignUp() {
        // dispatch to hermesnodeweb up on 3DS authenticate decline.
        _logger.$logger.info('xoon_to_hermes_redirect_on_signup_3DS_Authentication_decline');
        $dispatch('hermes', {
          token: $rootScope.token,
          redirectToHermesOn3DSDecline: 'xoon'
        });
      },
      clear3DSContingency: function clear3DSContingency() {
        var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
        return checkoutSession.action('clear3DSContingency', {
          data: {
            ccId: checkoutSession.resolve_3ds.ccId
          },
          success: function success() {
            // don't call authorize if the contingency is not cleared
            if (!checkoutSession.resolve_3ds) {
              return authorizeSession(checkoutSession);
            } else {
              multiStepFunctions.routeToHermesOn3DSDeclineForSignUp();
            }
          },
          contingencies: {
            // contingency may be "no cc" or any thing from clear3DSContingency(patch on xosession)
            // for "no cc" symphony throws NEED_CREDIT_CARD or NEED_CREDIT_CARD_OR_BANK_ACCOUNT
            DEFAULT: function handleContingency(name, contingency) {
              _logger.$logger.info('clear3DSContingency_contingency', {
                'int_error_description': contingency && contingency.message,
                'contingency_name': name
              });
              // route to member review page upon patch xo throws contingency for signup
              multiStepFunctions.routeToHermesOn3DSDeclineForSignUp();
            }
          }
        });
      }
    };
    return multiStepFunctions;
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_util.redirectToSubscriptionFinalRoute;
_logger.$logger;
_utils.isConversionChangeableForCardType;
_utils.logBuyerFxFptiEvent3;
_utils.logBuyerFxFptiEvent7;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/apiCalls", "../node_modules/xo-guest-components/src/multistep-signup/apiCalls/factory.js", __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/createAccount/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _contentKeys = __webpack_require__("../node_modules/xo-guest-components/src/lib/contentKeys.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/createAccount/template.html"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/lib/util.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-models/src/onboard/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js"), __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js"), __webpack_require__("../node_modules/xo-models/src/user/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/apiCalls/factory.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, module, template, util) {
  return angular.module('xo-multistep-signup-create-account.directive', ['squid', 'xomodel.onboard', 'xo-value-props.directive', 'xo-dob-input.directive', 'xo-national-id-input.directive', 'xomodel.user', 'xomultistepsignupapi']).directive('xoMultistepSignupCreateAccount', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        parentCallbacks: '=?',
        multistepSignupModel: '=?',
        positionToErrorField: '=?',
        backState: '=?',
        backendError: '=?',
        clearBackendError: '=?'
      },
      controller: ['$scope', '$rootScope', '$populate', '$state', '$util', '$locale', '$ShippingAddressModel', '$logger', '$CheckoutSessionModel', '$CheckoutAppDataModel', '$CheckoutCartModel', '$UserInfoModel', '$dispatch', '$pxpFactors', '$config', '$MultistepApiCalls', '$pxp', '$elmo', function ($scope, $rootScope, $populate, $state, $util, $locale, $ShippingAddressModel, $logger, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $UserInfoModel, $dispatch, $pxpFactors, $config, $MultistepApiCalls, $pxp, $elmo) {
        // Log to FPTI to indicate the page has been rendered
        $logger.info('checkout_fpti', {
          from: 'CHECKOUT_MULTISTEPSIGNUP_MULTISTEPSIGNUPCREATEACCOUNT',
          to: 'prepare_checkout_multistepsignup_multistepsignupcreateaccount'
        });
        $scope.locale = $locale;
        $scope.componentsFlag = util.componentsMap($locale.country);
        $scope.metadata = angular.copy($locale.metadata);
        $scope.countries = $scope.metadata.territory;
        $scope.checkoutCart = $CheckoutCartModel.instance($scope.token);
        $scope.checkoutAppData = $CheckoutAppDataModel.instance($scope.token);
        if ($scope.checkoutAppData && $scope.checkoutAppData.merchant) {
          $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
            nonEmptyReturnValue: true
          });
        }
        function formatFiLast4(ccNum) {
          if (ccNum === void 0) {
            ccNum = '';
          }
          return 'x-' + ccNum.replace(/\s+/g, '').slice(-4);
        }
        function formatFiName(ccType) {
          if (ccType === void 0) {
            ccType = '';
          }
          var tmp = ccType.toLowerCase();
          return tmp.charAt(0).toUpperCase() + tmp.slice(1);
        }
        $elmo('xo_xoon_no_balance_agreement', {
          'ctx.COUNTRY': $locale.country
        }, '(Trmt_xo_xoon_no_balance_agreement_)(.*)').then(function (result) {
          var contentOpts = {
            cart: $scope.checkoutCart,
            appData: $scope.checkoutAppData,
            locale: $scope.locale,
            noBalance: Boolean(result && result.treatment_name)
          };
          $scope.billingAgrementContentInfo = (0, _contentKeys.getBillingAgreementContentInfo)(contentOpts);
          if ($scope.billingAgrementContentInfo && $scope.billingAgrementContentInfo.data) {
            $scope.billingAgrementContentInfo.data.fiName = $scope.fiName;
            $scope.billingAgrementContentInfo.data.fiFormatLast4 = $scope.fiFormatLast4;
          }
        });
        $scope.isWpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();
        $scope.isWpsAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();
        $scope.isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();
        $scope.isWpsInstallmentPlan = $scope.checkoutAppData.is_wps_installmentplan_flow();
        $scope.isSubscription = $scope.isWpsSubscription || $scope.isSubscriptionsV1;
        $scope.fiName = formatFiName($scope.multistepSignupModel.onboard.card.type);
        $scope.fiFormatLast4 = formatFiLast4($scope.multistepSignupModel.onboard.card.number);

        // Reset password fields
        delete $scope.multistepSignupModel.onboard.user.password;
        delete $scope.multistepSignupModel.onboard.user.confirmPassword;
        var useraction = $scope.checkoutAppData.useraction();
        $scope.isCommit = useraction && useraction.toLowerCase() === 'commit';
        $logger.info('checkout_fpti', {
          'billing_page_button_text': $scope.isCommit ? 'paynow_y' : 'paynow_n'
        });
        if ($scope.isCommit) {
          if ($scope.isSubscription || $scope.isWpsInstallmentPlan || $scope.isWpsAutobilling) {
            $scope.submitButtonKey = 'wpsSubscription.guest.createAccountAndSubscribe.button.text';
          } else {
            $scope.submitButtonKey = 'common.agreeAndPay';
          }
        } else {
          $scope.submitButtonKey = 'common.agreeAndContinue';
        }
        if (!$rootScope.miniBrowser && $locale.country === 'BR') {
          var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_createaccount_design;
          $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
            $scope.createAccountDesignExp = result;
          });
        }
        function handleUIValidation(fields) {
          var $fields = $(fields);
          $fields.addClass('backendError');
          if (window.scrollTo) {
            window.scrollTo(0, 0);
          }
        }
        function isNameCyrillic() {
          var result = true;
          var regexCyrillic = /[а-яА-ЯЁё]/;
          if (!regexCyrillic.test($('#firstName').val())) {
            result = false;
            handleUIValidation('#firstName');
          }
          if (!regexCyrillic.test($('#lastName').val())) {
            result = false;
            handleUIValidation('#lastName');
          }
          if (!regexCyrillic.test($('#middleName').val())) {
            result = false;
            handleUIValidation('#middleName');
          }
          if (!result) {
            var messages = [];
            messages.push($locale.content.get('addTaxId.cyrillicNameError'));
            $scope.multistepSignupModel.pageError = $scope.multistepSignupModel.pageError || {};
            $scope.multistepSignupModel.pageError.multistepsignupcreateaccount = {
              errorMessage: {
                msgs: messages,
                type: 'error'
              }
            };
          }
          return result;
        }
        $scope.onContinue = function () {
          var validInput = true;
          if ($scope.multistepSignupModel.onboard.user.countryOfResidence === 'RU') {
            validInput = isNameCyrillic();
          }
          var isLegalAge = util.validateLegalAge($scope.multistepSignupModel.onboard.user.dob_month, $scope.multistepSignupModel.onboard.user.dob_day, $scope.multistepSignupModel.onboard.user.dob_year);
          if (!isLegalAge) {
            validInput = false;
            handleUIValidation('#dobText');
          }
          if (validInput) {
            $scope.onSubmit();
          }
        };
        $scope.legalAgreeToolTip = function () {
          if ($scope.multistepSignupModel.onboard.agree) {
            $scope.showTooltip = false;
          } else {
            $scope.showTooltip = true;
          }
        };
        $scope.validate = function () {
          $scope.legalAgreeToolTip();
          $scope.validated = true;
          return true;
        };
        $scope.onComplete3DSHandler = function (status) {
          $scope.multistepSignupModel.is3ds = false;
          if (status === 'decline' || status === 'close') {
            // Flow should route to member review page for sign up case
            // up on receiving "decline" or "close" response from 3DS authenticate call
            $MultistepApiCalls.routeToHermesOn3DSDeclineForSignUp();
          } else if (status === 'success') {
            // Up on Successful authenticate, perform Patch on XO session and authorise.
            $MultistepApiCalls.clear3DSContingency();
          }
        };
        $scope.onSubmit = function () {
          $logger.info($scope.multistepSignupModel.flags.mode + '_submit', {
            type: $scope.multistepSignupModel.onboard.card.type,
            country: $locale.country,
            lang: $locale.lang
          }).flush();
          if ($scope.multistepSignupModel.flags.shipToBilling) {
            $scope.multistepSignupModel.onboard.shipping_address = $ShippingAddressModel.create($scope.token, $scope.multistepSignupModel.onboard.billing_address, {
              first_name: $scope.multistepSignupModel.onboard.user.first_name,
              last_name: $scope.multistepSignupModel.onboard.user.last_name
            });
          }
          $MultistepApiCalls.onboard()["catch"](function (pageError) {
            var addCard = pageError.multistepsignupaddcard;
            var addShipping = pageError.multistepsignupaddshipping;
            var createAcc = pageError.multistepsignupcreateaccount;

            // Globally handled contingencies also trigger the catch block.
            if (addCard && addCard.length > 0) {
              $state.go('checkout.multistepsignup.multistepsignupaddcard');
            } else if (addShipping && addShipping.length > 0) {
              $state.go('checkout.multistepsignup.multistepsignupaddshipping');
            } else if (createAcc && createAcc.length > 0) {
              $scope.backendError('multistepsignupcreateaccount');
            }
          });
        };
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_contentKeys.getBillingAgreementContentInfo;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/createAccount/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/createAccount/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-multistep-signup-create-account.route', ['squid', 'xo-multistep-signup-create-account.directive']).factory('$MultistepSignupCreateAccountRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('MultistepSignupCreateAccountRoute', {
      name: 'multistepsignupcreateaccount',
      directive: 'xo-multistep-signup-create-account',
      children: []
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup/createAccount", "../node_modules/xo-guest-components/src/multistep-signup/createAccount/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-guest-components/src/multistep-signup/template.html"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/index.js"), __webpack_require__("../node_modules/xo-models/src/onboard/index.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, module, template) {
  return angular.module('xo-multistep-signup.directive', ['squid', 'xomultistepsignupmodel', 'xomodel.onboard', 'xomodel.checkout', 'xomodel.address', 'xo-fi-contingency-list.util']).directive('xoMultistepSignup', ['$rootScope', function ($rootScope) {
    return {
      template: template,
      scope: {
        token: '=?',
        parentCallbacks: '=?',
        buttonParams: '=?'
      },
      controller: ['$populate', '$scope', '$state', '$locale', '$MultistepSignupModel', '$OnboardModel', '$logger', '$PrefillAddressModel', '$OnboardUserModel', '$OnboardPhoneModel', '$ShippingAddressModel', '$BillingAddressModel', '$InstallmentOptionsModel', '$location', '$feature', '$timeout', '$CheckoutPayeeModel', '$CheckoutCartModel', '$CheckoutAppDataModel', '$fiErrorUtil', '$util', function ($populate, $scope, $state, $locale, $MultistepSignupModel, $OnboardModel, $logger, $PrefillAddressModel, $OnboardUserModel, $OnboardPhoneModel, $ShippingAddressModel, $BillingAddressModel, $InstallmentOptionsModel, $location, $feature, $timeout, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutAppDataModel, $fiErrorUtil, $util) {
        $scope.locale = $locale;
        $scope.multistepSignupModel = $MultistepSignupModel.instance();
        function triggerPageDesignFPTILog() {
          var pageContext = 'Full-context';
          if ($rootScope.miniBrowser) {
            pageContext = 'In-context';
          }
          $logger.info('checkout_fpti', {
            'design': pageContext
          });
        }
        // Log Initial Page Design
        triggerPageDesignFPTILog();
        // Trigger Design FPTI Log on Page Design Change
        $rootScope.$watch('miniBrowser', triggerPageDesignFPTILog);
        var normalizeCallback;
        var lastPrefillCall = {};
        function sanitizeZip(value) {
          return (value || '').replace(/[^0-9]+/g, '');
        }
        $scope.multistepSignupModel.onboard = new $OnboardModel({
          user: $OnboardUserModel.instance($scope.token, {
            country: $locale.country
          }),
          billing_address: $BillingAddressModel.create($scope.token, {
            country: $locale.country
          }),
          shipping_address: $ShippingAddressModel.create($scope.token, {
            country: $locale.country
          }),
          phone: new $OnboardPhoneModel(),
          residential_address_present: false
        });
        $scope.multistepSignupModel.onboard.card.ppconversion = 'PAYPAL';

        // remove this upon oas ramp completion
        $scope.multistepSignupModel.onboard.testParams = {
          oas: $util.param('oas'),
          cardCandidate: $util.param('cardCandidate')
        };
        $populate($scope, {
          checkoutCart: $CheckoutCartModel.instance($scope.token)
        }).then(function () {
          $scope.multistepSignupModel.onboard.user.email = $scope.checkoutCart.payer && $scope.checkoutCart.payer.email;
          // Prefill birth_date from cart(/v2/checkout/orders api can send birth date while creating the token)
          // according to PPAAS v2/checkout/orders api, regex for birth_date is always "yyyy-mm-dd"
          // PPAAS url for v2/checkout/orders: https://ppaas/api/3719176155269081#apiReference
          var payerBirthDate = $scope.checkoutCart.get('payer.birth_date');
          if (payerBirthDate) {
            var _payerBirthDate$split = payerBirthDate.split('-'),
              year = _payerBirthDate$split[0],
              month = _payerBirthDate$split[1],
              day = _payerBirthDate$split[2];
            $scope.multistepSignupModel.onboard.user.dob_day = day;
            $scope.multistepSignupModel.onboard.user.dob_month = month;
            $scope.multistepSignupModel.onboard.user.dob_year = year;
          }
        });
        $scope.multistepSignupModel.onboard.shipping_address.setProperties({
          first_name: '',
          last_name: ''
        });
        $scope.multistepSignupModel.onboard.billing_address.setProperties({
          first_name: '',
          last_name: ''
        });
        $scope.multistepSignupModel.flags = {
          mode: 'signup',
          shipToBilling: true,
          allowEditShipping: true,
          billingAddress: {
            addrPrefilled: false
          },
          shippingAddress: {
            addrPrefilled: false
          }
        };
        function sortCountryList() {
          $scope.metadata = angular.copy($locale.metadata);
          return $scope.metadata.territory;
        }
        $scope.multistepSignupModel.countries = sortCountryList();
        $scope.positionToErrorField = function positionToErrorField() {
          var errorFields = $('.backendError:visible, input:visible.ng-invalid, select:visible.ng-invalid');
          var firstErrorField = errorFields && errorFields.length && errorFields[0];
          if (firstErrorField) {
            firstErrorField.focus();
            window.document.body.scrollTop = $(firstErrorField).offset().top;
          } else {
            // If there are no field errors and only page level errors.
            window.document.body.scrollTop = 0;
          }
          $('.backendError:visible').on('blur', function (event) {
            $(this).removeClass('backendError');
          });
          if ($('#installments').length) {
            $('#paymentMethod').addClass('ng-invalid');
          } else {
            $('#paymentMethod').removeClass('ng-invalid');
          }
          return true;
        };
        $scope.backState = function backState() {
          history.back();
          // $scope.$apply();
        };
        $scope.backendError = function backendError(pageName) {
          $timeout(function () {
            var modelErrors = $scope.multistepSignupModel.pageError;
            if (modelErrors && modelErrors[pageName]) {
              var pageErrors = modelErrors[pageName];
              pageErrors.forEach(function (err) {
                if (err.name) {
                  // Highlight the Error Fields by name
                  $fiErrorUtil.addFieldErrorsByName(err, 'form', err.name);
                } else {
                  // Highlight the Error Fields by ng-model
                  $fiErrorUtil.addFieldErrors(err, 'form', err.model);
                }
              });
            }
          }, 10);
        };
        $scope.clearBackendError = function clearBackendError(pageName) {
          if ($scope.multistepSignupModel.pageError) {
            $scope.multistepSignupModel.pageError[pageName] = [];
          }
        };
        $scope.normalizeAddress = function normalizeAddress(address, callback) {
          $scope.multistepSignupModel.onboard.toBeNormalizedAddress = address;
          $state.go('checkout.multistepsignup.multistepsignupaddressnormalization');
          normalizeCallback = callback;
        };
        $scope.prefillAddressCommon = function (postal_code, address, user, flag, override) {
          if (!postal_code) {
            return;
          }
          var addressType = address instanceof $ShippingAddressModel ? 'shipping' : 'billing';
          if (!override && lastPrefillCall[addressType] === sanitizeZip(postal_code)) {
            return;
          }
          $scope.prefillAddress = new $PrefillAddressModel({
            id: $scope.token,
            address: {
              country: $locale.country,
              postal_code: postal_code
            }
          });
          $scope.prefillAddress.save({
            data: $scope.prefillAddress,
            success: function success(result) {
              if (result) {
                lastPrefillCall[addressType] = sanitizeZip(result.postal_code);
                address.setProperties(result);
              }
              if (address.name) {
                var names = util.nameUtil.splitName(address.name); // eslint-disable-line block-scoped-var,no-undef

                user.setProperties(names);
              }
              flag.addrPrefilled = true;
              $timeout(function () {
                flag.addrPrefilled = true;
              }, 1000);
            },
            contingencies: {
              DEFAULT: function DEFAULT() {
                flag.addrPrefilled = true;
              }
            }
          });
        };
        $scope.uponNormalization = function uponNormalization(normalizedAddress, isBack) {
          if (normalizeCallback) {
            normalizeCallback(normalizedAddress, isBack);
          }
        };

        /* Eligibility Check call is done only after first load. Hence is done in the parent directive
         * and not in addCard directive. Addcard directive will be called after each back button
         * rendering
         */
        function isInstallmentEligible() {
          $populate($scope, {
            payee: $CheckoutPayeeModel.instance($scope.token),
            checkoutCart: $CheckoutCartModel.instance($scope.token),
            checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
          }).then(function () {
            // Installment options should not show up for payment_action authorize/order
            if ($scope.checkoutCart.isBilling() || $scope.checkoutCart.payment_action !== 'sale') {
              // Reference transaction detected
              $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
            } else {
              $scope.multistepSignupModel.eligibilityModel = {};
              var installments = $InstallmentOptionsModel.instance($scope.token);

              /* Updating the eligibilityModel with the installment response.
               * Show Or hide of installment depends upon the card type.
               * Card model changes for type is checked in addCard directive to determine installment display.
               */
              installments.save({
                data: {
                  payee: $scope.payee,
                  checkoutCart: $scope.checkoutCart,
                  checkoutAppData: $scope.checkoutAppData
                },
                resultModel: $scope.multistepSignupModel.eligibilityModel
              }).then(function () {
                $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
              });
            }
          });
        }
        if ($feature('installments', false, $locale.country)) {
          isInstallmentEligible();
        } else {
          // BUG - switching from BR to RU country needs this timeout
          // Without timeout the route change is so fast that it just loads an empty cached page
          // without the form elements
          $timeout(function () {
            $location.path('/checkout/multistepsignup/multistepsignupaddcard').replace();
          });
        }
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('xomultistepsignupmodel', ['squid']).factory('$MultistepSignupModel', ['$Model', function ($Model) {
    return $Model.extend('MultistepSignupModel', {});
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup", "../node_modules/xo-guest-components/src/multistep-signup/index.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/lib/util.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  var name = {
    splitName: function splitName(fullName) {
      var index = fullName.indexOf(' ');
      return {
        first_name: index > 0 ? fullName.substr(0, index) : fullName,
        last_name: index > 0 ? fullName.substr(index + 1) : ''
      };
    }
  };
  var masking = {
    maskZip: function maskZip(value) {
      if (value) {
        var unformatted = value.replace(/[^0-9]/gi, '');
        return unformatted.length > 5 ? [unformatted.slice(0, 5), '-', unformatted.slice(5)].join('') : unformatted;
      }
      return '';
    }
  };
  var validateLegalAge = function validateLegalAge(dobMonth, dobDay, dobYear) {
    var currentDate = new Date();
    var currentMonth = currentDate.getMonth() + 1;
    var currentDay = currentDate.getDate();
    var currentYear = currentDate.getFullYear();
    var largestDOBYear = currentYear - 18; // Legal age is 18

    var isLegal = dobYear < largestDOBYear || dobYear === largestDOBYear && dobMonth < currentMonth || dobYear === largestDOBYear && dobMonth === currentMonth && dobDay <= currentDay;
    return isLegal;
  };
  var componentsMap = function componentsMap(locale) {
    var flags = {};
    switch (locale) {
      case 'BR':
        flags = {
          zipCode: true,
          billingAddressLabel: false,
          shippingAddress: false,
          shippingAddressPage: true,
          dobDropDown: true,
          addTaxId: true
        };
        break;
      case 'RU':
        flags = {
          zipCode: false,
          billingAddressLabel: true,
          shippingAddress: true,
          shippingAddressPage: false,
          dobDropDown: false,
          dobText: true
        };
        break;
      default:
        flags = {
          nameInput: true,
          zipCode: true,
          billingAddressLabel: true,
          shippingAddress: true,
          dobDropDown: true
        };
        break;
    }
    return flags;
  };
  var contingencyMap = function contingencyMap(code) {
    var errorElementMap = {
      INVALID_FIRST_NAME: {
        fields: [{
          field: 'first_name'
        }],
        model: 'user.',
        path: 'multistepsignupaddcard'
      },
      INVALID_LAST_NAME: {
        fields: [{
          field: 'last_name'
        }],
        model: 'user.',
        path: 'multistepsignupaddcard'
      },
      INVALID_MIDDLE_NAME: {
        fields: [{
          field: 'middle_name'
        }],
        model: 'user.',
        path: 'multistepsignupaddcard'
      },
      INVALID_NATIVE_FIRST_NAME: {
        fields: [{
          field: 'first_name'
        }],
        model: 'user.',
        path: 'multistepsignupcreateaccount'
      },
      INVALID_NATIVE_LAST_NAME: {
        fields: [{
          field: 'last_name'
        }],
        model: 'user.',
        path: 'multistepsignupcreateaccount'
      },
      INVALID_NATIVE_MIDDLE_NAME: {
        fields: [{
          field: 'middle_name'
        }],
        model: 'user.nativeName.',
        path: 'multistepsignupcreateaccount'
      },
      INVALID_PHONE_TYPE: {
        fields: [{
          field: 'phoneType'
        }],
        model: 'phone.',
        path: 'multistepsignupaddcard'
      },
      INVALID_PHONE_NUMBER: {
        fields: [{
          field: 'telephone'
        }],
        model: 'phone.',
        path: 'multistepsignupaddcard'
      },
      INVALID_CITY_STATE_ZIPCODE: {
        fields: [{
          field: 'city'
        }, {
          field: 'state'
        }, {
          field: 'zipCode'
        }],
        model: 'address.',
        path: 'multistepsignupaddcard'
      },
      INVALID_LINE1: {
        fields: [{
          field: 'line1'
        }],
        model: 'address.',
        path: 'multistepsignupaddcard'
      },
      INVALID_CITY: {
        fields: [{
          field: 'city'
        }],
        model: 'address.',
        path: 'multistepsignupaddcard'
      },
      INVALID_STATE: {
        fields: [{
          field: 'state'
        }],
        model: 'address.',
        path: 'multistepsignupaddcard'
      },
      INVALID_ZIPCODE: {
        fields: [{
          field: 'zipCode'
        }],
        model: 'address.',
        path: 'multistepsignupaddcard'
      },
      INVALID_NATIONAL_ID_TYPE: {
        fields: [{
          field: 'type'
        }],
        model: 'nationalIdModel.nationalId.',
        path: 'multistepsignupcreateaccount'
      },
      INVALID_NATIONAL_ID: {
        fields: [{
          field: 'Id'
        }],
        name: 'national',
        path: 'multistepsignupcreateaccount'
      },
      INVALID_SECONDARY_ID_TYPE: {
        fields: [{
          field: 'secondaryIdType'
        }],
        model: 'nationalIdModel.',
        path: 'multistepsignupcreateaccount'
      },
      INVALID_SECONDARY_ID: {
        fields: [{
          field: 'secondaryIdValue'
        }],
        model: 'nationalIdModel.',
        path: 'multistepsignupcreateaccount'
      },
      INVALID_CARD_NUMBER: {
        path: 'multistepsignupaddcard'
      },
      INVALID_BILLING_ADDRESS: {
        model: 'address.',
        path: 'multistepsignupaddcard'
      },
      INVALID_SHIPPING_ADDRESS: {
        model: 'address.',
        path: 'multistepsignupaddshipping'
      },
      INVALID_EXPIRY: {
        path: 'multistepsignupaddcard'
      },
      PASSWORD_CONTAINS_FORBIDDEN_WORDS: {
        fields: [{
          field: 'password'
        }, {
          field: 'confirmPassword'
        }],
        model: 'user.',
        path: 'multistepsignupcreateaccount'
      },
      PASSWORD_HAS_ILLEGAL_CHARACTERS: {
        fields: [{
          field: 'password'
        }, {
          field: 'confirmPassword'
        }],
        model: 'user.',
        path: 'multistepsignupcreateaccount'
      },
      ACCOUNT_ALREADY_EXISTS: {
        fields: [{
          field: 'user.email'
        }],
        pageError: {
          contentKey: 'login.userMayHaveAccount'
        },
        compileMessageWith: {
          href: 'loginRedirectUrl'
        },
        path: 'multistepsignupcreateaccount'
      },
      DOB_INVALID: {
        fields: [{
          field: 'user.dob_day'
        }, {
          field: 'user.dob_month'
        }, {
          field: 'user.dob_year'
        }],
        path: 'multistepsignupcreateaccount'
      },
      CC_NUMBER_BLOCKED: {
        model: 'card.',
        pageError: {
          contentKey: 'creditcard.errorGeneral'
        },
        path: 'multistepsignupaddcard'
      },
      COUNTRY_NOT_SUPPORTED: {
        model: 'card.',
        pageError: {
          contentKey: 'creditcard.complianceDecline'
        },
        path: 'multistepsignupaddcard'
      },
      CARD_GENERIC_ERROR: {
        model: 'card.',
        pageError: {
          contentKey: 'creditcard.errorGeneral'
        },
        path: 'multistepsignupaddcard'
      }
    };
    return errorElementMap[code];
  };
  var util = {};
  util.nameUtil = name;
  util.maskingUtil = masking;
  util.componentsMap = componentsMap;
  util.contingencyMap = contingencyMap;
  util.validateLegalAge = validateLegalAge;
  return util;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-guest-components/src/multistep-signup/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addCard/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addShipping/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/createAccount/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/addressNormalization/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-multistep-signup.route', ['squid', 'xo-multistep-signup.directive', 'xo-multistep-signup-add-card.route', 'xo-multistep-signup-add-shipping.route', 'xo-multistep-signup-create-account.route', 'xo-multistep-signup-address-normalization.route']).factory('$MultistepSignupRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('MultistepSignupRoute', {
      name: 'multistepsignup',
      directive: 'xo-multistep-signup',
      children: [{
        name: '$MultistepSignupAddCardRoute',
        attributes: {
          token: 'token',
          'multistep-signup-model': 'multistepSignupModel',
          'position-to-error-field': 'positionToErrorField',
          'back-state': 'backState',
          'backend-error': 'backendError',
          'clear-backend-error': 'clearBackendError',
          'normalize-address': 'normalizeAddress',
          'prefill-address-common': 'prefillAddressCommon',
          'button-params': 'buttonParams'
        }
      }, {
        name: '$MultistepSignupAddShippingRoute',
        attributes: {
          token: 'token',
          'multistep-signup-model': 'multistepSignupModel',
          'position-to-error-field': 'positionToErrorField',
          'back-state': 'backState',
          'backend-error': 'backendError',
          'clear-backend-error': 'clearBackendError',
          'normalize-address': 'normalizeAddress',
          'prefill-address-common': 'prefillAddressCommon'
        }
      }, {
        name: '$MultistepSignupCreateAccountRoute',
        attributes: {
          token: 'token',
          'multistep-signup-model': 'multistepSignupModel',
          'position-to-error-field': 'positionToErrorField',
          'back-state': 'backState',
          'backend-error': 'backendError',
          'clear-backend-error': 'clearBackendError'
        }
      }, {
        name: '$MultistepSignupAddressNormalizationRoute',
        attributes: {
          token: 'token',
          address: 'multistepSignupModel.onboard.toBeNormalizedAddress',
          'done-fn': 'uponNormalization'
        }
      }]
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-guest-components/src/multistep-signup", "../node_modules/xo-guest-components/src/multistep-signup/route.js"))

/***/ }),

/***/ "../node_modules/xo-guest-components/src/phone-confirmation-interstitial/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.ERRORS_WITH_MESSAGE_MAPPING = exports.DEFAULT_ERROR_MESSAGE_KEY = void 0;
var ERRORS_WITH_MESSAGE_MAPPING = exports.ERRORS_WITH_MESSAGE_MAPPING = ['BAD_REQUEST', 'VALIDATION_ERROR', 'SEND_NOTIFICATION_FAILED', 'CREATE_ATTEMPTS_EXCEEDED_LIMIT', 'CONFIRM_ATTEMPTS_EXCEEDED_LIMIT', 'PIN_NOT_FOUND', 'PIN_EXPIRED', 'INCORRECT_PIN', 'UNSUPPORTED_COUNTRY', 'INTERNAL_SERVICE_ERROR'];
var DEFAULT_ERROR_MESSAGE_KEY = exports.DEFAULT_ERROR_MESSAGE_KEY = '2faPhoneConfirmation.errors.BAD_REQUEST';

/***/ }),

/***/ "../node_modules/xo-guest-components/src/phone-confirmation-interstitial/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _phoneConfirmation = __webpack_require__("../node_modules/xo-models/src/phoneConfirmation/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-guest-components/src/phone-confirmation-interstitial/template.html"));
__webpack_require__("../node_modules/xo-guest-components/src/phone-confirmation-interstitial/styles.less");
var _constants = __webpack_require__("../node_modules/xo-guest-components/src/phone-confirmation-interstitial/constants.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('xoPhoneConfirmationInterstitial', {
  tag: 'xo-phone-confirmation-interstitial',
  template: _template["default"],
  props: {
    phoneDetails: {
      type: 'var',
      required: true
    },
    onPhoneConfirmationSuccess: {
      type: 'var',
      required: true
    }
  },
  lifecycle: {
    enter: function enter() {
      // There is a ramp in phone-input between phone-input-a and phone-input-b
      // phoneCountryCode - phone-input-a will have this key
      // phoneCountry - phone-input-b will have this key
      var _ref = this.phoneDetails || {},
        phoneNumber = _ref.telephone,
        phoneCountry = _ref.phoneCountry,
        phoneCountryCode = _ref.phoneCountryCode;

      // Make sure meta is not undefined, as we add verificationId to
      // meta object upon successful completion of phone verification
      this.phoneDetails.meta = this.phoneDetails.meta || {};
      this.phoneConfirmationModel = new _phoneConfirmation.$PhoneConfirmationModel();
      this.phoneConfirmationModel.phoneNumber = phoneNumber;
      this.phoneConfirmationModel.locale = {
        country: _squid.$locale.country,
        lang: _squid.$locale.lang
      };
      this.phoneConfirmationModel.phoneCountry = phoneCountry || phoneCountryCode;

      // Contingency handler function for both init and confirm call
      this.contingencyHandler = function contingencyHandler(apiType, name) {
        _logger.$logger.info("phone_confirmation_" + apiType + "_contingency_" + name);
        _logger.$logger.info('checkout_fpti', {
          from: 'phone_confirmation',
          to: "process_" + apiType + "_api_phone_confirmation",
          int_error_code: name
        });

        // Default error message
        this.errorMessageKey = _constants.DEFAULT_ERROR_MESSAGE_KEY;
        if (_constants.ERRORS_WITH_MESSAGE_MAPPING.indexOf(name) > -1) {
          this.errorMessageKey = "2faPhoneConfirmation.errors." + name;
        }
        this.showError = true;
      };

      // Error handler function for both init and confirm call
      this.errorHandler = function errorHandler(apiType, err) {
        _logger.$logger.info("phone_confirmation_" + apiType + "_error", err);
        _logger.$logger.info('checkout_fpti', {
          from: 'phone_confirmation',
          to: "process_" + apiType + "_api_phone_confirmation",
          int_error_code: err.name,
          int_error_description: err.message
        });
        this.errorMessageKey = _constants.DEFAULT_ERROR_MESSAGE_KEY;
        this.showError = true;
      };
    },
    populate: function populate() {
      _logger.$logger.info('checkout_fpti', {
        from: 'phone_confirmation',
        to: 'prepare_phone_confirmation'
      });
      // call initiatePhoneConfirmation
      this.actions.initiatePhoneConfirmation();

      // set the china upop flag on event heard
      // based on upop detected
      this.$watch('phoneConfirmationModel.pin', function (newVal) {});
    }
  },
  actions: {
    // This function is called on component load and
    // when user clicks on "resend" button in UI
    initiatePhoneConfirmation: function initiatePhoneConfirmation(event) {
      var _this = this;
      var apiType = 'init';
      if (event) {
        event.preventDefault();
        _logger.$logger.info('phone_confirmation_resend_button_clicked');
        _logger.$logger.info('checkout_fpti', {
          from: 'phone_confirmation',
          to: 'prepare_resend'
        });
      }
      _logger.$logger.info('checkout_fpti', {
        from: 'phone_confirmation',
        to: "prepare_" + apiType + "_api_phone_confirmation"
      });
      this.phoneConfirmationModel.action('initiate', {
        data: this.phoneConfirmationModel.serializeInitiateData(),
        silent: true,
        success: function success(result) {
          var id = result.id,
            state = result.state;
          // validUntil Object looks like - { timeMedium: "10:18:00 AM" }
          var _ref2 = result.validUntil || {},
            validUntil = _ref2.timeMedium;
          _this.phoneConfirmationModel.verificationId = id;
          _this.phoneConfirmationModel.state = state;
          _this.phoneConfirmationModel.validUntil = validUntil;
          _logger.$logger.info('checkout_fpti', {
            from: 'phone_confirmation',
            to: "process_" + apiType + "_api_phone_confirmation"
          });
        },
        error: function error(err) {
          _this.errorHandler(apiType, err);
        },
        contingencies: {
          DEFAULT: function DEFAULT(name) {
            _this.contingencyHandler(apiType, name);
          }
        }
      });
    },
    onChange: function onChange() {
      this.showError = false;
      this.errorMessageKey = '';
    },
    onFocus: function onFocus() {
      _logger.$logger.info('checkout_fpti', {
        from: 'phone_confirmation',
        to: 'code_entry_start'
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      var apiType = 'confirm';
      _logger.$logger.info('checkout_fpti', {
        from: 'phone_confirmation',
        to: 'process_phone_confirmation'
      });
      _logger.$logger.info('checkout_fpti', {
        from: 'phone_confirmation',
        to: "prepare_" + apiType + "_api_phone_confirmation"
      });
      this.phoneConfirmationModel.action('confirm', {
        data: this.phoneConfirmationModel.serializeConfirmData(),
        success: function success(result) {
          result = result || {};
          if (result.state === 'CONFIRMED') {
            // Assign the verificationId only upon confirmation success
            _this2.phoneDetails.meta.verificationId = result.id;
            _logger.$logger.info('checkout_fpti', {
              from: 'phone_confirmation',
              to: "process_" + apiType + "_api_phone_confirmation"
            });
            _this2.onPhoneConfirmationSuccess();
          } else {
            _this2.errorMessageKey = _constants.DEFAULT_ERROR_MESSAGE_KEY;
            _this2.showError = true;
          }
        },
        error: function error(err) {
          _this2.errorHandler(apiType, err);
        },
        contingencies: {
          DEFAULT: function DEFAULT(name) {
            _this2.contingencyHandler(apiType, name);
          }
        }
      });
    }
  }
});
_squid.$Component;
_squid.$locale;
_logger.$logger;
_phoneConfirmation.$PhoneConfirmationModel;
_constants.ERRORS_WITH_MESSAGE_MAPPING;
_constants.DEFAULT_ERROR_MESSAGE_KEY;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-guest-components/src/phone-confirmation-interstitial/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-guest-components/src/phone-confirmation-interstitial/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"phoneConfirmationContainer\" content>\n    <h1>{{content('2faPhoneConfirmation.title')}}</h1>\n    <p>{{content('2faPhoneConfirmation.mainMessage', { phoneNumber: phoneDetails.telephone })}}</p>\n    <form\n        id=\"phoneConfirmationForm\"\n        name=\"phoneConfirmationForm\"\n        ng-class=\"{'validated': validated }\"\n        ng-submit=\"phoneConfirmationForm.$valid && actions.onSubmit()\"\n        novalidate\n    >\n        <div class=\"inputField confirmationCodeField confidential\" floating-label directionality>\n            <!-- type=\"text\" because if we enter 000000 in staging, the validation and api call fails -->\n            <!-- 000000 with type=\"numeric\" is considered as 0 -->\n            <input\n                autocomplete=\"off\"\n                class=\"confirmationCode\"\n                inputmode=\"numeric\"\n                min=\"6\"\n                name=\"confirmationCode\"\n                ng-change=\"actions.onChange()\"\n                ng-class=\"{'backendError': showError }\"\n                ng-focus=\"actions.onFocus()\"\n                ng-model=\"phoneConfirmationModel.pin\"\n                ng-required=\"true\"\n                pattern=\"[0-9]{6}\"\n                required\n                type=\"text\"\n                value=\"\"\n            />\n            <div class=\"resend\">\n                <button\n                   aria-label=\"{{ content('2faPhoneConfirmation.resendButtonTitle') }}\"\n                   ng-click=\"actions.initiatePhoneConfirmation($event)\"\n                >\n                    {{ content('2faPhoneConfirmation.resendButtonTitle') }}\n                </button>\n            </div>\n            <label for=\"phoneConfirmation\">\n                {{content('2faPhoneConfirmation.phoneInputLabel')}}\n            </label>\n        </div>\n        <p class=\"errorMessage\" ng-if=\"showError\">{{ content(errorMessageKey) }}</p>\n\n        <input\n            class=\"btn full\"\n            id=\"phoneConfirmationSubmit\"\n            ng-click=\"validated = true\"\n            track-submit=\"xoon_phone_confirmation_submit\"\n            type=\"submit\"\n            value=\"{{content('2faPhoneConfirmation.continueButtonTitle')}}\"\n        />\n    </form>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-jquery-mask-plugin/dist/jquery.mask.min.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery, global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var jquery = __webpack_provided_window_dot_jQuery;

// jQuery Mask Plugin v1.14.11
// github.com/igorescobar/jQuery-Mask-Plugin
var $jscomp={scope:{},findInternal:function(a,l,d){a instanceof String&&(a=String(a));for(var p=a.length,h=0;h<p;h++){var b=a[h];if(l.call(d,b,h,a))return{i:h,v:b}}return{i:-1,v:void 0}}};$jscomp.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(a,l,d){if(d.get||d.set)throw new TypeError("ES3 does not support getters and setters.");a!=Array.prototype&&a!=Object.prototype&&(a[l]=d.value)};
$jscomp.getGlobal=function(a){return"undefined"!=typeof window&&window===a?a:"undefined"!=typeof global&&null!=global?global:a};$jscomp.global=$jscomp.getGlobal(this);$jscomp.polyfill=function(a,l,d,p){if(l){d=$jscomp.global;a=a.split(".");for(p=0;p<a.length-1;p++){var h=a[p];h in d||(d[h]={});d=d[h]}a=a[a.length-1];p=d[a];l=l(p);l!=p&&null!=l&&$jscomp.defineProperty(d,a,{configurable:!0,writable:!0,value:l})}};
$jscomp.polyfill("Array.prototype.find",function(a){return a?a:function(a,d){return $jscomp.findInternal(this,a,d).v}},"es6-impl","es3");
(function(a,l,d){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof exports?module.exports=a(require("jquery")):a(l||d)})(function(a){var l=function(b,e,f){var c={invalid:[],getCaret:function(){try{var a,r=0,g=b.get(0),e=document.selection,f=g.selectionStart;if(e&&-1===navigator.appVersion.indexOf("MSIE 10"))a=e.createRange(),a.moveStart("character",-c.val().length),r=a.text.length;else if(f||"0"===f)r=f;return r}catch(C){}},setCaret:function(a){try{if(b.is(":focus")){var c,
g=b.get(0);g.setSelectionRange?g.setSelectionRange(a,a):(c=g.createTextRange(),c.collapse(!0),c.moveEnd("character",a),c.moveStart("character",a),c.select())}}catch(B){}},events:function(){b.on("keydown.mask",function(a){b.data("mask-keycode",a.keyCode||a.which);b.data("mask-previus-value",b.val());b.data("mask-previus-caret-pos",c.getCaret());c.maskDigitPosMapOld=c.maskDigitPosMap}).on(a.jMaskGlobals.useInput?"input.mask":"keyup.mask",c.behaviour).on("paste.mask drop.mask",function(){setTimeout(function(){b.keydown().keyup()},
100)}).on("change.mask",function(){b.data("changed",!0)}).on("blur.mask",function(){d===c.val()||b.data("changed")||b.trigger("change");b.data("changed",!1)}).on("blur.mask",function(){d=c.val()}).on("focus.mask",function(b){!0===f.selectOnFocus&&a(b.target).select()}).on("focusout.mask",function(){f.clearIfNotMatch&&!h.test(c.val())&&c.val("")})},getRegexMask:function(){for(var a=[],b,c,f,n,d=0;d<e.length;d++)(b=m.translation[e.charAt(d)])?(c=b.pattern.toString().replace(/.{1}$|^.{1}/g,""),f=b.optional,
(b=b.recursive)?(a.push(e.charAt(d)),n={digit:e.charAt(d),pattern:c}):a.push(f||b?c+"?":c)):a.push(e.charAt(d).replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&"));a=a.join("");n&&(a=a.replace(new RegExp("("+n.digit+"(.*"+n.digit+")?)"),"($1)?").replace(new RegExp(n.digit,"g"),n.pattern));return new RegExp(a)},destroyEvents:function(){b.off("input keydown keyup paste drop blur focusout ".split(" ").join(".mask "))},val:function(a){var c=b.is("input")?"val":"text";if(0<arguments.length){if(b[c]()!==a)b[c](a);
c=b}else c=b[c]();return c},calculateCaretPosition:function(){var a=b.data("mask-previus-value")||"",e=c.getMasked(),g=c.getCaret();if(a!==e){var f=b.data("mask-previus-caret-pos")||0,e=e.length,d=a.length,m=a=0,h=0,l=0,k;for(k=g;k<e&&c.maskDigitPosMap[k];k++)m++;for(k=g-1;0<=k&&c.maskDigitPosMap[k];k--)a++;for(k=g-1;0<=k;k--)c.maskDigitPosMap[k]&&h++;for(k=f-1;0<=k;k--)c.maskDigitPosMapOld[k]&&l++;g>d?g=e:f>=g&&f!==d?c.maskDigitPosMapOld[g]||(f=g,g=g-(l-h)-a,c.maskDigitPosMap[g]&&(g=f)):g>f&&(g=
g+(h-l)+m)}return g},behaviour:function(f){f=f||window.event;c.invalid=[];var e=b.data("mask-keycode");if(-1===a.inArray(e,m.byPassKeys)){var e=c.getMasked();setTimeout(function(){c.setCaret(c.calculateCaretPosition())},10);c.val(e);c.setCaret(e.length);return c.callbacks(f)}},getMasked:function(a,b){var g=[],d=void 0===b?c.val():b+"",n=0,h=e.length,q=0,l=d.length,k=1,r="push",p=-1,t=0,y=[],v,z;f.reverse?(r="unshift",k=-1,v=0,n=h-1,q=l-1,z=function(){return-1<n&&-1<q}):(v=h-1,z=function(){return n<
h&&q<l});for(var A;z();){var x=e.charAt(n),w=d.charAt(q),u=m.translation[x];if(u)w.match(u.pattern)?(g[r](w),u.recursive&&(-1===p?p=n:n===v&&(n=p-k),v===p&&(n-=k)),n+=k):w===A?(t--,A=void 0):u.optional?(n+=k,q-=k):u.fallback?(g[r](u.fallback),n+=k,q-=k):c.invalid.push({p:q,v:w,e:u.pattern}),q+=k;else{if(!a)g[r](x);w===x?(y.push(q),q+=k):(A=x,y.push(q+t),t++);n+=k}}d=e.charAt(v);h!==l+1||m.translation[d]||g.push(d);g=g.join("");c.mapMaskdigitPositions(g,y,l);return g},mapMaskdigitPositions:function(a,
b,e){a=f.reverse?a.length-e:0;c.maskDigitPosMap={};for(e=0;e<b.length;e++)c.maskDigitPosMap[b[e]+a]=1},callbacks:function(a){var h=c.val(),g=h!==d,m=[h,a,b,f],q=function(a,b,c){"function"===typeof f[a]&&b&&f[a].apply(this,c)};q("onChange",!0===g,m);q("onKeyPress",!0===g,m);q("onComplete",h.length===e.length,m);q("onInvalid",0<c.invalid.length,[h,a,b,c.invalid,f])}};b=a(b);var m=this,d=c.val(),h;e="function"===typeof e?e(c.val(),void 0,b,f):e;m.mask=e;m.options=f;m.remove=function(){var a=c.getCaret();
c.destroyEvents();c.val(m.getCleanVal());c.setCaret(a);return b};m.getCleanVal=function(){return c.getMasked(!0)};m.getMaskedVal=function(a){return c.getMasked(!1,a)};m.init=function(d){d=d||!1;f=f||{};m.clearIfNotMatch=a.jMaskGlobals.clearIfNotMatch;m.byPassKeys=a.jMaskGlobals.byPassKeys;m.translation=a.extend({},a.jMaskGlobals.translation,f.translation);m=a.extend(!0,{},m,f);h=c.getRegexMask();if(d)c.events(),c.val(c.getMasked());else{f.placeholder&&b.attr("placeholder",f.placeholder);b.data("mask")&&
b.attr("autocomplete","off");d=0;for(var l=!0;d<e.length;d++){var g=m.translation[e.charAt(d)];if(g&&g.recursive){l=!1;break}}l&&b.attr("maxlength",e.length);c.destroyEvents();c.events();c.val(c.getMasked());c.setCaret(c.getMasked().length)}};m.init(!b.is("input"))};a.maskWatchers={};var d=function(){var b=a(this),e={},f=b.attr("data-mask");b.attr("data-mask-reverse")&&(e.reverse=!0);b.attr("data-mask-clearifnotmatch")&&(e.clearIfNotMatch=!0);"true"===b.attr("data-mask-selectonfocus")&&(e.selectOnFocus=
!0);if(p(b,f,e))return b.data("mask",new l(this,f,e))},p=function(b,e,f){f=f||{};var c=a(b).data("mask"),d=JSON.stringify;b=a(b).val()||a(b).text();try{return"function"===typeof e&&(e=e(b)),"object"!==typeof c||d(c.options)!==d(f)||c.mask!==e}catch(t){}},h=function(a){var b=document.createElement("div"),d;a="on"+a;d=a in b;d||(b.setAttribute(a,"return;"),d="function"===typeof b[a]);return d};a.fn.mask=function(b,d){d=d||{};var e=this.selector,c=a.jMaskGlobals,h=c.watchInterval,c=d.watchInputs||c.watchInputs,
t=function(){if(p(this,b,d))return a(this).data("mask",new l(this,b,d))};a(this).each(t);e&&""!==e&&c&&(clearInterval(a.maskWatchers[e]),a.maskWatchers[e]=setInterval(function(){a(document).find(e).each(t)},h));return this};a.fn.masked=function(a){return this.data("mask").getMaskedVal(a)};a.fn.unmask=function(){clearInterval(a.maskWatchers[this.selector]);delete a.maskWatchers[this.selector];return this.each(function(){var b=a(this).data("mask");b&&b.remove().removeData("mask")})};a.fn.cleanVal=function(){return this.data("mask").getCleanVal()};
a.applyDataMask=function(b){b=b||a.jMaskGlobals.maskElements;(b instanceof a?b:a(b)).filter(a.jMaskGlobals.dataMaskAttr).each(d)};h={maskElements:"input,td,span,div",dataMaskAttr:"*[data-mask]",dataMask:!0,watchInterval:300,watchInputs:!0,useInput:!/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent)&&h("input"),watchDataMask:!1,byPassKeys:[9,16,17,18,36,37,38,39,40,91],translation:{0:{pattern:/\d/},9:{pattern:/\d/,optional:!0},"#":{pattern:/\d/,recursive:!0},A:{pattern:/[a-zA-Z0-9]/},
S:{pattern:/[a-zA-Z]/}}};a.jMaskGlobals=a.jMaskGlobals||{};h=a.jMaskGlobals=a.extend(!0,{},h,a.jMaskGlobals);h.dataMask&&a.applyDataMask();setInterval(function(){a.jMaskGlobals.watchDataMask&&a.applyDataMask()},h.watchInterval)},__webpack_provided_window_dot_jQuery,window.Zepto);


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/xo-locale/dist/country.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-locale/dist/helper.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/auth/index.js"), __webpack_require__("../node_modules/xo-models/src/app/index.js"), __webpack_require__("../node_modules/xo-models/src/onboard/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('locale.resolvers.country', ['squid', 'locale.helper', 'xomodel.checkout', 'xomodel.auth', 'xomodel.app', 'xomodel.onboard']).factory('$CountryResolvers', function ($q, $rootScope, $populate, $util, $meta, $localeHelper, $locale, $AuthModel, $CheckoutCartModel, $AppDataModel, $CheckoutAppDataModel, $GuestUpgradeModel) {
    return {
      viaCountryPreference: {
        method: function method() {
          return $locale.chosenCountry;
        }
      },
      viaLocaleTestUrlParam: {
        desc: 'For non-LIVE test, read from locale.test url param, e.g. http://localhost.com:3000/?locale.test=fr_FR',
        method: function method() {
          var locale = $util.param('locale.test');
          if (locale) {
            return $localeHelper.normalizeLocale(locale).country;
          }
        }
      },
      viaMerchantParam: {
        desc: 'As part of url merchants can pass the locale.x=en_FR or country.x=FR. Here we extract the country param',
        method: function method() {
          var country = $util.param('country.x');
          if (country) {
            return country;
          }
          var locale = $util.param('locale.x');
          return $localeHelper.normalizeLocale(locale).country;
        }
      },
      viaUserProfile: {
        desc: 'From AuthModel. Country comes as "US", "FR" etc. ',
        method: function method() {
          var data = {};
          return $populate(data, {
            auth: $AuthModel.instance()
          }).then(function () {
            return data.auth.country;
          });
        }
      },
      viaCheckoutSession: {
        desc: 'From Merchant locale in CheckoutAppDataModel. merchant_locale comes as en_US etc.',
        method: function method() {
          // check before creating $CheckoutAppDataModel
          if (!$rootScope.token) {
            return;
          }
          var data = {};
          return $populate(data, {
            checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
          }).then(function () {
            var merchant_locale = data.checkoutAppData.get('merchant.merchant_locale');
            if (!merchant_locale) {
              return;
            }
            if (merchant_locale.match(/^\w{2}_\w{2}$/)) {
              return $localeHelper.normalizeLocale(merchant_locale).country;
            }
            return merchant_locale;
          });
        }
      },
      viaCheckoutBilling: {
        desc: 'From Merchant passed billingAddress in CheckoutCart.',
        method: function method() {
          // check before creating $CheckoutCartModel
          if (!$rootScope.token) {
            return;
          }
          var data = {};
          return $populate(data, {
            checkoutCart: $CheckoutCartModel.instance($rootScope.token)
          }).then(function () {
            return data.checkoutCart.get('payer_info.billing_address.country_code');
          });
        }
      },
      viaCheckoutShipping: {
        method: function method() {
          // check before creating $CheckoutCartModel
          if (!$rootScope.token) {
            return;
          }
          var data = {};
          return $populate(data, {
            checkoutCart: $CheckoutCartModel.instance($rootScope.token)
          }).then(function () {
            return data.checkoutCart.get('purchase.shipping_address.country_code');
          });
        }
      },
      viaMerchantCountry: {
        method: function method() {
          // check before creating $CheckoutAppDataModel
          if (!$rootScope.token) {
            return;
          }
          var data = {};
          return $populate(data, {
            checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
          }).then(function () {
            return data.checkoutAppData.get('merchant.merchant_country');
          });
        }
      },
      viaGuestAccountCountry: {
        desc: 'From Guest account legal country in ISO country code format (e.g. US, AU)',
        method: function method() {
          // only perform this resolver for guest-upgrade flow (has data param)
          if (!$util.param('data')) {
            return;
          }
          return $GuestUpgradeModel.instance().retrieve({
            error: angular.noop,
            transientError: true
          }).then(function (model) {
            return model.get('user.country');
          });
        }
      },
      viaCountryCoBrand: {
        method: function method() {
          return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
            return appData.get('locale_info.cobrand');
          });
        }
      },
      viaLangCookie: {
        method: function method() {
          return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
            return appData.get('locale_info.lang_cookie.country');
          });
        }
      },
      viaBrowserPref: {
        method: function method() {
          return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
            return appData.get('locale_info.browser_lang.country');
          });
        }
      },
      viaIP: {
        method: function method() {
          return $meta.ipcountry;
        }
      },
      viaDefault: {
        method: function method() {
          return 'US';
        }
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-locale/dist", "../node_modules/xo-locale/dist/country.js"))

/***/ }),

/***/ "../node_modules/xo-locale/dist/helper.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('locale.helper', ['squid']).factory('$localeHelper', function () {
    return {
      /**
       *
       * @param locale - Ex: en_US
       * @returns {{country: *, dialect}}
       */
      normalizeLocale: function normalizeLocale(locale) {
        if (!locale) {
          return {};
        }
        locale = locale.replace('-', '_');
        var country;
        var language;
        if (locale.match(/^\w{2}_\w{2}$/)) {
          locale = locale.split('_');
          language = locale[0];
          country = locale[1];
        } else {
          language = locale;
        }
        return {
          country: country,
          language: language
        };
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-locale/dist", "../node_modules/xo-locale/dist/helper.js"))

/***/ }),

/***/ "../node_modules/xo-locale/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js"), __webpack_require__("../node_modules/xo-locale/dist/resolvers.js"), __webpack_require__("../node_modules/xo-locale/dist/language.js"), __webpack_require__("../node_modules/xo-locale/dist/helper.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  return angular.module('xolocale', ['squid', 'beaver', 'locale.resolvers', 'locale.resolvers.language', 'locale.helper']);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-locale/dist/language.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-locale/dist/helper.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/auth/index.js"), __webpack_require__("../node_modules/xo-models/src/app/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('locale.resolvers.language', ['squid', 'locale.helper', 'xomodel.checkout', 'xomodel.auth', 'xomodel.app']).factory('$LanguageResolvers', function ($q, $rootScope, $populate, $util, $AuthModel, $config, $locale, $localeHelper, $CheckoutCartModel, $AppDataModel, $CheckoutAppDataModel) {
    var browserPrefCountries = ['US', 'GB', 'CA'];
    return {
      viaLanguagePreference: {
        method: function method(country) {
          return $locale.chosenLang;
        }
      },
      viaLocaleTestUrlParam: {
        desc: 'For non-LIVE test, read from locale.test url param, e.g. http://localhost.com:3000/?locale.test=fr_FR',
        method: function method() {
          var locale = $util.param('locale.test');
          if (locale) {
            return $localeHelper.normalizeLocale(locale).language;
          }
        }
      },
      viaMerchantParam: {
        desc: 'As part of url merchants can pass the locale.x=en_FR, were we extract the language param',
        method: function method() {
          var locale = $util.param('locale.x');
          if (locale) {
            return $localeHelper.normalizeLocale(locale).language;
          }
        }
      },
      viaUserProfile: {
        method: function method(country) {
          var data = {};
          return $populate(data, {
            auth: $AuthModel.instance()
          }).then(function () {
            var locale = $localeHelper.normalizeLocale(data.auth.language);
            return locale && locale.language;
          });
        }
      },
      viaMerchantLocale: {
        method: function method() {
          // check before creating $CheckoutAppDataModel
          if (!$rootScope.token) {
            return;
          }
          var data = {};
          return $populate(data, {
            checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
          }).then(function () {
            var merchant_locale = data.checkoutAppData.get('merchant.merchant_locale');
            if (!merchant_locale) {
              return;
            }
            if (!merchant_locale.match(/^\w{2}_\w{2}$/)) {
              return;
            }
            return $localeHelper.normalizeLocale(merchant_locale && merchant_locale).language;
          });
        }
      },
      viaLangCookie: {
        method: function method(country) {
          return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
            var lang_cookie = appData.get('locale_info.lang_cookie', {});
            if (lang_cookie.country === country) {
              return lang_cookie.language;
            }
          });
        }
      },
      viaBrowserPref: {
        method: function method(country) {
          if (browserPrefCountries.indexOf(country) === -1) {
            return $q.when();
          }
          return $AppDataModel.instance($rootScope.token).retrieve().then(function (appData) {
            return appData.get('locale_info.browser_lang.language');
          });
        }
      },
      viaDefault: {
        method: function method(country) {
          return $config.supportedCountries[country][0];
        }
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-locale/dist", "../node_modules/xo-locale/dist/language.js"))

/***/ }),

/***/ "../node_modules/xo-locale/dist/resolvers.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-locale/dist/country.js"), __webpack_require__("../node_modules/xo-locale/dist/language.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('locale.resolvers', [
  // eslint-disable-line angular/no-service-method
  'locale.resolvers.country', 'locale.resolvers.language']).service('$LocaleResolver', function ($locale, $Class, $util, $logger, $CountryResolvers, $LanguageResolvers, $config, $q) {
    var LocaleResolver = $Class.extend('LocaleResolver', {
      registerCountryResolver: function registerCountryResolver(name, resolver) {
        $CountryResolvers[name] = resolver;
      },
      registerLangResolver: function registerLangResolver(name, resolver) {
        $LanguageResolvers[name] = resolver;
      },
      resolvePromiseChain: function resolvePromiseChain(resolvers, validator, args) {
        var self = this;
        var promise = $q.when();
        var result;
        angular.forEach(resolvers, function (resolver) {
          promise = promise.then(function () {
            if (result) {
              return result;
            }
            return $q.when(resolver.method.apply(self, args || [])).then(function (resolved) {
              if (resolved && validator(resolved)) {
                result = {
                  resolver: resolver.name,
                  resolved: resolved
                };
                return result;
              }
            });
          }, angular.noop);
        });
        return promise;
      },
      resolveCountry: function resolveCountry() {
        var validator = function validator(country) {
          return Boolean(country && $config.supportedCountries[country]);
        };
        var resolvers = $util.map($config.locale.country.resolvers, function (name) {
          $CountryResolvers[name].name = name;
          return $CountryResolvers[name];
        });
        return this.resolvePromiseChain(resolvers, validator).then(function (resolved) {
          $logger.debug('resolve_country', {
            country: resolved.resolved,
            resolver: resolved.resolver
          });
          return resolved.resolved;
        });
      },
      resolveLanguage: function resolveLanguage(country) {
        var validator = function validator(language) {
          return Boolean($config.supportedCountries[country].indexOf(language) > -1);
        };
        var resolvers = $util.map($config.locale.lang.resolvers, function (name) {
          $LanguageResolvers[name].name = name;
          return $LanguageResolvers[name];
        });
        return this.resolvePromiseChain(resolvers, validator, [country]).then(function (resolved) {
          $logger.debug('resolve_lang', {
            lang: resolved.resolved,
            resolver: resolved.resolver
          });
          return resolved.resolved;
        });
      },
      setUserPreferredCountry: function setUserPreferredCountry(country) {
        $util.assert(country, 'No country provided');
        this.userPreferredCountry = country;
      },
      setUserPreferredLanguage: function setUserPreferredLanguage(language) {
        $util.assert(language, 'No language provided');
        this.userPreferredLanguage = language;
      },
      resolve: function resolve(preventContentLoad) {
        var self = this;
        function resolveCountry() {
          if (self.userPreferredCountry) {
            return $q.when(self.userPreferredCountry);
          }
          return self.resolveCountry();
        }
        function resolveLanguage(country) {
          if (self.userPreferredLanguage) {
            return $q.when(self.userPreferredLanguage);
          }
          return self.resolveLanguage(country);
        }
        return resolveCountry().then(function (country) {
          return resolveLanguage(country).then(function (language) {
            return {
              language: language,
              country: country
            };
          });
        }).then(function (result) {
          return $locale.change(result.country, result.language, preventContentLoad);
        });
      }
    });
    return new LocaleResolver();
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-locale/dist", "../node_modules/xo-locale/dist/resolvers.js"))

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _utils = __webpack_require__("../node_modules/xo-login-components/src/dolphin/utils.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-login-components/src/dolphin/template.html"));
__webpack_require__("../node_modules/xo-login-components/src/dolphin/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend({
  tag: 'xo-dolphin',
  template: _template["default"],
  actions: {
    startTimer: function startTimer() {
      var _this = this;
      _logger.$logger.info('xoDolphin_startTimer');
      // Set a 10 second timer to check if UL has loaded or not
      this.isTimerRunning = true;
      (0, _angular.$timeout)(function () {
        if (!_this.hasOverlayLoaded && _this.isTimerRunning) {
          _logger.$logger.info(_utils.flowName, {
            'from': 'show_banner',
            'to': 'overlay_timeout',
            'context_id': _angular.$rootScope.token
          });
          _this.isTimerRunning = false;
          _this.showSpinner = false;
        }
      }, this.timerDuration);
    },
    closeBanner: function closeBanner() {
      this.showBanner = false;
      _logger.$logger.info(_utils.flowName, {
        'from': 'show_banner',
        'to': 'close_banner',
        'context_id': _angular.$rootScope.token
      });
    },
    openOverlay: function openOverlay() {
      var _this2 = this;
      var onPostMessagesHandler = function onPostMessagesHandler(postMessage) {
        if (!angular.isObject(postMessage)) {
          try {
            postMessage = JSON.parse(postMessage);
          } catch (e) {
            _logger.$logger.info('xoDolphin_jsonParseFailed');
          }
        }
        if (!postMessage || !postMessage.data || !postMessage.data.event) {
          _logger.$logger.info('xoDolphin_invalidPostMessage');
          return;
        }
        _this2.showSpinner = false;
        if (postMessage.data.event === 'phoneConfirmationLoaded') {
          _this2.hasOverlayLoaded = true;
          _angular.$rootScope.$emit('loaded');
          _logger.$logger.info(_utils.flowName, {
            'from': 'show_banner',
            'to': 'overlay_loaded',
            'context_id': _angular.$rootScope.token
          });
        }
        if (postMessage.data.event === 'phoneConfirmationCompleted') {
          _this2.isPhoneConfirmed = true;
          // For auto triggered overlays (confirm3 & add3), the banner is hidden by default
          // Unhide it once phone confirmation completes or SMS to complete it is sent out
          if (_this2.toastParams.autoTriggeredOverlay) {
            _logger.$logger.info('xoDolphin_showBannerOnAutoTriggeredOverlay');
            _this2.showBanner = true;
          }
          _logger.$logger.info(_utils.flowName, {
            'from': 'show_banner',
            'to': 'successfully_confirmed',
            'context_id': _angular.$rootScope.token
          });
          _this2.actions.closeOverlay();
        }
        if (postMessage.data.event === 'smsSent') {
          // Set isPhoneConfirmed to true as user will complete the phone confirmation from sms
          // hence from app point of view it s completed for the 'current' request
          // Also, the experience is exactly the same (show success message)
          _this2.isPhoneConfirmed = true;
          _this2.successContent = _this2.toastParams.smsSentKey;
          _this2.showBanner = true;
          _logger.$logger.info(_utils.flowName, {
            'from': 'show_banner',
            'to': 'sms_sent',
            'context_id': _angular.$rootScope.token
          });
          _this2.actions.closeOverlay();
        }
        if (postMessage.data.event === 'phoneConfirmationError') {
          _this2.hasOverlayLoaded = true;
          _logger.$logger.info(_utils.flowName, {
            'from': 'show_banner',
            'to': 'generic_error',
            'context_id': _angular.$rootScope.token
          });
          _this2.actions.closeOverlay();
        }
        if (postMessage.data.event === 'close') {
          _this2.hasOverlayLoaded = true;
          _this2.actions.closeOverlay();
        }

        // One Touch WPS Post Messages
        if (postMessage.data.event === 'oneTouchWPSError') {
          _this2.hasOverlayLoaded = true;
          _logger.$logger.info(_utils.flowName, {
            'from': 'one_touch_wps',
            'to': 'error',
            'context_id': _angular.$rootScope.token
          });
          _this2.actions.closeOverlay();
        }
        if (postMessage.data.event === 'oneTouchWPSViewLoaded') {
          _this2.hasOverlayLoaded = true;
          _logger.$logger.info(_utils.flowName, {
            'from': 'one_touch_wps',
            'to': 'view_loaded',
            'context_id': _angular.$rootScope.token
          });
        }
        if (postMessage.data.event === 'oneTouchWPSActivateButtonClicked') {
          _logger.$logger.info(_utils.flowName, {
            'from': 'one_touch_wps',
            'to': 'activate',
            'context_id': _angular.$rootScope.token
          });
        }
        if (postMessage.data.event === 'oneTouchWPSSuccess') {
          _logger.$logger.info(_utils.flowName, {
            'from': 'one_touch_wps',
            'to': 'success',
            'context_id': _angular.$rootScope.token
          });
          (0, _angular.$timeout)(function () {
            _this2.actions.closeOverlay();
          }, 3000);
        }
        if (postMessage.data.event === 'oneTouchWPSNotNowClicked') {
          _logger.$logger.info(_utils.flowName, {
            'from': 'one_touch_wps',
            'to': 'not_now',
            'context_id': _angular.$rootScope.token
          });
          _this2.actions.closeOverlay();
        }
      };
      (0, _angular.$timeout)(function () {
        _logger.$logger.info(_utils.flowName, {
          'from': 'show_banner',
          'to': 'show_overlay',
          'context_id': _angular.$rootScope.token
        });
        _this2.$element.addClass('overlayOpen').promise().then(function () {
          // Note: A second timeout is added here to avoid a race condition where the DOM is not yet available
          // for the inject script to pick a targetElement for injecting the iframe.
          (0, _angular.$timeout)(function () {
            var variant = _this2.toastParams && _this2.toastParams.variant;
            var options = (0, _utils.getInjectULBaseObject)(variant);
            options.onPostMessage = onPostMessagesHandler;
            if (!options.targetElement) {
              _logger.$logger.info('xoDolphin_missingTargetElement');
            }
            // Since, One Touch interstitial has a spinnner with lock icon
            // hidinng this spinnner for consistent experience
            if (variant !== 'wpsOneTouchInterstitial') {
              _this2.showSpinner = true;
            }
            if (window.PAYPAL && window.PAYPAL.unifiedLogin && options.targetElement) {
              _logger.$logger.info('xoDolphin_injectIframe');
              window.PAYPAL.unifiedLogin.inject(options);
              _this2.actions.startTimer();
            }
          });
        });
      });
    },
    closeOverlay: function closeOverlay() {
      var _this3 = this;
      this.$element.removeClass('overlayOpen');
      this.isTimerRunning = false;
      this.showSpinner = false;
      _logger.$logger.info(_utils.flowName, {
        'from': 'show_banner',
        'to': 'overlay_closed',
        'context_id': _angular.$rootScope.token
      });
      (0, _angular.$timeout)(function () {
        _logger.$logger.info('xoDolphin_hideOverlay');
        _this3.showOverlay = false;
        _this3.hasOverlayLoaded = false;
      }, 300);
    }
  },
  lifecycle: {
    enter: function enter() {
      var ulToast = _squid.$util.param('ulToast') || _squid.$util.param('ulToastWpsDone');
      this.toastParams = ulToast && _utils.variantParams[ulToast];
      this.isPhoneConfirmed = false;
      this.hasOverlayLoaded = false;
      this.isTimerRunning = false;
      this.timerDuration = 10000;
    },
    populate: function populate() {
      var _this4 = this;
      if (!this.toastParams) {
        _logger.$logger.info('Missing or invalid toast param!');
        return;
      }
      this.showBanner = !this.toastParams.autoTriggeredOverlay;
      this.showOverlay = this.toastParams.autoTriggeredOverlay;
      this.bannerContent = this.toastParams.messageKey;
      this.successContent = this.toastParams.successKey;
      this.autoTriggeredOverlay = this.toastParams.autoTriggeredOverlay;
      this.variant = this.toastParams.variant;
      // DeviceInfo doesnt seem to have isDesktop, hence just avoiding the mobile use case
      this.fixedBanner = _index.$DeviceInfo.isMobile() ? '' : 'dolphinBannerFixed';
      _logger.$logger.info(_utils.flowName, {
        'from': 'show_banner',
        'to': this.toastParams.transitionName,
        'banner_type': this.toastParams.bannerType,
        'context_id': _angular.$rootScope.token
      });

      // Cannot use `$apply` as we need to wait for the entire digest cycle to complete
      (0, _angular.$timeout)(function () {
        if (_this4.autoTriggeredOverlay) {
          _this4.actions.openOverlay();
          return;
        }
        angular.element('#confirmPhoneBtn').on('click', function () {
          _logger.$logger.info(_utils.flowName, {
            'from': 'show_banner',
            'to': 'click_link',
            'context_id': _angular.$rootScope.token
          });
          _this4.showOverlay = true;
          // Allow overlay DOM to be added before animating it in
          (0, _angular.$timeout)(_this4.actions.openOverlay, 150);
        });
        // Add a delay to open the overlay when it's A) auto trigger and B) Not WPS OR
        // Add a delay to open the overlay when it's A) auto trigger and B) WPS Done with One Touch variant
        // `ulToastWpsDone` will be added by UL only if it is indeed a WPS flow
      }, this.autoTriggeredOverlay && !_squid.$util.param('ulToastWpsDone') || this.autoTriggeredOverlay && _squid.$util.param('ulToastWpsDone') === 'wpsOneTouchInterstitial' ? 1800 : 0);
    }
  }
});
_angular.$rootScope;
_angular.$timeout;
_squid.$Component;
_squid.$util;
_logger.$logger;
_index.$DeviceInfo;
_utils.getInjectULBaseObject;
_utils.flowName;
_utils.variantParams;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"dolphinContainer\" ng-if=\"showBanner\">\n    <section class=\"dolphinBanner {{ fixedBanner }}\" content>\n        <div class=\"dolphinBannerContent {{ variant }}\" ng-if=\"!isPhoneConfirmed\" ng-bind-html=\"htmlContent(bannerContent)\"></div>\n        <div class=\"dolphinBannerContent\" ng-if=\"isPhoneConfirmed\">\n            <span class=\"dolphinBannerSuccessIcon\"></span>\n            <span class=\"dolphinBannerSuccessContent\">{{ content(successContent) }}</p>\n        </div>\n        <div class=\"dolphinBannerCloseIcon\" ng-click=\"actions.closeBanner()\"></div>\n    </section>\n</div>\n<section ng-if=\"showOverlay\" class=\"pageOverlay\">\n    <div ng-if=\"!autoTriggeredOverlay\" class=\"overlayMask\"></div>\n    <div ng-if=\"autoTriggeredOverlay\" class=\"overlayAutoTriggerMask\"></div>\n    <div class=\"overlayWrapper\">\n        <div class=\"overlayContainer\">\n            <div class=\"aside\">\n                <a class=\"close\" href=\"#\" ng-click=\"actions.closeOverlay()\"></a>\n                <div id=\"injectedULPhoneConfirmation\"></div>\n            </div>\n            <div class=\"pushLogo\"></div>\n        </div>\n        <div class=\"logo\"></div>\n    </div>\n    <div ng-if=\"showSpinner\" class=\"spinner\">\n        <div class=\"spinWrap\">\n            <p class=\"loader\"></p>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-login-components/src/dolphin/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.variantParams = exports.getInjectULBaseObject = exports.getDolphinEligibility = exports.flowName = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _eligibility = __webpack_require__("../node_modules/xo-models/src/eligibility/index.js");
var getCreditInterstitialEligibility = function getCreditInterstitialEligibility() {
  // TODO: Refactor the usage of PXP result stored in rootScope once Credit team make a change to this
  var creditInterstitialPXPResult = _angular.$rootScope['creditInterstitialPXPResult'];
  var creditInterstitialControl = 'xo_hermesnodeweb_us_ryi_ppc_ppcacquisition_interstitial_control';
  // If there is a value && it is not Control, then it's any of the treatments

  return creditInterstitialPXPResult && creditInterstitialPXPResult !== creditInterstitialControl;
};
var getInjectULBaseObject = exports.getInjectULBaseObject = function getInjectULBaseObject(variant) {
  var options = {
    config: {
      name: 'PPFrameRedirect',
      height: 577
    },
    queryParams: {
      intent: variant === 'add3' || variant === 'confirm3' || 'wpsOneTouchInterstitial' ? 'xoAutoTrigger' : 'xoToast',
      flowId: _angular.$rootScope.token,
      flowInfo: _uiRouter.$state.current && _uiRouter.$state.current.name,
      'country.x': _squid.$locale.country,
      'locale.x': _squid.$locale.getLocaleCode()
    },
    iframePathname: '/signin/phone-confirmation',
    targetElement: document.getElementById('injectedULPhoneConfirmation')
  };
  if (variant === 'wpsOneTouchInterstitial') {
    options.queryParams.flowName = 'wpsOneTouchInterstitial';
    options.iframePathname = '/signin/activate-one-touch';
  }
  return options;
};
var flowName = exports.flowName = 'ul_dolphin';

// A simple object to map all the properties specific to a particular variant
// Not creating a function & abstracting common things for the sake of simplicity
// Once the performance is measured, only 1 of the 4 variants will be left behind
// and this object will have only 2 props again.
// A variant prop is added to define the class name in the template
// The query param's value is not used directly to avoid XSS
var variantParams = exports.variantParams = {
  confirm: {
    messageKey: 'login.confirmPhone',
    successKey: 'login.confirmPhoneSuccess',
    transitionName: 'confirm_phone',
    bannerType: 'short_text_link',
    // `variant` uses a hardcoded value for th ulToast query param
    // it is used later in the flow from here instead of the query param
    variant: 'confirm'
  },
  confirm1: {
    messageKey: 'login.confirmPhoneWithButton',
    successKey: 'login.confirmPhoneSuccess',
    transitionName: 'confirm_phone',
    bannerType: 'short_text_button',
    variant: 'confirm1'
  },
  confirm2: {
    messageKey: 'login.confirmPhoneLongWithButton',
    successKey: 'login.confirmPhoneSuccess',
    transitionName: 'confirm_phone',
    bannerType: 'long_text_button',
    variant: 'confirm2'
  },
  confirm3: {
    // There is no messageKey in this variant
    successKey: 'login.confirmPhoneSuccess',
    smsSentKey: 'login.smsSent',
    transitionName: 'confirm_phone',
    bannerType: 'auto_trigger',
    variant: 'confirm3',
    autoTriggeredOverlay: true
  },
  add: {
    messageKey: 'login.addPhone',
    successKey: 'login.addPhoneSuccess',
    transitionName: 'add_phone',
    bannerType: 'short_text_link',
    variant: 'add'
  },
  add1: {
    messageKey: 'login.addPhoneWithButton',
    successKey: 'login.addPhoneSuccess',
    transitionName: 'add_phone',
    bannerType: 'short_text_button',
    variant: 'add1'
  },
  add2: {
    messageKey: 'login.addPhoneLongWithButton',
    successKey: 'login.addPhoneSuccess',
    transitionName: 'add_phone',
    bannerType: 'long_text_button',
    variant: 'add2'
  },
  add3: {
    // There is no messageKey in this variant
    successKey: 'login.addPhoneSuccess',
    smsSentKey: 'login.smsSent',
    transitionName: 'add_phone',
    bannerType: 'auto_trigger',
    variant: 'add3',
    autoTriggeredOverlay: true
  },
  wpsOneTouchInterstitial: {
    variant: 'wpsOneTouchInterstitial',
    autoTriggeredOverlay: true
  }
};
var getDolphinEligibility = exports.getDolphinEligibility = function getDolphinEligibility(stateName) {
  var isReviewOrFi = /checkout\.review|checkout\.selectFi/.test(stateName) && _squid.$util.param('ulToast');
  if (!isReviewOrFi) {
    _logger.$logger.info(flowName, {
      'from': 'dolphin_elg_chk',
      'to': 'process_dolphin_elg_chk',
      'eligibility_reason': 'not_ryp',
      'context_id': _angular.$rootScope.token
    });
    return _squid.$promise.resolve();
  }
  return _eligibility.$stickyCTA.instance().getEligibility()
  // Dolphin can be enabled only in case sticky & credit interstitial are not eligibile
  .then(function (isStickyEligible) {
    var eligibilityReason = 'no_sticky_or_credit';
    var isCreditInsterstialEligible = getCreditInterstitialEligibility();
    if (isCreditInsterstialEligible) {
      eligibilityReason = 'has_credit_interstitial';
    }
    if (isStickyEligible) {
      eligibilityReason = 'has_sticky';
    }
    _logger.$logger.info(flowName, {
      'from': 'dolphin_elg_chk',
      'to': 'process_dolphin_elg_chk',
      'eligibility_reason': eligibilityReason,
      'context_id': _angular.$rootScope.token
    });
    return !isStickyEligible && !isCreditInsterstialEligible;
  });
};
_angular.$rootScope;
_uiRouter.$state;
_squid.$locale;
_squid.$promise;
_squid.$util;
_logger.$logger;
_eligibility.$stickyCTA;

/***/ }),

/***/ "../node_modules/xo-login-components/src/unified-login/ul.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ul = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _config = __webpack_require__("../node_modules/squid/dist/core/config.js");
var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");
var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
__webpack_require__("../node_modules/ul-inline/dist/inject.js");
/**
 * Created by upigilam on 4/8/16.
 * UL handler is to exchange ST to RT exchanges.
 */

// Loads unifiedLogin key on to PAYPAL window object

var $ul = exports.$ul = {
  optInToOneTouch: function optInToOneTouch(token, locale_country, locale_code, silent, fptiData, flowName) {
    return (0, _angular.$q)(function (resolve, reject) {
      var PAYPAL = window.PAYPAL || {};
      var ulTimeOutValue = 10000;
      var ulTimeoutPromise = null;
      function logSubmit(data) {
        var fptiPayload = {
          'from': fptiData && fptiData.stateName ? fptiData.stateName : 'poma_page',
          'to': fptiData && fptiData.transInfix ? fptiData.transInfix : 'process_kmli_optin'
        };
        if (data && data.errorCode) {
          angular.extend(fptiPayload, {
            'int_error_code': data.errorCode,
            'error_type': 'hard_decline',
            'error_source': 'unifiedloginnodeweb'
          });
        }
        _logger.$logger.info('checkout_fpti', fptiPayload);
      }
      function failureHandler(reason) {
        logSubmit({
          errorCode: reason
        });
        _logger.$logger.info('UL_Loading_error_' + reason);
        return reject(new Error('UL_Loading_error_' + reason));
      }
      function startTimer(tag) {
        _logger.$logger.info('UL_START_TIMER_' + tag);
        ulTimeoutPromise = (0, _angular.$timeout)(function () {
          failureHandler('timed_out');
          if (!silent) {
            _angular.$rootScope.$emit('loaded');
          }
        }, ulTimeOutValue);
      }
      function stopTimer(tag) {
        if (!silent) {
          _angular.$rootScope.$emit('loaded');
        }
        _logger.$logger.info('UL_STOP_TIMER_' + tag);
        if (ulTimeoutPromise) {
          _angular.$timeout.cancel(ulTimeoutPromise);
          ulTimeoutPromise = null;
        }
      }
      var ulEventHandlers = {
        'oneTouchInterstitialOptInLoaded': function oneTouchInterstitialOptInLoaded(data) {
          // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
        },
        'oneTouchInterstitialOptInAttempted': function oneTouchInterstitialOptInAttempted(data) {
          // Don't start or stop timer. Flow should not get block even the post messages is not returned from UL
        },
        'oneTouchInterstitialOptInSuccess': function oneTouchInterstitialOptInSuccess(data) {
          stopTimer(data.event);
          logSubmit();
          // UL will drop RT cookie and respond oneTouchInterstitialOptInSuccess postmessage.
          _auth.$AuthModel.instance().retrieve().then(function (auth) {
            auth.refresh_token = true;
          });
          return resolve();
        },
        'oneTouchInterstitialOptInFailed': function oneTouchInterstitialOptInFailed(data) {
          stopTimer(data.event);
          failureHandler(data.event);
        },
        'oneTouchInterstitialOptInNotAuthorized': function oneTouchInterstitialOptInNotAuthorized(data) {
          // removing the element - ulTargetAttribute from DOM, to avoid any other accidental
          // actions on the element which is causing excess spinners later.
          var child = document.getElementById('ulTargetAttribute');
          child.parentNode.removeChild(child);
          stopTimer(data.event);
          failureHandler(data.event);
        }
      };
      function postMessageHandler(response) {
        (0, _angular.$timeout)(function () {
          _logger.$logger.info('ul_postmessaged_received', response);
          var data = response.data || response.error;
          var eventId = data && data.event;
          if (eventId) {
            _logger.$logger.debug('UL' + eventId, response);
            var handler = ulEventHandlers[eventId];
            if (handler) {
              handler(data);
            }
          }
        });
      }
      function loadOneTouchUpsell() {
        if (!silent) {
          _angular.$rootScope.$emit('loading');
        }
        var ulTargetAttribute = document.createElement('div');
        ulTargetAttribute.setAttribute('id', 'ulTargetAttribute');

        // setting display to None leading FireFox hiding all the ul elements due to which body click doesn't work
        // ulTargetAttribute.style.display = "None";

        // Making 0px, it works for FF, Chrome, Safari
        ulTargetAttribute.style.width = '0px';
        ulTargetAttribute.style.margin = '0px';
        ulTargetAttribute.style.height = '0px';
        ulTargetAttribute.style.padding = '0px';
        document.body.appendChild(ulTargetAttribute);
        var options = {
          targetElement: document.getElementById('ulTargetAttribute'),
          queryParams: {
            'country.x': locale_country,
            'locale.x': locale_code,
            'flowId': token,
            'correlationId': _model.$CalDataModel.getCalCorrId(),
            'flowName': flowName ? flowName : 'checkoutOnlyMember' // default is poma flow
          },
          iframePathname: '/signin/activate-one-touch',
          onPostMessage: postMessageHandler
        };
        if (_config.$config.deploy.isLocal()) {
          if (_config.$meta.stage) {
            options.origin = 'https://' + _config.$meta.stage;
          } else {
            // if no stage url shows up then use any backup url for origin
            options.origin = _config.$config.urls.onboarding.split('/webapps/')[0];
          }
        }
        if (PAYPAL && PAYPAL.unifiedLogin) {
          startTimer('initializeUl');
          PAYPAL.unifiedLogin.inject(options);
        } else {
          failureHandler('PAYPAL.unifiedLogin_undefined');
        }
      }
      loadOneTouchUpsell();
    });
  }
};
angular.value("$ul", $ul);
_angular.$rootScope;
_angular.$q;
_angular.$timeout;
_logger.$logger;
_config.$config;
_config.$meta;
_model.$CalDataModel;
_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/address/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ValidateAddressModel = exports.$ResidentialAddressModel = exports.$PrefillAddressModel = exports.$AddressNormalizationModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _fi = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var $AddressNormalizationModel = exports.$AddressNormalizationModel = _squid.$Model.extend('$AddressNormalizationModel', {
  api: new _squid.$Api({
    uri: '/api/address/normalize'
  })
});
var $PrefillAddressModel = exports.$PrefillAddressModel = _squid.$Model.extend('$PrefillAddressModel', {
  api: new _squid.$Api({
    uri: '/api/address/prefill'
  })
});
var $ValidateAddressModel = exports.$ValidateAddressModel = _squid.$Model.extend('$ValidateAddressModel', {
  api: new _squid.$Api({
    uri: '/api/address/validate'
  })
});
var $ResidentialAddressModel = exports.$ResidentialAddressModel = _squid.$Model.extend('$ResidentialAddressModel', {
  format: function format() {
    var langConfig = (_fi.BILLING_ADDRESS_FORMAT[_squid.$locale.country] || {})[_squid.$locale.lang] || {};
    var comma = angular.isUndefined(langConfig[',']) ? _fi.BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
    var space = angular.isUndefined(langConfig[' ']) ? _fi.BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];
    return _squid.$util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + _squid.$util.filter([this.postal_code]);
  },
  serialize: function serialize() {
    return {
      line1: this.line1 && this.line1.trim(),
      line2: this.line2 && this.line2.trim(),
      city: this.city && this.city.trim(),
      state: this.state && this.state.trim(),
      postal_code: this.postal_code && this.postal_code.trim(),
      normalization_status: this.normalization_status,
      country: this.country
    };
  }
});
angular.value("$AddressNormalizationModel", $AddressNormalizationModel);
angular.value("$PrefillAddressModel", $PrefillAddressModel);
angular.value("$ValidateAddressModel", $ValidateAddressModel);
angular.value("$ResidentialAddressModel", $ResidentialAddressModel);
_squid.$Model;
_squid.$Api;
_squid.$util;
_squid.$locale;
_fi.BILLING_ADDRESS_FORMAT;

/***/ }),

/***/ "../node_modules/xo-models/src/app/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$TokenizedWalletPinModel = exports.$TokenizedWalletMsbOfferModel = exports.$TokenizedWalletInfoModel = exports.$TokenizedWalletEligibilityModel = exports.$TokenizedFundingCapabilitiesModel = exports.$TeslaFlowIdModel = exports.$PXPModel = exports.$PXPBlacklist = exports.$MessengerIntegrationDataModel = exports.$LocaleConfigModel = exports.$AppDataModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _brandNames, _msbDisclaimerLinks;
var $TeslaFlowIdModel = exports.$TeslaFlowIdModel = _squid.$Model.extend('$TeslaFlowIdModel', {
  api: new _squid.$Api({
    uri: '/api/teslaFlowId/:id'
  })
});
var $PXPModel = exports.$PXPModel = _squid.$Model.extend('$PXPModel', {
  api: new _squid.$Api({
    uri: '/api/pxp/:id'
  })
});
var $LocaleConfigModel = exports.$LocaleConfigModel = _squid.$Model.extend('$LocaleConfigModel', {
  api: new _squid.$Api({
    uri: '/api/localeConfig'
  })
});
var $AppDataModel = exports.$AppDataModel = _squid.$Model.extend('$AppDataModel', {
  api: new _squid.$Api({
    uri: '/api/app'
  }),
  isMobile: function isMobile() {
    return this.platform === 'mobile';
  }
});
var $MessengerIntegrationDataModel = exports.$MessengerIntegrationDataModel = _squid.$Model.extend('$MessengerIntegrationDataModel', {
  api: new _squid.$Api({
    uri: '/api/messenger'
  })
});
var $TokenizedWalletEligibilityModel = exports.$TokenizedWalletEligibilityModel = _squid.$Model.extend('$TokenizedWalletEligibilityModel', {
  api: new _squid.$Api({
    uri: '/api/eligibility/tokenizedWallet/:id'
  }),
  invalidateOnLogout: true,
  // invalidate this model when auth.logout() gets called

  isEligible: function isEligible() {
    return this.eligible;
  }
});
var subjectTypes = {
  SAMSUNG_PAY: 'Samsung',
  ANDROID_PAY: 'google'
};
var brandNames = (_brandNames = {}, _brandNames[subjectTypes.SAMSUNG_PAY] = 'Samsung Pay', _brandNames[subjectTypes.ANDROID_PAY] = 'Google Pay', _brandNames);

/**
 * disclaimer links used on the *pay review page
 */
var disclaimerLinks = function disclaimerLinks(country) {
  var _ref;
  return _ref = {}, _ref[subjectTypes.SAMSUNG_PAY] = "https://www.paypal.com/" + country + "/webapps/mpp/ua/ppsamsungpay-tnc", _ref[subjectTypes.ANDROID_PAY] = "https://www.paypal.com/" + country + "/webapps/mpp/ua/ppandroidpay-tnc", _ref;
};

// disclaimer links used on Msb offer popup
var msbDisclaimerLinks = (_msbDisclaimerLinks = {}, _msbDisclaimerLinks[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/us/smarthelp/article/samsung-pay-terms-and-conditions-faq3863', _msbDisclaimerLinks[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/us/smarthelp/article/google-pay-terms-and-conditions-faq3862', _msbDisclaimerLinks);

/**
 * this model populates data from tokenized wallet mayfly object
 * (see xo-hermes-app/apis/tokenizedWalletInfo) which contains:
 *
 * - wallet_id (used for both Samsung Pay and Android Pay)
 * - external_device_id (used for Samsung Pay only)
 * - subject (used for both Samsung Pay and Android Pay)
 *
 * Note: model is being populated in xo-preload on the server (see config.json)
 */

var $TokenizedWalletInfoModel = exports.$TokenizedWalletInfoModel = _squid.$Model.extend('$TokenizedWalletInfoModel', {
  api: new _squid.$Api({
    uri: '/api/info/tokenizedWallet/:id'
  }),
  isAndroidPay: function isAndroidPay() {
    return this.subject === subjectTypes.ANDROID_PAY;
  },
  isSamsungPay: function isSamsungPay() {
    return this.subject === subjectTypes.SAMSUNG_PAY;
  },
  getSubject: function getSubject() {
    return this.subject || subjectTypes.ANDROID_PAY;
  },
  // until we use mayfly for android pay - fallback to Android Pay
  brandName: function brandName() {
    return brandNames[this.subject] || brandNames[subjectTypes.ANDROID_PAY];
  },
  // until we use mayfly for android pay - fallback to Android Pay
  getDisclaimerLink: function getDisclaimerLink() {
    var country = _squid.$locale.country.toLowerCase();
    return disclaimerLinks(country)[this.subject] || disclaimerLinks(country)[subjectTypes.ANDROID_PAY];
  },
  // get Msb terms and conditions link based on the subject
  getMsbDisclaimerLink: function getMsbDisclaimerLink() {
    return msbDisclaimerLinks[this.subject] || msbDisclaimerLinks[subjectTypes.ANDROID_PAY];
  }
});
var $TokenizedFundingCapabilitiesModel = exports.$TokenizedFundingCapabilitiesModel = _squid.$Model.extend('$TokenizedFundingCapabilitiesModel', {
  api: new _squid.$Api({
    uri: '/api/capabilities/tokenizedWallet/:id'
  }),
  invalidateOnLogout: true,
  isDirectFundingEnabled: function isDirectFundingEnabled() {
    return this.directFundingEnabled;
  },
  isTopupEnabled: function isTopupEnabled() {
    return this.topupFundingEnabled;
  },
  getProductName: function getProductName() {
    return this.name;
  },
  getCurrency: function getCurrency() {
    return this.issuingCurrency;
  },
  getContingencies: function getContingencies() {
    return this.contingencies;
  },
  getTopupAmountChoices: function getTopupAmountChoices() {
    return this.topUpAmountChoices;
  }
});
var $TokenizedWalletPinModel = exports.$TokenizedWalletPinModel = _squid.$Model.extend('$TokenizedWalletPinModel', {
  api: new _squid.$Api({
    uri: '/api/pin/tokenizedWallet/:id'
  }),
  invalidateOnLogout: true,
  // invalidate this model when auth.logout() gets called

  getPinOrigin: function getPinOrigin() {
    return this.pinOrigin;
  },
  getSuggestedPin: function getSuggestedPin() {
    return this.suggestedPin;
  },
  getSuggestedKey: function getSuggestedKey() {
    return this.suggestedKey;
  },
  getPinId: function getPinId() {
    return this.pinId;
  },
  isPinIdPresent: function isPinIdPresent() {
    return !!this.pinId;
  },
  isSetupEligible: function isSetupEligible() {
    return this.pinOrigin === 'UNSET' || this.pinOrigin === 'SYSTEM';
  }
});
var $TokenizedWalletMsbOfferModel = exports.$TokenizedWalletMsbOfferModel = _squid.$Model.extend('$TokenizedWalletMsbOfferModel', {
  api: new _squid.$Api({
    uri: '/api/msb/tokenizedWallet/:id'
  }),
  invalidateOnLogout: true
});
var $PXPBlacklist = exports.$PXPBlacklist = {
  isMerchantBlacklisted: function isMerchantBlacklisted(merchantId) {
    return _squid.$config.pxpBlacklist && _squid.$config.pxpBlacklist.merchant && _squid.$config.pxpBlacklist.merchant.indexOf(merchantId) !== -1;
  }
};
angular.value("$TeslaFlowIdModel", $TeslaFlowIdModel);
angular.value("$PXPModel", $PXPModel);
angular.value("$LocaleConfigModel", $LocaleConfigModel);
angular.value("$AppDataModel", $AppDataModel);
angular.value("$MessengerIntegrationDataModel", $MessengerIntegrationDataModel);
angular.value("$TokenizedWalletEligibilityModel", $TokenizedWalletEligibilityModel);
angular.value("$TokenizedWalletInfoModel", $TokenizedWalletInfoModel);
angular.value("$TokenizedFundingCapabilitiesModel", $TokenizedFundingCapabilitiesModel);
angular.value("$TokenizedWalletPinModel", $TokenizedWalletPinModel);
angular.value("$TokenizedWalletMsbOfferModel", $TokenizedWalletMsbOfferModel);
angular.value("$PXPBlacklist", $PXPBlacklist);
_squid.$config;
_squid.$locale;
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/auth/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ULoginModel = exports.$AuthModel = exports.$AuthApi = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");
var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");
var $AuthApi = exports.$AuthApi = _squid.$Model.extend('$AuthApi', {
  api: new _squid.$Api({
    uri: '/api/auth',
    postAttempts: 3
  })
});
var $AuthModel = exports.$AuthModel = _squid.$Model.extend('$AuthModel', {
  api: new _squid.$Api({
    uri: '/api/auth',
    postAttempts: 3
  }),
  invalidateOnLogout: true,
  // invalidate this model when auth.logout() gets called

  loggedIn: function loggedIn() {
    return this.logged_in;
  },
  isOnetouchULRedirect: function isOnetouchULRedirect() {
    return this.is_onetouch_ul_redirect;
  },
  visitorId: function visitorId() {
    return this.visitor_id;
  },
  accessToken: function accessToken() {
    return this.access_token;
  },
  accessTokenPresent: function accessTokenPresent() {
    return this.access_token_present;
  },
  refreshToken: function refreshToken() {
    return this.refresh_token;
  },
  rememberedOT: function rememberedOT() {
    return this.remembered && this.remembered_device_token;
  },
  isSessionTimeout: function isSessionTimeout() {
    return this.meta && this.meta.invalidated;
  },
  clearCookies: function clearCookies(data) {
    if (data === void 0) {
      data = {};
    }
    return this.action('clearCookies', {
      data: data
    });
  },
  isFBSkipLogin: function isFBSkipLogin() {
    /* Facebook pass the code generated in checkout URL , check for to determine it as FB Skip Login
     * if both OneTouch cookie present and if code passed by FB, login usually happens using OneTouch
     * as both are having auth state as remembered, we may look for rememberedOT as it is having remembered_device_token
     * for OneTouch identifier to differentiate both logins
     * auth_claims for OneTouch is DEVICE_TOKEN
     */
    return this.remembered && _squid.$util.param('code') && !this.rememberedOT();
  },
  showNotYou: function showNotYou() {
    var isAuthApiCall = this.is_auth_api_call;
    var isConsumerApp = _squid.$util.param('source') === 'consumerApp';
    var redirectToHermesOn3DSDecline = _squid.$util.param('redirectToHermesOn3DSDecline');
    var isUlReturnLoggedIn = _squid.$util.param('ulReturn') && this.auth_state === 'LOGGEDIN';

    // for Tokenized Venice integraion (Google Pay Venice / Samsung Pay Venice) - `not you` link should be hidden.
    // `TokenizedWalletInfoModel` is always populated in xo-preload (even for error cases - it will be just empty)
    // so we don't need to retrieve the model
    var tokenizedWalletInfo = _app.$TokenizedWalletInfoModel.instance(_angular.$rootScope.token);
    var isNotVeniceTokenizedIntegration = function isNotVeniceTokenizedIntegration() {
      return !tokenizedWalletInfo || tokenizedWalletInfo && !tokenizedWalletInfo.is_venice_integration;
    };
    var isGuestVenmoAcct = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token) && this.auth_state === 'IDENTIFIED';

    // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)
    return (isAuthApiCall || this.isFBSkipLogin()) && !isConsumerApp && !redirectToHermesOn3DSDecline && !isUlReturnLoggedIn && !this.disallow_login_switch && isNotVeniceTokenizedIntegration() && !isGuestVenmoAcct;
  },
  logout: function logout() {
    _squid.$Model.bulkInvalidate('invalidateOnLogout');
    _angular.$rootScope.$broadcast('logout');
    return this.action('logout');
  },
  /**
   * Perform a logout and then redirect.
   * @param reason - used to log reason why a redirect was trigged.
   */
  logoutAndRedirect: function logoutAndRedirect(reason) {
    var _this = this;
    if (reason === void 0) {
      reason = 'logout';
    }
    var logoutFrom = this.get('tenant', 'PAYPAL');
    return this.logout().then(function () {
      return _this.redirectToLogin(reason, {
        logoutFrom: logoutFrom
      });
    });
  },
  // redirect to UL as landing through xo-landing-router
  // so first it hits hermes app and then redirects to UL
  redirectToLogin: function redirectToLogin(reason, ctx) {
    if (!reason) {
      return false;
    }
    // current query parameters
    var qs = _squid.$util.queryString() || '';
    var params = {
      'ulClientRedirect': reason
    };
    params = _squid.$util.extend(params, ctx); // update params with context that may be sent

    // insert "ulClientRedirect" param and remove "ul", "ulReturn"
    var updatedQs = _squid.$util.queryStringSplice(qs, params, ['ul', 'ulReturn']);

    // base url should not be hardcoded to "/webapps/hermes" due to other use cases such as
    // 1. * Pay (Android Pay / Samsung Pay) -- uses /agreements/setup to exchange BA token to EC token
    var ulAsLandingUrl = _squid.$util.paypalURL("" + window.location.pathname + updatedQs);
    _logger.$logger.info('redirecting_to_ulAsLanding');
    return _squid.$util.redirect(ulAsLandingUrl);
  }
});
var $ULoginModel = exports.$ULoginModel = _squid.$Model.extend('$ULoginModel', {
  api: new _squid.$Api({
    uri: '/api/auth/ulogin',
    postAttempts: 1,
    cache: false
  })
});
angular.value("$AuthApi", $AuthApi);
angular.value("$AuthModel", $AuthModel);
angular.value("$ULoginModel", $ULoginModel);
_angular.$rootScope;
_squid.$Model;
_squid.$Api;
_squid.$util;
_logger.$logger;
_app.$TokenizedWalletInfoModel;
_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-models/src/auth/lib/xoAPayUtils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoAPayUtils = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _jwtToken = '';
var _authenticated;

// Call browser PaymentRequest API that returns a promise
function createPaymentRequest() {
  var supportedInstruments = [{
    supportedMethods: ['https://android.com/pay'],
    data: {
      minGooglePlayServicesVersion: '10400000',
      paymentMethodTokenizationParameters: {
        tokenizationType: 'GATEWAY_TOKEN',
        parameters: {
          gateway: 'paypal'
        }
      }
    }
  }];
  var details = {
    // Payment request requires an amount. Hardcode the value for now.
    total: {
      label: 'Checkout',
      amount: {
        currency: 'USD',
        value: '5.00'
      }
    }
  };
  var options = {};
  try {
    return new PaymentRequest(supportedInstruments, details, options); // eslint-disable-line no-undef
  } catch (e) {
    _logger.$logger.info('PAYMENT_REQUEST_NOT_SUPPORTED');
  }
}
function updateCookie(url, params) {
  (0, _angular.$http)({
    method: 'GET',
    url: url,
    params: params
  })["catch"](function (err) {
    _logger.$logger.info('tokenized_wallet_update_cookie_error', {
      err: err
    });
  });
}
function isPaymentRequestAPISupported() {
  var currentVersionMatch = navigator.userAgent.match(/Chrome\/([0-9]+)\./i);
  return _index.$DeviceInfo.isMobile() && window.navigator.vendor === 'Google Inc.' && 'PaymentRequest' in window && navigator.userAgent.match(/Android/i) && currentVersionMatch && Number(currentVersionMatch[1]) >= 58;
}
var $xoAPayUtils = exports.$xoAPayUtils = {
  isAPayAPISupported: function isAPayAPISupported() {
    return isPaymentRequestAPISupported();
  },
  canMakeAPayPayment: function canMakeAPayPayment() {
    if (!isPaymentRequestAPISupported()) {
      return _angular.$q.resolve(false);
    }
    var paymentRequest = window.appPaymentRequest || createPaymentRequest();
    if (paymentRequest && paymentRequest.canMakePayment) {
      _logger.$logger.info('APAY_CHECK_CAN_MAKE_PAYMENT');
      _logger.$logger.info('checkout_fpti', {
        from: 'payment_request_check_payment',
        to: 'prepare_payment_request_check_payment'
      });
      return paymentRequest.canMakePayment().then(function (result) {
        if (result) {
          _logger.$logger.info('APAY_CAN_MAKE_PAYMENT');
          _logger.$logger.info('checkout_fpti', {
            from: 'payment_request_check_payment',
            to: 'process_payment_request_can_make_payment'
          });
          return true;
        } else {
          _logger.$logger.info('APAY_CAN_NOT_MAKE_PAYMENT_NO_PAYMENT');
          _logger.$logger.info('checkout_fpti', {
            from: 'payment_request_can_make_payment',
            to: 'process_payment_request_can_not_make_payment',
            error_source: 'PaymentRequestAPI',
            error_type: 'no_payment'
          });
          return false;
        }
      })["catch"](function (err) {
        _logger.$logger.info('APAY_CAN_NOT_MAKE_PAYMENT_SOFT_DECLINE', {
          msg: err && err.message,
          name: err && err.name
        });
        _logger.$logger.info('checkout_fpti', {
          from: 'payment_request_can_make_payment',
          to: 'prepare_payment_request_can_make_payment_soft_decline',
          int_error_code: err && err.name,
          int_error_description: err && err.message,
          error_source: 'PaymentRequestAPI',
          error_type: 'soft_decline'
        });
        return false;
      });
    } else {
      return _angular.$q.resolve(false);
    }
  },
  authenticateAPay: function authenticateAPay(forceAuthenticate) {
    if (forceAuthenticate === void 0) {
      forceAuthenticate = false;
    }
    if (!forceAuthenticate && _authenticated !== undefined) {
      return _angular.$q.resolve(_authenticated);
    }
    _authenticated = false;
    _jwtToken = '';

    // Do not proceed if PaymentRequest is not supported.
    if (!isPaymentRequestAPISupported()) {
      return _angular.$q.resolve(false);
    }
    var paymentRequest = window.appPaymentRequest || createPaymentRequest();
    if (paymentRequest) {
      _logger.$logger.info('APAY_AUTHENTICATION_BEGIN');
      _logger.$logger.info('checkout_fpti', {
        from: 'payment_request_auth',
        to: 'prepare_payment_request_auth'
      });
      return paymentRequest.show().then(function (result) {
        result.complete('success');
        _logger.$logger.info('APAY_AUTHENTICATION_SUCCEEDED');
        _logger.$logger.info('checkout_fpti', {
          from: 'payment_request_auth',
          to: 'process_payment_request_auth',
          param_type: 'JWT'
        });
        var paymentMethodToken = result.details && result.details.paymentMethodToken && JSON.parse(result.details.paymentMethodToken);
        _jwtToken = paymentMethodToken.authJwt;
        _authenticated = true;
        return true;
      })["catch"](function (err) {
        _logger.$logger.info('APAY_AUTHENTICATION_FAILED', {
          msg: err && err.message,
          name: err && err.name
        });
        _logger.$logger.info('checkout_fpti', {
          from: 'payment_request_auth',
          to: 'process_payment_request_auth',
          int_error_code: err && err.name,
          int_error_description: err && err.message,
          error_source: 'PaymentRequestAPI',
          error_type: 'soft_decline'
        });
        return false;
      });
    } else {
      return _angular.$q.resolve(false);
    }
  },
  getAPayAuthToken: function getAPayAuthToken() {
    return _jwtToken;
  },
  setAPayCookie: function setAPayCookie(token) {
    if (_squid.$config.tokenizedWalletCookieURL) {
      updateCookie(_squid.$config.tokenizedWalletCookieURL, {
        op: 'set',
        token: token
      });
    }
  },
  clearAPayCookie: function clearAPayCookie(token) {
    if (_squid.$config.tokenizedWalletCookieURL) {
      updateCookie(_squid.$config.tokenizedWalletCookieURL, {
        op: 'clear',
        token: token
      });
    }
  },
  setOTAPayCookie: function setOTAPayCookie(token) {
    if (_squid.$config.tokenizedWalletCookieURL) {
      updateCookie(_squid.$config.tokenizedWalletCookieURL, {
        op: 'setot',
        token: token
      });
    }
  }
};
angular.value("$xoAPayUtils", $xoAPayUtils);
_angular.$http;
_angular.$q;
_logger.$logger;
_squid.$config;
_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.serializeInstallmentsOptionsData = exports.$ShippingAddressModel = exports.$InstallmentOptionsModel = exports.$FundingSourceModel = exports.$FundingOptionsModel = exports.$FlowEligibilityModel = exports.$CreditOptionsModel = exports.$CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressModel = exports.$CheckoutSessionModel = exports.$CheckoutPlanModel = exports.$CheckoutPayeeModel = exports.$CheckoutCartModel = exports.$CheckoutAppDataModel = exports.$CardBackupModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _processorDecline = __webpack_require__("../node_modules/xo-models/src/processorDecline/index.js");
var _utils = __webpack_require__("../node_modules/xo-models/src/checkout/lib/utils.js");
var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");
var _index = _interopRequireDefault(__webpack_require__("../node_modules/xo-models/src/fiMeta/index.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
var $CheckoutCartModel = exports.$CheckoutCartModel = _squid.$Model.extend('$CheckoutCartModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/cart',
    cache: true
  }),
  isPurchase: function isPurchase() {
    return Boolean(this.purchase);
  },
  getCartCurrencyCode: function getCartCurrencyCode() {
    return _squid.$util.getProperty(this, 'purchase.amounts.total.currency_code');
  },
  // NOTE returns undefined if this is not a purchase or there is some other error
  getPurchaseAmount: function getPurchaseAmount() {
    if (!this.isPurchase()) {
      return;
    }
    var purchaseAmount = _squid.$util.getProperty(this, 'purchase.amounts.total.amount');
    var purchaseAmountFloat = parseFloat(purchaseAmount);
    return purchaseAmountFloat || undefined;
  },
  isBilling: function isBilling() {
    return Boolean(this.billing);
  },
  isReferenceTransaction: function isReferenceTransaction() {
    if (this.isBilling() && this.billing.type) {
      var isChannelInitiatedBilling = this.billing.type === 'CHANNEL_INITIATED_BILLING';
      var isMerchantInitiatedBilling = this.billing.type === 'MERCHANT_INITIATED_BILLING';
      var isMerchantInitiatedSingleBilling = this.billing.type === 'MERCHANT_INITIATED_SINGLE_BILLING';

      // isReferenceTransaction() function will return true , if any of isChannelInitiatedBilling , isMerchantInitiatedBilling ,  isMerchantInitiatedSingleBilling is true
      return isChannelInitiatedBilling || isMerchantInitiatedBilling || isMerchantInitiatedSingleBilling;
    }
    return false;
  },
  isConsumerCountry: function isConsumerCountry(country) {
    return _squid.$locale.country === country;
  },
  isRecurringPayment: function isRecurringPayment() {
    if (this.isBilling() && this.billing.type) {
      return this.billing.type === 'RECURRING_PAYMENTS';
    }
    return false;
  },
  isChargePatternImmediateOrDeferred: function isChargePatternImmediateOrDeferred() {
    return ['IMMEDIATE', 'DEFERRED'].includes(this.billing.charge_pattern);
  },
  isSubscriptionsV1: function isSubscriptionsV1() {
    return this.isBilling() && this.billing.type === 'SUBSCRIPTIONS_V1';
  },
  getBaToken: function getBaToken() {
    return this.isBilling() && this.billing.ba_token;
  },
  isBillingPurchase: function isBillingPurchase() {
    return this.isPurchase() && this.isBilling();
  },
  isBillingNoPurchase: function isBillingNoPurchase() {
    return this.isBilling() && !this.isPurchase();
  },
  getBillingDescription: function getBillingDescription() {
    return this.billing && this.billing.description;
  },
  isMultiSellerPurchase: function isMultiSellerPurchase() {
    return this.purchaseUnits && this.purchaseUnits.length > 1;
  },
  isShippingMethodStorePickUp: function isShippingMethodStorePickUp() {
    return this.isPurchase() && (this.purchase.shipping_method === '29' || this.purchase.shipping_method === '21');
  },
  isWalletTokenization: function isWalletTokenization() {
    return this.isBilling() && this.billing.intent === 'TOKENIZED_WALLET';
  },
  getExternalCallbackOptions: function getExternalCallbackOptions() {
    return this.purchaseUnits && this.purchaseUnits[0] && this.purchaseUnits[0].external_callback_options;
  }
});
var $CheckoutAppDataModel = exports.$CheckoutAppDataModel = _squid.$Model.extend('$CheckoutAppDataModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/appData'
  }),
  useraction: function useraction() {
    // user_action from session takes precedence over CGI param.
    var incontext_integration = window.xchild && window.xchild.props.commit ? 'commit' : false;
    var rest_integration = this.flags && this.flags.user_action === 'PAY' ? 'commit' : false;
    return rest_integration || incontext_integration || _squid.$util.param('useraction');
  },
  is_wps_flow: function is_wps_flow() {
    return this.flags && this.flags.is_wps_flow;
  },
  isMerchantCountry: function isMerchantCountry(country) {
    return this.merchant.merchant_country === country;
  },
  is_snt_supported: function is_snt_supported() {
    return this.flags && this.flags.is_snt_supported;
  },
  is_snt_enabled: function is_snt_enabled() {
    return this.flags && this.flags.is_snt_enabled;
  },
  is_autoreturn_enabled: function is_autoreturn_enabled() {
    return this.merchant_preferences && this.merchant_preferences.auto_return && this.merchant_preferences.auto_return.enabled;
  },
  is_pdt_enabled: function is_pdt_enabled() {
    return this.merchant_preferences && this.merchant_preferences.pdt && this.merchant_preferences.pdt.enabled;
  },
  doec_on_approve: function doec_on_approve() {
    return this.flags && this.flags.doec_on_approve;
  },
  is_wps_subscription_flow: function is_wps_subscription_flow() {
    return this.flags && this.flags.is_wps_subscription_flow;
  },
  isWpsAutobillingFlow: function isWpsAutobillingFlow() {
    return this.flags && this.flags.is_wps_autobilling_flow;
  },
  is_wps_installmentplan_flow: function is_wps_installmentplan_flow() {
    return this.flags && this.flags.is_wps_installmentplan_flow;
  },
  /*
   * Returns a string or undefined value
   * nonEmptyReturnValue - if true, then always return non empty string
   * isSentenceBeginning - if true, and merchant brand_name and merchant_name is undefined
   *              then returns 'The merchant'. If false, returns 'the merchant'
   * NOTE: We should not return merchant_email for any reason as it is a PII
   */
  getMerchantDisplayName: function getMerchantDisplayName(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      nonEmptyReturnValue = _ref.nonEmptyReturnValue,
      isSentenceBeginning = _ref.isSentenceBeginning,
      getContent = _ref.getContent;
    var merchantName = this.merchant.brand_name || this.merchant.merchant_name;
    if (nonEmptyReturnValue) {
      var contentKey = isSentenceBeginning ? 'common.Themerchant' : 'common.themerchant';
      var merchantAltName = getContent ? getContent(contentKey) : _squid.$locale.content.get(contentKey);
      return merchantName || merchantAltName;
    }
    return merchantName;
  },
  isInvoiceFlow: function isInvoiceFlow() {
    return Boolean(this.flags && this.flags.is_invoice_flow);
  },
  // Returns true if flow should be treated as a second button (PP Credit) transaction
  isSecondButton: function isSecondButton() {
    return this.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';
  }
});
var $FundingSourceModel = exports.$FundingSourceModel = _squid.$Model.extend('$FundingSourceModel', {
  formatLast4: function formatLast4() {
    var last4;
    if (this.last4) {
      last4 = this.last4;
      if (!this.parent.isAuthRequired) {
        last4 = 'x-' + last4;
      }
    }
    return last4;
  }
});
var $FundingOptionsModel = exports.$FundingOptionsModel = _squid.$Model.extend('$FundingOptionsModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/fundingOptions',
    postAttempts: 2
  }),
  onPopulate: function onPopulate() {
    var self = this;
    angular.forEach(this.plans, function (plan) {
      if (plan.primaryFs && plan.primaryFs.type === 'BANK' && (plan.primaryFs.subtype === 'IACH' || plan.primaryFs.subtype === 'PAD')) {
        Object.defineProperty(plan.primaryFs, plan.primaryFs.subtype === 'IACH' ? 'padPlanId' : 'iachPlanId', {
          enumerable: true,
          configurable: false,
          writeable: false,
          value: self.getBankPlanIdByInstrumentId(plan.primaryFs.id, plan.primaryFs.subtype === 'IACH' ? 'PAD' : 'IACH')
        });
      }
    });
  },
  eachPlan: function eachPlan(method, context) {
    angular.forEach(this.plans, method, this);
  },
  hasECheck: function hasECheck() {
    var _this$instruments = this.instruments,
      instruments = _this$instruments === void 0 ? [] : _this$instruments;
    return instruments.some(function (instr) {
      return instr.type === 'ECHECK' || instr.subtype === 'ECHECK';
    });
  },
  hasCredit: function hasCredit() {
    var _this$instruments2 = this.instruments,
      instruments = _this$instruments2 === void 0 ? [] : _this$instruments2;
    return instruments.some(function (instrument) {
      return instrument.type === 'CREDIT';
    });
  },
  getBankPlanIdByInstrumentId: function getBankPlanIdByInstrumentId(id, subType) {
    var fundingInstrument = _squid.$util.find(this.plans, function (plan) {
      return plan.primaryFs && plan.primaryFs.type === 'BANK' && plan.primaryFs.id === id && plan.primaryFs.subtype === subType;
    });
    return fundingInstrument && fundingInstrument.planId;
  },
  // get IACH and PAD banks combined by plan.primaryFs.id
  // order matters, so if IACH comes first then PAD is filtered and vise versa
  getPadAndIachCombinedPlans: function getPadAndIachCombinedPlans(plans) {
    var _this = this;
    if (plans === void 0) {
      plans = this.plans;
    }
    if (!plans) {
      return [];
    }
    var planIds = {};
    plans.forEach(function (plan) {
      var planId = plan.planId,
        primaryFs = plan.primaryFs;
      if (_this.isIACH(plan) && !planIds[planId]) {
        planIds[primaryFs.padPlanId] = true;
      }
      if (_this.isPAD(plan) && !planIds[planId]) {
        planIds[primaryFs.iachPlanId] = true;
      }
    });
    return plans.filter(function (plan) {
      return !planIds[plan.planId];
    });
  },
  // get plan by planId
  getPlanByPlanId: function getPlanByPlanId(id) {
    var plan = _squid.$util.find(this.plans, function (p) {
      return p.primaryFs && p.planId === id;
    });
    return plan;
  },
  getPlanSubType: function getPlanSubType(plan) {
    if (plan === void 0) {
      plan = {};
    }
    var _plan = plan,
      _plan$primaryFs = _plan.primaryFs,
      _plan$primaryFs2 = _plan$primaryFs === void 0 ? {} : _plan$primaryFs,
      subtype = _plan$primaryFs2.subtype;
    return subtype;
  },
  // is plan PAD bank (bank is charged after some delay)
  isPAD: function isPAD(plan) {
    return this.getPlanSubType(plan) === 'PAD';
  },
  // is plan IACH bank (instant transfer)
  isIACH: function isIACH(plan) {
    return this.getPlanSubType(plan) === 'IACH';
  },
  // is plan MEFT bank
  isMEFT: function isMEFT(plan) {
    return this.getPlanSubType(plan) === 'MEFT';
  },
  // is plan IACH bank (instant transfer)
  isIACHWithPad: function isIACHWithPad(plan) {
    return this.isIACH(plan) && plan.primaryFs.padPlanId;
  },
  // is plan PayPal Credit (a.k.a BILL_ME_LATER)
  isPayPalCredit: function isPayPalCredit(plan) {
    return plan && plan.primaryFs.type === 'CREDIT' && plan.primaryFs.name === 'BILL_ME_LATER';
  },
  // get PAD hop date (when bank will be charged) based on selected plan and PAD toggle state
  getPadPlanHopDate: function getPadPlanHopDate(plan) {
    if (this.isIACH(plan)) {
      var padPlan = this.getPlanByPlanId(plan.primaryFs.padPlanId);
      if (padPlan) {
        return padPlan.primaryFs.hop_date;
      }
    } else {
      return plan.primaryFs.hop_date;
    }
  },
  // get PAD or IACH plan id based on selected plan and PAD toggle state
  getPadOrIachPlanIdBySelectedPlan: function getPadOrIachPlanIdBySelectedPlan(_ref2) {
    var plan = _ref2.plan,
      isPadToggleSelected = _ref2.isPadToggleSelected;
    if (!plan || !plan.primaryFs) {
      return;
    }
    var _plan$primaryFs3 = plan.primaryFs,
      padPlanId = _plan$primaryFs3.padPlanId,
      iachPlanId = _plan$primaryFs3.iachPlanId,
      planId = plan.planId;
    if (isPadToggleSelected) {
      return this.isPAD(plan) ? planId : padPlanId;
    } else {
      return this.isIACH(plan) ? planId : iachPlanId;
    }
  },
  getBankPadPlanIdByInstrumentId: function getBankPadPlanIdByInstrumentId(fsId, fsSubtype) {
    var bankPadPlan = _squid.$util.find(this.plans, function (plan) {
      if (plan === void 0) {
        plan = {};
      }
      var _plan2 = plan,
        _plan2$primaryFs = _plan2.primaryFs,
        _plan2$primaryFs2 = _plan2$primaryFs === void 0 ? {} : _plan2$primaryFs,
        id = _plan2$primaryFs2.id,
        type = _plan2$primaryFs2.type,
        subtype = _plan2$primaryFs2.subtype;
      return id === fsId && type === 'BANK' && subtype === fsSubtype;
    });
    if (!bankPadPlan) {
      return;
    }
    var _bankPadPlan$primaryF = bankPadPlan.primaryFs,
      _bankPadPlan$primaryF2 = _bankPadPlan$primaryF === void 0 ? {} : _bankPadPlan$primaryF,
      subtype = _bankPadPlan$primaryF2.subtype,
      padPlanId = _bankPadPlan$primaryF2.padPlanId,
      iachPlanId = _bankPadPlan$primaryF2.iachPlanId;
    return subtype === 'IACH' ? padPlanId : iachPlanId;
  },
  isPadToggleApplicable: function isPadToggleApplicable() {
    var padToggleApplicable = false;
    this.eachPlan(function (plan) {
      if (!padToggleApplicable && plan.primaryFs && plan.primaryFs.type === 'BANK') {
        if (plan.primaryFs.subtype === 'IACH' && plan.primaryFs.hasOwnProperty('padPlanId')) {
          padToggleApplicable = plan.primaryFs.padPlanId ? true : false;
        } else if (plan.primaryFs.subtype === 'PAD' && plan.primaryFs.hasOwnProperty('iachPlanId')) {
          padToggleApplicable = plan.primaryFs.iachPlanId ? true : false;
        }
      }
    }, this);
    return padToggleApplicable;
  },
  isPadToggleApplicableForFS: function isPadToggleApplicableForFS(planId) {
    var padToggleApplicable = false;
    var selectedPlan = _squid.$util.find(this.plans, function (plan) {
      return plan.planId === planId;
    });
    if (selectedPlan && selectedPlan.primaryFs && selectedPlan.primaryFs.type === 'BANK' && (selectedPlan.primaryFs.subtype === 'IACH' && selectedPlan.primaryFs.padPlanId || selectedPlan.primaryFs.subtype === 'PAD' && selectedPlan.primaryFs.iachPlanId)) {
      padToggleApplicable = true;
    }
    return padToggleApplicable;
  },
  getPreferred: function getPreferred() {
    var _this2 = this;
    return _squid.$util.find(this.plans, function (plan) {
      return _this2.isPreferred(plan);
    });
  },
  isPreferred: function isPreferred(plan) {
    if (plan === void 0) {
      plan = {};
    }
    if (this.isPAD(plan)) {
      // if the current plan is PAD -> find corresponding IACH plan to see if it's preferred
      var iachPlan = this.getPlanByPlanId(plan.primaryFs.iachPlanId) || {};
      var _iachPlan$primaryFs = iachPlan.primaryFs,
        _iachPlan$primaryFs2 = _iachPlan$primaryFs === void 0 ? {} : _iachPlan$primaryFs,
        _iachPlan$primaryFs2$ = _iachPlan$primaryFs2.isPreferred,
        _isPreferred = _iachPlan$primaryFs2$ === void 0 ? false : _iachPlan$primaryFs2$;
      return _isPreferred;
    }
    var _plan3 = plan,
      _plan3$primaryFs = _plan3.primaryFs,
      _plan3$primaryFs2 = _plan3$primaryFs === void 0 ? {} : _plan3$primaryFs,
      _plan3$primaryFs2$isP = _plan3$primaryFs2.isPreferred,
      isPreferred = _plan3$primaryFs2$isP === void 0 ? false : _plan3$primaryFs2$isP;
    return isPreferred;
  },
  // get Merchant specific balance by plan id
  getMsbByPlanId: function getMsbByPlanId(planId) {
    var plan = this.getPlanByPlanId(planId);
    return plan && plan.incentive;
  },
  /**
   * Avoid plans that are not meant for display on the UI.
   * - Hide Rewards
   */
  getDisplayPlans: function getDisplayPlans() {
    // return type should be undefined in no plans
    // for billing agreement use case
    return this.plans ? this.plans.filter(function (plan) {
      return !plan.rewards;
    }) : this.plans;
  },
  /**
   * Avoid instruments that are not meant for display on the UI.
   * - Hide Rewards
   */
  getDisplayInstruments: function getDisplayInstruments() {
    var _this$instruments3 = this.instruments,
      instruments = _this$instruments3 === void 0 ? [] : _this$instruments3;
    return instruments.filter(function (instrument) {
      return instrument.type !== 'REWARDS';
    });
  }
});

// Map the data needed for the installmentsOptions endpoint
var serializeInstallmentsOptionsData = exports.serializeInstallmentsOptionsData = function serializeInstallmentsOptionsData(_ref3) {
  var merchant_country = _ref3.checkoutAppData.merchant.merchant_country,
    checkoutCart = _ref3.checkoutCart,
    country = _ref3.country,
    id = _ref3.payee.merchant.id,
    isMemberCredit = _ref3.isMemberCredit,
    cc = _ref3.cc;
  var payload = {
    checkoutAppData: {
      merchant: {
        merchant_country: merchant_country
      }
    },
    checkoutCart: {},
    country: country,
    payee: {
      merchant: {
        id: id
      }
    },
    isMemberCredit: isMemberCredit,
    cc: cc
  };
  if (checkoutCart.purchase && checkoutCart.purchase.amounts) {
    var _checkoutCart$purchas = checkoutCart.purchase.amounts.total,
      amount = _checkoutCart$purchas.amount,
      currency_code = _checkoutCart$purchas.currency_code;
    payload.checkoutCart.purchase = {
      amounts: {
        total: {
          amount: amount,
          currency_code: currency_code
        }
      }
    };
  }
  return payload;
};
var $InstallmentOptionsModel = exports.$InstallmentOptionsModel = _squid.$Model.extend('$InstallmentOptionsModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/installmentOptions/',
    postAttempts: 2
  }),
  save: function save(options) {
    options.data = serializeInstallmentsOptionsData(options.data);
    return this._super.save.call(this, options);
  }
});
var $FlowEligibilityModel = exports.$FlowEligibilityModel = _squid.$Model.extend('$FlowEligibilityModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/flowEligibility'
  })
});
var $CheckoutShippingAddressModel = exports.$CheckoutShippingAddressModel = _squid.$Model.extend('$CheckoutShippingAddressModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:parent.id/shipping/:id'
  })
});
var $ShippingAddressModel = exports.$ShippingAddressModel = _squid.$Model.extend('$ShippingAddressModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/shipping/add'
  }),
  serialize: function serialize() {
    return {
      first_name: this.first_name,
      last_name: this.last_name,
      recipient_name: this.recipient_name,
      line1: this.line1,
      line2: this.line2,
      city: this.city,
      state: this.state,
      postal_code: this.postal_code,
      country: this.country
    };
  }
});
var $CheckoutPayeeModel = exports.$CheckoutPayeeModel = _squid.$Model.extend('$CheckoutPayeeModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/payee'
  }),
  getId: function getId() {
    return this.merchant && this.merchant.id;
  },
  isGambling: function isGambling() {
    return this.merchant && this.merchant.isGambling;
  },
  isOnBaNoStickyList: function isOnBaNoStickyList() {
    var merchantId = this.getId();
    return merchantId && _squid.$config.disableMerchantForStickyBA && _squid.$config.disableMerchantForStickyBA.indexOf(merchantId) > -1;
  }
});
var creditOptionsModel = {
  largeEligibleAmount: {
    US: 99,
    GB: 150
  }
};

// keeping sacEligibleAmount available for backwards compat, largeEligibleAmount preferred
creditOptionsModel.sacEligibleAmount = creditOptionsModel.largeEligibleAmount;
var $CreditOptionsModel = exports.$CreditOptionsModel = creditOptionsModel;
var $CheckoutShippingAddressesModel = exports.$CheckoutShippingAddressesModel = _squid.$Model.extend('$CheckoutShippingAddressesModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/shipping'
  }),
  onPopulate: function onPopulate() {
    this.addresses = this.children($CheckoutShippingAddressModel, this.addresses);
  },
  getPreferredShippingAddress: function getPreferredShippingAddress() {
    var preferredAddress = {};
    if (this.addresses) {
      var i;
      var address;
      for (i = 0; i < this.addresses.length; i++) {
        address = this.addresses[i];
        if (address && address.preferred_address) {
          preferredAddress = {
            line1: address.line1,
            line2: address.line2,
            city: address.city,
            state: address.state,
            postal_code: address.postal_code,
            country_code: address.country_code
          };
          break;
        }
      }
    }
    return preferredAddress;
  },
  getPrimaryShippingAddress: function getPrimaryShippingAddress() {
    var primaryAddress = {};
    if (this.addresses) {
      var i;
      var address;
      for (i = 0; i < this.addresses.length; i++) {
        address = this.addresses[i];
        if (address && address.primary_address) {
          primaryAddress = {
            line1: address.line1,
            line2: address.line2,
            city: address.city,
            state: address.state,
            postal_code: address.postal_code,
            country_code: address.country_code
          };
          break;
        }
      }
    }
    return primaryAddress;
  }
});
var $CheckoutPlanModel = exports.$CheckoutPlanModel = _squid.$Model.extend('$CheckoutPlanModel', {
  onPopulate: function onPopulate() {
    this.sources = this.children($FundingSourceModel, this.sources);
  },
  eachSource: function eachSource(method, context) {
    angular.forEach(this.sources, method, this);
  },
  hasFundingMethodType: function hasFundingMethodType(name) {
    var found = false;
    this.eachSource(function (source) {
      if (source.type === name) {
        found = true;
      }
    }, this);
    return found;
  },
  hasFundingMethodSubType: function hasFundingMethodSubType(name) {
    var found = false;
    this.eachSource(function (source) {
      if (source.sub_type === name) {
        found = true;
      }
    }, this);
    return found;
  },
  isPAD: function isPAD() {
    return this.hasFundingMethodSubType('DELAYED_TRANSFER');
  },
  isIACH: function isIACH() {
    var found = false;
    this.eachSource(function (source) {
      if (source.type === 'BANK_ACCOUNT' && source.sub_type === 'INSTANT_TRANSFER') {
        found = true;
      }
    }, this);
    return found;
  },
  isSplitBalance: function isSplitBalance() {
    return this.sources && this.sources.length > 1 && this.hasFundingMethodType('BALANCE');
  },
  isSplitPaymentWithBalanceAndIach: function isSplitPaymentWithBalanceAndIach() {
    return this.isSplitBalance() && this.isIACH();
  },
  isMSB: function isMSB() {
    return this.sources && this.sources.length === 1 && this.sources[0].type === 'INCENTIVE';
  },
  isBalance: function isBalance() {
    return this.sources && this.sources.length === 1 && this.sources[0].type === 'BALANCE';
  },
  hasConversion: function hasConversion() {
    return this.conversion !== null && typeof this.conversion === 'object';
  }
});
var $CardBackupModel = exports.$CardBackupModel = _squid.$Model.extend('$CardBackupModel', {
  onPopulate: function onPopulate() {
    if (!this.get('parent.meta.populated')) {
      return;
    }

    // If plan IDs change, we need to reevaluate the correct backup plan id
    this.resetIfDoesNotApply();
    this.reevaluateEligibility();
  },
  /**
   * getCardBackupInstrument
   * Get the user's last selection for card backup, if still eligible
   * @returns {Object|undefined} the plan of the user's last selection, or undefined otherwise
   */
  getPlan: function getPlan() {
    if (!this.isAllowed()) {
      return;
    }
    return this.plan;
  },
  /**
   * setCardBackupInstrument
   * Save the user's selection for backup. Tied to the currently selected plan
   * @param {Object} plan - the plan to use as the backup
   * @param {Object} [forPlan] - if needed, the plan to compare against. prefer not to pass it in
   */
  setPlan: function setPlan(plan, forPlan) {
    this.plan = plan;
    this.forPlan = forPlan || this.getCheckoutSessionPlan();
  },
  isAllowed: function isAllowed() {
    var _this$forPlan = this.forPlan,
      _this$forPlan2 = _this$forPlan === void 0 ? {} : _this$forPlan,
      _this$forPlan2$primar = _this$forPlan2.primaryFs,
      _this$forPlan2$primar2 = _this$forPlan2$primar === void 0 ? {} : _this$forPlan2$primar,
      type = _this$forPlan2$primar2.type,
      secondaryFIs = _this$forPlan2.secondaryFIs;
    if (type !== 'CARD' || secondaryFIs !== false) {
      return false;
    }
    return this.allowCardBackup;
  },
  getCheckoutSessionPlan: function getCheckoutSessionPlan() {
    return this.get('parent.fundingOptions.plans.0');
  },
  reevaluateEligibility: function reevaluateEligibility() {
    var _this3 = this;
    (0, _processorDecline.getProcessorDeclineRetryEligibility)(this.id, this.parent).then(function (eligibility) {
      _this3.allowCardBackup = eligibility;
      return eligibility;
    });
  },
  reset: function reset(forPlan) {
    this.setPlan(undefined, forPlan);
  },
  /**
   * resetIfDoesNotApply
   * resets the selected backup for card if no longer valid based on user's choice
   * matches the plan ID if still valid but plan IDs change
   * @param {String} [plan] - current checkout session funding options plan user has selected
   */
  resetIfDoesNotApply: function resetIfDoesNotApply(plan) {
    if (!plan) {
      plan = this.getCheckoutSessionPlan();
    }
    var getKey = function getKey(p) {
      return p && p.primaryFs && p.primaryFs.id;
    };
    var planKey = getKey(plan);
    var forKey = getKey(this.forPlan);
    if (!planKey || planKey !== forKey) {
      return this.reset(plan);
    }

    // Since planIds may change, if backup is still valid then find the new plan
    var plans = this.get('parent.fundingOptions.plans') || [];
    var currentPlanKey = getKey(this.plan);
    var newPlan = currentPlanKey && plans.find(function (p) {
      return getKey(p) === currentPlanKey;
    });

    // If, for whatever reason, the old instrument isn't in the new plans, we'll reset
    if (currentPlanKey && !newPlan) {
      return this.reset(plan);
    }
    this.forPlan = plan;
    this.plan = newPlan;
  }
});
var $CheckoutSessionModel = exports.$CheckoutSessionModel = _squid.$Model.extend('$CheckoutSessionModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:id/session',
    postAttempts: 2
  }),
  invalidateOnLogout: true,
  // invalidate this model when auth.logout() gets called
  smartDollarAuthFailed: false,
  // initial value for smartDollar authorization check

  onPopulate: function onPopulate() {
    try {
      // Initialize plan, shipping, and funding options
      this.plan = new $CheckoutPlanModel(this.plan);
      this.shipping = this.child($CheckoutShippingAddressModel, this.shipping);
      this.fundingOptions = this.child($FundingOptionsModel, this.fundingOptions);
      var wallet = _wallet.$WalletModel.instance(_squid.$meta.token);

      // Ensure wallet and fundingOptions exist before proceeding
      if (wallet && this.fundingOptions && this.fundingOptions.parent && this.fundingOptions.parent.selectedFuturePaymentInstrument) {
        var instrumentId = this.fundingOptions.parent.selectedFuturePaymentInstrument.instrument_id;
        var allAccounts = {
          bank_accounts: wallet.bank_accounts || [],
          card_accounts: wallet.card_accounts || [],
          credit_accounts: wallet.credit_accounts || []
        };
        var matchingCategory = null;
        var matchingWallet = null;

        // Iterate over all account categories to find the matching object
        Object.keys(allAccounts).forEach(function (category) {
          var found = allAccounts[category].find(function (account) {
            return account.id === instrumentId;
          });
          if (found) {
            matchingWallet = found;
            matchingCategory = category;
          }
        });
        if (matchingWallet) {
          console.log('Matching Wallet Object found in ' + matchingCategory + ':', matchingWallet);
          this.selectedWallet = matchingWallet; // Use selectedFuturePaymentInstrument
        } else {
          console.log('No matching wallet found for instrument ID:', instrumentId);
          this.selectedWallet = this.fundingOptions.parent.selectedFuturePaymentInstrument;
        }
      } else {
        console.log('selectedFuturePaymentInstrument does not exist, fallback to default logic.');

        // Default fallback logic: select the first eligible funding option
        var _allAccounts = {
          bank_accounts: wallet ? wallet.bank_accounts || [] : [],
          card_accounts: wallet ? wallet.card_accounts || [] : [],
          credit_accounts: wallet ? wallet.credit_accounts || [] : []
        };
        var firstBank = _allAccounts.bank_accounts[0];
        var firstCard = _allAccounts.card_accounts[0];
        var firstCredit = _allAccounts.credit_accounts[0];
        if (this.selectedWallet) {
          console.log('Selected first available wallet:', this.selectedWallet);

          // Prioritize accounts in the order: bank > card > credit
          this.selectedWallet = firstBank || firstCard || firstCredit;
        }
      }
    } catch (e) {
      console.error('Error in onPopulate:', e);
      this.selectedWallet = null; // Reset to null if an error occurs
    }

    // Reevaluate the eligibility for allowing backup with cards.
    this.cardBackup = this.child($CardBackupModel, this.cardBackup || {});
    // Emit a session change event for apps to react accordingly
    _squid.$event.emit('checkoutSessionChange');
  },
  /**
   * Finds the plan in billing cases that the user is intending to use as the sticky FI.
   * @return {Object} the instrument representation from futurePaymentInstruments
   */
  getSelectedStickyInstrument: function getSelectedStickyInstrument() {
    // This method doesn't apply for non-billing cases
    if (!this.futurePaymentInstruments) {
      return;
    }

    // For BA no purchase cases (no plan), use either
    // 1. selectedFuturePaymentInstrument (we've made and persisted a selection)
    // 2. first of futurePaymentInstruments (we haven't made a selection and need to save it later)
    if (!(this.plan && this.plan.sources)) {
      return this.selectedFuturePaymentInstrument || this.futurePaymentInstruments[0];
    }

    // Otherwise, if we have a plan list (ie. this is a purchase case),
    // we'll always want to take the currently selected plan,
    // as selectedFuturePaymentInstrument may not be updated to the user's current plan
    var selectedInstrumentId = _squid.$util.some(this.plan.sources, function (fi) {
      return fi.instrument_id ? fi.instrument_id : undefined;
    });
    var stickyInstrument = _squid.$util.find(this.futurePaymentInstruments, function (fi) {
      return fi.instrument_id === selectedInstrumentId;
    });
    return stickyInstrument;
  },
  /**
   * Retrieves the selected sticky financial instrument for the disclaimer.
   * @return {Object} The instrument representation from futurePaymentInstruments.
   */
  getSelectedStickyInstrumentForDisclaimer: function getSelectedStickyInstrumentForDisclaimer() {
    var fiMetaInstance = _index["default"].instance(_squid.$meta.token);
    return Object.keys(this.selectedWallet || {}).length ? fiMetaInstance.getName(this.selectedWallet) : this.getSelectedStickyInstrument() && this.getSelectedStickyInstrument().name;
  },
  getPlanList: function getPlanList() {
    // Only show plans that need to be shown.
    return this.fundingOptions && this.fundingOptions.getDisplayPlans();
  },
  // returns true if more than one plan uses BALANCE as the primary FI
  isMultipleBalancePlan: function isMultipleBalancePlan() {
    var matchingBalancePlans = 0;
    return this.fundingOptions && this.fundingOptions.plans && this.fundingOptions.plans.some(function (plan) {
      // if BALANCE is the primary FI...
      if (plan.primaryFs.name === 'BALANCE') {
        // increment number of balance plans found
        matchingBalancePlans++;
      }
      // exit once we have more than one balance plan
      return matchingBalancePlans > 1;
    });
  },
  getDisallowedInstruments: function getDisallowedInstruments() {
    if (this.fundingOptions && this.fundingOptions.disallowedInstruments && angular.isArray(this.fundingOptions.disallowedInstruments)) {
      var filteredDisallowedInstruments = this.fundingOptions.disallowedInstruments.filter(function (instrument) {
        if (instrument.type === 'CARD' && instrument.declineReason === 'unsupportedDueToExpiration') {
          return (0, _utils.filterCardWithinLastNMonths)(instrument, (0, _squid.$feature)('expirePeriod'));
        }
        return true;
      });
      this.fundingOptions.disallowedInstruments = filteredDisallowedInstruments;
    }
    return this.fundingOptions && this.fundingOptions.disallowedInstruments;
  },
  getDisallowedPreferred: function getDisallowedPreferred() {
    var disallowedInstrument = this.getDisallowedInstruments();

    // find only the disallowed instrument that has been marked as preferred.
    disallowedInstrument = disallowedInstrument && _squid.$util.find(disallowedInstrument, function (fi) {
      return fi.isPreferred;
    });

    // if the disallowed instrument is in the plan list (in the case that the instrument has a BUF)
    // we do not show it in the disallowed section.
    var isDisallowedInstrumentInPlanList = disallowedInstrument && _squid.$util.some(this.getPlanList(), function (plan) {
      var instrumentID = plan.primaryFs && plan.primaryFs.id;
      if (instrumentID && disallowedInstrument.id) {
        return instrumentID === disallowedInstrument.id;
      } else {
        return false;
      }
    });
    return !isDisallowedInstrumentInPlanList && disallowedInstrument;
  },
  isBalanceDisallowed: function isBalanceDisallowed() {
    var disallowedInstruments = this.getDisallowedInstruments();
    return disallowedInstruments && disallowedInstruments.some(function (fi) {
      return fi.type === 'BALANCE';
    });
  },
  expiredInstruments: function expiredInstruments() {
    var expiredInstruments = [];
    var disallowedPreferred = this.getDisallowedPreferred();
    var disallowedInstruments = this.getDisallowedInstruments();
    if (disallowedPreferred) {
      expiredInstruments.push(disallowedPreferred);
    }
    _squid.$util.forEach(disallowedInstruments, function (instrument) {
      if (instrument.type === 'CARD' && !instrument.isPreferred && instrument.declineReason === 'unsupportedDueToExpiration') {
        expiredInstruments.push(instrument);
      }
    });
    return expiredInstruments;
  },
  preferredExpiredInstruments: function preferredExpiredInstruments() {
    var disallowedPreferred = this.getDisallowedPreferred();
    if (disallowedPreferred && disallowedPreferred.type === 'CARD' && disallowedPreferred.isPreferred && disallowedPreferred.declineReason === 'unsupportedDueToExpiration') {
      return true;
    }
    return false;
  },
  getShippingAddressMinimalDetails: function getShippingAddressMinimalDetails() {
    return {
      line1: this.shipping.line1,
      line2: this.shipping.line2,
      city: this.shipping.city,
      state: this.shipping.state,
      postal_code: this.shipping.postal_code,
      country_code: this.shipping.country
    };
  },
  getPPCconversionInfo: function getPPCconversionInfo() {
    var ppcFi;
    if (this.fundingOptions && this.fundingOptions.instruments) {
      ppcFi = this.fundingOptions.instruments.find(function (fi) {
        return fi.type === 'CREDIT' && fi.name === 'BILL_ME_LATER';
      });
    }
    if (ppcFi && ppcFi.currency_conversion) {
      return Object.assign({}, ppcFi.currency_conversion);
    }
    return null;
  }
});
angular.value("$CheckoutCartModel", $CheckoutCartModel);
angular.value("$CheckoutAppDataModel", $CheckoutAppDataModel);
angular.value("$FundingSourceModel", $FundingSourceModel);
angular.value("$FundingOptionsModel", $FundingOptionsModel);
angular.value("serializeInstallmentsOptionsData", serializeInstallmentsOptionsData);
angular.value("$InstallmentOptionsModel", $InstallmentOptionsModel);
angular.value("$FlowEligibilityModel", $FlowEligibilityModel);
angular.value("$CheckoutShippingAddressModel", $CheckoutShippingAddressModel);
angular.value("$ShippingAddressModel", $ShippingAddressModel);
angular.value("$CheckoutPayeeModel", $CheckoutPayeeModel);
angular.value("$CreditOptionsModel", $CreditOptionsModel);
angular.value("$CheckoutShippingAddressesModel", $CheckoutShippingAddressesModel);
angular.value("$CheckoutPlanModel", $CheckoutPlanModel);
angular.value("$CardBackupModel", $CardBackupModel);
angular.value("$CheckoutSessionModel", $CheckoutSessionModel);
_squid.$Class;
_squid.$Model;
_squid.$Api;
_squid.$util;
_squid.$config;
_squid.$locale;
_squid.$event;
_squid.$feature;
_processorDecline.getProcessorDeclineRetryEligibility;
_utils.filterCardWithinLastNMonths;
_wallet.$WalletModel;
_squid.$meta;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-models/src/checkout/lib/utils.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.filterCardWithinLastNMonths = void 0;
/**
* @param {Date} d1
* @param {Date} d2
* @returns {number}
*/
var monthDiff = function monthDiff(d1, d2) {
  var months;
  months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth() + 1;
  months += d2.getMonth() + 1;
  return months <= 0 ? 0 : months;
};

/**
* @param {Object} fi - A funding instrument
* @param {boolean} expiredPeriod - feature boolean flag from config.json
* @returns {boolean}
*/
var filterCardWithinLastNMonths = exports.filterCardWithinLastNMonths = function filterCardWithinLastNMonths(fi, expirePeriod) {
  var expire_year = fi.expire_year,
    expire_month = fi.expire_month;
  var expiryDate = new Date(expire_year + '-' + expire_month + '-01');
  var monthDifference = monthDiff(expiryDate, new Date());
  return monthDifference !== 0 && monthDifference <= expirePeriod;
};

/***/ }),

/***/ "../node_modules/xo-models/src/consent/consent.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ConsentModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var $ConsentModel = exports.$ConsentModel = _squid.$Model.extend('$ConsentModel', {
  api: new _squid.$Api({
    uri: '/api/consent',
    cache: false,
    postAttempts: 2
  }),
  onPopulate: function onPopulate() {
    if (!this.meta || !this.meta.populated) {
      // Data didn't fetch yet, just populate afterwards
      return;
    }
    if (!this.policy_info || !this.policy_info.status) {
      _logger.$logger.info('consent_serv_no_data_found');
      return;
    }
    this.activeUrl = this.policy_info.active_url;
    this.upcomingUrl = this.policy_info.upcoming_url;
    this.majorVersion = this.policy_info.major_version;
    this.minorVersion = this.policy_info.minor_version;
    this.status = this.policy_info.status;
  },
  getActiveUrl: function getActiveUrl() {
    return this.activeUrl;
  },
  getUpcomingUrl: function getUpcomingUrl() {
    return this.upcomingUrl;
  },
  getMajorVersion: function getMajorVersion() {
    return this.majorVersion;
  },
  getMinorVersion: function getMinorVersion() {
    return this.minorVersion;
  },
  getStatus: function getStatus() {
    return this.status;
  }
});
angular.value("$ConsentModel", $ConsentModel);
_squid.$Model;
_squid.$Api;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/consent/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _consent = __webpack_require__("../node_modules/xo-models/src/consent/consent.js");
Object.keys(_consent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _consent[key]) return;
  exports[key] = _consent[key];
});
var _userAgreementConsent = __webpack_require__("../node_modules/xo-models/src/consent/userAgreementConsent.js");
Object.keys(_userAgreementConsent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _userAgreementConsent[key]) return;
  exports[key] = _userAgreementConsent[key];
});

/***/ }),

/***/ "../node_modules/xo-models/src/consent/userAgreementConsent.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$UserAgreementConsentModel = void 0;
var _consent = __webpack_require__("../node_modules/xo-models/src/consent/consent.js");
var CONSENT_USER_AGREEMENT_DEFAULT = {
  activeUrl: '/webapps/mpp/ua/useragreement-full',
  upcomingUrl: '/webapps/mpp/ua/upcoming-policies-full',
  majorVersion: '3',
  minorVersion: '2',
  status: 'PENDING'
};
var $UserAgreementConsentModel = exports.$UserAgreementConsentModel = _consent.$ConsentModel.extend('$UserAgreementConsentModel', {
  init: function init() {
    this._super.init.apply(this);
    this.setProperties(CONSENT_USER_AGREEMENT_DEFAULT);
  }
});
angular.value("$UserAgreementConsentModel", $UserAgreementConsentModel);
_consent.$ConsentModel;

/***/ }),

/***/ "../node_modules/xo-models/src/eligibility/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$stickyCTA = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");
var checkEligibility = function checkEligibility() {
  var token = _angular.$rootScope.token;
  var models = {};
  return _squid.$promise.all([(0, _squid.$populate)(models, {
    checkoutCartModel: _checkout.$CheckoutCartModel.instance(token),
    checkoutSessionModel: _checkout.$CheckoutSessionModel.instance(token),
    checkoutAppDataModel: _checkout.$CheckoutAppDataModel.instance(token)
  }), _gdprCookieBanner.$GDPRCookieBannerModel.instance().hasBanner()]).then(function () {
    // Device Checks
    var userAgent = _angular.$window.navigator.userAgent;
    var isIE = !!userAgent.match(/MSIE|trident|edge/i);
    var isMobile = _index.$DeviceInfo.isMobile();
    var miniBrowser = _angular.$rootScope.miniBrowser;
    var isValidTraffic = isMobile || miniBrowser;
    var isSmallScreen = _angular.$window.innerWidth <= 600;

    // Flow Checks
    var billing = models.checkoutCartModel.isBilling();
    var invoice = models.checkoutAppDataModel.get('flags.is_invoice_flow');
    var upop = models.checkoutSessionModel.unconfirmed_upop;
    var gpdr = _gdprCookieBanner.$GDPRCookieBannerModel.instance().shown();

    // Feature checks
    var eligibleCountry = (0, _squid.$feature)('stickyCTA');
    var ineligibilityConditions = {
      isIE: isIE,
      upop: upop,
      invoice: invoice,
      gpdr: gpdr,
      billing: billing,
      isNotSmallScreen: !isSmallScreen,
      isNotValidTraffic: !isValidTraffic,
      isNotEligibleCountry: !eligibleCountry
    };
    var decision = isValidTraffic && eligibleCountry && isSmallScreen && !billing && !invoice && !upop && !isIE && !gpdr;
    var ineligibilityReasons = Object.keys(ineligibilityConditions).filter(function (key) {
      return ineligibilityConditions[key];
    });
    var eligibility_reason = 'eligible';
    if (ineligibilityReasons.length > 0 || !decision) {
      eligibility_reason = "ineligible-" + ineligibilityReasons.join(',');
    }
    _logger.$logger.info('checkout_fpti', {
      from: 'sticky_cta',
      to: 'process_eligibility_check',
      eligibility_reason: eligibility_reason
    });
    return decision;
  });
};
var checkPxp = function checkPxp() {
  var _$CheckoutAppDataMode = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
    merchant = _$CheckoutAppDataMode.merchant;
  var country = merchant && merchant.merchant_country;
  return (0, _squid.$pxp)('xo_hermesnode_config', {
    'ctx.COUNTRY': country
  }, 'xo_hermesnode_sticky_cta_(.*)', false, true).then(function (treatment) {
    if (treatment) {
      var test = /xo_hermesnode_sticky_cta_(.*)/g;
      var name = treatment && treatment.treatment_name;
      var treatmentTest = test.exec(name);
      var treatmentName = treatmentTest.length > 1 && treatmentTest[1];
      _logger.$logger.info('checkout_fpti', {
        from: 'sticky_cta',
        to: 'process_pxp_check',
        eligibility_reason: treatmentName
      });
      return treatmentName;
    }
    return '';
  });
};
var mapper = function mapper(eligibility, treatment) {
  var variant = {
    'treatmentA': 'bottom',
    'treatmentB': 'top',
    'control': '',
    'DEFAULT': ''
  };
  var result = variant[treatment] || variant.DEFAULT;
  _logger.$logger.info('checkout_fpti', {
    from: 'sticky_cta',
    to: 'process_variant_check',
    eligibility_reason: result || 'ineligible'
  });
  return result;
};

/**
 * To be replaced by $EligibilityClass.
 * Following new EligibilityClass pattern.
*/
var $stickyCTA = exports.$stickyCTA = _squid.$Model.extend('$stickyCTA', {
  getEligibility: function getEligibility() {
    return checkEligibility().then(function (eligibility) {
      if (eligibility) {
        return checkPxp().then(function (treatment) {
          return mapper(eligibility, treatment);
        });
      } else {
        return '';
      }
    });
  }
});
angular.value("$stickyCTA", $stickyCTA);
_angular.$rootScope;
_angular.$window;
_logger.$logger;
_squid.$Model;
_squid.$populate;
_squid.$pxp;
_squid.$feature;
_squid.$promise;
_index.$DeviceInfo;
_checkout.$CheckoutCartModel;
_checkout.$CheckoutSessionModel;
_checkout.$CheckoutAppDataModel;
_gdprCookieBanner.$GDPRCookieBannerModel;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.BILLING_ADDRESS_FORMAT = exports.$WalletPreferences = exports.$WalletInstrumentNameMapping = exports.$UnavailableCardModel = exports.$SepaModel = exports.$ResolveOTP = exports.$Resolve3DS = exports.$PreferredFi = exports.$DeleteCardModel = exports.$CurrencyConversionModel = exports.$CardTypesModel = exports.$CardTypeFromBinModel = exports.$CardModel = exports.$CardInfoModel = exports.$CardConfirmationModel = exports.$BillingAddressesModel = exports.$BillingAddressModel = exports.$BankModel = exports.$AddCardModel = exports.$AddBillingAddressModel = exports.$AddBankModel = void 0;
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var BILLING_ADDRESS_FORMAT = exports.BILLING_ADDRESS_FORMAT = {
  DEFAULT: {
    ',': ', ',
    ' ': ' '
  },
  IL: {
    he: {
      ',': '‏, ‏',
      ' ': '‏ ‏'
    }
  }
};
var $CardModel = exports.$CardModel = _squid.$Model.extend('$CardModel', {
  serialize: function serialize() {
    return {
      type: this.type,
      number: this.number.replace(/[^\d]+/g, ''),
      security_code: this.security_code,
      expiry_month: this.expiry_month && _squid.$util.pad(this.expiry_month, 2),
      expiry_year: this.expiry_year,
      issue_number: this.issue_number ? this.issue_number : undefined,
      start_month: this.start_month ? _squid.$util.pad(this.start_month, 2) : undefined,
      start_year: this.start_year ? this.start_year : undefined
    };
  },
  last4: function last4() {
    var cardNumber = this.number;
    return cardNumber.substr(cardNumber.length - 4);
  },
  isExisting: function isExisting() {
    return this.number && Boolean(this.number.match(/^xxxx-xxxx-xxxx-[\d]{4}$/));
  }
});
var $AddCardModel = exports.$AddCardModel = _squid.$Model.extend('$AddCardModel', {
  api: new _squid.$Api({
    uri: '/api/fi/card/:id?'
  }),
  init: function init() {
    this._super.init.apply(this);
    this.card = new $CardModel();
  },
  serialize: function serialize() {
    var id = this.address.id && this.address.id !== '0' ? this.address.id : undefined;
    return {
      cardType: this.cardType ? this.cardType : 'creditCard',
      sponsor_id: this.sponsor_id,
      preference: this.preference,
      user: this.user,
      card: this.card.serialize(),
      address: id ? {
        id: id
      } : this.address.serialize()
    };
  },
  clearId: function clearId() {
    delete this.id;
  }
});
var $UnavailableCardModel = exports.$UnavailableCardModel = _squid.$Model.extend('$UnavailableCardModel', {
  api: new _squid.$Api({
    uri: '/api/fi/unavailable/card?addFIContingency'
  })
});
var $CardTypesModel = exports.$CardTypesModel = _squid.$Model.extend('$CardTypesModel', {
  api: new _squid.$Api({
    uri: '/api/fi/card/types?country=:country&token=:token'
  }),
  retrieve: function retrieve() {
    return this._super.retrieve.apply(this, arguments).then(function (result) {
      this.disallowedCards = (0, _squid.$feature)('disallowedCards', undefined, this.country);
      // override disallowed cards with card types config list based on country
      if (this.disallowedCards) {
        result.disallowed = this.disallowedCards.cardTypes;
      }
      return result;
    });
  },
  supportedNames: function supportedNames() {
    if (typeof this.allowed === 'undefined') {
      return;
    }
    return this.allowed.map(function (type) {
      return _squid.$locale.content.cardTypes[type];
    });
  },
  unsupportedNames: function unsupportedNames() {
    if (typeof this.disallowed === 'undefined') {
      return;
    }
    return this.disallowed.map(function (type) {
      return _squid.$locale.content.cardTypes[type];
    });
  }
});
var $BankModel = exports.$BankModel = _squid.$Model.extend('$BankModel', {
  init: function init() {
    this._super.init.apply(this);
    this.bank_account_number = '';
    this.bank_routing_number = '';
    this.iban_number = '';
  },
  serialize: function serialize() {
    var data = {};
    if (this.bank_account_number) {
      data.bank_account_number = this.bank_account_number;
    }
    if (this.bank_routing_number) {
      data.bank_routing_number = this.bank_routing_number;
    }
    if (this.iban_number) {
      data.iban_number = this.iban_number.replace(/\s/g, '').toUpperCase();
    }
    return data;
  }
});
var $AddBankModel = exports.$AddBankModel = _squid.$Model.extend('$AddBankModel', {
  api: new _squid.$Api({
    uri: '/api/fi/bank'
  }),
  init: function init() {
    this._super.init.apply(this);
    this.user = this.user || {
      first_name: '',
      dob_day: '',
      dob_month: '',
      dob_year: '',
      currency_code: '',
      country: ''
    };
    this.bank = this.bank || new $BankModel();
    this.address = this.address || {};
    this.creditorDetails = this.creditorDetails || {};
    this.fiDetails = this.fiDetails || {};
  },
  getBankData: function getBankData() {
    var data = {};

    // Set user info
    data.user = this.user;

    // Set bank info
    var bank = {};
    this.bank = this.bank || {};
    if (this.candidate_id) {
      data.candidate_id = this.candidate_id;
    }
    if (this.bank.bank_account_number) {
      bank.bank_account_number = this.bank.bank_account_number;
    }
    if (this.bank.bank_routing_number) {
      bank.bank_routing_number = this.bank.bank_routing_number;
    }
    if (this.bank.iban_number) {
      bank.iban_number = this.bank.iban_number.replace(/\s/g, '');
    }
    data.bank = bank;

    // Set address info
    if (this.address) {
      data.address = {
        line1: this.address.line1,
        line2: this.address.line2,
        city: this.address.city,
        country: this.address.country,
        postal_code: this.address.postal_code
      };
    }
    return data;
  }
});
var $PreferredFi = exports.$PreferredFi = _squid.$Model.extend('$PreferredFi', {
  api: new _squid.$Api({
    uri: '/api/fi/preferred'
  }),
  init: function init() {
    this._super.init.apply(this);

    // Get the type of device to send to FI for logging
    function getUiChannel() {
      var capabilities = _index.$DeviceInfo.getCapabilities();
      if (capabilities.isTablet) {
        return 'Tablet';
      } else if (capabilities.isMobile) {
        return 'Mobile';
      } else if (capabilities.isDesktop) {
        return 'Desktop';
      } else if (capabilities.isApp) {
        return 'App';
      } else {
        return null;
      }
    }
    this.uiChannel = getUiChannel();
  },
  serialize: function serialize() {
    return {
      preferred: this.preferred,
      uiChannel: this.uiChannel
    };
  }
});
var $SepaModel = exports.$SepaModel = _squid.$Model.extend('$SepaModel', {
  api: new _squid.$Api({
    uri: '/api/fi/bank'
  })
});
var $DeleteCardModel = exports.$DeleteCardModel = _squid.$Model.extend('$DeleteCardModel', {
  api: new _squid.$Api({
    uri: '/api/fi/card/:id/delete'
  })
});
var $AddBillingAddressModel = exports.$AddBillingAddressModel = _squid.$Model.extend('$AddBillingAddressModel', {
  api: new _squid.$Api({
    uri: '/api/fi/:instrumentid/addbillingaddress'
  })
});
var $BillingAddressModel = exports.$BillingAddressModel = _squid.$Model.extend('$BillingAddressModel', {
  api: new _squid.$Api({
    uri: '/api/fi/billingaddress/validate'
  }),
  format: function format() {
    var langConfig = (BILLING_ADDRESS_FORMAT[_squid.$locale.country] || {})[_squid.$locale.lang] || {};
    var comma = angular.isUndefined(langConfig[',']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][','] : langConfig[','];
    var space = angular.isUndefined(langConfig[' ']) ? BILLING_ADDRESS_FORMAT['DEFAULT'][' '] : langConfig[' '];
    return _squid.$util.filter([this.line1, this.line2, this.city, this.state, this.country]).join(comma) + space + _squid.$util.filter([this.postal_code]);
  },
  serialize: function serialize() {
    return {
      line1: this.line1 && this.line1.trim(),
      line2: this.line2 && this.line2.trim(),
      city: this.city && this.city.trim(),
      state: this.state && this.state.trim(),
      postal_code: this.postal_code && this.postal_code.trim(),
      normalization_status: this.normalization_status,
      country: this.country
    };
  }
});
var $CurrencyConversionModel = exports.$CurrencyConversionModel = _squid.$Model.extend('$CurrencyConversionModel', {
  api: new _squid.$Api({
    uri: '/api/fi/currencyConversion'
  })
});
var $BillingAddressesModel = exports.$BillingAddressesModel = _squid.$Model.extend('$BillingAddressesModel', {
  api: new _squid.$Api({
    uri: '/api/fi/billingaddress'
  }),
  onPopulate: function onPopulate() {
    this.addresses = this.children($BillingAddressModel, this.addresses);
  }
});
var $CardTypeFromBinModel = exports.$CardTypeFromBinModel = _squid.$Model.extend('$CardTypeFromBinModel', {
  api: new _squid.$Api({
    uri: '/api/fi/cardTypeFromBin'
  })
});
var $Resolve3DS = exports.$Resolve3DS = _squid.$Model.extend('$Resolve3DS', {
  api: new _squid.$Api({
    uri: '/api/fi/3ds/:id'
  })
});
var $CardConfirmationModel = exports.$CardConfirmationModel = _squid.$Model.extend('$CardConfirmationModel', {
  api: new _squid.$Api({
    uri: '/api/fi/card/:id/confirmations'
  })
});
var $ResolveOTP = exports.$ResolveOTP = _squid.$Model.extend('$ResolveOTP', {
  api: new _squid.$Api({
    uri: '/api/fi/otp/:id'
  })
});
var $WalletPreferences = exports.$WalletPreferences = _squid.$Model.extend('$WalletPreferences', {
  api: new _squid.$Api({
    uri: '/api/fi/wallet/preferences'
  }),
  invalidateOnLogout: true,
  // invalidate this model when auth.logout() gets called

  init: function init() {
    this._super.init.apply(this);
    this.topup = {};
    this.direct = {};
  },
  serialize: function serialize() {
    var data = {};
    if (this.topup.amount) {
      var _this$topup = this.topup,
        amount = _this$topup.amount,
        _this$topup$fundingSo = _this$topup.fundingSource,
        _this$topup$fundingSo2 = _this$topup$fundingSo === void 0 ? {} : _this$topup$fundingSo,
        instrument_id = _this$topup$fundingSo2.instrument_id;

      // Set the Topup funding instrument in the wallet preference api, which will be used by future Topup transactions
      data.topup = {
        amount: amount,
        instrument_id: instrument_id,
        autoload_minimum_threshold: _squid.$config.topup.autoload_minimum_threshold
      };
    } else {
      var _this$direct$fundingS = this.direct.fundingSource,
        _this$direct$fundingS2 = _this$direct$fundingS === void 0 ? {} : _this$direct$fundingS,
        _instrument_id = _this$direct$fundingS2.instrument_id;

      // Set the Direct funding instrument in the wallet preference api, which will be used by future Direct funding transactions
      data.direct = {
        instrument_id: _instrument_id,
        currency_code: this.currency
      };
    }
    return data;
  },
  /**
      * Return the preferred topup/direct fundingsource.
      * Originally values of topup & direct are from the FI wallet preferences api, which gets assigned during the init() call.
      * Values can be changed in the Review and the Wallet pages.
      */
  getPreferred: function getPreferred() {
    if (this.topup.fundingSource && this.topup.fundingSource.instrument_id) {
      // xo-hermes-fi will always return topup.fundingSource even when there is no preferred topup instrument, hence making the additional check here.
      return this.topup.fundingSource;
    } else {
      return this.direct.fundingSource || {};
    }
  }
});
var $WalletInstrumentNameMapping = exports.$WalletInstrumentNameMapping = _squid.$Model.extend('$WalletInstrumentNameMapping', {
  init: function init() {
    this._super.init.apply(this);
    this.INSTRUMENT_MAP = {
      AMSOUTH: /AMSOUTH,/,
      BOFA: /BANK OF AMERICA/,
      CAPITAL: /CAPITAL/,
      CHASE: /CHASE/,
      CITI: /CITIBANK/,
      FIFTHTHIRD: /FIFTH THIRD BANK/,
      HUNTINGTON: /HUNTINGTON/,
      INGDIRECT: /ING DIRECT/,
      NATIONALCITY: /NATIONAL CITY/,
      PNC: /PNC/,
      REGIONS: /REGIONS/,
      SUNTRUST: /SUNTRUST/,
      TDWATERHOUSE: /TD WATERHOUSE/,
      USAA: /USAA/,
      USBANK: /US BANK/,
      VISA: /VISA/,
      WAMUTUAL: /WASHINGTON MUTUAL/,
      WELLSFARGO: /WELLS FARGO/
    };
    this.INSTRUMENT_NAMES = Object.keys(this.INSTRUMENT_MAP);
  },
  getInstrumentNameNormalized: function getInstrumentNameNormalized(fsName) {
    var _this = this;
    if (!fsName) {
      return;
    }
    fsName = fsName.toUpperCase();
    return _squid.$util.find(this.INSTRUMENT_NAMES, function (instName) {
      if (_this.INSTRUMENT_MAP[instName].test(fsName)) {
        return true;
      }
      return false;
    });
  }
});
var $CardInfoModel = exports.$CardInfoModel = _squid.$Model.extend('$CardInfoModel', {
  api: new _squid.$Api({
    uri: '/api/fi/card/:id'
  })
});
angular.value("BILLING_ADDRESS_FORMAT", BILLING_ADDRESS_FORMAT);
angular.value("$CardModel", $CardModel);
angular.value("$AddCardModel", $AddCardModel);
angular.value("$UnavailableCardModel", $UnavailableCardModel);
angular.value("$CardTypesModel", $CardTypesModel);
angular.value("$BankModel", $BankModel);
angular.value("$AddBankModel", $AddBankModel);
angular.value("$PreferredFi", $PreferredFi);
angular.value("$SepaModel", $SepaModel);
angular.value("$DeleteCardModel", $DeleteCardModel);
angular.value("$AddBillingAddressModel", $AddBillingAddressModel);
angular.value("$BillingAddressModel", $BillingAddressModel);
angular.value("$CurrencyConversionModel", $CurrencyConversionModel);
angular.value("$BillingAddressesModel", $BillingAddressesModel);
angular.value("$CardTypeFromBinModel", $CardTypeFromBinModel);
angular.value("$Resolve3DS", $Resolve3DS);
angular.value("$CardConfirmationModel", $CardConfirmationModel);
angular.value("$ResolveOTP", $ResolveOTP);
angular.value("$WalletPreferences", $WalletPreferences);
angular.value("$WalletInstrumentNameMapping", $WalletInstrumentNameMapping);
angular.value("$CardInfoModel", $CardInfoModel);
_index.$DeviceInfo;
_squid.$Model;
_squid.$Api;
_squid.$util;
_squid.$config;
_squid.$feature;
_squid.$locale;

/***/ }),

/***/ "../node_modules/xo-models/src/fi/lib/fiApis.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$fiApis = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var $fiApis = exports.$fiApis = {
  patchCvv: function patchCvv(checkoutSession) {
    var cvvData = checkoutSession.get('cvvData');
    if (cvvData) {
      return checkoutSession.action('patchCvv', {
        data: {
          id: cvvData.id,
          cvv: cvvData.security_code,
          type: cvvData.type,
          number: cvvData.number
        }
      });
    }
    return _angular.$q.when();
  }
};
angular.value("$fiApis", $fiApis);
_angular.$q;

/***/ }),

/***/ "../node_modules/xo-models/src/fiMeta/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _wallet = __webpack_require__("../node_modules/xo-models/src/wallet/index.js");
var _dist = __webpack_require__("../node_modules/squid/dist/index.js");
var PADSUBTYPE = 'DELAYED_TRANSFER';
var MEFTSUBTYPE = 'MEFT';
var IACHSUBTYPE = 'IACH';
var ECHECKSUBTYPE = 'ECHECK';

// any mappings to normalize fi name
var NAME_MAPPINGS = {
  'MERCHANT_SPECIFIC_BALANCE': 'INCENTIVE'
};

// eslint-disable-next-line no-confusing-arrow
var allFis = function allFis(plan) {
  return plan.secondaryFIs ? [plan.primaryFs].concat(plan.secondaryFIs) : [plan.primaryFs];
};
var isSubType = function isSubType(subtype) {
  return function (fi) {
    return fi.subtype === subtype || fi.sub_type === subtype;
  };
};
var capFirst = function capFirst(product) {
  return product && product.charAt(0).toUpperCase() + product.slice(1).toLowerCase();
};
var _default = exports["default"] = _squid.$Model.extend('$FiMetaModel', {
  invalidateOnLogout: true,
  onInvalidate: function onInvalidate() {
    if (this.session) {
      delete this.session;
    }
    if (this.wallet) {
      delete this.wallet;
    }
  },
  fetch: function fetch() {
    var _this = this;
    if (_squid.$config.disableCardArt) {
      return _squid.$promise.resolve(this);
    } else {
      return _squid.$promise.all({
        session: _checkout.$CheckoutSessionModel.instance(this.id).retrieve(),
        wallet: _wallet.$WalletModel.instance(this.id).retrieve()
      }).then(function (r) {
        return _squid.$util.extend(_this, r);
      });
    }
  },
  cardArtEnabled: function cardArtEnabled() {
    if ((0, _squid.$feature)('cardArtEnabled', false)) {
      // return true if feature config enabled for countries and have wallet
      return this.wallet && true;
    }
    return false;
  },
  getCardArt: function getCardArt(fi) {
    return this.wallet && this.cardArtEnabled() && this.wallet.getCardArt(fi);
  },
  plans: function plans() {
    return this.session.fundingOptions.plans;
  },
  hasPadPlan: function hasPadPlan() {
    return this.plans().map(allFis).some(function (fis) {
      return fis.some(isSubType(PADSUBTYPE));
    });
  },
  type: function type(fi) {
    if (fi.type === 'CREDIT' || fi.type === 'BILL_ME_LATER') {
      return 'CREDIT';
    } else {
      return fi.type;
    }
  },
  getName: function getName(fi) {
    if (fi.isPinlessDebit || fi.is_pinless_debit) {
      return (0, _dist.$renderContent)('fsMappings.PINLESSDEBIT');
    }

    // Normalize fs name for content key lookup
    var name = NAME_MAPPINGS[fi.name] || fi.name;
    return this.wallet && this.wallet.getCustomName(fi) || (0, _dist.$renderContent)("fsMappings." + name).toString() || name;
  },
  getAmount: function getAmount(fi) {
    return fi.amount;
  },
  getCurrencyCode: function getCurrencyCode(fi) {
    return fi.amount.currency_code;
  },
  getAllCurrencyCodes: function getAllCurrencyCodes(plan) {
    return allFis(plan).map(this.getCurrencyCode);
  },
  getCardMask: function getCardMask(fi) {
    var mask = this.wallet && this.wallet.getCardMask(fi);
    if (!mask.before) {
      mask.before = capFirst(fi.productClass);
    }
    if (!mask.after) {
      mask.after = fi.lastDigits || fi.last4;
    }
    return mask;
  },
  isPinlessDebit: function isPinlessDebit(fi) {
    return fi.is_pinless_debit || fi.isPinlessDebit;
  },
  isPad: function isPad(fi) {
    return isSubType(PADSUBTYPE)(fi) || isSubType('PAD')(fi);
  },
  isMeft: function isMeft(fi) {
    return isSubType(MEFTSUBTYPE)(fi);
  },
  isIach: function isIach(fi) {
    return isSubType(IACHSUBTYPE)(fi);
  },
  isEcheck: function isEcheck(fi) {
    return isSubType(ECHECKSUBTYPE)(fi);
  },
  getEditDisallowedContentKey: function getEditDisallowedContentKey(fi) {
    if (!fi) {
      return;
    }
    if (fi.editDisallowedMsg) {
      return "wallet." + fi.editDisallowedMsg;
    } else if (this.wallet.isLinkedCard(fi)) {
      return 'wallet.editDisallowedPayment';
    }
  }
});
_squid.$Model;
_squid.$promise;
_squid.$util;
_squid.$config;
_squid.$feature;
_checkout.$CheckoutSessionModel;
_wallet.$WalletModel;
_dist.$renderContent;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-models/src/gdprCookieBanner/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.testGdprBannerCookie = exports.isGdprValid = exports.$GDPRCookieBannerModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var testGdprBannerCookie = exports.testGdprBannerCookie = function testGdprBannerCookie(cookies) {
  return /(^|;\s*)cookie_prefs=/.test(cookies);
};
var isGdprValid = exports.isGdprValid = function isGdprValid() {
  if (_squid.$util.param('forceGDPR')) {
    return true;
  }
  var country = _squid.$locale.country;
  return _squid.$util.getProperty(_squid.$config, 'GDPR.cookieBanner', {
    "default": false
  }) && _squid.$util.getProperty(_squid.$config, 'GDPR.countries', {
    "default": []
  }).indexOf(country) > -1;
};
var $GDPRCookieBannerModel = exports.$GDPRCookieBannerModel = _squid.$Model.extend('$GDPRCookieBannerModel', {
  api: new _squid.$Api({
    uri: '/api/cookieBanner'
  }),
  /**
   * Handles the logic for when to fetch the banner and when to return
   * Don't repeat the call for same country
   * Don't return the banner if not PXP check
   * @returns {Promise} resolves an object
   */
  getBanner: function getBanner() {
    var _this = this;
    // API is cached on country. Return current result if already present
    if (this.lastResult && this.lastCountry === _squid.$locale.country && this.lastLang === _squid.$locale.lang) {
      return this.lastResult;
    }

    // Invalidate the model to make a fresh call
    this.invalidate();

    // Log if the user has cookie indicating a previous interaction with the cookie banner
    if (testGdprBannerCookie(document.cookie)) {
      _logger.$logger.info('checkout_fpti', {
        from: 'GDPR_banner',
        to: 'GDPR_banner_has_cookie'
      });
    }

    // Cache the result promise and params
    this.lastCountry = _squid.$locale.country;
    this.lastLang = _squid.$locale.lang;
    this.lastResult = this.retrieve().then(function (res) {
      var html = res.html,
        css = res.css,
        js = res.js;
      if (!html || !js || !css) {
        _logger.$logger.info('gdpr_response_missing_props', {
          html: !!html,
          js: !!js,
          css: !!css
        });
        _this.reset();
        return;
      }
      _logger.$logger.info('checkout_fpti', {
        from: 'GDPR_banner',
        to: 'GDPR_banner_shown'
      });
      return {
        html: html,
        css: css,
        js: js
      };
    });
    return this.lastResult;
  },
  reset: function reset() {
    this.html = '';
    this.css = '';
    this.js = '';
  },
  shown: function shown() {
    return !!this.html;
  },
  // Check if a banner was shown in the flow.
  // SOME EDGE CASES:
  //   Will not update when the user clicks to accept the banner, and it closes
  //   Will update if retrieve is called with a new country and blank data is returned
  hasBanner: function hasBanner() {
    var _this2 = this;
    // check config flag
    // check if already populated
    // make call again and let regular logic populate html
    // return boolean

    if (!isGdprValid()) {
      return _squid.$promise.resolve(false);
    }
    if (this.html) {
      return _squid.$promise.resolve(this.shown());
    }
    return this.getBanner().then(function () {
      return _this2.shown();
    });
  }
});
angular.value("testGdprBannerCookie", testGdprBannerCookie);
angular.value("isGdprValid", isGdprValid);
angular.value("$GDPRCookieBannerModel", $GDPRCookieBannerModel);
_squid.$Model;
_squid.$Api;
_squid.$locale;
_squid.$config;
_squid.$util;
_squid.$promise;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-models/src/inventory/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$InventoryModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $InventoryModel = exports.$InventoryModel = _squid.$Model.extend('$InventoryModel', {
  api: new _squid.$Api({
    uri: '/api/catalog/:id/item/',
    postAttempts: 2,
    cache: true
  }),
  setInvetoryItems: function setInvetoryItems(inventoryItems) {
    this.inventoryItems = inventoryItems;
  },
  getInventoryItems: function getInventoryItems() {
    return this.inventoryItems;
  }
});
angular.value("$InventoryModel", $InventoryModel);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/marketingoffer/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$fireMORSBeacon = exports.$MessageDiscoverModel = exports.$MemberSegmentModel = exports.$MarketingOfferModel = exports.$CreditOfferModel = void 0;
var _uuid = _interopRequireDefault(__webpack_require__("../node_modules/node-uuid/uuid.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $MarketingOfferModel = exports.$MarketingOfferModel = _squid.$Model.extend('$MarketingOfferModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/offer/search-ads',
    postAttempts: 1,
    cache: true
  }),
  init: function init() {
    this.setProperties({
      ads: []
    });
    this.meta = {
      populated: false
    };
  },
  onPopulate: function onPopulate() {
    var _this = this;
    if (this.targetPlacements && this.targetPlacements[0]) {
      var targetAd = this.ads.find(function (ad) {
        return ad.valid && ad.campaign.adunit_id === _this.targetPlacements[0].placement_code;
      });
      this.ad = undefined;
      if (targetAd) {
        var ad = {};
        var nvpContent = targetAd && targetAd.content && targetAd.content.nvp;
        nvpContent.forEach(function (obj) {
          ad[obj.name] = obj.value;
        });
        ad['impressionUrl'] = targetAd && targetAd.tracking && targetAd.tracking.impression_url;
        ad['clickUrl'] = targetAd && targetAd.tracking && targetAd.tracking.click_url;
        ad['campaignId'] = targetAd && targetAd.campaign && targetAd.campaign.campaign_id;
        ad['buyItemId'] = targetAd && targetAd.campaign && targetAd.campaign.buy_item_id;
        ad['placementCode'] = targetAd && targetAd.campaign && targetAd.campaign.adunit_id;
        this.ad = ad;
      }
    }
  },
  getCacheKey: function getCacheKey() {
    var cacheKey = {};
    if (this.cacheParam) {
      this.cacheParam.forEach(function (element) {
        if (typeof element.value !== 'undefined') {
          cacheKey[element.name] = element.value.toString();
        }
      });
    }
    return cacheKey;
  },
  serialize: function serialize() {
    return {
      'site': this.site,
      'locale': this.locale,
      'si': this.si,
      'visit_id': _uuid["default"].v4(),
      'page': this.page,
      'epu': this.payer,
      'pu_type': this.puType || 'ANONYMOUS',
      'country_code': this.countryCode,
      'payment_context': {
        'total_transaction_amount': this.totalTransactionAmount,
        'total_shipping_amount': this.totalShippingAmount,
        'business_case': 'NONE',
        'business_case_variation': '',
        'validate_existing_offer': 'false',
        'payment_units': [{
          'transaction_amount': this.totalTransactionAmount,
          'transaction_id': '',
          'encrypted_transaction_id': '',
          'activity_id': '',
          'payee': {
            'pu_type': 'BUSINESS',
            'country_code': this.countryCode,
            'epu': this.payee,
            'pu': ''
          }
        }]
      },
      'target_placements': this.targetPlacements,
      'wallet_instruments': this.walletInstruments,
      'addl_property_installments_not_allowed': this.installmentsNotAllowed
    };
  },
  getTargetAd: function getTargetAd() {
    return this.ad;
  },
  isAdFound: function isAdFound() {
    if (this.ad) {
      for (var property in this.ad) {
        if (this.ad.hasOwnProperty(property)) {
          return true;
        }
      }
    }
    return false;
  }
});
var $MessageDiscoverModel = exports.$MessageDiscoverModel = _squid.$Model.extend('$MessageDiscoverModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/offer/discover-messages',
    postAttempts: 1
  })
});
var $fireMORSBeacon = exports.$fireMORSBeacon = {
  fireBeacon: function fireBeacon(uri) {
    var img = document.createElement('img');
    img.setAttribute('src', uri);
    document.body.appendChild(img);
    return;
  }
};
var $MemberSegmentModel = exports.$MemberSegmentModel = _squid.$Model.extend('$MemberSegmentModel', {
  api: new _squid.$Api({
    uri: '/api/segment/memberSegment',
    postAttempts: 1
  }),
  invalidateOnLogout: true,
  // invalidate this model when auth.logout() gets called
  getMemberSegment: function getMemberSegment() {
    return this.memberSegment;
  },
  getCreditOffer: function getCreditOffer() {
    return this.creditOffer;
  },
  isNewMember: function isNewMember() {
    return this.memberSegment === 'NEW_MEMBER' || this.memberSegment === 'YOUNG_MEMBER';
  },
  isExistingMember: function isExistingMember() {
    return this.memberSegment === 'EXISTING_MEMBER';
  },
  // Member Segments that are eligble for the New Experience
  isEligibleForExperimentation: function isEligibleForExperimentation() {
    var eligibleMemberSegments = _squid.$config.memberSegments;
    return eligibleMemberSegments.indexOf(this.memberSegment) > -1;
  }
});
var $CreditOfferModel = exports.$CreditOfferModel = $MessageDiscoverModel.extend('$CreditOfferModel', {
  init: function init() {
    this.setProperties({
      bannerMessages: []
    });
  },
  populate: function populate(result) {
    var _this2 = this;
    if (result && result.touchpoint_messages) {
      var touchpoint_messages = result.touchpoint_messages.find(function (element) {
        return element.touchpoint_code === _this2.touchpoint;
      });
      this.storeMessages(touchpoint_messages);
    }
  },
  storeMessages: function storeMessages(touchpoint_messages) {
    if (touchpoint_messages) {
      this.viewName = touchpoint_messages.view_name;
      if (touchpoint_messages.messages) {
        var messages = touchpoint_messages.messages;
        for (var i = 0; i < touchpoint_messages.messages.length; i++) {
          var presentmentType = messages[i].content.json.PresentmentType;
          if (presentmentType === 'Banner') {
            this.bannerMessages.push(messages[i]);
          }
        }
      }
    }
  },
  getBannerCount: function getBannerCount() {
    return this.bannerMessages.length;
  },
  hasBannerMessage: function hasBannerMessage() {
    return this.getBannerCount() > 0;
  },
  getTouchpointCode: function getTouchpointCode() {
    return this.touchpoint;
  },
  getBannerMessage: function getBannerMessage(i) {
    i = !i ? 0 : i;
    if (this.getBannerCount() > i) {
      return this.bannerMessages[i];
    }
    return null;
  },
  getCacheKey: function getCacheKey() {
    var cacheKey = {};
    if (this.application_context) {
      this.application_context.forEach(function (element) {
        if (typeof element.value !== 'undefined') {
          cacheKey[element.name] = element.value.toString();
        }
      });
    }
    return cacheKey;
  },
  serialize: function serialize() {
    return {
      'country_code': this.locale.country,
      'language': this.locale.lang + "_" + this.locale.country,
      'identity_context': [{
        'type': 'PAYER_ID',
        'value': this.payer
      }, {
        'type': 'MERCHANT_PAYER_ID',
        'value': this.payee
      }],
      'recommendation_context': {
        'view_names': this.view_names ? this.view_names : [],
        'touchpoint_details': [{
          'code': this.touchpoint,
          'message_count': this.message_count ? this.message_count : 1
        }]
      },
      'application_context': this.application_context
    };
  }
});
angular.value("$MarketingOfferModel", $MarketingOfferModel);
angular.value("$MessageDiscoverModel", $MessageDiscoverModel);
angular.value("$fireMORSBeacon", $fireMORSBeacon);
angular.value("$MemberSegmentModel", $MemberSegmentModel);
angular.value("$CreditOfferModel", $CreditOfferModel);
_squid.$Model;
_squid.$Api;
_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/mayfly/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MayflyModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $MayflyModel = exports.$MayflyModel = _squid.$Model.extend('$MayflyModel', {
  api: new _squid.$Api({
    uri: '/api/mayfly/:id'
  })
});
angular.value("$MayflyModel", $MayflyModel);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/onboard/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SingleStepModel = exports.$OnboardUserModel = exports.$OnboardPhoneModel = exports.$OnboardModel = exports.$GuestUpgradeModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var _directive = __webpack_require__("../node_modules/xo-form-components/src/national-id-input/directive.js");
var $OnboardModel = exports.$OnboardModel = _squid.$Model.extend('$OnboardModel', {
  api: new _squid.$Api({
    uri: '/api/onboard'
  }),
  init: function init() {
    this._super.init.apply(this);
    this.fiMode = this.fiMode || 'card'; // Supports card or bank
    this.bank = this.bank || new _index.$BankModel();
    this.card = this.card || new _index.$CardModel();
  },
  serialize: function serialize() {
    var data = {
      user: this.user.serialize(),
      billing_address: this.billing_address.serialize(),
      shipping_address: this.shipping_address.serialize(),
      phone: this.phone.serialize(),
      marketing_optin: this.marketingOptin,
      shipping_address_validation: this.shipping_address_validation,
      billing_address_present: this.billing_address_present,
      residential_address_present: this.residential_address_present,
      payment_experience_initiator: this.payment_experience_initiator,
      poma_flow: this.poma_flow,
      prox_flow: this.prox_flow,
      testParams: this.testParams,
      content_identifier: this.content_identifier,
      frs_optin_flow_applicable: this.frs_optin_flow_applicable,
      // Free Return Shipping Opt-in flow applicability flag
      frs_optin_active_flow: this.frs_optin_active_flow,
      // Denotes FRS opt in flow type - Active (true) or Silent (false)
      flow_eligibility_data: this.flow_eligibility_data,
      bypass_address_verification: this.bypass_address_verification,
      bypass_authorization: this.bypass_authorization
    };
    if (this.nationalIdModel) {
      data.nationalIdModel = {
        'secondaryIdType': this.nationalIdModel.secondaryIdType,
        'secondaryIdValue': this.nationalIdModel.secondaryIdValue
      };
      if (this.nationalIdModel.nationalId) {
        data.nationalIdModel.nationalId = {
          type: this.nationalIdModel.nationalId.type,
          subType: this.nationalIdModel.nationalId.subType,
          value: this.nationalIdModel.nationalId.value
        };
      }
    }
    if (this.fiMode === 'card') {
      data.card = this.card.serialize();
    } else {
      data.bank = this.bank.serialize();
    }
    if (this.residential_address_present && this.residential_address) {
      data.residential_address = this.residential_address.serialize();
    }
    data.skipInitiateAuth = this.skipInitiateAuth;
    if (this.legal_agreements) {
      data.legal_agreements = this.legal_agreements;
    }
    return data;
  }
});
var $OnboardUserModel = exports.$OnboardUserModel = _squid.$Model.extend('$OnboardUserModel', {
  serialize: function serialize() {
    var onboardUserModel = {
      first_name: this.first_name,
      last_name: this.last_name,
      email: this.email,
      password: this.password,
      countryOfResidence: this.countryOfResidence,
      country: this.country,
      dob_day: this.dob_day,
      dob_month: this.dob_month,
      dob_year: this.dob_year,
      occupation: this.occupation,
      nationality: this.nationality,
      gender_type: this.gendertype,
      place_of_birth: this.placeofbirth
    };
    if (this.nativeName) {
      onboardUserModel.nativeName = {
        first_name: this.nativeName.first_name,
        last_name: this.nativeName.last_name,
        middle_name: this.nativeName.middle_name
      };
    }
    return onboardUserModel;
  }
});
var $OnboardPhoneModel = exports.$OnboardPhoneModel = _squid.$Model.extend('$OnboardPhoneModel', {
  serialize: function serialize() {
    var phoneMeta = this.meta || {};
    return {
      type: this.phoneType,
      number: this.telephone,
      countryCode: this.IntDialingCountryCode,
      verificationId: phoneMeta.verificationId
    };
  }
});

/**
 * A model for handling onboarding guest accounts
 * into PayPal accounts (happens post transaction)
 */

var $GuestUpgradeModel = exports.$GuestUpgradeModel = _squid.$Model.extend('$GuestUpgradeModel', {
  api: new _squid.$Api({
    uri: '/api/onboard/guest-upgrade'
  }),
  serialize: function serialize() {
    var data = {
      user: this.user.serialize(),
      phone: this.phone.serialize(),
      billing_address: this.billing_address.serialize(),
      payerId: this.payerId,
      transaction: this.transaction,
      marketing_optin: this.marketing_optin,
      contentIdentifier: this.contentIdentifier,
      experienceIdentifier: this.experienceIdentifier,
      experienceChannel: this.experienceChannel,
      nationalId: this.nationalIdModel ? this.nationalIdModel.serialize() : _directive.$NationalIdModel.instance().serialize()
    };

    // append additional phone data
    data.phone.country_prefix = this.phone && this.phone.IntDialingCountryCode;

    // append additional billing_address data
    data.billing_address.normalization_status = this.billing_address && this.billing_address.normalization_status;
    if (this.legal_agreements) {
      data.legal_agreements = this.legal_agreements;
    }
    return data;
  },
  serializeEmailFlow: function serializeEmailFlow() {
    var data = {
      user: this.user.serialize(),
      phone: this.phone.serialize(),
      billing_address: this.billing_address.serialize(),
      payerId: this.payerId,
      transaction: this.transaction,
      receiptId: this.receiptId,
      marketing_optin: this.marketing_optin,
      card: this.card
    };
    return data;
  }
});
var $SingleStepModel = exports.$SingleStepModel = _squid.$Model.extend('$SingleStepModel', {});
angular.value("$OnboardModel", $OnboardModel);
angular.value("$OnboardUserModel", $OnboardUserModel);
angular.value("$OnboardPhoneModel", $OnboardPhoneModel);
angular.value("$GuestUpgradeModel", $GuestUpgradeModel);
angular.value("$SingleStepModel", $SingleStepModel);
_squid.$Model;
_squid.$Api;
_index.$CardModel;
_index.$BankModel;
_directive.$NationalIdModel;

/***/ }),

/***/ "../node_modules/xo-models/src/phoneConfirmation/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$PhoneConfirmationModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $PhoneConfirmationModel = exports.$PhoneConfirmationModel = _squid.$Model.extend('$PhoneConfirmationModel', {
  api: new _squid.$Api({
    uri: '/api/onboard/phoneConfirmation'
  }),
  init: function init() {
    this._super.init.apply(this);
  },
  serializeInitiateData: function serializeInitiateData() {
    return {
      phoneCountry: this.phoneCountry,
      phoneNumber: this.phoneNumber,
      locale: this.locale
    };
  },
  serializeConfirmData: function serializeConfirmData() {
    return {
      pin: this.pin,
      verificationId: this.verificationId
    };
  }
});
angular.value("$PhoneConfirmationModel", $PhoneConfirmationModel);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/processorDecline/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getProcessorDeclineRetryEligibility = getProcessorDeclineRetryEligibility;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var INELIGIBLE = _squid.$promise.resolve(false);
var lastBuyerId = null;

// Check eligibility for processor decline retry feature
// First checks if feature eligibility is met, then PXP eligibility is met
function getProcessorDeclineRetryEligibility(token, checkoutSession) {
  if (!(0, _squid.$feature)('cardBackup')) {
    return INELIGIBLE;
  }

  // TODO: Refactor the eligibility rules to a set of common rules
  var models = {};
  return (0, _squid.$populate)(models, {
    auth: _auth.$AuthModel.instance(),
    checkoutCart: _checkout.$CheckoutCartModel.instance(token),
    checkoutPayee: _checkout.$CheckoutPayeeModel.instance(token),
    checkoutAppData: _checkout.$CheckoutAppDataModel.instance(token)
  }).then(function () {
    var checkoutCart = models.checkoutCart,
      checkoutPayee = models.checkoutPayee,
      checkoutAppData = models.checkoutAppData;
    var plans = checkoutSession.get('fundingOptions.plans', []);
    var moreThanOneCard = plans.filter(function (fi) {
      return fi.primaryFs.type === 'CARD';
    }).length < 2;

    // exclude rewards from the eligibility list
    var hasRewards = plans.filter(function (fi) {
      return fi && fi.rewards !== undefined;
    }).length > 0;

    // See https://engineering.paypalcorp.com/confluence/display/HellsKitchen/Hermes+Processor+Decline+Retry for eligibility reasons
    var isGambling = checkoutPayee.isGambling();
    var isBilling = checkoutCart.isBilling();
    // We're only sure that Sale transactions will go onto the new payments stack, for now
    var isNotSale = checkoutCart.get('payment_action') !== 'sale';
    var isThirdParty = _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(token);
    // Exclude all WPS products
    var isWpsOrInvoice = checkoutAppData.get('flags.is_wps_flow') || checkoutAppData.get('flags.is_invoice_flow');
    // We will need to confirm functionality for this before we can enable for this feature
    var isMultiSellerPurchase = checkoutCart.isMultiSellerPurchase();
    var hasInstallments = checkoutSession.installments && checkoutSession.installments.length > 1;
    var involvedCurrencies = plans.reduce(function (currencies, plan) {
      currencies[plan.primaryFs.amount.currency_code] = 1;
      return currencies;
    }, {});
    // Buyer promo email routing through checkoutserv, downstream does not support
    var hasBuyerPromoEmail = checkoutAppData.get('flags.display_buyer_email_promotional_opt_in');
    if (checkoutCart.get('purchase.amounts.total.currency_code')) {
      involvedCurrencies[checkoutCart.purchase.amounts.total.currency_code] = 1;
    }
    var ineligibilityCriteria = {
      isGambling: isGambling,
      moreThanOneCard: moreThanOneCard,
      hasRewards: hasRewards,
      isBilling: isBilling,
      isNotSale: isNotSale,
      isThirdParty: isThirdParty,
      isWpsOrInvoice: isWpsOrInvoice,
      isMultiSellerPurchase: isMultiSellerPurchase,
      hasInstallments: hasInstallments,
      currencyConversion: Object.keys(involvedCurrencies).length > 1,
      hasBuyerPromoEmail: hasBuyerPromoEmail
    };
    var ineligibleReasons = Object.keys(ineligibilityCriteria).filter(function (key) {
      return ineligibilityCriteria[key];
    });
    var eligible = ineligibleReasons.length === 0;

    // Logging for FPTI
    _logger.$logger.info('checkout_fpti', {
      from: 'processor_decline_retry',
      // This logs whether user is eligible by Hermes criteria
      to: "processor_decline_retry_" + (eligible ? 'eligible' : 'ineligible')
    });
    if (!eligible) {
      // This logs the overall result of the eligibility check
      _logger.$logger.info('processor_decline_retry_ineligible', {
        reasons: ineligibleReasons.join()
      });
    }
    return eligible;
  }).then(function (featureEligible) {
    // BuyerId is needed to make sure pxp is reloaded if a new user logs in.
    // Refactor: Make this a common pxp model that is invalidated on logout
    var buyerId = models.auth.buyerId;
    var sameBuyer = buyerId === lastBuyerId;
    lastBuyerId = buyerId;
    if (!featureEligible) {
      return false;
    }

    // Only run the PXP if the feature is eligible, as requested from analytics
    return (0, _squid.$pxp)('xo_hermes_processor_decline_retry', {}, 'xo_hermes_processor_decline_retry_treatment', sameBuyer ? false : true, true).then(function (pxpRes) {
      if (!pxpRes) {
        _logger.$logger.info('processor_decline_retry_ineligible', {
          pxpIneligible: true
        });
      }
      return !!pxpRes;
    });
  }).then(function (eligibleWithPxp) {
    if (eligibleWithPxp) {
      _logger.$logger.info('processor_decline_retry_eligible');
    }
    return eligibleWithPxp;
  });
}
_squid.$feature;
_squid.$populate;
_squid.$promise;
_squid.$pxp;
_logger.$logger;
_thirdPartyInfo.thirdPartyExperience;
_checkout.$CheckoutCartModel;
_checkout.$CheckoutPayeeModel;
_checkout.$CheckoutAppDataModel;
_auth.$AuthModel;

/***/ }),

/***/ "../node_modules/xo-models/src/profilemanagement/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MerchantPreferenceModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $MerchantPreferenceModel = exports.$MerchantPreferenceModel = _squid.$Model.extend('$MerchantPreferenceModel', {
  init: function init() {
    this._super.init.apply(this);
    this.setProperties({
      rm: _squid.$util.param('rm'),
      // Return Method
      return_url: _squid.$util.param('return'),
      auto_return: {
        enabled: false
      },
      pdt: {
        enabled: false
      }
    });
  },
  api: new _squid.$Api({
    baseURI: _squid.$config.urls.baseUrl,
    uri: '/api/profilemanagement/:id/getMerchantPreferences'
  }),
  autoReturn: function autoReturn() {
    return this.auto_return.enabled;
  },
  pdtEnabled: function pdtEnabled() {
    return this.pdt && this.pdt.enabled;
  },
  returnUrl: function returnUrl() {
    return this.return_url || this.auto_return.url;
  },
  /**
   * 0 – redirect using GET method ( default behavior )
   * 1 – redirect using the GET method, but no payment variables are included
   * 2 – redirect using the POST method, and include all payment variables
   */
  returnMethod: function returnMethod() {
    if (this.rm === '2') {
      return this.pdtEnabled() ? 'GET' : 'POST';
    }
    return 'GET';
  },
  returnMethodSupported: function returnMethodSupported() {
    return this.returnMethod() === 'GET';
  },
  /**
   * Determines if payment details need to be sent back to the merchant.
   * @returns {boolean}
   */
  postPaymentData: function postPaymentData() {
    return this.rm === '2' && !this.pdtEnabled() && this.returnUrl();
  },
  // charset of merchant having in profile
  charSet: function charSet() {
    return this.charset;
  }
});
angular.value("$MerchantPreferenceModel", $MerchantPreferenceModel);
_squid.$Model;
_squid.$Api;
_squid.$config;
_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/prox/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ContextualLoginModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $ContextualLoginModel = exports.$ContextualLoginModel = _squid.$Model.extend('$ContextualLoginModel', {
  init: function init() {
    this._super.init.apply(this);
    this.setProperties({
      key: _squid.$util.param('ctxId')
    });
  },
  api: new _squid.$Api({
    uri: '/api/contextualLogin/:key'
  })
});
angular.value("$ContextualLoginModel", $ContextualLoginModel);
_squid.$Model;
_squid.$Api;
_squid.$util;

/***/ }),

/***/ "../node_modules/xo-models/src/shippingMethod/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingRuleSummaryModel = exports.$ShippingMethodModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $ShippingMethodModel = exports.$ShippingMethodModel = _squid.$Model.extend('$ShippingMethodModel', {
  api: new _squid.$Api({
    uri: '/api/shippingtax/charges'
  }),
  getShippingMethodId: function getShippingMethodId(shippingMethodType) {
    var shippingMethodsMap = {
      DEFAULT: '0',
      AIR_SERVICE: '1',
      ECONOMY: '2',
      EXPEDITED_AIR_SERVICE: '3',
      EXPEDITED_FLAT_RATE_SHIPPING: '4',
      EXPRESS: '5',
      EXPRESS_DOMESTIC: '6',
      FREE_SHIPPING: '7',
      GROUND: '8',
      GLOBAL_PRIORITY: '9',
      INTERNATIONAL_ECONOMY: '10',
      INTERNATIONAL_EXPEDITED: '11',
      INTERNATIONAL_EXPRESS: '12',
      INTERNATIONAL_EXPRESS_AIR: '13',
      INTERNATIONAL_PRIORITY_AIR: '14',
      NEXT_DAY: '15',
      NEXT_DAY_AIR: '16',
      NEXT_DAY_AIR_ECONOMY: '17',
      ONE_DAY_SHIPPING: '18',
      OVERNIGHT: '19',
      OVERNIGHT_FLAT_RATE_SHIPPING: '20',
      PICKUP: '21',
      PRIORITY: '22',
      RUSH_DELIVERY: '23',
      STANDARD_DOMESTIC: '24',
      STANDARD_EXPEDITED: '25',
      STANDARD_FLAT_RATE_SHIPPING: '26',
      STANDARD_INTERNATIONAL: '27',
      STANDARD_SHIPPING: '28',
      STORE_PICKUP: '29',
      TWO_DAY_SHIPPING: '30',
      WORLDWIDE_SHIPPING: '31',
      TWO_DAY_AIR: '32'
    };
    return shippingMethodsMap[shippingMethodType];
  },
  isStorePickUp: function isStorePickUp(shipping_method_type) {
    return shipping_method_type === 'STORE_PICKUP' || shipping_method_type === 'PICKUP';
  }
});
var $ShippingRuleSummaryModel = exports.$ShippingRuleSummaryModel = _squid.$Model.extend('$ShippingRuleSummaryModel', {
  api: new _squid.$Api({
    uri: '/api/shippingtax/:id/rulesSummary'
  })
});
angular.value("$ShippingMethodModel", $ShippingMethodModel);
angular.value("$ShippingRuleSummaryModel", $ShippingRuleSummaryModel);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/shoppingcart/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShoppingCartModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $ShoppingCartModel = exports.$ShoppingCartModel = _squid.$Model.extend('$ShoppingCartModel', {
  api: new _squid.$Api({
    uri: '/api/shoppingcart/:id',
    postAttempts: 2,
    cache: false
  })
});
angular.value("$ShoppingCartModel", $ShoppingCartModel);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/subscription/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SubscriptionsV1Model = exports.$SubscriptionModel = exports.$CreateBAModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $CreateBAModel = exports.$CreateBAModel = _squid.$Model.extend('$CreateBAModel', {
  api: new _squid.$Api({
    uri: '/api/billagmt',
    postAttempts: 3
  })
});
var $SubscriptionModel = exports.$SubscriptionModel = _squid.$Model.extend('$SubscriptionModel', {
  api: new _squid.$Api({
    uri: '/api/billagmt/:id',
    postAttempts: 3,
    cache: true
  })
});
var $SubscriptionsV1Model = exports.$SubscriptionsV1Model = _squid.$Model.extend('$SubscriptionsV1Model', {
  api: new _squid.$Api({
    uri: '/api/billagmt/subscriptions/v1/:id',
    cache: true
  })
});
angular.value("$CreateBAModel", $CreateBAModel);
angular.value("$SubscriptionModel", $SubscriptionModel);
angular.value("$SubscriptionsV1Model", $SubscriptionsV1Model);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/switchPaymentsApiServ/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$switch3DSLookUpModel = exports.$switch3DSAuthenticateModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $switch3DSLookUpModel = exports.$switch3DSLookUpModel = _squid.$Model.extend('$switch3DSLookUpModel', {
  api: new _squid.$Api({
    uri: '/api/switch/threeDSLookUp'
  })
});
var $switch3DSAuthenticateModel = exports.$switch3DSAuthenticateModel = _squid.$Model.extend('$switch3DSAuthenticateModel', {
  api: new _squid.$Api({
    uri: '/api/switch/threeDSAuthenticate'
  })
});
angular.value("$switch3DSLookUpModel", $switch3DSLookUpModel);
angular.value("$switch3DSAuthenticateModel", $switch3DSAuthenticateModel);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/threeDS/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ThreeDSJWTModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $ThreeDSJWTModel = exports.$ThreeDSJWTModel = _squid.$Model.extend('$ThreeDSJWTModel', {
  api: new _squid.$Api({
    uri: '/api/fi/threeds'
  }),
  init: function init() {
    this._super.init.apply(this);
  },
  serialize: function serialize() {
    var data = {
      referenceId: this.referenceId,
      cardBin: this.cardBin,
      cardType: this.cardType,
      jwtIssuer: this.jwtInfo.jwtIssuer,
      jwtOrgUnitId: this.jwtInfo.jwtOrgUnitId,
      returnUrl: this.returnUrl,
      redirectUrl: this.redirectUrl,
      transactionId: this.transactionId,
      paymentAuthenticationRequest: this.paymentAuthenticationRequest,
      authenticationProvider: this.authenticationProvider
    };
    return data;
  }
});
angular.value("$ThreeDSJWTModel", $ThreeDSJWTModel);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-models/src/user/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$WaxUserModel = exports.$ValidatePhoneModel = exports.$UserProductSubscriptionModel = exports.$UserPhotoModel = exports.$UserInfoModel = exports.$UserEligibleToHoldBalanceModel = exports.$PatchPhoneModel = exports.$EConsentModel = exports.$CheckoutInputDataModel = exports.$CheckoutClientDataModel = exports.$AuthConsentModel = exports.$AddKYCModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $CheckoutClientDataModel = exports.$CheckoutClientDataModel = _squid.$Model.extend('$CheckoutClientDataModel', {
  api: new _squid.$Api({
    uri: '/api/user/:id/clientData'
  }),
  merchantIdentityData: function merchantIdentityData() {
    return {
      email: this.email,
      brand_name: this.display_name,
      logo_uri: this.logo_uri,
      identity_uri: this.identity_uri
    };
  },
  validateClient: function validateClient() {
    if (this.partner_id && this.identity_uri) {
      return {
        success: true
      };
    } else {
      return {
        success: false,
        error: 'invalid_client'
      };
    }
  },
  validateRedirectUri: function validateRedirectUri(redirectUrl) {
    if (this.identity_uri && this.identity_uri.indexOf(redirectUrl) > -1) {
      return {
        success: true
      };
    } else {
      return {
        success: false,
        error: 'invalid_redirect_url'
      };
    }
  }
});
var ACTION = {
  login: 'login',
  resolve: 'resolve',
  addCard: 'addCard',
  addBank: 'addBank',
  changeCurrencyConv: 'changeCurrencyConv',
  signup: 'signup',
  mandate: 'mandate',
  addCredit: 'addCredit',
  ulReturn: 'ulReturn',
  creditReturn: 'creditReturn',
  guestCurrencyConversion: 'guestCurrencyConversion',
  guestAuthentication: 'guestAuthentication',
  compliance: 'compliance'
};
var $CheckoutInputDataModel = exports.$CheckoutInputDataModel = _squid.$Model.extend('$CheckoutInputDataModel', {
  init: function init() {
    this._super.init.apply(this);
    this.setProperties({
      client_id: _squid.$util.param('client_id'),
      action: _squid.$util.param('action'),
      redirect_uri: _squid.$util.param('redirect_uri'),
      scope: _squid.$util.param('scope'),
      state: _squid.$util.param('state'),
      flow: _squid.$util.param('flow'),
      payer_id: _squid.$util.param('payer_id'),
      mandate_reference_number: _squid.$util.param('mandate_reference_number'),
      funding_option_id: _squid.$util.param('funding_option_id'),
      locale: _squid.$util.param('locale'),
      logout: _squid.$util.param('logout'),
      refresh_parent: _squid.$util.param('refresh_parent'),
      escape_hatch: _squid.$util.param('escape_hatch'),
      failedBecause: _squid.$util.param('failedBecause'),
      redirectReferrer: _squid.$util.param('redirectReferrer'),
      id_token: _squid.$util.param('prox_id'),
      nonce: _squid.$util.param('nonce'),
      hide_rm: _squid.$util.param('hideRM'),
      payloadEnc: _squid.$util.param('payloadEnc'),
      xcancel: _squid.$util.param('x-cancel'),
      xsuccess: _squid.$util.param('x-success')
    });
  },
  api: new _squid.$Api({
    baseURI: _squid.$config.urls.baseUrl,
    uri: '/api/user/:id/payerId'
  }),
  isEbayTxn: function isEbayTxn() {
    return Boolean(this.client_id);
  },
  validAction: function validAction() {
    var actions = {
      login: 'login',
      resolve: 'resolve',
      addCard: 'addCard',
      addBank: 'addBank',
      changeCurrencyConv: 'changeCurrencyConv',
      signup: 'signup',
      mandate: 'mandate',
      addCredit: 'addCredit',
      ulReturn: 'ulReturn',
      creditReturn: 'creditReturn',
      guestCurrencyConversion: 'guestCurrencyConversion',
      guestAuthentication: 'guestAuthentication',
      compliance: 'compliance'
    };
    return actions.hasOwnProperty(this.action);
  },
  showRYP: function showRYP() {
    return !this.isEbayTxn();
  },
  requiresOAuth: function requiresOAuth() {
    return this.action === ACTION.login || this.action === ACTION.signup;
  },
  requiresRedirectUri: function requiresRedirectUri() {
    return this.action === ACTION.mandate || !this.requiresOAuth();
  },
  validRedirectUri: function validRedirectUri() {
    if (this.requiresRedirectUri()) {
      return Boolean(this.redirect_uri);
    }
    return true;
  },
  validate: function validate() {
    var error;
    var success = true;
    if (this.isEbayTxn()) {
      if (!this.validAction()) {
        success = false;
        error = 'invalid_action';
      } else if (!this.validRedirectUri()) {
        success = false;
        error = 'invalid_redirect_uri';
      }
    }
    return {
      success: success,
      error: error
    };
  },
  errorUrl: function errorUrl(err, errorDesc) {
    var url = this.redirect_uri;
    url += url && url.indexOf('?') < 0 ? '?' : '&';
    url += 'state=' + encodeURIComponent(this.state);
    if (err) {
      url += '&error=' + err;
    }
    if (errorDesc) {
      url += '&error_description=' + errorDesc;
    }
    return url;
  },
  successUrl: function successUrl(code) {
    var url = this.redirect_uri;
    url += url && url.indexOf('?') < 0 ? '?' : '&';
    url += 'state=' + encodeURIComponent(this.state);
    url += '&code=' + code;
    return url;
  },
  rmEnabled: function rmEnabled(featureEnabled) {
    return featureEnabled && this.action === ACTION.login;
  },
  hideRM: function hideRM() {
    return angular.isDefined(this.hide_rm) ? this.hide_rm.toLowerCase() === 'true' : false;
  }
});
var $UserInfoModel = exports.$UserInfoModel = _squid.$Model.extend('$UserInfoModel', {
  api: new _squid.$Api({
    uri: '/api/user/:id/session'
  })
});
var $ValidatePhoneModel = exports.$ValidatePhoneModel = _squid.$Model.extend('$ValidatePhoneModel', {
  api: new _squid.$Api({
    uri: '/api/user/:token/session/validatePhone',
    cache: false
  })
});
var $AddKYCModel = exports.$AddKYCModel = _squid.$Model.extend('$AddKYCModel', {
  api: new _squid.$Api({
    uri: '/api/user/:token/session/addKYC'
  })
});
var $PatchPhoneModel = exports.$PatchPhoneModel = _squid.$Model.extend('$PatchPhoneModel', {
  api: new _squid.$Api({
    uri: '/api/checkout/:token/session/patch',
    cache: false
  })
});
var $WaxUserModel = exports.$WaxUserModel = _squid.$Model.extend('$WaxUserModel', {
  api: new _squid.$Api({
    uri: '/api/user/:id/waxUser'
  })
});
var $EConsentModel = exports.$EConsentModel = _squid.$Model.extend('$EConsentModel', {
  api: new _squid.$Api({
    uri: '/api/user/eConsent'
  }),
  invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});
var $UserPhotoModel = exports.$UserPhotoModel = _squid.$Model.extend('$UserPhotoModel', {
  api: new _squid.$Api({
    baseURI: _squid.$config.urls.baseUrl,
    uri: 'api/user/photo'
  }),
  invalidateOnLogout: true // invalidate this model when auth.logout() gets called
});
var $AuthConsentModel = exports.$AuthConsentModel = _squid.$Model.extend('$AuthConsentModel', {
  api: new _squid.$Api({
    uri: '/api/user/authConsent'
  })
});
var $UserProductSubscriptionModel = exports.$UserProductSubscriptionModel = _squid.$Model.extend('$UserProductSubscriptionModel', {
  api: new _squid.$Api({
    uri: '/api/user/productSubscription'
  })
});
var $UserEligibleToHoldBalanceModel = exports.$UserEligibleToHoldBalanceModel = _squid.$Model.extend('$UserEligibleToHoldBalanceModel', {
  api: new _squid.$Api({
    uri: '/api/user/eligibleToHoldBalance'
  })
});
angular.value("$CheckoutClientDataModel", $CheckoutClientDataModel);
angular.value("$CheckoutInputDataModel", $CheckoutInputDataModel);
angular.value("$UserInfoModel", $UserInfoModel);
angular.value("$ValidatePhoneModel", $ValidatePhoneModel);
angular.value("$AddKYCModel", $AddKYCModel);
angular.value("$PatchPhoneModel", $PatchPhoneModel);
angular.value("$WaxUserModel", $WaxUserModel);
angular.value("$EConsentModel", $EConsentModel);
angular.value("$UserPhotoModel", $UserPhotoModel);
angular.value("$AuthConsentModel", $AuthConsentModel);
angular.value("$UserProductSubscriptionModel", $UserProductSubscriptionModel);
angular.value("$UserEligibleToHoldBalanceModel", $UserEligibleToHoldBalanceModel);
_squid.$Model;
_squid.$Api;
_squid.$util;
_squid.$config;

/***/ }),

/***/ "../node_modules/xo-models/src/wallet/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {

exports.__esModule = true;
exports.$WalletModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _instrument = __webpack_require__("../node_modules/xo-models/src/wallet/instrument.js");
// ID https://engineering.paypalcorp.com/confluence/display/PayPalMediaService/Image+Request+Metadata+Data
var imageSizeId = '0';
var normalize = function normalize(instId) {
  return instId && instId.replace(/-/g, '');
};
var imageTypes = ['png', 'jpg', 'gif', 'bmp'];
var imageType = function imageType(mimeType) {
  return _squid.$util.find(imageTypes, function (t) {
    return mimeType.indexOf(t) !== -1;
  }) || 'png';
};

// Network types to check for linked cards
var NETWORK_TYPES = {
  CHASE: 'CHASENET'
};
function capFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
function getLinkedCapability(cardData) {
  return cardData.fs.capabilities.find(function (cap) {
    return cap.name === 'TOKEN';
  });
}
var $WalletModel = exports.$WalletModel = _squid.$Model.extend('$WalletModel', {
  invalidateOnLogout: true,
  api: new _squid.$Api({
    uri: '/api/fi/wallet/wallet'
  }),
  getId: function getId(fs) {
    return normalize(fs.instrument_id || fs.id);
  },
  getCardMask: function getCardMask(fs) {
    var rep = this.getWalletRepresentation(fs);
    if (!rep) {
      return {
        mask: true
      };
    }
    var selector = rep.type === 'card' ? 'product_class' : 'type';
    var renderedType;
    if (rep.fs[selector] === 'UNKNOWN' || !rep.fs[selector]) {
      renderedType = '';
    } else {
      renderedType = capFirst(rep.fs[selector]) + ' ';
    }
    return {
      before: renderedType,
      mask: true,
      after: rep.fs.last_nchars || rep.fs.last_nchars_card_number || ''
    };
  },
  /**
   * Returns the wallet API data for a FI given a funding source from the checkoutSession model
   * @returns {Instrument|BankInstrument|null}
   */
  getWalletRepresentation: function getWalletRepresentation(fs) {
    if (!fs) {
      return null;
    }
    if (fs.type === 'BALANCE') {
      var currency = fs.amount && fs.amount.currency_code;
      if (currency) {
        var bal = this.balance_accounts.find(function (b) {
          return b.currency_code === currency;
        });
        if (bal) {
          return new _instrument.Instrument({
            type: 'balance',
            fs: bal
          });
        }
      }
      return null;
    }
    return this.getById(this.getId(fs));
  },
  /**
   * Returns the wallet API data for a FI based on the id provided
   * @returns {Instrument|BankInstrument|null} - the model of the FI, if found
   */
  getById: function getById(id) {
    if (!id) {
      return null;
    }
    return this.getCardById(id) || this.getBankById(id) || this.getCreditById(id) || null;
  },
  /**
   * Return the wallet API data for a FI of a card id provided
   * @returns {Instrument}
   */
  getCardById: function getCardById(id) {
    var card = _squid.$util.find(this.card_accounts, function (c) {
      return normalize(c.id) === id;
    });
    return card && new _instrument.Instrument({
      type: 'card',
      fs: card
    });
  },
  /**
   * Return the wallet API data for a FI of a card id provided
   * @returns {Instrument}
   */
  getCreditById: function getCreditById(id) {
    var creditCards = _squid.$util.find(this.credit_accounts, function (c) {
      return normalize(c.id) === id;
    });
    return creditCards && new _instrument.Instrument({
      type: 'credit',
      fs: creditCards
    });
  },
  /**
   * Return the wallet API data for a FI of a bank id provided
   * @returns {BankInstrument}
   */
  getBankById: function getBankById(id) {
    var bank = _squid.$util.find(this.bank_accounts, function (b) {
      return normalize(b.id) === id;
    });
    return bank && new _instrument.BankInstrument({
      type: 'bank',
      fs: bank
    });
  },
  getCustomName: function getCustomName(fs) {
    try {
      var rep = this.getWalletRepresentation(fs);
      if (!rep || !rep.type) {
        return '';
      }
      var type = rep.type.toLowerCase();
      if (type === 'credit' && rep.fs && rep.fs.credit_product_descriptor) {
        return rep.fs.credit_product_descriptor;
      }
      if (type === 'card' && rep.fs && rep.fs.issuer && rep.fs.issuer.issuer_product_description) {
        return rep.fs.issuer.issuer_product_description;
      }
      return '';
    } catch (e) {
      console.error('getCustomNameError', e);
      return '';
    }
  },
  getCardArt: function getCardArt(fs) {
    try {
      if (!fs || !fs.type) {
        console.error('Invalid input: fs is missing or does not have a type.', fs);
        return null;
      }
      var type = fs.type.toLowerCase();
      var cardId = this.getId(fs);
      var card, propertyPath;
      if (type === 'card') {
        card = this.getCardById(cardId);
        console.debug('Retrieved Card:', card);
        if (card && card.fs && card.fs.card_art_details && card.fs.card_art_details.card_art) {
          propertyPath = card.fs.card_art_details.card_art.primary_content;
        }
      } else if (type === 'credit' || type === 'txn_card_bml') {
        card = this.getCreditById(cardId);
        console.debug('Retrieved Credit:', card);
        if (card && card.fs && card.fs.art_details) {
          propertyPath = card.fs.art_details.primary_content;
        }
      }
      if (!propertyPath) {
        console.error('propertyPath is missing:', propertyPath);
        return null;
      }
      var base = propertyPath.base_cdn_link_path || propertyPath.base_cdnlink_path;
      console.debug('Base CDN Link Path:', base);
      if (!base) {
        console.error('Base CDN link path is missing.');
        return null;
      }
      return base + imageSizeId + '.' + imageType(propertyPath.original_mime_type);
    } catch (e) {
      console.error('getCardArtError', e);
      return null;
    }
  },
  /**
   * retrieve list of total balances (each currency is a separate balance account)
   * Notes:
   * 1. Skip balances with '0' amount
   * 2. Since wallet returns amount in "cents" - convert it to "dollars".
   *    For us it's safe to divide by 100 as PayPal doesn't support currencies with more than 2 decimal points.
   *    For those currencies with no decimal points - wallet adds two zeros, e.g
   *        in case of JPY - 1 JPY will be sent as 100 to the response
   */
  getAmountsOfBalances: function getAmountsOfBalances() {
    var balances = [];
    this.get('balance_accounts', []).forEach(function (balanceAccount) {
      var _balanceAccount$sub_b = balanceAccount.sub_balances.find(function (subBalance) {
          return subBalance.type === 'TOTAL_BALANCE';
        }),
        amount = _balanceAccount$sub_b.amount;
      if (amount.value !== '0') {
        balances.push({
          value: Number(amount.value) / 100,
          currency: amount.currency
        });
      }
    });
    return balances;
  },
  isLinkedCard: function isLinkedCard(fi) {
    var id = this.getId(fi);
    var card = this.getCardById(id);
    var hasLinkedCapability = card && !!getLinkedCapability(card);
    return hasLinkedCapability;
  },
  /**
   * Check if the given CI passed is a ChasePay linked card, which means it was added by linking to their Chase account
   */
  isChaseLinkedCard: function isChaseLinkedCard(fi) {
    var id = this.getId(fi);
    var card = this.getCardById(id);
    var linkedCapability = card && getLinkedCapability(card);
    if (!linkedCapability) {
      return false;
    }
    return linkedCapability.network_contingencies.some(function (networkInfo) {
      return networkInfo.network === NETWORK_TYPES.CHASE;
    });
  }
});
angular.value("$WalletModel", $WalletModel);
_squid.$Model;
_squid.$Api;
_squid.$util;
_instrument.Instrument;
_instrument.BankInstrument;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-models/src/wallet/instrument.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.Instrument = exports.BankInstrument = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
/*
 * Base model for wallet instrument data, to be used as a fallback if more specific
 * model does not exist
 */
var Instrument = exports.Instrument = _squid.$Class.extend('Instrument', {
  getName: _squid.$util.noop,
  getLastChars: _squid.$util.noop
});
var BankInstrument = exports.BankInstrument = Instrument.extend({
  getName: function getName() {
    return this.get('fs.issuer.name');
  },
  getLastChars: function getLastChars() {
    return this.get('fs.last_nchars');
  }
});
_squid.$util;
_squid.$Class;

/***/ }),

/***/ "../node_modules/xo-page-components/src/aside-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/aside-header/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
_angular["default"].module().directive('xoAsideHeader', function () {
  return {
    template: _template["default"],
    restrict: 'E',
    scope: {
      hdrtype: '@?',
      heading: '@?',
      subHead: '@?',
      addLink: '@?',
      backUrl: '@?',
      closeUrl: '@?',
      hidex: '@?',
      headerLeftLink: '=?',
      headerLeft: '@?',
      headerLeftIcon: '@?',
      headerRightLink: '=?',
      headerRight: '@?',
      headerRightIcon: '@?',
      subHeaderLeftLink: '@?',
      subHeaderLeft: '@?',
      subHeaderLeftIcon: '@?',
      subHeaderRightLink: '@?',
      subHeaderRight: '@?',
      subHeaderRightIcon: '@?',
      showDualFi: '=?'
    },
    controller: ['$scope', '$element', function ($scope, $element) {
      (0, _angular.$timeout)(function () {
        // Explicitly select `x` button and `<` buttons from manage wallet
        // and add card pages
        // See: https://engineering.paypalcorp.com/jira/browse/PPPLMER-64007
        // See: https://engineering.paypalcorp.com/jira/browse/PPPLMER-64008
        $element.find('a.focusableIcon').focus();
      });
      if (_angular["default"].isUndefined($scope.closeUrl)) {
        $scope.closeUrl = 'checkout.review';
      }
      if ($scope.addLink) {
        $scope.subHeaderRight = 'asideHeader.add';
        $scope.subHeaderRightLink = $scope.addLink;
      }
      $scope.onClickLink = function (event, target, showDualFi) {
        event.preventDefault();
        if (showDualFi) {
          $scope.showFiOptions = true;
        } else if (_angular["default"].isFunction(target)) {
          target();
        } else {
          _uiRouter.$state.go(target);
        }
      };
    }]
  };
});
_uiRouter.$state;

/***/ }),

/***/ "../node_modules/xo-page-components/src/aside-header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"header noButtons\" tabindex=\"-1\" ng-class=\"[hdrtype]\" content>\n    <div class=\"primaryHeader\">\n        <h1 class=\"asideAlpha walletHeading noHead noBottom alpha\">{{ content(heading) }}</h1>\n        <a link-button ui-sref=\"{{backUrl}}\" class=\"backArrow focusableIcon goTray\" ng-if=\"backUrl\" aria-label=\"Back button\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerLeftLink)\" class=\"left focusableIcon\" ng-if=\"headerLeftLink\">\n            <span ng-if=\"headerLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{closeUrl}}\" class=\"close focusableIcon\" ng-if=\"!backUrl && !hidex\" aria-label=\"Back button\"\n           data-test-id=\"closeAsideWallet\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n        <a link-button ng-click=\"onClickLink($event, headerRightLink)\" class=\"right focusableIcon\" ng-if=\"headerRightLink\">\n            <span ng-if=\"headerRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"accessAid\">{{ content(headerRight) }}</span>\n        </a>\n    </div>\n\n    <div class=\"subHeader\" ng-class=\"{'addOptions': !subHeaderLeftLink}\" ng-if=\"subHeaderLeftLink || subHeaderRightLink\">\n        <h2 class=\"subheading gamma\" ng-if=\"!subHeaderLeftLink\">{{ content(subHead) }}</h2>\n        <a link-button ui-sref=\"{{subHeaderLeftLink}}\" ng-click=\"onClickLink($event, subHeaderLeftLink, showDualFi)\" ng-if=\"subHeaderLeftLink\" id=\"leftLink\" class=\"left\" data-test-id=\"sideBarAddLink\">\n            <span ng-if=\"subHeaderLeftIcon\" class=\"leftIcon\"></span>\n            <span class=\"leftText\">{{ content(subHeaderLeft) }}</span>\n        </a>\n        <a link-button ui-sref=\"{{subHeaderRightLink}}\" ng-class=\"{'addLink': !subHeaderLeftLink}\"  ng-click=\"onClickLink($event, subHeaderRightLink)\" ng-if=\"subHeaderRightLink\" id=\"rightLink\" class=\"right\">\n            <span ng-if=\"subHeaderRightIcon\" class=\"rightIcon\"></span>\n            <span class=\"rightText\">{{ content(subHeaderRight) }}</span>\n        </a>\n    </div>\n</div>\n<div class=\"fundingInstrumentList\" id=\"fundingInstrumentList\" ng-if=\"showFiOptions\">\n    <ul>\n        <li class=\"bank\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddBank.bank.add\" id=\"addBank\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addBank')}}</span>\n            </a>\n        </li>\n        <li class=\"cards\">\n            <a link-button ui-sref=\"checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard\" id=\"addCC\" class=\"submit\">\n                <span class=\"icon\"></span>\n                <span class=\"description\">{{ content('DEMemberGuest.addCC')}}</span>\n            </a>\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/autobilling-terms/autobillingTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _wpsAutobilling = __webpack_require__("../node_modules/xo-page-components/src/constants/wpsAutobilling.js");
/**
 * Wrapper for calling formatCurreny fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
  arguments[0] = arguments[0].toFixed(2);
  return _squid.formatCurrency.apply(void 0, arguments);
}
function mapBaResponse(baResponseData) {
  var mappedAutobillingDetails = {};
  var plan = baResponseData && baResponseData.plan;
  var payment_definition = plan && plan.payment_definitions && plan.payment_definitions[0];
  var mappedTerms = [];
  mappedAutobillingDetails.currencyCode = plan && plan.currency_code;
  if (payment_definition) {
    var eachMappedTerm = {
      amount: payment_definition.amount && payment_definition.amount.value / 100,
      billPeriod: _wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD,
      periodType: _wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD_TYPE,
      billFrequency: _wpsAutobilling.WPS_AUTOBILING_BILLING_FREQUENCY,
      totalCycles: _wpsAutobilling.WPS_AUTOBILING_BILLING_CYCLE
    };
    if (!mappedAutobillingDetails.currencyCode) {
      mappedAutobillingDetails.currencyCode = payment_definition.amount && payment_definition.amount.currency;
    }
    mappedTerms.push(eachMappedTerm);
    mappedAutobillingDetails.autobillingTerms = mappedTerms;
  }
  return mappedAutobillingDetails;
}

/**
 * Prepare and return a autobilling terms
 * @param baResponseData
 * @returns {Object} Containing Autobilling Terms Text
 */
function getTermsText(baResponseData) {
  var autoBillingDetails = mapBaResponse(baResponseData);
  var termText;
  var templatePlaceholderData = {
    amount: getFormattedCurrency(+autoBillingDetails.autobillingTerms[0].amount, autoBillingDetails.currencyCode, false)
  };
  termText = _squid.Content.get(_wpsAutobilling.CONTENT_KEY, templatePlaceholderData) && _squid.Content.get(_wpsAutobilling.CONTENT_KEY, templatePlaceholderData).toString();
  return termText;
}

/**
 * Retrieve item details
 */
function getItemOptions(baResponseData) {
  var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];
  return itemDetails.options || [];
}

/**
 * Retrieve item name
 */
function getItemName(baResponseData) {
  if (!baResponseData) {
    return;
  }
  var _baResponseData$items = baResponseData.items,
    _baResponseData$items2 = _baResponseData$items === void 0 ? [] : _baResponseData$items,
    _baResponseData$items3 = _baResponseData$items2[0],
    _baResponseData$items4 = _baResponseData$items3 === void 0 ? {} : _baResponseData$items3,
    name = _baResponseData$items4.name;
  return name;
}
module.exports = {
  getItemOptions: getItemOptions,
  getItemName: getItemName,
  getTermsText: getTermsText
};
_squid.formatCurrency;
_squid.Content;
_wpsAutobilling.CONTENT_KEY;
_wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD;
_wpsAutobilling.WPS_AUTOBILING_BILLING_PERIOD_TYPE;
_wpsAutobilling.WPS_AUTOBILING_BILLING_FREQUENCY;
_wpsAutobilling.WPS_AUTOBILING_BILLING_CYCLE;

/***/ }),

/***/ "../node_modules/xo-page-components/src/autobilling-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _autobillingTerms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/autobilling-terms/autobillingTerms.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
module.exports = {
  getItemOptions: _autobillingTerms["default"].getItemOptions,
  getItemName: _autobillingTerms["default"].getItemName,
  getTermsText: _autobillingTerms["default"].getTermsText
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/ba-message-banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/ba-message-banner/template.html"));
__webpack_require__("../node_modules/xo-page-components/src/ba-message-banner/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoBaMessageBanner', {
  tag: 'xo-ba-message-banner',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    isMessengerIntegration: {
      type: 'var',
      required: false
    },
    borderPosition: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      if (this.props.token) {
        return {
          checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
          checkoutCart: _index.$CheckoutCartModel.instance(this.props.token).retrieve()
        };
      }
    }
  },
  lifecycle: {
    enter: function enter() {
      this.borderPosition = this.borderPosition || 'bottom';
    },
    populate: function populate() {
      this.merchantMsg = this.models.checkoutCart.getBillingDescription();

      // We need other variables only if this.merchantMsg exists
      if (this.merchantMsg) {
        // We need merchantDisplayName to be non empty and if merchant_name or brand_name is undefined
        // then we need the value of merchantDisplayName to be 'the merchant' as it is the middle of sentence
        // in content keys used in template
        this.nonEmptyMerchantDisplayName = this.models.checkoutAppData.getMerchantDisplayName({
          nonEmptyReturnValue: true
        });
        var _ref = window.xprops || {},
          _ref$experience = _ref.experience,
          experience = _ref$experience === void 0 ? {
            facebook: false
          } : _ref$experience;
        this.isFacebookIntegration = experience.facebook;
      }
    }
  }
});
_squid.$Component;
_index.$CheckoutAppDataModel;
_index.$CheckoutCartModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-page-components/src/ba-message-banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/ba-message-banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"{{ borderPosition + 'Border' }} baMessageBanner row-fluid\" ng-if=\"merchantMsg\" content>\n    <h1 ng-if=\"!isMessengerIntegration\" class=\"baIntegration noBottom alpha\" id=\"merchantMsgHeader\">\n        {{ content('billingAgreement.merchantMsgHeader', { merchantName: nonEmptyMerchantDisplayName }) }}\n    </h1>\n    <h1 ng-if=\"isFacebookIntegration\" class=\"fbIntegration messengerBAHeader\" id=\"merchantMsgHeader\">\n        {{ content('messenger.fbHeader') }}\n    </h1>\n    <h1 ng-if=\"!isFacebookIntegration && isMessengerIntegration\" class=\"messengerIntegration messengerBAHeader\" id=\"merchantMsgHeader\">\n        {{ content('messenger.baHeader') }}\n    </h1>\n    <div class=\"merchantMsg\" id=\"merchantMsg\">\n        <span class=\"subTitle given-name\">\n            {{ merchantMsg }}\n        </span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");
var _autobillingTerms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/autobilling-terms/index.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/template.html"));
__webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$autobilling', {
  tag: 'autobilling',
  template: _template["default"],
  props: {
    baToken: {
      type: 'var',
      optional: false
    },
    merchantId: {
      type: 'var',
      optional: false
    }
  },
  resolve: {
    models: function models() {
      return {
        autobillingData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
          params: {
            merchant_id: this.merchantId
          }
        })["catch"](_angular.noop)
      };
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this = this;
      this.itemName = _autobillingTerms["default"].getItemName(this.models.autobillingData);
      this.itemOptions = _autobillingTerms["default"].getItemOptions(this.models.autobillingData);
      this.getTermsText = function () {
        return _autobillingTerms["default"].getTermsText(_this.models.autobillingData);
      };
    }
  }
});
_angular.noop;
_squid.$Component;
_index.$SubscriptionModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/autobilling/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"autobillingTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"autobillingDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\" data-test-id=\"autobilling-minicart-heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <span class=\"item-name\" data-test-id=\"autobilling-minicart-itemname\">{{itemName}}</span>\n                <div class=\"item-option\">\n                    <div ng-repeat=\"option in itemOptions track by $index\">{{option.name}}:\n                        {{option.selection}}\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"autobill-terms-text\" role=\"gridcell\">\n            <h4 class=\"heading\" data-test-id=\"autobilling-minicart-termsTitle\">{{content('wpsSubscription.message.terms')}}:\n            </h4>\n            <div class=\"content\" data-test-id=\"autobilling-minicart-termsText\">\n                <span class=\"term-line\" ng-bind-html=\"getTermsText()\"></span>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");
var _subscriptionTerms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('cartWrapper', function () {
  return {
    template: _template["default"],
    restrict: 'E',
    scope: {
      showAmt: '=?',
      showArrow: '=?',
      token: '=?',
      baToken: '=?'
    },
    controller: ['$scope', function ($scope) {
      _squid.$util.assert($scope.token, 'Expected token');
      (0, _squid.$populate)($scope, {
        checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
      }).then(function () {
        if ($scope.checkoutCart.isSubscriptionsV1()) {
          $scope.showAmt = true;
          (0, _squid.$populate)($scope, {
            subscriptionsV1Data: _index2.$SubscriptionsV1Model.instance($scope.baToken)
          }).then(function () {
            var planReview = $scope.subscriptionsV1Data.planReview;
            var plan = planReview.new_plan || planReview.current_plan;
            $scope.subscriptionAmount = _subscriptionTerms["default"].getFormattedAmount(_subscriptionTerms["default"].getNumericValueNonZero(plan, 'initial_payment_info.total_amount.value'));
            $scope.currencyCode = _squid.$util.getProperty(plan, 'initial_payment_info.total_amount.currency_code');
          })["catch"](_angular.noop);
        }
        if ($scope.checkoutCart.purchase) {
          $scope.currencyCode = $scope.checkoutCart.purchase.amounts.total.currency_code;
        }
        $scope.getAmount = function () {
          if ($scope.checkoutCart.isSubscriptionsV1()) {
            return $scope.subscriptionAmount;
          } else if ($scope.checkoutCart.purchase) {
            return $scope.checkoutCart.purchase.amounts.total.amount;
          }
        };
      });
    }]
  };
});
_angular.noop;
_squid.$populate;
_squid.$util;
_index.$CheckoutCartModel;
_index2.$SubscriptionsV1Model;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/cartWrapper/template.html":
/***/ (function(module, exports) {

module.exports = "<span class=\"totalWrapper clearfix\" id=\"totalWrapper\" content>\n    <span id=\"transactionCart\" ng-class=\"{hasItems:showArrow}\">\n        <span class=\"cartIcon\" aria-label=\"{{ content('base.shoppingCart') }}\"></span>\n        <span ng-if=\"showAmt && getAmount()\">\n            <format-currency class=\"formatCurrency\" code=\"currencyCode\"\n                             amount=\"getAmount()\"></format-currency>\n        </span>\n        <span ng-if=\"showArrow\" class=\"arrow\" aria-label=\"{{ content('common.show') }}\"/>\n    </span>\n</span>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _sanitizeCaja = _interopRequireDefault(__webpack_require__("../node_modules/sanitize-caja/index.js"));
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/cartWrapper/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/lib/ui.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/autobilling/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/cart/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable max-statements */

angular.module().directive('xoCart', function () {
  return {
    template: _template["default"],
    restrict: 'E',
    scope: {
      showCartTotal: '=?',
      renderCartContainer: '=?',
      overrideShowDetails: '=?',
      detailsExpanded: '=?',
      token: '=?'
    },
    controller: ['$scope', function ($scope) {
      _squid.$util.assert($scope.token, 'Expected token');
      (0, _squid.$populate)($scope, {
        checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
        checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
        payee: _index.$CheckoutPayeeModel.instance($scope.token)
      }).then(function loadCartData() {
        // eslint-disable-line

        var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
        var cartDesc = (0, _sanitizeCaja["default"])($scope.checkoutCart.get('purchase.description'));
        $scope.note = (0, _sanitizeCaja["default"])($scope.checkoutCart.get('note'));

        // resolve string in descriptions array since the only element may be `null`
        // TODO: fix backend to return a string, to avoid this conditional
        if (cartDesc && angular.isString(cartDesc[0])) {
          cartDesc = cartDesc[0];
        } else {
          cartDesc = '';
        }
        $scope.desc = cartDesc;
        $scope.hasItems = !$scope.renderCartContainer && !emptyCart;
        var showCartDetails = !$scope.checkoutAppData.flags.hide_cart_details;
        var notMultiSellerPurchase = !$scope.checkoutCart.isMultiSellerPurchase();
        // Always Render minicart for wps subscription .
        var wpsSubscription = $scope.checkoutAppData.is_wps_subscription_flow();
        var wpsAutobilling = $scope.checkoutAppData.isWpsAutobillingFlow();
        var wpsInstallmentPlan = $scope.checkoutAppData.is_wps_installmentplan_flow();
        var isSubscriptionsV1 = $scope.checkoutCart.isSubscriptionsV1();
        $scope.wpsSubscription = wpsSubscription;
        $scope.wpsInstallmentPlan = wpsInstallmentPlan;
        $scope.isSubscriptionsV1 = isSubscriptionsV1;
        $scope.wpsAutobilling = wpsAutobilling;

        // We need non empty value for merchantDisplayName in #merchant-name tag of installmentPlan	
        $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
          nonEmptyReturnValue: true,
          isSentenceBeginning: true
        });
        var wpsBillingFlow = wpsSubscription || wpsInstallmentPlan || isSubscriptionsV1 || wpsAutobilling;
        var cartDetails = showCartDetails && (cartDesc || $scope.overrideShowDetails || $scope.hasItems || $scope.note) && notMultiSellerPurchase;
        $scope.showArrow = wpsBillingFlow || cartDetails;

        // add details to render to the checkoutCart items
        $scope.checkoutCart.get('purchase.items', []).forEach(function addDetails(item) {
          item.details = {};
          if (item.quantity > 1) {
            item.details.price = item.price.amount;
            item.details.quantity = (0, _squid.formatQuantity)(item.quantity);
          }
          if (item.description) {
            if (!item.name) {
              item.name = item.description;
            } else {
              item.details.description = item.description;
            }
          }

          // move options to detail section
          if (item.item_option_selections) {
            item.details.hasSelections = true;
            item.details.item_option_selections = item.item_option_selections;
          }
          if (item.sku) {
            item.details.sku = item.sku;
          }
          item.hasDetails = Object.keys(item.details).length > 0;
          item.details.hasMore = item.hasDetails || item.details.hasSelections;
        });

        // Mapping of field name as recieved by API to corresponding property key
        $scope.amountHeaders = {
          'total': 'header.total',
          'subtotal': 'header.itemTotal',
          'tax': 'header.tax',
          'shipping': 'header.shipping',
          'insurance': 'header.insurance',
          'handling_fee': 'header.handling',
          'shipping_discount': 'header.shippingDiscount',
          'description': 'header.description',
          'discount': 'header.discount',
          'checkout': 'header.checkout'
        };

        // Non-AU merchants are subjected to PXP test when user action is not commit and line item details
        // are not available and purchase amount is not zero.
        var userAction = $scope.userAction = $scope.checkoutAppData.useraction();
        var purchase = $scope.checkoutCart.purchase;
        var total = purchase && purchase.amounts && purchase.amounts.total;
        $scope.isCartTextTotalOrSubTotal = userAction === 'commit' || $scope.showCartTotal === true ? 'header.total' : 'header.subTotal';
        var isWPSBilling = $scope.checkoutAppData.is_wps_subscription_flow() || $scope.checkoutAppData.is_wps_installmentplan_flow() || $scope.checkoutCart.isSubscriptionsV1() || $scope.checkoutAppData.isWpsAutobillingFlow();

        //  Replacing the show cart decision using Elmo experiment by this piece of code simulating
        //  Weasley behavior where if the amount exists just showed. Also added the conditions
        //  isPurchase from the pxp call and the extra conditions for subtotal from showCartDecision 
        //  https://github.paypal.com/Checkout/xo-page-components/blob/master/src/cart/lib/showCartDecision.js#L10-L12
        //  https://github.paypal.com/Checkout/xo-page-components/blob/master/src/cart/lib/pxp.js#L6-L36   
        $scope.showAmt = $scope.checkoutCart.isPurchase() && total && total.amount !== '0';
        $scope.showCartSubTotal = $scope.checkoutCart.isPurchase() && total && !isWPSBilling; //  checking for  isWpsSubscriptionFlow & isWpsInstallmentPlan & isWpsAutobillingFlow
        $scope.showAmountInCartIcon = $scope.checkoutCart.isPurchase() && total && total.amount !== '0';
      }).then(function handleCartOpenClose() {
        // the cart is only automatically open under the following criteria:
        // 1. the cart has a 'note to buyer' ($scope.note is defined)
        // 2. the cart was not previously automatically opened before
        // 3. the state has transitioned to checkout.review or checkout.guest
        // OR `detailsExpanded` is passed as true to the component
        function decideShowCart(currentState) {
          var falsePositive = /^checkout\.(selectFi)$/.test(currentState) && /^checkout\.(review|guest)$/.test($scope.openedAlready);
          var notOpened = !$scope.openedAlready && /^checkout\.(review|guest)$/.test(currentState);
          var canShow = notOpened || falsePositive;
          if ($scope.note && canShow || $scope.detailsExpanded) {
            $scope.openedAlready = currentState; // may have been undefined before
            return true;
          }
          return false;
        }
        $scope.showCartItem = function (breakdown) {
          return breakdown.field_name !== 'total' && Number(breakdown.amount) !== 0;
        };
        $scope.showCart = decideShowCart(_uiRouter.$state.current.name);

        // TODO: Must we really couple this so tightly with the state transition names?
        var openCartListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
          $scope.showCart = decideShowCart(toState.name);
        });
        $scope.$on('$destroy', openCartListener); // see http://stackoverflow.com/a/27016855 on why $destroy

        $scope.toggleCart = function ($event) {
          $scope.showCart = !$scope.showCart;
          $event.preventDefault();
        };
        $scope.closeCart = function ($event) {
          $scope.showCart = false;
          // for accessible autofocus on cart toggle link button
          $scope.$broadcast('cart-closed');
          if ($event) {
            $event.preventDefault();
          }
        };
        $scope.$on('clickBody', function ($event, target) {
          if ($scope.showCart && $(target).parents('.cartContainer').length === 0) {
            $scope.closeCart($event);
            $scope.$apply();
          }
        });

        // this listener / broadcast allows accessibility components to scan and focus inside the cart
        // when the cart is displayed
        $scope.$watch('showCart', function (showCart) {
          if (showCart) {
            $scope.$broadcast('cart-updated');
          }
        });
      }).then(function handleEllipsisIssues() {
        // NOTE: the scattered broadcasts of "cart-updated" events are mostly
        // to allow the accessibility directives modal-box and focus-when to
        // know when to recalculate keyboard behavior / focus
        $scope.toolongTracker = {};

        // this function is invoked by the onEllipsis directive that tracks
        // if the item name won't fit within the restricted space.
        $scope.toolong = function (idx) {
          $scope.toolongTracker[idx] = true;
          $scope.$broadcast('cart-updated');
        };
        $scope.showMore = function (idx, type) {
          // there are 2 types of more, "floating" when the name is too long
          // and "inline" when the name can fit, but there are additional details.
          //
          // Show a more if the item
          // 1. has an expanded state
          // 2. is not already expanded
          // 3. if it is appropriate to show that type.
          var itemIsTooLong = $scope.toolongTracker[idx];
          var isAppropriateType = itemIsTooLong && type === 'floating' || !itemIsTooLong && type === 'inline';
          return $scope.hasExpandedState(idx) && !$scope.isExpanded(idx) && isAppropriateType;
        };
        $scope.expandedIndex = -1; // initially, none of the line items are expanded
        $scope.isExpanded = function isExpanded(idx) {
          return idx === $scope.expandedIndex;
        };
        $scope.hasExpandedState = function hasExpandedState(idx) {
          // A line item is exandable if
          // 1. the name cannot fit in one line ($scope.toolongTracker) and/or
          // 2. there are details (attached to purchase.items in the cart)
          // 3. there is item number (sku) in the item
          var item = $scope.checkoutCart.get('purchase.items', [])[idx] || {};
          var nameTooLong = $scope.toolongTracker[idx];
          return nameTooLong || item.hasDetails || item.sku;
        };
        $scope.expand = function expand(idx) {
          $scope.expandedIndex = idx;
          $scope.$broadcast('cart-updated');
        };
        $scope.collapse = function collapse() {
          $scope.expandedIndex = -1;
          $scope.$broadcast('cart-updated');
        };

        // Set default focus on cart first element "more" link
        $scope.focusElementCssSelector = 'a.more';

        // Change the focus element as user clicks on elements
        $scope.$watch('expandedIndex', function (expandedIndex) {
          if (expandedIndex === -1) {
            $scope.focusElementCssSelector = 'a.more';
          } else {
            // If any "more" link or item is clicked in cart, then
            // set focus to itemNameContainer
            $scope.focusElementCssSelector = '.itemNameContainer.expanded';
          }
        });
        $scope.$emit('dataLoaded');
      });
    }]
  };
});
_angular.$rootScope;
_squid.$populate;
_squid.$util;
_squid.formatQuantity;
_uiRouter.$state;
_index.$CheckoutAppDataModel;
_index.$CheckoutCartModel;
_index.$CheckoutPayeeModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");
var _installmentplanTerms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/installmentplan-terms/index.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/template.html"));
__webpack_require__("../node_modules/xo-page-components/src/cart/installmentPlan/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$installmentplan', {
  tag: 'installmentplan',
  template: _template["default"],
  props: {
    baToken: {
      type: 'var',
      optional: false
    },
    merchantId: {
      type: 'var',
      optional: false
    },
    merchantName: {
      type: 'var',
      optional: false
    }
  },
  resolve: {
    models: function models() {
      return {
        installmentPlanData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
          params: {
            merchant_id: this.merchantId
          }
        })["catch"](_angular.noop)
      };
    }
  },
  lifecycle: {
    populate: function populate() {
      var installmentData = _installmentplanTerms["default"].getInstallmentPlanData(this.models.installmentPlanData);
      this.itemName = _installmentplanTerms["default"].getItemName(this.models.installmentPlanData);
      this.total = installmentData.formattedTotalAmount;
      this.getFirstAmount = function () {
        return installmentData.formattedFirstAmount;
      };
      this.getTermsText = function () {
        return installmentData.termsText;
      };
      this.getAmountText = function () {
        return installmentData.amountText;
      };
      this.getDisplayTotal = function () {
        return installmentData.displayTotal;
      };
    }
  }
});
_angular.noop;
_squid.$Component;
_index.$SubscriptionModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/installmentPlan/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"installmentPlanTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"installmentPlanDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsInstallmentPlan.message.installmentPlanDetails')}}:</h4>\n            <div class=\"content\">\n                <span class=\"item-name\">{{itemName}}</span>\n            </div>\n        </div>\n\n        <div class=\"installmentTermsText\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsInstallmentPlan.message.billCycle')}}:\n            </h4>\n            <div class=\"bill-cycle\">\n                <div class=\"bill-cycle-term\">\n                    <div class=\"term-line\" ng-repeat=\"term in getTermsText() track by $index\">{{term}}</div>\n                </div>\n                <div class=\"bill-cycle-amount\">\n                    <div class=\"amount-line\" ng-repeat=\"amount in getAmountText() track by $index\">{{amount}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"installmentTermsText\" role=\"gridcell\" ng-if=\"getDisplayTotal()\">\n            <div class=\"display-total\">\n                <div class=\"bill-cycle-term\">\n                    <div class=\"term-line\" >{{content('wpsInstallmentPlan.message.total')}}:</div>\n                </div>\n                <div class=\"bill-cycle-amount\">\n                    <div class=\"amount-line\">{{total}}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"installmentPlanLegal\">\n            <div class=\"content\">\n                <div class=\"legal-text\">{{content('wpsInstallmentPlan.message.installmentPlanLegalText')}}</div>\n                <div class=\"legal-info\">{{content('wpsInstallmentPlan.message.installmentPlanLegalTextSuggestion', {merchantName})}}</div>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/directive.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/cart/itemDetails/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('itemDetails', function () {
  return {
    template: _template["default"],
    restrict: 'E',
    scope: {
      details: '=?',
      sku: '=?',
      currencyCode: '=?',
      onClickLess: '&?'
    },
    controller: function controller() {/* dumb component */}
  };
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/itemDetails/template.html":
/***/ (function(module, exports) {

module.exports = "<!-- this directive requires\n  * visible boolean\n  * details object (with .price, .quantity, .description,\n  * possible .item_option_selections)\n  * currency-code string\n  * possible sku (item number)\n  * on-click-less - function invocation expression\n-->\n<ul focusable content class=\"itemDetails\">\n  <li ng-if=\"details.sku\">\n      <span>\n          <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ details.sku }}</span>\n      </span>\n  </li>\n  <li ng-if=\"details.price\">{{ content('header.price') }}\n    <format-currency code=\"currencyCode\" amount=\"details.price\"></format-currency>\n  </li>\n  <li ng-if=\"details.quantity\">{{ content('header.quantity') }} <span class=\"item-quantity\">{{ details.quantity }}</span></li>\n  <li ng-if=\"details.hasMore\">\n    <div ng-if=\"details.hasSelections\" class=\"item-selections\">\n      <span class=\"item-selection\" ng-repeat=\"selection in details.item_option_selections track by $index\">\n        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n        <span class=\"item-selection-value\">{{ selection.select }}</span>\n      </span>\n    </div>\n\n    <div ng-if=\"details.description\">\n      <strong class=\"item-selection-name\">{{ content('header.description') }}</strong> <span class=\"item-description\">{{ details.description }}</span>\n    </div>\n  </li>\n</ul>\n<a class=\"less\" link-button=\"content('header.srLess')\" ng-click=\"onClickLess()\">{{ content('header.less') }}</a>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/decode_entities.js":
/***/ (function(module, exports) {



/**
 * Takes a string with HTML entities within and renders it as the unicode
 * characters they represent. This is done by leveraging the browser to
 * perform this transformation internally. InnerText is chosen as the output
 * so as to kill any HTML itself that was supplied.
 *
 * @param {Element} element any HTML element supporting innerText and
 * innerHTML. Preferably one not connected to the DOM or visible in any way.
 * @param {String} input a String containing HTML entities that need to be
 * decoded and HTML stripped.
 * @return {String} the same string with HTML tags removed and entities
 * decoded.
 */
exports.__esModule = true;
exports.decodeEntities = decodeEntities;
exports["default"] = decodeEntitiesAngularFilter;
function decodeEntities(element, input) {
  // Escape opening tags on vulnerable tags
  input = input.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link|source|video|audio|details|input|image|object|track|select)/ig, '&lt;$1$2');
  element.innerHTML = input;
  return element.textContent;
}
function decodeEntitiesAngularFilter() {
  // A constant key that can be used to find the element
  var ENTITY_ELEM = '__xpc_entitydecoder__';

  // Create the element if this is the first time this is called
  if (!window[ENTITY_ELEM]) {
    window[ENTITY_ELEM] = document.createElement('p');
  }

  // Retrieve the converter element rather than create one every
  // time. Angular may call this filter many times repeatedly and
  // we should make a small effort to optimize the process
  var converter = window[ENTITY_ELEM];

  /**
   * Takes a string with HTML entities within and renders it as the unicode
   * characters they represent. This is done by leveraging the browser to
   * perform this transformation internally. InnerText is chosen as the output
   * so as to kill any HTML itself that was supplied.
   *
   * @param {String} input a String containing HTML entities that need to be
   * decoded and HTML stripped.
   * @return {String} the same string with HTML tags removed and entities
   * decoded.
   */
  return decodeEntities.bind(null, converter);
}

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/pxp.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
angular.module().factory('$pxpCartAmt', function () {
  return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {
    if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {
      var pageName = 'xo_hermes_no_line_item_details';
      var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
      var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';
      return _angular.$q.all([(0, _squid.$pxp)(pageName, {
        'ctx.merchantID': merchantId,
        uid: merchantId
      }, showAmtBlacklistTreatment, false, true), (0, _squid.$pxp)(pageName, {
        'ctx.merchantID': merchantId,
        uid: merchantId
      }, showAmtTreatment, false, true)]).then(function (results) {
        var showAmtBlacklist = results[0];
        var showAmt = results[1];
        if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
          return true;
        }
        if (showAmt && showAmt.treatment_name === showAmtTreatment) {
          return true;
        }
        return false; // default to hide
      });
    }
    return _angular.$q.when(!noLineItemDetails && isPurchase);
  };
});
_squid.$pxp;
_angular.$q;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/cart/lib", "../node_modules/xo-page-components/src/cart/lib/pxp.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/showCartDecision.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.showCartDecision = showCartDecision;
var _pxp = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/pxp.js");
function showCartDecision(isWps, total, merchantCountry, merchantId, noLineItemDetails, isPurchase) {
  return (0, _pxp.$pxpCartAmt)(merchantCountry, merchantId, noLineItemDetails, isPurchase).then(function (showAmount) {
    // Show cart subtotal if there is a total amount
    // Do not show subtotal for wps subscription flow.
    // Show amount in cart icon only if showAmount is truthy and total amount is not zero
    return {
      showAmt: showAmount,
      showCartSubTotal: showAmount && total && !isWps,
      //  checking for  isWpsSubscriptionFlow & isWpsInstallmentPlan & isWpsAutobillingFlow
      showAmountInCartIcon: showAmount && +total.amount !== 0
    };
  });
}
_pxp.$pxpCartAmt;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/lib/ui.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _decode_entities = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/cart/lib/decode_entities.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Register entity decoding filter in Angular
_angular.$filterProvider.register('decodeEntities', _decode_entities["default"]);

// if an element has an ellipsis text-overflow in effect (it must already have
// the appropriate css styling) then invoke the function that is passed to the directive
function getVisibleWidth(elem) {
  var elemRect = elem.getBoundingClientRect();

  // cross browser, returns decimals for ultra-precision
  return elemRect.right - elemRect.left;
}
function getNaturalWidth(elem) {
  var old = {
    overflow: elem.style.overflow,
    width: elem.style.width,
    display: elem.style.display
  };
  var result;
  elem.style.overflow = 'visible';
  elem.style.width = 'auto';
  elem.style.display = 'inline-block';
  result = getVisibleWidth(elem);
  elem.style.overflow = old.overflow;
  elem.style.width = old.width;
  elem.style.display = old.display;
  return result;
}

// pre-determine approach to reading styles
var getStyle = _angular.$window.getComputedStyle ? function (elem, style) {
  return _angular.$window.getComputedStyle(elem)[style];
} // modern browsers
: function (elem, style) {
  return elem.currentStyle[style];
}; // IE

function hasEllipsis(elem) {
  var overflowHidden = getStyle(elem, 'overflow') === 'hidden';
  var textOverflowEllipsis = getStyle(elem, 'text-overflow') === 'ellipsis';
  var whiteSpaceNowrap = getStyle(elem, 'white-space') === 'nowrap';
  if (overflowHidden && textOverflowEllipsis && whiteSpaceNowrap) {
    return getVisibleWidth(elem) < getNaturalWidth(elem);
  }
  return false;
}
(0, _squid.$registerDirective)('onEllipsis', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      function invokeSubscriber() {
        (0, _angular.$parse)(attrs.onEllipsis)(scope);
        scope.$apply();
      }
      (0, _angular.$timeout)(function () {
        if (hasEllipsis(element[0])) {
          invokeSubscriber();
        }
      });
    }
  };
});

// Makes an element examine the outerHeight of its siblings
// and the max-height of its parent, then sets a max-height for itself
// so that everything fits within the limits of the parent. Note that it assumes
// no other sibling also has dynamic-maxheight.
(0, _squid.$registerDirective)('dynamicMaxheight', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      function resizeContainer() {
        var $element = (0, _jquery["default"])(element);
        var parentHeight = parseFloat(getStyle($element.parent()[0], 'max-height'));
        var siblings = $element.siblings().filter(function () {
          var pos = getStyle((0, _jquery["default"])(this)[0], 'position');
          return pos !== 'fixed' && pos !== 'absolute';
        }).map(function getOuterHeights() {
          return (0, _jquery["default"])(this).outerHeight();
        });
        var siblingsHeight = 0;
        var i;
        for (i = 0; i < siblings.length; i += 1) {
          siblingsHeight += siblings[i];
        }
        var spaceAvailable = parentHeight - siblingsHeight;
        if (!isNaN(spaceAvailable)) {
          $element.css('max-height', spaceAvailable + 'px');
        }
      }

      // if an expression is provided, it is used as an event to listen for and recalculate the height
      if (attrs.dynamicMaxheight) {
        scope.$on((0, _angular.$parse)(attrs.dynamicMaxheight)(scope), resizeContainer);
      }
      (0, _angular.$timeout)(resizeContainer);
    }
  };
});
_squid.$registerDirective;
_angular.$parse;
_angular.$timeout;
_angular.$filterProvider;
_angular.$window;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");
var _subscriptionTerms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/subscription-terms/index.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/template.html"));
__webpack_require__("../node_modules/xo-page-components/src/cart/subscription/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$subscription', {
  tag: 'subscription',
  template: _template["default"],
  props: {
    baToken: {
      type: 'var',
      optional: false
    },
    merchantId: {
      type: 'var',
      optional: false
    }
  },
  resolve: {
    models: function models() {
      return {
        subscriptionData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
          params: {
            merchant_id: this.merchantId
          }
        })["catch"](_angular.noop)
      };
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this = this;
      this.itemName = _subscriptionTerms["default"].getItemName(this.models.subscriptionData);
      this.itemOptions = _subscriptionTerms["default"].getItemOptions(this.models.subscriptionData);
      this.getFirstAmount = function () {
        return _subscriptionTerms["default"].getFormattedFirstAmount(_this.models.subscriptionData);
      };
      this.getTermsText = function () {
        return _subscriptionTerms["default"].getTermsText(_this.models.subscriptionData);
      };
    }
  }
});
_angular.noop;
_squid.$Component;
_index.$SubscriptionModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscription/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <span class=\"item-name\">{{itemName}}</span>\n                <div class=\"item-option\">\n                    <div ng-repeat=\"option in itemOptions track by $index\">{{option.name}}:\n                        {{option.selection}}\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"subs-terms-text\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.terms')}}:\n            </h4>\n            <div class=\"content\">\n                <span class=\"term-line\" ng-repeat=\"term in getTermsText() track by $index\">{{term}}</span>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\">{{content('wpsSubscription.message.firstAmount')}}</h4>\n            <div ng-bind-html=\"getFirstAmount()\" class=\"content\"></div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/subscription/index.js");
var _subscriptionV1Terms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/subscriptionV1-terms/index.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/template.html"));
__webpack_require__("../node_modules/xo-page-components/src/cart/subscriptionsV1/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$SubscriptionsV1', {
  tag: 'subscriptions-v1',
  template: _template["default"],
  props: {
    baToken: {
      type: 'var',
      optional: false
    },
    merchantId: {
      type: 'var',
      optional: false
    }
  },
  resolve: {
    models: function models() {
      return {
        subscriptionData: _index.$SubscriptionsV1Model.instance(this.baToken).retrieve({
          params: {
            merchant_id: this.merchantId
          }
        })["catch"](_angular.noop)
      };
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this$models$subscrip = this.models.subscriptionData,
        planReview = _this$models$subscrip.planReview,
        billingAgreementCart = _this$models$subscrip.billingAgreementCart;
      var plan = planReview.new_plan || planReview.current_plan;
      var itemAmount = _squid.$util.getProperty(plan, 'initial_payment_info.first_payment.value');
      var isItemAmountPresent = _subscriptionV1Terms["default"].isNumericValue(itemAmount);
      var currencyCode = _squid.$util.getProperty(plan, 'initial_payment_info.total_amount.currency_code');
      this.termsText = _subscriptionV1Terms["default"].getTermsText(plan);
      this.isAutoRenew = billingAgreementCart.auto_renewal !== 'false';
      this.startDate = billingAgreementCart.start_time_formatted;
      this.itemName = _squid.$util.getProperty(plan, 'plan.name');
      var taxPercentage = _subscriptionV1Terms["default"].getNumericValueNonZero(plan, 'initial_payment_info.taxPercentage');
      var taxAmount = _squid.$util.getProperty(plan, 'initial_payment_info.tax_amount');
      var taxAmountFormatted = taxAmount && _subscriptionV1Terms["default"].getFormattedAmount(taxAmount.value, taxAmount.currency_code);
      this.taxDisclaimer = _subscriptionV1Terms["default"].getTaxDisclaimer(taxPercentage, taxAmountFormatted);
      this.itemPrice = isItemAmountPresent && _subscriptionV1Terms["default"].getFormattedAmount(itemAmount, currencyCode);
      this.quantity = plan.plan.quantity_supported && billingAgreementCart.quantity;
      this.shipping = _subscriptionV1Terms["default"].getNumericValueNonZero(plan, 'initial_payment_info.shipping_amount.value');
      this.shippingAmount = _subscriptionV1Terms["default"].getFormattedAmount(this.shipping, currencyCode);
      this.setupFee = _subscriptionV1Terms["default"].getNumericValueNonZero(plan, 'initial_payment_info.setup_fee.value');
      this.setupFeeAmount = _subscriptionV1Terms["default"].getFormattedAmount(this.setupFee, currencyCode);
      var totalAmount = _subscriptionV1Terms["default"].getNumericValueNonZero(plan, 'initial_payment_info.total_amount.value');
      this.totalAmount = _subscriptionV1Terms["default"].getFormattedAmount(totalAmount, currencyCode);
    }
  }
});
_angular.noop;
_squid.$Component;
_squid.$util;
_index.$SubscriptionsV1Model;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/subscriptionsV1/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"subscriptionTerms\" content>\n    <div role=\"grid\" class=\"minicart\">\n        <div class=\"subscriptionDetails\" role=\"gridcell\">\n\n            <h4 class=\"heading\">{{content('wpsSubscription.message.subscriptionDetails')}}:</h4>\n            <div class=\"content\">\n\n                <div class=\"item-option\">\n                    <div ng-repeat=\"terms in termsText track by $index\">\n                        {{terms}}\n                    </div>\n                    <div ng-if=\"isAutoRenew\" class=\"subscription-terms\">{{content('subscriptions.message.renewsUntilCancelled')}}</div>\n                    <div class=\"start-date\" ng-if=\"startDate\"> {{content('subscriptions.message.startDate')}} {{ startDate }}</div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"landing-page-item-details-container\">\n            <div class=\"item-details-row\">\n                <div class=\"item-details-left\" ng-class=\"{'tax-indicator-after': taxDisclaimer}\">{{ itemName }} </div>\n                <div class=\"item-details-right\" ng-if=\"itemPrice\"> {{ itemPrice }}</div>\n            </div>\n            <div class=\"item-details-row label-color\" ng-if=\"quantity\">\n                <div class=\"item-details-left\">{{ content('header.quantity') }} {{ quantity }}</div>\n                <div class=\"item-details-right\"></div>\n            </div>\n            <div class=\"item-details-row\" ng-if=\"shipping\">\n                <div class=\"item-details-left\">{{ content('header.shipping') }}</div>\n                <div class=\"item-details-right\">{{ shippingAmount }}</div>\n            </div>\n\n            <div class=\"item-details-row\" ng-if=\"setupFee\">\n                <div class=\"item-details-left\" ng-class=\"{'tax-indicator-after': taxDisclaimer}\">{{ content('subscriptions.message.setupFee') }}</div>\n                <div class=\"item-details-right\">{{ setupFeeAmount }}</div>\n            </div>\n\n            <div class=\"item-details-row margin-top-30\" ng-if=\"taxDisclaimer\">\n                <div class=\"item-details-left label-color tax-indicator-before\" data-test-id=\"tax-disclaimer\">\n                    {{ taxDisclaimer }}\n                </div>\n            </div>\n        </div>\n        <div class=\"firstAmount\" role=\"gridcell\">\n            <h4 class=\"heading\" >{{content('header.total')}}</h4>\n            <div class=\"content\">{{ totalAmount }}</div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/cart/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"cartContainer\" content ng-if=\"showAmt || showArrow\">\n    <div class=\"transactionDetailsContainer\" ng-class=\"{cart:showCart, hasAmount:showAmt}\">\n\n        <a href=\"#transactionCartDetails\"\n           class=\"transactionDetails scTrack:hermes-cartExpanded\"\n           aria-controls=\"transctionCartDetails\" aria-haspopup=\"true\"\n           role=\"button\" ng-click=\"toggleCart($event)\"\n           focus-when focus-refresh-on=\"'cart-closed'\" ng-if=\"showArrow\">\n            <cart-wrapper ng-if=\"showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                          token=\"token\" ba-token=\"checkoutCart.getBaToken()\"\n            ></cart-wrapper>\n        </a>\n\n        <cart-wrapper ng-if=\"!showArrow\" show-amt=\"showAmountInCartIcon\" show-arrow=\"showArrow\"\n                      token=\"token\"></cart-wrapper>\n\n        <div class=\"transctionCartDetails\" id=\"transctionCartDetails\" modal-box modal-refresh-on=\"'cart-updated'\" modal-cancel=\"closeCart()\" aria-hidden=\"{{ !showArrow }}\" ng-if=\"showArrow\">\n            <div class=\"details\" role=\"document\" focus-when focus-refresh-on=\"'cart-updated'\" focus-element=\"focusElementCssSelector\">\n\n                <a id=\"closeCart\" link-button=\"content('header.close')\" class=\"actions focusableIcon\" ng-click=\"closeCart($event)\" ></a>\n\n                <div>\n                    <h2 ng-if=\"checkoutAppData.merchant\" class=\"merchantName\" ng-class=\"{merchantTitle: showAmt && (note || desc)}\" id=\"merchantName\">\n                        <span ng-if=\"note\">{{ content('header.noteFromMerchant', {merchant: checkoutAppData.merchant.brand_name}) }}</span>\n                        <span ng-if=\"!note\">{{ checkoutAppData.merchant.brand_name }}</span>\n                    </h2>\n                    <p ng-if=\"note || desc\"class=\"note\" ng-class=\"{ noteHighlighted: desc || !showAmt }\">\n                        <span ng-if=\"note\">{{ note | decodeEntities }}</span>\n                        <span ng-if=\"!note\">{{ desc | decodeEntities }}</span>\n                    </p>\n                </div>\n\n                <subscription ng-if=\"wpsSubscription\"\n                              ba-token=\"checkoutCart.getBaToken()\"\n                              merchant-id=\"payee.getId()\">\n                </subscription>\n\n                <autobilling ng-if=\"wpsAutobilling\"\n                              ba-token=\"checkoutCart.getBaToken()\"\n                              merchant-id=\"payee.getId()\">\n                </autobilling>\n\n                <installmentplan ng-if=\"wpsInstallmentPlan\"\n                              ba-token=\"checkoutCart.getBaToken()\" merchant-id=\"payee.getId()\" merchant-name=\"nonEmptyMerchantDisplayName\"></installmentplan>\n\n                <subscriptions-v1 ng-if=\"isSubscriptionsV1\"\n                                  ba-token=\"checkoutCart.getBaToken()\"\n                                  merchant-id=\"payee.getId()\">\n                </subscriptions-v1>\n\n                <div ng-if=\"!(wpsSubscription) \" dynamic-maxheight=\"'cart-updated'\" class=\"scrollable-middle\">\n                    <div ng-if=\"!(wpsInstallmentPlan)\">\n                        <div ng-if=\"!(autobilling)\">\n                            <ul class=\"detail-items\" ng-if=\"hasItems\">\n                                <li ng-repeat=\"item in checkoutCart.purchase.items track by $index\" class=\"items\">\n\n                                    <div focusable class=\"itemNameContainer\" ng-class=\"{expanded: isExpanded($index)}\">\n                                        <a class=\"more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'floating')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a>\n                                        <span on-ellipsis=\"toolong($index)\" title=\"{{ item.name }}\" class=\"itemName\">{{ item.name }} <a class=\"less\" link-button=\"content('header.srLess')\" ng-show=\"isExpanded($index) && !item.hasDetails\" ng-click=\"collapse()\">{{ content('header.less') }}</a><a class=\"more inline-more\" link-button=\"content('header.srMore')\" ng-show=\"showMore($index, 'inline')\" ng-click=\"expand($index)\">{{ content('header.more') }}</a></span>\n                                    </div>\n                                    <span class=\"itemPrice\">\n                                        <format-currency code=\"item.amount.currency_code\" amount=\"item.amount.amount\"></format-currency>\n                                    </span>\n                                    <item-details ng-show=\"isExpanded($index) && item.hasDetails\" currency-code=\"item.amount.currency_code\" details=\"item.details\" on-click-less=\"collapse()\">\n                                </li>\n                            </ul>\n\n                            <ul class=\"detail-extras\" ng-if=\"showAmt && hasItems\">\n                                <li class=\"detail-breakdown\" ng-if=\"checkoutCart.purchase.amounts\">\n                                    <li ng-repeat=\"breakdown in checkoutCart.purchase.amounts track by $index\" class=\"amounts\" ng-if=\"showCartItem(breakdown)\">\n                                        <span class=\"itemNameContainer\">{{ content(amountHeaders[breakdown.field_name]) }}</span>\n                                        <span class=\"itemPrice\">\n                                            <format-currency code=\"breakdown.currency_code\" amount=\"breakdown.amount\"></format-currency>\n                                        </span>\n                                    </li>\n                                </li>\n                            </ul>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"!(wpsInstallmentPlan)\">\n                <div class=\"subTotal\" ng-if=\"showCartSubTotal\">\n                    <span class=\"itemNameContainer\">{{ content(isCartTextTotalOrSubTotal) }}</span>\n                        <span class=\"itemPrice\">\n                            <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                            amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                        </span>\n                    </div>\n                </div>\n\n                <div class=\"subTotal\" ng-if=\"(wpsInstallmentPlan && (showAmt && hasItems))\">\n                    <span class=\"itemNameContainer\">{{ content(amountHeaders['checkout']) }}</span>\n                    <span class=\"itemPrice\">\n                        <format-currency code=\"checkoutCart.purchase.amounts.total.currency_code\"\n                                         amount=\"checkoutCart.purchase.amounts.total.amount\"></format-currency>\n                    </span>\n                </div>\n\n            </div>\n            <div class=\"pointer\"> </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/constants/fbMessenger.js":
/***/ (function(module, exports) {



/* Constants for FB messenger related components */
module.exports = {
  OVERRIDE_FBPP_REPEAT_FLAG: 'override_fbpp_repeat',
  OVERRIDE_FBPP_MOBILE_FLAG: 'override_fbpp_mobile',
  FB_BA_SHOWN_FLAG: 'is_xo_wps_fb_messenger_plugin_match_withba_shown',
  MOBILE_CHANNEL: 'MOBILE',
  WEB_CHANNEL: 'WEB',
  FB_USER_API_MOBILE_URL: 'https://m.facebook.com/paypal/user_identifier',
  FB_USER_API_URL: 'https://www.facebook.com/paypal/user_identifier',
  FB_PROD_APP_ID: '1084613224964631',
  FB_PROD_PAGE_ID: {
    US: '55982004572',
    AU: '171522459698178',
    CA: '164660263560926',
    GB: '167465479930420',
    HK: '575224445931086',
    JP: '252040838174046',
    NZ: '171522459698178',
    PH: '1895483750701842',
    SG: '1405303076421245',
    IL: '369238992488',
    CZ: '199396843578121',
    DE: '109838022384872',
    AT: '109838022384872',
    CH: '109838022384872',
    FR: '124143236317',
    IT: '198366693576785',
    BR: '170288122998781',
    ES: '244240615638886',
    MX: '42433532610',
    ZA: '388473619362',
    NL: '105370782861413',
    DK: '133211860117553',
    SE: '121404111292725',
    RU: '275216545856555',
    PL: '244706038980513',
    NO: '304581546592510',
    GR: '704200349634422',
    IN: '347199669139259',
    AE: '402374783229274',
    BH: '402374783229274',
    DZ: '402374783229274',
    EG: '402374783229274',
    JO: '402374783229274',
    KW: '402374783229274',
    MA: '402374783229274',
    OM: '402374783229274',
    QA: '402374783229274',
    SA: '402374783229274',
    TN: '402374783229274',
    YE: '402374783229274',
    AR: '474276366001351',
    CL: '474276366001351',
    CO: '474276366001351',
    CR: '474276366001351',
    DO: '474276366001351',
    EC: '474276366001351',
    PE: '474276366001351',
    UY: '474276366001351',
    VE: '474276366001351'
  }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/constants/wpsAutobilling.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.WPS_AUTOBILING_BILLING_PERIOD_TYPE = exports.WPS_AUTOBILING_BILLING_PERIOD = exports.WPS_AUTOBILING_BILLING_FREQUENCY = exports.WPS_AUTOBILING_BILLING_CYCLE = exports.CONTENT_KEY = void 0;
var CONTENT_KEY = exports.CONTENT_KEY = 'wpsSubscription.message.termsText';
var WPS_AUTOBILING_BILLING_PERIOD = exports.WPS_AUTOBILING_BILLING_PERIOD = 'MONTH';
var WPS_AUTOBILING_BILLING_PERIOD_TYPE = exports.WPS_AUTOBILING_BILLING_PERIOD_TYPE = 'REGULAR';
var WPS_AUTOBILING_BILLING_FREQUENCY = exports.WPS_AUTOBILING_BILLING_FREQUENCY = 1;
var WPS_AUTOBILING_BILLING_CYCLE = exports.WPS_AUTOBILING_BILLING_CYCLE = 'Infinity';

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _profilemanagement = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");
var _thirdPartyInfo = __webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/index.js");
var _index3 = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/utils/index.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/done/template.html"));
var _sanitizeCaja = _interopRequireDefault(__webpack_require__("../node_modules/sanitize-caja/index.js"));
__webpack_require__("../node_modules/xo-login-components/src/dolphin/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AUTORETURN_TIMEOUT = 5000;
// If the user returns into checkout, it causes errors since the checkout
// session is not what we'd expect it to look like. Rather than proofing our
// code against this, we will attempt to prevent navigation instead.
// Any valid routes should be added here
var WHITELISTED_ROUTES = ['checkout.end'];
(0, _angular.$registerDirective)('xo-done', function () {
  return {
    template: _template["default"],
    controller: ['$scope', function ($scope) {
      $scope.isGuestSignup = _angular.$rootScope.mode && _angular.$rootScope.mode === 'signup';
      $scope.locale = _squid.$locale;
      $scope.wpsVirtualCardRedirectUrl = _squid.$config.urls.wpsVirtualCardRedirectUrl;
      function addPageMessage(code) {
        var CONTENT_KEY_MAPPING = {
          NO_UPGRADE: 'accountUpgradeFailed'
        };
        if (code && CONTENT_KEY_MAPPING[code]) {
          $scope.errorMessage = {
            msgs: [_squid.$locale.content.get('done.' + CONTENT_KEY_MAPPING[code])],
            type: 'warning'
          };
        }
      }
      function isThirdPartyFlow() {
        return _thirdPartyInfo.thirdPartyExperience.isThirdPartyExperience(_angular.$rootScope.token);
      }
      function postMerchantSettingsRead() {
        // Set content key based on device
        $scope.autoReturnContentKey = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet() ? 'done.autoReturnStatement' : 'done.autoReturnStatementWeb';
        $scope.guestSignupKey = $scope.isGuestSignup ? 'done.paymentGuest' : 'done.payment';

        // control the virtual card banner for WPS using config
        if (_squid.$config.wpsVirtualCardBanner) {
          _logger.$logger.info('virtual_card_upsell_enabled');

          // if merchant not enabled auto return and buyer from US
          if (!$scope.isAutoReturn && (0, _squid.$feature)('wpsUpsellVirtualCard')) {
            _logger.$logger.info('virtual_card_eligible');
            $scope.showVirualCardBanner = true;
          } else {
            _logger.$logger.info('virtual_card_upsell_ineligible');
          }
        } else {
          _logger.$logger.info('virtual_card_upsell_disabled');
        }
        if (_uiRouter.$stateParams.code) {
          addPageMessage(_uiRouter.$stateParams.code);
        }
        var amount = $scope.checkoutSession.transactionDetails.amount.total;
        var code = $scope.checkoutSession.transactionDetails.amount.currency;
        $scope.formattedAmount = (0, _squid.formatCurrency)(amount, code);
        var itemList = $scope.checkoutSession.itemsList;
        itemList.forEach(function (item) {
          item.quantity = (0, _squid.formatQuantity)(item.quantity);
        });
      }
      (0, _squid.$populate)($scope, {
        checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token),
        checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token),
        checkoutCart: _index2.$CheckoutCartModel.instance($scope.token),
        payee: _index2.$CheckoutPayeeModel.instance($scope.token),
        auth: _auth.$AuthModel.instance($scope.token)
      }).then(function () {
        // populate fpti payload about facebook skip login
        if ($scope.auth.isFBSkipLogin()) {
          _logger.$logger.info('checkout_fpti', {
            'design': 'facebook_onetouch'
          });
        }

        // We need merchant display name (which can be undefined) to display in
        // merchant details section of the page
        $scope.merchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName();
        // We need non empty value for merchantDisplayName in #merchant-text tag
        $scope.nonEmptyMerchantDisplayName = $scope.checkoutAppData.getMerchantDisplayName({
          nonEmptyReturnValue: true
        });
        $scope.sanitizedMerchantBrandName = (0, _sanitizeCaja["default"])($scope.checkoutAppData.merchant.brand_name);
        /**
         * Caja Sanitization required to prevent XSS inserted through the return URL.
         * For more information, see Jira ticket: https://paypal.atlassian.net/browse/LI-28757
         * Additional santization is required to prevent XSS attack leveraging bind-html-compile directive.
         * For more information, see Jira ticket: https://paypal.atlassian.net/browse/LI-46460
         *
         * Enhanced fix to prevent case-sensitive bypass (e.g., BIND-HTML-COMPILE)
         * and other potential XSS vectors in return URLs.
         */
        var returnUrl = $scope.checkoutAppData.urls.return_url;
        if (returnUrl) {
          // Case-insensitive removal of bind-html-compile attributes
          var sanitizedUrl = (0, _sanitizeCaja["default"])(returnUrl).replace(/bind-html-compile\s*=\s*["'][^"']*["']/gim, '').replace(/ng-bind-html\s*=\s*["'][^"']*["']/gim, '').replace(/on\w+\s*=\s*["'][^"']*["']/gim, '') // Remove event handlers
          .replace(/javascript:/gim, '') // Remove javascript: URLs
          .replace(/<script[^>]*>.*?<\/script>/gim, ''); // Remove script tags

          // Additional validation - only allow safe protocols
          try {
            var url = new URL(sanitizedUrl);
            if (!['http:', 'https:'].includes(url.protocol)) {
              sanitizedUrl = '#'; // Fallback to safe URL
            }
          } catch (e) {
            // If URL parsing fails, it's likely malformed - use fallback
            sanitizedUrl = '#';
          }
          $scope.sanitizedReturnUrl = encodeURI(sanitizedUrl);
        } else {
          $scope.sanitizedReturnUrl = '';
        }
        if (_squid.$config.readMerchantPreferencesFromAppData === true || _squid.$config.readMerchantPreferencesFromAppData === 'true') {
          $scope.isAutoReturn = $scope.checkoutAppData.merchant_preferences && $scope.checkoutAppData.merchant_preferences.auto_return && $scope.checkoutAppData.merchant_preferences.auto_return.enabled;
          _logger.$logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
            return_url: $scope.sanitizedReturnUrl || 'not_available'
          });
          postMerchantSettingsRead();
          return;
        } else {
          return (0, _squid.$populate)($scope, {
            merchantPreferenceModel: _profilemanagement.$MerchantPreferenceModel.instance($scope.payee.merchant.id)
          }).then(function () {
            // Show auto return page when feature is enabled by merchant and txn
            $scope.isAutoReturn = $scope.merchantPreferenceModel.autoReturn();
            _logger.$logger.info('wps_autoreturn_' + ($scope.isAutoReturn ? 'enabled' : 'disabled'), {
              return_url: $scope.sanitizedReturnUrl || 'not_available',
              autoreturn_url: $scope.merchantPreferenceModel.returnUrl() || 'not_available'
            });
            postMerchantSettingsRead();
          });
        }
      }).then(function () {
        var pxpContext = _index3["default"].getMessengerPXPContext();
        _logger.$logger.info('pxp_xo_wps_fb_messenger_plugin ', pxpContext);

        // Skipping FB messenger experience if Venmo flow detected as this is only for PayPal users
        // Also not loading if merchant auto return is enabled

        if (!$scope.isAutoReturn && !isThirdPartyFlow()) {
          if (_index3["default"].isDolphinEligibleOnWpsDone(_uiRouter.$state.current && _uiRouter.$state.current.name)) {
            _logger.$logger.info('ul_dolphin', {
              'from': 'dolphin_elg_chk',
              'to': 'process_dolphin_elg_chk',
              'eligibility_reason': 'wps_done_flow',
              'context_id': _angular.$rootScope.token
            });
            $scope.isDolphinEligibleOnWpsDone = true;
          } else {
            var country = _squid.$locale.country;
            var _$scope$checkoutSessi = $scope.checkoutSession.payer,
              _$scope$checkoutSessi2 = _$scope$checkoutSessi === void 0 ? {} : _$scope$checkoutSessi,
              payerId = _$scope$checkoutSessi2.id;
            _logger.$logger.info('checkout_fpti', {
              buyer_country: country,
              buyer_id: payerId,
              design: 'fbmessenger',
              from: 'XO_SUCCESS',
              eligibility_reason: 'messenger'
            });
            $scope.pxpMessengerIntegrationEnabled = true;
          }
        }
        (0, _jquery["default"])('#outerWrapper').addClass('xo-done');
        $scope.expansion = false;
        $scope.toggle = function () {
          if ($scope.expansion === false) {
            $scope.maxHeight = document.getElementsByClassName('details-expand')[0].scrollHeight + 'px';
            $scope.expansion = true;
          } else {
            $scope.expansion = false;
          }
          return $scope.expansion;
        };
        $scope.autoReturnStatementClick = function (event) {
          event.preventDefault();
          if (event.target && event.target.nodeName === 'A') {
            _logger.$logger.info('autoreturn_statement_clicked');
            $scope.returnToMerchant();
          }
        };
        if ($scope.isAutoReturn) {
          _logger.$logger.info('autoreturn_to_merchant');
          (0, _angular.$timeout)($scope.returnToMerchant, AUTORETURN_TIMEOUT);
        }
      });
      $scope.$on('localeChange', function () {
        if (_uiRouter.$stateParams.code) {
          addPageMessage(_uiRouter.$stateParams.code);
        }
      });
      $scope.returnToMerchant = function () {
        _logger.$logger.info('return_to_merchant_clicked');
        return _uiRouter.$state.go('checkout.end');
      };
      var onExitListeners = function onExitListeners() {
        var removeClassListener = _angular.$rootScope.$on('$stateChangeSuccess', function (event, newState, newParams, oldState) {
          if (oldState.name === 'checkout.done') {
            (0, _jquery["default"])('#outerWrapper').removeClass('xo-done');
          }
        });
        var preventBackListener = _angular.$rootScope.$on('$stateChangeStart', function (event, newState) {
          if (!~WHITELISTED_ROUTES.indexOf(newState.name)) {
            _logger.$logger.info('done_page_prevent_routing', {
              to: newState.name
            });
            event.preventDefault();
            preventBackListener();
            return _uiRouter.$state.go('checkout.genericError', {
              code: 'PAYMENT_ALREADY_DONE'
            });
          }
        });
        return function () {
          removeClassListener();
          preventBackListener();
        };
      };
      $scope.$on('$destroy', onExitListeners());
    }]
  };
});
_uiRouter.$state;
_uiRouter.$stateParams;
_logger.$logger;
_index.$DeviceInfo;
_angular.$registerDirective;
_angular.$rootScope;
_angular.$timeout;
_squid.$config;
_squid.$locale;
_squid.$populate;
_squid.$feature;
_squid.formatCurrency;
_squid.formatQuantity;
_auth.$AuthModel;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutCartModel;
_index2.$CheckoutPayeeModel;
_index2.$CheckoutSessionModel;
_profilemanagement.$MerchantPreferenceModel;
_thirdPartyInfo.thirdPartyExperience;

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$DoneRoute = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-page-components/src/done/directive.js");
var $DoneRoute = exports.$DoneRoute = _squid.$ComponentRoute.extend('DoneRoute', {
  name: 'done',
  directive: 'xo-done',
  titleContent: 'done.paymentCompleted',
  query: ['code'],
  trackingData: {
    fptiState: 'done_page',
    templateName: 'memberDone.dust',
    pageGoal: 'Payment Done Receipt',
    trackStateExit: true,
    buzname: {
      'fullpage': {
        'pagename': '%::fullpage-done',
        'pagename2': '%::fullpage-done:member:hermes:',
        'version': 'member:%:'
      }
    }
  },
  children: []
});
angular.value("$DoneRoute", $DoneRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-page-components/src/done/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"xo-done-content\" content>\n    <xo-dolphin ng-if=\"isDolphinEligibleOnWpsDone\"></xo-dolphin>\n    <div ng-click=\"toggle()\" class=\"splash-receipt\" tabindex=\"-1\">\n        <div class=\"receipt basics\">\n            <div class=\"done\" id=\"circle\"></div>\n            <div id=\"paid-text\" bind-html-compile=\"htmlContent(guestSignupKey, {amt: formattedAmount})\"/>\n            <div id=\"merchant-text\">{{ content('done.payment_target', { merchantName: nonEmptyMerchantDisplayName }) }}</div>\n            <a id=\"details-text\" link-button href=\"#\" aria-expanded=\"{{expansion}}\">{{content('paymentMethod.msbDetails')}}</a>\n        </div>\n        <div class=\"details-expand\" ng-class=\"{ expansion : expansion}\" ng-style=\"expansion && {'max-height': maxHeight}\"\n            tabindex=\"-1\" focus-when=\"expansion\">\n            <div class=\"grouping\" ng-repeat=\"item in checkoutSession.itemsList track by $index\">\n                <div class=\"row\">\n                    <span class=\"ltrOverride\" directionality><span ng-if=\"item.quantity\">{{item.quantity}} x </span>{{item.name}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\" amount=\"item.price\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"item.sku\" class=\"item-number-container\">\n                    <span>\n                        <strong>{{ content('header.itemNumber') }}</strong> <span class=\"item-number\">{{ item.sku }}</span>\n                    </span>\n                </div>\n                <div ng-if=\"item.item_option_selections\" class=\"item-selections\">\n                    <span class=\"item-selection\" ng-repeat=\"selection in item.item_option_selections track by $index\">\n                        <strong class=\"item-selection-name\">{{ selection.name }}:</strong>\n                        <span class=\"item-selection-value\">{{ selection.select }}</span>\n                    </span>\n                </div>\n            </div>\n            <div class=\"grouping\">\n                <div ng-if=\"checkoutSession.transactionDetails.amount.subtotal\" class=\"row\">\n                    <span>{{content('header.subTotal')}}</span>\n                     <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.subtotal\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.tax\" class=\"row\">\n                    <span>{{content('header.tax')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.tax\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.shipping\" class=\"row\">\n                    <span>{{content('header.shipping')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.shipping\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.insurance\" class=\"row\">\n                    <span>{{content('header.insurance')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.insurance\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.handling_fee\" class=\"row\">\n                    <span>{{content('header.handling')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.handling_fee\">\n                        </format-currency>\n                    </span>\n                </div>\n                <div ng-if=\"checkoutSession.transactionDetails.amount.discount\" class=\"row\">\n                    <span>{{content('header.discount')}}</span>\n                    <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.discount\">\n                        </format-currency>\n                    </span>\n                </div>\n            </div>\n            <div class=\"row totalAmount\">\n                <b>\n                    <span>{{content('base.totalLabel')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"checkoutSession.transactionDetails.amount.currency\"\n                                         amount=\"checkoutSession.transactionDetails.amount.total\">\n                        </format-currency>\n                    </span>\n                </b>\n            </div>\n        </div>\n        <div id=\"details-button\">\n            <span ng-hide=\"!expansion\" class=\"arrow collapse\"></span>\n            <span ng-hide=\"expansion\" class=\"arrow expand\"></span>\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"checkoutSession.transactionDetails.reason_code === 'REGULATORY_REVIEW'\">\n        <div class=\"alert\" role=\"alert\">\n            {{content('done.temporarily_pending')}}\n        </div>\n    </div>\n    <div class=\"essentials\" ng-if=\"!isAutoReturn\">\n        <xo-message message=\"errorMessage\"></xo-message>\n\n        <div id=\"messenger-ba-integration\" ng-if=\"pxpMessengerIntegrationEnabled\">\n          <div id=\"messenger-ba-integration-content\" style=\"display:none\">\n            <div class=\"text\">{{ content('messenger.integration') }}</div>\n          </div>\n          <div id=\"ba-integration-content\" style=\"display:none\">\n            <div class=\"receipt title\">{{ content('messenger.linkedTitle') }}</div>\n            <div class=\"text\">{{ content('messenger.linkedSubtitle') }}</div>\n          </div>\n          <div id=\"stm-upsell-content\" class=\"text\">{{ content('messenger.upsell') }}</div>\n          <xo-messenger-plugin plugin-type=\"STM\" token=\"token\"></xo-messenger-plugin>\n        </div>\n\n        <h2 ng-if=\"checkoutSession.plan.sources.length > 0\" class=\"receipt title\">{{content('done.paidWith')}}</h2>\n        <div ng-repeat=\"item in checkoutSession.plan.sources track by $index\">\n            <div class=\"row clearfix\">\n                <span class=\"money-source\" ng-if=\"!ppBalanceRebrandedExperiment || !ppBalanceRebrandedExperiment.enabled || item.type !== 'BALANCE'\">{{content('fsMappings.'+item.type) || item.name}} <span ng-if=\"item.last4\">x-</span>{{item.last4}}</span>\n                <span class=\"money-source\" ng-if=\"ppBalanceRebrandedExperiment && ppBalanceRebrandedExperiment.enabled && item.type === 'BALANCE'\">{{content('paymentMethod.paypalBalanceRebranded')}}</span>\n                <span class='amount'>\n                        <format-currency code=\"item.amount.currency_code\"\n                                         amount=\"item.amount.amount\">\n                        </format-currency>\n                </span>\n            </div>\n        </div>\n        <div ng-if=\"checkoutSession.transactionDetails.soft_descriptor\" class=\"secondary receipt statement\">{{content('done.transactionInformation', {merchantName: checkoutSession.transactionDetails.soft_descriptor})}}\n        </div>\n        <h2 ng-if=\"checkoutSession.shipping\" class=\"receipt title\">{{content('done.shippedTo')}}</h2>\n        <div class=\"text\" ng-if=\"!checkoutCart.isShippingMethodStorePickUp()\">\n            <div ng-if=\"checkoutSession.shipping.name\">{{checkoutSession.shipping.name}}</div>\n            <ul class=\"multilineAddressList\">\n                <li ng-repeat=\"item in checkoutSession.shipping.full_address_multiline track by $index\" directionality-text=\"item\">{{item}}</li>\n            </ul>\n            <div><span>{{content('countryList.'+checkoutSession.shipping.country)}}</span></div>\n        </div>\n        <div class=\"text\" ng-if=\"checkoutCart.isShippingMethodStorePickUp()\">\n            <div class=\"storeLocation\" >{{ content('shippingMethod.storeLocation') }}</div>\n            <p class=\"storeLocationInfo\">{{ content('shippingMethod.storeLocationInfo') }}</p>\n        </div>\n        <h2 class=\"receipt title\">{{content('done.purchaseDetails')}}</h2>\n        <div id=\"receiptNumber\"> {{content('done.receiptNumber')}} {{checkoutSession.transactionDetails.receipt_id}}</div>\n        <div class=\"text\">\n            <div>{{content('done.confirmation')}}</div>\n            <div id=\"buyerEmail\">{{checkoutSession.payer.email}}</div>\n        </div>\n\n        <div ng-if=\"merchantDisplayName || checkoutAppData.merchant.phone\">\n            <h2 text-align=\"left\" class=\"receipt title\">{{content('done.merchantDetails')}}</h2>\n            <div class=\"text\" id=\"merchantInfoSection\">\n                <div ng-if=\"merchantDisplayName\"><span directionality-text=\"merchantDisplayName\">{{ merchantDisplayName }}</span></div>\n                <div ng-if=\"checkoutAppData.merchant.phone\">{{checkoutAppData.merchant.phone}}</div>\n            </div>\n        </div>\n\n        <div ng-if=\"checkoutAppData.urls.return_url\" id=\"button\" class=\"buttons reviewButton\">\n            <input track-submit type=\"submit\" value=\"{{content('common.returnToDefaultMerchant')}}\" id=\"merchantReturnBtn\"\n                   class=\"btn btn-secondary full submit receipt ng-binding ng-scope\" ng-click=\"returnToMerchant()\" />\n        </div>\n    </div>\n    <div class=\"essentials autoReturnSection\" ng-if=\"isAutoReturn\">\n        <div>{{content('done.paymentCompleted')}}</div>\n        <div ng-click=\"autoReturnStatementClick($event)\" data-test-id=\"autoreturn-link\">\n            <span>{{content(autoReturnContentKey, {merchantName: sanitizedMerchantBrandName})}}</span>\n            <a ng-href=\"{{sanitizedReturnUrl}}\" ng-if=\"sanitizedReturnUrl\">{{sanitizedReturnUrl}}</a>\n        </div>\n    </div>\n\n    <div class=\"blockContainer\" ng-if=\"showVirualCardBanner\">\n        <div class=\"keyImage\"></div>\n        <div class=\"textContainer\">\n            <p class=\"headingText\">{{content('done.virtualCardBanner')}}</p>\n            <a ng-href=\"{{wpsVirtualCardRedirectUrl}}\" class=\"btn payButtonKey\" target=\"_blank\">{{content('done.virtualCardLabel')}}</a>\n        </div>\n    <div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/cycoExitFactory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var POPUP_WIDTH = 560;
var POPUP_HEIGHT = 550;
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().factory('$cycoExitFactory', function () {
  // exported factory functions go in this object
  var factory = {};

  // state variables
  var onCycoPage = false;
  var shouldShowPopup = false;
  var cycoInitTime = Date.now();

  // This function should be called when we enter the cyco page.
  // It will make an elmo call, and set the `shouldShowPopup` variable based on
  // whether or not you are in the control or treatment experience. It will also
  // set the `onCycoPage` to true.
  factory.cycoEnter = function (merchantCountry) {
    onCycoPage = true;
    cycoInitTime = Date.now();
    return (0, _squid.$elmo)('xo_hermes_cyco_cancel_feedback', {
      'ctx.COUNTRY': merchantCountry
    }, 'Trmt_xo_hermes_cyco_cancel_feedback_.*', false, true).then(function (res) {
      var treatmentName = res && res.treatment_name;
      _logger.$logger.info('checkout_fpti', {
        'xo_hermes_cyco_cancel_feedback': treatmentName ? treatmentName : 'Ctrl_xo_hermes_cyco_cancel_feedback'
      });
      shouldShowPopup = treatmentName ? true : false;
    })["catch"](_angular.noop);
  };

  // This function should be called when we exit the cyco page.
  // It will reset the `onCycoPage` and `shouldShowPopup` variables to false.
  factory.cycoExit = function () {
    onCycoPage = false;
    shouldShowPopup = false;
  };

  // We call this function in the footer, and on certain links on the
  // xo-credit-component CYCO page
  factory.showExitSurvey = function () {
    var exitSurveyShown = false;
    try {
      // we only show the opinionlab exit survey if we are on the cyco page, 
      // and in the correct treatment
      if (onCycoPage && shouldShowPopup) {
        var _sW = window.screen.width;
        var _sH = window.screen.height;
        var countryCode = ("" + _squid.$locale.country).toLowerCase();
        var languageCode = ("" + _squid.$locale.lang).toLowerCase();
        var userGuid = _squid.$util.getProperty(window.meta, 'userGuid') || 'Unknown';
        var customVars = {
          guid: userGuid,
          tealeafId: userGuid,
          fptiPageGroup: 'main:ec:hermes::choose_credit_offer:member:hermes:',
          fptiPagename: 'main:ec:hermes::choose_credit_offer:member:hermes:',
          rlogId: _squid.$util.getProperty(window.meta, 'rlogId') || 'Unknown',
          calc: _squid.$util.getProperty(window.meta, 'correlationId') || 'Unknown',
          merchantId: _squid.$util.getProperty(window.meta, 'checkoutCTX.merchant_id') || 'Unknown',
          token: _squid.$util.getProperty(window.meta, 'token') || 'Unknown',
          countryCode: countryCode,
          languageCode: languageCode
        };
        var showCycoOpinionUrl = _squid.$util.buildURL('https://secure.opinionlab.com/ccc01/comment_card.asp', {
          width: _sW,
          height: _sH,
          referer: "https://surveys.paypal.com/" + countryCode + "/" + languageCode + "/CycoPageExit",
          prev: document.referrer,
          time1: cycoInitTime,
          time2: Date.now(),
          currentURL: document.location.href,
          type: 'Popup',
          custom_var: userGuid,
          customVars: JSON.stringify(customVars)
        });
        _logger.$logger.info('checkout_fpti', {
          from: 'elmo_showCycoOpinionUrl',
          to: showCycoOpinionUrl
        });
        window.open(showCycoOpinionUrl, 'comments', "width=" + POPUP_WIDTH + ",height=" + POPUP_HEIGHT + ",screenX=" + (_sW - POPUP_WIDTH) / 2 + ",screenY=" + (_sH - POPUP_HEIGHT) / 2 + ",top=" + (_sH - POPUP_HEIGHT) / 2 + ",left=" + (_sW - POPUP_WIDTH) / 2 + ",resizable=yes,copyhistory=yes,scrollbars=no");
        exitSurveyShown = true;
      }
    } catch (err) {
      _logger.$logger.error('choose-credit-offer: showCycoOpinion error', {
        error: err
      });
    }
    return exitSurveyShown;
  };
  return factory;
});
_logger.$logger;
_squid.$locale;
_squid.$util;
_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/footer", "../node_modules/xo-page-components/src/footer/cycoExitFactory.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index5 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/modal/directive.js");
var _footerMap = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/footer/footerMap.js"));
var _opinionlab = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/footer/opinionlab.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/footer/template.html"));
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _cycoExitFactory = __webpack_require__("../node_modules/xo-page-components/src/footer/cycoExitFactory.js");
var _factory = __webpack_require__("../node_modules/xo-page-components/src/footer/factory.js");
__webpack_require__("../node_modules/xo-page-components/src/footer/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('xoFooter', function () {
  return {
    template: _template["default"],
    restrict: 'EA',
    scope: {
      token: '=?',
      escapeHatchIncontext: '=?',
      cancel: '@?',
      merchant: '@?',
      languageSwitch: '=?',
      showVenmoLegalLinks: '=?',
      policyInformationContentKey: '=?'
    },
    controller: ['$scope', function ($scope) {
      $scope.isIFrame = _squid.$util.isIFrame();
      if ($scope.escapeHatchIncontext) {
        $scope.showEscapeHatch = $scope.isIFrame;
      }
      $scope.locale = _squid.$locale;
      $scope.proxSignUpFlow = _index4.$CheckoutInputDataModel.instance($scope.token).isEbayTxn();
      $scope.year = new Date().getFullYear();

      // Determine if country belongs to a region to serve correct footer links
      var getRegion = function getRegion(country) {
        var regions = _squid.$config.regions;
        for (var region in regions) {
          if (regions[region].indexOf(country) > -1) {
            return region;
          }
        }
        return false;
      };
      function isDESecondButtonFlow() {
        return $scope.locale.country === 'DE' && $scope.checkoutAppData && $scope.checkoutAppData.is_second_button_txn;
      }
      $scope.getPolicyInformationContentKey = function () {
        return $scope.policyInformationContentKey;
      };
      $scope.footerLinks = function () {
        if (_factory.$footerFactory.isApac()) {
          return _footerMap["default"].APAC;
        }

        // It is a product requirement that for the DE CYCO page, Hermes only show the footer links
        // that were available in Aries
        if (isDESecondButtonFlow()) {
          return _footerMap["default"]['DESecondButton'];
        }
        return _footerMap["default"][$scope.locale.country] || _footerMap["default"][getRegion($scope.locale.country)] || _footerMap["default"].DEFAULT;
      };
      $scope.showPolicyInfo = function () {
        return _factory.$footerFactory.isApac() || _factory.$footerFactory.is3PL() || $scope.locale.country === 'AU';
      };
      $scope.cancelRedirect = function ($event) {
        $event.preventDefault();

        // if a user is on the CYCO page, we show an opinionlab exit survey based on
        // whether or not they are in the xo_hermes_cyco_cancel_feedback elmo treatment.
        var surveyShown = _cycoExitFactory.$cycoExitFactory.showExitSurvey();
        _logger.$logger.info("cyco_exit_surveyShown_" + Boolean(surveyShown));
        var cancelUri = $scope.cancel;
        var redirectUri = _squid.$util.param('redirect_uri');
        if (window.xprops && window.xprops.onCancel && !cancelUri) {
          return window.xprops.onCancel({
            orderID: $scope.token
          });
        }

        // "redirect_uri" as a query param overrides the cancel url in the checkout session
        if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && redirectUri) {
          cancelUri = _squid.$util.buildURL(redirectUri, {
            opType: 'cancel',
            return_uri: $scope.cancel,
            token: $scope.token
          });
        }
        _index5.$ReturnToMerchant.goTo(cancelUri);
      };
      if ($scope.token) {
        (0, _squid.$populate)($scope, {
          checkoutAppData: _index3.$CheckoutAppDataModel.instance($scope.token),
          checkoutPayee: _index3.$CheckoutPayeeModel.instance($scope.token),
          checkoutCart: _index3.$CheckoutCartModel.instance($scope.token),
          auth: _index2.$AuthModel.instance()
        }).then(function () {
          return _factory.$footerFactory.decidePolicyInformationContentKey($scope.auth);
        }).then(function (policyInformationContentKey) {
          $scope.policyInformationContentKey = policyInformationContentKey;
          var payee = $scope.checkoutPayee;
          if (payee && payee.merchant && payee.merchant.id) {
            var hcl = _squid.$config.hideCancelLinkForMerchant;
            var shouldHide = hcl && hcl.indexOf(payee.merchant.id) !== -1;
            if (shouldHide) {
              $scope.hideCancel = true;
            }
          }
          $scope.cancel = $scope.checkoutAppData.urls.cancel_url;
          var billingData = $scope.checkoutCart.billing || {};
          if (billingData.intent === 'VAULT') {
            var originalCancelUrl = $scope.checkoutAppData.urls.original_urls.cancel_url;
            var vaultCancelParams = {
              approval_token_id: billingData.vault_approval_token_id,
              approval_session_id: billingData.vault_approval_session_id
            };
            $scope.cancel = originalCancelUrl ? _squid.$util.buildURL(originalCancelUrl, vaultCancelParams) : originalCancelUrl;
          }
          $scope.merchant = $scope.checkoutAppData.getMerchantDisplayName();
        });
      }
      var cancelShowModal = _angular.$rootScope.$on('showModal', function (event, ctx) {
        var url = ctx && ctx.popupUrl;
        _logger.$logger.info('show_popup_modal', {
          url: url,
          ua: _angular.$window.navigator.userAgent
        });
        $scope.popupUrl = _angular.$sce.trustAsResourceUrl(url);
        $scope.show = true;
        $scope.$digest(); // eslint-disable-line angular/ng_no_digest
      });

      // for webkit webview (wkwebview) on ios devices, we need to open footer
      // policies/terms links in a modal window as wkwebview blocks anchor tags
      // with target _blank from loading
      $scope.openLinkInModalIfWebview = function (event) {
        // if webview then open the link in a modal window
        if (_index.$DeviceInfo.isWebView()) {
          event.preventDefault();
          var url = event.target.href;
          _logger.$logger.info('show_popup_modal_footer_links', {
            url: url
          });
          $scope.popupUrl = _angular.$sce.trustAsResourceUrl(url);
          // As this code is only for webviews, we are going fullscreen
          // with css class - fullsize-modal
          $scope.fullsizeModal = true;
          $scope.show = true;
        }
      };
      $scope.hideModal = function () {
        _logger.$logger.info('hide_popup_modal');
        $scope.show = false;
        $scope.fullsizeModal = false;
      };
      $scope.$on('localeChange', function () {
        _factory.$footerFactory.decidePolicyInformationContentKey($scope.auth).then(function (policyInformationContentKey) {
          $scope.policyInformationContentKey = policyInformationContentKey;
        });
      });
      $scope.$on('$destroy', cancelShowModal);
      $scope.showOL = function showOL(event) {
        event.preventDefault();
        var placeholder = 'main:ec:hermes';
        var page = _uiRouter.$state.current.get('trackingData.buzname.fullpage.pagename2', 'unknown').replace('%', placeholder);
        var data = {
          opVars: {
            rlogId: _angular.$window.meta.rlogId || '',
            page: page || window.location.hash,
            csci: 'Unknown',
            calc: _angular.$window.meta.correlationId,
            custId: 'Unknown',
            merchantId: 'Unknown',
            token: $scope.token || 'Unknown'
          },
          locale: {
            country: _squid.$locale.country,
            languageCode: _squid.$locale.lang + "_" + _squid.$locale.country
          }
        };
        (0, _opinionlab["default"])(data);
      };
      $scope.hideReturnCancelUrl = function () {
        if (window.xprops && window.xprops.onCancel) {
          return false;
        }
        if (!$scope.cancel) {
          return true;
        }
        if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.done') {
          return true;
        }
        return false;
      };
      $scope.showVenmoLinks = function () {
        // if on payWithSelection State, always show it, else we choose whatever 'checkout' directive says.
        if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
          return true;
        }
        return !!$scope.showVenmoLegalLinks;
      };
      $scope.showPaypalLinks = function () {
        // will force Paypal Links if on payWithSelection state. Hide paypal links if we explicitly request venmo Links
        if (_uiRouter.$state.current && _uiRouter.$state.current.name === 'checkout.payWithSelection') {
          return true;
        }
        return !$scope.showVenmoLegalLinks;
      };
    }]
  };
});
_uiRouter.$state;
_angular.$window;
_angular.$rootScope;
_angular.$sce;
_squid.$config;
_squid.$util;
_squid.$locale;
_squid.$populate;
_squid.$integration;
_index.$DeviceInfo;
_index2.$AuthModel;
_index3.$CheckoutAppDataModel;
_index3.$CheckoutPayeeModel;
_index3.$CheckoutCartModel;
_index4.$CheckoutInputDataModel;
_index5.$ReturnToMerchant;
_logger.$logger;
_cycoExitFactory.$cycoExitFactory;
_factory.$footerFactory;

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/factory.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().factory('$footerFactory', function () {
  function isIndiaLegalEntity(auth) {
    // for PayPal India domestic launch legal entity should be 84
    // update footer with indian policy for this case
    return auth && auth.logged_in && auth.legalEntity === 84 || _squid.$locale.country === 'IN';
  }
  function is3PL() {
    return _squid.$config.threePLCountries && _squid.$config.threePLCountries.indexOf(_squid.$locale.country.toUpperCase()) > -1;
  }
  function isApac() {
    return _squid.$config.apacCountries && _squid.$config.apacCountries.indexOf(_squid.$locale.country) > -1;
  }
  ;
  function decidePolicyInformationContentKey(auth) {
    return (0, _squid.$elmo)('xo_legacy_3pl_issued_license_update', {
      'ctx.COUNTRY': _squid.$locale.country
    }, 'Trmt_xo_legacy_3pl_issued_license_update_1').then(function (result) {
      var enabled = Boolean(result && result.treatment_name);
      if (enabled) {
        return 'footer.issued3plLicensePH';
      }
      if (isIndiaLegalEntity(auth)) {
        return 'footer.4plpolicyInformation';
      }
      if (is3PL()) {
        // Ramped to 100% since July 2023. Previous key footer.3plPolicyInformation is now replaced
        // Elmos have been removed and now we will always see the new key:
        // Key footer.issued3plLicense states that the legal license is already issued and live.
        return 'footer.issued3plLicense';
      }
      return 'footer.policyInformation';
    });
  }
  return {
    decidePolicyInformationContentKey: decidePolicyInformationContentKey,
    is3PL: is3PL,
    isApac: isApac
  };
});
_squid.$config;
_squid.$locale;
_squid.$elmo;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-page-components/src/footer", "../node_modules/xo-page-components/src/footer/factory.js"))

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/footerMap.js":
/***/ (function(module, exports, __webpack_require__) {



!(module.exports = {
  CA: [{
    id: 'policy',
    content: 'footer.policiesCA'
  }, {
    id: 'terms',
    content: 'footer.termsCA'
  }, {
    id: 'privacy',
    content: 'footer.privacyCA'
  }],
  BE: [{
    id: 'legal',
    content: 'footer.legal'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  DE: [{
    id: 'imprint',
    content: 'footer.DEImprint'
  }, {
    id: 'legal',
    content: 'footer.DELegal'
  }, {
    id: 'privacy',
    content: 'footer.DEPrivacy'
  }, {
    id: 'paymentdesc',
    content: 'footer.DEKeyPaymentDesc'
  }],
  ES: [{
    id: 'legal',
    content: 'footer.legal'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  FR: [{
    id: 'legal',
    content: 'footer.FRLegal'
  }, {
    id: 'useragreement',
    content: 'footer.FRUserAgreement'
  }, {
    id: 'privacy',
    content: 'footer.FRPrivacy'
  }],
  IT: [{
    id: 'legal',
    content: 'footer.legal'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  NL: [{
    id: 'legal',
    content: 'footer.legal'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  IE: [{
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'useragreement',
    content: 'footer.userAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  APAC: [{
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'useragreement',
    content: 'footer.userAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  EMEA: [{
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'useragreement',
    content: 'footer.userAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  EM: [{
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'useragreement',
    content: 'footer.userAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  LATAM: [{
    id: 'help',
    content: 'footer.help'
  }, {
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  AU: [{
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  AT: [{
    id: 'imprint',
    content: 'footer.ATImprint'
  }, {
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  CH: [{
    id: 'imprint',
    content: 'footer.CHImprint'
  }, {
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  DK: [{
    id: 'useragreement',
    content: 'footer.DKUserAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  SE: [{
    id: 'useragreement',
    content: 'footer.SEUserAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  PL: [{
    id: 'useragreement',
    content: 'footer.PLUserAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  NO: [{
    id: 'useragreement',
    content: 'footer.NOUserAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  TR: [{
    id: 'useragreement',
    content: 'footer.TRUserAgreement'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  BR: [{
    id: 'help',
    content: 'footer.help'
  }, {
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  MX: [{
    id: 'help',
    content: 'footer.help'
  }, {
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  RU: [{
    id: 'terms',
    content: 'footer.terms'
  }, {
    id: 'privacy',
    content: 'footer.privacy'
  }],
  DESecondButton: [{
    id: 'imprint',
    content: 'footer.DEImprint'
  }, {
    id: 'privacy',
    content: 'footer.DEPrivacy'
  }],
  DEFAULT: [{
    id: 'policy',
    content: 'footer.policies',
    venmoContent: 'footer.venmo_policies'
  }, {
    id: 'terms',
    content: 'footer.terms',
    venmoContent: 'footer.venmo_terms'
  }, {
    id: 'privacy',
    content: 'footer.privacy',
    venmoContent: 'footer.venmo_privacy'
  }]
});

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/opinionlab.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  var _doc = document;
  var _w = window;
  var _tm = new Date().getTime();
  var _sH = screen.height;
  var _ht = escape(_w.location.href); // eslint-disable-line block-scoped-var,no-undef
  var _hr = escape(_doc.referrer); // eslint-disable-line block-scoped-var,no-undef
  var _sW = screen.width;
  function popUp(opinionlabURL) {
    _w.open(opinionlabURL, 'comments', 'width=535,height=192' + ',screenX=' + (_sW - 535) / 2 + ',screenY=' + (_sH - 192) / 2 + ',top=' + (_sH - 192) / 2 + ',left=' + (_sW - 535) / 2 + ',resizable=yes' + ',copyhistory=yes' + ',scrollbars=no');
  }
  function updateCustomVars(data) {
    var opVars = data.opVars;
    var locale = data.locale;
    _ht = 'https://' + locale.country + '.paypal.com/' + locale.languageCode + '/00/' + escape(opVars.page.replace(/\s|\//g, '_')) + '.page'; // eslint-disable-line block-scoped-var,no-undef

    var customVar = (opVars.rlogId || opVars.calc) + '|' + opVars.csci + '|' + opVars.page + '|' + locale.country + '|' + locale.languageCode + '|' + opVars.custId + '|' + opVars.merchantId + '|' + opVars.token + '|' + 'Unknown';
    return customVar;
  }
  function _fC(_u) {
    var _sp = '%3A\\/\\/';
    var _rp = '%3A//';
    var _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F';
    var _aA = _aT.split(',');
    for (var i = 0; i < 5; i++) {
      eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])'); // eslint-disable-line no-eval
    }
    return _u;
  }
  return function (locale) {
    var custom_var = updateCustomVars(locale);
    var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' + 'time1=' + _tm + '&time2=' + new Date().getTime() + '&prev=' + _fC(_hr) + '&referer=' + _fC(_ht) + '&height=' + _sH + '&width=' + _sW + '&custom_var=' + custom_var;
    popUp(opinionlabURL);
  };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/footer/template.html":
/***/ (function(module, exports) {

module.exports = "<footer content>\n    <div class=\"footer clearfix commonFooter\" ng-class=\"{APAC: isApac()}\">\n        <p ng-if=\"!hideCancel\" id=\"defaultCancelLink\" class=\"cancelUrl\">\n            <a track-link=\"cancel_and_return_to_merchant\" href=\"{{cancel || '#'}}\" ng-click=\"cancelRedirect($event)\" role=\"button\" id=\"cancelLink\" ng-hide=\"hideReturnCancelUrl()\">\n               <span ng-bind-html=\"merchant ? content('base.cancelUrl', { merchantName: merchant, modelName: 'merchant' }) : content('common.cancelAndReturnToMerchant')\"></span>\n            </a>\n        </p>\n\n        <div class=\"footerWrapper\">\n            <ul class=\"footerLinks\" ng-if=\"showPaypalLinks()\">\n                <li ng-click=\"openLinkInModalIfWebview($event)\" ng-repeat=\"link in footerLinks() track by $index\" id =\"footer_{{link.id}}\" bind-html-compile=\"htmlContent(link.content, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n            </ul>\n            <ul class=\"footerLinks\" ng-if=\"showVenmoLinks()\">\n                <li ng-click=\"openLinkInModalIfWebview($event)\" ng-repeat=\"link in footerLinks() track by $index\" id =\"venmoFooter_{{link.id}}\" bind-html-compile=\"htmlContent(link.venmoContent, {country: locale.country.toLowerCase(), lang: locale.lang})\"></li>\n            </ul>\n            <p class=\"copyright\">\n                {{ content('footer.copyright', {year: year}) }}\n                <span class=\"secureIcon\"></span>\n                <span class=\"accessAid\">{{ content('memberReview.propHead') }}</span>\n            </p>\n\n            <xo-language-options direction=\"top\" ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n        </div>\n\n        <div class=\"policyInfoWrapper\" ng-if=\"showPolicyInfo()\">\n            <p class=\"moreInfo\" ng-bind-html=\"htmlContent(getPolicyInformationContentKey(), {country: locale.country})\"> </p>\n            <p class=\"moreCopyRight\" ng-if=\"locale.country === 'AU'\">{{ content('footer.moreCopyright', {year: year}) }}</P>\n        </div>\n\n    </div>\n    <xo-modal\n        ng-attr-id=\"{{(fullsizeModal ? 'fullsize' : 'responsive') + '-modal'}}\"\n        ng-if=\"show\" show=\"show\" enable-mobile-interstitial=\"true\"\n        show-close-button=\"true\" on-close=\"hideModal\" override-default-container=\"fullsizeModal\">\n        <div class=\"popupModalContainer\">\n            <iframe src=\"{{popupUrl}}\" class=\"popupModal\" frameborder=\"0\"></iframe>\n        </div>\n    </xo-modal>\n</footer>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$gdprCookieBannerComponent = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/template.html"));
__webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * General Data Protection Regulation (GDPR) defines standards on how personal data is collected, processed, transferred and disposed.
 * Affected Countries: All "GDPR" countries: Please check config.json for country list.
 * Wiki: https://github.paypal.com/Checkout-R/xoonboardingnodeweb/wiki/GDPR:-Feature,-Integration-documentation
 */

var $gdprCookieBannerComponent = exports.$gdprCookieBannerComponent = _squid.$Component.extend('$gdprCookieBanner', {
  tag: 'xo-gdpr-cookie-banner',
  template: _template["default"],
  actions: {
    // Fetch the GDPR banner, append to DOM if available
    refreshGDPR: function refreshGDPR() {
      var _this = this;
      var gdprModel = _gdprCookieBanner.$GDPRCookieBannerModel.instance();
      return gdprModel.getBanner().then(function (banner) {
        if (banner === void 0) {
          banner = {};
        }
        // Run cleanup once we know the result, to prevent screen flash
        _this.actions.cleanup();
        var _banner = banner,
          html = _banner.html,
          css = _banner.css,
          js = _banner.js;
        if (!html || !css || !js) {
          return;
        }
        var div = angular.element(html);
        var style = angular.element(css);
        var script = angular.element(js);

        // setting nonce value from client app if provided,
        if (_squid.$meta && _squid.$meta.nonce) {
          script.attr('nonce', _squid.$meta.nonce);
        }
        var el = _this.$element.find('#gdpr-cookie-banner-outerwrap');
        el.append(style);
        el.append(div);
        el.append(script);
        if (!(0, _angular.isFunction)(window.bindGdprEvents)) {
          _logger.$logger.error('gdpr_banner_bindGdprEvents_not_defined');
          return;
        }

        // TODO: Remove this class add when cookie banner script is fixed to add this class properly
        angular.element(document.body).addClass('gdprCookieBanner-acceptedAll');
        window.bindGdprEvents();
      });
    },
    // Clear out the banner container to remove the old elements
    cleanup: function cleanup() {
      var el = this.$element.find('#gdpr-cookie-banner-outerwrap');
      el.empty();
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this2 = this;
      this.actions.refreshGDPR();

      // On "localeChange" we are re-fetching data.
      this.$on('localeChange', function () {
        _this2.actions.refreshGDPR();
      });
    }
  }
});
angular.value("$gdprCookieBannerComponent", $gdprCookieBannerComponent);
_squid.$Component;
_squid.$meta;
_angular.isFunction;
_gdprCookieBanner.$GDPRCookieBannerModel;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/gdprCookieBanner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"gdpr-cookie-banner-outerwrap\"></div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$SetHeaderText = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/language-options/directive.js");
__webpack_require__("../node_modules/xo-page-components/src/cart/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/header/template.html"));
__webpack_require__("../node_modules/xo-page-components/src/header/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var headerText = '';
var $SetHeaderText = exports.$SetHeaderText = {
  setText: function setText(text) {
    headerText = text;
    _angular.$rootScope.$emit('update_header_text', text);
  },
  getText: function getText() {
    return headerText;
  },
  subscribe: function subscribe($scope, callback) {
    var handler = _angular.$rootScope.$on('update_header_text', callback);
    $scope.$on('$destroy', handler);
  }
};
angular.module().directive('xoHeader', function () {
  return {
    template: _template["default"],
    scope: {
      showCartTotal: '=?',
      renderCartContainer: '=?',
      token: '=?',
      isUnbranded: '=?',
      unbrandedTitle: '=?',
      unbrandedSubTitle: '=?',
      languageSwitch: '=?',
      redirectiframe: '=?',
      redirectLightbox: '=?',
      isVenmoFlow: '=?'
    },
    controller: ['$scope', function ($scope) {
      var _ref = window.xprops || {},
        _ref$experience = _ref.experience,
        experience = _ref$experience === void 0 ? {
          facebook: false
        } : _ref$experience;

      // Callback-integrated merchants should have a breakdown available in their flow
      $scope.enableCartBreakdown = Boolean(window.xprops && window.xprops.onShippingChange);
      $scope.isFacebookBAIntegration = experience.facebook;
      $scope.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
      $scope.isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
      $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
      $scope.subTitle = (0, _squid.$renderContent)($scope.unbrandedSubTitle);
      $SetHeaderText.subscribe($scope, function (event, text) {
        $scope.unbrandedTitle = text;
        $scope.title = (0, _squid.$renderContent)($scope.unbrandedTitle);
      });
    }]
  };
});
angular.value("$SetHeaderText", $SetHeaderText);
_angular.$rootScope;
_squid.$integration;
_squid.$renderContent;
_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/header/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"row-fluid paypalHeaderWrapper\" ng-class=\"{ 'langDropdown': languageSwitch && languageSwitch.show }\" content>\n    <div class=\"span14 clearfix paypalHeader\">\n        <div id=\"mobileMerchantHeader\">\n            <xo-merchant-header token=\"token\" disable-id=\"true\"></xo-merchant-header>\n        </div>\n        <span class=\"pageTitle\" ng-if=\"unbrandedTitle\">{{title}}</span>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && !isVenmoFlow\" id=\"paypalLogo\" class=\"logo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n        <div ng-if=\"!isMessengerBAIntegration && !isUnbranded && isVenmoFlow\" class=\"venmoLogo\"><span class=\"accessAid\">Venmo Checkout</span></div>\n        <div ng-if=\"isFacebookBAIntegration\" class=\"ng-scope facebookPayPalHeader\">\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/paypal_monogram_logo.png\" class=\"facebookPayPalHeader-logo\" alt=\"PayPal\">\n            <span class=\"facebookPayPalHeader-separator\"></span>\n            <img ng-src=\"https://www.paypalobjects.com/images/shared/facebook_logo.svg\" class=\"facebookPayPalHeader-logo\" alt=\"Facebook\">\n        </div>\n        <div ng-if=\"!isFacebookBAIntegration && isMessengerBAIntegration\">\n            <div ng-if=\"isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_mobile_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n            <div ng-if=\"!isMobile\">\n                <img ng-src=\"https://www.paypalobjects.com/images/checkout/hermes/PP_Messenger_logo_lockup_2x.png\" class=\"messengerLogo\" width=\"50%\" height=\"50%\" alt=\"PayPal and Messenger\">\n            </div>\n        </div>\n\n        <xo-cart\n            token=\"token\"\n            override-show-details=\"enableCartBreakdown\"\n            show-cart-total=\"showCartTotal\"\n            render-cart-container=\"renderCartContainer\"\n        ></xo-cart>\n\n        <xo-language-options ng-if=\"languageSwitch && languageSwitch.show\"></xo-language-options>\n\n        <div class=\"subTitle\" ng-if=\"unbrandedSubTitle\">{{subTitle}}</div>\n        <xo-close-frame redirectiframe=\"redirectiframe\" redirect-lightbox=\"redirectLightbox\"></xo-close-frame>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/installmentplan-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _installmentPlanTerms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/installmentplan-terms/installmentPlanTerms.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
module.exports = {
  getItemName: _installmentPlanTerms["default"].getItemName,
  getInstallmentPlanData: _installmentPlanTerms["default"].getInstallmentPlanData
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/installmentplan-terms/installmentPlanTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _require = __webpack_require__("../node_modules/lodash/lodash.js"),
  get = _require.get;
var BILL_PERIOD_DAY = 'DAY';
var BILL_PERIOD_WEEK = 'WEEK';
var BILL_PERIOD_MONTH = 'MONTH';
var REGULAR_INSTALLMENTPLAN = 'REGULAR';

/**
 * Plural time unit
 *  True: time unit will be one of: days, weeks, months, years
 *  False: time unit will be one of: day, week, month, year
 * @type {boolean}
 */
var pluralTimeUnit = false;

/**
 * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
 *  e.g. Then 2$ for next 4 months
 *  otherwise statement will be
 *  2$ for next 4 months
 * @type {boolean}
 */
var hasPriorTerm = false;

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
  return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @returns {string}
 */
function computeTimeUnit(billPeriod) {
  var timeUnit;
  switch (billPeriod) {
    case BILL_PERIOD_DAY:
      timeUnit = pluralTimeUnit ? 'days' : 'day';
      break;
    case BILL_PERIOD_WEEK:
      timeUnit = pluralTimeUnit ? 'weeks' : 'week';
      break;
    case BILL_PERIOD_MONTH:
      timeUnit = pluralTimeUnit ? 'months' : 'month';
      break;
    default:
      timeUnit = '';
  }
  return localizedContent("wpsInstallmentPlan.label." + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amount, currencyCode) {
  return (0, _squid.formatCurrency)(amount, currencyCode, false);
}

/**
 * Computes and returns content key for regular installmentPlan
 * There can be 5 variations of regular installmentPlan content
 * @param totalCycles
 * @returns {string}  Content Key for 2nd trial, which must be prepended by wpsInstallmentPlan.message
 */
function computeRegularInstallmentPlanKey(totalCycles, isTerms) {
  var key = 'regularInstallmentPlanPeriod';
  if (hasPriorTerm) {
    // Content starts with Then {amount} for ......
    key += '.withPriorTerms';
  } else {
    // Content does NOT starts with Then
    key += '.noPriorTerms';
  }
  if (pluralTimeUnit) {
    // Content has: {amount} for each 2 days/weeks/months/years
    key += '.plural';
  } else {
    // Content has: {amount} for each day/week/month/year
    key += '.singular';
  }
  switch (+totalCycles) {
    case 0:
    case 1:
      // Text will look like $20.00 USD for the next 2 months
      // Content does NOT end with: for 3 installments
      key += isTerms ? '.nonRecurring' : '.nonRecurringAmount';
      break;
    case Infinity:
      // Content ends with: for each 2 months OR for each month
      // Content will look like $30.00 USD for each week
      key += isTerms ? '.recurringInfinite' : '.recurringInfiniteAmount';
      break;
    default:
      // Content ends with: for 3 installments
      // Content will look like $100.00 USD for each 2 months, for 3 installments
      key += isTerms ? '.recurring' : '.recurringAmount';
  }
  return key;
}

/**
 * Prepares and returns an individual term text string
 * @param installmentPlanTerms
 * @param index
 * @param currencyCode
 * @returns {string}
 */
function prepareIndividualTermAmountText(installmentPlanTerms, index, currencyCode, isTerms) {
  var amount = +installmentPlanTerms[index].amount,
    billPeriod = installmentPlanTerms[index].billPeriod,
    periodType = installmentPlanTerms[index].periodType,
    billFrequency = +installmentPlanTerms[index].billFrequency,
    totalCycles = +installmentPlanTerms[index].totalCycles;
  var contentKey;
  hasPriorTerm = index > 0;
  pluralTimeUnit = billFrequency > 1;
  if (periodType === REGULAR_INSTALLMENTPLAN) {
    contentKey = computeRegularInstallmentPlanKey(totalCycles, isTerms);
  }
  contentKey = "wpsInstallmentPlan.message." + contentKey;
  var templatePlaceholderData = {
    amount: computeAmount(amount, currencyCode),
    timePeriod: billFrequency,
    timeUnit: computeTimeUnit(billPeriod),
    installmentCount: totalCycles
  };
  return localizedContent(contentKey, templatePlaceholderData);
}
function getItemName(baResponseData) {
  if (!baResponseData) {
    return;
  }
  var _baResponseData$items = baResponseData.items,
    _baResponseData$items2 = _baResponseData$items === void 0 ? [] : _baResponseData$items,
    _baResponseData$items3 = _baResponseData$items2[0],
    _baResponseData$items4 = _baResponseData$items3 === void 0 ? {} : _baResponseData$items3,
    name = _baResponseData$items4.name;
  return name;
}
function getInstallmentPlanData(baResponseData) {
  if (!baResponseData) {
    return;
  }
  var installmentPlanDetails = {};
  var plan = baResponseData && baResponseData.plan;
  var allTerms = plan && plan.payment_definitions;
  var effectiveDate = baResponseData && baResponseData.effective_date;
  var supplementaryData = get(baResponseData.plan.metadata, 'supplementary_data');
  var displayTotal = supplementaryData.find(function (item) {
    return item.name === 'display_total';
  });
  var currencyCode = plan && plan.currency_code;
  var firstAmount = allTerms[0].amount;
  var totalAmount = allTerms.reduce(function (accumulator, currentVal) {
    return accumulator + currentVal.amount * currentVal.totalCycles;
  }, 0);
  var formattedTotalAmount = (0, _squid.formatCurrency)(totalAmount, currencyCode, false);
  var formattedFirstAmount = (0, _squid.formatCurrency)(firstAmount, currencyCode, false);
  var termsText = [];
  for (var i = 0; i < allTerms.length; i++) {
    termsText.push(prepareIndividualTermAmountText(allTerms, i, currencyCode, true)); // Passing 'true' flag for Terms
  }
  var amountText = [];
  for (var _i = 0; _i < allTerms.length; _i++) {
    amountText.push(prepareIndividualTermAmountText(allTerms, _i, currencyCode, false)); // Passing 'false' flag for Amount
  }
  installmentPlanDetails.displayTotal = displayTotal.value === 'true';
  installmentPlanDetails.effectiveDate = effectiveDate;
  installmentPlanDetails.currencyCode = currencyCode;
  installmentPlanDetails.formattedTotalAmount = formattedTotalAmount;
  installmentPlanDetails.formattedFirstAmount = formattedFirstAmount;
  installmentPlanDetails.termsText = termsText;
  installmentPlanDetails.amountText = amountText;
  return installmentPlanDetails;
}
module.exports = {
  getItemName: getItemName,
  getInstallmentPlanData: getInstallmentPlanData
};
_squid.formatCurrency;
_squid.Content;

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
__webpack_require__("../node_modules/xo-title/dist/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/marketingOffers/template.html"));
var _marketingoffer = __webpack_require__("../node_modules/xo-models/src/marketingoffer/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('xoMarketingOffers', function () {
  return {
    template: _template["default"],
    scope: {
      placementCode: '=?',
      titleTxtProperty: '=?',
      subtitleProperty: '=?',
      token: '=?',
      pageName: '=?',
      backgroundImage: '=?',
      xoTitleTag: '@?',
      xoTitleClass: '@?'
    },
    controller: ['$scope', '$element', '$sce', function ($scope, $element, $sce) {
      var morsOfferFlag = $scope.placementCode === '202003' && (0, _squid.$feature)('morsValuePropOffers');
      var populateObj;
      if (morsOfferFlag) {
        populateObj = {
          checkoutCart: _index.$CheckoutCartModel.instance($scope.token),
          checkoutSession: _index.$CheckoutSessionModel.instance($scope.token),
          payee: _index.$CheckoutPayeeModel.instance($scope.token),
          auth: _auth.$AuthModel.instance()
        };
      } else {
        populateObj = {
          checkoutCart: _index.$CheckoutCartModel.instance($scope.token)
        };
      }
      (0, _squid.$populate)($scope, populateObj).then(function () {
        $scope.locale = _squid.$locale;
        $scope.token = _angular.$rootScope.token;
        function setDefaultValues() {
          $scope.ad = {
            Title: (0, _squid.$renderContent)($scope.titleTxtProperty),
            Body: (0, _squid.$renderContent)($scope.subtitleProperty),
            backgroundImage: $scope.backgroundImage
          };
        }
        $scope.$watch('ad.backgroundImage', function (imageUrl) {
          if (imageUrl) {
            var url = imageUrl;
            var propImg = angular.element($element[0].querySelector('div.prop-img'));
            var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;
            if (isRetina && url) {
              var index = url.lastIndexOf('.'); // index at which file extension start

              url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
              propImg.css({
                'background-image': 'url(' + url + ')',
                'height': '150px',
                'margin-top': '0px'
              });
            } else {
              propImg.css({
                'background-image': 'url(' + url + ')',
                'height': '150px',
                'margin-top': '0px'
              });
            }
          }
        });
        if ($scope.placementCode === '202002') {
          $scope.pu_type = 'ANONYMOUS';
          $scope.presentation_types = ['CompositeText'];
        } else if ($scope.placementCode === '202003') {
          $scope.className = 'props';
          $scope.pu_type = 'PERSONAL';
          $scope.presentation_types = ['GenericComposite'];
          $scope.chooseAd = true;
        } else {
          setDefaultValues();
        }

        //  serve ads only if country is US and lang is en and based on placementcode
        if ($scope.chooseAd && _squid.$locale.country === 'US' && _squid.$locale.lang === 'en' && $scope.placementCode && (0, _squid.$feature)('morsValuePropOffers')) {
          $scope.marketingOfferData = new _marketingoffer.$MarketingOfferModel({
            countryCode: $scope.locale.country,
            page: $scope.pageName,
            puType: $scope.pu_type,
            locale: _squid.$locale.lang + '_' + _squid.$locale.country,
            totalTransactionAmount: {
              'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
              // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
              // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
              'value': Math.round($scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100)
            },
            totalShippingAmount: {
              'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
              // Round the calculation to eliminate Floating point Rounding Error (69.99 * 100 === 6998.999999999999)
              // http://docs.oracle.com/cd/E19957-01/806-3568/ncg_goldberg.html
              'value': Math.round($scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100)
            },
            payee: morsOfferFlag ? $scope.payee.merchant.id : '',
            payer: morsOfferFlag ? $scope.checkoutSession.payer.id : '',
            si: morsOfferFlag ? $scope.checkoutSession.id : '',
            visitor_id: morsOfferFlag ? $scope.auth.visitor_id : '',
            targetPlacements: [{
              'placement_code': $scope.placementCode,
              'presentation_types': $scope.presentation_types
            }]
          });
          return _marketingoffer.$MarketingOfferModel.instance($scope.token).save({
            silent: true,
            data: $scope.marketingOfferData.serialize(),
            // Ignore all errors from this api, by passing transientError as true
            transientError: true,
            success: function success(result) {
              var ads_arr = result && result.ads || [];
              var adFound = false;

              // MORS could serve multiple ads for a given page. Iterate to get the
              // correct one based on the ad placement_id
              ads_arr.forEach(function (ad) {
                var adunit_id = ad.campaign.adunit_id;
                if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
                  adFound = true;
                  $scope.ad = {};
                  var content = ad.content.nvp;
                  content.forEach(function (obj) {
                    $scope.ad[obj.name] = obj.value;
                  });
                  $scope.ad['impressionUrl'] = ad.tracking.impression_url;
                  $scope.ad['clickUrl'] = ad.tracking.click_url;
                }
              });
              if (adFound) {
                $scope.ad.Body = $sce.trustAsHtml($scope.ad.Body);
                // $scope.ad.Title does not need to be assigned. for 202001, 202002,
                // and 202003 placement_ids as this will already be assigned.

                // notify MORS of successful rendering by firing the impressionurl
                // beacon and by setting the click url to be fired for future
                // conversion.
                // setting the placement_id helps to differentiate between multiple ads
                // displayed on the same page

                _logger.$logger.info('MORS_ad_displayed');
                _marketingoffer.$fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);
                _angular.$rootScope.$broadcast('MORSDisplayed', {
                  clickUrl: $scope.ad.clickUrl,
                  placementId: $scope.placementCode
                });
              } else {
                _logger.$logger.info('MORS_ad_not_found');
                setDefaultValues();
                _angular.$rootScope.$broadcast('MORSNotDisplayed');
              }
            },
            error: function error(err) {
              setDefaultValues();
              _logger.$logger.error('MORS_api_failure', {
                error: err
              });
            }
          });
        } else {
          setDefaultValues();
          _angular.$rootScope.$broadcast('MORSNotDisplayed');
        }
        $scope.$on('localeChange', function () {
          setDefaultValues();
        });
      });
    }]
  };
});
_angular.$rootScope;
_squid.$feature;
_squid.$locale;
_squid.$populate;
_squid.$renderContent;
_logger.$logger;
_auth.$AuthModel;
_index.$CheckoutCartModel;
_index.$CheckoutPayeeModel;
_index.$CheckoutSessionModel;
_marketingoffer.$MarketingOfferModel;
_marketingoffer.$fireMORSBeacon;

/***/ }),

/***/ "../node_modules/xo-page-components/src/marketingOffers/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"marketingOffers {{className}}\" content >\n    <div ng-if=\"ad.backgroundImage\" class=\"prop-img\"></div>\n    <xo-title title-txt=\"{{ ad.Title }}\" tag-name=\"{{ xoTitleTag }}\" class-name=\"{{ xoTitleClass }}\"></xo-title>\n    <p class=\"subTitle\" ng-bind-html=\"ad.Body\"></p>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index3 = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/utils/index.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/merchant-header/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoMerchantHeaderDirective', {
  tag: 'xo-merchant-header',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    merchant: {
      type: 'var',
      required: false
    },
    disableId: {
      type: 'str',
      required: false
    }
  },
  resolve: {
    models: function models() {
      if (this.props.token) {
        return {
          checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()["catch"](_angular.noop)
        };
      }
    }
  },
  lifecycle: {
    populate: function populate() {
      var _ref = this.models || {},
        checkoutAppData = _ref.checkoutAppData;
      if (checkoutAppData) {
        // get Merchant display name - can be undefined in which case we have an empty header
        this.merchantDisplayName = checkoutAppData.getMerchantDisplayName();
        if (this.props.token && !_index2.$CheckoutInputDataModel.instance(this.props.token).isEbayTxn()) {
          this.merchant = checkoutAppData.merchant;
        }
        this.escapedMerchantName = _index3["default"].escapeTags(this.merchantDisplayName || this.merchant.brand_name);
      }
    }
  }
});
(0, _squid.$registerDirective)('xoMerchantImageResize', function () {
  return {
    restrict: 'A',
    link: function link(scope, element) {
      element.bind('load', function () {
        var MAX_WIDTH = 780;
        var MAX_HEIGHT = 60;
        if (this.width > MAX_WIDTH) {
          var ratio = MAX_WIDTH / this.width;
          var height = this.height * ratio;
          this.width = MAX_WIDTH;
          this.height = height > MAX_HEIGHT ? MAX_HEIGHT : height;
        }
        if (this.height > MAX_HEIGHT) {
          var _ratio = MAX_HEIGHT / this.height;
          var width = this.width * _ratio;
          this.height = MAX_HEIGHT;
          this.width = width > MAX_WIDTH ? MAX_WIDTH : width;
        }
      });
    }
  };
});
_angular.noop;
_squid.$Component;
_squid.$registerDirective;
_index.$CheckoutAppDataModel;
_index2.$CheckoutInputDataModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-page-components/src/merchant-header/template.html":
/***/ (function(module, exports) {

module.exports = "<header role=\"banner\">\n    <div ng-attr-id=\"{{ props.disableId ? '' : 'header' }}\" class=\"merchantHeader clearfix\">\n        <div class=\"headerWrapper\">\n            <span class=\"merchantName\" directionality-text=\"escapedMerchantName\" ng-if=\"!(merchant.logo_url || merchant.imageUrl)\">\n                {{ escapedMerchantName }}\n         \t</span>\n            <img ng-src=\"{{merchant.logo_url || merchant.imageUrl}}\" alt=\"{{ escapedMerchantName }}\" ng-if=\"merchant.logo_url || merchant.imageUrl\" xo-merchant-image-resize/>\n        </div>\n    </div>\n</header>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/returnParams/index.js":
/***/ (function(module, exports, __webpack_require__) {



var addValidParam = __webpack_require__("../node_modules/xo-page-components/src/utils/index.js").addValidParam;
function returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow) {
  var params = {};
  var customData = checkoutCart.get('purchase.custom');
  if (returnToMerchantMethod === 'POST') {
    // TODO: find out why we get postbackData as undefined
    // UPDATE: couldn't reproduce an issue on the stage for now
    if (checkoutSession.postbackData) {
      params = checkoutSession.postbackData;
    }
  } else {
    var transactionDetail = checkoutSession.transactionDetails;
    if (transactionDetail) {
      addValidParam(params, 'tx', transactionDetail.id);
      addValidParam(params, 'st', transactionDetail.state);
      if (transactionDetail.amount) {
        addValidParam(params, 'amt', transactionDetail.amount.total);
        addValidParam(params, 'cc', transactionDetail.amount.currency);
      }
    }

    // Cart uploads can have more than one item so we don't add any in return URL
    if (!is_cart_upload_flow) {
      var itemDetail = checkoutSession.get('itemsList.0');
      if (itemDetail) {
        addValidParam(params, 'item_name', itemDetail.name);
        addValidParam(params, 'item_number', itemDetail.sku);
      }
    }
    addValidParam(params, 'cm', customData);
  }
  return params;
}

/**
 * this API function is used by hermesnodeweb/public/pages/xo-end and xoonboardingnodeweb/public/pages/xo-end
 * Create params to return back to the merchant after clicking on "Return to merchant" on the Done page.
 * buy-now and cart-upload params are slightly different: given cart-upload might have multiple items,
 * please refer https://github.paypal.com/NodeXOShared/xo-hermes-checkout/blob/master/apis/session/postBackDataMapper.js
 * to know more details about post back data

 * @param {Object (angular model)} cart model
 * @param {Object (angular model)} session model
 * @param {String} http method, either "POST" or "GET"
 * @param {String} feature type (WPS only for now)
 * @param {Boolean} flag that indicates if it's a cart upload or not
 * @returns {object} params to pass back to the merchant
*/
module.exports = {
  $returnParams: function $returnParams(checkoutCart, checkoutSession, returnToMerchantMethod, feature, is_cart_upload_flow) {
    if (feature === 'WPS') {
      return returnWPSParams(checkoutCart, checkoutSession, returnToMerchantMethod, is_cart_upload_flow);
    }
    return {};
  }
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/route-to-complete/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/route-to-complete/template.html"));
__webpack_require__("../node_modules/xo-page-components/src/route-to-complete/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
angular.module().directive('xoRouteToComplete', function () {
  return {
    template: _template["default"],
    scope: {
      token: '=?'
    },
    controller: ['$scope', function ($scope) {
      /* hide the footer cancel link */
      angular.element('#defaultCancelLink').hide();
      _angular.$rootScope.$on('$stateChangeStart', function (event) {
        event.preventDefault();
      });

      /* hide header paypal logo*/
      $('.paypalHeaderWrapper').hide();
      $('.footerWrapper').addClass('routecss');

      /* urlType is passed from xo-end or from xo-page-components/footer/directive.
      *  urltype can be either success(incase of successfull flow completion ) or cancel
      * */
      var urlType = _uiRouter.$stateParams.urlType;

      // show the return to merchant url only in case of success.
      if (urlType === 'success') {
        $scope.enableSuccessReturnUrl = true;
      }
      if (urlType === 'cancel') {
        // defaulting to False. Once the cancel content is available, turn it to true.
        $scope.enableCancelReturnUrl = true;
      }
      $scope.goToMerchant = function () {
        _angular.$window.onunload = _angular.$window.onbeforeunload = function () {}; // eslint-disable-line
        _angular.$window.location = _uiRouter.$stateParams.url;
      };
      (0, _squid.$populate)($scope, {
        checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
      }).then(function () {
        $scope.merchant = $scope.checkoutAppData.getMerchantDisplayName();
      });
      $scope.$on('$destroy', function (event) {
        $('.paypalHeaderWrapper').show();
        $('.footerWrapper').removeClass('routecss');
      });
    }]
  };
});
_squid.$populate;
_uiRouter.$stateParams;
_angular.$rootScope;
_angular.$window;
_index.$CheckoutAppDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-page-components/src/route-to-complete/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$RouteToCompleteRoute = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-page-components/src/route-to-complete/directive.js");
var $RouteToCompleteRoute = exports.$RouteToCompleteRoute = _squid.$ComponentRoute.extend('$RouteToCompleteRoute', {
  name: 'routeToComplete',
  directive: 'xo-route-to-complete',
  titleContent: 'genericError.pleaseTryAgain',
  query: ['url', 'urlType'],
  trackingData: {
    fptiState: 'route-to-complete',
    buzname: {
      'fullpage': {
        'pagename': '%::route-to-complete',
        'pagename2': '%::route-to-complete:member:hermes:',
        'version': 'member:%:'
      }
    }
  },
  children: []
});
angular.value("$RouteToCompleteRoute", $RouteToCompleteRoute);
_squid.$ComponentRoute;

/***/ }),

/***/ "../node_modules/xo-page-components/src/route-to-complete/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-page-components/src/route-to-complete/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"routecss\" content>\n    <div class=\"container\">\n        <div class=\"logo\"></div>\n        <div class=\"title\">{{content('genericMessage.paymentSuccessTitle')}}</div>\n        <div class=\"message\">{{content('genericMessage.successMessage')}}</div>\n        <div ng-if=\"enableSuccessReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{content('genericMessage.returnButton')}}\" ng-click=\"goToMerchant()\"/>\n            </div>\n        </div>\n        <div ng-if=\"enableCancelReturnUrl\">\n            <div>\n                <input class=\"btn full loginBtn\" type=\"button\" value=\"{{merchant ? content('base.cancelUrl', { merchantName: merchant }) : content('common.cancelAndReturnToMerchant')}}\" ng-click=\"goToMerchant()\"/>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _subscriptionTerms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
module.exports = {
  getFirstAmount: _subscriptionTerms["default"].getFirstAmount,
  getFormattedFirstAmount: _subscriptionTerms["default"].getFormattedFirstAmount,
  getFormattedAmount: _subscriptionTerms["default"].getFormattedAmount,
  getItemOptions: _subscriptionTerms["default"].getItemOptions,
  getItemName: _subscriptionTerms["default"].getItemName,
  getCurrencyCode: _subscriptionTerms["default"].getCurrencyCode,
  getTermsText: _subscriptionTerms["default"].getTermsText,
  getEffectiveDate: _subscriptionTerms["default"].getEffectiveDate,
  getNumericValueNonZero: _subscriptionTerms["default"].getNumericValueNonZero,
  isNumericValue: _subscriptionTerms["default"].isNumericValue
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscription-terms/subscriptionTerms.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var BILL_PERIOD_DAY = 'DAY';
var BILL_PERIOD_WEEK = 'WEEK';
var BILL_PERIOD_MONTH = 'MONTH';
var BILL_PERIOD_YEAR = 'YEAR';
var TRIAL_SUBSCRIPTION = 'TRIAL';
var REGULAR_SUBSCRIPTION = 'REGULAR';
var INFINITE_CYCLES = 'INFINITE';

/**
 * Plural time unit
 *  True: time unit will be one of: days, weeks, months, years
 *  False: time unit will be one of: day, week, month, year
 * @type {boolean}
 */
var pluralTimeUnit = false;

/**
 * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
 *  e.g. Then 2$ for next 4 months
 *  otherwise statement will be
 *  2$ for next 4 months
 * @type {boolean}
 */
var hasPriorTerm = false;

/**
 * Wrapper for calling formatCurrent fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
  arguments[0] = arguments[0].toFixed(2);
  return _squid.formatCurrency.apply(void 0, arguments);
}

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
  return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @returns {string}
 */
function computeTimeUnit(billPeriod) {
  var timeUnit;
  switch (billPeriod) {
    case BILL_PERIOD_DAY:
      timeUnit = pluralTimeUnit ? 'days' : 'day';
      break;
    case BILL_PERIOD_WEEK:
      timeUnit = pluralTimeUnit ? 'weeks' : 'week';
      break;
    case BILL_PERIOD_MONTH:
      timeUnit = pluralTimeUnit ? 'months' : 'month';
      break;
    case BILL_PERIOD_YEAR:
      timeUnit = pluralTimeUnit ? 'years' : 'year';
      break;
    default:
      timeUnit = '';
  }
  return localizedContent("wpsSubscription.label." + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amount, currencyCode) {
  if (amount === 0) {
    return localizedContent('wpsSubscription.label.free');
  } else {
    return getFormattedCurrency(amount, currencyCode, false);
  }
}

/**
 * This method computes first trial key
 * @returns {string} Content Key for 1st trial, which must be prepended by wpsSubscription.message
 */
function computeFirstTrialKey() {
  if (pluralTimeUnit) {
    // {amount} for the first {timePeriod} {timeUnit}
    return 'firstTrialPeriod.plural';
  } else {
    // {amount} for the first {timeUnit}
    return 'firstTrialPeriod.singular';
  }
}

/**
 * This method computes content key for 2nd trial
 * @returns {string} Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeSecondTrialKey() {
  if (pluralTimeUnit) {
    // Then {amount} for the next {timePeriod} {timeUnit}
    return 'secondTrialPeriod.plural';
  } else {
    // Then {amount} for the next {timeUnit}
    return 'secondTrialPeriod.singular';
  }
}

/**
 * Computes and returns content key for regular subscription
 * There can be 12 variations of regular subscription content
 * @param totalCycles
 * @returns {string}  Content Key for 2nd trial, which must be prepended by wpsSubscription.message
 */
function computeRegularSubscriptionKey(totalCycles) {
  var key = 'regularSubscriptionPeriod';
  if (hasPriorTerm) {
    // Content starts with Then {amount} for ......
    key += '.withPriorTerms';
  } else {
    // Content does NOT starts with Then
    key += '.noPriorTerms';
  }
  if (pluralTimeUnit) {
    // Content has: {amount} for each 2 days/weeks/months/years
    key += '.plural';
  } else {
    // Content has: {amount} for each day/week/month/year
    key += '.singular';
  }
  switch (+totalCycles) {
    case 0:
    case 1:
      // Text will look like $20.00 USD for the next 2 months
      // Content does NOT end with: for 3 installments
      key += '.nonRecurring';
      break;
    case Infinity:
      // Content ends with: for each 2 months OR for each month
      // Content will look like $30.00 USD for each week
      key += '.recurringInfinite';
      break;
    default:
      // Content ends with: for 3 installments
      // Content will look like $100.00 USD for each 2 months, for 3 installments
      key += '.recurring';
  }
  return key;
}

/**
 * Prepares and returns an individual term text string
 * @param subscriptionTerms
 * @param index
 * @param currencyCode
 * @returns {string}
 */
function prepareIndividualTermText(subscriptionTerms, index, currencyCode) {
  var amount = +subscriptionTerms[index].amount,
    billPeriod = subscriptionTerms[index].billPeriod,
    periodType = subscriptionTerms[index].periodType,
    billFrequency = +subscriptionTerms[index].billFrequency,
    totalCycles = +subscriptionTerms[index].totalCycles;
  var contentKey;
  hasPriorTerm = index > 0;
  pluralTimeUnit = billFrequency > 1;
  if (periodType === TRIAL_SUBSCRIPTION) {
    if (index === 0) {
      // First Trial
      contentKey = computeFirstTrialKey();
    } else if (index === 1) {
      // Second Trial
      contentKey = computeSecondTrialKey();
    }
  } else if (periodType === REGULAR_SUBSCRIPTION) {
    contentKey = computeRegularSubscriptionKey(totalCycles);
  }
  contentKey = "wpsSubscription.message." + contentKey;
  var templatePlaceholderData = {
    amount: computeAmount(amount, currencyCode),
    timePeriod: billFrequency,
    timeUnit: computeTimeUnit(billPeriod),
    installmentCount: totalCycles
  };
  return localizedContent(contentKey, templatePlaceholderData);
}
function mapBaResponse(baResponseData) {
  var mappedSubscriptionDetails = {};
  var plan = baResponseData && baResponseData.plan;
  var allTerms = plan && plan.payment_definitions;
  var mappedTerms = [];
  var firstTrialAmount = null;
  var regularAmount;
  mappedSubscriptionDetails.currencyCode = plan && plan.currency_code;
  if (allTerms) {
    allTerms.forEach(function (eachTerm) {
      var totalCycles = eachTerm.duration === INFINITE_CYCLES ? Infinity : eachTerm.cycles;
      var eachMappedTerm = {
        amount: eachTerm.amount && eachTerm.amount.value / 100,
        billPeriod: eachTerm.frequency,
        periodType: eachTerm.type,
        billFrequency: eachTerm.frequency_interval,
        totalCycles: totalCycles
      };
      if (!mappedSubscriptionDetails.currencyCode) {
        // V1 Subscriptions: Pick currency code from any of the amounts.
        mappedSubscriptionDetails.currencyCode = eachTerm.amount && eachTerm.amount.currency_code;
      }
      if (eachTerm.type === TRIAL_SUBSCRIPTION && eachTerm.index === '1') {
        firstTrialAmount = eachMappedTerm.amount;
      } else if (eachTerm.type === REGULAR_SUBSCRIPTION) {
        regularAmount = eachMappedTerm.amount;
      }
      mappedTerms.push(eachMappedTerm);
    });

    // firstTrialAmount can be zero for free trial, null for no trial
    // and valid value if there is trial amount
    mappedSubscriptionDetails.firstAmount = firstTrialAmount !== null ? firstTrialAmount : regularAmount;
    mappedSubscriptionDetails.subscriptionTerms = mappedTerms;
  }
  return mappedSubscriptionDetails;
}

/**
 * Prepare and return a subscription terms
 * @param baResponseData
 * @returns {Object} Containing Subscription Terms Text
 */
function getTermsText(baResponseData) {
  var subscriptionDetails = mapBaResponse(baResponseData);
  var subscriptionTerms = subscriptionDetails.subscriptionTerms;
  var currencyCode = subscriptionDetails.currencyCode;
  var termTextList = [];
  for (var i = 0, len = subscriptionTerms.length; i < len; i++) {
    termTextList.push(prepareIndividualTermText(subscriptionTerms, i, currencyCode));
  }
  return termTextList;
}

/**
 * Returns a un formatted first amount from ba response
 */
function getFirstAmount(baResponseData) {
  var subscriptionDetails = mapBaResponse(baResponseData);
  return subscriptionDetails.firstAmount;
}

/**
 * Returns the currency code
 */
function getCurrencyCode(baResponseData) {
  var plan = baResponseData && baResponseData.plan;
  return plan && plan.currency_code;
}

/**
 * Returns a formatted first amount from ba response data
 */
function getFormattedFirstAmount(baResponseData) {
  var amount = getFirstAmount(baResponseData);
  var currencyCode = getCurrencyCode(baResponseData);
  return getFormattedCurrency(amount, currencyCode, false);
}

/**
 * Retrieve item details
 */
function getItemOptions(baResponseData) {
  var itemDetails = baResponseData && baResponseData.items && baResponseData.items[0];
  return itemDetails.options;
}

/**
 * Retrieve item name
 */
function getItemName(baResponseData) {
  if (!baResponseData) {
    return;
  }
  var _baResponseData$items = baResponseData.items,
    _baResponseData$items2 = _baResponseData$items === void 0 ? [] : _baResponseData$items,
    _baResponseData$items3 = _baResponseData$items2[0],
    _baResponseData$items4 = _baResponseData$items3 === void 0 ? {} : _baResponseData$items3,
    name = _baResponseData$items4.name;
  return name;
}
function getEffectiveDate(baResponseData) {
  return baResponseData && baResponseData.effective_date;
}
function getFormattedAmount(amount, currencyCode) {
  var formattedAmount = amount / 100;
  return currencyCode ? getFormattedCurrency(formattedAmount, currencyCode, false) : formattedAmount.toFixed(2);
}
function getNumericValueNonZero(obj, path) {
  var data = parseFloat(_squid.$util.getProperty(obj, path));
  return !isNaN(data) && data > 0 && data;
}
function isNumericValue(value) {
  var data = parseInt(value, 10);
  return !isNaN(data) && data >= 0;
}
module.exports = {
  getFirstAmount: getFirstAmount,
  getFormattedFirstAmount: getFormattedFirstAmount,
  getFormattedAmount: getFormattedAmount,
  getItemOptions: getItemOptions,
  getItemName: getItemName,
  getCurrencyCode: getCurrencyCode,
  getTermsText: getTermsText,
  getEffectiveDate: getEffectiveDate,
  getNumericValueNonZero: getNumericValueNonZero,
  isNumericValue: isNumericValue
};
_squid.formatCurrency;
_squid.Content;
_squid.$util;

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscriptionV1-terms/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _subscriptionV1Terms = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/subscriptionV1-terms/subscriptionV1Terms.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
module.exports = {
  getFormattedAmount: _subscriptionV1Terms["default"].getFormattedAmount,
  getTermsText: _subscriptionV1Terms["default"].getTermsText,
  getNumericValueNonZero: _subscriptionV1Terms["default"].getNumericValueNonZero,
  isNumericValue: _subscriptionV1Terms["default"].isNumericValue,
  getTaxDisclaimer: _subscriptionV1Terms["default"].getTaxDisclaimer
};

/***/ }),

/***/ "../node_modules/xo-page-components/src/subscriptionV1-terms/subscriptionV1Terms.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getTermsText = getTermsText;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
/**
 * This file contains the computation of terms from billing cycles object in planReview data
 */

var INTERVAL_UNIT_DAY = 'DAY';
var INTERVAL_UNIT_WEEK = 'WEEK';
var INTERVAL_UNIT_MONTH = 'MONTH';
var INTERVAL_UNIT_YEAR = 'YEAR';

/**
 * Wrapper for calling formatCurreny fn after updating the amount to fixed decimal place.
 * @param args
 */

function getFormattedCurrency() {
  arguments[0] = arguments[0].toFixed(2);
  return _squid.formatCurrency.apply(void 0, arguments);
}

/**
 * Returns a localized text from given key and props
 * @param key
 * @param props
 */
function localizedContent(key, props) {
  return _squid.Content.get(key, props) && _squid.Content.get(key, props).toString();
}

/**
 * Computes the singular or plural form for time unit
 * @param billPeriod
 * @param pluralTimeUnit
 * @returns {string}
 */
function computeTimeUnit(billPeriod, pluralTimeUnit) {
  var timeUnit;

  // eslint-disable-next-line default-case
  switch (billPeriod) {
    case INTERVAL_UNIT_DAY:
      timeUnit = pluralTimeUnit ? 'days' : 'day';
      break;
    case INTERVAL_UNIT_WEEK:
      timeUnit = pluralTimeUnit ? 'weeks' : 'week';
      break;
    case INTERVAL_UNIT_MONTH:
      timeUnit = pluralTimeUnit ? 'months' : 'month';
      break;
    case INTERVAL_UNIT_YEAR:
      timeUnit = pluralTimeUnit ? 'years' : 'year';
      break;
  }
  return localizedContent("wpsSubscription.label." + timeUnit);
}

/**
 * Format amount
 * @param amount
 * @param currencyCode
 * @returns {string} A formatted amount string with currency code or free if 0
 */
function computeAmount(amountValue, currencyCode) {
  if (amountValue === 0) {
    return localizedContent('wpsSubscription.label.free');
  } else {
    return getFormattedCurrency(amountValue, currencyCode, false);
  }
}

/**
 * Computes and returns content key for subscription terms
 * There can be 12 variations of subscription content
 * @param totalCycles
 * @param hasPriorTerm
 * @param pluralTimeUnit
 * @returns {string}  Content Key which must be prepended by wpsSubscription.message
 */
function computeSubscriptionKey(totalCycles, hasPriorTerm, pluralTimeUnit) {
  var key = 'regularSubscriptionPeriod';

  /**
   * If a statement has hasPriorTerm=true , then the statement will begin with "Then"
   * @type {boolean}
   */
  if (hasPriorTerm) {
    // Content starts with Then, e.g. Then 2$ for next 4 months
    key += '.withPriorTerms';
  } else {
    // Content does NOT starts with Then
    // Content looks like 2$ for next 4 months
    key += '.noPriorTerms';
  }

  /**
   * Plural time unit
   * @type {boolean}
   */
  if (pluralTimeUnit) {
    // Content has: {amount} for each 2 days/weeks/months/years
    key += '.plural';
  } else {
    // Content has: {amount} for each day/week/month/year
    key += '.singular';
  }
  switch (+totalCycles) {
    case 0:
      // Content ends with: for each 2 months OR for each month
      // Content will look like $30.00 USD for each week
      key += '.recurringInfinite';
      break;
    case 1:
      // Text will look like $20.00 USD for 2 months
      // Content does NOT end with: for 3 installments
      key += '.nonRecurring';
      break;
    default:
      // Content ends with: for 3 installments
      // Content will look like $100.00 USD for each 2 months, for 3 installments
      key += '.recurring';
  }
  return key;
}

/**
 * Prepares and returns an individual term text string
 * @param billingCycle
 * @param index
 * @returns {string}
 */
function prepareIndividualTermText(billingCycle, index) {
  var amount = billingCycle.pricing_scheme.fixed_price;
  var amountValue = amount.value / 100;
  var currencyCode = amount.currency_code;
  var billPeriod = billingCycle.frequency.interval_unit;
  var billFrequency = billingCycle.frequency.interval_count;
  var totalCycles = billingCycle.total_cycles;
  var pluralTimeUnit = billFrequency > 1;
  var hasPriorTerm = index > 0;
  var computedContentKey = computeSubscriptionKey(totalCycles, hasPriorTerm, pluralTimeUnit);
  var contentKey = "wpsSubscription.message." + computedContentKey;
  var templatePlaceholderData = {
    amount: computeAmount(amountValue, currencyCode),
    timePeriod: billFrequency,
    timeUnit: computeTimeUnit(billPeriod, pluralTimeUnit),
    installmentCount: totalCycles
  };
  return localizedContent(contentKey, templatePlaceholderData);
}

/**
 * Prepare and return a subscription terms
 * @param plan data from planReview
 * @returns {Array} Subscription Terms Text
 */
function getTermsText(planResponse) {
  var termTextList = [];
  var billingCycles = _squid.$util.getProperty(planResponse, 'plan.billing_cycles');
  billingCycles.forEach(function (billingCycle, index) {
    termTextList.push(prepareIndividualTermText(billingCycle, index));
  });
  return termTextList;
}
function getFormattedAmount(amount, currencyCode) {
  var formattedAmount = amount / 100;
  return currencyCode ? getFormattedCurrency(formattedAmount, currencyCode, false) : formattedAmount.toFixed(2);
}
function getNumericValueNonZero(obj, path) {
  var data = parseFloat(_squid.$util.getProperty(obj, path));
  return !isNaN(data) && data > 0 && data;
}
function isNumericValue(value) {
  var data = parseInt(value, 10);
  return !isNaN(data) && data >= 0;
}
function getTaxDisclaimer(taxPercentage, taxAmount) {
  if (taxPercentage) {
    return localizedContent('subscriptions.message.includesTax', {
      tax: taxPercentage
    });
  } else if (taxAmount) {
    return localizedContent('subscriptions.message.includesTaxAmount', {
      tax: taxAmount
    });
  }
  return '';
}
module.exports = {
  getFormattedAmount: getFormattedAmount,
  getTermsText: getTermsText,
  getNumericValueNonZero: getNumericValueNonZero,
  isNumericValue: isNumericValue,
  getTaxDisclaimer: getTaxDisclaimer
};
_squid.formatCurrency;
_squid.Content;
_squid.$util;

/***/ }),

/***/ "../node_modules/xo-page-components/src/utils/index.js":
/***/ (function(module, exports, __webpack_require__) {



var _fbMessenger = _interopRequireDefault(__webpack_require__("../node_modules/xo-page-components/src/constants/fbMessenger.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable angular/typecheck-string */

module.exports = {
  /**
   * add non empty key, value to the object
   * @param {Object} object where to add new key, value
   * @param {String} key
   * @param {Any type} value, can not be empty
   * @returns {void}
   */
  addValidParam: function addValidParam(obj, key, val) {
    if (!obj) {
      return;
    }
    if (typeof key === 'string' && key && val !== undefined && val !== null) {
      obj[key] = val;
    }
  },
  // Get PXP context for Messenger feature
  getMessengerPXPContext: function getMessengerPXPContext() {
    var isMobile = _index.$DeviceInfo.isMobile() || _index.$DeviceInfo.isTablet();
    var overrideMobileUserFlag = _squid.$util.param(_fbMessenger["default"].OVERRIDE_FBPP_MOBILE_FLAG);
    var channelVal = isMobile ? _fbMessenger["default"].MOBILE_CHANNEL : _fbMessenger["default"].WEB_CHANNEL;
    var pxpContext = {
      'ctx.COUNTRY': _squid.$locale.country,
      'ctx.CHANNEL': overrideMobileUserFlag ? _fbMessenger["default"].WEB_CHANNEL : channelVal,
      'ctx.LANGUAGE': _squid.$locale.lang + '_' + _squid.$locale.country
    };
    return pxpContext;
  },
  isDolphinEligibleOnWpsDone: function isDolphinEligibleOnWpsDone(stateName) {
    return /checkout\.done/.test(stateName) && !!_squid.$util.param('ulToastWpsDone');
  },
  /**
   * Escape opening tags on vulnerable tags
   * @param {String} merchantName
   * @returns {Boolean}
   */
  escapeTags: function escapeTags(merchantName) {
    if (merchantName === void 0) {
      merchantName = '';
    }
    return merchantName.replace(/<(\/?)(html|script|body|meta|style|img|iframe|svg|link|source|video)/ig, '&lt;$1$2');
  }
};
_squid.$util;
_squid.$locale;
_index.$DeviceInfo;

/***/ }),

/***/ "../node_modules/xo-page-components/src/value-props/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-page-components/src/value-props/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
  squid.module('xo-value-props.directive', ['squid']).directive('xoValueProps', function () {
    return {
      template: template,
      restrict: 'E',
      scope: {
        type: '@?',
        title: '@?',
        text: '@?',
        textContent: '@?',
        imageUrl: '@?'
      },
      link: function link(scope, element, attrs) {
        if (angular.isString(attrs.imageUrl)) {
          // Only do this when image-url is defined so that we do not affect default behavior. These image-url
          // are configured through pxp tool for factor based experiments, hence they should all should adhere
          // to standard size i.e. 150X150 pixels.
          attrs.$observe('imageUrl', function (imageUrl) {
            var url = imageUrl;
            var propImg = angular.element(element[0].querySelector('div.prop-img'));
            var isRetina = window && window.matchMedia && window.matchMedia('(-webkit-min-device-pixel-ratio: 2), ' + '(min--moz-device-pixel-ratio: 2), ' + '(-o-min-device-pixel-ratio: 2/1),' + '(min-device-pixel-ratio: 2),' + '(min-resolution: 192dpi), ' + '(min-resolution: 2dppx)').matches;
            if (isRetina) {
              var index = url.lastIndexOf('.'); // index at which file extension start

              url = url.substring(0, index) + '_2x' + url.substring(index, url.length);
              propImg.css({
                'background-image': 'url(' + url + ')',
                'height': '150px',
                'background-size': '150px 150px',
                'margin-top': '0px'
              });
            } else {
              propImg.css({
                'background-image': 'url(' + url + ')',
                'height': '150px',
                'margin-top': '0px'
              });
            }
          });
        }
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/formatReturnContent.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.MAX_MERCHANT_NAME_LENGTH = void 0;
exports.formatReturnContent = formatReturnContent;
var MAX_MERCHANT_NAME_LENGTH = exports.MAX_MERCHANT_NAME_LENGTH = 15;
function formatReturnContent($renderContent, merchantName) {
  if (merchantName && merchantName.length < MAX_MERCHANT_NAME_LENGTH) {
    return $renderContent('common.returnToMerchant', {
      merchantName: merchantName
    });
  }
  return $renderContent('common.returnToDefaultMerchant');
}

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.formatReturnContent = exports.MAX_MERCHANT_NAME_LENGTH = exports.$ReturnToMerchant = void 0;
var _util = __webpack_require__("../node_modules/xo-return-to-merchant/dist/util.js");
exports.$ReturnToMerchant = _util.$ReturnToMerchant;
var _formatReturnContent = __webpack_require__("../node_modules/xo-return-to-merchant/dist/formatReturnContent.js");
exports.formatReturnContent = _formatReturnContent.formatReturnContent;
exports.MAX_MERCHANT_NAME_LENGTH = _formatReturnContent.MAX_MERCHANT_NAME_LENGTH;

/***/ }),

/***/ "../node_modules/xo-return-to-merchant/dist/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ReturnToMerchant = void 0;
exports.goTo = goTo;
exports.postTo = postTo;
exports.postToMerchant = postToMerchant;
var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function goTo(url, forceRedirect) {
  _logger.$logger.info('goTo', {
    url: url,
    forceRedirect: forceRedirect
  });
  if (!url) {
    return;
  }

  // prevent xss attacks
  if ((0, _squid.isUnsafeRedirect)(url)) {
    _logger.$logger.error('unsafe_redirect_url', {
      url: url
    });
    throw new Error('Unsafe redirect url: ' + url);
  }
  _logger.$logger.info(url.indexOf('PayerID') > -1 ? 'return_to_merchant' : 'cancel_to_merchant', {
    url: url
  });

  // if V4 in-context integration, we'll terminate and call the close handler.
  if (window.xchild) {
    _logger.$logger.done();
    _angular.$rootScope.$emit('loading');
    var _paymentToken = _angular.$rootScope.token;
    var cart = _index2.$CheckoutCartModel.instance(_paymentToken);
    var appData = _index2.$CheckoutAppDataModel.instance(_paymentToken);
    var orderID = _paymentToken;
    var intent = cart.payment_action;
    var billingToken = cart.billing && cart.billing.ba_token;
    var paymentID = appData.payment_id;
    var cancelUrl = url;
    return window.xprops.onCancel({
      paymentToken: _paymentToken,
      billingToken: billingToken,
      orderID: orderID,
      paymentID: paymentID,
      intent: intent,
      cancelUrl: cancelUrl
    });
  }
  var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
  var isNativeXo = _squid.$util.param('native_xo') && _squid.$util.param('native_xo') === '1';
  // if isDevice, NOT an HTTP url, and NOT a Native Checkout Transaction
  var showPaymentSuccess = Boolean(_index.$DeviceInfo.isDevice() && !isHTTPUrl && !isNativeXo);
  _logger.$logger.info('showPaymentSuccess', {
    isDevice: _index.$DeviceInfo.isDevice(),
    isHTTPUrl: isHTTPUrl,
    isNativeXo: isNativeXo
  });
  if (showPaymentSuccess) {
    _logger.$logger.info('showPaymentSuccessRedirect', {
      url: url
    });
    _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
    };

    // wait until state change is done and then redirect
    // for some reason, in case of webview (invoice flow) and code split
    // when user is redirecting to the return url - dynamic chunk fails to load
    // which triggers reload of the previous page
    return _uiRouter.$state.go('checkout.genericMessage', {
      code: 'PAYMENT_SUCCESS',
      returnUrl: url
    })["catch"](function (err) {
      _logger.$logger.info('app_redirect_to_merchant_generic_message_error', {
        error: err && err.message
      });
    })["finally"](function () {
      _angular.$window.location = url;
    });
  }
  if (forceRedirect) {
    _logger.$logger.info('forceRedirect', {
      url: url
    });
    _squid.$util.redirect(url);
  } else {
    var isVZeroIframe = Boolean(_angular.$rootScope.partnerIntegration) && _squid.$util.isIFrame();
    if (isVZeroIframe) {
      _logger.$logger.info('VZeroIframeRedirect');
      _squid.$util.redirect(url, {
        redirectImmediateParent: true
      });
    }

    // If we are not in minibrowser, do a hard redirect
    else if (_angular.$rootScope.partnerIntegration || !_angular.$rootScope.miniBrowser && !_squid.$util.isIFrame()) {
      _logger.$logger.info('redirectFlowType', {
        partnerIntegration: _angular.$rootScope.partnerIntegration,
        miniBrower: _angular.$rootScope.miniBrowser,
        iframe: _squid.$util.isIFrame()
      });
      _squid.$util.redirect(url);
    } else {
      // Construct a message to send to the parent
      var result = this.postToMerchant({
        operation: 'return_to_merchant',
        returnUrl: url,
        updateParent: true
      });

      // Otherwise we have no choice but to return to the merchant
      if (!result) {
        _logger.$logger.info('postFalseHardRedirect');
        _squid.$util.redirect(url);
      }
    }
  }
  var paymentToken = _angular.$rootScope.token;
  var payee = _index2.$CheckoutPayeeModel.instance(paymentToken);
  var merchantId = payee.get('merchant.id');
  var userStatus = function userStatus() {
    _logger.$logger.info('redirected_user_still_on_page_second_checkpoint', {
      merchantId: merchantId
    });
    if (!_squid.$config.deploy.isLocal()) {
      // If user is still present on this screen, redirect buyer to generic message page when merchant is whitelisted.
      // some merchants want the spinner to be displayed until they take necessary action at their end.
      // These merchants can be put in black list and we can do ramp as well for rest of the merchants if PO wants it.
      (0, _squid.$elmo)('show_end_of_flow', {
        uid: merchantId
      }, 'Trmt_show_end_of_flow').then(function (elmoResult) {
        if (elmoResult && elmoResult.treatment_name) {
          _angular.$rootScope.allowStateChangeAfterRedirect = true;
          _angular.$rootScope.$emit('loaded');
          _angular.$window.onunload = _angular.$window.onbeforeunload = function () {// eslint-disable no-empty-function
          };
          return _uiRouter.$state.go('checkout.genericMessage', {
            code: 'PAYMENT_SUCCESS_REDIRECT_FAILED',
            returnUrl: url
          })["catch"](function (err) {
            _logger.$logger.info('app_redirect_to_merchant_generic_message_error', {
              error: err && err.message
            });
          });
        }
      })["catch"](function (err) {
        // In case elmo call fails, just log and do not do any action.
        _logger.$logger.error('elmo_call_failed', {
          error: err.stack || err.toString()
        });
      });
    }
  };
  var timeout = _squid.$config.idleTimeoutPostRedirectSuccess;
  (0, _angular.$timeout)(function () {
    _logger.$logger.info('redirected_user_still_on_page_first_checkpoint');
    (0, _angular.$timeout)(userStatus, timeout);
  }, timeout);
}
function postToMerchant(msg) {
  try {
    msg = _angular["default"].toJson(msg, 0);

    // If we are not in IE, attempt to send a postMessage
    if (_angular.$window.opener && (_angular.$window.navigator.userAgent.match(/edge/i) || _angular.$window.opener.postMessage && !_angular.$window.navigator.userAgent.match(/msie|trident/i))) {
      _angular.$window.opener.postMessage(msg, '*');
      _logger.$logger.info('minibrowser_postmessage');
      return true;
    }
    // Otherwise, attempt to send a message through the iframe bridge
    var bridge = _angular.$window.opener && _angular.$window.opener.frames && _angular.$window.opener.frames.length && _angular.$window.opener.frames.PayPalBridge;
    if (bridge && bridge.returnToParent) {
      bridge.returnToParent(msg);
      _logger.$logger.info('minibrowser_bridgemessage');
      return true;
    }
    _logger.$logger.warn('minibrowser_nopostback');
  } catch (err) {
    _logger.$logger.error('minibrowser_postback_error', {
      error: err.stack || err.toString()
    });
  }
  return false;
}
function postTo(url, msg) {
  // prevent xss attacks
  if (url && (0, _squid.isUnsafeRedirect)(url)) {
    _logger.$logger.error('unsafe_redirect_url', {
      url: url
    });
    throw new Error('Unsafe redirect url: ' + url);
  }
  var form = document.createElement('form');
  form.method = 'POST';
  form.action = url;
  form.className = 'hide';
  for (var key in msg) {
    var input = document.createElement('input');
    input.name = key;
    input.value = msg[key];
    form.appendChild(input);
  }
  _angular.$window.document.body.appendChild(form);
  form.submit();
  _logger.$logger.info('web_postmessage');
  return true;
}
var $ReturnToMerchant = exports.$ReturnToMerchant = {
  goTo: goTo,
  postToMerchant: postToMerchant,
  postTo: postTo
};
_angular["default"].value("goTo", goTo);
_angular["default"].value("postToMerchant", postToMerchant);
_angular["default"].value("postTo", postTo);
_angular["default"].value("$ReturnToMerchant", $ReturnToMerchant);
_index.$DeviceInfo;
_logger.$logger;
_uiRouter.$state;
_squid.$util;
_squid.$config;
_squid.$elmo;
_squid.isUnsafeRedirect;
_index2.$CheckoutCartModel;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutPayeeModel;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/factory.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$ShippingChangeFactory = $ShippingChangeFactory;
var _util = __webpack_require__("../node_modules/xo-shipping-change/src/util.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function $ShippingChangeFactory(_ref) {
  var checkoutAppData = _ref.checkoutAppData,
    checkoutCart = _ref.checkoutCart,
    appName = _ref.appName;
  return {
    getCartTotal: function getCartTotal() {
      return (0, _util.getCartTotal)(checkoutCart);
    },
    getPayload: function getPayload(shippingAddress) {
      var paymentID = checkoutAppData.get('payment_id');
      var orderID = checkoutAppData.get('id');
      return (0, _util.getPayload)({
        orderID: orderID,
        paymentID: paymentID,
        shippingAddress: shippingAddress,
        checkoutCart: checkoutCart
      });
    },
    updateCart: function updateCart() {
      return (0, _util.updateCart)(checkoutCart);
    },
    callOnShippingChange: function callOnShippingChange(payload) {
      var allowChangeShipping = checkoutAppData.get('flags.allow_change_shipping', false);
      if (!allowChangeShipping) {
        return (0, _squid.$promise)({
          cartHasChanged: false,
          rejected: false
        });
      }
      return (0, _util.callOnShippingChange)({
        payload: payload,
        checkoutCart: checkoutCart,
        appName: appName
      });
    }
  };
}
angular.value("$ShippingChangeFactory", $ShippingChangeFactory);
_util.getCartTotal;
_util.getPayload;
_util.updateCart;
_util.callOnShippingChange;
_squid.$promise;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/outputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.payloadOutputMapper = exports.breakdownOutputMapper = exports.amountOutputMapper = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var breakdownOutputMapper = exports.breakdownOutputMapper = function breakdownOutputMapper(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    subtotal = _ref.subtotal,
    item_total = _ref.item_total,
    shipping = _ref.shipping,
    handling = _ref.handling,
    tax = _ref.tax,
    tax_total = _ref.tax_total,
    insurance = _ref.insurance,
    shipping_discount = _ref.shipping_discount,
    discount = _ref.discount;
  var breakdown = {
    item_total: subtotal || item_total,
    tax_total: tax || tax_total,
    handling: handling,
    shipping: shipping,
    insurance: insurance,
    discount: discount,
    shipping_discount: shipping_discount
  };
  return Object.keys(breakdown).reduce(function (newBreakdown, item) {
    var _$util$extend;
    if (!breakdown[item]) {
      return newBreakdown;
    }
    return _squid.$util.extend(newBreakdown, (_$util$extend = {}, _$util$extend[item] = amountOutputMapper(breakdown[item]), _$util$extend));
  }, {});
};
var amountOutputMapper = exports.amountOutputMapper = function amountOutputMapper(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    amount = _ref2.amount,
    value = _ref2.value,
    currency = _ref2.currency,
    currency_code = _ref2.currency_code,
    breakdown = _ref2.breakdown;
  var fullAmount = {
    value: amount || value,
    currency_code: currency || currency_code
  };
  return breakdown ? _squid.$util.extend(fullAmount, {
    breakdown: breakdownOutputMapper(breakdown)
  }) : fullAmount;
};
var shippingAddressMapper = function shippingAddressMapper(_temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3,
    city = _ref3.city,
    state = _ref3.state,
    country_code = _ref3.country_code,
    postal_code = _ref3.postal_code;
  return {
    city: city,
    state: state,
    country_code: country_code,
    postal_code: postal_code
  };
};
var shippingOptionMapper = function shippingOptionMapper(_temp4) {
  var _ref4 = _temp4 === void 0 ? {} : _temp4,
    id = _ref4.id,
    label = _ref4.label,
    type = _ref4.type,
    amount = _ref4.amount,
    selected = _ref4.selected;
  if (!id) {
    return undefined;
  }
  return {
    id: id,
    type: type,
    label: label,
    amount: amountOutputMapper(amount),
    selected: selected
  };
};
var payloadOutputMapper = exports.payloadOutputMapper = function payloadOutputMapper(_ref5, appName) {
  var orderID = _ref5.orderID,
    paymentID = _ref5.paymentID,
    shipping_address = _ref5.shipping_address,
    amount = _ref5.amount,
    selected_shipping_option = _ref5.selected_shipping_option;
  return {
    orderID: orderID,
    paymentID: paymentID,
    paymentToken: orderID,
    selected_shipping_option: shippingOptionMapper(selected_shipping_option),
    shipping_address: shippingAddressMapper(shipping_address),
    amount: amountOutputMapper(amount),
    appName: appName
  };
};
_squid.$util;

/***/ }),

/***/ "../node_modules/xo-shipping-change/src/util.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.callOnShippingChange = callOnShippingChange;
exports.getCartTotal = getCartTotal;
exports.getPayload = getPayload;
exports.updateCart = updateCart;
var _xoShippingOptions = __webpack_require__("../node_modules/xo-shipping-options/src/index.js");
var _outputMapper = __webpack_require__("../node_modules/xo-shipping-change/src/outputMapper.js");
function getCartTotal(cart) {
  var isPurchaseTransaction = cart && cart.get('purchase');
  if (isPurchaseTransaction) {
    var breakdown = Object.keys(cart.get('purchase.amounts')).reduce(function (acc, value) {
      if (value !== 'total') {
        acc[value] = (0, _outputMapper.amountOutputMapper)(cart.get("purchase.amounts." + value));
      }
      return acc;
    }, {});
    return {
      currency_code: cart.get('purchase.amounts.total.currency_code'),
      value: cart.get('purchase.amounts.total.amount'),
      breakdown: breakdown
    };
  }
  return {
    currency_code: '',
    value: '0.00',
    breakdown: {}
  };
}
function getPayload(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    orderID = _ref.orderID,
    paymentID = _ref.paymentID,
    _ref$shippingAddress = _ref.shippingAddress,
    shippingAddress = _ref$shippingAddress === void 0 ? {} : _ref$shippingAddress,
    checkoutCart = _ref.checkoutCart;
  var city = shippingAddress.city,
    state = shippingAddress.state,
    country = shippingAddress.country,
    postal_code = shippingAddress.postal_code;
  var amount = checkoutCart ? getCartTotal(checkoutCart) : {};
  var shippingChangePayload = {
    orderID: orderID,
    paymentID: paymentID,
    shipping_address: {
      city: city,
      state: state,
      country_code: country,
      postal_code: postal_code
    },
    selected_shipping_option: undefined,
    amount: amount
  };
  return (0, _xoShippingOptions.getSelectedShippingOption)(orderID).then(function (option) {
    shippingChangePayload.selected_shipping_option = option;
  }).then(function () {
    return (0, _outputMapper.payloadOutputMapper)(shippingChangePayload);
  });
}
function updateCart(cart) {
  cart.invalidate();
  cart.api.cache = false;
  return cart.reload().then(function () {
    return getCartTotal(cart);
  });
}
function callOnShippingChange(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
    payload = _ref2.payload,
    checkoutCart = _ref2.checkoutCart,
    appName = _ref2.appName;
  var rejected = false;
  var shippingOptionsChanged = false;
  var shippingOptions;
  var shippingChangeActions = {
    reject: function reject() {
      rejected = true;
    }
  };
  var cartTotal = getCartTotal(checkoutCart);
  var changedShippingOptions = function changedShippingOptions(oldOptions, newOptions) {
    if (oldOptions === void 0) {
      oldOptions = [];
    }
    if (newOptions === void 0) {
      newOptions = [];
    }
    if (oldOptions.length !== newOptions.length) {
      return true;
    }
    return Boolean(newOptions.filter(function (key) {
      return JSON.stringify(newOptions[key]) !== JSON.stringify(oldOptions[key]);
    }).length);
  };
  return (0, _xoShippingOptions.getShippingOptions)(payload.orderID).then(function (options) {
    return shippingOptions = options;
  }).then(function () {
    return window.xprops.onShippingChange((0, _outputMapper.payloadOutputMapper)(payload, appName), shippingChangeActions);
  }).then(function () {
    return (0, _xoShippingOptions.getShippingOptions)(payload.orderID);
  }).then(function (options) {
    shippingOptionsChanged = changedShippingOptions(shippingOptions, options);
  }).then(function () {
    return updateCart(checkoutCart);
  }).then(function (total) {
    var newCartTotal = getCartTotal(checkoutCart);
    var cartHasChanged = cartTotal.currency_code !== newCartTotal.currency_code || cartTotal.value !== newCartTotal.value;
    return {
      cartHasChanged: cartHasChanged || shippingOptionsChanged,
      rejected: rejected
    };
  });
}
_xoShippingOptions.getSelectedShippingOption;
_xoShippingOptions.getShippingOptions;
_outputMapper.amountOutputMapper;
_outputMapper.payloadOutputMapper;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
__webpack_require__("../node_modules/xo-address-components/src/address-display/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/tabs/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/select-simple/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-shipping-options/src/component/template.html"));
__webpack_require__("../node_modules/xo-shipping-options/src/component/styles.less");
var _TYPE_CONTENT_MAPPING, _TAB_CONTENT_MAPPING;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SHIPPING_TYPE = {
  SHIPPING: 'SHIPPING',
  PICKUP: 'PICKUP'
};
var TYPE_CONTENT_MAPPING = (_TYPE_CONTENT_MAPPING = {}, _TYPE_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING] = 'shipping.shipHome', _TYPE_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP] = 'shipping.shipStore', _TYPE_CONTENT_MAPPING);
var TAB_CONTENT_MAPPING = (_TAB_CONTENT_MAPPING = {}, _TAB_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING] = 'shipping.shipItTab', _TAB_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP] = 'shipping.pickItUp', _TAB_CONTENT_MAPPING);
var _default = exports["default"] = _squid.$Component.extend('$xoShippingOptionsComponent', {
  tag: 'xo-shipping-options',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    methods: {
      type: 'var',
      required: true
    },
    selectedMethod: {
      type: 'var',
      required: false
    },
    onSelect: {
      type: 'var',
      required: false
    },
    onClickEdit: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        checkoutAppData: _index.$CheckoutAppDataModel.instance(this.props.token).retrieve()["catch"](_angular.noop),
        checkoutSession: _index.$CheckoutSessionModel.instance(this.props.token).retrieve()["catch"](_angular.noop)
      };
    }
  },
  actions: {
    // Takes the buyer to the change-shipping page
    gotoShipping: function gotoShipping() {
      if (!this.canChangeShipping) {
        return;
      }
      if (typeof this.onClickEdit === 'function') {
        return this.onClickEdit();
      }
      _uiRouter.$state.go('checkout.review.sidebar.shipping');
    },
    setTab: function setTab(tab) {
      this.actions.setStateTo(tab.id);
    },
    getTabs: function getTabs() {
      if (!this.methods || !this.methods.length) {
        return [];
      }
      var hasShipping = Boolean(this.methods.filter(function (method) {
        return method.type === SHIPPING_TYPE.SHIPPING;
      }).length);
      var hasPickup = Boolean(this.methods.filter(function (method) {
        return method.type === SHIPPING_TYPE.PICKUP;
      }).length);
      var shippingTab = {
        id: SHIPPING_TYPE.SHIPPING,
        label: (0, _squid.$renderContent)(TAB_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING]).toString()
      };
      var pickupTab = {
        id: SHIPPING_TYPE.PICKUP,
        label: (0, _squid.$renderContent)(TAB_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP]).toString()
      };
      return [hasShipping && shippingTab, hasPickup && pickupTab].filter(function (tab) {
        return tab;
      });
    },
    // Switches the active tab (pickup or shipping)
    // Auto-selects method if it's the only item, or auto-selects if it was pre-selected
    // Will not auto-select if second param is false
    setStateTo: function setStateTo(state, autoSelect) {
      var _this = this;
      if (autoSelect === void 0) {
        autoSelect = true;
      }
      this.state = state;
      var getSelectedTab = function getSelectedTab() {
        return _this.tabs.filter(function (tab) {
          return tab.id === _this.state;
        }).pop();
      };
      this.selectedTab = getSelectedTab();
      if (!this.methods || !this.methods.length || !this.selectedTab || !autoSelect) {
        return;
      }
      var hasMultiShippingMethods = this.shippingMethods && this.shippingMethods.length > 1;
      var hasMultiPickupMethods = this.pickupMethods && this.pickupMethods.length > 1;
      if (state === SHIPPING_TYPE.SHIPPING) {
        if (this.selectedShippingMethod) {
          return this.actions.selectShippingMethod(this.selectedShippingMethod);
        } else if (hasMultiShippingMethods) {
          this.showMissingShippingOptionMessage = true;
          this.missingShippingOptionMessage = {
            msgKeys: ['shippingMethod.shippingMethodWarning'],
            type: 'warning'
          };

          // the second two parameters of onSelect only apply to hermes and trigger a change
          // in the application to stop the payNow function

          this.onSelect(null, this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
        }
        if (!hasMultiShippingMethods && this.shippingMethods && this.shippingMethods.length) {
          return this.actions.selectShippingMethod(this.shippingMethods[0]);
        }
      }
      if (state === SHIPPING_TYPE.PICKUP) {
        if (this.selectedPickupMethod) {
          return this.actions.selectShippingMethod(this.selectedPickupMethod);
        } else if (hasMultiPickupMethods) {
          this.showMissingPickupOptionMessage = true;
          this.missingPickupOptionMessage = {
            msgKeys: ['shippingMethod.pickupMethodWarning'],
            type: 'warning'
          };

          // the second two parameters of onSelect only apply to hermes and trigger a change
          // in the application to stop the payNow function

          this.onSelect(null, this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
        }
        if (!hasMultiPickupMethods && this.pickupMethods && this.pickupMethods.length) {
          return this.actions.selectShippingMethod(this.pickupMethods[0]);
        }
      }
    },
    // Set the local selected pickup/shipping method, then call the
    // callback passed via props with the method
    selectShippingMethod: function selectShippingMethod(selected, callCallback) {
      var _this2 = this;
      if (callCallback === void 0) {
        callCallback = true;
      }
      var getShippingMethodByID = function getShippingMethodByID(id) {
        if (!id) {
          return false;
        }
        return _this2.methods.find(function (method) {
          return method.id === id;
        });
      };
      var shippingMethod = getShippingMethodByID(selected && selected.id);
      if (shippingMethod === undefined) {
        this.selectedPickupMethod = false;
        this.selectedShippingMethod = false;
        return this.onSelect(null);
      }
      if (!this.state !== selected.type) {
        this.actions.setStateTo(SHIPPING_TYPE[selected.type], false);
      }
      if (this.state === SHIPPING_TYPE.SHIPPING) {
        this.showMissingShippingOptionMessage = false;
        this.selectedShippingMethod = this.formatShippingMethod(shippingMethod);
      } else if (this.state === SHIPPING_TYPE.PICKUP) {
        this.showMissingPickupOptionMessage = false;
        this.selectedPickupMethod = this.formatShippingMethod(shippingMethod);
      } else {
        this.state = SHIPPING_TYPE.SHIPPING;
      }
      if (callCallback) {
        this.onSelect((0, _angular.extend)({}, shippingMethod), this.showMissingShippingOptionMessage, this.showMissingPickupOptionMessage);
      }
    },
    // Helper to map shipping methods passed by the props and
    // select only the ones that fit the 'type'.
    mapShippingMethodsByType: function mapShippingMethodsByType(shippingMethods, type) {
      var _this3 = this;
      if (shippingMethods === void 0) {
        shippingMethods = [];
      }
      return shippingMethods.filter(function (shippingMethod) {
        return SHIPPING_TYPE[shippingMethod.type] === type;
      }).map(function (shippingMethod) {
        return _this3.formatShippingMethod(shippingMethod);
      });
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this4 = this;
      this.formatShippingMethod = function (method) {
        if (!method || (0, _angular.equals)(method, {})) {
          return false;
        }
        var getFormattedLabel = function getFormattedLabel() {
          if (!method.amount || parseFloat(method.amount.value) <= 0) {
            return method.label;
          }
          var amountFormatted = (0, _squid.formatCurrency)(method.amount.value, method.amount.currency_code || method.amount.currency);
          return (0, _squid.$renderContent)('shipping.customLabelAndAmount', {
            amount: amountFormatted,
            label: method.label
          }).toString();
        };
        return (0, _angular.extend)({}, method, {
          label: getFormattedLabel()
        });
      };

      // Dropdown active flag
      this.isPickupDropdownActive = false;
      this.isShippingDropdownActive = false;

      // Initiate the shipWarning messages
      if (this.selectedMethod) {
        var type = this.selectedMethod.type;
        if (type === 'SHIPPING') {
          this.showMissingPickupOptionMessage = false;
          this.showMissingShippingOptionMessage = true;
        } else {
          this.showMissingPickupOptionMessage = true;
          this.showMissingShippingOptionMessage = false;
        }
      }
      this.isPickup = function () {
        return _this4.state === SHIPPING_TYPE.PICKUP;
      };
      this.isShipping = function () {
        return _this4.state === SHIPPING_TYPE.SHIPPING;
      };
      this.pickupLabel = (0, _squid.$renderContent)(TYPE_CONTENT_MAPPING[SHIPPING_TYPE.PICKUP]).toString();
      this.shippingLabel = (0, _squid.$renderContent)(TYPE_CONTENT_MAPPING[SHIPPING_TYPE.SHIPPING]).toString();
      this.selectedPickupMethod = false; // eslint-disable-line no-unused-expressions
      this.selectedShippingMethod = false; // eslint-disable-line no-unused-expressions

      this.formatShippingMethods = function () {
        _this4.pickupMethods = _this4.actions.mapShippingMethodsByType(_this4.methods, SHIPPING_TYPE.PICKUP);
        _this4.shippingMethods = _this4.actions.mapShippingMethodsByType(_this4.methods, SHIPPING_TYPE.SHIPPING);
        if (_this4.selectedMethod) {
          _this4.actions.selectShippingMethod(_this4.selectedMethod, false);
        } else if (_this4.methods && _this4.methods.length) {
          _this4.actions.setStateTo((_this4.shippingMethods.length ? _this4.shippingMethods : _this4.pickupMethods)[0].type);
        } else {
          _this4.state = SHIPPING_TYPE.SHIPPING;
        }
      };
      this.$watch('methods', (0, _lodash.once)(function () {
        _this4.formatShippingMethods();
      }));
      this.tabs = this.actions.getTabs();

      // We'll render dual tabs ONLY when there are TWO Shipping types sent by the merchant
      this.renderTabs = Boolean(this.tabs.length > 1);

      // when clicking outside the dropdown
      this.$on('clickBody', function () {
        _this4.isPickupDropdownActive = false;
        _this4.isShippingDropdownActive = false;
      });
    },
    populate: function populate() {
      var allowChangeShipping = this.models.checkoutAppData.get('flags.allow_change_shipping');

      // Only allow buyer to change shipping address if allowed
      this.canChangeShipping = typeof this.onClickEdit === 'function' || allowChangeShipping;
      this.showShippingAddress = Boolean(!this.models.checkoutAppData.flags.hide_shipping_address && this.models.checkoutSession && this.models.checkoutSession.shipping);
    }
  }
});
_angular.noop;
_angular.extend;
_angular.equals;
_uiRouter.$state;
_lodash.once;
_squid.$Component;
_squid.$renderContent;
_squid.formatCurrency;
_index.$CheckoutAppDataModel;
_index.$CheckoutSessionModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/component/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"shippingOptionsForm\" content>\n    <xo-ui-tabs\n        ng-if=\"renderTabs\"\n        on-select=\"actions.setTab\"\n        selected-tab=\"selectedTab\"\n        tabs=\"tabs\"\n    ></xo-ui-tabs>\n\n    <!-- Shipping Tab -->\n    <div ng-if=\"isShipping()\">\n\n        <!--Address display section-->\n        <div\n            ng-if=\"showShippingAddress\"\n            id=\"shippingAddress\"\n            class=\"address focusable\"\n            ng-class=\"{ noTop: !renderTabs, editable:canChangeShipping}\"\n            focusable=\"canChangeShipping\"\n            select-button ng-click=\"actions.gotoShipping()\">\n            <span class=\"given-name\">{{models.checkoutSession.shipping.name}}</span>\n            <xo-address-display\n                token=\"token\"\n                address=\"models.checkoutSession.shipping\"\n            ></xo-address-display>\n            <a\n                ng-if=\"canChangeShipping\"\n                class=\"edits changeShipping ng-class:{disabled:cannotChangeShippingInfoMessages}\"\n                data-test-id=\"shipToChangeLink\"\n                select-button focusable=\"!cannotChangeShippingInfoMessages\"\n                ng-click=\"actions.gotoShipping()\"\n                aria-label=\"{{ content('shippingAddress.label') }}\"\n                focus-when-state=\"checkout.review.sidebar.shipping\"\n                transitions-to=\"checkout.review\">\n                {{ content('common.change') }}\n                <span class=\"frontArrow goTray ng-scope ng-class:{disabled:cannotChangeShippingInfoMessages}\"></span>\n            </a>\n        </div>\n\n        <div ng-if=\"!models.checkoutSession.shipping\">\n            <p class=\"optionTypeInfo\" ng-class=\"{ noTop: !renderTabs }\" ng-bind-html=\"content('shippingMethod.guestMerchantOptions')\">\n        </div>\n\n        <div class=\"missing-message\">\n            <xo-message ng-if=\"showMissingShippingOptionMessage\" message=\"missingShippingOptionMessage\"></xo-message>\n        </div>\n\n        <xo-ui-select-simple\n            ng-if=\"shippingMethods.length > 1\"\n            default-text=\"content('shipping.selectShippingMethod').toString()\"\n            label=\"shippingLabel\"\n            options=\"shippingMethods\"\n            selected-option=\"selectedShippingMethod\"\n            on-select=\"actions.selectShippingMethod\"\n        ></xo-ui-select-simple>\n\n        <div ng-if=\"shippingMethods.length === 1 && selectedShippingMethod\">\n            <p class=\"optionSelected\" ng-bind-html=\"selectedShippingMethod.label\">\n        </div>\n    </div>\n\n    <!-- Pick Up Tab -->\n    <div ng-if=\"isPickup()\" class=\"pickupSelection\">\n\n        <div>\n            <p class=\"optionTypeInfo\" ng-class=\"{ noTop: !renderTabs }\" ng-bind-html=\"content('shippingMethod.guestMerchantOptions')\">\n        </div>\n\n        <div class=\"missing-message\">\n            <xo-message class=\"missing-message\" ng-if=\"showMissingPickupOptionMessage\" message=\"missingPickupOptionMessage\"></xo-message>\n        </div>\n\n        <xo-ui-select-simple\n            ng-if=\"pickupMethods.length > 1\"\n            default-text=\"content('shipping.selectPickUpLocation').toString()\"\n            label=\"pickupLabel\"\n            options=\"pickupMethods\"\n            selected-option=\"selectedPickupMethod\"\n            on-select=\"actions.selectShippingMethod\">\n        </xo-ui-select-simple>\n\n        <div ng-if=\"pickupMethods.length === 1 && selectedPickupMethod\">\n            <p class=\"optionSelected\" ng-bind-html=\"selectedPickupMethod.label\">\n        </div>\n    </div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _exportNames = {
  $xoShippingOptions: true
};
exports.$xoShippingOptions = void 0;
var _directive = __webpack_require__("../node_modules/xo-shipping-options/src/component/directive.js");
exports.$xoShippingOptions = _directive.$xoShippingOptions;
var _lib = __webpack_require__("../node_modules/xo-shipping-options/src/lib/index.js");
Object.keys(_lib).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _lib[key]) return;
  exports[key] = _lib[key];
});

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/api.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.selectShippingOption = exports.getShippingOptions = exports.getSelectedShippingOption = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _cart = __webpack_require__("../node_modules/xo-shipping-options/src/lib/cart.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
/*
    Shipping Option API

    For now, this is strictly client-side and comes from the
    incontext flow.
*/

var getShippingOptions = exports.getShippingOptions = function getShippingOptions(token) {
  var checkoutCart = _checkout.$CheckoutCartModel.instance(token);
  return checkoutCart.reload().then(function () {
    var shippingOptions = checkoutCart.get('purchaseUnits.0.item_list.shipping_options');
    if (shippingOptions && shippingOptions.length) {
      _logger.$logger.info('shipping_options_from_cart', shippingOptions);
    } else {
      _logger.$logger.info('no_shipping_options_from_cart');
      return;
    }
    return shippingOptions.map(function (options) {
      return {
        id: options.id,
        type: options.type,
        amount: options.amount,
        label: options.label,
        selected: options.selected
      };
    });
  });
};
var getSelectedShippingOption = exports.getSelectedShippingOption = function getSelectedShippingOption(token) {
  return getShippingOptions(token).then(function (shippingOptions) {
    if (!shippingOptions || !shippingOptions.length) {
      return undefined;
    }
    var selectedShippingOption = shippingOptions.filter(function (option) {
      return option.selected;
    }).pop();
    if (selectedShippingOption) {
      _logger.$logger.info('selected_shipping_option_from_cart', selectedShippingOption);
      return selectedShippingOption;
    } else {
      _logger.$logger.info('no_shipping_option_from_cart');
    }
  });
};
var buildAmountPatchEntity = function buildAmountPatchEntity(amount, token) {
  return {
    field: 'purchaseAmount',
    value: (0, _cart.retotalCart)(token, !!amount && !!amount.value ? amount.value : '0.00')
  };
};
var selectShippingOption = exports.selectShippingOption = function selectShippingOption(token, option) {
  var checkoutCart = _checkout.$CheckoutCartModel.instance(token);
  var checkoutSession = _checkout.$CheckoutSessionModel.instance(token);
  return checkoutCart.retrieve().then(function () {
    return getShippingOptions(token);
  }).then(function (shippingOptions) {
    var newShippingOptions = shippingOptions.map(function (newOption) {
      return _squid.$util.extend(newOption, {
        selected: option.id === newOption.id
      });
    });
    var shippingOptionsPatch = {
      field: 'shippingOptions',
      value: newShippingOptions
    };
    var cartAmountPatch = buildAmountPatchEntity(option.amount, token);

    // add cartAmountPatch to the patchEntities array if option.amount is not null
    return checkoutCart.action('patchCartData', {
      data: {
        id: token,
        patchEntities: [shippingOptionsPatch, cartAmountPatch]
      }
    }).then(function (result) {
      return checkoutSession.reload().then(function () {
        return result;
      });
    });
  });
};
_squid.$util;
_logger.$logger;
_cart.retotalCart;
_checkout.$CheckoutCartModel;
_checkout.$CheckoutSessionModel;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/cart.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.retotalCart = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
// Re-totals the cart with new shipping costs.
//
// @param token: PAY token/Cart ID
// @param shippingAmount: String float amount (Ex: '15.00')
// @returns amount: Amount object with new total and breakdown

var retotalCart = exports.retotalCart = function retotalCart(token, shippingAmount) {
  var checkoutCart = _checkout.$CheckoutCartModel.instance(token);
  var currencyCode = checkoutCart.grossTotalAmount.currency;
  var currencyDigits = _squid.$locale.metadata && _squid.$locale.metadata.currency && _squid.$locale.metadata.currency.digits;
  var decimalDigits = isNaN(currencyDigits && currencyDigits[currencyCode]) ? 2 : currencyDigits && currencyDigits[currencyCode];

  // Takes an integer/string and formats as a float
  var formatAmount = function formatAmount(amount) {
    return parseFloat(amount).toFixed(decimalDigits);
  };

  // Sums all of the arguments
  var sumAmounts = function sumAmounts() {
    for (var _len = arguments.length, amounts = new Array(_len), _key = 0; _key < _len; _key++) {
      amounts[_key] = arguments[_key];
    }
    return amounts.reduce(function (total, amount) {
      return formatAmount(parseFloat(total) + parseFloat(amount));
    }, '0');
  };

  // Sums up all of the amount details (except the total)
  var sumDetails = function sumDetails(details, blacklist) {
    if (blacklist === void 0) {
      blacklist = [];
    }
    return Object.keys(details).reduce(function (value, detail) {
      var detailValue = details[detail];
      if (blacklist.indexOf(detail) !== -1) {
        return value;
      }
      switch (detail) {
        case 'shipping_discount':
        case 'discount':
          return sumAmounts(formatAmount(parseFloat(detailValue) * -1), value);
        default:
          return sumAmounts(details[detail], value);
      }
    }, '0');
  };

  // Simplifies the checkout cart amounts with just a simple key-value { detail: cost } format
  var oldTotal = checkoutCart.get('purchase.amounts.total.amount', formatAmount(0));
  var oldDetails = Object.keys(checkoutCart.get('purchase.amounts', {})).reduce(function (details, name) {
    var _extend;
    var amount = checkoutCart.get("purchase.amounts." + name + ".amount", formatAmount(0));
    return name === 'total' ? details : (0, _angular.extend)({}, details, (_extend = {}, _extend[name] = amount, _extend));
  }, {});

  // Create a new amount details object with new shipping cost, and subtotal (if it was left out)
  var newDetails = (0, _angular.extend)({}, oldDetails, {
    shipping: formatAmount(shippingAmount),
    subtotal: formatAmount(parseFloat(oldTotal) - parseFloat(sumDetails(oldDetails, ['subtotal', 'total'])))
  });

  // Sum up all of the new amount details for the new total
  var newTotal = sumDetails(newDetails, ['total']);
  return {
    currency: currencyCode,
    total: newTotal,
    details: newDetails
  };
};
_squid.$locale;
_angular.extend;
_checkout.$CheckoutCartModel;

/***/ }),

/***/ "../node_modules/xo-shipping-options/src/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _api = __webpack_require__("../node_modules/xo-shipping-options/src/lib/api.js");
Object.keys(_api).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _api[key]) return;
  exports[key] = _api[key];
});
var _cart = __webpack_require__("../node_modules/xo-shipping-options/src/lib/cart.js");
Object.keys(_cart).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cart[key]) return;
  exports[key] = _cart[key];
});

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getUserAgent = getUserAgent;
exports.redirect = redirect;
exports.venmoExperience = exports.thirdPartyInfo = exports.thirdPartyExperience = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _sessionStorage = _interopRequireDefault(__webpack_require__("../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js"));
var _venmoModels = __webpack_require__("../node_modules/xo-third-party-components/src/venmo-models/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// TODO: Check how the cookie should be read/set (through meta? if read on server side)
var PWV_COOKIE = 'pwv';
var BA = 'BILLING_AGREEMENT';
var cancelLogoutEventListener = _angular.$rootScope.$on('logout', function (event, args) {
  // disable venmo models when ready
  var token = _angular.$rootScope.token;
  _venmoModels.$VenmoUserModel.instance(token).invalidate();
  _venmoModels.$VenmoOnboardModel.instance(token).invalidate();
  thirdPartyExperience.resetThirdPartyExperience();
});
_angular.$rootScope.$on('$destroy', cancelLogoutEventListener);
var readCookie = function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0, len = ca.length; i < len; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};
var thirdPartyInfo = exports.thirdPartyInfo = {
  /**
   * @name isThirdPartyEligible
   * @returns {Promise}
   */
  isThirdPartyEligible: function isThirdPartyEligible() {
    var _this = this;
    return this.isBaiduEligible().then(function (baiduEligibility) {
      return _this.isVenmoEligible() || baiduEligibility;
    });
  },
  /**
   * @name isBaiduEligible
   * @returns {Promise}
   */
  isBaiduEligible: function isBaiduEligible() {
    return _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token, {
      params: {
        geolocation: _squid.$meta.geolocation
      }
    }).retrieve().then(function (eligibility) {
      _logger.$logger.info('baidu_eligibility', eligibility);
      return eligibility.baiduWallet;
    });
  },
  /**
   * @name isVenmoEligible
   * @description Handler to call to determine if user can use Venmo
   * @returns {Boolean}
   */
  isVenmoEligible: function isVenmoEligible() {
    var appData = _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token);
    var cart = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
    var merchantCountry = appData.get('merchant.merchant_country');
    var isProcessorDeclined = appData.get('flags.processor_declined');
    var isInvoice = appData.get('flags.is_invoice_flow');
    var isBillingAgreement = cart.isBilling();
    var isMobile = _index.$DeviceInfo.isDevice();
    var isVenmoCookie = this.isVenmoCookiePresent();
    var isSFAuthenticationSession = _squid.$util.param('bt_int_type') === '2';
    var isMSPTransaction = cart.isMultiSellerPurchase();
    var eligibilityParams = {
      isMobile: isMobile,
      isVenmoCookie: isVenmoCookie,
      isNotInvoice: !isInvoice,
      isNotProcessorDeclined: !isProcessorDeclined,
      isNotBillingAgreement: !isBillingAgreement,
      isUSMerchant: merchantCountry === 'US',
      isNotSFAuthenticationSession: !isSFAuthenticationSession,
      isNotMSPTransaction: !isMSPTransaction
    };
    var venmoEligibility = Object.keys(eligibilityParams).filter(function (param) {
      return !eligibilityParams[param];
    });
    venmoEligibility = venmoEligibility && venmoEligibility.length > 0 ? "ineligible:" + venmoEligibility.join() : "eligible";
    _logger.$logger.info('venmo_eligibility', venmoEligibility);
    _logger.$logger.info('checkout_fpti', {
      'is_venmo_cookie': isVenmoCookie ? '1' : '0',
      'eligibility_reason': venmoEligibility
    });
    return Boolean(venmoEligibility === 'eligible');
  },
  /**
   * @name isVenmoCookiePresent
   * @returns {Boolean}
   */
  isVenmoCookiePresent: function isVenmoCookiePresent() {
    var cookieValue = readCookie(PWV_COOKIE);
    return Boolean(cookieValue);
  },
  /**
   * @name buildVenmoURL
   * @description Build the venmo URL scheme
   * @returns {String}
   */
  buildVenmoURL: function buildVenmoURL() {
    // SCHEME needs to change according to old or new experience
    // const linkType = venmoUrlSchemeType();
    var SCHEME = _squid.$config.urls && _squid.$config.urls.venmoAppSwitchURL['universal'];
    var VENMO_ROUTE = '#/checkout/venmo';
    var LOGIN_ROUTE = '#/checkout/login?venmoError=true';
    var cartModel = _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token);
    var token;
    var total;
    var currency;
    var intent;

    // Send BA token when it's BA without Purchase
    if (cartModel.get('billing.ba_token') && cartModel.get('purchase.amounts.total.amount', '0') === '0') {
      token = cartModel.get('billing.ba_token');
    } else {
      // Send EC token when it's BA without purchase.
      token = _angular.$rootScope.token;
    }

    // For BA: setting billing agreement as payment_action explicitly, not relying on payment action returned in cart
    intent = cartModel.billing ? BA : cartModel.payment_action;

    // total cannot be undefined, outdated venmo app clients will crash otherwise
    total = cartModel.get('purchase.amounts.total.amount', '0');
    currency = cartModel.get('purchase.amounts.total.currency_code', 'none');
    var params = (0, _angular.$httpParamSerializer)({
      'x-success': _angular.$location.absUrl().replace(/#.*$/, VENMO_ROUTE),
      'x-failure': _angular.$location.absUrl().replace(/#.*$/, LOGIN_ROUTE),
      'ua': _angular.$window.navigator.userAgent,
      'merchant_id': _checkout.$CheckoutPayeeModel.instance(_angular.$rootScope.token).getId(),
      'token': token,
      total: total,
      currency: currency,
      // can be undefined for BA w/o purchase
      intent: intent
    });
    return SCHEME + "?" + params;
  }
};
var venmoExperienceKey = 'VENMO_EXPERIENCE';

// Get whether a token is marked as Venmo experience.
var venmoExperience = exports.venmoExperience = {
  set: function set(token) {
    var sessionStorage = (0, _sessionStorage["default"])();
    sessionStorage.setItem(venmoExperienceKey, token);
  },
  get: function get(token) {
    var auth = _auth.$AuthModel.instance();
    var sessionStorage = (0, _sessionStorage["default"])();
    if (auth.logged_in && auth.guest &&
    // Check if Venmo guest account logged in
    sessionStorage.getItem(venmoExperienceKey) === token) {
      return true;
    } else {
      this.set(null);
      return false;
    }
  }
};
var allowedThirdPartyExperiences = {
  VENMO: 'VENMO_EXPERIENCE',
  BAIDU: 'BAIDU_EXPERIENCE'
};
var THIRD_PARTY_NAMESPSACE = 'THIRD_PARTY_EXPERIENCE';
var thirdPartyExperience = exports.thirdPartyExperience = {
  setAsVenmoExperience: function setAsVenmoExperience(token) {
    var _JSON$stringify;
    var sessionStorage = (0, _sessionStorage["default"])();
    var payload = JSON.stringify((_JSON$stringify = {}, _JSON$stringify[token] = allowedThirdPartyExperiences['VENMO'], _JSON$stringify));
    sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
  },
  setAsBaiduExperience: function setAsBaiduExperience(token) {
    var _JSON$stringify2;
    var sessionStorage = (0, _sessionStorage["default"])();
    var payload = JSON.stringify((_JSON$stringify2 = {}, _JSON$stringify2[token] = allowedThirdPartyExperiences['BAIDU'], _JSON$stringify2));
    sessionStorage.setItem(THIRD_PARTY_NAMESPSACE, payload);
  },
  isThirdPartyExperience: function isThirdPartyExperience(token) {
    var availableExperiences = [];
    for (var key in allowedThirdPartyExperiences) {
      availableExperiences.push(allowedThirdPartyExperiences[key]);
    }
    var currentExperience = this.getExperience(token);
    return Boolean(availableExperiences.indexOf(currentExperience) > -1);
  },
  getExperience: function getExperience(token) {
    var auth = _auth.$AuthModel.instance();
    var sessionStorage = (0, _sessionStorage["default"])();

    // if logged in, and guest, we return the experience if any
    if (auth.logged_in && auth.guest && sessionStorage.getItem(THIRD_PARTY_NAMESPSACE)) {
      var payload = JSON.parse(sessionStorage.getItem(THIRD_PARTY_NAMESPSACE) || '');
      return payload && payload[token] || 'MEMBER_EXPERIENCE';
    } else if (auth.logged_in && auth.tenant === 'VENMO') {
      return allowedThirdPartyExperiences['VENMO'];
    } else {
      // If not logged in, we reset the third party experience
      this.resetThirdPartyExperience();
      return 'MEMBER_EXPERIENCE';
    }
  },
  resetThirdPartyExperience: function resetThirdPartyExperience() {
    var sessionStorage = (0, _sessionStorage["default"])();
    sessionStorage.removeItem(THIRD_PARTY_NAMESPSACE);
  }
};

// used to trigger app switches and flush the logs before doing so
function redirect(url) {
  return _logger.$logger.flush().then(function () {
    _angular.$window.location.replace(url);
  });
}

// fetching browser's user agent.
function getUserAgent() {
  return _angular.$window.navigator.userAgent;
}
_squid.$config;
_squid.$util;
_squid.$meta;
_logger.$logger;
_auth.$AuthModel;
_index.$DeviceInfo;
_angular.$rootScope;
_angular.$window;
_angular.$location;
_angular.$httpParamSerializer;
_checkout.$CheckoutPayeeModel;
_checkout.$CheckoutCartModel;
_checkout.$CheckoutAppDataModel;
_checkout.$FlowEligibilityModel;
_venmoModels.$VenmoOnboardModel;
_venmoModels.$VenmoUserModel;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/thirdParty-info/sessionStorage.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports["default"] = getSessionStorage;
var store = {};

// Polyfill for sessionStorage if not available. Simple variable store

function getSessionStorage() {
  try {
    window['sessionStorage'].setItem('__feature_test__', '0');
    window['sessionStorage'].removeItem('__feature_test__');
    return window.sessionStorage;
  } catch (err) {
    return {
      getItem: function getItem(key) {
        if (arguments < 1) {
          throw new Error('1 argument required');
        }
        return store[key];
      },
      setItem: function setItem(key, val) {
        if (arguments < 2) {
          throw new Error('2 arguments required');
        }
        store[key] = val;
      },
      removeItem: function removeItem(key) {
        delete store[key];
      }
    };
  }
}
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-third-party-components/src/venmo-models/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$VenmoUserModel = exports.$VenmoTransactionEligibility = exports.$VenmoSupplementaryInfo = exports.$VenmoOnboardModel = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var $VenmoOnboardModel = exports.$VenmoOnboardModel = _squid.$Model.extend('$VenmoOnboardModel', {
  api: new _squid.$Api({
    uri: '/api/venmo/onboard'
  })
});
var $VenmoUserModel = exports.$VenmoUserModel = _squid.$Model.extend('$VenmoUserModel', {
  api: new _squid.$Api({
    uri: '/api/venmo/user'
  })
});
var $VenmoSupplementaryInfo = exports.$VenmoSupplementaryInfo = _squid.$Model.extend('$VenmoSupplementaryInfo', {
  api: new _squid.$Api({
    uri: '/api/venmo/address'
  }),
  serialize: function serialize() {
    return {
      user: {
        first_name: this.user && this.user.first_name && this.user.first_name.trim(),
        last_name: this.user && this.user.last_name && this.user.last_name.trim()
      },
      billing: {
        line1: this.billing && this.billing.line1 && this.billing.line1.trim(),
        line2: this.billing && this.billing.line2 && this.billing.line2.trim(),
        city: this.billing && this.billing.city && this.billing.city.trim(),
        state: this.billing && this.billing.state && this.billing.state.trim(),
        postal_code: this.billing && this.billing.postal_code && this.billing.postal_code.trim(),
        normalization_status: this.billing && this.billing.normalization_status && this.billing.normalization_status.trim(),
        country: this.billing && this.billing.country && this.billing.country.trim()
      },
      shipping: {
        line1: this.shipping && this.shipping.line1 && this.shipping.line1.trim(),
        line2: this.shipping && this.shipping.line2 && this.shipping.line2.trim(),
        city: this.shipping && this.shipping.city && this.shipping.city.trim(),
        state: this.shipping && this.shipping.state && this.shipping.state.trim(),
        postal_code: this.shipping && this.shipping.postal_code && this.shipping.postal_code.trim(),
        normalization_status: this.shipping && this.shipping.normalization_status && this.shipping.normalization_status.trim(),
        country: this.shipping && this.shipping.country && this.shipping.country.trim()
      },
      shipToBilling: this.shipToBilling
    };
  }
});
var $VenmoTransactionEligibility = exports.$VenmoTransactionEligibility = _squid.$Model.extend('$VenmoTransactionEligibility', {
  api: new _squid.$Api({
    uri: '/api/venmo/:id/eligibility'
  })
});
angular.value("$VenmoOnboardModel", $VenmoOnboardModel);
angular.value("$VenmoUserModel", $VenmoUserModel);
angular.value("$VenmoSupplementaryInfo", $VenmoSupplementaryInfo);
angular.value("$VenmoTransactionEligibility", $VenmoTransactionEligibility);
_squid.$Model;
_squid.$Api;

/***/ }),

/***/ "../node_modules/xo-title/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-title/dist/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
_angular["default"].module().directive('xoTitle', [function () {
  return {
    template: _template["default"],
    restrict: 'E',
    scope: {
      titleTxt: '@?',
      className: '@?',
      tagName: '@?'
    },
    link: function link($scope, $element) {
      if ($scope.tagName) {
        var newEl = document.createElement($scope.tagName || 'h1');
        newEl.className = $scope.className || 'alpha';
        newEl.textContent = '{{ titleTxt }}';
        (0, _angular.$compile)(newEl)($scope);
        $element.empty().append(newEl);
      }
    }
  };
}]);

/***/ }),

/***/ "../node_modules/xo-title/dist/template.html":
/***/ (function(module, exports) {

module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"

/***/ }),

/***/ "../node_modules/xo-tracking/dist/builder.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().factory('$FptiBuilder', function () {
  /**
   *  Build the front-end FPTI event from three data sources
   *      1. the per-product configuration
   *      2. the buzname defined per-route
   *      3. the additional attributes that only available at a specific checkpoint
   *
   */

  return _squid.$Class.extend('FptiBuilder', {
    resolvePageQualifier: function resolvePageQualifier(trackingData) {
      // The pages can populated pageQualifier to override the default one
      this.pageQualifier = trackingData && trackingData.pageQualifier ? trackingData.pageQualifier
      // because 'fullpage' has been widely embedded into routes
      // we had better to keep it as a place holder
      : 'fullpage'; // update later if it's in-context
    },
    build: function build() {
      if (!this.trackingData && !this.error) {
        // do nothing if neither page nor error tracking
        return this;
      }
      this.resolvePageQualifier(this.trackingData);
      this._dataObj = new _model.$FptiDataModel().decorate('base', this.baseData).decorate('buzname', this.trackingData, this.pageQualifier, undefined, this.productOverride).decorate('templateName', this.trackingData, this.pageQualifier).decorate('pageGoal', this.trackingData.pageGoal).decorate('ecToken', this.trackingData.token).decorate('correlationId', (0, _squid.$getLatestCorrelationID)()).decorate('uuid', _model.$CalDataModel.getUUID()).decorate('fieldError', this.error).decorate('pageError', this.error).decorate('pageStartTime', new Date().getTime()).decorate('pxptrackingdata', this.trackingData.pxpData).decorate('transition_time', this.transition_time).decorate('cust', this.cust).decorate('dc', this.dc).decorate('az', this.az).decorate('comp', this.comp).getDataObject(this.isInContext);
      return this;
    },
    toString: function toString() {
      var dataAry = [];
      _angular["default"].forEach(this._dataObj, function (v, k) {
        dataAry.push(k + '=' + v);
      });
      return dataAry.join('&');
    }
  });
});
_squid.$getLatestCorrelationID;
_squid.$Class;
_model.$FptiDataModel;
_model.$CalDataModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/builder.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/button.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().factory('$ButtonTrackingService', function () {
  var _beaconUrl = 'https://www.paypalobjects.com/en_US/i/scr/btn_tracking_pixel.gif?teal=null&Id=null&ru=null';
  var _beaconParams = ['fltk', 'calc', 'page', 'xe', 'xt'];
  var _alreadyFired = false;
  function _strToElements(str) {
    var elements = {};
    if (str && str.length) {
      str.split('&').forEach(function (param) {
        var nvp = param.split('=');
        elements[nvp[0]] = nvp[1];
      });
    }
    return elements;
  }
  function _fireButtonTrackingBeacon(elements) {
    var url = _beaconUrl;
    var xoData = {};
    function buildParam(param, value) {
      var p = '&' + param + '=' + (value ? value : 'null');
      return p;
    }
    function getGUIID(ts) {
      return _strToElements(ts).vr;
    }
    function addToDocument(uri) {
      var img = document.createElement('img');
      img.setAttribute('src', uri);
      document.body.appendChild(img);
    }

    // Get some params from FPTI data.
    _beaconParams.forEach(function (param) {
      url += buildParam(param, elements[param]);
    });

    // Build the rest of the params.
    url += buildParam('fpti', getGUIID(_squid.$cookies && _squid.$cookies.ts));
    url += buildParam('WWW_AKA_MVT_BUTTONS', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_BUTTONS);
    url += buildParam('WWW_AKA_MVT_ID', _squid.$cookies && _squid.$cookies.WWW_AKA_MVT_ID);
    url += buildParam('ip', _squid.$meta && _squid.$meta.ipaddress);
    if (_angular.$rootScope.token) {
      (0, _squid.$populate)(xoData, {
        payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
        appData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
      }).then(function () {
        url += buildParam('mrid', xoData.payee && xoData.payee.getId());
        url += buildParam('calf', xoData.appData && xoData.appData.flow_id);
        addToDocument(url);
      });
    } else {
      url += buildParam('mrid', null);
      url += buildParam('calf', null);
      addToDocument(url);
    }
  }
  return {
    fireBeacon: function fireBeacon(fptiData) {
      if (!_alreadyFired && fptiData) {
        var elements = _strToElements(fptiData);

        // Fire the beacon if this is a page render.
        if (elements.page) {
          _alreadyFired = true;
          return _fireButtonTrackingBeacon(elements);
        }
      }
    },
    resetAlreadyFired: function resetAlreadyFired() {
      _alreadyFired = false;
    }
  };
});
_angular.$rootScope;
_squid.$meta;
_squid.$cookies;
_squid.$populate;
_index.$CheckoutAppDataModel;
_index.$CheckoutPayeeModel;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/button.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
_angular["default"].module('tracking.directive', ['ui.router']).directive('trackSubmit', function () {
  return {
    restrict: 'AE',
    link: function link($scope, element, attr) {
      element.on('mousedown', function (event) {
        var transition = attr && attr.trackSubmit;
        var trackSubmit = {
          currentRoute: _uiRouter.$state.current,
          transition: transition,
          errors: []
        };
        _angular["default"].forEach($('input.ng-invalid, select.ng-invalid'), function (el) {
          var elem = $(el);
          var elementId = elem.attr('id');
          var elementName = elem.attr('name');
          var errorKey = elem.attr('data-error-key');
          var errorText = elem.has('required') ? 'required' : 'no error key';
          var fieldName = elementId ? elementId : elementName;
          if (!fieldName) {
            var elementModel = elem.attr('ng-model');
            fieldName = elementModel ? elementModel : 'unnamed-field';
          }
          trackSubmit.errors.push({
            fieldName: fieldName,
            errorMessage: errorKey ? errorKey : errorText
          });
        });
        _angular.$rootScope.$broadcast('trackSubmit', trackSubmit);
      });
    }
  };
}).directive('trackLink', function () {
  return {
    restrict: 'AE',
    link: function link($scope, element, attr) {
      element.on('mousedown', function (event) {
        var state = attr && attr.trackLink;
        if (state) {
          var trackLink = {
            currentRoute: _uiRouter.$state.current,
            transition: state
          };
          _angular.$rootScope.$broadcast('trackLink', trackLink);
        }
      });
    }
  };
}).directive('trackClick', function () {
  return {
    restrict: 'AE',
    link: function link($scope, element, attr) {
      element.on('click', function (event) {
        var state = attr && attr.trackClick;
        if (state) {
          var trackClick = {
            currentRoute: _uiRouter.$state.current,
            transition: state
          };
          _angular.$rootScope.$broadcast('trackClick', trackClick);
        }
      });
    }
  };
}).directive('trackInput', function () {
  /*
  * Track an input tag with track-input attribute
  * you can use the value of track-input attribute as
  * a tracking attr Eg.: track-input="xo_guest_yes"
  */
  return {
    restrict: 'AE',
    link: function link($scope, element, attr) {
      element.on('click', function (event) {
        var state;
        if (event.target.type === 'checkbox') {
          if (event.target.checked) {
            state = attr && attr.trackInput + "_CHECKED";
          } else {
            state = attr && attr.trackInput + "_UNCHECKED";
          }
        } else {
          state = attr && attr.trackInput;
        }
        var trackInput = {
          currentRoute: _uiRouter.$state.current,
          page: 'main:ec:hermes::fullpage-billing:guest:aries:'
        };
        if (state) {
          trackInput.transition = state;
        }
        _angular.$rootScope.$broadcast('trackInput', trackInput);
      });
    }
  };
}).directive('trackFocusAndBlur', function () {
  return {
    restrict: 'AE',
    link: function link($scope, element, attr) {
      var isAddressField = function isAddressField(s) {
        return /^billing|^shipping/.test(s);
      };
      ['blur', 'focus'].forEach(function (eventName) {
        element.on(eventName, function (event) {
          if (document.body.className.includes('loading')) {
            // Angular fires this event while the page is still loading.
            // This is a hacky way of preventing this but this ask is time-sensitive
            // and this is an app we are deprecating.
            return;
          }
          var id = event.target.id;
          var attrName = attr && attr.name;
          var fieldName = isAddressField(id) ? id : attrName;
          var data = {
            from: 'billing',
            to: "process_field_" + eventName,
            field_name: fieldName
          };

          // The tags `selectedvalue` and `user_filled` were pulled
          // from `go/fptigov` as keys that are already indexed.
          var elType = event.target.type;
          if (elType === 'checkbox' || elType === 'radio') {
            data.selectedvalue = event.target.checked;
          } else {
            data.user_filled = Boolean(event.target.value);
          }
          _angular.$rootScope.$broadcast('trackFocusAndBlur', data);
        });
      });
    }
  };
});
_uiRouter.$state;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/fpti.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().factory('$fpti', function () {
  var _beaconUrl;

  // Logic to switch between production/staging urls. This way we don't pollute live logs,
  // and we are able to test on stage using the fpti log viewing tool.
  if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
    _beaconUrl = 'https://tracking.qa.paypal.com/webapps/tracking/ts'; // stage url
  } else {
    _beaconUrl = _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
  }
  return {
    // Get all the tracking data defined at the page level
    getPageTrackingData: function getPageTrackingData(route) {
      route = route || {};
      var trackingData = route.trackingData || {};
      var routeParent = route.parent;
      trackingData.token = _angular.$rootScope.token;
      while (routeParent) {
        trackingData = _angular["default"].merge({}, routeParent.trackingData || {}, trackingData);
        routeParent = routeParent.parent;
      }
      return trackingData;
    },
    setupDataString: function setupDataString(route, err, data) {
      var trackingData = this.getPageTrackingData(route);
      var PAYPAL = window && window.PAYPAL;
      var fptiData;
      if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
        PAYPAL.core = PAYPAL.core || {};
        var payload = {
          baseData: window.meta.fpti,
          trackingData: trackingData,
          error: err,
          isInContext: _angular.$rootScope.miniBrowser
        };
        _angular["default"].extend(payload, data || {});
        fptiData = new _builder.$FptiBuilder(payload).build().toString();

        // FPTI client side tracking only if we have template
        if (route && route.template && _angular["default"].isFunction(PAYPAL.analytics.setup)) {
          PAYPAL.core.pta = PAYPAL.analytics.setup({
            data: fptiData,
            url: _beaconUrl
          });
        }
      }
      return fptiData;
    }
  };
}).factory('$fptiError', function () {
  function stringifyErrorMessage(msg) {
    return encodeURIComponent(_angular["default"].isString(msg) ? msg.split('\n').slice(0, 2).join('@') // Get the first two lines of stack
    : (_angular["default"].toJson(msg) || 'undefined').substring(0, 128));
  }
  return _squid.$Error.extend({
    construct: function construct(err) {
      if (!err) {
        return;
      }
      this.type = err.type;
      this.field = err.field;
      this.msg = stringifyErrorMessage(err.message || err.error);
      this.code = err.code || err.cause;
    }
  });
});
_squid.$config;
_squid.$Error;
_builder.$FptiBuilder;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/fpti.js"))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * xo-tracking encapsulates all the details about instrumentation
 * and only register event listeners during bootstrap
 */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/xo-tracking/dist/listener.js"), __webpack_require__("../node_modules/xo-tracking/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {
  // Declare the dependency to register the listeners
  return angular.module('tracking', ['tracking.listener', 'tracking.directive']);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-tracking/dist/listener.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, console) {

var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");
var _builder = __webpack_require__("../node_modules/xo-tracking/dist/builder.js");
var _button = __webpack_require__("../node_modules/xo-tracking/dist/button.js");
var _fpti = __webpack_require__("../node_modules/xo-tracking/dist/fpti.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
_angular["default"].module().run(function () {
  // eslint-disable-line max-statements
  var token = window.meta.token;
  // logAppName is the appname from meta.js. if the logAppName is not defined, default it to 'appNameNotDefined'.
  var appName = _squid.$meta.logAppName || 'appNameNotDefined';
  var addTrackingData = function addTrackingData(object) {
    return _squid.$util.extend(object, {
      dc: _squid.$meta.dc,
      az: _squid.$meta.az,
      cust: _index.$AuthModel.instance().buyer_id || '',
      comp: appName
    });
  };
  var cplSettings = _squid.$config.enableCPL;
  var passesCplThrottle = cplSettings && (typeof cplSettings.throttle === 'undefined' || (0, _squid.$experiment)('cpl_tracking', cplSettings.throttle, token));
  var cplEnabled = passesCplThrottle || _squid.$util.params().forceEnableCPL;
  function logTransition(state) {
    return !(state.trackingData && state.trackingData.suppressTransitionLog);
  }
  function logStateExit(state) {
    return state.trackingData && state.trackingData.trackStateExit;
  }
  function getBeaconUrl() {
    // Logic to switch between production/staging urls. This way we don't pollute live logs,
    // and we are able to test on stage using the fpti log viewing tool.
    return _squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage() ? 'https://tracking.qa.paypal.com/webapps/tracking/ts' // stage url
    : _squid.$config.urls && _squid.$config.urls.fptiBeaconUrl;
  }

  /*
  * Triggers pa.js recordClick with custom parameters
  */
  function fptiCustomRecordClick(route, customData) {
    var analyticsInstance, fptiData, fptiDataObj;
    var PAYPAL = window.PAYPAL;
    if (PAYPAL && typeof PAYPAL.analytics !== 'undefined') {
      PAYPAL.core = PAYPAL.core || {};
      analyticsInstance = new PAYPAL.analytics.Analytics();
      fptiData = new _builder.$FptiBuilder({
        trackingData: route.trackingData,
        isInContext: _angular.$rootScope.miniBrowser,
        comp: appName
        // ... Other flow data pass-in here to resolve page qualifier
      }).build();

      // Grab the fpti data object and extend with custom params
      // The fpti data obj should include pxp params as well
      fptiDataObj = fptiData._dataObj;
      $.extend(fptiDataObj, customData);
      analyticsInstance.setRequestData(fptiDataObj);
      analyticsInstance.recordClick({
        url: getBeaconUrl()
      });
    }
  }
  _angular.$rootScope.$on('trackInput', function (event, trackInput) {
    if (!trackInput) {
      return;
    }
    var customData = {
      link: trackInput && trackInput.transition,
      page: trackInput && trackInput.page
    };
    fptiCustomRecordClick(trackInput.currentRoute, customData);
  });
  _angular.$rootScope.$on('trackFocusAndBlur', function (event, data) {
    _logger.$logger.info('checkout_fpti', data);
  });
  _angular.$rootScope.$on('trackClick', function (event, trackClick) {
    if (!trackClick) {
      return;
    }
    var customData = {
      link: trackClick && trackClick.transition
    };
    fptiCustomRecordClick(trackClick.currentRoute, customData);
  });
  _angular.$rootScope.$on('trackSubmit', function (event, trackSubmit) {
    if (!trackSubmit) {
      return;
    }
    var currentRoute = trackSubmit && trackSubmit.currentRoute;
    var routeName = currentRoute ? currentRoute.name : 'noRoute';
    _logger.$logger.info('track_submit', {
      route_name: routeName
      // ID stuff here later
    });
    if (logTransition(currentRoute)) {
      routeName = routeName.replace(/\./g, '_');
      var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
      var transition = trackSubmit.transition || state;
      _logger.$logger.info(routeName + '_exit', {
        fptiState: state,
        fptiTransition: transition
      });
    }
    if (trackSubmit.errors && trackSubmit.errors.length) {
      var fptiFieldErrors = JSON.stringify(trackSubmit.errors);
      _logger.$logger.info('checkout_fpti', {
        form_field_errors: fptiFieldErrors
      });
    }
    var errors = trackSubmit.errors;
    if (_angular["default"].isArray(errors)) {
      errors.forEach(function (err) {
        _logger.$logger.debug('track_submit_error', err);
        if (_fpti.$fpti) {
          _fpti.$fpti.setupDataString(currentRoute, new _fpti.$fptiError({
            type: 'fieldError',
            field: err.fieldName,
            code: err.errorMessage
          }));
        }
      });
      if (errors.length) {
        _logger.$logger.flush(true);
      }
    }
  });
  _angular.$rootScope.$on('unhandled_error', function (event, exception) {
    if (_fpti.$fpti) {
      _fpti.$fpti.setupDataString(exception.currentRoute, new _fpti.$fptiError({
        type: 'pageError',
        message: exception.message,
        code: exception.cause
      }));
    }
  });
  _angular.$rootScope.$on('trackLink', function (event, trackLink) {
    if (!trackLink) {
      return;
    }
    var currentRoute = trackLink.currentRoute;
    var routeName = (currentRoute ? currentRoute.name : 'noRoute').replace(/\./g, '_');
    var state = currentRoute.trackingData && currentRoute.trackingData.fptiState || routeName;
    _logger.$logger.info(routeName + '_exit', {
      fptiState: state,
      fptiTransition: trackLink.transition
    });
  });
  _angular.$rootScope.$on('$transition', function (event, data) {
    (0, _angular.$timeout)(function () {
      if (_fpti.$fpti) {
        var fptiData = _fpti.$fpti.setupDataString(data.toState, null, addTrackingData({
          transition_time: data.duration
        }));

        // This seems to conflict with CPL data, so don't fire if CPL
        if (!cplEnabled) {
          // Fire and forget button tracking beacon.
          _button.$ButtonTrackingService.fireBeacon(fptiData);
        }
      }
    });
  });
  _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    var from = fromState && fromState.name.replace(/\./g, '_');
    var to = toState && toState.name.replace(/\./g, '_');
    if (from && logTransition(fromState) && logStateExit(fromState)) {
      var trackingData = fromState.trackingData && fromState.trackingData || {};
      _logger.$logger.info(from + '_exit', {
        fptiState: trackingData.fptiState || from,
        fptiTransition: trackingData.fptiState || from
      });
    }
    _logger.$logger.info('state_change', {
      from: from || 'start',
      to: to || 'end'
    });

    // Generate a new CAL correlation_id to be shared until next flow transition (only for view states)
    if (toState.template) {
      _model.$CalDataModel.generateMetaIds();
    }
    _angular.$rootScope.currentState = to;
    if (to && logTransition(toState)) {
      _logger.$logger.info(to + '_enter', {
        fptiState: toState.trackingData && toState.trackingData.fptiState || to
      });
    }
  });
  _angular.$rootScope.$on('page_loaded', function (event, from, to) {
    if (from !== 'checkout_init') {
      return;
    }
    var key = _model.$FptiConstants.stateName[to] || 'review';
    var landing_page = _model.$FptiConstants.landing_page[key];
    _logger.$logger.info('landing_page', {
      'from': landing_page,
      'to': 'process_page_loaded',
      fpti_landing_page: landing_page
    });
  });
  _angular.$rootScope.$on('page_reloaded', function () {
    _logger.$logger.flush(true);
    _model.$CalDataModel.generateMetaIds();
  });
  _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState) {
    var to = toState.name.replace(/\./g, '_');
    if (toState.hasResolver && to) {
      _logger.$logger.info(to + "_load");
    } else if (to) {
      _logger.$logger.info(to + "_rendering");
    }
  });
  _angular.$rootScope.$on('addrDiff', function (event, addrDiff) {
    if (!addrDiff) {
      return;
    }
    _logger.$logger.info("checkout_fpti" + addrDiff);
  });
  function getHash(url) {
    if (!url || !~url.indexOf('#')) {
      // eslint-disable-line no-bitwise
      return;
    }
    url = url.split('#');
    return url[url.length - 1];
  }
  var oldHash = window.location.hash;
  window.addEventListener('hashchange', function (event) {
    _logger.$logger.info('hashchange', {
      from: getHash(event.oldURL || oldHash),
      to: getHash(event.newURL || window.location.hash)
    });
    if (!_squid.$loader.isLoading()) {
      _logger.$logger.flush();
    }
    oldHash = window.location.hash;
  });
  $(document).on('click', function (event) {
    if (event && event.target && event.target.tagName) {
      var name = event.target.tagName.toLowerCase();
      if (event.target.id) {
        name += '#' + event.target.id;
      } else if (event.target.attributes && event.target.attributes['ng-model']) {
        name += ':' + event.target.attributes['ng-model'].value;
      } else if (event.target.className) {
        name += '.' + event.target.className.split(' ').join('.');
      }
      _logger.$logger.info('click', {
        el: name
      });
    }
  });
  if (cplEnabled) {
    window.fptiserverurl = getBeaconUrl();
    var firstInvocation = true;
    var trackPageStart = function trackPageStart() {
      if (firstInvocation) {
        firstInvocation = false;
        return;
      }
      try {
        window.PAYPAL.analytics.startCPLTracking();
      } catch (e) {
        console.log("error starting cpl tracking " + e);
      }
    };
    var firstDone = true;
    var trackDone = function trackDone(beaconData) {
      window.PAYPAL.analytics.endCPLTracking({
        pageData: addTrackingData(beaconData),
        inferStart: firstDone
      });
      firstDone = false;
    };
    var currentRoute = null;
    _angular.$rootScope.$on('startLoad', function () {
      return trackPageStart();
    });
    _angular.$rootScope.$on('$stateChangeSuccess', function (e, route) {
      currentRoute = route;
    });
    _angular.$rootScope.$on('allLoaded', function () {
      try {
        var buildParams = {
          productOverride: window.fptiProductOverride,
          trackingData: _fpti.$fpti.getPageTrackingData(currentRoute)
        };
        var legacyFptiData = new _builder.$FptiBuilder(buildParams).build()._dataObj;
        var product = window.fptiProductOverride || 'ec';
        legacyFptiData.pgrp = "main:" + product + ":hermes";
        legacyFptiData.flid = token;
        trackDone(legacyFptiData);
      } catch (e) {
        console.log("error tracking CPL data " + e);
      }
    });
  }
});
_index.$AuthModel;
_squid.$util;
_squid.$meta;
_squid.$config;
_squid.$experiment;
_squid.$loader;
_logger.$logger;
_model.$CalDataModel;
_model.$FptiConstants;
_builder.$FptiBuilder;
_button.$ButtonTrackingService;
_fpti.$fpti;
_fpti.$fptiError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-tracking/dist/model.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {

var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _uuid = _interopRequireDefault(__webpack_require__("../node_modules/node-uuid/uuid.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/* eslint-disable angular/di */

(function exportProviders(angular) {
  angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);
_angular["default"].module().constant('$FptiConstants', {
  // The prototype of buzname data object
  buznameMap: {
    flowgatename: {
      placeHolder: '',
      fptiKey: 'fltp'
    },
    'flowname': {
      placeHolder: 'ec:hermes:',
      fptiKey: 'flnm'
    },
    'hier1': {
      placeHolder: 'main_ec_hermes_',
      fptiKey: 'shir'
    },
    'inout': {
      placeHolder: 'inout',
      fptiKey: 'lgin'
    },
    'pagename': {
      placeHolder: 'main:ec:hermes',
      fptiKey: 'pgrp'
    },
    'pagename2': {
      placeHolder: 'main:ec:hermes',
      fptiKey: 'page'
    },
    'version': {
      placeHolder: 'hermes',
      fptiKey: 'vers'
    }
  },
  // Full list of FPTI keys indexed by readable names
  // This mapping can also be served as default decorator
  fptiKeys: {
    'businessType': 'bztp',
    'correlationId': 'calc',
    // CalDataModel
    'cust': 'cust',
    'errorCode': 'eccd',
    'fieldError': 'erfd',
    'flowgatename': 'fltp',
    // buzname
    'flowname': 'flnm',
    // buzname
    'loggedIn': 'lgin',
    // buzname
    'merchantId': 'mrid',
    'merchantType': 'mbtp',
    'pageError': 'erpg',
    'pageGoal': 'goal',
    // route
    'pageGroup': 'pgrp',
    // buzname
    'pageName': 'page',
    // buzname
    'pageQualifer': 'qual',
    // buzname
    'pageStartTime': 'pgst',
    // FptiBuilder
    'pageTechnologyFlag': 'pgtf',
    // productConfig
    'paymentFlowId': 'pfid',
    'rLogId': 'teal',
    'sessionId': 'fpti',
    'siteHierarchy': 'shir',
    // buzname
    'sourceCi': 's',
    // productConfig
    'tealeaf': 'teal',
    'templateName': 'tmpl',
    // route
    'transition_time': 'transition_time',
    'uuid': 'csci',
    // CalDataModel
    'version': 'vers',
    // buzname
    'visitorId': 'vid',
    'ecToken': 'fltk',
    // metadata
    'pxpExpSelected': 'xe',
    'pxpTreatementSelected': 'xt',
    'pxpQualifiedTreatment': 'qt',
    'pxpContextId': 'qc',
    'dc': 'dc',
    'az': 'az',
    'comp': 'comp'
  },
  landing_page: {
    login: 'LOGIN',
    econsent: 'eConsent',
    review: 'Review',
    error_page: 'error_page',
    add_card: 'add_card',
    add_bank: 'add_bank',
    billing: 'billing',
    done_page: 'done_page',
    shoppingCart: 'shoppingCart',
    emptyCart: 'emptyCart',
    soldout: 'soldout',
    openButton: 'openButton'
  },
  stateName: {
    checkout_login: 'login',
    checkout_genericError: 'error_page',
    checkout_fastlogin: 'login',
    checkout_econsent: 'econsent',
    checkout_review: 'review',
    checkout_pageAddCard_addCardFlow_addCard: 'add_card',
    checkout_updateCard_addCardFlow_addCard: 'add_card',
    checkout_pageAddFi_bank_add: 'add_bank',
    guest: 'billing',
    checkout_done: 'done_page',
    checkout_guest: 'billing',
    checkout_signup: 'billing',
    guestupgrade_genericError: 'error_page',
    checkout_multistepsignup_multistepsignupaddcard: 'billing',
    checkout_shoppingCart: 'shoppingCart',
    checkout_emptyCart: 'emptyCart',
    checkout_soldout: 'soldout',
    checkout_openButton: 'openButton'
  }
}).factory('$FptiDataModel', ['$FptiConstants', function ($FptiConstants) {
  var productConfig = {};

  // TODO to read from config.json
  productConfig[$FptiConstants.fptiKeys.sourceCi] = 'ci';
  productConfig[$FptiConstants.fptiKeys.pageTechnologyFlag] = 'NodeJS';

  /**
   * Utilizing Decorator pattern to allow defining additional logic for specific keys
   */
  return _squid.$Class.extend('FptiDataModel', {
    init: function init() {
      this._dataObj = _angular["default"].extend({}, productConfig);
      this._decoratorList = [];
    },
    decorators: {
      buzname: function buzname(trackingData, pageQualifier, isInContext, productOverride) {
        if (!trackingData) {
          return;
        }
        var buzname = trackingData.buzname;
        if (!buzname) {
          return;
        }
        var buznameDiff = buzname[pageQualifier];
        if (!buznameDiff) {
          return;
        }
        var dataObj = this._dataObj;
        var buznameMap = $FptiConstants.buznameMap;
        // read app specific place holder from config
        var placeHolderConfig = _squid.$config && _squid.$config.fpti && _squid.$config.fpti.buznameEntryPlaceHolder;
        Object.keys(buznameMap).forEach(function (key) {
          var buznameEntry = buznameMap[key];
          var fptiKey = buznameEntry.fptiKey;
          var placeHolder = buznameEntry.placeHolder;
          if (buznameDiff[key]) {
            if (placeHolderConfig && placeHolderConfig[key]) {
              placeHolder = placeHolderConfig[key];
            }
            if (productOverride) {
              var _placeHolder$split = placeHolder.split(':'),
                main = _placeHolder$split[0],
                hermes = _placeHolder$split[2];
              placeHolder = main + ":" + productOverride + ":" + hermes;
            }
            dataObj[fptiKey] = buznameDiff[key].replace('%', placeHolder);
          } else {
            dataObj[fptiKey] = placeHolder;
          }
        });
        dataObj[$FptiConstants.fptiKeys.pageQualifer] = pageQualifier;
      },
      base: function base(_base) {
        if (_base) {
          for (var key in _base) {
            if (!this._dataObj[key]) {
              this._dataObj[key] = _base[key];
            }
          }
        }
      },
      locale: function locale(_locale) {
        if (_locale && _locale.country) {
          this._dataObj[$FptiConstants.fptiKeys.locale] = _locale.country;
        }
      },
      pxptrackingdata: function pxptrackingdata(pxpData) {
        var qt = [];
        var qc = [];
        var xe = [];
        var xt = [];
        _squid.$util.some(pxpData, function (trackInfo) {
          var match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqt=([^;]+);');
          if (match) {
            qt.push(match[1]);
          }
          match = trackInfo && trackInfo.tracking_tags && trackInfo.tracking_tags.match('\\bqc=([^;]+);');
          if (match) {
            qc.push(match[1]);
          }
          _squid.$util.some(trackInfo.treatments, function (treatment) {
            xe.push(treatment.experiment_id);
            xt.push(treatment.treatment_id);
          });
        });
        this._dataObj[$FptiConstants.fptiKeys.pxpQualifiedTreatment] = qt.join(',');
        this._dataObj[$FptiConstants.fptiKeys.pxpContextId] = qc.join(',');
        this._dataObj[$FptiConstants.fptiKeys.pxpExpSelected] = xe.join(',');
        this._dataObj[$FptiConstants.fptiKeys.pxpTreatementSelected] = xt.join(',');
      },
      templateName: function templateName(trackingData, pageQualifier, isInContext) {
        if (trackingData && trackingData.templateName) {
          var templateName = (trackingData.templateName || '') + (pageQualifier ? ':' + pageQualifier : '');
          this._dataObj[$FptiConstants.fptiKeys.templateName] = templateName;
        }
      },
      fieldError: function fieldError(err) {
        if (err && err.type === 'fieldError') {
          this._dataObj[$FptiConstants.fptiKeys.fieldError] = err.field;
          this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
        }
      },
      pageError: function pageError(err) {
        if (err && err.type === 'pageError') {
          this._dataObj[$FptiConstants.fptiKeys.pageError] = err.msg;
          this._dataObj[$FptiConstants.fptiKeys.errorCode] = err.code;
        }
      }
    },
    decorate: function decorate(name) {
      this._decoratorList.push({
        name: name,
        params: Array.prototype.slice.call(arguments, 1)
      });
      return this;
    },
    getDataObject: function getDataObject(isInContext) {
      var i;
      var decorator;
      for (i = 0; i < this._decoratorList.length; i++) {
        decorator = this._decoratorList[i];
        if (!decorator) {
          continue;
        }
        var name = decorator.name;
        var params = decorator.params;
        if (_angular["default"].isFunction(this.decorators[name])) {
          // Invoke the decorator and pass in the parameter list
          this.decorators[name].apply(this, params);
        } else {
          var fptiKey = $FptiConstants.fptiKeys[name];

          // If the fptiKey is defined and value is present, add the k-v pair
          if (fptiKey && params && params.length > 0) {
            this._dataObj[fptiKey] = params[0];
          }
        }
      }

      // 'fullpage' was widely used as default key in page routs definition
      // finally replace it here if it's incontext
      var dataObj = this._dataObj;
      if (isInContext) {
        Object.keys(dataObj).forEach(function (k) {
          if (_angular["default"].isString(dataObj[k])) {
            // some values can be number
            dataObj[k] = dataObj[k].replace('fullpage', 'incontext');
          }
        });
      }
      return this._dataObj;
    }
  });
}]).factory('$CalDataModel', function () {
  var uuid_v4_mask = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  var uuid_v1_mask = 'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX';
  function _generateCorrelationId() {
    var uidRandomArr = (_uuid["default"].v4() || uuid_v4_mask).split('-');
    var uidTime = (_uuid["default"].v1() || uuid_v1_mask).split('-');
    return uidTime[0] + uidRandomArr[0].substr(0, 5);
  }
  function _generateUUID() {
    return (_uuid["default"].v4() || uuid_v4_mask).replace(/-/g, '');
  }
  var CalModel = _squid.$Model.extend({
    _calCorrId: _generateCorrelationId(),
    _uuid: _generateUUID(),
    generateCalCorrId: function generateCalCorrId() {
      this._calCorrId = _generateCorrelationId();
    },
    generateUUID: function generateUUID() {
      this._uuid = _generateUUID();
    },
    generateMetaIds: function generateMetaIds() {
      this.generateCalCorrId();
      this.generateUUID();
    },
    getCalCorrId: function getCalCorrId() {
      return this._calCorrId;
    },
    getUUID: function getUUID() {
      return this._uuid;
    }
  });
  return new CalModel();
});
_squid.$Model;
_squid.$Class;
_squid.$util;
_squid.$config;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-tracking/dist", "../node_modules/xo-tracking/dist/model.js"))

/***/ }),

/***/ "../node_modules/xo-tray-height/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
/* grab the logger so we can warn about being in the fallback mode */

/** Name:  Tray height helper */
angular.module().directive('xoTrayHeight', function () {
  return {
    restrict: 'A',
    link: function link($scope, element, attrs) {
      // Check to see if we can use the safer full height approach
      // or if we need to fallback to calculating the height using
      // math and relying on the "right" timing.
      var topClass = 'xo-sidebar-wrapper';
      var topSelector = "." + topClass;
      var topElem = document.querySelector(topSelector);
      var inScope = topElem && topElem.querySelector('[xo-tray-height]');
      var useNewFlow = topElem && inScope;

      /**
       * NOTE:
       * The following code, despite being the "new" flow, is still
       * a stopgap solution until such time as the markup and or
       * CSS undergo an overhaul. It relies on the more stable
       * cascading relative/absolute positioning and 100% height
       * *and* the fact that the code is an instance of xo-tray-height
       * within the xo-sidebar-wrapper.
       */
      function calculate() {
        var curElem = element[0];
        while (!~curElem.className.indexOf(topClass)) {
          var style = getComputedStyle(curElem, null);
          if (style.position !== 'absolute') {
            curElem.style.position = 'relative';
          }
          curElem.style.height = '100%';
          curElem = curElem.parentNode;
        }
      }

      /**
       * NOTE:
       * The following DEPRECATED version of the calculate method
       * relies on calculating the heights using math. This heavy
       * handed approach is fine if it is called at the right times
       * and often enough; however, this criteria is hard to achieve.
       *
       * A markup and styles overhaul is recommended to do away with
       * both of these methods.
       */
      function deprecatedCalculate() {
        // DEPRECATED
        _logger.$logger.warn('xo-tray-height-fallback', {
          message: 'Using the fallback sidebar height calculation. ' + 'height may not be 100%. You should not be here!'
        });
        var height;
        var headerHeight;
        var mainHeight;
        var trayMinheight = 400;
        var asideContentHeight;
        var $aside = $(element).parents('aside:visible');
        var $asideContent = $aside.find('.asideContent');
        if (!$aside || !$asideContent) {
          return;
        }

        // Updates the tray height to the section height
        headerHeight = $aside.find('.header').outerHeight(true);
        mainHeight = $('#main').outerHeight(true);
        height = mainHeight - headerHeight;
        asideContentHeight = $asideContent.outerHeight(true);
        if ($scope.miniBrowser) {
          $aside.find('.aside').css('height', '534px');
          var minHeight = 534 - headerHeight;
          $asideContent.css('height', minHeight);
        } else if (asideContentHeight > height) {
          $asideContent.css('height', height);
          $aside.find('aside:visible').addClass('hasScroll');
        } else {
          height = height > trayMinheight ? height : trayMinheight;
          $asideContent.css('height', height);
          $aside.removeClass('hasScroll');
        }
      }
      if (useNewFlow) {
        calculate();
      } else {
        (0, _angular.$timeout)(deprecatedCalculate, 1);
        $scope.$on('SidebarError', function () {
          deprecatedCalculate();
        });
      }
    }
  };
});
_angular.$timeout;
_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _ui = __webpack_require__("../node_modules/xo-ui-components/src/accessibility/ui.js");
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Adds role='button' and tabindex='0' to anchor elements
// so that it is keyboard navigable and recognized by screen
// readers as a button.
//
// As anchors without href do not fire their click event
// automatically on a Space or ENTER key, this directive forces
// that functionality.
//
// If something is assigned to the link-button attribute, then
// it is used as an aria-label.
(0, _squid.$registerDirective)('link-button', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var ariaLabel = (0, _angular.$parse)(attrs.linkButton)(scope);
      var $element = (0, _jquery["default"])(element);
      $element.attr('role', 'button');
      $element.attr('tabindex', '0');
      if (ariaLabel) {
        $element.attr('aria-label', ariaLabel);
      }
      $element.on('keydown', function (event) {
        // do nothing if there is an alt or ctrl key as well
        if (!(event.altKey || event.ctrlKey)) {
          switch (event.keyCode) {
            case _ui.KEYS.SPACE:
            case _ui.KEYS.ENTER:
              element[0].click();
              return false;
            default:
              break;
          }
        }
        return true;
      });
    }
  };
});

// this directive gives an element characteristics of a native
// select element in terms of keyboard navigation. It becomes reachable
// via the tab key, reflects screenreader characteristics and
// can be activated by any of the DOWN, SPACE or ENTER KEYS.
(0, _squid.$registerDirective)('select-button', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var $element = (0, _jquery["default"])(element);
      if (!attrs.hasOwnProperty('disableRole')) {
        $element.attr('role', 'button');
      }
      $element.attr('aria-haspopup', 'true').attr('tabindex', '0').on('keydown', function (event) {
        // do nothing if there is an alt or ctrl key as well
        if (!(event.altKey || event.ctrlKey)) {
          switch (event.keyCode) {
            case _ui.KEYS.DOWN:
            case _ui.KEYS.SPACE:
            case _ui.KEYS.ENTER:
              element[0].click();
              return false;
            default:
              break;
          }
        }
        return true;
      });
    }
  };
});

// this directive makes a container with links act as if it were a select dropdown
// in terms of keyboard accessibility. The following characteristics are implemented:
//
// * UP/RIGHT and DOWN/lEFT KEYS navigate through the options.
// * ESC cancels and closes the dropdown
// * SPACE or ENTER select an option
// * You cannot TAB out of a dropdown until you select or cancel
//
// in addition, the following extra characteristics are implemented
//
// * The TAB (and SHIFT-TAB) key will also function to move between options
// * Upon reaching the end of the list, the focus will shift back to the first item, and vice versa
//
// How to use:
// 1. The select-cancel attribute is an agnostic expression to implement the cancel / back mechanic.
//    The expression is run whenever the ESC key is pressed.
// 2. The select-allow-tab-escape attribute can be added alongside the select-box attribute to allow
//    tabs to escape the select-box element.
(0, _squid.$registerDirective)('select-box', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var allowTabEscape = (0, _angular.isDefined)(attrs.selectAllowTabEscape);
      function escapeToggle() {
        if (attrs.selectCancel) {
          (0, _angular.$parse)(attrs.selectCancel)(scope);
          scope.$apply();
        }
      }
      element.attr('role', 'menu');
      element.on('keydown.selectBox', function (event) {
        var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
        var $origin = (0, _jquery["default"])(event.target);
        if (!(event.altKey || event.ctrlKey)) {
          var index = $allTabbable.index($origin);
          switch (event.keyCode) {
            case _ui.KEYS.TAB:
              if (allowTabEscape && (index === 0 && event.shiftKey || index === $allTabbable.length && !event.shiftKey)) {
                // Enable default behavior to escape select-box
                escapeToggle();
                break;
              } else if (event.shiftKey) {
                index = (index - 1 + $allTabbable.length) % $allTabbable.length;
              } else {
                index = (index + 1) % $allTabbable.length;
              }
              $allTabbable.eq(index).focus();
              event.preventDefault();
              break;
            case _ui.KEYS.DOWN:
            case _ui.KEYS.RIGHT:
              index = (index + 1) % $allTabbable.length;
              $allTabbable.eq(index).focus();
              event.preventDefault();
              break;
            case _ui.KEYS.UP:
            case _ui.KEYS.LEFT:
              index = (index - 1 + $allTabbable.length) % $allTabbable.length;
              $allTabbable.eq(index).focus();
              event.preventDefault();
              break;
            case _ui.KEYS.SPACE:
            case _ui.KEYS.ENTER:
              $origin.click();
              event.preventDefault();
              break;
            case _ui.KEYS.ESC:
              escapeToggle();
              break;
            default:
              break;
          }
        }
      });
    }
  };
});

// similar to select-box, this directive restrains tabbing within a container
// to the container itself.
//
// 1. modal-cancel is the equivalent of select-cancel from select-box, and
// should define a cancellation / ESC function.
(0, _squid.$registerDirective)('modal-box', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      function escapeToggle() {
        (0, _angular.$parse)(attrs.modalCancel)(scope);
        scope.$apply();
      }

      // Gets the index of the element that should be focused after pressing Tab
      function getNextIndex($element, $elements, shift) {
        if (shift) {
          return ($elements.index($element) - 1 + $elements.length) % $elements.length;
        } else {
          return ($elements.index($element) + 1) % $elements.length;
        }
      }
      if ((0, _angular.$parse)(attrs.modalBox)(scope) !== false) {
        element.on('keydown.modalBox', function (event) {
          var $allTabbable = (0, _ui.findAll)(element, _ui.tabbable);
          var $origin = (0, _jquery["default"])(event.target);
          if (!(event.altKey || event.ctrlKey)) {
            switch (event.keyCode) {
              case _ui.KEYS.TAB:
                var index = getNextIndex($origin, $allTabbable, event.shiftKey);
                $allTabbable.eq(index).focus();
                event.preventDefault();
                event.stopPropagation();
                break;
              case _ui.KEYS.ESC:
                escapeToggle();
                event.preventDefault();
                event.stopPropagation();
                break;
              default:
                break;
            }
          }
        });
      }
    }
  };
});

// A simple version of modal that doesn't rely on controlling keyboard behavior
// as strictly. Should be used in cases where tab items are not as easily accessible
// via JS (ie. iframes)
// Redirects focus to container when focusin event fired on element not in container
(0, _squid.$registerDirective)('simple-modal', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.attr('tabindex', '-1');
      var cancelFn;
      if (attrs.modalCancel) {
        cancelFn = function cancelFn() {
          (0, _angular.$parse)(attrs.modalCancel)(scope);
          scope.$apply();
        };
      }
      function registerModal() {
        (0, _jquery["default"])(document).on('focusin.simple-modal', function (event) {
          if (!element[0].contains(event.target)) {
            event.stopPropagation();
            element.focus();
          }
        });
        if (cancelFn) {
          (0, _jquery["default"])(document).on('click.simple-modal', function (event) {
            if (!element[0].contains(event.target)) {
              deregisterModal();
              cancelFn();
            }
          });
        }
      }
      function deregisterModal() {
        (0, _jquery["default"])(document).off('focusin.simple-modal');
        (0, _jquery["default"])(document).off('click.simple-modal');
      }

      // Watch the expression provided to simpleModal and add modal behavior when
      // expression result changes to truthy
      if ((0, _angular.isDefined)(element.attr('simpleModal'))) {
        scope.$watch(attrs['simpleModal'], function (newVal) {
          if (newVal) {
            registerModal();
          } else {
            deregisterModal();
          }
        });
      } else {
        registerModal();
      }
      scope.$on('$destroy', deregisterModal);
    }
  };
});

// this directive gives an element characteristics of a native
// option element in terms of aria attributes. It must be used
// as a child of a selectBox for proper keyboard behavior as it
// disables default tabbing behavior.
//
// The expression provided to the directive is used to set the
// aria-selected attribute when the expression evaluates to true.
(0, _squid.$registerDirective)('select-option', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      (0, _jquery["default"])(element).attr('role', 'menuitem');
      if ((0, _angular.$parse)(attrs.selectOption)(scope)) {
        (0, _jquery["default"])(element).attr('aria-selected', 'true');
      }
    }
  };
});

// adapted from http://stackoverflow.com/a/24416690
// This directive makes the element focused when the expression
// provided _changes_ to true.
//
// In order to avoid conflicts with autofocus when a page first loads,
// adding the focused-once-before attribute will enable the expression
// only if it has been focused on before.
//
// * if the element itself is not focusable, then it will locate the first focusable
// element within it.
// * if the additional attribute focus-element is provided, it is wrapped
// as a jQuery element (could be selector string or actual element) and focused on
// it will be parsed when the focus-when attribute is true
// * if the attribute focus-on is provided, then the focus-when attribute is ignored and
// the directive listens to the event specified by focus-on
(0, _squid.$registerDirective)('focus-when', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      function locateAndFocus(active) {
        (0, _angular.$timeout)(function () {
          if (active) {
            // deal with figuring out which element to focus on
            var $elementToFocus = (0, _jquery["default"])(); // start with "monad" to make life easier
            var directiveElementFocusable = (0, _ui.focusable)(element[0]);

            // this works by fallthrough. it will try each one
            // in succession until an element is found
            if (attrs.focusElement) {
              // scenario 1 - specific element provided
              $elementToFocus = (0, _ui.filterAll)((0, _angular.$parse)(attrs.focusElement)(scope), _ui.focusable);
            }
            if ($elementToFocus.length === 0 && !directiveElementFocusable) {
              // scenario 2 - element with directive is not focusable
              $elementToFocus = (0, _ui.findAll)(element, _ui.focusable);
            }

            // default / scenario 3 - no valid targets specified or found
            if ($elementToFocus.length === 0) {
              $elementToFocus = (0, _jquery["default"])(element);
            }
            $elementToFocus.first().focus();
          }
        });
      }
      var active = true;
      if ('focusedOnceBefore' in attrs) {
        active = false;
        (0, _jquery["default"])(element).on('focus', function () {
          active = true;
        });
      }
      if (attrs.focusRefreshOn) {
        scope.$on((0, _angular.$parse)(attrs.focusRefreshOn)(scope), function () {
          locateAndFocus(active);
        });
      } else {
        scope.$watch(attrs.focusWhen, function (val) {
          locateAndFocus(active && val);
        });
      }
    }
  };
});

// angularUI router specific - listens to a specific transition
// defined in two attributes, focusWhenState (this directive) and TransitionsTo
var FOCUS_EVENT_NAME = 'accessible-focus';
(0, _squid.$registerDirective)('focus-when-state', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var startState = attrs.focusWhenState;
      var endState = attrs.transitionsTo;
      var transitionMessage = startState + ' > ' + endState;
      var unregisterEventFn = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (fromState.name === startState && toState.name === endState) {
          scope.$broadcast(FOCUS_EVENT_NAME, transitionMessage);
        }
      });
      scope.$on(FOCUS_EVENT_NAME, function (event, message) {
        if (message === transitionMessage) {
          (0, _angular.$timeout)(function () {
            return element[0].focus();
          });
        }
      });

      // see http://stackoverflow.com/a/27016855
      scope.$on('$destroy', unregisterEventFn);
    }
  };
});

// Listens for the next state transition and focuses an element provided by selector
// Use with links where focus is needed to return to a specific element after the transition
(0, _squid.$registerDirective)('focus-after-transition', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.on('click', function () {
        var focusSelector = attrs['focusAfterTransition'];
        var cancel = _angular.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
          cancel();
          (0, _angular.$timeout)(function () {
            (0, _jquery["default"])(focusSelector).focus();
          });
        });
      });
    }
  };
});

// focuses on the first focusable element on a container containing form elements
(0, _squid.$registerDirective)('form-autofocus', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      // wait for the entire DOM to settle down first
      (0, _angular.$timeout)(function () {
        var $allFocusable = (0, _ui.findAll)(element, _ui.focusable);
        if ($allFocusable.length > 0) {
          $allFocusable.first().focus();
        }
      });
    }
  };
});

// Change element to be focusable and tabbable or unfocusable if it is
// not typically a focusable element by removing the tabindex attribute.
(0, _squid.$registerDirective)('focusable', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      function setFocusable(value) {
        if (value) {
          element.attr('tabindex', 0);
        } else {
          element.removeAttr('tabindex');
        }
      }
      if (attrs.focusable) {
        scope.$watch(attrs.focusable, function (newVal) {
          if (newVal) {
            setFocusable(true);
          } else {
            setFocusable(false);
          }
        });
      } else {
        setFocusable(true);
      }
    }
  };
});
_squid.$registerDirective;
_angular.$parse;
_angular.$timeout;
_angular.$rootScope;
_angular.isDefined;
_ui.KEYS;
_ui.focusable;
_ui.tabbable;
_ui.findAll;
_ui.filterAll;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/accessibility/ui.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.KEYS = void 0;
exports.filterAll = filterAll;
exports.findAll = findAll;
exports.focusable = focusable;
exports.tabbable = tabbable;
exports.visible = visible;
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KEYS = exports.KEYS = {
  TAB: 0x09,
  ENTER: 0x0D,
  ESC: 0x1B,
  SPACE: 0x20,
  LEFT: 0x25,
  UP: 0x26,
  RIGHT: 0x27,
  DOWN: 0x28
};
function visible(element) {
  return _jquery["default"].expr.filters.visible(element) && !(0, _jquery["default"])(element).parents().addBack().filter(function () {
    return _jquery["default"].css(this, 'visibility') === 'hidden';
  }).length;
}

// ripped from http://stackoverflow.com/a/7668761
/* istanbul ignore next */
function focusable(element) {
  var nodeName = element.nodeName.toLowerCase();
  var isTabIndexNotNaN = !isNaN(_jquery["default"].attr(element, 'tabindex'));
  var map;
  var mapName;
  var img;
  if (nodeName === 'area') {
    map = element.parentNode;
    mapName = map.name;
    if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
      return false;
    }
    img = (0, _jquery["default"])('img[usemap=#' + mapName + ']')[0];
    return !!img && visible(img);
  }
  return (/^(input|select|textarea|button|object)$/.test(nodeName) ?
  // eslint-disable-line no-nested-ternary
  !element.disabled : nodeName === 'a' ? element.href || isTabIndexNotNaN : isTabIndexNotNaN) &&
  // the element and all of its ancestors must be visible
  visible(element);
}

/* istanbul ignore next */
function tabbable(element) {
  var tabIndex = _jquery["default"].attr(element, 'tabindex');
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element);
}
function filterAll(elements, filterFn) {
  return (0, _jquery["default"])(elements).filter(function () {
    return filterFn(this);
  });
}
function findAll(container, filterFn) {
  return filterAll((0, _jquery["default"])(container).find('*'), filterFn);
}

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _auth = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-ui-components/src/banner/template.html"));
__webpack_require__("../node_modules/xo-ui-components/src/banner/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoBanner', {
  tag: 'xo-banner',
  template: _template["default"],
  transclude: true,
  props: {
    isNmj: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    // Need buyer_id from $AuthModel first to get the URL for the user profile photo
    models: function models() {
      return {
        auth: _auth.$AuthModel.instance().retrieve()
      };
    },
    userPhoto: function userPhoto(resolvers) {
      return resolvers.models.then(function (models) {
        return {
          photoData: _index.$UserPhotoModel.instance(models.auth.buyer_id).retrieve({
            params: {
              'min_size': 45
            }
          })["catch"](function (error) {
            _logger.$logger.info('error_retrieve_user_photo');
            return {};
          })
        };
      });
    }
  },
  lifecycle: {
    populate: function populate() {
      var avatarElement = this.$element.find('#banner-picture');
      var auth = this.models.auth;
      var photoData = this.userPhoto.photoData;

      // Currently only showing initials for New Member Journey
      var showInitials = auth.first_name && auth.last_name && this.props.isNmj;
      if (avatarElement && auth.buyer_id) {
        // The "phantom" avatar image is displayed by default via CSS
        // background-image property. If the request for a user's
        // profile photo returns a URL, the background-image property
        // is replaced with that URL.

        // Show user photo for avatar
        if (photoData && photoData.photo_url) {
          avatarElement.css('background-image', 'url("' + photoData.photo_url + '")');
          _logger.$logger.info('xoBanner_user');
        }

        // No user photo: show user initials instead of phantom image
        if (!photoData.photo_url && showInitials) {
          avatarElement.addClass('initials');
          this.initials = "" + auth.first_name[0] + auth.last_name[0];
          _logger.$logger.info('xoBanner_initials');
        }
      } else {
        // Leave the phantom avatar as the background image
        _logger.$logger.info('xoBanner_default');
      }
    }
  }
});
_squid.$Component;
_auth.$AuthModel;
_index.$UserPhotoModel;
_logger.$logger;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/banner/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"banner-wrapper\">\n    <div id=\"banner-picture\">{{ initials }}</div>\n    <div id=\"banner-content\" ng-transclude></div>\n</div>"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
__webpack_require__("../node_modules/xo-ui-components/src/directionality/styles.less");
/**
 * This directive watches the model and listens to user input to look for arabic/hebrew/right-to-left language
 * unicode chars, then adds dir="rtl" or dir="ltr" attribute to input field
 *
 * Add directionality to the container html div element of a input field.
 * <div directionality><input type=text ng-model="user.name"></div>
 */
(0, _squid.$registerDirective)('directionality', function () {
  return {
    restrict: 'A',
    link: function link(scope, element) {
      var currentWatchDeregister;
      var input = element.find('input');
      if (!input.length) {
        listenForInputRendered();
        return;
      }

      // If the input has not yet been rendered inside the container, listen for dom node inserted
      // then, if the node inserted is an input, we will use that element and init the directionality
      // listeners. The first input rendered is the one that will be captured by this directive.
      function listenForInputRendered() {
        element.bind('DOMNodeInserted', checkDOMNodeInserted);
        function checkDOMNodeInserted(event) {
          if (event && event.target && event.target.tagName === 'INPUT') {
            element.unbind('DOMNodeInserted', checkDOMNodeInserted);
            input = angular.element(event.target);
            init();
          }
        }
      }
      function setDirectionality(value) {
        if (value) {
          // set directionality to 'rtl' if the value has hebrew/arabic unicode chars.
          element.toggleClass('ltrOverride', !_squid.$util.hasRTL(value));
        } else {
          element.toggleClass('ltrOverride', _angular.$document.prop('documentElement').getAttribute('dir') !== 'rtl');
        }
      }
      function jqueryOnKeyupHandler(event) {
        setDirectionality(event.target.value);
      }

      // Reset directionality listeners when we transition from ltr -> rtl locale or vice versa
      function resetDirectionalityListener() {
        // remove directionality listeners that were set on prior locale
        input.unbind('keyup', jqueryOnKeyupHandler);
        if (currentWatchDeregister) {
          currentWatchDeregister();
        }

        // set new directionality listeners for the current locale if 'rtl'
        if (document.documentElement.getAttribute('dir') === 'rtl') {
          (0, _angular.$timeout)(function () {
            // Watch ng-model on input to set directionality if it contains RTL char
            currentWatchDeregister = scope.$watch(input.attr('ng-model'), function (value) {
              setDirectionality(value);
            });
            // jQuery listener for cases where ng-model is not populated until post validation
            input.on('keyup', jqueryOnKeyupHandler);
          });
        }
      }
      function init() {
        resetDirectionalityListener();
        scope.$on('localeChange', function () {
          resetDirectionalityListener();
        });
      }
      init();
    }
  };
});

/**
 * This directive watches the model for arabic/hebrew/right-to-left language unicode chars, then adds dir="rtl"
 * or dir="ltr" attribute to the html element.
 *
 * Add directionality-text="<<model>>" to the div or span or any element containing text.
 * <span directionality-text="user.name"><{{user.name}}</span>
 */
(0, _squid.$registerDirective)('directionality-text', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      if (document.documentElement.getAttribute('dir') === 'rtl') {
        var $element = $(element);
        (0, _angular.$timeout)(function () {
          if (attrs.directionalityText) {
            scope.$watch(attrs.directionalityText, function () {
              $element.toggleClass('ltrOverride', !_squid.$util.hasRTL((0, _angular.$parse)(attrs.directionalityText)(scope)));
            });
          } else {
            $element.toggleClass('ltrOverride', !_squid.$util.hasRTL(element.text()));
          }
        });
      }
    }
  };
});
_squid.$util;
_squid.$registerDirective;
_angular.$document;
_angular.$parse;
_angular.$timeout;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/directionality/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/dropdown-multiline/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {
  squid.module('xo-dropdown-multiline.directive', ['squid']).directive('xoDropdownMultiline', ['$timeout', function ($timeout) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link($scope, $select, attrs, ngModel) {
        var isListVisible = false;
        var listCreated = false;
        $select = $($select);
        var $span = $('<span class="custom-select" aria-hidden="true"><div class="arrow"></div><span class="innerContainer"><span></span></span></span>');
        var $container = $('<div class="custom-select-container multiline-select-container" tabindex="0" />');
        var $list;
        function updateCover() {
          $timeout(function () {
            $span.find('span span').html($select.find('[selected]').text().replace(/\\n/gi, '<br>').trim());
          }, 10);
        }
        function createList($options) {
          if ($options.length < 2) {
            return;
          }
          function getModel() {
            var modelName;
            var model;
            var subParts;
            if ($select.attr('ng-options')) {
              modelName = $select.attr('ng-options').substring($select.attr('ng-options').indexOf('in ') + 3, $select.attr('ng-options').length);
            } else {
              var $option = $($select.find('[ng-repeat]')[0]);
              modelName = $option.attr('ng-repeat').substring($option.attr('ng-repeat').indexOf('in ') + 3, $option.attr('ng-repeat').length);
            }

            // This is to handle cases like card.billingAddress
            if (modelName.indexOf('.') !== -1) {
              subParts = modelName.split('.');
              model = $scope;
              for (var i = 0; i < subParts.length; i++) {
                model = model[subParts[i]];
              }
            } else {
              // And this is to handle straightforward model names
              model = $scope[modelName];
            }
            return model;
          }
          function hideList(event) {
            $list.hide();
            $container.append($list);
            isListVisible = false;
            $container.removeClass('open');
          }
          function positionList() {
            $list.css('left', $container.offset().left + 'px');
            $list.css('top', $container.offset().top + $container.height() + 'px');
            $list.css('width', $container.width() + 'px');
          }
          function setFocusOnSelected() {
            var $selected = $select.find('[selected]');
            if ($selected.length) {
              var $item = $list.find('[data-value="' + $selected.attr('value') + '"]');
              $item.focus();
            } else {
              $list.find('li')[0].focus();
            }
          }
          function showList() {
            $('body').append($list);
            $container.addClass('open');
            $list.show();
            positionList();
            isListVisible = true;
            setFocusOnSelected();
          }
          function processContainerKeypress(event) {
            var keyCode = event && event.keyCode;
            if (keyCode === 13 || keyCode === 40) {
              // enter or down arrow
              if (!isListVisible) {
                showList();
              } else {
                hideList();
                $container.focus();
              }
            } else if (keyCode === 27) {
              // escape
              if (isListVisible) {
                hideList();
                $container.focus();
              }
            }
          }
          if ($list) {
            $list.remove();
          }
          $list = $('<ul class="multiline-select-list" tabindex="0"></ul>');
          Array.prototype.forEach.call($options, function (option) {
            var $option = $(option);
            var value = $option.attr('value');
            var text = option.innerHTML.replace(/\\n/gi, '<br>');
            if (text.indexOf('content(') !== -1) {
              text = $scope.content(text.substring(text.indexOf('(\'') + 2, text.indexOf('\')')));
            }
            var html = '<li tabindex="0"';
            if (value !== $option.text()) {
              html = html + ' data-value="' + value + '"';
            }
            html = html + '>' + text + '</li>';
            $list.append($(html));
          });
          $container.append($list);
          $list.hide();
          $($list.find('li')).click(function (event) {
            var $target = $(event.target);
            var value = $target.data('value');
            if (typeof value !== 'undefined') {
              $select.find('option').removeAttr('selected');
              $select.find('option[value="' + value + '"]').attr('selected', 'selected');
              $select.find('option').removeProp('selected');
              $select.find('option[value="' + value + '"]').prop('selected', 'selected');
            } else {
              value = $target.html().replace(/\/<br\/>/gi, '\\n');
              $select.val(value);
            }
            if ($select.attr('ng-model')) {
              if ($select.attr('ng-options') || $select.find('[ng-repeat]').length) {
                /* This parses the 'ng-options' directive and returns the options model.
                For example: If you have: ng-options='opt as opt.label for opt in options'
                Here it will parse this attribute and return 'options */
                var model = getModel();
                ngModel.$setViewValue(model[value]);
              } else {
                ngModel.$setViewValue(value);
              }
            }
            updateCover();
            hideList();
          });
          var $innerContainer = $container.find('.innerContainer');
          $container.click(function () {
            if (isListVisible) {
              hideList();
              $container.focus();
            } else {
              showList();
            }
          });
          $container.keydown(function (event) {
            return processContainerKeypress(event);
          });
          $innerContainer.keydown(function (event) {
            return processContainerKeypress(event);
          });
          $list.find('li').keydown(function (event) {
            var keyCode = event && event.keyCode;
            var $target = $(event.target);
            if (keyCode === 13) {
              // enter
              $target.click();
              event.stopPropagation();
            } else if (keyCode === 27) {
              // escape
              if (isListVisible) {
                hideList();
                $container.focus();
                event.stopPropagation();
              }
            } else if (keyCode === 40) {
              // down arrow
              if (!$target.is(':last-of-type')) {
                $target.next().focus();
                event.preventDefault();
                event.stopPropagation();
              }
            } else if (keyCode === 38) {
              // up arrow
              if (!$target.is(':first-of-type')) {
                $target.prev().focus();
              }
              event.preventDefault();
              event.stopPropagation();
            }
          });
          $(window).resize(function () {
            if (isListVisible) {
              positionList();
            }
          });
          $(window).bind('hashchange', function () {
            if (isListVisible) {
              hideList();
            }
          });
          $(document).click(function (event) {
            var $target = $(event.target);
            if (!($target.is($container) || $.contains($container.get()[0], $target.get()[0])) && isListVisible) {
              hideList();
            }
          });
          $container.blur(function (event) {
            // The setTimeout here is to ensure activeElement is set before our function executes
            $timeout(function () {
              var $newTarget = $(event.explicitOriginalTarget || document.activeElement);
              if (!($.contains($container.get()[0], $newTarget.get()[0]) || $.contains($list.get()[0], $newTarget.get()[0]))) {
                hideList(event);
              }
            }, 1);
          });
          listCreated = true;
          updateCover();
        }
        function render() {
          var options = $select.find('option');
          if (!listCreated) {
            createList(options);
          }
        }
        $select.wrap($container);
        $container = $select.parent();

        // Change class names to enable styling of hover/focus states
        $select.bind('mouseenter focus', function () {
          return $span.addClass('active');
        });
        // Change class names to enable styling of hover/focus states
        $select.bind('mouseleave blur', function () {
          return $span.removeClass('active');
        });
        $select.after($span);
        $select.addClass('replaced');
        $select.attr('tabindex', '-1');
        if (attrs['default']) {
          var defaultOption = document.createElement('option');
          defaultOption.innerText = attrs['default'];
          $select.append(defaultOption);
        }
        if ($select.attr('ng-options')) {
          $scope.$watch(attrs.ngModel, function () {
            render();
          });
        } else {
          $timeout(function () {
            return $scope.$broadcast('pageRendered');
          });
        }
        $scope.$on('pageRendered', function () {
          return render();
        });
      }
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/dropdown/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(console) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, $) {
  $.fn.dropdown = function () {
    console.warn('Dropdown deprecated');
  };
  squid.module('xo-dropdown.directive', ['squid']).directive('xoDropdown', ['$parse', '$window', '$timeout', '$util', '$compile', function ($parse, $window, $timeout, $util, $compile) {
    var userAgent = ($window.navigator || {}).userAgent;
    var isWinOS = Boolean(userAgent.match(/\(win/i));
    return {
      restrict: 'A',
      scope: {
        dropdownTextBindVar: '=?'
      },
      link: function link($scope, $element, attrs) {
        var $parentScope = $scope.$parent;
        var $select = $($element);
        // TODO: This html should be refactored out into a template.
        var $span = $('<span class="custom-select" aria-hidden="true"><span><span></span></span></span>');
        var selectInitialValue = '';
        var ngChange = '';
        $select.parent().addClass('custom-select-container');
        // Change class names to enable styling of hover/focus states
        $select.bind('mouseenter', function () {
          return $span.addClass('active');
        });
        $select.bind('mouseleave', function () {
          return $span.removeClass('active');
        });
        // Change class names to enable styling of hover/focus states
        $select.bind('focus', function () {
          selectInitialValue = $parse(attrs.ngModel)($parentScope);
          $span.addClass('active');
        });
        function executeSelectChange() {
          // setTimeout here is to ensure activeElement is set before our function executes
          $timeout(function () {
            var val = $parse(attrs.ngModel)($parentScope);
            if (selectInitialValue !== val) {
              if (ngChange) {
                ngChange($parentScope);
              }
              selectInitialValue = val;
            }
          }, 5);
        }
        if (isWinOS) {
          if (attrs['ngChange']) {
            ngChange = $parse(attrs.ngChange);
            attrs['ngChange'] = '';
          }
          $select.bind('blur', function () {
            executeSelectChange();
            $span.removeClass('active');
          });
          $select.bind('click', function () {
            return executeSelectChange();
          });
        } else {
          $select.bind('blur', function () {
            return $span.removeClass('active');
          });
        }
        $select.after($span);
        $select.addClass('replaced');
        if (attrs['default']) {
          var defaultOption = document.createElement('option');
          defaultOption.innerText = attrs['default'];
          $select.append(defaultOption);
        }
        var match = (attrs.ngOptions || '').match(/in ([\w\.]+)/);
        // Text Update Method 1(new): ng-bind on variable passed in directive and that is updated in parent/sibling scope
        if (angular.isDefined($scope.dropdownTextBindVar)) {
          var selectTextElement = $span.find('span span');
          if (selectTextElement.length) {
            $(selectTextElement).attr('ng-bind', 'dropdownTextBindVar');
            $(selectTextElement).html($compile(selectTextElement[0])($scope));
          }
          $scope.$watch('dropdownTextBindVar', function (newVal) {
            if (document.documentElement.getAttribute('dir') === 'rtl') {
              $span.toggleClass('ltrOverride', !$util.hasRTL(newVal));
            }
          });
        }
        // Text Update Method 2(old): jQuery text update on various conditions (not as reliable for me, ran into timing edge cases)
        else {
          var updateCover = function updateCover() {
            $timeout(function () {
              var text = $select.find(':selected').text().trim();
              $span.find('span span').text(text);
              if (document.documentElement.getAttribute('dir') === 'rtl') {
                $span.toggleClass('ltrOverride', !$util.hasRTL(text));
              }
            }, 5);
          };
          $parentScope.$watch(attrs.ngModel, updateCover);
          $scope.$on('contentChange', updateCover);
          if (match) {
            $parentScope.$watch(match[1], updateCover);
          }
          // Update cover on arrow key press, for case where menu is not open
          // but user is interacting with dropdown (eg. Firefox)
          $select.bind('keyup', function (event) {
            // Arrow keys are 37 - 40
            if (event.which >= 37 || event.which <= 40) {
              updateCover();
            }
          });
        }
        toggleOptionsLTROverride();
        if (match) {
          $parentScope.$watch(match[1], function (newVal) {
            toggleOptionsLTROverride();
          });
        }
        function toggleOptionsLTROverride() {
          if (document.documentElement.getAttribute('dir') === 'rtl') {
            $timeout(function () {
              var options = $select.find('option');
              for (var i = 0; i < options.length; i++) {
                $(options.get(i)).toggleClass('ltrOverride', !$util.hasRTL(options.get(i).text));
              }
            });
          }
        }
      }
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/console-browserify/index.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/error-tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _angularAria = __webpack_require__("../node_modules/angular-aria/angular-aria.min.js");
// Configure angular aria.
// Note that aria configuration applies globally
_angularAria.$ariaProvider.config({
  // eslint-disable-line angular/di
  // Remove bindRoleForClick since we use ngClick for several items that shouldn't be treated as buttons.
  bindRoleForClick: false,
  // Remove ariaInvalid and ariaRequired as we want to handle them ourselves.
  // These attributes should only be set once the form is submitted, to match what
  // visually what we display
  ariaInvalid: false,
  ariaRequired: false,
  // Removing aria-hidden attribute for hidden elements
  ariaHidden: false
});
(0, _squid.$registerDirective)('xo-error-tooltip', function () {
  return {
    restrict: 'A',
    require: ['?^form', '?ngModel'],
    link: function link(scope, element, attrs, ctrls) {
      var formCtrl = ctrls[0],
        modelCtrl = ctrls[1];
      function shouldBeRequired() {
        if (formCtrl) {
          // If input is a checkbox and has error-text or error-key, show the error text instead of the required text.
          // error-text is a legacy thing for backward compatibility, we can get rid of this once all teams
          // adopt error-key in all input tags
          var showCheckboxRequired = !(element.attr('type') === 'checkbox' && (attrs.errorText || attrs.errorKey));
          return formCtrl.$submitted && modelCtrl.$error.required && showCheckboxRequired;
        } else {
          return modelCtrl.$error.required;
        }
      }
      function shouldBeInvalid() {
        if (formCtrl) {
          return formCtrl.$submitted && modelCtrl.$invalid;
        } else {
          return modelCtrl.$invalid;
        }
      }

      // Add or remove a string into a space split string (eg. aria-describedby ids, class names)
      function formatSpaceSplitString(str, id, add) {
        var strArray;
        if (str) {
          strArray = str.split(' ');
        } else {
          strArray = [];
        }
        var idIndex = strArray.indexOf(id);
        if (~idIndex && !add) {
          strArray.splice(idIndex, 1);
        } else if (!~idIndex && add) {
          strArray.push(id);
        }
        return strArray.join(' ');
      }

      // Add tooltip behavior after DOM settles
      (0, _angular.$timeout)(function () {
        var generateId = function generateId() {
          return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
        };
        var requiredId = generateId();
        var invalidId = generateId();
        var requiredError;
        var invalidError;
        if (attrs.errorKey) {
          element.addClass('hasErrorTooltipRuleSpecific');
          invalidError = (0, _angular.$compile)("<div class=\"errorTooltip errorTooltipRuleSpecific\" id=\"" + invalidId + "\">{{content(\"" + attrs.errorKey + "\")}}</div>")(scope);
          element.after(invalidError);
        } else if (attrs.errorText) {
          // errorText if case is for backward compatibility, we can get rid of this once
          // all teams adopt error-key in all input tags for tooltip message display
          element.addClass('hasErrorTooltipRuleSpecific');
          invalidError = $("<div class=\"errorTooltip errorTooltipRuleSpecific\" id=\"" + invalidId + "\">" + attrs.errorText + "</div>");
          element.after(invalidError);
        }
        if (attrs.required || (0, _angular.$parse)(attrs.ngRequired)(scope)) {
          element.addClass('hasErrorTooltipRequired');
          requiredError = (0, _angular.$compile)("<div class=\"errorTooltip errorTooltipRequired\" id=\"" + requiredId + "\">{{content(\"validation.required\")}}</div>")(scope);
          element.after(requiredError);
          element.removeAttr('aria-required');
        }
        function setAriaAttributes() {
          var addTooltips = {
            required: false,
            invalid: false
          };

          // Do not associate "Required" error with aria-describedby
          // because this should already be read out either by "required"
          // attribute or "aria-required"=true, and only associate "Invalid"
          // error if "Required" is not showing to match visuals
          if (shouldBeRequired()) {
            addTooltips.required = true;
          } else if (shouldBeInvalid()) {
            addTooltips.invalid = true;
          }
          var describedby = element.attr('aria-describedby');
          describedby = formatSpaceSplitString(describedby, requiredId, addTooltips.required);
          describedby = formatSpaceSplitString(describedby, invalidId, addTooltips.invalid);
          element.attr('aria-describedby', describedby);
        }
        scope.$watch(shouldBeRequired, function (newVal) {
          setAriaAttributes();
        });
        scope.$watch(shouldBeInvalid, function (newVal) {
          element.attr('aria-invalid', newVal);
          setAriaAttributes();
        });

        // Set scroll so that the error message is in view when element receives focus
        element.on('focus', function (event) {
          var windowBot = $(window).scrollTop() + $(window).height();
          var requiredBot = requiredError ? requiredError.offset().top + requiredError.outerHeight() : 0;
          var invalidBot = invalidError ? invalidError.offset().top + invalidError.outerHeight() : 0;
          if (windowBot < Math.max(requiredBot, invalidBot)) {
            $(window).scrollTop(Math.max(requiredBot, invalidBot) - $(window).height());
          }
        });
      });
    }
  };
});
_squid.$registerDirective;
_angular.$parse;
_angular.$compile;
_angular.$timeout;
_angularAria.$ariaProvider;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/closeFrame/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/closeFrame/template.html"), __webpack_require__("../node_modules/xo-models/src/user/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
  squid.module('xo-escape-hatch.closeFrame.directive', ['squid', 'xomodel.user']).directive('xoCloseFrame', [function () {
    return {
      template: template,
      restrict: 'E',
      scope: {
        redirectiframe: '=?',
        redirectLightbox: '=?'
      },
      controller: ['$scope', '$rootScope', '$populate', '$CheckoutInputDataModel', '$window', '$CheckoutAppDataModel', '$util', '$injector', '$logger', function ($scope, $rootScope, $populate, $CheckoutInputDataModel, $window, $CheckoutAppDataModel, $util, $injector, $logger) {
        $populate($scope, {
          checkoutAppData: $CheckoutAppDataModel.instance($rootScope.token)
        }).then(function () {
          var cancel_url = $scope.checkoutAppData.urls.cancel_url;
          $scope.checkoutInputData = $CheckoutInputDataModel.instance($scope.token);
          $scope.isIFrame = $util.isIFrame();
          $scope.closeFrame = function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (window.xchild) {
              if (window.xprops.onCancel) {
                return window.xprops.onCancel({
                  token: $scope.token,
                  cancelUrl: cancel_url
                });
              } else {
                return window.xchild.close();
              }
            }
            if ($scope.redirectLightbox) {
              var result = _index.$ReturnToMerchant.postToMerchant({
                operation: 'return_to_merchant',
                returnUrl: cancel_url,
                updateParent: true
              });

              // Otherwise we have no choice but to return to the merchant
              if (!result) {
                $util.redirect(cancel_url);
              }

              // TODO - Move out helios specific logic. Apps should provide a callback instead.
            } else if ($scope.redirectiframe) {
              $window.location.replace(cancel_url);

              // TODO - Move out helios specific logic. Apps should provide a callback instead.
            } else {
              var iFrameFlow = $injector.get('$IFrameFlow');
              $logger.info('HELIOS_FLOW_FALLBACK'); // overall fallbacks
              $logger.info('HELIOS_FALLBACK_TO_MERCHANT');
              $logger.info('HELIOS_FALLBACK_MERCHANT_USER_CANCELLED');
              var url = $scope.checkoutInputData.errorUrl('user_cancelled');
              if ($scope.auth && $scope.auth.code) {
                url += '&code=' + $scope.auth.code;
              }
              iFrameFlow.findWindowAndRedirect($scope.checkoutInputData, url);
            }
            $scope.$emit('exitFrame');
          };
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_index.$ReturnToMerchant;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/escape-hatch/escapeHatch/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
  squid.module('xo-escape-hatch.escapeHatch.directive', ['squid']).directive('xoEscapeHatch', [function () {
    return {
      template: template,
      restrict: 'E',
      controller: ['$scope', '$rootScope', '$window', '$util', '$logger', function ($scope, $rootScope, $window, $util, $logger) {
        $scope.isIFrame = $util.isIFrame();
        $scope.closeFrame = function (event) {
          var url = $window.location.href && $window.location.href.split('#')[0] || '';
          if (url.indexOf('proxflow') > -1) {
            url = url.replace('proxflow', 'webapps/helios');
          }
          url += url.slice(-1) === '&' ? 'escape_hatch=1' : '&escape_hatch=1';
          if (url.indexOf('hermes') > -1 || url.indexOf('checkoutnow')) {
            $logger.info('HERMES_ESCAPE_HATCH_CLICKED');
          } else {
            $logger.info('HELIOS_ESCAPE_HATCH_CLICKED');
          }
          $window.top.location = url;
          $scope.$emit('exitFrame');
        };
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/floating-label/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/styles.less");
var treatmentType;
var newLocale;
var oldLocale;
function getTreatment() {
  if (treatmentType !== undefined) {
    return treatmentType;
  }
  if ((0, _squid.$feature)('floatingLabels')) {
    return true;
  }
  var token = _angular.$rootScope.token;
  var throttle = _squid.$config['floatingLabelLocales'] && _squid.$config['floatingLabelLocales'][_squid.$locale.country] && _squid.$config['floatingLabelLocales'][_squid.$locale.country][_squid.$locale.lang];
  var id = _squid.$locale.lang + "_" + _squid.$locale.country + token;
  treatmentType = throttle && (0, _squid.$experiment)('floating_label_exp', throttle, id, {}) ? true : false;
  return treatmentType;
}
(0, _squid.$registerDirective)('floating-label', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      scope.$on('localeChange', function () {
        newLocale = _squid.$locale.country + "_" + _squid.$locale.lang;
        if (oldLocale !== newLocale) {
          treatmentType = undefined;
          oldLocale = newLocale;
        }
        scope.showFloatingLabels = getTreatment();
      });
      (0, _angular.$timeout)(function () {
        scope.showFloatingLabels = getTreatment();
        scope.$watch('showFloatingLabels', function (val) {
          // remove else block after experimentation is complete
          if (val) {
            element.addClass('floatingLabel');
            element.removeClass('noFloatingLabel');
          } else {
            element.removeClass('floatingLabel');
            element.addClass('noFloatingLabel');
          }
        });
        var input = element.find('input');
        if (input.attr('placeholder')) {
          input.addClass('hasPlaceholder');
        }

        // To hide the placeholder labels for pre-populated input fields
        scope.$watch(input.attr('ng-model'), function (value) {
          input.toggleClass('focused', !!value);
        });

        // We're using this as an alternative to watching 'ng-model' since this properly triggers the focused CSS property on email input.
        input.on('keyup', function (event) {
          var val = event.target.value;
          input.toggleClass('focused', !!val);
        });
        input.on('focus blur click', function (event) {
          if (scope.showFloatingLabels) {
            input.toggleClass('focused', event.type === 'focus' || this.value.length > 0);
          }
        });
        if (!('disableAutoblur' in attrs)) {
          input.trigger('blur');
        }
      });
    }
  };
});
(0, _squid.$registerDirective)('floating-label-dropdown', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      scope.$on('localeChange', function () {
        newLocale = _squid.$locale.country + "_" + _squid.$locale.lang;
        if (oldLocale !== newLocale) {
          treatmentType = undefined;
          oldLocale = newLocale;
        }
        scope.showFloatingLabels = getTreatment();
      });
      (0, _angular.$timeout)(function () {
        scope.showFloatingLabels = getTreatment();
        scope.$watch('showFloatingLabels', function (val) {
          // remove else block after experimentation is complete
          if (val) {
            element.addClass('floatingLabel');
            element.removeClass('noFloatingLabel');
          } else {
            element.removeClass('floatingLabel');
            element.addClass('noFloatingLabel');
          }
        });
        var select = element.find('select');
        var label = element.find('label');
        var flSpan = element.find('.custom-select span span');
        select.on('change mouseenter mouseleave blur', function (event) {
          var value = event.currentTarget.value;
          select.toggleClass('focused', event.type === 'change' || value.length > 0);
          flSpan.toggleClass('noValue', value.length < 1);
          label.toggleClass('hide', value.length < 1);
        }).trigger('mouseleave');
      });
    }
  };
});
_angular.$timeout;
_angular.$rootScope;
_squid.$locale;
_squid.$experiment;
_squid.$config;
_squid.$feature;
_squid.$registerDirective;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/floating-label/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");
var _index2 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/banner/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-ui-components/src/generic-error/template.html"));
__webpack_require__("../node_modules/xo-ui-components/src/generic-error/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TITLE_KEY_MAPPING = {
  BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingTitle',
  BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleTitle',
  COMPLIANCE_VIOLATION: 'transactionRefusedTitle',
  DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredTitle',
  GAMER_LOGIN_OUT_OF_COUNTRY: 'sorry',
  GAMER_RESIDENCE_OUT_OF_COUNTRY: 'sorry',
  HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleMemberDCF',
  INTERNAL_SERVICE_ERROR: 'transactionRefusedTitle',
  NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedTitle',
  PAYEE_ACCOUNT_LOCKED_OR_CLOSED: 'payeeAccountLockedOrClosedTitle',
  PAYER_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
  PAYER_COUNTRY_NOT_ENABLED: 'payerCountryNotAllowedTitle',
  PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'payerCountryNotAllowedTitle',
  PAYMENT_PROCESS_ERROR: 'paymentProcessError',
  RETRY: 'sorry',
  SENDING_LIMIT_EXCEEDED: 'genericErrorMessageTitle',
  STUDENT_ACCOUNT: 'studentAccountTitle',
  TRANSACTION_REFUSED: 'transactionRefusedTitle',
  XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'payerCountryNotAllowedTitleSignupDCF',
  CREDIT_CARD_AUTH_FAILED: 'smartDollarAuthFailedMsg'
};
var CONTENT_KEY_MAPPING = {
  ACCOUNT_CANNOT_BE_FETCHED: 'genericError',
  AGREEMENT_ALREADY_CREATED: 'agreementAlreadyCreated',
  // TODO: rename to a common one, e.g TOKENIZED_WALLET_ELIGIBILITY_ERROR later
  ANDROID_PAY_ALREADY_PROVISIONED: 'tokenizedWalletAlreadyProvisioned',
  ANDROID_PAY_ELIGIBILITY_ERROR: 'tokenizedWalletGenericError',
  // end of TODO
  BLOCK_NON_DOMESTIC_SHIPPING: 'blockNonDomesticShippingMessage',
  BLOCK_PPC_INELIGIBLE_USER: 'blockPPCIneligibleMessage',
  COMPLIANCE_VIOLATION: 'complianceViolationMessage',
  DEFAULT_TOKENIZED_WALLET_ERROR: 'tokenizedWalletGenericError',
  DEFAULT: 'genericError',
  DOMESTIC_TRANSACTION_REQUIRED: 'domesticTransactionRequiredMessage',
  DUPLICATE_INVOICE_ID: 'duplicateInvoiceId',
  EINVALIDCSRF_JWT_EXPIRED: 'csrfTokenExpired',
  EXPIRED_SESSION: 'expiredOrTokenNotFoundError',
  GAMER_ACCOUNT_UNVERIFIED: 'accountUnverified',
  GAMER_INELIGIBLE: 'transactionRefusedTitle',
  GAMER_FI_INELIGIBLE: 'fiIneligible',
  GAMER_FI_UNCONFIRMED: 'fiUnconfirmed',
  GAMER_INVALID_ACCOUNT_TYPE: 'invalidAccountType',
  GAMER_LOGIN_OUT_OF_COUNTRY: 'unauthorizedCountryLogin',
  GAMER_NO_VALID_FUNDING_INSTRUMENT: 'fiIneligible',
  GAMER_RESIDENCE_OUT_OF_COUNTRY: 'unauthorizedCountryAccountRegistered',
  GAMING_FUNDING_SOURCE_VALIDATION_FAILED: 'unauthorizedCountryAccountRegistered',
  GUEST_UPGRADE_ERROR: 'guestUpgradeError',
  GUEST_UPGRADE_SESSION_ERROR: 'guestUpgradeSessionError',
  HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountMemberDCF',
  INTERNAL_SERVICE_ERROR: 'transactionRefusedMessage',
  INVALID_RESOURCE_ID: 'expiredOrTokenNotFoundError',
  NEGATIVE_BALANCE_TRANSACTION_REFUSED: 'negativeBalanceRefusedMessage',
  PAYEE_ACCOUNT_LOCKED_OR_CLOSED: 'payeeAccountLockedOrClosed',
  PAYEE_BLOCKED_TRANSACTION: 'paymentDeniedError',
  PAYER_CANNOT_PAY: 'paymentDeniedError',
  PAYER_CANNOT_MAKE_PAYMENT: 'paymentDeniedError1',
  PAYER_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryAccountRegistered',
  PAYER_COUNTRY_NOT_ENABLED: 'rpUnauthorizedCountryMessage',
  PAYER_LOGIN_COUNTRY_NOT_ALLOWED: 'unauthorizedCountryLogin',
  PAYMENT_ALREADY_DONE: 'paymentAlreadyCompletedError',
  PAYMENT_DENIED: 'paymentDeniedError',
  PAYMENT_PROCESS_ERROR: 'chooseOtherWayToPay',
  RESTRICTED_USER: 'buyerRestrictedError',
  RETRY: 'thingsNotWorking',
  SENDING_LIMIT_EXCEEDED: 'sendingLimitExceeded',
  STUDENT_ACCOUNT: 'studentAccountMessage',
  TRANSACTION_LIMIT_EXCEEDED: 'transactionLimitExceeded',
  TRANSACTION_REFUSED: 'transactionRefusedMessage',
  CREDIT_CARD_AUTH_FAILED: 'transactionRefusedMessage',
  UNSUPPORTED_COUNTRY: 'unsupportedCountry',
  UNSUPPORTED_DUE_TO_RECEIVER_PREFERENCE: 'unsupportedReceiverPreferences',
  UNSUPPORTED_PAYEE_CURRENCY: 'unsupportedPayeeCurrency',
  XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: 'unauthorizedCountryAccountSignupDCF'
};

// pass merchantName attribute, if undefined, then suffix 'Default' to key
var renderContentWithMerchantName = function renderContentWithMerchantName(key) {
  var merchantNameFromProps = this.props.merchant;

  // we may not get merchantName as props, look for models also
  var merchantNameFromModels;
  if (this.models && this.models.checkoutAppData && this.models.checkoutAppData.merchant) {
    var merchant = this.models.checkoutAppData.merchant;
    merchantNameFromModels = merchant.brand_name || merchant.merchant_name;
  }
  var merchantName = merchantNameFromProps || merchantNameFromModels;
  if (merchantName) {
    return (0, _squid.$renderContent)(key, {
      merchantName: merchantName
    });
  }
  return (0, _squid.$renderContent)(key + 'Default');
};
var renderContentWithWalletTokenizationName = function renderContentWithWalletTokenizationName(key) {
  var brandName = this.models.tokenizedWalletInfoModel.brandName();
  return (0, _squid.$renderContent)(key, {
    type: brandName
  });
};
var renderContentWithCountryAndLang = function renderContentWithCountryAndLang(key) {
  return (0, _squid.$renderContent)(key, {
    lang: _squid.$locale.lang,
    country: _squid.$locale.country
  });
};

// handle non-standard merchant error title strings
var TITLE_KEY_HANDLER = {
  DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
  HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
  XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName
};

// handle non-standard merchant error content strings
var CONTENT_KEY_HANDLER = {
  AGREEMENT_ALREADY_CREATED: renderContentWithMerchantName,
  ANDROID_PAY_ALREADY_PROVISIONED: renderContentWithWalletTokenizationName,
  DEFAULT_TOKENIZED_WALLET_ERROR: renderContentWithWalletTokenizationName,
  DOMESTIC_TRANSACTION_REQUIRED: renderContentWithMerchantName,
  HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
  XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF: renderContentWithMerchantName,
  PAYER_CANNOT_MAKE_PAYMENT: renderContentWithCountryAndLang
};
var SHOW_LOGOUT_LINK_CODES = ['HERMES_PAYER_COUNTRY_NOT_ALLOWED_DCF', 'ANDROID_PAY_COUNTRY_NOT_SUPPORTED', 'ANDROID_PAY_ALREADY_PROVISIONED', 'GAMER_INVALID_ACCOUNT_TYPE'];
var HIDE_CANCEL_LINK_CODES = ['PAYER_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'VENMO_ERROR_WITH_CANCEL_URL'];
var RETRY_LINK = ['EINVALIDCSRF_JWT_EXPIRED', 'GUEST_CHECKOUT_NOT_ALLOWED', 'RETRY'];
var TRANSACTION_REFUSED_BA_TITLE_MSG = {
  BA_NO_PURCHASE: 'transactionRefusedBAnoPurchaseTitle',
  BA_WITH_PURCHASE: 'transactionRefusedBAPurchaseTitle'
};

/* eslint-disable fasec/no-unsafe-regex */
var base64regex = new RegExp('^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$');
var _default = exports["default"] = _squid.$Component.extend('$xoGenericErrorComponent', {
  tag: 'xo-generic-error',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    logout: {
      type: 'var',
      required: false
    },
    isUnbranded: {
      type: 'var',
      required: false
    },
    cancelUrl: {
      type: 'str',
      required: false
    },
    merchant: {
      type: 'str',
      required: false
    }
  },
  resolve: {
    models: function models() {
      if (this.props.token) {
        return {
          checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.props.token).retrieve()["catch"](angular.noop),
          cart: _index3.$CheckoutCartModel.instance(this.props.token).retrieve()["catch"](angular.noop),
          checkoutPayee: _index3.$CheckoutPayeeModel.instance(this.props.token).retrieve()["catch"](angular.noop),
          auth: _index.$AuthModel.instance().retrieve()["catch"](angular.noop),
          tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance(this.props.token).retrieve()["catch"](angular.noop)
        };
      }
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        event.preventDefault();
      });
      this.$on('$destroy', cancelPreventStateChange);
      var self = this;

      // to not break other application's error integration, we'll still support base64 decoded code parameters
      if (_uiRouter.$stateParams.code && base64regex.test(_uiRouter.$stateParams.code)) {
        self.errorCode = _squid.$util.base64Decode(_uiRouter.$stateParams.code);
      } else {
        self.errorCode = _uiRouter.$stateParams.code;
      }
      self.hideCancelLink = HIDE_CANCEL_LINK_CODES.indexOf(self.errorCode) > -1;
      self.retryLink = RETRY_LINK.indexOf(self.errorCode) > -1;
      _angular.$rootScope.allowUnload = true;
      self.cancelLink = self.props.cancelUrl;
      self.checkAccountLink = _squid.$config.urls.myAccountUrl;

      // PAYER_CANNOT_MAKE_PAYMENT is a key for treatment group
      // corresponding to control group that passes PAYER_CANNOT_PAY
      // we pass this.treatment as ng-if case for showing html element
      // for treatment or control group selectively
      self.treatment = self.errorCode === 'PAYER_CANNOT_MAKE_PAYMENT';
      self.checkAccountRedirect = function () {
        _logger.$logger.info('redirectto_account');
        _squid.$util.redirect(self.checkAccountLink);
      };
      self.cancelRedirect = function () {
        var redirectUrl = self.cancelLink;
        if (_angular.$rootScope.partnerIntegration) {
          _logger.$logger.info('genericerror_partner_integration');
          redirectUrl = _squid.$util.buildURL(self.cancelLink, {
            error: 'true'
          });
        }
        _index2.$ReturnToMerchant.goTo(redirectUrl);
      };
      self.retryCheckout = function () {
        _squid.$util.reload();
      };
      self.isMessengerBAIntegration = _squid.$integration.getConfig('IS_MESSENGER_BA_INTEGRATION');
      self.loggingOut = function ($event) {
        $event.preventDefault();
        cancelPreventStateChange();
        self.props.logout();
      };
      (0, _jquery["default"])('.paypalHeaderWrapper').hide();
      // Cancel link should be shown for "Credit Ineligible" page for DE
      if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
        (0, _jquery["default"])('#defaultCancelLink').hide();
      }
      (0, _jquery["default"])('.footerWrapper').addClass('genericError');
      self.$on('$destroy', function (event) {
        (0, _jquery["default"])('.paypalHeaderWrapper').show();
        if (self.errorCode !== 'BLOCK_PPC_INELIGIBLE_USER') {
          (0, _jquery["default"])('#defaultCancelLink').show();
        }
        (0, _jquery["default"])('.footerWrapper').removeClass('genericError');
      });

      // Returns the title string, based on custom key handler
      self.getTitle = function () {
        var key = self.titleKey;
        if (TITLE_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
          return TITLE_KEY_HANDLER[self.errorCode].call(_this, key);
        }
        return (0, _squid.$renderContent)(key);
      };

      // Returns the content string, based on custom key handler
      self.getContent = function () {
        var key = self.contentKey;
        if (CONTENT_KEY_HANDLER.hasOwnProperty(self.errorCode)) {
          return CONTENT_KEY_HANDLER[self.errorCode].call(_this, key);
        }
        return (0, _squid.$renderContent)(key);
      };

      // Returns the cancel button label, based on presence of brand/merchant name
      self.getCancelLabel = function () {
        if (self.walletTokenization) {
          var brandName = _this.models.tokenizedWalletInfoModel.brandName();
          return (0, _squid.$renderContent)('common.backToTokenizedWalletB', {
            type: brandName
          });
        } else {
          var merchantName = _this.props.merchant;
          return (0, _index2.formatReturnContent)(_squid.$renderContent, merchantName);
        }
      };
      this.personalizedBanner = {
        show: false
      };
      _logger.$logger.info('checkout_fpti', {
        landing_page: 'error_page',
        int_error_code: '1',
        int_error_description: _uiRouter.$stateParams.code
      });
    },
    populate: function populate() {
      var _this$models = this.models,
        checkoutAppData = _this$models.checkoutAppData,
        checkoutPayee = _this$models.checkoutPayee,
        cart = _this$models.cart,
        auth = _this$models.auth;
      this.walletTokenization = cart && cart.isWalletTokenization();
      this.personalizedBanner.show = auth && auth.rememberedOT() && (0, _squid.$feature)('oneTouchPersonalization');
      if (checkoutAppData) {
        this.cancelLink = checkoutAppData.urls.cancel_url;
      }
      if (checkoutPayee) {
        var merchant = checkoutPayee.merchant;
        if (merchant.id && !this.hideCancelLink) {
          var hcl = _squid.$config.hideCancelLinkForMerchant;
          var shouldHide = hcl && hcl.indexOf(merchant.id) !== -1;
          if (shouldHide) {
            this.hideCancelLink = true;
          }
        }
      }
      if (auth) {
        this.showLogoutLink = _squid.$util.param('source') !== 'consumerApp' && this.props.logout && SHOW_LOGOUT_LINK_CODES.indexOf(this.errorCode) > -1 && !auth.disallow_login_switch; // disallow_login_switch is used for Google Pay - acount linking to hide "not you" button (see xo-hercules/auth/outputMapper)

        this.formattedNameInformal = (0, _squid.formatNameInformal)({
          first_name: auth.first_name,
          last_name: auth.last_name
        }) || auth.email;
      }

      // Map error code for Android Pay
      if (this.walletTokenization) {
        // For Android Pay, map all errors to generic Android Pay error except for
        // ANDROID_PAY_ALREADY_PROVISIONED
        if (this.errorCode !== 'ANDROID_PAY_ALREADY_PROVISIONED') {
          this.errorCode = 'DEFAULT_TOKENIZED_WALLET_ERROR';
        }
      }
      var titleKey = this.errorCode && TITLE_KEY_MAPPING[this.errorCode];
      if (titleKey) {
        if (titleKey === 'transactionRefusedTitle' && cart && cart.isBillingNoPurchase()) {
          this.titleKey = "genericError." + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_NO_PURCHASE'];
        } else if (titleKey === 'transactionRefusedTitle' && cart && cart.isBillingPurchase()) {
          this.titleKey = "genericError." + TRANSACTION_REFUSED_BA_TITLE_MSG['BA_WITH_PURCHASE'];
        } else {
          this.titleKey = "genericError." + titleKey;
        }
      }
      var contentKey = this.errorCode && CONTENT_KEY_MAPPING[this.errorCode] || CONTENT_KEY_MAPPING.DEFAULT;
      this.contentKey = "genericError." + contentKey;
    }
  }
});
_angular.$rootScope;
_uiRouter.$stateParams;
_logger.$logger;
_index.$AuthModel;
_app.$TokenizedWalletInfoModel;
_index2.$ReturnToMerchant;
_index2.formatReturnContent;
_squid.$Component;
_squid.$util;
_squid.$renderContent;
_squid.$config;
_squid.formatNameInformal;
_squid.$integration;
_squid.$feature;
_squid.$locale;
_index3.$CheckoutAppDataModel;
_index3.$CheckoutCartModel;
_index3.$CheckoutPayeeModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-error/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"genericError\" content>\n    <div class=\"container\">\n        <div class=\"logo\" ng-if=\"!props.isUnbranded\"></div>\n\n        <xo-banner ng-if=\"personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('memberReview.loggedInWithOneTouch', {userName: formattedNameInformal, lastName: models.auth.last_name, firstName: models.auth.first_name}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </xo-banner>\n        <div ng-if=\"!personalizedBanner.show && !isMessengerBAIntegration && showLogoutLink\" class=\"banner\">\n            <p class=\"userEmail\" id=\"reviewUserInfo\">\n                {{ content('creditcard.hi', {userName: formattedNameInformal}) }}\n                <a track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"loggingOut($event)\">{{ content('memberReview.notYou')}}</a>\n            </p>\n        </div>\n\n        <div class=\"title\" ng-if=\"titleKey\">\n            {{ getTitle() }}\n        </div>\n        <div class=\"message\"\n            ng-if=\"contentKey\"\n            ng-bind-html=\"getContent()\">\n        </div>\n        <p ng-if=\"retryLink\">\n            <a link-button prevent-default ng-click=\"retryCheckout()\" id=\"retryLink\" class=\"btn full\" role=\"button\">\n                {{ content('genericError.tryAgain') }}\n            </a>\n        </p>\n        <p class=\"topButton\" ng-if=\"checkAccountLink && treatment\">\n            <a prevent-default ng-click=\"checkAccountRedirect()\" id=\"checkAccountLink\" class=\"btn full\" role=\"button\">\n                {{ content('common.checkYourAccount') }}\n            </a>\n        </p>\n        <p class=\"cancelLink\" ng-if=\"cancelLink && !hideCancelLink\" ng-class=\"[{'topButton': !treatment}]\">\n            <a prevent-default ng-click=\"cancelRedirect()\" id=\"cancelLink\" ng-class=\"[{'btn full ': !treatment}, {'btn-secondary': retryLink}, {'cancelMessage': treatment}]\" role=\"button\" >\n                {{ getCancelLabel() }}\n            </a>\n        </p>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _app = __webpack_require__("../node_modules/xo-models/src/app/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/generic-message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, squid, template) {
  return angular.module('xo-generic-message.directive', ['squid']).directive('xoGenericMessage', ['$rootScope', function ($rootScope) {
    return {
      template: template,
      scope: {
        token: '=?'
      },
      controller: ['$scope', '$rootScope', '$stateParams', '$state', '$logger', '$CheckoutAppDataModel', '$DeviceInfo', '$window', '$populate', function ($scope, $rootScope,
      // eslint-disable-line no-shadow
      $stateParams, $state, $logger, $CheckoutAppDataModel, $DeviceInfo, $window, $populate) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
          event.preventDefault();
        });
        $('.paypalHeaderWrapper').hide();
        $('.footerWrapper').addClass('genericMessage');
        var titleKeyMapping = {
          PAYMENT_SUCCESS: 'paymentSuccessTitle',
          PAYMENT_SUCCESS_REDIRECT_FAILED: 'paymentSuccessTitle',
          DEFAULT: 'paymentSuccessTitle'
        };
        $scope.titleKey = 'genericMessage.' + ($stateParams.code && titleKeyMapping[$stateParams.code]) || titleKeyMapping.DEFAULT;
        $scope.disableReturnToMerchantButton = false;
        var contentKeyMapping = {
          PAYMENT_SUCCESS: 'paymentSuccessMessage',
          PAYMENT_SUCCESS_REDIRECT_FAILED: 'paymentSuccessMessage',
          DEFAULT: 'paymentSuccessMessage'
        };
        var contentKey = $stateParams.code && contentKeyMapping[$stateParams.code];
        if (contentKey) {
          $scope.contentKey = 'genericMessage.' + contentKey;
        }
        $populate($scope, {
          checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
          tokenizedWalletInfoModel: _app.$TokenizedWalletInfoModel.instance($scope.token),
          cart: _index.$CheckoutCartModel.instance($scope.token)
        }).then(function () {
          var merchant = $scope.checkoutAppData.merchant;
          $scope.merchant = merchant.brand_name || merchant.merchant_name || merchant.merchant_email;
          var _$stateParams$returnU = $stateParams.returnUrl,
            returnUrl = _$stateParams$returnU === void 0 ? $scope.checkoutAppData.urls.return_url : _$stateParams$returnU;
          var redirectTimedout = Boolean($stateParams.code === 'PAYMENT_SUCCESS_REDIRECT_FAILED');
          var enableSuccessReturnButton = Boolean($DeviceInfo.isDevice() && !redirectTimedout);
          if (enableSuccessReturnButton) {
            $scope.enableSuccessReturnUrl = true;
            var contentWithButtonKeyMapping = {
              PAYMENT_SUCCESS: 'successMessage',
              DEFAULT: 'paymentSuccessMessage'
            };
            var contentWithButtonKey = $stateParams.code && contentWithButtonKeyMapping[$stateParams.code];

            // hard coding it to returnButton, double checkout before changing this that content exists in genericMessage properties
            $scope.returnButtonLabel = (0, _squid.$renderContent)('genericMessage.returnButton');
            if (contentWithButtonKey) {
              $logger.info('generic_message_page_content_with_button_key');
              $scope.contentKey = '';
            }
            var walletTokenization = $scope.cart && $scope.cart.isWalletTokenization();
            if (walletTokenization) {
              var brandName = $scope.tokenizedWalletInfoModel.brandName();
              $scope.returnButtonLabel = (0, _squid.$renderContent)('common.backToTokenizedWalletB', {
                type: brandName
              });
            }
            $scope.goToMerchant = function () {
              $logger.info('checkout_fpti', {
                'from': 'POST_3DS',
                'to': 'checkout_end',
                'message': 'REDIRECT_TO_MERCHANT_ON_BUTTON_CLICK',
                'returnUrl': returnUrl
              });
              // eslint-disable-next-line no-empty-function
              $window.onunload = $window.onbeforeunload = function () {};
              $scope.disableReturnToMerchantButton = true;
              setTimeout(function () {
                $scope.disableReturnToMerchantButton = false;
              }, 15000); // Re-enable button after 15 seconds
              _squid.$util.redirect(returnUrl);
            };
          }
        });
        $scope.$on('$destroy', function (event) {
          $('.paypalHeaderWrapper').show();
          $('.footerWrapper').removeClass('genericMessage');
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_app.$TokenizedWalletInfoModel;
_index.$CheckoutCartModel;
_squid.$renderContent;
_squid.$util;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/message/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
  squid.module('xo-message.directive', ['squid']).directive('xoMessage', ['$timeout', '$loader', '$rootScope', function ($timeout, $loader, $rootScope) {
    return {
      scope: {
        message: '=?',
        // Expected type - {msgs: [], type: "info|error|success|warning"}
        isgreyheader: '=?'
      },
      template: template,
      link: function link(scope, element, attrs) {
        // Hide and show the alerts so that messages can be registered by
        // screen reader even if they are repeats. Uses $timeout to
        // wait for DOM before showing alerts again.
        var toggleAlert = function toggleAlert() {
          var $alert = element.find('ul');
          $alert.detach();
          $timeout(function () {
            element.find('#pageLevelErrors').append($alert);
          });
        };

        // Toggle the alert whenever message changes by removing it and reappending it
        // to the DOM. Should fire even if message
        // is changed to the same, as assumes that the message should be reapplied.
        var cancel;
        scope.$watchCollection('message', function () {
          if ($loader.isLoading() && !cancel) {
            // If loading, toggle the alert after all loading calls have been made.
            // This is so that the alert can be read by screen reader after focus
            cancel = $rootScope.$on('allLoaded', function () {
              cancel();
              toggleAlert();
              cancel = null;
            });
          } else {
            toggleAlert();
          }
        });
        scope.$on('$destroy', function () {
          if (cancel) {
            cancel();
          }
        });
      }
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-ui-components/src/modal/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Directives used in the template

(0, _squid.$registerDirective)('xoModal', function () {
  return {
    template: _template["default"],
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      show: '=?',
      showCloseButton: '=?',
      enableCloseOnEscape: '=?',
      onClose: '=?',
      enableMobileInterstitial: '@?',
      overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
    },
    controller: ['$scope', function ($scope) {
      $scope.animate = false; // Don't animate until triggered
      $scope.showOverlay = $scope.show;
      var escapeKeyHandler = function escapeKeyHandler($event) {
        if ($event.keyCode === 27) {
          // Escape key maps to keycode 27
          $scope.hideModal();
        }
      };
      if ($scope.enableCloseOnEscape) {
        // Handle escape button as close button click
        $(document).bind('keyup', escapeKeyHandler);
      }
      $scope.hideModal = function ($event) {
        if ($event) {
          $event.preventDefault();
        }
        $scope.show = false;
        $(document).unbind('keyup', escapeKeyHandler);
        if ($scope.onClose) {
          $scope.onClose();
        }
      };
    }],
    link: function link($scope, elem, attrs) {
      // HACK: without this check, the modal slides down/fades out upon it being rendered
      $scope.$watch('show', function (newVal, oldVal) {
        if (oldVal !== newVal) {
          // When the show prop changes
          $scope.animate = true; // Ensure the modal is animated
        }
      });
    }
  };
});
_squid.$registerDirective;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/modal/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-wrapper\" ng-class=\"{'animate': animate}\" ng-show='show' content>\n\t<div class=\"modal-overlay\"></div>\n\t<div class=\"modal-dialog\" ng-class=\"{'mobile-interstitial': enableMobileInterstitial}\" modal-box modal-cancel=\"hideModal()\">\n\t\t<div class=\"modal-content\" ng-class=\"{'modal-default': !overrideDefaultContainer}\" tabindex=\"-1\" focus-when=\"show\">\n\t\t\t<div ng-transclude>\n\t\t\t</div>\n\t\t\t<a link-button ng-if=\"showCloseButton\" ng-click=\"hideModal($event)\" class=\"close modal-x-link\"><span class=\"accessAid\">{{ content('common.back') }}</span></a>\n\t\t</div>\n\t</div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/prefix-attrs-with/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _default = exports["default"] = (0, _squid.$registerDirective)('prefix-attrs-with', function () {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      var prefix = attrs.prefixAttrsWith;
      if (prefix && prefix.length) {
        ['id', 'for', 'name'].forEach(function (attrName) {
          var base = attrs[attrName];
          if (base) {
            elem.attr(attrName, _squid.$util.dasherizeToCamel(prefix + "-" + base));
          }
        });
      }
    }
  };
});
_squid.$util;
_squid.$registerDirective;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-ui-components/src/select-simple/template.html"));
__webpack_require__("../node_modules/xo-ui-components/src/select-simple/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * xo-ui-select-simple
 * Full directive/template for the dropdown UI component (http://paypal-ui/components/forms/dropdowns)
 *
 * props:
 *  - options: Array<Option> ([{id: 1, label: 'Foo'}, {id: 2, label: 'Bar'}])
 *  - onSelect: Function, gets called when an option is selected
 *  - selectedOption: Option ({id: 1, label: 'Red'})
 *  - label: String, will add a floating label to the text box if passed
 *  - defaultText: String, placeholder text before an option is selected
*/
var _default = exports["default"] = _squid.$Component.extend('$xoUiSelectSimpleComponent', {
  tag: 'xo-ui-select-simple',
  template: _template["default"],
  props: {
    options: {
      type: 'var',
      required: true
    },
    selectedOption: {
      type: 'var',
      required: false
    },
    label: {
      type: 'var',
      required: false
    },
    defaultText: {
      type: 'var',
      required: false
    },
    onSelect: {
      type: 'var',
      required: false
    }
  },
  actions: {
    selectOption: function selectOption(option) {
      var hasOnSelectedCallback = typeof this.onSelect === 'function';
      var isNotSelected = !this.checkSameOption(this.selectedOption, option);
      if (hasOnSelectedCallback && isNotSelected) {
        this.onSelect(option);
      }
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.focused = false;
      this.checkSameOption = function (option1, option2) {
        if (option1 === void 0) {
          option1 = {};
        }
        if (option2 === void 0) {
          option2 = {};
        }
        return option1.id === option2.id && option1.label === option2.label;
      };
      var isValidSelected = function isValidSelected() {
        var inOptions = function inOptions() {
          return Boolean(_this.options.filter(function (option) {
            return _this.checkSameOption(_this.selectedOption, option);
          }).length);
        };
        return _this.selectedOption && inOptions();
      };
      var updateComputedOption = function updateComputedOption() {
        _this.hasLabel = Boolean(_this.label && _this.label.length && _this.selectedOption);
        if (isValidSelected()) {
          _this.compSelectedOption = (0, _angular.extend)({}, _this.selectedOption);
          return;
        } else {
          _this.compSelectedOption = undefined;
          _this.actions.selectOption(_this.compSelectedOption);
        }
      };
      this.$watch('selectedOption', updateComputedOption);
    }
  }
});
_squid.$Component;
_angular.extend;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/select-simple/template.html":
/***/ (function(module, exports) {

module.exports = "<div\n    ng-class=\"{ floatingLabel: hasLabel }\"\n    class=\"uiSelectSimple dropdown inputField\"\n    ng-mouseenter=\"active = true\"\n    ng-mouseleave=\"active = false\">\n    <div class=\"custom-select-container\">\n        <select\n            ng-model=\"compSelectedOption\"\n            ng-click=\"focused = !focused\"\n            ng-change=\"actions.selectOption(compSelectedOption)\"\n            ng-options=\"option.label for option in options track by option.id\"\n            ng-class=\"{ focused: focused || selectedOption }\"\n            class=\"replaced\">\n            <option value=\"\" disabled selected>{{ defaultText }}</option>\n        </select>\n        <span\n            ng-class=\"{ active: active }\"\n            class=\"custom-select\" aria-hidden=\"true\">\n            <span><span>{{ compSelectedOption ? compSelectedOption.label : '' }}</span></span>\n        </span>\n        <label ng-if=\"(label && selectedOption)\" class=\"floatingLabelLabel\">{{ label }}</label>\n        <label ng-if=\"!selectedOption\" class=\"defaultTextLabel\">{{ defaultText }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner-button/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner-button/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {
  return angular.module('xo-spinner-button.directive', []).directive('xoSpinnerButton', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        track: '@?',
        onClick: '=?',
        buttonText: '@?',
        isProcessing: '=?',
        validate: '=?'
      },
      controller: ['$scope', function ($scope) {
        $scope.submit = function () {
          if ($scope.onClick) {
            $scope.onClick();
          } else {
            $scope.validate = true;
          }
        };
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/spinner/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _sanitizeCaja = _interopRequireDefault(__webpack_require__("../node_modules/sanitize-caja/index.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-ui-components/src/spinner/template.html"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {
  squid.module('xo-spinner.directive', ['squid', 'beaver']).directive('xoSpinner', [function () {
    return {
      scope: {},
      template: template,
      controller: ['$scope', '$element', '$rootScope', '$locale', '$logger', '$loader', '$timeout', function ($scope, $element, $rootScope, $locale, $logger, $loader, $timeout) {
        var $body = angular.element(document.getElementsByTagName('body'));
        var $priorActiveElement = $();
        var $capturedElement = $();
        var $header = $('header');
        var $slidingArea = $('#main');
        var $footer = $('footer');

        /**
         * This hides page content from any screen readers.
         * When the spinner's active, the only thing that should be read out is the "Loading..." text.
         *
         * The only crappy thing here is the spinner's nested deep in the content, so please excuse this jQuery crap.
         * At the very least, let's cache these selectors :|
         */
        function hidePageContentFromScreenReader(toggle) {
          $body.attr('aria-busy', toggle);
          $header.attr('aria-busy', toggle);
          $slidingArea.attr('aria-busy', toggle);
          $footer.attr('aria-busy', toggle);
        }
        function preventDefault(event) {
          var _event$target = event.target,
            _event$target2 = _event$target === void 0 ? {} : _event$target,
            targetId = _event$target2.id;

          // Only call preventDefault if the target is not a captcha input.
          // If the target is a captcha input we don't want to prevent the
          // user from entering the captcha code.
          if (targetId !== 'captchaCode') {
            event.preventDefault();
          }
        }
        function captureFocus(event) {
          if (!$element.has(event.target).length) {
            $capturedElement = $(event.target);
          }
        }
        function setLoadingMessage(message) {
          if (angular.isObject(message)) {
            $scope.message = message.heading;
            $scope.subMessage = message.subHeading;
            $('#spinnerMessage').css('font-size', '17.5px');
            $('#spinnerMessage').html((0, _sanitizeCaja["default"])(message.heading));
            $('#spinnerSubHeading').html((0, _sanitizeCaja["default"])(message.subHeading));
          } else {
            $scope.message = message;
            $scope.subMessage = null;
            $('#spinnerMessage').html(message);
          }
        }
        function showSpinner() {
          $scope.loading = true;
          $logger.info('show_loading_spinner');
          $body.addClass('loading');

          // remember what was previously focused
          $priorActiveElement = $(':focus');
          $(':input, a').blur();
          hidePageContentFromScreenReader(true);
          if ($loader.firstLoad()) {
            setLoadingMessage($locale.content.get('base.processing'));
          }

          // focus on the message so that screen readers will let the user know the page is loading
          $(document).on('keydown', preventDefault);
          $(document).on('focusin', captureFocus);
          $timeout(function () {
            $('#spinner-message').focus().attr('alt', $scope.message || $locale.content.get('base.processing'));
          });
        }
        function hideSpinner() {
          $scope.loading = false;
          $logger.info('hide_loading_spinner');
          $('#preloaderSpinner').hide();
          $body.removeClass('loading');
          $(document).off('keydown', preventDefault);
          $(document).off('focusin', captureFocus);
          hidePageContentFromScreenReader(false);

          // Focus captured element if focus was given to an element while spinner was active.
          if ($capturedElement.length && $(document.body).has($capturedElement).length) {
            $capturedElement.focus();
            // Focus element that had focus before if it is still within the document
          } else if ($priorActiveElement.length && $(document.body).has($priorActiveElement).length) {
            $priorActiveElement.focus();
          } else {
            // If focus is not managed, default to focusing sliding area. Fixes FF and IE bug where tab focus starts from
            // the element last clicked, rather than top of page.
            $slidingArea.focus();
          }
          $priorActiveElement = $();
          $capturedElement = $();
        }
        var cancelStartLoad = $rootScope.$on('startLoad', showSpinner);
        var cancelAllLoaded = $rootScope.$on('allLoaded', hideSpinner);
        var cancelSetLoadingMessage = $rootScope.$on('loadingMessage', function (event, text) {
          setLoadingMessage(text);
        });
        $scope.$on('$destroy', function () {
          hideSpinner();
          cancelStartLoad();
          cancelAllLoaded();
          cancelSetLoadingMessage();
        });
        if ($loader.isLoading()) {
          showSpinner();
        }
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-ui-components/src/tabs/template.html"));
__webpack_require__("../node_modules/xo-ui-components/src/tabs/styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * THIS IS A WIP
 * At this point, only pass 2 tabs!
 *
 * xo-ui-tabs
 * props:
 *  - tabs: Array<Tab> ([{id: 1, label: content('string')}, {id: 2, label: content('otherString')}])
 *  - onSelect: Function, gets called when a tab is selected
 *  - selectedTab: Tab ({id: 1, label: content('string')})
 */
var _default = exports["default"] = _squid.$Component.extend('$xoUiTabsComponent', {
  tag: 'xo-ui-tabs',
  template: _template["default"],
  props: {
    tabs: {
      type: 'var',
      required: true
    },
    onSelect: {
      type: 'var',
      required: false
    },
    selectedTab: {
      type: 'var',
      required: false
    }
  },
  actions: {
    getTabIsActive: function getTabIsActive(tab) {
      return this.compSelectedTab && tab.id === this.compSelectedTab.id;
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      var isValidSelected = function isValidSelected() {
        var inTabs = function inTabs() {
          return Boolean(_this.tabs.filter(function (tab) {
            return _this.selectedTab.id === tab.id && _this.selectedTab.label === tab.label;
          }).length);
        };
        return _this.selectedTab && inTabs();
      };
      var updateComputedSelected = function updateComputedSelected() {
        if (_this.tabs.length <= 1) {
          return;
        }
        if (isValidSelected()) {
          _this.compSelectedTab = (0, _angular.extend)({}, _this.selectedTab);
          return;
        } else {
          _this.compSelectedTab = (0, _angular.extend)({}, _this.tabs[0]);
          _this.onSelect(_this.compSelectedTab);
        }
      };
      this.$watch('selectedTab', updateComputedSelected);
    }
  }
});
_squid.$Component;
_angular.extend;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tabs/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"tabs.length > 1\" class=\"tabContainer\">\n    <div class=\"tab\"\n        ng-repeat=\"tab in tabs\"\n        ng-class=\"{ active: actions.getTabIsActive(tab) }\"\n        ng-click=\"!actions.getTabIsActive(tab) && onSelect(tab)\"\n        ng-bind-html=\"tab.label\"></div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-ui-components/src/tooltip/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getDefaultShowEvent($el) {
  return $el.is('a') || $el.is('button') ? 'click' : 'focus';
}

// Modify the aria-describedby property to include the id when showing the element so contents are properly read
function addDescribedById($el, id) {
  var describedByIds = $el.attr('aria-describedby') ? $el.attr('aria-describedby').split(' ') : [];
  if (!~describedByIds.indexOf(id)) {
    describedByIds.push(id);
  }
  $el.attr('aria-describedby', describedByIds.join(' '));
}

// Modify the aria-describedby attribute to remove the id when hiding the element so contents are no longer read
function removeDescribedById($el, id) {
  var describedByIds = $el.attr('aria-describedby') || '';
  $el.attr('aria-describedby', describedByIds.split(' ').filter(function (existingId) {
    return existingId !== id;
  }).join(' '));
}
var isMouseTypeEvent = function isMouseTypeEvent(type) {
  return /mouse/.test(type);
};
function debounceOnMouseTrigger(type, fn) {
  var isMouseType = isMouseTypeEvent(type);
  return function () {
    var _arguments = arguments;
    if (isMouseType) {
      (0, _angular.$timeout)(function () {
        return fn.apply(null, _arguments);
      }, 250);
    } else {
      fn.apply(null, arguments);
    }
  };
}
var _default = exports["default"] = _squid.$Component.extend('xoTooltip', {
  tag: 'xo-tooltip',
  template: _template["default"],
  transclude: true,
  props: {
    trigger: {
      type: 'str',
      required: false
    },
    showEvent: {
      type: 'str',
      required: false
    },
    hideEvent: {
      type: 'str',
      required: false
    },
    displayInline: {
      type: 'var',
      required: false
    },
    align: {
      type: 'str',
      required: false
    }
  },
  lifecycle: {
    populate: function populate() {
      var $element = this.$element,
        trigger = this.trigger;
      var $trigger = $(trigger);
      var toolTip = $element.find('.toolTip');
      var toolTipID = this.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);
      var isMouseOver = false;

      /**
       * Toggle the show/hide state of the tooltip
       */
      var toggle = function toggle(event) {
        if (toolTip.length && toolTip.is(':visible')) {
          close(event);
        } else {
          show(event);
        }
      };

      /**
       * Show the tooltip, if not already shown.
       */
      var show = function show(event) {
        if (event) {
          event.stopPropagation();
          event.preventDefault();
        }
        addDescribedById($trigger, toolTipID);

        // Show the tooltip and position the page scroll to include the element on page
        $element.show();
        toolTip.slideDown({
          progress: function progress() {
            var windowBot = $(window).scrollTop() + $(window).height();
            var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
            if (toolTipBot > windowBot) {
              $(window).scrollTop(toolTipBot - $(window).height());
            }
          }
        });
      };

      /**
       * Hide the tooltip
       */
      var close = function close(event) {
        if (event) {
          event.stopPropagation();
          event.preventDefault();
        }
        if (!isMouseOver) {
          if (toolTip.length && toolTip.is(':visible')) {
            toolTip.slideUp(100, function () {
              $element.hide();
            });
          } else {
            $element.hide();
          }
          removeDescribedById($trigger, toolTipID);
        }
      };

      /**
       * Setting up the DOM behavior for this component
       */
      // Set defaults for showEvent and hideEvent if not provided
      this.showEvent = this.showEvent || getDefaultShowEvent($element);
      this.hideEvent = this.hideEvent || 'blur';
      var SHOW_EVENT = this.showEvent + ".toolTip";
      var HIDE_EVENT = this.hideEvent + ".toolTip";

      // Initially hide the tooltip
      $element.hide();

      // If tooltip is clicked, don't bubble up and trigger parent handlers
      $element.on('click', function (event) {
        return event.stopPropagation();
      });

      // If the tooltip contains an element with a "close" class, treat it as a close button
      $element.on('click', '.close', close);

      // Track whether the mouse is on the tooltip or not
      $element.on('mouseover', function () {
        isMouseOver = true;
      });
      $element.on('mouseleave', function () {
        isMouseOver = false;
      });

      // Clicking anywhere on the document not on the tooltip will close the tooltip.
      // Event is not passed so that other actions are not prevented
      $(document).on('click.toolTip', function (e) {
        // Needed because when the trigger is clicked, this click handler will also be fired.
        // So without this check the tooltip will open due to the trigger click and then this
        // document event handler would immediately close it
        if (!$trigger.is(e.target)) {
          close();
        } else {
          show();
        }
      });

      // Register the handlers to show and hide the tooltip
      if (this.showEvent === this.hideEvent) {
        $trigger.on(SHOW_EVENT, toggle);
        $element.on(SHOW_EVENT, toggle);
      } else {
        $trigger.on(SHOW_EVENT, show);
        $trigger.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
        // Also allow close event to happen on the tooltip itself, for mouse type events
        $element.on(HIDE_EVENT, debounceOnMouseTrigger(this.hideEvent, close));
      }

      // Clean up external listeners on exit
      this.$on('$destroy', function () {
        $(document).off('click.toolTip');
        $trigger.off(SHOW_EVENT);
        $trigger.off(HIDE_EVENT);
        close();
      });
    }
  }
});
_angular.$timeout;
_squid.$Component;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-ui-components/src/tooltip/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-ui-components/src/ui-utils/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Generic scroll top.
(0, _squid.$registerDirective)('scrollTop', function () {
  return {
    link: function link(scope, element, attr) {
      var targetId = attr['scrollTop'];
      (0, _jquery["default"])(element).on('focus', function () {
        (0, _jquery["default"])('#' + targetId).scrollTop((0, _jquery["default"])(element).offset().top);
      });
    }
  };
});

// Element types that accept disabled attribute
// See https://www.w3.org/TR/html5/disabled-elements.html#disabled-elements
//
//  Usage:
//      Provide expression to be evaluated to determine if form needs to be disabled
//      Form will be disabled when the expression evaluates to true
//          <form disable-form="expression"></form>
var ACCEPT_DISABLED = 'button, input, select, textarea, optgroup, option, fieldset';
(0, _squid.$registerDirective)('disable-form', function () {
  return {
    link: function link(scope, element, attrs) {
      var toggleDisabled = function toggleDisabled(disable) {
        var collection = element.find(ACCEPT_DISABLED);
        if (disable) {
          collection.attr('disabled', true);
        } else {
          collection.removeAttr('disabled');
        }
      };

      // Watch number of elements to get a rough idea of if any new inputs are
      // added that also need to be disabled.
      scope.$watch(function checkIfDisabled() {
        return (0, _angular.$parse)(attrs['disableForm'])(scope) && element.find(ACCEPT_DISABLED).length;
      }, toggleDisabled);
    }
  };
});
_angular.$parse;
_squid.$registerDirective;

/***/ }),

/***/ "../node_modules/xo-validation/dist/directive.js":
/***/ (function(module, exports, __webpack_require__) {



var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
_angular["default"].module().directive('xoValidation', function () {
  return {
    template: '',
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, elem, attr, ngModel) {
      var validationUtil = {
        // because IE8 doesnt have String.prototype.trim()
        trim: function trim(value) {
          var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
          return value.replace(rtrim, '');
        },
        /**
         * Generic function that runs a given input against
         * a given regular expression
         *
         * @param {String} value input to test
         * @param {String/RegExp} regex Regular expression to test against
         * @returns {Boolean} matches or does not match given pattern
         */
        valid: function valid(value, regex) {
          if (this.empty(value)) {
            return false;
          }
          if (_angular["default"].isString(regex)) {
            regex = new RegExp(regex);
          }
          return regex ? regex.test(value) : true;
        },
        // returns whether empty or not
        empty: function empty(value) {
          if (!value) {
            return true;
          }

          // IE8 and below doesn't have native .trim()
          return !this.trim(value);
        },
        // returns whether alphabetic or not
        alphabetic: function alphabetic(value) {
          return this.valid(value, /[A-Za-z]+$/);
        },
        // returns whether numeric or not
        numeric: function numeric(value) {
          var NUMERIC_REGEX = new RegExp('^[0-9]+$');
          return this.valid(value, NUMERIC_REGEX);
        },
        validBankAccount: function validBankAccount(value) {
          if (!scope.showIBAN) {
            return this.numeric(value);
          }
          return true;
        },
        validRouting: function validRouting(value) {
          if (!scope.showIBAN) {
            return this.valid(value, /^\d{8}$/);
          }
          return true;
        },
        validIBANCode: function validIBANCode(value) {
          if (scope.showIBAN) {
            value = value && value.replace(/ +/g, '');
            return this.valid(value, /^([A-Z]){2}\d{2}[A-Z0-9]{1,30}$/);
          }
          return true;
        },
        validIBAN: function validIBAN(value) {
          if (scope.showIBAN) {
            value = value && value.replace(/ +/g, '');
            return this.valid(value, /^DE\d{20}$/);
          }
          return true;
        },
        validIBANCountry: function validIBANCountry(value) {
          value = value && value.replace(/ +/g, '');
          return !this.valid(value, /^([^D0-9][E]|[D][^E0-9]|[^D0-9][^E0-9])\d{2}[A-Z0-9]{1,30}$/i);
        },
        // @Deprecated: This function is deprecated.
        // first two letters are the country code the rest are the bank account numbers max length 32
        validIBANWithValidCountryCode: function validIBANWithValidCountryCode(value) {
          value = value && value.replace(/ +/g, '');
          return this.valid(value, /^(AT|BE|CY|EE|FI|FR|DE|EL|IE|IT|LV|LT|LU|MT|MC|NL|PT|SK|SI|ES)\d{3,32}$/i);
        },
        validLast4: function validLast4(value) {
          // @TODO - Unsafe regular expression, need to fix.
          var LAST_4 = /^([0-9]{4})?$/; // eslint-disable-line fasec/no-unsafe-regex

          return this.valid(value, LAST_4);
        },
        validStreet: function validStreet(value) {
          return this.valid(value, /^([A-Za-z0-9-. ]*)$/);
        },
        // Validating phone format with metadata from griffin
        validPhone: function validPhone(value) {
          var regex = scope.pattern;

          /*
              * User can enter phone format in various manner according to griffin mask
              * (00) 0000-0000
              * 00 000 0000
              * Since the griffin pattern only validates against numbers, need to trim the input
              * to only validate the numbers
              */
          value = value && value.replace(/[^0-9]/gi, '');
          return this.valid(value, regex);
        },
        validDobYear: function validDobYear(value) {
          return value !== 'YYYY';
        },
        validDobDay: function validDobDay(value) {
          return value !== 'DD';
        },
        validDobMonth: function validDobMonth(value) {
          return value !== 'MM';
        },
        validPoBox: function validPoBox(value) {
          // @TODO - Unsafe regular expression, need to fix.
          var boxRE = /\b(((general\s+)?post\s+(office|mail)?)|((g\.?)?p[-\.]?\s?[om][\.-]?))\s?(b(ox|\.)?)?(\s+\d+)\b/i; // eslint-disable-line fasec/no-unsafe-regex

          if (boxRE.test(value)) {
            return true;
          }
          return false;
        },
        validAddressSansPoBox: function validAddressSansPoBox(value) {
          var boxRE = /(p[-.]? ?[om]?[-.]? ?|post ?(office|mail)?)? ?b(.|ox)[^,]*\d+/i;
          var cassRE = /(drawer|locker|bin|firm caller)\s?#?[0-9]+/i;
          if (boxRE.test(value) || cassRE.test(value)) {
            return false;
          }
          return true;
        },
        validEmailOrPhone: function validEmailOrPhone(value) {
          if (!value) {
            return false;
          }
          return this.validEmail(value) || this.validPhone(value);
        },
        validEmail: function validEmail(value) {
          if (!value) {
            return false;
          }
          var trimmedValue = this.trim(value); // Trim leading and trailing whitespace
          // @TODO - Unsafe regular expression, need to fix.
          var EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i; // eslint-disable-line

          return this.valid(trimmedValue, EMAIL_REGEX) && !this.highAscii(trimmedValue);
        },
        highAscii: function highAscii(value) {
          var trimmedValue = this.trim(value);
          // @TODO - Unsafe regular expression, need to fix.
          var HIGH_ASCII_REGEX = /[^\x00-\x7F]/; // eslint-disable-line no-control-regex

          return this.valid(trimmedValue, HIGH_ASCII_REGEX);
        },
        // expected format: MM/DD/YYYY
        validDate: function validDate(value) {
          var re = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
          var dArr = value.split('/');
          var d = new Date(value);
          var isValid = false;
          if (re.test(value)) {
            isValid = d.getMonth() + 1 === dArr[0] && d.getDate() === dArr[1] && d.getFullYear() === dArr[2];
          }
          return isValid;
        },
        /* Expects value and state. state can be "past" or "future".
            NOTE: This function validates only month and year, not day!
            Please use validDate() if you need to validate the whole date. */
        validDateWithoutDay: function validDateWithoutDay(value, options) {
          // eslint-disable-line max-statements
          var state = options.state;
          value = value.replace(/\s/g, '');
          if (value === '') {
            return true;
          }
          var split = value.split('/');
          var month = split[0];
          var year = split[1];
          var currentYear = parseInt(new Date().getFullYear().toString().substr(2, 2), 10);
          var currentMonth = parseInt(new Date().getMonth(), 10) + 1;
          var validYear = true;
          var validMonth = true;
          if (value.length < 5) {
            return false;
          }
          if (!this.validDobMonth(month)) {
            return false;
          }
          month = parseInt(month, 10);
          year = parseInt(year, 10);
          if (state === 'past') {
            validYear = year <= currentYear;
            if (!validYear) {
              return false;
            }
            if (year === currentYear) {
              validMonth = month <= currentMonth;
            }
          } else if (state === 'future') {
            validYear = year >= currentYear;
            if (!validYear) {
              return false;
            }
            if (year === currentYear) {
              validMonth = month >= currentMonth;
            }
          }
          if (!validYear || !validMonth) {
            return false;
          }
          return true;
        },
        // formats to MM/DD/YYYY
        mmddyyyy: function mmddyyyy(day, month, year) {
          if (year.length < 4) {
            year = "20" + year;
          }
          return this.twoDigits(month) + "/" + this.twoDigits(day) + "/" + this.twoDigits(year);
        },
        // formats to YY-MMM-DDDD
        yyyymmdd: function yyyymmdd(day, month, year) {
          if (year.length < 4) {
            year = "20" + year;
          }
          return year + "-" + this.twoDigits(month) + "-" + this.twoDigits(day);
        },
        // pads a number to two digits
        twoDigits: function twoDigits(value) {
          return value < 10 ? "0" + value : "" + value;
        },
        // expects YYYY-MM-DD
        legalAge: function legalAge(value) {
          if (this.empty(value)) {
            return false;
          }
          var dateParts = value.split('-'); // expecting YYYY-MM-DD
          var birthDate = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
          var yr = 365.25 * 24 * 60 * 60 * 1000; // milliseconds in a year
          var validBD = new Date(new Date() - 18 * yr);
          return validBD >= birthDate;
        },
        validZip: function validZip(value, options) {
          var postalCodeRegex = {
            // TODO: Once this is removed from the xo-add-address template, we can remove it...
            GB: /[A-Z]{1,2}[0-9][0-9A-Z]?\s?[0-9][A-Z]{2}/,
            /**
             * Note: These are "nice to have".
             * Once we add support for these countries, we can remove these.
             */
            BA: /^\d{5}$/,
            CY: /^\d{4}$/,
            EE: /^\d{5}$/,
            HR: /^\d{5}$/,
            LU: /^\d{4}$/,
            LV: /^\d{4}$/,
            MT: /^\d{3,4}$/,
            SI: /^\d{4}$/,
            SK: /^[0-9]{3}[\s][0-9]{2}$/,
            NZ: /^\d{4}$/,
            LT: /^\d{5}$/,
            BG: /^\d{4}$/,
            CZ: /^\d{5}$/,
            GR: /^\d{3}[\s]\d{2}$/,
            HU: /^\d{4}$/,
            MX: /^\d{5}$/
          };
          var country = options && options.country;
          var regex = scope.zipEntry && scope.zipEntry.validationPattern || postalCodeRegex[country];
          var isRequired = scope.zipEntry && scope.zipEntry.required;
          if (!isRequired && this.empty(value)) {
            return true;
          }

          // If there is no regex, or it's not populated yet...
          if (!regex || _angular["default"].isString(regex) && regex.indexOf('validationPattern') > -1) {
            return !this.empty(value);
          }
          value = value && value.toUpperCase();
          if (_angular["default"].isString(regex)) {
            if (regex.charAt(0) !== '^') {
              regex = "^" + regex;
            }
            if (regex.charAt(regex.length - 1) !== '$') {
              regex += '$';
            }
          }
          return this.valid(value, regex);
        },
        validExpiry: function validExpiry(value, options) {
          var $monthEl = (0, _jquery["default"])('[ng-model="card.expiry_month"]');
          var $yearEl = (0, _jquery["default"])('[ng-model="card.expiry_year"]');
          var month = $monthEl.val();
          var year = $yearEl.val();
          var isValid = false;
          var monthElName = 'card.expiry_month';
          var yearElName = 'card.expiry_year';
          var cardType = options.cardType;
          if (month) {
            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
          }
          if (year) {
            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
          }
          if (month && year) {
            isValid = this.validExpires(month, year);
          }
          var formName = $monthEl.closest('form').attr('id');
          var form = scope[formName] || scope.$parent[formName];
          var monthFieldName = monthElName;
          var yearFieldName = yearElName;
          if (monthFieldName.indexOf('.') !== -1) {
            monthFieldName = monthFieldName.split('.')[1];
          }
          if (yearFieldName.indexOf('.') !== -1) {
            yearFieldName = yearFieldName.split('.')[1];
          }
          var cardsDontNeedExpiry = ['COFIDIS', 'COFINOGA', 'CETELEM'];
          if (cardType && cardsDontNeedExpiry.indexOf(cardType) !== -1) {
            isValid = true;
          }
          if (form) {
            form[monthFieldName].$setValidity('validExpiry', isValid);
            form[yearFieldName].$setValidity('validExpiry', isValid);
          }
          return isValid;
        },
        validExpires: function validExpires(month, year) {
          var date = new Date();
          var currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
          var currentMonth;
          if (year < currentYear) {
            return false;
          } else if (year > currentYear) {
            return this.validDobMonth(month);
          }

          // account for display date vs. system date
          currentMonth = date.getMonth() + 1;
          return this.validDobMonth(month) && month >= currentMonth;
        },
        startDate: function startDate(value, options) {
          var valueOptions = {
            cardType: scope.card.type
          };
          valueOptions[elem.attr('id')] = value;
          return this.setStartDateValidity(valueOptions);
        },
        setExpiryValidity: function setExpiryValidity(options) {
          if (!options) {
            return true;
          }
          var cardType = options.cardType || '';
          var expiryValidity = this.validExpiry(null, {
            cardType: cardType
          });
          return expiryValidity;
        },
        // start date validation for Maestro card
        setStartDateValidity: function setStartDateValidity(options) {
          if (!options) {
            return true;
          }
          var cardType = options.cardType || '';
          var startDateValidity = true;
          var $monthEl = (0, _jquery["default"])('#startmonth');
          var $yearEl = (0, _jquery["default"])('#startyear');
          var month = $monthEl.val();
          var year = $yearEl.val();
          if (cardType === 'MAESTRO') {
            if (!month || !year) {
              startDateValidity = false;
            }
          }
          var formName = $monthEl.closest('form').attr('id'),
            form = scope[formName] || scope.$parent[formName];
          if (form) {
            form.startmonth.$setValidity('startDate', startDateValidity);
            form.startyear.$setValidity('startDate', startDateValidity);
          }
          return startDateValidity;
        },
        dobField: function dobField(value, options) {
          var valueOptions = {};
          var fieldMap = {
            dobDayCC: 'day',
            dobMonthCC: 'month',
            dobYearCC: 'year'
          };
          valueOptions.cardType = scope.card.type;
          valueOptions[fieldMap[elem.attr('id')]] = value;
          return this.setDOBValidity(valueOptions);
        },
        setDOBValidity: function setDOBValidity(options) {
          if (!options) {
            return true;
          }
          var dobEnabledCards = ['COFIDIS', 'COFINOGA', 'CETELEM'];
          var dobValidity = true;
          var $monthEl = (0, _jquery["default"])('#dobMonthCC');
          var $dayEl = (0, _jquery["default"])('#dobDayCC');
          var $yearEl = (0, _jquery["default"])('#dobYearCC');
          var month = options.month || $monthEl.val();
          var year = options.year || $yearEl.val();
          var day = options.day || $dayEl.val();
          if (month) {
            month = $monthEl.find('option')[$monthEl.val() * 1 + 1].label;
          }
          if (day) {
            day = $dayEl.find('option')[$dayEl.val() * 1 + 1].label;
          }
          if (year) {
            year = $yearEl.find('option')[$yearEl.val() * 1 + 1].label;
          }
          var cardType = options.cardType;
          if (cardType && dobEnabledCards.indexOf(cardType) !== -1) {
            if (!month || !year || !day) {
              dobValidity = false;
              // invalidate if < 18 y/o.
            } else if (!this.legalAge(this.yyyymmdd(day, month, year))) {
              dobValidity = false;
            } else if (!this.validDate(this.mmddyyyy(day, month, year))) {
              dobValidity = false;
            }
          }
          var formName = $monthEl.closest('form').attr('id');
          var form = scope[formName] || scope.$parent[formName];
          if (form) {
            form.dobMonthCC.$setValidity('dobField', dobValidity);
            form.dobDayCC.$setValidity('dobField', dobValidity);
            form.dobYearCC.$setValidity('dobField', dobValidity);
          }
          return dobValidity;
        },
        validName: function validName(value) {
          return this.valid(value, /^([a-zA-Z,\xC0-\xFF,\u00C0-\u017F\,\-\s\,\'])*$/);
        },
        isChecked: function isChecked(value, options) {
          // $.is does not exist in $
          // eslint-disable-line angular/ng_angularelement
          var $el = (0, _jquery["default"])(options.el);
          return $el.is(':checked');
        },
        validRUPassport: function validRUPassport(value, options) {
          if (scope.user.countryOfResidence === 'RU') {
            return this.valid(value, /^\d{10}$/);
          }
          return true;
        }
      };
      var customValidator = function customValidator(value) {
        var ruleJson = _angular["default"].fromJson(elem.attr('xo-validation'));
        var validator = ruleJson.validator;
        var options = ruleJson.options;
        ngModel.$setValidity(validator, validationUtil[validator](value, options));
        return value;
      };
      ngModel.$parsers.unshift(customValidator);
      ngModel.$formatters.unshift(customValidator);
    }
  };
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/3ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/3ds/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, template) {
  return angular.module('xo-3ds.directive', ['squid']).directive('xo3ds', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        data: '=?',
        onComplete3dsHandler: '=?',
        closable: '=?'
      },
      controller: ['$scope', '$rootScope', '$timeout', '$window', '$Resolve3DS', '$DeviceInfo', '$CheckoutAppDataModel', '$config', '$locale', '$logger', function ($scope, $rootScope, $timeout, $window, $Resolve3DS, $DeviceInfo, $CheckoutAppDataModel, $config, $locale, $logger) {
        var resolve3DS = $Resolve3DS.instance($scope.token);
        $scope.closable = angular.isDefined($scope.closable) ? $scope.closable : true;
        $scope.termUrl = window.location.origin + $config.urls.baseUrl + '/process3DS';
        $scope.data = $scope.data || {};
        var isIos = $DeviceInfo.getiOSVersion();
        var timeout3DSConfig = $config.timeout3DS || {
          DEFAULT: 30000
        };
        var lightBoxTimeout = isIos && $locale.country === 'IN' ? 0 : timeout3DSConfig[$locale.country] || timeout3DSConfig.DEFAULT;
        var threeDSIframe = document.getElementById('threeDSFrame');
        function show3DSLightBox() {
          if ($scope.show3DS) {
            var lightbox = angular.element(document.getElementById('light-box'));
            lightbox.addClass('open');
            $scope.show3DS = false;
            $rootScope.$emit('loaded');
            threeDSIframe.removeEventListener('load', show3DSLightBox);
          }
        }
        function handleInitFailure(message) {
          // Since init3DS call failed. We disable the feature and proceed to checkout.
          $CheckoutAppDataModel.instance($rootScope.token).action('updatePaymentExperience', {
            data: {
              payment_experience: 'HERMESNODE',
              '3d_secure_authentication_supported': false
            },
            silent: true,
            transientError: true
          }).then(function () {
            $logger.info('checkout_fpti', {
              from: '3DS_CHALLENGE',
              to: 'process_3ds_challenge',
              int_error_description: message,
              error_type: 'soft_decline',
              error_source: 'fiLifecycle'
            });
            $scope.onComplete3dsHandler('success');
          });
        }
        function init3DSApi() {
          $rootScope.$emit('loadingMessage', $locale.content.get('threeDS.processing'));
          var _$scope$data = $scope.data,
            cardVerificationCode = _$scope$data.card_verification_code,
            supportedPaymentExperiences = _$scope$data.paymentExperience,
            channelType = _$scope$data.channelType,
            overridePaymentExpAsIframe = _$scope$data.overridePaymentExpAsIframe,
            isRedirectTreatment = _$scope$data.isRedirectTreatment,
            process3dsReturnQueryParams = _$scope$data.process3dsReturnQueryParams;
          var mode = $scope.data.mode;
          return resolve3DS.action('init3DS', {
            data: {
              cc_id: $scope.data.cc_id,
              flow_id: $scope.data.flow_id,
              merchant_id: $scope.data.merchant_id,
              merchant_country: $scope.data.merchant_country_code,
              currency: $scope.data.transaction_amount_currency,
              transaction_amount: $scope.data.transaction_amount_value,
              channel: channelType,
              card_verification_code: cardVerificationCode,
              supported_payment_experiences: supportedPaymentExperiences,
              overridePaymentExpAsIframe: overridePaymentExpAsIframe
            },
            success: function success(response) {
              if (response.status === 'SUCCESS' && response.acsUrl) {
                $logger.info('checkout_fpti', {
                  from: '3DS_CHALLENGE',
                  to: 'prepare_3ds_challenge'
                });
                $scope.acsUrl = response.acsUrl;
                $scope.acsMethod = response.acsMethod || 'POST';
                $scope.acsPaReq = response.acsPaReq;
                $scope.redirectRequestParameters = response.redirectRequestParameters;
                $scope.paymentExperience = response.paymentExperience || (isRedirectTreatment ? 'REDIRECT' : 'IFRAME');

                // Force fpr unsupported flows to complete 3ds in iframe
                if (overridePaymentExpAsIframe) {
                  $scope.paymentExperience = 'IFRAME';
                }
                var target = 'threeDSFrame';
                if ($scope.paymentExperience === 'REDIRECT') {
                  var complete3DSQuery = process3dsReturnQueryParams + ("&mode=" + mode);
                  $scope.termUrl = "" + window.location.origin + $config.urls.baseUrl + "/process3DSRedirect?" + complete3DSQuery;
                  target = '_self';
                }
                var form = $('<form/>', {
                  action: $scope.acsUrl,
                  method: $scope.acsMethod,
                  id: 'iFrameForm',
                  target: target
                });

                /**
                 * Construct of form input fields from the  init3DS response array redirect_request_parameters while submitting to bank page.
                 * 
                 * With the new FI changes in init3DS, the response of "redirect_request_parameters" looks like below:
                 * Also refer in WIKI https://github.paypal.com/Checkout-R/xoonboardingnodeweb/wiki - "3DS FPR (full page redirection) Integration" link
                 * 
                 * "redirect_request_parameters": [
                        {
                            "key": "AccuCardholderId",
                            "value": "89172389132"
                        },,
                        {
                            "key": "TermUrl",
                            "value": "PAYPAL_RETURN_URL"
                        },
                        {
                            "key": "AccuRequestId",
                            "value": "ZGU2NmExMzM3N2M0ZjkyBlOTdmMzlmNDlkYw=="
                        }
                    ]
                */

                /*
                    Iterating the redirect_request_parameters array and and contruct the form field and it will be looking like below:
                    <form method=POST action={FI.acsUrl}>
                        <input name="AccuCardholderId" value=89172389132/>
                        <input name="TermUrl" value={$scope.termUrl}/>
                        <input name="AccuRequestId" value=ZGU2NmExMzM3N2M0ZjkyBlOTdmMzlmNDlkYw==/>
                    </form>
                */

                if ($scope.redirectRequestParameters && $scope.redirectRequestParameters.length) {
                  $scope.redirectRequestParameters.forEach(function (item) {
                    form.append($('<input/>', {
                      type: 'hidden',
                      name: item.key,
                      value: item.value === 'PAYPAL_RETURN_URL' ? $scope.termUrl : item.value
                    }));
                  });
                } else if ($scope.acsPaReq) {
                  form.append($('<input/>', {
                    type: 'hidden',
                    name: 'TermUrl',
                    value: $scope.termUrl
                  }));
                  form.append($('<input/>', {
                    type: 'hidden',
                    name: 'PaReq',
                    value: $scope.acsPaReq
                  }));
                }
                $('#lightBoxAcsWrapper').append(form);
                $('#iFrameForm').submit();

                // wait for 3DS page to load with a timeout

                // The $scope.show3DS in the line below is set true when the 3DS modal is eligible to be shown to user when the
                // bank page loads in its iframe, i.e., after init3DS success
                $scope.show3DS = true;
                threeDSIframe.addEventListener('load', show3DSLightBox);
                $rootScope.$emit('loading');
                $rootScope.$emit('loadingMessage', $locale.content.get('threeDS.processing'));
                $timeout(function () {
                  if ($scope.show3DS) {
                    $logger.info('checkout_fpti', {
                      from: '3DS_CHALLENGE',
                      to: '3DS_CHALLENGE',
                      int_error_description: 'load_3ds_issuer_page_content_timeout',
                      error_type: 'soft_decline',
                      error_source: 'fiLifecycle'
                    });
                  }
                  show3DSLightBox();
                }, lightBoxTimeout);
              } else {
                $logger.info('checkout_fpti', {
                  from: '3DS_CHALLENGE',
                  to: 'process_3ds_challenge',
                  int_error_description: 'acsUrl_not_presented_on_init',
                  error_type: 'soft_decline',
                  error_source: 'fiLifecycle'
                });

                // When there is no 3DS challenge page to be shown, we return success to the caller
                $scope.onComplete3dsHandler('success');
              }
            },
            error: function error() {
              handleInitFailure('unknown_error_on_init3DS');
            },
            validation: function validation() {
              handleInitFailure('validation_error_on_init3DS');
            },
            contingencies: {
              DEFAULT: function DEFAULT() {
                handleInitFailure('contingency_presented_on_init3DS');
              }
            }
          });
        }
        function complete3DSApi(paRes) {
          return resolve3DS.action('complete3DS', {
            data: {
              third_party_response: paRes,
              cc_id: $scope.data.cc_id,
              flow_id: $scope.data.flow_id
            },
            success: function success(response) {
              var status;
              if (response.status === 'SUCCESS') {
                status = 'success';
                $logger.info('checkout_fpti', {
                  from: '3DS_CHALLENGE',
                  to: 'process_3ds_challenge'
                });
              } else {
                status = 'decline';
                $logger.info('checkout_fpti', {
                  from: '3DS_CHALLENGE',
                  to: 'process_3ds_challenge',
                  int_error_description: 'complete3DS_decline',
                  error_type: 'soft_decline',
                  error_source: 'fiLifecycle'
                });
              }
              $scope.onComplete3dsHandler(status);
            }
          });
        }
        function onKeyUp(event) {
          if (event.which === 27) {
            $scope.close3DSFrame();
          }
        }
        $scope.close3DSFrame = function () {
          $logger.info('checkout_fpti', {
            from: '3DS_CHALLENGE',
            to: 'process_user_close'
          });
          $logger.flush();
          var lightbox = angular.element(document.getElementById('light-box'));
          lightbox.removeClass('open');
          $timeout(function () {
            var lightboxMask = angular.element(document.getElementById('mask'));
            lightboxMask.remove();
            $('html').off('keyup', onKeyUp);
            $scope.onComplete3dsHandler('close');
          }, 200);
        };
        init3DSApi();
        $scope.complete3DS = function (paRes) {
          complete3DSApi(paRes);
        };
        $window.complete3DSFrame = function (paRes) {
          $scope.complete3DS(paRes);
        };

        // when the esc key is pressed
        if ($scope.closable) {
          $('html').on('keyup', onKeyUp);
        }
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/bank-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _showCartDecision = __webpack_require__("../node_modules/xo-page-components/src/cart/lib/showCartDecision.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
__webpack_require__("../node_modules/xo-jquery-mask-plugin/dist/jquery.mask.min.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-bank/bank-input/template.html"), __webpack_require__("../node_modules/xo-wallet-components/src/add-bank/bank-input/styles.less"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {
  return squid.module('xo-add-bank.bank-input.directive', ['squid', 'xomodel.fi', 'xomodel.checkout', 'xo-dropdown.directive', 'xo-error-tooltip.directive']).directive('xoBankInput', ['$rootScope', function ($rootScope) {
    return {
      template: template,
      scope: {
        token: '=?',
        user: '=?',
        bank: '=?',
        isUnbranded: '=?'
      },
      /* auto formatting the user entered IBAN input */
      link: function link(scope, element, attr) {
        var IBANMask = 'AA00 0000 0000 0000 0000 0000 0000 0000 00';
        element.on('keyup', function (event) {
          $('#ibanNumber').mask(IBANMask, {
            'translation': {
              0: {
                pattern: /[A-Za-z0-9]/
              }
            }
          });
        });
      },
      controller: ['$scope', '$populate', '$locale', '$elmo', '$AddBankModel', '$CheckoutCartModel', '$CheckoutAppDataModel', '$CheckoutPayeeModel', '$CurrencyConversionModel', function ($scope, $populate, $locale, $elmo, $AddBankModel, $CheckoutCartModel, $CheckoutAppDataModel, $CheckoutPayeeModel, $CurrencyConversionModel) {
        $populate($scope, {
          checkoutCart: $CheckoutCartModel.instance($scope.token),
          checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
          payee: $CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
          // TODO: In the future, automate this information
          var BANK_CURRENCY = 'EUR';
          var BANK_COUNTRY = 'DE';
          var showDCCTreatmentName = 'xo_xoonboarding_bank_dcc_test';
          var UTC = 'UTC';
          $scope.showIBAN = true;
          var days = [];
          var months = [];
          var years = [];
          var i;
          for (i = 1; i <= 31; i += 1) {
            var d = i < 10 ? '0' + i : i.toString();
            days.push(d);
          }
          for (i = 1; i <= 12; i += 1) {
            var m = i < 10 ? '0' + i : i.toString();
            months.push(m);
          }
          var year = new Date().getFullYear();
          for (i = year - 17; i >= year - 100; i -= 1) {
            years.push(i);
          }
          $scope.days = days;
          $scope.months = months;
          $scope.years = years;
          $scope.toggleIBAN = function () {
            $scope.showIBAN = !$scope.showIBAN;
          };
          $scope.onibanKeyup = function () {
            $scope.bank.iban_number = $scope.bank.iban_number.toUpperCase();
          };
          var merchantID = $scope.payee.get('merchant.id', '');

          // check if currency conversion is needed by comparing cart's currency code with EUR
          var sourceCurrency = $scope.checkoutCart.get('purchase.amounts.total.currency_code');
          var sourceValue = $scope.checkoutCart.get('purchase.amounts.total.amount');
          if (!(sourceCurrency && sourceValue)) {
            return;
          }

          // Check if currency conversion is required
          if (sourceCurrency !== BANK_CURRENCY) {
            return $elmo('xo_xoonboarding_bank_dcc', {
              'uid': merchantID
            }, showDCCTreatmentName).then(function (_temp) {
              var _ref = _temp === void 0 ? {} : _temp,
                treatment_name = _ref.treatment_name;
              if (treatment_name === showDCCTreatmentName) {
                $CurrencyConversionModel.instance().retrieve({
                  params: {
                    sourceCurrency: sourceCurrency,
                    sourceValue: sourceValue,
                    targetCurrency: BANK_CURRENCY,
                    countryCode: BANK_COUNTRY,
                    language: $locale.lang
                  }
                }).then(function (pricing) {
                  if (pricing) {
                    // If pricing object is true, currency conversion is valid
                    $scope.isCurrencyConversionValid = true;
                    var emptyCart = $scope.checkoutCart.get('purchase.items.length', 0) <= 0;
                    var userAction = $scope.checkoutAppData.useraction();
                    var noLineItemDetails = !(userAction && userAction.toLowerCase() === 'commit') && emptyCart;
                    var total = $scope.checkoutCart.get('purchase.amounts.total');
                    (0, _showCartDecision.showCartDecision)($scope.checkoutAppData.is_wps_subscription_flow(), total, $scope.checkoutAppData.get('merchant.merchant_country'), merchantID, noLineItemDetails, $scope.checkoutCart.isPurchase()).then(function (result) {
                      $scope.showTotalAmount = result.showAmountInCartIcon;
                      if ($scope.showTotalAmount) {
                        $scope.targetFormatStr = pricing.from.currencyFormatSymbolISOCurrency;
                      } else {
                        $scope.sourceCurrencyCode = pricing.to.currencyCode;
                      }
                    });

                    // Exchange Spread is the entire conversion spread. Eg: 1 USD = 1.5194 EUR
                    $scope.exchangeSpreadFormatStr = pricing.spread;
                    // griffin's dateTimeShort does not return timezone, so concatenate TZ
                    $scope.fxDate = pricing.issuedDate.dateTimeShort + " " + UTC;
                  } else {
                    _logger.$logger.warn('Currency conversion API returned empty pricing object');
                    $scope.isCurrencyConversionValid = false;
                  }
                })["catch"](function (err) {
                  _logger.$logger.warn('currency_conversion_error', {
                    reason: 'Error retrieving currency conversion rates for the source amount',
                    error: err
                  });
                  $scope.isCurrencyConversionValid = false;
                });
              }
            });
          }
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_showCartDecision.showCartDecision;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-bank/bank-input/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addCep/template.html"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js"), __webpack_require__("../node_modules/xo-form-components/src/zipcode/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {
  return angular.module('xo-add-card.addcep.directive', ['squid', 'xomodel.address', 'xo-zipcode.directive']).directive('xoAddCep', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        sidebar: '=?',
        prefillAddress: '=?',
        doneFn: '=?'
      },
      controller: ['$scope', '$populate', '$state', '$PrefillAddressModel', '$locale', function ($scope, $populate, $state, $PrefillAddressModel, $locale) {
        $scope.country = $locale.country;
        $scope.address = {};
        $scope.onSubmit = function () {
          $scope.prefillAddress.address = {
            country: $locale.country,
            postal_code: $scope.address.postal_code
          };
          $scope.prefillAddress.save({
            data: $scope.prefillAddress,
            success: function success(result) {
              $scope.prefillAddress.address = result;
              $scope.doneFn();
            }
          });
        };
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addCep/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('xo-add-card.addcep.route', ['squid', 'xo-add-card.addcep.directive']).factory('$AddCepRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('AddCepRoute', {
      name: 'addCep',
      directive: 'xo-add-cep',
      titleContent: 'addBillingAddress.title',
      loginRequired: true,
      children: []
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addCep", "../node_modules/xo-wallet-components/src/add-card/addCep/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addbilling/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js"), __webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, squid, template) {
  return squid.module('xo-add-card.addbilling.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address', 'xo-add-address.directive', 'xo-aside-header.directive', 'xo-error-tooltip.directive', 'xo-accessibility.directive']).directive('xoAddBilling', [function () {
    return {
      template: template,
      scope: {
        auth: '=?',
        token: '=?',
        doneFn: '=?',
        parentCallbacks: '=?',
        sidebar: '=?',
        showmeftsection: '=?',
        hideparenthead: '=?',
        billingaddressupdated: '=?',
        prefillAddress: '=?'
      },
      controller: ['$scope', '$populate', '$BillingAddressesModel', '$BillingAddressModel', '$PrefillAddressModel', '$feature', '$state', '$element', '$config', '$locale', '$timeout', function ($scope, $populate, $BillingAddressesModel, $BillingAddressModel, $PrefillAddressModel, $feature, $state, $element, $config, $locale, $timeout) {
        var country = $locale.getCountryCodeISO();
        $scope.billing = true; // to denote its billing address page still
        $scope.normalize = $feature('addressNormalization');
        $scope.country = country;
        var $el = $($element);
        if ($scope.showmeftsection) {
          $scope.showmeftsection.toggle = false;
        }
        if ($scope.hideparenthead) {
          $scope.hideparenthead.toggle = true;
        }
        function isUserInputtedAddress(address) {
          return address.id === '0';
        }

        // Label fields has having error if needed to, and focus the first error if needed
        function handleValidation(res) {
          if (res && res.fields && res.fields.length) {
            res.fields.forEach(function (field) {
              if (field.field) {
                var $field = $($el.find('[name="' + field.field + '"]'));
                if ($field.length === 0 && field.field === 'zip') {
                  $field = $($el.find('[ng-model="address.postal_code"], [ng-model="zipCode"]'));
                }
                $field.addClass('backendError');
                $field.attr('aria-invalid', true);
              }
            });
          }
          $el.find('form').find('.backendError, .ng-invalid').first().focus();
        }
        var prefilledAddress = $scope.prefillAddress && $scope.prefillAddress.address;
        if (prefilledAddress) {
          $scope.prefilled = true;
        }
        $scope.address = $scope.address || prefilledAddress || {
          country: country
        };
        $populate($scope, {
          billingAddresses: $BillingAddressesModel.instance()
        }).then(function () {
          $scope.cancelFn = function () {
            $state.go('^.addCard');
          };
          $scope.onSubmit = function () {
            $scope.updateAddress();
          };
          $scope.prefill = function () {
            $scope.address.country = $scope.country;
            $scope.prefillAddress = new $PrefillAddressModel({
              id: $scope.token,
              address: $scope.address
            });
            $scope.prefillAddress.save({
              data: $scope.prefillAddress,
              success: function success(result) {
                $scope.address = result;
                $scope.prefilled = true;
                $scope.showAddressFields = true;
                $timeout(function () {
                  var value = $scope.address.state;
                  var $option = $el.find('[value="' + value + '"]');
                  $option.prop('selected', 'selected');
                  $option.trigger('change');
                  value = $option.attr('label');
                }, 1000);
              }
            });
          };
          $scope.updateAddress = function () {
            var newBilling = new $BillingAddressModel({
              line1: $scope.address.line1,
              line2: $scope.address.line2,
              city: $scope.address.city,
              state: $scope.address.state,
              postal_code: $scope.address.postal_code,
              normalization_status: $scope.address.normalization_status,
              country: country,
              id: '0'
            });
            newBilling.save({
              data: $scope.billingAddress,
              success: function success() {
                if ($scope.normalize) {
                  // set to false so that html related to billing address is hidden when child is shown
                  $scope.billing = false;
                  $scope.address.full_address = newBilling.full_address;
                  $state.go('.addressNormalization');
                } else {
                  $scope.updateBillingAddressAndReturn('^.addCard', newBilling);
                }
              },
              validation: function validation(res) {
                handleValidation(res);
              }
            });
          };
          $scope.uponNormalization = function (normalizedAddress, isBack) {
            if (isBack) {
              $scope.billing = true;
              $state.go('^');
            } else {
              $scope.updateBillingAddressAndReturn('^.^.addCard', normalizedAddress);
            }
          };
          $scope.updateBillingAddressAndReturn = function (target, address) {
            var newBillingAddress;
            if (address && address instanceof $BillingAddressModel) {
              newBillingAddress = address;
            } else {
              newBillingAddress = new $BillingAddressModel({
                line1: address.line1,
                line2: address.line2,
                city: address.city,
                state: address.state,
                postal_code: address.postal_code,
                normalization_status: address.normalization_status,
                country: address.country || $scope.country,
                full_address: address.full_address || $scope.address.full_address,
                id: '0'
              });
            }
            var addresses = $scope.billingAddresses.addresses;
            if (!isUserInputtedAddress(addresses[0])) {
              addresses.unshift(newBillingAddress);
            } else {
              addresses[0] = newBillingAddress;
            }
            $scope.billingaddressupdated.value = true;
            $state.go(target);
          };
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addbilling/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/directive.js"), __webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js"), __webpack_require__("../node_modules/xo-address-components/src/address-normalization/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('xo-add-card.addbilling.route', ['squid', 'xo-add-card.addbilling.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddBillingRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('AddBillingRoute', {
      name: 'addBilling',
      directive: 'xo-add-billing',
      titleContent: 'addBillingAddress.title',
      trackingData: {
        fptiState: 'edit_billing'
      },
      loginRequired: true,
      children: [{
        name: '$AddressNormalizationRoute',
        attributes: {
          id: 'token',
          sidebar: 'sidebar',
          address: 'address',
          'done-fn': 'uponNormalization'
        }
      }]
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addbilling", "../node_modules/xo-wallet-components/src/add-card/addbilling/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");
__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/addcard/template.html"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/auth/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("../node_modules/xo-tray-height/dist/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/message/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/accessibility/directive.js"), __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template, $) {
  return squid.module('xo-add-card.addcard.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xomodel.fi', 'xo-add-card.creditcard-input.directive', 'xo-dropdown.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-message.directive', 'xo-error-tooltip.directive', 'xo-accessibility.directive', 'fi.errorUtil']).directive('xoAddCard', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        done: '=?',
        message: '=?',
        pagetitle: '=?',
        sidebar: '=?',
        showmeftsection: '=?',
        hideparenthead: '=?',
        billingaddressupdated: '=?',
        cardmodel: '=?',
        parentCallbacks: '=?',
        selectedPromotionCardType: '=?',
        promotion: '=?',
        pageLevel: '=?',
        logout: '=?',
        phone: '=?',
        manageCardFlow: '=?',
        onSuccess: '=?',
        backUri: '=?'
      },
      controller: ['$scope', '$populate', '$state', '$BillingAddressesModel', '$CardTypesModel', '$CheckoutSessionModel', '$AuthModel', '$CheckoutCartModel', '$timeout', '$element', '$rootScope', '$locale', '$util', '$feature', '$ResolveOTP', '$Class', '$fiErrorUtil', '$renderContent', function ($scope, $populate, $state, $BillingAddressesModel, $CardTypesModel, $CheckoutSessionModel, $AuthModel, $CheckoutCartModel, $timeout, $element, $rootScope, $locale, $util, $feature, $ResolveOTP, $Class, $fiErrorUtil, $renderContent) {
        $populate($scope, {
          cart: $CheckoutCartModel.instance($scope.token),
          auth: $AuthModel.instance(),
          billingAddresses: $BillingAddressesModel.instance(),
          checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
            contingencies: {
              NEED_CREDIT_CARD: angular.noop,
              EXPIRED_CREDIT_CARD: angular.noop
            }
          })
        }).then(function () {
          // Set up the back url if passed down from the parent or else use the default review route
          $scope.backUri = $scope.backUri || 'checkout.review.sidebar.wallet';
          if ($scope.showmeftsection) {
            $scope.showmeftsection.toggle = true;
          }
          if ($scope.hideparenthead) {
            $scope.hideparenthead.toggle = false;
          }
          $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();
          var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;
          if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
            $state.go('^.selectCard');
          }
          $scope.showplcc = type === 'plcc';
          $scope.country = $locale.country;
          $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;
          $scope.cardmodel.cardType = 'creditCard';
          if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
            $scope.cardmodel.cardType = 'privateLabel';
            $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
          }
          $scope.cardmodel.user = {
            first_name: $scope.auth.first_name,
            last_name: $scope.auth.last_name
          };
          $scope.cardmodel.address = $scope.billingAddresses.addresses[0];
          if ($scope.billingaddressupdated.value) {
            $scope.billingaddressupdated = {
              msgs: [$locale.content.get('editCard.newAddressAdded')],
              type: 'success',
              value: true
            };
          }
          $scope.gotoBilling = function (address) {
            if ($scope.pageLevel) {
              $scope.pageLevel.message = null;
            }
            if (!address) {
              if ($locale.country === 'BR') {
                $scope.parentCallbacks.showCep();
              } else {
                $state.go('^.addBilling');
              }
            }
          };
          $scope.isUPOP = function () {
            /*
            * we do have a BIN lookup for C2 country to FIMS
            * if that fails
            *   a) buyer selects card type from dropdown and it could be CUP
            *   b) and we are not going to get isUpop from FIMS , but C2 CUP is always upop card
            * if that success
            *   a) card can be of type VISA or CUP for dual cards
            *   b) and we need to show dropdown for buyer to choose the card, eventhough we default to VISA
            *   c) even though VISA selected , it is UPOP card
            * if that success
            *   a) card be of type CUP and AMEX for dual cards
            *   b) we don't show dropdown but default to CUP
            *   c) here both CUP and UPOP is true
            *
            * so checking either CUP or UPOP (for VISA)
            * and yes only for OTP enabled country (C2 for now)
            */
            var needOTPForAddCard = $feature('needOTPForAddCard');
            var isCUP = $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
            var isUpop = $scope.cardmodel.card && $scope.cardmodel.card.isUpop;
            return needOTPForAddCard && isCUP && isUpop;
          };
          $scope.flag = function (field) {
            // passing country code to differentiate CUP for C2 and ROW
            return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field, $locale.country);
          };
          $scope.buttonText = function () {
            var contentString = 'creditcard.addBtn';
            if ($scope.cardmodel.card.isExisting()) {
              contentString = 'creditcard.updateBtn';
            } else if ($scope.isUPOP()) {
              contentString = 'creditcard.continuetext';
            }
            return contentString;
          };
          $scope.cardTypeChanged = function () {
            $scope.phone.phoneType = $scope.flag('phoneType');
          };
          function addErrorMessage(contentKey) {
            if (contentKey) {
              contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
              var message = $locale.content.get('creditcard.' + contentKey);
              $scope.message.msgs.push(message);
            }
          }
          function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
            var errorData;
            if (result.errorCodes) {
              errorData = result;
            } else {
              errorData = {
                errorCodes: result && [result['0']]
              };
            }
            $scope.message = $fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);
            if (window.scrollTo) {
              window.scrollTo(0, 0);
            }
          }
          $scope.cancelFn = function () {
            if ($scope.sidebar) {
              if (!$scope.checkoutSession.plccOffer) {
                $state.go('checkout.review.sidebar.wallet');
              } else {
                $state.go('^.selectCard');
              }
            } else {
              $scope.done();
            }
          };
          function initiateOTP() {
            var resolveOTP = new $ResolveOTP({
              id: $scope.cardmodel.id
            });
            resolveOTP.action('init', {
              data: {
                phone: {
                  country_code: $scope.phone.IntDialingCountryCode,
                  number: $scope.phone.telephone
                }
              },
              resultModel: {},
              success: function success() {
                $scope.message = {};
                $state.go('.confirmUpop');
              },
              error: function error() {
                handleContingencies({}, 'confirmUpop', 'declineMessage');
              },
              contingencies: {
                INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                  // prop for last 4 digits of card in error message
                  var prop = {
                    number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
                  };
                  handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
                  $fiErrorUtil.addFieldErrors(result, $element);
                },
                DEFAULT: function DEFAULT() {
                  handleContingencies({}, 'confirmUpop', 'declineMessage');
                }
              }
            });
          }
          $scope.onSubmit = function () {
            if ($scope.pageLevel) {
              $scope.pageLevel.message = null;
            }
            var isNewCard = !$scope.cardmodel.card.isExisting();
            if (isNewCard) {
              delete $scope.cardmodel.id;
            }
            if ($('#plccAgree').is(':checked')) {
              $scope.cardmodel.preference = true;
            }

            // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
            if ($scope.isUPOP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {
              initiateOTP();
            } else {
              $scope.cardmodel.save({
                success: function success() {
                  if ($scope.isUPOP()) {
                    initiateOTP();
                  } else {
                    $scope.checkoutSession.fundingOptions.action('update', {
                      resultModel: $scope.checkoutSession,
                      data: {
                        planId: $scope.cardmodel.id
                      },
                      success: function success(result) {
                        if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
                          delete $scope.checkoutSession.plccOffer;
                        }
                        delete $scope.checkoutSession.errorData;
                        var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
                        var numberAdded;
                        var cardTypeAdded;
                        if (cardAdded) {
                          numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
                          cardTypeAdded = cardAdded.type;
                        }
                        var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
                        var cvvData = $scope.checkoutSession.cvvData;
                        var last4ToUse;
                        var cardTypeToUse;
                        if (cvvData) {
                          last4ToUse = cvvData.number;
                          cardTypeToUse = cvvData.type;
                        }
                        if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
                          $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));
                        }
                        var updateCardSidebarMessage = $renderContent('wallet.cardUpdated', {
                          type: cardTypeAdded,
                          number: last4Added
                        });
                        var updateCardPageMessage = $renderContent('smallToolTip.cardUpdated');
                        var addCardMessage = $renderContent('smallToolTip.cardAdded');
                        var msgs = [addCardMessage];
                        if (!isNewCard) {
                          msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
                        }
                        $scope.checkoutSession.message = {
                          type: 'success',
                          msgs: msgs
                        };
                        $scope.done();
                      },
                      contingencies: {
                        TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
                          $scope.message.msgs = [];
                          $scope.message.type = 'info';
                          addErrorMessage('addedButCannotUse');
                        }
                      }
                    });
                  }
                },
                contingencies: {
                  ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(name, result) {
                    if ($scope.sidebar) {
                      $scope.$emit('SidebarError');
                    }
                    $scope.billingaddressupdated.value = false;
                    if (result && result.errorCodes) {
                      handleContingencies(result, 'creditcard', 'errorInvalidData');
                      $fiErrorUtil.addFieldErrors(result, $element);
                    } else if (result && result['0']) {
                      handleContingencies(result, 'creditcard');
                    } else {
                      handleContingencies({}, 'creditcard', 'errorInternalError');
                    }
                  },
                  DISALLOWED_CUPSECURE_ADDITION: function DISALLOWED_CUPSECURE_ADDITION(name, result) {
                    handleContingencies({}, 'creditcard', 'errorInternalError');
                  },
                  VALIDATION_ERROR: function VALIDATION_ERROR(name, result) {
                    var $field = $($element).find('[ng-model="card.number"]');
                    $field.addClass('backendError');
                    $field.attr('aria-invalid', true);
                    $field.focus();
                  },
                  DEFAULT: function DEFAULT(name, result) {
                    handleContingencies({
                      errorCodes: [name]
                    }, 'creditcard', 'errorInternalError');
                  }
                },
                error: function error() {
                  handleContingencies({}, 'creditcard', 'errorInternalError');
                },
                validation: function validation(res) {// eslint-disable-line no-empty-function
                }
              });
            }
          };
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_cardMetaData.$CardMetaData;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/addcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _route = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('xo-add-card.addcard.route', ['squid', 'xo-add-card.addcard.directive']).factory('$AddCardRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('AddCardRoute', {
      name: 'addCard',
      directive: 'xo-add-card',
      titleContent: 'asideHeader.addCard',
      trackingData: {
        fptiState: 'add_or_update_cc'
      },
      loginRequired: true,
      children: [{
        route: _route["default"],
        attributes: {
          token: 'token',
          phone: 'phone',
          cardmodel: 'cardmodel',
          'on-success': 'onSuccess'
        }
      }]
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/addcard", "../node_modules/xo-wallet-components/src/add-card/addcard/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$xoCardExpiryDirective = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
  tag: 'xo-card-expiry',
  template: _template["default"],
  props: {
    expiryMonth: {
      type: 'var',
      required: false
    },
    expiryYear: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    experiments: function experiments() {
      return {
        showNumericKeypad: (0, _squid.$elmo)('xo_xoon_numeric_keypad_expirydob', {
          'ctx.COUNTRY': _squid.$locale.country
        }, 'xo_xoon_numeric_keypad_expirydob_test')
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.focusAndBlurHandler = function ($event) {
        _logger.$logger.info("credit_card_expiry_" + $event.type + "_event");
      };
      this.expiryFormat = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);
      if (this.expiryMonth && this.expiryYear) {
        if (this.expiryFormat === 'MMYY') {
          this.expiryDate = this.expiryMonth + '/' + this.expiryYear.substring(2, 4);
        } else if (this.expiryFormat === 'MMYYYY') {
          this.expiryDate = this.expiryMonth + '/' + this.expiryYear;
        }
      }
      if (this.expiryFormat === 'MMYY') {
        this.maxlength = 5;
        this.expiryMask = '99/99';
      } else {
        this.maxlength = 7;
        this.expiryMask = '99/9999';
      }
      this.formatExpiry = function (event) {
        var key = event.keyCode || event.charCode;
        var $el = $(event.target);
        var val = $el.val().replace(/[^0-9\/]/gi, '');
        var strokes = val.length;

        // Ignore delete keys
        if (key === 8 || key === 46) {
          return;
        }

        // after two characters add a slash char
        if (strokes === 2) {
          val += '/';
        }
        _this.expiryDate = val;
        $el.mask(_this.expiryMask);
      };
      var currentYear = new Date().getFullYear().toString();
      var validMonths = _squid.$util.map(_squid.$util.range(1, 13), function (num) {
        return ('0' + num).substr(-2);
      });
      this.validate = function (expiryDate) {
        if (!expiryDate) {
          return;
        }
        var month, year, unformatted;
        var isValid = false;
        unformatted = expiryDate.replace(/[^0-9]/gi, '');
        if (unformatted.length > 3) {
          month = unformatted.substring(0, 2);
          if (_this.expiryFormat === 'MMYY') {
            year = currentYear.substring(0, 2) + unformatted.substring(2, 4);
          } else if (_this.expiryFormat === 'MMYYYY') {
            year = unformatted.substring(2, 6);
          }
          isValid = validMonths.indexOf(month) > -1 && year >= currentYear;
        }
        _this.expiryYear = year;
        _this.expiryMonth = month;
        return isValid;
      };
    },
    populate: function populate() {
      // We are controlling card-expiry field through PXP.
      // Note: If locale is 'JP', then we always use keyType as 'tel' (jquery-mask-fix)
      if (this.experiments && this.experiments.showNumericKeypad || _squid.$locale.country === 'JP') {
        this.keyType = 'tel';
      } else {
        this.keyType = 'text';
      }
    }
  }
});
angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
_squid.$Component;
_squid.$locale;
_squid.$feature;
_squid.$util;
_squid.$elmo;
_logger.$logger;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardExpiry/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"expirationField inputField\" id=\"expirationField\" content>\n    <div class=\"inputField\" floating-label directionality>\n        <input type=\"{{keyType}}\"\n               ng-blur=\"focusAndBlurHandler($event)\"\n               ng-focus=\"focusAndBlurHandler($event)\"\n               ng-model=\"expiryDate\"\n               name=\"expiry_value\"\n               id=\"expiry_value\"\n               value=\"\"\n               maxlength=\"{{maxlength}}\"\n               autocapitalize=\"off\"\n               aria-describedby=\"expiryHelp\"\n               autocomplete=\"off\"\n               ui-validate=\"'validate($value)'\"\n               ng-keyup=\"formatExpiry($event)\"\n               placeholder=\"{{content('creditcard.expiresPlaceholder')}}\"\n               data-error-key=\"validation.validExpirationDate\"\n               xo-error-tooltip\n               track-focus-and-blur=\"cardExpiry\"\n               required />\n        <span id=\"expiryHelp\" class=\"accessAid\" ng-bind=\"content('creditcard.expiresPlaceholder')\"></span>\n        <label for=\"expiry_value\">{{ content('creditcard.expiresLabel') }}</label>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports.$CardMetaData = void 0;
var _angular = _interopRequireDefault(__webpack_require__("../node_modules/angular/angular.min.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CARD_META_DATA = {
  DEFAULT: {
    fields: {
      address: true,
      cvv: true,
      dob: false,
      expiry: true,
      issue: false,
      phone: false
    },
    length: {
      cvv: 3,
      min: 16,
      max: 16
    },
    luhn: true,
    phoneType: 'Mobile',
    spaces: '4,8,12'
  },
  PLCC: {
    fields: {
      expiry: false,
      cvv: false,
      address: false
    },
    length: {
      min: 10,
      max: 16
    }
  },
  MAESTRO: {
    pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
    length: {
      min: 12,
      max: 19
    },
    spaces: '4,8,12,16'
  },
  SWITCH: {
    pattern: /^(5018|5020|5038|4903|4911|4936|564182|545250|504834|503615|6333|6304|6759|676[1-3]|0604)/,
    fields: {
      issue: true
    },
    length: {
      min: 12,
      max: 19
    },
    spaces: '4,8,12,16'
  },
  DINERSCLUB: {
    pattern: /^(36|38|30[0-5])/,
    length: {
      min: 14,
      max: 14
    }
  },
  DISCOVER: {
    pattern: /^(6011|65|64[4-9]|622|36|38|30[0-5])/,
    length: {
      min: 14
    }
  },
  MASTERCARD: {
    pattern: /^(5[1-5]|2(2(2[1-9]|[3-9]\d)|[3-6]\d\d|7[0-1]\d|720))/
  },
  AMEX: {
    pattern: /^3[47]/,
    length: {
      cvv: 4,
      min: 15,
      max: 15
    },
    spaces: '4,10'
  },
  VISA: {
    pattern: /^4/,
    length: {
      min: 13
    },
    subTypes: {
      QIWI: {
        pattern: /^(428122|489049|469395|446942|462012)/
      }
    }
  },
  RUPAY: {
    pattern: /^(508[5-9][0-9]{12})|(6069[8-9][0-9]{11})|(607[0-8][0-9]{12})|(6079[0-8][0-9]{11})|(608[0-5][0-9]{12})|(6521[5-9][0-9]{11})|(652[2-9][0-9]{12})|(6530[0-9]{12})|(6531[0-4][0-9]{11})|(817200[0-9]{10})/
  },
  JCB: {
    pattern: /^(?:2131|1800|35[0-9]{3})/,
    length: {
      min: 15
    }
  },
  CBNATIONALE: {},
  CETELEM: {
    fields: {
      dob: true
    },
    length: {
      max: 19
    },
    spaces: '4,8,12,16'
  },
  COFIDIS: {
    fields: {
      dob: true,
      expiry: false,
      cvv: false
    },
    length: {
      min: 8,
      max: 9
    },
    spaces: '4,8',
    luhn: false
  },
  COFINOGA: {
    fields: {
      dob: true,
      cvv: false
    },
    length: {
      min: 17,
      max: 17
    },
    spaces: '4,8,12,16'
  },
  ELO: {
    pattern: /^9/,
    length: {
      min: 13
    }
  },
  HIPER: {
    pattern: /^6/,
    length: {
      min: 13
    }
  },
  HIPERCARD: {
    pattern: /^7/,
    length: {
      min: 13
    }
  },
  // C2 CUP Credit Card - not a dual brand
  CUPC2CREDIT: {
    fields: {
      address: false,
      phone: true
    },
    length: {
      max: 19
    }
  },
  // C2 CUP AMEX Dual Credit Card - force Cup as primary card
  CUPC2AMEXCREDIT: {
    fields: {
      address: false,
      phone: true
    },
    length: {
      cvv: 4,
      min: 15,
      max: 15
    }
  },
  // C2 CUP non dual Debit Card
  CUPC2DEBIT: {
    fields: {
      address: false,
      cvv: false,
      expiry: false,
      phone: true
    },
    length: {
      max: 19
    }
  },
  // C2 CUP Amex Dual Debit Card  - force cup as primary card
  CUPC2AMEXDEBIT: {
    fields: {
      address: false,
      cvv: false,
      expiry: false,
      phone: true
    },
    length: {
      min: 15,
      max: 15
    }
  },
  // C2 VISA CUP Dual Debit Card  - force visa as primary card
  VISACUPDEBIT: {},
  // C2 VISA CUP Dual Credit Card - force Visa as primary card
  VISACUPCREDIT: {},
  // CUP for non C2 countries
  CUPCREDIT: {},
  CUPDEBIT: {}
};
Object.keys(CARD_META_DATA).forEach(function (key) {
  CARD_META_DATA[key] = $.extend(true, {}, CARD_META_DATA.DEFAULT, CARD_META_DATA[key]);
});
Object.keys(CARD_META_DATA).forEach(function (key) {
  CARD_META_DATA[key].spaces = CARD_META_DATA[key].spaces.split(',').map(Number);
});
function getTypeByPattern(cardMetaData, types, number) {
  var result;
  types.some(function (type) {
    var metaData = cardMetaData[type];
    if (metaData && metaData.pattern && metaData.pattern.test(number)) {
      result = type;
      return true;
    }
    return false;
  });
  return result;
}
var $CardMetaData = exports.$CardMetaData = {
  getMetaData: function getMetaData(card, field, country) {
    var cardType = card && card.type || 'DEFAULT';
    var cardDualType = card && card.dualType;
    if (cardType === 'CUP') {
      /* append the country code to differentiate C2 and ROW CUP cards
       * at the end cardType is going be look like
       * CUPC2AMEXDEBIT  / CUPC2AMEXCREDIT for dual brands
       * CUPC2CREDIT / CUPC2DEBIT for c2 non dual brands
       * CUPCREDIT / CUPDEBIT for ROW
       */
      var dualType = cardDualType === 'AMEX' ? cardDualType : '';
      var cardCountry = country === 'C2' ? 'C2' : '';
      var productType = ['DEBIT', 'DEBITCARD'].indexOf(card.productType) > -1 ? 'DEBIT' : 'CREDIT';
      cardType = "" + cardType + cardCountry + dualType + productType;
    } else if (cardType === 'VISA' && cardDualType === 'CUP') {
      /*
       * VISA & CUP is applicable for China WorldWide
       * at the end cardType is going to be
       * we don't have any other country in this combination
       * so don't use country passed into this method
       * VISACUPCREDIT / VISACUPDEBIT
       */
      var _productType = ['DEBIT', 'DEBITCARD'].indexOf(card.productType) > -1 ? 'DEBIT' : 'CREDIT';
      cardType = "" + cardType + cardDualType + _productType;
    }
    return _squid.$Class.get(CARD_META_DATA[cardType], field);
  },
  getCardType: function getCardType(types, number) {
    var cardType = {};
    if (_angular["default"].isArray(types) && number) {
      cardType.type = getTypeByPattern(CARD_META_DATA, types, number);
      var metaData = CARD_META_DATA[cardType.type];
      if (metaData && metaData.subTypes) {
        cardType.subType = getTypeByPattern(metaData.subTypes, types, number);
      }
    }
    return cardType;
  }
};
_angular["default"].value("$CardMetaData", $CardMetaData);
_squid.$Class;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/creditcard-input/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");
var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/creditcard-input/utils.js");
__webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/add-card/dob/directive.js");
__webpack_require__("../node_modules/xo-angular-ui-utils/ui-utils.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/creditcard-input/template.html"), __webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template, $) {
  squid.module('xo-add-card.creditcard-input.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xo-tooltip.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive']).directive('scrollToTop', [function () {
    return {
      link: function link(scope, element, attr) {
        $(element).on('focus', function () {
          if ($('#mxCardTitle').is(':visible')) {
            $('#creditCardForm').scrollTop($(element).offset().top);
          }
        });
      }
    };
  }]).directive('jsOnchange', [function () {
    /**
     * The 'jsOnchange' directive uses JavaScript's native 'onchange'
     * event instead of Angular's 'ng-change' directive. We need
     * this because 'ng-change' gets fired every time the input changes
     * but we want to fire the event until the users focuses out of the input,
     * which is how JavaScript's 'onchange' event works.
     */
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        var jsChangeHandler = scope.$eval(attrs.jsOnchange);
        element.on('change', jsChangeHandler);
        element.on('$destroy', function () {
          element.off('change');
        });
      }
    };
  }]).directive('xoCreditCard', ['$timeout', '$util', function ($timeout, $util) {
    return {
      template: template,
      restrict: 'E',
      scope: {
        token: '=?',
        card: '=?',
        user: '=?',
        selectedPromotionCardType: '=?',
        promotion: '=?',
        cardTypeChanged: '=?',
        cardNumberChanged: '=?',
        manageCardFlow: '=?',
        setBuyerFxFlag: '=?'
      },
      controller: ['$scope', '$populate', '$CardTypesModel', '$Class', '$locale', '$CardTypeFromBinModel', '$config', '$feature', '$pxp', '$logger', '$CheckoutAppDataModel', '$CheckoutCartModel', '$FlowEligibilityModel', '$meta', function ($scope, $populate, $CardTypesModel, $Class, $locale, $CardTypeFromBinModel, $config, $feature, $pxp, $logger, $CheckoutAppDataModel, $CheckoutCartModel, $FlowEligibilityModel, $meta) {
        $scope.locale = $locale;
        $scope.country = $scope.locale.country;
        var isUnsupportedCard;
        var lastVerifiedBin = '';
        var lastRequestedBin = ''; // bin requested to service to fetch card type and pending response.

        function updateBuyerFXCurrencyConversion() {
          return (0, _squid.$elmo)('xo_xoon_dcc_popup_content', {
            'ctx.COUNTRY': $scope.locale.country
          }, '(xo_xoon_dcc_popup_content_)(.*)').then(function (_temp) {
            var _ref = _temp === void 0 ? {} : _temp,
              treatment = _ref.treatment_name;
            if (treatment) {
              var isControl = treatment.includes('control');
              $scope.setBuyerFxFlag({
                treatment: treatment
              });
              if (!isControl) {
                $scope.isBuyerFxApplicable = true;
              }
            }
          });
        }
        function logConversionDataToFPTI(isChangeable) {
          var _$scope$card$currency = $scope.card.currencyConvData,
            _$scope$card$currency2 = _$scope$card$currency === void 0 ? {} : _$scope$card$currency,
            from_code = _$scope$card$currency2.from_code,
            to_code = _$scope$card$currency2.to_code,
            spread = _$scope$card$currency2.spread;

          /**
           * If conversion is not chnagable because of our agreement with
           * the card issuer we will not have conversion data. In that
           * case we will get the from code from the metadata and the
           * to code from the cart.
           */
          if (!from_code) {
            from_code = $util.getProperty($scope, 'locale.metadata.currency.code');
            to_code = $scope.checkoutCart.get('purchase.amounts.total.currency_code');
          }

          /**
           * FPTI event #3 for Buyer FX guest experience
           * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
           */
          $logger.info('checkout_fpti', {
            from: 'CURRENCY_CONVERSION',
            to: 'prepare_currency_conversion_pre_plan',
            conversion_type: (0, _utils.getDefaultCoversionSelection)($scope.card),
            is_conversion_shown: isChangeable ? 1 : 0,
            currency_conversion_from_curr: from_code,
            currency_conversion_to_curr: to_code,
            currency_conversion_spread: spread,
            locale: $locale.country
          });
        }
        function setConversionData(data) {
          /**
           * We want to enter this conditional if both of the
           * following conditions are met:
           * 1. The PXP `xo_xoon_dcc_popup_content` returns a
           *    treatment or control value
           * 2. Either:
           *    a. `data` is present, in which case this
           *       function is being called after a successful
           *       call to the `calculateCurrencyConversion` API
           *       and we need to set `card.currencyConvData` and
           *       log to FPTI
           *    b. `card.currencyConvData` is NOT `undefined`, which
           *       occurs when a user has prevously entered a card and
           *       a successful call the the currency conversion API
           *       has occurred and the user is now deleting/changing
           *       the card number for some reason
           */
          if ($scope.isBuyerFxApplicable && (data || $scope.card.currencyConvData)) {
            $scope.card.currencyConvData = data;
            $logger.info('setting_currency_conversion_data', {
              hasConversionData: Boolean(data)
            });
            $scope.setBuyerFxFlag({
              hasBuyerFxPrePlanData: Boolean(data)
            });

            /**
             * If data is `undefined` then we are resetting
             * conversion data and therefore need to reset the
             * default conversion selection to 'PAYPAL'
             */
            if (!data) {
              $scope.card.ppconversion = 'PAYPAL';
            } else {
              /**
               * If we have data the getCurrencyConversion() call
               * was successful and the conversion selection is
               * changeable.
               */
              logConversionDataToFPTI(true);
            }
          }
        }
        function conversionErrorHandler(key) {
          /**
           * Set `$scope.card.currencyConvData` to `undefined` so that if this isn't
           * the first card the user entered and the previous card got a 200 response
           * from the API, then we don't want the conversion data for that card to be
           * used for the newly entered card.
           */
          setConversionData();
          $logger.warn('Contingency encountered during calculateCurrencyConversion call.');
          return;
        }
        function getCurrencyConversion(number) {
          $scope.checkoutCart.action('calculateCurrencyConversion', {
            data: {
              cardNumber: number,
              country: $locale.country
            },
            success: setConversionData,
            contingencies: {
              DEFAULT: conversionErrorHandler
            },
            error: conversionErrorHandler
          });
        }
        function currencyConvCardTypeChangeHandler() {
          $scope.card.ppconversion = 'PAYPAL';
        }
        $scope.checkCardForDccCall = function checkCardForDccCall() {
          var _$scope$card = $scope.card,
            _$scope$card2 = _$scope$card === void 0 ? {} : _$scope$card,
            number = _$scope$card2.number;

          /**
           * If the cart currency and the currency for the user's billing address are the
           * same or we are not showing the BuyerFX PXP then we don't need to make the
           * API call to get conversion information since no conversion is necessary
           */
          if (!$scope.isBuyerFxApplicable || !(0, _utils.isConversionApplicable)($scope)) {
            return;
          }
          var cardNumber = (0, _utils.removeNonNumericCharsAndTruncate)(number, $scope.maxLength());
          var isCardLenValid = $scope.cardLengthValid(cardNumber);
          var isCardLuhnValid = $scope.cardLuhnValid(cardNumber);

          // If the card has changed, we want to wipe out the currency conversion data
          // associated with the previous card number that the user had entered.
          setConversionData();

          /**
           * If the card length or luhn isn't valid, we return because we are in the
           * process of entering in new card number or because the card number isn't
           * valid and we don't want to make the API call until it is.
           */
          if (!isCardLenValid || !isCardLuhnValid) {
            return;
          }
          var _$scope$card3 = $scope.card,
            _$scope$card4 = _$scope$card3 === void 0 ? {} : _$scope$card3,
            type = _$scope$card4.type,
            currencyConvData = _$scope$card4.currencyConvData;

          /**
           * Combined check for all conditions for a getCurrencyConversion call
           * 1. Card type is defined
           * 2. If we haven't fetched conversion data for this card yet
           * 3. If card allows for conversion selection
           *      (i.e. card type is not AMEX, CUP, DISCOVER, or JCB)
           */
          if (type && !currencyConvData) {
            /**
             * If conversion is not changeable we log to FPTI now since we aren't
             * calling getCurrencyConversion(), which logs in the success callback.
             */
            if (_utils.unchangeableCardTypes.includes(type)) {
              logConversionDataToFPTI(false);
              return;
            }
            getCurrencyConversion(cardNumber);
          }
        };
        $scope.$watch('card.type', function () {
          currencyConvCardTypeChangeHandler();
          if ($scope.cardTypeChanged) {
            $scope.cardTypeChanged();
          }
        });
        $scope.mxDebitCards = ['BANAMEX', 'BANCOARFACA', 'BBVA', 'BANORTE', 'HSBC', 'INBURSA', 'SANTANDER'];
        $scope.cardLengthValid = function (number) {
          if ($scope.card && $scope.card.isExisting()) {
            return true;
          }
          number = (0, _utils.removeNonNumericCharsAndTruncate)(number);
          return number.length >= $scope.flag('length.min') && number.length <= $scope.flag('length.max');
        };

        // Use the Luhn algorithm to validate the check digit (i.e. last digit) of the card number
        $scope.cardLuhnValid = function (input) {
          if (!$scope.flag('luhn') || $scope.card && $scope.card.isExisting()) {
            return true;
          }
          input = (0, _utils.removeNonNumericCharsAndTruncate)(input);
          var sum = 0;
          var numdigits = input.length;
          var parity = numdigits % 2;
          var i = 0;
          var digit;
          for (; i < numdigits; i++) {
            digit = parseInt(input.charAt(i), 10);
            if (i % 2 === parity) {
              digit *= 2;
            }
            if (digit > 9) {
              digit -= 9;
            }
            sum += digit;
          }

          // In non-production envs, JAWS will generate card numbers using a modified Luhn algorithm that increments the check digit by 1
          var isJawsCardLuhnValid = !$config.deploy.isLive() && sum % 10 === 1;
          return sum % 10 === 0 || isJawsCardLuhnValid;
        };
        var _ref2 = $scope.selectedPromotionCardType || {},
          promotionType = _ref2.type;
        $scope.isPlcc = promotionType === 'plcc';
        $scope.flag = function (field) {
          if ($scope.isPlcc && !$scope.card.type) {
            $scope.card.type = 'PLCC';
          }
          // passing country to differentiate CUP for C2 and ROW
          return _cardMetaData.$CardMetaData.getMetaData($scope.card, field, $locale.country);
        };
        $scope.maxLength = function () {
          if ($scope.card && $scope.card.isExisting()) {
            return 30;
          }
          return $scope.flag('length.max') + $scope.flag('spaces.length');
        };
        if ($scope.card && $scope.card.number) {
          $scope.unformattedCardNumber = (0, _utils.removeNonNumericCharsAndTruncate)($scope.card.number, $scope.maxLength());
        }
        $scope.showMXCardLogos = function () {
          return $locale.country === 'MX';
        };
        function pxpMXCardLabels() {
          if ($scope.showMXCardLogos()) {
            $pxp('xo_hermes_mx_cardlogo', {}, 'xo_hermes_mx_cardlogo_treatment').then(function (_temp2) {
              var _ref3 = _temp2 === void 0 ? {} : _temp2,
                treatment_name = _ref3.treatment_name;
              $scope.showLabels = treatment_name === 'xo_hermes_mx_cardlogo_treatment';
            });
          } else {
            $scope.showLabels = false;
          }
        }
        $populate($scope, {
          cardTypes: $CardTypesModel.instance($scope.token + ':' + $locale.country, {
            token: $scope.token,
            country: $locale.country
          }),
          checkoutAppData: $CheckoutAppDataModel.instance($scope.token).retrieve(),
          checkoutCart: $CheckoutCartModel.instance($scope.token),
          flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
            params: {
              geolocation: $meta.geolocation,
              localeCountry: $locale.country
            }
          })
        }).then(function () {
          if ((0, _utils.isConversionApplicable)($scope)) {
            return updateBuyerFXCurrencyConversion();
          }
        }).then(function () {
          $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';
          var cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;
          $scope.cardProductValid = function () {
            return $scope.debitCardFlow ? $scope.card.productType === 'DEBIT' : true;
          };
          var forceDropDown = false;
          function str(item) {
            var s = item.toString();
            return item < 10 ? '0' + s : s;
          }
          $scope.showScanCardExperiment = false;
          $scope.supportedCardNamesCommaSeparated = $scope.cardTypes.supportedNames().join(', ');
          $scope.$on('localeChange', function () {
            $scope.cardTypes = $CardTypesModel.instance($scope.token + ':' + $locale.country, {
              token: $scope.token,
              country: $locale.country
            });
            $scope.cardTypes.retrieve().then(function () {
              if ($scope.card.type && $scope.cardTypes.allowed.indexOf($scope.card.type) === -1) {
                delete $scope.card.type;
                forceDropDown = false;
                $scope.changeCardNumber(true);
              }
            });
            $scope.country = $locale.country;
            pxpMXCardLabels();
          });
          pxpMXCardLabels();
          $scope.cvvShown = function () {
            if ($scope.card.type === 'CETELEM' && $scope.locale.country === 'FR') {
              return false;
            }
            if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
              return false;
            }
            if ($scope.isPlcc && $scope.card.type) {
              return true;
            }
            return $scope.flag('fields.cvv');
          };
          $scope.expiryShown = function () {
            if ($scope.isPlcc && $scope.card.type) {
              return true;
            }
            if ($scope.card.type === 'CUP' && $scope.card.productType === 'DEBITCARD') {
              return false;
            }
            return $scope.flag('fields.expiry');
          };
          $scope.enableDropDown = function () {
            // for VISA CUP dual card, force show dropdown for buyer to choose card type
            return Boolean(['ES', 'FR', 'GB', 'IT'].indexOf($scope.locale.country) > -1) || forceDropDown || $scope.card && $scope.card.type === 'VISA' && $scope.card && $scope.card.dualType === 'CUP';
          };
          $scope.showDropDown = function () {
            if ($scope.enableDropDown()) {
              return true;
            }
            if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 4 && !cardTypeServiceCall && !$scope.isPlcc) {
              return true;
            }
            if (!$scope.card.type && $scope.card.number && $scope.card.number.length >= 7 && cardTypeServiceCall && isUnsupportedCard) {
              return true;
            }
            return false;
          };
          $scope.showAcceptedCardLogos = function () {
            return !$scope.showDropDown() && $feature('showAcceptedCardLogos', false, $scope.country);
          };
          $scope.getCardTypeByNumber = function (types, number) {
            if ($scope.isPlcc && number.length > 6 || !$scope.isPlcc) {
              return _cardMetaData.$CardMetaData.getCardType(types, number);
            }
          };
          function formatCardNumber(number) {
            var spaces = $scope.flag('spaces');
            var formatted = [];
            for (var i = 0; i < number.length; i++) {
              if (spaces.indexOf(i) > -1) {
                formatted.push(' ');
              }
              formatted.push(number.charAt(i));
            }
            return formatted.join('');
          }
          $scope.$watch('country', function (newValue, oldValue) {
            cardTypeServiceCall = $feature('cardTypeServiceCallRequired', false, $scope.country) || $scope.debitCardFlow;
          });

          /**
           * Hit Callback(unformatted cc no) when user gets out of the cardNumber field.
           */
          $scope.focusAndBlurHandler = function ($event) {
            var type = $event.type;
            $logger.info("credit_card_number_" + type + "_event");
            if (type !== 'focus' && $scope.cardNumberChanged) {
              $scope.cardNumberChanged($scope.unformattedCardNumber);
            }
          };

          // e.g for a dual brand = ['CUP' ,'VISA'], select VISA or CUP based
          // on regex defined for card type. If not regex was defined, pick one
          // of the allowed card type.
          function selectCardTypeForDualBrands(result) {
            var dualCardTypes = $feature('dualCardTypes', {});
            var match;
            Object.keys(dualCardTypes).some(function (key) {
              return result.some(function (cardType) {
                if (cardType.type === key) {
                  match = key;
                  return true;
                }
                return false;
              });
            });
            if (match) {
              var regex = new RegExp(dualCardTypes[match]);
              var selected = $util.find(result, function (cardType) {
                if (regex.test(cardType.type)) {
                  return true;
                }
              });

              // if selected card based on regexp is CUP
              // then we can test for AMEX as subtype (a dualType card)
              if (selected && selected.type === 'CUP') {
                $util.some(result, function (cardType) {
                  if (/^AMEX$/.test(cardType.type)) {
                    selected.dualType = cardType.type;
                    return true;
                  }
                });
              }

              // if selected card based on regexp is VISA
              // then we can test for CUP as subtype (a dualType card)
              if (selected && selected.type === 'VISA') {
                $util.some(result, function (cardType) {
                  if (/^CUP$/.test(cardType.type)) {
                    selected.dualType = cardType.type;
                    return true;
                  }
                });
              }
              return selected;
            } else {
              return $util.find(result, function (cardType) {
                return $scope.cardTypes.allowed.indexOf(cardType.type) > -1;
              });
            }
          }
          function selectCardType(result) {
            if (angular.isArray(result)) {
              if (result.length >= 2) {
                result = selectCardTypeForDualBrands(result);
              } else {
                result = result[0];
              }
            }
            return result || {};
          }
          function clearCardType() {
            $scope.card.type = '';
            $scope.card.isUpop = false;
            $scope.card.dualType = '';
            $scope.card.productType = '';
          }
          function getCardTypeByNumberServiceCall(number) {
            if (number.length >= 9) {
              /*
               * We have BIN numbers of different lengths - 6, 8, 9
               * For a 9 digit BIN number, when users enter 6 digits,
               * we might get a response different from what is expected out
               * of 9 digit BIN number.
               * So, we decided to call fims only when user entered card number
               * length is greater than or equal to 9.
               * This will also avoid multiple calls to fims at different length
               * of card (i.e. calling fims at every new digit after 6th digit until 9th digit)
               */
              var bin = number.slice(0, 9);
              if (lastVerifiedBin && lastVerifiedBin.bin === bin) {
                $scope.card.type = lastVerifiedBin.type;
                $scope.card.dualType = lastVerifiedBin.dualType;
                $scope.card.productType = lastVerifiedBin.productType;
                $scope.card.isUpop = lastVerifiedBin.isUpop;
                return;
              }
              if (isUnsupportedCard === bin || bin === lastRequestedBin) {
                return;
              }

              // protect against requesting substring of already requested bin
              if (bin.length <= lastRequestedBin.length && lastRequestedBin.indexOf(bin) > -1) {
                return;
              }
              lastRequestedBin = bin;
              $CardTypeFromBinModel.instance().save({
                data: {
                  user_country: $scope.country,
                  bin: bin
                },
                silent: true,
                success: function success(result) {
                  // Log card brands returned from fims
                  if (result) {
                    var logObj = {
                      totalItems: result.length,
                      brands: []
                    };
                    result.forEach(function (brandObj) {
                      logObj.brands.push(brandObj.type);
                    });
                    $logger.info('fims_card_type_from_bin_response', logObj);
                  }
                  result = selectCardType(result);
                  var type = result.type;
                  var disallowedCard = false;
                  if ($scope.cardTypes.allowed.indexOf(type) === -1) {
                    disallowedCard = true;
                  } else if ($scope.debitCardFlow) {
                    if (result.productType !== 'DEBIT') {
                      disallowedCard = true;
                    }
                  }

                  // if we get upop in the response from BIN lookup
                  // set into the cardModel to trigger OTP
                  // this should not only be set if dropdown is not shown
                  $scope.card.isUpop = result.isUpop;
                  if (disallowedCard) {
                    clearCardType();
                    isUnsupportedCard = bin;
                    $scope.allowedCardsTooltip = true;
                    return;
                  }
                  isUnsupportedCard = undefined;
                  forceDropDown = false;
                  if (!$scope.showDropDown()) {
                    $scope.card.type = type;
                    $scope.card.dualType = result.dualType;
                    $scope.card.productType = result.productType;
                  }

                  // check for shorter version of bin coming back after longer version, protect against overwrite
                  if (!lastVerifiedBin.bin || lastVerifiedBin.bin.indexOf(bin) === -1) {
                    lastVerifiedBin = {
                      bin: bin,
                      type: type,
                      dualType: result.dualType,
                      productType: result.productType,
                      isUpop: result.isUpop
                    };
                  }

                  // This logic is to handle copy paste case when all numbers are entered at once
                  if ($scope.card.type && number.length >= $scope.flag('length.min')) {
                    if (/android/i.test(navigator.userAgent)) {
                      return;
                    }
                    var ccNumber = (0, _utils.removeNonNumericCharsAndTruncate)($scope.card.number, $scope.maxLength());
                    if (ccNumber.indexOf(number) >= 0) {
                      $scope.card.number = formatCardNumber(ccNumber);
                    }
                  }
                  return;
                },
                contingencies: {
                  GET_FI_ISSUER_DETAILS_ERR: function GET_FI_ISSUER_DETAILS_ERR(name, result) {
                    clearCardType();
                    isUnsupportedCard = bin;
                    lastRequestedBin = undefined;
                  }
                },
                error: function error() {
                  clearCardType();
                  isUnsupportedCard = bin;
                }
              });
            } else {
              isUnsupportedCard = undefined;
              forceDropDown = false;
              clearCardType();
            }
          }
          $scope.getAllowedCardTypeByNumber = function (number) {
            return $scope.getCardTypeByNumber($scope.cardTypes.allowed, number);
          };
          $scope.getDisallowedCardTypeByNumber = function (number) {
            return $scope.getCardTypeByNumber($scope.cardTypes.disallowed, number);
          };
          $scope.enableAddMode = function () {
            if ($scope.card.isExisting()) {
              $scope.card.number = '';
            }
          };
          $scope.changeType = function () {
            forceDropDown = true;
            $scope.changeCardNumber(true);

            // If the card type dropdown changes we want to
            // check to see if we need to call the DCC API
            // and if it is then make a call
            $scope.checkCardForDccCall();

            // Blank out unsupported fields

            if (!$scope.flag('fields.expiry')) {
              delete $scope.card.expiry_month;
              delete $scope.card.expiry_year;
            }
            if (!$scope.flag('fields.issue')) {
              delete $scope.card.start_month;
              delete $scope.card.start_year;
              delete $scope.card.issue_number;
            }
            if (!$scope.flag('fields.dob')) {
              delete $scope.card.dob_day;
              delete $scope.card.dob_month;
              delete $scope.card.dob_year;
            }
            if (!$scope.flag('fields.cvv')) {
              delete $scope.card.security_code;
            }
          };
          $scope.changeCardNumber = function (isCardTypeChanged) {
            // If buyer tries to modify an update card number. We remove the whole string
            // so buyer can add a card instead.
            $scope.enableAddMode();
            $scope.allowedCardsTooltip = false;
            var regex = /[０-９]/;
            if ($feature('disableFullWidthCharacters') && regex.test($scope.card.number)) {
              $logger.info('checkout_fpti', {
                'is_fullwidth_character': true
              });
            }
            var number = (0, _utils.removeNonNumericCharsAndTruncate)($scope.card.number, $scope.maxLength());
            var formattedNumber;
            $scope.unformattedCardNumber = number;

            // Attempt to determine the card type
            var cardType;
            if (cardTypeServiceCall) {
              if (!isCardTypeChanged) {
                getCardTypeByNumberServiceCall(number);
              }
              if (isUnsupportedCard) {
                $scope.allowedCardsTooltip = true;
              }
            } else {
              if (!isCardTypeChanged) {
                // Hide dropdown and trigger bin matching when the cc number is < 4 digits
                if (number.length < 4) {
                  forceDropDown = false;
                }
                if (!$scope.enableDropDown()) {
                  cardType = $scope.getAllowedCardTypeByNumber(number);
                  $scope.card.type = cardType.type;
                  $scope.card.subType = cardType.subType;
                }
              }
              if ($scope.isPlcc && $scope.card.type) {
                $scope.cvvShown();
                $scope.expiryShown();
              }
              if (!$scope.card.type && !$scope.isPlcc && (number.length >= 4 || $scope.getDisallowedCardTypeByNumber(number).type)) {
                $scope.allowedCardsTooltip = true;
              }
            }

            // Format the card number

            /*
             * PPPLMER-1563 commented out to fix this bug
            if (/android/i.test(navigator.userAgent)) {
                return;
            }
            */

            formattedNumber = formatCardNumber(number);

            // If the card is already formatted correctly, we can leave the user to continue in peace.
            if ($scope.card.number === formattedNumber) {
              return;
            }

            // Wait for the user's input to be reflected on the page (necessary for safari 5 otherwise selectionStart is incorrect)
            $timeout(function () {
              // re-formatting the number, since the card type may not have resolved before the first call
              $scope.card.number = formatCardNumber(number);

              // Save the current cursor positions
              var ccField = document.getElementById('cc');
              if (!ccField) {
                return;
              }
              var inputLength = ccField.value.length;
              var cursorStart = ccField.selectionStart;

              // Wait for the formatted card to be reflected on the page
              $timeout(function () {
                // If the cursor was at the end of the input field, keep it at the end
                if (cursorStart === inputLength) {
                  ccField.selectionStart = ccField.selectionEnd = ccField.value.length;
                  // Otherwise place the cursor to the position it was in before we replaced with the formatted number
                } else {
                  ccField.selectionStart = ccField.selectionEnd = cursorStart;
                }
              });
            });
          };
          var year = new Date().getFullYear();
          $scope.months = $util.map($util.range(1, 13), str);
          $scope.startYears = $util.map($util.range(year - 9, year + 1), str);
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_cardMetaData.$CardMetaData;
_utils.unchangeableCardTypes;
_utils.getDefaultCoversionSelection;
_utils.isConversionApplicable;
_utils.removeNonNumericCharsAndTruncate;
_squid.$elmo;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/creditcard-input/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.unchangeableCardTypes = exports.removeNonNumericCharsAndTruncate = exports.isConversionApplicable = exports.getDefaultCoversionSelection = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
/* eslint-disable no-arrow-condition, no-confusing-arrow, angular/typecheck-string */

var getForcedCards = function getForcedCards(type) {
  return _squid.$util.getProperty(_squid.$config, "currencyConversion.cards.forced" + type, {
    "default": []
  });
};
var unchangeableCardTypes = exports.unchangeableCardTypes = [].concat(getForcedCards('PayPal'), getForcedCards('Vendor'));
var getDefaultCoversionSelection = exports.getDefaultCoversionSelection = function getDefaultCoversionSelection(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    type = _ref.type;
  return getForcedCards('Vendor').includes(type) ? 'VENDOR' : 'PAYPAL';
};

/**
 * @function isConversionApplicable
 * @description checks to see if currency conversion is needed for the transaction
 * @param {object} scope - Angular scope
 * @returns {boolean}
 */
var isConversionApplicable = exports.isConversionApplicable = function isConversionApplicable(scope) {
  var cartCurrency = scope.checkoutCart.get('purchase.amounts.total.currency_code');
  var billingCurrency = _squid.$util.getProperty(scope, 'locale.metadata.currency.code');

  // If the cart currency and the currency for the user's billing address
  // are both presetn and different then currency conversion is applicable
  var hasDifferentCurrency = Boolean(cartCurrency && billingCurrency && cartCurrency !== billingCurrency);

  /**
   * Certain countries (e.g. IN) only allow domestic transactions, transactions between
   * a buyer and merchant both from that country (e.g. IN buyer & IN merchant), to be
   * done in the domestic currency (e.g. INR). For these countries we should not show
   * the conversion information, even if the cart currency is different from the countries
   * domestic currency. (See PPPLMER-63051)
   */
  var ineligibleDomesticCountriesList = _squid.$util.getProperty(_squid.$config, 'currencyConversion.domesticTransactionsIneligibleCountries', {
    "default": []
  });
  var merchantCountry = scope.checkoutAppData.get('merchant.merchant_country');
  var isForcedDomesticConversion = _squid.$locale.country === merchantCountry && ineligibleDomesticCountriesList.includes(_squid.$locale.country);
  return hasDifferentCurrency && !isForcedDomesticConversion;
};

/**
 * @function removeNonNumericCharsAndTruncate
 * @description removes non-numeric chars and optionally truncates
 *      the string based on the provided `maxLen` param
 * @param {string} str
 * @param {number} maxLen
 * @returns {string}
 */
var removeNonNumericCharsAndTruncate = exports.removeNonNumericCharsAndTruncate = function removeNonNumericCharsAndTruncate(str, maxLen) {
  if (typeof str !== 'string') {
    return '';
  }
  var replacedStr = str.replace(/[^0-9]+/g, '');
  return maxLen ? replacedStr.slice(0, maxLen) : replacedStr;
};
_squid.$config;
_squid.$locale;
_squid.$util;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoCvvDirective = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
__webpack_require__("../node_modules/xo-ui-components/src/floating-label/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/directionality/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $xoCvvDirective = exports.$xoCvvDirective = _squid.$Component.extend('$xoCvvDirective', {
  tag: 'xo-cvv',
  template: _template["default"],
  props: {
    card: {
      type: 'var',
      required: false
    },
    showLabel: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.focusAndBlurHandler = function ($event) {
        _logger.$logger.info("credit_card_cvv_" + $event.type + "_event");
      };
      this.maskCVV = (0, _squid.$feature)('maskCVV', false, _squid.$locale.country);
      this.cvvLength = function () {
        // passing country to differentiate CUP for C2 and ROW
        return _cardMetaData.$CardMetaData.getMetaData(_this.props.card, 'length.cvv', _squid.$locale.country);
      };
      this.cvvRequired = function () {
        return _this.props.card.type !== 'MAESTRO' || (0, _squid.$feature)('maestroCvvRequired', false, _squid.$locale.country);
      };
    }
  }
});
angular.value("$xoCvvDirective", $xoCvvDirective);
_squid.$Component;
_squid.$locale;
_squid.$feature;
_cardMetaData.$CardMetaData;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/cvv/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"inputField cvvField\" id=\"cvvField\">\n    <div class=\"cvvSecurityCode inputField\" floating-label directionality>\n        <input type=\"{{maskCVV ? 'password' : 'tel'}}\" id=\"cvv\" name=\"cvv\" ng-model=\"card.security_code\"\n               ng-blur=\"focusAndBlurHandler($event)\"\n               ng-focus=\"focusAndBlurHandler($event)\"\n               aria-describedby=\"securityCodeHelp\"\n               ng-pattern=\"/^[0-9]{1,4}$/\" ng-minlength=\"cvvLength()\" maxlength=\"{{cvvLength()}}\"\n               placeholder=\"{{cvvLength() === 3 ? content('creditcard.threeDigits') : content('creditcard.fourDigits')}}\"\n               ng-required=\"cvvRequired()\" ng-class=\"{'four': cvvLength() === 4}\" autocomplete=\"off\"\n               track-focus-and-blur=\"cardCvv\"\n               data-error-key=\"validation.validCSC\" xo-error-tooltip />\n\n        <span id=\"securityCode\" class=\"creditCard\" role=\"img\" ng-class=\"{'four': cvvLength() === 4}\"\n              aria-label=\"{{cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')}}\">\n        </span>\n        <label ng-if=\"showLabel\" for=\"cvv\">{{ content('creditcard.cscLabel') }}</label>\n        <span id=\"securityCodeHelp\" class=\"accessAid\" ng-bind=\"cvvLength() === 4 ? content('creditcard.cscHelp4Digits') : content('creditcard.cscHelp3Digits')\"></span>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/fi/index.js"), __webpack_require__("../node_modules/xo-models/src/address/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {
  return squid.module('xo-add-card.directive', ['squid', 'xomodel.checkout', 'xomodel.fi', 'xomodel.address']).directive('xoAddCardFlow', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        parentCallbacks: '=?',
        message: '=?',
        pagetitle: '=?',
        sidebar: '=?',
        showmeftsection: '=?',
        hideparenthead: '=?',
        promotion: '=?',
        pageLevel: '=?',
        logout: '=?',
        phone: '=?',
        fundingid: '=?',
        onSuccess: '=?',
        backUri: '=?'
      },
      controller: ['$scope', '$state', '$populate', '$AddCardModel', '$CardModel', '$CheckoutSessionModel', '$PrefillAddressModel', '$util', '$renderContent', function ($scope, $state, $populate, $AddCardModel, $CardModel, $CheckoutSessionModel, $PrefillAddressModel, $util, $renderContent) {
        $scope.addCCDone = function () {
          $scope.parentCallbacks.finish();
        };
        $scope.callbacks = {
          done: function done() {
            $scope.parentCallbacks.finish();
          },
          showCep: function showCep() {
            $scope.prefillAddress = new $PrefillAddressModel({
              id: $scope.token
            });
            $state.go('^.addCep');
          },
          cardTypeSelected: function cardTypeSelected(type) {
            $scope.selectedPromotionCardType = {
              type: type
            };
            $state.go('^.addCard');
          }
        };
        $scope.cepDone = function () {
          $state.go('^.addBilling');
        };
        $scope.selectedPromotionCardType = {
          type: $scope.promotion && $scope.promotion.type
        };
        if ($scope.promotion) {
          $scope.promotion.type = null;
        }
        $scope.billingaddressupdated = {
          value: false
        };
        $scope.phone = {
          hide_type: true
        };
        $scope.cardmodel = new $AddCardModel({
          card: new $CardModel()
        });
        $populate($scope, {
          checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
            contingencies: {
              NEED_CREDIT_CARD: angular.noop,
              EXPIRED_CREDIT_CARD: angular.noop
            }
          })
        }).then(function () {
          if ($scope.checkoutSession.errorData && $scope.checkoutSession.errorData.resolution) {
            var card = $scope.checkoutSession.errorData.resolution.data;
            if (card.fundingId && card.fi && card.fi.type) {
              $scope.cardmodel.id = card.fundingId;
              $scope.cardmodel.card = new $CardModel({
                number: 'xxxx-xxxx-xxxx-' + card.fi.number,
                type: card.fi.type.toUpperCase(),
                productType: card.fi.productType
              });
            }
          }
          if ($scope.fundingid) {
            var fundingSource = $util.find($scope.checkoutSession.fundingOptions.instruments, function (funding) {
              if (funding && funding.id === $scope.fundingid) {
                return funding;
              }
            });
            if (fundingSource) {
              $scope.cardmodel.id = fundingSource.id;
              $scope.cardmodel.card = new $CardModel({
                number: 'xxxx-xxxx-xxxx-' + fundingSource.lastDigits,
                lastDigits: fundingSource.lastDigits,
                type: fundingSource.name,
                name: $renderContent('fsMappings.' + fundingSource.name)
              });
            }
          }
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/dob/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/add-card/dob/template.html"));
__webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoDobCardInputDirective', {
  tag: 'xo-dob-card-input',
  template: _template["default"],
  props: {
    user: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      function pad(length) {
        if (length === void 0) {
          length = 2;
        }
        return function (num) {
          return (new Array(length + 1).join('0') + num).substr(-length);
        };
      }
      var year = new Date().getFullYear();
      this.days = _squid.$util.map(_squid.$util.range(1, 32), pad());
      this.months = _squid.$util.map(_squid.$util.range(1, 13), pad());
      this.years = _squid.$util.map(_squid.$util.range(year - 100, year), pad(4)).reverse();
    }
  }
});
_squid.$Component;
_squid.$util;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/dob/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\">\n    <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n    <div class=\"dropdown fidobDay nullable\">\n        <select xo-dropdown name=\"dobDayCC\" id=\"dobDayCC\" ng-model=\"user.dob_day\"\n                ng-options=\"day for day in days track by day\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobMonth nullable\">\n        <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"user.dob_month\"\n                ng-options=\"month for month in months track by month\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n        </select>\n    </div>\n\n    <div class=\"dropdown fidobYear nullable\">\n        <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"user.dob_year\"\n                ng-options=\"year for year in years track by year\" ng-required=\"true\">\n            <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n        </select>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _directive = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js");
Object.keys(_directive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _directive[key]) return;
  exports[key] = _directive[key];
});
var _cardMetaData = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cardMetaData/index.js");
Object.keys(_cardMetaData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cardMetaData[key]) return;
  exports[key] = _cardMetaData[key];
});
var _directive2 = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/cvv/directive.js");
Object.keys(_directive2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _directive2[key]) return;
  exports[key] = _directive2[key];
});

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addcard/route.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/route.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addbilling/route.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/addCep/route.js"), __webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('xo-add-card.route', ['squid', 'xo-add-card.directive', 'xo-add-card.addcard.route', 'xo-add-card.selectcard.route', 'xo-add-card.addbilling.route', 'xo-add-card.addcep.route', 'xo-confirm-upop.route']).factory('$AddCardFlowRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('CardRoute', {
      name: 'addCardFlow',
      directive: 'xo-add-card-flow',
      titleContent: 'asideHeader.addCard',
      children: [{
        name: '$AddCardRoute',
        attributes: {
          token: 'token',
          cardmodel: 'cardmodel',
          done: 'addCCDone',
          message: 'message',
          pagetitle: 'pagetitle',
          sidebar: 'sidebar',
          showmeftsection: 'showmeftsection',
          hideparenthead: 'hideparenthead',
          billingaddressupdated: 'billingaddressupdated',
          isupdatecard: 'isupdatecard',
          'parent-callbacks': 'callbacks',
          'selected-promotion-card-type': 'selectedPromotionCardType',
          promotion: 'promotion',
          'page-level': 'pageLevel',
          logout: 'logout',
          phone: 'phone',
          'on-success': 'onSuccess',
          'back-uri': 'backUri'
        }
      }, {
        name: '$SelectCardRoute',
        attributes: {
          token: 'token',
          'parent-callbacks': 'callbacks',
          message: 'message',
          pagetitle: 'pagetitle',
          sidebar: 'sidebar',
          'selected-promotion-card-type': 'selectedPromotionCardType',
          promotion: 'promotion'
        }
      }, {
        name: '$AddBillingRoute',
        attributes: {
          token: 'token',
          sidebar: 'sidebar',
          showmeftsection: 'showmeftsection',
          'parent-callbacks': 'callbacks',
          hideparenthead: 'hideparenthead',
          billingaddressupdated: 'billingaddressupdated',
          'prefill-address': 'prefillAddress'
        }
      }, {
        name: '$AddCepRoute',
        attributes: {
          token: 'token',
          sidebar: 'sidebar',
          'done-fn': 'cepDone',
          'prefill-address': 'prefillAddress'
        }
      }]
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card", "../node_modules/xo-wallet-components/src/add-card/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/add-card/selectcard/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, template) {
  return angular.module('xo-add-card.selectcard.directive', []).directive('xoSelectCard', [function () {
    return {
      template: template,
      scope: {
        parentCallbacks: '=?',
        token: '=?',
        promotion: '=?'
      },
      controller: ['$scope', '$populate', '$CheckoutSessionModel', function ($scope, $populate, $CheckoutSessionModel) {
        $populate($scope, {
          checkoutSession: $CheckoutSessionModel.instance($scope.token)
        }).then(function () {
          $scope.selectCardType = function (type) {
            // card type is either 'cc' or 'plcc'
            $scope.parentCallbacks.cardTypeSelected(type);
          };
        });
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/add-card/selectcard/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/selectcard/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('xo-add-card.selectcard.route', ['xo-add-card.selectcard.directive']).factory('$SelectCardRoute', ['$ComponentRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('SelectCardRoute', {
      name: 'selectCard',
      directive: 'xo-select-card',
      titleContent: 'asideHeader.selectCard',
      children: []
    });
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/add-card/selectcard", "../node_modules/xo-wallet-components/src/add-card/selectcard/route.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/confirm/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _angular = _interopRequireWildcard(__webpack_require__("../node_modules/angular/angular.min.js"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");
var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/spinner-button/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/confirm/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var VERIFICATION_CODE_COUNTDOWN_IN_SECS = 180; // 3 minutes
var RESEND_CODE_LINK_TIMEOUT_MILLI_SECS = 60000; // 1 minute
var ONE_MINUTE_IN_SECS = 60;
var _default = exports["default"] = _squid.$Component.extend('$xoConfirmOtpDirective', {
  tag: 'xo-confirm-otp',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    phone: {
      type: 'var',
      required: false
    },
    cardModel: {
      type: 'var',
      required: false
    },
    onSuccess: {
      type: 'var',
      required: false
    },
    message: {
      type: 'var',
      required: false
    },
    buttonTextKey: {
      type: 'var',
      required: false
    }
  },
  actions: {
    addMessage: function addMessage(type, contentKey) {
      if (contentKey) {
        this.message({
          msgKeys: [_angular["default"].isArray(contentKey) ? contentKey[0] : contentKey],
          type: type || 'error'
        });
      }
    },
    stopConfirmCodeTimer: function stopConfirmCodeTimer() {
      if (this.confirmCodeTimer) {
        _angular.$interval.cancel(this.confirmCodeTimer);
      }
      this.countdown = 0;
    },
    stopResendCodeTimer: function stopResendCodeTimer() {
      if (this.resendCodeTimer) {
        _angular.$timeout.cancel(this.resendCodeTimer);
      }
      this.showResendLink = false;
    },
    updateCountdown: function updateCountdown() {
      if (this.countdown > 0) {
        this.countdown--;
        this.timer = Math.floor(this.countdown / ONE_MINUTE_IN_SECS) + ':' + ('0' + this.countdown % ONE_MINUTE_IN_SECS).slice(-2);
      } else {
        if (!this.isConfirmProcessing) {
          this.actions.addMessage('warning', 'confirmUpop.codeExpired');
        }
        this.actions.stopConfirmCodeTimer();
        this.actions.stopResendCodeTimer();
      }
    },
    startCountdown: function startCountdown(resetTimer) {
      var _this = this;
      if (resetTimer) {
        this.actions.stopConfirmCodeTimer();
        this.countdown = VERIFICATION_CODE_COUNTDOWN_IN_SECS;
        this.actions.updateCountdown();
        this.confirmCodeTimer = (0, _angular.$interval)(this.actions.updateCountdown, 1000);
      }
      this.actions.stopResendCodeTimer();
      this.showResendLink = false;
      this.resendCodeTimer = (0, _angular.$timeout)(function () {
        _this.showResendLink = true;
      }, RESEND_CODE_LINK_TIMEOUT_MILLI_SECS);
      this.actions.addMessage('success', 'confirmUpop.codeSent');
    },
    processed: function processed() {
      if (!this.countdown && this.isConfirmProcessing) {
        this.actions.addMessage('warning', 'confirmUpop.codeExpired');
      }
      this.isProcessing = this.isConfirmProcessing = false;
    },
    handleContingencies: function handleContingencies(result, prop) {
      if (result === void 0) {
        result = {};
      }
      var errorData;
      if (result.errorCodes) {
        errorData = result;
      } else {
        errorData = {
          errorCodes: [result['0'] || 'ISSUER_DECLINE']
        };
      }
      this.message(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
      if (window.scrollTo) {
        window.scrollTo(0, 0);
      }
    },
    sendNewCode: function sendNewCode() {
      // reset the code field.
      if (this.cardModel) {
        this.cardModel.otp_code = '';
      }
      this.actions.resendCode(true);
    },
    resendCode: function resendCode(resetTimer) {
      var _this2 = this;
      this.isProcessing = true;
      this.resolveOTP.action('init', {
        silent: true,
        data: {
          phone: {
            country_code: this.phone.IntDialingCountryCode,
            number: this.phone.telephone
          }
        },
        resultModel: {},
        success: function success() {
          _this2.actions.startCountdown(resetTimer);
        },
        error: function error() {
          _this2.actions.handleContingencies();
        },
        contingencies: {
          INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
            // prop for last 4 digits of card in error message
            var prop = {
              number: _this2.cardLast4
            };
            _this2.actions.handleContingencies(result, prop);
            _util.$fiErrorUtil.addFieldErrors(result, _this2.$element);
          },
          DEFAULT: function DEFAULT() {
            _this2.actions.handleContingencies();
          }
        }
      })['finally'](this.actions.processed);
    },
    confirmOTP: function confirmOTP() {
      var _this3 = this;
      this.isProcessing = this.isConfirmProcessing = true;
      this.resolveOTP.action('complete', {
        silent: true,
        data: {
          code: this.cardModel.otp_code,
          phone: {
            country_code: this.phone.IntDialingCountryCode,
            number: this.phone.telephone
          },
          card_data: {
            expiration_time: {
              month: this.cardModel.expiry_month,
              year: this.cardModel.expiry_year
            },
            card_verification_code: this.cardModel.security_code
          }
        },
        success: this.onSuccess,
        error: function error() {
          _this3.actions.handleContingencies({}, 'confirmUpop');
          _this3.actions.processed();
        },
        contingencies: {
          COMPLETE_OTP_CONTINGENCY: function COMPLETE_OTP_CONTINGENCY(name, result) {
            // prop for last 4 digits of card in error message
            var prop = {
              number: _this3.cardLast4
            };
            _this3.actions.handleContingencies(result, prop);
            _util.$fiErrorUtil.addFieldErrors(result, _this3.$element);
            _this3.actions.processed();
          }
        }
      })["catch"](function () {
        _this3.actions.handleContingencies();
        _this3.actions.processed();
      });
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this4 = this;
      this.resolveOTP = new _index.$ResolveOTP({
        id: this.cardModel.id
      });
      this.isProcessing = this.showResendLink = false;
      this.cardLast4 = this.cardModel.last4();
      this.phoneLast4 = this.phone && this.phone.telephone && this.phone.telephone.slice(-4);
      this.actions.startCountdown(true);
      if (!this.buttonTextKey) {
        this.buttonTextKey = 'common.confirm';
      }
      this.$watch('isProcessing', function (isProcessing) {
        if (isProcessing) {
          _this4.$element.addClass('processing');
        } else {
          _this4.$element.removeClass('processing');
        }
      });
      $('#upopConfirmation .modalContainer').focus();
    }
  }
});
_angular.$interval;
_angular.$timeout;
_squid.$Component;
_util.$fiErrorUtil;
_index.$ResolveOTP;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/confirm/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"confirmOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent('confirmUpop.verificationCodeMsg', {phoneLastFour: phoneLast4})\"></div>\n\n    <div class=\"timer\">\n        <span class=\"left\">{{content('confirmUpop.timeRemaining')}}</span>\n        <span class=\"timeLeft\">{{timer}} {{content('confirmUpop.minutes')}}</span>\n        <a link-button class=\"resendLink right focusableIcon\" href=\"\" ng-if=\"showResendLink\" ng-click=\"actions.resendCode(false)\">{{content('confirmUpop.resendCode')}}</a>\n    </div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.confirmOTP()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"confirmFields\" ng-show=\"countdown || isConfirmProcessing\">\n            <div class=\"inputField confidential\">\n                <input id=\"otp_code\"\n                       class=\"otp_code\"\n                       type=\"tel\"\n                       ng-model=\"cardModel.otp_code\"\n                       name=\"otp_code\"\n                       value=\"\"\n                       placeholder=\"{{ content('confirmUpop.verificationCodeHint') }}\"\n                       autocapitalize=\"off\"\n                       autocomplete=\"off\"\n                       aria-required=\"false\"\n                       required\n                       scroll-to-top\n                       data-error-key=\"confirmUpop.fieldInvalidOTP\"\n                       xo-error-tooltip/>\n\n            </div>\n            <xo-spinner-button track='confirm_otp_code' token=\"token\" validate=\"validated\"\n                               is-processing=\"isProcessing\" button-text=\"{{buttonTextKey}}\"></xo-spinner-button>\n        </div>\n    </form>\n    <div class=\"sendNewOtp\">\n        <xo-spinner-button ng-if=\"!countdown && !isConfirmProcessing\" track='resend_otp_code' token=\"token\" on-click=\"actions.sendNewCode\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnResendCode\"></xo-spinner-button>\n    </div>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _addCard = __webpack_require__("../node_modules/xo-wallet-components/src/add-card/index.js");
var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");
var _jquery = _interopRequireDefault(__webpack_require__("../node_modules/jquery/dist/jquery.min.js"));
__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/init/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/confirm/directive.js");
__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/template.html"));
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoConfirmUpopDirective', {
  tag: 'xo-confirm-upop',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    phone: {
      type: 'var',
      required: false
    },
    cardModel: {
      type: 'var',
      required: false
    },
    onSuccess: {
      type: 'var',
      required: false
    },
    onCancel: {
      type: 'var',
      required: false
    },
    buttonTextKey: {
      type: 'var',
      required: false
    },
    onInitError: {
      type: 'var',
      required: false
    }
  },
  actions: {
    initSuccess: function initSuccess() {
      this.showCollectOtpScreen = true;
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.phone = this.props.phone || {};
      this.cardLast4 = this.cardModel.last4();

      // Set only from Login page
      this.fromLoginOverlay = _uiRouter.$stateParams.fromLoginOverlay;
      (0, _angular.$timeout)(function () {
        (0, _jquery["default"])('#upopConfirmation .upopConfirm').addClass('upopOpen');
        if (_this.fromLoginOverlay) {
          (0, _angular.$timeout)(function () {
            (0, _jquery["default"])('#upopConfirmation .modalWrapper').addClass('modalWrapperAnimation');
          });
        }
      });
      var hideModal = function hideModal() {
        (0, _jquery["default"])('#upopConfirmation .upopConfirm').removeClass('upopOpen');
      };
      var done = function done(handler, target, errorData) {
        hideModal();
        (0, _angular.$timeout)(function () {
          return handler ? handler(errorData) : _this["goto"](target);
        }, 300);
      };
      var _success = function success() {
        done(_this.props.onSuccess, 'checkout.review');
      };
      this.closeModal = function (event) {
        if (event) {
          event.preventDefault();
        }
        done(_this.props.onCancel, '^');
      };
      this.confirmed = function () {
        if (_this.props.onSuccess) {
          // Make sure Guest/Signup always passes the onSuccess callback method.
          return _success();
        }

        // Update is only applicable for Hermes Member flow.
        var checkoutSession = _index.$CheckoutSessionModel.instance(_this.token);
        checkoutSession.fundingOptions.action('update', {
          resultModel: checkoutSession,
          silent: true,
          data: {
            planId: _this.cardModel.id
          },
          success: function success() {
            if (checkoutSession.cvvData) {
              checkoutSession.set('cvvData.security_code', _this.cardModel.security_code);
            }
            var isNewCard = !_this.cardModel.isExisting();
            var msg = isNewCard ? ['smallToolTip.cardAddedConfirmed'] : ['smallToolTip.cardConfirmed'];
            checkoutSession.message = {
              type: 'success',
              msgKeys: msg
            };
            _success();
          },
          contingencies: {
            TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
              checkoutSession.message = {
                type: 'info',
                msgKeys: 'creditcard.addedButCannotUse'
              };
              _success();
            }
          }
        });
      };
      this.flag = function (field) {
        // passing country to differentiate CUP for C2 and ROW
        return _addCard.$CardMetaData.getMetaData(_this.cardModel, field, _squid.$locale.country);
      };
      this.setMessage = function (message) {
        _this.message = message;
      };
      this.setInitErrorData = function (errorData) {
        if (_this.props.onInitError) {
          // Pass on the errorData to onInitError callback function for client specific content adaptation.
          done(_this.props.onInitError, '^', errorData);
        } else {
          // prop for last 4 digits of card in error message
          var prop = {
            number: _this.cardModel.last4()
          };

          // Build the content message from errorData
          _this.setMessage(_util.$fiErrorUtil.addPageErrors(errorData, 'confirmUpop', prop, 'error'));
        }
      };
    }
  }
});
_angular.$timeout;
_squid.$Component;
_squid.$locale;
_uiRouter.$stateParams;
_addCard.$CardMetaData;
_util.$fiErrorUtil;
_index.$CheckoutSessionModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/init/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");
var _index = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/spinner-button/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/init/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoInitOtpDirective', {
  tag: 'xo-init-otp',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    phone: {
      type: 'var',
      required: false
    },
    cardModel: {
      type: 'var',
      required: false
    },
    onSuccess: {
      type: 'var',
      required: false
    },
    flag: {
      type: 'var',
      required: false
    },
    setErrorData: {
      type: 'var',
      required: false
    }
  },
  actions: {
    initOtp: function initOtp() {
      var _this = this;
      var handleContingencies = function handleContingencies(result, prop) {
        if (result === void 0) {
          result = {};
        }
        var errorData;
        if (result.errorCodes) {
          errorData = result;
        } else {
          errorData = {
            errorCodes: [result['0'] || 'ISSUER_DECLINE']
          };
        }
        _this.setErrorData(errorData);
        if (window.scrollTo) {
          window.scrollTo(0, 0);
        }
      };
      this.isProcessing = true;
      var resolveOTP = new _index.$ResolveOTP({
        id: this.cardModel.id
      });
      resolveOTP.action('init', {
        data: {
          phone: {
            country_code: this.phone.IntDialingCountryCode,
            number: this.phone.telephone
          }
        },
        resultModel: {},
        success: function success() {
          _this.onSuccess();
        },
        error: function error() {
          handleContingencies();
        },
        contingencies: {
          INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
            handleContingencies(result);
            _util.$fiErrorUtil.addFieldErrors(result, _this.$element);
          },
          DEFAULT: function DEFAULT() {
            handleContingencies();
          }
        }
      })['finally'](function () {
        _this.isProcessing = false;
      });
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this2 = this;
      this.$watch('isProcessing', function (isProcessing) {
        if (isProcessing) {
          _this2.$element.addClass('processing');
        } else {
          _this2.$element.removeClass('processing');
        }
      });
      if (this.flag('fields.expiry') && !this.cardModel.get('expiry_month') || this.flag('fields.cvv') && !this.cardModel.get('security_code') || this.flag('fields.phone') && !(this.phone && this.phone.telephone)) {
        this.showInitScreen = true;
      } else {
        this.actions.initOtp();
      }
      $('#upopConfirmation .modalContainer').focus();
    }
  }
});
_squid.$Component;
_util.$fiErrorUtil;
_index.$ResolveOTP;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/init/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"showInitScreen\" class=\"initOtp\" content>\n    <div class=\"confirmMsg\" ng-bind-html=\"htmlContent(flag('fields.expiry') ? 'confirmUpop.creditInitOtp' : 'confirmUpop.debitInitOtp')\"></div>\n\n    <form id=\"otpForm\" name=\"otpForm\" autocomplete=\"off\" ng-submit=\"otpForm.$valid && actions.initOtp()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n        <div class=\"expiration confidential\" id=\"expiration\" ng-if=\"flag('fields.expiry') || flag('fields.cvv')\">\n            <xo-card-expiry ng-if=\"flag('fields.expiry')\" expiry-month=\"cardModel.expiry_month\" expiry-year=\"cardModel.expiry_year\"></xo-card-expiry>\n            <xo-cvv ng-if=\"flag('fields.cvv')\" card=\"cardModel\" show-label=\"true\"></xo-cvv>\n        </div>\n        <xo-phone-input token=\"token\" ng-if=\"flag('fields.phone')\" show-phone-type=\"false\" phone=\"phone\"></xo-phone-input>\n\n        <xo-spinner-button track='init_otp_code' token=\"token\" validate=\"validated\"\n                           is-processing=\"isProcessing\" button-text=\"confirmUpop.btnsendOtpCode\"></xo-spinner-button>\n    </form>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _directive = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/confirm-upop/directive.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Route.extend('$xoConfirmUpopRoute', {
  path: 'confirmUpop',
  directive: _directive["default"],
  titleContent: 'confirmUpop.confirm',
  trackingData: {
    fptiState: 'confirm_upop'
  },
  query: ['fromLoginOverlay'],
  loginRequired: true,
  pageOnOverlay: true,
  children: []
});
_index.$Route;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/confirm-upop/template.html":
/***/ (function(module, exports) {

module.exports = "<section id=\"upopConfirmation\">\n    <div class=\"upopConfirm\">\n        <div class=\"modalMask\"></div>\n        <div class=\"modalWrapper\" modal-box modal-cancel=\"closeModal()\" ng-class=\"{'modalWrapperAnimation': !fromLoginOverlay}\">\n            <div class=\"modalContainer\" content tabindex=\"-1\">\n                <a link-button track-submit=\"{{collectOtpInput ? 'close_otp_init' : 'close_otp_confirm'}}\" class=\"close focusableIcon\" href=\"#\" ng-click=\"closeModal($event)\"></a>\n                <xo-message message=\"message\"></xo-message>\n                <div class=\"heading\" ng-bind-html=\"htmlContent('confirmUpop.heading', {acctLastFour: cardLast4})\"></div>\n\n                <xo-init-otp token=\"token\" set-error-data=\"setInitErrorData\" phone=\"props.phone\" card-model=\"cardModel\" on-success=\"actions.initSuccess\" flag=\"flag\" ng-if=\"!showCollectOtpScreen\"></xo-init-otp>\n                <xo-confirm-otp token=\"token\" message=\"setMessage\" phone=\"props.phone\" card-model=\"cardModel\" on-success=\"confirmed\" ng-if=\"showCollectOtpScreen\" button-text-key=\"buttonTextKey\"></xo-confirm-otp>\n                <div class=\"pushlogo\"></div>\n            </div>\n            <div class=\"ppLogoContainer\">\n                <div class=\"logo\"></div>\n            </div>\n        </div>\n    </div>\n</section>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _checkout = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/currency-conversion-options/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoCurrencyConversionOptions', {
  tag: 'xo-currency-conversion-options',
  template: _template["default"],
  props: {
    card: {
      type: 'var',
      required: false
    },
    token: {
      type: 'var',
      required: false
    },
    treatment: {
      type: 'var',
      required: false
    },
    isPrePlan: {
      type: 'str',
      required: false
    },
    updateConversionSelection: {
      type: 'var',
      required: false
    },
    openModal: {
      type: 'var',
      required: false
    },
    showInvoicingRegEMsg: {
      type: 'var',
      required: false
    },
    nonEmptyMerchantDisplayName: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      var modelsObj = {
        checkoutCart: _checkout.$CheckoutCartModel.instance(this.props.token).retrieve()
      };
      if (!this.isPrePlan) {
        modelsObj.checkoutSession = _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve();
      }
      return modelsObj;
    }
  },
  actions: {
    onConversionOptionChange: function onConversionOptionChange() {
      if (this.isPrePlan) {
        this.card.ppconversion = this.models.ppconversion;
      } else {
        // For post-plan conversion we need to update the chosen conversion
        // selection in the guest currency conversion interstitial component
        this.updateConversionSelection(this.models.ppconversion);
      }

      /**
       * FPTI event #4 for Buyer FX guest experience
       * https://engineering.paypalcorp.com/confluence/display/EDS/Buyer+FX+Instrumentation+Specs
       */
      var planType = this.isPrePlan ? 'pre' : 'post';
      _logger.$logger.info('checkout_fpti', {
        from: 'CURRENCY_CONVERSION',
        to: "changed_currency_conversion_" + planType + "_plan",
        currency_conversion_selected: this.models.ppconversion,
        currency_conversion_from_curr: this.conversion.from_code,
        currency_conversion_to_curr: this.conversion.to_code,
        currency_conversion_spread: this.conversion.spread
      });
      this.conversionIsPayPal = this.models.ppconversion === this.conversionOptions.PAYPAL;
    }
  },
  lifecycle: {
    enter: function enter() {
      this.conversionOptions = _squid.$config.currencyConversion.options;
      this.isPrePlan = this.props.isPrePlan === 'true';
      var _this$props$treatment = this.props.treatment,
        treatment = _this$props$treatment === void 0 ? '' : _this$props$treatment;
      this.isTreatment1 = treatment.includes('treatment_1');
      this.conversionIsPayPal = true;
    },
    populate: function populate() {
      this.models.ppconversion = this.conversionOptions.PAYPAL;

      /**
       * In the pre-plan case the conversion data will be located at
       * this.card.currencyConvData, whereas in the post-plan caes it
       * will be located at this.models.checkoutSession.plan.converison
       */
      var modelWithConversion = this.isPrePlan ? this.card : this.models.checkoutSession;
      var conversionKey = this.isPrePlan ? 'currencyConvData' : 'plan.conversion';
      this.conversion = modelWithConversion.get(conversionKey);
      var _this$models$checkout = this.models.checkoutCart.get('grossTotalAmount', {}),
        toValue = _this$models$checkout.value,
        toCurrency = _this$models$checkout.currency;
      var _this$conversion = this.conversion,
        fullString = _this$conversion.to,
        amount = _this$conversion.to_amount,
        amountForex = _this$conversion.to_amount_forex,
        fromCurrency = _this$conversion.from_code;
      var formattedToStr = (0, _squid.truncateCurrencyConversionString)({
        fullString: fullString,
        amount: amount,
        amountForex: amountForex
      });
      this.paypalRate = "1 " + fromCurrency + " = " + formattedToStr;
      this.spread = this.conversion.spread;

      // Get formatted currency amounts to display
      var paypalTotalPath = this.isPrePlan ? 'currencyConvData.payment_amt.value' : 'plan.sources.0.amount.amount_formatted_currency';
      this.paypalConversionTotal = this.isPrePlan ? (0, _squid.formatCurrency)(this.card.get(paypalTotalPath), fromCurrency, false) : this.models.checkoutSession.get(paypalTotalPath);
      this.issuerConversionTotal = (0, _squid.formatCurrency)(toValue, toCurrency, false);

      // Currency codes are used as labels for treatment 2
      this.toCurrency = toCurrency;
      this.fromCurrency = fromCurrency;

      // New Zealand departed from the other non-localized APAC countries and is not
      // showing the PayPal rate disclosure but instead is showing the spread disclosure
      // South Korea has a specific spread disclosure which makes rate disclosure not required
      this.showRateDisclosure = !['NZ', 'KR'].includes(_squid.$locale.country);
      this.showBRDisclosure = _squid.$locale.country === 'BR';
      var _$config$AMLRuleCount = _squid.$config.AMLRuleCountries,
        AMLRuleCountries = _$config$AMLRuleCount === void 0 ? [] : _$config$AMLRuleCount;
      this.showAMLDisclosure = AMLRuleCountries.includes(_squid.$locale.country);

      // When the pre-plan API fails we show the conversion options
      // in an interstitial after the user submits the form.
      if (!this.isPrePlan && typeof this.openModal === 'function') {
        // eslint-disable-line angular/typecheck-function
        this.openModal();
      }
    }
  }
});
_squid.$Component;
_squid.$locale;
_squid.formatCurrency;
_squid.$config;
_squid.truncateCurrencyConversionString;
_checkout.$CheckoutCartModel;
_checkout.$CheckoutSessionModel;
_logger.$logger;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/currency-conversion-options/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"conversion-options-container\" data-test-id=\"conversion-options-container\" content>\n    <ul class=\"conversion-options\">\n        <!-- PayPal conversion option -->\n        <li class=\"conversion-options__option\">\n            <input\n                type=\"radio\"\n                ng-model=\"models.ppconversion\"\n                ng-change=\"actions.onConversionOptionChange()\"\n                name=\"ppconversion\"\n                id=\"conversion-PayPal\"\n                value=\"{{conversionOptions.PAYPAL}}\"\n                data-test-id=\"conversion-paypal\"\n                required/>\n            <label for=\"conversion-PayPal\" data-test-id=\"conversion-paypal-label\">\n                {{ isTreatment1 ? content('currencyOptions.bfxConversionPayPalLabelRate') : fromCurrency }}\n            </label>\n        </li>\n\n        <!-- Issuer conversion option -->\n        <li class=\"conversion-options__option\">\n            <input\n                type=\"radio\"\n                class=\"conversion-option-input\"\n                ng-model=\"models.ppconversion\"\n                ng-change=\"actions.onConversionOptionChange()\"\n                name=\"ppconversion\"\n                id=\"conversion-vendor\"\n                value=\"{{conversionOptions.VENDOR}}\"\n                data-test-id=\"conversion-vendor\"\n                required/>\n            <label for=\"conversion-vendor\" data-test-id=\"conversion-vendor-label\">\n                {{ isTreatment1 ? content('currencyOptions.bfxConversionIssuerLabelRate') : toCurrency }}\n            </label>\n        </li>\n    </ul>\n\n    <dl class=\"conversion-total\" data-test-id=\"conversion-total\">\n        <!-- PayPal conversion amount -->\n        <dt class=\"conversion-total__title\" ng-if=\"conversionIsPayPal\">\n            {{ content('currencyOptions.bfxConversionPayPalTotal') }}\n        </dt>\n        <dd class=\"conversion-total__amount\" ng-if=\"conversionIsPayPal\">\n            {{ paypalConversionTotal }}\n        </dd>\n\n        <!-- Issuer conversion amount -->\n        <dt class=\"conversion-total__title\" ng-if=\"!conversionIsPayPal\">\n            {{ content('currencyOptions.bfxConversionIssuerTotal') }}\n        </dt>\n        <dd class=\"conversion-total__amount\" ng-if=\"!conversionIsPayPal\">\n            {{ issuerConversionTotal }}\n        </dd>\n    </dl>\n\n    <ul class=\"conversion-disclaimers\">\n        <!-- PayPal conversion disclaimers -->\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimer-paypal-rate\"\n            ng-if=\"conversionIsPayPal\"\n            data-test-id=\"disclaimer-paypal\">\n            {{ content('currencyOptions.bfxConversionPayPalRate') }} {{ paypalRate }}\n        </li>\n        <li ng-if=\"showInvoicingRegEMsg\"\n            class=\"conversion-disclaimers__disclaimer\"\n            data-test-id=\"disclaimer-paypal-reg-e\">\n            {{\n                content('billingAgreement.invoicingRegEMsgWithCurrConversion', {\n                    amountInPayerCurrency: paypalConversionTotal,\n                    merchantName: nonEmptyMerchantDisplayName,\n                    amountInInvCurrency: issuerConversionTotal\n                })\n            }}\n        </li>\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimers-spread\"\n            ng-if=\"conversionIsPayPal\"\n            data-test-id=\"disclaimer-paypal-spread\">\n            <div data-ng-bind-html=\"htmlContent('currencyOptions.conversionRateLockDisclosure', { rate: spread })\"></div> \n        </li>\n        <li class=\"conversion-disclaimers__disclaimer\"\n            ng-if=\"conversionIsPayPal && showRateDisclosure\"\n            data-test-id=\"disclaimer-paypal-rate\">\n            {{ content('currencyOptions.bfxConversionPayPalRateDisclosure') }}\n        </li>\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimer-secondary\"\n            ng-if=\"conversionIsPayPal\" >\n            <button class=\"button-72-hrs-title\" ng-click=\"showDetails = ! showDetails\" type=\"button\">\n                {{ content('currencyOptions.conversionRateLockTitle')}}\n            <span ng-class= \"showDetails ? 'arrow-down open' : 'arrow-down'\" />\n            </button>\n            <p class= \"conversion-disclaimers__disclaimer conversion-disclaimer-lock-details\" ng-if=\"showDetails\">\n                {{ content('currencyOptions.conversionRateLockSeventyTwoHoursDetails')}}\n            </p>\n        </li>\n        <li class=\"conversion-disclaimers__disclaimer\"\n            ng-if=\"conversionIsPayPal && showAMLDisclosure\"\n            data-test-id=\"disclaimer-paypal-AML\">\n            {{ content('currencyOptions.bfxConversionAMLRulesDisclosure') }}\n        </li>\n\n        <!-- Issuer conversion disclaimers -->\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimer-issuer-rate\"\n            ng-class=\"{ 'conversion-disclaimer-inline': isPrePlan }\"\n            ng-if=\"!conversionIsPayPal\"\n            data-test-id=\"disclaimer-issuer\">\n            {{ content('currencyOptions.bfxConversionIssuerDisclosure') }}\n        </li>\n\n        <!-- BR disclaimer that applies to PayPal and Issuer -->\n        <li class=\"conversion-disclaimers__disclaimer conversion-disclaimer-secondary\"\n            ng-if=\"showBRDisclosure\"\n            data-test-id=\"disclaimer-IOF\">\n            {{ content('currencyOptions.bfxConversionBRIOFRateDisclosure') }}\n        </li>\n    </ul>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-contingency-list/contingencies.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
  // When adding a key, please keep list in alphabetical order
  var contingencyList = {
    ACCOUNT_RESTRICTED: ['errorAccountRestricted', 'errorGeneral'],
    ADD_REFUSED_DUE_TO_EXCEEDING_MAX_DUPLICATE_INSTRUMENT_LIMIT: 'errorInstrumentUnavailable',
    ADDRESS_MISMATCH: 'errorInstrumentBillingAddressNotMatch',
    BANK_ACCOUNT_NUMBER_IS_EMPTY: 'invalidPINumber',
    BANK_ADDRESS_IS_EMPTY: 'errorGeneral',
    BANK_ROUTING_NUMBER_IS_EMPTY: 'invalidPINumber',
    BILL_ADDR_NOT_ALLOWED: ['errorInstrumentBillingAddressNotAccepted', 'errorAddressNotAllowed'],
    BILL_ADDR_UNAVAILABLE: ['errorInstrumentBillingAddressUnavailable', 'errorInstrumentBillingAddressNotAccepted'],
    BILL_ADDR_UNAVAILABLE_GLOBAL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
    BILL_ADDR_UNAVAILABLE_INTL: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
    BILL_ADDR_UNSUPPORTED: ['errorInstrumentBillingAddressUnsupported', 'errorInstrumentBillingAddressNotAccepted'],
    BILLING_ADDRESS1: 'errorInstrumentBillingAddressNotAccepted',
    BILLING_CITY: 'errorInstrumentBillingAddressNotAccepted',
    BILLING_COUNTRY: 'errorInstrumentBillingAddressNotAccepted',
    BILLING_DIFFERENT_COUNTRY: ['errorInstrumentBillingAddressUnavailableIntl', 'errorInstrumentBillingAddressNotAccepted'],
    CARD_NOT_ACTIVATED_FOR_UPOP: 'cardNotActivatedUpop',
    CC_INVALID_CSC: ['errorCheckDigits', 'errorGeneral'],
    CHECK_DIGITS_NOT_PRESENT: ['errorCheckDigitsNotPresent', 'errorGeneral'],
    CHECK_DIGITS_NOT_PROC: ['errorCheckDigitsNotPresent', 'errorGeneral'],
    CHECK_DIGITS_UNAVAILABLE: ['errorCheckDigits', 'errorGeneral'],
    CHECK_DIGITS_UNSUPPORTED: ['errorCheckDigits', 'errorGeneral'],
    CONFIRMATION_RESEND_COUNT_EXCEEDED: 'resendValExceeded',
    CONTACT_CARD_ISSUER_TO_VERIFY: 'issuerVerify',
    COUNTRY_NOT_SUPPORTED: 'complianceDecline',
    DUPLICATED_TRANSACTION: 'duplicateTransaction',
    EMPTY_DATA: 'errorGeneral',
    EXCESSIVE_REJECTIONS: ['errorExcessiveRejectGuest', 'errorInstrumentRefused'],
    FREQUENT_REQUEST_VERIFICATION_CODE: 'frequentVerificationCodeReq',
    INSTRUMENT_ALREADY_EXISTS: 'errorInstrumentAlreadyExists',
    INSTRUMENT_BILLING_ADDRESS_NOT_ACCEPTED: 'errorInstrumentBillingAddressNotAccepted',
    INSTRUMENT_COUNT_EXCEEDED: 'errorInstrumentCountExceeded',
    INSTRUMENT_COUNT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
    INSTRUMENT_COUNT_LIMIT_EXCEEDED: 'errorInstrumentCountExceeded',
    INSTRUMENT_COUNT_LIMIT_EXCEEDED_VERIFIED: 'errorInstrumentCountExceeded',
    INSTRUMENT_DISABLED: 'errorInstrumentRefused',
    INSTRUMENT_DUPLICATE_LIMIT_REACHED: 'errorInstrumentRefused',
    INSTRUMENT_INTERNATIONAL: 'errorIssuerRejectIntl',
    INSTRUMENT_REFUSED: 'errorInstrumentRefused',
    INSTRUMENT_REFUSED_DUE_TO_MAX_LIMIT: 'errorInstrumentRefused',
    INSTRUMENT_REFUSED_DUE_TO_MAX_SHARED_INSTRUMENT_LIMIT: ['errorInstrumentUnavailable', 'errorInstrumentRefused'],
    INSTRUMENT_UNAVAILABLE: 'errorInstrumentUnavailable',
    INSTRUMENT_UPDATE_NO_CHANGE: 'errorInstrumentUpdateNoChange',
    INTERNAL_ERROR: 'errorInternalError',
    INVALID_ACCOUNT: ['errorInvalidAccount', 'errorGeneral'],
    INVALID_BANK_ACCOUNT_NUMBER: 'invalidPINumber',
    INVALID_BANK_ADDRESS: 'errorGeneral',
    INVALID_BANK_BENEFICIARY_NUMBER: 'errorGeneral',
    INVALID_BANK_BRANCH_NUMBER: 'errorGeneral',
    INVALID_BANK_IBAN: 'invalidPINumber',
    INVALID_BANK_IBAN_CONVERSION_ERROR: 'invalidPINumber',
    INVALID_BANK_ROUTING_NUMBER: 'invalidRoutingNumber',
    INVALID_BENEFICIARY_FIRST_NAME: 'errorInvalidFirstName',
    INVALID_BENEFICIARY_NAME: 'errorInvalidFirstName',
    INVALID_CARD_NUMBER: 'errorInvalidCCNumberOrType',
    INVALID_CARD_TYPE: 'errorInvalidCCNumberOrType',
    INVALID_DATA: ['errorInvalidData', 'errorGeneral'],
    INVALID_EXPIRATION_DATE: 'errorInvalidExpirationDate',
    INVALID_EXPIRY: 'errorInvalidExpirationDate',
    INVALID_FIRST_NAME: 'errorInvalidFirstName',
    INVALID_IBAN_CODE: 'invalidPINumber',
    INVALID_INSTRUMENT_ID: ['errorInvalidAccount', 'errorGeneral'],
    INVALID_LAST_NAME: 'errorInvalidLastName',
    INVALID_ONE_TIME_PASSWORD: 'errorInvalidOtpCode',
    INVALID_PARAMETERS: ['errorInvalidData', 'errorGeneral'],
    INVALID_PHONE: 'errorInvalidPhone',
    INVALID_SECURITY_CODE: 'errorInvalidCSC',
    ISSUER_DECLINE: 'errorIssuerReject',
    ISSUER_ERROR: ['errorIssuerDenied', 'errorInstrumentRefused'],
    ISSUER_REJECTED: ['errorIssuerReject', 'errorGeneral'],
    ISSUER_RESTRICTED: ['errorIssuerReject', 'errorGeneral'],
    MAX_AMOUNT_EXCEEDED: ['errorMaxAmountExceeded', 'errorInstrumentRefused'],
    MISSING_FIELD: ['errorInvalidData', 'errorGeneral'],
    NOT_CONFIRMED: 'notConfirmed',
    NOT_ELIGIBLE_TO_EDIT_CARD: 'notEligibleToEditCard',
    PAYPAL_CARD_REFUSED: ['errorPaypalRefused', 'errorGeneral'],
    PAYPAL_CREDIT_CARD_REFUSED: ['errorPaypalCreditRefused', 'errorGeneral'],
    PAYPAL_DEBIT_CARD_REFUSED: ['errorPaypalDebitRefused', 'errorGeneral'],
    PI_TYPE_NOT_SUPPORTED: 'errorInvalidCCNumberOrType_global',
    REJECT_AMEX_ADULT: ['errorAmexAdult', 'errorGeneral'],
    REJECT_REFUSED: ['errorIssuerReject', 'errorInstrumentRefused'],
    REJECT_UNKNOWN: ['errorIssuerReject', 'errorInstrumentRefused'],
    RESTRICTED_CARD: 'cardRestricted',
    RESTRICTED_CARD_GUEST: 'cardRestrictedGuest',
    SETTLEMENT_DENIED: 'errorInstrumentRefused',
    TRANSACTION_TIMEOUT: 'transactionTimeout',
    WRONG_CONFIRMATION_VALUES: 'wrongConfirmationValue'
  };
  return contingencyList;
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/fi-contingency-list/util.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/jquery/dist/jquery.min.js"), __webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/contingencies.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function ($, angular, squid, contingencyList) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  squid.module('fi.errorUtil', ['squid']).factory('$fiErrorUtil', ['$renderContent', function ($renderContent) {
    return {
      addPageErrors: function addPageErrors(errorData, contentBundle, prop, defaultKey) {
        // error handling for filifecycle and fimanagement. 
        if (!errorData.errorCodes) {
          errorData.errorCodes = errorData && [errorData['0']];
        }
        var messages = [];
        if (errorData.errorCodes && errorData.errorCodes.length) {
          errorData.errorCodes.forEach(function (errorCode) {
            var contentKey = contingencyList[errorCode] || defaultKey || 'errorGeneral';
            var message;
            if (angular.isArray(contentKey)) {
              for (var i = 0; i < contentKey.length; i++) {
                message = $renderContent(contentBundle + '.' + contentKey[i], prop);
                if (message && message.string) {
                  break;
                }
              }
            } else {
              message = $renderContent(contentBundle + '.' + contentKey, prop);
            }
            messages.push(message);
          });
          return {
            msgs: messages,
            type: 'error'
          };
        }
      },
      /**
       * Highlight the Error Fields by ng-model
       * @param errorData
       * @param element
       * @param modelPrefix
       */
      addFieldErrors: function addFieldErrors(errorData, element, modelPrefix) {
        if (errorData.fields && errorData.fields.length) {
          errorData.fields.forEach(function (field) {
            var $field = $(element).find('[ng-model="' + (modelPrefix ? modelPrefix : '') + field.field + '"]');
            $field.addClass('backendError');
            $field.attr('aria-invalid', true);
          });
        }
        $(element).find('.backendError:first').focus();
      },
      /**
       * Highlight the Error Fields by element name
       * @param errorData
       * @param element
       * @param modelPrefix
       */
      addFieldErrorsByName: function addFieldErrorsByName(errorData, element, modelPrefix) {
        if (errorData.fields && errorData.fields.length) {
          errorData.fields.forEach(function (field) {
            var fieldName;
            if (modelPrefix && field.field && field.field.length > 0) {
              // Add prefix with CamelCase of field name
              fieldName = modelPrefix + field.field[0].toUpperCase() + field.field.substring(1);
            } else {
              fieldName = field.field;
            }
            var $field = $(element).find('[name="' + fieldName + '"]');
            $field.addClass('backendError');
            $field.attr('aria-invalid', true);
          });
        }
        $(element).find('.backendError:first').focus();
      }
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "../node_modules/xo-wallet-components/src/fi-contingency-list", "../node_modules/xo-wallet-components/src/fi-contingency-list/util.js"))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!../node_modules/xo-wallet-components/src/installment-options/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-models/src/auth/index.js"), __webpack_require__("../node_modules/xo-tray-height/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (squid, template) {
  squid.module('xo-installment-options.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xo-tray-height.directive']).directive('xoInstallmentOptions', [function () {
    return {
      template: template,
      scope: {
        token: '=?',
        doneFn: '=?',
        cardNumber: '=?'
      },
      controller: ['$AuthModel', '$scope', '$populate', '$CheckoutSessionModel', '$InstallmentOptionsModel', '$CheckoutPayeeModel', '$CheckoutCartModel', '$CheckoutAppDataModel', function ($AuthModel, $scope, $populate, $CheckoutSessionModel, $InstallmentOptionsModel, $CheckoutPayeeModel, $CheckoutCartModel, $CheckoutAppDataModel) {
        $populate($scope, {
          auth: $AuthModel.instance($scope.token)
        }).then(function () {
          if ($scope.auth.logged_in) {
            // Installment support for authenticated user
            $populate($scope, {
              checkoutSession: $CheckoutSessionModel.instance($scope.token)
            }).then(function () {
              $scope.cardInfo = $scope.checkoutSession.plan.sources[0];
              $scope.installments = $scope.checkoutSession.installments;
            });
          } else {
            // Installment support added for not authenticated user, e.g. BR signup flow
            var installmentsModel = $InstallmentOptionsModel.instance($scope.token);
            installmentsModel.save({
              data: {
                cc: $scope.cardNumber,
                payee: $CheckoutPayeeModel.instance($scope.token),
                checkoutCart: $CheckoutCartModel.instance($scope.token),
                checkoutAppData: $CheckoutAppDataModel.instance($scope.token)
              },
              success: function success(result) {
                $scope.cardInfo = result.cardInfo;
                $scope.installments = result.installment_options;
              }
            });
          }
        });
        $scope.onSelect = function (index) {
          var selectedInstallmentData = $scope.installments[index];
          $scope.installmentsModel = $InstallmentOptionsModel.instance($scope.token);
          var param = {
            term: selectedInstallmentData.term,
            payment_value: selectedInstallmentData.monthly_payment.value,
            payment_currency: selectedInstallmentData.monthly_payment.currency
          };
          if (selectedInstallmentData.total_cost) {
            param.total_cost_value = selectedInstallmentData.total_cost.value;
            param.total_cost_currency = selectedInstallmentData.total_cost.currency;
          }
          if (selectedInstallmentData.discount_amount) {
            param.discount_value = selectedInstallmentData.discount_amount.value;
            param.discount_currency = selectedInstallmentData.monthly_payment.currency;
          }
          if (selectedInstallmentData.discount_percentage) {
            param.discount_percentage = selectedInstallmentData.discount_percentage;
          }
          return $scope.installmentsModel.action('select', {
            data: {
              installments: param
            },
            success: function success(result) {
              if ($scope.auth.logged_in) {
                $scope.checkoutSession.selectedInstallmentData = selectedInstallmentData;
              }
              $scope.doneFn(result);
            }
          });
        };
      }]
    };
  }]);
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/pay-upon-invoice/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var _util = __webpack_require__("../node_modules/xo-wallet-components/src/fi-contingency-list/util.js");
var _index5 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _index6 = __webpack_require__("../node_modules/xo-models/src/address/index.js");
__webpack_require__("../node_modules/xo-address-components/src/add-address/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/name-input/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/dob-input/directive.js");
__webpack_require__("../node_modules/xo-guest-components/src/guest/emailInput/directive.js");
__webpack_require__("../node_modules/xo-form-components/src/phone/phoneInput/directive.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/pay-upon-invoice/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('xoPayUponInvoice', {
  tag: 'xo-pay-upon-invoice',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    isUnbranded: {
      type: 'var',
      required: false
    }
  },
  resolve: {
    models: function models() {
      return {
        auth: _index5.$AuthModel.instance(this.token).retrieve(),
        checkoutAppData: _index2.$CheckoutAppDataModel.instance(this.props.token).retrieve(),
        checkoutCart: _index2.$CheckoutCartModel.instance(this.token).retrieve()
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      this.locale = _index.$locale;
      var days = [];
      var months = [];
      var years = [];
      var i;
      for (i = 1; i <= 31; i += 1) {
        var d = i < 10 ? '0' + i : i.toString();
        days.push(d);
      }
      for (i = 1; i <= 12; i += 1) {
        var m = i < 10 ? '0' + i : i.toString();
        months.push(m);
      }
      var year = new Date().getFullYear();
      for (i = year - 17; i >= year - 100; i -= 1) {
        years.push(i);
      }
      this.dobDays = days;
      this.dobMonths = months;
      this.dobYears = years;
      this.hideHelper = true;
      this.onboard = new _index3.$OnboardModel({
        user: new _index3.$OnboardUserModel({
          country: _index.$locale.country
        }),
        billing_address: _index4.$BillingAddressModel.create(this.token, {
          country: _index.$locale.country
        }),
        shipping_address: _index2.$ShippingAddressModel.create(this.token, {
          country: _index.$locale.country
        }),
        phone: new _index3.$OnboardPhoneModel()
      });
    },
    populate: function populate() {
      var _this = this;
      // logout the user before user clicks on submit button
      // User might be logged into paypal on another tab, in which case
      // createPUI to PAPS fails (if we dont logout the user)
      this.models.auth.action('logout');
      var shippingAddress = this.models.checkoutCart.get('purchase.shipping_address');
      var billingAddress = this.models.checkoutCart.get('billing_address') || {};
      billingAddress.first_name = this.models.checkoutCart.get('payer.first_name');
      billingAddress.last_name = this.models.checkoutCart.get('payer.last_name');

      // basic validation to check if any data is missing
      var validateAddress = function validateAddress(address) {
        return address && address.line1 && address.city && address.postal_code;
      };

      /**
      /* Set prefill billing address. By default set to merchant passed billing address if its valid
       * Otherwise prefill valid shipping address as billing address
       */

      var getDefaultAddress = function getDefaultAddress() {
        var isValidBilling = validateAddress(billingAddress);
        var isValidShipping = validateAddress(shippingAddress);
        var defaultAddress = billingAddress;
        _logger.$logger.info("pay_upon_invoice_is_billing_valid_" + isValidBilling);
        if (!isValidBilling && isValidShipping) {
          defaultAddress = shippingAddress;
          _logger.$logger.info('pay_upon_invoice_set_shipping_as_default');
        }
        return defaultAddress || {};
      };
      var prefilledAddress = getDefaultAddress();
      this.isPrefilledAddress = validateAddress(prefilledAddress) && prefilledAddress.first_name && prefilledAddress.last_name;
      if (this.isPrefilledAddress) {
        this.shipping = prefilledAddress;
        this.shipping.recipientName = prefilledAddress.first_name + ' ' + prefilledAddress.last_name;
        this.shipping.zipAndCity = prefilledAddress.postal_code + ' ' + prefilledAddress.city;
      }
      var getPayButtonText = function getPayButtonText() {
        _this.useraction = _this.models.checkoutAppData.useraction();
        var payButtonText = _index.$locale.content.get('common.agreeAndContinue');
        if (_this.useraction && _this.useraction.toLowerCase() === 'commit') {
          payButtonText = _index.$locale.content.get('common.agreeAndPay');
        }
        return payButtonText;
      };
      this.payButtonText = getPayButtonText();

      /**
      /* Set the prefilled Phone Number either from shipping address or billing address which merchants pass while making create payment call
       * If both are present shipping address take the preference over billing address.
       */
      var prefilledNumber = this.models.checkoutCart.get('purchase.phone_fields') || this.models.checkoutCart.get('billing.phone_fields');
      if (prefilledNumber && prefilledNumber.telephone_country === _index.$locale.country) {
        this.onboard.phone.telephone = prefilledNumber.normalized_phone_number;
      }
      this.onboard.shipping_address = _index2.$ShippingAddressModel.create(this.token, {
        country: _index.$locale.country
      }, prefilledAddress);
      this.onboard.billing_address = _index4.$BillingAddressModel.create(this.token, {
        country: _index.$locale.country
      }, prefilledAddress);

      // saving in to user object so that email field pre-populate if its passed in from setEc.
      this.onboard.user.email = this.models.checkoutCart.payer && this.models.checkoutCart.payer.email;
    }
  },
  actions: {
    changeShipping: function changeShipping() {
      this.isPrefilledAddress = !this.isPrefilledAddress;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      this.onboard.billing_address.country = _index.$locale.country;
      this.addressNormalization = new _index6.$AddressNormalizationModel({
        address: this.onboard.billing_address
      });
      var handleValidation = function handleValidation() {
        var data = {
          errorCodes: ['BILL_ADDR_NOT_ALLOWED']
        };
        _this2.errorMessage = _util.$fiErrorUtil.addPageErrors(data, 'payUponInvoice');
        if (window.scrollTo) {
          window.scrollTo(0, 0);
        }
        return _angular.$q.reject();
      };
      this.addressNormalization.save({
        data: this.addressNormalization,
        contingencies: {
          VALIDATION_ERROR: function VALIDATION_ERROR() {
            handleValidation()["catch"](function (error) {
              _logger.$logger.info('PUI_addressNormalization_validation_rejection_captured');
            });
          }
        },
        error: function error() {
          _uiRouter.$state.go('checkout.genericError', {
            code: 'PAYMENT_PROCESS_ERROR'
          });
        },
        success: function success(result) {
          var loginDataGsid = {
            user: {
              email: _this2.onboard.user.email
            },
            pui_flow: true
          };
          // Adding login call to get the Global session ID
          // by passing email and actorinfovo(just with actor type) to STS.
          // auth_state will be anonymous after the below passive login call.
          // since account is not created yet.

          return _angular.$q.when().then(function () {
            _logger.$logger.info('PUI_Invoking_login_call_to_get_GSID');
            return _this2.models.auth.action('login', {
              data: loginDataGsid,
              success: function success() {
                _logger.$logger.info('PUI_login_call_succeeded_to_get_GSID');
                _this2.normalizedAddress = result;
                var checkoutSession = _index2.$CheckoutSessionModel.instance(_this2.token);
                checkoutSession.action('createPUI', {
                  data: {
                    user: _this2.onboard.user,
                    address: _this2.onboard.billing_address,
                    isPayerRequired: true,
                    paymentMethod: 'pay_upon_invoice',
                    phone: _this2.onboard.phone || ''
                  },
                  contingencies: {
                    PAYMENT_METHOD_UNUSABLE: function PAYMENT_METHOD_UNUSABLE() {
                      _logger.$logger.info('PUI_create_PUI_call_failed_payment_method_unusable');
                      _uiRouter.$state.go('checkout.genericError', {
                        code: 'PAYMENT_PROCESS_ERROR'
                      });
                    }
                  },
                  error: function error() {
                    _logger.$logger.info('PUI_create_PUI_call_failed');
                    _uiRouter.$state.go('checkout.genericError', {
                      code: 'PAYMENT_PROCESS_ERROR'
                    });
                  },
                  success: function success(successResult) {
                    _logger.$logger.info('PUI_create_PUI_call_successful');
                    var loginData = {
                      user: {
                        account_number: successResult.payer.account_number,
                        email: successResult.payer.email
                      }
                    };
                    return _angular.$q.when().then(function () {
                      return _this2.models.auth.action('login', {
                        data: loginData,
                        success: function success() {
                          _logger.$logger.info('PUI_guest_passive_login_successful', {
                            from: 'LOGIN',
                            to: 'process_login'
                          });
                          return checkoutSession.action('authorize', {
                            error: function error() {
                              _logger.$logger.info('PUI_authorize_payment_failed');
                              _uiRouter.$state.go('checkout.genericError', {
                                code: 'PAYMENT_PROCESS_ERROR'
                              });
                            },
                            success: function success() {
                              _logger.$logger.info('PUI_authorize_payment_successful');
                              _uiRouter.$state.go('checkout.end');
                            }
                          });
                        },
                        error: function error() {
                          _logger.$logger.info('PUI_guest_passive_login_failed');
                          _uiRouter.$state.go('checkout.genericError', {
                            code: 'PAYMENT_PROCESS_ERROR'
                          });
                        }
                      })["catch"](function (err) {
                        _logger.$logger.info('default_contingency_handling_PUI_passive_login_call_failed', {
                          reason: 'passive login unhandled contingency',
                          error: err
                        });
                        return _uiRouter.$state.go('checkout.genericError', {
                          code: 'DEFAULT'
                        });
                      });
                    });
                  },
                  VALIDATION_ERROR: function VALIDATION_ERROR() {
                    _uiRouter.$state.go('checkout.genericError', {
                      code: 'PAYMENT_PROCESS_ERROR'
                    });
                  }
                });
              },
              error: function error() {
                _logger.$logger.info('PUI_login_call_failed_to_get_GSID');
                _uiRouter.$state.go('checkout.genericError', {
                  code: 'PAYMENT_PROCESS_ERROR'
                });
              }
            })["catch"](function (err) {
              _logger.$logger.info('default_contingency_handling_PUI_login_call_failed_to_get_GSID', {
                reason: 'login unhandled contingency to get GSID',
                error: err
              });
              return _uiRouter.$state.go('checkout.genericError', {
                code: 'DEFAULT'
              });
            });
          });
        }
      });
    }
  }
});
_angular.$q;
_index.$Component;
_index.$locale;
_index2.$CheckoutSessionModel;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutCartModel;
_index2.$ShippingAddressModel;
_index3.$OnboardModel;
_index3.$OnboardUserModel;
_index3.$OnboardPhoneModel;
_index4.$BillingAddressModel;
_util.$fiErrorUtil;
_index5.$AuthModel;
_logger.$logger;
_uiRouter.$state;
_index6.$AddressNormalizationModel;
module.exports = exports.default;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/pay-upon-invoice/template.html":
/***/ (function(module, exports) {

module.exports = "<div content class=\"payUponInvoice\" id=\"payUponInvoice\">\n\n\n    <div class=\"personalInfo\" >{{content('payUponInvoice.title')}}</div>\n    <xo-message message=\"errorMessage\"></xo-message>\n\n    <form id=\"payUponInvoiceForm\" name=\"payUponInvoiceForm\" class=\"payUponInvoiceForm\"\n          ng-submit=\"payUponInvoiceForm.$valid && actions.onSubmit()\" ng-class=\"{true: 'validated'}[validated]\" novalidate>\n\n        <div class=\"addressArea\">\n            <label class=\"nolap billingLabel\">{{content('payUponInvoice.addressTitle')}}</label>\n            <div  ng-if=\"isPrefilledAddress\" class=\"billingArea\">\n                <div class=\"addressDisplay\" >\n                    <div class=\"confidential streets street-address\">\n                        {{shipping.recipientName}}\n                    </div>\n\n                    <div class=\"confidential streets street-address\">\n                        {{shipping.line1}}\n                    </div>\n\n                    <div class=\"confidential streets street-address\" ng-if=\"shipping.line2\">\n                        {{shipping.line2}}\n                    </div>\n\n                    <div class=\"postal-code\">\n                        {{shipping.zipAndCity}}\n                    </div>\n                </div>\n            </div>\n            <a class=\"edits changeShipping\" ng-if=\"isPrefilledAddress\" ng-click=\"actions.changeShipping()\" >\n                {{ content('common.change') }}\n            </a>\n        </div>\n\n        <div id=\"billingAddress\" class=\"billingArea clearfix\" ng-if=\"!isPrefilledAddress\">\n            <div class=\"addressSubTitle\">{{content('payUponInvoice.notification')}}</div>\n            <xo-add-address address=\"onboard.billing_address\" is-shipping=\"true\" country=\"locale.country\"></xo-add-address>\n        </div>\n\n        <div id=\"phone\" ng-if=\"isUnbranded\">\n            <xo-phone-input phone=\"onboard.phone\" countryCode=\"locale.country\"></xo-phone-input>\n        </div>\n\n        <xo-email-input user=\"onboard.user\" hide-helper=\"hideHelper\"></xo-email-input>\n\n        <!-- DOB fields for Country specific cards -->\n        <!-- TODO: Pull out DOB fields into a separate component -->\n        <div id=\"cardDOB\" class=\"cardDOB inputField invisiField confidential last-child\" >\n            <label class=\"dobLabel nolap\" for=\"dobDayCC\">{{ content('creditcard.dob') }}</label>\n\n            <span class=\"dobHelper\">\n                <a href=\"#\" id=\"verifyHelp\" alt=\"Why do we need this\" class=\"verifyHelp\">\n                </a>\n            </span>\n\n            <xo-tooltip trigger=\"#verifyHelp\">\n                <div class=\"tip tipDesc emailToolTip\">\n                    {{ content('payUponInvoice.dobTooltip') }}\n                </div>\n            </xo-tooltip>\n            <div class=\"dropdown fidobDay nullable\">\n                <select xo-dropdown name=\"dobDayCC\" ng-model=\"onboard.user.dob_day\"\n                        ng-options=\"day for day in dobDays track by day\"\n                        id=\"dobDayCC\"  ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyDD') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobMonth nullable\">\n                <select xo-dropdown name=\"dobMonthCC\" id=\"dobMonthCC\" ng-model=\"onboard.user.dob_month\"\n                        ng-options=\"month for month in dobMonths track by month\" ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyMM') }}</option>\n                </select>\n            </div>\n\n            <div class=\"dropdown fidobYear nullable\">\n                <select xo-dropdown name=\"dobYearCC\" id=\"dobYearCC\" ng-model=\"onboard.user.dob_year\"\n                        ng-options=\"year for year in dobYears track by year\" ng-required=\"true\">\n                    <option value=\"\">{{ content('applyForBml.bmlApplyYYYY') }}</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"row-fluid checkbox legal\">\n            <input ng-model=\"sepaAgree\" type=\"checkbox\" name=\"sepaAgree\" id=\"sepaAgree\" required/>\n            <label class=\"noBottom agreeSepaTerms\" for=\"sepaAgree\"\n                   bind-html-compile=\"htmlContent('payUponInvoice.agreeTerms')\"></label>\n        </div>\n\n        <div class=\"buttons\">\n            <input track-submit id=\"invoiceSubmit\" type=\"submit\" value=\"{{ payButtonText }}\"\n            class=\"btn\" ng-click=\"validated=true\" />\n        </div>\n    </form>\n</div>\n\n\n\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds-ddc/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/three-ds-ddc/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoThreeDsDdcDirective', {
  tag: 'xo-three-ds-ddc',
  template: _template["default"],
  props: {
    jwt: {
      type: 'var',
      required: true
    },
    ddcUrl: {
      type: 'var',
      required: true
    },
    doneCallback: {
      type: 'var',
      required: true
    }
  },
  resolve: {
    experiments: function experiments() {
      return {
        ddcTreatment: (0, _squid.$elmo)('three_ds_ddc', {
          'ctx.COUNTRY': _squid.$locale.country
        }, 'three_ds_ddc_trmt(.*)')
      };
    }
  },
  lifecycle: {
    enter: function enter() {
      _squid.$config.cardinalcommerce = _squid.$config.cardinalcommerce || {};
    },
    populate: function populate() {
      var _this = this;
      var startTime = Date.now();
      var ddcCompleted = function ddcCompleted() {
        var elapsedMs = Date.now() - startTime;
        _logger.$logger.info('threeds_v2', {
          from: '3DS_DDC',
          to: '3DS_DDC_DONE',
          duration: elapsedMs,
          ddc_end_time: Date.now(),
          context_id: _angular.$rootScope.token
        });
        _this.doneCallback();
      };
      function fireAndForget() {
        // no wait
        return ddcCompleted();
      }
      function waitDdcForFixedTime() {
        // Prioritize app config over hardcoded value for timeout
        (0, _angular.$timeout)(function () {
          return ddcCompleted();
        }, _squid.$config.cardinalcommerce.ddcShortCircuitTime || 1000);
      }
      function waitDdcResponse() {
        window.addEventListener('message', function (event) {
          // add ddcOrigin - "https://centinelapisbox.cardinalcommerce.com:50486/"" into app config.json
          // This domain changes with every environment. This origin value will be the CentinelAPI domain
          // event message sample
          // {MessageType:  "profile.completed",   SessionId : "0_57f063fd-659a-4779-b45b-9e456fdb7935", Status: true}
          _logger.$logger.info('3DS_DDC_MESSAGE_EVENT_LISTENER_TRIGGERED');
          if (event.origin === _squid.$config.cardinalcommerce.ddcOrigin || event.origin.includes('paypal.com')) {
            var data = JSON.parse(event.data);
            if (data && data.MessageType === 'profile.completed') {
              return ddcCompleted();
            }
          }
        }, false);
      }
      _logger.$logger.info('3DS_INIT_DDC_TRIGGERED');
      $('#threedsDdcIframeForm').submit();
      var ddcTreatmentName = this.experiments && this.experiments.ddcTreatment && this.experiments.ddcTreatment.treatment_name;
      if (!ddcTreatmentName) {
        // default
        _logger.$logger.info('3DS_DDC_FIRE_FORGET_EMPTY_TRMT');
        return fireAndForget();
      }
      if (ddcTreatmentName === 'three_ds_ddc_trmt1') {
        _logger.$logger.info('3DS_DDC_TRMT1');
        return fireAndForget();
      }
      if (ddcTreatmentName === 'three_ds_ddc_trmt2') {
        _logger.$logger.info('3DS_DDC_TRMT2');
        return waitDdcForFixedTime();
      }
      if (ddcTreatmentName === 'three_ds_ddc_trmt3') {
        _logger.$logger.info('3DS_DDC_TRMT3');
        return waitDdcResponse();
      }
    }
  },
  actions: {
    trustSrc: function trustSrc(url) {
      return _angular.$sce.trustAsResourceUrl(url);
    }
  }
});
_angular.$sce;
_angular.$rootScope;
_angular.$timeout;
_squid.$config;
_squid.$Component;
_squid.$elmo;
_squid.$locale;
_logger.$logger;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds-ddc/template.html":
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"ddcUrl && jwt\">\n    <!-- this form uses iframe to post data because of target attribute -->\n    <form id=\"threedsDdcIframeForm\" name=\"threedsDdcIframeForm\" action=\"{{actions.trustSrc(ddcUrl)}}\" target=\"threedsDdcIframe\" method=\"post\">\n        <input type=\"hidden\" name=\"JWT\" value=\"{{jwt}}\" />\n    </form>\n    <iframe name=\"threedsDdcIframe\" height=\"1\" width=\"1\" style=\"display:none\" sandbox=\"allow-forms allow-pointer-lock allow-scripts allow-same-origin\">\n    </iframe>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/apis.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.initThreeds = exports.getJwt = exports.authenticate3DS = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _index = __webpack_require__("../node_modules/xo-models/src/threeDS/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/fi/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/switchPaymentsApiServ/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");
var getJwt = exports.getJwt = function getJwt(payload) {
  var threeDSJWTModel = new _index.$ThreeDSJWTModel(payload);
  return threeDSJWTModel.action('jwt', {
    // hide the loading spinner
    silent: true,
    data: threeDSJWTModel.serialize(),
    success: function success(result) {
      _logger.$logger.info('3DS_JWT_SUCCESS');
      return result;
    },
    validation: function validation() {
      _logger.$logger.info('threeds_v2', {
        context_id: _angular.$rootScope.token,
        int_error_description: 'JWT_SERVICE_VALIDATION_ERROR'
      });
    },
    error: function error() {
      _logger.$logger.info('threeds_v2', {
        context_id: _angular.$rootScope.token,
        int_error_description: 'JWT_SERVICE_ERROR'
      });
    }
  });
};
var initThreeds = exports.initThreeds = function initThreeds(integrationType, fundingId, payload, callback) {
  var request = {
    data: payload,
    resultModel: {},
    success: function success(result) {
      callback(_constants.STATUS_SUCCESS, result);
    },
    error: function error(err) {
      _logger.$logger.warn('INIT_3DS_UKNOWN_ERROR', {
        reason: 'init 3ds unknown error',
        error: err
      });
      _logger.$logger.info('threeds_v2', {
        context_id: _angular.$rootScope.token,
        int_error_description: 'INIT_3DS_UNKNOW_ERROR'
      });
      callback(_constants.STATUS_API_ERROR, err);
    },
    contingencies: {
      DEFAULT: function DEFAULT(contingency) {
        _logger.$logger.warn('INIT_3DS_UKNOWN_CONTIGENCY', {
          reason: 'init 3ds unknown contingency',
          error: contingency
        });
        _logger.$logger.info('threeds_v2', {
          context_id: _angular.$rootScope.token,
          int_error_description: 'INIT_3DS_ERROR'
        });
        callback(_constants.STATUS_API_ERROR, contingency);
      }
    }
  };

  // hide the loading spinner
  request.silent = true;
  if (integrationType === _constants.ADD_CARD_INTEGRATION) {
    var cardConfirmationModel = new _index2.$CardConfirmationModel({
      id: fundingId
    });
    delete request.data.fundingId;
    return cardConfirmationModel.save(request);
  } else {
    return _index3.$switch3DSLookUpModel.instance().save(request);
  }
};
var completeThreeds = function completeThreeds(integrationType, fundingId, request) {
  // hide the loading spinner
  request.silent = true;
  _logger.$logger.info("3DS_TRIGGER_AUTHENTICATE_CALL_" + integrationType + "_INTEGRATION");
  if (integrationType === _constants.ADD_CARD_INTEGRATION) {
    var cardConfirmationModel = new _index2.$CardConfirmationModel({
      id: fundingId
    });
    return cardConfirmationModel.action('update', request);
  } else {
    return _index3.$switch3DSAuthenticateModel.instance().save(request);
  }
};
var authenticate3DS = exports.authenticate3DS = function authenticate3DS(intType, request, onComplete) {
  var fundingId = request.initThreedsData && request.initThreedsData.fundingId;
  return completeThreeds(intType, fundingId, {
    data: request,
    success: function success(response) {
      var status = _constants.RESPONSE_STATUS_MAPPER[response.status || response.threeDSStatus];
      var onCompleteData = {
        threeDSTransactionId: response.threeDSTransactionId
      };
      _logger.$logger.info('3DS_AUTHENTICATE_SUCCESS');
      if (status === 'FAILED') {
        _logger.$logger.info('threeds_v2', {
          context_id: _angular.$rootScope.token,
          int_error_description: 'AUTHENTICATE_3DS_STATUS_DECLINE'
        });
      }
      // Send the status and response data with threeDSTransactionId as separate params, Similar to init api calls
      // what are all the possible status's retuned by Switch?
      // can we assume status is success when status is decline?
      onComplete(status === 'FAILED' ? _constants.STATUS_DECLINE : status, onCompleteData);
    },
    error: function error(err) {
      _logger.$logger.info('3DS_AUTHENTICATE_ERROR', err);
      _logger.$logger.info('threeds_v2', {
        context_id: _angular.$rootScope.token,
        int_error_description: 'AUTHENTICATE_3DS_ERROR'
      });
      onComplete(_constants.STATUS_API_ERROR);
    },
    contingencies: {
      DEFAULT: function DEFAULT(contingency) {
        _logger.$logger.info('threeds_addcard_update_confirmation_contingency', contingency);
        _logger.$logger.info('threeds_v2', {
          context_id: _angular.$rootScope.token,
          int_error_description: 'AUTHENTICATE_3DS_ERROR'
        });
        onComplete(_constants.STATUS_API_ERROR);
      }
    }
  });
};
_angular.$rootScope;
_index.$ThreeDSJWTModel;
_index2.$CardConfirmationModel;
_index3.$switch3DSLookUpModel;
_index3.$switch3DSAuthenticateModel;
_logger.$logger;
_constants.RESPONSE_STATUS_MAPPER;
_constants.ADD_CARD_INTEGRATION;
_constants.STATUS_API_ERROR;
_constants.STATUS_SUCCESS;
_constants.STATUS_DECLINE;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/constants.js":
/***/ (function(module, exports) {



exports.__esModule = true;
exports.WINDOW_SIZE = exports.TRANSACTION_INTEGRATION = exports.STATUS_SUCCESS = exports.STATUS_DECLINE = exports.STATUS_API_ERROR = exports.RESPONSE_STATUS_MAPPER = exports.INIT_3DS_RESPONSE_STATUS = exports.CARD_TYPE_TO_NETWORK_LOGO = exports.ADD_CARD_INTEGRATION = void 0;
var ADD_CARD_INTEGRATION = exports.ADD_CARD_INTEGRATION = 'ADD_CARD';
var TRANSACTION_INTEGRATION = exports.TRANSACTION_INTEGRATION = 'TRANSACTION';
var INIT_3DS_RESPONSE_STATUS = exports.INIT_3DS_RESPONSE_STATUS = ['FAILED', 'SUCCESS', 'CHALLENGE_REQUIRED', 'DECLINED'];
var RESPONSE_STATUS_MAPPER = exports.RESPONSE_STATUS_MAPPER = {
  CHALLENGE_REQUIRED: 'STEPUP',
  FAILED: 'FAILED',
  SUCCESS: 'SUCCESS',
  DECLINED: 'FAILED',
  STEPUP: 'STEPUP'
};
var STATUS_SUCCESS = exports.STATUS_SUCCESS = 'SUCCESS';
// API errors like 500, api not found etc.
var STATUS_API_ERROR = exports.STATUS_API_ERROR = 'FAILURE';
// API responds with 200 but the status is set to FAILURE in response
var STATUS_DECLINE = exports.STATUS_DECLINE = 'DECLINE';
var CARD_TYPE_TO_NETWORK_LOGO = exports.CARD_TYPE_TO_NETWORK_LOGO = {
  AMEX: 'https://pics.paypal.com/00/p/NTk0ZGE4MTUtMzk5Ni00OTQ3LTlkMjctNjY5ZWY3MTBlYTEz/image_',
  VISA: 'https://pics.paypal.com/00/p/NmE4M2FmNWItODBlYi00MWIwLTgxODEtZDU3ZjAzZDI1NmJm/image_',
  MASTERCARD: 'https://pics.paypal.com/00/p/OGIxNWYzYzktMjEyMC00ZDBkLWE0YWUtOWQyMTRjNTM5ZTE2/image_'
};
var getWindowSizeMapping = function getWindowSizeMapping() {
  var returnObj = {};
  returnObj[ADD_CARD_INTEGRATION] = {
    MOBILE: '250X400',
    COMPUTER: '500X600',
    TABLET: '500X600',
    UNKNOWN: '500X600'
  };
  returnObj[TRANSACTION_INTEGRATION] = {
    MOBILE: '_250_x_400',
    COMPUTER: '_500_x_600',
    TABLET: '_500_x_600',
    UNKNOWN: '_500_x_600'
  };
  return returnObj;
};
var WINDOW_SIZE = exports.WINDOW_SIZE = getWindowSizeMapping();

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
__webpack_require__("../node_modules/xo-wallet-components/src/three-ds/styles.less");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/three-ds/template.html"));
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/utils.js");
var _outputMapper = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/outputMapper.js");
var _inputMapper = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/inputMapper.js");
var _apis = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/apis.js");
var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");
__webpack_require__("../node_modules/xo-wallet-components/src/three-ds-ddc/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoThreeDs', {
  tag: 'xo-three-ds',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    referenceId: {
      type: 'var',
      required: true
    },
    jwtInfo: {
      type: 'var',
      required: true
    },
    networkLogo: {
      type: 'var',
      required: true
    },
    cardBin: {
      type: 'var',
      required: true
    },
    ddcUrl: {
      type: 'var',
      required: true
    },
    // Default value is zero
    networkLogoSizeId: {
      type: 'var',
      required: false
    },
    integrationType: {
      type: 'var',
      required: false
    },
    initThreedsData: {
      type: 'var',
      required: false
    },
    onComplete: {
      type: 'var',
      required: false
    },
    cardBrand: {
      type: 'var',
      required: false
    },
    authenticationProvider: {
      type: 'var',
      required: false
    },
    cardBrandProcessed: {
      type: 'var',
      required: false
    }
  },
  lifecycle: {
    enter: function enter() {
      var _this = this;
      this.locale = _squid.$locale;
      this.networkLogoSizeId = this.networkLogoSizeId || 0;
      this.challengeOn = false;
      this.spinnerMessageKey = (0, _utils.getLoadingSpinnerMessageKey)();
      this.networkLogo = this.networkLogo || {};

      // networkLogo information is available even before this
      // this directive render is triggered, so lets get it ready in enter fn
      var imageExtension = (this.networkLogo.original_mime_type || 'image/png').split('/')[1];

      // If network logo is missing in api response then load it from static urls
      if (!this.networkLogo.base_cdn_link_path) {
        _logger.$logger.info('3DS_NETWORK_LOGO_MISSING_IN_CONTINGENCY_DATA', {
          cardBrand: this.cardBrand
        });
        this.networkLogo.base_cdn_link_path = _constants.CARD_TYPE_TO_NETWORK_LOGO[this.cardBrand] || '';
      }
      _logger.$logger.info('3DS_NETWORK_LOGO_DISPLAY_PARAMS', {
        baseCdnLinkPath: this.networkLogo.base_cdn_link_path,
        imageExtension: imageExtension,
        networkLogoSizeId: this.networkLogoSizeId
      });
      this.networkLogoBackgroundStyle = {
        'background-image': "url(\"" + this.networkLogo.base_cdn_link_path + this.networkLogoSizeId + "." + imageExtension + "\")"
      };
      this.showNetworkLogo = !!this.networkLogo.base_cdn_link_path;

      // Spinner messages
      var index = 0;
      var loadMessages = function loadMessages() {
        // keep the index to last message 'threeDS.preLoadCaution' so that after
        // cardinal iframe is hidden, we show a generic message to user
        if (index > 2) {
          index = 2;
          _angular.$interval.cancel(_this.loaderInterval);
        }
        _this.spinnerMessageKey = (0, _utils.getLoadingSpinnerMessageKey)(index);
        index++;
      };

      // loading spinner message changes every 3 seconds and then sticks to the last message
      this.loaderInterval = (0, _angular.$interval)(function () {
        loadMessages(index);
      }, 3000);

      // Setup a callback function on window object
      // This fn is called when cardinal returns to our app after successful OTP validation
      // cardinalToken is the ecToken we have in the url
      _angular.$window.completeThreedsFrame = function (cardinalResponse) {
        var cardinalTransactionId;

        // cardinalResponse.MD is also available which nothing but EC/WPS token
        cardinalTransactionId = cardinalResponse.TransactionId;
        _logger.$logger.info('threeds_v2', {
          from: '3DS_CHALLENGE',
          to: '3DS_CHALLENGE_END',
          challenge_end_time: Date.now(),
          context_id: _angular.$rootScope.token,
          '3ds_ref_id': _this.referenceId,
          '3ds_authenticate_id': cardinalTransactionId
        });
        // call onComplete with failure status if transactionId is missing in
        // cardinal response before/after stepup iframe is shown to user
        // NOTE: if invalid data is passed to cardinal iframe, then cardinal
        // calls returnUrl without showing the OTP screen
        if (!cardinalTransactionId) {
          _this.challengeOn = false;
          _this.onComplete(_constants.STATUS_DECLINE);
          // no need to call authenticate in case of failure
          return;
        }
        _this.challengeOn = false;

        // FI Request
        var fiReq = {
          token: _angular.$rootScope.token,
          referenceId: _this.referenceId,
          initThreedsData: _this.initThreedsData,
          initThreedsResponse: _this.initThreedsResponse,
          transactionId: cardinalTransactionId,
          confirmationId: _this.initThreedsResponse.confirmationId,
          confirmationStatus: 'CONFIRMED',
          confirmationMethod: _this.initThreedsData.confirmationMethod,
          cvv: _this.initThreedsData.cvv
        };
        // Switch Request
        var switchReq = {
          threeDsServerTransactionId: cardinalTransactionId,
          authenticatePayload: _this.lookUpPayload,
          amount: _this.amount,
          paymentAuthenticationRequest: _this.initThreedsResponse.payload
        };
        var request = _this.integrationType === _constants.ADD_CARD_INTEGRATION ? fiReq : switchReq;
        (0, _apis.authenticate3DS)(_this.integrationType, request, _this.onComplete);
      };

      // watch for id "threedsIframeForm" to be present in dom to trigger
      // cardinal iframe display
      this.$watch(function () {
        return $('#threedsIframeForm').length;
      }, function (newVal) {
        if (_this.challengeOn && newVal === 1) {
          $('#threedsIframeForm').submit();
        }
      });
    },
    populate: function populate() {
      var _this2 = this;
      // Show challenge iframe
      this.showChallengeIframe = function (stepupUrl, stepupJwt) {
        // set all variables required for challenge iframe
        _this2.stepupUrl = stepupUrl;
        _this2.stepupJwt = stepupJwt;

        // render challenge page
        _this2.showNetworkLogo = false;
        _this2.challengeOn = true;
      };
      return (0, _apis.getJwt)({
        referenceId: this.referenceId,
        cardBin: this.cardBin,
        jwtInfo: this.jwtInfo,
        authenticationProvider: this.authenticationProvider,
        cardType: this.cardBrandProcessed
      }).then(function (result) {
        _logger.$logger.info('threeds_v2', {
          from: '3DS_DDC',
          to: '3DS_DDC_START',
          ddc_start_time: Date.now(),
          context_id: _angular.$rootScope.token,
          '3ds_ref_id': _this2.referenceId
        });

        // set jwt and triggerDDC before showing the networkLogo modal window
        _this2.jwt = result;
        _this2.triggerDDC = true;
      })["catch"](function (err) {
        _logger.$logger.warn('3DS_GET_JWT_ERROR', {
          message: err.message,
          stack: err.stack
        });
        _this2.actions.ddcDoneCallback();
      });
    }
  },
  actions: {
    ddcDoneCallback: function ddcDoneCallback() {
      var request = (0, _inputMapper.get3DSLooksRequest)(this.integrationType, this.initThreedsData);
      // Need this variable to send in switch authenticate call

      this.lookUpPayload = request.lookUpPayload;
      this.amount = request.amount;
      _logger.$logger.info('threeds_v2', {
        from: '3DS_LOOKUP',
        to: '3DS_LOOKUP_START',
        lookup_start_time: Date.now(),
        context_id: _angular.$rootScope.token,
        '3ds_ref_id': this.referenceId
      });

      // upon completion, initThreedsCallback is called
      (0, _apis.initThreeds)(this.integrationType, this.initThreedsData.fundingId, request, this.actions.initThreedsCallback);
    },
    initThreedsCallback: function initThreedsCallback(status, response) {
      var _this3 = this;
      if (status === _constants.STATUS_API_ERROR) {
        _logger.$logger.info('3DS_INIT_FAILED_CALLING_ONCOMPLETE_CALLBACK');
        this.onComplete(_constants.STATUS_API_ERROR);
        return;
      }
      this.initThreedsResponse = (0, _outputMapper.initThreedsResponseMapper)(response, this.integrationType);
      // load the iframe when stepUpUrl and status is STEPUP
      if (this.initThreedsResponse.status === 'STEPUP' && this.initThreedsResponse.stepUpUrl) {
        var jwtreq = (0, _inputMapper.challengeJwtInputMapper)(this.referenceId, this.jwtInfo, this.initThreedsResponse);
        var stepUpUrl = this.initThreedsResponse.stepUpUrl;
        (0, _apis.getJwt)(jwtreq).then(function (jwtResponse) {
          _logger.$logger.info('threeds_v2', {
            from: '3DS_CHALLENGE',
            to: '3DS_CHALLENGE_START',
            challenge_start_time: Date.now(),
            context_id: _angular.$rootScope.token,
            '3ds_ref_id': _this3.referenceId
          });
          _this3.showChallengeIframe(stepUpUrl, jwtResponse);
        })["catch"](function (err) {
          // todo: do we need to decline for getJwt call?
          _logger.$logger.warn('GET_JWT_STEPUP_UNKNOWN_ERROR', {
            reason: 'get jwt failed before loading stepupurl',
            error: err
          });
          _this3.onComplete(_constants.STATUS_API_ERROR);
        });
      } else if (this.initThreedsResponse.status === 'SUCCESS') {
        _logger.$logger.info('INIT_3DS_STATUS_SUCCESS_NO_ACS_URL');
        var threedsResponse = {
          threeDSTransactionId: this.initThreedsResponse.threeDSTransactionId
        };
        this.onComplete(_constants.STATUS_SUCCESS, threedsResponse);
      } else if (this.initThreedsResponse.status === 'FAILED') {
        _logger.$logger.info('INIT_3DS_STATUS_FAILED');
        this.onComplete(_constants.STATUS_DECLINE);
      } else {
        // all other cases
        delete response.cavv; // do not log cavv
        _logger.$logger.info('3DS_INIT_FAILED_CALLING_ONCOMPLETE_CALLBACK', {
          response: response
        });
        this.onComplete(_constants.STATUS_API_ERROR);
      }
    },
    trustSrc: function trustSrc(url) {
      return _angular.$sce.trustAsResourceUrl(url);
    }
  }
});
_angular.$sce;
_angular.$window;
_angular.$interval;
_angular.$rootScope;
_squid.$Component;
_squid.$locale;
_logger.$logger;
_utils.getLoadingSpinnerMessageKey;
_outputMapper.initThreedsResponseMapper;
_inputMapper.get3DSLooksRequest;
_inputMapper.challengeJwtInputMapper;
_apis.getJwt;
_apis.initThreeds;
_apis.authenticate3DS;
_constants.ADD_CARD_INTEGRATION;
_constants.CARD_TYPE_TO_NETWORK_LOGO;
_constants.STATUS_API_ERROR;
_constants.STATUS_SUCCESS;
_constants.STATUS_DECLINE;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/inputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.get3DSLooksRequest = exports.challengeJwtInputMapper = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _utils = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/utils.js");
var get3DSLooksRequest = exports.get3DSLooksRequest = function get3DSLooksRequest(integrationType, payLoad) {
  if (integrationType === 'ADD_CARD') {
    var request = Object.assign({}, payLoad);
    delete request.fundingId;
    request.senderContext = (0, _utils.getSenderContext)();
    return request;
  }
  var browserInfo = (0, _utils.getBrowserDetails)(integrationType);
  var threeDSContingencySource = payLoad.threeDSContingencySource,
    threeDSContingencyReason = payLoad.threeDSContingencyReason,
    merchantCategoryCode = payLoad.merchant_category_code;
  var billingAddress = Object.assign({}, payLoad.billing_address);
  billingAddress.country = payLoad.billing_address.country_code;
  billingAddress.postalCode = payLoad.billing_address.postal_code;

  // xobuyernodeserv doesn't like these variables. since schema doesnt support them.
  delete billingAddress.country_code;
  delete billingAddress.postal_code;
  var lookUpPayload = {
    threeDSReferenceId: payLoad.referenceId,
    flowId: 'HERMES',
    billingAddress: billingAddress,
    encryptedCardNumber: payLoad.number_encrypted,
    creditCardId: payLoad.creditCardId,
    cardUsage: payLoad.card_product_class,
    expirationMonth: payLoad.expire_month,
    expirationYear: payLoad.expire_year,
    cardTransactionCharacteristics: 'PRE_AUTH',
    threeDSContingencySource: threeDSContingencySource,
    threeDSContingencyReason: threeDSContingencyReason,
    merchantCategoryCode: merchantCategoryCode
  };
  return {
    lookUpPayload: lookUpPayload,
    amount: payLoad.amount,
    browserInfo: browserInfo,
    productDetails: payLoad.productDetails
  };
};
var challengeJwtInputMapper = exports.challengeJwtInputMapper = function challengeJwtInputMapper(referenceId, jwtInfo, initThreedsResponse) {
  return {
    jwtInfo: jwtInfo,
    referenceId: referenceId,
    returnUrl: _angular.$window.location.origin + _squid.$config.urls.baseUrl + '/processThreedsConfirmation',
    redirectUrl: initThreedsResponse.redirectUrl,
    /**
     * for switch api call  we need to read the processor trace number and to get used in challenge jwt
     * for FI api we need to use transaction id, but transaction id is returned from both the apis
     * so look for processor trace number in response , if exists use that  if not go for transaction id
     * so that it will not break FI api call and switch api is also happy.
     */
    transactionId: initThreedsResponse.threeDsProcessorTraceNumber || initThreedsResponse.threeDSTransactionId,
    paymentAuthenticationRequest: initThreedsResponse.payload,
    authenticationProvider: initThreedsResponse.authenticationProvider
  };
};
_squid.$config;
_angular.$window;
_utils.getSenderContext;
_utils.getBrowserDetails;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/outputMapper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.initThreedsResponseMapper = void 0;
var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");
var initThreedsResponseMapper = exports.initThreedsResponseMapper = function initThreedsResponseMapper(response, integrationType) {
  // FI response mapper
  if (integrationType === _constants.ADD_CARD_INTEGRATION) {
    // possible response.status values - STEPUP FAILED SUCCESS
    return {
      status: _constants.RESPONSE_STATUS_MAPPER[response.status],
      redirectUrl: response.redirectUrl && response.redirectUrl.href,
      // acs is redirect url - which needs to be in jwt payload
      stepUpUrl: response.stepUpUrl && response.stepUpUrl.href,
      // redirect is step up which is used for loading iframe
      threeDSTransactionId: response.transactionId,
      payload: response.payload,
      confirmationId: response.confirmationId,
      authenticationProvider: response.authenticationProvider
    };
  }

  // switch response mapper
  if (_constants.INIT_3DS_RESPONSE_STATUS.indexOf(response.threeDSStatus) > -1) {
    return {
      status: _constants.RESPONSE_STATUS_MAPPER[response.threeDSStatus],
      redirectUrl: response.acsURL && response.acsURL.href,
      // acs is redirect url - which needs to be in jwt payload
      stepUpUrl: response.redirectURL && response.redirectURL.href,
      // redirect is step up which is used for loading iframe
      threeDSTransactionId: response.transactionId,
      payload: response.paymentAuthenticationRequest,
      confirmationId: response.threeDsServerTransactionId,
      threeDsProcessorTraceNumber: response.threeDsProcessorTraceNumber,
      authenticationProvider: response.authenticationProvider
    };
  }
};
_constants.ADD_CARD_INTEGRATION;
_constants.INIT_3DS_RESPONSE_STATUS;
_constants.RESPONSE_STATUS_MAPPER;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/styles.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/template.html":
/***/ (function(module, exports) {

module.exports = "<div id=\"threeDSContainer\" content>\n    <div class=\"threeDSModalContainer\" id=\"iframeContainer\">\n        <div class=\"logo\"></div>\n        <div ng-class=\"{ 'showNetworkLogo': showNetworkLogo }\" ng-if=\"!challengeOn\">\n            <div class=\"staticSpinner\">\n                <div class=\"spinWrap\">\n                    <p class=\"spinnerImage\"></p>\n                    <p class=\"loader\"></p>\n                </div>\n                <p class=\"loadingMessage\">\n                    <span  ng-bind-html=\"htmlContent(spinnerMessageKey)\"></span>...\n                </p>\n            </div>\n            <div class=\"networkLogo\">\n                <span class=\"{{'sizeId_' + networkLogoSizeId}}\" ng-style=\"networkLogoBackgroundStyle\"></span>\n            </div>\n        </div>\n        <div class=\"cardinalIframeContainer\" ng-if=\"challengeOn\">\n            <h3 class=\"infoHeader\" ng-bind-html=\"htmlContent('threeDS.iFrameTitle')\"></h3>\n            <!-- this form uses iframe to post data because of target attribute -->\n            <form id=\"threedsIframeForm\" name=\"threedsIframeForm\" action=\"{{actions.trustSrc(stepupUrl)}}\" target=\"threedsIframeV2\" method=\"post\">\n                <input type=\"hidden\" name=\"JWT\" value=\"{{stepupJwt}}\" />\n                <input type=\"hidden\" name=\"MD\" value=\"{{token}}\" />\n            </form>\n            <iframe id=\"threedsIframeV2\" name=\"threedsIframeV2\" frameborder=\"0\" sandbox=\"allow-forms allow-pointer-lock allow-scripts allow-same-origin\"></iframe>\n        </div>\n    </div>\n    <xo-three-ds-ddc\n        ng-if=\"triggerDDC\"\n        jwt=\"jwt\"\n        ddc-url=\"ddcUrl\"\n        done-callback=\"actions.ddcDoneCallback\">\n    </xo-three-ds-ddc>\n</div>\n"

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/three-ds/utils.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.getSenderContext = exports.getLoadingSpinnerMessageKey = exports.getBrowserDetails = void 0;
var _index = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _constants = __webpack_require__("../node_modules/xo-wallet-components/src/three-ds/constants.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var getPaymentMode = function getPaymentMode(capabilities) {
  var mode = 'UNKNOWN';
  if (capabilities.isDesktop) {
    mode = 'COMPUTER';
  } else if (capabilities.isTablet) {
    mode = 'TABLET';
  } else if (capabilities.isMobile) {
    mode = 'MOBILE';
  }
  return mode;
};
var getBrowserDetails = exports.getBrowserDetails = function getBrowserDetails(integrationType) {
  if (integrationType === void 0) {
    integrationType = _constants.ADD_CARD_INTEGRATION;
  }
  var paymentMode = getPaymentMode(_index.$DeviceInfo.getCapabilities());
  var windowNavigator = window.navigator;
  var windowSize;

  // TODO: revisit this code once cardinal fix their code to make sure
  // the iframe content is responsive
  // Mobile - for all mobile devices hardcode size to smallest one
  // Desktop - hardcode size to 500x600 as our modal window is 560x600
  // NOTE: with cardinal fix, mobile will be FULL_PAGE and
  //       other devices will be 500x600
  windowSize = _constants.WINDOW_SIZE[integrationType] && _constants.WINDOW_SIZE[integrationType][paymentMode];
  _logger.$logger.info("3DS_V2_WINDOW_SIZE_" + windowSize);
  return {
    windowSize: windowSize || 'FULL_PAGE',
    javaEnabled: windowNavigator && windowNavigator.javaEnabled(),
    language: windowNavigator && windowNavigator.language && typeof windowNavigator.language === 'string' && windowNavigator.language.split('-')[0],
    colorDepth: window.screen && window.screen.colorDepth,
    screenHeight: window.innerHeight,
    screenWidth: window.innerWidth,
    timeZoneOffset: new Date().getTimezoneOffset()
  };
};
var getSenderContext = exports.getSenderContext = function getSenderContext() {
  var senderContext = {
    browserDetails: getBrowserDetails(),
    paymentMode: getPaymentMode(_index.$DeviceInfo.getCapabilities()),
    deviceChannel: 'BROWSER'
  };
  return senderContext;
};
var getLoadingSpinnerMessageKey = exports.getLoadingSpinnerMessageKey = function getLoadingSpinnerMessageKey(index) {
  var messageKeys = ['threeDS.preLoadContactIssuer', 'threeDS.preLoadWaitMessage', 'threeDS.preLoadCaution'];

  // if index === 0 then the default return statement
  // returns messageKeys[0]
  if (index && index > 0 && index < messageKeys.length) {
    return messageKeys[index];
  }
  return messageKeys[0];
};
_index.$DeviceInfo;
_constants.ADD_CARD_INTEGRATION;
_constants.WINDOW_SIZE;
_logger.$logger;

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/ul-iframe/directive.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {

exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("../node_modules/xo-wallet-components/src/ul-iframe/template.html"));
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$xoUlIframe', {
  tag: 'xo-ul-iframe',
  template: _template["default"],
  props: {
    token: {
      type: 'var',
      required: false
    },
    onComplete: {
      type: 'var',
      required: false
    },
    mkey: {
      type: 'var',
      required: true
    }
  },
  lifecycle: {
    enter: function enter() {
      this.locale = _squid.$locale;
    },
    populate: function populate() {
      var scope = this;
      var timeoutULConfig = _squid.$config.timeoutUL || {
        DEFAULT: 10000
      };
      var lightBoxTimeout = timeoutULConfig[_squid.$locale.country] || timeoutULConfig.DEFAULT;
      var addEvent = function addEvent(element, event, callback) {
        if (!element || !event || !callback) {
          return;
        }
        if (element.addEventListener) {
          element.addEventListener(event, callback, false);
        } else if (element.attachEvent) {
          element.attachEvent("on" + event, callback);
        }
      };
      var postMessageHandler = function postMessageHandler(event) {
        var message;

        // Parse the message into JSON
        if (event && event.data) {
          try {
            message = JSON.parse(event.data);
          } catch (err) {
            // As this PostMessage is on Window which is pretty common so window will
            // keep getting post messages even those are not from UL iframe,  So Just
            // ignoring those messages.
            return;
          }
        }
        if (!message) {
          return;
        }
        if (message.source === 'UL') {
          var data = message.data || {};
          var action = data.event;
          if (action === 'RENDER_COMPLETE') {
            _logger.$logger.info('checkout_fpti', {
              from: 'otp_challenge',
              to: 'process_otp_challenge'
            });
          } else if (['RENDER_FAILED', 'NOT_NOW', 'LOGIN_SUCCESS', 'LOGIN_FAILED'].includes(action)) {
            _logger.$logger.info('checkout_fpti', {
              from: 'otp_challenge',
              to: 'process_otp_challenge',
              user_action: action
            });
            scope.closeIframe(action);
          }
        }
      };
      var showULiFrameLightBox = function showULiFrameLightBox() {
        if (scope.showUlIframe) {
          var lightbox = angular.element(document.getElementById('light-box'));
          lightbox.addClass('open');
          scope.showUlIframe = false;
          _angular.$rootScope.$emit('loaded');
          $('#ULiFrame').off('load');
        }
      };
      var initUliFrame = function initUliFrame() {
        _logger.$logger.info('checkout_fpti', {
          from: 'otp_challenge',
          to: 'prepare_otp_challenge'
        });
        var unifiedLoginOTPUrl = _squid.$config.urls.unifiedLoginOTPUrl || '/signin/challenge/sms';
        scope.iFrameSrc = unifiedLoginOTPUrl + "?ctxId=" + scope.mkey;
        scope.showUlIframe = true;
        var $ULiFrame = $('#ULiFrame');
        $ULiFrame.on('load', showULiFrameLightBox);
        _angular.$rootScope.$emit('loading');
        $ULiFrame.attr('src', scope.iFrameSrc);
        (0, _angular.$timeout)(function () {
          showULiFrameLightBox();
        }, lightBoxTimeout);
      };
      scope.closeIframe = function (status) {
        var lightbox = angular.element(document.getElementById('light-box'));
        var lightboxMask = angular.element(document.getElementById('mask'));
        lightbox.removeClass('open');
        (0, _angular.$timeout)(function () {
          lightboxMask.remove();
          _angular.$window.removeEventListener('message', postMessageHandler, false);
          _logger.$logger.info('closing UL iframe', {
            user_action: status
          });
          scope.onComplete(status);
        }, 200);
      };
      addEvent(_angular.$window, 'message', postMessageHandler);
      initUliFrame();
    }
  }
});
_angular.$window;
_angular.$rootScope;
_angular.$timeout;
_squid.$Component;
_squid.$locale;
_squid.$config;
_logger.$logger;
module.exports = exports.default;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/jquery/dist/jquery.min.js")))

/***/ }),

/***/ "../node_modules/xo-wallet-components/src/ul-iframe/template.html":
/***/ (function(module, exports) {

module.exports = "<div content id=\"light-box-ul-iframe\">\n    <div content id=\"light-box\" class=\"light-box\" ng-class=\"{mobile: isDevice}\">\n        <div id=\"mask\" class=\"light-box mask\"></div>\n        <div class=\"light-box wrapper\">\n            <div class=\"light-box-container\">\n                <div class=\"aside\" id=\"lightBoxAcsWrapper\">\n                    <div id=\"paypalLogo\" class=\"logo miniLogo\"><span class=\"accessAid\">{{ content('base.payPal') }}</span></div>\n                    <iframe id=\"ULiFrame\" name=\"PPFrameRedirect\" src=\"\"\n                            sandbox=\"allow-same-origin allow-scripts allow-modals allow-popups allow-forms allow-top-navigation\"\n                            class=\"light-box-iframe\"></iframe>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n"

/***/ }),

/***/ "../node_modules/xo-webpack-config/polyfills.js":
/***/ (function(module, exports, __webpack_require__) {

// array
__webpack_require__("../node_modules/core-js/fn/array/find.js");
__webpack_require__("../node_modules/core-js/fn/array/includes.js");

// string
__webpack_require__("../node_modules/core-js/fn/string/includes.js");


// object
__webpack_require__("../node_modules/core-js/fn/object/entries.js");
__webpack_require__("../node_modules/core-js/fn/object/values.js");
__webpack_require__("../node_modules/core-js/fn/object/assign.js");




/***/ }),

/***/ "./css/app.less":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./js/app.js":
/***/ (function(module, exports, __webpack_require__) {



__webpack_require__("./css/app.less");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _route = __webpack_require__("./pages/xo-checkout/route.js");
var _route2 = __webpack_require__("./pages/xo-guest-upgrade/route.js");
var _middleware = __webpack_require__("./js/lib/middleware.js");
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
_logger.$logger.info('checkout_fpti', {
  from: 'billing',
  to: 'prepare_app_load'
});
_logger.$logger.info('app_bootstrap', {
  hash: window.location.hash
});
if (_index.$util.param('data')) {
  var guestUpgradeRoute = new _route2.$GuestUpgradeRoute();
  guestUpgradeRoute.bootstrap('guestupgrade', _middleware.$Middleware);
} else {
  var baseRoute = new _route.$BaseRoute();
  baseRoute.bootstrap('checkout.landing', _middleware.$Middleware);
}
window.bootstrap = true;
_logger.$logger;
_route.$BaseRoute;
_route2.$GuestUpgradeRoute;
_middleware.$Middleware;
_index.$util;

/***/ }),

/***/ "./js/bootstrap.js":
/***/ (function(module, exports, __webpack_require__) {



window.main = true;

// Angular 1.6.9 adds a `!` as a hash prefix to the url by default.
// This is different behavior than Angular 1.4.7 which didn't add
// a hash prefix. The code snippet below will prevent the hash prefix
// from being added so that after the Angular 1.6.9 upgrade the url
// hash will remain the same.
// Angular 1.4.7: http://.../xoonboarding?token=EC-9CC38595EA0236714#/checkout/signup
// Angular 1.6.9 with out setting the `hashPrefix` to an empty string:
//      http://.../xoonboarding?token=EC-9CC38595EA0236714#!/checkout/signup
angular.module('app').config(['$locationProvider', function ($locationProvider) {
  $locationProvider.hashPrefix('');
}]);
if (!window.prefetch) {
  angular.bootstrap(document.getElementById('angular_app_container'), ['app']);
  __webpack_require__("./js/app.js");
}

/***/ }),

/***/ "./js/lib/contingency.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$contingencyHandler = $contingencyHandler;
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function showGenericError(code) {
  return function (errCode) {
    errCode = code || errCode;
    // Encode error text
    errCode = errCode ? window.btoa(errCode) : errCode;
    _uiRouter.$state.go('checkout.genericError', {
      code: errCode
    });
  };
}

/**
 * Route with default parameters unless special handler implemented otherwise
 *
 * To satisfy url: '/pageAddCard/:country/:fiType' in the route definition.
 * {country: ..., fiType: ...} must be passed for ui.router..
 *
 */
function route(path, params) {
  return function () {
    _uiRouter.$state.go(path, params);
  };
}
var routeToAddCC = function routeToAddCC(msg, contingency) {
  var gamblingCauses = ['PAYER_FUNDING_INSTRUMENT_INELIGIBLE', 'PAYER_FINANCIAL_INSTRUMENT_OUT_OF_COUNTRY', 'PAYER_FINANCIAL_INSTRUMENT_UNDER_AGE'];
  var isGambling = gamblingCauses.indexOf(contingency.cause) > -1;
  var param = isGambling ? {
    gaming: '1'
  } : {};
  return route('checkout.pageAddCard.addCardFlow.addCard', param);
};
function forbidden(err) {
  throw new _squid.$Forbidden(err);
}
function fallback(product) {
  return function (err) {
    throw new _squid.$FallbackError({
      reason: err,
      product: product
    });
  };
}
function $contingencyHandler(contingency) {
  if (contingency instanceof _squid.$Contingency) {
    // Leave a footprint here. The subsequent state where log how it goes..
    _logger.$logger.warn('contingency_handler', contingency);
    return contingency.handle({
      // TODO : modify these routes
      // Route
      NEED_CREDIT_CARD: routeToAddCC,
      NEED_CONFIRMED_CARD: routeToAddCC,
      NEED_CREDIT_CARD_OR_BANK_ACCOUNT: routeToAddCC,
      EXPIRED_CREDIT_CARD: routeToAddCC,
      // Generic Error Pages
      CURRENCY_COMPLIANCE: showGenericError(),
      INVALID_RESOURCE_ID: showGenericError(),
      PAYMENT_ALREADY_DONE: showGenericError(),
      PAYEE_BLOCKED_TRANSACTION: showGenericError(),
      RESTRICTED_USER: showGenericError(),
      PAYMENT_DENIED: showGenericError(),
      PAYER_CANNOT_PAY: showGenericError(),
      PAYEE_ACCOUNT_RESTRICTED: showGenericError(),
      PAYER_COUNTRY_NOT_ALLOWED: showGenericError(),
      PAYER_COUNTRY_NOT_ALLOWED_DCF: showGenericError('XOON_PAYER_COUNTRY_NOT_ALLOWED_DCF'),
      PAYER_COUNTRY_NOT_ENABLED: showGenericError(),
      PAYER_LOGIN_COUNTRY_NOT_ALLOWED: showGenericError(),
      GAMING_FUNDING_SOURCE_VALIDATION_FAILED: showGenericError(),
      GUEST_CHECKOUT_NOT_ALLOWED: showGenericError(),
      EINVALIDCSRF_JWT_EXPIRED: showGenericError(),
      // Fallbacks
      TRANSACTION_REFUSED: fallback('ux'),
      VERIFY_USER_IDENTITY: fallback('ux'),
      SENDING_LIMIT_EXCEEDED: fallback('ux'),
      PAYER_INVALID_FOR_PAYMENT: fallback('ux'),
      PAYMENT_CANNOT_BE_INITIATED: fallback('ux'),
      PERMISSION_DENIED: fallback('ux'),
      NEGATIVE_BALANCE_TRANSACTION_REFUSED: fallback('ux'),
      INVALID_TOKEN: fallback('ux'),
      INVALID_FUNDING_OPTION: fallback('ux'),
      INTERNAL_SERVICE_ERROR: fallback('ux'),
      VALIDATION_ERROR: fallback('ux'),
      SHIPPING_ADDRESS_INVALID: fallback('ux'),
      RISK_DENIED: fallback('ux'),
      DOMESTIC_TRANSACTION_REQUIRED: fallback('ux'),
      INVALID_ARGUMENT: fallback('ux'),
      CREDIT_PAYMENT_NOT_ALLOWED: fallback('ux'),
      UNSUPPORTED_PAYEE_CURRENCY: fallback('ux'),
      PAYEE_ACCOUNT_LOCKED_OR_CLOSED: fallback('ux'),
      CANNOT_PAY_SELF: fallback('hermes'),
      // Residential Address Fallbacks
      RESIDENTIAL_ADDRESS_VALIDATION_ERROR: fallback('ux'),
      // Forbidden
      BUYER_NOT_SET: forbidden,
      // TODO: duplicate - PAYER_INVALID_FOR_PAYMENT: forbidden,
      // Default
      DEFAULT: function logUnhandledContingency() {
        _logger.$logger.warn("ui_unhandled_contingency_" + this.message);
        throw new _squid.$FallbackError({
          reason: 'unhandled_contingency',
          product: 'ux'
        });
      }
    });
  }
}
angular.value("$contingencyHandler", $contingencyHandler);
_uiRouter.$state;
_logger.$logger;
_squid.$Forbidden;
_squid.$FallbackError;
_squid.$Contingency;

/***/ }),

/***/ "./js/lib/error.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$apiErrorHandler = $apiErrorHandler;
exports.$exceptionHandler = $exceptionHandler;
exports.$forbiddenHandler = $forbiddenHandler;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _fallback = __webpack_require__("./js/lib/fallback.js");
var _contingency = __webpack_require__("./js/lib/contingency.js");
var ERROR_STATE;
var ERROR_PREVENTED;
function $apiErrorHandler(err) {
  if (err instanceof _squid.$ApiError) {
    _logger.$logger.error('api_error', {
      error: err.toString()
    });
    throw new _squid.$FallbackError({
      reason: 'api_error',
      product: 'ux'
    });

    // @TODO - wtf?
    return true; // eslint-disable-line no-unreachable
  }
}
function $forbiddenHandler(err) {
  if (err instanceof _squid.$Forbidden) {
    _logger.$logger.warn('forbidden_handler');
    _index.$AuthModel.instance().invalidate();
    throw new _squid.$FallbackError({
      reason: 'user_not_logged_in',
      product: 'ux'
    });
  }
}
var handlers = [{
  type: _squid.$FallbackError,
  handle: _fallback.$fallbackErrorHandler
}, {
  type: _squid.$Contingency,
  handle: _contingency.$contingencyHandler
}, {
  type: _squid.$Forbidden,
  handle: $forbiddenHandler
}];
function $exceptionHandler(err, cause) {
  if (ERROR_STATE) {
    if (ERROR_PREVENTED) {
      throw err;
    }
    return;
  }

  // non token based Guest Upgrade Flow
  if (_squid.$util.param('data')) {
    _logger.$logger.error('guest_upgrade_error', {
      error: err
    });
    _uiRouter.$state.go('guestupgrade.genericError', {
      code: 'GUEST_UPGRADE_ERROR'
    });
    return;
  }
  var handled = handlers.some(function (handler) {
    if (err instanceof handler.type) {
      handler.handle(err);
      return true;
    }
    return false;
  });
  if (handled) {
    return;
  } else if (!err["transient"]) {
    ERROR_STATE = err;
  }
  var errType = (err.constructor.name || 'error').toLowerCase();
  var errName = "ui_unhandled_" + errType;
  var errMsg = err.message || '';
  if (errMsg.indexOf('infdig') > -1) {
    errName = 'infinite_digest';
  } else if (errMsg.indexOf('inprog') > -1) {
    errName = 'digest_inprog';
  } else if (errMsg.indexOf('badparse') > -1) {
    errName = 'sanitize_badparse';
  } else if (errMsg.match(/^[\w_]+$/) && !(err instanceof _squid.$Error)) {
    errName = errMsg;
  }
  if (['ui_unhandled_error', 'ui_unhandled_typeerror'].indexOf(errName) > -1) {
    if (err.stack && err.stack.indexOf('framework') > -1 && err.stack.indexOf('main.js') === -1) {
      errName = 'ui_unhandled_framework_error';
    }
  }
  var errObj = {
    error: err.stack || err.toString(),
    message: errMsg,
    cause: cause && cause.toString(),
    state: _uiRouter.$state.current.name,
    url: _angular.$window.location.toString()
  };
  _logger.$logger.error(errName, errObj);

  // emit the error object for subscribers like xo-tracking
  var event = _angular.$rootScope.$emit('unhandled_error', {
    route: (_uiRouter.$state || {}).current,
    message: errObj.error,
    code: errObj.cause,
    currentRoute: _uiRouter.$state.current
  });
  if (event.defaultPrevented) {
    ERROR_PREVENTED = true;
    throw err;
  } else if (!err["transient"]) {
    return (0, _fallback.$fallbackErrorHandler)(new _squid.$FallbackError({
      reason: errName
    }));
  }
}
function constructEventName(toState, fromState) {
  var fromStateFormatted = fromState.name.replace(/\./g, '_') || 'start';
  var toStateFormatted = toState.name.replace(/\./g, '_') || 'end';
  return "state_change_" + fromStateFormatted + "_to_" + toStateFormatted;
}
var stateChangeError = _angular.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, err) {
  // Set prevent default to avoid angular UI router to keep looping back to same state
  event.preventDefault();
  $exceptionHandler(err, constructEventName(toState, fromState));
});
var windowError = _angular.$rootScope.$on('$windowError', function (event, details) {
  _logger.$logger.error('window_error', details, {
    debounceFactor: details.message,
    debounceInterval: 1000
  });
});
_angular.$rootScope.$on('$destroy', stateChangeError);
_angular.$rootScope.$on('$destroy', windowError);
angular.value("$apiErrorHandler", $apiErrorHandler);
angular.value("$forbiddenHandler", $forbiddenHandler);
angular.value("$exceptionHandlerLazy", $exceptionHandler);
_angular.$rootScope;
_angular.$window;
_uiRouter.$state;
_squid.$Forbidden;
_squid.$ApiError;
_squid.$FallbackError;
_squid.$util;
_squid.$Error;
_squid.$Contingency;
_index.$AuthModel;
_logger.$logger;
_fallback.$fallbackErrorHandler;
_contingency.$contingencyHandler;

/***/ }),

/***/ "./js/lib/fallback.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$fallbackErrorHandler = $fallbackErrorHandler;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
function goToUrl(url, wpsParams, xoAppData) {
  if (xoAppData.is_wps_flow()) {
    return _index.$ReturnToMerchant.postTo(url, wpsParams);
  }
  return _index.$ReturnToMerchant.goTo(url);
}

/**
 * This function contains an additional determination of fallback url in case of an UX fallback
 *
 * @param {object} checkoutAppDataModel
 * @param {string} fallbackUrl
 * @returns {string}
 */
function determineUrlForUxFallback(checkoutAppDataModel, fallbackUrl) {
  var experienceInitiator = checkoutAppDataModel.get('flags.payment_experience_initiator');

  // For UX fallback during a PPPlus transaction the fallback url
  // is merchants cancel_url with added parameter ppp_msg = 1
  if (experienceInitiator === 'PAYPAL_PLUS') {
    return _squid.$util.buildURL(checkoutAppDataModel.get('urls.cancel_url'), {
      ppp_msg: '1'
    });
  }
  return fallbackUrl;
}
function goToGenericError(code) {
  if (code === void 0) {
    code = 'DEFAULT';
  }
  _uiRouter.$state.go('checkout.genericError', {
    code: code
  });
  return true;
}
function $fallbackErrorHandler(err) {
  if (err === void 0) {
    err = {};
  }
  var _err = err,
    reason = _err.reason;
  var models = {};
  return (0, _squid.$populate)(models, {
    checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
    checkoutCart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token),
    checkoutInputData: _index2.$CheckoutInputDataModel.instance(_angular.$rootScope.token),
    payeeModel: _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
  }).then(function () {
    var checkoutAppData = models.checkoutAppData,
      checkoutCart = models.checkoutCart,
      checkoutInputData = models.checkoutInputData;
    if (checkoutCart.isWalletTokenization()) {
      return goToGenericError();
    }
    if (checkoutAppData.doec_on_approve() && _angular.$rootScope.paymentComplete) {
      // Do not fallback. UX has no context of hermes token and will result in duplicate payment
      _logger.$logger.info('wps_error_payment_already_done', {
        reason: reason
      });
      return goToGenericError('PAYMENT_ALREADY_DONE');
    }
    var _$config$fallbackWhit = _squid.$config.fallbackWhitelist,
      _$config$fallbackWhit2 = _$config$fallbackWhit === void 0 ? {} : _$config$fallbackWhit,
      _$config$fallbackWhit3 = _$config$fallbackWhit2.whitelist,
      whitelist = _$config$fallbackWhit3 === void 0 ? [] : _$config$fallbackWhit3;
    if (err instanceof _squid.$FallbackError) {
      var _err2 = err,
        _err2$product = _err2.product,
        product = _err2$product === void 0 ? 'ux' : _err2$product;
      var _err3 = err,
        entry_point = _err3.entry_point;
      if (checkoutInputData.requiresOAuth()) {
        // there is no fallback for flows that require oauth code return (ex:PROX Signup),
        // so we show a generic error page
        _logger.$logger.error('fallback_inhibited_for_oauth_return_flows', {
          reason: reason
        });
        return goToGenericError(reason);
      }
      if (product === 'ux' && _angular.$rootScope.partnerIntegration) {
        _logger.$logger.info('partner_integration_fallback_to_UX');
        _angular.$window.resizeTo(screen.availWidth, screen.availHeight);
      }

      // For checkout-order tokens symphony sets checkoutAppData.flags.disable_legacy_fallback flag to 'true'.
      // In such cases we disable fallback to UX and show the generic error page.
      if (checkoutAppData.get('flags.disable_legacy_fallback')) {
        _logger.$logger.error('fallback_inhibited_for_checkout_order_tokens', {
          reason: reason
        });
        return goToGenericError(reason);
      }
      _squid.$util.assert(reason, 'expected fallback reason');
      _logger.$logger.log(product ? 'info' : 'error', 'fallback', {
        reason: reason,
        product: product,
        entry_point: entry_point
      });
      var country = _squid.$locale.country;
      var paymentAction = checkoutCart.payment_action;
      _logger.$logger.info("fallback_reason_" + reason);
      if (checkoutAppData.is_wps_flow()) {
        _logger.$logger.log('info', 'wps_fallback', {
          token: _squid.$meta.token,
          reason: reason
        });
        _logger.$logger.info("wps_fallback_reason_" + reason, {
          reason: reason
        });
      }
      if (!_squid.$config.fallbackEnabled && !entry_point) {
        _logger.$logger.info('fallback_disabled_by_config');
        return goToGenericError();
      }

      /**
       * CONFIG BASED WHITELIST:
       * Determines if we should fallback or instead redirect to generic error page.
       * We go to generic error page if the reason is not in the whitelist
       * If the users' browser supports session storage they will be shown the retry link
       * in generic error page.
       */
      var fallbackNotWhitelisted = whitelist.indexOf(reason) === -1;

      // We can add countries to the config param to enable fallback to UX
      // If fallback reason not whitelisted
      if (fallbackNotWhitelisted) {
        _logger.$logger.info('fallback_reason_not_whitelisted', {
          reason: reason,
          product: product,
          country: country,
          paymentAction: paymentAction
        });

        // We're using sessionStorage for retry detection
        if (_squid.$util.sessionStorageEnabled()) {
          var RETRY_KEY = 'retry_page_shown';
          var RETRY_PAGE_LIMIT = 3; // Only show the retry page at most 3 times
          var timesSeen = Number(sessionStorage.getItem(RETRY_KEY));
          var destination = 'RETRY';

          // Reset if there's an invalid value for timesSeen for some reason
          if (!timesSeen || timesSeen < 0) {
            timesSeen = 0;
          }

          // Only try to go to retry page if we're within retry attempts
          if (timesSeen < RETRY_PAGE_LIMIT) {
            timesSeen++;
            sessionStorage.setItem(RETRY_KEY, timesSeen);
          } else {
            destination = 'DEFAULT';
          }
          _logger.$logger.info('checkout_fpti', {
            'enable_refresh_prompt': reason
          });
          return goToGenericError(destination);
        }
        return goToGenericError();
      }
      _logger.$logger.info('fallback_reason_whitelisted', {
        reason: reason,
        product: product,
        country: country,
        paymentAction: paymentAction
      });
      if (_squid.$config.deploy.isLocal() && !entry_point) {
        return _angular.$log.info('Fallback inhibited in local mode. Please refresh to re-enable error logging');
      }
      _angular.$rootScope.$emit('loading');
      var urlParams = {
        token: _squid.$meta.token,
        fallback: 1,
        landing: entry_point,
        useraction: _squid.$util.param('useraction')
      };
      if (_angular.$rootScope.partnerIntegration) {
        urlParams.incontext = '1';
        urlParams.nolegacy = '1';
      } else if (_angular.$rootScope.miniBrowser) {
        urlParams.incontext = '1';
      }
      var _checkoutAppData$flag = checkoutAppData.flags,
        appDataFlags = _checkoutAppData$flag === void 0 ? {} : _checkoutAppData$flag;
      var base = _squid.$config.urls.fallbackUrl[product];
      var wpsParams;
      if (checkoutAppData.is_wps_subscription_flow()) {
        base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
        wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
        wpsParams.cmd = wpsParams.hosted_button_id ? '_s-xclick' : '_xclick-subscriptions';
      } else if (checkoutAppData.isWpsAutobillingFlow()) {
        base = _squid.$config.urls.fallbackUrl['wpsSubscription'];
        wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
        wpsParams.cmd = wpsParams.hosted_button_id ? '_s-xclick' : '_xclick-auto-billing';
      } else if (checkoutAppData.is_wps_flow()) {
        base = appDataFlags.is_cart_upload_flow || appDataFlags.is_shopping_cart_flow ? _squid.$config.urls.fallbackUrl['cartUpload'] : _squid.$config.urls.fallbackUrl['buyNow'];
        wpsParams = _squid.$util.decodeAndParse(_squid.$meta.xclickParams);
      }
      if (appDataFlags.is_invoice_flow) {
        urlParams.id = checkoutAppData.invoice_id;
        base = _squid.$config.urls.fallbackUrl['invoice'];
      }
      var hostname = _squid.$meta.stage ? _squid.$meta.stage : _angular.$window.location.hostname;
      var url = _squid.$util.buildURL("https://" + hostname + base, urlParams);
      if (checkoutAppData.is_wps_flow() || appDataFlags.is_invoice_flow) {
        goToUrl(url, wpsParams, checkoutAppData);
        return true;
      }
      if (product === 'ux') {
        var uxUrl = determineUrlForUxFallback(checkoutAppData, url);

        // Otherwise we can make a decision based on whether we're in the minibrowser or not
        return checkoutAppData.action('updateFallbackAction', {
          data: {
            fallback_action: 'CA_FALLBACK_USER_ACTION_LOGIN_GUEST_TAB_SELECTION'
          },
          success: function success() {
            _index.$ReturnToMerchant.goTo(uxUrl);
            return true;
          },
          contingencies: {
            DEFAULT: function DEFAULT() {
              _index.$ReturnToMerchant.goTo(uxUrl);
              return true;
            }
          }
        })["catch"](function () {
          _index.$ReturnToMerchant.goTo(uxUrl);
          return true;
        });
      }

      // Safe to always return to Aries
      _squid.$util.redirect(url);
    }
    return goToGenericError();
  })["catch"](function (modelLoadErr) {
    _logger.$logger.info('fallback_model_load_error', {
      reason: modelLoadErr
    });
    return goToGenericError(modelLoadErr);
  });
}
angular.value("$fallbackErrorHandler", $fallbackErrorHandler);
_angular.$window;
_angular.$log;
_angular.$rootScope;
_uiRouter.$state;
_index.$ReturnToMerchant;
_squid.$FallbackError;
_squid.$config;
_squid.$meta;
_squid.$util;
_squid.$locale;
_squid.$populate;
_index2.$CheckoutInputDataModel;
_index3.$CheckoutAppDataModel;
_index3.$CheckoutCartModel;
_index3.$CheckoutPayeeModel;
_logger.$logger;

/***/ }),

/***/ "./js/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
var _contingency = __webpack_require__("./js/lib/contingency.js");
Object.keys(_contingency).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _contingency[key]) return;
  exports[key] = _contingency[key];
});
var _error = __webpack_require__("./js/lib/error.js");
Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _error[key]) return;
  exports[key] = _error[key];
});
var _fallback = __webpack_require__("./js/lib/fallback.js");
Object.keys(_fallback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fallback[key]) return;
  exports[key] = _fallback[key];
});
var _metaBuilder = __webpack_require__("./js/lib/metaBuilder.js");
Object.keys(_metaBuilder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _metaBuilder[key]) return;
  exports[key] = _metaBuilder[key];
});
var _middleware = __webpack_require__("./js/lib/middleware.js");
Object.keys(_middleware).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _middleware[key]) return;
  exports[key] = _middleware[key];
});
var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
Object.keys(_miniBrowser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _miniBrowser[key]) return;
  exports[key] = _miniBrowser[key];
});

/***/ }),

/***/ "./js/lib/integration.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$FLOWS = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
exports.$integration = _squid.$integration;
exports.$CONTEXT = _squid.$CONTEXT;
var _$DEFAULT, _$CONTEXT$FULLPAGE, _$integration$init;
var $FLOWS = exports.$FLOWS = {
  // Regular end-to-end checkout flow with one entry and one exit point
  CHECKOUT: 'CHECKOUT',
  // Partner flow [ TODO: FACTOR THIS OUT ]
  PARTNER: 'PARTNER',
  // Native checkout flow
  NATIVE_CHECKOUT: 'NATIVE_CHECKOUT'
};
_squid.$integration.init($FLOWS.CHECKOUT, (_$integration$init = {}, _$integration$init[_squid.$DEFAULT] = (_$DEFAULT = {
  REDIRECT_TOP: true,
  REDIRECT_QUERY_PARAM: false
}, _$DEFAULT[$FLOWS.PARTNER] = {
  REDIRECT_TOP: false,
  REDIRECT_QUERY_PARAM: true
}, _$DEFAULT), _$integration$init[_squid.$CONTEXT.FULLPAGE] = (_$CONTEXT$FULLPAGE = {}, _$CONTEXT$FULLPAGE[$FLOWS.NATIVE_CHECKOUT] = {
  REDIRECT_QUERY_PARAM: true
}, _$CONTEXT$FULLPAGE), _$integration$init[_squid.$CONTEXT.LIGHTBOX] = {
  REDIRECT_TOP: false
}, _$integration$init));
angular.value("$FLOWS", $FLOWS);
_squid.$integration;
_squid.$DEFAULT;
_squid.$CONTEXT;

/***/ }),

/***/ "./js/lib/metaBuilder.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$metaBuilder = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _model = __webpack_require__("../node_modules/xo-tracking/dist/model.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function buildMeta() {
  return {
    token: _angular.$rootScope.token || _squid.$config.token || _squid.$meta.token || _squid.$util.param('token'),
    cartId: _squid.$util.param('cart_id'),
    calc: _model.$CalDataModel.getCalCorrId(),
    csci: _model.$CalDataModel.getUUID(),
    locale: {
      country: _squid.$locale && _squid.$locale.country,
      language: _squid.$locale && _squid.$locale.lang
    },
    state: "ui_" + (_angular.$rootScope.currentState || 'checkout_init'),
    app_name: 'xoonboardingnodeweb'
  };
}
_squid.$Api.registerMetaBuilder(buildMeta);
var $metaBuilder = exports.$metaBuilder = {
  build: buildMeta
};
angular.value("$metaBuilder", $metaBuilder);
_angular.$rootScope;
_model.$CalDataModel;
_squid.$util;
_squid.$meta;
_squid.$Api;
_squid.$locale;
_squid.$config;

/***/ }),

/***/ "./js/lib/middleware.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$Middleware = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _miniBrowser = __webpack_require__("./js/lib/miniBrowser.js");
var _xoAPayUtils = __webpack_require__("../node_modules/xo-models/src/auth/lib/xoAPayUtils.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/onboard/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var noop = function noop() {
  return undefined;
};

// making sure query param locale is in the format en_<XX>.
var isLocaleQueryParamValid = function isLocaleQueryParamValid(locale, token) {
  var isString = typeof locale === 'string' || locale instanceof String;
  if (!locale || !isString) {
    return false;
  }
  locale = locale.replace('-', '_');
  var valid = locale.match(/^\w{2}_\w{2}$/) ? true : false;
  _logger.$logger.info("xoon_isLocaleQueryParamValid_" + valid, {
    token: token,
    locale: locale
  });
  return valid;
};

/* Purpose of this method:
// overriding the resolvers(ipCountry/ localeTestUrlParam/ etc) with US for
// those are resolved to INDIA(IN) via cart/appData/ query params so that
// $locale.retrieve() called from middleware resolveLocale() method will resolve it to
// US. This helps app retrieve the griffin meta data/ content for US and renders
// initial page in US as if it rendering originally in US for IN users.
//
// Reason for Overriding:
// Since xoon is the process of being deprecated, and according to CAL search it
// only has 500 starts a day. And ROI of building this experience on xoon is low.
// so as per the product/ dev recommendation, user landing page is defaulted to US.
// see the below linked confluence for decision/ agreements.
//
// Context:
// As a part of IN KYC, checkout now requires a PayPal account with KYC
// verification and thats achieved via tesla flow -> detroit flow. So
// guest checkout flows needs to redirect to tesla flows for all IN user.
//
// Tickets/ confluence:
// https://paypal.atlassian.net/browse/LR-9854 - for legal approvals and
// figma links.
// https://paypal.atlassian.net/wiki/spaces/Checkout/pages/829816964/Spike+-+India+KYC#Decisions%2F-Agreements
*/
var resolveParams = function resolveParams(cart, appData, token) {
  var localeTest = _squid.$util.param('locale.test');
  var billingCountryFromCart = cart && cart.get('payer_info.billing_address.country_code');
  var shippingCountryFromCart = cart && cart.get('purchase.shipping_address.country_code');
  var merchantCountryFromAppData = appData && appData.get('merchant.merchant_country');
  var merchantLocaleFromAppData = appData && appData.get('merchant.merchant_locale');
  var countryX = _squid.$util.param('country.x') || _squid.$meta.query && _squid.$meta.query['country.x'];
  var localeX = _squid.$util.param('locale.x') || _squid.$meta.query && _squid.$meta.query['locale.x'];
  return {
    ipCountry: _squid.$meta.ipcountry,
    localeTestUrlParam: isLocaleQueryParamValid(localeTest, token) && localeTest.split('_')[1] === 'IN' ? 'en_US' : localeTest,
    checkoutBillingCountry: billingCountryFromCart === 'IN' ? 'US' : billingCountryFromCart,
    checkoutShippingCountry: shippingCountryFromCart === 'IN' ? 'US' : shippingCountryFromCart,
    merchantCountry: merchantCountryFromAppData === 'IN' ? 'US' : merchantCountryFromAppData,
    checkoutSessionLocale: isLocaleQueryParamValid(merchantLocaleFromAppData, token) && merchantLocaleFromAppData.split('_')[1] === 'IN' ? 'en_US' : merchantLocaleFromAppData,
    countryParam: countryX === 'IN' ? 'US' : countryX,
    localeParam: isLocaleQueryParamValid(localeX, token) && localeX.split('_')[1] === 'IN' ? 'en_US' : localeX
  };
};
var $Middleware = exports.$Middleware = [function checkToken() {
  var urlToken = _squid.$util.param('token');
  var bodyToken = _squid.$meta.token;
  if (urlToken !== _squid.$meta.token) {
    _logger.$logger.error('token_mismatch', {
      server: _squid.$meta.token,
      client: urlToken
    });
  }
  if (!urlToken && !bodyToken && !_squid.$util.param('data')) {
    throw new Error('No token or data found in page url');
  }

  // first set regular token (EC transactions)
  _angular.$rootScope.token = bodyToken || urlToken;
  _angular.$window.root = _angular.$rootScope;
}, function resolveLocale() {
  var models = {};
  if (_angular.$rootScope.token) {
    return (0, _squid.$populate)(models, {
      appData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve({
        contingencies: {
          DEFAULT: noop
        }
      }),
      cart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token)
    })["finally"](function () {
      var localeParams = resolveParams(models.cart, models.appData, _angular.$rootScope.token);

      // We need to have finally here instead of then, as we always want
      // locale to be resolved no matter failure of getCart or getAppData call
      return _squid.$locale.retrieve({
        params: _extends({}, localeParams)
      });
    });
  } else if (_squid.$util.param('data')) {
    var options = {
      params: {
        data: _squid.$util.param('data')
      }
    };
    return (0, _squid.$populate)(models, {
      guestAccountData: _index3.$GuestUpgradeModel.instance().retrieve({
        options: options,
        contingencies: {
          MAYFLY_ERROR: noop,
          DEFAULT: noop
        }
      })
    }).then(function () {
      return _squid.$locale.retrieve({
        params: {
          ipCountry: _squid.$meta.ipcountry,
          localeTestUrlParam: _squid.$util.param('locale.test'),
          countryParam: models.guestAccountData.get('user.country')
        }
      });
    });
  }
},
/*
 * checkFlowType: this function checks the flow type and adds call info logs
 *
 * We moved this fn from checkToken to a separate middleware, as we found an issue
 * when checkoutAppData call fails
 *
 * ISSUE FIXED: when checkoutAppData call fails with INVALID_RESOURCE_ID,
 * we redirect user to generie error page, and error page was shown without any
 * content/text, as resolveLocale middleware was never executed due to error thrown
 * in checkToken middleware function (error thrown by checkoutAppData failure)
 */
function checkFlowType() {
  // wps tokens are not preceeded with 'EC-'
  var wpsPattern = /^[0-9A-Z]{17}$/;

  // now test for WPS, set flags as necessary and log.
  // make sure ebay transactions aren't counted
  var isEbay = _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn();

  // identify WPS vs checkout-order token
  if (!isEbay && wpsPattern.test(_angular.$rootScope.token)) {
    return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
      // For WPS tokens appData.is_wps_flow() will always return 'true'.
      var isWPS = appData.is_wps_flow();
      _logger.$logger.info("xoon_" + (isWPS ? 'wps' : 'xo_order') + "_flow", {
        token: _angular.$rootScope.token
      });
    });
  }
}, function logout() {
  if (!_squid.$config.clientSideLogout) {
    return;
  }
  return _index4.$AuthModel.instance().retrieve().then(function (auth) {
    if (auth.logged_in || auth.email) {
      return auth.action('logout');
    }
  });
},
/**
 * Redirect back to Hermes if Android user with PayPal available through Android pay who
 * landed on Xoon due to BASL. 2 checks need to be done to determine if user has PayPal
 * in Android pay wallet: 1. chrome version >=58 (this version support payment api)
 * 2. call canMakePayment api call to validate if PayPal is already available in Android pay
 */
function checkAPayBASLRedirect() {
  if (!_squid.$config.apayEnabled) {
    return;
  }
  // Check if browser supports PaymentRequest API.
  if (!_xoAPayUtils.$xoAPayUtils.isAPayAPISupported()) {
    return;
  }
  var models = {};
  return (0, _squid.$populate)(models, {
    cart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve()
  }).then(function () {
    // Do nothing for APay onboarding flow.
    if (models.cart.isWalletTokenization()) {
      return;
    }

    // Call PaymentRequest API to check if paypal as payment available
    return _xoAPayUtils.$xoAPayUtils.canMakeAPayPayment().then(function (result) {
      if (result) {
        return (0, _squid.$dispatch)('hermes', {
          token: _angular.$rootScope.token,
          hermesLoginRedirect: 'xoon',
          'locale.x': _squid.$locale.lang + "_" + _squid.$locale.country,
          'country.x': _squid.$locale.country
        });
      }
    });
  });
}, function xcomponent() {
  if (window.xprops && window.xprops.init) {
    return _angular.$q.all([_index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(), _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve()]).then(function (_ref) {
      var checkoutAppData = _ref[0],
        checkoutPayee = _ref[1];
      return window.xprops.init({
        paymentToken: _angular.$rootScope.token,
        merchantID: checkoutPayee.merchant.id,
        cancelUrl: checkoutAppData.urls.cancel_url
      });
    });
  }
}, function updateMerchantData() {
  if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
    return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
      return _index.$CheckoutClientDataModel.instance(_angular.$rootScope.token).retrieve().then(function (clientData) {
        var checkoutInputData = _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token);
        var identityData = clientData.merchantIdentityData();
        appData.merchant = {
          brand_name: identityData.brand_name,
          logo_url: identityData.logo_uri
        };
        appData.urls = {
          cancel_url: checkoutInputData.errorUrl('user_cancelled')
        };
      });
    });
  }
}, function checkJavaScriptInjection() {
  if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
    _logger.$logger.info('prox_signup_start', {
      cart_id: _angular.$rootScope.token
    });
    var redirectUri = _squid.$util.param('redirect_uri');
    if (redirectUri && redirectUri.indexOf('http') !== 0) {
      _logger.$logger.warn('XOON_FLOW_INVALID_REDIRECT_URI_JAVASCRIPT_INJECTION', {
        uri: redirectUri
      });
      return _angular.$q.reject(new _squid.$FallbackError({
        reason: 'invalidRedirectURI',
        product: 'ux'
      }));
    }
  }
}, function verifyRedirectURI() {
  if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
    var redirectUri = _squid.$util.param('redirect_uri');
    return _index.$CheckoutClientDataModel.instance(_angular.$rootScope.token).retrieve().then(function (clientData) {
      var isValidUri = clientData.validateRedirectUri(redirectUri) || {};
      if (!isValidUri.success) {
        _logger.$logger.warn('XOON_FLOW_INVALID_REDIRECT_URI', {
          uri: redirectUri
        });
        return _angular.$q.reject(new _squid.$FallbackError({
          reason: 'invalidRedirectURI',
          product: 'ux'
        }));
      }
    });
  }
},
// allow PROX to support country content separate from Hermes
function proxFallbackManager() {
  if (_index.$CheckoutInputDataModel.instance(_angular.$rootScope.token).isEbayTxn()) {
    (0, _squid.$featureCountries)('guestFallback').forEach(function (country, index) {
      _squid.$config.features[country].guestFallback = false;
    });
  }
}, function handleTagManager() {
  _angular.$window.dataLayer = {
    // Two letter country code of the current page's content
    contentCountry: _squid.$locale.country.toLowerCase(),
    // Two letter locale
    contentLanguage: _squid.$locale.lang.toLowerCase()
  };
}, function setupMiniBrowser() {
  if (_squid.$util.param('data')) {
    return _miniBrowser.$MiniBrowser.initialize(_squid.$util.param('cancel_url'));
  }
  return _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve().then(function (appData) {
    return _miniBrowser.$MiniBrowser.initialize(appData.urls.cancel_url);
  });
}, function logStart() {
  _logger.$logger.info('app_start_design', {
    is_directintegration: _miniBrowser.$MiniBrowser.isDirectIntegration ? 1 : 0,
    is_incontext: _miniBrowser.$MiniBrowser.isMiniBrowser || _miniBrowser.$MiniBrowser.isFrame ? 1 : 0
  });
}, function checkForSDK() {
  var isSDKintegration = window.name && window.name.indexOf('xcomponent__ppcheckout') === 0 || window.name.indexOf('zoid__ppcheckout') === 0 || _squid.$util.param('xcomponent') || _squid.$util.param('zoid');
  var sdkLoaded = window.paypal && window.xprops && window.paypal.Checkout && window.paypal.Checkout.isChild();
  if (isSDKintegration && !sdkLoaded) {
    throw new Error('Checkout loaded in an SDK integration, but no xprops found. Maybe the sdk script failed to load in the child window.');
  }
}];
angular.value("$Middleware", $Middleware);
_angular.$q;
_angular.$rootScope;
_angular.$window;
_logger.$logger;
_index.$CheckoutInputDataModel;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutCartModel;
_index2.$CheckoutPayeeModel;
_miniBrowser.$MiniBrowser;
_xoAPayUtils.$xoAPayUtils;
_index.$CheckoutClientDataModel;
_index3.$GuestUpgradeModel;
_index4.$AuthModel;
_squid.$FallbackError;
_squid.$config;
_squid.$meta;
_squid.$util;
_squid.$locale;
_squid.$populate;
_squid.$dispatch;
_squid.$featureCountries;

/***/ }),

/***/ "./js/lib/miniBrowser.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$MiniBrowser = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _index = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");
var _integration = __webpack_require__("./js/lib/integration.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var MiniBrowser = _squid.$Class.extend('MiniBrowser', {
  isMiniBrowser: false,
  partnerIntegration: false,
  isDirectIntegration: false,
  _isMiniBrowser: function _isMiniBrowser() {
    return window.name && window.name.indexOf('PPFrame') === 0 && _squid.$util.isPopup() || _squid.$util.param('incontext') === '1' || window.xchild && _squid.$util.isPopup();
  },
  _isFrame: function _isFrame() {
    return _squid.$util.isIFrame();
  },
  initialize: function initialize(cancel_url) {
    this.isMiniBrowser = _angular.$rootScope.miniBrowser = this._isMiniBrowser();
    this.isFrame = this._isFrame();
    this.partnerIntegration = _angular.$rootScope.partnerIntegration = _angular.$window.name === 'PPFrameRedirect' || _squid.$util.param('nolegacy') === '1';

    //  this.nativeIntegration is true, whenever the query param native_xo=1 when hermes was launched
    this.nativeIntegration = _squid.$util.param('native_xo') === '1';
    this.isDirectIntegration = this.isMiniBrowser || this.partnerIntegration || Boolean(_squid.$util.param('incontext')) || _angular.$window.location.pathname.indexOf('/checkoutnow') > -1;
    _integration.$integration.setFlow(_integration.$FLOWS.CHECKOUT);
    if (this.partnerIntegration) {
      _integration.$integration.setFlow(_integration.$FLOWS.PARTNER);
      _logger.$logger.info('partner_integration_flow');
    } else if (this.nativeIntegration && (0, _squid.$feature)('nativexoSupport')) {
      // we are setting the flow to be native checkout type
      // whenever the nativeIntegration flag is on
      // setting this flow will enable the redirect_uri query param
      // passed to hermes to override the merchant's redirect url
      // on cancel or redirect after a successful payment
      _integration.$integration.setFlow(_integration.$FLOWS.NATIVE_CHECKOUT);
      _logger.$logger.info('nativexo_integration_flow');
    }
    if (this.isMiniBrowser && !this.partnerIntegration) {
      var msg;
      try {
        msg = {
          cancelUrl: cancel_url,
          landingUrl: _angular.$window.location.href,
          secureWindowmsg: _squid.$locale.content.scripts.secureWindowmsg
        };
      } catch (error) {
        return _logger.$logger.error('minibrowser_msg_construction_failed', {
          error: error
        });
      }
      if (!_index.$ReturnToMerchant.postToMerchant(msg)) {
        _logger.$logger.error('minibrowser_post_failed');
      }
    }
  }
});
var $MiniBrowser = exports.$MiniBrowser = new MiniBrowser();
angular.value("$MiniBrowser", $MiniBrowser);
_angular.$rootScope;
_angular.$window;
_index.$ReturnToMerchant;
_integration.$integration;
_integration.$FLOWS;
_squid.$Class;
_squid.$feature;
_squid.$locale;
_squid.$util;
_logger.$logger;

/***/ }),

/***/ "./pages/xo-add-card/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-add-card/template.html"), __webpack_require__("../node_modules/xo-models/src/fi/lib/fiApis.js"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/directive.js"), __webpack_require__("../node_modules/xo-validation/dist/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/tooltip/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/dropdown/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/done/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {
  return angular.module('hermes.page.xo-add-card.directive', ['squid', 'fi.apis', 'beaver', 'xo-add-card.directive', 'xo-validation.directive', 'xo-tooltip.directive', 'xo-dropdown.directive', 'xo-value-props.directive', 'xo-done.directive']).directive('xoPageAddCardPage', function ($rootScope) {
    return {
      template: template,
      scope: {
        token: '=?'
      },
      controller: function controller($scope, $rootScope, $state, $stateParams, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel,
      // eslint-disable-line no-shadow
      $ShippingAddressModel, $locale, $fiApis, $logger) {
        function populateInfoMessage() {
          var msg;
          if ($stateParams.gaming === '1') {
            msg = $locale.content.get('creditcard.noEligibleFI');
          } else if ($stateParams.country === 'DE') {
            if ($stateParams.fiType === 'BANK') {
              msg = $locale.content.get('creditcard.cannotUseBank');
            } else {
              msg = $locale.content.get('creditcard.cannotUseCard');
            }
          } else {
            msg = $locale.content.get('creditcard.noFIContingency');
          }
          $scope.message = {
            msgs: [msg],
            type: 'error'
          };
        }
        populateInfoMessage();
        $scope.pagetitle = $locale.content.get('addCard.addACard');
        $scope.callbacks = {
          finish: function finish() {
            var checkoutSession = $CheckoutSessionModel.instance($rootScope.token);
            var checkoutAppData = $CheckoutAppDataModel.instance($rootScope.token);
            var checkoutCart = $CheckoutCartModel.instance($rootScope.token);
            var shippingAddress = $ShippingAddressModel.instance('123');
            var showGenericError = function showGenericError(code) {
              return function () {
                $state.go('checkout.genericError', {
                  code: code
                });
              };
            };
            var makePayment = function makePayment() {
              return checkoutSession.action('createPayment', {
                data: {
                  payer_id: checkoutSession.payer.id,
                  intent: checkoutCart.payment_action
                },
                success: function success(result) {
                  $rootScope.paymentComplete = true;
                  $logger.info('wps_cart_to_txn_mapping', {
                    cart_id: $rootScope.token,
                    txn_id: result.transactionDetails && result.transactionDetails.id,
                    txn_receipt_id: result.transactionDetails && result.transactionDetails.receipt_id
                  });
                  return $state.go('checkout.done');
                },
                contingencies: {
                  TRANSACTION_REFUSED: showGenericError('TRANSACTION_REFUSED'),
                  PAYEE_BLOCKED_TRANSACTION: showGenericError('PAYMENT_DENIED'),
                  DUPLICATE_TRANSACTION: showGenericError('PAYMENT_ALREADY_DONE')
                }
              });
            };
            var authorize = function authorize() {
              checkoutSession.action('authorize', {
                success: function success() {
                  if (checkoutAppData.doec_on_approve()) {
                    return makePayment();
                  } else {
                    $state.go('checkout.end');
                  }
                }
              });
            };
            var setStickyInstrument = function setStickyInstrument() {
              if ($stateParams.mode !== 'signup') {
                return;
              }
              var stickyInstrument = checkoutSession.selectedFuturePaymentInstrument ? undefined : checkoutSession.getSelectedStickyInstrument();
              if (stickyInstrument) {
                return checkoutSession.action('setStickyFI', {
                  data: {
                    instrument_id: stickyInstrument.instrument_id
                  }
                });
              }
            };
            if (shippingAddress.isNew) {
              shippingAddress.save({
                data: shippingAddress,
                success: function success() {
                  _angular.$q.when(setStickyInstrument())["catch"](function (err) {
                    $logger.info('setStickyFI Failed', err);
                  }).then(function () {
                    return authorize();
                  });
                }
              });
            } else {
              _angular.$q.when(setStickyInstrument())["catch"](function (err) {
                $logger.info('setStickyFI Failed', err);
              }).then($fiApis.patchCvv(checkoutSession)).then(authorize(), function (err) {
                $logger.error('patchCvv error', err);
              });
            }
          }
        };
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_angular.$q;

/***/ }),

/***/ "./pages/xo-add-card/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/xo-wallet-components/src/add-card/route.js"), __webpack_require__("./pages/xo-add-card/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-add-card.route', ['squid', 'xo-add-card.route', 'hermes.page.xo-add-card.directive']).factory('$AddCardPageRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('AddCardPageRoute', {
      name: 'pageAddCard',
      directive: 'xo-page-add-card-page',
      titleContent: 'asideHeader.addCard',
      query: ['gaming', 'country', 'fiType', 'mode'],
      trackingData: {
        templateName: 'addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
          'fullpage': {
            'pagename': '%::fullpage-add-cc',
            'pagename2': '%::fullpage-add-cc:guest:hermes:',
            'version': 'guest:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: [{
        name: '$AddCardFlowRoute',
        attributes: {
          token: 'token',
          message: 'message',
          pagetitle: 'pagetitle',
          'parent-callbacks': 'callbacks'
        }
      }]
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-add-card", "pages/xo-add-card/route.js"))

/***/ }),

/***/ "./pages/xo-checkout/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _fn = __webpack_require__("../node_modules/xo-guest-components/src/fraudnet/fn.js");
var _gdprCookieBanner = __webpack_require__("../node_modules/xo-models/src/gdprCookieBanner/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-checkout/template.html"), __webpack_require__("../node_modules/xo-ui-components/src/spinner/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/merchant-header/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/header/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/footer/directive.js"), __webpack_require__("../node_modules/xo-page-components/src/cart/directive.js"), __webpack_require__("../node_modules/xo-ui-components/src/error-tooltip/directive.js"), __webpack_require__("../node_modules/xo-validation/dist/directive.js"), __webpack_require__("../node_modules/xo-device-info/dist/index.js"), __webpack_require__("../node_modules/xo-models/src/shippingMethod/index.js"), __webpack_require__("../node_modules/xo-page-components/src/gdprCookieBanner/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {
  return angular.module('hermes.page.xo-checkout.directive', ['squid', 'xo-spinner.directive', 'xo-merchant-header.directive', 'xo-header.directive', 'xo-footer.directive', 'xo-cart.directive', 'xo-error-tooltip.directive', 'xo-validation.directive', 'xo-device-info', 'xo-gdpr-cookie-banner.directive']).directive('xoCheckout', function ($document, $config, $util) {
    return {
      template: template,
      scope: {},
      controller: function controller($scope, $rootScope, $state, $renderContent, $locale, $LocaleResolver, $DeviceInfo, $FallbackError, $feature, $populate, $CheckoutAppDataModel, $CheckoutCartModel, $CheckoutPayeeModel, $ShippingRuleSummaryModel) {
        $scope.guestAuthFlow = !!$util.param('atoSuccess');
        $scope.token = $rootScope.token;
        $scope.locale = $locale;
        _fn.$fn.trigger();
        $scope.isGdprValid = _gdprCookieBanner.isGdprValid;

        // Regulation E only applies to invoicing flows where a US payer is
        // sending money to a non-US receiver
        function isRegulationEApplicable() {
          var checkoutAppData = $scope.checkoutAppData;
          var isInvoicingFlow = checkoutAppData.isInvoiceFlow();
          var isUSSender = $locale.country === 'US';
          var isNonUSReceiver = checkoutAppData.merchant.merchant_country !== 'US';
          return isInvoicingFlow && isUSSender && isNonUSReceiver;
        }
        function setLanguageToggleFlags() {
          var landingPage = $scope.checkoutAppData.get('flags.landing_page');
          var hermesLoginRedirectParam = $util.param('hermesLoginRedirect');
          var languageToggleFeature = $feature('languageToggle');

          // Language Toggle - header
          if (landingPage === 'BILLING' && !hermesLoginRedirectParam || isRegulationEApplicable()) {
            $scope.languageSwitchHeader = {
              show: languageToggleFeature
            };
          } else {
            $scope.languageSwitchFooter = {
              show: languageToggleFeature
            };
          }
        }
        function checkShippingRulesExist() {
          return $populate($scope, {
            shippingRulesSummary: $ShippingRuleSummaryModel.instance($rootScope.token).retrieve({
              params: {
                merchant_id: $scope.checkoutPayee.merchant.id,
                currency_code: $scope.checkoutCart.purchase.amounts.total.currency_code
              }
            })
          });
        }
        function setButtonParams(isSnTEnabled) {
          // We need instant update flow check here again, because all instant update flows will
          // not have SnTEnabled in shippingRulesSummary
          if (isSnTEnabled || $scope.checkoutCart.instantUpdateIntegration) {
            // preserve these cart amount values passed from the merchant
            // since they could get changed after SnT from profile/callback (in case instant update) is applied
            // TODO: get rid of buttonParams and start using checkoutCart in SnT module
            $scope.buttonParams = {
              shipping: $scope.checkoutCart.purchase.amounts.shipping,
              tax: $scope.checkoutCart.purchase.amounts.tax,
              total: $scope.checkoutCart.purchase.amounts.total
            };
          }
        }
        $populate($scope, {
          checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
          checkoutCart: $CheckoutCartModel.instance($scope.token),
          checkoutPayee: $CheckoutPayeeModel.instance($scope.token)
        }).then(function () {
          setLanguageToggleFlags();
          var isSntSupported = $scope.checkoutAppData.is_snt_supported();

          // call checkShippingRulesExist only if the token is WPS and not WPS subscription flow, or the token
          // is instant update flow
          // We have instant update flow check here to avoid making unnecessary calls to shippingRulesSummary
          if (isSntSupported || $scope.checkoutCart.instantUpdateIntegration) {
            var isSnTEnabled;
            _logger.$logger.info('config_read_rules_summary', {
              readRulesSummaryFromAppData: $config.readRulesSummaryFromAppData
            });
            if ($config.readRulesSummaryFromAppData) {
              isSnTEnabled = $scope.checkoutAppData.is_snt_enabled();
              setButtonParams(isSnTEnabled);
            } else {
              checkShippingRulesExist().then(function () {
                isSnTEnabled = $scope.shippingRulesSummary && $scope.shippingRulesSummary.isSnTEnabled;
                setButtonParams(isSnTEnabled);
              });
            }
          }
        });

        // Change html dir attribute for RTL/LTR, append RTL styling if needed.
        function setDirectionality() {
          $document.prop('documentElement').setAttribute('dir', $locale.metadata.directionality);
        }

        // Change html lang attribute and document title
        function localizeHead() {
          $document.prop('documentElement').setAttribute('lang', $locale.lang);
          setDirectionality();
          var content = $renderContent('base.payPal');
          if (content) {
            $document.title = content;
          }
        }
        function getPaymentMethod() {
          var paymentMethodViaUrl = $util.param('paymentMethod');
          var paymentMethodViaCheckoutAppData = $scope.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;
          return paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
        }
        function checkUnbranded() {
          var paymentMethod = getPaymentMethod();
          if (!paymentMethod || !$config.allowedUnbrandedPayments) {
            return false;
          }

          // If paymentMethod in URL is NOT in the list of allowed payment methods, return false
          if ($config.allowedUnbrandedPayments.indexOf(paymentMethod) === -1) {
            return false;
          }
          return true;
        }
        $scope.isUnbranded = checkUnbranded();
        $scope.paymentMethod = '';
        if ($scope.isUnbranded) {
          $scope.paymentMethod = getPaymentMethod();
          if ($scope.paymentMethod === 'invoice') {
            $scope.unbrandedTitle = 'payUponInvoice.header';
            $scope.unbrandedSubTitle = 'payUponInvoice.processedBy';
          }
        }
        $scope.isApp = $DeviceInfo.isApp();
        var contentChange = $rootScope.$on('contentChange', localizeHead);
        localizeHead();
        var cancel = $rootScope.$on('allLoaded', function () {
          angular.element('#preloaderSpinner').hide();

          // Opera for Andriod has support for window.performance.timing but
          // not for window.performance.now()
          var loadTime = 'N/A';
          if ('now' in performance) {
            loadTime = performance.now();
          } else if (['timeOrigin', 'timing'].some(function (key) {
            return key in performance;
          })) {
            var _performance = performance,
              timeOrigin = _performance.timeOrigin,
              _performance$timing = _performance.timing,
              timing = _performance$timing === void 0 ? {} : _performance$timing;
            var start = timeOrigin || timing.navigationStart;
            loadTime = Date.now() - start;
          }
          _logger.$logger.info('checkout_fpti', {
            from: 'BILLING',
            to: 'prepare_billing_page_loaded',
            page_load_time: loadTime
          });
          cancel();
        });
        $scope.$on('localeChange', function () {
          localizeHead();
          setLanguageToggleFlags();
        });
        $scope.$on('$destroy', function () {
          cancel();
          contentChange();
        });
        $document.bind('click', function (event) {
          $scope.$broadcast('clickBody', event.target);
        });
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_fn.$fn;
_gdprCookieBanner.isGdprValid;
_logger.$logger;

/***/ }),

/***/ "./pages/xo-checkout/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("../node_modules/jquery/dist/jquery.min.js");
__webpack_require__("../node_modules/xo-angular-shims-placeholder/dist/angular-shims-placeholder.min.js");
var _index = __webpack_require__("./js/lib/index.js");
__webpack_require__("../node_modules/xo-tracking/dist/index.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-checkout/directive.js"), __webpack_require__("./pages/xo-landing/route.js"), __webpack_require__("./pages/xo-generic-error/route.js"), __webpack_require__("./pages/xo-generic-message/route.js"), __webpack_require__("./pages/xo-end/route.js"), __webpack_require__("./pages/xo-guest/route.js"), __webpack_require__("./pages/xo-signup/route.js"), __webpack_require__("./pages/xo-add-card/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/multistep-signup/route.js"), __webpack_require__("./pages/xo-pay-upon-invoice/route.js"), __webpack_require__("../node_modules/xo-page-components/src/done/route.js"), __webpack_require__("../node_modules/xo-page-components/src/route-to-complete/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-authnode/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/continue-3ds-redirect/route.js"), __webpack_require__("../node_modules/xo-form-components/src/inventory-soldout/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-checkout.route', ['squid', 'hermes.page.xo-landing.route', 'hermes.page.xo-checkout.directive', 'hermes.page.xo-generic-error.route', 'hermes.page.xo-generic-message.route', 'hermes.page.xo-end.route', 'hermes.page.xo-guest.route', 'hermes.page.xo-signup.route', 'hermes.page.xo-add-card.route', 'xo-multistep-signup.route', 'hermes.page.xo-pay-upon-invoice.route', 'xo-done', 'xo-route-to-complete', 'xo-guest-authnode']).factory('$BaseRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('CheckoutRoute', {
      defaultState: 'checkout.landing',
      middleware: _index.$Middleware,
      name: 'checkout',
      directive: 'xo-checkout',
      titleContent: 'base.payPal',
      children: [{
        name: '$LandingRoute',
        attributes: {
          'is-unbranded': 'isUnbranded'
        }
      }, {
        name: '$GuestRoute',
        attributes: {
          token: 'token',
          'is-unbranded': 'isUnbranded',
          'payment-method': 'paymentMethod',
          'button-params': 'buttonParams'
        }
      }, {
        name: '$SignupRoute',
        attributes: {
          token: 'token',
          'button-params': 'buttonParams'
        }
      }, {
        name: '$AddCardPageRoute',
        attributes: {
          token: 'token'
        }
      }, {
        name: '$xoSoldOutPageRoute'
      }, {
        name: '$GenericErrorRoute'
      }, {
        name: '$GenericMessageRoute'
      }, {
        name: '$EndRoute'
      }, {
        name: '$MultistepSignupRoute',
        attributes: {
          token: 'token',
          'button-params': 'buttonParams'
        }
      }, {
        name: '$PayUponInvoiceRoute',
        attributes: {
          token: 'token',
          'is-unbranded': 'isUnbranded'
        }
      }, {
        name: '$DoneRoute'
      }, {
        name: '$RouteToCompleteRoute',
        attributes: {
          token: 'token'
        }
      }, {
        name: '$GuestAuthNodeRoute',
        attributes: {
          token: 'token'
        }
      }]
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_index.$Middleware;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-checkout", "pages/xo-checkout/route.js"))

/***/ }),

/***/ "./pages/xo-end/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports["default"] = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _index = __webpack_require__("../node_modules/squid/dist/index.js");
var _index2 = __webpack_require__("../node_modules/xo-device-info/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index4 = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index5 = __webpack_require__("../node_modules/xo-models/src/auth/index.js");
var _index6 = __webpack_require__("../node_modules/xo-models/src/prox/index.js");
var _index7 = __webpack_require__("../node_modules/xo-models/src/profilemanagement/index.js");
var _index8 = __webpack_require__("../node_modules/xo-return-to-merchant/dist/index.js");
var _returnParams = __webpack_require__("../node_modules/xo-page-components/src/returnParams/index.js");
var _template = _interopRequireDefault(__webpack_require__("./pages/xo-end/template.html"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _index.$Component.extend('xoEnd', {
  tag: 'xo-end',
  template: _template["default"],
  props: {},
  resolve: {
    models: function models() {
      return {
        payee: _index3.$CheckoutPayeeModel.instance(_angular.$rootScope.token).retrieve(),
        checkoutAppData: _index3.$CheckoutAppDataModel.instance(_angular.$rootScope.token).retrieve(),
        checkoutCart: _index3.$CheckoutCartModel.instance(_angular.$rootScope.token).retrieve(),
        checkoutSession: _index3.$CheckoutSessionModel.instance(_angular.$rootScope.token).retrieve()
      };
    },
    dependentModels: function dependentModels(resolvers) {
      return resolvers.models.then(function (models) {
        return {
          merchantPreferences: _index7.$MerchantPreferenceModel.instance(models.payee.merchant.id).retrieve()
        };
      });
    }
  },
  lifecycle: {
    enter: function enter() {
      angular.element('#outerWrapper').addClass('xo-end');
      _angular.$rootScope.$emit('startLoad');
    },
    exit: function exit() {
      // If there is any error in this directive, then we need to hide spinner
      // so that when user reaches generic error page, he can return to merchant
      // by clicking on "return to merchant" button
      _angular.$rootScope.$emit('allLoaded');
    },
    populate: function populate() {
      var _this = this;
      function returnMethod(merchantPreferences) {
        if (merchantPreferences) {
          return merchantPreferences.returnMethod();
        }
        return 'GET';
      }
      function returnHttpMethodFromAppData(checkoutAppData) {
        if (checkoutAppData.flags.http_return_method) {
          return checkoutAppData.is_pdt_enabled() ? 'GET' : 'POST';
        }
        return 'GET';
      }
      function returnUrl(checkoutAppData, merchantPreferences) {
        var returnUrl = checkoutAppData.urls.return_url;
        if (checkoutAppData.is_wps_flow() && !_index.$config.readMerchantPreferencesFromAppData && !returnUrl) {
          returnUrl = merchantPreferences && merchantPreferences.returnUrl();
        }
        return returnUrl;
      }
      function postToMerchant(wpsURL, wpsData) {
        _index8.$ReturnToMerchant.postTo(wpsURL, wpsData);
      }
      function getPdtDisabledFromAppData(checkoutAppData) {
        return checkoutAppData && !checkoutAppData.is_pdt_enabled();
      }
      function getPdtDisabledFromMerchantSettings(merchantPreferences) {
        return merchantPreferences && !merchantPreferences.pdtEnabled();
      }
      var goToMerchant = function goToMerchant(wpsURL, wpsData, isPdtDisabled) {
        // if PDT is disabled don't send params in the url
        if (isPdtDisabled) {
          return _index8.$ReturnToMerchant.goTo(wpsURL);
        }
        return _index8.$ReturnToMerchant.goTo(_index.$util.buildURL(wpsURL, wpsData));
      };
      _angular.$q.when().then(function () {
        /*
            If we're in an in-context flow, the parent button
            iframe may need the access token to continue running
            and execute the payment (e.g. in 3rd party cookies
            disabled mode)
             We reload the auth model, since after the user is
            onboarded this model is not updated, then pass the
            access token up. The token will only be passed if
            we're on the same-domain as the parent button.
        */

        if (window.xprops && window.xprops.onAuth) {
          var auth = _index5.$AuthModel.instance();
          return auth.reload().then(function () {
            window.xprops.onAuth({
              accessToken: auth.access_token
            });
          });
        }
      }).then(function () {
        // handle the return url with post and get , with and without PDT for WPS alone
        // PDT - Payment Data Transfer
        if (_this.models.checkoutAppData.is_wps_flow()) {
          var wpsURL = returnUrl(_this.models.checkoutAppData, _this.dependentModels.merchantPreferences);
          var returnToMerchantMethod = _index.$config.readMerchantPreferencesFromAppData ? returnHttpMethodFromAppData(_this.models.checkoutAppData) : returnMethod(_this.dependentModels.merchantPreferences);
          var isWPSCart = _this.models.checkoutAppData.flags.is_cart_upload_flow || _this.models.checkoutAppData.flags.is_shopping_cart_flow;
          var wpsParams = (0, _returnParams.$returnParams)(_this.models.checkoutCart, _this.models.checkoutSession, returnToMerchantMethod, 'WPS', isWPSCart);
          var isPdtDisabled = _index.$config.readMerchantPreferencesFromAppData ? getPdtDisabledFromAppData(_this.models.checkoutAppData) : getPdtDisabledFromMerchantSettings(_this.dependentModels.merchantPreferences);
          return returnToMerchantMethod === 'POST' ? postToMerchant(wpsURL, wpsParams) : goToMerchant(wpsURL, wpsParams, isPdtDisabled);
        }
        var params = {};
        // Creating the checkoutInputData here so that it would not make payer-id call.
        var checkoutInputData = _index4.$CheckoutInputDataModel.instance(_angular.$rootScope.token);

        // Don't post PayerID for RT without purchase
        if (!_this.models.checkoutCart.isBillingNoPurchase()) {
          params.PayerID = _this.models.checkoutSession.payer.id;
        }
        var billingData = _this.models.checkoutCart.billing || {};

        // exclude BA token in the returnUrl for external merchant - (merchant not calling BEAM directly)
        if (billingData.ba_token && !_this.models.checkoutAppData.legacy_billing_integration) {
          params.ba_token = billingData.ba_token;
        }

        // When "redirect_uri" is passed as a query param
        if (_index.$integration.getConfig('REDIRECT_QUERY_PARAM') && _index.$util.param('redirect_uri')) {
          params.return_uri = _this.models.checkoutAppData.urls.return_url ? _index.$util.buildURL(_this.models.checkoutAppData.urls.return_url, params) : null;

          // Add these params after building `return_uri` to ensure they are not added into the final url
          params.intent = _this.models.checkoutCart.payment_action;
          params.opType = 'payment';
          params.paymentId = _this.models.checkoutAppData.payment_id;
          params.token = _angular.$rootScope.token;
        }
        var handleRedirection = function handleRedirection(url) {
          var isHTTPUrl = Boolean(url.indexOf('http') === 0 || url.indexOf('www') === 0);
          var isMobileDevice = Boolean(_index2.$DeviceInfo.isDevice() && !isHTTPUrl);

          /* Webview to App view switching is not happening properly
          * so to handle , adding a work around by adding cancel / return to merchant url
          * on success page
          * routeToComplete is the route which shows cancel / return to merchant url*/
          if (isMobileDevice) {
            _logger.$logger.info('Switching_Webview_To_App_view', {
              url: url
            });
            _angular.$window.onunload = _angular.$window.onbeforeunload = function () {
              // leave this blank , having this comment for lint warning - Unexpected Empty Function
            };
            _angular.$window.location = url;
            return _uiRouter.$state.go('checkout.routeToComplete', {
              url: url,
              urlType: 'success'
            });
          } else {
            _index8.$ReturnToMerchant.goTo(url);
          }
          return _index.$unresolved;
        };
        function finishProxFlow() {
          // for Prox Signup flow (eBay), generate auth code
          var auth = _index5.$AuthModel.instance();
          _logger.$logger.info('prox_exit_login_code_start');
          return auth.action('loginCode', {
            data: {
              user: {},
              client: {
                client_id: _index.$config.proxStsClientId,
                redirect_uri: checkoutInputData.redirect_uri,
                scope: checkoutInputData.scope,
                id_token: '',
                nonce: auth.nonce,
                response_type: 'code',
                skip_oauth: false,
                skip_consent: true,
                target_client_id: _index.$util.base64Decode(checkoutInputData.client_id),
                visitor_id: auth.visitor_id,
                scope_consent_context: 'access_token'
              }
            }
          })["catch"](function (err) {
            _logger.$logger.error('prox_exit_login_code_error', err);
            _index8.$ReturnToMerchant.goTo(checkoutInputData.errorUrl(err.message));
            return _index.$unresolved;
          }).then(function (loginCodeResult) {
            if (loginCodeResult && loginCodeResult.data && loginCodeResult.data.code) {
              _logger.$logger.info('prox_exit_login_code_success');
              return handleRedirection(checkoutInputData.successUrl(loginCodeResult.data.code));
            } else {
              _logger.$logger.error('prox_exit_login_code_not_found');
              _index8.$ReturnToMerchant.goTo(checkoutInputData.errorUrl('auth_code_error'));
              return _index.$unresolved;
            }
          });
        }
        if (!checkoutInputData.isEbayTxn()) {
          // non-Ebay/xoon flow
          return _angular.$q.when().then(function () {
            if (billingData.intent === 'VAULT') {
              var returnParams = {
                approval_token_id: billingData.vault_approval_token_id,
                approval_session_id: billingData.vault_approval_session_id
              };
              var _returnUrl = _this.models.checkoutAppData.get('urls.original_urls.return_url');
              return handleRedirection(_index.$util.buildURL(_returnUrl, returnParams));
            } else if (window.xprops && window.xprops.onAuthorize) {
              _angular.$rootScope.$emit('loading');
              var xparams = {
                paymentToken: _angular.$rootScope.token,
                orderID: _angular.$rootScope.token,
                billingToken: params['ba_token'],
                payerID: params['PayerID'],
                paymentID: params['paymentId'] || _this.models.checkoutAppData.payment_id,
                intent: _this.models.checkoutCart.payment_action
              };
              if (_this.models.checkoutAppData.get('urls.return_url')) {
                xparams.returnUrl = _index.$util.buildURL(_this.models.checkoutAppData.get('urls.return_url'), params);
              }
              if (window.xprops.getConnectURL) {
                return window.xprops.getConnectURL({
                  payerID: xparams.payerID
                }).then(function (connectURL) {
                  _logger.$logger.info('redirect_to_connect');
                  return _index.$util.redirect(connectURL);
                })["catch"](function (err) {
                  _logger.$logger.error('redirect_to_connect_error', {
                    err: err.stack || err.toString()
                  });
                  return window.xprops.onAuthorize(xparams);
                });
              } else {
                return window.xprops.onAuthorize(xparams);
              }
            } else if (_index.$integration.getConfig('REDIRECT_QUERY_PARAM') && _index.$util.param('redirect_uri')) {
              var redirect = _index.$util.buildURL(_index.$util.param('redirect_uri'));
              _logger.$logger.info('Nativeapp_Redirection', {
                redirect: redirect
              });
              return handleRedirection(_index.$util.buildURL(redirect, params));
            } else {
              return handleRedirection(_index.$util.buildURL(_this.models.checkoutAppData.get('urls.return_url'), params));
            }
          });
        } else {
          // PrOX flow only
          return _angular.$q.when().then(function () {
            _logger.$logger.info('prox_exit_for_authcode_start');
            if (_index.$util.param('fromLipp') === 'true') {
              var lippParamList = {
                client_id: _index.$util.param('client_id'),
                scope: _index.$util.param('scope'),
                state: _index.$util.param('state'),
                redirect_uri: _index.$util.param('redirect_uri'),
                metadata_id: _index.$util.param('cart_id')
              };
              var lippUrl = _index.$util.buildURL(_angular.$window.location.protocol + "//" + _angular.$window.location.host + _index.$config.urls.lippRedirectUrl, lippParamList);

              // reroute to LIPP to generate authcode if send from lipp
              _logger.$logger.info('XOON_REDIRECT_TO_LIPP_FOR_AUTHCODE');
              return _index8.$ReturnToMerchant.goTo(lippUrl, true);
            }
            if (_index.$util.param('ctxId')) {
              // for UL flow
              return _index6.$ContextualLoginModel.instance(_angular.$rootScope.token).retrieve().then(function (response) {
                if (response.success) {
                  _logger.$logger.info('XOON_REDIRECT_TO_UL_FOR_AUTHCODE');
                  _logger.$logger.info('checkout_fpti', {
                    from: 'xoon_ul_auth_code',
                    to: 'ul_auth_code'
                  });
                  var clUrl = _angular.$window.location.protocol + "//" + _angular.$window.location.host + _index.$config.urls.contextualLoginRedirectUrl + _index.$util.param('ctxId');
                  return _index8.$ReturnToMerchant.goTo(clUrl, true);
                } else {
                  _logger.$logger.error('XOON_UNABLE_TO_UPDATE_PAYLOAD_TO_UL_FOR_AUTHCODE');
                  _logger.$logger.info('checkout_fpti', {
                    from: 'xoon_ul_auth_code',
                    to: 'regular_prox_ul_payload_update_error'
                  });
                  return finishProxFlow();
                }
              });
            } else {
              return finishProxFlow();
            }
          });
        }
      }); // end of then function
    } // populate
  }
});
_angular.$q;
_angular.$rootScope;
_angular.$window;
_index.$Component;
_index.$config;
_index.$util;
_index.$unresolved;
_index.$integration;
_index2.$DeviceInfo;
_logger.$logger;
_uiRouter.$state;
_index3.$CheckoutSessionModel;
_index3.$CheckoutAppDataModel;
_index3.$CheckoutPayeeModel;
_index3.$CheckoutCartModel;
_index4.$CheckoutInputDataModel;
_index5.$AuthModel;
_index6.$ContextualLoginModel;
_index7.$MerchantPreferenceModel;
_index8.$ReturnToMerchant;
_returnParams.$returnParams;
module.exports = exports.default;

/***/ }),

/***/ "./pages/xo-end/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("./pages/xo-end/directive.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-end.route', ['squid']).factory('$EndRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('EndRoute', {
      name: 'end',
      directive: 'xo-end'
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-end", "pages/xo-end/route.js"))

/***/ }),

/***/ "./pages/xo-end/template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"xo-end-content\" content>\n    <!-- find css for this page in public/css/pages -->\n</div>\n"

/***/ }),

/***/ "./pages/xo-generic-error/directive.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$xoGenericErrorPageComponent = void 0;
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _template = _interopRequireDefault(__webpack_require__("./pages/xo-generic-error/template.html"));
__webpack_require__("../node_modules/xo-models/src/checkout/index.js");
__webpack_require__("../node_modules/xo-ui-components/src/generic-error/directive.js");
__webpack_require__("../node_modules/xo-ui-components/src/message/directive.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var $xoGenericErrorPageComponent = exports.$xoGenericErrorPageComponent = _squid.$Component.extend('$xoGenericErrorPageComponent', {
  tag: 'xo-generic-error-page',
  template: _template["default"],
  controller: function controller($scope, $rootScope,
  // eslint-disable-line no-shadow
  $locale, $CheckoutInputDataModel, $util, $logger, $state) {
    $scope.token = $rootScope.token;
    var terminalKey = "terminal-error-" + $scope.token,
      refreshKey = "has-seen-error-" + $scope.token;
    function renderErrorPage() {
      // prevent render flicker
      $scope.shouldRender = true;
      if ($CheckoutInputDataModel.instance($scope.token).isEbayTxn()) {
        $scope.cancelUrl = $util.param('redirect_uri');
        $scope.merchant = $locale.content.get('signup.ebay');
      }
    }
    if (!$util.sessionStorageEnabled() || !$scope.token || sessionStorage.getItem(terminalKey)) {
      return renderErrorPage();
    }

    // is not a refresh, user landing for the first time on generic error page.
    if (!sessionStorage.getItem(refreshKey)) {
      sessionStorage.setItem(refreshKey, '1');
      return renderErrorPage();
    } else {
      // This is a refresh. Go to guest page if a refresh happens, don't show generic error page
      $logger.info('checkout_fpti', {
        user_refresh: 1
      });
      // delete the refresh key, so that next time renders the error page.
      sessionStorage.removeItem(refreshKey);
      // go guest page if a refresh happens
      $state.go('checkout.landing')["catch"](function () {
        // don't try to do this again
        sessionStorage.setItem(terminalKey, '1');
      });
    }
  }
});
angular.value("$xoGenericErrorPageComponent", $xoGenericErrorPageComponent);
_squid.$Component;

/***/ }),

/***/ "./pages/xo-generic-error/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-error/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-generic-error.route', ['squid', 'hermes.page.xo-generic-error.directive']).factory('$GenericErrorRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GenericErrorRoute', {
      name: 'genericError',
      directive: 'xo-generic-error-page',
      titleContent: 'genericError.pleaseTryAgain',
      query: ['code'],
      // need to find these values
      trackingData: {
        templateName: 'genericError.dust',
        pageGoal: 'Generic Error',
        buzname: {
          'fullpage': {
            'pagename': '%::fullpage-generic-error',
            'pagename2': '%::fullpage-generic-error:member:hermes:',
            'version': 'member:%:'
          }
        }
      },
      children: []
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-generic-error", "pages/xo-generic-error/route.js"))

/***/ }),

/***/ "./pages/xo-generic-error/template.html":
/***/ (function(module, exports) {

module.exports = "<xo-generic-error ng-if=shouldRender token=\"token\" merchant={{merchant}} cancel-url={{cancelUrl}} is-unbranded=\"isUnbranded\"></xo-generic-error>\n"

/***/ }),

/***/ "./pages/xo-generic-message/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-generic-message/template.html"), __webpack_require__("../node_modules/xo-models/src/checkout/index.js"), __webpack_require__("../node_modules/xo-ui-components/src/generic-message/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {
  return angular.module('hermes.page.xo-generic-message.directive', ['squid', 'xomodel.checkout', 'xo-generic-message.directive']).directive('xoGenericMessagePage', function ($rootScope) {
    return {
      template: template,
      controller: function controller($scope, $rootScope,
      // eslint-disable-line no-shadow
      $stateParams, $state, $logger, $CheckoutAppDataModel, $util, $q, $populate) {
        $scope.token = $rootScope.token;
        angular.element('#defaultCancelLink').hide();
        var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
          event.preventDefault();
        });
        $rootScope.$on('$destroy', stateChangeStart);
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-generic-message/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-message/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-generic-message.route', ['squid', 'hermes.page.xo-generic-message.directive']).factory('$GenericMessageRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GenericMessageRoute', {
      name: 'genericMessage',
      directive: 'xo-generic-message-page',
      titleContent: 'genericError.pleaseTryAgain',
      query: ['code', 'returnUrl'],
      // need to find these values
      trackingData: {},
      children: []
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-generic-message", "pages/xo-generic-message/route.js"))

/***/ }),

/***/ "./pages/xo-guest-upgrade/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

__webpack_require__("../node_modules/jquery/dist/jquery.min.js");
__webpack_require__("../node_modules/xo-angular-shims-placeholder/dist/angular-shims-placeholder.min.js");
__webpack_require__("./js/lib/index.js");
__webpack_require__("../node_modules/xo-tracking/dist/index.js");
var _middleware = __webpack_require__("./js/lib/middleware.js");
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-generic-error/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-guest-upgrade.route', ['squid', 'hermes.page.xo-generic-error.route', 'xo-guest-upgrade.directive']).factory('$GuestUpgradeRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GuestUpgradeRoute', {
      defaultState: 'guestupgrade',
      middleware: _middleware.$Middleware,
      name: 'guestupgrade',
      directive: 'xo-guest-upgrade',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'accountCreationGuest.heading',

      trackingData: {
        templateName: 'xoguestupgrade.dust',
        pageGoal: 'guest upgrade',
        pageQualifier: 'guestupgrade',
        buzname: {
          'guestupgrade': {
            'pagename': '%::guestupgrade',
            'pagename2': '%::guestupgrade:prox-guest-upgrade',
            'version': 'version-1:%:'
          }
        }
      },
      children: [{
        name: '$GenericErrorRoute'
      }]
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
_middleware.$Middleware;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-guest-upgrade", "pages/xo-guest-upgrade/route.js"))

/***/ }),

/***/ "./pages/xo-guest/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-guest/template.html"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {
  return angular.module('hermes.page.xo-guest.directive', ['squid', 'xo-value-props.directive', 'xo-onboard.payment.directive']).directive('xoGuest', function ($rootScope, $SingleStepModel) {
    return {
      template: template,
      scope: {
        token: '=?',
        parentCallbacks: '=?',
        isUnbranded: '=?',
        paymentMethod: '=?',
        buttonParams: '=?'
      },
      controller: function controller($scope, $rootScope, $state) {
        $scope.mode = 'guest';
        $rootScope.mode = 'guest';
        $scope.backUri = 'checkout.guest';
        $scope.singleStepModel = new $SingleStepModel();
        $scope.onComplete = function () {
          $state.go('checkout.end');
        };
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-guest/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-guest/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-existing-member-interstitial/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/continue-3ds-redirect/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-guest.route', ['squid', 'hermes.page.xo-guest.directive', 'hermes.page.xo-sidebar.route']).factory('$GuestRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GuestRoute', {
      name: 'guest',
      directive: 'xo-guest',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'accountCreationGuest.heading',

      trackingData: {
        fptiState: 'guest_xo',
        trackStateExit: false,
        templateName: 'guest.dust',
        pageGoal: 'Payment Start',
        pageQualifier: 'guest',
        buzname: {
          'guest': {
            'pagename': '%::fullpage-guest',
            'pagename2': '%::fullpage-guest:member:hermes:',
            'version': 'guest:%:'
          },
          'signup': {
            'pagename': '%::fullpage-guestSignup',
            'pagename2': '%::fullpage-guestSignup:member:hermes:',
            'version': 'guestSignup:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: [{
        name: '$SidebarRoute',
        attributes: {
          'back-uri': 'backUri',
          'parent-model': 'singleStepModel'
        }
      }, {
        name: '$GuestUpgradeInterstitialRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      }, {
        name: '$GuestExistingMemberInterstitialRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      },
      /**
       * Url endpoint: checkout/guest/continue3DSRedirect
       * This endpoint is need to call existing client method `onComplete3DSHandler` 
       * so that once after complete3DS success in full page redirection of bank page to 
       * continue the 3ds process.
       */
      {
        name: '$Continue3DSRedirectRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      }]
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-guest", "pages/xo-guest/route.js"))

/***/ }),

/***/ "./pages/xo-landing/helper.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.landingPageResolver = void 0;
var _paypalSdkConstants = __webpack_require__("../node_modules/paypal-sdk-constants/index.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _index = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _uiRouter = __webpack_require__("../node_modules/angular-ui-router/release/angular-ui-router.min.js");
var landingFlow = function landingFlow(models) {
  var merchantCountry = models.checkoutAppData.get('merchant.merchant_country');
  var merchantId = models.checkoutPayeeModel.getId();
  var paymentMethodViaUrl = _squid.$util.param('paymentMethod');
  var paymentMethodViaCheckoutAppData = models.checkoutAppData.get('user_selected_funding_source_type') === 'PAY_UPON_INVOICE' ? 'invoice' : undefined;
  var paymentMethod = paymentMethodViaCheckoutAppData || paymentMethodViaUrl;
  var isUnbranded = paymentMethod !== undefined;
  function getProcessedRoute(appRoute) {
    var isForcedSignup;
    switch (appRoute) {
      case 'checkout.guest':
        isForcedSignup = 0;
        break;
      case 'checkout.signup':
      case 'checkout.multistepsignup':
        isForcedSignup = 1;
        break;
      default:
        isForcedSignup = -1;
        break;
    }
    _logger.$logger.info('checkout_fpti', {
      from: 'LANDING_PAGE_PARAM',
      forced_signup_offered: isForcedSignup,
      landing_page: 'Billing',
      locale: _squid.$locale.lang + "_" + _squid.$locale.country
    });
    return appRoute;
  }
  function getBlockedSignupErrorMessage(country) {
    if (country === 'IN') {
      return 'PAYEE_ACCOUNT_LOCKED_OR_CLOSED';
    }
    return "SIGNUP_BLOCKED_IN_COUNTRY_" + country;
  }
  function callEPM() {
    return _index.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
      params: {
        localeCountry: _squid.$locale.country,
        fundingSource: window.xprops && window.xprops.fundingSource,
        merchantId: merchantId,
        merchantCountry: merchantCountry
      }
    }).then(function (flowEligibility) {
      var mode = flowEligibility.guest ? 'guest' : 'signup';
      _logger.$logger.info(mode + "_flow_offered_by_epm_at_route");
      // TH force signup is blocked due to compliance requirements.
      if (mode === 'signup' && (0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
        _logger.$logger.info(_squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED");
        return _uiRouter.$state.go('checkout.genericError', {
          code: getBlockedSignupErrorMessage(_squid.$locale.country)
        });
      }
      var appRoute = mode === 'signup' ? 'checkout.signup' : 'checkout.guest';
      return getProcessedRoute(appRoute);
    });
  }
  if (_squid.$config.deploy.isLocal() || _squid.$config.deploy.isStage()) {
    var passedInExp = _squid.$util.param('showExp');
    if ('guest'.includes(passedInExp)) {
      return getProcessedRoute('checkout.guest');
    }
    if ('signup'.includes(passedInExp)) {
      // TH force signup is blocked due to compliance requirements.
      if ((0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
        _logger.$logger.info("DEV_STAGING_" + _squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED");
        return _uiRouter.$state.go('checkout.genericError', {
          code: getBlockedSignupErrorMessage(_squid.$locale.country)
        });
      }
      return getProcessedRoute('checkout.signup');
    }
  }
  var _ref = window.xprops || {},
    _ref$fundingSource = _ref.fundingSource,
    fundingSourceFromXprops = _ref$fundingSource === void 0 ? '' : _ref$fundingSource,
    _ref$fundingOffered = _ref.fundingOffered,
    fundingOfferedFromXprops = _ref$fundingOffered === void 0 ? [] : _ref$fundingOffered;
  function isSPBSignEligible() {
    // fundingOfferedFromXprops is already an array from xprops.
    if (fundingSourceFromXprops === _paypalSdkConstants.FUNDING.PAYPAL && fundingOfferedFromXprops.includes(_paypalSdkConstants.FUNDING.CARD)) {
      return (0, _squid.$elmo)('xo_xoon_spb_signup', 'xo_xoon_spb_signup_test', undefined, false, true).then(function (result) {
        var treatmentName = result && result.treatment_name;
        return treatmentName === 'xo_xoon_spb_signup_test';
      });
    }
    return _angular.$q.resolve(false);
  }
  return isSPBSignEligible().then(function (spbSignupEligible) {
    if (spbSignupEligible) {
      _logger.$logger.info('spb_flow_signup');
      if ((0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
        _logger.$logger.info(_squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED_FOR_SPBSIGNUP");
        return _uiRouter.$state.go('checkout.genericError', {
          code: getBlockedSignupErrorMessage(_squid.$locale.country)
        });
      }
      return getProcessedRoute('checkout.signup');
    } else if (isUnbranded) {
      _logger.$logger.info("unbranded_flow_paymentMethod_" + paymentMethod);
      _logger.$logger.info('checkout_fpti', {
        from: 'BILLING',
        to: "prepare_billing_page_for_unbranded_paymentMethod_" + paymentMethod,
        locale: _squid.$locale.lang + "_" + _squid.$locale.country
      });
      var isUnbrandedAllowed = (0, _squid.$feature)('unbranded', true, merchantCountry);
      var isPuiAllowed = (0, _squid.$feature)('invoicePayment', true, merchantCountry);
      if (isUnbrandedAllowed && isPuiAllowed && paymentMethod === 'invoice') {
        return getProcessedRoute('checkout.pay-upon-invoice');
      }
      return getProcessedRoute('checkout.guest');
    } else if (models.checkoutAppData.get('flags.payment_experience_initiator') === 'PAYPAL_PLUS' && _squid.$util.param('exp') === 'signup') {
      _logger.$logger.info('ppplus_flow_signup');
      if ((0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
        _logger.$logger.info(_squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED_FOR_PPPLUS");
        return _uiRouter.$state.go('checkout.genericError', {
          code: getBlockedSignupErrorMessage(_squid.$locale.country)
        });
      }
      return getProcessedRoute('checkout.signup');
    } else if ((0, _squid.$feature)('multiStepSignup', false, _squid.$locale.country)) {
      return getProcessedRoute('checkout.multistepsignup');
    } else if (models.checkoutInputData.isEbayTxn()) {
      // force signup for eBay users
      _logger.$logger.info('ebay_flow_signup');
      if ((0, _squid.$feature)('blockSignup', false, _squid.$locale.country)) {
        _logger.$logger.info(_squid.$locale.country + "_COUNTRY_SIGNUP_BLOCKED_FOR_EBAY");
        return _uiRouter.$state.go('checkout.genericError', {
          code: getBlockedSignupErrorMessage(_squid.$locale.country)
        });
      }
      return getProcessedRoute('checkout.signup');
    } else {
      // if you here means, now we need to determine the route based on symphony EPM call.
      return callEPM();
    }
  });
};
var landingPageResolver = exports.landingPageResolver = {
  landingFlow: landingFlow
};
_paypalSdkConstants.FUNDING;
_squid.$util;
_squid.$feature;
_squid.$config;
_squid.$locale;
_squid.$elmo;
_index.$FlowEligibilityModel;
_logger.$logger;
_angular.$q;
_angular.$rootScope;
_uiRouter.$state;

/***/ }),

/***/ "./pages/xo-landing/route.js":
/***/ (function(module, exports, __webpack_require__) {



exports.__esModule = true;
exports.$LandingRoute = void 0;
var _angular = __webpack_require__("../node_modules/angular/angular.min.js");
var _squid = __webpack_require__("../node_modules/squid/dist/index.js");
var _logger = __webpack_require__("../node_modules/xo-beaver/dist/logger.js");
var _index = __webpack_require__("../node_modules/xo-models/src/user/index.js");
var _index2 = __webpack_require__("../node_modules/xo-models/src/checkout/index.js");
var _index3 = __webpack_require__("../node_modules/xo-models/src/inventory/index.js");
var _helper = __webpack_require__("./pages/xo-landing/helper.js");
var $LandingRoute = exports.$LandingRoute = _squid.$ComponentRoute.extend('LandingRoute', {
  name: 'landing',
  // Uncomment the following line to suffix content to
  // the title of the page
  // Base title is 'PayPal Checkout'
  // titleContent: 'accountCreationGuest.heading',

  scope: {
    isUnbranded: '=?'
  },
  trackingData: {
    fptiState: 'landing',
    trackStateExit: true
  },
  init: function init() {
    this._super.init.apply(this);
    _squid.$event.on('countryChange', function () {
      _index2.$FlowEligibilityModel.instance(_angular.$rootScope.token).invalidate();
    });
  },
  resolve: {
    action: function action() {
      var models = {};
      return (0, _squid.$populate)(models, {
        checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
        checkoutPayeeModel: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
        checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
        checkoutInputData: _index.$CheckoutInputDataModel.instance(_angular.$rootScope.token)
      }).then(function () {
        // C2 ramp - force CN country code to C2 upon landing
        if (_squid.$locale.country === 'CN') {
          _squid.$locale.change('C2', _squid.$locale.lang);
          _logger.$logger.info('CN_locale_forced_to_C2');
        }
      }).then(function () {
        if (_squid.$util.param('atoSuccess')) {
          _logger.$logger.info('Guest_authflow_successful_redirection_from_ANW');
          return 'checkout.guestauthnode';
        }
        var cartHasInventory = models.checkoutCart.get('cartHasInventory');
        if (_squid.$config.enableInventoryWPS && cartHasInventory) {
          var inventoryModel = _index3.$InventoryModel.instance(_angular.$rootScope.token);
          var inventoryInput = {
            items: models.checkoutCart.get('purchase.items'),
            merchantId: models.checkoutPayeeModel.getId()
          };
          return inventoryModel.action('getInventory', {
            data: inventoryInput,
            success: function success(inventoryResponse) {
              if (inventoryResponse.showSoldoutPage) {
                return {
                  to: 'checkout.soldout',
                  params: {
                    items: encodeURIComponent(inventoryResponse.soldoutItems),
                    soldOutUrl: encodeURIComponent(inventoryResponse.soldoutUrl)
                  }
                };
              } else {
                inventoryModel.setInvetoryItems(inventoryResponse);
                return _helper.landingPageResolver.landingFlow(models);
              }
            }
          });
        } else {
          return _helper.landingPageResolver.landingFlow(models);
        }
      });
    }
  }
});
angular.value("$LandingRoute", $LandingRoute);
_angular.$rootScope;
_squid.$ComponentRoute;
_squid.$config;
_squid.$event;
_squid.$util;
_squid.$locale;
_squid.$populate;
_logger.$logger;
_index.$CheckoutInputDataModel;
_index2.$CheckoutAppDataModel;
_index2.$CheckoutPayeeModel;
_index2.$CheckoutCartModel;
_index2.$FlowEligibilityModel;
_index3.$InventoryModel;
_helper.landingPageResolver;

/***/ }),

/***/ "./pages/xo-pay-upon-invoice/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-pay-upon-invoice/template.html"), __webpack_require__("../node_modules/xo-beaver/dist/logger.js"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-wallet-components/src/pay-upon-invoice/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {
  return angular.module('hermes.page.xo-pay-upon-invoice.directive', ['squid', 'xo-value-props.directive', 'xo-pay-upon-invoice.directive']).directive('xoPayUponInvoicePage', function ($rootScope, $logger) {
    return {
      template: template,
      scope: {
        token: '=?',
        isUnbranded: '=?'
      },
      controller: function controller($scope, $rootScope, $state, $locale) {// eslint-disable-line no-shadow
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-pay-upon-invoice/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-pay-upon-invoice/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-pay-upon-invoice.route', ['squid', 'hermes.page.xo-pay-upon-invoice.directive']).factory('$PayUponInvoiceRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('PayUponInvoiceRoute', {
      name: 'pay-upon-invoice',
      directive: 'xo-pay-upon-invoice-page',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'payment.payWithCard',

      trackingData: {
        templateName: 'pay-upon-invoice.dust',
        pageGoal: 'Payment Start',
        pageQualifier: 'pay-upon-invoice',
        buzname: {
          'pay-upon-invoice': {
            'pagename': '%::fullpage-pay-upon-invoice',
            'pagename2': '%::fullpage-pay-upon-invoice:guest:hermes:',
            'version': 'pay-upon-invoice:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: []
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-pay-upon-invoice", "pages/xo-pay-upon-invoice/route.js"))

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-sidebar-installment-options/template.html"), __webpack_require__("../node_modules/xo-page-components/src/aside-header/directive.js"), __webpack_require__("../node_modules/xo-wallet-components/src/installment-options/directive.js"), __webpack_require__("../node_modules/xo-tray-height/dist/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid, template) {
  return angular.module('hermes.page.xo-sidebar-installment-options.directive', ['squid', 'xo-aside-header.directive', 'xo-installment-options.directive', 'xo-tray-height.directive']).directive('xoSidebarInstallmentOptionsPage', function () {
    return {
      template: template,
      scope: {
        backUri: '=?',
        parentModel: '=?'
      },
      controller: function controller($scope, $rootScope, $state) {
        $scope.token = $rootScope.token;
        $scope.cardInfo = {
          number: $scope.parentModel.onboard.card.number.replace(/ /g, ''),
          type: $scope.parentModel.onboard.card.type
        };
        $scope.onComplete = function (result) {
          $scope.parentModel.setProperties({
            selectedInstallmentData: result
          });
          angular.element('#paymentMethod').removeClass('ng-invalid'); // FIXME : setup a callback in xo-multistep-signup

          $state.go($scope.backUri);
        };
        $scope.$emit('populated');
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-sidebar-installment-options/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-sidebar-installment-options/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-sidebar-installment-options.route', ['squid', 'hermes.page.xo-sidebar-installment-options.directive']).factory('$SidebarInstallmentOptionsRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('InstallmentOptionsRoute', {
      name: 'installmentOptions',
      directive: 'xo-sidebar-installment-options-page',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'accountCreationGuest.heading',

      trackingData: {
        templateName: 'tray/installmentOptions.dust',
        pageGoal: 'Installment Options',
        buzname: {
          'fullpage': {
            'pagename': '%::fullpage-installment-options',
            'pagename2': '%::fullpage-installment-options::hermes:',
            'version': ':%:'
          }
        }
      },
      children: []
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-sidebar-installment-options", "pages/xo-sidebar-installment-options/route.js"))

/***/ }),

/***/ "./pages/xo-sidebar/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-sidebar/template.html")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, index, template) {
  return angular.module('hermes.page.xo-sidebar.directive', ['squid']).directive('xoSidebar', function () {
    return {
      template: template,
      scope: {
        backUri: '=?',
        parentModel: '=?'
      },
      link: function link($scope, element, attr) {
        $scope.$on('populated', function () {
          angular.element('body').addClass('trayOpen');
          angular.element('#wrapper').addClass('maskMember');
          var payButton = angular.element('.confirmButton');
          if (payButton) {
            payButton.attr('disabled', true);
          }
        });
        $scope.$on('$destroy', function () {
          angular.element('body').removeClass('trayOpen');
          var payButton = angular.element('.confirmButton');
          if (payButton) {
            payButton.attr('disabled', false);
          }
        });
      },
      controller: function controller($scope, $rootScope, $window, $state, $util, $populate) {
        $util.assert($scope.backUri, 'Expected backUri');
        $populate($scope);
        $scope.token = $rootScope.token;
        $scope.onPageClick = function ($event) {
          $event.stopPropagation();
        };
        $scope.close = function () {
          $state.go($scope.backUri);
        };
        $scope.callbacks = {
          done: function done() {
            $state.go($scope.backUri);
          }
        };
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-sidebar/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-sidebar/directive.js"), __webpack_require__("./pages/xo-sidebar-installment-options/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-sidebar.route', ['squid', 'hermes.page.xo-sidebar.directive', 'hermes.page.xo-sidebar-installment-options.route']).factory('$SidebarRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('SidebarRoute', {
      name: 'sidebar',
      directive: 'xo-sidebar',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'accountCreationGuest.heading',

      children: [{
        name: '$SidebarInstallmentOptionsRoute',
        attributes: {
          'back-uri': 'backUri',
          'parent-model': 'parentModel'
        }
      }]
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-sidebar", "pages/xo-sidebar/route.js"))

/***/ }),

/***/ "./pages/xo-signup/directive.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/module.js"), __webpack_require__("../node_modules/noop-loader/index.js!./pages/xo-signup/template.html"), __webpack_require__("../node_modules/xo-page-components/src/value-props/directive.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest/directive.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, module, template) {
  return angular.module('hermes.page.xo-signup.directive', ['squid', 'xo-value-props.directive', 'xo-onboard.payment.directive']).directive('xoSignup', function ($rootScope, $SingleStepModel) {
    return {
      template: template,
      scope: {
        token: '=?',
        parentCallbacks: '=?',
        buttonParams: '=?'
      },
      controller: function controller($scope, $rootScope, $state, $locale) {
        // eslint-disable-line no-shadow
        $scope.mode = 'signup';
        $rootScope.mode = 'signup';
        $scope.backUri = 'checkout.signup';
        $scope.singleStepModel = new $SingleStepModel();
        $scope.onComplete = function () {
          $state.go('checkout.end');
        };
      }
    };
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),

/***/ "./pages/xo-signup/route.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, __dirname, __filename) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__("../node_modules/angular/angular.min.js"), __webpack_require__("../node_modules/squid/dist/index.js"), __webpack_require__("./pages/xo-signup/directive.js"), __webpack_require__("./pages/xo-sidebar/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/guest-upgrade-interstitial/route.js"), __webpack_require__("../node_modules/xo-guest-components/src/continue-3ds-redirect/route.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-signup.route', ['squid', 'hermes.page.xo-signup.directive', 'hermes.page.xo-sidebar.route']).factory('$SignupRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('SignupRoute', {
      name: 'signup',
      directive: 'xo-signup',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'accountCreationGuest.heading',

      trackingData: {
        fptiState: 'signup',
        trackStateExit: false,
        templateName: 'signup.dust',
        pageGoal: 'Signup Start',
        pageQualifier: 'signup',
        buzname: {
          'signup': {
            'pagename': '%::fullpage-signup',
            'pagename2': '%::fullpage-signup:member:hermes:',
            'version': 'guest:%:'
          }
          // More page qualifiers come here...
        }
      },
      children: [{
        name: '$SidebarRoute',
        attributes: {
          'back-uri': 'backUri',
          'parent-model': 'singleStepModel'
        }
      }, {
        name: '$GuestUpgradeInterstitialRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      },
      /**
       * Url endpoint: checkout/signup/continue3DSRedirect
       * This endpoint is need to call the existing client method `onComplete3DSHandler` 
       * so that once after complete3DS success in full page redirection of bank page to 
       * continue the 3ds process.
       */
      {
        name: '$Continue3DSRedirectRoute',
        attributes: {
          token: 'token',
          'parent-model': 'singleStepModel'
        }
      }]
    });
  });
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), "pages/xo-signup", "pages/xo-signup/route.js"))

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("../node_modules/xo-webpack-config/polyfills.js");
module.exports = __webpack_require__("./js/bootstrap.js");


/***/ })

},[0]);


// WEBPACK FOOTER //
// js/main.js